
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5oaC6", function(module, exports) {
// Generated by js_of_ocaml
//# buildInfo:effects=disabled, kind=unknown, use-js-string=true, version=6.0.1
//# 6 ".tensor_playground_web.eobjs/jsoo/tensor_playground_web.bc.runtime.js"
(function(Object1) {
    typeof globalThis !== "object" && (this ? get() : (Object1.defineProperty(Object1.prototype, "_T_", {
        configurable: true,
        get: get
    }), _T_));
    function get() {
        var global = this || self;
        global.globalThis = global;
        delete Object1.prototype._T_;
    }
})(Object);






(function(globalThis1) {
    "use strict";
    function Base_am_testing(x) {
        return 0;
    }
    function Base_caml_exn_is_most_recent_exn(x) {
        return 1;
    }
    function Base_clear_caml_backtrace_pos(x) {
        return 0;
    }
    function caml_is_continuation_tag(t) {
        return t === 245 ? 1 : 0;
    }
    function caml_mul(a, b) {
        return Math.imul(a, b);
    }
    function caml_hash_mix_int(h, d) {
        d = caml_mul(d, -862048943);
        d = d << 15 | d >>> 17;
        d = caml_mul(d, 0x1b873593);
        h ^= d;
        h = h << 13 | h >>> 19;
        return (h + (h << 2) | 0) + -430675100 | 0;
    }
    function caml_hash_mix_jsbytes(h, s) {
        var len = s.length, i, w;
        for(i = 0; i + 4 <= len; i += 4){
            w = s.charCodeAt(i) | s.charCodeAt(i + 1) << 8 | s.charCodeAt(i + 2) << 16 | s.charCodeAt(i + 3) << 24;
            h = caml_hash_mix_int(h, w);
        }
        w = 0;
        switch(len & 3){
            case 3:
                w = s.charCodeAt(i + 2) << 16;
            case 2:
                w |= s.charCodeAt(i + 1) << 8;
            case 1:
                w |= s.charCodeAt(i);
                h = caml_hash_mix_int(h, w);
        }
        h ^= len;
        return h;
    }
    var log2_ok = Math.log2 && Math.log2(1.1235582092889474e307) === 1020;
    function jsoo_floor_log2(x) {
        if (log2_ok) return Math.floor(Math.log2(x));
        var i = 0;
        if (x === 0) return Number.NEGATIVE_INFINITY;
        if (x >= 1) while(x >= 2){
            x /= 2;
            i++;
        }
        else while(x < 1){
            x *= 2;
            i--;
        }
        return i;
    }
    var caml_int64_offset = Math.pow(2, -24);
    function caml_raise_constant(tag) {
        throw tag;
    }
    var caml_global_data = [
        0
    ];
    function caml_raise_zero_divide() {
        caml_raise_constant(caml_global_data.Division_by_zero);
    }
    function MlInt64(lo, mi, hi) {
        this.lo = lo & 0xffffff;
        this.mi = mi & 0xffffff;
        this.hi = hi & 0xffff;
    }
    MlInt64.prototype.caml_custom = "_j";
    MlInt64.prototype.copy = function() {
        return new MlInt64(this.lo, this.mi, this.hi);
    };
    MlInt64.prototype.ucompare = function(x) {
        if (this.hi > x.hi) return 1;
        if (this.hi < x.hi) return -1;
        if (this.mi > x.mi) return 1;
        if (this.mi < x.mi) return -1;
        if (this.lo > x.lo) return 1;
        if (this.lo < x.lo) return -1;
        return 0;
    };
    MlInt64.prototype.compare = function(x) {
        var hi = this.hi << 16, xhi = x.hi << 16;
        if (hi > xhi) return 1;
        if (hi < xhi) return -1;
        if (this.mi > x.mi) return 1;
        if (this.mi < x.mi) return -1;
        if (this.lo > x.lo) return 1;
        if (this.lo < x.lo) return -1;
        return 0;
    };
    MlInt64.prototype.neg = function() {
        var lo = -this.lo, mi = -this.mi + (lo >> 24), hi = -this.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.add = function(x) {
        var lo = this.lo + x.lo, mi = this.mi + x.mi + (lo >> 24), hi = this.hi + x.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.sub = function(x) {
        var lo = this.lo - x.lo, mi = this.mi - x.mi + (lo >> 24), hi = this.hi - x.hi + (mi >> 24);
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.mul = function(x) {
        var lo = this.lo * x.lo, mi = (lo * caml_int64_offset | 0) + this.mi * x.lo + this.lo * x.mi, hi = (mi * caml_int64_offset | 0) + this.hi * x.lo + this.mi * x.mi + this.lo * x.hi;
        return new MlInt64(lo, mi, hi);
    };
    MlInt64.prototype.isZero = function() {
        return (this.lo | this.mi | this.hi) === 0;
    };
    MlInt64.prototype.isNeg = function() {
        return this.hi << 16 < 0;
    };
    MlInt64.prototype.and = function(x) {
        return new MlInt64(this.lo & x.lo, this.mi & x.mi, this.hi & x.hi);
    };
    MlInt64.prototype.or = function(x) {
        return new MlInt64(this.lo | x.lo, this.mi | x.mi, this.hi | x.hi);
    };
    MlInt64.prototype.xor = function(x) {
        return new MlInt64(this.lo ^ x.lo, this.mi ^ x.mi, this.hi ^ x.hi);
    };
    MlInt64.prototype.shift_left = function(s) {
        s = s & 63;
        if (s === 0) return this;
        if (s < 24) return new MlInt64(this.lo << s, this.mi << s | this.lo >> 24 - s, this.hi << s | this.mi >> 24 - s);
        if (s < 48) return new MlInt64(0, this.lo << s - 24, this.mi << s - 24 | this.lo >> 48 - s);
        return new MlInt64(0, 0, this.lo << s - 48);
    };
    MlInt64.prototype.shift_right_unsigned = function(s) {
        s = s & 63;
        if (s === 0) return this;
        if (s < 24) return new MlInt64(this.lo >> s | this.mi << 24 - s, this.mi >> s | this.hi << 24 - s, this.hi >> s);
        if (s < 48) return new MlInt64(this.mi >> s - 24 | this.hi << 48 - s, this.hi >> s - 24, 0);
        return new MlInt64(this.hi >> s - 48, 0, 0);
    };
    MlInt64.prototype.shift_right = function(s) {
        s = s & 63;
        if (s === 0) return this;
        var h = this.hi << 16 >> 16;
        if (s < 24) return new MlInt64(this.lo >> s | this.mi << 24 - s, this.mi >> s | h << 24 - s, this.hi << 16 >> s >>> 16);
        var sign = this.hi << 16 >> 31;
        if (s < 48) return new MlInt64(this.mi >> s - 24 | this.hi << 48 - s, this.hi << 16 >> s - 24 >> 16, sign & 0xffff);
        return new MlInt64(this.hi << 16 >> s - 32, sign, sign);
    };
    MlInt64.prototype.lsl1 = function() {
        this.hi = this.hi << 1 | this.mi >> 23;
        this.mi = (this.mi << 1 | this.lo >> 23) & 0xffffff;
        this.lo = this.lo << 1 & 0xffffff;
    };
    MlInt64.prototype.lsr1 = function() {
        this.lo = (this.lo >>> 1 | this.mi << 23) & 0xffffff;
        this.mi = (this.mi >>> 1 | this.hi << 23) & 0xffffff;
        this.hi = this.hi >>> 1;
    };
    MlInt64.prototype.udivmod = function(x) {
        var offset = 0, modulus = this.copy(), divisor = x.copy(), quotient = new MlInt64(0, 0, 0);
        while(modulus.ucompare(divisor) > 0){
            offset++;
            divisor.lsl1();
        }
        while(offset >= 0){
            offset--;
            quotient.lsl1();
            if (modulus.ucompare(divisor) >= 0) {
                quotient.lo++;
                modulus = modulus.sub(divisor);
            }
            divisor.lsr1();
        }
        return {
            quotient: quotient,
            modulus: modulus
        };
    };
    MlInt64.prototype.div = function(y) {
        var x = this;
        if (y.isZero()) caml_raise_zero_divide();
        var sign = x.hi ^ y.hi;
        if (x.hi & 0x8000) x = x.neg();
        if (y.hi & 0x8000) y = y.neg();
        var q = x.udivmod(y).quotient;
        if (sign & 0x8000) q = q.neg();
        return q;
    };
    MlInt64.prototype.mod = function(y) {
        var x = this;
        if (y.isZero()) caml_raise_zero_divide();
        var sign = x.hi;
        if (x.hi & 0x8000) x = x.neg();
        if (y.hi & 0x8000) y = y.neg();
        var r = x.udivmod(y).modulus;
        if (sign & 0x8000) r = r.neg();
        return r;
    };
    MlInt64.prototype.toInt = function() {
        return this.lo | this.mi << 24;
    };
    MlInt64.prototype.toFloat = function() {
        return (this.hi << 16) * Math.pow(2, 32) + this.mi * Math.pow(2, 24) + this.lo;
    };
    MlInt64.prototype.toArray = function() {
        return [
            this.hi >> 8,
            this.hi & 0xff,
            this.mi >> 16,
            this.mi >> 8 & 0xff,
            this.mi & 0xff,
            this.lo >> 16,
            this.lo >> 8 & 0xff,
            this.lo & 0xff
        ];
    };
    MlInt64.prototype.lo32 = function() {
        return this.lo | (this.mi & 0xff) << 24;
    };
    MlInt64.prototype.hi32 = function() {
        return this.mi >>> 8 & 0xffff | this.hi << 16;
    };
    function caml_int64_create_lo_mi_hi(lo, mi, hi) {
        return new MlInt64(lo, mi, hi);
    }
    function caml_int64_bits_of_float(x) {
        if (!Number.isFinite(x)) {
            if (Number.isNaN(x)) return caml_int64_create_lo_mi_hi(1, 0, 0x7ff0);
            return x > 0 ? caml_int64_create_lo_mi_hi(0, 0, 0x7ff0) : caml_int64_create_lo_mi_hi(0, 0, 0xfff0);
        }
        var sign = x === 0 && 1 / x === Number.NEGATIVE_INFINITY ? 0x8000 : x >= 0 ? 0 : 0x8000;
        if (sign) x = -x;
        var exp = jsoo_floor_log2(x) + 1023;
        if (exp <= 0) {
            exp = 0;
            x /= Math.pow(2, -1026);
        } else {
            x /= Math.pow(2, exp - 1027);
            if (x < 16) {
                x *= 2;
                exp -= 1;
            }
            if (exp === 0) x /= 2;
        }
        var k = Math.pow(2, 24), r3 = x | 0;
        x = (x - r3) * k;
        var r2 = x | 0;
        x = (x - r2) * k;
        var r1 = x | 0;
        r3 = r3 & 0xf | sign | exp << 4;
        return caml_int64_create_lo_mi_hi(r1, r2, r3);
    }
    function caml_int64_lo32(v) {
        return v.lo32();
    }
    function caml_int64_hi32(v) {
        return v.hi32();
    }
    function caml_hash_mix_int64(h, v) {
        h = caml_hash_mix_int(h, caml_int64_lo32(v));
        h = caml_hash_mix_int(h, caml_int64_hi32(v));
        return h;
    }
    function caml_hash_mix_float(h, v0) {
        return caml_hash_mix_int64(h, caml_int64_bits_of_float(v0));
    }
    function caml_jsbytes_of_string(x) {
        return x;
    }
    function caml_hash_mix_string(h, v) {
        return caml_hash_mix_jsbytes(h, caml_jsbytes_of_string(v));
    }
    function caml_hash_mix_bytes_arr(h, s) {
        var len = s.length, i, w;
        for(i = 0; i + 4 <= len; i += 4){
            w = s[i] | s[i + 1] << 8 | s[i + 2] << 16 | s[i + 3] << 24;
            h = caml_hash_mix_int(h, w);
        }
        w = 0;
        switch(len & 3){
            case 3:
                w = s[i + 2] << 16;
            case 2:
                w |= s[i + 1] << 8;
            case 1:
                w |= s[i];
                h = caml_hash_mix_int(h, w);
        }
        h ^= len;
        return h;
    }
    function caml_str_repeat(n, s) {
        if (n === 0) return "";
        if (s.repeat) return s.repeat(n);
        var r = "", l = 0;
        for(;;){
            if (n & 1) r += s;
            n >>= 1;
            if (n === 0) return r;
            s += s;
            l++;
            if (l === 9) s.slice(0, 1);
        }
    }
    function caml_sub_uint8_array_to_jsbytes(a, i, len) {
        var f = String.fromCharCode;
        if (i === 0 && len <= 4096 && len === a.length) return f.apply(null, a);
        var s = "";
        for(; 0 < len; i += 1024, len -= 1024)s += f.apply(null, a.subarray(i, i + Math.min(len, 1024)));
        return s;
    }
    function caml_convert_string_to_bytes(s) {
        if (s.t === 2) s.c += caml_str_repeat(s.l - s.c.length, "\0");
        else s.c = caml_sub_uint8_array_to_jsbytes(s.c, 0, s.c.length);
        s.t = 0;
    }
    function jsoo_is_ascii(s) {
        if (s.length < 24) {
            for(var i = 0; i < s.length; i++)if (s.charCodeAt(i) > 127) return false;
            return true;
        } else return !/[^\x00-\x7f]/.test(s);
    }
    function caml_utf16_of_utf8(s) {
        for(var b = "", t = "", c, c1, c2, v, i = 0, l = s.length; i < l; i++){
            c1 = s.charCodeAt(i);
            if (c1 < 0x80) {
                for(var j = i + 1; j < l && (c1 = s.charCodeAt(j)) < 0x80; j++);
                if (j - i > 512) {
                    t.slice(0, 1);
                    b += t;
                    t = "";
                    b += s.slice(i, j);
                } else t += s.slice(i, j);
                if (j === l) break;
                i = j;
            }
            v = 1;
            if (++i < l && ((c2 = s.charCodeAt(i)) & -64) === 128) {
                c = c2 + (c1 << 6);
                if (c1 < 0xe0) {
                    v = c - 0x3080;
                    if (v < 0x80) v = 1;
                } else {
                    v = 2;
                    if (++i < l && ((c2 = s.charCodeAt(i)) & -64) === 128) {
                        c = c2 + (c << 6);
                        if (c1 < 0xf0) {
                            v = c - 0xe2080;
                            if (v < 0x800 || v >= 0xd7ff && v < 0xe000) v = 2;
                        } else {
                            v = 3;
                            if (++i < l && ((c2 = s.charCodeAt(i)) & -64) === 128 && c1 < 0xf5) {
                                v = c2 - 0x3c82080 + (c << 6);
                                if (v < 0x10000 || v > 0x10ffff) v = 3;
                            }
                        }
                    }
                }
            }
            if (v < 4) {
                i -= v;
                t += "\ufffd";
            } else if (v > 0xffff) t += String.fromCharCode(0xd7c0 + (v >> 10), 0xdc00 + (v & 0x3ff));
            else t += String.fromCharCode(v);
            if (t.length > 1024) {
                t.slice(0, 1);
                b += t;
                t = "";
            }
        }
        return b + t;
    }
    function MlBytes(tag, contents, length) {
        this.t = tag;
        this.c = contents;
        this.l = length;
    }
    MlBytes.prototype.toString = function() {
        switch(this.t){
            case 9:
            case 8:
                return this.c;
            case 4:
            case 2:
                caml_convert_string_to_bytes(this);
            case 0:
                if (jsoo_is_ascii(this.c)) this.t = 9;
                else this.t = 8;
                return this.c;
        }
    };
    MlBytes.prototype.toUtf16 = function() {
        var r = this.toString();
        if (this.t === 9) return r;
        return caml_utf16_of_utf8(r);
    };
    MlBytes.prototype.slice = function() {
        var content = this.t === 4 ? this.c.slice() : this.c;
        return new MlBytes(this.t, content, this.l);
    };
    function caml_ml_bytes_content(s) {
        switch(s.t & 6){
            case 2:
                caml_convert_string_to_bytes(s);
                return s.c;
            default:
                return s.c;
        }
    }
    function caml_hash_mix_bytes(h, v) {
        var content = caml_ml_bytes_content(v);
        return typeof content === "string" ? caml_hash_mix_jsbytes(h, content) : caml_hash_mix_bytes_arr(h, content);
    }
    var caml_packFloat16 = function() {
        const INVERSE_OF_EPSILON = 1 / Number.EPSILON;
        function roundTiesToEven(num) {
            return num + INVERSE_OF_EPSILON - INVERSE_OF_EPSILON;
        }
        const FLOAT16_MIN_VALUE = 6.103515625e-5, FLOAT16_MAX_VALUE = 65504, FLOAT16_EPSILON = 0.0009765625, FLOAT16_EPSILON_MULTIPLIED_BY_FLOAT16_MIN_VALUE = FLOAT16_EPSILON * FLOAT16_MIN_VALUE, FLOAT16_EPSILON_DEVIDED_BY_EPSILON = FLOAT16_EPSILON * INVERSE_OF_EPSILON;
        function roundToFloat16(num) {
            const number = +num;
            if (!Number.isFinite(number) || number === 0) return number;
            const sign = number > 0 ? 1 : -1, absolute = Math.abs(number);
            if (absolute < FLOAT16_MIN_VALUE) return sign * roundTiesToEven(absolute / FLOAT16_EPSILON_MULTIPLIED_BY_FLOAT16_MIN_VALUE) * FLOAT16_EPSILON_MULTIPLIED_BY_FLOAT16_MIN_VALUE;
            const temp = (1 + FLOAT16_EPSILON_DEVIDED_BY_EPSILON) * absolute, result = temp - (temp - absolute);
            if (result > FLOAT16_MAX_VALUE || Number.isNaN(result)) return sign * Number.POSITIVE_INFINITY;
            return sign * result;
        }
        const baseTable = new Uint16Array(512), shiftTable = new Uint8Array(512);
        for(let i = 0; i < 256; ++i){
            const e = i - 127;
            if (e < -24) {
                baseTable[i] = 0x0000;
                baseTable[i | 0x100] = 0x8000;
                shiftTable[i] = 24;
                shiftTable[i | 0x100] = 24;
            } else if (e < -14) {
                baseTable[i] = 0x0400 >> -e - 14;
                baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
                shiftTable[i] = -e - 1;
                shiftTable[i | 0x100] = -e - 1;
            } else if (e <= 15) {
                baseTable[i] = e + 15 << 10;
                baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
                shiftTable[i] = 13;
                shiftTable[i | 0x100] = 13;
            } else if (e < 128) {
                baseTable[i] = 0x7c00;
                baseTable[i | 0x100] = 0xfc00;
                shiftTable[i] = 24;
                shiftTable[i | 0x100] = 24;
            } else {
                baseTable[i] = 0x7c00;
                baseTable[i | 0x100] = 0xfc00;
                shiftTable[i] = 13;
                shiftTable[i | 0x100] = 13;
            }
        }
        const buffer = new ArrayBuffer(4), floatView = new Float32Array(buffer), uint32View = new Uint32Array(buffer);
        return function(num) {
            floatView[0] = roundToFloat16(num);
            const f = uint32View[0], e = f >> 23 & 0x1ff;
            return baseTable[e] + ((f & 0x007fffff) >> shiftTable[e]);
        };
    }();
    function caml_int32_bits_of_float(x) {
        var float32a = new Float32Array(1);
        float32a[0] = x;
        var int32a = new Int32Array(float32a.buffer);
        return int32a[0] | 0;
    }
    function caml_int64_to_bytes(x) {
        return x.toArray();
    }
    function caml_ba_serialize(writer, ba, sz) {
        writer.write(32, ba.dims.length);
        writer.write(32, ba.kind | ba.layout << 8);
        if (ba.caml_custom === "_bigarr02") for(var i = 0; i < ba.dims.length; i++)if (ba.dims[i] < 0xffff) writer.write(16, ba.dims[i]);
        else {
            writer.write(16, 0xffff);
            writer.write(32, 0);
            writer.write(32, ba.dims[i]);
        }
        else for(var i = 0; i < ba.dims.length; i++)writer.write(32, ba.dims[i]);
        switch(ba.kind){
            case 2:
            case 3:
            case 12:
                for(var i = 0; i < ba.data.length; i++)writer.write(8, ba.data[i]);
                break;
            case 4:
            case 5:
                for(var i = 0; i < ba.data.length; i++)writer.write(16, ba.data[i]);
                break;
            case 6:
                for(var i = 0; i < ba.data.length; i++)writer.write(32, ba.data[i]);
                break;
            case 8:
            case 9:
                writer.write(8, 0);
                for(var i = 0; i < ba.data.length; i++)writer.write(32, ba.data[i]);
                break;
            case 7:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var b = caml_int64_to_bytes(ba.get(i));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
            case 1:
                for(var i = 0; i < ba.data.length; i++){
                    var b = caml_int64_to_bytes(caml_int64_bits_of_float(ba.get(i)));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
            case 13:
                for(var i = 0; i < ba.data.length; i++)writer.write(16, ba.data[i]);
                break;
            case 0:
                for(var i = 0; i < ba.data.length; i++){
                    var b = caml_int32_bits_of_float(ba.get(i));
                    writer.write(32, b);
                }
                break;
            case 10:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var j = ba.get(i);
                    writer.write(32, caml_int32_bits_of_float(j[1]));
                    writer.write(32, caml_int32_bits_of_float(j[2]));
                }
                break;
            case 11:
                for(var i = 0; i < ba.data.length / 2; i++){
                    var complex = ba.get(i), b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[1]));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                    var b = caml_int64_to_bytes(caml_int64_bits_of_float(complex[2]));
                    for(var j = 0; j < 8; j++)writer.write(8, b[j]);
                }
                break;
        }
        sz[0] = (4 + ba.dims.length) * 4;
        sz[1] = (4 + ba.dims.length) * 8;
    }
    var caml_unpackFloat16 = function() {
        var pow = Math.pow, EXP_MASK16 = 31, SIGNIFICAND_MASK16 = 1023, MIN_SUBNORMAL16 = pow(2, -24), SIGNIFICAND_DENOM16 = 0.0009765625;
        return function(bytes) {
            var sign = bytes >>> 15, exponent = bytes >>> 10 & EXP_MASK16, significand = bytes & SIGNIFICAND_MASK16;
            if (exponent === EXP_MASK16) return significand === 0 ? sign === 0 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : Number.NaN;
            if (exponent === 0) return significand * (sign === 0 ? MIN_SUBNORMAL16 : -MIN_SUBNORMAL16);
            var r = pow(2, exponent - 15) * (sign === 0 ? 1 + significand * SIGNIFICAND_DENOM16 : -1 - significand * SIGNIFICAND_DENOM16);
            return r;
        };
    }(), jsoo_static_env = {};
    function jsoo_sys_getenv(n) {
        if (jsoo_static_env[n]) return jsoo_static_env[n];
        var process = globalThis1.process;
        if (process && process.env && process.env[n] !== undefined) return process.env[n];
        if (globalThis1.jsoo_env && typeof globalThis1.jsoo_env[n] === "string") return globalThis1.jsoo_env[n];
    }
    var caml_record_backtrace_env_flag = 0;
    (function() {
        var r = jsoo_sys_getenv("OCAMLRUNPARAM");
        if (r !== undefined) {
            var l = r.split(",");
            for(var i = 0; i < l.length; i++)if (l[i] === "b") {
                caml_record_backtrace_env_flag = 1;
                break;
            } else if (l[i].startsWith("b=")) caml_record_backtrace_env_flag = +l[i].slice(2);
            else continue;
        }
    })();
    var caml_record_backtrace_runtime_flag = caml_record_backtrace_env_flag;
    function caml_exn_with_js_backtrace(exn, force) {
        if (!exn.js_error || force || exn[0] === 248) exn.js_error = new globalThis1.Error("Js exception containing backtrace");
        return exn;
    }
    function caml_maybe_attach_backtrace(exn, force) {
        return caml_record_backtrace_env_flag && caml_record_backtrace_runtime_flag ? caml_exn_with_js_backtrace(exn, force) : exn;
    }
    function caml_raise_with_arg(tag, arg) {
        throw caml_maybe_attach_backtrace([
            0,
            tag,
            arg
        ]);
    }
    function caml_string_of_jsbytes(x) {
        return x;
    }
    function caml_raise_with_string(tag, msg) {
        caml_raise_with_arg(tag, caml_string_of_jsbytes(msg));
    }
    function caml_invalid_argument(msg) {
        caml_raise_with_string(caml_global_data.Invalid_argument, msg);
    }
    function caml_ba_get_size_per_element(kind) {
        switch(kind){
            case 7:
            case 10:
            case 11:
                return 2;
            default:
                return 1;
        }
    }
    function caml_ba_create_buffer(kind, size) {
        var view;
        switch(kind){
            case 0:
                view = Float32Array;
                break;
            case 1:
                view = Float64Array;
                break;
            case 2:
                view = Int8Array;
                break;
            case 3:
                view = Uint8Array;
                break;
            case 4:
                view = Int16Array;
                break;
            case 5:
                view = Uint16Array;
                break;
            case 6:
                view = Int32Array;
                break;
            case 7:
                view = Int32Array;
                break;
            case 8:
                view = Int32Array;
                break;
            case 9:
                view = Int32Array;
                break;
            case 10:
                view = Float32Array;
                break;
            case 11:
                view = Float64Array;
                break;
            case 12:
                view = Uint8Array;
                break;
            case 13:
                view = Uint16Array;
                break;
        }
        if (!view) caml_invalid_argument("Bigarray.create: unsupported kind");
        var data = new view(size * caml_ba_get_size_per_element(kind));
        return data;
    }
    function caml_int32_float_of_bits(x) {
        var int32a = new Int32Array(1);
        int32a[0] = x;
        var float32a = new Float32Array(int32a.buffer);
        return float32a[0];
    }
    function caml_int64_of_bytes(a) {
        return new MlInt64(a[7] << 0 | a[6] << 8 | a[5] << 16, a[4] << 0 | a[3] << 8 | a[2] << 16, a[1] << 0 | a[0] << 8);
    }
    function caml_int64_float_of_bits(x) {
        var lo = x.lo, mi = x.mi, hi = x.hi, exp = (hi & 0x7fff) >> 4;
        if (exp === 2047) return (lo | mi | hi & 0xf) === 0 ? hi & 0x8000 ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY : Number.NaN;
        var k = Math.pow(2, -24), res = (lo * k + mi) * k + (hi & 0xf);
        if (exp > 0) {
            res += 16;
            res *= Math.pow(2, exp - 1027);
        } else res *= Math.pow(2, -1026);
        if (hi & 0x8000) res = -res;
        return res;
    }
    function caml_ba_get_size(dims) {
        var n_dims = dims.length, size = 1;
        for(var i = 0; i < n_dims; i++){
            if (dims[i] < 0) caml_invalid_argument("Bigarray.create: negative dimension");
            size = size * dims[i];
        }
        return size;
    }
    function caml_int64_create_lo_hi(lo, hi) {
        return new MlInt64(lo & 0xffffff, lo >>> 24 & 0xff | (hi & 0xffff) << 8, hi >>> 16 & 0xffff);
    }
    function caml_array_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    var caml_ba_custom_name = "_bigarr02";
    function Ml_Bigarray(kind, layout, dims, buffer) {
        this.kind = kind;
        this.layout = layout;
        this.dims = dims;
        this.data = buffer;
    }
    Ml_Bigarray.prototype.caml_custom = caml_ba_custom_name;
    Ml_Bigarray.prototype.offset = function(arg) {
        var ofs = 0;
        if (typeof arg === "number") arg = [
            arg
        ];
        if (!Array.isArray(arg)) caml_invalid_argument("bigarray.js: invalid offset");
        if (this.dims.length !== arg.length) caml_invalid_argument("Bigarray.get/set: bad number of dimensions");
        if (this.layout === 0) for(var i = 0; i < this.dims.length; i++){
            if (arg[i] < 0 || arg[i] >= this.dims[i]) caml_array_bound_error();
            ofs = ofs * this.dims[i] + arg[i];
        }
        else for(var i = this.dims.length - 1; i >= 0; i--){
            if (arg[i] < 1 || arg[i] > this.dims[i]) caml_array_bound_error();
            ofs = ofs * this.dims[i] + (arg[i] - 1);
        }
        return ofs;
    };
    Ml_Bigarray.prototype.get = function(ofs) {
        switch(this.kind){
            case 7:
                var l = this.data[ofs * 2 + 0], h = this.data[ofs * 2 + 1];
                return caml_int64_create_lo_hi(l, h);
            case 10:
            case 11:
                var r = this.data[ofs * 2 + 0], i = this.data[ofs * 2 + 1];
                return [
                    254,
                    r,
                    i
                ];
            case 13:
                return caml_unpackFloat16(this.data[ofs]);
            default:
                return this.data[ofs];
        }
    };
    Ml_Bigarray.prototype.set = function(ofs, v) {
        switch(this.kind){
            case 7:
                this.data[ofs * 2 + 0] = caml_int64_lo32(v);
                this.data[ofs * 2 + 1] = caml_int64_hi32(v);
                break;
            case 10:
            case 11:
                this.data[ofs * 2 + 0] = v[1];
                this.data[ofs * 2 + 1] = v[2];
                break;
            case 13:
                this.data[ofs] = caml_packFloat16(v);
                break;
            default:
                this.data[ofs] = v;
                break;
        }
        return 0;
    };
    Ml_Bigarray.prototype.fill = function(v) {
        switch(this.kind){
            case 7:
                var a = caml_int64_lo32(v), b = caml_int64_hi32(v);
                if (a === b) this.data.fill(a);
                else for(var i = 0; i < this.data.length; i++)this.data[i] = i % 2 === 0 ? a : b;
                break;
            case 10:
            case 11:
                var im = v[1], re = v[2];
                if (im === re) this.data.fill(im);
                else for(var i = 0; i < this.data.length; i++)this.data[i] = i % 2 === 0 ? im : re;
                break;
            case 13:
                this.data.fill(caml_packFloat16(v));
                break;
            default:
                this.data.fill(v);
                break;
        }
    };
    Ml_Bigarray.prototype.compare = function(b, total) {
        if (this.layout !== b.layout || this.kind !== b.kind) {
            var k1 = this.kind | this.layout << 8, k2 = b.kind | b.layout << 8;
            return k2 - k1;
        }
        if (this.dims.length !== b.dims.length) return b.dims.length - this.dims.length;
        for(var i = 0; i < this.dims.length; i++)if (this.dims[i] !== b.dims[i]) return this.dims[i] < b.dims[i] ? -1 : 1;
        switch(this.kind){
            case 0:
            case 1:
            case 10:
            case 11:
                var x, y;
                for(var i = 0; i < this.data.length; i++){
                    x = this.data[i];
                    y = b.data[i];
                    if (x < y) return -1;
                    if (x > y) return 1;
                    if (x !== y) {
                        if (!total) return Number.NaN;
                        if (!Number.isNaN(x)) return 1;
                        if (!Number.isNaN(y)) return -1;
                    }
                }
                break;
            case 7:
                for(var i = 0; i < this.data.length; i += 2){
                    if (this.data[i + 1] < b.data[i + 1]) return -1;
                    if (this.data[i + 1] > b.data[i + 1]) return 1;
                    if (this.data[i] >>> 0 < b.data[i] >>> 0) return -1;
                    if (this.data[i] >>> 0 > b.data[i] >>> 0) return 1;
                }
                break;
            case 13:
                for(var i = 0; i < this.data.length; i++){
                    var aa = caml_unpackFloat16(this.data[i]), bb = caml_unpackFloat16(b.data[i]);
                    if (aa < bb) return -1;
                    if (aa > bb) return 1;
                }
                break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 8:
            case 9:
            case 12:
                for(var i = 0; i < this.data.length; i++){
                    if (this.data[i] < b.data[i]) return -1;
                    if (this.data[i] > b.data[i]) return 1;
                }
                break;
        }
        return 0;
    };
    function Ml_Bigarray_c_1_1(kind, layout, dims, buffer) {
        this.kind = kind;
        this.layout = layout;
        this.dims = dims;
        this.data = buffer;
    }
    Ml_Bigarray_c_1_1.prototype = new Ml_Bigarray();
    Ml_Bigarray_c_1_1.prototype.offset = function(arg) {
        if (typeof arg !== "number") {
            if (Array.isArray(arg) && arg.length === 1) arg = arg[0];
            else caml_invalid_argument("Ml_Bigarray_c_1_1.offset");
        }
        if (arg < 0 || arg >= this.dims[0]) caml_array_bound_error();
        return arg;
    };
    Ml_Bigarray_c_1_1.prototype.get = function(ofs) {
        return this.data[ofs];
    };
    Ml_Bigarray_c_1_1.prototype.set = function(ofs, v) {
        this.data[ofs] = v;
        return 0;
    };
    Ml_Bigarray_c_1_1.prototype.fill = function(v) {
        this.data.fill(v);
        return 0;
    };
    function caml_ba_create_unsafe(kind, layout, dims, data) {
        var size_per_element = caml_ba_get_size_per_element(kind);
        if (caml_ba_get_size(dims) * size_per_element !== data.length) caml_invalid_argument("length doesn't match dims");
        if (layout === 0 && dims.length === 1 && size_per_element === 1 && kind !== 13) return new Ml_Bigarray_c_1_1(kind, layout, dims, data);
        return new Ml_Bigarray(kind, layout, dims, data);
    }
    function caml_failwith(msg) {
        if (!caml_global_data.Failure) caml_global_data.Failure = [
            248,
            caml_string_of_jsbytes("Failure"),
            -3
        ];
        caml_raise_with_string(caml_global_data.Failure, msg);
    }
    function caml_ba_deserialize(reader, sz, name) {
        var num_dims = reader.read32s();
        if (num_dims < 0 || num_dims > 16) caml_failwith("input_value: wrong number of bigarray dimensions");
        var tag = reader.read32s(), kind = tag & 0xff, layout = tag >> 8 & 1, dims = [];
        if (name === "_bigarr02") for(var i = 0; i < num_dims; i++){
            var size_dim = reader.read16u();
            if (size_dim === 0xffff) {
                var size_dim_hi = reader.read32u(), size_dim_lo = reader.read32u();
                if (size_dim_hi !== 0) caml_failwith("input_value: bigarray dimension overflow in 32bit");
                size_dim = size_dim_lo;
            }
            dims.push(size_dim);
        }
        else for(var i = 0; i < num_dims; i++)dims.push(reader.read32u());
        var size = caml_ba_get_size(dims), data = caml_ba_create_buffer(kind, size), ba = caml_ba_create_unsafe(kind, layout, dims, data);
        switch(kind){
            case 2:
                for(var i = 0; i < size; i++)data[i] = reader.read8s();
                break;
            case 3:
            case 12:
                for(var i = 0; i < size; i++)data[i] = reader.read8u();
                break;
            case 4:
                for(var i = 0; i < size; i++)data[i] = reader.read16s();
                break;
            case 5:
                for(var i = 0; i < size; i++)data[i] = reader.read16u();
                break;
            case 6:
                for(var i = 0; i < size; i++)data[i] = reader.read32s();
                break;
            case 8:
            case 9:
                var sixty = reader.read8u();
                if (sixty) caml_failwith("input_value: cannot read bigarray with 64-bit OCaml ints");
                for(var i = 0; i < size; i++)data[i] = reader.read32s();
                break;
            case 7:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var int64 = caml_int64_of_bytes(t);
                    ba.set(i, int64);
                }
                break;
            case 1:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var f = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    ba.set(i, f);
                }
                break;
            case 13:
                for(var i = 0; i < size; i++)data[i] = reader.read16u();
                break;
            case 0:
                for(var i = 0; i < size; i++){
                    var f = caml_int32_float_of_bits(reader.read32s());
                    ba.set(i, f);
                }
                break;
            case 10:
                for(var i = 0; i < size; i++){
                    var re = caml_int32_float_of_bits(reader.read32s()), im = caml_int32_float_of_bits(reader.read32s());
                    ba.set(i, [
                        254,
                        re,
                        im
                    ]);
                }
                break;
            case 11:
                var t = new Array(8);
                for(var i = 0; i < size; i++){
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var re = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                    var im = caml_int64_float_of_bits(caml_int64_of_bytes(t));
                    ba.set(i, [
                        254,
                        re,
                        im
                    ]);
                }
                break;
        }
        sz[0] = (4 + num_dims) * 4;
        return caml_ba_create_unsafe(kind, layout, dims, data);
    }
    function caml_ba_compare(a, b, total) {
        return a.compare(b, total);
    }
    function caml_hash_mix_float16(hash, d) {
        if ((d & 0x7c00) === 0x7c00 && (d & 0x03ff) !== 0) d = 0x7c01;
        else if (d === 0x8000) d = 0;
        return caml_hash_mix_int(hash, d);
    }
    function caml_ba_hash(ba) {
        var num_elts = caml_ba_get_size(ba.dims), h = 0;
        switch(ba.kind){
            case 2:
            case 3:
            case 12:
                if (num_elts > 256) num_elts = 256;
                var w = 0, i = 0;
                for(i = 0; i + 4 <= ba.data.length; i += 4){
                    w = ba.data[i + 0] | ba.data[i + 1] << 8 | ba.data[i + 2] << 16 | ba.data[i + 3] << 24;
                    h = caml_hash_mix_int(h, w);
                }
                w = 0;
                switch(num_elts & 3){
                    case 3:
                        w = ba.data[i + 2] << 16;
                    case 2:
                        w |= ba.data[i + 1] << 8;
                    case 1:
                        w |= ba.data[i + 0];
                        h = caml_hash_mix_int(h, w);
                }
                break;
            case 4:
            case 5:
                if (num_elts > 128) num_elts = 128;
                var w = 0, i = 0;
                for(i = 0; i + 2 <= ba.data.length; i += 2){
                    w = ba.data[i + 0] | ba.data[i + 1] << 16;
                    h = caml_hash_mix_int(h, w);
                }
                if ((num_elts & 1) !== 0) h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 6:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 8:
            case 9:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 7:
                if (num_elts > 32) num_elts = 32;
                num_elts *= 2;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_int(h, ba.data[i]);
                break;
            case 10:
                num_elts *= 2;
            case 0:
                if (num_elts > 64) num_elts = 64;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_float(h, ba.data[i]);
                break;
            case 11:
                num_elts *= 2;
            case 1:
                if (num_elts > 32) num_elts = 32;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_float(h, ba.data[i]);
                break;
            case 13:
                if (num_elts > 128) num_elts = 128;
                for(var i = 0; i < num_elts; i++)h = caml_hash_mix_float16(h, ba.data[i]);
                break;
        }
        return h;
    }
    function caml_int32_unmarshal(reader, size) {
        size[0] = 4;
        return reader.read32s();
    }
    function caml_nativeint_unmarshal(reader, size) {
        switch(reader.read8u()){
            case 1:
                size[0] = 4;
                return reader.read32s();
            case 2:
                caml_failwith("input_value: native integer value too large");
                break;
            default:
                caml_failwith("input_value: ill-formed native integer");
        }
    }
    function caml_int64_unmarshal(reader, size) {
        var t = new Array(8);
        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
        size[0] = 8;
        return caml_int64_of_bytes(t);
    }
    function caml_int64_marshal(writer, v, sizes) {
        var b = caml_int64_to_bytes(v);
        for(var i = 0; i < 8; i++)writer.write(8, b[i]);
        sizes[0] = 8;
        sizes[1] = 8;
    }
    function caml_int64_compare(x, y, total) {
        return x.compare(y);
    }
    function caml_int64_hash(v) {
        return v.lo32() ^ v.hi32();
    }
    var caml_custom_ops = {
        _j: {
            deserialize: caml_int64_unmarshal,
            serialize: caml_int64_marshal,
            fixed_length: 8,
            compare: caml_int64_compare,
            hash: caml_int64_hash
        },
        _i: {
            deserialize: caml_int32_unmarshal,
            fixed_length: 4
        },
        _n: {
            deserialize: caml_nativeint_unmarshal,
            fixed_length: 4
        },
        _bigarray: {
            deserialize: function(reader, sz) {
                return caml_ba_deserialize(reader, sz, "_bigarray");
            },
            serialize: caml_ba_serialize,
            compare: caml_ba_compare,
            hash: caml_ba_hash
        },
        _bigarr02: {
            deserialize: function(reader, sz) {
                return caml_ba_deserialize(reader, sz, "_bigarr02");
            },
            serialize: caml_ba_serialize,
            compare: caml_ba_compare,
            hash: caml_ba_hash
        }
    };
    function caml_hash_mix_final(h) {
        h ^= h >>> 16;
        h = caml_mul(h, -2048144789);
        h ^= h >>> 13;
        h = caml_mul(h, -1028477387);
        h ^= h >>> 16;
        return h;
    }
    function caml_is_ml_string(s) {
        return typeof s === "string" && !/[^\x00-\xff]/.test(s);
    }
    function caml_is_ml_bytes(s) {
        return s instanceof MlBytes;
    }
    function caml_hash(count, limit, seed, obj) {
        var queue, rd, wr, sz, num, h, v, i, len;
        sz = limit;
        if (sz < 0 || sz > 256) sz = 256;
        num = count;
        h = seed;
        queue = [
            obj
        ];
        rd = 0;
        wr = 1;
        while(rd < wr && num > 0){
            v = queue[rd++];
            if (v && v.caml_custom) {
                if (caml_custom_ops[v.caml_custom] && caml_custom_ops[v.caml_custom].hash) {
                    var hh = caml_custom_ops[v.caml_custom].hash(v);
                    h = caml_hash_mix_int(h, hh);
                    num--;
                }
            } else if (Array.isArray(v) && v[0] === (v[0] | 0)) switch(v[0]){
                case 248:
                    h = caml_hash_mix_int(h, v[2]);
                    num--;
                    break;
                case 250:
                    queue[--rd] = v[1];
                    break;
                default:
                    if (caml_is_continuation_tag(v[0])) break;
                    var tag = v.length - 1 << 10 | v[0];
                    h = caml_hash_mix_int(h, tag);
                    for(i = 1, len = v.length; i < len; i++){
                        if (wr >= sz) break;
                        queue[wr++] = v[i];
                    }
                    break;
            }
            else if (caml_is_ml_bytes(v)) {
                h = caml_hash_mix_bytes(h, v);
                num--;
            } else if (caml_is_ml_string(v)) {
                h = caml_hash_mix_string(h, v);
                num--;
            } else if (typeof v === "string") {
                h = caml_hash_mix_jsbytes(h, v);
                num--;
            } else if (v === (v | 0)) {
                h = caml_hash_mix_int(h, v + v + 1);
                num--;
            } else if (typeof v === "number") {
                h = caml_hash_mix_float(h, v);
                num--;
            }
        }
        h = caml_hash_mix_final(h);
        return h & 0x3fffffff;
    }
    function Base_hash_double(d) {
        return caml_hash(1, 1, 0, d);
    }
    function Base_hash_string(s) {
        return caml_hash(1, 1, 0, s);
    }
    function Base_int_math_int32_clz(x) {
        var n = 32, y;
        y = x >> 16;
        if (y != 0) {
            n = n - 16;
            x = y;
        }
        y = x >> 8;
        if (y != 0) {
            n = n - 8;
            x = y;
        }
        y = x >> 4;
        if (y != 0) {
            n = n - 4;
            x = y;
        }
        y = x >> 2;
        if (y != 0) {
            n = n - 2;
            x = y;
        }
        y = x >> 1;
        if (y != 0) return n - 2;
        return n - x;
    }
    function Base_int_math_int32_ctz(x) {
        if (x === 0) return 32;
        var n = 1;
        if ((x & 0x0000FFFF) === 0) {
            n = n + 16;
            x = x >> 16;
        }
        if ((x & 0x000000FF) === 0) {
            n = n + 8;
            x = x >> 8;
        }
        if ((x & 0x0000000F) === 0) {
            n = n + 4;
            x = x >> 4;
        }
        if ((x & 0x00000003) === 0) {
            n = n + 2;
            x = x >> 2;
        }
        return n - (x & 1);
    }
    function caml_int64_shift_right_unsigned(x, s) {
        return x.shift_right_unsigned(s);
    }
    function caml_int64_is_zero(x) {
        return +x.isZero();
    }
    function caml_int64_to_int32(x) {
        return x.toInt();
    }
    function Base_int_math_int64_clz(x) {
        var n = 64, y;
        y = caml_int64_shift_right_unsigned(x, 32);
        if (!caml_int64_is_zero(y)) {
            n = n - 32;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 16);
        if (!caml_int64_is_zero(y)) {
            n = n - 16;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 8);
        if (!caml_int64_is_zero(y)) {
            n = n - 8;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 4);
        if (!caml_int64_is_zero(y)) {
            n = n - 4;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 2);
        if (!caml_int64_is_zero(y)) {
            n = n - 2;
            x = y;
        }
        y = caml_int64_shift_right_unsigned(x, 1);
        if (!caml_int64_is_zero(y)) return n - 2;
        return n - caml_int64_to_int32(x);
    }
    function caml_int64_and(x, y) {
        return x.and(y);
    }
    function caml_int64_of_int32(x) {
        return new MlInt64(x & 0xffffff, x >> 24 & 0xffffff, x >> 31 & 0xffff);
    }
    function Base_int_math_int64_ctz(x) {
        if (caml_int64_is_zero(x)) return 64;
        var n = 1;
        function is_zero(x) {
            return caml_int64_is_zero(x);
        }
        function land(x, y) {
            return caml_int64_and(x, y);
        }
        function small_int64(x) {
            return caml_int64_create_lo_mi_hi(x, 0, 0);
        }
        if (is_zero(land(x, caml_int64_create_lo_mi_hi(0xFFFFFF, 0x0000FF, 0x0000)))) {
            n = n + 32;
            x = caml_int64_shift_right_unsigned(x, 32);
        }
        if (is_zero(land(x, small_int64(0x00FFFF)))) {
            n = n + 16;
            x = caml_int64_shift_right_unsigned(x, 16);
        }
        if (is_zero(land(x, small_int64(0x0000FF)))) {
            n = n + 8;
            x = caml_int64_shift_right_unsigned(x, 8);
        }
        if (is_zero(land(x, small_int64(0x00000F)))) {
            n = n + 4;
            x = caml_int64_shift_right_unsigned(x, 4);
        }
        if (is_zero(land(x, small_int64(0x000003)))) {
            n = n + 2;
            x = caml_int64_shift_right_unsigned(x, 2);
        }
        return n - caml_int64_to_int32(caml_int64_and(x, small_int64(0x000001)));
    }
    function caml_int64_mul(x, y) {
        return x.mul(y);
    }
    function Base_int_math_int64_pow_stub(base, exponent) {
        var one = caml_int64_create_lo_hi(1, 0), mul = [
            one,
            base,
            one,
            one
        ], res = one;
        while(!caml_int64_is_zero(exponent)){
            mul[1] = caml_int64_mul(mul[1], mul[3]);
            mul[2] = caml_int64_mul(mul[1], mul[1]);
            mul[3] = caml_int64_mul(mul[2], mul[1]);
            res = caml_int64_mul(res, mul[caml_int64_lo32(exponent) & 3]);
            exponent = caml_int64_shift_right_unsigned(exponent, 2);
        }
        return res;
    }
    function Base_int_math_int_clz(x) {
        return Base_int_math_int32_clz(x);
    }
    function Base_int_math_int_ctz(x) {
        return Base_int_math_int32_ctz(x);
    }
    function Base_int_math_int_popcount(v) {
        v = v - (v >>> 1 & 0x55555555);
        v = (v & 0x33333333) + (v >>> 2 & 0x33333333);
        return (v + (v >>> 4) & 0xF0F0F0F) * 0x1010101 >>> 24;
    }
    function Base_int_math_int_pow_stub(base, exponent) {
        var one = 1, mul = [
            one,
            base,
            one,
            one
        ], res = one;
        while(!exponent == 0){
            mul[1] = mul[1] * mul[3] | 0;
            mul[2] = mul[1] * mul[1] | 0;
            mul[3] = mul[2] * mul[1] | 0;
            res = res * mul[exponent & 3] | 0;
            exponent = exponent >> 2;
        }
        return res;
    }
    function Base_int_math_nativeint_clz(x) {
        return Base_int_math_int32_clz(x);
    }
    function Base_int_math_nativeint_ctz(x) {
        return Base_int_math_int32_ctz(x);
    }
    var Base_internalhash_fold_float = caml_hash_mix_float, Base_internalhash_fold_int = caml_hash_mix_int, Base_internalhash_fold_int64 = caml_hash_mix_int64, Base_internalhash_fold_string = caml_hash_mix_string;
    function Base_internalhash_get_hash_value(seed) {
        var h = caml_hash_mix_final(seed);
        return h & 0x3FFFFFFF;
    }
    function caml_create_bytes(len) {
        if (len < 0) caml_invalid_argument("Bytes.create");
        return new MlBytes(len ? 2 : 9, "", len);
    }
    function Base_unsafe_create_local_bytes(v_len) {
        return caml_create_bytes(v_len);
    }
    function caml_string_of_uint8_array(a) {
        return caml_sub_uint8_array_to_jsbytes(a, 0, a.length);
    }
    function caml_ba_get_1(ba, i0) {
        return ba.get(ba.offset(i0));
    }
    function BigStringReader(bs, i) {
        this.s = bs;
        this.i = i;
    }
    BigStringReader.prototype = {
        read8u: function() {
            return caml_ba_get_1(this.s, this.i++);
        },
        read8s: function() {
            return caml_ba_get_1(this.s, this.i++) << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return caml_ba_get_1(s, i) << 8 | caml_ba_get_1(s, i + 1);
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return caml_ba_get_1(s, i) << 24 >> 16 | caml_ba_get_1(s, i + 1);
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (caml_ba_get_1(s, i) << 24 | caml_ba_get_1(s, i + 1) << 16 | caml_ba_get_1(s, i + 2) << 8 | caml_ba_get_1(s, i + 3)) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return caml_ba_get_1(s, i) << 24 | caml_ba_get_1(s, i + 1) << 16 | caml_ba_get_1(s, i + 2) << 8 | caml_ba_get_1(s, i + 3);
        },
        readstr: function(len) {
            var i = this.i, offset = this.offset(i);
            this.i = i + len;
            return caml_string_of_uint8_array(this.s.data.subarray(offset, offset + len));
        },
        readuint8array: function(len) {
            var i = this.i, offset = this.offset(i);
            this.i = i + len;
            return this.s.data.subarray(offset, offset + len);
        }
    };
    function MlChanid(id) {
        this.id = id;
    }
    function caml_utf8_of_utf16(s) {
        for(var b = "", t = b, c, d, i = 0, l = s.length; i < l; i++){
            c = s.charCodeAt(i);
            if (c < 0x80) {
                for(var j = i + 1; j < l && (c = s.charCodeAt(j)) < 0x80; j++);
                if (j - i > 512) {
                    t.slice(0, 1);
                    b += t;
                    t = "";
                    b += s.slice(i, j);
                } else t += s.slice(i, j);
                if (j === l) break;
                i = j;
            }
            if (c < 0x800) {
                t += String.fromCharCode(0xc0 | c >> 6);
                t += String.fromCharCode(0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xdfff) t += String.fromCharCode(0xe0 | c >> 12, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
            else if (c >= 0xdbff || i + 1 === l || (d = s.charCodeAt(i + 1)) < 0xdc00 || d > 0xdfff) t += "\xef\xbf\xbd";
            else {
                i++;
                c = (c << 10) + d - 0x35fdc00;
                t += String.fromCharCode(0xf0 | c >> 18, 0x80 | c >> 12 & 0x3f, 0x80 | c >> 6 & 0x3f, 0x80 | c & 0x3f);
            }
            if (t.length > 1024) {
                t.slice(0, 1);
                b += t;
                t = "";
            }
        }
        return b + t;
    }
    function caml_string_of_jsstring(s) {
        return jsoo_is_ascii(s) ? caml_string_of_jsbytes(s) : caml_string_of_jsbytes(caml_utf8_of_utf16(s));
    }
    function caml_raise_sys_error(msg) {
        caml_raise_with_arg(caml_global_data.Sys_error, caml_string_of_jsstring(msg));
    }
    function caml_raise_with_args(tag, args) {
        throw caml_maybe_attach_backtrace([
            0,
            tag
        ].concat(args));
    }
    var unix_error = [
        "E2BIG",
        "EACCES",
        "EAGAIN",
        "EBADF",
        "EBUSY",
        "ECHILD",
        "EDEADLK",
        "EDOM",
        "EEXIST",
        "EFAULT",
        "EFBIG",
        "EINTR",
        "EINVAL",
        "EIO",
        "EISDIR",
        "EMFILE",
        "EMLINK",
        "ENAMETOOLONG",
        "ENFILE",
        "ENODEV",
        "ENOENT",
        "ENOEXEC",
        "ENOLCK",
        "ENOMEM",
        "ENOSPC",
        "ENOSYS",
        "ENOTDIR",
        "ENOTEMPTY",
        "ENOTTY",
        "ENXIO",
        "EPERM",
        "EPIPE",
        "ERANGE",
        "EROFS",
        "ESPIPE",
        "ESRCH",
        "EXDEV",
        "EWOULDBLOCK",
        "EINPROGRESS",
        "EALREADY",
        "ENOTSOCK",
        "EDESTADDRREQ",
        "EMSGSIZE",
        "EPROTOTYPE",
        "ENOPROTOOPT",
        "EPROTONOSUPPORT",
        "ESOCKTNOSUPPORT",
        "EOPNOTSUPP",
        "EPFNOSUPPORT",
        "EAFNOSUPPORT",
        "EADDRINUSE",
        "EADDRNOTAVAIL",
        "ENETDOWN",
        "ENETUNREACH",
        "ENETRESET",
        "ECONNABORTED",
        "ECONNRESET",
        "ENOBUFS",
        "EISCONN",
        "ENOTCONN",
        "ESHUTDOWN",
        "ETOOMANYREFS",
        "ETIMEDOUT",
        "ECONNREFUSED",
        "EHOSTDOWN",
        "EHOSTUNREACH",
        "ELOOP",
        "EOVERFLOW"
    ];
    function make_unix_err_args(code, syscall, path, errno) {
        var variant = unix_error.indexOf(code);
        if (variant < 0) {
            if (errno == null) errno = -9999;
            variant = [
                0,
                -errno
            ];
        }
        var args = [
            variant,
            caml_string_of_jsstring(syscall || ""),
            caml_string_of_jsstring(path || "")
        ];
        return args;
    }
    var caml_named_values = {};
    function caml_named_value(nm) {
        return caml_named_values[nm];
    }
    function caml_raise_system_error(raise_unix, code, cmd, msg, path) {
        var unix_error = caml_named_value("Unix.Unix_error");
        if (raise_unix && unix_error) caml_raise_with_args(unix_error, make_unix_err_args(code, cmd, path));
        else {
            var msg = code + ": " + msg + ", " + cmd;
            if (path !== undefined) msg += " '" + path + "'";
            caml_raise_sys_error(msg);
        }
    }
    function caml_bytes_of_array(a) {
        if (!(a instanceof Uint8Array)) a = new Uint8Array(a);
        return new MlBytes(4, a, a.length);
    }
    function caml_bytes_of_jsbytes(s) {
        return new MlBytes(0, s, s.length);
    }
    function caml_bytes_of_string(s) {
        return caml_bytes_of_jsbytes(caml_jsbytes_of_string(s));
    }
    function caml_raise_no_such_file(name, raise_unix) {
        caml_raise_system_error(raise_unix, "ENOENT", "no such file or directory", name);
    }
    function caml_convert_bytes_to_array(s) {
        var a = new Uint8Array(s.l), b = s.c, l = b.length, i = 0;
        for(; i < l; i++)a[i] = b.charCodeAt(i);
        for(l = s.l; i < l; i++)a[i] = 0;
        s.c = a;
        s.t = 4;
        return a;
    }
    function caml_uint8_array_of_bytes(s) {
        if (s.t !== 4) caml_convert_bytes_to_array(s);
        return s.c;
    }
    function caml_bytes_of_uint8_array(a) {
        return new MlBytes(4, a, a.length);
    }
    function caml_ml_bytes_length(s) {
        return s.l;
    }
    function caml_blit_bytes(s1, i1, s2, i2, len) {
        if (len === 0) return 0;
        if (i2 === 0 && (len >= s2.l || s2.t === 2 && len >= s2.c.length)) {
            s2.c = s1.t === 4 ? caml_sub_uint8_array_to_jsbytes(s1.c, i1, len) : i1 === 0 && s1.c.length === len ? s1.c : s1.c.slice(i1, i1 + len);
            s2.t = s2.c.length === s2.l ? 0 : 2;
        } else if (s2.t === 2 && i2 === s2.c.length) {
            s2.c += s1.t === 4 ? caml_sub_uint8_array_to_jsbytes(s1.c, i1, len) : i1 === 0 && s1.c.length === len ? s1.c : s1.c.slice(i1, i1 + len);
            s2.t = s2.c.length === s2.l ? 0 : 2;
        } else {
            if (s2.t !== 4) caml_convert_bytes_to_array(s2);
            var c1 = s1.c, c2 = s2.c;
            if (s1.t === 4) {
                if (i2 <= i1) for(var i = 0; i < len; i++)c2[i2 + i] = c1[i1 + i];
                else for(var i = len - 1; i >= 0; i--)c2[i2 + i] = c1[i1 + i];
            } else {
                var l = Math.min(len, c1.length - i1);
                for(var i = 0; i < l; i++)c2[i2 + i] = c1.charCodeAt(i1 + i);
                for(; i < len; i++)c2[i2 + i] = 0;
            }
        }
        return 0;
    }
    function MlFile() {}
    function MlFakeFile(content) {
        this.data = content;
    }
    MlFakeFile.prototype = new MlFile();
    MlFakeFile.prototype.constructor = MlFakeFile;
    MlFakeFile.prototype.truncate = function(len) {
        var old = this.data;
        this.data = caml_create_bytes(len | 0);
        caml_blit_bytes(old, 0, this.data, 0, len);
    };
    MlFakeFile.prototype.length = function() {
        return caml_ml_bytes_length(this.data);
    };
    MlFakeFile.prototype.write = function(offset, buf, pos, len) {
        var clen = this.length();
        if (offset + len >= clen) {
            var new_str = caml_create_bytes(offset + len), old_data = this.data;
            this.data = new_str;
            caml_blit_bytes(old_data, 0, this.data, 0, clen);
        }
        caml_blit_bytes(caml_bytes_of_uint8_array(buf), pos, this.data, offset, len);
        return len;
    };
    MlFakeFile.prototype.read = function(offset, buf, pos, len) {
        var clen = this.length();
        if (offset + len >= clen) len = clen - offset;
        if (len) {
            var data = caml_create_bytes(len | 0);
            caml_blit_bytes(this.data, offset, data, 0, len);
            buf.set(caml_uint8_array_of_bytes(data), pos);
        }
        return len;
    };
    function MlFakeFd(name, file, flags) {
        this.file = file;
        this.name = name;
        this.flags = flags;
        this.offset = 0;
        this.seeked = false;
    }
    MlFakeFd.prototype.err_closed = function(cmd, raise_unix) {
        caml_raise_system_error(raise_unix, "EBADF", cmd, "bad file descriptor");
    };
    MlFakeFd.prototype.length = function() {
        if (this.file) return this.file.length();
        this.err_closed("length");
    };
    MlFakeFd.prototype.truncate = function(len, raise_unix) {
        if (this.file) {
            if (!(this.flags.wronly || this.flags.rdwr)) caml_raise_system_error(raise_unix, "EINVAL", "truncate", "invalid argument");
            return this.file.truncate(len);
        }
        this.err_closed("truncate", raise_unix);
    };
    MlFakeFd.prototype.write = function(buf, pos, len, raise_unix) {
        if (this.file && (this.flags.wronly || this.flags.rdwr)) {
            var offset = this.offset;
            this.offset += len;
            return this.file.write(offset, buf, pos, len);
        }
        this.err_closed("write", raise_unix);
    };
    MlFakeFd.prototype.read = function(buf, pos, len, raise_unix) {
        if (this.file && !this.flags.wronly) {
            var offset = this.offset;
            this.offset += len;
            return this.file.read(offset, buf, pos, len);
        }
        this.err_closed("read", raise_unix);
    };
    MlFakeFd.prototype.seek = function(offset, whence, raise_unix) {
        switch(whence){
            case 0:
                break;
            case 1:
                offset += this.offset;
                break;
            case 2:
                offset += this.length();
                break;
        }
        if (offset < 0) caml_raise_system_error(raise_unix, "EINVAL", "lseek", "invalid argument");
        this.offset = offset;
        this.seeked = true;
    };
    MlFakeFd.prototype.close = function() {
        if (!this.file) this.err_closed("close");
        this.file = undefined;
    };
    MlFakeFd.prototype.check_stream_semantics = function(cmd) {
        if (!this.file) return this.err_closed(cmd, 1);
    };
    function MlFakeDevice(root, f) {
        this.content = {};
        this.root = root;
        this.lookupFun = f;
    }
    MlFakeDevice.prototype.nm = function(name) {
        return this.root + name;
    };
    MlFakeDevice.prototype.create_dir_if_needed = function(name) {
        var comp = name.split("/"), res = "";
        for(var i = 0; i < comp.length - 1; i++){
            res += comp[i] + "/";
            if (this.content[res]) continue;
            this.content[res] = Symbol("directory");
        }
    };
    MlFakeDevice.prototype.slash = function(name) {
        return /\/$/.test(name) ? name : name + "/";
    };
    MlFakeDevice.prototype.lookup = function(name) {
        if (!this.content[name] && this.lookupFun) {
            var res = this.lookupFun(caml_string_of_jsstring(this.root), caml_string_of_jsstring(name));
            if (res !== 0) {
                this.create_dir_if_needed(name);
                this.content[name] = new MlFakeFile(caml_bytes_of_string(res[1]));
            }
        }
    };
    MlFakeDevice.prototype.exists = function(name, do_not_lookup) {
        if (name === "") return 1;
        var name_slash = this.slash(name);
        if (this.content[name_slash]) return 1;
        if (!do_not_lookup) this.lookup(name);
        return this.content[name] ? 1 : 0;
    };
    MlFakeDevice.prototype.isFile = function(name) {
        return this.exists(name) && !this.is_dir(name) ? 1 : 0;
    };
    MlFakeDevice.prototype.mkdir = function(name, mode, raise_unix) {
        if (this.exists(name)) caml_raise_system_error(raise_unix, "EEXIST", "mkdir", "file already exists", this.nm(name));
        var parent = /^(.*)\/[^/]+/.exec(name);
        parent = parent && parent[1] || "";
        if (!this.exists(parent)) caml_raise_system_error(raise_unix, "ENOENT", "mkdir", "no such file or directory", this.nm(name));
        if (!this.is_dir(parent)) caml_raise_system_error(raise_unix, "ENOTDIR", "mkdir", "not a directory", this.nm(name));
        this.create_dir_if_needed(this.slash(name));
    };
    MlFakeDevice.prototype.rmdir = function(name, raise_unix) {
        var name_slash = name === "" ? "" : this.slash(name), r = new RegExp("^" + name_slash + "([^/]+)");
        if (!this.exists(name)) caml_raise_system_error(raise_unix, "ENOENT", "rmdir", "no such file or directory", this.nm(name));
        if (!this.is_dir(name)) caml_raise_system_error(raise_unix, "ENOTDIR", "rmdir", "not a directory", this.nm(name));
        for(var n in this.content)if (n.match(r)) caml_raise_system_error(raise_unix, "ENOTEMPTY", "rmdir", "directory not empty", this.nm(name));
        delete this.content[name_slash];
    };
    MlFakeDevice.prototype.readdir = function(name) {
        var name_slash = name === "" ? "" : this.slash(name);
        if (!this.exists(name)) caml_raise_sys_error(name + ": No such file or directory");
        if (!this.is_dir(name)) caml_raise_sys_error(name + ": Not a directory");
        var r = new RegExp("^" + name_slash + "([^/]+)"), seen = {}, a = [];
        for(var n in this.content){
            var m = n.match(r);
            if (m && !seen[m[1]]) {
                seen[m[1]] = true;
                a.push(m[1]);
            }
        }
        return a;
    };
    MlFakeDevice.prototype.opendir = function(name, raise_unix) {
        var a = this.readdir(name), c = false, i = 0;
        return {
            readSync: function() {
                if (c) caml_raise_system_error(raise_unix, "EBADF", "readdir", "bad file descriptor");
                if (i === a.length) return null;
                var entry = a[i];
                i++;
                return {
                    name: entry
                };
            },
            closeSync: function() {
                if (c) caml_raise_system_error(raise_unix, "EBADF", "readdir", "bad file descriptor");
                c = true;
                a = [];
            }
        };
    };
    MlFakeDevice.prototype.is_dir = function(name) {
        if (name === "") return true;
        var name_slash = this.slash(name);
        return this.content[name_slash] ? 1 : 0;
    };
    MlFakeDevice.prototype.unlink = function(name, raise_unix) {
        if (!this.exists(name, true)) caml_raise_system_error(raise_unix, "ENOENT", "unlink", "no such file or directory", name);
        delete this.content[name];
        return 0;
    };
    MlFakeDevice.prototype.open = function(name, f, _perms, raise_unix) {
        var file;
        this.lookup(name);
        if (this.content[name]) {
            if (this.is_dir(name)) caml_raise_system_error(raise_unix, "EISDIR", "open", "illegal operation on a directory", this.nm(name));
            if (f.create && f.excl) caml_raise_system_error(raise_unix, "EEXIST", "open", "file already exists", this.nm(name));
            file = this.content[name];
            if (f.truncate) file.truncate();
        } else if (f.create) {
            this.create_dir_if_needed(name);
            this.content[name] = new MlFakeFile(caml_create_bytes(0));
            file = this.content[name];
        } else caml_raise_no_such_file(this.nm(name), raise_unix);
        return new MlFakeFd(this.nm(name), file, f);
    };
    MlFakeDevice.prototype.truncate = function(name, len, raise_unix) {
        var file;
        this.lookup(name);
        if (this.content[name]) {
            if (this.is_dir(name)) caml_raise_system_error(raise_unix, "EISDIR", "open", "illegal operation on a directory", this.nm(name));
            file = this.content[name];
            file.truncate(len);
        } else caml_raise_no_such_file(this.nm(name), raise_unix);
    };
    MlFakeDevice.prototype.register = function(name, content) {
        var file;
        if (this.content[name]) caml_raise_sys_error(this.nm(name) + " : file already exists");
        if (caml_is_ml_bytes(content)) file = new MlFakeFile(content);
        if (caml_is_ml_string(content)) file = new MlFakeFile(caml_bytes_of_string(content));
        else if (Array.isArray(content)) file = new MlFakeFile(caml_bytes_of_array(content));
        else if (typeof content === "string") file = new MlFakeFile(caml_bytes_of_jsbytes(content));
        else if (content.toString) {
            var bytes = caml_bytes_of_string(caml_string_of_jsstring(content.toString()));
            file = new MlFakeFile(bytes);
        }
        if (file) {
            this.create_dir_if_needed(name);
            this.content[name] = file;
        } else caml_raise_sys_error(this.nm(name) + " : registering file with invalid content type");
    };
    MlFakeDevice.prototype.constructor = MlFakeDevice;
    function MlFakeFd_out(fd, flags) {
        MlFakeFile.call(this, caml_create_bytes(0));
        this.log = function(s) {
            return 0;
        };
        if (fd === 1 && typeof console.log === "function") this.log = console.log;
        else if (fd === 2 && typeof console.error === "function") this.log = console.error;
        else if (typeof console.log === "function") this.log = console.log;
        this.flags = flags;
    }
    MlFakeFd_out.prototype.length = function() {
        return 0;
    };
    MlFakeFd_out.prototype.truncate = function(len, raise_unix) {
        caml_raise_system_error(raise_unix, "EINVAL", "ftruncate", "invalid argument");
    };
    MlFakeFd_out.prototype.write = function(buf, pos, len, raise_unix) {
        var written = len;
        if (this.log) {
            if (len > 0 && pos >= 0 && pos + len <= buf.length && buf[pos + len - 1] === 10) len--;
            var src = caml_create_bytes(len);
            caml_blit_bytes(caml_bytes_of_uint8_array(buf), pos, src, 0, len);
            this.log(src.toUtf16());
            return written;
        }
        caml_raise_system_error(raise_unix, "EBADF", "write", "bad file descriptor");
    };
    MlFakeFd_out.prototype.read = function(buf, pos, len, raise_unix) {
        caml_raise_system_error(raise_unix, "EBADF", "read", "bad file descriptor");
    };
    MlFakeFd_out.prototype.seek = function(len, whence, raise_unix) {
        caml_raise_system_error(raise_unix, "ESPIPE", "lseek", "illegal seek");
    };
    MlFakeFd_out.prototype.close = function() {
        this.log = undefined;
    };
    MlFakeFd_out.prototype.check_stream_semantics = function(cmd) {};
    function MlMutex() {
        this.locked = false;
    }
    function MlNat(x) {
        this.data = new Int32Array(x);
        this.length = this.data.length + 2;
    }
    MlNat.prototype.caml_custom = "_nat";
    function caml_raise_nodejs_error(err, raise_unix, cmd) {
        var unix_error = caml_named_value("Unix.Unix_error");
        if (raise_unix && unix_error) {
            var args = make_unix_err_args(err.code, cmd || err.syscall, err.path, err.errno);
            caml_raise_with_args(unix_error, args);
        } else caml_raise_sys_error(err.toString());
    }
    function caml_int64_of_float(x) {
        if (x < 0) x = Math.ceil(x);
        return new MlInt64(x & 0xffffff, Math.floor(x * caml_int64_offset) & 0xffffff, Math.floor(x * caml_int64_offset * caml_int64_offset) & 0xffff);
    }
    function fs_node_stats_from_js(js_stats, large) {
        var file_kind;
        if (js_stats.isFile()) file_kind = 0;
        else if (js_stats.isDirectory()) file_kind = 1;
        else if (js_stats.isCharacterDevice()) file_kind = 2;
        else if (js_stats.isBlockDevice()) file_kind = 3;
        else if (js_stats.isSymbolicLink()) file_kind = 4;
        else if (js_stats.isFIFO()) file_kind = 5;
        else if (js_stats.isSocket()) file_kind = 6;
        return [
            0,
            js_stats.dev,
            js_stats.ino | 0,
            file_kind,
            js_stats.mode,
            js_stats.nlink,
            js_stats.uid,
            js_stats.gid,
            js_stats.rdev,
            large ? caml_int64_of_float(js_stats.size) : js_stats.size | 0,
            js_stats.atimeMs / 1000,
            js_stats.mtimeMs / 1000,
            js_stats.ctimeMs / 1000
        ];
    }
    function caml_ml_string_length(s) {
        return s.length;
    }
    function caml_string_unsafe_get(s, i) {
        return s.charCodeAt(i);
    }
    function caml_uint8_array_of_string(s) {
        var l = caml_ml_string_length(s), a = new Uint8Array(l), i = 0;
        for(; i < l; i++)a[i] = caml_string_unsafe_get(s, i);
        return a;
    }
    function caml_bytes_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    function caml_bytes_unsafe_set(s, i, c) {
        c &= 0xff;
        if (s.t !== 4) {
            if (i === s.c.length) {
                s.c += String.fromCharCode(c);
                if (i + 1 === s.l) s.t = 0;
                return 0;
            }
            caml_convert_bytes_to_array(s);
        }
        s.c[i] = c;
        return 0;
    }
    function caml_bytes_set(s, i, c) {
        if (i >>> 0 >= s.l) caml_bytes_bound_error();
        return caml_bytes_unsafe_set(s, i, c);
    }
    function MlNodeFd(fd, flags) {
        this.fs = (parcelRequire("48K42"));
        this.fd = fd;
        this.flags = flags;
        var stats = this.fs.fstatSync(fd);
        flags.noSeek = stats.isCharacterDevice() || stats.isFIFO() || stats.isSocket();
        this.offset = this.flags.append ? stats.size : 0;
        this.seeked = false;
    }
    MlNodeFd.prototype = new MlFile();
    MlNodeFd.prototype.constructor = MlNodeFd;
    MlNodeFd.prototype.truncate = function(len, raise_unix) {
        try {
            this.fs.ftruncateSync(this.fd, len | 0);
            if (this.offset > len) this.offset = len;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeFd.prototype.length = function() {
        try {
            return this.fs.fstatSync(this.fd).size;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeFd.prototype.write = function(buf, buf_offset, len, raise_unix) {
        try {
            if (this.flags.noSeek || !this.seeked) var written = this.fs.writeSync(this.fd, buf, buf_offset, len);
            else var written = this.fs.writeSync(this.fd, buf, buf_offset, len, this.offset);
            this.offset += written;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
        return written;
    };
    MlNodeFd.prototype.read = function(a, buf_offset, len, raise_unix) {
        try {
            if (this.flags.noSeek || !this.seeked) var read = this.fs.readSync(this.fd, a, buf_offset, len);
            else var read = this.fs.readSync(this.fd, a, buf_offset, len, this.offset);
            this.offset += read;
            return read;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeFd.prototype.seek = function(offset, whence, raise_unix) {
        if (this.flags.noSeek) caml_raise_system_error(raise_unix, "ESPIPE", "lseek", "illegal seek");
        switch(whence){
            case 0:
                break;
            case 1:
                offset += this.offset;
                break;
            case 2:
                offset += this.length();
                break;
        }
        if (offset < 0) caml_raise_system_error(raise_unix, "EINVAL", "lseek", "invalid argument");
        this.offset = offset;
        this.seeked = true;
        return this.offset;
    };
    MlNodeFd.prototype.stat = function(large) {
        try {
            var js_stats = this.fs.fstatSync(this.fd);
            return fs_node_stats_from_js(js_stats, large);
        } catch (err) {
            caml_raise_nodejs_error(err, 1);
        }
    };
    MlNodeFd.prototype.close = function(raise_unix) {
        try {
            this.fs.closeSync(this.fd);
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeFd.prototype.check_stream_semantics = function(cmd) {
        try {
            var js_stats = this.fs.fstatSync(this.fd);
        } catch (err) {
            caml_raise_nodejs_error(err, 1, cmd);
        }
        if (!(js_stats.isFile() || js_stats.isCharacterDevice() || js_stats.isFIFO() || js_stats.isSocket())) caml_raise_system_error(1, "EINVAL", cmd, "invalid argument");
    };
    function MlNodeDevice(root) {
        this.fs = (parcelRequire("48K42"));
        this.root = root;
    }
    MlNodeDevice.prototype.nm = function(name) {
        return this.root + name;
    };
    MlNodeDevice.prototype.exists = function(name) {
        try {
            return this.fs.existsSync(this.nm(name)) ? 1 : 0;
        } catch (err) {
            return 0;
        }
    };
    MlNodeDevice.prototype.isFile = function(name) {
        try {
            return this.fs.statSync(this.nm(name)).isFile() ? 1 : 0;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeDevice.prototype.mkdir = function(name, mode, raise_unix) {
        try {
            this.fs.mkdirSync(this.nm(name), {
                mode: mode
            });
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.rmdir = function(name, raise_unix) {
        try {
            this.fs.rmdirSync(this.nm(name));
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.readdir = function(name, raise_unix) {
        try {
            return this.fs.readdirSync(this.nm(name));
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.is_dir = function(name) {
        try {
            return this.fs.statSync(this.nm(name)).isDirectory() ? 1 : 0;
        } catch (err) {
            caml_raise_sys_error(err.toString());
        }
    };
    MlNodeDevice.prototype.unlink = function(name, raise_unix) {
        try {
            this.fs.unlinkSync(this.nm(name));
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.utimes = function(name, atime, mtime, raise_unix) {
        try {
            if (atime === 0 && mtime === 0) {
                atime = new Date().getTime() / 1000;
                mtime = atime;
            }
            this.fs.utimesSync(this.nm(name), atime, mtime);
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.truncate = function(name, len, raise_unix) {
        try {
            this.fs.truncateSync(this.nm(name), len | 0);
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.open = function(name, f, perms, raise_unix) {
        var consts = (parcelRequire("77U2W")), res = 0;
        for(var key in f)switch(key){
            case "rdonly":
                res |= consts.O_RDONLY;
                break;
            case "wronly":
                res |= consts.O_WRONLY;
                break;
            case "rdwr":
                res |= consts.O_RDWR;
                break;
            case "append":
                res |= consts.O_APPEND;
                break;
            case "create":
                res |= consts.O_CREAT;
                break;
            case "truncate":
                res |= consts.O_TRUNC;
                break;
            case "excl":
                res |= consts.O_EXCL;
                break;
            case "binary":
                res |= consts.O_BINARY;
                break;
            case "text":
                res |= consts.O_TEXT;
                break;
            case "nonblock":
                res |= consts.O_NONBLOCK;
                break;
            case "noctty":
                res |= consts.O_NOCTTY;
                break;
            case "dsync":
                res |= consts.O_DSYNC;
                break;
            case "sync":
                res |= consts.O_SYNC;
                break;
        }
        try {
            var fd = this.fs.openSync(this.nm(name), res, perms);
            return new MlNodeFd(fd, f);
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    if (globalThis1.process?.platform === "win32") MlNodeDevice.prototype.rename = function(o, n, raise_unix) {
        try {
            var target = this.nm(n), source = this.nm(o), target_stats, source_stats;
            if ((target_stats = this.fs.statSync(target, {
                throwIfNoEntry: false
            })) && (source_stats = this.fs.statSync(source, {
                throwIfNoEntry: false
            })) && source_stats.isDirectory()) {
                if (target_stats.isDirectory()) {
                    if (!target.startsWith(source)) try {
                        this.fs.rmdirSync(target);
                    } catch  {}
                } else {
                    var err = new Error(`ENOTDIR: not a directory, rename '${source}' -> '${target}'`);
                    throw Object.assign(err, {
                        errno: -20,
                        code: "ENOTDIR",
                        syscall: "rename",
                        path: target
                    });
                }
            }
            this.fs.renameSync(this.nm(o), this.nm(n));
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    else MlNodeDevice.prototype.rename = function(o, n, raise_unix) {
        try {
            this.fs.renameSync(this.nm(o), this.nm(n));
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.stat = function(name, large, raise_unix) {
        try {
            var js_stats = this.fs.statSync(this.nm(name));
            return fs_node_stats_from_js(js_stats, large);
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.lstat = function(name, large, raise_unix) {
        try {
            var js_stats = this.fs.lstatSync(this.nm(name));
            return fs_node_stats_from_js(js_stats, large);
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.symlink = function(to_dir, target, path, raise_unix) {
        try {
            this.fs.symlinkSync(target, this.nm(path), to_dir === 0 ? null : to_dir[1] ? "dir" : "file");
            return 0;
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.readlink = function(name, raise_unix) {
        try {
            var link = this.fs.readlinkSync(this.nm(name), "utf8");
            return caml_string_of_jsstring(link);
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.opendir = function(name, raise_unix) {
        try {
            return this.fs.opendirSync(this.nm(name));
        } catch (err) {
            caml_raise_nodejs_error(err, raise_unix);
        }
    };
    MlNodeDevice.prototype.constructor = MlNodeDevice;
    var MlObjectTable;
    if (typeof globalThis1.Map === "undefined") MlObjectTable = function() {
        function NaiveLookup(objs) {
            this.objs = objs;
        }
        NaiveLookup.prototype.get = function(v) {
            for(var i = 0; i < this.objs.length; i++)if (this.objs[i] === v) return i;
        };
        NaiveLookup.prototype.set = function() {};
        return function() {
            this.objs = [];
            this.lookup = new NaiveLookup(this.objs);
        };
    }();
    else MlObjectTable = function() {
        this.objs = [];
        this.lookup = new globalThis1.Map();
    };
    MlObjectTable.prototype.store = function(v) {
        this.lookup.set(v, this.objs.length);
        this.objs.push(v);
    };
    MlObjectTable.prototype.recall = function(v) {
        var i = this.lookup.get(v);
        return i === undefined ? undefined : this.objs.length - i;
    };
    function MlStringReader(s, i) {
        this.s = caml_jsbytes_of_string(s);
        this.i = i;
    }
    MlStringReader.prototype = {
        read8u: function() {
            return this.s.charCodeAt(this.i++);
        },
        read8s: function() {
            return this.s.charCodeAt(this.i++) << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s.charCodeAt(i) << 8 | s.charCodeAt(i + 1);
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s.charCodeAt(i) << 24 >> 16 | s.charCodeAt(i + 1);
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (s.charCodeAt(i) << 24 | s.charCodeAt(i + 1) << 16 | s.charCodeAt(i + 2) << 8 | s.charCodeAt(i + 3)) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return s.charCodeAt(i) << 24 | s.charCodeAt(i + 1) << 16 | s.charCodeAt(i + 2) << 8 | s.charCodeAt(i + 3);
        },
        readstr: function(len) {
            var i = this.i;
            this.i = i + len;
            return caml_string_of_jsbytes(this.s.slice(i, i + len));
        },
        readuint8array: function(len) {
            var b = new Uint8Array(len), s = this.s, i = this.i;
            for(var j = 0; j < len; j++)b[j] = s.charCodeAt(i + j);
            this.i = i + len;
            return b;
        }
    };
    function UInt8ArrayReader(s, i) {
        this.s = s;
        this.i = i;
    }
    UInt8ArrayReader.prototype = {
        read8u: function() {
            return this.s[this.i++];
        },
        read8s: function() {
            return this.s[this.i++] << 24 >> 24;
        },
        read16u: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s[i] << 8 | s[i + 1];
        },
        read16s: function() {
            var s = this.s, i = this.i;
            this.i = i + 2;
            return s[i] << 24 >> 16 | s[i + 1];
        },
        read32u: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return (s[i] << 24 | s[i + 1] << 16 | s[i + 2] << 8 | s[i + 3]) >>> 0;
        },
        read32s: function() {
            var s = this.s, i = this.i;
            this.i = i + 4;
            return s[i] << 24 | s[i + 1] << 16 | s[i + 2] << 8 | s[i + 3];
        },
        readstr: function(len) {
            var i = this.i;
            this.i = i + len;
            return caml_string_of_uint8_array(this.s.subarray(i, i + len));
        },
        readuint8array: function(len) {
            var i = this.i;
            this.i = i + len;
            return this.s.subarray(i, i + len);
        }
    };
    function incr_nat(nat, ofs, len, carry_in) {
        var carry = carry_in;
        for(var i = 0; i < len; i++){
            var x = (nat.data[ofs + i] >>> 0) + carry;
            nat.data[ofs + i] = x | 0;
            if (x === x >>> 0) {
                carry = 0;
                break;
            } else carry = 1;
        }
        return carry;
    }
    function add_nat(nat1, ofs1, len1, nat2, ofs2, len2, carry_in) {
        var carry = carry_in;
        for(var i = 0; i < len2; i++){
            var x = (nat1.data[ofs1 + i] >>> 0) + (nat2.data[ofs2 + i] >>> 0) + carry;
            nat1.data[ofs1 + i] = x;
            if (x === x >>> 0) carry = 0;
            else carry = 1;
        }
        return incr_nat(nat1, ofs1 + len2, len1 - len2, carry);
    }
    function bigstring_of_array_buffer(ab) {
        var ta = new Uint8Array(ab);
        return caml_ba_create_unsafe(12, 0, [
            ta.length
        ], ta);
    }
    function bigstring_of_typed_array(ba) {
        var ta = new Uint8Array(ba.buffer, ba.byteOffset, ba.length * ba.BYTES_PER_ELEMENT);
        return caml_ba_create_unsafe(12, 0, [
            ta.length
        ], ta);
    }
    function bigstring_to_array_buffer(bs) {
        return bs.data.buffer;
    }
    function bigstring_to_typed_array(bs) {
        return bs.data;
    }
    var blake2b = function() {
        function ADD64AA(v, a, b) {
            const o0 = v[a] + v[b];
            let o1 = v[a + 1] + v[b + 1];
            if (o0 >= 0x100000000) o1++;
            v[a] = o0;
            v[a + 1] = o1;
        }
        function ADD64AC(v, a, b0, b1) {
            let o0 = v[a] + b0;
            if (b0 < 0) o0 += 0x100000000;
            let o1 = v[a + 1] + b1;
            if (o0 >= 0x100000000) o1++;
            v[a] = o0;
            v[a + 1] = o1;
        }
        function B2B_GET32(arr, i) {
            return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
        }
        function B2B_G(a, b, c, d, ix, iy) {
            const x0 = m[ix], x1 = m[ix + 1], y0 = m[iy], y1 = m[iy + 1];
            ADD64AA(v, a, b);
            ADD64AC(v, a, x0, x1);
            let xor0 = v[d] ^ v[a], xor1 = v[d + 1] ^ v[a + 1];
            v[d] = xor1;
            v[d + 1] = xor0;
            ADD64AA(v, c, d);
            xor0 = v[b] ^ v[c];
            xor1 = v[b + 1] ^ v[c + 1];
            v[b] = xor0 >>> 24 ^ xor1 << 8;
            v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
            ADD64AA(v, a, b);
            ADD64AC(v, a, y0, y1);
            xor0 = v[d] ^ v[a];
            xor1 = v[d + 1] ^ v[a + 1];
            v[d] = xor0 >>> 16 ^ xor1 << 16;
            v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
            ADD64AA(v, c, d);
            xor0 = v[b] ^ v[c];
            xor1 = v[b + 1] ^ v[c + 1];
            v[b] = xor1 >>> 31 ^ xor0 << 1;
            v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
        }
        const BLAKE2B_IV32 = new Uint32Array([
            0xf3bcc908,
            0x6a09e667,
            0x84caa73b,
            0xbb67ae85,
            0xfe94f82b,
            0x3c6ef372,
            0x5f1d36f1,
            0xa54ff53a,
            0xade682d1,
            0x510e527f,
            0x2b3e6c1f,
            0x9b05688c,
            0xfb41bd6b,
            0x1f83d9ab,
            0x137e2179,
            0x5be0cd19
        ]), SIGMA8 = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            14,
            10,
            4,
            8,
            9,
            15,
            13,
            6,
            1,
            12,
            0,
            2,
            11,
            7,
            5,
            3,
            11,
            8,
            12,
            0,
            5,
            2,
            15,
            13,
            10,
            14,
            3,
            6,
            7,
            1,
            9,
            4,
            7,
            9,
            3,
            1,
            13,
            12,
            11,
            14,
            2,
            6,
            5,
            10,
            4,
            0,
            15,
            8,
            9,
            0,
            5,
            7,
            2,
            4,
            10,
            15,
            14,
            1,
            11,
            12,
            6,
            8,
            3,
            13,
            2,
            12,
            6,
            10,
            0,
            11,
            8,
            3,
            4,
            13,
            7,
            5,
            15,
            14,
            1,
            9,
            12,
            5,
            1,
            15,
            14,
            13,
            4,
            10,
            0,
            7,
            6,
            3,
            9,
            2,
            8,
            11,
            13,
            11,
            7,
            14,
            12,
            1,
            3,
            9,
            5,
            0,
            15,
            4,
            8,
            6,
            2,
            10,
            6,
            15,
            14,
            9,
            11,
            3,
            0,
            8,
            12,
            2,
            13,
            7,
            1,
            4,
            10,
            5,
            10,
            2,
            8,
            4,
            7,
            6,
            1,
            5,
            15,
            11,
            9,
            14,
            3,
            12,
            13,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            14,
            10,
            4,
            8,
            9,
            15,
            13,
            6,
            1,
            12,
            0,
            2,
            11,
            7,
            5,
            3
        ], SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
            return x * 2;
        })), v = new Uint32Array(32), m = new Uint32Array(32);
        function blake2bCompress(ctx, last) {
            let i = 0;
            for(i = 0; i < 16; i++){
                v[i] = ctx.h[i];
                v[i + 16] = BLAKE2B_IV32[i];
            }
            v[24] = v[24] ^ ctx.t;
            v[25] = v[25] ^ ctx.t / 0x100000000;
            if (last) {
                v[28] = ~v[28];
                v[29] = ~v[29];
            }
            for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
            for(i = 0; i < 12; i++){
                B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
            }
            for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
        }
        const parameterBlock = new Uint8Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        function blake2bInit(outlen, key) {
            if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
            if (key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
            const ctx = {
                b: new Uint8Array(128),
                h: new Uint32Array(16),
                t: 0,
                c: 0,
                outlen: outlen
            };
            parameterBlock.fill(0);
            parameterBlock[0] = outlen;
            parameterBlock[1] = key.length;
            parameterBlock[2] = 1;
            parameterBlock[3] = 1;
            for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameterBlock, i * 4);
            if (key.length > 0) {
                blake2bUpdate(ctx, key);
                ctx.c = 128;
            }
            return ctx;
        }
        function blake2bUpdate(ctx, input) {
            for(let i = 0; i < input.length; i++){
                if (ctx.c === 128) {
                    ctx.t += ctx.c;
                    blake2bCompress(ctx, false);
                    ctx.c = 0;
                }
                ctx.b[ctx.c++] = input[i];
            }
        }
        function blake2bFinal(ctx) {
            ctx.t += ctx.c;
            while(ctx.c < 128)ctx.b[ctx.c++] = 0;
            blake2bCompress(ctx, true);
            const out = new Uint8Array(ctx.outlen);
            for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
            return out;
        }
        return {
            Init: blake2bInit,
            Update: blake2bUpdate,
            Final: blake2bFinal
        };
    }();
    function blit_nat(nat1, ofs1, nat2, ofs2, len) {
        for(var i = 0; i < len; i++)nat1.data[ofs1 + i] = nat2.data[ofs2 + i];
        return 0;
    }
    var caml_MD5Transform = function() {
        function add(x, y) {
            return x + y | 0;
        }
        function xx(q, a, b, x, s, t) {
            a = add(add(a, q), add(x, t));
            return add(a << s | a >>> 32 - s, b);
        }
        function ff(a, b, c, d, x, s, t) {
            return xx(b & c | ~b & d, a, b, x, s, t);
        }
        function gg(a, b, c, d, x, s, t) {
            return xx(b & d | c & ~d, a, b, x, s, t);
        }
        function hh(a, b, c, d, x, s, t) {
            return xx(b ^ c ^ d, a, b, x, s, t);
        }
        function ii(a, b, c, d, x, s, t) {
            return xx(c ^ (b | ~d), a, b, x, s, t);
        }
        return function(w, buffer) {
            var a = w[0], b = w[1], c = w[2], d = w[3];
            a = ff(a, b, c, d, buffer[0], 7, 0xd76aa478);
            d = ff(d, a, b, c, buffer[1], 12, 0xe8c7b756);
            c = ff(c, d, a, b, buffer[2], 17, 0x242070db);
            b = ff(b, c, d, a, buffer[3], 22, 0xc1bdceee);
            a = ff(a, b, c, d, buffer[4], 7, 0xf57c0faf);
            d = ff(d, a, b, c, buffer[5], 12, 0x4787c62a);
            c = ff(c, d, a, b, buffer[6], 17, 0xa8304613);
            b = ff(b, c, d, a, buffer[7], 22, 0xfd469501);
            a = ff(a, b, c, d, buffer[8], 7, 0x698098d8);
            d = ff(d, a, b, c, buffer[9], 12, 0x8b44f7af);
            c = ff(c, d, a, b, buffer[10], 17, 0xffff5bb1);
            b = ff(b, c, d, a, buffer[11], 22, 0x895cd7be);
            a = ff(a, b, c, d, buffer[12], 7, 0x6b901122);
            d = ff(d, a, b, c, buffer[13], 12, 0xfd987193);
            c = ff(c, d, a, b, buffer[14], 17, 0xa679438e);
            b = ff(b, c, d, a, buffer[15], 22, 0x49b40821);
            a = gg(a, b, c, d, buffer[1], 5, 0xf61e2562);
            d = gg(d, a, b, c, buffer[6], 9, 0xc040b340);
            c = gg(c, d, a, b, buffer[11], 14, 0x265e5a51);
            b = gg(b, c, d, a, buffer[0], 20, 0xe9b6c7aa);
            a = gg(a, b, c, d, buffer[5], 5, 0xd62f105d);
            d = gg(d, a, b, c, buffer[10], 9, 0x02441453);
            c = gg(c, d, a, b, buffer[15], 14, 0xd8a1e681);
            b = gg(b, c, d, a, buffer[4], 20, 0xe7d3fbc8);
            a = gg(a, b, c, d, buffer[9], 5, 0x21e1cde6);
            d = gg(d, a, b, c, buffer[14], 9, 0xc33707d6);
            c = gg(c, d, a, b, buffer[3], 14, 0xf4d50d87);
            b = gg(b, c, d, a, buffer[8], 20, 0x455a14ed);
            a = gg(a, b, c, d, buffer[13], 5, 0xa9e3e905);
            d = gg(d, a, b, c, buffer[2], 9, 0xfcefa3f8);
            c = gg(c, d, a, b, buffer[7], 14, 0x676f02d9);
            b = gg(b, c, d, a, buffer[12], 20, 0x8d2a4c8a);
            a = hh(a, b, c, d, buffer[5], 4, 0xfffa3942);
            d = hh(d, a, b, c, buffer[8], 11, 0x8771f681);
            c = hh(c, d, a, b, buffer[11], 16, 0x6d9d6122);
            b = hh(b, c, d, a, buffer[14], 23, 0xfde5380c);
            a = hh(a, b, c, d, buffer[1], 4, 0xa4beea44);
            d = hh(d, a, b, c, buffer[4], 11, 0x4bdecfa9);
            c = hh(c, d, a, b, buffer[7], 16, 0xf6bb4b60);
            b = hh(b, c, d, a, buffer[10], 23, 0xbebfbc70);
            a = hh(a, b, c, d, buffer[13], 4, 0x289b7ec6);
            d = hh(d, a, b, c, buffer[0], 11, 0xeaa127fa);
            c = hh(c, d, a, b, buffer[3], 16, 0xd4ef3085);
            b = hh(b, c, d, a, buffer[6], 23, 0x04881d05);
            a = hh(a, b, c, d, buffer[9], 4, 0xd9d4d039);
            d = hh(d, a, b, c, buffer[12], 11, 0xe6db99e5);
            c = hh(c, d, a, b, buffer[15], 16, 0x1fa27cf8);
            b = hh(b, c, d, a, buffer[2], 23, 0xc4ac5665);
            a = ii(a, b, c, d, buffer[0], 6, 0xf4292244);
            d = ii(d, a, b, c, buffer[7], 10, 0x432aff97);
            c = ii(c, d, a, b, buffer[14], 15, 0xab9423a7);
            b = ii(b, c, d, a, buffer[5], 21, 0xfc93a039);
            a = ii(a, b, c, d, buffer[12], 6, 0x655b59c3);
            d = ii(d, a, b, c, buffer[3], 10, 0x8f0ccc92);
            c = ii(c, d, a, b, buffer[10], 15, 0xffeff47d);
            b = ii(b, c, d, a, buffer[1], 21, 0x85845dd1);
            a = ii(a, b, c, d, buffer[8], 6, 0x6fa87e4f);
            d = ii(d, a, b, c, buffer[15], 10, 0xfe2ce6e0);
            c = ii(c, d, a, b, buffer[6], 15, 0xa3014314);
            b = ii(b, c, d, a, buffer[13], 21, 0x4e0811a1);
            a = ii(a, b, c, d, buffer[4], 6, 0xf7537e82);
            d = ii(d, a, b, c, buffer[11], 10, 0xbd3af235);
            c = ii(c, d, a, b, buffer[2], 15, 0x2ad7d2bb);
            b = ii(b, c, d, a, buffer[9], 21, 0xeb86d391);
            w[0] = add(a, w[0]);
            w[1] = add(b, w[1]);
            w[2] = add(c, w[2]);
            w[3] = add(d, w[3]);
        };
    }();
    function caml_MD5Final(ctx) {
        var in_buf = ctx.len & 0x3f;
        ctx.b8[in_buf] = 0x80;
        in_buf++;
        if (in_buf > 56) {
            for(var j = in_buf; j < 64; j++)ctx.b8[j] = 0;
            caml_MD5Transform(ctx.w, ctx.b32);
            for(var j = 0; j < 56; j++)ctx.b8[j] = 0;
        } else for(var j = in_buf; j < 56; j++)ctx.b8[j] = 0;
        ctx.b32[14] = ctx.len << 3;
        ctx.b32[15] = ctx.len >> 29 & 0x1fffffff;
        caml_MD5Transform(ctx.w, ctx.b32);
        var t = new Uint8Array(16);
        for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++)t[i * 4 + j] = ctx.w[i] >> 8 * j & 0xff;
        return t;
    }
    function caml_MD5Init() {
        var buffer = new ArrayBuffer(64), b32 = new Uint32Array(buffer), b8 = new Uint8Array(buffer);
        return {
            len: 0,
            w: new Uint32Array([
                0x67452301,
                0xefcdab89,
                0x98badcfe,
                0x10325476
            ]),
            b32: b32,
            b8: b8
        };
    }
    function caml_MD5Update(ctx, input, input_len) {
        var in_buf = ctx.len & 0x3f, input_pos = 0;
        ctx.len += input_len;
        if (in_buf) {
            var missing = 64 - in_buf;
            if (input_len < missing) {
                ctx.b8.set(input.subarray(0, input_len), in_buf);
                return;
            }
            ctx.b8.set(input.subarray(0, missing), in_buf);
            caml_MD5Transform(ctx.w, ctx.b32);
            input_len -= missing;
            input_pos += missing;
        }
        while(input_len >= 64){
            ctx.b8.set(input.subarray(input_pos, input_pos + 64), 0);
            caml_MD5Transform(ctx.w, ctx.b32);
            input_len -= 64;
            input_pos += 64;
        }
        if (input_len) ctx.b8.set(input.subarray(input_pos, input_pos + input_len), 0);
    }
    function caml_acosh_float(x) {
        return Math.acosh(x);
    }
    function caml_call_gen(f, args) {
        var n = f.l >= 0 ? f.l : f.l = f.length, argsLen = args.length, d = n - argsLen;
        if (d === 0) return f(...args);
        else if (d < 0) {
            var g = f(...args.slice(0, n));
            if (typeof g !== "function") return g;
            return caml_call_gen(g, args.slice(n));
        } else {
            switch(d){
                case 1:
                    var g = function(x) {
                        var nargs = new Array(argsLen + 1);
                        for(var i = 0; i < argsLen; i++)nargs[i] = args[i];
                        nargs[argsLen] = x;
                        return f(...nargs);
                    };
                    break;
                case 2:
                    var g = function(x, y) {
                        var nargs = new Array(argsLen + 2);
                        for(var i = 0; i < argsLen; i++)nargs[i] = args[i];
                        nargs[argsLen] = x;
                        nargs[argsLen + 1] = y;
                        return f(...nargs);
                    };
                    break;
                default:
                    var g = function(...extra_args) {
                        if (extra_args.length === 0) extra_args = [
                            undefined
                        ];
                        return caml_call_gen(f, args.concat(extra_args));
                    };
            }
            g.l = d;
            return g;
        }
    }
    function caml_alloc_dummy_infix() {
        return function f(x) {
            return caml_call_gen(f.fun, [
                x
            ]);
        };
    }
    function caml_alloc_stack(hv, hx, hf) {
        return 0;
    }
    var caml_argv = function() {
        var process = globalThis1.process, main = "a.out", args = [];
        if (process && process.argv && process.argv.length > 1) {
            var argv = process.argv;
            main = argv[1];
            args = argv.slice(2);
        }
        var p = caml_string_of_jsstring(main), args2 = [
            0,
            p
        ];
        for(var i = 0; i < args.length; i++)args2.push(caml_string_of_jsstring(args[i]));
        return args2;
    }();
    function caml_array_append(a1, a2) {
        var l1 = a1.length, l2 = a2.length, l = l1 + l2 - 1, a = new Array(l);
        a[0] = 0;
        var i = 1, j = 1;
        for(; i < l1; i++)a[i] = a1[i];
        for(; i < l; i++, j++)a[i] = a2[j];
        return a;
    }
    function caml_array_blit(a1, i1, a2, i2, len) {
        if (i2 <= i1) for(var j = 1; j <= len; j++)a2[i2 + j] = a1[i1 + j];
        else for(var j = len; j >= 1; j--)a2[i2 + j] = a1[i1 + j];
        return 0;
    }
    function caml_array_concat(l) {
        var a = [
            0
        ];
        while(l !== 0){
            var b = l[1];
            for(var i = 1; i < b.length; i++)a.push(b[i]);
            l = l[2];
        }
        return a;
    }
    function caml_array_create_float(len) {
        if (len >>> 0 >= (0x7fffffff / 8 | 0)) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = 0;
        return b;
    }
    function caml_array_fill(array, ofs, len, v) {
        for(var i = 0; i < len; i++)array[ofs + i + 1] = v;
        return 0;
    }
    function caml_array_get(array, index) {
        if (index < 0 || index >= array.length - 1) caml_array_bound_error();
        return array[index + 1];
    }
    function caml_array_make(len, init) {
        if (len >>> 0 >= 536870911) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 0;
        for(var i = 1; i < len; i++)b[i] = init;
        return b;
    }
    function caml_array_of_bytes(x) {
        return caml_uint8_array_of_bytes(x);
    }
    function caml_array_of_string(x) {
        return caml_uint8_array_of_string(x);
    }
    function caml_array_set(array, index, newval) {
        if (index < 0 || index >= array.length - 1) caml_array_bound_error();
        array[index + 1] = newval;
        return 0;
    }
    function caml_array_sub(a, i, len) {
        var a2 = new Array(len + 1);
        a2[0] = 0;
        for(var i2 = 1, i1 = i + 1; i2 <= len; i2++, i1++)a2[i2] = a[i1];
        return a2;
    }
    function caml_asinh_float(x) {
        return Math.asinh(x);
    }
    function caml_atanh_float(x) {
        return Math.atanh(x);
    }
    function caml_atomic_cas(ref, o, n) {
        if (ref[1] === o) {
            ref[1] = n;
            return 1;
        }
        return 0;
    }
    function caml_atomic_exchange(ref, v) {
        var r = ref[1];
        ref[1] = v;
        return r;
    }
    function caml_atomic_fetch_add(ref, i) {
        var old = ref[1];
        ref[1] += i;
        return old;
    }
    function caml_atomic_load(ref) {
        return ref[1];
    }
    function caml_atomic_make_contended(a) {
        return [
            0,
            a
        ];
    }
    function caml_ba_blit(src, dst) {
        if (dst.dims.length !== src.dims.length) caml_invalid_argument("Bigarray.blit: dimension mismatch");
        for(var i = 0; i < dst.dims.length; i++)if (dst.dims[i] !== src.dims[i]) caml_invalid_argument("Bigarray.blit: dimension mismatch");
        dst.data.set(src.data);
        return 0;
    }
    function caml_ba_change_layout(ba, layout) {
        if (ba.layout === layout) return ba;
        var new_dims = [];
        for(var i = 0; i < ba.dims.length; i++)new_dims[i] = ba.dims[ba.dims.length - i - 1];
        return caml_ba_create_unsafe(ba.kind, layout, new_dims, ba.data);
    }
    function caml_js_from_array(a) {
        return a.slice(1);
    }
    function caml_ba_create(kind, layout, dims_ml) {
        var dims = caml_js_from_array(dims_ml), data = caml_ba_create_buffer(kind, caml_ba_get_size(dims));
        return caml_ba_create_unsafe(kind, layout, dims, data);
    }
    function caml_ba_create_from(data1, data2, jstyp, kind, layout, dims) {
        if (data2 || caml_ba_get_size_per_element(kind) === 2) caml_invalid_argument("caml_ba_create_from: use return caml_ba_create_unsafe");
        return caml_ba_create_unsafe(kind, layout, dims, data1);
    }
    function caml_ba_dim(ba, i) {
        if (i < 0 || i >= ba.dims.length) caml_invalid_argument("Bigarray.dim");
        return ba.dims[i];
    }
    function caml_ba_dim_1(ba) {
        return caml_ba_dim(ba, 0);
    }
    function caml_ba_dim_2(ba) {
        return caml_ba_dim(ba, 1);
    }
    function caml_ba_dim_3(ba) {
        return caml_ba_dim(ba, 2);
    }
    function caml_ba_fill(ba, v) {
        ba.fill(v);
        return 0;
    }
    function caml_ba_kind_of_typed_array(ta) {
        var kind;
        if (ta instanceof Float32Array) kind = 0;
        else if (ta instanceof Float64Array) kind = 1;
        else if (ta instanceof Int8Array) kind = 2;
        else if (ta instanceof Uint8Array) kind = 3;
        else if (ta instanceof Uint8ClampedArray) kind = 3;
        else if (ta instanceof Int16Array) kind = 4;
        else if (ta instanceof Uint16Array) kind = 5;
        else if (ta instanceof Int32Array) kind = 6;
        else if (ta instanceof Uint32Array) kind = 6;
        else caml_invalid_argument("caml_ba_kind_of_typed_array: unsupported kind");
        return kind;
    }
    function caml_ba_from_typed_array(ta) {
        var kind = caml_ba_kind_of_typed_array(ta), ta = ta instanceof Uint32Array ? new Int32Array(ta.buffer, ta.byteOffset, ta.length) : ta;
        return caml_ba_create_unsafe(kind, 0, [
            ta.length
        ], ta);
    }
    function caml_ba_get_2(ba, i0, i1) {
        return ba.get(ba.offset([
            i0,
            i1
        ]));
    }
    function caml_ba_get_3(ba, i0, i1, i2) {
        return ba.get(ba.offset([
            i0,
            i1,
            i2
        ]));
    }
    function caml_ba_get_generic(ba, i) {
        var ofs = ba.offset(caml_js_from_array(i));
        return ba.get(ofs);
    }
    function caml_ba_init() {
        return 0;
    }
    function caml_ba_kind(ba) {
        return ba.kind;
    }
    function caml_ba_layout(ba) {
        return ba.layout;
    }
    function caml_ba_map_file(vfd, kind, layout, shared, dims, pos) {
        caml_failwith("caml_ba_map_file not implemented");
    }
    function caml_ba_map_file_bytecode(argv, argn) {
        return caml_ba_map_file(argv[0], argv[1], argv[2], argv[3], argv[4], argv[5]);
    }
    function caml_ba_num_dims(ba) {
        return ba.dims.length;
    }
    function caml_ba_reshape(ba, vind) {
        vind = caml_js_from_array(vind);
        var new_dim = [], num_dims = vind.length;
        if (num_dims < 0 || num_dims > 16) caml_invalid_argument("Bigarray.reshape: bad number of dimensions");
        var num_elts = 1;
        for(var i = 0; i < num_dims; i++){
            new_dim[i] = vind[i];
            if (new_dim[i] < 0) caml_invalid_argument("Bigarray.reshape: negative dimension");
            num_elts = num_elts * new_dim[i];
        }
        var size = caml_ba_get_size(ba.dims);
        if (num_elts !== size) caml_invalid_argument("Bigarray.reshape: size mismatch");
        return caml_ba_create_unsafe(ba.kind, ba.layout, new_dim, ba.data);
    }
    function caml_ba_set_1(ba, i0, v) {
        ba.set(ba.offset(i0), v);
        return 0;
    }
    function caml_ba_set_2(ba, i0, i1, v) {
        ba.set(ba.offset([
            i0,
            i1
        ]), v);
        return 0;
    }
    function caml_ba_set_3(ba, i0, i1, i2, v) {
        ba.set(ba.offset([
            i0,
            i1,
            i2
        ]), v);
        return 0;
    }
    function caml_ba_set_generic(ba, i, v) {
        ba.set(ba.offset(caml_js_from_array(i)), v);
        return 0;
    }
    function caml_ba_slice(ba, vind) {
        vind = caml_js_from_array(vind);
        var num_inds = vind.length, index = [], sub_dims = [], ofs;
        if (num_inds > ba.dims.length) caml_invalid_argument("Bigarray.slice: too many indices");
        if (ba.layout === 0) {
            for(var i = 0; i < num_inds; i++)index[i] = vind[i];
            for(; i < ba.dims.length; i++)index[i] = 0;
            sub_dims = ba.dims.slice(num_inds);
        } else {
            for(var i = 0; i < num_inds; i++)index[ba.dims.length - num_inds + i] = vind[i];
            for(var i = 0; i < ba.dims.length - num_inds; i++)index[i] = 1;
            sub_dims = ba.dims.slice(0, ba.dims.length - num_inds);
        }
        ofs = ba.offset(index);
        var size = caml_ba_get_size(sub_dims), size_per_element = caml_ba_get_size_per_element(ba.kind), new_data = ba.data.subarray(ofs * size_per_element, (ofs + size) * size_per_element);
        return caml_ba_create_unsafe(ba.kind, ba.layout, sub_dims, new_data);
    }
    function caml_ba_sub(ba, ofs, len) {
        var changed_dim, mul = 1;
        if (ba.layout === 0) {
            for(var i = 1; i < ba.dims.length; i++)mul = mul * ba.dims[i];
            changed_dim = 0;
        } else {
            for(var i = 0; i < ba.dims.length - 1; i++)mul = mul * ba.dims[i];
            changed_dim = ba.dims.length - 1;
            ofs = ofs - 1;
        }
        if (ofs < 0 || len < 0 || ofs + len > ba.dims[changed_dim]) caml_invalid_argument("Bigarray.sub: bad sub-array");
        var new_dims = [];
        for(var i = 0; i < ba.dims.length; i++)new_dims[i] = ba.dims[i];
        new_dims[changed_dim] = len;
        mul *= caml_ba_get_size_per_element(ba.kind);
        var new_data = ba.data.subarray(ofs * mul, (ofs + len) * mul);
        return caml_ba_create_unsafe(ba.kind, ba.layout, new_dims, new_data);
    }
    function caml_ba_to_typed_array(ba) {
        return ba.data;
    }
    function caml_ba_uint8_get16(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 1 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs), b2 = ba.get(ofs + 1);
        return b1 | b2 << 8;
    }
    function caml_ba_uint8_get32(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 3 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs + 0), b2 = ba.get(ofs + 1), b3 = ba.get(ofs + 2), b4 = ba.get(ofs + 3);
        return b1 << 0 | b2 << 8 | b3 << 16 | b4 << 24;
    }
    function caml_ba_uint8_get64(ba, i0) {
        var ofs = ba.offset(i0);
        if (ofs + 7 >= ba.data.length) caml_array_bound_error();
        var b1 = ba.get(ofs + 0), b2 = ba.get(ofs + 1), b3 = ba.get(ofs + 2), b4 = ba.get(ofs + 3), b5 = ba.get(ofs + 4), b6 = ba.get(ofs + 5), b7 = ba.get(ofs + 6), b8 = ba.get(ofs + 7);
        return caml_int64_of_bytes([
            b8,
            b7,
            b6,
            b5,
            b4,
            b3,
            b2,
            b1
        ]);
    }
    function caml_ba_uint8_set16(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 1 >= ba.data.length) caml_array_bound_error();
        ba.set(ofs + 0, v & 0xff);
        ba.set(ofs + 1, v >>> 8 & 0xff);
        return 0;
    }
    function caml_ba_uint8_set32(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 3 >= ba.data.length) caml_array_bound_error();
        ba.set(ofs + 0, v & 0xff);
        ba.set(ofs + 1, v >>> 8 & 0xff);
        ba.set(ofs + 2, v >>> 16 & 0xff);
        ba.set(ofs + 3, v >>> 24 & 0xff);
        return 0;
    }
    function caml_ba_uint8_set64(ba, i0, v) {
        var ofs = ba.offset(i0);
        if (ofs + 7 >= ba.data.length) caml_array_bound_error();
        var v = caml_int64_to_bytes(v);
        for(var i = 0; i < 8; i++)ba.set(ofs + i, v[7 - i]);
        return 0;
    }
    function caml_backtrace_status(_unit) {
        return caml_record_backtrace_runtime_flag ? 1 : 0;
    }
    function caml_bigstring_blit_ba_to_ba(ba1, pos1, ba2, pos2, len) {
        if (12 !== ba1.kind) caml_invalid_argument("caml_bigstring_blit_ba_to_ba: kind mismatch");
        if (12 !== ba2.kind) caml_invalid_argument("caml_bigstring_blit_ba_to_ba: kind mismatch");
        if (len === 0) return 0;
        var ofs1 = ba1.offset(pos1), ofs2 = ba2.offset(pos2);
        if (ofs1 + len > ba1.data.length) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = ba1.data.subarray(ofs1, ofs1 + len);
        ba2.data.set(slice, pos2);
        return 0;
    }
    function caml_bigstring_blit_ba_to_bytes(ba1, pos1, bytes2, pos2, len) {
        if (12 !== ba1.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len === 0) return 0;
        var ofs1 = ba1.offset(pos1);
        if (ofs1 + len > ba1.data.length) caml_array_bound_error();
        if (pos2 + len > caml_ml_bytes_length(bytes2)) caml_array_bound_error();
        var slice = ba1.data.subarray(ofs1, ofs1 + len);
        caml_blit_bytes(caml_bytes_of_uint8_array(slice), 0, bytes2, pos2, len);
        return 0;
    }
    function caml_bigstring_blit_bytes_to_ba(str1, pos1, ba2, pos2, len) {
        if (12 !== ba2.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len === 0) return 0;
        var ofs2 = ba2.offset(pos2);
        if (pos1 + len > caml_ml_bytes_length(str1)) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = caml_uint8_array_of_bytes(str1).subarray(pos1, pos1 + len);
        ba2.data.set(slice, ofs2);
        return 0;
    }
    function caml_bigstring_blit_string_to_ba(str1, pos1, ba2, pos2, len) {
        if (12 !== ba2.kind) caml_invalid_argument("caml_bigstring_blit_string_to_ba: kind mismatch");
        if (len === 0) return 0;
        var ofs2 = ba2.offset(pos2);
        if (pos1 + len > caml_ml_string_length(str1)) caml_array_bound_error();
        if (ofs2 + len > ba2.data.length) caml_array_bound_error();
        var slice = caml_uint8_array_of_string(str1).subarray(pos1, pos1 + len);
        ba2.data.set(slice, ofs2);
        return 0;
    }
    function caml_bigstring_memcmp(s1, pos1, s2, pos2, len) {
        for(var i = 0; i < len; i++){
            var a = caml_ba_get_1(s1, pos1 + i), b = caml_ba_get_1(s2, pos2 + i);
            if (a < b) return -1;
            if (a > b) return 1;
        }
        return 0;
    }
    function caml_blake2_final(ctx, hashlen) {
        var r = blake2b.Final(ctx);
        return caml_string_of_uint8_array(r);
    }
    function caml_blake2_update(ctx, buf, ofs, len) {
        var input = caml_uint8_array_of_bytes(buf);
        input = input.subarray(ofs, ofs + len);
        blake2b.Update(ctx, input);
        return 0;
    }
    function caml_blake2_create(hashlen, key) {
        key = caml_uint8_array_of_string(key);
        if (key.length > 64) key.subarray(0, 64);
        return blake2b.Init(hashlen, key);
    }
    function caml_blake2_bytes(hashlen, key, buf, ofs, len) {
        var ctx = caml_blake2_create(hashlen, key);
        caml_blake2_update(ctx, buf, ofs, len);
        return caml_blake2_final(ctx, hashlen);
    }
    function caml_blake2_string(hashlen, key, buf_str, ofs, len) {
        var ctx = caml_blake2_create(hashlen, key), buf = caml_bytes_of_string(buf_str);
        caml_blake2_update(ctx, buf, ofs, len);
        return caml_blake2_final(ctx, hashlen);
    }
    function caml_blit_string(a, b, c, d, e) {
        caml_blit_bytes(caml_bytes_of_string(a), b, c, d, e);
        return 0;
    }
    function caml_bswap16(x) {
        return (x & 0x00ff) << 8 | (x & 0xff00) >> 8;
    }
    function caml_jsstring_of_string(s) {
        if (jsoo_is_ascii(s)) return s;
        return caml_utf16_of_utf8(s);
    }
    function caml_build_symbols(symb) {
        var r = {}, max = -1;
        if (symb) for(var i = 1; i < symb.length; i++){
            var idx = symb[i][2];
            max = Math.max(max, idx);
            r[caml_jsstring_of_string(symb[i][1])] = idx;
        }
        r.next_idx = max + 1;
        return r;
    }
    function caml_bytes_compare(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c < s2.c ? -1 : s1.c > s2.c ? 1 : 0;
    }
    function caml_bytes_equal(s1, s2) {
        if (s1 === s2) return 1;
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c === s2.c ? 1 : 0;
    }
    function caml_bytes_unsafe_get(s, i) {
        switch(s.t & 6){
            case 0:
                return s.c.charCodeAt(i);
            case 2:
                if (i >= s.c.length) return 0;
                return s.c.charCodeAt(i);
            case 4:
                return s.c[i];
        }
    }
    function caml_bytes_get(s, i) {
        if (i >>> 0 >= s.l) caml_bytes_bound_error();
        return caml_bytes_unsafe_get(s, i);
    }
    function caml_bytes_get16(s, i) {
        if (i >>> 0 >= s.l - 1) caml_bytes_bound_error();
        var b1 = caml_bytes_unsafe_get(s, i), b2 = caml_bytes_unsafe_get(s, i + 1);
        return b2 << 8 | b1;
    }
    function caml_bytes_get32(s, i) {
        if (i >>> 0 >= s.l - 3) caml_bytes_bound_error();
        var b1 = caml_bytes_unsafe_get(s, i), b2 = caml_bytes_unsafe_get(s, i + 1), b3 = caml_bytes_unsafe_get(s, i + 2), b4 = caml_bytes_unsafe_get(s, i + 3);
        return b4 << 24 | b3 << 16 | b2 << 8 | b1;
    }
    function caml_bytes_get64(s, i) {
        if (i >>> 0 >= s.l - 7) caml_bytes_bound_error();
        var a = new Array(8);
        for(var j = 0; j < 8; j++)a[7 - j] = caml_bytes_unsafe_get(s, i + j);
        return caml_int64_of_bytes(a);
    }
    function caml_bytes_lessequal(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c <= s2.c ? 1 : 0;
    }
    function caml_bytes_greaterequal(s1, s2) {
        return caml_bytes_lessequal(s2, s1);
    }
    function caml_bytes_lessthan(s1, s2) {
        s1.t & 6 && caml_convert_string_to_bytes(s1);
        s2.t & 6 && caml_convert_string_to_bytes(s2);
        return s1.c < s2.c ? 1 : 0;
    }
    function caml_bytes_greaterthan(s1, s2) {
        return caml_bytes_lessthan(s2, s1);
    }
    function caml_bytes_notequal(s1, s2) {
        return 1 - caml_bytes_equal(s1, s2);
    }
    function caml_bytes_of_utf16_jsstring(s) {
        var tag = 9;
        if (!jsoo_is_ascii(s)) tag = 8, s = caml_utf8_of_utf16(s);
        return new MlBytes(tag, s, s.length);
    }
    function caml_bytes_set16(s, i, i16) {
        if (i >>> 0 >= s.l - 1) caml_bytes_bound_error();
        var b2 = 0xff & i16 >> 8, b1 = 0xff & i16;
        caml_bytes_unsafe_set(s, i + 0, b1);
        caml_bytes_unsafe_set(s, i + 1, b2);
        return 0;
    }
    function caml_bytes_set32(s, i, i32) {
        if (i >>> 0 >= s.l - 3) caml_bytes_bound_error();
        var b4 = 0xff & i32 >> 24, b3 = 0xff & i32 >> 16, b2 = 0xff & i32 >> 8, b1 = 0xff & i32;
        caml_bytes_unsafe_set(s, i + 0, b1);
        caml_bytes_unsafe_set(s, i + 1, b2);
        caml_bytes_unsafe_set(s, i + 2, b3);
        caml_bytes_unsafe_set(s, i + 3, b4);
        return 0;
    }
    function caml_bytes_set64(s, i, i64) {
        if (i >>> 0 >= s.l - 7) caml_bytes_bound_error();
        var a = caml_int64_to_bytes(i64);
        for(var j = 0; j < 8; j++)caml_bytes_unsafe_set(s, i + 7 - j, a[j]);
        return 0;
    }
    var caml_callback = caml_call_gen;
    function caml_cbrt_float(x) {
        return Math.cbrt(x);
    }
    function caml_ml_channels_state() {
        this.map = new globalThis1.WeakMap();
        this.opened = new globalThis1.Set();
    }
    caml_ml_channels_state.prototype.close = function(chanid) {
        this.opened.delete(chanid);
    };
    caml_ml_channels_state.prototype.get = function(chanid) {
        return this.map.get(chanid);
    };
    caml_ml_channels_state.prototype.set = function(chanid, val) {
        if (val.opened) this.opened.add(chanid);
        return this.map.set(chanid, val);
    };
    caml_ml_channels_state.prototype.all = function() {
        return this.opened.values();
    };
    var caml_ml_channels = new caml_ml_channels_state();
    function caml_ml_channel_get(id) {
        return caml_ml_channels.get(id);
    }
    function caml_channel_descriptor(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.fd;
    }
    function caml_check_bound(array, index) {
        if (index >>> 0 >= array.length - 1) caml_array_bound_error();
        return array;
    }
    function caml_classify_float(x) {
        if (Number.isFinite(x)) {
            if (Math.abs(x) >= 2.2250738585072014e-308) return 0;
            if (x !== 0) return 1;
            return 2;
        }
        return Number.isNaN(x) ? 4 : 3;
    }
    function caml_compare_val_get_custom(a) {
        return caml_custom_ops[a.caml_custom] && caml_custom_ops[a.caml_custom].compare;
    }
    function caml_compare_val_number_custom(num, custom, swap, total) {
        var comp = caml_compare_val_get_custom(custom);
        if (comp) {
            var x = swap > 0 ? comp(custom, num, total) : comp(num, custom, total);
            if (total && Number.isNaN(x)) return swap;
            if (Number.isNaN(+x)) return +x;
            if ((x | 0) !== 0) return x | 0;
        }
        return swap;
    }
    function caml_compare_val_tag(a) {
        if (typeof a === "number") return 1000;
        else if (caml_is_ml_bytes(a)) return 252;
        else if (caml_is_ml_string(a)) return 1252;
        else if (Array.isArray(a) && a[0] === a[0] >>> 0 && a[0] <= 255) {
            var tag = a[0] | 0;
            return tag === 254 ? 0 : tag;
        } else if (a instanceof String) return 12520;
        else if (typeof a === "string") return 12520;
        else if (a instanceof Number) return 1000;
        else if (a && a.caml_custom) return 1255;
        else if (a && a.compare) return 1256;
        else if (typeof a === "function") return 1247;
        else if (typeof a === "symbol") return 1251;
        return 1001;
    }
    function caml_int_compare(a, b) {
        if (a < b) return -1;
        if (a === b) return 0;
        return 1;
    }
    function caml_string_compare(s1, s2) {
        return s1 < s2 ? -1 : s1 > s2 ? 1 : 0;
    }
    function caml_compare_val(a, b, total) {
        var stack = [];
        for(;;){
            if (!(total && a === b)) {
                var tag_a = caml_compare_val_tag(a);
                if (tag_a === 250) {
                    a = a[1];
                    continue;
                }
                var tag_b = caml_compare_val_tag(b);
                if (tag_b === 250) {
                    b = b[1];
                    continue;
                }
                if (tag_a !== tag_b) {
                    if (tag_a === 1000) {
                        if (tag_b === 1255) return caml_compare_val_number_custom(a, b, -1, total);
                        return -1;
                    }
                    if (tag_b === 1000) {
                        if (tag_a === 1255) return caml_compare_val_number_custom(b, a, 1, total);
                        return 1;
                    }
                    return tag_a < tag_b ? -1 : 1;
                }
                switch(tag_a){
                    case 247:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 248:
                        var x = caml_int_compare(a[2], b[2]) | 0;
                        if (x !== 0) return x;
                        break;
                    case 249:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 250:
                        caml_invalid_argument("equal: got Forward_tag, should not happen");
                        break;
                    case 251:
                        caml_invalid_argument("equal: abstract value");
                        break;
                    case 252:
                        if (a !== b) {
                            var x = caml_bytes_compare(a, b) | 0;
                            if (x !== 0) return x;
                        }
                        break;
                    case 253:
                        caml_invalid_argument("equal: got Double_tag, should not happen");
                        break;
                    case 254:
                        caml_invalid_argument("equal: got Double_array_tag, should not happen");
                        break;
                    case 255:
                        caml_invalid_argument("equal: got Custom_tag, should not happen");
                        break;
                    case 1247:
                        caml_invalid_argument("compare: functional value");
                        break;
                    case 1255:
                        var comp = caml_compare_val_get_custom(a);
                        if (comp !== caml_compare_val_get_custom(b)) return a.caml_custom < b.caml_custom ? -1 : 1;
                        if (!comp) caml_invalid_argument("compare: abstract value");
                        var x = comp(a, b, total);
                        if (Number.isNaN(x)) return total ? -1 : x;
                        if (x !== (x | 0)) return -1;
                        if (x !== 0) return x | 0;
                        break;
                    case 1256:
                        var x = a.compare(b, total);
                        if (Number.isNaN(x)) return total ? -1 : x;
                        if (x !== (x | 0)) return -1;
                        if (x !== 0) return x | 0;
                        break;
                    case 1000:
                        a = +a;
                        b = +b;
                        if (a < b) return -1;
                        if (a > b) return 1;
                        if (a !== b) {
                            if (!total) return Number.NaN;
                            if (!Number.isNaN(a)) return 1;
                            if (!Number.isNaN(b)) return -1;
                        }
                        break;
                    case 1001:
                        if (a < b) return -1;
                        if (a > b) return 1;
                        if (a !== b) return total ? 1 : Number.NaN;
                        break;
                    case 1251:
                        if (a !== b) return total ? 1 : Number.NaN;
                        break;
                    case 1252:
                        var a = caml_jsbytes_of_string(a), b = caml_jsbytes_of_string(b);
                        if (a !== b) {
                            if (a < b) return -1;
                            if (a > b) return 1;
                        }
                        break;
                    case 12520:
                        var a = a.toString(), b = b.toString();
                        if (a !== b) {
                            if (a < b) return -1;
                            if (a > b) return 1;
                        }
                        break;
                    default:
                        if (caml_is_continuation_tag(tag_a)) {
                            caml_invalid_argument("compare: continuation value");
                            break;
                        }
                        if (a.length !== b.length) return a.length < b.length ? -1 : 1;
                        if (a.length > 1) stack.push(a, b, 1);
                        break;
                }
            }
            if (stack.length === 0) return 0;
            var i = stack.pop();
            b = stack.pop();
            a = stack.pop();
            if (i + 1 < a.length) stack.push(a, b, i + 1);
            a = a[i];
            b = b[i];
        }
    }
    function caml_compare(a, b) {
        return caml_compare_val(a, b, true);
    }
    function caml_continuation_use_noexc(cont) {
        var stack = cont[1];
        cont[1] = 0;
        return stack;
    }
    function caml_continuation_use_and_update_handler_noexc(cont, hval, hexn, heff) {
        var stack = caml_continuation_use_noexc(cont);
        if (stack === 0) return stack;
        var last = cont[2];
        if (last === 0) {
            last = stack;
            while(last.e !== 0)last = last.e;
        }
        last.h[1] = hval;
        last.h[2] = hexn;
        last.h[3] = heff;
        return stack;
    }
    function caml_convert_raw_backtrace() {
        return [
            0
        ];
    }
    function caml_convert_raw_backtrace_slot() {
        caml_failwith("caml_convert_raw_backtrace_slot");
    }
    function caml_copysign_float(x, y) {
        if (y === 0) y = 1 / y;
        x = Math.abs(x);
        return y < 0 ? -x : x;
    }
    function caml_cosh_float(x) {
        return Math.cosh(x);
    }
    function fs_node_supported() {
        return typeof globalThis1.process !== "undefined" && typeof globalThis1.process.versions !== "undefined" && typeof globalThis1.process.versions.node !== "undefined";
    }
    function make_path_is_absolute() {
        function posix(path) {
            if (path.charAt(0) === "/") return [
                "",
                path.slice(1)
            ];
            return;
        }
        function win32(path) {
            var splitDeviceRe = /^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/, result = splitDeviceRe.exec(path), device = result[1] || "", isUnc = device.length > 0 && device.charAt(1) !== ":";
            if (result[2] || isUnc) {
                var root = result[1] || "", sep = result[2] || "";
                return [
                    root,
                    path.slice(root.length + sep.length)
                ];
            }
            return;
        }
        return fs_node_supported() && globalThis1.process && globalThis1.process.platform ? globalThis1.process.platform === "win32" ? win32 : posix : posix;
    }
    var path_is_absolute = make_path_is_absolute();
    function caml_trailing_slash(name) {
        return name.slice(-1) !== "/" ? name + "/" : name;
    }
    if (fs_node_supported() && globalThis1.process && globalThis1.process.cwd) var caml_current_dir = globalThis1.process.cwd().replace(/\\/g, "/");
    else var caml_current_dir = "/static";
    caml_current_dir = caml_trailing_slash(caml_current_dir);
    function caml_make_path(name) {
        name = caml_jsstring_of_string(name);
        if (!path_is_absolute(name)) name = caml_current_dir + name;
        var comp0 = path_is_absolute(name), comp = comp0[1].split(/[/\\]/), ncomp = [];
        for(var i = 0; i < comp.length; i++)switch(comp[i]){
            case "..":
                if (ncomp.length > 1) ncomp.pop();
                break;
            case ".":
                break;
            case "":
                break;
            default:
                ncomp.push(comp[i]);
                break;
        }
        ncomp.unshift(comp0[0]);
        ncomp.orig = name;
        return ncomp;
    }
    function caml_get_root(path) {
        var x = path_is_absolute(path);
        if (!x) return;
        return x[0] + "/";
    }
    var caml_root = caml_get_root(caml_current_dir) || caml_failwith("unable to compute caml_root"), jsoo_mount_point = [];
    if (fs_node_supported()) jsoo_mount_point.push({
        path: caml_root,
        device: new MlNodeDevice(caml_root)
    });
    else jsoo_mount_point.push({
        path: caml_root,
        device: new MlFakeDevice(caml_root)
    });
    jsoo_mount_point.push({
        path: "/static/",
        device: new MlFakeDevice("/static/")
    });
    function resolve_fs_device(name) {
        var path = caml_make_path(name), name = path.join("/"), name_slash = caml_trailing_slash(name), res;
        for(var i = 0; i < jsoo_mount_point.length; i++){
            var m = jsoo_mount_point[i];
            if (name_slash.search(m.path) === 0 && (!res || res.path.length < m.path.length)) res = {
                path: m.path,
                device: m.device,
                rest: name.slice(m.path.length, name.length)
            };
        }
        if (!res && fs_node_supported()) {
            var root = caml_get_root(name);
            if (root && root.match(/^[a-zA-Z]:\/$/)) {
                var m = {
                    path: root,
                    device: new MlNodeDevice(root)
                };
                jsoo_mount_point.push(m);
                res = {
                    path: m.path,
                    device: m.device,
                    rest: name.slice(m.path.length, name.length)
                };
            }
        }
        if (res) return res;
        caml_raise_sys_error("no device found for " + name_slash);
    }
    function caml_create_file(name, content) {
        var root = resolve_fs_device(name);
        if (!root.device.register) caml_failwith("cannot register file");
        root.device.register(root.rest, content);
        return 0;
    }
    function caml_create_string(len) {
        caml_invalid_argument("String.create");
    }
    function caml_csel_value(v_cond, v_true, v_false) {
        return v_cond ? v_true : v_false;
    }
    var caml_custom_event_index = 0;
    function caml_custom_identifier(o) {
        return caml_string_of_jsstring(o.caml_custom);
    }
    var zstd_decompress = function() {
        var ab = ArrayBuffer, u8 = Uint8Array, u16 = Uint16Array, i16 = Int16Array, u32 = Uint32Array, i32 = Int32Array;
        function slc(v, s, e) {
            if (u8.prototype.slice) return u8.prototype.slice.call(v, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            var n = new u8(e - s);
            n.set(v.subarray(s, e));
            return n;
        }
        function fill(v, n, s, e) {
            if (u8.prototype.fill) return u8.prototype.fill.call(v, n, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            for(; s < e; ++s)v[s] = n;
            return v;
        }
        function cpw(v, t, s, e) {
            if (u8.prototype.copyWithin) return u8.prototype.copyWithin.call(v, t, s, e);
            if (s == null || s < 0) s = 0;
            if (e == null || e > v.length) e = v.length;
            while(s < e)v[t++] = v[s++];
        }
        var ec = [
            "invalid zstd data",
            "window size too large (>2046MB)",
            "invalid block type",
            "FSE accuracy too high",
            "match distance too far back",
            "unexpected EOF"
        ];
        function err(ind, msg, nt) {
            var e = new Error(msg || ec[ind]);
            e.code = ind;
            if (!nt) throw e;
            return e;
        }
        function rb(d, b, n) {
            var i = 0, o = 0;
            for(; i < n; ++i)o |= d[b++] << (i << 3);
            return o;
        }
        function b4(d, b) {
            return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
        }
        function rzfh(dat, w) {
            var n3 = dat[0] | dat[1] << 8 | dat[2] << 16;
            if (n3 === 0x2fb528 && dat[3] === 253) {
                var flg = dat[4], ss = flg >> 5 & 1, cc = flg >> 2 & 1, df = flg & 3, fcf = flg >> 6;
                if (flg & 8) err(0);
                var bt = 6 - ss, db = df === 3 ? 4 : df, di = rb(dat, bt, db);
                bt += db;
                var fsb = fcf ? 1 << fcf : ss, fss = rb(dat, bt, fsb) + (fcf === 1 && 256), ws = fss;
                if (!ss) {
                    var wb = 1 << 10 + (dat[5] >> 3);
                    ws = wb + (wb >> 3) * (dat[5] & 7);
                }
                if (ws > 2145386496) err(1);
                var buf = new u8((w === 1 ? fss || ws : w ? 0 : ws) + 12);
                buf[0] = 1, buf[4] = 4, buf[8] = 8;
                return {
                    b: bt + fsb,
                    y: 0,
                    l: 0,
                    d: di,
                    w: w && w !== 1 ? w : buf.subarray(12),
                    e: ws,
                    o: new i32(buf.buffer, 0, 3),
                    u: fss,
                    c: cc,
                    m: Math.min(131072, ws)
                };
            } else if ((n3 >> 4 | dat[3] << 20) === 0x184d2a5) return b4(dat, 4) + 8;
            err(0);
        }
        function msb(val) {
            var bits = 0;
            for(; 1 << bits <= val; ++bits);
            return bits - 1;
        }
        function rfse(dat, bt, mal) {
            var tpos = (bt << 3) + 4, al = (dat[bt] & 15) + 5;
            if (al > mal) err(3);
            var sz = 1 << al, probs = sz, sym = -1, re = -1, i = -1, ht = sz, buf = new ab(512 + (sz << 2)), freq = new i16(buf, 0, 256), dstate = new u16(buf, 0, 256), nstate = new u16(buf, 512, sz), bb1 = 512 + (sz << 1), syms = new u8(buf, bb1, sz), nbits = new u8(buf, bb1 + sz);
            while(sym < 255 && probs > 0){
                var bits = msb(probs + 1), cbt = tpos >> 3, msk = (1 << bits + 1) - 1, val = (dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (tpos & 7) & msk, msk1fb = (1 << bits) - 1, msv = msk - probs - 1, sval = val & msk1fb;
                if (sval < msv) tpos += bits, val = sval;
                else {
                    tpos += bits + 1;
                    if (val > msk1fb) val -= msv;
                }
                freq[++sym] = --val;
                if (val === -1) {
                    probs += val;
                    syms[--ht] = sym;
                } else probs -= val;
                if (!val) do {
                    var rbt = tpos >> 3;
                    re = (dat[rbt] | dat[rbt + 1] << 8) >> (tpos & 7) & 3;
                    tpos += 2;
                    sym += re;
                }while (re === 3);
            }
            if (sym > 255 || probs) err(0);
            var sympos = 0, sstep = (sz >> 1) + (sz >> 3) + 3, smask = sz - 1;
            for(var s = 0; s <= sym; ++s){
                var sf = freq[s];
                if (sf < 1) {
                    dstate[s] = -sf;
                    continue;
                }
                for(i = 0; i < sf; ++i){
                    syms[sympos] = s;
                    do sympos = sympos + sstep & smask;
                    while (sympos >= ht);
                }
            }
            if (sympos) err(0);
            for(i = 0; i < sz; ++i){
                var ns = dstate[syms[i]]++, nb = nbits[i] = al - msb(ns);
                nstate[i] = (ns << nb) - sz;
            }
            return [
                tpos + 7 >> 3,
                {
                    b: al,
                    s: syms,
                    n: nbits,
                    t: nstate
                }
            ];
        }
        function rhu(dat, bt) {
            var i = 0, wc = -1, buf = new u8(292), hb = dat[bt], hw = buf.subarray(0, 256), rc = buf.subarray(256, 268), ri = new u16(buf.buffer, 268);
            if (hb < 128) {
                var _a = rfse(dat, bt + 1, 6), ebt = _a[0], fdt = _a[1];
                bt += hb;
                var epos = ebt << 3, lb = dat[bt];
                if (!lb) err(0);
                var st1 = 0, st2 = 0, btr1 = fdt.b, btr2 = btr1, fpos = (++bt << 3) - 8 + msb(lb);
                for(;;){
                    fpos -= btr1;
                    if (fpos < epos) break;
                    var cbt = fpos >> 3;
                    st1 += (dat[cbt] | dat[cbt + 1] << 8) >> (fpos & 7) & (1 << btr1) - 1;
                    hw[++wc] = fdt.s[st1];
                    fpos -= btr2;
                    if (fpos < epos) break;
                    cbt = fpos >> 3;
                    st2 += (dat[cbt] | dat[cbt + 1] << 8) >> (fpos & 7) & (1 << btr2) - 1;
                    hw[++wc] = fdt.s[st2];
                    btr1 = fdt.n[st1];
                    st1 = fdt.t[st1];
                    btr2 = fdt.n[st2];
                    st2 = fdt.t[st2];
                }
                if (++wc > 255) err(0);
            } else {
                wc = hb - 127;
                for(; i < wc; i += 2){
                    var byte = dat[++bt];
                    hw[i] = byte >> 4;
                    hw[i + 1] = byte & 15;
                }
                ++bt;
            }
            var wes = 0;
            for(i = 0; i < wc; ++i){
                var wt = hw[i];
                if (wt > 11) err(0);
                wes += wt && 1 << wt - 1;
            }
            var mb = msb(wes) + 1, ts = 1 << mb, rem = ts - wes;
            if (rem & rem - 1) err(0);
            hw[wc++] = msb(rem) + 1;
            for(i = 0; i < wc; ++i){
                var wt = hw[i];
                ++rc[hw[i] = wt && mb + 1 - wt];
            }
            var hbuf = new u8(ts << 1), syms = hbuf.subarray(0, ts), nb = hbuf.subarray(ts);
            ri[mb] = 0;
            for(i = mb; i > 0; --i){
                var pv = ri[i];
                fill(nb, i, pv, ri[i - 1] = pv + rc[i] * (1 << mb - i));
            }
            if (ri[0] !== ts) err(0);
            for(i = 0; i < wc; ++i){
                var bits = hw[i];
                if (bits) {
                    var code = ri[bits];
                    fill(syms, i, code, ri[bits] = code + (1 << mb - bits));
                }
            }
            return [
                bt,
                {
                    n: nb,
                    b: mb,
                    s: syms
                }
            ];
        }
        var dllt = rfse(new u8([
            81,
            16,
            99,
            140,
            49,
            198,
            24,
            99,
            12,
            33,
            196,
            24,
            99,
            102,
            102,
            134,
            70,
            146,
            4
        ]), 0, 6)[1], dmlt = rfse(new u8([
            33,
            20,
            196,
            24,
            99,
            140,
            33,
            132,
            16,
            66,
            8,
            33,
            132,
            16,
            66,
            8,
            33,
            68,
            68,
            68,
            68,
            68,
            68,
            68,
            68,
            36,
            9
        ]), 0, 6)[1], doct = rfse(new u8([
            32,
            132,
            16,
            66,
            102,
            70,
            68,
            68,
            68,
            68,
            36,
            73,
            2
        ]), 0, 5)[1];
        function b2bl(b, s) {
            var len = b.length, bl = new i32(len);
            for(var i = 0; i < len; ++i){
                bl[i] = s;
                s += 1 << b[i];
            }
            return bl;
        }
        var llb = new u8(new i32([
            0,
            0,
            0,
            0,
            16843009,
            50528770,
            134678020,
            202050057,
            269422093
        ]).buffer, 0, 36), llbl = b2bl(llb, 0), mlb = new u8(new i32([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            16843009,
            50528770,
            117769220,
            185207048,
            252579084,
            16
        ]).buffer, 0, 53), mlbl = b2bl(mlb, 3);
        function dhu(dat, out, hu) {
            var len = dat.length, ss = out.length, lb = dat[len - 1], msk = (1 << hu.b) - 1, eb = -hu.b;
            if (!lb) err(0);
            var st = 0, btr = hu.b, pos = (len << 3) - 8 + msb(lb) - btr, i = -1;
            while(pos > eb && i < ss){
                var cbt = pos >> 3, val = (dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (pos & 7);
                st = (st << btr | val) & msk;
                out[++i] = hu.s[st];
                pos -= btr = hu.n[st];
            }
            if (pos !== eb || i + 1 !== ss) err(0);
        }
        function dhu4(dat, out, hu) {
            var bt = 6, ss = out.length, sz1 = ss + 3 >> 2, sz2 = sz1 << 1, sz3 = sz1 + sz2;
            dhu(dat.subarray(bt, bt += dat[0] | dat[1] << 8), out.subarray(0, sz1), hu);
            dhu(dat.subarray(bt, bt += dat[2] | dat[3] << 8), out.subarray(sz1, sz2), hu);
            dhu(dat.subarray(bt, bt += dat[4] | dat[5] << 8), out.subarray(sz2, sz3), hu);
            dhu(dat.subarray(bt), out.subarray(sz3), hu);
        }
        function rzb(dat, st, out) {
            var _a, bt = st.b, b0 = dat[bt], btype = b0 >> 1 & 3;
            st.l = b0 & 1;
            var sz = b0 >> 3 | dat[bt + 1] << 5 | dat[bt + 2] << 13, ebt = (bt += 3) + sz;
            if (btype === 1) {
                if (bt >= dat.length) return;
                st.b = bt + 1;
                if (out) {
                    fill(out, dat[bt], st.y, st.y += sz);
                    return out;
                }
                return fill(new u8(sz), dat[bt]);
            }
            if (ebt > dat.length) return;
            if (btype === 0) {
                st.b = ebt;
                if (out) {
                    out.set(dat.subarray(bt, ebt), st.y);
                    st.y += sz;
                    return out;
                }
                return slc(dat, bt, ebt);
            }
            if (btype === 2) {
                var b3 = dat[bt], lbt = b3 & 3, sf = b3 >> 2 & 3, lss = b3 >> 4, lcs = 0, s4 = 0;
                if (lbt < 2) {
                    if (sf & 1) lss |= dat[++bt] << 4 | (sf & 2 && dat[++bt] << 12);
                    else lss = b3 >> 3;
                } else {
                    s4 = sf;
                    if (sf < 2) lss |= (dat[++bt] & 63) << 4, lcs = dat[bt] >> 6 | dat[++bt] << 2;
                    else if (sf === 2) lss |= dat[++bt] << 4 | (dat[++bt] & 3) << 12, lcs = dat[bt] >> 2 | dat[++bt] << 6;
                    else lss |= dat[++bt] << 4 | (dat[++bt] & 63) << 12, lcs = dat[bt] >> 6 | dat[++bt] << 2 | dat[++bt] << 10;
                }
                ++bt;
                var buf = out ? out.subarray(st.y, st.y + st.m) : new u8(st.m), spl = buf.length - lss;
                if (lbt === 0) buf.set(dat.subarray(bt, bt += lss), spl);
                else if (lbt === 1) fill(buf, dat[bt++], spl);
                else {
                    var hu = st.h;
                    if (lbt === 2) {
                        var hud = rhu(dat, bt);
                        lcs += bt - (bt = hud[0]);
                        st.h = hu = hud[1];
                    } else if (!hu) err(0);
                    (s4 ? dhu4 : dhu)(dat.subarray(bt, bt += lcs), buf.subarray(spl), hu);
                }
                var ns = dat[bt++];
                if (ns) {
                    if (ns === 255) ns = (dat[bt++] | dat[bt++] << 8) + 0x7f00;
                    else if (ns > 127) ns = ns - 128 << 8 | dat[bt++];
                    var scm = dat[bt++];
                    if (scm & 3) err(0);
                    var dts = [
                        dmlt,
                        doct,
                        dllt
                    ];
                    for(var i = 2; i > -1; --i){
                        var md = scm >> (i << 1) + 2 & 3;
                        if (md === 1) {
                            var rbuf = new u8([
                                0,
                                0,
                                dat[bt++]
                            ]);
                            dts[i] = {
                                s: rbuf.subarray(2, 3),
                                n: rbuf.subarray(0, 1),
                                t: new u16(rbuf.buffer, 0, 1),
                                b: 0
                            };
                        } else if (md === 2) _a = rfse(dat, bt, 9 - (i & 1)), bt = _a[0], dts[i] = _a[1];
                        else if (md === 3) {
                            if (!st.t) err(0);
                            dts[i] = st.t[i];
                        }
                    }
                    var _b = st.t = dts, mlt = _b[0], oct = _b[1], llt = _b[2], lb = dat[ebt - 1];
                    if (!lb) err(0);
                    var spos = (ebt << 3) - 8 + msb(lb) - llt.b, cbt = spos >> 3, oubt = 0, lst = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << llt.b) - 1;
                    cbt = (spos -= oct.b) >> 3;
                    var ost = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << oct.b) - 1;
                    cbt = (spos -= mlt.b) >> 3;
                    var mst = (dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << mlt.b) - 1;
                    for(++ns; --ns;){
                        var llc = llt.s[lst], lbtr = llt.n[lst], mlc = mlt.s[mst], mbtr = mlt.n[mst], ofc = oct.s[ost], obtr = oct.n[ost];
                        cbt = (spos -= ofc) >> 3;
                        var ofp = 1 << ofc, off = ofp + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16 | dat[cbt + 3] << 24) >>> (spos & 7) & ofp - 1);
                        cbt = (spos -= mlb[mlc]) >> 3;
                        var ml = mlbl[mlc] + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (spos & 7) & (1 << mlb[mlc]) - 1);
                        cbt = (spos -= llb[llc]) >> 3;
                        var ll = llbl[llc] + ((dat[cbt] | dat[cbt + 1] << 8 | dat[cbt + 2] << 16) >> (spos & 7) & (1 << llb[llc]) - 1);
                        cbt = (spos -= lbtr) >> 3;
                        lst = llt.t[lst] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << lbtr) - 1);
                        cbt = (spos -= mbtr) >> 3;
                        mst = mlt.t[mst] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << mbtr) - 1);
                        cbt = (spos -= obtr) >> 3;
                        ost = oct.t[ost] + ((dat[cbt] | dat[cbt + 1] << 8) >> (spos & 7) & (1 << obtr) - 1);
                        if (off > 3) {
                            st.o[2] = st.o[1];
                            st.o[1] = st.o[0];
                            st.o[0] = off -= 3;
                        } else {
                            var idx = off - (ll !== 0);
                            if (idx) {
                                off = idx === 3 ? st.o[0] - 1 : st.o[idx];
                                if (idx > 1) st.o[2] = st.o[1];
                                st.o[1] = st.o[0];
                                st.o[0] = off;
                            } else off = st.o[0];
                        }
                        for(var i = 0; i < ll; ++i)buf[oubt + i] = buf[spl + i];
                        oubt += ll, spl += ll;
                        var stin = oubt - off;
                        if (stin < 0) {
                            var len = -stin, bs = st.e + stin;
                            if (len > ml) len = ml;
                            for(var i = 0; i < len; ++i)buf[oubt + i] = st.w[bs + i];
                            oubt += len, ml -= len, stin = 0;
                        }
                        for(var i = 0; i < ml; ++i)buf[oubt + i] = buf[stin + i];
                        oubt += ml;
                    }
                    if (oubt !== spl) while(spl < buf.length)buf[oubt++] = buf[spl++];
                    else oubt = buf.length;
                    if (out) st.y += oubt;
                    else buf = slc(buf, 0, oubt);
                } else if (out) {
                    st.y += lss;
                    if (spl) for(var i = 0; i < lss; ++i)buf[i] = buf[spl + i];
                } else if (spl) buf = slc(buf, spl);
                st.b = ebt;
                return buf;
            }
            err(2);
        }
        function cct(bufs, ol) {
            if (bufs.length === 1) return bufs[0];
            var buf = new u8(ol);
            for(var i = 0, b = 0; i < bufs.length; ++i){
                var chk = bufs[i];
                buf.set(chk, b);
                b += chk.length;
            }
            return buf;
        }
        return function(dat, buf) {
            var bt = 0, bufs = [], nb = +!buf, ol = 0;
            while(dat.length){
                var st = rzfh(dat, nb || buf);
                if (typeof st === "object") {
                    if (nb) {
                        buf = null;
                        if (st.w.length === st.u) {
                            bufs.push(buf = st.w);
                            ol += st.u;
                        }
                    } else {
                        bufs.push(buf);
                        st.e = 0;
                    }
                    while(!st.l){
                        var blk = rzb(dat, st, buf);
                        if (!blk) err(5);
                        if (buf) st.e = st.y;
                        else {
                            bufs.push(blk);
                            ol += blk.length;
                            cpw(st.w, 0, blk.length);
                            st.w.set(blk, st.w.length - blk.length);
                        }
                    }
                    bt = st.b + st.c * 4;
                } else bt = st;
                dat = dat.subarray(bt);
            }
            return cct(bufs, ol);
        };
    }(), caml_decompress_input = zstd_decompress;
    function caml_div(x, y) {
        if (y === 0) caml_raise_zero_divide();
        return x / y | 0;
    }
    var caml_domain_dls = [
        0
    ];
    function caml_domain_dls_compare_and_set(old, n) {
        if (caml_domain_dls !== old) return 0;
        caml_domain_dls = n;
        return 1;
    }
    function caml_domain_dls_get(unit) {
        return caml_domain_dls;
    }
    function caml_domain_dls_set(a) {
        caml_domain_dls = a;
    }
    var caml_domain_id = 0;
    function caml_ml_mutex_unlock(t) {
        t.locked = false;
        return 0;
    }
    var caml_domain_latest_idx = 1;
    function caml_domain_spawn(f, term_sync) {
        var id = caml_domain_latest_idx++, old = caml_domain_id;
        caml_domain_id = id;
        var res = caml_callback(f, [
            0
        ]);
        caml_domain_id = old;
        caml_ml_mutex_unlock(term_sync[2]);
        term_sync[1] = [
            0,
            [
                0,
                res
            ]
        ];
        return id;
    }
    function caml_dummy_obj_is_stack(x) {
        throw new Error(`BUG: this function should be unreachable; please report to compiler or base devs.`);
    }
    var caml_ephe_none = {
        caml_ephe_none: 0
    }, caml_ephe_data_offset = 2, caml_ephe_key_offset = 3;
    function caml_ephe_get_data(x) {
        var data = x[caml_ephe_data_offset];
        if (data === caml_ephe_none) return 0;
        for(var i = caml_ephe_key_offset; i < x.length; i++){
            var k = x[i];
            if (globalThis1.WeakRef && k instanceof globalThis1.WeakRef) {
                var d = k.deref();
                if (d === undefined) {
                    x[i] = caml_ephe_none;
                    x[caml_ephe_data_offset] = caml_ephe_none;
                    return 0;
                }
                if (globalThis1.WeakMap) {
                    data = data.get(k);
                    if (data === undefined) {
                        x[caml_ephe_data_offset] = caml_ephe_none;
                        return 0;
                    }
                }
            }
        }
        return [
            0,
            data
        ];
    }
    function caml_ephe_unset_data(x) {
        x[caml_ephe_data_offset] = caml_ephe_none;
        return 0;
    }
    function caml_ephe_set_data(x, data) {
        for(var i = x.length - 1; i >= caml_ephe_key_offset; i--){
            var k = x[i];
            if (globalThis1.WeakRef && k instanceof globalThis1.WeakRef) {
                var d = k.deref();
                if (d === undefined) {
                    x[i] = caml_ephe_none;
                    continue;
                }
                if (globalThis1.WeakMap) data = new globalThis1.WeakMap().set(k, data);
            }
        }
        x[caml_ephe_data_offset] = data;
        return 0;
    }
    function caml_ephe_set_data_opt(x, data_opt) {
        if (data_opt === 0) caml_ephe_unset_data(x);
        else caml_ephe_set_data(x, data_opt[1]);
        return 0;
    }
    function caml_ephe_blit_data(src, dst) {
        var old = caml_ephe_get_data(src);
        caml_ephe_set_data_opt(dst, old);
        return 0;
    }
    function caml_ephe_blit_key(a1, i1, a2, i2, len) {
        var old = caml_ephe_get_data(a1);
        caml_array_blit(a1, caml_ephe_key_offset + i1 - 1, a2, caml_ephe_key_offset + i2 - 1, len);
        caml_ephe_set_data_opt(a2, old);
        return 0;
    }
    function caml_ephe_check_data(x) {
        var data = caml_ephe_get_data(x);
        return data === 0 ? 0 : 1;
    }
    function caml_ephe_check_key(x, i) {
        var weak = x[caml_ephe_key_offset + i];
        if (weak === caml_ephe_none) return 0;
        if (globalThis1.WeakRef && weak instanceof globalThis1.WeakRef) {
            weak = weak.deref();
            if (weak === undefined) {
                x[caml_ephe_key_offset + i] = caml_ephe_none;
                x[caml_ephe_data_offset] = caml_ephe_none;
                return 0;
            }
        }
        return 1;
    }
    function caml_weak_create(n) {
        var alen = caml_ephe_key_offset + n, x = new Array(alen);
        x[0] = 251;
        x[1] = "caml_ephe_list_head";
        for(var i = 2; i < alen; i++)x[i] = caml_ephe_none;
        return x;
    }
    function caml_ephe_create(n) {
        return caml_weak_create(n);
    }
    function caml_obj_dup(x) {
        var l = x.length, a = new Array(l);
        for(var i = 0; i < l; i++)a[i] = x[i];
        return a;
    }
    function caml_ephe_get_data_copy(x) {
        var r = caml_ephe_get_data(x);
        if (r === 0) return 0;
        var z = r[1];
        if (Array.isArray(z)) return [
            0,
            caml_obj_dup(z)
        ];
        return r;
    }
    function caml_ephe_get_key(x, i) {
        var weak = x[caml_ephe_key_offset + i];
        if (weak === caml_ephe_none) return 0;
        if (globalThis1.WeakRef && weak instanceof globalThis1.WeakRef) {
            weak = weak.deref();
            if (weak === undefined) {
                x[caml_ephe_key_offset + i] = caml_ephe_none;
                x[caml_ephe_data_offset] = caml_ephe_none;
                return 0;
            }
        }
        return [
            0,
            weak
        ];
    }
    function caml_ephe_get_key_copy(x, i) {
        var y = caml_ephe_get_key(x, i);
        if (y === 0) return y;
        var z = y[1];
        if (Array.isArray(z)) return [
            0,
            caml_obj_dup(z)
        ];
        return y;
    }
    function caml_ephe_set_key(x, i, v) {
        var old = caml_ephe_get_data(x);
        if (globalThis1.WeakRef && v instanceof Object) v = new globalThis1.WeakRef(v);
        x[caml_ephe_key_offset + i] = v;
        caml_ephe_set_data_opt(x, old);
        return 0;
    }
    function caml_ephe_unset_key(x, i) {
        var old = caml_ephe_get_data(x);
        x[caml_ephe_key_offset + i] = caml_ephe_none;
        caml_ephe_set_data_opt(x, old);
        return 0;
    }
    function caml_equal(x, y) {
        return +(caml_compare_val(x, y, false) === 0);
    }
    function caml_erf_float(x) {
        var a1 = 0.254829592, a2 = -0.284496736, a3 = 1.421413741, a4 = -1.453152027, a5 = 1.061405429, p = 0.3275911, sign = 1;
        if (x < 0) sign = -1;
        x = Math.abs(x);
        var t = 1.0 / (1.0 + p * x), y = 1.0 - ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-(x * x));
        return sign * y;
    }
    function caml_erfc_float(x) {
        return 1 - caml_erf_float(x);
    }
    var caml_executable_name = caml_argv[1];
    function caml_exp2_float(x) {
        return Math.pow(2, x);
    }
    function caml_expm1_float(x) {
        return Math.expm1(x);
    }
    function caml_is_special_exception(exn) {
        switch(exn[2]){
            case -8:
            case -11:
            case -12:
                return 1;
            default:
                return 0;
        }
    }
    function caml_format_exception(exn) {
        var r = "";
        if (exn[0] === 0) {
            r += exn[1][1];
            if (exn.length === 3 && exn[2][0] === 0 && caml_is_special_exception(exn[1])) var bucket = exn[2], start = 1;
            else var start = 2, bucket = exn;
            r += "(";
            for(var i = start; i < bucket.length; i++){
                if (i > start) r += ", ";
                var v = bucket[i];
                if (typeof v === "number") r += v.toString();
                else if (v instanceof MlBytes) r += '"' + v.toString() + '"';
                else if (typeof v === "string") r += '"' + v.toString() + '"';
                else r += "_";
            }
            r += ")";
        } else if (exn[0] === 248) r += exn[1];
        return r;
    }
    function caml_fatal_uncaught_exception(err) {
        if (Array.isArray(err) && (err[0] === 0 || err[0] === 248)) {
            var handler = caml_named_value("Printexc.handle_uncaught_exception");
            if (handler) caml_callback(handler, [
                err,
                false
            ]);
            else {
                var msg = caml_format_exception(err), at_exit = caml_named_value("Pervasives.do_at_exit");
                if (at_exit) caml_callback(at_exit, [
                    0
                ]);
                console.error("Fatal error: exception " + msg);
                if (err.js_error) throw err.js_error;
            }
        } else throw err;
    }
    function caml_fill_bytes(s, i, l, c) {
        if (l > 0) {
            if (i === 0 && (l >= s.l || s.t === 2 && l >= s.c.length)) {
                if (c === 0) {
                    s.c = "";
                    s.t = 2;
                } else {
                    s.c = caml_str_repeat(l, String.fromCharCode(c));
                    s.t = l === s.l ? 0 : 2;
                }
            } else {
                if (s.t !== 4) caml_convert_bytes_to_array(s);
                for(l += i; i < l; i++)s.c[i] = c;
            }
        }
        return 0;
    }
    function caml_final_register() {
        return 0;
    }
    var all_finalizers = new globalThis1.Set();
    function caml_final_register_called_without_value(cb, a) {
        if (globalThis1.FinalizationRegistry && a instanceof Object) {
            var x = new globalThis1.FinalizationRegistry(function(x) {
                all_finalizers.delete(x);
                cb(0);
                return;
            });
            x.register(a, x);
            all_finalizers.add(x);
        }
        return 0;
    }
    function caml_final_release() {
        return 0;
    }
    function caml_finish_formatting(f, rawbuffer) {
        if (f.uppercase) rawbuffer = rawbuffer.toUpperCase();
        var len = rawbuffer.length;
        if (f.signedconv && (f.sign < 0 || f.signstyle !== "-")) len++;
        if (f.alternate) {
            if (f.base === 8) len += 1;
            if (f.base === 16) len += 2;
        }
        var buffer = "";
        if (f.justify === "+" && f.filler === " ") for(var i = len; i < f.width; i++)buffer += " ";
        if (f.signedconv) {
            if (f.sign < 0) buffer += "-";
            else if (f.signstyle !== "-") buffer += f.signstyle;
        }
        if (f.alternate && f.base === 8) buffer += "0";
        if (f.alternate && f.base === 16) buffer += f.uppercase ? "0X" : "0x";
        if (f.justify === "+" && f.filler === "0") for(var i = len; i < f.width; i++)buffer += "0";
        buffer += rawbuffer;
        if (f.justify === "-") for(var i = len; i < f.width; i++)buffer += " ";
        return caml_string_of_jsbytes(buffer);
    }
    function caml_float_compare(x, y) {
        if (x === y) return 0;
        if (x < y) return -1;
        if (x > y) return 1;
        if (!Number.isNaN(x)) return 1;
        if (!Number.isNaN(y)) return -1;
        return 0;
    }
    function caml_float_of_bytes(a) {
        return caml_int64_float_of_bits(caml_int64_of_bytes(a));
    }
    function caml_float_of_string(s) {
        var res, r_float = /^ *[-+]?(?:\d*\.?\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?$/;
        s = caml_jsbytes_of_string(s);
        res = +s;
        if (!Number.isNaN(res) && r_float.test(s)) return res;
        s = s.replace(/_/g, "");
        res = +s;
        if (!Number.isNaN(res) && r_float.test(s) || /^[+-]?nan$/i.test(s)) return res;
        var m = /^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)(p([+-]?[0-9]+))?$/i.exec(s);
        if (m) {
            var m3 = m[3].replace(/0+$/, ""), mantissa = Number.parseInt(m[1] + m[2] + m3, 16), exponent = (+m[5] || 0) - 4 * m3.length;
            res = mantissa * Math.pow(2, exponent);
            return res;
        }
        if (/^\+?inf(inity)?$/i.test(s)) return Number.POSITIVE_INFINITY;
        if (/^-inf(inity)?$/i.test(s)) return Number.NEGATIVE_INFINITY;
        caml_failwith("float_of_string");
    }
    function caml_floatarray_append(a1, a2) {
        return caml_array_append(a1, a2);
    }
    function caml_floatarray_blit(a1, i1, a2, i2, len) {
        return caml_array_blit(a1, i1, a2, i2, len);
    }
    function caml_floatarray_create(len) {
        if (len >>> 0 >= (0x7fffffff / 8 | 0)) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = 0;
        return b;
    }
    function caml_floatarray_fill(array, ofs, len, v) {
        return caml_array_fill(array, ofs, len, v);
    }
    function caml_floatarray_fill_unboxed(array, ofs, len, v) {
        return caml_array_fill(array, ofs, len, v);
    }
    function caml_floatarray_make(len, init) {
        if (len >>> 0 >= (0x7fffffff / 8 | 0)) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = init;
        return b;
    }
    function caml_floatarray_make_unboxed(len, init) {
        return caml_floatarray_make(len, init);
    }
    function caml_floatarray_sub(a, i, len) {
        return caml_array_sub(a, i, len);
    }
    function caml_fma_float(x, y, z) {
        var SPLIT = Math.pow(2, 27) + 1, MIN_VALUE = Math.pow(2, -1022), EPSILON = Math.pow(2, -52), C = 416, A = Math.pow(2, +C), B = Math.pow(2, -C);
        function multiply(a, b) {
            var at = SPLIT * a, ahi = at - (at - a), alo = a - ahi, bt = SPLIT * b, bhi = bt - (bt - b), blo = b - bhi, p = a * b, e = ahi * bhi - p + ahi * blo + alo * bhi + alo * blo;
            return {
                p: p,
                e: e
            };
        }
        function add(a, b) {
            var s = a + b, v = s - a, e = a - (s - v) + (b - v);
            return {
                s: s,
                e: e
            };
        }
        function adjust(x, y) {
            return x !== 0 && y !== 0 && SPLIT * x - (SPLIT * x - x) === x ? x * (1 + (x < 0 ? -1 : 1) * (y < 0 ? -1 : 1) * EPSILON) : x;
        }
        if (x === 0 || y === 0 || !Number.isFinite(x) || !Number.isFinite(y)) return x * y + z;
        if (z === 0) return x * y;
        if (!Number.isFinite(z)) return z;
        var scale = 1;
        while(Math.abs(x) > A){
            scale *= A;
            x *= B;
        }
        while(Math.abs(y) > A){
            scale *= A;
            y *= B;
        }
        if (scale === 1 / 0) return x * y * scale;
        while(Math.abs(x) < B){
            scale *= B;
            x *= A;
        }
        while(Math.abs(y) < B){
            scale *= B;
            y *= A;
        }
        if (scale === 0) return z;
        var xs = x, ys = y, zs = z / scale;
        if (Math.abs(zs) > Math.abs(xs * ys) * 4 / EPSILON) return z;
        if (Math.abs(zs) < Math.abs(xs * ys) * EPSILON / 4 * EPSILON / 4) zs = (z < 0 ? -1 : 1) * MIN_VALUE;
        var xy = multiply(xs, ys), s = add(xy.p, zs), u = add(xy.e, s.e), i = add(s.s, u.s), f = i.s + adjust(i.e, u.e);
        if (f === 0) return f;
        var fs = f * scale;
        if (Math.abs(fs) > MIN_VALUE) return fs;
        return fs + adjust(f - fs / scale, i.e) * scale;
    }
    function caml_parse_format(fmt) {
        fmt = caml_jsbytes_of_string(fmt);
        var len = fmt.length;
        if (len > 31) caml_invalid_argument("format_int: format too long");
        var f = {
            justify: "+",
            signstyle: "-",
            filler: " ",
            alternate: false,
            base: 0,
            signedconv: false,
            width: 0,
            uppercase: false,
            sign: 1,
            prec: -1,
            conv: "f"
        };
        for(var i = 0; i < len; i++){
            var c = fmt.charAt(i);
            switch(c){
                case "-":
                    f.justify = "-";
                    break;
                case "+":
                case " ":
                    f.signstyle = c;
                    break;
                case "0":
                    f.filler = "0";
                    break;
                case "#":
                    f.alternate = true;
                    break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                    f.width = 0;
                    while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){
                        f.width = f.width * 10 + c;
                        i++;
                    }
                    i--;
                    break;
                case ".":
                    f.prec = 0;
                    i++;
                    while(c = fmt.charCodeAt(i) - 48, c >= 0 && c <= 9){
                        f.prec = f.prec * 10 + c;
                        i++;
                    }
                    i--;
                    break;
                case "d":
                case "i":
                    f.signedconv = true;
                    f.base = 10;
                    break;
                case "u":
                    f.base = 10;
                    break;
                case "x":
                    f.base = 16;
                    break;
                case "X":
                    f.base = 16;
                    f.uppercase = true;
                    break;
                case "o":
                    f.base = 8;
                    break;
                case "e":
                case "f":
                case "g":
                    f.signedconv = true;
                    f.conv = c;
                    break;
                case "E":
                case "F":
                case "G":
                    f.signedconv = true;
                    f.uppercase = true;
                    f.conv = c.toLowerCase();
                    break;
            }
        }
        return f;
    }
    function caml_format_float(fmt, x) {
        function toFixed(x, dp) {
            if (Math.abs(x) < 1.0) return x.toFixed(dp);
            else {
                var e = Number.parseInt(x.toString().split("+")[1]);
                if (e > 20) {
                    e -= 20;
                    x /= Math.pow(10, e);
                    x += new Array(e + 1).join("0");
                    if (dp > 0) x = x + "." + new Array(dp + 1).join("0");
                    return x;
                } else return x.toFixed(dp);
            }
        }
        var s, f = caml_parse_format(fmt), prec = f.prec < 0 ? 6 : f.prec;
        if (x < 0 || x === 0 && 1 / x === Number.NEGATIVE_INFINITY) {
            f.sign = -1;
            x = -x;
        }
        if (Number.isNaN(x)) {
            s = "nan";
            f.filler = " ";
        } else if (!Number.isFinite(x)) {
            s = "inf";
            f.filler = " ";
        } else switch(f.conv){
            case "e":
                var s = x.toExponential(prec), i = s.length;
                if (s.charAt(i - 3) === "e") s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
                break;
            case "f":
                s = toFixed(x, prec);
                break;
            case "g":
                prec = prec ? prec : 1;
                s = x.toExponential(prec - 1);
                var j = s.indexOf("e"), exp = +s.slice(j + 1);
                if (exp < -4 || x >= 1e21 || x.toFixed(0).length > prec) {
                    var i = j - 1;
                    while(s.charAt(i) === "0")i--;
                    if (s.charAt(i) === ".") i--;
                    s = s.slice(0, i + 1) + s.slice(j);
                    i = s.length;
                    if (s.charAt(i - 3) === "e") s = s.slice(0, i - 1) + "0" + s.slice(i - 1);
                    break;
                } else {
                    var p = prec;
                    if (exp < 0) {
                        p -= exp + 1;
                        s = x.toFixed(p);
                    } else while(s = x.toFixed(p), s.length > prec + 1)p--;
                    if (p) {
                        var i = s.length - 1;
                        while(s.charAt(i) === "0")i--;
                        if (s.charAt(i) === ".") i--;
                        s = s.slice(0, i + 1);
                    }
                }
                break;
        }
        return caml_finish_formatting(f, s);
    }
    function caml_format_int(fmt, i) {
        if (caml_jsbytes_of_string(fmt) === "%d") return caml_string_of_jsbytes("" + i);
        var f = caml_parse_format(fmt);
        if (i < 0) {
            if (f.signedconv) {
                f.sign = -1;
                i = -i;
            } else i >>>= 0;
        }
        var s = i.toString(f.base);
        if (f.prec >= 0) {
            f.filler = " ";
            var n = f.prec - s.length;
            if (n > 0) s = caml_str_repeat(n, "0") + s;
        }
        return caml_finish_formatting(f, s);
    }
    var caml_oo_last_id = 0;
    function caml_fresh_oo_id() {
        return caml_oo_last_id++;
    }
    function caml_frexp_float(x) {
        if (x === 0 || !Number.isFinite(x)) return [
            0,
            x,
            0
        ];
        var neg = x < 0;
        if (neg) x = -x;
        var exp = Math.max(-1023, jsoo_floor_log2(x) + 1);
        x *= Math.pow(2, -exp);
        while(x < 0.5){
            x *= 2;
            exp--;
        }
        while(x >= 1){
            x *= 0.5;
            exp++;
        }
        if (neg) x = -x;
        return [
            0,
            x,
            exp
        ];
    }
    function jsoo_create_file(name, content) {
        var name = caml_string_of_jsstring(name), content = caml_string_of_jsbytes(content);
        return caml_create_file(name, content);
    }
    function caml_fs_init() {
        var tmp = globalThis1.jsoo_fs_tmp;
        if (tmp) for(var i = 0; i < tmp.length; i++)jsoo_create_file(tmp[i].name, tmp[i].content);
        globalThis1.jsoo_create_file = jsoo_create_file;
        globalThis1.jsoo_fs_tmp = [];
        return 0;
    }
    function caml_gc_compaction() {
        return 0;
    }
    function caml_gc_counters() {
        return [
            254,
            0,
            0,
            0
        ];
    }
    function caml_gc_full_major(unit) {
        if (typeof globalThis1.gc === "function") globalThis1.gc();
        return 0;
    }
    function caml_gc_get() {
        return [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
    }
    function caml_gc_major(unit) {
        if (typeof globalThis1.gc === "function") globalThis1.gc();
        return 0;
    }
    function caml_gc_major_slice(work) {
        return 0;
    }
    function caml_gc_minor(unit) {
        if (typeof globalThis1.gc === "function") globalThis1.gc(true);
        return 0;
    }
    function caml_gc_minor_words(unit) {
        return 0;
    }
    function caml_gc_quick_stat() {
        return [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
    }
    function caml_gc_set(_control) {
        return 0;
    }
    function caml_gc_stat() {
        return caml_gc_quick_stat();
    }
    function caml_get_continuation_callstack() {
        return [
            0
        ];
    }
    function caml_get_current_callstack() {
        return [
            0
        ];
    }
    function caml_get_exception_backtrace() {
        return 0;
    }
    function caml_get_exception_raw_backtrace() {
        return [
            0
        ];
    }
    function caml_get_global_data() {
        return caml_global_data;
    }
    function caml_get_minor_free(unit) {
        return 0;
    }
    var caml_method_cache = [];
    function caml_get_public_method(obj, tag, cacheid) {
        var meths = obj[1], ofs = caml_method_cache[cacheid];
        if (ofs === undefined) for(var i = caml_method_cache.length; i < cacheid; i++)caml_method_cache[i] = 0;
        else if (meths[ofs] === tag) return meths[ofs - 1];
        var li = 3, hi = meths[1] * 2 + 1, mi;
        while(li < hi){
            mi = li + hi >> 1 | 1;
            if (tag < meths[mi + 1]) hi = mi - 2;
            else li = mi;
        }
        caml_method_cache[cacheid] = li + 1;
        return tag === meths[li + 1] ? meths[li] : 0;
    }
    function caml_gr_arc_aux(ctx, cx, cy, ry, rx, a1, a2) {
        while(a1 > a2)a2 += 360;
        a1 /= 180;
        a2 /= 180;
        var rot = 0, xPos, yPos, xPos_prev, yPos_prev, space = 2, num = (a2 - a1) * Math.PI * ((rx + ry) / 2) / space | 0, delta = (a2 - a1) * Math.PI / num, i = a1 * Math.PI;
        for(var j = 0; j <= num; j++){
            xPos = cx - rx * Math.sin(i) * Math.sin(rot * Math.PI) + ry * Math.cos(i) * Math.cos(rot * Math.PI);
            xPos = xPos.toFixed(2);
            yPos = cy + ry * Math.cos(i) * Math.sin(rot * Math.PI) + rx * Math.sin(i) * Math.cos(rot * Math.PI);
            yPos = yPos.toFixed(2);
            if (j === 0) ctx.moveTo(xPos, yPos);
            else if (xPos_prev !== xPos || yPos_prev !== yPos) ctx.lineTo(xPos, yPos);
            xPos_prev = xPos;
            yPos_prev = yPos;
            i -= delta;
        }
        return 0;
    }
    var caml_gr_state;
    function caml_gr_state_get() {
        if (caml_gr_state) return caml_gr_state;
        throw caml_maybe_attach_backtrace([
            0,
            caml_named_value("Graphics.Graphic_failure"),
            caml_string_of_jsbytes("Not initialized")
        ]);
    }
    function caml_gr_blit_image(im, x, y) {
        var s = caml_gr_state_get(), im2 = s.context.getImageData(x, s.height - im.height - y, im.width, im.height);
        for(var i = 0; i < im2.data.length; i += 4){
            im.data[i] = im2.data[i];
            im.data[i + 1] = im2.data[i + 1];
            im.data[i + 2] = im2.data[i + 2];
            im.data[i + 3] = im2.data[i + 3];
        }
        return 0;
    }
    function caml_gr_clear_graph() {
        var s = caml_gr_state_get();
        s.canvas.width = s.width;
        s.canvas.height = s.height;
        return 0;
    }
    function caml_gr_close_graph() {
        var s = caml_gr_state_get();
        s.canvas.width = 0;
        s.canvas.height = 0;
        return 0;
    }
    function caml_gr_close_subwindow(a) {
        caml_failwith("caml_gr_close_subwindow not Implemented");
    }
    function caml_gr_create_image(x, y) {
        var s = caml_gr_state_get();
        return s.context.createImageData(x, y);
    }
    function caml_gr_current_x() {
        var s = caml_gr_state_get();
        return s.x;
    }
    function caml_gr_current_y() {
        var s = caml_gr_state_get();
        return s.y;
    }
    function caml_gr_display_mode() {
        caml_failwith("caml_gr_display_mode not Implemented");
    }
    function caml_gr_doc_of_state(state) {
        if (state.canvas.ownerDocument) return state.canvas.ownerDocument;
    }
    function caml_gr_draw_arc(x, y, rx, ry, a1, a2) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        caml_gr_arc_aux(s.context, x, s.height - y, rx, ry, a1, a2);
        s.context.stroke();
        return 0;
    }
    function caml_gr_draw_str(str) {
        var s = caml_gr_state_get(), m = s.context.measureText(str), dx = m.width;
        s.context.fillText(str, s.x, s.height - s.y);
        s.x += dx | 0;
        return 0;
    }
    function caml_gr_draw_char(c) {
        caml_gr_draw_str(String.fromCharCode(c));
        return 0;
    }
    function caml_gr_draw_image(im, x, y) {
        var s = caml_gr_state_get();
        if (!im.image) {
            var canvas = document.createElement("canvas");
            canvas.width = s.width;
            canvas.height = s.height;
            canvas.getContext("2d").putImageData(im, 0, 0);
            var image = new globalThis1.Image();
            image.onload = function() {
                s.context.drawImage(image, x, s.height - im.height - y);
                im.image = image;
            };
            image.src = canvas.toDataURL("image/png");
        } else s.context.drawImage(im.image, x, s.height - im.height - y);
        return 0;
    }
    function caml_gr_draw_rect(x, y, w, h) {
        var s = caml_gr_state_get();
        s.context.strokeRect(x, s.height - y, w, -h);
        return 0;
    }
    function caml_gr_draw_string(str) {
        caml_gr_draw_str(caml_jsstring_of_string(str));
        return 0;
    }
    function caml_gr_dump_image(im) {
        var data = [
            0
        ];
        for(var i = 0; i < im.height; i++){
            data[i + 1] = [
                0
            ];
            for(var j = 0; j < im.width; j++){
                var o = i * (im.width * 4) + j * 4, r = im.data[o + 0], g = im.data[o + 1], b = im.data[o + 2];
                data[i + 1][j + 1] = (r << 16) + (g << 8) + b;
            }
        }
        return data;
    }
    function caml_gr_fill_arc(x, y, rx, ry, a1, a2) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        caml_gr_arc_aux(s.context, x, s.height - y, rx, ry, a1, a2);
        s.context.fill();
        return 0;
    }
    function caml_gr_fill_poly(ar) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        s.context.moveTo(ar[1][1], s.height - ar[1][2]);
        for(var i = 2; i < ar.length; i++)s.context.lineTo(ar[i][1], s.height - ar[i][2]);
        s.context.lineTo(ar[1][1], s.height - ar[1][2]);
        s.context.fill();
        return 0;
    }
    function caml_gr_fill_rect(x, y, w, h) {
        var s = caml_gr_state_get();
        s.context.fillRect(x, s.height - y, w, -h);
        return 0;
    }
    function caml_gr_lineto(x, y) {
        var s = caml_gr_state_get();
        s.context.beginPath();
        s.context.moveTo(s.x, s.height - s.y);
        s.context.lineTo(x, s.height - y);
        s.context.stroke();
        s.x = x;
        s.y = y;
        return 0;
    }
    function caml_gr_make_image(arr) {
        var s = caml_gr_state_get(), h = arr.length - 1, w = arr[1].length - 1, im = s.context.createImageData(w, h);
        for(var i = 0; i < h; i++)for(var j = 0; j < w; j++){
            var c = arr[i + 1][j + 1], o = i * (w * 4) + j * 4;
            if (c === -1) {
                im.data[o + 0] = 0;
                im.data[o + 1] = 0;
                im.data[o + 2] = 0;
                im.data[o + 3] = 0;
            } else {
                im.data[o + 0] = c >> 16 & 0xff;
                im.data[o + 1] = c >> 8 & 0xff;
                im.data[o + 2] = c >> 0 & 0xff;
                im.data[o + 3] = 0xff;
            }
        }
        return im;
    }
    function caml_gr_moveto(x, y) {
        var s = caml_gr_state_get();
        s.x = x;
        s.y = y;
        return 0;
    }
    function caml_gr_set_window_title(name) {
        var s = caml_gr_state_get();
        s.title = name;
        var jsname = caml_jsstring_of_string(name);
        if (s.set_title) s.set_title(jsname);
        return 0;
    }
    function caml_gr_set_line_width(w) {
        var s = caml_gr_state_get();
        s.line_width = w;
        s.context.lineWidth = w;
        return 0;
    }
    function caml_gr_set_text_size(size) {
        var s = caml_gr_state_get();
        s.text_size = size;
        s.context.font = s.text_size + "px " + caml_jsstring_of_string(s.font);
        return 0;
    }
    function caml_gr_set_font(f) {
        var s = caml_gr_state_get();
        s.font = f;
        s.context.font = s.text_size + "px " + caml_jsstring_of_string(s.font);
        return 0;
    }
    function caml_gr_set_color(color) {
        var s = caml_gr_state_get();
        function convert(number) {
            var str = "" + number.toString(16);
            while(str.length < 2)str = "0" + str;
            return str;
        }
        var r = color >> 16 & 0xff, g = color >> 8 & 0xff, b = color >> 0 & 0xff;
        s.color = color;
        var c_str = "#" + convert(r) + convert(g) + convert(b);
        s.context.fillStyle = c_str;
        s.context.strokeStyle = c_str;
        return 0;
    }
    function caml_gr_resize_window(w, h) {
        var s = caml_gr_state_get();
        s.width = w;
        s.height = h;
        s.canvas.width = w;
        s.canvas.height = h;
        return 0;
    }
    function caml_gr_state_init() {
        caml_gr_moveto(caml_gr_state.x, caml_gr_state.y);
        caml_gr_resize_window(caml_gr_state.width, caml_gr_state.height);
        caml_gr_set_line_width(caml_gr_state.line_width);
        caml_gr_set_text_size(caml_gr_state.text_size);
        caml_gr_set_font(caml_gr_state.font);
        caml_gr_set_color(caml_gr_state.color);
        caml_gr_set_window_title(caml_gr_state.title);
        caml_gr_state.context.textBaseline = "bottom";
    }
    function caml_gr_state_set(ctx) {
        caml_gr_state = ctx;
        caml_gr_state_init();
        return 0;
    }
    function caml_gr_state_create(canvas, w, h) {
        var context = canvas.getContext("2d");
        return {
            context: context,
            canvas: canvas,
            x: 0,
            y: 0,
            width: w,
            height: h,
            line_width: 1,
            font: caml_string_of_jsbytes("fixed"),
            text_size: 26,
            color: 0x000000,
            title: caml_string_of_jsbytes("")
        };
    }
    function caml_gr_open_graph(info) {
        var info = caml_jsstring_of_string(info);
        function get(name) {
            var res = info.match("(^|,) *" + name + " *= *([a-zA-Z0-9_]+) *(,|$)");
            if (res) return res[2];
        }
        var specs = [];
        if (!(info === "")) specs.push(info);
        var target = get("target");
        if (!target) target = "";
        var status = get("status");
        if (!status) specs.push("status=1");
        var w = get("width");
        w = w ? Number.parseInt(w) : 200;
        specs.push("width=" + w);
        var h = get("height");
        h = h ? Number.parseInt(h) : 200;
        specs.push("height=" + h);
        var win = globalThis1.open("about:blank", target, specs.join(","));
        if (!win) caml_failwith("Graphics.open_graph: cannot open the window");
        var doc = win.document, canvas = doc.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        var ctx = caml_gr_state_create(canvas, w, h);
        ctx.set_title = function(title) {
            doc.title = title;
        };
        caml_gr_state_set(ctx);
        var body = doc.body;
        body.style.margin = "0px";
        body.appendChild(canvas);
        return 0;
    }
    function caml_gr_open_subwindow(a, b, c, d) {
        caml_failwith("caml_gr_open_subwindow not Implemented");
    }
    function caml_gr_plot(x, y) {
        var s = caml_gr_state_get(), im = s.context.createImageData(1, 1), d = im.data, color = s.color;
        d[0] = color >> 16 & 0xff;
        d[1] = color >> 8 & 0xff, d[2] = color >> 0 & 0xff;
        d[3] = 0xff;
        s.x = x;
        s.y = y;
        s.context.putImageData(im, x, s.height - y);
        return 0;
    }
    function caml_gr_point_color(x, y) {
        var s = caml_gr_state_get(), im = s.context.getImageData(x, s.height - y, 1, 1), d = im.data;
        return (d[0] << 16) + (d[1] << 8) + d[2];
    }
    function caml_gr_remember_mode() {
        caml_failwith("caml_gr_remember_mode not Implemented");
    }
    function caml_gr_sigio_handler() {
        return 0;
    }
    function caml_gr_sigio_signal() {
        return 0;
    }
    function caml_gr_size_x() {
        var s = caml_gr_state_get();
        return s.width;
    }
    function caml_gr_size_y() {
        var s = caml_gr_state_get();
        return s.height;
    }
    function caml_gr_synchronize() {
        caml_failwith("caml_gr_synchronize not Implemented");
    }
    function caml_gr_text_size(txt) {
        var s = caml_gr_state_get(), w = s.context.measureText(caml_jsstring_of_string(txt)).width;
        return [
            0,
            w,
            s.text_size
        ];
    }
    function caml_gr_wait_event(_evl) {
        caml_failwith("caml_gr_wait_event not Implemented: use Graphics_js instead");
    }
    function caml_gr_window_id(a) {
        caml_failwith("caml_gr_window_id not Implemented");
    }
    function caml_greaterequal(x, y) {
        return +(caml_compare_val(x, y, false) >= 0);
    }
    function caml_greaterthan(x, y) {
        return +(caml_compare_val(x, y, false) > 0);
    }
    function caml_hash_mix_bigstring(h, bs) {
        return caml_hash_mix_bytes_arr(h, bs.data);
    }
    function num_digits_nat(nat, ofs, len) {
        for(var i = len - 1; i >= 0; i--)if (nat.data[ofs + i] !== 0) return i + 1;
        return 1;
    }
    function caml_hash_nat(x) {
        var len = num_digits_nat(x, 0, x.data.length), h = 0;
        for(var i = 0; i < len; i++)h = caml_hash_mix_int(h, x.data[i]);
        return h;
    }
    function caml_hexstring_of_float(x, prec, style) {
        if (!Number.isFinite(x)) {
            if (Number.isNaN(x)) return caml_string_of_jsstring("nan");
            return caml_string_of_jsstring(x > 0 ? "infinity" : "-infinity");
        }
        var sign = x === 0 && 1 / x === Number.NEGATIVE_INFINITY ? 1 : x >= 0 ? 0 : 1;
        if (sign) x = -x;
        var exp = 0;
        if (x === 0) ;
        else if (x < 1) while(x < 1 && exp > -1022){
            x *= 2;
            exp--;
        }
        else while(x >= 2){
            x /= 2;
            exp++;
        }
        var exp_sign = exp < 0 ? "" : "+", sign_str = "";
        if (sign) sign_str = "-";
        else switch(style){
            case 43:
                sign_str = "+";
                break;
            case 32:
                sign_str = " ";
                break;
            default:
                break;
        }
        if (prec >= 0 && prec < 13) {
            var cst = Math.pow(2, prec * 4);
            x = Math.round(x * cst) / cst;
        }
        var x_str = x.toString(16);
        if (prec >= 0) {
            var idx = x_str.indexOf(".");
            if (idx < 0) x_str += "." + caml_str_repeat(prec, "0");
            else {
                var size = idx + 1 + prec;
                if (x_str.length < size) x_str += caml_str_repeat(size - x_str.length, "0");
                else x_str = x_str.slice(0, size);
            }
        }
        return caml_string_of_jsstring(sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10));
    }
    function caml_hypot_float(x, y) {
        return Math.hypot(x, y);
    }
    var caml_marshal_header_size = 16;
    function caml_refill(chan) {
        if (chan.refill != null) {
            var str = chan.refill(), str_a = caml_uint8_array_of_string(str);
            if (str_a.length === 0) chan.refill = null;
            else {
                if (chan.buffer.length < chan.buffer_max + str_a.length) {
                    var b = new Uint8Array(chan.buffer_max + str_a.length);
                    b.set(chan.buffer);
                    chan.buffer = b;
                }
                chan.buffer.set(str_a, chan.buffer_max);
                chan.offset += str_a.length;
                chan.buffer_max += str_a.length;
            }
        } else {
            if (chan.fd === -1) caml_raise_sys_error("Bad file descriptor");
            var nread = chan.file.read(chan.buffer, chan.buffer_max, chan.buffer.length - chan.buffer_max);
            chan.offset += nread;
            chan.buffer_max += nread;
        }
    }
    function caml_raise_end_of_file() {
        caml_raise_constant(caml_global_data.End_of_file);
    }
    function caml_marshal_data_size(s, ofs) {
        var r = new UInt8ArrayReader(caml_uint8_array_of_bytes(s), ofs);
        function readvlq(overflow) {
            var c = r.read8u(), n = c & 0x7f;
            while((c & 0x80) !== 0){
                c = r.read8u();
                var n7 = n << 7;
                if (n !== n7 >> 7) overflow[0] = true;
                n = n7 | c & 0x7f;
            }
            return n;
        }
        switch(r.read32u()){
            case 0x8495a6be:
                var header_len = 20, data_len = r.read32u();
                break;
            case 0x8495a6bd:
                var header_len = r.read8u() & 0x3f, overflow = [
                    false
                ], data_len = readvlq(overflow);
                if (overflow[0]) caml_failwith("Marshal.data_size: object too large to be read back on this platform");
                break;
            case 0x8495a6bf:
                caml_failwith("Marshal.data_size: object too large to be read back on a 32-bit platform");
                break;
            default:
                caml_failwith("Marshal.data_size: bad object");
                break;
        }
        return header_len - caml_marshal_header_size + data_len;
    }
    function caml_set_oo_id(b) {
        b[2] = caml_oo_last_id++;
        return b;
    }
    function caml_input_value_from_reader(reader, ofs) {
        function readvlq(overflow) {
            var c = reader.read8u(), n = c & 0x7f;
            while((c & 0x80) !== 0){
                c = reader.read8u();
                var n7 = n << 7;
                if (n !== n7 >> 7) overflow[0] = true;
                n = n7 | c & 0x7f;
            }
            return n;
        }
        var magic = reader.read32u();
        switch(magic){
            case 0x8495a6be:
                var header_len = 20, compressed = 0, data_len = reader.read32u(), uncompressed_data_len = data_len, num_objects = reader.read32u(), _size_32 = reader.read32u(), _size_64 = reader.read32u();
                break;
            case 0x8495a6bd:
                var header_len = reader.read8u() & 0x3f, compressed = 1, overflow = [
                    false
                ], data_len = readvlq(overflow), uncompressed_data_len = readvlq(overflow), num_objects = readvlq(overflow), _size_32 = readvlq(overflow), _size_64 = readvlq(overflow);
                if (overflow[0]) caml_failwith("caml_input_value_from_reader: object too large to be read back on this platform");
                break;
            case 0x8495a6bf:
                caml_failwith("caml_input_value_from_reader: object too large to be read back on a 32-bit platform");
                break;
            default:
                caml_failwith("caml_input_value_from_reader: bad object");
                break;
        }
        var stack = [], objects = [], intern_obj_table = num_objects > 0 ? [] : null, obj_counter = 0;
        function intern_rec(reader) {
            var code = reader.read8u();
            if (code >= 0x40) {
                if (code >= 0x80) {
                    var tag = code & 0xf, size = code >> 4 & 0x7, v = [
                        tag
                    ];
                    if (size === 0) return v;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    if (tag === 248) objects.push(v);
                    stack.push(v, size);
                    return v;
                } else return code & 0x3f;
            } else if (code >= 0x20) {
                var len = code & 0x1f, v = reader.readstr(len);
                if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                return v;
            } else switch(code){
                case 0x00:
                    return reader.read8s();
                case 0x01:
                    return reader.read16s();
                case 0x02:
                    return reader.read32s();
                case 0x03:
                    caml_failwith("input_value: integer too large");
                    break;
                case 0x04:
                    var offset = reader.read8u();
                    if (compressed === 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x05:
                    var offset = reader.read16u();
                    if (compressed === 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x06:
                    var offset = reader.read32u();
                    if (compressed === 0) offset = obj_counter - offset;
                    return intern_obj_table[offset];
                case 0x08:
                    var header = reader.read32u(), tag = header & 0xff, size = header >> 10, v = [
                        tag
                    ];
                    if (size === 0) return v;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    if (tag === 248) objects.push(v);
                    stack.push(v, size);
                    return v;
                case 0x13:
                    caml_failwith("input_value: data block too large");
                    break;
                case 0x09:
                    var len = reader.read8u(), v = reader.readstr(len);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0a:
                    var len = reader.read32u(), v = reader.readstr(len);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0c:
                    var t = new Array(8);
                    for(var i = 0; i < 8; i++)t[7 - i] = reader.read8u();
                    var v = caml_float_of_bytes(t);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0b:
                    var t = new Array(8);
                    for(var i = 0; i < 8; i++)t[i] = reader.read8u();
                    var v = caml_float_of_bytes(t);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                case 0x0e:
                    var len = reader.read8u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[7 - j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x0d:
                    var len = reader.read8u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x07:
                    var len = reader.read32u(), v = new Array(len + 1);
                    v[0] = 254;
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    var t = new Array(8);
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[7 - j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x0f:
                    var len = reader.read32u(), v = new Array(len + 1);
                    v[0] = 254;
                    var t = new Array(8);
                    for(var i = 1; i <= len; i++){
                        for(var j = 0; j < 8; j++)t[j] = reader.read8u();
                        v[i] = caml_float_of_bytes(t);
                    }
                    return v;
                case 0x10:
                case 0x11:
                    caml_failwith("input_value: code pointer");
                    break;
                case 0x12:
                case 0x18:
                case 0x19:
                    var c, s = "";
                    while((c = reader.read8u()) !== 0)s += String.fromCharCode(c);
                    var ops = caml_custom_ops[s], expected_size;
                    if (!ops) caml_failwith("input_value: unknown custom block identifier");
                    switch(code){
                        case 0x12:
                            break;
                        case 0x19:
                            if (!ops.fixed_length) caml_failwith("input_value: expected a fixed-size custom block");
                            expected_size = ops.fixed_length;
                            break;
                        case 0x18:
                            expected_size = reader.read32u();
                            reader.read32s();
                            reader.read32s();
                            break;
                    }
                    var old_pos = reader.i, size = [
                        0
                    ], v = ops.deserialize(reader, size);
                    if (expected_size !== undefined) {
                        if (expected_size !== size[0]) caml_failwith("input_value: incorrect length of serialized custom block");
                    }
                    if (intern_obj_table) intern_obj_table[obj_counter++] = v;
                    return v;
                default:
                    caml_failwith("input_value: ill-formed message");
            }
        }
        if (compressed) {
            if (caml_decompress_input) var data = reader.readuint8array(data_len), res = new Uint8Array(uncompressed_data_len), res = caml_decompress_input(data, res), reader = new UInt8ArrayReader(res, 0);
            else caml_failwith("input_value: compressed object, cannot decompress");
        }
        var res = intern_rec(reader);
        while(stack.length > 0){
            var size = stack.pop(), v = stack.pop(), d = v.length;
            if (d < size) stack.push(v, size);
            v[d] = intern_rec(reader);
        }
        while(objects.length > 0){
            var x = objects.pop();
            if (x[2] >= 0) caml_set_oo_id(x);
        }
        return res;
    }
    function caml_string_of_bytes(s) {
        s.t & 6 && caml_convert_string_to_bytes(s);
        return caml_string_of_jsbytes(s.c);
    }
    function caml_input_value_from_bytes(s, ofs) {
        var reader = new MlStringReader(caml_string_of_bytes(s), typeof ofs === "number" ? ofs : ofs[0]);
        return caml_input_value_from_reader(reader, ofs);
    }
    function caml_input_value(chanid) {
        var chan = caml_ml_channel_get(chanid), header = new Uint8Array(caml_marshal_header_size);
        function block(buffer, offset, n) {
            var r = 0;
            while(r < n){
                if (chan.buffer_curr >= chan.buffer_max) {
                    chan.buffer_curr = 0;
                    chan.buffer_max = 0;
                    caml_refill(chan);
                }
                if (chan.buffer_curr >= chan.buffer_max) break;
                buffer[offset + r] = chan.buffer[chan.buffer_curr];
                chan.buffer_curr++;
                r++;
            }
            return r;
        }
        var r = block(header, 0, caml_marshal_header_size);
        if (r === 0) caml_raise_end_of_file();
        else if (r < caml_marshal_header_size) caml_failwith("input_value: truncated object");
        var len = caml_marshal_data_size(caml_bytes_of_uint8_array(header), 0), buf = new Uint8Array(len + caml_marshal_header_size);
        buf.set(header, 0);
        var r = block(buf, caml_marshal_header_size, len);
        if (r < len) caml_failwith("input_value: truncated object " + r + "  " + len);
        var res = caml_input_value_from_bytes(caml_bytes_of_uint8_array(buf), 0);
        return res;
    }
    function caml_input_value_to_outside_heap(c) {
        return caml_input_value(c);
    }
    function caml_install_signal_handler() {
        return 0;
    }
    function caml_int32_bswap(x) {
        return (x & 0x000000ff) << 24 | (x & 0x0000ff00) << 8 | (x & 0x00ff0000) >>> 8 | (x & 0xff000000) >>> 24;
    }
    function caml_int64_add(x, y) {
        return x.add(y);
    }
    function caml_int64_bswap(x) {
        var y = caml_int64_to_bytes(x);
        return caml_int64_of_bytes([
            y[7],
            y[6],
            y[5],
            y[4],
            y[3],
            y[2],
            y[1],
            y[0]
        ]);
    }
    function caml_int64_div(x, y) {
        return x.div(y);
    }
    function caml_int64_is_negative(x) {
        return +x.isNeg();
    }
    function caml_int64_neg(x) {
        return x.neg();
    }
    function caml_int64_format(fmt, x) {
        var f = caml_parse_format(fmt);
        if (f.signedconv && caml_int64_is_negative(x)) {
            f.sign = -1;
            x = caml_int64_neg(x);
        }
        var buffer = "", wbase = caml_int64_of_int32(f.base), cvtbl = "0123456789abcdef";
        do {
            var p = x.udivmod(wbase);
            x = p.quotient;
            buffer = cvtbl.charAt(caml_int64_to_int32(p.modulus)) + buffer;
        }while (!caml_int64_is_zero(x));
        if (f.prec >= 0) {
            f.filler = " ";
            var n = f.prec - buffer.length;
            if (n > 0) buffer = caml_str_repeat(n, "0") + buffer;
        }
        return caml_finish_formatting(f, buffer);
    }
    function caml_int64_mod(x, y) {
        return x.mod(y);
    }
    function caml_int64_ult(x, y) {
        return x.ucompare(y) < 0;
    }
    function caml_parse_sign_and_base(s) {
        var i = 0, len = caml_ml_string_length(s), base = 10, sign = 1, signedness = 1;
        if (len > 0) switch(caml_string_unsafe_get(s, i)){
            case 45:
                i++;
                sign = -1;
                break;
            case 43:
                i++;
                sign = 1;
                break;
        }
        if (i + 1 < len && caml_string_unsafe_get(s, i) === 48) switch(caml_string_unsafe_get(s, i + 1)){
            case 120:
            case 88:
                signedness = 0;
                base = 16;
                i += 2;
                break;
            case 111:
            case 79:
                signedness = 0;
                base = 8;
                i += 2;
                break;
            case 98:
            case 66:
                signedness = 0;
                base = 2;
                i += 2;
                break;
            case 117:
            case 85:
                signedness = 0;
                i += 2;
                break;
        }
        return [
            i,
            sign,
            base,
            signedness
        ];
    }
    function caml_parse_digit(c) {
        if (c >= 48 && c <= 57) return c - 48;
        if (c >= 65 && c <= 90) return c - 55;
        if (c >= 97 && c <= 122) return c - 87;
        return -1;
    }
    function caml_int64_of_string(s) {
        var r = caml_parse_sign_and_base(s), i = r[0], sign = r[1], base = r[2], signedness = r[3], base64 = caml_int64_of_int32(base), threshold = new MlInt64(0xffffff, 0xfffffff, 0xffff).udivmod(base64).quotient, c = caml_string_unsafe_get(s, i), d = caml_parse_digit(c);
        if (d < 0 || d >= base) caml_failwith("int_of_string");
        var res = caml_int64_of_int32(d);
        for(;;){
            i++;
            c = caml_string_unsafe_get(s, i);
            if (c === 95) continue;
            d = caml_parse_digit(c);
            if (d < 0 || d >= base) break;
            if (caml_int64_ult(threshold, res)) caml_failwith("int_of_string");
            d = caml_int64_of_int32(d);
            res = caml_int64_add(caml_int64_mul(base64, res), d);
            if (caml_int64_ult(res, d)) caml_failwith("int_of_string");
        }
        if (i !== caml_ml_string_length(s)) caml_failwith("int_of_string");
        if (signedness && caml_int64_ult(new MlInt64(0, 0, 0x8000), res)) caml_failwith("int_of_string");
        if (sign < 0) res = caml_int64_neg(res);
        return res;
    }
    function caml_int64_or(x, y) {
        return x.or(y);
    }
    function caml_int64_shift_left(x, s) {
        return x.shift_left(s);
    }
    function caml_int64_shift_right(x, s) {
        return x.shift_right(s);
    }
    function caml_int64_sub(x, y) {
        return x.sub(y);
    }
    function caml_int64_to_float(x) {
        return x.toFloat();
    }
    function caml_int64_xor(x, y) {
        return x.xor(y);
    }
    function caml_int_of_string(s) {
        var r = caml_parse_sign_and_base(s), i = r[0], sign = r[1], base = r[2], signedness = r[3], len = caml_ml_string_length(s), threshold = 4294967295, c = i < len ? caml_string_unsafe_get(s, i) : 0, d = caml_parse_digit(c);
        if (d < 0 || d >= base) caml_failwith("int_of_string");
        var res = d;
        for(i++; i < len; i++){
            c = caml_string_unsafe_get(s, i);
            if (c === 95) continue;
            d = caml_parse_digit(c);
            if (d < 0 || d >= base) break;
            res = base * res + d;
            if (res > threshold) caml_failwith("int_of_string");
        }
        if (i !== len) caml_failwith("int_of_string");
        res = sign * res;
        if (signedness && (res | 0) !== res) caml_failwith("int_of_string");
        return res | 0;
    }
    function caml_is_js() {
        return 1;
    }
    function caml_is_printable(c) {
        return +(c > 31 && c < 127);
    }
    function caml_js_call(f, o, args) {
        return f.apply(o, caml_js_from_array(args));
    }
    function caml_js_delete(o, f) {
        delete o[f];
        return 0;
    }
    function caml_js_equals(x, y) {
        return +(x == y);
    }
    function caml_js_error_of_exception(exn) {
        if (exn.js_error) return exn.js_error;
        return null;
    }
    function caml_js_error_option_of_exception(exn) {
        if (exn.js_error) return [
            0,
            exn.js_error
        ];
        return 0;
    }
    function caml_js_eval_string(s) {
        return eval(caml_jsstring_of_string(s));
    }
    function caml_js_expr(s) {
        console.error("caml_js_expr: fallback to runtime evaluation\n");
        return eval(caml_jsstring_of_string(s));
    }
    function caml_js_from_bool(x) {
        return !!x;
    }
    function caml_js_from_float(x) {
        return x;
    }
    function caml_js_from_string(s) {
        return caml_jsstring_of_string(s);
    }
    function caml_js_fun_call(f, a) {
        switch(a.length){
            case 1:
                return f();
            case 2:
                return f(a[1]);
            case 3:
                return f(a[1], a[2]);
            case 4:
                return f(a[1], a[2], a[3]);
            case 5:
                return f(a[1], a[2], a[3], a[4]);
            case 6:
                return f(a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return f(a[1], a[2], a[3], a[4], a[5], a[6]);
            case 8:
                return f(a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
        }
        return f.apply(null, caml_js_from_array(a));
    }
    function caml_js_function_arity(f) {
        return f.l >= 0 ? f.l : f.l = f.length;
    }
    function caml_js_get(o, f) {
        return o[f];
    }
    function caml_js_get_console() {
        var c = console, m = [
            "log",
            "debug",
            "info",
            "warn",
            "error",
            "assert",
            "dir",
            "dirxml",
            "trace",
            "group",
            "groupCollapsed",
            "groupEnd",
            "time",
            "timeEnd"
        ];
        function f() {}
        for(var i = 0; i < m.length; i++)if (!c[m[i]]) c[m[i]] = f;
        return c;
    }
    function caml_js_html_entities(s) {
        var entity = /^&#?[0-9a-zA-Z]+;$/;
        if (s.match(entity)) {
            var str, temp = document.createElement("p");
            temp.innerHTML = s;
            str = temp.textContent || temp.innerText;
            temp = null;
            return str;
        } else return null;
    }
    var caml_js_regexps = {
        amp: /&/g,
        lt: /</g,
        quot: /"/g,
        all: /[&<"]/
    };
    function caml_js_html_escape(s) {
        if (!caml_js_regexps.all.test(s)) return s;
        return s.replace(caml_js_regexps.amp, "&amp;").replace(caml_js_regexps.lt, "&lt;").replace(caml_js_regexps.quot, "&quot;");
    }
    function caml_js_instanceof(o, c) {
        return o instanceof c ? 1 : 0;
    }
    function caml_js_meth_call(o, f, args) {
        return o[caml_jsstring_of_string(f)].apply(o, caml_js_from_array(args));
    }
    function caml_js_new(c, a) {
        switch(a.length){
            case 1:
                return new c();
            case 2:
                return new c(a[1]);
            case 3:
                return new c(a[1], a[2]);
            case 4:
                return new c(a[1], a[2], a[3]);
            case 5:
                return new c(a[1], a[2], a[3], a[4]);
            case 6:
                return new c(a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return new c(a[1], a[2], a[3], a[4], a[5], a[6]);
            case 8:
                return new c(a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
        }
        function F() {
            return c.apply(this, caml_js_from_array(a));
        }
        F.prototype = c.prototype;
        return new F();
    }
    function caml_js_object(a) {
        var o = {};
        for(var i = 1; i < a.length; i++){
            var p = a[i];
            o[caml_jsstring_of_string(p[1])] = p[2];
        }
        return o;
    }
    function caml_js_pure_expr(f) {
        return caml_callback(f, [
            0
        ]);
    }
    function caml_js_set(o, f, v) {
        o[f] = v;
        return 0;
    }
    function caml_js_strict_equals(x, y) {
        return +(x === y);
    }
    function caml_js_to_array(a) {
        var len = a.length, b = new Array(len + 1);
        b[0] = 0;
        for(var i = 0; i < len; i++)b[i + 1] = a[i];
        return b;
    }
    function caml_js_to_bool(x) {
        return +x;
    }
    function caml_js_to_byte_string(s) {
        return caml_string_of_jsbytes(s);
    }
    function caml_js_to_float(x) {
        return x;
    }
    function caml_js_to_int32(x) {
        return x | 0;
    }
    function caml_js_to_string(s) {
        return caml_string_of_jsstring(s);
    }
    function caml_js_typeof(o) {
        return typeof o;
    }
    function caml_js_var(x) {
        var x = caml_jsstring_of_string(x);
        if (!x.match(/^[a-zA-Z_$][a-zA-Z_$0-9]*(\.[a-zA-Z_$][a-zA-Z_$0-9]*)*$/)) console.error('caml_js_var: "' + x + '" is not a valid JavaScript variable. continuing ..');
        return eval(x);
    }
    function caml_js_wrap_callback(f) {
        return function(...args) {
            if (args.length === 0) args = [
                undefined
            ];
            var res = caml_callback(f, args);
            return res instanceof Function ? caml_js_wrap_callback(res) : res;
        };
    }
    function caml_js_wrap_callback_arguments(f) {
        return function(...args) {
            return caml_callback(f, [
                args
            ]);
        };
    }
    function caml_js_wrap_callback_strict(arity, f) {
        return function(...args) {
            args.length = arity;
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_callback_unsafe(f) {
        return function(...args) {
            var len = caml_js_function_arity(f);
            args.length = len;
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_meth_callback(f) {
        return function(...args) {
            args.unshift(this);
            var res = caml_callback(f, args);
            return res instanceof Function ? caml_js_wrap_callback(res) : res;
        };
    }
    function caml_js_wrap_meth_callback_arguments(f) {
        return function(...args) {
            return caml_callback(f, [
                this,
                args
            ]);
        };
    }
    function caml_js_wrap_meth_callback_strict(arity, f) {
        return function(...args) {
            args.length = arity;
            args.unshift(this);
            return caml_callback(f, args);
        };
    }
    function caml_js_wrap_meth_callback_unsafe(f) {
        return function(...args) {
            var len = caml_js_function_arity(f);
            args.unshift(this);
            args.length = len;
            return caml_callback(f, args);
        };
    }
    function caml_jsoo_flags_effects(unit) {
        return "disabled";
    }
    function caml_jsoo_flags_use_js_string(unit) {
        return 1;
    }
    function caml_lazy_make_forward(v) {
        return [
            250,
            v
        ];
    }
    function caml_obj_tag(x) {
        if (Array.isArray(x) && x[0] === x[0] >>> 0) return x[0];
        else if (caml_is_ml_bytes(x)) return 252;
        else if (caml_is_ml_string(x)) return 252;
        else if (x instanceof Function || typeof x === "function") return 247;
        else if (x && x.caml_custom) return 255;
        else return 1000;
    }
    function caml_lazy_read_result(o) {
        return caml_obj_tag(o) === 250 ? o[1] : o;
    }
    function caml_obj_update_tag(b, o, n) {
        if (b[0] === o) {
            b[0] = n;
            return 1;
        }
        return 0;
    }
    function caml_lazy_reset_to_lazy(o) {
        caml_obj_update_tag(o, 244, 246);
        return 0;
    }
    function caml_lazy_update_to_forcing(o) {
        return Array.isArray(o) && o[0] === o[0] >>> 0 && caml_obj_update_tag(o, 246, 244) ? 0 : 1;
    }
    function caml_lazy_update_to_forward(o) {
        caml_obj_update_tag(o, 244, 250);
        return 0;
    }
    function caml_ldexp_float(x, exp) {
        exp |= 0;
        if (exp > 1023) {
            exp -= 1023;
            x *= Math.pow(2, 1023);
            if (exp > 1023) {
                exp -= 1023;
                x *= Math.pow(2, 1023);
            }
        }
        if (exp < -1023) {
            exp += 1023;
            x *= Math.pow(2, -1023);
        }
        x *= Math.pow(2, exp);
        return x;
    }
    function caml_lessequal(x, y) {
        return +(caml_compare_val(x, y, false) <= 0);
    }
    function caml_lessthan(x, y) {
        return +(caml_compare_val(x, y, false) < 0);
    }
    function caml_lex_array(s) {
        s = caml_jsbytes_of_string(s);
        var l = s.length / 2, a = new Array(l);
        for(var i = 0; i < l; i++)a[i] = (s.charCodeAt(2 * i) | s.charCodeAt(2 * i + 1) << 8) << 16 >> 16;
        return a;
    }
    function caml_lex_engine(tbl, start_state, lexbuf) {
        var lex_buffer = 2, lex_buffer_len = 3, lex_start_pos = 5, lex_curr_pos = 6, lex_last_pos = 7, lex_last_action = 8, lex_eof_reached = 9, lex_base = 1, lex_backtrk = 2, lex_default = 3, lex_trans = 4, lex_check = 5;
        if (!tbl.lex_default) {
            tbl.lex_base = caml_lex_array(tbl[lex_base]);
            tbl.lex_backtrk = caml_lex_array(tbl[lex_backtrk]);
            tbl.lex_check = caml_lex_array(tbl[lex_check]);
            tbl.lex_trans = caml_lex_array(tbl[lex_trans]);
            tbl.lex_default = caml_lex_array(tbl[lex_default]);
        }
        var c, state = start_state, buffer = lexbuf[lex_buffer];
        if (state >= 0) {
            lexbuf[lex_last_pos] = lexbuf[lex_start_pos] = lexbuf[lex_curr_pos];
            lexbuf[lex_last_action] = -1;
        } else state = -state - 1;
        for(;;){
            var base = tbl.lex_base[state];
            if (base < 0) return -base - 1;
            var backtrk = tbl.lex_backtrk[state];
            if (backtrk >= 0) {
                lexbuf[lex_last_pos] = lexbuf[lex_curr_pos];
                lexbuf[lex_last_action] = backtrk;
            }
            if (lexbuf[lex_curr_pos] >= lexbuf[lex_buffer_len]) {
                if (lexbuf[lex_eof_reached] === 0) return -state - 1;
                else c = 256;
            } else {
                c = caml_bytes_unsafe_get(buffer, lexbuf[lex_curr_pos]);
                lexbuf[lex_curr_pos]++;
            }
            if (tbl.lex_check[base + c] === state) state = tbl.lex_trans[base + c];
            else state = tbl.lex_default[state];
            if (state < 0) {
                lexbuf[lex_curr_pos] = lexbuf[lex_last_pos];
                if (lexbuf[lex_last_action] === -1) caml_failwith("lexing: empty token");
                else return lexbuf[lex_last_action];
            } else if (c === 256) lexbuf[lex_eof_reached] = 0;
        }
    }
    function caml_list_mount_point() {
        var prev = 0;
        for(var i = 0; i < jsoo_mount_point.length; i++){
            var old = prev;
            prev = [
                0,
                caml_string_of_jsstring(jsoo_mount_point[i].path),
                old
            ];
        }
        return prev;
    }
    function caml_list_of_js_array(a) {
        var l = 0;
        for(var i = a.length - 1; i >= 0; i--){
            var e = a[i];
            l = [
                0,
                e,
                l
            ];
        }
        return l;
    }
    function caml_list_to_js_array(l) {
        var a = [];
        for(; l !== 0; l = l[2])a.push(l[1]);
        return a;
    }
    function caml_log10_float(x) {
        return Math.log10(x);
    }
    function caml_log1p_float(x) {
        return Math.log1p(x);
    }
    function caml_log2_float(x) {
        return Math.log2(x);
    }
    var caml_lxm_M = caml_int64_of_string(caml_string_of_jsstring("0xd1342543de82ef95")), caml_lxm_daba = caml_int64_of_string(caml_string_of_jsstring("0xdaba0b6eb09322e3"));
    function caml_lxm_next(v) {
        function shift_l(x, k) {
            return caml_int64_shift_left(x, k);
        }
        function shift_r(x, k) {
            return caml_int64_shift_right_unsigned(x, k);
        }
        function or(a, b) {
            return caml_int64_or(a, b);
        }
        function xor(a, b) {
            return caml_int64_xor(a, b);
        }
        function add(a, b) {
            return caml_int64_add(a, b);
        }
        function mul(a, b) {
            return caml_int64_mul(a, b);
        }
        function rotl(x, k) {
            return or(shift_l(x, k), shift_r(x, 64 - k));
        }
        function get(a, i) {
            return caml_ba_get_1(a, i);
        }
        function set(a, i, x) {
            return caml_ba_set_1(a, i, x);
        }
        var M = caml_lxm_M, daba = caml_lxm_daba, z, q0, q1, st = v, a = get(st, 0), s = get(st, 1), x0 = get(st, 2), x1 = get(st, 3);
        z = add(s, x0);
        z = mul(xor(z, shift_r(z, 32)), daba);
        z = mul(xor(z, shift_r(z, 32)), daba);
        z = xor(z, shift_r(z, 32));
        set(st, 1, add(mul(s, M), a));
        var q0 = x0, q1 = x1;
        q1 = xor(q1, q0);
        q0 = rotl(q0, 24);
        q0 = xor(xor(q0, q1), shift_l(q1, 16));
        q1 = rotl(q1, 37);
        set(st, 2, q0);
        set(st, 3, q1);
        return z;
    }
    function caml_make_float_vect(len) {
        if (len >>> 0 >= (0x7fffffff / 8 | 0)) caml_array_bound_error();
        var len = len + 1 | 0, b = new Array(len);
        b[0] = 254;
        for(var i = 1; i < len; i++)b[i] = 0;
        return b;
    }
    function caml_make_vect(len, init) {
        return caml_array_make(len, init);
    }
    function caml_make_local_vect(v_len, v_elt) {
        return caml_make_vect(v_len, v_elt);
    }
    var caml_marshal_constants = {
        PREFIX_SMALL_BLOCK: 0x80,
        PREFIX_SMALL_INT: 0x40,
        PREFIX_SMALL_STRING: 0x20,
        CODE_INT8: 0x00,
        CODE_INT16: 0x01,
        CODE_INT32: 0x02,
        CODE_INT64: 0x03,
        CODE_SHARED8: 0x04,
        CODE_SHARED16: 0x05,
        CODE_SHARED32: 0x06,
        CODE_BLOCK32: 0x08,
        CODE_BLOCK64: 0x13,
        CODE_STRING8: 0x09,
        CODE_STRING32: 0x0a,
        CODE_DOUBLE_BIG: 0x0b,
        CODE_DOUBLE_LITTLE: 0x0c,
        CODE_DOUBLE_ARRAY8_BIG: 0x0d,
        CODE_DOUBLE_ARRAY8_LITTLE: 0x0e,
        CODE_DOUBLE_ARRAY32_BIG: 0x0f,
        CODE_DOUBLE_ARRAY32_LITTLE: 0x07,
        CODE_CODEPOINTER: 0x10,
        CODE_INFIXPOINTER: 0x11,
        CODE_CUSTOM: 0x12,
        CODE_CUSTOM_LEN: 0x18,
        CODE_CUSTOM_FIXED: 0x19
    };
    function caml_maybe_print_stats(unit) {
        return 0;
    }
    function caml_md5_bytes(s, ofs, len) {
        var ctx = caml_MD5Init(), a = caml_uint8_array_of_bytes(s);
        caml_MD5Update(ctx, a.subarray(ofs, ofs + len), len);
        return caml_string_of_uint8_array(caml_MD5Final(ctx));
    }
    function caml_ml_input_block(chanid, ba, i, l) {
        var chan = caml_ml_channel_get(chanid), n = l, avail = chan.buffer_max - chan.buffer_curr;
        if (l <= avail) {
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + l), i);
            chan.buffer_curr += l;
        } else if (avail > 0) {
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + avail), i);
            chan.buffer_curr += avail;
            n = avail;
        } else {
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
            caml_refill(chan);
            var avail = chan.buffer_max - chan.buffer_curr;
            if (n > avail) n = avail;
            ba.set(chan.buffer.subarray(chan.buffer_curr, chan.buffer_curr + n), i);
            chan.buffer_curr += n;
        }
        return n | 0;
    }
    function caml_md5_chan(chanid, toread) {
        var ctx = caml_MD5Init(), buffer = new Uint8Array(4096);
        if (toread < 0) while(true){
            var read = caml_ml_input_block(chanid, buffer, 0, buffer.length);
            if (read === 0) break;
            caml_MD5Update(ctx, buffer.subarray(0, read), read);
        }
        else while(toread > 0){
            var read = caml_ml_input_block(chanid, buffer, 0, toread > buffer.length ? buffer.length : toread);
            if (read === 0) caml_raise_end_of_file();
            caml_MD5Update(ctx, buffer.subarray(0, read), read);
            toread -= read;
        }
        return caml_string_of_uint8_array(caml_MD5Final(ctx));
    }
    function caml_md5_string(s, ofs, len) {
        return caml_md5_bytes(caml_bytes_of_string(s), ofs, len);
    }
    function caml_memprof_discard(t) {
        return 0;
    }
    function caml_memprof_start(rate, stack_size, tracker) {
        return 0;
    }
    function caml_memprof_stop(unit) {
        return 0;
    }
    function caml_ml_channel_redirect(captured, into) {
        var to_restore = caml_ml_channel_get(captured), new_ = caml_ml_channel_get(into);
        caml_ml_channels.set(captured, new_);
        return to_restore;
    }
    function caml_ml_channel_restore(captured, to_restore) {
        caml_ml_channels.set(captured, to_restore);
        return 0;
    }
    function caml_ml_channel_size(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.file.length() | 0;
    }
    function caml_ml_channel_size_64(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return caml_int64_of_float(chan.file.length());
    }
    var caml_sys_fds = new Array(3);
    function caml_sys_close(fd) {
        var x = caml_sys_fds[fd];
        if (x) {
            x.file.close();
            delete caml_sys_fds[fd];
        }
        return 0;
    }
    function caml_ml_flush(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (!chan.opened) caml_raise_sys_error("Cannot flush a closed channel");
        if (!chan.buffer || chan.buffer_curr === 0) return 0;
        if (chan.output) chan.output(caml_sub_uint8_array_to_jsbytes(chan.buffer, 0, chan.buffer_curr));
        else for(var pos = 0; pos < chan.buffer_curr;)pos += chan.file.write(chan.buffer, pos, chan.buffer_curr - pos);
        chan.offset += chan.buffer_curr;
        chan.buffer_curr = 0;
        return 0;
    }
    function caml_ml_close_channel(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.opened) {
            chan.opened = false;
            caml_ml_channels.close(chanid);
            caml_sys_close(chan.fd);
            chan.fd = -1;
            chan.buffer = new Uint8Array(0);
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
        }
        return 0;
    }
    function caml_ml_condition_broadcast(t) {
        return 0;
    }
    function caml_ml_condition_new(unit) {
        return {
            condition: 1
        };
    }
    function caml_ml_condition_signal(t) {
        return 0;
    }
    function caml_ml_condition_wait(t, mutext) {
        return 0;
    }
    function caml_ml_debug_info_status() {
        return 0;
    }
    function caml_ml_domain_cpu_relax(unit) {
        return 0;
    }
    function caml_ml_domain_id(unit) {
        return caml_domain_id;
    }
    function caml_ml_domain_index(unit) {
        return caml_domain_id;
    }
    var caml_runtime_warnings = 0;
    function caml_ml_enable_runtime_warnings(bool) {
        caml_runtime_warnings = bool;
        return 0;
    }
    function caml_ml_input(chanid, b, i, l) {
        var ba = caml_uint8_array_of_bytes(b);
        return caml_ml_input_block(chanid, ba, i, l);
    }
    function caml_ml_input_bigarray(chanid, b, i, l) {
        var ba = caml_ba_to_typed_array(b);
        return caml_ml_input_block(chanid, ba, i, l);
    }
    function caml_ml_input_char(chanid) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.buffer_curr >= chan.buffer_max) {
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
            caml_refill(chan);
        }
        if (chan.buffer_curr >= chan.buffer_max) caml_raise_end_of_file();
        var res = chan.buffer[chan.buffer_curr];
        chan.buffer_curr++;
        return res;
    }
    function caml_ml_input_int(chanid) {
        var chan = caml_ml_channel_get(chanid), res = 0;
        for(var i = 0; i < 4; i++)res = (res << 8) + caml_ml_input_char(chanid) | 0;
        return res | 0;
    }
    function caml_ml_input_scan_line(chanid) {
        var chan = caml_ml_channel_get(chanid), p = chan.buffer_curr;
        do if (p >= chan.buffer_max) {
            if (chan.buffer_curr > 0) {
                chan.buffer.set(chan.buffer.subarray(chan.buffer_curr), 0);
                p -= chan.buffer_curr;
                chan.buffer_max -= chan.buffer_curr;
                chan.buffer_curr = 0;
            }
            if (chan.buffer_max >= chan.buffer.length) return -chan.buffer_max | 0;
            var prev_max = chan.buffer_max;
            caml_refill(chan);
            if (prev_max === chan.buffer_max) return -chan.buffer_max | 0;
        }
        while (chan.buffer[p++] !== 10);
        return p - chan.buffer_curr | 0;
    }
    function caml_ml_is_binary_mode(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.file.flags.binary;
    }
    function caml_ml_is_buffered(chanid) {
        return caml_ml_channel_get(chanid).buffered ? 1 : 0;
    }
    function caml_ml_mutex_lock(t) {
        if (t.locked) caml_failwith("Mutex.lock: mutex already locked. Cannot wait.");
        else t.locked = true;
        return 0;
    }
    function caml_ml_mutex_new(unit) {
        return new MlMutex();
    }
    function caml_ml_mutex_try_lock(t) {
        if (!t.locked) {
            t.locked = true;
            return 1;
        }
        return 0;
    }
    function caml_sys_open_for_node(fd, flags) {
        if (flags.altname) try {
            var fs = (parcelRequire("48K42")), fd2 = fs.openSync(flags.altname, "rs");
            return new MlNodeFd(fd2, flags);
        } catch (e) {}
        return new MlNodeFd(fd, flags);
    }
    function caml_sys_open_internal(file, idx) {
        var chanid;
        if (idx === undefined) {
            idx = caml_sys_fds.length;
            chanid = new MlChanid(idx);
        } else if (caml_sys_fds[idx]) chanid = caml_sys_fds[idx].chanid;
        else chanid = new MlChanid(idx);
        caml_sys_fds[idx] = {
            file: file,
            chanid: chanid
        };
        return idx | 0;
    }
    function caml_sys_open(name, flags, perms) {
        var f = {};
        while(flags){
            switch(flags[1]){
                case 0:
                    f.rdonly = 1;
                    break;
                case 1:
                    f.wronly = 1;
                    break;
                case 2:
                    f.append = 1;
                    f.writeonly = 1;
                    break;
                case 3:
                    f.create = 1;
                    break;
                case 4:
                    f.truncate = 1;
                    break;
                case 5:
                    f.excl = 1;
                    break;
                case 6:
                    f.binary = 1;
                    break;
                case 7:
                    f.text = 1;
                    break;
                case 8:
                    f.nonblock = 1;
                    break;
            }
            flags = flags[2];
        }
        var root = resolve_fs_device(name), file = root.device.open(root.rest, f, perms);
        return caml_sys_open_internal(file, undefined);
    }
    (function() {
        var is_node = fs_node_supported();
        function file(fd, flags) {
            return is_node ? caml_sys_open_for_node(fd, flags) : new MlFakeFd_out(fd, flags);
        }
        caml_sys_open_internal(file(0, {
            rdonly: 1,
            altname: "/dev/stdin",
            isCharacterDevice: true
        }), 0);
        caml_sys_open_internal(file(1, {
            buffered: is_node ? 1 : 2,
            wronly: 1,
            isCharacterDevice: true
        }), 1);
        caml_sys_open_internal(file(2, {
            buffered: is_node ? 1 : 2,
            wronly: 1,
            isCharacterDevice: true
        }), 2);
    })();
    function caml_ml_open_descriptor_in(fd) {
        var fd_desc = caml_sys_fds[fd];
        if (fd_desc === undefined) caml_raise_sys_error("fd " + fd + " doesn't exist");
        var file = fd_desc.file, chanid = fd_desc.chanid, refill = null, channel = {
            file: file,
            offset: file.offset,
            fd: fd,
            opened: true,
            out: false,
            buffer_curr: 0,
            buffer_max: 0,
            buffer: new Uint8Array(65536),
            refill: refill
        };
        caml_ml_channels.set(chanid, channel);
        return chanid;
    }
    function caml_ml_open_descriptor_in_with_flags(fd, flags) {
        return caml_ml_open_descriptor_in(fd);
    }
    function caml_ml_open_descriptor_out(fd) {
        var fd_desc = caml_sys_fds[fd];
        if (fd_desc === undefined) caml_raise_sys_error("fd " + fd + " doesn't exist");
        var file = fd_desc.file, chanid = fd_desc.chanid, buffered = file.flags.buffered !== undefined ? file.flags.buffered : 1, channel = {
            file: file,
            offset: file.offset,
            fd: fd,
            opened: true,
            out: true,
            buffer_curr: 0,
            buffer: new Uint8Array(65536),
            buffered: buffered
        };
        caml_ml_channels.set(chanid, channel);
        return chanid;
    }
    function caml_ml_open_descriptor_out_with_flags(fd, flags) {
        return caml_ml_open_descriptor_out(fd);
    }
    function caml_ml_out_channels_list() {
        var l = 0, keys = caml_ml_channels.all();
        for (var k of keys){
            var chan = caml_ml_channel_get(k);
            if (chan.opened && chan.out) l = [
                0,
                k,
                l
            ];
        }
        return l;
    }
    function caml_ml_output_ta(chanid, buffer, offset, len) {
        var chan = caml_ml_channel_get(chanid);
        if (!chan.opened) caml_raise_sys_error("Cannot output to a closed channel");
        buffer = buffer.subarray(offset, offset + len);
        if (chan.buffer_curr + buffer.length > chan.buffer.length) {
            var b = new Uint8Array(chan.buffer_curr + buffer.length);
            b.set(chan.buffer);
            chan.buffer = b;
        }
        switch(chan.buffered){
            case 0:
                chan.buffer.set(buffer, chan.buffer_curr);
                chan.buffer_curr += buffer.length;
                caml_ml_flush(chanid);
                break;
            case 1:
                chan.buffer.set(buffer, chan.buffer_curr);
                chan.buffer_curr += buffer.length;
                if (chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
                break;
            case 2:
                var id = buffer.lastIndexOf(10);
                if (id < 0) {
                    chan.buffer.set(buffer, chan.buffer_curr);
                    chan.buffer_curr += buffer.length;
                    if (chan.buffer_curr >= chan.buffer.length) caml_ml_flush(chanid);
                } else {
                    chan.buffer.set(buffer.subarray(0, id + 1), chan.buffer_curr);
                    chan.buffer_curr += id + 1;
                    caml_ml_flush(chanid);
                    chan.buffer.set(buffer.subarray(id + 1), chan.buffer_curr);
                    chan.buffer_curr += buffer.length - id - 1;
                }
                break;
        }
        return 0;
    }
    function caml_ml_output_bytes(chanid, buffer, offset, len) {
        var buffer = caml_uint8_array_of_bytes(buffer);
        return caml_ml_output_ta(chanid, buffer, offset, len);
    }
    function caml_ml_output(chanid, buffer, offset, len) {
        return caml_ml_output_bytes(chanid, caml_bytes_of_string(buffer), offset, len);
    }
    function caml_ml_output_bigarray(chanid, buffer, offset, len) {
        var buffer = caml_ba_to_typed_array(buffer);
        return caml_ml_output_ta(chanid, buffer, offset, len);
    }
    function caml_ml_output_char(chanid, c) {
        var s = caml_string_of_jsbytes(String.fromCharCode(c));
        caml_ml_output(chanid, s, 0, 1);
        return 0;
    }
    function caml_ml_output_int(chanid, i) {
        var arr = [
            i >> 24 & 0xff,
            i >> 16 & 0xff,
            i >> 8 & 0xff,
            i & 0xff
        ];
        caml_ml_output_ta(chanid, new Uint8Array(arr), 0, 4);
        return 0;
    }
    function caml_pos_in(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.offset - (chan.buffer_max - chan.buffer_curr);
    }
    function caml_ml_pos_in(chanid) {
        return caml_pos_in(chanid) | 0;
    }
    function caml_ml_pos_in_64(chanid) {
        return caml_int64_of_float(caml_pos_in(chanid));
    }
    function caml_pos_out(chanid) {
        var chan = caml_ml_channel_get(chanid);
        return chan.offset + chan.buffer_curr;
    }
    function caml_ml_pos_out(chanid) {
        return caml_pos_out(chanid) | 0;
    }
    function caml_ml_pos_out_64(chanid) {
        return caml_int64_of_float(caml_pos_out(chanid));
    }
    function caml_ml_runtime_events_are_active() {
        return 0;
    }
    function caml_ml_runtime_events_path(_unit) {
        return 0;
    }
    function caml_ml_runtime_events_pause() {
        return 0;
    }
    function caml_ml_runtime_events_resume() {
        return 0;
    }
    function caml_ml_runtime_events_start() {
        return 0;
    }
    function caml_ml_runtime_warnings_enabled(_unit) {
        return caml_runtime_warnings;
    }
    function caml_seek_in(chanid, pos) {
        var chan = caml_ml_channel_get(chanid);
        if (chan.refill != null) caml_raise_sys_error("Illegal seek");
        if (pos >= chan.offset - chan.buffer_max && pos <= chan.offset && chan.file.flags.binary) chan.buffer_curr = chan.buffer_max - (chan.offset - pos);
        else {
            chan.file.seek(pos, 0);
            chan.offset = pos;
            chan.buffer_curr = 0;
            chan.buffer_max = 0;
        }
        return 0;
    }
    function caml_ml_seek_in(chanid, pos) {
        return caml_seek_in(chanid, pos);
    }
    function caml_ml_seek_in_64(chanid, pos) {
        var pos = caml_int64_to_float(pos);
        return caml_seek_in(chanid, pos);
    }
    function caml_seek_out(chanid, pos) {
        caml_ml_flush(chanid);
        var chan = caml_ml_channel_get(chanid);
        chan.file.seek(pos, 0);
        chan.offset = pos;
        return 0;
    }
    function caml_ml_seek_out(chanid, pos) {
        return caml_seek_out(chanid, pos);
    }
    function caml_ml_seek_out_64(chanid, pos) {
        var pos = caml_int64_to_float(pos);
        return caml_seek_out(chanid, pos);
    }
    function caml_ml_set_binary_mode(chanid, mode) {
        var chan = caml_ml_channel_get(chanid);
        chan.file.flags.text = !mode;
        chan.file.flags.binary = mode;
        return 0;
    }
    function caml_ml_set_buffered(chanid, v) {
        caml_ml_channel_get(chanid).buffered = v;
        if (!v) caml_ml_flush(chanid);
        return 0;
    }
    function caml_ml_set_channel_name(chanid, name) {
        var chan = caml_ml_channel_get(chanid);
        chan.name = name;
        return 0;
    }
    function caml_ml_set_channel_output(chanid, f) {
        var chan = caml_ml_channel_get(chanid);
        chan.output = function(s) {
            f(s);
        };
        return 0;
    }
    function caml_ml_set_channel_refill(chanid, f) {
        caml_ml_channel_get(chanid).refill = f;
        return 0;
    }
    function caml_mod(x, y) {
        if (y === 0) caml_raise_zero_divide();
        return x % y;
    }
    function caml_modf_float(x) {
        if (Number.isFinite(x)) {
            var neg = 1 / x < 0;
            x = Math.abs(x);
            var i = Math.floor(x), f = x - i;
            if (neg) {
                i = -i;
                f = -f;
            }
            return [
                0,
                f,
                i
            ];
        }
        if (Number.isNaN(x)) return [
            0,
            Number.NaN,
            Number.NaN
        ];
        return [
            0,
            1 / x,
            x
        ];
    }
    function caml_mount_autoload(name, f) {
        var path = caml_make_path(name), name = caml_trailing_slash(path.join("/"));
        jsoo_mount_point.push({
            path: name,
            device: new MlFakeDevice(name, f)
        });
        return 0;
    }
    function caml_lex_run_mem(s, i, mem, curr_pos) {
        for(;;){
            var dst = s.charCodeAt(i);
            i++;
            if (dst === 0xff) return;
            var src = s.charCodeAt(i);
            i++;
            if (src === 0xff) mem[dst + 1] = curr_pos;
            else mem[dst + 1] = mem[src + 1];
        }
    }
    function caml_lex_run_tag(s, i, mem) {
        for(;;){
            var dst = s.charCodeAt(i);
            i++;
            if (dst === 0xff) return;
            var src = s.charCodeAt(i);
            i++;
            if (src === 0xff) mem[dst + 1] = -1;
            else mem[dst + 1] = mem[src + 1];
        }
    }
    function caml_new_lex_engine(tbl, start_state, lexbuf) {
        var lex_buffer = 2, lex_buffer_len = 3, lex_start_pos = 5, lex_curr_pos = 6, lex_last_pos = 7, lex_last_action = 8, lex_eof_reached = 9, lex_mem = 10, lex_base = 1, lex_backtrk = 2, lex_default = 3, lex_trans = 4, lex_check = 5, lex_base_code = 6, lex_backtrk_code = 7, lex_default_code = 8, lex_trans_code = 9, lex_check_code = 10, lex_code = 11;
        if (!tbl.lex_default) {
            tbl.lex_base = caml_lex_array(tbl[lex_base]);
            tbl.lex_backtrk = caml_lex_array(tbl[lex_backtrk]);
            tbl.lex_check = caml_lex_array(tbl[lex_check]);
            tbl.lex_trans = caml_lex_array(tbl[lex_trans]);
            tbl.lex_default = caml_lex_array(tbl[lex_default]);
        }
        if (!tbl.lex_default_code) {
            tbl.lex_base_code = caml_lex_array(tbl[lex_base_code]);
            tbl.lex_backtrk_code = caml_lex_array(tbl[lex_backtrk_code]);
            tbl.lex_check_code = caml_lex_array(tbl[lex_check_code]);
            tbl.lex_trans_code = caml_lex_array(tbl[lex_trans_code]);
            tbl.lex_default_code = caml_lex_array(tbl[lex_default_code]);
        }
        if (tbl.lex_code == null) tbl.lex_code = caml_jsbytes_of_string(tbl[lex_code]);
        var c, state = start_state, buffer = lexbuf[lex_buffer];
        if (state >= 0) {
            lexbuf[lex_last_pos] = lexbuf[lex_start_pos] = lexbuf[lex_curr_pos];
            lexbuf[lex_last_action] = -1;
        } else state = -state - 1;
        for(;;){
            var base = tbl.lex_base[state];
            if (base < 0) {
                var pc_off = tbl.lex_base_code[state];
                caml_lex_run_tag(tbl.lex_code, pc_off, lexbuf[lex_mem]);
                return -base - 1;
            }
            var backtrk = tbl.lex_backtrk[state];
            if (backtrk >= 0) {
                var pc_off = tbl.lex_backtrk_code[state];
                caml_lex_run_tag(tbl.lex_code, pc_off, lexbuf[lex_mem]);
                lexbuf[lex_last_pos] = lexbuf[lex_curr_pos];
                lexbuf[lex_last_action] = backtrk;
            }
            if (lexbuf[lex_curr_pos] >= lexbuf[lex_buffer_len]) {
                if (lexbuf[lex_eof_reached] === 0) return -state - 1;
                else c = 256;
            } else {
                c = caml_bytes_unsafe_get(buffer, lexbuf[lex_curr_pos]);
                lexbuf[lex_curr_pos]++;
            }
            var pstate = state;
            if (tbl.lex_check[base + c] === state) state = tbl.lex_trans[base + c];
            else state = tbl.lex_default[state];
            if (state < 0) {
                lexbuf[lex_curr_pos] = lexbuf[lex_last_pos];
                if (lexbuf[lex_last_action] === -1) caml_failwith("lexing: empty token");
                else return lexbuf[lex_last_action];
            } else {
                var base_code = tbl.lex_base_code[pstate], pc_off;
                if (tbl.lex_check_code[base_code + c] === pstate) pc_off = tbl.lex_trans_code[base_code + c];
                else pc_off = tbl.lex_default_code[pstate];
                if (pc_off > 0) caml_lex_run_mem(tbl.lex_code, pc_off, lexbuf[lex_mem], lexbuf[lex_curr_pos]);
                if (c === 256) lexbuf[lex_eof_reached] = 0;
            }
        }
    }
    function caml_new_string(s) {
        return caml_string_of_jsbytes(s);
    }
    function caml_nextafter_float(x, y) {
        if (Number.isNaN(x) || Number.isNaN(y)) return Number.NaN;
        if (x === y) return y;
        if (x === 0) return y < 0 ? -Math.pow(2, -1074) : Math.pow(2, -1074);
        var bits = caml_int64_bits_of_float(x), one = caml_int64_of_int32(1);
        if (x < y === x > 0) bits = caml_int64_add(bits, one);
        else bits = caml_int64_sub(bits, one);
        return caml_int64_float_of_bits(bits);
    }
    function caml_notequal(x, y) {
        return +(caml_compare_val(x, y, false) !== 0);
    }
    function caml_obj_add_offset(v, offset) {
        caml_failwith("Obj.add_offset is not supported");
    }
    function caml_obj_block(tag, size) {
        var o = new Array(size + 1);
        o[0] = tag;
        for(var i = 1; i <= size; i++)o[i] = 0;
        return o;
    }
    function caml_obj_compare_and_swap(x, i, old, n) {
        if (x[i + 1] === old) {
            x[i + 1] = n;
            return 1;
        }
        return 0;
    }
    function caml_obj_is_shared(x) {
        return 1;
    }
    function caml_obj_raw_field(o, i) {
        return o[i + 1];
    }
    function caml_obj_reachable_words(o) {
        return 0;
    }
    function caml_obj_set_raw_field(o, i, v) {
        return o[i + 1] = v;
    }
    function caml_obj_with_tag(tag, x) {
        var l = x.length, a = new Array(l);
        a[0] = tag;
        for(var i = 1; i < l; i++)a[i] = x[i];
        return a;
    }
    function caml_ojs_new_arr(c, a) {
        switch(a.length){
            case 0:
                return new c();
            case 1:
                return new c(a[0]);
            case 2:
                return new c(a[0], a[1]);
            case 3:
                return new c(a[0], a[1], a[2]);
            case 4:
                return new c(a[0], a[1], a[2], a[3]);
            case 5:
                return new c(a[0], a[1], a[2], a[3], a[4]);
            case 6:
                return new c(a[0], a[1], a[2], a[3], a[4], a[5]);
            case 7:
                return new c(a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
        }
        function F() {
            return c.apply(this, a);
        }
        F.prototype = c.prototype;
        return new F();
    }
    var caml_output_val = function() {
        function Writer() {
            this.chunk = [];
        }
        Writer.prototype = {
            chunk_idx: 20,
            block_len: 0,
            obj_counter: 0,
            size_32: 0,
            size_64: 0,
            write: function(size, value) {
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[this.chunk_idx++] = value >> i & 0xff;
            },
            write_at: function(pos, size, value) {
                var pos = pos;
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[pos++] = value >> i & 0xff;
            },
            write_code: function(size, code, value) {
                this.chunk[this.chunk_idx++] = code;
                for(var i = size - 8; i >= 0; i -= 8)this.chunk[this.chunk_idx++] = value >> i & 0xff;
            },
            write_shared: function(offset) {
                if (offset < 256) this.write_code(8, 0x04, offset);
                else if (offset < 65536) this.write_code(16, 0x05, offset);
                else this.write_code(32, 0x06, offset);
            },
            pos: function() {
                return this.chunk_idx;
            },
            finalize: function() {
                this.block_len = this.chunk_idx - 20;
                this.chunk_idx = 0;
                this.write(32, 0x8495a6be);
                this.write(32, this.block_len);
                this.write(32, this.obj_counter);
                this.write(32, this.size_32);
                this.write(32, this.size_64);
                return this.chunk;
            }
        };
        return function(v, flags) {
            flags = caml_list_to_js_array(flags);
            var no_sharing = flags.indexOf(0) !== -1, closures = flags.indexOf(1) !== -1;
            if (closures) console.warn("in caml_output_val: flag Marshal.Closures is not supported.");
            var writer = new Writer(), stack = [], intern_obj_table = no_sharing ? null : new MlObjectTable();
            function memo(v) {
                if (no_sharing) return false;
                var existing_offset = intern_obj_table.recall(v);
                if (existing_offset) {
                    writer.write_shared(existing_offset);
                    return true;
                } else {
                    intern_obj_table.store(v);
                    return false;
                }
            }
            function extern_rec(v) {
                if (v.caml_custom) {
                    if (memo(v)) return;
                    var name = v.caml_custom, ops = caml_custom_ops[name], sz_32_64 = [
                        0,
                        0
                    ];
                    if (!ops.serialize) caml_invalid_argument("output_value: abstract value (Custom)");
                    if (ops.fixed_length === undefined) {
                        writer.write(8, 0x18);
                        for(var i = 0; i < name.length; i++)writer.write(8, name.charCodeAt(i));
                        writer.write(8, 0);
                        var header_pos = writer.pos();
                        for(var i = 0; i < 12; i++)writer.write(8, 0);
                        ops.serialize(writer, v, sz_32_64);
                        writer.write_at(header_pos, 32, sz_32_64[0]);
                        writer.write_at(header_pos + 4, 32, 0);
                        writer.write_at(header_pos + 8, 32, sz_32_64[1]);
                    } else {
                        writer.write(8, 0x19);
                        for(var i = 0; i < name.length; i++)writer.write(8, name.charCodeAt(i));
                        writer.write(8, 0);
                        var old_pos = writer.pos();
                        ops.serialize(writer, v, sz_32_64);
                        if (ops.fixed_length !== writer.pos() - old_pos) caml_failwith("output_value: incorrect fixed sizes specified by " + name);
                    }
                    writer.size_32 += 2 + (sz_32_64[0] + 3 >> 2);
                    writer.size_64 += 2 + (sz_32_64[1] + 7 >> 3);
                } else if (Array.isArray(v) && v[0] === (v[0] | 0)) {
                    if (v[0] === 251) caml_failwith("output_value: abstract value (Abstract)");
                    if (caml_is_continuation_tag(v[0])) caml_invalid_argument("output_value: continuation value");
                    if (v.length > 1 && memo(v)) return;
                    if (v[0] < 16 && v.length - 1 < 8) writer.write(8, 0x80 + v[0] + (v.length - 1 << 4));
                    else writer.write_code(32, 0x08, v.length - 1 << 10 | v[0]);
                    writer.size_32 += v.length;
                    writer.size_64 += v.length;
                    if (v.length > 1) stack.push(v, 1);
                } else if (caml_is_ml_bytes(v)) {
                    if (!caml_is_ml_bytes(caml_string_of_jsbytes(""))) caml_failwith("output_value: [Bytes.t] cannot safely be marshaled with [--enable use-js-string]");
                    if (memo(v)) return;
                    var len = caml_ml_bytes_length(v);
                    if (len < 0x20) writer.write(8, 0x20 + len);
                    else if (len < 0x100) writer.write_code(8, 0x09, len);
                    else writer.write_code(32, 0x0a, len);
                    for(var i = 0; i < len; i++)writer.write(8, caml_bytes_unsafe_get(v, i));
                    writer.size_32 += 1 + ((len + 4) / 4 | 0);
                    writer.size_64 += 1 + ((len + 8) / 8 | 0);
                } else if (caml_is_ml_string(v)) {
                    if (memo(v)) return;
                    var len = caml_ml_string_length(v);
                    if (len < 0x20) writer.write(8, 0x20 + len);
                    else if (len < 0x100) writer.write_code(8, 0x09, len);
                    else writer.write_code(32, 0x0a, len);
                    for(var i = 0; i < len; i++)writer.write(8, caml_string_unsafe_get(v, i));
                    writer.size_32 += 1 + ((len + 4) / 4 | 0);
                    writer.size_64 += 1 + ((len + 8) / 8 | 0);
                } else if (v !== (v | 0)) {
                    var type_of_v = typeof v;
                    if (type_of_v !== "number") caml_failwith("output_value: abstract value (" + type_of_v + ")");
                    if (memo(v)) return;
                    var t = caml_int64_to_bytes(caml_int64_bits_of_float(v));
                    writer.write(8, 0x0c);
                    for(var i = 0; i < 8; i++)writer.write(8, t[7 - i]);
                    writer.size_32 += 3;
                    writer.size_64 += 2;
                } else if (v >= 0 && v < 0x40) writer.write(8, 0x40 + v);
                else if (v >= -128 && v < 128) writer.write_code(8, 0x00, v);
                else if (v >= -32768 && v < 32768) writer.write_code(16, 0x01, v);
                else writer.write_code(32, 0x02, v);
            }
            extern_rec(v);
            while(stack.length > 0){
                var i = stack.pop(), v = stack.pop();
                if (i + 1 < v.length) stack.push(v, i + 1);
                extern_rec(v[i]);
            }
            if (intern_obj_table) writer.obj_counter = intern_obj_table.objs.length;
            writer.finalize();
            return new Uint8Array(writer.chunk);
        };
    }();
    function caml_output_value_to_string(v, flags) {
        return caml_string_of_uint8_array(caml_output_val(v, flags));
    }
    function caml_output_value(chanid, v, flags) {
        var s = caml_output_value_to_string(v, flags);
        caml_ml_output(chanid, s, 0, caml_ml_string_length(s));
        return 0;
    }
    function caml_output_value_to_buffer(s, ofs, len, v, flags) {
        var t = caml_output_val(v, flags);
        if (t.length > len) caml_failwith("Marshal.to_buffer: buffer overflow");
        caml_blit_bytes(caml_bytes_of_uint8_array(t), 0, s, ofs, t.length);
        return 0;
    }
    function caml_output_value_to_bytes(v, flags) {
        return caml_bytes_of_uint8_array(caml_output_val(v, flags));
    }
    var caml_parser_trace = 0;
    function caml_parse_engine(tables, env, cmd, arg) {
        var ERRCODE = 256, loop = 6, testshift = 7, shift = 8, shift_recover = 9, reduce = 10, READ_TOKEN = 0, RAISE_PARSE_ERROR = 1, GROW_STACKS_1 = 2, GROW_STACKS_2 = 3, COMPUTE_SEMANTIC_ACTION = 4, CALL_ERROR_FUNCTION = 5, env_s_stack = 1, env_v_stack = 2, env_symb_start_stack = 3, env_symb_end_stack = 4, env_stacksize = 5, env_stackbase = 6, env_curr_char = 7, env_lval = 8, env_symb_start = 9, env_symb_end = 10, env_asp = 11, env_rule_len = 12, env_rule_number = 13, env_sp = 14, env_state = 15, env_errflag = 16, tbl_transl_const = 2, tbl_transl_block = 3, tbl_lhs = 4, tbl_len = 5, tbl_defred = 6, tbl_dgoto = 7, tbl_sindex = 8, tbl_rindex = 9, tbl_gindex = 10, tbl_tablesize = 11, tbl_table = 12, tbl_check = 13, tbl_names_const = 15, tbl_names_block = 16;
        function log(x) {
            var s = caml_string_of_jsbytes(x + "\n");
            caml_ml_output(caml_sys_fds[2].chanid, s, 0, caml_ml_string_length(s));
        }
        function token_name(names, number) {
            var str = caml_jsstring_of_string(names);
            if (str[0] === "\x00") return "<unknown token>";
            return str.split("\x00")[number];
        }
        function print_token(state, tok) {
            var token, kind;
            if (Array.isArray(tok)) {
                token = token_name(tables[tbl_names_block], tok[0]);
                if (typeof tok[1] === "number") kind = "" + tok[1];
                else if (typeof tok[1] === "string") kind = tok[1];
                else if (tok[1] instanceof MlBytes) kind = caml_jsbytes_of_string(tok[1]);
                else kind = "_";
                log("State " + state + ": read token " + token + "(" + kind + ")");
            } else {
                token = token_name(tables[tbl_names_const], tok);
                log("State " + state + ": read token " + token);
            }
        }
        if (!tables.dgoto) {
            tables.defred = caml_lex_array(tables[tbl_defred]);
            tables.sindex = caml_lex_array(tables[tbl_sindex]);
            tables.check = caml_lex_array(tables[tbl_check]);
            tables.rindex = caml_lex_array(tables[tbl_rindex]);
            tables.table = caml_lex_array(tables[tbl_table]);
            tables.len = caml_lex_array(tables[tbl_len]);
            tables.lhs = caml_lex_array(tables[tbl_lhs]);
            tables.gindex = caml_lex_array(tables[tbl_gindex]);
            tables.dgoto = caml_lex_array(tables[tbl_dgoto]);
        }
        var res = 0, n, n1, n2, state1, sp = env[env_sp], state = env[env_state], errflag = env[env_errflag];
        the_loop: for(;;)switch(cmd){
            case 0:
                state = 0;
                errflag = 0;
            case 6:
                n = tables.defred[state];
                if (n !== 0) {
                    cmd = reduce;
                    continue the_loop;
                }
                if (env[env_curr_char] >= 0) {
                    cmd = testshift;
                    continue the_loop;
                }
                res = READ_TOKEN;
                break the_loop;
            case 1:
                if (Array.isArray(arg)) {
                    env[env_curr_char] = tables[tbl_transl_block][arg[0] + 1];
                    env[env_lval] = arg[1];
                } else {
                    env[env_curr_char] = tables[tbl_transl_const][arg + 1];
                    env[env_lval] = 0;
                }
                if (caml_parser_trace) print_token(state, arg);
            case 7:
                n1 = tables.sindex[state];
                n2 = n1 + env[env_curr_char];
                if (n1 !== 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] === env[env_curr_char]) {
                    cmd = shift;
                    continue the_loop;
                }
                n1 = tables.rindex[state];
                n2 = n1 + env[env_curr_char];
                if (n1 !== 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] === env[env_curr_char]) {
                    n = tables.table[n2];
                    cmd = reduce;
                    continue the_loop;
                }
                if (errflag <= 0) {
                    res = CALL_ERROR_FUNCTION;
                    break the_loop;
                }
            case 5:
                if (errflag < 3) {
                    errflag = 3;
                    for(;;){
                        state1 = env[env_s_stack][sp + 1];
                        n1 = tables.sindex[state1];
                        n2 = n1 + ERRCODE;
                        if (n1 !== 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] === ERRCODE) {
                            if (caml_parser_trace) log("Recovering in state " + state1);
                            cmd = shift_recover;
                            continue the_loop;
                        } else {
                            if (caml_parser_trace) log("Discarding state " + state1);
                            if (sp <= env[env_stackbase]) {
                                if (caml_parser_trace) log("No more states to discard");
                                return RAISE_PARSE_ERROR;
                            }
                            sp--;
                        }
                    }
                } else {
                    if (env[env_curr_char] === 0) return RAISE_PARSE_ERROR;
                    if (caml_parser_trace) log("Discarding last token read");
                    env[env_curr_char] = -1;
                    cmd = loop;
                    continue the_loop;
                }
            case 8:
                env[env_curr_char] = -1;
                if (errflag > 0) errflag--;
            case 9:
                if (caml_parser_trace) log("State " + state + ": shift to state " + tables.table[n2]);
                state = tables.table[n2];
                sp++;
                if (sp >= env[env_stacksize]) {
                    res = GROW_STACKS_1;
                    break the_loop;
                }
            case 2:
                env[env_s_stack][sp + 1] = state;
                env[env_v_stack][sp + 1] = env[env_lval];
                env[env_symb_start_stack][sp + 1] = env[env_symb_start];
                env[env_symb_end_stack][sp + 1] = env[env_symb_end];
                cmd = loop;
                continue the_loop;
            case 10:
                if (caml_parser_trace) log("State " + state + ": reduce by rule " + n);
                var m = tables.len[n];
                env[env_asp] = sp;
                env[env_rule_number] = n;
                env[env_rule_len] = m;
                sp = sp - m + 1;
                m = tables.lhs[n];
                state1 = env[env_s_stack][sp];
                n1 = tables.gindex[m];
                n2 = n1 + state1;
                if (n1 !== 0 && n2 >= 0 && n2 <= tables[tbl_tablesize] && tables.check[n2] === state1) state = tables.table[n2];
                else state = tables.dgoto[m];
                if (sp >= env[env_stacksize]) {
                    res = GROW_STACKS_2;
                    break the_loop;
                }
            case 3:
                res = COMPUTE_SEMANTIC_ACTION;
                break the_loop;
            case 4:
                env[env_s_stack][sp + 1] = state;
                env[env_v_stack][sp + 1] = arg;
                var asp = env[env_asp];
                env[env_symb_end_stack][sp + 1] = env[env_symb_end_stack][asp + 1];
                if (sp > asp) env[env_symb_start_stack][sp + 1] = env[env_symb_end_stack][asp + 1];
                cmd = loop;
                continue the_loop;
            default:
                return RAISE_PARSE_ERROR;
        }
        env[env_sp] = sp;
        env[env_state] = state;
        env[env_errflag] = errflag;
        return res;
    }
    function caml_process_pending_actions_with_root(extra_root) {
        return 0;
    }
    function caml_pure_js_expr(s) {
        console.error("caml_pure_js_expr: fallback to runtime evaluation\n");
        return eval(caml_jsstring_of_string(s));
    }
    function caml_raise_not_found() {
        caml_raise_constant(caml_global_data.Not_found);
    }
    function caml_raw_backtrace_length() {
        return 0;
    }
    function caml_raw_backtrace_next_slot() {
        return 0;
    }
    function caml_raw_backtrace_slot() {
        caml_invalid_argument("Printexc.get_raw_backtrace_slot: index out of bounds");
    }
    function caml_read_file_content(name) {
        var name = typeof name === "string" ? caml_string_of_jsstring(name) : name, root = resolve_fs_device(name);
        if (root.device.exists(root.rest)) {
            var file = root.device.open(root.rest, {
                rdonly: 1
            }), len = file.length(), buf = new Uint8Array(len);
            file.read(buf, 0, len);
            return caml_string_of_uint8_array(buf);
        }
        caml_raise_no_such_file(caml_jsstring_of_string(name));
    }
    function caml_recommended_domain_count(unit) {
        return 1;
    }
    function caml_record_backtrace(b) {
        caml_record_backtrace_runtime_flag = b;
        return 0;
    }
    var jsoo_toplevel_reloc = undefined;
    function caml_register_global(n, v, name_opt) {
        if (name_opt) {
            var name = name_opt;
            if (jsoo_toplevel_reloc) n = caml_callback(jsoo_toplevel_reloc, [
                name
            ]);
            else if (caml_global_data.symbols) {
                if (!caml_global_data.symidx) caml_global_data.symidx = caml_build_symbols(caml_global_data.symbols);
                var nid = caml_global_data.symidx[name];
                if (nid >= 0) n = nid;
                else {
                    var n = caml_global_data.symidx.next_idx++;
                    caml_global_data.symidx[name] = n;
                }
            }
        }
        caml_global_data[n + 1] = v;
        if (name_opt) caml_global_data[name_opt] = v;
    }
    function caml_register_named_value(nm, v) {
        caml_named_values[caml_jsbytes_of_string(nm)] = v;
        return 0;
    }
    function caml_restore_raw_backtrace(exn, bt) {
        return 0;
    }
    function caml_round_float(x) {
        if (x >= 0) {
            var y = Math.floor(x);
            return x - y >= 0.5 ? y + 1 : y;
        } else {
            var y = Math.ceil(x);
            return y - x >= 0.5 ? y - 1 : y;
        }
    }
    function caml_runtime_events_create_cursor(target) {
        return {};
    }
    function caml_runtime_events_free_cursor(cursor) {
        return 0;
    }
    function caml_runtime_events_read_poll(cursor, callbacks, num) {
        return 0;
    }
    function caml_runtime_events_user_register(event_name, event_tag, event_type) {
        caml_custom_event_index += 1;
        return [
            0,
            caml_custom_event_index,
            event_name,
            event_type,
            event_tag
        ];
    }
    function caml_runtime_events_user_resolve() {
        return 0;
    }
    function caml_runtime_events_user_write(event, event_content) {
        return 0;
    }
    function caml_runtime_parameters(_unit) {
        return caml_string_of_jsbytes("");
    }
    function caml_runtime_variant(_unit) {
        return caml_string_of_jsbytes("");
    }
    function caml_set_parser_trace(bool) {
        var oldflag = caml_parser_trace;
        caml_parser_trace = bool;
        return oldflag;
    }
    function caml_set_static_env(k, v) {
        jsoo_static_env[k] = v;
        return 0;
    }
    function caml_signbit_float(x) {
        if (x === 0) x = 1 / x;
        return x < 0 ? 1 : 0;
    }
    function caml_sinh_float(x) {
        return Math.sinh(x);
    }
    function caml_sse2_float64_max_bytecode(x, y) {
        return x > y ? x : y;
    }
    function caml_sse2_float64_min_bytecode(x, y) {
        return x < y ? x : y;
    }
    function caml_string_bound_error() {
        caml_invalid_argument("index out of bounds");
    }
    function caml_string_concat(a, b) {
        return a + b;
    }
    function caml_string_equal(s1, s2) {
        if (s1 === s2) return 1;
        return 0;
    }
    function caml_string_get(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s)) caml_string_bound_error();
        return caml_string_unsafe_get(s, i);
    }
    function caml_string_get16(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 1) caml_string_bound_error();
        var b1 = caml_string_unsafe_get(s, i), b2 = caml_string_unsafe_get(s, i + 1);
        return b2 << 8 | b1;
    }
    function caml_string_get32(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 3) caml_string_bound_error();
        var b1 = caml_string_unsafe_get(s, i), b2 = caml_string_unsafe_get(s, i + 1), b3 = caml_string_unsafe_get(s, i + 2), b4 = caml_string_unsafe_get(s, i + 3);
        return b4 << 24 | b3 << 16 | b2 << 8 | b1;
    }
    function caml_string_get64(s, i) {
        if (i >>> 0 >= caml_ml_string_length(s) - 7) caml_string_bound_error();
        var a = new Array(8);
        for(var j = 0; j < 8; j++)a[7 - j] = caml_string_unsafe_get(s, i + j);
        return caml_int64_of_bytes(a);
    }
    function caml_string_lessequal(s1, s2) {
        return s1 <= s2 ? 1 : 0;
    }
    function caml_string_greaterequal(s1, s2) {
        return caml_string_lessequal(s2, s1);
    }
    function caml_string_lessthan(s1, s2) {
        return s1 < s2 ? 1 : 0;
    }
    function caml_string_greaterthan(s1, s2) {
        return caml_string_lessthan(s2, s1);
    }
    function caml_string_hash(h, v) {
        var h = caml_hash_mix_string(h, v), h = caml_hash_mix_final(h);
        return h & 0x3fffffff;
    }
    function caml_string_notequal(s1, s2) {
        return 1 - caml_string_equal(s1, s2);
    }
    function caml_subarray_to_jsbytes(a, i, len) {
        var f = String.fromCharCode;
        if (i === 0 && len <= 4096 && len === a.length) return f.apply(null, a);
        var s = "";
        for(; 0 < len; i += 1024, len -= 1024)s += f.apply(null, a.slice(i, i + Math.min(len, 1024)));
        return s;
    }
    function caml_string_of_array(a) {
        return caml_string_of_jsbytes(caml_subarray_to_jsbytes(a, 0, a.length));
    }
    function caml_string_set(s, i, c) {
        caml_failwith("caml_string_set");
    }
    function caml_sys_argv(a) {
        return caml_argv;
    }
    function caml_sys_chdir(dir) {
        var root = resolve_fs_device(dir);
        if (root.device.is_dir(root.rest)) {
            if (root.rest) caml_current_dir = caml_trailing_slash(root.path + root.rest);
            else caml_current_dir = root.path;
            return 0;
        } else if (root.device.exists(root.rest)) caml_raise_sys_error("ENOTDIR: not a directory, chdir '" + caml_jsstring_of_string(dir) + "'");
        else caml_raise_no_such_file(caml_jsstring_of_string(dir));
    }
    function caml_sys_const_backend_type() {
        return [
            0,
            caml_string_of_jsbytes("js_of_ocaml")
        ];
    }
    function caml_sys_const_big_endian() {
        return 0;
    }
    function caml_sys_const_int_size() {
        return 32;
    }
    function caml_sys_const_max_wosize() {
        return 536870911;
    }
    function caml_sys_const_naked_pointers_checked(_unit) {
        return 0;
    }
    var os_type = globalThis1.process && globalThis1.process.platform && globalThis1.process.platform === "win32" ? "Win32" : "Unix";
    function caml_sys_const_ostype_cygwin() {
        return os_type === "Cygwin" ? 1 : 0;
    }
    function caml_sys_const_ostype_unix() {
        return os_type === "Unix" ? 1 : 0;
    }
    function caml_sys_const_ostype_win32() {
        return os_type === "Win32" ? 1 : 0;
    }
    function caml_sys_const_word_size() {
        return 32;
    }
    function caml_sys_executable_name(a) {
        return caml_executable_name;
    }
    function caml_sys_exit(code) {
        if (globalThis1.quit) globalThis1.quit(code);
        if (globalThis1.process && globalThis1.process.exit) globalThis1.process.exit(code);
        caml_invalid_argument("Function 'exit' not implemented");
    }
    function caml_sys_file_exists(name) {
        var root = resolve_fs_device(name);
        return root.device.exists(root.rest);
    }
    function caml_sys_get_argv(a) {
        return [
            0,
            caml_argv[1],
            caml_argv
        ];
    }
    function caml_sys_get_config() {
        return [
            0,
            caml_string_of_jsbytes(os_type),
            32,
            0
        ];
    }
    function caml_sys_getcwd() {
        return caml_string_of_jsstring(caml_current_dir);
    }
    function caml_sys_getenv(name) {
        var r = jsoo_sys_getenv(caml_jsstring_of_string(name));
        if (r === undefined) caml_raise_not_found();
        return caml_string_of_jsstring(r);
    }
    function caml_sys_is_directory(name) {
        var root = resolve_fs_device(name), a = root.device.is_dir(root.rest);
        return a ? 1 : 0;
    }
    function caml_sys_is_regular_file(name) {
        var root = resolve_fs_device(name);
        return root.device.isFile(root.rest);
    }
    function caml_sys_isatty(_chan) {
        return 0;
    }
    function caml_sys_mkdir(name, perm) {
        var root = resolve_fs_device(name);
        root.device.mkdir(root.rest, perm);
        return 0;
    }
    function caml_sys_modify_argv(arg) {
        caml_argv = arg;
        return 0;
    }
    function caml_sys_random_seed() {
        if (globalThis1.crypto) {
            if (globalThis1.crypto.getRandomValues) {
                var a = globalThis1.crypto.getRandomValues(new Int32Array(4));
                return [
                    0,
                    a[0],
                    a[1],
                    a[2],
                    a[3]
                ];
            } else if (globalThis1.crypto.randomBytes) {
                var a = new Int32Array(globalThis1.crypto.randomBytes(16).buffer);
                return [
                    0,
                    a[0],
                    a[1],
                    a[2],
                    a[3]
                ];
            }
        }
        var now = new Date().getTime(), x = now ^ 0xffffffff * Math.random();
        return [
            0,
            x
        ];
    }
    function caml_sys_read_directory(name) {
        var root = resolve_fs_device(name), a = root.device.readdir(root.rest), l = new Array(a.length + 1);
        l[0] = 0;
        for(var i = 0; i < a.length; i++)l[i + 1] = caml_string_of_jsstring(a[i]);
        return l;
    }
    function caml_sys_remove(name) {
        var root = resolve_fs_device(name);
        return root.device.unlink(root.rest);
    }
    function caml_sys_rename(o, n) {
        var o_root = resolve_fs_device(o), n_root = resolve_fs_device(n);
        if (o_root.device !== n_root.device) caml_failwith("caml_sys_rename: cannot move file between two filesystem");
        if (!o_root.device.rename) caml_failwith("caml_sys_rename: no implemented");
        o_root.device.rename(o_root.rest, n_root.rest);
    }
    function caml_sys_rmdir(name) {
        var root = resolve_fs_device(name);
        root.device.rmdir(root.rest);
        return 0;
    }
    function caml_sys_system_command(cmd) {
        var cmd = caml_jsstring_of_string(cmd);
        var child_process = (parcelRequire("48K42"));
        if (child_process && child_process.execSync) try {
            child_process.execSync(cmd, {
                stdio: "inherit"
            });
            return 0;
        } catch (e) {
            return 1;
        }
    }
    var caml_initial_time = new Date().getTime() * 0.001;
    function caml_sys_time() {
        var now = new Date().getTime();
        return now * 0.001 - caml_initial_time;
    }
    function caml_sys_time_include_children(b) {
        return caml_sys_time();
    }
    function caml_sys_unsafe_getenv(name) {
        return caml_sys_getenv(name);
    }
    function caml_tanh_float(x) {
        return Math.tanh(x);
    }
    function caml_to_js_string(s) {
        return caml_jsstring_of_string(s);
    }
    function caml_trampoline(res) {
        var c = 1;
        while(res && res.joo_tramp){
            res = res.joo_tramp.apply(null, res.joo_args);
            c++;
        }
        return res;
    }
    function caml_trampoline_return(f, args, direct) {
        return {
            joo_tramp: f,
            joo_args: args,
            joo_direct: direct
        };
    }
    function caml_trunc_float(x) {
        return Math.trunc(x);
    }
    function caml_uniform_array_append(a1, a2) {
        return caml_array_append(a1, a2);
    }
    function caml_uniform_array_blit(a1, i1, a2, i2, len) {
        return caml_array_blit(a1, i1, a2, i2, len);
    }
    function caml_uniform_array_fill(array, ofs, len, v) {
        return caml_array_fill(array, ofs, len, v);
    }
    function caml_uniform_array_make(len, init) {
        return caml_array_make(len, init);
    }
    function caml_uniform_array_sub(a, i, len) {
        return caml_array_sub(a, i, len);
    }
    function caml_unix_cleanup() {}
    function caml_unix_lookup_file(fd, cmd) {
        var fd_desc = caml_sys_fds[fd];
        if (fd_desc === undefined) caml_raise_system_error(1, "EBADF", cmd);
        return fd_desc.file;
    }
    function caml_unix_close(fd) {
        var file = caml_unix_lookup_file(fd, "close");
        file.close(1);
        return 0;
    }
    function caml_unix_closedir(dir_handle) {
        try {
            dir_handle.pointer.closeSync();
        } catch (e) {
            caml_raise_system_error(1, "EBADF", "closedir");
        }
    }
    function caml_unix_filedescr_of_fd(x) {
        return x;
    }
    function caml_unix_findclose(dir_handle) {
        return caml_unix_closedir(dir_handle);
    }
    function caml_unix_opendir(path) {
        var root = resolve_fs_device(path);
        if (!root.device.opendir) caml_failwith("caml_unix_opendir: not implemented");
        var dir_handle = root.device.opendir(root.rest, true);
        return {
            pointer: dir_handle,
            path: path
        };
    }
    function caml_unix_readdir(dir_handle) {
        var entry;
        try {
            entry = dir_handle.pointer.readSync();
        } catch (e) {
            caml_raise_system_error(1, "EBADF", "readdir");
        }
        if (entry === null) caml_raise_end_of_file();
        else return caml_string_of_jsstring(entry.name);
    }
    function caml_unix_findfirst(path) {
        var path_js = caml_jsstring_of_string(path);
        path_js = path_js.replace(/(^|[\\/])\*\.\*$/, "");
        path = caml_string_of_jsstring(path_js);
        var dir_handle = caml_unix_opendir(path), first_entry = caml_unix_readdir(dir_handle);
        return [
            0,
            first_entry,
            dir_handle
        ];
    }
    function caml_unix_findnext(dir_handle) {
        return caml_unix_readdir(dir_handle);
    }
    function caml_unix_fstat(fd) {
        var file = caml_unix_lookup_file(fd, "fstat");
        if (!file.stat) caml_failwith("caml_unix_fstat: not implemented");
        return file.stat(false);
    }
    function caml_unix_fstat_64(fd) {
        var file = caml_unix_lookup_file(fd, "fstat");
        if (!file.stat) caml_failwith("caml_unix_fstat64: not implemented");
        return file.stat(true);
    }
    function caml_unix_ftruncate(fd, len) {
        var file = caml_unix_lookup_file(fd, "ftruncate");
        if (!file.truncate) caml_failwith("caml_unix_ftruncate: not implemented");
        file.truncate(len, 1);
        return 0;
    }
    function caml_unix_ftruncate_64(fd, len) {
        var file = caml_unix_lookup_file(fd, "ftruncate");
        if (!file.truncate) caml_failwith("caml_unix_ftruncate_64: not implemented");
        file.truncate(caml_int64_to_float(len), 1);
        return 0;
    }
    function caml_unix_getpwuid(unit) {
        caml_raise_not_found();
    }
    function caml_unix_gettimeofday() {
        return new Date().getTime() / 1000;
    }
    function caml_unix_getuid(unit) {
        if (globalThis1.process && globalThis1.process.getuid) return globalThis1.process.getuid();
        return 1;
    }
    function caml_unix_gmtime(t) {
        var d = new Date(t * 1000), d_num = d.getTime(), januaryfirst = new Date(Date.UTC(d.getUTCFullYear(), 0, 1)).getTime(), doy = Math.floor((d_num - januaryfirst) / 86400000);
        return [
            0,
            d.getUTCSeconds(),
            d.getUTCMinutes(),
            d.getUTCHours(),
            d.getUTCDate(),
            d.getUTCMonth(),
            d.getUTCFullYear() - 1900,
            d.getUTCDay(),
            doy,
            0
        ];
    }
    function caml_unix_has_symlink(unit) {
        return fs_node_supported() ? 1 : 0;
    }
    function caml_unix_inchannel_of_filedescr(fd) {
        var file = caml_unix_lookup_file(fd, "out_channel_of_descr");
        file.check_stream_semantics("in_channel_of_descr");
        return caml_ml_open_descriptor_in(fd);
    }
    function caml_unix_inet_addr_of_string() {
        return 0;
    }
    function caml_unix_isatty(fd) {
        if (fs_node_supported()) {
            var tty = (parcelRequire("85dKZ"));
            return tty.isatty(caml_unix_lookup_file(fd).fd) ? 1 : 0;
        } else return 0;
    }
    function caml_unix_localtime(t) {
        var d = new Date(t * 1000), d_num = d.getTime(), januaryfirst = new Date(d.getFullYear(), 0, 1).getTime(), doy = Math.floor((d_num - januaryfirst) / 86400000), jan = new Date(d.getFullYear(), 0, 1), jul = new Date(d.getFullYear(), 6, 1), stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
        return [
            0,
            d.getSeconds(),
            d.getMinutes(),
            d.getHours(),
            d.getDate(),
            d.getMonth(),
            d.getFullYear() - 1900,
            d.getDay(),
            doy,
            d.getTimezoneOffset() < stdTimezoneOffset | 0
        ];
    }
    function caml_unix_lseek(fd, len, whence) {
        var file = caml_unix_lookup_file(fd, "lseek");
        return file.seek(len, whence, 1);
    }
    function caml_unix_lseek_64(fd, len, whence) {
        var file = caml_unix_lookup_file(fd, "lseek");
        return file.seek(caml_int64_to_float(len), whence, 1);
    }
    function caml_unix_lstat(name) {
        var root = resolve_fs_device(name);
        if (!root.device.lstat) caml_failwith("caml_unix_lstat: not implemented");
        return root.device.lstat(root.rest, false, true);
    }
    function caml_unix_lstat_64(name) {
        var root = resolve_fs_device(name);
        if (!root.device.lstat) caml_failwith("caml_unix_lstat_64: not implemented");
        return root.device.lstat(root.rest, true, true);
    }
    function caml_unix_mkdir(name, perm) {
        var root = resolve_fs_device(name);
        if (!root.device.mkdir) caml_failwith("caml_unix_mkdir: not implemented");
        return root.device.mkdir(root.rest, perm, true);
    }
    function caml_unix_mktime(tm) {
        var d = new Date(tm[6] + 1900, tm[5], tm[4], tm[3], tm[2], tm[1]).getTime(), t = Math.floor(d / 1000), tm2 = caml_unix_localtime(t);
        return [
            0,
            t,
            tm2
        ];
    }
    function caml_unix_open(name, flags, perms) {
        var f = {};
        while(flags){
            switch(flags[1]){
                case 0:
                    f.rdonly = 1;
                    break;
                case 1:
                    f.wronly = 1;
                    break;
                case 2:
                    f.rdwr = 1;
                    break;
                case 3:
                    f.nonblock = 1;
                    break;
                case 4:
                    f.append = 1;
                    break;
                case 5:
                    f.create = 1;
                    break;
                case 6:
                    f.truncate = 1;
                    break;
                case 7:
                    f.excl = 1;
                    break;
                case 8:
                    f.noctty = 1;
                    break;
                case 9:
                    f.dsync = 1;
                    break;
                case 10:
                    f.sync = 1;
                    break;
            }
            flags = flags[2];
        }
        var root = resolve_fs_device(name), file = root.device.open(root.rest, f, perms, true), idx = caml_sys_fds.length, chanid = new MlChanid(idx);
        caml_sys_fds[idx] = {
            file: file,
            chanid: chanid
        };
        return idx | 0;
    }
    function caml_unix_outchannel_of_filedescr(fd) {
        var file = caml_unix_lookup_file(fd, "out_channel_of_descr");
        file.check_stream_semantics("out_channel_of_descr");
        return caml_ml_open_descriptor_out(fd);
    }
    function caml_unix_read(fd, buf, pos, len) {
        var file = caml_unix_lookup_file(fd, "read");
        return file.read(caml_uint8_array_of_bytes(buf), pos, len, 1);
    }
    function caml_unix_read_bigarray(fd, buf, pos, len) {
        var a = caml_ba_to_typed_array(buf), file = caml_unix_lookup_file(fd, "read");
        return file.read(a, pos, len, 1);
    }
    function caml_unix_readlink(name) {
        var root = resolve_fs_device(name);
        if (!root.device.readlink) caml_failwith("caml_unix_readlink: not implemented");
        return root.device.readlink(root.rest, true);
    }
    function caml_unix_rename(o, n) {
        var o_root = resolve_fs_device(o), n_root = resolve_fs_device(n);
        if (o_root.device !== n_root.device) caml_raise_system_error(1, "EXDEV", "rename");
        if (!o_root.device.rename) caml_failwith("caml_sys_rename: no implemented");
        o_root.device.rename(o_root.rest, n_root.rest, true);
    }
    function caml_unix_rewinddir(dir_handle) {
        caml_unix_closedir(dir_handle);
        var new_dir_handle = caml_unix_opendir(dir_handle.path);
        dir_handle.pointer = new_dir_handle.pointer;
        return 0;
    }
    function caml_unix_rmdir(name) {
        var root = resolve_fs_device(name);
        if (!root.device.rmdir) caml_failwith("caml_unix_rmdir: not implemented");
        return root.device.rmdir(root.rest, true);
    }
    function caml_unix_startup() {}
    function caml_unix_stat(name) {
        var root = resolve_fs_device(name);
        if (!root.device.stat) caml_failwith("caml_unix_stat: not implemented");
        return root.device.stat(root.rest, false, true);
    }
    function caml_unix_stat_64(name) {
        var root = resolve_fs_device(name);
        if (!root.device.stat) caml_failwith("caml_unix_stat_64: not implemented");
        return root.device.stat(root.rest, true, true);
    }
    function caml_unix_symlink(to_dir, src, dst) {
        var dst_root = resolve_fs_device(dst);
        if (!dst_root.device.symlink) caml_failwith("caml_unix_symlink: not implemented");
        return dst_root.device.symlink(to_dir, caml_jsstring_of_string(src), dst_root.rest, true);
    }
    function caml_unix_time() {
        return Math.floor(caml_unix_gettimeofday());
    }
    function caml_unix_truncate(name, len) {
        var root = resolve_fs_device(name);
        if (!root.device.truncate) caml_failwith("caml_unix_truncate: not implemented");
        root.device.truncate(root.rest, len, true);
        return 0;
    }
    function caml_unix_truncate_64(name, len) {
        var root = resolve_fs_device(name);
        if (!root.device.truncate) caml_failwith("caml_unix_truncate_64: not implemented");
        root.device.truncate(root.rest, caml_int64_to_float(len), true);
        return 0;
    }
    function caml_unix_unlink(name) {
        var root = resolve_fs_device(name);
        if (!root.device.unlink) caml_failwith("caml_unix_unlink: not implemented");
        root.device.unlink(root.rest, true);
        return 0;
    }
    function caml_unix_utimes(name, atime, mtime) {
        var root = resolve_fs_device(name);
        if (!root.device.utimes) caml_failwith("caml_unix_utimes: not implemented");
        root.device.utimes(root.rest, atime, mtime, true);
        return 0;
    }
    function caml_unix_write(fd, buf, pos, len) {
        var file = caml_unix_lookup_file(fd, "write"), a = caml_uint8_array_of_bytes(buf), written = 0;
        while(len > 0){
            var n = file.write(a, pos, len, 1);
            written += n;
            pos += n;
            len -= n;
        }
        return written;
    }
    function caml_unix_write_bigarray(fd, buf, pos, len) {
        var a = caml_ba_to_typed_array(buf), file = caml_unix_lookup_file(fd, "write"), written = 0;
        while(len > 0){
            var n = file.write(a, pos, len, 1);
            written += n;
            pos += n;
            len -= n;
        }
        return written;
    }
    function caml_unmount(name) {
        var path = caml_make_path(name), name = caml_trailing_slash(path.join("/")), idx = -1;
        for(var i = 0; i < jsoo_mount_point.length; i++)if (jsoo_mount_point[i].path === name) idx = i;
        if (idx > -1) jsoo_mount_point.splice(idx, 1);
        return 0;
    }
    function caml_update_dummy(x, y) {
        if (y.fun) {
            x.fun = y.fun;
            return 0;
        }
        if (typeof y === "function") {
            x.fun = y;
            return 0;
        }
        var i = y.length;
        while(i--)x[i] = y[i];
        return 0;
    }
    function caml_weak_set(x, i, v) {
        if (v === 0) caml_ephe_unset_key(x, i);
        else caml_ephe_set_key(x, i, v[1]);
        return 0;
    }
    function caml_wrap_exception(e) {
        if (Array.isArray(e)) return e;
        var exn;
        if (globalThis1.RangeError && e instanceof globalThis1.RangeError && e.message && e.message.match(/maximum call stack/i)) exn = caml_global_data.Stack_overflow;
        else if (globalThis1.InternalError && e instanceof globalThis1.InternalError && e.message && e.message.match(/too much recursion/i)) exn = caml_global_data.Stack_overflow;
        else if (e instanceof globalThis1.Error && caml_named_value("jsError")) exn = [
            0,
            caml_named_value("jsError"),
            e
        ];
        else exn = [
            0,
            caml_global_data.Failure,
            caml_string_of_jsstring(String(e))
        ];
        if (e instanceof globalThis1.Error) exn.js_error = e;
        return exn;
    }
    function caml_xdg_defaults(_unit) {
        return 0;
    }
    function caml_xmlhttprequest_create(unit) {
        if (typeof globalThis1.XMLHttpRequest !== "undefined") try {
            return new globalThis1.XMLHttpRequest();
        } catch (e) {}
        caml_failwith("Cannot create a XMLHttpRequest");
    }
    function caml_zstd_initialize(unit) {
        caml_decompress_input = zstd_decompress;
        return 1;
    }
    function compare_digits_nat(nat1, ofs1, nat2, ofs2) {
        if (nat1.data[ofs1] > nat2.data[ofs2]) return 1;
        if (nat1.data[ofs1] < nat2.data[ofs2]) return -1;
        return 0;
    }
    function compare_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        var a = num_digits_nat(nat1, ofs1, len1), b = num_digits_nat(nat2, ofs2, len2);
        if (a > b) return 1;
        if (a < b) return -1;
        for(var i = len1 - 1; i >= 0; i--){
            if (nat1.data[ofs1 + i] >>> 0 > nat2.data[ofs2 + i] >>> 0) return 1;
            if (nat1.data[ofs1 + i] >>> 0 < nat2.data[ofs2 + i] >>> 0) return -1;
        }
        return 0;
    }
    function complement_nat(nat, ofs, len) {
        for(var i = 0; i < len; i++)nat.data[ofs + i] = 4294967295 - (nat.data[ofs + i] >>> 0);
    }
    function create_nat(size) {
        var arr = new MlNat(size);
        for(var i = 0; i < size; i++)arr.data[i] = -1;
        return arr;
    }
    function decr_nat(nat, ofs, len, carry_in) {
        var borrow = carry_in === 1 ? 0 : 1;
        for(var i = 0; i < len; i++){
            var x = (nat.data[ofs + i] >>> 0) - borrow;
            nat.data[ofs + i] = x;
            if (x >= 0) {
                borrow = 0;
                break;
            } else borrow = 1;
        }
        return borrow === 1 ? 0 : 1;
    }
    function deserialize_nat(reader, sz) {
        var len = reader.read32s(), nat = new MlNat(len);
        for(var i = 0; i < len; i++)nat.data[i] = reader.read32s();
        sz[0] = len * 4;
        return nat;
    }
    function div_helper(a, b, c) {
        var x = a * 65536 + (b >>> 16), y = Math.floor(x / c) * 65536, z = x % c * 65536, w = z + (b & 0x0000ffff);
        return [
            y + Math.floor(w / c),
            w % c
        ];
    }
    function div_digit_nat(natq, ofsq, natr, ofsr, nat1, ofs1, len, nat2, ofs2) {
        var rem = nat1.data[ofs1 + len - 1] >>> 0;
        for(var i = len - 2; i >= 0; i--){
            var x = div_helper(rem, nat1.data[ofs1 + i] >>> 0, nat2.data[ofs2] >>> 0);
            natq.data[ofsq + i] = x[0];
            rem = x[1];
        }
        natr.data[ofsr] = rem;
        return 0;
    }
    function num_leading_zero_bits_in_digit(nat, ofs) {
        var a = nat.data[ofs], b = 0;
        if (a & 0xffff0000) {
            b += 16;
            a >>>= 16;
        }
        if (a & 0xff00) {
            b += 8;
            a >>>= 8;
        }
        if (a & 0xf0) {
            b += 4;
            a >>>= 4;
        }
        if (a & 12) {
            b += 2;
            a >>>= 2;
        }
        if (a & 2) {
            b += 1;
            a >>>= 1;
        }
        if (a & 1) b += 1;
        return 32 - b;
    }
    function shift_left_nat(nat1, ofs1, len1, nat2, ofs2, nbits) {
        if (nbits === 0) {
            nat2.data[ofs2] = 0;
            return 0;
        }
        var wrap = 0;
        for(var i = 0; i < len1; i++){
            var a = nat1.data[ofs1 + i] >>> 0;
            nat1.data[ofs1 + i] = a << nbits | wrap;
            wrap = a >>> 32 - nbits;
        }
        nat2.data[ofs2] = wrap;
        return 0;
    }
    function shift_right_nat(nat1, ofs1, len1, nat2, ofs2, nbits) {
        if (nbits === 0) {
            nat2.data[ofs2] = 0;
            return 0;
        }
        var wrap = 0;
        for(var i = len1 - 1; i >= 0; i--){
            var a = nat1.data[ofs1 + i] >>> 0;
            nat1.data[ofs1 + i] = a >>> nbits | wrap;
            wrap = a << 32 - nbits;
        }
        nat2.data[ofs2] = wrap;
        return 0;
    }
    function set_to_zero_nat(nat, ofs, len) {
        for(var i = 0; i < len; i++)nat.data[ofs + i] = 0;
        return 0;
    }
    function nat_of_array(l) {
        return new MlNat(l);
    }
    function mult_digit_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat3, ofs3) {
        var carry = 0, a = nat3.data[ofs3] >>> 0;
        for(var i = 0; i < len2; i++){
            var x1 = (nat1.data[ofs1 + i] >>> 0) + (nat2.data[ofs2 + i] >>> 0) * (a & 0x0000ffff) + carry, x2 = (nat2.data[ofs2 + i] >>> 0) * (a >>> 16);
            carry = Math.floor(x2 / 65536);
            var x3 = x1 + x2 % 65536 * 65536;
            nat1.data[ofs1 + i] = x3;
            carry += Math.floor(x3 / 4294967296);
        }
        return len2 < len1 && carry ? add_nat(nat1, ofs1 + len2, len1 - len2, nat_of_array([
            carry
        ]), 0, 1, 0) : carry;
    }
    function sub_nat(nat1, ofs1, len1, nat2, ofs2, len2, carry_in) {
        var borrow = carry_in === 1 ? 0 : 1;
        for(var i = 0; i < len2; i++){
            var x = (nat1.data[ofs1 + i] >>> 0) - (nat2.data[ofs2 + i] >>> 0) - borrow;
            nat1.data[ofs1 + i] = x;
            if (x >= 0) borrow = 0;
            else borrow = 1;
        }
        return decr_nat(nat1, ofs1 + len2, len1 - len2, borrow === 1 ? 0 : 1);
    }
    function div_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        if (len2 === 1) {
            div_digit_nat(nat1, ofs1 + 1, nat1, ofs1, nat1, ofs1, len1, nat2, ofs2);
            return 0;
        }
        var s = num_leading_zero_bits_in_digit(nat2, ofs2 + len2 - 1);
        shift_left_nat(nat2, ofs2, len2, nat_of_array([
            0
        ]), 0, s);
        shift_left_nat(nat1, ofs1, len1, nat_of_array([
            0
        ]), 0, s);
        var d = (nat2.data[ofs2 + len2 - 1] >>> 0) + 1, a = create_nat(len2 + 1);
        for(var i = len1 - 1; i >= len2; i--){
            var quo = d === 4294967296 ? nat1.data[ofs1 + i] >>> 0 : div_helper(nat1.data[ofs1 + i] >>> 0, nat1.data[ofs1 + i - 1] >>> 0, d)[0];
            set_to_zero_nat(a, 0, len2 + 1);
            mult_digit_nat(a, 0, len2 + 1, nat2, ofs2, len2, nat_of_array([
                quo
            ]), 0);
            sub_nat(nat1, ofs1 + i - len2, len2 + 1, a, 0, len2 + 1, 1);
            while(nat1.data[ofs1 + i] !== 0 || compare_nat(nat1, ofs1 + i - len2, len2, nat2, ofs2, len2) >= 0){
                quo = quo + 1;
                sub_nat(nat1, ofs1 + i - len2, len2 + 1, nat2, ofs2, len2, 1);
            }
            nat1.data[ofs1 + i] = quo;
        }
        shift_right_nat(nat1, ofs1, len2, nat_of_array([
            0
        ]), 0, s);
        shift_right_nat(nat2, ofs2, len2, nat_of_array([
            0
        ]), 0, s);
        return 0;
    }
    function serialize_nat(writer, nat, sz) {
        var len = nat.data.length;
        writer.write(32, len);
        for(var i = 0; i < len; i++)writer.write(32, nat.data[i]);
        sz[0] = len * 4;
        sz[1] = len * 8;
    }
    function initialize_nat() {
        caml_custom_ops._nat = {
            deserialize: deserialize_nat,
            serialize: serialize_nat,
            hash: caml_hash_nat
        };
    }
    function is_digit_int(nat, ofs) {
        if (nat.data[ofs] >= 0) return 1;
        return 0;
    }
    function is_digit_normalized(nat, ofs) {
        return 1;
    }
    function is_digit_odd(nat, ofs) {
        if (nat.data[ofs] & 1) return 1;
        return 0;
    }
    function is_digit_zero(nat, ofs) {
        if (nat.data[ofs] === 0) return 1;
        return 0;
    }
    function jsoo_create_file_extern(name, content) {
        if (globalThis1.jsoo_create_file) globalThis1.jsoo_create_file(name, content);
        else {
            if (!globalThis1.jsoo_fs_tmp) globalThis1.jsoo_fs_tmp = [];
            globalThis1.jsoo_fs_tmp.push({
                name: name,
                content: content
            });
        }
        return 0;
    }
    function jsoo_effect_not_supported() {
        caml_failwith("Effect handlers are not supported");
    }
    function land_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] &= nat2.data[ofs2];
        return 0;
    }
    function length_nat(x) {
        return x.data.length;
    }
    function lor_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] |= nat2.data[ofs2];
        return 0;
    }
    function lxor_digit_nat(nat1, ofs1, nat2, ofs2) {
        nat1.data[ofs1] ^= nat2.data[ofs2];
        return 0;
    }
    function ms_float_to_ns_int64(ms) {
        return caml_int64_of_float(ms * 1000000);
    }
    function mult_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat3, ofs3, len3) {
        var carry = 0;
        for(var i = 0; i < len3; i++)carry += mult_digit_nat(nat1, ofs1 + i, len1 - i, nat2, ofs2, len2, nat3, ofs3 + i);
        return carry;
    }
    function nth_digit_nat(nat, ofs) {
        return nat.data[ofs];
    }
    function nth_digit_nat_native(nat, ofs) {
        return nat.data[ofs];
    }
    var ppx_expect_runtime_saved_stderr, ppx_expect_runtime_saved_stdout;
    function ppx_expect_runtime_after_test(vstdout, vstderr) {
        caml_ml_channel_restore(vstdout, ppx_expect_runtime_saved_stdout);
        caml_ml_channel_restore(vstderr, ppx_expect_runtime_saved_stderr);
        return 0;
    }
    function ppx_expect_runtime_before_test(voutput, vstdout, vstderr) {
        ppx_expect_runtime_saved_stderr = caml_ml_channel_redirect(vstderr, voutput);
        ppx_expect_runtime_saved_stdout = caml_ml_channel_redirect(vstdout, voutput);
        return 0;
    }
    function ppx_expect_runtime_flush_stubs_streams(vunit) {
        return 0;
    }
    function ppx_expect_runtime_out_channel_position(chan) {
        var info = caml_ml_channel_get(chan);
        return info.offset;
    }
    var re_match = function() {
        var re_word_letters = [
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0xff,
            0x03,
            0xfe,
            0xff,
            0xff,
            0x87,
            0xfe,
            0xff,
            0xff,
            0x07,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0xff,
            0xff,
            0x7f,
            0xff,
            0xff,
            0xff,
            0x7f,
            0xff
        ], opcodes = {
            CHAR: 0,
            CHARNORM: 1,
            STRING: 2,
            STRINGNORM: 3,
            CHARCLASS: 4,
            BOL: 5,
            EOL: 6,
            WORDBOUNDARY: 7,
            BEGGROUP: 8,
            ENDGROUP: 9,
            REFGROUP: 10,
            ACCEPT: 11,
            SIMPLEOPT: 12,
            SIMPLESTAR: 13,
            SIMPLEPLUS: 14,
            GOTO: 15,
            PUSHBACK: 16,
            SETMARK: 17,
            CHECKPROGRESS: 18
        };
        function is_word_letter(c) {
            return re_word_letters[c >> 3] >> (c & 7) & 1;
        }
        function in_bitset(s, i) {
            return caml_string_get(s, i >> 3) >> (i & 7) & 1;
        }
        function re_match_impl(re, s, pos, partial) {
            var prog = caml_js_from_array(re[1]), cpool = caml_js_from_array(re[2]), normtable = caml_jsbytes_of_string(re[3]), numgroups = re[4] | 0, numregisters = re[5] | 0, startchars = re[6] | 0, s = caml_uint8_array_of_string(s), pc = 0, quit = false, stack = [], groups = new Array(numgroups), re_register = new Array(numregisters);
            for(var i = 0; i < groups.length; i++)groups[i] = {
                start: -1,
                end: -1
            };
            groups[0].start = pos;
            function backtrack() {
                while(stack.length){
                    var item = stack.pop();
                    if (item.undo) item.undo.obj[item.undo.prop] = item.undo.value;
                    else if (item.pos) {
                        pc = item.pos.pc;
                        pos = item.pos.txt;
                        return;
                    }
                }
                quit = true;
            }
            function push(item) {
                stack.push(item);
            }
            function accept() {
                groups[0].end = pos;
                var result = new Array(1 + groups.length * 2);
                result[0] = 0;
                for(var i = 0; i < groups.length; i++){
                    var g = groups[i];
                    if (g.start < 0 || g.end < 0) g.start = g.end = -1;
                    result[2 * i + 1] = g.start;
                    result[2 * i + 1 + 1] = g.end;
                }
                return result;
            }
            function prefix_match() {
                if (partial) return accept();
                else backtrack();
            }
            while(!quit){
                var op = prog[pc] & 0xff, sarg = prog[pc] >> 8, uarg = sarg & 0xff, c = s[pos], group;
                pc++;
                switch(op){
                    case opcodes.CHAR:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (c === uarg) pos++;
                        else backtrack();
                        break;
                    case opcodes.CHARNORM:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (normtable.charCodeAt(c) === uarg) pos++;
                        else backtrack();
                        break;
                    case opcodes.STRING:
                        for(var arg = caml_jsbytes_of_string(cpool[uarg]), i = 0; i < arg.length; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (c === arg.charCodeAt(i)) c = s[++pos];
                            else {
                                backtrack();
                                break;
                            }
                        }
                        break;
                    case opcodes.STRINGNORM:
                        for(var arg = caml_jsbytes_of_string(cpool[uarg]), i = 0; i < arg.length; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (normtable.charCodeAt(c) === arg.charCodeAt(i)) c = s[++pos];
                            else {
                                backtrack();
                                break;
                            }
                        }
                        break;
                    case opcodes.CHARCLASS:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (in_bitset(cpool[uarg], c)) pos++;
                        else backtrack();
                        break;
                    case opcodes.BOL:
                        if (pos > 0 && s[pos - 1] !== 10) backtrack();
                        break;
                    case opcodes.EOL:
                        if (pos < s.length && s[pos] !== 10) backtrack();
                        break;
                    case opcodes.WORDBOUNDARY:
                        if (pos === 0) {
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (is_word_letter(s[0])) break;
                            backtrack();
                        } else if (pos === s.length) {
                            if (is_word_letter(s[pos - 1])) break;
                            backtrack();
                        } else {
                            if (is_word_letter(s[pos - 1]) !== is_word_letter(s[pos])) break;
                            backtrack();
                        }
                        break;
                    case opcodes.BEGGROUP:
                        group = groups[uarg];
                        push({
                            undo: {
                                obj: group,
                                prop: "start",
                                value: group.start
                            }
                        });
                        group.start = pos;
                        break;
                    case opcodes.ENDGROUP:
                        group = groups[uarg];
                        push({
                            undo: {
                                obj: group,
                                prop: "end",
                                value: group.end
                            }
                        });
                        group.end = pos;
                        break;
                    case opcodes.REFGROUP:
                        group = groups[uarg];
                        if (group.start < 0 || group.end < 0) {
                            backtrack();
                            break;
                        }
                        for(var i = group.start; i < group.end; i++){
                            if (pos === s.length) {
                                prefix_match();
                                break;
                            }
                            if (s[i] !== s[pos]) {
                                backtrack();
                                break;
                            }
                            pos++;
                        }
                        break;
                    case opcodes.SIMPLEOPT:
                        if (in_bitset(cpool[uarg], c)) pos++;
                        break;
                    case opcodes.SIMPLESTAR:
                        while(in_bitset(cpool[uarg], c))c = s[++pos];
                        break;
                    case opcodes.SIMPLEPLUS:
                        if (pos === s.length) {
                            prefix_match();
                            break;
                        }
                        if (in_bitset(cpool[uarg], c)) do c = s[++pos];
                        while (in_bitset(cpool[uarg], c));
                        else backtrack();
                        break;
                    case opcodes.ACCEPT:
                        return accept();
                    case opcodes.GOTO:
                        pc = pc + sarg;
                        break;
                    case opcodes.PUSHBACK:
                        push({
                            pos: {
                                pc: pc + sarg,
                                txt: pos
                            }
                        });
                        break;
                    case opcodes.SETMARK:
                        push({
                            undo: {
                                obj: re_register,
                                prop: uarg,
                                value: re_register[uarg]
                            }
                        });
                        re_register[uarg] = pos;
                        break;
                    case opcodes.CHECKPROGRESS:
                        if (re_register[uarg] === pos) backtrack();
                        break;
                    default:
                        throw new Error("Invalid bytecode");
                }
            }
            return 0;
        }
        return re_match_impl;
    }();
    function re_partial_match(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.partial_match");
        var res = re_match(re, s, pos, 1);
        return res ? res : [
            0
        ];
    }
    function re_replacement_text(repl, groups, orig) {
        var repl = caml_jsbytes_of_string(repl), len = repl.length, orig = caml_jsbytes_of_string(orig), res = "", n = 0, cur, start, end, c;
        while(n < len){
            cur = repl.charAt(n++);
            if (cur !== "\\") res += cur;
            else {
                if (n === len) caml_failwith("Str.replace: illegal backslash sequence");
                cur = repl.charAt(n++);
                switch(cur){
                    case "\\":
                        res += cur;
                        break;
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        c = +cur;
                        if (c * 2 >= groups.length - 1) caml_failwith("Str.replace: reference to unmatched group");
                        start = caml_array_get(groups, c * 2);
                        end = caml_array_get(groups, c * 2 + 1);
                        if (start === -1) caml_failwith("Str.replace: reference to unmatched group");
                        res += orig.slice(start, end);
                        break;
                    default:
                        res += "\\" + cur;
                }
            }
        }
        return caml_string_of_jsbytes(res);
    }
    function re_search_backward(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.search_backward");
        while(pos >= 0){
            var res = re_match(re, s, pos, 0);
            if (res) return res;
            pos--;
        }
        return [
            0
        ];
    }
    function re_search_forward(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.search_forward");
        while(pos <= caml_ml_string_length(s)){
            var res = re_match(re, s, pos, 0);
            if (res) return res;
            pos++;
        }
        return [
            0
        ];
    }
    function re_string_match(re, s, pos) {
        if (pos < 0 || pos > caml_ml_string_length(s)) caml_invalid_argument("Str.string_match");
        var res = re_match(re, s, pos, 0);
        return res ? res : [
            0
        ];
    }
    function set_digit_nat(nat, ofs, digit) {
        nat.data[ofs] = digit;
        return 0;
    }
    function set_digit_nat_native(nat, ofs, digit) {
        nat.data[ofs] = digit;
        return 0;
    }
    function square_nat(nat1, ofs1, len1, nat2, ofs2, len2) {
        var carry = 0;
        carry += add_nat(nat1, ofs1, len1, nat1, ofs1, len1, 0);
        carry += mult_nat(nat1, ofs1, len1, nat2, ofs2, len2, nat2, ofs2, len2);
        return carry;
    }
    function time_now_nanosecond_counter_for_timing() {
        var ms_since_program_started = performance.now(), ns_since_program_started = ms_float_to_ns_int64(ms_since_program_started);
        return caml_int64_shift_left(ns_since_program_started, 1);
    }
    var ms_to_nano = caml_int64_of_int32(1000000);
    function time_now_nanoseconds_since_unix_epoch_or_zero() {
        var ms = Date.now(), ms_i63 = caml_int64_of_float(ms * 2);
        return caml_int64_mul(ms_i63, ms_to_nano);
    }
    function caml_setup_uncaught_exception_handler() {
        var process = globalThis1.process;
        if (process && process.on) process.on("uncaughtException", function(err, origin) {
            caml_fatal_uncaught_exception(err);
            process.exit(2);
        });
        else if (globalThis1.addEventListener) globalThis1.addEventListener("error", function(event) {
            if (event.error) caml_fatal_uncaught_exception(event.error);
        });
    }
    caml_setup_uncaught_exception_handler();
    globalThis1.jsoo_runtime = {
        ppx_expect_runtime_flush_stubs_streams: ppx_expect_runtime_flush_stubs_streams,
        ppx_expect_runtime_out_channel_position: ppx_expect_runtime_out_channel_position,
        ppx_expect_runtime_after_test: ppx_expect_runtime_after_test,
        ppx_expect_runtime_before_test: ppx_expect_runtime_before_test,
        ppx_expect_runtime_saved_stderr: ppx_expect_runtime_saved_stderr,
        ppx_expect_runtime_saved_stdout: ppx_expect_runtime_saved_stdout,
        time_now_nanosecond_counter_for_timing: time_now_nanosecond_counter_for_timing,
        ms_float_to_ns_int64: ms_float_to_ns_int64,
        time_now_nanoseconds_since_unix_epoch_or_zero: time_now_nanoseconds_since_unix_epoch_or_zero,
        caml_dummy_obj_is_stack: caml_dummy_obj_is_stack,
        caml_make_local_vect: caml_make_local_vect,
        Base_unsafe_create_local_bytes: Base_unsafe_create_local_bytes,
        Base_am_testing: Base_am_testing,
        Base_hash_double: Base_hash_double,
        Base_hash_string: Base_hash_string,
        Base_int_math_int64_pow_stub: Base_int_math_int64_pow_stub,
        Base_int_math_int_pow_stub: Base_int_math_int_pow_stub,
        Base_int_math_int64_ctz: Base_int_math_int64_ctz,
        Base_int_math_nativeint_ctz: Base_int_math_nativeint_ctz,
        Base_int_math_int_ctz: Base_int_math_int_ctz,
        Base_int_math_int32_ctz: Base_int_math_int32_ctz,
        Base_int_math_int64_clz: Base_int_math_int64_clz,
        Base_int_math_nativeint_clz: Base_int_math_nativeint_clz,
        Base_int_math_int_clz: Base_int_math_int_clz,
        Base_int_math_int32_clz: Base_int_math_int32_clz,
        Base_caml_exn_is_most_recent_exn: Base_caml_exn_is_most_recent_exn,
        Base_clear_caml_backtrace_pos: Base_clear_caml_backtrace_pos,
        Base_int_math_int_popcount: Base_int_math_int_popcount,
        caml_sse2_float64_max_bytecode: caml_sse2_float64_max_bytecode,
        caml_sse2_float64_min_bytecode: caml_sse2_float64_min_bytecode,
        caml_csel_value: caml_csel_value,
        Base_internalhash_get_hash_value: Base_internalhash_get_hash_value,
        Base_internalhash_fold_string: Base_internalhash_fold_string,
        Base_internalhash_fold_float: Base_internalhash_fold_float,
        Base_internalhash_fold_int: Base_internalhash_fold_int,
        Base_internalhash_fold_int64: Base_internalhash_fold_int64,
        caml_blake2_bytes: caml_blake2_bytes,
        caml_blake2_string: caml_blake2_string,
        caml_blake2_update: caml_blake2_update,
        caml_blake2_final: caml_blake2_final,
        caml_blake2_create: caml_blake2_create,
        blake2b: blake2b,
        caml_ml_runtime_events_path: caml_ml_runtime_events_path,
        caml_runtime_events_read_poll: caml_runtime_events_read_poll,
        caml_runtime_events_free_cursor: caml_runtime_events_free_cursor,
        caml_runtime_events_create_cursor: caml_runtime_events_create_cursor,
        caml_ml_runtime_events_resume: caml_ml_runtime_events_resume,
        caml_ml_runtime_events_are_active: caml_ml_runtime_events_are_active,
        caml_ml_runtime_events_pause: caml_ml_runtime_events_pause,
        caml_ml_runtime_events_start: caml_ml_runtime_events_start,
        caml_runtime_events_user_resolve: caml_runtime_events_user_resolve,
        caml_runtime_events_user_write: caml_runtime_events_user_write,
        caml_runtime_events_user_register: caml_runtime_events_user_register,
        caml_custom_event_index: caml_custom_event_index,
        caml_zstd_initialize: caml_zstd_initialize,
        caml_decompress_input: caml_decompress_input,
        zstd_decompress: zstd_decompress,
        jsoo_effect_not_supported: jsoo_effect_not_supported,
        caml_ml_condition_signal: caml_ml_condition_signal,
        caml_ml_condition_broadcast: caml_ml_condition_broadcast,
        caml_ml_condition_wait: caml_ml_condition_wait,
        caml_ml_condition_new: caml_ml_condition_new,
        caml_get_continuation_callstack: caml_get_continuation_callstack,
        caml_continuation_use_and_update_handler_noexc: caml_continuation_use_and_update_handler_noexc,
        caml_continuation_use_noexc: caml_continuation_use_noexc,
        caml_alloc_stack: caml_alloc_stack,
        caml_ml_mutex_unlock: caml_ml_mutex_unlock,
        caml_ml_mutex_try_lock: caml_ml_mutex_try_lock,
        caml_ml_mutex_lock: caml_ml_mutex_lock,
        caml_ml_mutex_new: caml_ml_mutex_new,
        MlMutex: MlMutex,
        caml_lxm_next: caml_lxm_next,
        caml_lxm_daba: caml_lxm_daba,
        caml_lxm_M: caml_lxm_M,
        caml_ml_domain_cpu_relax: caml_ml_domain_cpu_relax,
        caml_ml_domain_id: caml_ml_domain_id,
        caml_domain_spawn: caml_domain_spawn,
        caml_domain_id: caml_domain_id,
        caml_ml_domain_index: caml_ml_domain_index,
        caml_recommended_domain_count: caml_recommended_domain_count,
        caml_atomic_make_contended: caml_atomic_make_contended,
        caml_atomic_exchange: caml_atomic_exchange,
        caml_atomic_fetch_add: caml_atomic_fetch_add,
        caml_atomic_cas: caml_atomic_cas,
        caml_atomic_load: caml_atomic_load,
        caml_domain_dls_get: caml_domain_dls_get,
        caml_domain_dls_compare_and_set: caml_domain_dls_compare_and_set,
        caml_domain_dls_set: caml_domain_dls_set,
        caml_domain_dls: caml_domain_dls,
        caml_ephe_check_data: caml_ephe_check_data,
        caml_ephe_unset_data: caml_ephe_unset_data,
        caml_ephe_set_data_opt: caml_ephe_set_data_opt,
        caml_ephe_set_data: caml_ephe_set_data,
        caml_ephe_get_data_copy: caml_ephe_get_data_copy,
        caml_ephe_get_data: caml_ephe_get_data,
        caml_ephe_blit_data: caml_ephe_blit_data,
        caml_ephe_blit_key: caml_ephe_blit_key,
        caml_ephe_check_key: caml_ephe_check_key,
        caml_ephe_get_key_copy: caml_ephe_get_key_copy,
        caml_ephe_get_key: caml_ephe_get_key,
        caml_weak_set: caml_weak_set,
        caml_weak_create: caml_weak_create,
        caml_ephe_create: caml_ephe_create,
        caml_ephe_unset_key: caml_ephe_unset_key,
        caml_ephe_set_key: caml_ephe_set_key,
        caml_ephe_none: caml_ephe_none,
        caml_ephe_data_offset: caml_ephe_data_offset,
        caml_ephe_key_offset: caml_ephe_key_offset,
        caml_raise_system_error: caml_raise_system_error,
        caml_unix_inet_addr_of_string: caml_unix_inet_addr_of_string,
        caml_unix_findclose: caml_unix_findclose,
        caml_unix_findnext: caml_unix_findnext,
        caml_unix_findfirst: caml_unix_findfirst,
        caml_unix_rewinddir: caml_unix_rewinddir,
        caml_unix_closedir: caml_unix_closedir,
        caml_unix_readdir: caml_unix_readdir,
        caml_unix_opendir: caml_unix_opendir,
        caml_unix_has_symlink: caml_unix_has_symlink,
        caml_unix_getpwuid: caml_unix_getpwuid,
        caml_unix_getuid: caml_unix_getuid,
        caml_unix_outchannel_of_filedescr: caml_unix_outchannel_of_filedescr,
        caml_unix_inchannel_of_filedescr: caml_unix_inchannel_of_filedescr,
        caml_unix_close: caml_unix_close,
        caml_unix_ftruncate_64: caml_unix_ftruncate_64,
        caml_unix_ftruncate: caml_unix_ftruncate,
        caml_unix_lseek_64: caml_unix_lseek_64,
        caml_unix_lseek: caml_unix_lseek,
        caml_unix_read_bigarray: caml_unix_read_bigarray,
        caml_unix_read: caml_unix_read,
        caml_unix_write_bigarray: caml_unix_write_bigarray,
        caml_unix_write: caml_unix_write,
        caml_unix_fstat_64: caml_unix_fstat_64,
        caml_unix_fstat: caml_unix_fstat,
        caml_unix_lookup_file: caml_unix_lookup_file,
        caml_unix_open: caml_unix_open,
        caml_unix_truncate_64: caml_unix_truncate_64,
        caml_unix_truncate: caml_unix_truncate,
        caml_unix_utimes: caml_unix_utimes,
        caml_unix_unlink: caml_unix_unlink,
        caml_unix_readlink: caml_unix_readlink,
        caml_unix_symlink: caml_unix_symlink,
        caml_unix_rmdir: caml_unix_rmdir,
        caml_unix_mkdir: caml_unix_mkdir,
        caml_unix_rename: caml_unix_rename,
        caml_unix_lstat_64: caml_unix_lstat_64,
        caml_unix_lstat: caml_unix_lstat,
        caml_unix_stat_64: caml_unix_stat_64,
        caml_unix_stat: caml_unix_stat,
        make_unix_err_args: make_unix_err_args,
        unix_error: unix_error,
        caml_unix_isatty: caml_unix_isatty,
        caml_unix_filedescr_of_fd: caml_unix_filedescr_of_fd,
        caml_unix_cleanup: caml_unix_cleanup,
        caml_unix_startup: caml_unix_startup,
        caml_unix_mktime: caml_unix_mktime,
        caml_unix_localtime: caml_unix_localtime,
        caml_unix_gmtime: caml_unix_gmtime,
        caml_unix_time: caml_unix_time,
        caml_unix_gettimeofday: caml_unix_gettimeofday,
        re_replacement_text: re_replacement_text,
        re_partial_match: re_partial_match,
        re_string_match: re_string_match,
        re_search_backward: re_search_backward,
        re_search_forward: re_search_forward,
        re_match: re_match,
        caml_sys_is_regular_file: caml_sys_is_regular_file,
        caml_xdg_defaults: caml_xdg_defaults,
        caml_sys_const_naked_pointers_checked: caml_sys_const_naked_pointers_checked,
        caml_ml_runtime_warnings_enabled: caml_ml_runtime_warnings_enabled,
        caml_ml_enable_runtime_warnings: caml_ml_enable_runtime_warnings,
        caml_runtime_warnings: caml_runtime_warnings,
        caml_install_signal_handler: caml_install_signal_handler,
        caml_runtime_parameters: caml_runtime_parameters,
        caml_runtime_variant: caml_runtime_variant,
        caml_sys_isatty: caml_sys_isatty,
        caml_sys_get_config: caml_sys_get_config,
        os_type: os_type,
        caml_sys_const_backend_type: caml_sys_const_backend_type,
        caml_sys_const_ostype_cygwin: caml_sys_const_ostype_cygwin,
        caml_sys_const_ostype_win32: caml_sys_const_ostype_win32,
        caml_sys_const_ostype_unix: caml_sys_const_ostype_unix,
        caml_sys_const_max_wosize: caml_sys_const_max_wosize,
        caml_sys_const_int_size: caml_sys_const_int_size,
        caml_sys_const_word_size: caml_sys_const_word_size,
        caml_sys_const_big_endian: caml_sys_const_big_endian,
        caml_sys_random_seed: caml_sys_random_seed,
        caml_sys_time_include_children: caml_sys_time_include_children,
        caml_sys_time: caml_sys_time,
        caml_sys_system_command: caml_sys_system_command,
        caml_sys_executable_name: caml_sys_executable_name,
        caml_sys_modify_argv: caml_sys_modify_argv,
        caml_sys_argv: caml_sys_argv,
        caml_sys_get_argv: caml_sys_get_argv,
        caml_executable_name: caml_executable_name,
        caml_argv: caml_argv,
        caml_sys_unsafe_getenv: caml_sys_unsafe_getenv,
        caml_sys_getenv: caml_sys_getenv,
        jsoo_sys_getenv: jsoo_sys_getenv,
        caml_set_static_env: caml_set_static_env,
        jsoo_static_env: jsoo_static_env,
        caml_fatal_uncaught_exception: caml_fatal_uncaught_exception,
        caml_format_exception: caml_format_exception,
        caml_is_special_exception: caml_is_special_exception,
        caml_sys_exit: caml_sys_exit,
        caml_raise_sys_error: caml_raise_sys_error,
        caml_process_pending_actions_with_root: caml_process_pending_actions_with_root,
        caml_maybe_print_stats: caml_maybe_print_stats,
        caml_is_printable: caml_is_printable,
        caml_get_global_data: caml_get_global_data,
        caml_register_global: caml_register_global,
        jsoo_toplevel_reloc: jsoo_toplevel_reloc,
        caml_build_symbols: caml_build_symbols,
        caml_global_data: caml_global_data,
        caml_named_value: caml_named_value,
        caml_register_named_value: caml_register_named_value,
        caml_named_values: caml_named_values,
        caml_call_gen: caml_call_gen,
        caml_set_parser_trace: caml_set_parser_trace,
        caml_parse_engine: caml_parse_engine,
        caml_parser_trace: caml_parser_trace,
        caml_custom_identifier: caml_custom_identifier,
        caml_is_continuation_tag: caml_is_continuation_tag,
        caml_lazy_read_result: caml_lazy_read_result,
        caml_lazy_reset_to_lazy: caml_lazy_reset_to_lazy,
        caml_lazy_update_to_forward: caml_lazy_update_to_forward,
        caml_lazy_update_to_forcing: caml_lazy_update_to_forcing,
        caml_obj_update_tag: caml_obj_update_tag,
        caml_obj_add_offset: caml_obj_add_offset,
        caml_obj_reachable_words: caml_obj_reachable_words,
        caml_obj_set_raw_field: caml_obj_set_raw_field,
        caml_obj_raw_field: caml_obj_raw_field,
        caml_fresh_oo_id: caml_fresh_oo_id,
        caml_set_oo_id: caml_set_oo_id,
        caml_oo_last_id: caml_oo_last_id,
        caml_get_public_method: caml_get_public_method,
        caml_lazy_make_forward: caml_lazy_make_forward,
        caml_obj_is_shared: caml_obj_is_shared,
        caml_obj_compare_and_swap: caml_obj_compare_and_swap,
        caml_obj_dup: caml_obj_dup,
        caml_obj_with_tag: caml_obj_with_tag,
        caml_obj_block: caml_obj_block,
        caml_obj_tag: caml_obj_tag,
        caml_alloc_dummy_infix: caml_alloc_dummy_infix,
        caml_update_dummy: caml_update_dummy,
        deserialize_nat: deserialize_nat,
        serialize_nat: serialize_nat,
        lxor_digit_nat: lxor_digit_nat,
        lor_digit_nat: lor_digit_nat,
        land_digit_nat: land_digit_nat,
        compare_nat: compare_nat,
        compare_digits_nat: compare_digits_nat,
        shift_right_nat: shift_right_nat,
        div_nat: div_nat,
        div_digit_nat: div_digit_nat,
        div_helper: div_helper,
        shift_left_nat: shift_left_nat,
        square_nat: square_nat,
        mult_nat: mult_nat,
        mult_digit_nat: mult_digit_nat,
        sub_nat: sub_nat,
        decr_nat: decr_nat,
        complement_nat: complement_nat,
        add_nat: add_nat,
        incr_nat: incr_nat,
        is_digit_odd: is_digit_odd,
        is_digit_normalized: is_digit_normalized,
        is_digit_zero: is_digit_zero,
        is_digit_int: is_digit_int,
        num_leading_zero_bits_in_digit: num_leading_zero_bits_in_digit,
        num_digits_nat: num_digits_nat,
        nth_digit_nat_native: nth_digit_nat_native,
        set_digit_nat_native: set_digit_nat_native,
        nth_digit_nat: nth_digit_nat,
        set_digit_nat: set_digit_nat,
        blit_nat: blit_nat,
        set_to_zero_nat: set_to_zero_nat,
        create_nat: create_nat,
        nat_of_array: nat_of_array,
        length_nat: length_nat,
        caml_hash_nat: caml_hash_nat,
        MlNat: MlNat,
        initialize_nat: initialize_nat,
        caml_new_string: caml_new_string,
        caml_array_of_bytes: caml_array_of_bytes,
        caml_array_of_string: caml_array_of_string,
        caml_js_to_string: caml_js_to_string,
        caml_to_js_string: caml_to_js_string,
        caml_js_from_string: caml_js_from_string,
        caml_js_to_byte_string: caml_js_to_byte_string,
        caml_is_ml_string: caml_is_ml_string,
        caml_ml_bytes_content: caml_ml_bytes_content,
        caml_is_ml_bytes: caml_is_ml_bytes,
        caml_bytes_of_jsbytes: caml_bytes_of_jsbytes,
        caml_string_of_jsstring: caml_string_of_jsstring,
        caml_jsstring_of_string: caml_jsstring_of_string,
        caml_jsbytes_of_string: caml_jsbytes_of_string,
        caml_string_of_jsbytes: caml_string_of_jsbytes,
        caml_bytes_of_string: caml_bytes_of_string,
        caml_string_of_bytes: caml_string_of_bytes,
        caml_string_lessthan: caml_string_lessthan,
        caml_string_lessequal: caml_string_lessequal,
        caml_string_equal: caml_string_equal,
        caml_string_compare: caml_string_compare,
        caml_ml_string_length: caml_ml_string_length,
        caml_string_unsafe_get: caml_string_unsafe_get,
        caml_string_concat: caml_string_concat,
        caml_ml_bytes_length: caml_ml_bytes_length,
        caml_blit_string: caml_blit_string,
        caml_blit_bytes: caml_blit_bytes,
        caml_fill_bytes: caml_fill_bytes,
        caml_bytes_greaterthan: caml_bytes_greaterthan,
        caml_string_greaterthan: caml_string_greaterthan,
        caml_bytes_greaterequal: caml_bytes_greaterequal,
        caml_string_greaterequal: caml_string_greaterequal,
        caml_bytes_lessthan: caml_bytes_lessthan,
        caml_bytes_lessequal: caml_bytes_lessequal,
        caml_bytes_notequal: caml_bytes_notequal,
        caml_string_notequal: caml_string_notequal,
        caml_bytes_equal: caml_bytes_equal,
        caml_bytes_compare: caml_bytes_compare,
        caml_bytes_of_uint8_array: caml_bytes_of_uint8_array,
        caml_bytes_of_array: caml_bytes_of_array,
        caml_string_of_uint8_array: caml_string_of_uint8_array,
        caml_string_of_array: caml_string_of_array,
        caml_create_bytes: caml_create_bytes,
        caml_create_string: caml_create_string,
        caml_uint8_array_of_string: caml_uint8_array_of_string,
        caml_uint8_array_of_bytes: caml_uint8_array_of_bytes,
        caml_convert_bytes_to_array: caml_convert_bytes_to_array,
        caml_convert_string_to_bytes: caml_convert_string_to_bytes,
        MlBytes: MlBytes,
        caml_bytes_of_utf16_jsstring: caml_bytes_of_utf16_jsstring,
        caml_bytes_set: caml_bytes_set,
        caml_bytes_set64: caml_bytes_set64,
        caml_bytes_set32: caml_bytes_set32,
        caml_bytes_set16: caml_bytes_set16,
        caml_string_set: caml_string_set,
        caml_bytes_get: caml_bytes_get,
        caml_bytes_get64: caml_bytes_get64,
        caml_string_get64: caml_string_get64,
        caml_bytes_get32: caml_bytes_get32,
        caml_string_get32: caml_string_get32,
        caml_bytes_get16: caml_bytes_get16,
        caml_string_get16: caml_string_get16,
        caml_string_get: caml_string_get,
        caml_bytes_bound_error: caml_bytes_bound_error,
        caml_string_bound_error: caml_string_bound_error,
        caml_bytes_unsafe_set: caml_bytes_unsafe_set,
        caml_bytes_unsafe_get: caml_bytes_unsafe_get,
        jsoo_is_ascii: jsoo_is_ascii,
        caml_utf16_of_utf8: caml_utf16_of_utf8,
        caml_utf8_of_utf16: caml_utf8_of_utf16,
        caml_sub_uint8_array_to_jsbytes: caml_sub_uint8_array_to_jsbytes,
        caml_subarray_to_jsbytes: caml_subarray_to_jsbytes,
        caml_str_repeat: caml_str_repeat,
        caml_md5_bytes: caml_md5_bytes,
        caml_MD5Final: caml_MD5Final,
        caml_MD5Update: caml_MD5Update,
        caml_MD5Init: caml_MD5Init,
        caml_MD5Transform: caml_MD5Transform,
        caml_md5_string: caml_md5_string,
        caml_md5_chan: caml_md5_chan,
        caml_output_value_to_buffer: caml_output_value_to_buffer,
        caml_output_value_to_bytes: caml_output_value_to_bytes,
        caml_output_value_to_string: caml_output_value_to_string,
        caml_output_val: caml_output_val,
        MlObjectTable: MlObjectTable,
        caml_marshal_data_size: caml_marshal_data_size,
        caml_marshal_header_size: caml_marshal_header_size,
        caml_input_value_from_reader: caml_input_value_from_reader,
        caml_custom_ops: caml_custom_ops,
        caml_nativeint_unmarshal: caml_nativeint_unmarshal,
        caml_int32_unmarshal: caml_int32_unmarshal,
        caml_int64_marshal: caml_int64_marshal,
        caml_int64_unmarshal: caml_int64_unmarshal,
        caml_input_value_from_bytes: caml_input_value_from_bytes,
        caml_float_of_bytes: caml_float_of_bytes,
        BigStringReader: BigStringReader,
        MlStringReader: MlStringReader,
        UInt8ArrayReader: UInt8ArrayReader,
        caml_marshal_constants: caml_marshal_constants,
        caml_new_lex_engine: caml_new_lex_engine,
        caml_lex_engine: caml_lex_engine,
        caml_lex_array: caml_lex_array,
        caml_js_error_of_exception: caml_js_error_of_exception,
        caml_xmlhttprequest_create: caml_xmlhttprequest_create,
        caml_js_get_console: caml_js_get_console,
        caml_js_html_entities: caml_js_html_entities,
        caml_js_html_escape: caml_js_html_escape,
        caml_js_object: caml_js_object,
        caml_pure_js_expr: caml_pure_js_expr,
        caml_js_expr: caml_js_expr,
        caml_js_eval_string: caml_js_eval_string,
        caml_js_strict_equals: caml_js_strict_equals,
        caml_js_equals: caml_js_equals,
        caml_js_function_arity: caml_js_function_arity,
        caml_js_wrap_meth_callback_unsafe: caml_js_wrap_meth_callback_unsafe,
        caml_js_wrap_meth_callback_strict: caml_js_wrap_meth_callback_strict,
        caml_js_wrap_meth_callback_arguments: caml_js_wrap_meth_callback_arguments,
        caml_js_wrap_meth_callback: caml_js_wrap_meth_callback,
        caml_js_wrap_callback_unsafe: caml_js_wrap_callback_unsafe,
        caml_js_wrap_callback_strict: caml_js_wrap_callback_strict,
        caml_js_wrap_callback_arguments: caml_js_wrap_callback_arguments,
        caml_js_wrap_callback: caml_js_wrap_callback,
        caml_ojs_new_arr: caml_ojs_new_arr,
        caml_js_new: caml_js_new,
        caml_js_meth_call: caml_js_meth_call,
        caml_js_fun_call: caml_js_fun_call,
        caml_js_call: caml_js_call,
        caml_js_var: caml_js_var,
        caml_list_to_js_array: caml_list_to_js_array,
        caml_list_of_js_array: caml_list_of_js_array,
        caml_js_to_array: caml_js_to_array,
        caml_js_from_array: caml_js_from_array,
        caml_js_to_int32: caml_js_to_int32,
        caml_js_to_float: caml_js_to_float,
        caml_js_from_float: caml_js_from_float,
        caml_js_to_bool: caml_js_to_bool,
        caml_js_from_bool: caml_js_from_bool,
        caml_js_error_option_of_exception: caml_js_error_option_of_exception,
        caml_exn_with_js_backtrace: caml_exn_with_js_backtrace,
        caml_maybe_attach_backtrace: caml_maybe_attach_backtrace,
        caml_wrap_exception: caml_wrap_exception,
        caml_jsoo_flags_effects: caml_jsoo_flags_effects,
        caml_jsoo_flags_use_js_string: caml_jsoo_flags_use_js_string,
        caml_is_js: caml_is_js,
        caml_callback: caml_callback,
        caml_trampoline_return: caml_trampoline_return,
        caml_trampoline: caml_trampoline,
        caml_js_typeof: caml_js_typeof,
        caml_js_instanceof: caml_js_instanceof,
        caml_js_delete: caml_js_delete,
        caml_js_get: caml_js_get,
        caml_js_set: caml_js_set,
        caml_js_pure_expr: caml_js_pure_expr,
        caml_ml_set_buffered: caml_ml_set_buffered,
        caml_ml_is_buffered: caml_ml_is_buffered,
        caml_ml_output_int: caml_ml_output_int,
        caml_ml_pos_out_64: caml_ml_pos_out_64,
        caml_ml_pos_out: caml_ml_pos_out,
        caml_pos_out: caml_pos_out,
        caml_ml_seek_out_64: caml_ml_seek_out_64,
        caml_ml_seek_out: caml_ml_seek_out,
        caml_seek_out: caml_seek_out,
        caml_output_value: caml_output_value,
        caml_ml_output_char: caml_ml_output_char,
        caml_ml_output: caml_ml_output,
        caml_ml_output_bigarray: caml_ml_output_bigarray,
        caml_ml_output_bytes: caml_ml_output_bytes,
        caml_ml_output_ta: caml_ml_output_ta,
        caml_ml_flush: caml_ml_flush,
        caml_ml_input_scan_line: caml_ml_input_scan_line,
        caml_ml_pos_in_64: caml_ml_pos_in_64,
        caml_ml_pos_in: caml_ml_pos_in,
        caml_pos_in: caml_pos_in,
        caml_ml_seek_in_64: caml_ml_seek_in_64,
        caml_ml_seek_in: caml_ml_seek_in,
        caml_seek_in: caml_seek_in,
        caml_ml_input_int: caml_ml_input_int,
        caml_ml_input_char: caml_ml_input_char,
        caml_input_value_to_outside_heap: caml_input_value_to_outside_heap,
        caml_input_value: caml_input_value,
        caml_ml_input_block: caml_ml_input_block,
        caml_ml_input_bigarray: caml_ml_input_bigarray,
        caml_ml_input: caml_ml_input,
        caml_refill: caml_refill,
        caml_ml_set_channel_refill: caml_ml_set_channel_refill,
        caml_ml_set_channel_output: caml_ml_set_channel_output,
        caml_ml_channel_size_64: caml_ml_channel_size_64,
        caml_ml_channel_size: caml_ml_channel_size,
        caml_ml_close_channel: caml_ml_close_channel,
        caml_ml_is_binary_mode: caml_ml_is_binary_mode,
        caml_ml_set_binary_mode: caml_ml_set_binary_mode,
        caml_channel_descriptor: caml_channel_descriptor,
        caml_ml_open_descriptor_out_with_flags: caml_ml_open_descriptor_out_with_flags,
        caml_ml_open_descriptor_in_with_flags: caml_ml_open_descriptor_in_with_flags,
        caml_ml_open_descriptor_in: caml_ml_open_descriptor_in,
        caml_ml_open_descriptor_out: caml_ml_open_descriptor_out,
        caml_ml_out_channels_list: caml_ml_out_channels_list,
        caml_ml_channel_restore: caml_ml_channel_restore,
        caml_ml_channel_redirect: caml_ml_channel_redirect,
        caml_ml_channel_get: caml_ml_channel_get,
        caml_ml_channels: caml_ml_channels,
        caml_ml_set_channel_name: caml_ml_set_channel_name,
        caml_sys_open: caml_sys_open,
        MlChanid: MlChanid,
        caml_sys_close: caml_sys_close,
        caml_sys_fds: caml_sys_fds,
        caml_int64_bswap: caml_int64_bswap,
        caml_int32_bswap: caml_int32_bswap,
        caml_bswap16: caml_bswap16,
        caml_mod: caml_mod,
        caml_div: caml_div,
        caml_mul: caml_mul,
        caml_int_of_string: caml_int_of_string,
        caml_parse_digit: caml_parse_digit,
        caml_parse_sign_and_base: caml_parse_sign_and_base,
        caml_format_int: caml_format_int,
        caml_int64_hash: caml_int64_hash,
        caml_int64_to_bytes: caml_int64_to_bytes,
        caml_int64_of_bytes: caml_int64_of_bytes,
        caml_int64_hi32: caml_int64_hi32,
        caml_int64_lo32: caml_int64_lo32,
        caml_int64_create_lo_hi: caml_int64_create_lo_hi,
        caml_int64_create_lo_mi_hi: caml_int64_create_lo_mi_hi,
        caml_int64_of_string: caml_int64_of_string,
        caml_int64_format: caml_int64_format,
        caml_int64_of_float: caml_int64_of_float,
        caml_int64_to_float: caml_int64_to_float,
        caml_int64_to_int32: caml_int64_to_int32,
        caml_int64_of_int32: caml_int64_of_int32,
        caml_int64_mod: caml_int64_mod,
        caml_int64_div: caml_int64_div,
        caml_int64_shift_right: caml_int64_shift_right,
        caml_int64_shift_right_unsigned: caml_int64_shift_right_unsigned,
        caml_int64_shift_left: caml_int64_shift_left,
        caml_int64_xor: caml_int64_xor,
        caml_int64_or: caml_int64_or,
        caml_int64_and: caml_int64_and,
        caml_int64_is_negative: caml_int64_is_negative,
        caml_int64_is_zero: caml_int64_is_zero,
        caml_int64_mul: caml_int64_mul,
        caml_int64_sub: caml_int64_sub,
        caml_int64_add: caml_int64_add,
        caml_int64_neg: caml_int64_neg,
        caml_int64_compare: caml_int64_compare,
        caml_int64_ult: caml_int64_ult,
        MlInt64: MlInt64,
        caml_int64_offset: caml_int64_offset,
        caml_float_of_string: caml_float_of_string,
        caml_format_float: caml_format_float,
        caml_fma_float: caml_fma_float,
        caml_erfc_float: caml_erfc_float,
        caml_erf_float: caml_erf_float,
        caml_cbrt_float: caml_cbrt_float,
        caml_round_float: caml_round_float,
        caml_atanh_float: caml_atanh_float,
        caml_tanh_float: caml_tanh_float,
        caml_asinh_float: caml_asinh_float,
        caml_sinh_float: caml_sinh_float,
        caml_acosh_float: caml_acosh_float,
        caml_cosh_float: caml_cosh_float,
        caml_log10_float: caml_log10_float,
        caml_hypot_float: caml_hypot_float,
        caml_log2_float: caml_log2_float,
        caml_log1p_float: caml_log1p_float,
        caml_exp2_float: caml_exp2_float,
        caml_expm1_float: caml_expm1_float,
        caml_signbit_float: caml_signbit_float,
        caml_copysign_float: caml_copysign_float,
        caml_float_compare: caml_float_compare,
        caml_frexp_float: caml_frexp_float,
        caml_ldexp_float: caml_ldexp_float,
        caml_modf_float: caml_modf_float,
        caml_classify_float: caml_classify_float,
        caml_int32_float_of_bits: caml_int32_float_of_bits,
        caml_trunc_float: caml_trunc_float,
        caml_nextafter_float: caml_nextafter_float,
        caml_int64_float_of_bits: caml_int64_float_of_bits,
        caml_hexstring_of_float: caml_hexstring_of_float,
        caml_int32_bits_of_float: caml_int32_bits_of_float,
        caml_int64_bits_of_float: caml_int64_bits_of_float,
        jsoo_floor_log2: jsoo_floor_log2,
        caml_string_hash: caml_string_hash,
        caml_hash: caml_hash,
        caml_hash_mix_string: caml_hash_mix_string,
        caml_hash_mix_bytes: caml_hash_mix_bytes,
        caml_hash_mix_bytes_arr: caml_hash_mix_bytes_arr,
        caml_hash_mix_jsbytes: caml_hash_mix_jsbytes,
        caml_hash_mix_int64: caml_hash_mix_int64,
        caml_hash_mix_float: caml_hash_mix_float,
        caml_hash_mix_final: caml_hash_mix_final,
        caml_hash_mix_int: caml_hash_mix_int,
        caml_gr_close_subwindow: caml_gr_close_subwindow,
        caml_gr_open_subwindow: caml_gr_open_subwindow,
        caml_gr_window_id: caml_gr_window_id,
        caml_gr_display_mode: caml_gr_display_mode,
        caml_gr_remember_mode: caml_gr_remember_mode,
        caml_gr_synchronize: caml_gr_synchronize,
        caml_gr_wait_event: caml_gr_wait_event,
        caml_gr_sigio_signal: caml_gr_sigio_signal,
        caml_gr_sigio_handler: caml_gr_sigio_handler,
        caml_gr_blit_image: caml_gr_blit_image,
        caml_gr_create_image: caml_gr_create_image,
        caml_gr_draw_image: caml_gr_draw_image,
        caml_gr_dump_image: caml_gr_dump_image,
        caml_gr_make_image: caml_gr_make_image,
        caml_gr_text_size: caml_gr_text_size,
        caml_gr_set_text_size: caml_gr_set_text_size,
        caml_gr_set_font: caml_gr_set_font,
        caml_gr_draw_string: caml_gr_draw_string,
        caml_gr_draw_char: caml_gr_draw_char,
        caml_gr_draw_str: caml_gr_draw_str,
        caml_gr_fill_arc: caml_gr_fill_arc,
        caml_gr_fill_poly: caml_gr_fill_poly,
        caml_gr_fill_rect: caml_gr_fill_rect,
        caml_gr_set_line_width: caml_gr_set_line_width,
        caml_gr_draw_arc: caml_gr_draw_arc,
        caml_gr_arc_aux: caml_gr_arc_aux,
        caml_gr_draw_rect: caml_gr_draw_rect,
        caml_gr_lineto: caml_gr_lineto,
        caml_gr_current_y: caml_gr_current_y,
        caml_gr_current_x: caml_gr_current_x,
        caml_gr_moveto: caml_gr_moveto,
        caml_gr_point_color: caml_gr_point_color,
        caml_gr_plot: caml_gr_plot,
        caml_gr_set_color: caml_gr_set_color,
        caml_gr_size_y: caml_gr_size_y,
        caml_gr_size_x: caml_gr_size_x,
        caml_gr_clear_graph: caml_gr_clear_graph,
        caml_gr_resize_window: caml_gr_resize_window,
        caml_gr_set_window_title: caml_gr_set_window_title,
        caml_gr_close_graph: caml_gr_close_graph,
        caml_gr_doc_of_state: caml_gr_doc_of_state,
        caml_gr_state_create: caml_gr_state_create,
        caml_gr_state_init: caml_gr_state_init,
        caml_gr_open_graph: caml_gr_open_graph,
        caml_gr_state_set: caml_gr_state_set,
        caml_gr_state_get: caml_gr_state_get,
        caml_gr_state: caml_gr_state,
        caml_get_minor_free: caml_get_minor_free,
        caml_gc_minor_words: caml_gc_minor_words,
        caml_gc_major_slice: caml_gc_major_slice,
        caml_memprof_discard: caml_memprof_discard,
        caml_memprof_stop: caml_memprof_stop,
        caml_memprof_start: caml_memprof_start,
        caml_final_release: caml_final_release,
        caml_final_register_called_without_value: caml_final_register_called_without_value,
        caml_final_register: caml_final_register,
        caml_gc_get: caml_gc_get,
        caml_gc_set: caml_gc_set,
        caml_gc_stat: caml_gc_stat,
        caml_gc_quick_stat: caml_gc_quick_stat,
        caml_gc_counters: caml_gc_counters,
        caml_gc_compaction: caml_gc_compaction,
        caml_gc_full_major: caml_gc_full_major,
        caml_gc_major: caml_gc_major,
        caml_gc_minor: caml_gc_minor,
        caml_raise_nodejs_error: caml_raise_nodejs_error,
        caml_sys_open_for_node: caml_sys_open_for_node,
        MlNodeFd: MlNodeFd,
        fs_node_stats_from_js: fs_node_stats_from_js,
        MlNodeDevice: MlNodeDevice,
        fs_node_supported: fs_node_supported,
        MlFakeFd: MlFakeFd,
        MlFakeFd_out: MlFakeFd_out,
        MlFakeFile: MlFakeFile,
        MlFakeDevice: MlFakeDevice,
        caml_read_file_content: caml_read_file_content,
        jsoo_create_file: jsoo_create_file,
        caml_create_file: caml_create_file,
        caml_fs_init: caml_fs_init,
        jsoo_create_file_extern: jsoo_create_file_extern,
        caml_ba_map_file_bytecode: caml_ba_map_file_bytecode,
        caml_ba_map_file: caml_ba_map_file,
        caml_sys_rmdir: caml_sys_rmdir,
        caml_sys_mkdir: caml_sys_mkdir,
        caml_sys_rename: caml_sys_rename,
        caml_sys_is_directory: caml_sys_is_directory,
        caml_sys_remove: caml_sys_remove,
        caml_sys_read_directory: caml_sys_read_directory,
        caml_sys_file_exists: caml_sys_file_exists,
        caml_raise_no_such_file: caml_raise_no_such_file,
        caml_sys_chdir: caml_sys_chdir,
        caml_sys_getcwd: caml_sys_getcwd,
        caml_unmount: caml_unmount,
        caml_mount_autoload: caml_mount_autoload,
        resolve_fs_device: resolve_fs_device,
        caml_list_mount_point: caml_list_mount_point,
        jsoo_mount_point: jsoo_mount_point,
        caml_make_path: caml_make_path,
        path_is_absolute: path_is_absolute,
        MlFile: MlFile,
        caml_root: caml_root,
        caml_get_root: caml_get_root,
        caml_current_dir: caml_current_dir,
        caml_trailing_slash: caml_trailing_slash,
        caml_finish_formatting: caml_finish_formatting,
        caml_parse_format: caml_parse_format,
        caml_array_bound_error: caml_array_bound_error,
        caml_raise_not_found: caml_raise_not_found,
        caml_raise_zero_divide: caml_raise_zero_divide,
        caml_raise_end_of_file: caml_raise_end_of_file,
        caml_invalid_argument: caml_invalid_argument,
        caml_failwith: caml_failwith,
        caml_raise_with_string: caml_raise_with_string,
        caml_raise_with_args: caml_raise_with_args,
        caml_raise_with_arg: caml_raise_with_arg,
        caml_raise_constant: caml_raise_constant,
        caml_lessthan: caml_lessthan,
        caml_lessequal: caml_lessequal,
        caml_greaterthan: caml_greaterthan,
        caml_greaterequal: caml_greaterequal,
        caml_notequal: caml_notequal,
        caml_equal: caml_equal,
        caml_int_compare: caml_int_compare,
        caml_compare: caml_compare,
        caml_compare_val: caml_compare_val,
        caml_compare_val_number_custom: caml_compare_val_number_custom,
        caml_compare_val_get_custom: caml_compare_val_get_custom,
        caml_compare_val_tag: caml_compare_val_tag,
        caml_bigstring_blit_ba_to_bytes: caml_bigstring_blit_ba_to_bytes,
        caml_bigstring_blit_bytes_to_ba: caml_bigstring_blit_bytes_to_ba,
        caml_bigstring_blit_string_to_ba: caml_bigstring_blit_string_to_ba,
        caml_bigstring_blit_ba_to_ba: caml_bigstring_blit_ba_to_ba,
        caml_bigstring_memcmp: caml_bigstring_memcmp,
        bigstring_of_typed_array: bigstring_of_typed_array,
        bigstring_of_array_buffer: bigstring_of_array_buffer,
        bigstring_to_typed_array: bigstring_to_typed_array,
        bigstring_to_array_buffer: bigstring_to_array_buffer,
        caml_hash_mix_bigstring: caml_hash_mix_bigstring,
        caml_ba_from_typed_array: caml_ba_from_typed_array,
        caml_ba_kind_of_typed_array: caml_ba_kind_of_typed_array,
        caml_ba_to_typed_array: caml_ba_to_typed_array,
        caml_hash_mix_float16: caml_hash_mix_float16,
        caml_ba_hash: caml_ba_hash,
        caml_ba_create_from: caml_ba_create_from,
        caml_ba_deserialize: caml_ba_deserialize,
        caml_ba_serialize: caml_ba_serialize,
        caml_ba_reshape: caml_ba_reshape,
        caml_ba_slice: caml_ba_slice,
        caml_ba_sub: caml_ba_sub,
        caml_ba_blit: caml_ba_blit,
        caml_ba_fill: caml_ba_fill,
        caml_ba_set_3: caml_ba_set_3,
        caml_ba_set_2: caml_ba_set_2,
        caml_ba_set_1: caml_ba_set_1,
        caml_ba_uint8_set64: caml_ba_uint8_set64,
        caml_ba_uint8_set32: caml_ba_uint8_set32,
        caml_ba_uint8_set16: caml_ba_uint8_set16,
        caml_ba_set_generic: caml_ba_set_generic,
        caml_ba_get_3: caml_ba_get_3,
        caml_ba_get_2: caml_ba_get_2,
        caml_ba_get_1: caml_ba_get_1,
        caml_ba_uint8_get64: caml_ba_uint8_get64,
        caml_ba_uint8_get32: caml_ba_uint8_get32,
        caml_ba_uint8_get16: caml_ba_uint8_get16,
        caml_ba_get_generic: caml_ba_get_generic,
        caml_ba_dim_3: caml_ba_dim_3,
        caml_ba_dim_2: caml_ba_dim_2,
        caml_ba_dim_1: caml_ba_dim_1,
        caml_ba_dim: caml_ba_dim,
        caml_ba_num_dims: caml_ba_num_dims,
        caml_ba_layout: caml_ba_layout,
        caml_ba_kind: caml_ba_kind,
        caml_ba_change_layout: caml_ba_change_layout,
        caml_ba_create: caml_ba_create,
        caml_ba_create_unsafe: caml_ba_create_unsafe,
        caml_ba_compare: caml_ba_compare,
        Ml_Bigarray_c_1_1: Ml_Bigarray_c_1_1,
        Ml_Bigarray: Ml_Bigarray,
        caml_ba_custom_name: caml_ba_custom_name,
        caml_ba_create_buffer: caml_ba_create_buffer,
        caml_ba_get_size_per_element: caml_ba_get_size_per_element,
        caml_packFloat16: caml_packFloat16,
        caml_unpackFloat16: caml_unpackFloat16,
        caml_ba_get_size: caml_ba_get_size,
        caml_ba_init: caml_ba_init,
        caml_convert_raw_backtrace_slot: caml_convert_raw_backtrace_slot,
        caml_get_current_callstack: caml_get_current_callstack,
        caml_restore_raw_backtrace: caml_restore_raw_backtrace,
        caml_raw_backtrace_slot: caml_raw_backtrace_slot,
        caml_raw_backtrace_next_slot: caml_raw_backtrace_next_slot,
        caml_raw_backtrace_length: caml_raw_backtrace_length,
        caml_convert_raw_backtrace: caml_convert_raw_backtrace,
        caml_record_backtrace: caml_record_backtrace,
        caml_get_exception_raw_backtrace: caml_get_exception_raw_backtrace,
        caml_get_exception_backtrace: caml_get_exception_backtrace,
        caml_backtrace_status: caml_backtrace_status,
        caml_ml_debug_info_status: caml_ml_debug_info_status,
        caml_record_backtrace_runtime_flag: caml_record_backtrace_runtime_flag,
        caml_record_backtrace_env_flag: caml_record_backtrace_env_flag,
        caml_uniform_array_make: caml_uniform_array_make,
        caml_floatarray_make_unboxed: caml_floatarray_make_unboxed,
        caml_floatarray_make: caml_floatarray_make,
        caml_floatarray_create: caml_floatarray_create,
        caml_array_create_float: caml_array_create_float,
        caml_make_float_vect: caml_make_float_vect,
        caml_make_vect: caml_make_vect,
        caml_array_make: caml_array_make,
        caml_check_bound: caml_check_bound,
        caml_uniform_array_fill: caml_uniform_array_fill,
        caml_floatarray_fill_unboxed: caml_floatarray_fill_unboxed,
        caml_floatarray_fill: caml_floatarray_fill,
        caml_array_fill: caml_array_fill,
        caml_array_get: caml_array_get,
        caml_array_set: caml_array_set,
        caml_uniform_array_blit: caml_uniform_array_blit,
        caml_floatarray_blit: caml_floatarray_blit,
        caml_array_blit: caml_array_blit,
        caml_array_concat: caml_array_concat,
        caml_uniform_array_append: caml_uniform_array_append,
        caml_floatarray_append: caml_floatarray_append,
        caml_array_append: caml_array_append,
        caml_uniform_array_sub: caml_uniform_array_sub,
        caml_floatarray_sub: caml_floatarray_sub,
        caml_array_sub: caml_array_sub
    };
    var cst_Assert_failure = "Assert_failure", cst_Division_by_zero = "Division_by_zero", cst_End_of_file = "End_of_file", cst_Failure = "Failure", cst_Invalid_argument = "Invalid_argument", cst_Match_failure = "Match_failure", cst_Not_found = "Not_found", cst_Out_of_memory = "Out_of_memory", cst_Stack_overflow = "Stack_overflow", cst_Sys_blocked_io = "Sys_blocked_io", cst_Sys_error = "Sys_error", cst_Undefined_recursive_module = "Undefined_recursive_module";
    caml_fs_init();
    caml_register_global(0, [
        248,
        cst_Out_of_memory,
        -1
    ], cst_Out_of_memory);
    caml_register_global(1, [
        248,
        cst_Sys_error,
        -2
    ], cst_Sys_error);
    caml_register_global(2, [
        248,
        cst_Failure,
        -3
    ], cst_Failure);
    caml_register_global(3, [
        248,
        cst_Invalid_argument,
        -4
    ], cst_Invalid_argument);
    caml_register_global(4, [
        248,
        cst_End_of_file,
        -5
    ], cst_End_of_file);
    caml_register_global(5, [
        248,
        cst_Division_by_zero,
        -6
    ], cst_Division_by_zero);
    caml_register_global(6, [
        248,
        cst_Not_found,
        -7
    ], cst_Not_found);
    caml_register_global(7, [
        248,
        cst_Match_failure,
        -8
    ], cst_Match_failure);
    caml_register_global(8, [
        248,
        cst_Stack_overflow,
        -9
    ], cst_Stack_overflow);
    caml_register_global(9, [
        248,
        cst_Sys_blocked_io,
        -10
    ], cst_Sys_blocked_io);
    caml_register_global(10, [
        248,
        cst_Assert_failure,
        -11
    ], cst_Assert_failure);
    caml_register_global(11, [
        248,
        cst_Undefined_recursive_module,
        -12
    ], cst_Undefined_recursive_module);
    return;
})(globalThis);
(function(a) {
    "use strict";
    var hx = 289, hw = 163, hv = "Base__Pretty_printer", hu = "Base__Source_code_position0", dx = "Base__Uchar0", ht = 232, dw = 240, hs = "Base__Fn", du = 308, dv = "Jv", dq = "Base__Binary_search", dr = "Base__Monad_intf", ds = "Ocaml_intrinsics_kernel__Common", dt = "Stdlib__In_channel", hq = 218, hr = "Stdlib__Bytes", dp = "Dune__exe__Tensor_playground_web", dn = 293, hp = "Stdlib__Condition", ho = "Jstr", dm = 148, hm = 216, hn = "Out_of_memory", hk = 185, hl = 283, hj = "Base__Array", hi = "Base__Field", hh = "Failure", hg = "Stdlib__Printf", dk = 279, dl = "Stdlib", hf = "Brr_canvas", he = "Base__Hash_set", dj = "Stdlib__Filename", di = "Base__Nativeint", hc = 170, hd = "Stdio__", ha = "Base__Dictionary_mutable_intf", hb = "Base__Type_equal", dh = 238, g$ = "Stdlib__Mutex", dg = 176, de = "Ppx_expect_runtime__Current_file", df = 296, g_ = "Stdlib__ListLabels", g9 = 299, g8 = "Sexplib0__Sexp_conv_grammar", dd = 132, dc = "Base__Unit", g7 = 304, db = "Base__Int_math", da = 260, c$ = "Base__Import0", g5 = "Base__Float0", g6 = "Base__Monad", c_ = "Sexplib0__Sexp_grammar", g3 = "Match_failure", g4 = "Stdlib__Semaphore", g1 = "Base__Binary_searchable", g2 = 280, g0 = 109, c8 = 226, c9 = "Stdlib__Int64", c7 = 221, c6 = "Tensor_playground__Counter", gZ = 310, c5 = 284, gY = 265, c4 = "Time_now", gX = "Ocaml_intrinsics_kernel__Float", c3 = 139, gW = "Stdlib__Digest", gV = "Base__Either0", gT = 208, gU = "Stdlib__Type", c1 = "Base__Formatter", c2 = 107, gS = "Base__Int63", gQ = 203, gR = "Stdlib__Nativeint", gP = "Stdlib__Stack", c0 = "Undefined_recursive_module", cZ = "CamlinternalFormatBasics", cX = "Base__Error", cY = "Stdlib__Queue", gN = "Base__Intable", gO = 224, cV = "Base__Import", cW = "Base__Int64", cU = "Base__Sign_or_nan", cT = "Stdio__In_channel", cQ = 204, cR = "Base__String_intf", cS = "CamlinternalMod", gM = 192, cP = 264, cN = "Make_corrected_file__", cO = 114, cM = "Base__Dictionary_mutable", cL = "Stdlib__Parsing", cJ = "Base__Comparator", cK = 113, cH = "Base__Lazy", cI = "Stdlib__Effect", cE = "Stdlib__Bigarray", cF = "Stdlib__List", cG = "Tensor_playground__Tensor_type", cC = 256, cD = "Ppxlib_print_diff", gL = "Base__Option", cB = 111, gK = 258, gJ = "Base__Sequence", gI = 182, gH = "Base__Sexp_with_comparable", gG = "Stdlib__Atomic", cA = 135, gF = "Ppx_expect_runtime__Test_block", gE = 247, cz = "Dune__exe__Einsum_explanation", gD = 231, cy = "Stdlib__Set", cx = 123, cw = "Base__Map_intf", gC = "Base__Bytes", cv = "Ppx_expect_runtime__Expectation_intf", gB = 222, gA = 228, cu = "Base__List1", gz = 239, ct = 127, cq = 190, cr = "Base__Hash", cs = "Base__String", gy = "Brr_webcrypto", cp = "Sys_blocked_io", co = "Stdlib__Uchar", gw = "Base__Info_intf", gx = "Base__Int_intf", cn = "Stdio__Out_channel", ck = 217, cl = 205, cm = "Dune__exe__Isometric", cj = 245, gv = "Brr_webworkers", ci = "Base__Hashable", gt = "Base__Bytes0", gu = "Base__Random_repr", gr = "Ocaml_intrinsics_kernel__Conditional", gs = "Stdlib__Random", gq = "Base__Floatable", go = 137, gp = "Stdlib__Array", cf = "Assert_failure", cg = "Ppx_compare_lib", ch = "Ppx_expect_runtime__Output", ce = "Base__Array_permute", gn = "Jsoo_runtime__", cd = "Base__Comparable", gm = "Stdlib__Dynarray", cb = 131, cc = "Stdlib__BytesLabels", b9 = 152, b_ = 134, b$ = "Stdlib__Marshal", ca = "Tensor_playground__Einops", b7 = 253, b8 = 227, gl = 122, gj = "Base__Bytes_intf", gk = "Base__Either_intf", b6 = "Base__String0", gi = "Jsoo_runtime__Runtime_version", gh = "Stdlib__String", gg = "Base__Container_intf", b5 = "Base__Staged", b4 = 173, gf = "Base__Int0", b3 = 124, b2 = 235, b1 = 141, b0 = 120, bZ = 236, bY = 246, bX = "Base__Bool0", ge = "Base__Ppx_enumerate_lib", gd = 166, gc = 202, ga = 213, gb = "Dune__exe__Tensor_diagram", bW = "Sexplib0__", f9 = 210, f_ = "Ppx_expect_runtime__Test_node", f$ = "Sexplib0__Sexp", bV = "Base__Container", bU = "Base__With_return", f8 = "Ppx_expect_runtime", bT = "Inline_test_config", f7 = "Stdlib__Complex", f6 = 309, bS = "Base__Blit_intf", bQ = 181, bR = 118, f5 = "Stdlib__Sys", bO = "Base__Hash_set_intf", bP = "Base__Identifiable", f4 = "Base__Source_code_position", bN = 249, f3 = 273, f2 = 305, bM = "Base__Printf", f1 = 282, bK = "Fut", bL = "Stdlib__Char", f0 = 144, bI = "Note_brr_kit", bJ = "Stdlib__Int32", fZ = "Base__Popcount", fY = 275, fV = "Ocaml_intrinsics_kernel", fW = "Stdlib__Unit", fX = 295, bH = 151, fU = "Expect_test_config", fT = 188, fS = "Base__Hashtbl", bG = "Stack_overflow", bF = "Stdlib__Arg", fR = 183, bC = "Base__Comparable_intf", bD = 153, bE = "Base__Hashtbl_intf", fQ = 211, bB = 269, fP = "Tensor_playground__Einsum_parser_test", bA = 189, bz = 145, fO = 193, fN = "Ppx_here_lib", fL = 164, fM = 300, fK = "Ppx_hash_lib", fH = 178, fI = "Base__Queue", fJ = 272, fG = "Base__Info", by = "Stdlib__Lexing", fF = 297, fE = 187, fD = 149, bx = 162, bw = 243, fC = "Base__Bytes_tr", bv = "Base__Exn", bu = "Base__Ppx_compare_lib", fB = "Base__Set", fz = "Base__Obj_local", fA = "Ppx_inline_test_lib", fy = "Base__", bt = "Note", bs = "Tensor_playground__Einsum_parser", br = 115, bp = 270, bq = "Stdlib__Float", bo = "Base__Option_array", fw = 215, fx = "Base__Equal", bn = 143, bm = "Base__Char", bl = 104, bk = "Ppx_expect_runtime__Expectation", bj = "Base__Nothing", fv = "Stdlib__Obj", fs = 180, ft = 197, fu = 303, bi = 291, fp = 129, fq = "Base__Dictionary_immutable_intf", fr = 169, bh = "Stdlib__Map", bg = "Base__Poly0", fo = "Stdlib__Domain", be = 146, bf = 242, bd = "Stdlib__Format", fn = "Base__T", bc = "Note_brr_legacy", ba = "Base__Hash_intf", bb = "End_of_file", fm = "Brr_webgpu", a$ = "Base__Char0", fl = "Sexplib0__Sexp_conv_error", fj = 267, fk = 285, a_ = "Make_corrected_file__Import", fi = 244, a9 = "Base__Binary_searchable_intf", fh = 136, a8 = 177, fg = "Stdlib__Callback", fe = "Base__Float", ff = "Stdlib__Hashtbl", fd = 147, a7 = "Stdlib__Option", a5 = "Base__Applicative_intf", a6 = "Base__Uniform_array", fb = 125, fc = "Stdlib__MoreLabels", a4 = 219, a3 = 186, fa = "Base__Sexp", e$ = "Base__Ordering", a2 = "Base__Hashable_intf", e_ = 156, aZ = "Base__Int32", a0 = "Dune__exe__Colors", a1 = 307, e9 = 301, e7 = 154, e8 = 175, aY = "Base__Array0", e6 = "Ppx_sexp_conv_lib", aX = "Base__Hasher", aW = "Brr_webmidi", aV = "Base__Buffer", e4 = "Ocaml_intrinsics_kernel__Int64", e5 = 290, aU = 233, aT = 161, aS = "Sys_error", aR = "Base_internalhash_types", aQ = "Base__Buffer_intf", aO = 196, aP = "CamlinternalFormat", e3 = "Base__Int_conversions", e2 = "Stdlib__Printexc", e1 = "Base__Either", aN = 281, e0 = "Base__Indexed_container", aM = "Jsoo_runtime", eZ = 257, eY = "Division_by_zero", eX = "Ppx_expect_runtime__Write_corrected_file", aJ = "Base__Ordered_collection_common0", aK = "Sexplib0__Sexp_conv_record", aL = 276, eW = "Base__Dictionary_immutable", eV = 158, eS = 119, eT = 287, eU = "Stdlib__Weak", aI = 110, eP = "Base__Comparisons", eQ = "Brr_webaudio", eR = 101, aG = 128, aH = "Stdlib__StdLabels", eO = "Fmt", aF = "Base__Variant", aE = 155, eN = 255, eM = 288, aD = "Base__Ref", eJ = 261, eK = 100, eL = "Tensor_playground__Numpy", aC = 306, eI = "Base__Invariant_intf", aB = 229, eH = "Base__Stack_intf", ay = 200, az = 234, aA = 102, eG = 171, eF = "Make_corrected_file", eD = "Base__Indexed_container_intf", eE = "Base__Random", ax = "Base__Linked_queue0", eC = "Ocaml_intrinsics_kernel__Nativeint", eB = "Ocaml_intrinsics_kernel__Int", aw = "Base__Sign0", eA = 150, at = 199, au = "Expect_test_config_types", av = "Sexplib0__Sexp_conv_labeled_tuple", as = 184, ez = "Brr", aq = 237, ar = "Stdlib__Seq", ap = "Base__Identifiable_intf", ey = "Base__Queue_intf", ex = 225, an = "CamlinternalOO", ao = "Shadow_stdlib", ew = "Base__Type_equal_intf", ev = 266, eu = 172, et = 209, am = 191, al = "Stdlib__Gc", es = "Base__Sexpable", er = 206, ak = 116, eq = "Stdlib__Either", aj = "Ocaml_intrinsics_kernel__Naive_ints", eo = 212, ep = "Base__Stack", en = "Ocaml_intrinsics_kernel__Int32", ag = 259, ah = 159, ai = "Stdlib__Lazy", em = 277, el = "Tensor_playground__Util", ek = 201, af = "Base__List", ej = "Base__Backtrace", ae = "Ppx_expect_runtime__Types", ei = 278, ad = 160, eh = "Base__Fieldslib", ac = "Base__Bool", ef = 223, eg = "Not_found", ee = 230, ab = 121, aa = "Ppx_enumerate_lib", $ = 168, _ = "Invalid_argument", ed = 254, Y = 263, Z = 262, ec = "Base__Int63_emul", eb = "Base__Sys0", X = "Base__Ordered_collection_common", W = "Std_exit", V = "Jane_street_headers", ea = "Base__Blit", U = "Stdlib__StringLabels", d$ = 133, T = "Base__List0", S = 157, R = 112, Q = 140, P = "Base__Sign", O = "Base__Variantslib", d9 = "Base__Maybe_bound", d_ = "Base__Ppx_hash_lib", N = 198, d8 = "CamlinternalLazy", d7 = 207, M = "Stdlib__Scanf", K = 248, L = 174, d6 = 167, d5 = "Base__Result", J = 214, d4 = "Base__Int", d3 = 220, I = "Base__Stringable", d2 = "Base__Map", d1 = 126, H = "Tensor_playground", d0 = "Stdlib__ArrayLabels", G = 108, dZ = "Brr_io", dY = "Base__Sys", F = "Base__Avltree", dX = 241, dW = "Sexplib0__Sexpable", D = "Base__Globalize", E = "Stdlib__Bool", dV = 165, dU = 302, C = "Base__Int_string_conversions", dT = "Sexplib0__Sexp_conv", dS = "Dune__exe", z = 194, A = "Base__Pow_overflow_bounds", B = "Ppx_expect_runtime__", dR = "Base__Linked_queue", y = "Stdlib__Int", w = 271, x = "Stdlib__Oo", dQ = "Stdlib__Ephemeron", u = 130, v = 138, t = 298, dP = "Base", r = "Base__Hex_lexer", s = 106, dN = 252, dO = "Stdio", dL = 292, dM = "Stdlib__Fun", p = 179, q = 117, dK = "Base__Invariant", o = "Base__Uchar", n = 251, dJ = "Stdlib__Result", m = "Base__Set_intf", dH = "Base__Or_error", dI = "Stdlib__Buffer", dF = "Dune__exe__Frontend_util", dG = "Sexplib0", dE = "Note_brr", l = 250, dD = "Base__Obj_array", dC = "Stdlib__Out_channel", k = 268, i = "Base__Uchar_intf", j = 286, dB = "Brr_svg", g = 274, h = 103, f = 294, dA = "Base__Applicative", e = 142, dz = 105, dy = 195, d = "Base__Word_size", c = a.jsoo_runtime, b = c.caml_get_global_data();
    b.prim_count = 911;
    b.symbols = [
        0,
        [
            0,
            c0,
            11
        ],
        [
            0,
            c4,
            fJ
        ],
        [
            0,
            el,
            df
        ],
        [
            0,
            cG,
            fF
        ],
        [
            0,
            eL,
            t
        ],
        [
            0,
            fP,
            dU
        ],
        [
            0,
            bs,
            e9
        ],
        [
            0,
            ca,
            fM
        ],
        [
            0,
            c6,
            g9
        ],
        [
            0,
            H,
            fX
        ],
        [
            0,
            aS,
            10
        ],
        [
            0,
            cp,
            9
        ],
        [
            0,
            eU,
            61
        ],
        [
            0,
            fW,
            31
        ],
        [
            0,
            co,
            26
        ],
        [
            0,
            gU,
            17
        ],
        [
            0,
            f5,
            15
        ],
        [
            0,
            U,
            75
        ],
        [
            0,
            gh,
            30
        ],
        [
            0,
            aH,
            77
        ],
        [
            0,
            gP,
            42
        ],
        [
            0,
            cy,
            40
        ],
        [
            0,
            ar,
            21
        ],
        [
            0,
            g4,
            47
        ],
        [
            0,
            M,
            63
        ],
        [
            0,
            dJ,
            23
        ],
        [
            0,
            gs,
            59
        ],
        [
            0,
            cY,
            43
        ],
        [
            0,
            hg,
            50
        ],
        [
            0,
            e2,
            52
        ],
        [
            0,
            cL,
            39
        ],
        [
            0,
            dC,
            56
        ],
        [
            0,
            a7,
            22
        ],
        [
            0,
            x,
            66
        ],
        [
            0,
            fv,
            16
        ],
        [
            0,
            gR,
            37
        ],
        [
            0,
            g$,
            45
        ],
        [
            0,
            fc,
            76
        ],
        [
            0,
            b$,
            32
        ],
        [
            0,
            bh,
            41
        ],
        [
            0,
            g_,
            73
        ],
        [
            0,
            cF,
            27
        ],
        [
            0,
            by,
            38
        ],
        [
            0,
            ai,
            20
        ],
        [
            0,
            c9,
            36
        ],
        [
            0,
            bJ,
            35
        ],
        [
            0,
            y,
            28
        ],
        [
            0,
            dt,
            55
        ],
        [
            0,
            ff,
            60
        ],
        [
            0,
            al,
            54
        ],
        [
            0,
            dM,
            53
        ],
        [
            0,
            bd,
            62
        ],
        [
            0,
            bq,
            34
        ],
        [
            0,
            dj,
            70
        ],
        [
            0,
            dQ,
            69
        ],
        [
            0,
            eq,
            14
        ],
        [
            0,
            cI,
            78
        ],
        [
            0,
            gm,
            68
        ],
        [
            0,
            fo,
            48
        ],
        [
            0,
            gW,
            57
        ],
        [
            0,
            hp,
            46
        ],
        [
            0,
            f7,
            71
        ],
        [
            0,
            bL,
            25
        ],
        [
            0,
            fg,
            64
        ],
        [
            0,
            cc,
            74
        ],
        [
            0,
            hr,
            29
        ],
        [
            0,
            dI,
            44
        ],
        [
            0,
            E,
            24
        ],
        [
            0,
            cE,
            58
        ],
        [
            0,
            gG,
            18
        ],
        [
            0,
            d0,
            72
        ],
        [
            0,
            gp,
            33
        ],
        [
            0,
            bF,
            51
        ],
        [
            0,
            dl,
            13
        ],
        [
            0,
            cn,
            em
        ],
        [
            0,
            cT,
            aL
        ],
        [
            0,
            hd,
            fY
        ],
        [
            0,
            dO,
            ei
        ],
        [
            0,
            W,
            gZ
        ],
        [
            0,
            bG,
            8
        ],
        [
            0,
            ao,
            cB
        ],
        [
            0,
            dW,
            g0
        ],
        [
            0,
            c_,
            h
        ],
        [
            0,
            aK,
            G
        ],
        [
            0,
            av,
            c2
        ],
        [
            0,
            g8,
            bl
        ],
        [
            0,
            fl,
            s
        ],
        [
            0,
            dT,
            dz
        ],
        [
            0,
            f$,
            aA
        ],
        [
            0,
            bW,
            eR
        ],
        [
            0,
            dG,
            aI
        ],
        [
            0,
            cD,
            dk
        ],
        [
            0,
            e6,
            k
        ],
        [
            0,
            fA,
            f3
        ],
        [
            0,
            fN,
            g
        ],
        [
            0,
            fK,
            w
        ],
        [
            0,
            eX,
            eT
        ],
        [
            0,
            ae,
            j
        ],
        [
            0,
            f_,
            bi
        ],
        [
            0,
            gF,
            dn
        ],
        [
            0,
            ch,
            eM
        ],
        [
            0,
            cv,
            hx
        ],
        [
            0,
            bk,
            e5
        ],
        [
            0,
            de,
            dL
        ],
        [
            0,
            B,
            fk
        ],
        [
            0,
            f8,
            f
        ],
        [
            0,
            aa,
            bp
        ],
        [
            0,
            cg,
            bB
        ],
        [
            0,
            hn,
            7
        ],
        [
            0,
            eC,
            br
        ],
        [
            0,
            aj,
            cO
        ],
        [
            0,
            e4,
            ak
        ],
        [
            0,
            en,
            q
        ],
        [
            0,
            eB,
            bR
        ],
        [
            0,
            gX,
            eS
        ],
        [
            0,
            gr,
            b0
        ],
        [
            0,
            ds,
            cK
        ],
        [
            0,
            fV,
            R
        ],
        [
            0,
            bc,
            98
        ],
        [
            0,
            bI,
            97
        ],
        [
            0,
            dE,
            96
        ],
        [
            0,
            bt,
            95
        ],
        [
            0,
            eg,
            6
        ],
        [
            0,
            g3,
            5
        ],
        [
            0,
            a_,
            aN
        ],
        [
            0,
            cN,
            g2
        ],
        [
            0,
            eF,
            f1
        ],
        [
            0,
            dv,
            83
        ],
        [
            0,
            ho,
            82
        ],
        [
            0,
            gi,
            80
        ],
        [
            0,
            gn,
            79
        ],
        [
            0,
            aM,
            81
        ],
        [
            0,
            V,
            fj
        ],
        [
            0,
            _,
            4
        ],
        [
            0,
            bT,
            99
        ],
        [
            0,
            bK,
            84
        ],
        [
            0,
            eO,
            94
        ],
        [
            0,
            hh,
            3
        ],
        [
            0,
            au,
            hl
        ],
        [
            0,
            fU,
            c5
        ],
        [
            0,
            bb,
            2
        ],
        [
            0,
            dp,
            f6
        ],
        [
            0,
            gb,
            a1
        ],
        [
            0,
            cm,
            aC
        ],
        [
            0,
            dF,
            f2
        ],
        [
            0,
            cz,
            du
        ],
        [
            0,
            a0,
            g7
        ],
        [
            0,
            dS,
            fu
        ],
        [
            0,
            eY,
            1
        ],
        [
            0,
            an,
            65
        ],
        [
            0,
            cS,
            67
        ],
        [
            0,
            d8,
            19
        ],
        [
            0,
            cZ,
            12
        ],
        [
            0,
            aP,
            49
        ],
        [
            0,
            gv,
            92
        ],
        [
            0,
            aW,
            91
        ],
        [
            0,
            fm,
            88
        ],
        [
            0,
            gy,
            90
        ],
        [
            0,
            eQ,
            89
        ],
        [
            0,
            dB,
            93
        ],
        [
            0,
            dZ,
            86
        ],
        [
            0,
            hf,
            87
        ],
        [
            0,
            ez,
            85
        ],
        [
            0,
            aR,
            eK
        ],
        [
            0,
            d,
            v
        ],
        [
            0,
            bU,
            e
        ],
        [
            0,
            O,
            f0
        ],
        [
            0,
            aF,
            bn
        ],
        [
            0,
            dc,
            fE
        ],
        [
            0,
            a6,
            gO
        ],
        [
            0,
            i,
            ex
        ],
        [
            0,
            dx,
            e_
        ],
        [
            0,
            o,
            c8
        ],
        [
            0,
            ew,
            b8
        ],
        [
            0,
            hb,
            gA
        ],
        [
            0,
            fn,
            dm
        ],
        [
            0,
            eb,
            aG
        ],
        [
            0,
            dY,
            c7
        ],
        [
            0,
            I,
            as
        ],
        [
            0,
            cR,
            ga
        ],
        [
            0,
            b6,
            S
        ],
        [
            0,
            cs,
            J
        ],
        [
            0,
            b5,
            et
        ],
        [
            0,
            eH,
            aB
        ],
        [
            0,
            ep,
            gD
        ],
        [
            0,
            hu,
            eV
        ],
        [
            0,
            f4,
            ht
        ],
        [
            0,
            cU,
            aU
        ],
        [
            0,
            aw,
            p
        ],
        [
            0,
            P,
            a4
        ],
        [
            0,
            es,
            ek
        ],
        [
            0,
            gH,
            az
        ],
        [
            0,
            fa,
            fh
        ],
        [
            0,
            m,
            dw
        ],
        [
            0,
            fB,
            dX
        ],
        [
            0,
            gJ,
            ay
        ],
        [
            0,
            d5,
            aT
        ],
        [
            0,
            aD,
            bf
        ],
        [
            0,
            gu,
            fr
        ],
        [
            0,
            eE,
            hc
        ],
        [
            0,
            ey,
            bw
        ],
        [
            0,
            fI,
            fi
        ],
        [
            0,
            bM,
            ct
        ],
        [
            0,
            hv,
            Q
        ],
        [
            0,
            d_,
            cA
        ],
        [
            0,
            ge,
            at
        ],
        [
            0,
            bu,
            b_
        ],
        [
            0,
            A,
            d7
        ],
        [
            0,
            fZ,
            hq
        ],
        [
            0,
            bg,
            b3
        ],
        [
            0,
            e$,
            b4
        ],
        [
            0,
            aJ,
            $
        ],
        [
            0,
            X,
            fT
        ],
        [
            0,
            dH,
            fH
        ],
        [
            0,
            bo,
            ee
        ],
        [
            0,
            gL,
            N
        ],
        [
            0,
            fz,
            gB
        ],
        [
            0,
            dD,
            ef
        ],
        [
            0,
            bj,
            cj
        ],
        [
            0,
            di,
            bY
        ],
        [
            0,
            dr,
            be
        ],
        [
            0,
            g6,
            fd
        ],
        [
            0,
            d9,
            dh
        ],
        [
            0,
            cw,
            gz
        ],
        [
            0,
            d2,
            gE
        ],
        [
            0,
            cu,
            ad
        ],
        [
            0,
            T,
            dd
        ],
        [
            0,
            af,
            L
        ],
        [
            0,
            ax,
            K
        ],
        [
            0,
            dR,
            bN
        ],
        [
            0,
            cH,
            gd
        ],
        [
            0,
            eI,
            ah
        ],
        [
            0,
            dK,
            a8
        ],
        [
            0,
            gN,
            cl
        ],
        [
            0,
            C,
            ck
        ],
        [
            0,
            db,
            gT
        ],
        [
            0,
            gx,
            er
        ],
        [
            0,
            e3,
            aE
        ],
        [
            0,
            cW,
            l
        ],
        [
            0,
            ec,
            n
        ],
        [
            0,
            gS,
            b7
        ],
        [
            0,
            aZ,
            dN
        ],
        [
            0,
            gf,
            d1
        ],
        [
            0,
            d4,
            d3
        ],
        [
            0,
            gw,
            d6
        ],
        [
            0,
            fG,
            e8
        ],
        [
            0,
            eD,
            fL
        ],
        [
            0,
            e0,
            dV
        ],
        [
            0,
            c$,
            fb
        ],
        [
            0,
            cV,
            go
        ],
        [
            0,
            ap,
            hk
        ],
        [
            0,
            bP,
            a3
        ],
        [
            0,
            r,
            hm
        ],
        [
            0,
            bE,
            cC
        ],
        [
            0,
            fS,
            gK
        ],
        [
            0,
            aX,
            aq
        ],
        [
            0,
            a2,
            gI
        ],
        [
            0,
            ci,
            fR
        ],
        [
            0,
            bO,
            ag
        ],
        [
            0,
            he,
            da
        ],
        [
            0,
            ba,
            cb
        ],
        [
            0,
            cr,
            d$
        ],
        [
            0,
            D,
            cx
        ],
        [
            0,
            c1,
            c3
        ],
        [
            0,
            hs,
            bz
        ],
        [
            0,
            gq,
            gQ
        ],
        [
            0,
            g5,
            cQ
        ],
        [
            0,
            fe,
            eJ
        ],
        [
            0,
            eh,
            Z
        ],
        [
            0,
            hi,
            e7
        ],
        [
            0,
            bv,
            b1
        ],
        [
            0,
            cX,
            dg
        ],
        [
            0,
            fx,
            eu
        ],
        [
            0,
            gk,
            aO
        ],
        [
            0,
            gV,
            bD
        ],
        [
            0,
            e1,
            ft
        ],
        [
            0,
            ha,
            ed
        ],
        [
            0,
            cM,
            eN
        ],
        [
            0,
            fq,
            b2
        ],
        [
            0,
            eW,
            bZ
        ],
        [
            0,
            gg,
            bx
        ],
        [
            0,
            bV,
            hw
        ],
        [
            0,
            eP,
            b9
        ],
        [
            0,
            cJ,
            bH
        ],
        [
            0,
            bC,
            fs
        ],
        [
            0,
            cd,
            bQ
        ],
        [
            0,
            a$,
            u
        ],
        [
            0,
            bm,
            fQ
        ],
        [
            0,
            fC,
            eo
        ],
        [
            0,
            gj,
            f9
        ],
        [
            0,
            gt,
            fO
        ],
        [
            0,
            gC,
            fw
        ],
        [
            0,
            aQ,
            Y
        ],
        [
            0,
            aV,
            cP
        ],
        [
            0,
            bX,
            gl
        ],
        [
            0,
            ac,
            dy
        ],
        [
            0,
            bS,
            gM
        ],
        [
            0,
            ea,
            z
        ],
        [
            0,
            a9,
            cq
        ],
        [
            0,
            g1,
            am
        ],
        [
            0,
            dq,
            bA
        ],
        [
            0,
            ej,
            gY
        ],
        [
            0,
            F,
            eZ
        ],
        [
            0,
            ce,
            eG
        ],
        [
            0,
            aY,
            fp
        ],
        [
            0,
            hj,
            gc
        ],
        [
            0,
            a5,
            fD
        ],
        [
            0,
            dA,
            eA
        ],
        [
            0,
            fy,
            ab
        ],
        [
            0,
            dP,
            ev
        ],
        [
            0,
            cf,
            0
        ]
    ];
    var hy = [
        0,
        ej
    ], hz = [
        0,
        ea
    ], hA = [
        0,
        ac
    ], hB = [
        0,
        0,
        [
            0,
            gt
        ],
        fO,
        0,
        1
    ], hC = [
        0,
        gC
    ], hD = [
        0,
        [
            0,
            0,
            [
                0,
                aV
            ],
            cP,
            0,
            1
        ],
        [
            0,
            aQ
        ],
        Y,
        0,
        2
    ], hE = [
        0,
        bm
    ], hF = [
        0,
        0,
        [
            0,
            fC
        ],
        eo,
        0,
        1
    ], hG = [
        0,
        bC
    ], hH = [
        0,
        0,
        [
            0,
            cd
        ],
        bQ,
        0,
        1
    ], hI = [
        0,
        0,
        [
            0,
            bV
        ],
        hw,
        0,
        1
    ], hJ = [
        0,
        eP
    ], hK = [
        0,
        0,
        [
            0,
            cM
        ],
        eN,
        0,
        1
    ], hL = [
        0,
        fq
    ], hM = [
        0,
        0,
        [
            0,
            eW
        ],
        bZ,
        0,
        1
    ], hN = [
        0,
        e1
    ], hO = [
        0,
        gk
    ], hP = [
        0,
        cX
    ], hQ = [
        0,
        eh
    ], hR = [
        0,
        bO
    ], hS = [
        0,
        0,
        [
            0,
            he
        ],
        da,
        0,
        1
    ], hT = [
        0,
        bE
    ], hU = [
        0,
        0,
        [
            0,
            fS
        ],
        gK,
        0,
        1
    ], hV = [
        0,
        bP
    ], hW = [
        0,
        cV
    ], hX = [
        0,
        ec
    ], hY = [
        0,
        0,
        [
            0,
            aZ
        ],
        dN,
        [
            0,
            0,
            [
                0,
                gS
            ],
            b7,
            0,
            1
        ],
        2
    ], hZ = [
        0,
        e3
    ], h0 = [
        0,
        0,
        [
            0,
            C
        ],
        ck,
        0,
        1
    ], h1 = [
        0,
        db
    ], h2 = [
        0,
        dK
    ], h3 = [
        0,
        dR
    ], h4 = [
        0,
        cw
    ], h5 = [
        0,
        0,
        [
            0,
            d2
        ],
        gE,
        0,
        1
    ], h6 = [
        0,
        0,
        [
            0,
            fz
        ],
        gB,
        0,
        1
    ], h7 = [
        0,
        dD
    ], h8 = [
        0,
        [
            0,
            0,
            [
                0,
                di
            ],
            bY,
            0,
            1
        ],
        [
            0,
            bj
        ],
        cj,
        0,
        2
    ], h9 = [
        0,
        bo
    ], h_ = [
        0,
        X
    ], h$ = [
        0,
        e$
    ], ia = [
        0,
        ey
    ], ib = [
        0,
        0,
        [
            0,
            fI
        ],
        fi,
        0,
        1
    ], ic = [
        0,
        fB
    ], id = [
        0,
        gH
    ], ie = [
        0,
        P
    ], ig = [
        0,
        cU
    ], ih = [
        0,
        ep
    ], ii = [
        0,
        hb
    ], ij = [
        0,
        i
    ], ik = [
        0,
        dB
    ], il = [
        0,
        gy
    ], im = [
        0,
        gv
    ], io = [
        0,
        cS
    ], ip = [
        0,
        cz
    ], iq = [
        0,
        0,
        [
            0,
            gb
        ],
        a1,
        [
            0,
            0,
            [
                0,
                dp
            ],
            f6,
            0,
            1
        ],
        2
    ], ir = [
        0,
        cm
    ], is = [
        0,
        fU
    ], it = [
        0,
        eO
    ], iu = [
        0,
        bT
    ], iv = [
        0,
        V
    ], iw = [
        0,
        0,
        [
            0,
            a_
        ],
        aN,
        0,
        1
    ], ix = [
        0,
        cN
    ], iy = [
        0,
        0,
        [
            0,
            eF
        ],
        f1,
        0,
        1
    ], iz = [
        0,
        eg
    ], iA = [
        0,
        bI
    ], iB = [
        0,
        fV
    ], iC = [
        0,
        gX
    ], iD = [
        0,
        0,
        [
            0,
            gr
        ],
        b0,
        0,
        1
    ], iE = [
        0,
        e4
    ], iF = [
        0,
        eC
    ], iG = [
        0,
        cg
    ], iH = [
        0,
        f8
    ], iI = [
        0,
        cv
    ], iJ = [
        0,
        [
            0,
            0,
            [
                0,
                de
            ],
            dL,
            0,
            1
        ],
        [
            0,
            bk
        ],
        e5,
        0,
        2
    ], iK = [
        0,
        f_
    ], iL = [
        0,
        0,
        [
            0,
            gF
        ],
        dn,
        0,
        1
    ], iM = [
        0,
        eX
    ], iN = [
        0,
        fA
    ], iO = [
        0,
        0,
        [
            0,
            fN
        ],
        g,
        0,
        1
    ], iP = [
        0,
        0,
        [
            0,
            bW
        ],
        eR,
        0,
        1
    ], iQ = [
        0,
        dG
    ], iR = [
        0,
        0,
        [
            0,
            cD
        ],
        dk,
        0,
        1
    ], iS = [
        0,
        0,
        [
            0,
            fl
        ],
        s,
        0,
        1
    ], iT = [
        0,
        dT
    ], iU = [
        0,
        ao
    ], iV = [
        0,
        dO
    ], iW = [
        0,
        0,
        [
            0,
            W
        ],
        gZ,
        0,
        1
    ], iX = [
        0,
        0,
        [
            0,
            cn
        ],
        em,
        0,
        1
    ], iY = [
        0,
        cT
    ], iZ = [
        0,
        cI
    ], i0 = [
        0,
        dj
    ], i1 = [
        0,
        ff
    ], i2 = [
        0,
        x
    ], i3 = [
        0,
        dC
    ], i4 = [
        0,
        e2
    ], i5 = [
        0,
        M
    ], i6 = [
        0,
        aH
    ], i7 = [
        0,
        aS
    ], i8 = [
        0,
        0,
        [
            0,
            fP
        ],
        dU,
        0,
        1
    ], i9 = [
        0,
        bs
    ], i_ = [
        0,
        c0
    ];
    b.sections = [
        0,
        [
            0,
            311,
            [
                0,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cf
                                        ],
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dP
                                            ],
                                            ev,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        fy
                                    ],
                                    ab,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dA
                                            ],
                                            eA,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            a5
                                        ],
                                        fD,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hj
                                            ],
                                            gc,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    aY
                                ],
                                fp,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            ce
                                        ],
                                        eG,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                F
                                            ],
                                            eZ,
                                            [
                                                0,
                                                0,
                                                hy,
                                                gY,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dq
                                    ],
                                    bA,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g1
                                            ],
                                            am,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            a9
                                        ],
                                        cq,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hz,
                                                z,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bS
                                            ],
                                            gM,
                                            [
                                                0,
                                                0,
                                                hA,
                                                dy,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                5
                            ],
                            [
                                0,
                                bX
                            ],
                            gl,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hD,
                                                hC,
                                                fw,
                                                hB,
                                                3
                                            ],
                                            [
                                                0,
                                                gj
                                            ],
                                            f9,
                                            [
                                                0,
                                                hF,
                                                hE,
                                                fQ,
                                                0,
                                                2
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            a$
                                        ],
                                        u,
                                        [
                                            0,
                                            [
                                                0,
                                                hH,
                                                hG,
                                                fs,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                cJ
                                            ],
                                            bH,
                                            [
                                                0,
                                                0,
                                                hJ,
                                                b9,
                                                hI,
                                                2
                                            ],
                                            3
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        gg
                                    ],
                                    bx,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hM,
                                                hL,
                                                b2,
                                                hK,
                                                2
                                            ],
                                            [
                                                0,
                                                ha
                                            ],
                                            ed,
                                            [
                                                0,
                                                0,
                                                hN,
                                                ft,
                                                0,
                                                1
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            gV
                                        ],
                                        bD,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hO,
                                                aO,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fx
                                            ],
                                            eu,
                                            [
                                                0,
                                                0,
                                                hP,
                                                dg,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    bv
                                ],
                                b1,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            hi
                                        ],
                                        e7,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hQ,
                                                Z,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fe
                                            ],
                                            eJ,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        g5
                                    ],
                                    cQ,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gq
                                            ],
                                            gQ,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            hs
                                        ],
                                        bz,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                c1
                                            ],
                                            c3,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    4
                                ],
                                7
                            ],
                            8
                        ],
                        [
                            0,
                            D
                        ],
                        cx,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cr
                                            ],
                                            d$,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            ba
                                        ],
                                        cb,
                                        [
                                            0,
                                            [
                                                0,
                                                hS,
                                                hR,
                                                ag,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                ci
                                            ],
                                            fR,
                                            0,
                                            3
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        a2
                                    ],
                                    gI,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aX
                                            ],
                                            aq,
                                            [
                                                0,
                                                hU,
                                                hT,
                                                cC,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            r
                                        ],
                                        hm,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                hV,
                                                a3,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                ap
                                            ],
                                            hk,
                                            [
                                                0,
                                                0,
                                                hW,
                                                go,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                [
                                    0,
                                    c$
                                ],
                                fb,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            e0
                                        ],
                                        dV,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        eD
                                    ],
                                    fL,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fG
                                            ],
                                            e8,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            gw
                                        ],
                                        d6,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                d4
                                            ],
                                            d3,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                6
                            ],
                            [
                                0,
                                gf
                            ],
                            d1,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                hY,
                                                hX,
                                                n,
                                                0,
                                                3
                                            ],
                                            [
                                                0,
                                                cW
                                            ],
                                            l,
                                            [
                                                0,
                                                0,
                                                hZ,
                                                aE,
                                                0,
                                                1
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            gx
                                        ],
                                        er,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                h1,
                                                gT,
                                                h0,
                                                2
                                            ],
                                            [
                                                0,
                                                gN
                                            ],
                                            cl,
                                            [
                                                0,
                                                0,
                                                h2,
                                                a8,
                                                0,
                                                1
                                            ],
                                            3
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        eI
                                    ],
                                    ah,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cH
                                            ],
                                            gd,
                                            [
                                                0,
                                                0,
                                                h3,
                                                bN,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            ax
                                        ],
                                        K,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                af
                                            ],
                                            L,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    T
                                ],
                                dd,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cu
                                            ],
                                            ad,
                                            [
                                                0,
                                                h5,
                                                h4,
                                                gz,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            d9
                                        ],
                                        dh,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g6
                                            ],
                                            fd,
                                            0,
                                            1
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        dr
                                    ],
                                    be,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                h8,
                                                h7,
                                                ef,
                                                h6,
                                                3
                                            ],
                                            [
                                                0,
                                                gL
                                            ],
                                            N,
                                            [
                                                0,
                                                0,
                                                h9,
                                                ee,
                                                0,
                                                1
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            dH
                                        ],
                                        fH,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                h_,
                                                fT,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aJ
                                            ],
                                            $,
                                            [
                                                0,
                                                0,
                                                h$,
                                                b4,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        5
                                    ],
                                    6
                                ],
                                7
                            ],
                            8
                        ],
                        9
                    ],
                    [
                        0,
                        bg
                    ],
                    b3,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fZ
                                            ],
                                            hq,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            A
                                        ],
                                        d7,
                                        0,
                                        2
                                    ],
                                    [
                                        0,
                                        bu
                                    ],
                                    b_,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                ge
                                            ],
                                            at,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            d_
                                        ],
                                        cA,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hv
                                            ],
                                            Q,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    bM
                                ],
                                ct,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                ib,
                                                ia,
                                                bw,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                eE
                                            ],
                                            hc,
                                            0,
                                            3
                                        ],
                                        [
                                            0,
                                            gu
                                        ],
                                        fr,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aD
                                            ],
                                            bf,
                                            0,
                                            1
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        d5
                                    ],
                                    aT,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            gJ
                                        ],
                                        ay,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ic,
                                                dX,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                m
                                            ],
                                            dw,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    5
                                ],
                                6
                            ],
                            [
                                0,
                                fa
                            ],
                            fh,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                id,
                                                az,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                es
                                            ],
                                            ek,
                                            [
                                                0,
                                                0,
                                                ie,
                                                a4,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            aw
                                        ],
                                        p,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ig,
                                                aU,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                f4
                                            ],
                                            ht,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        hu
                                    ],
                                    eV,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ih,
                                                gD,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                eH
                                            ],
                                            aB,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            b5
                                        ],
                                        et,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cs
                                            ],
                                            J,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    b6
                                ],
                                S,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cR
                                        ],
                                        ga,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        I
                                    ],
                                    as,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            dY
                                        ],
                                        c7,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                5
                            ],
                            7
                        ],
                        [
                            0,
                            eb
                        ],
                        aG,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fn
                                            ],
                                            dm,
                                            [
                                                0,
                                                0,
                                                ii,
                                                gA,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            ew
                                        ],
                                        b8,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                o
                                            ],
                                            c8,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dx
                                    ],
                                    e_,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ij,
                                                ex,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                a6
                                            ],
                                            gO,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            dc
                                        ],
                                        fE,
                                        0,
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    aF
                                ],
                                bn,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                O
                                            ],
                                            f0,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            bU
                                        ],
                                        e,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                d
                                            ],
                                            v,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        aR
                                    ],
                                    eK,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            ez
                                        ],
                                        85,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                hf
                                            ],
                                            87,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                5
                            ],
                            [
                                0,
                                dZ
                            ],
                            86,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ik,
                                                93,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                eQ
                                            ],
                                            89,
                                            [
                                                0,
                                                0,
                                                il,
                                                90,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            fm
                                        ],
                                        88,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aW
                                            ],
                                            91,
                                            [
                                                0,
                                                0,
                                                im,
                                                92,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        aP
                                    ],
                                    49,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cZ
                                        ],
                                        12,
                                        0,
                                        1
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    d8
                                ],
                                19,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                io,
                                                67,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                an
                                            ],
                                            65,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            eY
                                        ],
                                        1,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dS
                                            ],
                                            fu,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        a0
                                    ],
                                    g7,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                ip,
                                                du,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                dF
                                            ],
                                            f2,
                                            [
                                                0,
                                                0,
                                                ir,
                                                aC,
                                                iq,
                                                3
                                            ],
                                            4
                                        ],
                                        [
                                            0,
                                            bb
                                        ],
                                        2,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                is,
                                                c5,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                au
                                            ],
                                            hl,
                                            0,
                                            2
                                        ],
                                        5
                                    ],
                                    6
                                ],
                                7
                            ],
                            8
                        ],
                        9
                    ],
                    10
                ],
                [
                    0,
                    hh
                ],
                3,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                it,
                                                94,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bK
                                            ],
                                            84,
                                            [
                                                0,
                                                0,
                                                iu,
                                                99,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            _
                                        ],
                                        4,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iv,
                                                fj,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aM
                                            ],
                                            81,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        gn
                                    ],
                                    79,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gi
                                            ],
                                            80,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            ho
                                        ],
                                        82,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dv
                                            ],
                                            83,
                                            [
                                                0,
                                                iy,
                                                ix,
                                                g2,
                                                iw,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                [
                                    0,
                                    g3
                                ],
                                5,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iz,
                                                6,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bt
                                            ],
                                            95,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            dE
                                        ],
                                        96,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iA,
                                                97,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                bc
                                            ],
                                            98,
                                            [
                                                0,
                                                0,
                                                iB,
                                                R,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        ds
                                    ],
                                    cK,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                iD,
                                                iC,
                                                eS,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                eB
                                            ],
                                            bR,
                                            0,
                                            3
                                        ],
                                        [
                                            0,
                                            en
                                        ],
                                        q,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iE,
                                                ak,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aj
                                            ],
                                            cO,
                                            [
                                                0,
                                                0,
                                                iF,
                                                br,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                6
                            ],
                            [
                                0,
                                hn
                            ],
                            7,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iG,
                                                bB,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                aa
                                            ],
                                            bp,
                                            [
                                                0,
                                                0,
                                                iH,
                                                f,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            B
                                        ],
                                        fk,
                                        [
                                            0,
                                            [
                                                0,
                                                iJ,
                                                iI,
                                                hx,
                                                0,
                                                3
                                            ],
                                            [
                                                0,
                                                ch
                                            ],
                                            eM,
                                            [
                                                0,
                                                iL,
                                                iK,
                                                bi,
                                                0,
                                                2
                                            ],
                                            4
                                        ],
                                        5
                                    ],
                                    [
                                        0,
                                        ae
                                    ],
                                    j,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                iM,
                                                eT,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                fK
                                            ],
                                            w,
                                            [
                                                0,
                                                iO,
                                                iN,
                                                f3,
                                                0,
                                                2
                                            ],
                                            3
                                        ],
                                        [
                                            0,
                                            e6
                                        ],
                                        k,
                                        [
                                            0,
                                            [
                                                0,
                                                iR,
                                                iQ,
                                                aI,
                                                iP,
                                                2
                                            ],
                                            [
                                                0,
                                                f$
                                            ],
                                            aA,
                                            [
                                                0,
                                                0,
                                                iT,
                                                dz,
                                                iS,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    6
                                ],
                                [
                                    0,
                                    g8
                                ],
                                bl,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            av
                                        ],
                                        c2,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                aK
                                            ],
                                            G,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    [
                                        0,
                                        c_
                                    ],
                                    h,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dW
                                            ],
                                            g0,
                                            [
                                                0,
                                                0,
                                                iU,
                                                cB,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            bG
                                        ],
                                        8,
                                        [
                                            0,
                                            [
                                                0,
                                                iW,
                                                iV,
                                                ei,
                                                0,
                                                2
                                            ],
                                            [
                                                0,
                                                hd
                                            ],
                                            fY,
                                            [
                                                0,
                                                0,
                                                iY,
                                                aL,
                                                iX,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    5
                                ],
                                7
                            ],
                            8
                        ],
                        [
                            0,
                            dl
                        ],
                        13,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            bF
                                        ],
                                        51,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        gp
                                    ],
                                    33,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            d0
                                        ],
                                        72,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                [
                                    0,
                                    gG
                                ],
                                18,
                                [
                                    0,
                                    0,
                                    [
                                        0,
                                        cE
                                    ],
                                    58,
                                    0,
                                    1
                                ],
                                3
                            ],
                            [
                                0,
                                E
                            ],
                            24,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            dI
                                        ],
                                        44,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        hr
                                    ],
                                    29,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cc
                                            ],
                                            74,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            fg
                                        ],
                                        64,
                                        0,
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    bL
                                ],
                                25,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            f7
                                        ],
                                        71,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        hp
                                    ],
                                    46,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gW
                                            ],
                                            57,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            fo
                                        ],
                                        48,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gm
                                            ],
                                            68,
                                            [
                                                0,
                                                0,
                                                iZ,
                                                78,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                5
                            ],
                            6
                        ],
                        9
                    ],
                    [
                        0,
                        eq
                    ],
                    14,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                dQ
                                            ],
                                            69,
                                            [
                                                0,
                                                0,
                                                i0,
                                                70,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            bq
                                        ],
                                        34,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                bd
                                            ],
                                            62,
                                            0,
                                            1
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        dM
                                    ],
                                    53,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            al
                                        ],
                                        54,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i1,
                                                60,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                dt
                                            ],
                                            55,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    y
                                ],
                                28,
                                [
                                    0,
                                    0,
                                    [
                                        0,
                                        bJ
                                    ],
                                    35,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            c9
                                        ],
                                        36,
                                        0,
                                        1
                                    ],
                                    2
                                ],
                                5
                            ],
                            [
                                0,
                                ai
                            ],
                            20,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            by
                                        ],
                                        38,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        cF
                                    ],
                                    27,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                g_
                                            ],
                                            73,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            bh
                                        ],
                                        41,
                                        0,
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    b$
                                ],
                                32,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                fc
                                            ],
                                            76,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            g$
                                        ],
                                        45,
                                        0,
                                        2
                                    ],
                                    [
                                        0,
                                        gR
                                    ],
                                    37,
                                    0,
                                    3
                                ],
                                4
                            ],
                            6
                        ],
                        [
                            0,
                            fv
                        ],
                        16,
                        [
                            0,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i2,
                                                66,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                a7
                                            ],
                                            22,
                                            [
                                                0,
                                                0,
                                                i3,
                                                56,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        [
                                            0,
                                            cL
                                        ],
                                        39,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i4,
                                                52,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                hg
                                            ],
                                            50,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        cY
                                    ],
                                    43,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gs
                                            ],
                                            59,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            dJ
                                        ],
                                        23,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i5,
                                                63,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                g4
                                            ],
                                            47,
                                            0,
                                            2
                                        ],
                                        3
                                    ],
                                    4
                                ],
                                [
                                    0,
                                    ar
                                ],
                                21,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            cy
                                        ],
                                        40,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                gP
                                            ],
                                            42,
                                            [
                                                0,
                                                0,
                                                i6,
                                                77,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    [
                                        0,
                                        gh
                                    ],
                                    30,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            U
                                        ],
                                        75,
                                        0,
                                        1
                                    ],
                                    4
                                ],
                                5
                            ],
                            [
                                0,
                                f5
                            ],
                            15,
                            [
                                0,
                                [
                                    0,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            gU
                                        ],
                                        17,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        co
                                    ],
                                    26,
                                    [
                                        0,
                                        0,
                                        [
                                            0,
                                            fW
                                        ],
                                        31,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                eU
                                            ],
                                            61,
                                            0,
                                            1
                                        ],
                                        2
                                    ],
                                    3
                                ],
                                [
                                    0,
                                    cp
                                ],
                                9,
                                [
                                    0,
                                    [
                                        0,
                                        [
                                            0,
                                            [
                                                0,
                                                0,
                                                i7,
                                                10,
                                                0,
                                                1
                                            ],
                                            [
                                                0,
                                                H
                                            ],
                                            fX,
                                            0,
                                            2
                                        ],
                                        [
                                            0,
                                            c6
                                        ],
                                        g9,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                ca
                                            ],
                                            fM,
                                            [
                                                0,
                                                0,
                                                i9,
                                                e9,
                                                i8,
                                                2
                                            ],
                                            3
                                        ],
                                        4
                                    ],
                                    [
                                        0,
                                        eL
                                    ],
                                    t,
                                    [
                                        0,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                cG
                                            ],
                                            fF,
                                            0,
                                            1
                                        ],
                                        [
                                            0,
                                            el
                                        ],
                                        df,
                                        [
                                            0,
                                            0,
                                            [
                                                0,
                                                c4
                                            ],
                                            fJ,
                                            [
                                                0,
                                                0,
                                                i_,
                                                11,
                                                0,
                                                1
                                            ],
                                            2
                                        ],
                                        3
                                    ],
                                    5
                                ],
                                6
                            ],
                            7
                        ],
                        8
                    ],
                    10
                ],
                11
            ]
        ],
        0,
        c.caml_list_of_js_array([
            "%caml_format_int_special",
            "%direct_int_div",
            "%direct_int_mod",
            "%direct_int_mul",
            "%direct_obj_tag",
            "%identity",
            "%int_add",
            "%int_and",
            "%int_asr",
            "%int_div",
            "%int_lsl",
            "%int_lsr",
            "%int_mod",
            "%int_mul",
            "%int_neg",
            "%int_or",
            "%int_sub",
            "%int_xor",
            "Base_am_testing",
            "Base_caml_exn_is_most_recent_exn",
            "Base_clear_caml_backtrace_pos",
            "Base_hash_double",
            "Base_hash_string",
            "Base_int_math_int32_clz",
            "Base_int_math_int32_ctz",
            "Base_int_math_int64_clz",
            "Base_int_math_int64_ctz",
            "Base_int_math_int64_pow_stub",
            "Base_int_math_int_clz",
            "Base_int_math_int_ctz",
            "Base_int_math_int_popcount",
            "Base_int_math_int_pow_stub",
            "Base_int_math_nativeint_clz",
            "Base_int_math_nativeint_ctz",
            "Base_internalhash_fold_float",
            "Base_internalhash_fold_int",
            "Base_internalhash_fold_int64",
            "Base_internalhash_fold_string",
            "Base_internalhash_get_hash_value",
            "Base_unsafe_create_local_bytes",
            "BigStringReader",
            "MlBytes",
            "MlChanid",
            "MlFakeDevice",
            "MlFakeFd",
            "MlFakeFd_out",
            "MlFakeFile",
            "MlFile",
            "MlInt64",
            "MlMutex",
            "MlNat",
            "MlNodeDevice",
            "MlNodeFd",
            "MlObjectTable",
            "MlStringReader",
            "Ml_Bigarray",
            "Ml_Bigarray_c_1_1",
            "UInt8ArrayReader",
            "add_nat",
            "bigstring_of_array_buffer",
            "bigstring_of_typed_array",
            "bigstring_to_array_buffer",
            "bigstring_to_typed_array",
            "blake2b",
            "blit_nat",
            "caml_MD5Final",
            "caml_MD5Init",
            "caml_MD5Transform",
            "caml_MD5Update",
            "caml_abs_float",
            "caml_acos_float",
            "caml_acosh_float",
            "caml_add_float",
            "caml_alloc_dummy",
            "caml_alloc_dummy_float",
            "caml_alloc_dummy_infix",
            "caml_alloc_stack",
            "caml_argv",
            "caml_array_append",
            "caml_array_blit",
            "caml_array_bound_error",
            "caml_array_concat",
            "caml_array_create_float",
            "caml_array_fill",
            "caml_array_get",
            "caml_array_get_addr",
            "caml_array_get_float",
            "caml_array_make",
            "caml_array_of_bytes",
            "caml_array_of_string",
            "caml_array_of_uniform_array",
            "caml_array_set",
            "caml_array_set_addr",
            "caml_array_set_float",
            "caml_array_sub",
            "caml_array_unsafe_get",
            "caml_array_unsafe_get_float",
            "caml_array_unsafe_set",
            "caml_array_unsafe_set_addr",
            "caml_array_unsafe_set_float",
            "caml_asin_float",
            "caml_asinh_float",
            "caml_atan2_float",
            "caml_atan_float",
            "caml_atanh_float",
            "caml_atomic_cas",
            "caml_atomic_exchange",
            "caml_atomic_fetch_add",
            "caml_atomic_load",
            "caml_atomic_make_contended",
            "caml_ba_blit",
            "caml_ba_change_layout",
            "caml_ba_compare",
            "caml_ba_create",
            "caml_ba_create_buffer",
            "caml_ba_create_from",
            "caml_ba_create_unsafe",
            "caml_ba_custom_name",
            "caml_ba_deserialize",
            "caml_ba_dim",
            "caml_ba_dim_1",
            "caml_ba_dim_2",
            "caml_ba_dim_3",
            "caml_ba_fill",
            "caml_ba_from_typed_array",
            "caml_ba_get_1",
            "caml_ba_get_2",
            "caml_ba_get_3",
            "caml_ba_get_generic",
            "caml_ba_get_size",
            "caml_ba_get_size_per_element",
            "caml_ba_hash",
            "caml_ba_init",
            "caml_ba_kind",
            "caml_ba_kind_of_typed_array",
            "caml_ba_layout",
            "caml_ba_map_file",
            "caml_ba_map_file_bytecode",
            "caml_ba_num_dims",
            "caml_ba_reshape",
            "caml_ba_serialize",
            "caml_ba_set_1",
            "caml_ba_set_2",
            "caml_ba_set_3",
            "caml_ba_set_generic",
            "caml_ba_slice",
            "caml_ba_sub",
            "caml_ba_to_typed_array",
            "caml_ba_uint8_get16",
            "caml_ba_uint8_get32",
            "caml_ba_uint8_get64",
            "caml_ba_uint8_set16",
            "caml_ba_uint8_set32",
            "caml_ba_uint8_set64",
            "caml_backtrace_status",
            "caml_bigstring_blit_ba_to_ba",
            "caml_bigstring_blit_ba_to_bytes",
            "caml_bigstring_blit_bytes_to_ba",
            "caml_bigstring_blit_string_to_ba",
            "caml_bigstring_memcmp",
            "caml_blake2_bytes",
            "caml_blake2_create",
            "caml_blake2_final",
            "caml_blake2_string",
            "caml_blake2_update",
            "caml_blit_bytes",
            "caml_blit_string",
            "caml_bswap16",
            "caml_build_symbols",
            "caml_bytes_bound_error",
            "caml_bytes_compare",
            "caml_bytes_equal",
            "caml_bytes_get",
            "caml_bytes_get16",
            "caml_bytes_get32",
            "caml_bytes_get64",
            "caml_bytes_greaterequal",
            "caml_bytes_greaterthan",
            "caml_bytes_lessequal",
            "caml_bytes_lessthan",
            "caml_bytes_notequal",
            "caml_bytes_of_array",
            "caml_bytes_of_jsbytes",
            "caml_bytes_of_string",
            "caml_bytes_of_uint8_array",
            "caml_bytes_of_utf16_jsstring",
            "caml_bytes_set",
            "caml_bytes_set16",
            "caml_bytes_set32",
            "caml_bytes_set64",
            "caml_bytes_unsafe_get",
            "caml_bytes_unsafe_set",
            "caml_call_gen",
            "caml_callback",
            "caml_cbrt_float",
            "caml_ceil_float",
            "caml_channel_descriptor",
            "caml_check_bound",
            "caml_check_bound_float",
            "caml_check_bound_gen",
            "caml_classify_float",
            "caml_compare",
            "caml_compare_val",
            "caml_compare_val_get_custom",
            "caml_compare_val_number_custom",
            "caml_compare_val_tag",
            "caml_continuation_use_and_update_handler_noexc",
            "caml_continuation_use_noexc",
            "caml_convert_bytes_to_array",
            "caml_convert_raw_backtrace",
            "caml_convert_raw_backtrace_slot",
            "caml_convert_string_to_bytes",
            "caml_copysign_float",
            "caml_cos_float",
            "caml_cosh_float",
            "caml_create_bytes",
            "caml_create_file",
            "caml_create_string",
            "caml_csel_value",
            "caml_current_dir",
            "caml_custom_event_index",
            "caml_custom_identifier",
            "caml_custom_ops",
            "caml_decompress_input",
            "caml_div",
            "caml_div_float",
            "caml_domain_dls",
            "caml_domain_dls_compare_and_set",
            "caml_domain_dls_get",
            "caml_domain_dls_set",
            "caml_domain_id",
            "caml_domain_spawn",
            "caml_dummy_obj_is_stack",
            "caml_ensure_stack_capacity",
            "caml_ephe_blit_data",
            "caml_ephe_blit_key",
            "caml_ephe_check_data",
            "caml_ephe_check_key",
            "caml_ephe_create",
            "caml_ephe_data_offset",
            "caml_ephe_get_data",
            "caml_ephe_get_data_copy",
            "caml_ephe_get_key",
            "caml_ephe_get_key_copy",
            "caml_ephe_key_offset",
            "caml_ephe_none",
            "caml_ephe_set_data",
            "caml_ephe_set_data_opt",
            "caml_ephe_set_key",
            "caml_ephe_unset_data",
            "caml_ephe_unset_key",
            "caml_eq_float",
            "caml_equal",
            "caml_erf_float",
            "caml_erfc_float",
            "caml_executable_name",
            "caml_exn_with_js_backtrace",
            "caml_exp2_float",
            "caml_exp_float",
            "caml_expm1_float",
            "caml_failwith",
            "caml_fatal_uncaught_exception",
            "caml_fill_bytes",
            "caml_final_register",
            "caml_final_register_called_without_value",
            "caml_final_release",
            "caml_finish_formatting",
            "caml_float_compare",
            "caml_float_of_bytes",
            "caml_float_of_int",
            "caml_float_of_string",
            "caml_floatarray_append",
            "caml_floatarray_blit",
            "caml_floatarray_create",
            "caml_floatarray_fill",
            "caml_floatarray_fill_unboxed",
            "caml_floatarray_get",
            "caml_floatarray_make",
            "caml_floatarray_make_unboxed",
            "caml_floatarray_set",
            "caml_floatarray_sub",
            "caml_floatarray_unsafe_get",
            "caml_floatarray_unsafe_set",
            "caml_floor_float",
            "caml_fma_float",
            "caml_fmod_float",
            "caml_format_exception",
            "caml_format_float",
            "caml_format_int",
            "caml_fresh_oo_id",
            "caml_frexp_float",
            "caml_fs_init",
            "caml_gc_compaction",
            "caml_gc_counters",
            "caml_gc_full_major",
            "caml_gc_get",
            "caml_gc_major",
            "caml_gc_major_slice",
            "caml_gc_minor",
            "caml_gc_minor_words",
            "caml_gc_quick_stat",
            "caml_gc_set",
            "caml_gc_stat",
            "caml_ge_float",
            "caml_get_continuation_callstack",
            "caml_get_current_callstack",
            "caml_get_exception_backtrace",
            "caml_get_exception_raw_backtrace",
            "caml_get_global_data",
            "caml_get_minor_free",
            "caml_get_public_method",
            "caml_get_root",
            "caml_global_data",
            "caml_gr_arc_aux",
            "caml_gr_blit_image",
            "caml_gr_clear_graph",
            "caml_gr_close_graph",
            "caml_gr_close_subwindow",
            "caml_gr_create_image",
            "caml_gr_current_x",
            "caml_gr_current_y",
            "caml_gr_display_mode",
            "caml_gr_doc_of_state",
            "caml_gr_draw_arc",
            "caml_gr_draw_char",
            "caml_gr_draw_image",
            "caml_gr_draw_rect",
            "caml_gr_draw_str",
            "caml_gr_draw_string",
            "caml_gr_dump_image",
            "caml_gr_fill_arc",
            "caml_gr_fill_poly",
            "caml_gr_fill_rect",
            "caml_gr_lineto",
            "caml_gr_make_image",
            "caml_gr_moveto",
            "caml_gr_open_graph",
            "caml_gr_open_subwindow",
            "caml_gr_plot",
            "caml_gr_point_color",
            "caml_gr_remember_mode",
            "caml_gr_resize_window",
            "caml_gr_set_color",
            "caml_gr_set_font",
            "caml_gr_set_line_width",
            "caml_gr_set_text_size",
            "caml_gr_set_window_title",
            "caml_gr_sigio_handler",
            "caml_gr_sigio_signal",
            "caml_gr_size_x",
            "caml_gr_size_y",
            "caml_gr_state",
            "caml_gr_state_create",
            "caml_gr_state_get",
            "caml_gr_state_init",
            "caml_gr_state_set",
            "caml_gr_synchronize",
            "caml_gr_text_size",
            "caml_gr_wait_event",
            "caml_gr_window_id",
            "caml_greaterequal",
            "caml_greaterthan",
            "caml_gt_float",
            "caml_hash",
            "caml_hash_mix_bigstring",
            "caml_hash_mix_bytes",
            "caml_hash_mix_bytes_arr",
            "caml_hash_mix_final",
            "caml_hash_mix_float",
            "caml_hash_mix_float16",
            "caml_hash_mix_int",
            "caml_hash_mix_int64",
            "caml_hash_mix_jsbytes",
            "caml_hash_mix_string",
            "caml_hash_nat",
            "caml_hexstring_of_float",
            "caml_hypot_float",
            "caml_input_value",
            "caml_input_value_from_bytes",
            "caml_input_value_from_reader",
            "caml_input_value_to_outside_heap",
            "caml_install_signal_handler",
            "caml_int32_add",
            "caml_int32_and",
            "caml_int32_bits_of_float",
            "caml_int32_bswap",
            "caml_int32_compare",
            "caml_int32_div",
            "caml_int32_float_of_bits",
            "caml_int32_format",
            "caml_int32_mod",
            "caml_int32_mul",
            "caml_int32_neg",
            "caml_int32_of_float",
            "caml_int32_of_int",
            "caml_int32_of_string",
            "caml_int32_or",
            "caml_int32_shift_left",
            "caml_int32_shift_right",
            "caml_int32_shift_right_unsigned",
            "caml_int32_sub",
            "caml_int32_to_float",
            "caml_int32_to_int",
            "caml_int32_unmarshal",
            "caml_int32_xor",
            "caml_int64_add",
            "caml_int64_and",
            "caml_int64_bits_of_float",
            "caml_int64_bswap",
            "caml_int64_compare",
            "caml_int64_create_lo_hi",
            "caml_int64_create_lo_mi_hi",
            "caml_int64_div",
            "caml_int64_float_of_bits",
            "caml_int64_format",
            "caml_int64_hash",
            "caml_int64_hi32",
            "caml_int64_is_negative",
            "caml_int64_is_zero",
            "caml_int64_lo32",
            "caml_int64_marshal",
            "caml_int64_mod",
            "caml_int64_mul",
            "caml_int64_neg",
            "caml_int64_of_bytes",
            "caml_int64_of_float",
            "caml_int64_of_int",
            "caml_int64_of_int32",
            "caml_int64_of_nativeint",
            "caml_int64_of_string",
            "caml_int64_offset",
            "caml_int64_or",
            "caml_int64_shift_left",
            "caml_int64_shift_right",
            "caml_int64_shift_right_unsigned",
            "caml_int64_sub",
            "caml_int64_to_bytes",
            "caml_int64_to_float",
            "caml_int64_to_int",
            "caml_int64_to_int32",
            "caml_int64_to_nativeint",
            "caml_int64_ult",
            "caml_int64_unmarshal",
            "caml_int64_xor",
            "caml_int_compare",
            "caml_int_of_float",
            "caml_int_of_string",
            "caml_invalid_argument",
            "caml_is_continuation_tag",
            "caml_is_js",
            "caml_is_ml_bytes",
            "caml_is_ml_string",
            "caml_is_printable",
            "caml_is_special_exception",
            "caml_js_call",
            "caml_js_delete",
            "caml_js_equals",
            "caml_js_error_of_exception",
            "caml_js_error_option_of_exception",
            "caml_js_eval_string",
            "caml_js_expr",
            "caml_js_from_array",
            "caml_js_from_bool",
            "caml_js_from_float",
            "caml_js_from_int32",
            "caml_js_from_nativeint",
            "caml_js_from_string",
            "caml_js_fun_call",
            "caml_js_function_arity",
            "caml_js_get",
            "caml_js_get_console",
            "caml_js_html_entities",
            "caml_js_html_escape",
            "caml_js_instanceof",
            "caml_js_meth_call",
            "caml_js_new",
            "caml_js_object",
            "caml_js_pure_expr",
            "caml_js_set",
            "caml_js_strict_equals",
            "caml_js_to_array",
            "caml_js_to_bool",
            "caml_js_to_byte_string",
            "caml_js_to_float",
            "caml_js_to_int32",
            "caml_js_to_nativeint",
            "caml_js_to_string",
            "caml_js_typeof",
            "caml_js_var",
            "caml_js_wrap_callback",
            "caml_js_wrap_callback_arguments",
            "caml_js_wrap_callback_strict",
            "caml_js_wrap_callback_unsafe",
            "caml_js_wrap_meth_callback",
            "caml_js_wrap_meth_callback_arguments",
            "caml_js_wrap_meth_callback_strict",
            "caml_js_wrap_meth_callback_unsafe",
            "caml_jsbytes_of_string",
            "caml_jsoo_flags_effects",
            "caml_jsoo_flags_use_js_string",
            "caml_jsstring_of_string",
            "caml_lazy_make_forward",
            "caml_lazy_read_result",
            "caml_lazy_reset_to_lazy",
            "caml_lazy_update_to_forcing",
            "caml_lazy_update_to_forward",
            "caml_ldexp_float",
            "caml_le_float",
            "caml_lessequal",
            "caml_lessthan",
            "caml_lex_array",
            "caml_lex_engine",
            "caml_list_mount_point",
            "caml_list_of_js_array",
            "caml_list_to_js_array",
            "caml_log10_float",
            "caml_log1p_float",
            "caml_log2_float",
            "caml_log_float",
            "caml_lt_float",
            "caml_lxm_M",
            "caml_lxm_daba",
            "caml_lxm_next",
            "caml_make_array",
            "caml_make_float_vect",
            "caml_make_local_vect",
            "caml_make_path",
            "caml_make_vect",
            "caml_marshal_constants",
            "caml_marshal_data_size",
            "caml_marshal_header_size",
            "caml_maybe_attach_backtrace",
            "caml_maybe_print_stats",
            "caml_md5_bytes",
            "caml_md5_chan",
            "caml_md5_string",
            "caml_memprof_discard",
            "caml_memprof_start",
            "caml_memprof_stop",
            "caml_ml_bytes_content",
            "caml_ml_bytes_length",
            "caml_ml_channel_get",
            "caml_ml_channel_redirect",
            "caml_ml_channel_restore",
            "caml_ml_channel_size",
            "caml_ml_channel_size_64",
            "caml_ml_channels",
            "caml_ml_close_channel",
            "caml_ml_condition_broadcast",
            "caml_ml_condition_new",
            "caml_ml_condition_signal",
            "caml_ml_condition_wait",
            "caml_ml_debug_info_status",
            "caml_ml_domain_cpu_relax",
            "caml_ml_domain_id",
            "caml_ml_domain_index",
            "caml_ml_enable_runtime_warnings",
            "caml_ml_flush",
            "caml_ml_input",
            "caml_ml_input_bigarray",
            "caml_ml_input_block",
            "caml_ml_input_char",
            "caml_ml_input_int",
            "caml_ml_input_scan_line",
            "caml_ml_is_binary_mode",
            "caml_ml_is_buffered",
            "caml_ml_mutex_lock",
            "caml_ml_mutex_new",
            "caml_ml_mutex_try_lock",
            "caml_ml_mutex_unlock",
            "caml_ml_open_descriptor_in",
            "caml_ml_open_descriptor_in_with_flags",
            "caml_ml_open_descriptor_out",
            "caml_ml_open_descriptor_out_with_flags",
            "caml_ml_out_channels_list",
            "caml_ml_output",
            "caml_ml_output_bigarray",
            "caml_ml_output_bytes",
            "caml_ml_output_char",
            "caml_ml_output_int",
            "caml_ml_output_ta",
            "caml_ml_pos_in",
            "caml_ml_pos_in_64",
            "caml_ml_pos_out",
            "caml_ml_pos_out_64",
            "caml_ml_runtime_events_are_active",
            "caml_ml_runtime_events_path",
            "caml_ml_runtime_events_pause",
            "caml_ml_runtime_events_resume",
            "caml_ml_runtime_events_start",
            "caml_ml_runtime_warnings_enabled",
            "caml_ml_seek_in",
            "caml_ml_seek_in_64",
            "caml_ml_seek_out",
            "caml_ml_seek_out_64",
            "caml_ml_set_binary_mode",
            "caml_ml_set_buffered",
            "caml_ml_set_channel_name",
            "caml_ml_set_channel_output",
            "caml_ml_set_channel_refill",
            "caml_ml_string_length",
            "caml_mod",
            "caml_modf_float",
            "caml_mount_autoload",
            "caml_mul",
            "caml_mul_float",
            "caml_named_value",
            "caml_named_values",
            "caml_nativeint_add",
            "caml_nativeint_and",
            "caml_nativeint_bswap",
            "caml_nativeint_compare",
            "caml_nativeint_div",
            "caml_nativeint_format",
            "caml_nativeint_mod",
            "caml_nativeint_mul",
            "caml_nativeint_neg",
            "caml_nativeint_of_float",
            "caml_nativeint_of_int",
            "caml_nativeint_of_int32",
            "caml_nativeint_of_string",
            "caml_nativeint_or",
            "caml_nativeint_shift_left",
            "caml_nativeint_shift_right",
            "caml_nativeint_shift_right_unsigned",
            "caml_nativeint_sub",
            "caml_nativeint_to_float",
            "caml_nativeint_to_int",
            "caml_nativeint_to_int32",
            "caml_nativeint_unmarshal",
            "caml_nativeint_xor",
            "caml_neg_float",
            "caml_neq_float",
            "caml_new_lex_engine",
            "caml_new_string",
            "caml_nextafter_float",
            "caml_notequal",
            "caml_obj_add_offset",
            "caml_obj_block",
            "caml_obj_compare_and_swap",
            "caml_obj_dup",
            "caml_obj_is_shared",
            "caml_obj_raw_field",
            "caml_obj_reachable_words",
            "caml_obj_set_raw_field",
            "caml_obj_tag",
            "caml_obj_update_tag",
            "caml_obj_with_tag",
            "caml_ojs_new_arr",
            "caml_oo_last_id",
            "caml_output_val",
            "caml_output_value",
            "caml_output_value_to_buffer",
            "caml_output_value_to_bytes",
            "caml_output_value_to_string",
            "caml_packFloat16",
            "caml_parse_digit",
            "caml_parse_engine",
            "caml_parse_format",
            "caml_parse_sign_and_base",
            "caml_parser_trace",
            "caml_pos_in",
            "caml_pos_out",
            "caml_power_float",
            "caml_process_pending_actions_with_root",
            "caml_pure_js_expr",
            "caml_raise_constant",
            "caml_raise_end_of_file",
            "caml_raise_no_such_file",
            "caml_raise_nodejs_error",
            "caml_raise_not_found",
            "caml_raise_sys_error",
            "caml_raise_system_error",
            "caml_raise_with_arg",
            "caml_raise_with_args",
            "caml_raise_with_string",
            "caml_raise_zero_divide",
            "caml_raw_backtrace_length",
            "caml_raw_backtrace_next_slot",
            "caml_raw_backtrace_slot",
            "caml_read_file_content",
            "caml_recommended_domain_count",
            "caml_record_backtrace",
            "caml_record_backtrace_env_flag",
            "caml_record_backtrace_runtime_flag",
            "caml_refill",
            "caml_register_global",
            "caml_register_named_value",
            "caml_restore_raw_backtrace",
            "caml_root",
            "caml_round_float",
            "caml_runtime_events_create_cursor",
            "caml_runtime_events_free_cursor",
            "caml_runtime_events_read_poll",
            "caml_runtime_events_user_register",
            "caml_runtime_events_user_resolve",
            "caml_runtime_events_user_write",
            "caml_runtime_parameters",
            "caml_runtime_variant",
            "caml_runtime_warnings",
            "caml_seek_in",
            "caml_seek_out",
            "caml_set_oo_id",
            "caml_set_parser_trace",
            "caml_set_static_env",
            "caml_signbit_float",
            "caml_sin_float",
            "caml_sinh_float",
            "caml_sqrt_float",
            "caml_sse2_float64_max_bytecode",
            "caml_sse2_float64_min_bytecode",
            "caml_str_repeat",
            "caml_string_bound_error",
            "caml_string_compare",
            "caml_string_concat",
            "caml_string_equal",
            "caml_string_get",
            "caml_string_get16",
            "caml_string_get32",
            "caml_string_get64",
            "caml_string_greaterequal",
            "caml_string_greaterthan",
            "caml_string_hash",
            "caml_string_lessequal",
            "caml_string_lessthan",
            "caml_string_notequal",
            "caml_string_of_array",
            "caml_string_of_bytes",
            "caml_string_of_jsbytes",
            "caml_string_of_jsstring",
            "caml_string_of_uint8_array",
            "caml_string_set",
            "caml_string_unsafe_get",
            "caml_sub_float",
            "caml_sub_uint8_array_to_jsbytes",
            "caml_subarray_to_jsbytes",
            "caml_sys_argv",
            "caml_sys_chdir",
            "caml_sys_close",
            "caml_sys_const_backend_type",
            "caml_sys_const_big_endian",
            "caml_sys_const_int_size",
            "caml_sys_const_max_wosize",
            "caml_sys_const_naked_pointers_checked",
            "caml_sys_const_ostype_cygwin",
            "caml_sys_const_ostype_unix",
            "caml_sys_const_ostype_win32",
            "caml_sys_const_word_size",
            "caml_sys_executable_name",
            "caml_sys_exit",
            "caml_sys_fds",
            "caml_sys_file_exists",
            "caml_sys_get_argv",
            "caml_sys_get_config",
            "caml_sys_getcwd",
            "caml_sys_getenv",
            "caml_sys_is_directory",
            "caml_sys_is_regular_file",
            "caml_sys_isatty",
            "caml_sys_mkdir",
            "caml_sys_modify_argv",
            "caml_sys_open",
            "caml_sys_open_for_node",
            "caml_sys_random_seed",
            "caml_sys_read_directory",
            "caml_sys_remove",
            "caml_sys_rename",
            "caml_sys_rmdir",
            "caml_sys_system_command",
            "caml_sys_time",
            "caml_sys_time_include_children",
            "caml_sys_unsafe_getenv",
            "caml_tan_float",
            "caml_tanh_float",
            "caml_to_js_string",
            "caml_trailing_slash",
            "caml_trampoline",
            "caml_trampoline_return",
            "caml_trunc_float",
            "caml_uint8_array_of_bytes",
            "caml_uint8_array_of_string",
            "caml_uniform_array_append",
            "caml_uniform_array_blit",
            "caml_uniform_array_fill",
            "caml_uniform_array_make",
            "caml_uniform_array_sub",
            "caml_unix_cleanup",
            "caml_unix_close",
            "caml_unix_closedir",
            "caml_unix_filedescr_of_fd",
            "caml_unix_findclose",
            "caml_unix_findfirst",
            "caml_unix_findnext",
            "caml_unix_fstat",
            "caml_unix_fstat_64",
            "caml_unix_ftruncate",
            "caml_unix_ftruncate_64",
            "caml_unix_getpwuid",
            "caml_unix_gettimeofday",
            "caml_unix_getuid",
            "caml_unix_gmtime",
            "caml_unix_has_symlink",
            "caml_unix_inchannel_of_filedescr",
            "caml_unix_inet_addr_of_string",
            "caml_unix_isatty",
            "caml_unix_localtime",
            "caml_unix_lookup_file",
            "caml_unix_lseek",
            "caml_unix_lseek_64",
            "caml_unix_lstat",
            "caml_unix_lstat_64",
            "caml_unix_mkdir",
            "caml_unix_mktime",
            "caml_unix_open",
            "caml_unix_opendir",
            "caml_unix_outchannel_of_filedescr",
            "caml_unix_read",
            "caml_unix_read_bigarray",
            "caml_unix_readdir",
            "caml_unix_readlink",
            "caml_unix_rename",
            "caml_unix_rewinddir",
            "caml_unix_rmdir",
            "caml_unix_startup",
            "caml_unix_stat",
            "caml_unix_stat_64",
            "caml_unix_symlink",
            "caml_unix_time",
            "caml_unix_truncate",
            "caml_unix_truncate_64",
            "caml_unix_unlink",
            "caml_unix_utimes",
            "caml_unix_write",
            "caml_unix_write_bigarray",
            "caml_unmount",
            "caml_unpackFloat16",
            "caml_update_dummy",
            "caml_utf16_of_utf8",
            "caml_utf8_of_utf16",
            "caml_weak_create",
            "caml_weak_set",
            "caml_wrap_exception",
            "caml_xdg_defaults",
            "caml_xmlhttprequest_create",
            "caml_zstd_initialize",
            "compare_digits_nat",
            "compare_nat",
            "complement_nat",
            "create_nat",
            "decr_nat",
            "deserialize_nat",
            "div_digit_nat",
            "div_helper",
            "div_nat",
            "fs_node_stats_from_js",
            "fs_node_supported",
            "incr_nat",
            "initialize_nat",
            "is_digit_int",
            "is_digit_normalized",
            "is_digit_odd",
            "is_digit_zero",
            "jsoo_create_file",
            "jsoo_create_file_extern",
            "jsoo_effect_not_supported",
            "jsoo_floor_log2",
            "jsoo_is_ascii",
            "jsoo_mount_point",
            "jsoo_static_env",
            "jsoo_sys_getenv",
            "jsoo_toplevel_reloc",
            "land_digit_nat",
            "length_nat",
            "lor_digit_nat",
            "lxor_digit_nat",
            "make_unix_err_args",
            "ms_float_to_ns_int64",
            "mult_digit_nat",
            "mult_nat",
            "nat_of_array",
            "nth_digit_nat",
            "nth_digit_nat_native",
            "num_digits_nat",
            "num_leading_zero_bits_in_digit",
            "os_type",
            "path_is_absolute",
            "ppx_expect_runtime_after_test",
            "ppx_expect_runtime_before_test",
            "ppx_expect_runtime_flush_stubs_streams",
            "ppx_expect_runtime_out_channel_position",
            "ppx_expect_runtime_saved_stderr",
            "ppx_expect_runtime_saved_stdout",
            "re_match",
            "re_partial_match",
            "re_replacement_text",
            "re_search_backward",
            "re_search_forward",
            "re_string_match",
            "resolve_fs_device",
            "serialize_nat",
            "set_digit_nat",
            "set_digit_nat_native",
            "set_to_zero_nat",
            "shift_left_nat",
            "shift_right_nat",
            "square_nat",
            "sub_nat",
            "time_now_nanosecond_counter_for_timing",
            "time_now_nanoseconds_since_unix_epoch_or_zero",
            "unix_error",
            "zstd_decompress"
        ]),
        0
    ];
    return;
})(globalThis);
//# 4 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function erase_rel(param) {
        if (typeof param === "number") return 0;
        switch(param[0]){
            case 0:
                var rest = param[1];
                return [
                    0,
                    erase_rel(rest)
                ];
            case 1:
                var rest$0 = param[1];
                return [
                    1,
                    erase_rel(rest$0)
                ];
            case 2:
                var rest$1 = param[1];
                return [
                    2,
                    erase_rel(rest$1)
                ];
            case 3:
                var rest$2 = param[1];
                return [
                    3,
                    erase_rel(rest$2)
                ];
            case 4:
                var rest$3 = param[1];
                return [
                    4,
                    erase_rel(rest$3)
                ];
            case 5:
                var rest$4 = param[1];
                return [
                    5,
                    erase_rel(rest$4)
                ];
            case 6:
                var rest$5 = param[1];
                return [
                    6,
                    erase_rel(rest$5)
                ];
            case 7:
                var rest$6 = param[1];
                return [
                    7,
                    erase_rel(rest$6)
                ];
            case 8:
                var rest$7 = param[2], ty = param[1];
                return [
                    8,
                    ty,
                    erase_rel(rest$7)
                ];
            case 9:
                var rest$8 = param[3], ty1 = param[1];
                return [
                    9,
                    ty1,
                    ty1,
                    erase_rel(rest$8)
                ];
            case 10:
                var rest$9 = param[1];
                return [
                    10,
                    erase_rel(rest$9)
                ];
            case 11:
                var rest$10 = param[1];
                return [
                    11,
                    erase_rel(rest$10)
                ];
            case 12:
                var rest$11 = param[1];
                return [
                    12,
                    erase_rel(rest$11)
                ];
            case 13:
                var rest$12 = param[1];
                return [
                    13,
                    erase_rel(rest$12)
                ];
            default:
                var rest$13 = param[1];
                return [
                    14,
                    erase_rel(rest$13)
                ];
        }
    }
    function concat_fmtty(fmtty1, fmtty2) {
        if (typeof fmtty1 === "number") return fmtty2;
        switch(fmtty1[0]){
            case 0:
                var rest = fmtty1[1];
                return [
                    0,
                    concat_fmtty(rest, fmtty2)
                ];
            case 1:
                var rest$0 = fmtty1[1];
                return [
                    1,
                    concat_fmtty(rest$0, fmtty2)
                ];
            case 2:
                var rest$1 = fmtty1[1];
                return [
                    2,
                    concat_fmtty(rest$1, fmtty2)
                ];
            case 3:
                var rest$2 = fmtty1[1];
                return [
                    3,
                    concat_fmtty(rest$2, fmtty2)
                ];
            case 4:
                var rest$3 = fmtty1[1];
                return [
                    4,
                    concat_fmtty(rest$3, fmtty2)
                ];
            case 5:
                var rest$4 = fmtty1[1];
                return [
                    5,
                    concat_fmtty(rest$4, fmtty2)
                ];
            case 6:
                var rest$5 = fmtty1[1];
                return [
                    6,
                    concat_fmtty(rest$5, fmtty2)
                ];
            case 7:
                var rest$6 = fmtty1[1];
                return [
                    7,
                    concat_fmtty(rest$6, fmtty2)
                ];
            case 8:
                var rest$7 = fmtty1[2], ty = fmtty1[1];
                return [
                    8,
                    ty,
                    concat_fmtty(rest$7, fmtty2)
                ];
            case 9:
                var rest$8 = fmtty1[3], ty2 = fmtty1[2], ty1 = fmtty1[1];
                return [
                    9,
                    ty1,
                    ty2,
                    concat_fmtty(rest$8, fmtty2)
                ];
            case 10:
                var rest$9 = fmtty1[1];
                return [
                    10,
                    concat_fmtty(rest$9, fmtty2)
                ];
            case 11:
                var rest$10 = fmtty1[1];
                return [
                    11,
                    concat_fmtty(rest$10, fmtty2)
                ];
            case 12:
                var rest$11 = fmtty1[1];
                return [
                    12,
                    concat_fmtty(rest$11, fmtty2)
                ];
            case 13:
                var rest$12 = fmtty1[1];
                return [
                    13,
                    concat_fmtty(rest$12, fmtty2)
                ];
            default:
                var rest$13 = fmtty1[1];
                return [
                    14,
                    concat_fmtty(rest$13, fmtty2)
                ];
        }
    }
    function concat_fmt(fmt1, fmt2) {
        if (typeof fmt1 === "number") return fmt2;
        switch(fmt1[0]){
            case 0:
                var rest = fmt1[1];
                return [
                    0,
                    concat_fmt(rest, fmt2)
                ];
            case 1:
                var rest$0 = fmt1[1];
                return [
                    1,
                    concat_fmt(rest$0, fmt2)
                ];
            case 2:
                var rest$1 = fmt1[2], pad = fmt1[1];
                return [
                    2,
                    pad,
                    concat_fmt(rest$1, fmt2)
                ];
            case 3:
                var rest$2 = fmt1[2], pad$0 = fmt1[1];
                return [
                    3,
                    pad$0,
                    concat_fmt(rest$2, fmt2)
                ];
            case 4:
                var rest$3 = fmt1[4], prec = fmt1[3], pad$1 = fmt1[2], iconv = fmt1[1];
                return [
                    4,
                    iconv,
                    pad$1,
                    prec,
                    concat_fmt(rest$3, fmt2)
                ];
            case 5:
                var rest$4 = fmt1[4], prec$0 = fmt1[3], pad$2 = fmt1[2], iconv$0 = fmt1[1];
                return [
                    5,
                    iconv$0,
                    pad$2,
                    prec$0,
                    concat_fmt(rest$4, fmt2)
                ];
            case 6:
                var rest$5 = fmt1[4], prec$1 = fmt1[3], pad$3 = fmt1[2], iconv$1 = fmt1[1];
                return [
                    6,
                    iconv$1,
                    pad$3,
                    prec$1,
                    concat_fmt(rest$5, fmt2)
                ];
            case 7:
                var rest$6 = fmt1[4], prec$2 = fmt1[3], pad$4 = fmt1[2], iconv$2 = fmt1[1];
                return [
                    7,
                    iconv$2,
                    pad$4,
                    prec$2,
                    concat_fmt(rest$6, fmt2)
                ];
            case 8:
                var rest$7 = fmt1[4], prec$3 = fmt1[3], pad$5 = fmt1[2], fconv = fmt1[1];
                return [
                    8,
                    fconv,
                    pad$5,
                    prec$3,
                    concat_fmt(rest$7, fmt2)
                ];
            case 9:
                var rest$8 = fmt1[2], pad$6 = fmt1[1];
                return [
                    9,
                    pad$6,
                    concat_fmt(rest$8, fmt2)
                ];
            case 10:
                var rest$9 = fmt1[1];
                return [
                    10,
                    concat_fmt(rest$9, fmt2)
                ];
            case 11:
                var rest$10 = fmt1[2], str = fmt1[1];
                return [
                    11,
                    str,
                    concat_fmt(rest$10, fmt2)
                ];
            case 12:
                var rest$11 = fmt1[2], chr = fmt1[1];
                return [
                    12,
                    chr,
                    concat_fmt(rest$11, fmt2)
                ];
            case 13:
                var rest$12 = fmt1[3], fmtty = fmt1[2], pad$7 = fmt1[1];
                return [
                    13,
                    pad$7,
                    fmtty,
                    concat_fmt(rest$12, fmt2)
                ];
            case 14:
                var rest$13 = fmt1[3], fmtty$0 = fmt1[2], pad$8 = fmt1[1];
                return [
                    14,
                    pad$8,
                    fmtty$0,
                    concat_fmt(rest$13, fmt2)
                ];
            case 15:
                var rest$14 = fmt1[1];
                return [
                    15,
                    concat_fmt(rest$14, fmt2)
                ];
            case 16:
                var rest$15 = fmt1[1];
                return [
                    16,
                    concat_fmt(rest$15, fmt2)
                ];
            case 17:
                var rest$16 = fmt1[2], fmting_lit = fmt1[1];
                return [
                    17,
                    fmting_lit,
                    concat_fmt(rest$16, fmt2)
                ];
            case 18:
                var rest$17 = fmt1[2], fmting_gen = fmt1[1];
                return [
                    18,
                    fmting_gen,
                    concat_fmt(rest$17, fmt2)
                ];
            case 19:
                var rest$18 = fmt1[1];
                return [
                    19,
                    concat_fmt(rest$18, fmt2)
                ];
            case 20:
                var rest$19 = fmt1[3], char_set = fmt1[2], width_opt = fmt1[1];
                return [
                    20,
                    width_opt,
                    char_set,
                    concat_fmt(rest$19, fmt2)
                ];
            case 21:
                var rest$20 = fmt1[2], counter = fmt1[1];
                return [
                    21,
                    counter,
                    concat_fmt(rest$20, fmt2)
                ];
            case 22:
                var rest$21 = fmt1[1];
                return [
                    22,
                    concat_fmt(rest$21, fmt2)
                ];
            case 23:
                var rest$22 = fmt1[2], ign = fmt1[1];
                return [
                    23,
                    ign,
                    concat_fmt(rest$22, fmt2)
                ];
            default:
                var rest$23 = fmt1[3], f = fmt1[2], arity = fmt1[1];
                return [
                    24,
                    arity,
                    f,
                    concat_fmt(rest$23, fmt2)
                ];
        }
    }
    var CamlinternalFormatBasics = [
        0,
        concat_fmtty,
        erase_rel,
        concat_fmt
    ];
    runtime.caml_register_global(0, CamlinternalFormatBasics, "CamlinternalFormatBasics");
    return;
})(globalThis);
//# 179 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_false$0 = "false", cst_true$0 = "true", caml_atomic_cas = runtime.caml_atomic_cas, caml_atomic_load = runtime.caml_atomic_load, caml_create_bytes = runtime.caml_create_bytes, caml_float_of_string = runtime.caml_float_of_string, caml_int64_float_of_bits = runtime.caml_int64_float_of_bits, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_channel_size = runtime.caml_ml_channel_size, caml_ml_channel_size_64 = runtime.caml_ml_channel_size_64, caml_ml_close_channel = runtime.caml_ml_close_channel, caml_ml_flush = runtime.caml_ml_flush, caml_ml_input = runtime.caml_ml_input, caml_ml_input_char = runtime.caml_ml_input_char, caml_ml_open_descriptor_in = runtime.caml_ml_open_descriptor_in, caml_ml_open_descriptor_out = runtime.caml_ml_open_descriptor_out, caml_ml_output = runtime.caml_ml_output, caml_ml_output_bytes = runtime.caml_ml_output_bytes, caml_ml_output_char = runtime.caml_ml_output_char, caml_ml_set_binary_mode = runtime.caml_ml_set_binary_mode, caml_ml_set_channel_name = runtime.caml_ml_set_channel_name, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_concat = runtime.caml_string_concat, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_sys_open = runtime.caml_sys_open, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Invalid_argument = global_data.Invalid_argument, Failure = global_data.Failure, Match_failure = global_data.Match_failure, Assert_failure = global_data.Assert_failure, Not_found = global_data.Not_found, Out_of_memory = global_data.Out_of_memory, Stack_overflow = global_data.Stack_overflow, Sys_error = global_data.Sys_error, End_of_file = global_data.End_of_file, Division_by_zero = global_data.Division_by_zero, Sys_blocked_io = global_data.Sys_blocked_io, Undefined_recursive_module = global_data.Undefined_recursive_module;
    function failwith(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Failure,
            s
        ], 1);
    }
    function invalid_arg(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Invalid_argument,
            s
        ], 1);
    }
    var Exit = [
        248,
        "Stdlib.Exit",
        runtime.caml_fresh_oo_id(0)
    ];
    function min(x, y) {
        return runtime.caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return runtime.caml_greaterequal(x, y) ? x : y;
    }
    function abs(x) {
        return 0 <= x ? x : -x | 0;
    }
    function lnot(x) {
        return x ^ -1;
    }
    var infinity = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 32752)), neg_infinity = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 65520)), nan = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(1, 0, 32760)), max_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32751)), min_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 16)), epsilon_float = caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(0, 0, 15536)), symbol_concat = caml_string_concat, cst_char_of_int = "char_of_int", cst_true = cst_true$0, cst_false = cst_false$0, cst_bool_of_string = "bool_of_string", _a_ = [
        0,
        1
    ], _b_ = [
        0,
        0
    ];
    function char_of_int(n) {
        if (0 <= n && 255 >= n) return n;
        return invalid_arg(cst_char_of_int);
    }
    function string_of_bool(b) {
        return b ? cst_true : cst_false;
    }
    function bool_of_string(param) {
        return param !== cst_false$0 ? param !== cst_true$0 ? invalid_arg(cst_bool_of_string) : 1 : 0;
    }
    function bool_of_string_opt(param) {
        return param !== cst_false$0 ? param !== cst_true$0 ? 0 : _a_ : _b_;
    }
    function string_of_int(n) {
        return "" + n;
    }
    function int_of_string_opt(s) {
        try {
            var _w_ = [
                0,
                caml_int_of_string(s)
            ];
            return _w_;
        } catch (_x_) {
            var _v_ = caml_wrap_exception(_x_);
            if (_v_[1] === Failure) return 0;
            throw caml_maybe_attach_backtrace(_v_, 0);
        }
    }
    function valid_float_lexem(s1) {
        var l = caml_ml_string_length(s1), i = 0;
        for(;;){
            if (l <= i) return s1 + ".";
            var match = runtime.caml_string_get(s1, i);
            a: {
                if (48 <= match) {
                    if (58 > match) break a;
                } else if (45 === match) break a;
                return s1;
            }
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function string_of_float(f) {
        return valid_float_lexem(runtime.caml_format_float("%.12g", f));
    }
    function float_of_string_opt(s) {
        try {
            var _t_ = [
                0,
                caml_float_of_string(s)
            ];
            return _t_;
        } catch (_u_) {
            var _s_ = caml_wrap_exception(_u_);
            if (_s_[1] === Failure) return 0;
            throw caml_maybe_attach_backtrace(_s_, 0);
        }
    }
    function symbol(l1, l2) {
        if (!l1) return l2;
        var _q_ = l1[2], h1 = l1[1];
        if (!_q_) return [
            0,
            h1,
            l2
        ];
        var match = _q_[2], h2 = _q_[1];
        if (!match) return [
            0,
            h1,
            [
                0,
                h2,
                l2
            ]
        ];
        var tl = match[2], h3 = match[1], block = [
            0,
            h3,
            24029
        ], dst = block, offset = 1, l1$0 = tl;
        for(;;){
            if (l1$0) {
                var _r_ = l1$0[2], h1$0 = l1$0[1];
                if (_r_) {
                    var match$0 = _r_[2], h2$0 = _r_[1];
                    if (match$0) {
                        var tl$0 = match$0[2], h3$0 = match$0[1], dst$0 = [
                            0,
                            h3$0,
                            24029
                        ];
                        dst[1 + offset] = [
                            0,
                            h1$0,
                            [
                                0,
                                h2$0,
                                dst$0
                            ]
                        ];
                        dst = dst$0;
                        offset = 1;
                        l1$0 = tl$0;
                        continue;
                    }
                    dst[1 + offset] = [
                        0,
                        h1$0,
                        [
                            0,
                            h2$0,
                            l2
                        ]
                    ];
                } else dst[1 + offset] = [
                    0,
                    h1$0,
                    l2
                ];
            } else dst[1 + offset] = l2;
            return [
                0,
                h1,
                [
                    0,
                    h2,
                    block
                ]
            ];
        }
    }
    var stdin = caml_ml_open_descriptor_in(0), stdout = caml_ml_open_descriptor_out(1), stderr = caml_ml_open_descriptor_out(2), _c_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                4,
                [
                    0,
                    7,
                    0
                ]
            ]
        ]
    ], _d_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                4,
                [
                    0,
                    6,
                    0
                ]
            ]
        ]
    ], cst_output = "output", cst_output_substring = "output_substring", _e_ = [
        0,
        0,
        [
            0,
            7,
            0
        ]
    ], _f_ = [
        0,
        0,
        [
            0,
            6,
            0
        ]
    ], cst_input = "input", cst_really_input = "really_input";
    function open_out_gen(mode, perm, name) {
        var c = caml_ml_open_descriptor_out(caml_sys_open(name, mode, perm));
        caml_ml_set_channel_name(c, name);
        return c;
    }
    function open_out(name) {
        return open_out_gen(_c_, 438, name);
    }
    function open_out_bin(name) {
        return open_out_gen(_d_, 438, name);
    }
    function flush_all(param) {
        var param$0 = runtime.caml_ml_out_channels_list(0);
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1];
            try {
                caml_ml_flush(a);
            } catch (_p_) {
                var _o_ = caml_wrap_exception(_p_);
                if (_o_[1] !== Sys_error) throw caml_maybe_attach_backtrace(_o_, 0);
            }
            param$0 = l;
        }
    }
    function output_bytes(oc, s) {
        return caml_ml_output_bytes(oc, s, 0, caml_ml_bytes_length(s));
    }
    function output_string(oc, s) {
        return caml_ml_output(oc, s, 0, caml_ml_string_length(s));
    }
    function output(oc, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_ml_output_bytes(oc, s, ofs, len);
        return invalid_arg(cst_output);
    }
    function output_substring(oc, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_string_length(s) - len | 0) >= ofs) return caml_ml_output(oc, s, ofs, len);
        return invalid_arg(cst_output_substring);
    }
    function output_value(chan, v) {
        return runtime.caml_output_value(chan, v, 0);
    }
    function close_out(oc) {
        caml_ml_flush(oc);
        return caml_ml_close_channel(oc);
    }
    function close_out_noerr(oc) {
        try {
            caml_ml_flush(oc);
        } catch (_n_) {}
        try {
            var _l_ = caml_ml_close_channel(oc);
            return _l_;
        } catch (_m_) {
            return 0;
        }
    }
    function open_in_gen(mode, perm, name) {
        var c = caml_ml_open_descriptor_in(caml_sys_open(name, mode, perm));
        caml_ml_set_channel_name(c, name);
        return c;
    }
    function open_in(name) {
        return open_in_gen(_e_, 0, name);
    }
    function open_in_bin(name) {
        return open_in_gen(_f_, 0, name);
    }
    function input(ic, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_ml_input(ic, s, ofs, len);
        return invalid_arg(cst_input);
    }
    function unsafe_really_input(ic, s, ofs, len) {
        var ofs$0 = ofs, len$0 = len;
        for(;;){
            if (0 >= len$0) return 0;
            var r = caml_ml_input(ic, s, ofs$0, len$0);
            if (0 === r) throw caml_maybe_attach_backtrace(End_of_file, 1);
            var len$1 = len$0 - r | 0, ofs$1 = ofs$0 + r | 0;
            ofs$0 = ofs$1;
            len$0 = len$1;
        }
    }
    function really_input(ic, s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return unsafe_really_input(ic, s, ofs, len);
        return invalid_arg(cst_really_input);
    }
    function really_input_string(ic, len) {
        var s = caml_create_bytes(len);
        really_input(ic, s, 0, len);
        return caml_string_of_bytes(s);
    }
    function input_line(chan) {
        function build_result(buf, pos, param) {
            var pos$0 = pos, param$0 = param;
            for(;;){
                if (!param$0) return buf;
                var tl = param$0[2], hd = param$0[1], len = caml_ml_bytes_length(hd);
                runtime.caml_blit_bytes(hd, 0, buf, pos$0 - len | 0, len);
                var pos$1 = pos$0 - len | 0;
                pos$0 = pos$1;
                param$0 = tl;
            }
        }
        var accu = 0, len = 0;
        for(;;){
            var n = runtime.caml_ml_input_scan_line(chan);
            if (0 === n) {
                if (!accu) throw caml_maybe_attach_backtrace(End_of_file, 1);
                var _k_ = build_result(caml_create_bytes(len), len, accu);
            } else {
                if (0 >= n) {
                    var beg = caml_create_bytes(-n | 0);
                    caml_ml_input(chan, beg, 0, -n | 0);
                    var len$1 = len - n | 0, accu$0 = [
                        0,
                        beg,
                        accu
                    ];
                    accu = accu$0;
                    len = len$1;
                    continue;
                }
                var res = caml_create_bytes(n - 1 | 0);
                caml_ml_input(chan, res, 0, n - 1 | 0);
                caml_ml_input_char(chan);
                if (accu) var len$0 = (len + n | 0) - 1 | 0, _k_ = build_result(caml_create_bytes(len$0), len$0, [
                    0,
                    res,
                    accu
                ]);
                else var _k_ = res;
            }
            return caml_string_of_bytes(_k_);
        }
    }
    function close_in_noerr(ic) {
        try {
            var _i_ = caml_ml_close_channel(ic);
            return _i_;
        } catch (_j_) {
            return 0;
        }
    }
    function print_char(c) {
        return caml_ml_output_char(stdout, c);
    }
    function print_string(s) {
        return output_string(stdout, s);
    }
    function print_bytes(s) {
        return output_bytes(stdout, s);
    }
    function print_int(i) {
        return output_string(stdout, "" + i);
    }
    function print_float(f) {
        return output_string(stdout, string_of_float(f));
    }
    function print_endline(s) {
        output_string(stdout, s);
        caml_ml_output_char(stdout, 10);
        return caml_ml_flush(stdout);
    }
    function print_newline(param) {
        caml_ml_output_char(stdout, 10);
        return caml_ml_flush(stdout);
    }
    function prerr_char(c) {
        return caml_ml_output_char(stderr, c);
    }
    function prerr_string(s) {
        return output_string(stderr, s);
    }
    function prerr_bytes(s) {
        return output_bytes(stderr, s);
    }
    function prerr_int(i) {
        return output_string(stderr, "" + i);
    }
    function prerr_float(f) {
        return output_string(stderr, string_of_float(f));
    }
    function prerr_endline(s) {
        output_string(stderr, s);
        caml_ml_output_char(stderr, 10);
        return caml_ml_flush(stderr);
    }
    function prerr_newline(param) {
        caml_ml_output_char(stderr, 10);
        return caml_ml_flush(stderr);
    }
    function read_line(param) {
        caml_ml_flush(stdout);
        return input_line(stdin);
    }
    function read_int(param) {
        return caml_int_of_string(read_line(0));
    }
    function read_int_opt(param) {
        return int_of_string_opt(read_line(0));
    }
    function read_float(param) {
        return caml_float_of_string(read_line(0));
    }
    function read_float_opt(param) {
        return float_of_string_opt(read_line(0));
    }
    function string_of_format(param) {
        var str = param[2];
        return str;
    }
    function symbol$0(_h_, param) {
        var str2 = param[2], fmt2 = param[1], str1 = _h_[2], fmt1 = _h_[1], s2 = "%," + str2;
        return [
            0,
            caml_call2(CamlinternalFormatBasics[3], fmt1, fmt2),
            str1 + s2
        ];
    }
    var exit_function = [
        0,
        flush_all
    ];
    function at_exit(f) {
        for(;;){
            var f_yet_to_run = [
                0,
                1
            ], old_exit = caml_atomic_load(exit_function);
            let f_yet_to_run$0 = f_yet_to_run, old_exit$0 = old_exit;
            var new_exit = function(param) {
                if (caml_atomic_cas(f_yet_to_run$0, 1, 0)) caml_call1(f, 0);
                return caml_call1(old_exit$0, 0);
            }, success = caml_atomic_cas(exit_function, old_exit, new_exit), _g_ = 1 - success;
            if (!_g_) return _g_;
        }
    }
    var do_domain_local_at_exit = [
        0,
        function(param) {
            return 0;
        }
    ];
    function do_at_exit(param) {
        caml_call1(do_domain_local_at_exit[1], 0);
        return caml_call1(caml_atomic_load(exit_function), 0);
    }
    function exit(retcode) {
        do_at_exit(0);
        return runtime.caml_sys_exit(retcode);
    }
    runtime.caml_register_named_value("Pervasives.do_at_exit", do_at_exit);
    var Stdlib = [
        0,
        invalid_arg,
        failwith,
        Exit,
        Match_failure,
        Assert_failure,
        Invalid_argument,
        Failure,
        Not_found,
        Out_of_memory,
        Stack_overflow,
        Sys_error,
        End_of_file,
        Division_by_zero,
        Sys_blocked_io,
        Undefined_recursive_module,
        min,
        max,
        abs,
        2147483647,
        -2147483648,
        lnot,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        symbol_concat,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        symbol,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        caml_ml_flush,
        flush_all,
        caml_ml_output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        caml_ml_output_char,
        runtime.caml_ml_output_int,
        output_value,
        runtime.caml_ml_seek_out,
        runtime.caml_ml_pos_out,
        caml_ml_channel_size,
        close_out,
        close_out_noerr,
        caml_ml_set_binary_mode,
        open_in,
        open_in_bin,
        open_in_gen,
        caml_ml_input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        caml_ml_input_char,
        runtime.caml_ml_input_int,
        runtime.caml_input_value,
        runtime.caml_ml_seek_in,
        runtime.caml_ml_pos_in,
        caml_ml_channel_size,
        caml_ml_close_channel,
        close_in_noerr,
        caml_ml_set_binary_mode,
        [
            0,
            runtime.caml_ml_seek_out_64,
            runtime.caml_ml_pos_out_64,
            caml_ml_channel_size_64,
            runtime.caml_ml_seek_in_64,
            runtime.caml_ml_pos_in_64,
            caml_ml_channel_size_64
        ],
        string_of_format,
        symbol$0,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit
    ];
    runtime.caml_register_global(45, Stdlib, "Stdlib");
    return;
})(globalThis);
//# 774 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), ocaml_version = "5.3.0", ocaml_release = [
        0,
        5,
        3,
        0,
        0
    ], Stdlib = global_data.Stdlib, executable_name = runtime.caml_sys_executable_name(0), os_type = runtime.caml_sys_get_config(0)[1], backend_type = [
        0,
        "js_of_ocaml"
    ], unix = runtime.caml_sys_const_ostype_unix(0), win32 = runtime.caml_sys_const_ostype_win32(0), cygwin = runtime.caml_sys_const_ostype_cygwin(0), max_array_length = runtime.caml_sys_const_max_wosize(0), max_floatarray_length = max_array_length / 2 | 0, max_string_length = (4 * max_array_length | 0) - 1 | 0;
    function getenv_opt(s) {
        try {
            var _d_ = [
                0,
                runtime.caml_sys_getenv(s)
            ];
            return _d_;
        } catch (_e_) {
            var _c_ = caml_wrap_exception(_e_);
            if (_c_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_c_, 0);
        }
    }
    var interactive = [
        0,
        0
    ];
    function set_signal(sig_num, sig_beh) {
        return 0;
    }
    var Break = [
        248,
        "Stdlib.Sys.Break",
        runtime.caml_fresh_oo_id(0)
    ];
    function catch_break(on) {
        return on ? 0 : 0;
    }
    function Make(_b_, _a_) {
        return [
            0,
            1
        ];
    }
    var Immediate64 = [
        0,
        Make
    ], Stdlib_Sys = [
        0,
        executable_name,
        getenv_opt,
        interactive,
        os_type,
        backend_type,
        unix,
        win32,
        cygwin,
        32,
        32,
        0,
        max_string_length,
        max_array_length,
        max_floatarray_length,
        set_signal,
        -1,
        -2,
        -3,
        -4,
        -5,
        -6,
        -7,
        -8,
        -9,
        -10,
        -11,
        -12,
        -13,
        -14,
        -15,
        -16,
        -17,
        -18,
        -19,
        -20,
        -21,
        -22,
        -23,
        -24,
        -25,
        -26,
        -27,
        -28,
        Break,
        catch_break,
        ocaml_version,
        0,
        ocaml_release,
        runtime.caml_ml_enable_runtime_warnings,
        runtime.caml_ml_runtime_warnings_enabled,
        Immediate64
    ];
    runtime.caml_register_global(4, Stdlib_Sys, "Stdlib__Sys");
    return;
})(globalThis);
//# 869 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Obj_extension_constructor$1 = "Obj.extension_constructor", caml_check_bound = runtime.caml_check_bound, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys;
    function is_block(a) {
        return 1 - (typeof a === "number" ? 1 : 0);
    }
    function double_field(x, i) {
        return caml_check_bound(x, i)[1 + i];
    }
    function set_double_field(x, i, v) {
        caml_check_bound(x, i)[1 + i] = v;
        return 0;
    }
    var cst_Obj_extension_constructor = cst_Obj_extension_constructor$1, cst_Obj_extension_constructor$0 = cst_Obj_extension_constructor$1;
    function of_val(x) {
        a: {
            if (is_block(x) && caml_obj_tag(x) !== 248 && 1 <= x.length - 1) {
                var slot = x[1];
                break a;
            }
            var slot = x;
        }
        a: {
            if (is_block(slot) && caml_obj_tag(slot) === 248) {
                var name = slot[1];
                break a;
            }
            var name = caml_call1(Stdlib[1], cst_Obj_extension_constructor$0);
        }
        return caml_obj_tag(name) === 252 ? slot : caml_call1(Stdlib[1], cst_Obj_extension_constructor);
    }
    function name(slot) {
        return slot[1];
    }
    function id(slot) {
        return slot[2];
    }
    var Extension_constructor = [
        0,
        of_val,
        name,
        id
    ], max_ephe_length = Stdlib_Sys[13] - 2 | 0, cst_Obj_Ephemeron_create = "Obj.Ephemeron.create", cst_Obj_Ephemeron_get_key = "Obj.Ephemeron.get_key", cst_Obj_Ephemeron_get_key_copy = "Obj.Ephemeron.get_key_copy", cst_Obj_Ephemeron_set_key = "Obj.Ephemeron.set_key", cst_Obj_Ephemeron_unset_key = "Obj.Ephemeron.unset_key", cst_Obj_Ephemeron_check_key = "Obj.Ephemeron.check_key", cst_Obj_Ephemeron_blit_key = "Obj.Ephemeron.blit_key";
    function create(l) {
        var _f_ = 0 <= l ? 1 : 0, _g_ = _f_ ? l <= max_ephe_length ? 1 : 0 : _f_;
        if (1 - _g_) caml_call1(Stdlib[1], cst_Obj_Ephemeron_create);
        return runtime.caml_ephe_create(l);
    }
    function length(x) {
        return x.length - 3 | 0;
    }
    function raise_if_invalid_offset(e, o, msg) {
        var _c_ = 0 <= o ? 1 : 0, _d_ = _c_ ? o < length(e) ? 1 : 0 : _c_, _e_ = 1 - _d_;
        return _e_ ? caml_call1(Stdlib[1], msg) : _e_;
    }
    function get_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_get_key);
        return runtime.caml_ephe_get_key(e, o);
    }
    function get_key_copy(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_get_key_copy);
        return runtime.caml_ephe_get_key_copy(e, o);
    }
    function set_key(e, o, x) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_set_key);
        return runtime.caml_ephe_set_key(e, o, x);
    }
    function unset_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_unset_key);
        return runtime.caml_ephe_unset_key(e, o);
    }
    function check_key(e, o) {
        raise_if_invalid_offset(e, o, cst_Obj_Ephemeron_check_key);
        return runtime.caml_ephe_check_key(e, o);
    }
    function blit_key(e1, o1, e2, o2, l) {
        if (0 <= l && 0 <= o1 && (length(e1) - l | 0) >= o1 && 0 <= o2 && (length(e2) - l | 0) >= o2) {
            var _a_ = 0 !== l ? 1 : 0, _b_ = _a_ ? runtime.caml_ephe_blit_key(e1, o1, e2, o2, l) : _a_;
            return _b_;
        }
        return caml_call1(Stdlib[1], cst_Obj_Ephemeron_blit_key);
    }
    var Stdlib_Obj = [
        0,
        is_block,
        double_field,
        set_double_field,
        0,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        251,
        252,
        253,
        254,
        255,
        1000,
        1001,
        1002,
        Extension_constructor,
        [
            0,
            create,
            length,
            get_key,
            get_key_copy,
            set_key,
            unset_key,
            check_key,
            blit_key,
            runtime.caml_ephe_get_data,
            runtime.caml_ephe_get_data_copy,
            runtime.caml_ephe_set_data,
            runtime.caml_ephe_unset_data,
            runtime.caml_ephe_check_data,
            runtime.caml_ephe_blit_data,
            max_ephe_length
        ]
    ];
    runtime.caml_register_global(11, Stdlib_Obj, "Stdlib__Obj");
    return;
})(globalThis);
//# 1046 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_atomic_exchange = runtime.caml_atomic_exchange, caml_atomic_fetch_add = runtime.caml_atomic_fetch_add;
    function set(r, x) {
        caml_atomic_exchange(r, x);
        return 0;
    }
    function incr(r) {
        caml_atomic_fetch_add(r, 1);
        return 0;
    }
    function decr(r) {
        caml_atomic_fetch_add(r, -1);
        return 0;
    }
    var Stdlib_Atomic = [
        0,
        function(_a_) {
            return [
                0,
                _a_
            ];
        },
        runtime.caml_atomic_make_contended,
        runtime.caml_atomic_load,
        set,
        caml_atomic_exchange,
        runtime.caml_atomic_cas,
        caml_atomic_fetch_add,
        incr,
        decr
    ];
    runtime.caml_register_global(0, Stdlib_Atomic, "Stdlib__Atomic");
    return;
})(globalThis);
//# 1074 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_lazy_update_to_forward = runtime.caml_lazy_update_to_forward, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, Undefined = [
        248,
        "CamlinternalLazy.Undefined",
        runtime.caml_fresh_oo_id(0)
    ];
    function force_gen_lazy_block(only_val, blk) {
        if (0 !== runtime.caml_lazy_update_to_forcing(blk)) throw caml_maybe_attach_backtrace(Undefined, 1);
        if (only_val) {
            var closure$0 = blk[1];
            blk[1] = 0;
            var result$0 = caml_call1(closure$0, 0);
            blk[1] = result$0;
            caml_lazy_update_to_forward(blk);
            return result$0;
        }
        var closure = blk[1];
        blk[1] = 0;
        try {
            var result = caml_call1(closure, 0);
            blk[1] = result;
            caml_lazy_update_to_forward(blk);
            return result;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            blk[1] = function(param) {
                throw caml_maybe_attach_backtrace(e, 0);
            };
            runtime.caml_lazy_reset_to_lazy(blk);
            throw caml_maybe_attach_backtrace(e, 0);
        }
    }
    function force_lazy_block(blk) {
        return force_gen_lazy_block(0, blk);
    }
    function force_gen(only_val, lzv) {
        var t = runtime.caml_obj_tag(lzv);
        if (t === Stdlib_Obj[12]) return lzv[1];
        if (t === Stdlib_Obj[6]) throw caml_maybe_attach_backtrace(Undefined, 1);
        return t !== Stdlib_Obj[8] ? lzv : force_gen_lazy_block(only_val, lzv);
    }
    var CamlinternalLazy = [
        0,
        Undefined,
        force_lazy_block,
        force_gen
    ];
    runtime.caml_register_global(2, CamlinternalLazy, "CamlinternalLazy");
    return;
})(globalThis);
//# 1133 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Obj = global_data.Stdlib__Obj, Undefined = CamlinternalLazy[1];
    function force_val(l) {
        return caml_call2(CamlinternalLazy[3], 1, l);
    }
    function from_fun(f) {
        var x = runtime.caml_obj_block(Stdlib_Obj[8], 1);
        x[1] = f;
        return x;
    }
    function from_val(v) {
        var t = caml_obj_tag(v);
        if (t !== Stdlib_Obj[12] && t !== Stdlib_Obj[8] && t !== Stdlib_Obj[6] && t !== Stdlib_Obj[16]) return v;
        return runtime.caml_lazy_make_forward(v);
    }
    function is_val(l) {
        var _i_ = Stdlib_Obj[8];
        return caml_obj_tag(l) !== _i_ ? 1 : 0;
    }
    function map(f, x) {
        return [
            246,
            function(_f_) {
                var _g_ = caml_obj_tag(x);
                a: if (250 === _g_) var _h_ = x[1];
                else {
                    if (246 !== _g_ && 244 !== _g_) {
                        var _h_ = x;
                        break a;
                    }
                    var _h_ = caml_call1(CamlinternalLazy[2], x);
                }
                return caml_call1(f, _h_);
            }
        ];
    }
    function map_val(f, x) {
        if (!is_val(x)) return [
            246,
            function(_c_) {
                var _d_ = caml_obj_tag(x);
                a: if (250 === _d_) var _e_ = x[1];
                else {
                    if (246 !== _d_ && 244 !== _d_) {
                        var _e_ = x;
                        break a;
                    }
                    var _e_ = caml_call1(CamlinternalLazy[2], x);
                }
                return caml_call1(f, _e_);
            }
        ];
        var _a_ = caml_obj_tag(x);
        a: if (250 === _a_) var _b_ = x[1];
        else {
            if (246 !== _a_ && 244 !== _a_) {
                var _b_ = x;
                break a;
            }
            var _b_ = caml_call1(CamlinternalLazy[2], x);
        }
        return from_val(caml_call1(f, _b_));
    }
    var Stdlib_Lazy = [
        0,
        Undefined,
        map,
        is_val,
        from_val,
        map_val,
        from_fun,
        force_val
    ];
    runtime.caml_register_global(2, Stdlib_Lazy, "Stdlib__Lazy");
    return;
})(globalThis);
//# 1218 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib_Atomic = global_data.Stdlib__Atomic, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib = global_data.Stdlib, Stdlib_Lazy = global_data.Stdlib__Lazy, cst_Seq_init = "Seq.init", cst_Seq_take = "Seq.take", cst_Seq_drop = "Seq.drop";
    function empty(param) {
        return 0;
    }
    function return$0(x, param) {
        return [
            0,
            x,
            empty
        ];
    }
    function cons(x, next, param) {
        return [
            0,
            x,
            next
        ];
    }
    function append(seq1, seq2, param) {
        var match = caml_call1(seq1, 0);
        if (!match) return caml_call1(seq2, 0);
        var next = match[2], x = match[1];
        return [
            0,
            x,
            function(_au_) {
                return append(next, seq2, _au_);
            }
        ];
    }
    function map(f, seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return [
            0,
            caml_call1(f, x),
            function(_at_) {
                return map(f, next, _at_);
            }
        ];
    }
    function filter_map(f, seq, param) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (match$0) {
                var y = match$0[1];
                return [
                    0,
                    y,
                    function(_as_) {
                        return filter_map(f, next, _as_);
                    }
                ];
            }
            seq$0 = next;
        }
    }
    function filter(f, seq, param) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1];
            if (caml_call1(f, x)) return [
                0,
                x,
                function(_ar_) {
                    return filter(f, next, _ar_);
                }
            ];
            seq$0 = next;
        }
    }
    function concat(seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return append(x, function(_aq_) {
            return concat(next, _aq_);
        }, 0);
    }
    function flat_map(f, seq, param) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var next = match[2], x = match[1];
        return append(caml_call1(f, x), function(_ap_) {
            return flat_map(f, next, _ap_);
        }, 0);
    }
    function fold_left(f, acc, seq) {
        var acc$0 = acc, seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return acc$0;
            var next = match[2], x = match[1], acc$1 = caml_call2(f, acc$0, x);
            acc$0 = acc$1;
            seq$0 = next;
        }
    }
    function iter(f, seq) {
        var seq$0 = seq;
        for(;;){
            var match = caml_call1(seq$0, 0);
            if (!match) return 0;
            var next = match[2], x = match[1];
            caml_call1(f, x);
            seq$0 = next;
        }
    }
    function unfold(f, u, param) {
        var match = caml_call1(f, u);
        if (!match) return 0;
        var match$0 = match[1], u$0 = match$0[2], x = match$0[1];
        return [
            0,
            x,
            function(_ao_) {
                return unfold(f, u$0, _ao_);
            }
        ];
    }
    function is_empty(xs) {
        return caml_call1(xs, 0) ? 0 : 1;
    }
    function uncons(xs) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        return [
            0,
            [
                0,
                x,
                xs$0
            ]
        ];
    }
    function length(xs$1) {
        var accu = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return accu;
            var xs$0 = match[2], accu$0 = accu + 1 | 0;
            accu = accu$0;
            xs = xs$0;
        }
    }
    function iteri(f, xs$1) {
        var i = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            caml_call2(f, i, x);
            var i$0 = i + 1 | 0;
            i = i$0;
            xs = xs$0;
        }
    }
    function fold_lefti(f, accu$1, xs$1) {
        var accu = accu$1, i = 0, xs = xs$1;
        for(;;){
            var match = caml_call1(xs, 0);
            if (!match) return accu;
            var xs$0 = match[2], x = match[1], accu$0 = caml_call3(f, accu, i, x), i$0 = i + 1 | 0;
            accu = accu$0;
            i = i$0;
            xs = xs$0;
        }
    }
    function for_all(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 1;
            var xs$1 = match[2], x = match[1], _an_ = caml_call1(p, x);
            if (!_an_) return _an_;
            xs$0 = xs$1;
        }
    }
    function exists(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], _am_ = caml_call1(p, x);
            if (_am_) return _am_;
            xs$0 = xs$1;
        }
    }
    function find(p, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            xs$0 = xs$1;
        }
    }
    function find_index(p, xs) {
        var i = 0, xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1];
            if (caml_call1(p, x)) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
            xs$0 = xs$1;
        }
    }
    function find_map(f, xs) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], result = caml_call1(f, x);
            if (result) return result;
            xs$0 = xs$1;
        }
    }
    function find_mapi(f, xs) {
        var i = 0, xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], result = caml_call2(f, i, x);
            if (result) return result;
            var i$0 = i + 1 | 0;
            i = i$0;
            xs$0 = xs$1;
        }
    }
    function iter2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 0;
            var ys$1 = match$0[2], y = match$0[1];
            caml_call2(f, x, y);
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function fold_left2(f, accu, xs, ys) {
        var accu$0 = accu, xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return accu$0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return accu$0;
            var ys$1 = match$0[2], y = match$0[1], accu$1 = caml_call3(f, accu$0, x, y);
            accu$0 = accu$1;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function for_all2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 1;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 1;
            var ys$1 = match$0[2], y = match$0[1], _al_ = caml_call2(f, x, y);
            if (!_al_) return _al_;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function exists2(f, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(ys$0, 0);
            if (!match$0) return 0;
            var ys$1 = match$0[2], y = match$0[1], _ak_ = caml_call2(f, x, y);
            if (_ak_) return _ak_;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function equal(eq, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0), match$0 = caml_call1(ys$0, 0);
            if (match) {
                if (match$0) {
                    var ys$1 = match$0[2], y = match$0[1], xs$1 = match[2], x = match[1], _aj_ = caml_call2(eq, x, y);
                    if (!_aj_) return _aj_;
                    xs$0 = xs$1;
                    ys$0 = ys$1;
                    continue;
                }
            } else if (!match$0) return 1;
            return 0;
        }
    }
    function compare(cmp, xs, ys) {
        var xs$0 = xs, ys$0 = ys;
        for(;;){
            var match = caml_call1(xs$0, 0), match$0 = caml_call1(ys$0, 0);
            if (!match) return match$0 ? -1 : 0;
            var xs$1 = match[2], x = match[1];
            if (!match$0) return 1;
            var ys$1 = match$0[2], y = match$0[1], c = caml_call2(cmp, x, y);
            if (0 !== c) return c;
            xs$0 = xs$1;
            ys$0 = ys$1;
        }
    }
    function init_aux(f, i, j, param) {
        if (i >= j) return 0;
        var _ah_ = i + 1 | 0;
        return [
            0,
            caml_call1(f, i),
            function(_ai_) {
                return init_aux(f, _ah_, j, _ai_);
            }
        ];
    }
    function init(n, f) {
        if (0 > n) return caml_call1(Stdlib[1], cst_Seq_init);
        var _af_ = 0;
        return function(_ag_) {
            return init_aux(f, _af_, n, _ag_);
        };
    }
    function repeat(x, param) {
        return [
            0,
            x,
            function(_ae_) {
                return repeat(x, _ae_);
            }
        ];
    }
    function forever(f, param) {
        return [
            0,
            caml_call1(f, 0),
            function(_ad_) {
                return forever(f, _ad_);
            }
        ];
    }
    function cycle_nonempty(xs, param) {
        return append(xs, function(_ac_) {
            return cycle_nonempty(xs, _ac_);
        }, 0);
    }
    function cycle(xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        function _$_(_ab_) {
            return cycle_nonempty(xs, _ab_);
        }
        return [
            0,
            x,
            function(_aa_) {
                return append(xs$0, _$_, _aa_);
            }
        ];
    }
    function iterate1(f, x, param) {
        var y = caml_call1(f, x);
        return [
            0,
            y,
            function(___) {
                return iterate1(f, y, ___);
            }
        ];
    }
    function iterate(f, x) {
        function next(_Z_) {
            return iterate1(f, x, _Z_);
        }
        return function(_Y_) {
            return [
                0,
                x,
                next
            ];
        };
    }
    function mapi_aux(f, i, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], _W_ = i + 1 | 0;
        return [
            0,
            caml_call2(f, i, x),
            function(_X_) {
                return mapi_aux(f, _W_, xs$0, _X_);
            }
        ];
    }
    function mapi(f, xs) {
        var _U_ = 0;
        return function(_V_) {
            return mapi_aux(f, _U_, xs, _V_);
        };
    }
    function tail_scan(f, s, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], s$0 = caml_call2(f, s, x);
        return [
            0,
            s$0,
            function(_T_1) {
                return tail_scan(f, s$0, xs$0, _T_1);
            }
        ];
    }
    function scan(f, s, xs) {
        function next(_S_) {
            return tail_scan(f, s, xs, _S_);
        }
        return function(_R_) {
            return [
                0,
                s,
                next
            ];
        };
    }
    function take_aux(n, xs) {
        return 0 === n ? empty : function(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                take_aux(n - 1 | 0, xs$0)
            ];
        };
    }
    function take(n, xs) {
        if (n < 0) caml_call1(Stdlib[1], cst_Seq_take);
        return take_aux(n, xs);
    }
    function drop(n, xs) {
        return 0 <= n ? 0 === n ? xs : function(param) {
            var n$0 = n, xs$0 = xs;
            for(;;){
                var match = caml_call1(xs$0, 0);
                if (!match) return 0;
                var xs$1 = match[2], n$1 = n$0 - 1 | 0;
                if (0 === n$1) return caml_call1(xs$1, 0);
                n$0 = n$1;
                xs$0 = xs$1;
            }
        } : caml_call1(Stdlib[1], cst_Seq_drop);
    }
    function take_while(p, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1];
        return caml_call1(p, x) ? [
            0,
            x,
            function(_Q_) {
                return take_while(p, xs$0, _Q_);
            }
        ] : 0;
    }
    function drop_while(p, xs, param) {
        var xs$0 = xs;
        for(;;){
            var node = caml_call1(xs$0, 0);
            if (!node) return 0;
            var xs$1 = node[2], x = node[1];
            if (!caml_call1(p, x)) return node;
            xs$0 = xs$1;
        }
    }
    function group(eq, xs, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], _J_ = caml_call1(eq, x);
        function _K_(_P_) {
            return drop_while(_J_, xs$0, _P_);
        }
        var _L_ = caml_call1(eq, x);
        function next(_O_) {
            return take_while(_L_, xs$0, _O_);
        }
        return [
            0,
            function(_N_) {
                return [
                    0,
                    x,
                    next
                ];
            },
            function(_M_) {
                return group(eq, _K_, _M_);
            }
        ];
    }
    var Forced_twice = [
        248,
        "Stdlib.Seq.Forced_twice",
        runtime.caml_fresh_oo_id(0)
    ], to_lazy = Stdlib_Lazy[6], _a_ = [
        0,
        "seq.ml",
        616,
        4
    ];
    function failure(param) {
        throw caml_maybe_attach_backtrace(Forced_twice, 1);
    }
    function memoize(xs) {
        function s$0(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                memoize(xs$0)
            ];
        }
        var s = caml_call1(to_lazy, s$0);
        return function(param) {
            var _I_ = runtime.caml_obj_tag(s);
            if (250 === _I_) return s[1];
            if (246 !== _I_ && 244 !== _I_) return s;
            return caml_call1(CamlinternalLazy[2], s);
        };
    }
    function once(xs) {
        function f(param) {
            var match = caml_call1(xs, 0);
            if (!match) return 0;
            var xs$0 = match[2], x = match[1];
            return [
                0,
                x,
                once(xs$0)
            ];
        }
        var action = caml_call1(Stdlib_Atomic[1], f);
        return function(param) {
            var f = caml_call2(Stdlib_Atomic[5], action, failure);
            return caml_call1(f, 0);
        };
    }
    function zip(xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], match$0 = caml_call1(ys, 0);
        if (!match$0) return 0;
        var ys$0 = match$0[2], y = match$0[1];
        return [
            0,
            [
                0,
                x,
                y
            ],
            function(_H_) {
                return zip(xs$0, ys$0, _H_);
            }
        ];
    }
    function map2(f, xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return 0;
        var xs$0 = match[2], x = match[1], match$0 = caml_call1(ys, 0);
        if (!match$0) return 0;
        var ys$0 = match$0[2], y = match$0[1];
        return [
            0,
            caml_call2(f, x, y),
            function(_G_) {
                return map2(f, xs$0, ys$0, _G_);
            }
        ];
    }
    function interleave(xs, ys, param) {
        var match = caml_call1(xs, 0);
        if (!match) return caml_call1(ys, 0);
        var xs$0 = match[2], x = match[1];
        return [
            0,
            x,
            function(_F_) {
                return interleave(ys, xs$0, _F_);
            }
        ];
    }
    function sorted_merge1(cmp, x, xs, y, ys) {
        return 0 < caml_call2(cmp, x, y) ? [
            0,
            y,
            function(_D_) {
                var match = caml_call1(ys, 0);
                if (!match) return [
                    0,
                    x,
                    xs
                ];
                var ys$0 = match[2], y = match[1];
                return sorted_merge1(cmp, x, xs, y, ys$0);
            }
        ] : [
            0,
            x,
            function(_E_) {
                var match = caml_call1(xs, 0);
                if (!match) return [
                    0,
                    y,
                    ys
                ];
                var xs$0 = match[2], x = match[1];
                return sorted_merge1(cmp, x, xs$0, y, ys);
            }
        ];
    }
    function sorted_merge(cmp, xs, ys, param) {
        var match = caml_call1(xs, 0), match$0 = caml_call1(ys, 0);
        if (match) {
            if (match$0) {
                var ys$0 = match$0[2], y = match$0[1], xs$0 = match[2], x = match[1];
                return sorted_merge1(cmp, x, xs$0, y, ys$0);
            }
            var c = match;
        } else {
            if (!match$0) return 0;
            var c = match$0;
        }
        return c;
    }
    function map_fst(xys, param) {
        var match = caml_call1(xys, 0);
        if (!match) return 0;
        var xys$0 = match[2], x = match[1][1];
        return [
            0,
            x,
            function(_C_) {
                return map_fst(xys$0, _C_);
            }
        ];
    }
    function map_snd(xys, param) {
        var match = caml_call1(xys, 0);
        if (!match) return 0;
        var xys$0 = match[2], y = match[1][2];
        return [
            0,
            y,
            function(_B_) {
                return map_snd(xys$0, _B_);
            }
        ];
    }
    function unzip(xys) {
        return [
            0,
            function(_A_) {
                return map_fst(xys, _A_);
            },
            function(_z_) {
                return map_snd(xys, _z_);
            }
        ];
    }
    function filter_map_find_left_map(f, xs, param) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (0 === match$0[0]) {
                var y = match$0[1];
                return [
                    0,
                    y,
                    function(_y_) {
                        return filter_map_find_left_map(f, xs$1, _y_);
                    }
                ];
            }
            xs$0 = xs$1;
        }
    }
    function filter_map_find_right_map(f, xs, param) {
        var xs$0 = xs;
        for(;;){
            var match = caml_call1(xs$0, 0);
            if (!match) return 0;
            var xs$1 = match[2], x = match[1], match$0 = caml_call1(f, x);
            if (0 !== match$0[0]) {
                var z = match$0[1];
                return [
                    0,
                    z,
                    function(_x_) {
                        return filter_map_find_right_map(f, xs$1, _x_);
                    }
                ];
            }
            xs$0 = xs$1;
        }
    }
    function partition_map(f, xs) {
        return [
            0,
            function(_w_) {
                return filter_map_find_left_map(f, xs, _w_);
            },
            function(_v_) {
                return filter_map_find_right_map(f, xs, _v_);
            }
        ];
    }
    function partition(p, xs) {
        function _s_(x) {
            return 1 - caml_call1(p, x);
        }
        return [
            0,
            function(_u_) {
                return filter(p, xs, _u_);
            },
            function(_t_) {
                return filter(_s_, xs, _t_);
            }
        ];
    }
    function peel(xss) {
        return unzip(function(_r_) {
            return filter_map(uncons, xss, _r_);
        });
    }
    function transpose(xss, param) {
        var match = peel(xss), tails = match[2], heads = match[1];
        if (!is_empty(heads)) return [
            0,
            heads,
            function(_q_) {
                return transpose(tails, _q_);
            }
        ];
        if (is_empty(tails)) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function _b_(remainders, xss, param) {
        var match = caml_call1(xss, 0);
        if (!match) return transpose(remainders, 0);
        var xss$0 = match[2], xs = match[1], match$0 = caml_call1(xs, 0);
        if (match$0) {
            var xs$0 = match$0[2], x = match$0[1], match$1 = peel(remainders), tails = match$1[2], heads = match$1[1], _l_ = function(_p_) {
                return [
                    0,
                    xs$0,
                    tails
                ];
            };
            return [
                0,
                function(_o_) {
                    return [
                        0,
                        x,
                        heads
                    ];
                },
                function(_n_) {
                    return _b_(_l_, xss$0, _n_);
                }
            ];
        }
        var match$2 = peel(remainders), tails$0 = match$2[2], heads$0 = match$2[1];
        return [
            0,
            heads$0,
            function(_m_) {
                return _b_(tails$0, xss$0, _m_);
            }
        ];
    }
    function map_product(f, xs, ys) {
        function _f_(x) {
            function _j_(y) {
                return caml_call2(f, x, y);
            }
            return function(_k_) {
                return map(_j_, ys, _k_);
            };
        }
        function xss(_i_) {
            return map(_f_, xs, _i_);
        }
        function _e_(_h_) {
            return _b_(empty, xss, _h_);
        }
        return function(_g_) {
            return concat(_e_, _g_);
        };
    }
    function product(xs, ys) {
        return map_product(function(x, y) {
            return [
                0,
                x,
                y
            ];
        }, xs, ys);
    }
    function of_dispenser(it) {
        function c(param) {
            var match = caml_call1(it, 0);
            if (!match) return 0;
            var x = match[1];
            return [
                0,
                x,
                c
            ];
        }
        return c;
    }
    function to_dispenser(xs) {
        var s = [
            0,
            xs
        ];
        return function(param) {
            var match = caml_call1(s[1], 0);
            if (!match) return 0;
            var xs = match[2], x = match[1];
            s[1] = xs;
            return [
                0,
                x
            ];
        };
    }
    function ints(i, param) {
        var _c_ = i + 1 | 0;
        return [
            0,
            i,
            function(_d_) {
                return ints(_c_, _d_);
            }
        ];
    }
    var Stdlib_Seq = [
        0,
        is_empty,
        uncons,
        length,
        iter,
        fold_left,
        iteri,
        fold_lefti,
        for_all,
        exists,
        find,
        find_index,
        find_map,
        find_mapi,
        iter2,
        fold_left2,
        for_all2,
        exists2,
        equal,
        compare,
        empty,
        return$0,
        cons,
        init,
        unfold,
        repeat,
        forever,
        cycle,
        iterate,
        map,
        mapi,
        filter,
        filter_map,
        scan,
        take,
        drop,
        take_while,
        drop_while,
        group,
        memoize,
        Forced_twice,
        once,
        transpose,
        append,
        concat,
        flat_map,
        flat_map,
        zip,
        map2,
        interleave,
        sorted_merge,
        product,
        map_product,
        unzip,
        unzip,
        partition_map,
        partition,
        of_dispenser,
        to_dispenser,
        ints
    ];
    runtime.caml_register_global(10, Stdlib_Seq, "Stdlib__Seq");
    return;
})(globalThis);
//# 1930 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, cst_option_is_None = "option is None";
    function some(v) {
        return [
            0,
            v
        ];
    }
    function value(o, default$0) {
        if (!o) return default$0;
        var v = o[1];
        return v;
    }
    function get(param) {
        if (!param) return caml_call1(Stdlib[1], cst_option_is_None);
        var v = param[1];
        return v;
    }
    function bind(o, f) {
        if (!o) return 0;
        var v = o[1];
        return caml_call1(f, v);
    }
    function join(param) {
        if (!param) return 0;
        var o = param[1];
        return o;
    }
    function map(f, o) {
        if (!o) return 0;
        var v = o[1];
        return [
            0,
            caml_call1(f, v)
        ];
    }
    function fold(none, some, param) {
        if (!param) return none;
        var v = param[1];
        return caml_call1(some, v);
    }
    function iter(f, param) {
        if (!param) return 0;
        var v = param[1];
        return caml_call1(f, v);
    }
    function is_none(param) {
        return param ? 0 : 1;
    }
    function is_some(param) {
        return param ? 1 : 0;
    }
    function equal(eq, o0, o1) {
        if (o0) {
            if (o1) {
                var v1 = o1[1], v0 = o0[1];
                return caml_call2(eq, v0, v1);
            }
        } else if (!o1) return 1;
        return 0;
    }
    function compare(cmp, o0, o1) {
        if (!o0) return o1 ? -1 : 0;
        var v0 = o0[1];
        if (!o1) return 1;
        var v1 = o1[1];
        return caml_call2(cmp, v0, v1);
    }
    function to_result(none, param) {
        if (!param) return [
            1,
            none
        ];
        var v = param[1];
        return [
            0,
            v
        ];
    }
    function to_list(param) {
        if (!param) return 0;
        var v = param[1];
        return [
            0,
            v,
            0
        ];
    }
    function to_seq(param) {
        if (!param) return Stdlib_Seq[20];
        var v = param[1];
        return caml_call1(Stdlib_Seq[21], v);
    }
    var Stdlib_Option = [
        0,
        0,
        some,
        value,
        get,
        bind,
        join,
        map,
        fold,
        iter,
        is_none,
        is_some,
        equal,
        compare,
        to_result,
        to_list,
        to_seq
    ];
    runtime.caml_register_global(3, Stdlib_Option, "Stdlib__Option");
    return;
})(globalThis);
//# 2038 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, cst_result_is_Error = "result is Error _", cst_result_is_Ok = "result is Ok _";
    function ok(v) {
        return [
            0,
            v
        ];
    }
    function error(e) {
        return [
            1,
            e
        ];
    }
    function value(r, default$0) {
        if (0 !== r[0]) return default$0;
        var v = r[1];
        return v;
    }
    function get_ok(param) {
        if (0 !== param[0]) return caml_call1(Stdlib[1], cst_result_is_Error);
        var v = param[1];
        return v;
    }
    function get_error(param) {
        if (0 === param[0]) return caml_call1(Stdlib[1], cst_result_is_Ok);
        var e = param[1];
        return e;
    }
    function bind(r, f) {
        if (0 !== r[0]) return r;
        var v = r[1];
        return caml_call1(f, v);
    }
    function join(e) {
        if (0 !== e[0]) return e;
        var r = e[1];
        return r;
    }
    function map(f, e) {
        if (0 !== e[0]) return e;
        var v = e[1];
        return [
            0,
            caml_call1(f, v)
        ];
    }
    function map_error(f, v) {
        if (0 === v[0]) return v;
        var e = v[1];
        return [
            1,
            caml_call1(f, e)
        ];
    }
    function fold(ok, error, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call1(ok, v);
        }
        var e = param[1];
        return caml_call1(error, e);
    }
    function iter(f, param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return caml_call1(f, v);
    }
    function iter_error(f, param) {
        if (0 === param[0]) return 0;
        var e = param[1];
        return caml_call1(f, e);
    }
    function is_ok(param) {
        return 0 === param[0] ? 1 : 0;
    }
    function is_error(param) {
        return 0 === param[0] ? 0 : 1;
    }
    function equal(ok, error, r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 === r1[0]) {
                var v1 = r1[1];
                return caml_call2(ok, v0, v1);
            }
        } else {
            var e0 = r0[1];
            if (0 !== r1[0]) {
                var e1 = r1[1];
                return caml_call2(error, e0, e1);
            }
        }
        return 0;
    }
    function compare(ok, error, r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 !== r1[0]) return -1;
            var v1 = r1[1];
            return caml_call2(ok, v0, v1);
        }
        var e0 = r0[1];
        if (0 === r1[0]) return 1;
        var e1 = r1[1];
        return caml_call2(error, e0, e1);
    }
    function to_option(param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return [
            0,
            v
        ];
    }
    function to_list(param) {
        if (0 !== param[0]) return 0;
        var v = param[1];
        return [
            0,
            v,
            0
        ];
    }
    function to_seq(param) {
        if (0 !== param[0]) return Stdlib_Seq[20];
        var v = param[1];
        return caml_call1(Stdlib_Seq[21], v);
    }
    var Stdlib_Result = [
        0,
        ok,
        error,
        value,
        get_ok,
        get_error,
        bind,
        join,
        map,
        map_error,
        fold,
        iter,
        iter_error,
        is_ok,
        is_error,
        equal,
        compare,
        to_option,
        to_list,
        to_seq
    ];
    runtime.caml_register_global(4, Stdlib_Result, "Stdlib__Result");
    return;
})(globalThis);
//# 2204 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_hash = runtime.caml_hash, caml_string_of_bytes = runtime.caml_string_of_bytes;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "\\\\", cst$0 = "\\'", Stdlib = global_data.Stdlib, cst_Char_chr = "Char.chr", cst_b = "\\b", cst_t = "\\t", cst_n = "\\n", cst_r = "\\r";
    function chr(n) {
        if (0 <= n && 255 >= n) return n;
        return caml_call1(Stdlib[1], cst_Char_chr);
    }
    function escaped(c) {
        a: {
            if (40 <= c) {
                if (92 === c) return cst;
                if (127 > c) break a;
            } else {
                if (32 <= c) {
                    if (39 <= c) return cst$0;
                    break a;
                }
                if (14 > c) switch(c){
                    case 8:
                        return cst_b;
                    case 9:
                        return cst_t;
                    case 10:
                        return cst_n;
                    case 13:
                        return cst_r;
                }
            }
            var s = caml_create_bytes(4);
            caml_bytes_unsafe_set(s, 0, 92);
            caml_bytes_unsafe_set(s, 1, 48 + (c / 100 | 0) | 0);
            caml_bytes_unsafe_set(s, 2, 48 + ((c / 10 | 0) % 10 | 0) | 0);
            caml_bytes_unsafe_set(s, 3, 48 + (c % 10 | 0) | 0);
            return caml_string_of_bytes(s);
        }
        var s$0 = caml_create_bytes(1);
        caml_bytes_unsafe_set(s$0, 0, c);
        return caml_string_of_bytes(s$0);
    }
    function lowercase_ascii(c) {
        return 25 < c - 65 >>> 0 ? c : c + 32 | 0;
    }
    function uppercase_ascii(c) {
        return 25 < c - 97 >>> 0 ? c : c - 32 | 0;
    }
    function compare(c1, c2) {
        return c1 - c2 | 0;
    }
    function equal(c1, c2) {
        return 0 === (c1 - c2 | 0) ? 1 : 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Char = [
        0,
        chr,
        escaped,
        lowercase_ascii,
        uppercase_ascii,
        compare,
        equal,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(8, Stdlib_Char, "Stdlib__Char");
    return;
})(globalThis);
//# 2288 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_uchar_ml = "uchar.ml", caml_format_int = runtime.caml_format_int, caml_hash = runtime.caml_hash, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), err_no_pred = "U+0000 has no predecessor", err_no_succ = "U+10FFFF has no successor", Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, cst_is_not_a_Unicode_scalar_va = " is not a Unicode scalar value", cst_is_not_a_latin1_character = " is not a latin1 character", cst_U = "U+", lo_bound = 55295, hi_bound = 57344;
    function succ(u) {
        return u === 55295 ? hi_bound : u === 1114111 ? caml_call1(Stdlib[1], err_no_succ) : u + 1 | 0;
    }
    function pred(u) {
        return u === 57344 ? lo_bound : u === 0 ? caml_call1(Stdlib[1], err_no_pred) : u - 1 | 0;
    }
    function is_valid(i) {
        var _m_ = 0 <= i ? 1 : 0, _n_ = _m_ ? i <= 55295 ? 1 : 0 : _m_;
        if (_n_) var _o_ = _n_;
        else var _p_ = 57344 <= i ? 1 : 0, _o_ = _p_ ? i <= 1114111 ? 1 : 0 : _p_;
        return _o_;
    }
    function of_int(i) {
        if (is_valid(i)) return i;
        var _l_ = caml_call2(Stdlib[28], caml_format_int("%X", i), cst_is_not_a_Unicode_scalar_va);
        return caml_call1(Stdlib[1], _l_);
    }
    function is_char(u) {
        return u < 256 ? 1 : 0;
    }
    function of_char(c) {
        return c;
    }
    function to_char(u) {
        if (255 >= u) return u;
        var _j_ = caml_call2(Stdlib[28], caml_format_int("%04X", u), cst_is_not_a_latin1_character), _k_ = caml_call2(Stdlib[28], cst_U, _j_);
        return caml_call1(Stdlib[1], _k_);
    }
    function unsafe_to_char(_i_) {
        return _i_;
    }
    function equal(_h_, _g_) {
        return _h_ === _g_ ? 1 : 0;
    }
    var compare = runtime.caml_int_compare, _a_ = [
        0,
        cst_uchar_ml,
        89,
        7
    ], _b_ = [
        0,
        cst_uchar_ml,
        84,
        18
    ], _c_ = [
        0,
        cst_uchar_ml,
        95,
        7
    ], _d_ = [
        0,
        cst_uchar_ml,
        92,
        18
    ];
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    function utf_decode_is_valid(d) {
        return 1 === (d >>> 27 | 0) ? 1 : 0;
    }
    function utf_decode_length(d) {
        return (d >>> 24 | 0) & 7;
    }
    function utf_decode_uchar(d) {
        return d & 16777215;
    }
    function utf_decode(n, u) {
        return (8 | n) << 24 | u;
    }
    function utf_decode_invalid(n) {
        return n << 24 | 65533;
    }
    function utf_8_byte_length(u) {
        if (0 > u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        if (127 >= u) return 1;
        if (2047 >= u) return 2;
        if (65535 >= u) return 3;
        if (1114111 < u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
        return 4;
    }
    function utf_16_byte_length(u) {
        if (0 > u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _d_
        ], 1);
        if (65535 >= u) return 2;
        if (1114111 < u) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
        return 4;
    }
    var Stdlib_Uchar = [
        0,
        0,
        1114111,
        65279,
        65533,
        succ,
        pred,
        is_valid,
        of_int,
        function(_f_) {
            return _f_;
        },
        function(_e_) {
            return _e_;
        },
        is_char,
        of_char,
        to_char,
        unsafe_to_char,
        equal,
        compare,
        seeded_hash,
        hash,
        utf_decode_is_valid,
        utf_decode_uchar,
        utf_decode_length,
        utf_decode,
        utf_decode_invalid,
        utf_8_byte_length,
        utf_16_byte_length
    ];
    runtime.caml_register_global(13, Stdlib_Uchar, "Stdlib__Uchar");
    return;
})(globalThis);
//# 2423 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_List_map2$1 = "List.map2", cst_List_nth$1 = "List.nth", caml_compare = runtime.caml_compare, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, cst_hd = "hd", cst_tl = "tl", cst_nth = "nth", cst_List_nth = cst_List_nth$1, cst_List_nth$0 = cst_List_nth$1;
    function length(l$0) {
        var len = 0, param = l$0;
        for(;;){
            if (!param) return len;
            var l = param[2], len$0 = len + 1 | 0;
            len = len$0;
            param = l;
        }
    }
    function cons(a, l) {
        return [
            0,
            a,
            l
        ];
    }
    function hd(param) {
        if (!param) return caml_call1(Stdlib[2], cst_hd);
        var a = param[1];
        return a;
    }
    function tl(param) {
        if (!param) return caml_call1(Stdlib[2], cst_tl);
        var l = param[2];
        return l;
    }
    function nth(l, n) {
        if (0 > n) return caml_call1(Stdlib[1], cst_List_nth);
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return caml_call1(Stdlib[2], cst_nth);
            var l$1 = l$0[2], a = l$0[1];
            if (0 === n$0) return a;
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    function nth_opt(l, n) {
        if (0 > n) return caml_call1(Stdlib[1], cst_List_nth$0);
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return 0;
            var l$1 = l$0[2], a = l$0[1];
            if (0 === n$0) return [
                0,
                a
            ];
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    var append = Stdlib[37], cst_List_init = "List.init", cst_List_map2 = cst_List_map2$1, cst_List_map2$0 = cst_List_map2$1, cst_List_rev_map2 = "List.rev_map2", cst_List_iter2 = "List.iter2", cst_List_fold_left2 = "List.fold_left2", cst_List_fold_right2 = "List.fold_right2", cst_List_for_all2 = "List.for_all2", cst_List_exists2 = "List.exists2", cst_List_take = "List.take", cst_List_drop = "List.drop", _a_ = [
        0,
        0,
        0
    ], cst_List_combine = "List.combine";
    function rev_append(l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0;
            var l1$1 = l1$0[2], a = l1$0[1], l2$1 = [
                0,
                a,
                l2$0
            ];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function rev(l) {
        return rev_append(l, 0);
    }
    function init(len, f) {
        if (0 > len) return caml_call1(Stdlib[1], cst_List_init);
        var last = len - 1 | 0, i$1 = 0;
        if (last < 0) return 0;
        if (0 === last) return [
            0,
            caml_call1(f, i$1),
            0
        ];
        var r1 = caml_call1(f, i$1), r2 = caml_call1(f, 1), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, i = 2;
        for(;;){
            if (last < i) dst[1 + offset] = 0;
            else {
                if (i !== last) {
                    var r1$0 = caml_call1(f, i), r2$0 = caml_call1(f, i + 1 | 0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$0,
                        dst$0
                    ];
                    var i$0 = i + 2 | 0;
                    dst = dst$0;
                    offset = 1;
                    i = i$0;
                    continue;
                }
                dst[1 + offset] = [
                    0,
                    caml_call1(f, i),
                    0
                ];
            }
            return [
                0,
                r1,
                block
            ];
        }
    }
    function flatten(param) {
        if (!param) return 0;
        var r = param[2], l = param[1], _I_ = flatten(r);
        return caml_call2(Stdlib[37], l, _I_);
    }
    function map(f, param) {
        if (!param) return 0;
        var match = param[2], a1 = param[1];
        if (!match) {
            var r1$0 = caml_call1(f, a1);
            return [
                0,
                r1$0,
                0
            ];
        }
        var l = match[2], a2 = match[1], r1 = caml_call1(f, a1), r2 = caml_call1(f, a2), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, param$0 = l;
        for(;;){
            if (param$0) {
                var match$0 = param$0[2], a1$0 = param$0[1];
                if (match$0) {
                    var l$0 = match$0[2], a2$0 = match$0[1], r1$1 = caml_call1(f, a1$0), r2$0 = caml_call1(f, a2$0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$1,
                        dst$0
                    ];
                    dst = dst$0;
                    offset = 1;
                    param$0 = l$0;
                    continue;
                }
                var r1$2 = caml_call1(f, a1$0);
                dst[1 + offset] = [
                    0,
                    r1$2,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                r1,
                block
            ];
        }
    }
    function mapi(f, l$1) {
        var i$1 = 0;
        if (!l$1) return 0;
        var match = l$1[2], a1 = l$1[1];
        if (!match) {
            var r1$0 = caml_call2(f, i$1, a1);
            return [
                0,
                r1$0,
                0
            ];
        }
        var l = match[2], a2 = match[1], r1 = caml_call2(f, i$1, a1), r2 = caml_call2(f, 1, a2), block = [
            0,
            r2,
            24029
        ], dst = block, offset = 1, i = 2, param = l;
        for(;;){
            if (param) {
                var match$0 = param[2], a1$0 = param[1];
                if (match$0) {
                    var l$0 = match$0[2], a2$0 = match$0[1], r1$1 = caml_call2(f, i, a1$0), r2$0 = caml_call2(f, i + 1 | 0, a2$0), dst$0 = [
                        0,
                        r2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        r1$1,
                        dst$0
                    ];
                    var i$0 = i + 2 | 0;
                    dst = dst$0;
                    offset = 1;
                    i = i$0;
                    param = l$0;
                    continue;
                }
                var r1$2 = caml_call2(f, i, a1$0);
                dst[1 + offset] = [
                    0,
                    r1$2,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                r1,
                block
            ];
        }
    }
    function rev_map(f, l) {
        var accu = 0, param = l;
        for(;;){
            if (!param) return accu;
            var l$0 = param[2], a = param[1], accu$0 = [
                0,
                caml_call1(f, a),
                accu
            ];
            accu = accu$0;
            param = l$0;
        }
    }
    function iter(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1];
            caml_call1(f, a);
            param$0 = l;
        }
    }
    function iteri(f, l$0) {
        var i = 0, param = l$0;
        for(;;){
            if (!param) return 0;
            var l = param[2], a = param[1];
            caml_call2(f, i, a);
            var i$0 = i + 1 | 0;
            i = i$0;
            param = l;
        }
    }
    function fold_left(f, accu, l) {
        var accu$0 = accu, l$0 = l;
        for(;;){
            if (!l$0) return accu$0;
            var l$1 = l$0[2], a = l$0[1], accu$1 = caml_call2(f, accu$0, a);
            accu$0 = accu$1;
            l$0 = l$1;
        }
    }
    function fold_right(f, l, accu) {
        if (!l) return accu;
        var l$0 = l[2], a = l[1];
        return caml_call2(f, a, fold_right(f, l$0, accu));
    }
    function map2(f, l1, l2) {
        if (l1) {
            var _G_ = l1[2], a1 = l1[1];
            if (_G_) {
                if (l2) {
                    var match = l2[2];
                    if (match) {
                        var l2$0 = match[2], b2 = match[1], b1 = l2[1], l1$0 = _G_[2], a2 = _G_[1], r1 = caml_call2(f, a1, b1), r2 = caml_call2(f, a2, b2), block = [
                            0,
                            r2,
                            24029
                        ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0;
                        for(;;){
                            a: {
                                if (l1$1) {
                                    var _H_ = l1$1[2], a1$0 = l1$1[1];
                                    if (_H_) {
                                        if (l2$1) {
                                            var match$0 = l2$1[2];
                                            if (match$0) {
                                                var l2$2 = match$0[2], b2$0 = match$0[1], b1$1 = l2$1[1], l1$2 = _H_[2], a2$0 = _H_[1], r1$1 = caml_call2(f, a1$0, b1$1), r2$0 = caml_call2(f, a2$0, b2$0), dst$0 = [
                                                    0,
                                                    r2$0,
                                                    24029
                                                ];
                                                dst[1 + offset] = [
                                                    0,
                                                    r1$1,
                                                    dst$0
                                                ];
                                                dst = dst$0;
                                                offset = 1;
                                                l1$1 = l1$2;
                                                l2$1 = l2$2;
                                                continue;
                                            }
                                        }
                                    } else if (l2$1 && !l2$1[2]) {
                                        var b1$2 = l2$1[1], r1$2 = caml_call2(f, a1$0, b1$2);
                                        dst[1 + offset] = [
                                            0,
                                            r1$2,
                                            0
                                        ];
                                        break a;
                                    }
                                } else if (!l2$1) {
                                    dst[1 + offset] = 0;
                                    break a;
                                }
                                dst[1 + offset] = caml_call1(Stdlib[1], cst_List_map2$0);
                            }
                            return [
                                0,
                                r1,
                                block
                            ];
                        }
                    }
                }
            } else if (l2 && !l2[2]) {
                var b1$0 = l2[1], r1$0 = caml_call2(f, a1, b1$0);
                return [
                    0,
                    r1$0,
                    0
                ];
            }
        } else if (!l2) return 0;
        return caml_call1(Stdlib[1], cst_List_map2);
    }
    function rev_map2(f, l1, l2) {
        var accu = 0, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], accu$0 = [
                        0,
                        caml_call2(f, a1, a2),
                        accu
                    ];
                    accu = accu$0;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return accu;
            return caml_call1(Stdlib[1], cst_List_rev_map2);
        }
    }
    function iter2(f, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1];
                    caml_call2(f, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Stdlib[1], cst_List_iter2);
        }
    }
    function fold_left2(f, accu, l1, l2) {
        var accu$0 = accu, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], accu$1 = caml_call3(f, accu$0, a1, a2);
                    accu$0 = accu$1;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return accu$0;
            return caml_call1(Stdlib[1], cst_List_fold_left2);
        }
    }
    function fold_right2(f, l1, l2, accu) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1];
                return caml_call3(f, a1, a2, fold_right2(f, l1$0, l2$0, accu));
            }
        } else if (!l2) return accu;
        return caml_call1(Stdlib[1], cst_List_fold_right2);
    }
    function for_all(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 1;
            var l = param$0[2], a = param$0[1], _F_ = caml_call1(p, a);
            if (!_F_) return _F_;
            param$0 = l;
        }
    }
    function exists(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _E_ = caml_call1(p, a);
            if (_E_) return _E_;
            param$0 = l;
        }
    }
    function for_all2(p, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _D_ = caml_call2(p, a1, a2);
                    if (!_D_) return _D_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return caml_call1(Stdlib[1], cst_List_for_all2);
        }
    }
    function exists2(p, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _C_ = caml_call2(p, a1, a2);
                    if (_C_) return _C_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Stdlib[1], cst_List_exists2);
        }
    }
    function mem(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _B_ = 0 === caml_compare(a, x) ? 1 : 0;
            if (_B_) return _B_;
            param$0 = l;
        }
    }
    function memq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1], _A_ = a === x ? 1 : 0;
            if (_A_) return _A_;
            param$0 = l;
        }
    }
    function assoc(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (0 === caml_compare(a, x)) return b;
            param$0 = l;
        }
    }
    function assoc_opt(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (0 === caml_compare(a, x)) return [
                0,
                b
            ];
            param$0 = l;
        }
    }
    function assq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (a === x) return b;
            param$0 = l;
        }
    }
    function assq_opt(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], match = param$0[1], b = match[2], a = match[1];
            if (a === x) return [
                0,
                b
            ];
            param$0 = l;
        }
    }
    function mem_assoc(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1][1], _z_ = 0 === caml_compare(a, x) ? 1 : 0;
            if (_z_) return _z_;
            param$0 = l;
        }
    }
    function mem_assq(x, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], a = param$0[1][1], _y_ = a === x ? 1 : 0;
            if (_y_) return _y_;
            param$0 = l;
        }
    }
    function remove_assoc(x, param) {
        if (!param) return 0;
        var l = param[2], pair = param[1], a = pair[1];
        return 0 === caml_compare(a, x) ? l : [
            0,
            pair,
            remove_assoc(x, l)
        ];
    }
    function remove_assq(x, param) {
        if (!param) return 0;
        var l = param[2], pair = param[1], a = pair[1];
        return a === x ? l : [
            0,
            pair,
            remove_assq(x, l)
        ];
    }
    function find(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) return x;
            param$0 = l;
        }
    }
    function find_opt(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            param$0 = l;
        }
    }
    function find_index(p) {
        var i = 0;
        return function(param$0) {
            var i$0 = i, param = param$0;
            for(;;){
                if (!param) return 0;
                var l = param[2], a = param[1];
                if (caml_call1(p, a)) return [
                    0,
                    i$0
                ];
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                param = l;
            }
        };
    }
    function find_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1], result = caml_call1(f, x);
            if (result) return result;
            param$0 = l;
        }
    }
    function find_mapi(f) {
        var i = 0;
        return function(param$0) {
            var i$0 = i, param = param$0;
            for(;;){
                if (!param) return 0;
                var l = param[2], x = param[1], result = caml_call2(f, i$0, x);
                if (result) return result;
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                param = l;
            }
        };
    }
    function find_all(p, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1];
            if (caml_call1(p, x)) {
                var block = [
                    0,
                    x,
                    24029
                ], dst = block, offset = 1, param$1 = l;
                for(;;){
                    if (!param$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var l$0 = param$1[2], x$0 = param$1[1];
                    if (caml_call1(p, x$0)) {
                        var dst$0 = [
                            0,
                            x$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        param$1 = l$0;
                    } else param$1 = l$0;
                }
            } else param$0 = l;
        }
    }
    function filteri(p, l$1) {
        var i = 0, param = l$1;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1], i$0 = i + 1 | 0;
            if (caml_call2(p, i, x)) break;
            i = i$0;
            param = l;
        }
        var block = [
            0,
            x,
            24029
        ], dst = block, offset = 1, i$1 = i$0, param$0 = l;
        for(;;){
            if (!param$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var l$0 = param$0[2], x$0 = param$0[1], i$2 = i$1 + 1 | 0;
            if (caml_call2(p, i$1, x$0)) {
                var dst$0 = [
                    0,
                    x$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                i$1 = i$2;
                param$0 = l$0;
            } else {
                i$1 = i$2;
                param$0 = l$0;
            }
        }
    }
    function filter_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], x = param$0[1], match = caml_call1(f, x);
            if (match) {
                var v = match[1], block = [
                    0,
                    v,
                    24029
                ], dst = block, offset = 1, param$1 = l;
                for(;;){
                    if (!param$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var l$0 = param$1[2], x$0 = param$1[1], match$0 = caml_call1(f, x$0);
                    if (match$0) {
                        var v$0 = match$0[1], dst$0 = [
                            0,
                            v$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        param$1 = l$0;
                    } else param$1 = l$0;
                }
            } else param$0 = l;
        }
    }
    function concat_map(f, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var xs = param$0[2], x = param$0[1], ys = caml_call1(f, x);
            if (ys) {
                var ys$1 = ys[2], y = ys[1], block = [
                    0,
                    y,
                    24029
                ], dst = block, offset = 1, ys$2 = ys$1, xs$1 = xs;
                for(;;)if (ys$2) {
                    var ys$3 = ys$2[2], y$0 = ys$2[1], dst$0 = [
                        0,
                        y$0,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    ys$2 = ys$3;
                } else {
                    if (!xs$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var xs$0 = xs$1[2], x$0 = xs$1[1], ys$0 = caml_call1(f, x$0);
                    ys$2 = ys$0;
                    xs$1 = xs$0;
                }
            } else param$0 = xs;
        }
    }
    function take(n, l) {
        if (n < 0) caml_call1(Stdlib[1], cst_List_take);
        if (0 !== n && l) {
            var l$0 = l[2], x = l[1], block = [
                0,
                x,
                24029
            ], n$0 = n - 1 | 0, dst = block, offset = 1, n$1 = n$0, l$1 = l$0;
            for(;;){
                if (0 !== n$1 && l$1) {
                    var l$2 = l$1[2], x$0 = l$1[1], dst$0 = [
                        0,
                        x$0,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    var n$2 = n$1 - 1 | 0;
                    dst = dst$0;
                    offset = 1;
                    n$1 = n$2;
                    l$1 = l$2;
                    continue;
                }
                dst[1 + offset] = 0;
                return block;
            }
        }
        return 0;
    }
    function drop(n, rest) {
        if (n < 0) caml_call1(Stdlib[1], cst_List_drop);
        var i = 0, rest$0 = rest;
        for(;;){
            if (rest$0) {
                var rest$1 = rest$0[2];
                if (i < n) {
                    var i$0 = i + 1 | 0;
                    i = i$0;
                    rest$0 = rest$1;
                    continue;
                }
            }
            return rest$0;
        }
    }
    function take_while(p, rest) {
        if (rest) {
            var rest$0 = rest[2], x = rest[1];
            if (caml_call1(p, x)) {
                var block = [
                    0,
                    x,
                    24029
                ], dst = block, offset = 1, rest$1 = rest$0;
                for(;;){
                    if (rest$1) {
                        var rest$2 = rest$1[2], x$0 = rest$1[1];
                        if (caml_call1(p, x$0)) {
                            var dst$0 = [
                                0,
                                x$0,
                                24029
                            ];
                            dst[1 + offset] = dst$0;
                            dst = dst$0;
                            offset = 1;
                            rest$1 = rest$2;
                            continue;
                        }
                    }
                    dst[1 + offset] = 0;
                    return block;
                }
            }
        }
        return 0;
    }
    function drop_while(p, rest) {
        var rest$0 = rest;
        for(;;){
            if (rest$0) {
                var rest$1 = rest$0[2], x = rest$0[1];
                if (caml_call1(p, x)) {
                    rest$0 = rest$1;
                    continue;
                }
            }
            return rest$0;
        }
    }
    function fold_left_map(f, accu, l) {
        var accu$0 = accu, l_accu = 0, param = l;
        for(;;){
            if (!param) return [
                0,
                accu$0,
                rev(l_accu)
            ];
            var l$0 = param[2], x = param[1], match = caml_call2(f, accu$0, x), x$0 = match[2], accu$1 = match[1], l_accu$0 = [
                0,
                x$0,
                l_accu
            ];
            accu$0 = accu$1;
            l_accu = l_accu$0;
            param = l$0;
        }
    }
    function partition(p, l) {
        var yes = 0, no = 0, param = l;
        for(;;){
            if (!param) {
                var _x_ = rev(no);
                return [
                    0,
                    rev(yes),
                    _x_
                ];
            }
            var l$0 = param[2], x = param[1];
            if (caml_call1(p, x)) {
                var yes$0 = [
                    0,
                    x,
                    yes
                ];
                yes = yes$0;
                param = l$0;
            } else {
                var no$0 = [
                    0,
                    x,
                    no
                ];
                no = no$0;
                param = l$0;
            }
        }
    }
    function partition_map(p, l) {
        var left = 0, right = 0, param = l;
        for(;;){
            if (!param) {
                var _w_ = rev(right);
                return [
                    0,
                    rev(left),
                    _w_
                ];
            }
            var l$0 = param[2], x = param[1], match = caml_call1(p, x);
            if (0 === match[0]) {
                var v = match[1], left$0 = [
                    0,
                    v,
                    left
                ];
                left = left$0;
                param = l$0;
            } else {
                var v$0 = match[1], right$0 = [
                    0,
                    v$0,
                    right
                ];
                right = right$0;
                param = l$0;
            }
        }
    }
    function split(param) {
        if (!param) return _a_;
        var l = param[2], match = param[1], y = match[2], x = match[1], match$0 = split(l), ry = match$0[2], rx = match$0[1];
        return [
            0,
            [
                0,
                x,
                rx
            ],
            [
                0,
                y,
                ry
            ]
        ];
    }
    function combine(l1, l2) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1];
                return [
                    0,
                    [
                        0,
                        a1,
                        a2
                    ],
                    combine(l1$0, l2$0)
                ];
            }
        } else if (!l2) return 0;
        return caml_call1(Stdlib[1], cst_List_combine);
    }
    function merge(cmp, l1, l2) {
        if (!l1) return l2;
        if (!l2) return l1;
        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
        return 0 < caml_call2(cmp, h1, h2) ? [
            0,
            h2,
            merge(cmp, l1, t2)
        ] : [
            0,
            h1,
            merge(cmp, t1, l2)
        ];
    }
    function stable_sort(cmp, l) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _v_ = l[2];
                if (_v_) {
                    var match$2 = _v_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _v_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x1$0, x3) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _u_ = rev_append(l1, accu);
                } else var _u_ = rev_append(l2, accu);
                return [
                    0,
                    _u_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _t_ = l[2];
                if (_t_) {
                    var match$2 = _t_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _t_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$1;
                        continue;
                    }
                    var _s_ = rev_append(l1, accu);
                } else var _s_ = rev_append(l2, accu);
                return [
                    0,
                    _s_,
                    tl$0
                ];
            }
        }
        var len = length(l);
        return 2 <= len ? sort(len, l)[1] : l;
    }
    function sort_uniq(cmp, l) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2), s = 0 === c$0 ? [
                            0,
                            x1,
                            0
                        ] : 0 <= c$0 ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _m_ = l[2];
                if (_m_) {
                    var match$2 = _m_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _m_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 === c$1) var c$2 = caml_call2(cmp, x2$0, x3), _n_ = 0 === c$2 ? [
                            0,
                            x2$0,
                            0
                        ] : 0 <= c$2 ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                0
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                0
                            ]
                        ], s$0 = _n_;
                        else if (0 <= c$1) {
                            var c$3 = caml_call2(cmp, x1$0, x3);
                            if (0 === c$3) var _o_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ];
                            else if (0 <= c$3) var c$4 = caml_call2(cmp, x2$0, x3), _p_ = 0 === c$4 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ] : 0 <= c$4 ? [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ], _o_ = _p_;
                            else var _o_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _o_;
                        } else {
                            var c$5 = caml_call2(cmp, x2$0, x3);
                            if (0 === c$5) var _q_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ];
                            else if (0 <= c$5) var c$6 = caml_call2(cmp, x1$0, x3), _r_ = 0 === c$6 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ] : 0 <= c$6 ? [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ], _q_ = _r_;
                            else var _q_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _q_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 === c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        if (0 < c) {
                            var accu$1 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$1;
                            continue;
                        }
                        var accu$2 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$2;
                        continue;
                    }
                    var _l_ = rev_append(l1, accu);
                } else var _l_ = rev_append(l2, accu);
                return [
                    0,
                    _l_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2), s = 0 === c$0 ? [
                            0,
                            x1,
                            0
                        ] : 0 < c$0 ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _f_ = l[2];
                if (_f_) {
                    var match$2 = _f_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _f_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 === c$1) var c$2 = caml_call2(cmp, x2$0, x3), _g_ = 0 === c$2 ? [
                            0,
                            x2$0,
                            0
                        ] : 0 < c$2 ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                0
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                0
                            ]
                        ], s$0 = _g_;
                        else if (0 < c$1) {
                            var c$3 = caml_call2(cmp, x2$0, x3);
                            if (0 === c$3) var _h_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ];
                            else if (0 < c$3) var _h_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else var c$4 = caml_call2(cmp, x1$0, x3), _i_ = 0 === c$4 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ] : 0 < c$4 ? [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ]
                            ], _h_ = _i_;
                            var s$0 = _h_;
                        } else {
                            var c$5 = caml_call2(cmp, x1$0, x3);
                            if (0 === c$5) var _j_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ];
                            else if (0 < c$5) var _j_ = [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else var c$6 = caml_call2(cmp, x2$0, x3), _k_ = 0 === c$6 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ] : 0 < c$6 ? [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ] : [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        0
                                    ]
                                ]
                            ], _j_ = _k_;
                            var s$0 = _j_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = n >> 1, n2 = n - n1 | 0, match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 === c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        if (0 <= c) {
                            var accu$1 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$1;
                            continue;
                        }
                        var accu$2 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$2;
                        continue;
                    }
                    var _e_ = rev_append(l1, accu);
                } else var _e_ = rev_append(l2, accu);
                return [
                    0,
                    _e_,
                    tl$0
                ];
            }
        }
        var len = length(l);
        return 2 <= len ? sort(len, l)[1] : l;
    }
    function compare_lengths(l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0 ? -1 : 0;
            if (!l2$0) return 1;
            var l2$1 = l2$0[2], l1$1 = l1$0[2];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function compare_length_with(l, n) {
        var l$0 = l, n$0 = n;
        for(;;){
            if (!l$0) return 0 === n$0 ? 0 : 0 < n$0 ? -1 : 1;
            var l$1 = l$0[2];
            if (0 >= n$0) return 1;
            var n$1 = n$0 - 1 | 0;
            l$0 = l$1;
            n$0 = n$1;
        }
    }
    function is_empty(param) {
        return param ? 0 : 1;
    }
    function equal(eq, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _d_ = caml_call2(eq, a1, a2);
                    if (!_d_) return _d_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return 0;
        }
    }
    function compare(cmp, l1, l2) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0 ? -1 : 0;
            var l1$1 = l1$0[2], a1 = l1$0[1];
            if (!l2$0) return 1;
            var l2$1 = l2$0[2], a2 = l2$0[1], c = caml_call2(cmp, a1, a2);
            if (0 !== c) return c;
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function to_seq(l) {
        function aux(l, param) {
            if (!l) return 0;
            var tail = l[2], x = l[1];
            return [
                0,
                x,
                function(_c_) {
                    return aux(tail, _c_);
                }
            ];
        }
        return function(_b_) {
            return aux(l, _b_);
        };
    }
    function of_seq(seq) {
        var match = caml_call1(seq, 0);
        if (!match) return 0;
        var seq$0 = match[2], x1 = match[1], match$0 = caml_call1(seq$0, 0);
        if (!match$0) return [
            0,
            x1,
            0
        ];
        var seq$1 = match$0[2], x2 = match$0[1], block = [
            0,
            x2,
            24029
        ], dst = block, offset = 1, seq$2 = seq$1;
        for(;;){
            var match$1 = caml_call1(seq$2, 0);
            if (match$1) {
                var seq$3 = match$1[2], x1$0 = match$1[1], match$2 = caml_call1(seq$3, 0);
                if (match$2) {
                    var seq$4 = match$2[2], x2$0 = match$2[1], dst$0 = [
                        0,
                        x2$0,
                        24029
                    ];
                    dst[1 + offset] = [
                        0,
                        x1$0,
                        dst$0
                    ];
                    dst = dst$0;
                    offset = 1;
                    seq$2 = seq$4;
                    continue;
                }
                dst[1 + offset] = [
                    0,
                    x1$0,
                    0
                ];
            } else dst[1 + offset] = 0;
            return [
                0,
                x1,
                block
            ];
        }
    }
    var Stdlib_List = [
        0,
        length,
        compare_lengths,
        compare_length_with,
        is_empty,
        cons,
        hd,
        tl,
        nth,
        nth_opt,
        rev,
        init,
        append,
        rev_append,
        flatten,
        flatten,
        equal,
        compare,
        iter,
        iteri,
        map,
        mapi,
        rev_map,
        filter_map,
        concat_map,
        fold_left_map,
        fold_left,
        fold_right,
        iter2,
        map2,
        rev_map2,
        fold_left2,
        fold_right2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        find_all,
        find_all,
        filteri,
        take,
        drop,
        take_while,
        drop_while,
        partition,
        partition_map,
        assoc,
        assoc_opt,
        assq,
        assq_opt,
        mem_assoc,
        mem_assq,
        remove_assoc,
        remove_assq,
        split,
        combine,
        stable_sort,
        stable_sort,
        stable_sort,
        sort_uniq,
        merge,
        to_seq,
        of_seq
    ];
    runtime.caml_register_global(19, Stdlib_List, "Stdlib__List");
    return;
})(globalThis);
//# 3883 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_hash = runtime.caml_hash;
    function abs(x) {
        return 0 <= x ? x : -x | 0;
    }
    function lognot(x) {
        return x ^ -1;
    }
    function equal(_b_, _a_) {
        return _b_ === _a_ ? 1 : 0;
    }
    var compare = runtime.caml_int_compare;
    function min(x, y) {
        return x <= y ? x : y;
    }
    function max(x, y) {
        return y <= x ? x : y;
    }
    function to_string(x) {
        return "" + x;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int = [
        0,
        0,
        1,
        -1,
        abs,
        2147483647,
        -2147483648,
        lognot,
        equal,
        compare,
        min,
        max,
        to_string,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(1, Stdlib_Int, "Stdlib__Int");
    return;
})(globalThis);
//# 3919 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_bytes_ml = "bytes.ml", cst_index_out_of_bounds$3 = "index out of bounds", caml_blit_bytes = runtime.caml_blit_bytes, caml_bswap16 = runtime.caml_bswap16, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_get16 = runtime.caml_bytes_get16, caml_bytes_get32 = runtime.caml_bytes_get32, caml_bytes_get64 = runtime.caml_bytes_get64, caml_bytes_of_string = runtime.caml_bytes_of_string, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_set16 = runtime.caml_bytes_set16, caml_bytes_set32 = runtime.caml_bytes_set32, caml_bytes_set64 = runtime.caml_bytes_set64, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_fill_bytes = runtime.caml_fill_bytes, caml_int32_bswap = runtime.caml_int32_bswap, caml_int64_bswap = runtime.caml_int64_bswap, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Uchar = global_data.Stdlib__Uchar, Assert_failure = global_data.Assert_failure, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Char = global_data.Stdlib__Char;
    function make(n, c) {
        var s = caml_create_bytes(n);
        caml_fill_bytes(s, 0, n, c);
        return s;
    }
    function init(n, f) {
        var s = caml_create_bytes(n), _ap_ = n - 1 | 0, _ao_ = 0;
        if (_ap_ >= 0) {
            var i = _ao_;
            for(;;){
                caml_bytes_unsafe_set(s, i, caml_call1(f, i));
                var _aq_ = i + 1 | 0;
                if (_ap_ === i) break;
                i = _aq_;
            }
        }
        return s;
    }
    var empty = caml_create_bytes(0), cst_String_sub_Bytes_sub = "String.sub / Bytes.sub", cst_Bytes_extend = "Bytes.extend", cst_String_fill_Bytes_fill = "String.fill / Bytes.fill", cst_Bytes_blit = "Bytes.blit", cst_String_blit_Bytes_blit_str = "String.blit / Bytes.blit_string", cst_Bytes_concat = "Bytes.concat", cst_String_index_from_Bytes_in = "String.index_from / Bytes.index_from", cst_String_index_from_opt_Byte = "String.index_from_opt / Bytes.index_from_opt", cst_String_rindex_from_Bytes_r = "String.rindex_from / Bytes.rindex_from", cst_String_rindex_from_opt_Byt = "String.rindex_from_opt / Bytes.rindex_from_opt", cst_String_contains_from_Bytes = "String.contains_from / Bytes.contains_from", cst_String_rcontains_from_Byte = "String.rcontains_from / Bytes.rcontains_from";
    function copy(s) {
        var len = caml_ml_bytes_length(s), r = caml_create_bytes(len);
        caml_blit_bytes(s, 0, r, 0, len);
        return r;
    }
    function to_string(b) {
        return caml_string_of_bytes(copy(b));
    }
    function of_string(s) {
        return copy(caml_bytes_of_string(s));
    }
    function sub(s, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) {
            var r = caml_create_bytes(len);
            caml_blit_bytes(s, ofs, r, 0, len);
            return r;
        }
        return caml_call1(Stdlib[1], cst_String_sub_Bytes_sub);
    }
    function sub_string(b, ofs, len) {
        return caml_string_of_bytes(sub(b, ofs, len));
    }
    function symbol(a, b) {
        var c = a + b | 0, _an_ = b < 0 ? 1 : 0, match = c < 0 ? 1 : 0;
        a: {
            if (a < 0) {
                if (_an_ && !match) break a;
            } else if (!_an_ && match) break a;
            return c;
        }
        return caml_call1(Stdlib[1], cst_Bytes_extend);
    }
    function extend(s, left, right) {
        var len = symbol(symbol(caml_ml_bytes_length(s), left), right), r = caml_create_bytes(len);
        if (0 <= left) var dstoff = left, srcoff = 0;
        else var dstoff = 0, srcoff = -left | 0;
        var cpylen = caml_call2(Stdlib_Int[10], caml_ml_bytes_length(s) - srcoff | 0, len - dstoff | 0);
        if (0 < cpylen) caml_blit_bytes(s, srcoff, r, dstoff, cpylen);
        return r;
    }
    function fill(s, ofs, len, c) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(s) - len | 0) >= ofs) return caml_fill_bytes(s, ofs, len, c);
        return caml_call1(Stdlib[1], cst_String_fill_Bytes_fill);
    }
    function blit(s1, ofs1, s2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (caml_ml_bytes_length(s1) - len | 0) >= ofs1 && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2) return caml_blit_bytes(s1, ofs1, s2, ofs2, len);
        return caml_call1(Stdlib[1], cst_Bytes_blit);
    }
    function blit_string(s1, ofs1, s2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (runtime.caml_ml_string_length(s1) - len | 0) >= ofs1 && 0 <= ofs2 && (caml_ml_bytes_length(s2) - len | 0) >= ofs2) return runtime.caml_blit_string(s1, ofs1, s2, ofs2, len);
        return caml_call1(Stdlib[1], cst_String_blit_Bytes_blit_str);
    }
    function iter(f, a) {
        var _al_ = caml_ml_bytes_length(a) - 1 | 0, _ak_ = 0;
        if (_al_ >= 0) {
            var i = _ak_;
            for(;;){
                caml_call1(f, caml_bytes_unsafe_get(a, i));
                var _am_ = i + 1 | 0;
                if (_al_ === i) break;
                i = _am_;
            }
        }
        return 0;
    }
    function iteri(f, a) {
        var _ai_ = caml_ml_bytes_length(a) - 1 | 0, _ah_ = 0;
        if (_ai_ >= 0) {
            var i = _ah_;
            for(;;){
                caml_call2(f, i, caml_bytes_unsafe_get(a, i));
                var _aj_ = i + 1 | 0;
                if (_ai_ === i) break;
                i = _aj_;
            }
        }
        return 0;
    }
    function concat(sep, l) {
        if (!l) return empty;
        var seplen = caml_ml_bytes_length(sep);
        a: {
            b: {
                var acc = 0, param = l, pos$1 = 0;
                for(;;){
                    if (!param) break;
                    var hd = param[1];
                    if (!param[2]) break b;
                    var tl = param[2], x = (caml_ml_bytes_length(hd) + seplen | 0) + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_Bytes_concat);
                    acc = acc$0;
                    param = tl;
                }
                var _ag_ = acc;
                break a;
            }
            var _ag_ = caml_ml_bytes_length(hd) + acc | 0;
        }
        var dst = caml_create_bytes(_ag_), pos = pos$1, param$0 = l;
        for(;;){
            if (!param$0) return dst;
            var hd$0 = param$0[1];
            if (!param$0[2]) {
                caml_blit_bytes(hd$0, 0, dst, pos, caml_ml_bytes_length(hd$0));
                return dst;
            }
            var tl$0 = param$0[2];
            caml_blit_bytes(hd$0, 0, dst, pos, caml_ml_bytes_length(hd$0));
            caml_blit_bytes(sep, 0, dst, pos + caml_ml_bytes_length(hd$0) | 0, seplen);
            var pos$0 = (pos + caml_ml_bytes_length(hd$0) | 0) + seplen | 0;
            pos = pos$0;
            param$0 = tl$0;
        }
    }
    function cat(s1, s2) {
        var l1 = caml_ml_bytes_length(s1), l2 = caml_ml_bytes_length(s2), r = caml_create_bytes(l1 + l2 | 0);
        caml_blit_bytes(s1, 0, r, 0, l1);
        caml_blit_bytes(s2, 0, r, l1, l2);
        return r;
    }
    function is_space(param) {
        var _af_ = param - 9 | 0;
        a: {
            if (4 < _af_ >>> 0) {
                if (23 !== _af_) break a;
            } else if (2 === _af_) break a;
            return 1;
        }
        return 0;
    }
    function trim(s) {
        var len = caml_ml_bytes_length(s), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= len) break;
            if (!is_space(caml_bytes_unsafe_get(s, i[1]))) break;
            i[1]++;
        }
        var j = [
            0,
            len - 1 | 0
        ];
        for(;;){
            if (i[1] <= j[1] && is_space(caml_bytes_unsafe_get(s, j[1]))) {
                j[1]--;
                continue;
            }
            return i[1] <= j[1] ? sub(s, i[1], (j[1] - i[1] | 0) + 1 | 0) : empty;
        }
    }
    function unsafe_escape(s) {
        var n = [
            0,
            0
        ], ___ = caml_ml_bytes_length(s) - 1 | 0, _Z_ = 0;
        if (___ >= 0) {
            var i$0 = _Z_;
            for(;;){
                var match = caml_bytes_unsafe_get(s, i$0);
                a: {
                    b: {
                        c: {
                            if (32 <= match) {
                                var _ac_ = match - 34 | 0;
                                if (58 < _ac_ >>> 0) {
                                    if (93 <= _ac_) break c;
                                } else if (56 < _ac_ - 1 >>> 0) break b;
                                var _ad_ = 1;
                                break a;
                            }
                            if (11 <= match) {
                                if (13 === match) break b;
                            } else if (8 <= match) break b;
                        }
                        var _ad_ = 4;
                        break a;
                    }
                    var _ad_ = 2;
                }
                n[1] = n[1] + _ad_ | 0;
                var _ae_ = i$0 + 1 | 0;
                if (___ === i$0) break;
                i$0 = _ae_;
            }
        }
        if (n[1] === caml_ml_bytes_length(s)) return s;
        var s$0 = caml_create_bytes(n[1]);
        n[1] = 0;
        var _aa_ = caml_ml_bytes_length(s) - 1 | 0, _$_ = 0;
        if (_aa_ >= 0) {
            var i = _$_;
            for(;;){
                var c = caml_bytes_unsafe_get(s, i);
                a: {
                    b: {
                        c: {
                            if (35 <= c) {
                                if (92 !== c) {
                                    if (127 <= c) break c;
                                    break b;
                                }
                            } else {
                                if (32 > c) {
                                    if (14 <= c) break c;
                                    switch(c){
                                        case 8:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 98);
                                            break a;
                                        case 9:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 116);
                                            break a;
                                        case 10:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 110);
                                            break a;
                                        case 13:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 114);
                                            break a;
                                        default:
                                            break c;
                                    }
                                }
                                if (34 > c) break b;
                            }
                            caml_bytes_unsafe_set(s$0, n[1], 92);
                            n[1]++;
                            caml_bytes_unsafe_set(s$0, n[1], c);
                            break a;
                        }
                        caml_bytes_unsafe_set(s$0, n[1], 92);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + (c / 100 | 0) | 0);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + ((c / 10 | 0) % 10 | 0) | 0);
                        n[1]++;
                        caml_bytes_unsafe_set(s$0, n[1], 48 + (c % 10 | 0) | 0);
                        break a;
                    }
                    caml_bytes_unsafe_set(s$0, n[1], c);
                }
                n[1]++;
                var _ab_ = i + 1 | 0;
                if (_aa_ === i) break;
                i = _ab_;
            }
        }
        return s$0;
    }
    function escaped(b) {
        var b$0 = copy(b);
        return unsafe_escape(b$0);
    }
    function map(f, s) {
        var l = caml_ml_bytes_length(s);
        if (0 === l) return s;
        var r = caml_create_bytes(l), _X_ = l - 1 | 0, _W_ = 0;
        if (_X_ >= 0) {
            var i = _W_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call1(f, caml_bytes_unsafe_get(s, i)));
                var _Y_ = i + 1 | 0;
                if (_X_ === i) break;
                i = _Y_;
            }
        }
        return r;
    }
    function mapi(f, s) {
        var l = caml_ml_bytes_length(s);
        if (0 === l) return s;
        var r = caml_create_bytes(l), _U_ = l - 1 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call2(f, i, caml_bytes_unsafe_get(s, i)));
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return r;
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _R_ = caml_ml_bytes_length(a) - 1 | 0, _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                r[1] = caml_call2(f, r[1], caml_bytes_unsafe_get(a, i));
                var _S_ = i + 1 | 0;
                if (_R_ === i) break;
                i = _S_;
            }
        }
        return r[1];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _O_ = caml_ml_bytes_length(a) - 1 | 0;
        if (_O_ >= 0) {
            var i = _O_;
            for(;;){
                r[1] = caml_call2(f, caml_bytes_unsafe_get(a, i), r[1]);
                var _P_ = i - 1 | 0;
                if (0 === i) break;
                i = _P_;
            }
        }
        return r[1];
    }
    function exists(p, s) {
        var n = caml_ml_bytes_length(s), i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, caml_bytes_unsafe_get(s, i))) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, s) {
        var n = caml_ml_bytes_length(s), i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, caml_bytes_unsafe_get(s, i))) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function uppercase_ascii(s) {
        return map(Stdlib_Char[4], s);
    }
    function lowercase_ascii(s) {
        return map(Stdlib_Char[3], s);
    }
    function apply1(f, s) {
        if (0 === caml_ml_bytes_length(s)) return s;
        var r = copy(s);
        caml_bytes_unsafe_set(r, 0, caml_call1(f, caml_bytes_unsafe_get(s, 0)));
        return r;
    }
    function capitalize_ascii(s) {
        return apply1(Stdlib_Char[4], s);
    }
    function uncapitalize_ascii(s) {
        return apply1(Stdlib_Char[3], s);
    }
    function starts_with(prefix, s) {
        var len_s = caml_ml_bytes_length(s), len_pre = caml_ml_bytes_length(prefix), _N_ = len_pre <= len_s ? 1 : 0;
        if (!_N_) return _N_;
        var i = 0;
        for(;;){
            if (i === len_pre) return 1;
            if (caml_bytes_unsafe_get(s, i) !== caml_bytes_unsafe_get(prefix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function ends_with(suffix, s) {
        var len_s = caml_ml_bytes_length(s), len_suf = caml_ml_bytes_length(suffix), diff = len_s - len_suf | 0, _M_ = 0 <= diff ? 1 : 0;
        if (!_M_) return _M_;
        var i = 0;
        for(;;){
            if (i === len_suf) return 1;
            if (caml_bytes_unsafe_get(s, diff + i | 0) !== caml_bytes_unsafe_get(suffix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function index_rec(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_bytes_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index(s, c) {
        return index_rec(s, caml_ml_bytes_length(s), 0, c);
    }
    function index_rec_opt(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) return 0;
            if (caml_bytes_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index_opt(s, c) {
        return index_rec_opt(s, caml_ml_bytes_length(s), 0, c);
    }
    function index_from(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) return index_rec(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_Bytes_in);
    }
    function index_from_opt(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) return index_rec_opt(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_opt_Byte);
    }
    function rindex_rec(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_bytes_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex(s, c) {
        return rindex_rec(s, caml_ml_bytes_length(s) - 1 | 0, c);
    }
    function rindex_from(s, i, c) {
        if (-1 <= i && caml_ml_bytes_length(s) > i) return rindex_rec(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_Bytes_r);
    }
    function rindex_rec_opt(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) return 0;
            if (caml_bytes_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex_opt(s, c) {
        return rindex_rec_opt(s, caml_ml_bytes_length(s) - 1 | 0, c);
    }
    function rindex_from_opt(s, i, c) {
        if (-1 <= i && caml_ml_bytes_length(s) > i) return rindex_rec_opt(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_opt_Byt);
    }
    function contains_from(s, i, c) {
        var l = caml_ml_bytes_length(s);
        if (0 <= i && l >= i) try {
            index_rec(s, l, i, c);
            var _K_ = 1;
            return _K_;
        } catch (_L_) {
            var _J_ = caml_wrap_exception(_L_);
            if (_J_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_J_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_contains_from_Bytes);
    }
    function contains(s, c) {
        return contains_from(s, 0, c);
    }
    function rcontains_from(s, i, c) {
        if (0 <= i && caml_ml_bytes_length(s) > i) try {
            rindex_rec(s, i, c);
            var _H_ = 1;
            return _H_;
        } catch (_I_) {
            var _G_ = caml_wrap_exception(_I_);
            if (_G_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_G_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_rcontains_from_Byte);
    }
    var compare = runtime.caml_bytes_compare, cst_Bytes_of_seq_cannot_grow_b = "Bytes.of_seq: cannot grow bytes";
    function split_on_char(sep, s) {
        var r = [
            0,
            0
        ], j = [
            0,
            caml_ml_bytes_length(s)
        ], _C_ = caml_ml_bytes_length(s) - 1 | 0;
        if (_C_ >= 0) {
            var i = _C_;
            for(;;){
                if (caml_bytes_unsafe_get(s, i) === sep) {
                    var _E_ = r[1];
                    r[1] = [
                        0,
                        sub(s, i + 1 | 0, (j[1] - i | 0) - 1 | 0),
                        _E_
                    ];
                    j[1] = i;
                }
                var _F_ = i - 1 | 0;
                if (0 === i) break;
                i = _F_;
            }
        }
        var _D_ = r[1];
        return [
            0,
            sub(s, 0, j[1]),
            _D_
        ];
    }
    function to_seq(s) {
        function aux(i, param) {
            if (i === caml_ml_bytes_length(s)) return 0;
            var x = caml_bytes_get(s, i), _A_ = i + 1 | 0;
            return [
                0,
                x,
                function(_B_) {
                    return aux(_A_, _B_);
                }
            ];
        }
        var _y_ = 0;
        return function(_z_) {
            return aux(_y_, _z_);
        };
    }
    function to_seqi(s) {
        function aux(i, param) {
            if (i === caml_ml_bytes_length(s)) return 0;
            var x = caml_bytes_get(s, i), _w_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_x_) {
                    return aux(_w_, _x_);
                }
            ];
        }
        var _u_ = 0;
        return function(_v_) {
            return aux(_u_, _v_);
        };
    }
    function of_seq(i) {
        var n = [
            0,
            0
        ], buf = [
            0,
            make(256, 0)
        ];
        caml_call2(Stdlib_Seq[4], function(c) {
            if (n[1] === caml_ml_bytes_length(buf[1])) {
                var new_len = caml_call2(Stdlib_Int[10], 2 * caml_ml_bytes_length(buf[1]) | 0, Stdlib_Sys[12]);
                if (caml_ml_bytes_length(buf[1]) === new_len) caml_call1(Stdlib[2], cst_Bytes_of_seq_cannot_grow_b);
                var new_buf = make(new_len, 0);
                blit(buf[1], 0, new_buf, 0, n[1]);
                buf[1] = new_buf;
            }
            caml_bytes_set(buf[1], n[1], c);
            n[1]++;
            return 0;
        }, i);
        return sub(buf[1], 0, n[1]);
    }
    function unsafe_get_uint16_le(b, i) {
        return Stdlib_Sys[11] ? caml_bswap16(caml_bytes_get16(b, i)) : caml_bytes_get16(b, i);
    }
    function unsafe_get_uint16_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get16(b, i) : caml_bswap16(caml_bytes_get16(b, i));
    }
    function get_int8(b, i) {
        var _s_ = Stdlib_Sys[10] - 8 | 0, _t_ = Stdlib_Sys[10] - 8 | 0;
        return caml_bytes_get(b, i) << _t_ >> _s_;
    }
    function get_uint16_le(b, i) {
        return Stdlib_Sys[11] ? caml_bswap16(caml_bytes_get16(b, i)) : caml_bytes_get16(b, i);
    }
    function get_uint16_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get16(b, i) : caml_bswap16(caml_bytes_get16(b, i));
    }
    function get_int16_ne(b, i) {
        var _q_ = Stdlib_Sys[10] - 16 | 0, _r_ = Stdlib_Sys[10] - 16 | 0;
        return caml_bytes_get16(b, i) << _r_ >> _q_;
    }
    function get_int16_le(b, i) {
        var _o_ = Stdlib_Sys[10] - 16 | 0, _p_ = Stdlib_Sys[10] - 16 | 0;
        return get_uint16_le(b, i) << _p_ >> _o_;
    }
    function get_int16_be(b, i) {
        var _m_ = Stdlib_Sys[10] - 16 | 0, _n_ = Stdlib_Sys[10] - 16 | 0;
        return get_uint16_be(b, i) << _n_ >> _m_;
    }
    function get_int32_le(b, i) {
        return Stdlib_Sys[11] ? caml_int32_bswap(caml_bytes_get32(b, i)) : caml_bytes_get32(b, i);
    }
    function get_int32_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get32(b, i) : caml_int32_bswap(caml_bytes_get32(b, i));
    }
    function get_int64_le(b, i) {
        return Stdlib_Sys[11] ? caml_int64_bswap(caml_bytes_get64(b, i)) : caml_bytes_get64(b, i);
    }
    function get_int64_be(b, i) {
        return Stdlib_Sys[11] ? caml_bytes_get64(b, i) : caml_int64_bswap(caml_bytes_get64(b, i));
    }
    function unsafe_set_uint16_le(b, i, x) {
        if (Stdlib_Sys[11]) {
            caml_bytes_set16(b, i, caml_bswap16(x));
            return;
        }
        caml_bytes_set16(b, i, x);
    }
    function unsafe_set_uint16_be(b, i, x) {
        if (Stdlib_Sys[11]) {
            caml_bytes_set16(b, i, x);
            return;
        }
        caml_bytes_set16(b, i, caml_bswap16(x));
    }
    function set_int16_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set16(b, i, caml_bswap16(x)) : caml_bytes_set16(b, i, x);
    }
    function set_int16_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set16(b, i, x) : caml_bytes_set16(b, i, caml_bswap16(x));
    }
    function set_int32_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set32(b, i, caml_int32_bswap(x)) : caml_bytes_set32(b, i, x);
    }
    function set_int32_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set32(b, i, x) : caml_bytes_set32(b, i, caml_int32_bswap(x));
    }
    function set_int64_le(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set64(b, i, caml_int64_bswap(x)) : caml_bytes_set64(b, i, x);
    }
    function set_int64_be(b, i, x) {
        return Stdlib_Sys[11] ? caml_bytes_set64(b, i, x) : caml_bytes_set64(b, i, caml_int64_bswap(x));
    }
    var set_uint8 = caml_bytes_set, set_uint16_ne = caml_bytes_set16, dec_invalid = Stdlib_Uchar[23], _a_ = [
        0,
        cst_bytes_ml,
        679,
        9
    ], _b_ = [
        0,
        cst_bytes_ml,
        654,
        20
    ], cst_index_out_of_bounds = cst_index_out_of_bounds$3, cst_index_out_of_bounds$0 = cst_index_out_of_bounds$3, _c_ = [
        0,
        cst_bytes_ml,
        777,
        9
    ], _d_ = [
        0,
        cst_bytes_ml,
        766,
        20
    ], cst_index_out_of_bounds$1 = cst_index_out_of_bounds$3, cst_index_out_of_bounds$2 = cst_index_out_of_bounds$3, _e_ = [
        0,
        cst_bytes_ml,
        831,
        9
    ], _f_ = [
        0,
        cst_bytes_ml,
        820,
        20
    ];
    function dec_ret(n, u) {
        var _l_ = caml_call1(Stdlib_Uchar[9], u);
        return caml_call2(Stdlib_Uchar[22], n, _l_);
    }
    function not_in_x80_to_xBF(b) {
        return 2 !== (b >>> 6 | 0) ? 1 : 0;
    }
    function not_in_xA0_to_xBF(b) {
        return 5 !== (b >>> 5 | 0) ? 1 : 0;
    }
    function not_in_x80_to_x9F(b) {
        return 4 !== (b >>> 5 | 0) ? 1 : 0;
    }
    function not_in_x90_to_xBF(b) {
        var _j_ = b < 144 ? 1 : 0, _k_ = _j_ || (191 < b ? 1 : 0);
        return _k_;
    }
    function not_in_x80_to_x8F(b) {
        return 8 !== (b >>> 4 | 0) ? 1 : 0;
    }
    function utf_8_uchar_3(b0, b1, b2) {
        return (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
    }
    function utf_8_uchar_4(b0, b1, b2, b3) {
        return (b0 & 7) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
    }
    function get_utf_8_uchar(b, i) {
        var b0 = caml_bytes_get(b, i), max = caml_ml_bytes_length(b) - 1 | 0;
        a: {
            if (224 <= b0) {
                if (237 <= b0) {
                    if (245 <= b0) break a;
                    switch(b0 - 237 | 0){
                        case 0:
                            var i$0 = i + 1 | 0;
                            if (max < i$0) return caml_call1(dec_invalid, 1);
                            var b1$4 = caml_bytes_unsafe_get(b, i$0);
                            if (not_in_x80_to_x9F(b1$4)) return caml_call1(dec_invalid, 1);
                            var i$1 = i$0 + 1 | 0;
                            if (max < i$1) return caml_call1(dec_invalid, 2);
                            var b2$3 = caml_bytes_unsafe_get(b, i$1);
                            return not_in_x80_to_xBF(b2$3) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$4, b2$3));
                        case 3:
                            var i$4 = i + 1 | 0;
                            if (max < i$4) return caml_call1(dec_invalid, 1);
                            var b1$2 = caml_bytes_unsafe_get(b, i$4);
                            if (not_in_x90_to_xBF(b1$2)) return caml_call1(dec_invalid, 1);
                            var i$5 = i$4 + 1 | 0;
                            if (max < i$5) return caml_call1(dec_invalid, 2);
                            var b2$1 = caml_bytes_unsafe_get(b, i$5);
                            if (not_in_x80_to_xBF(b2$1)) return caml_call1(dec_invalid, 2);
                            var i$6 = i$5 + 1 | 0;
                            if (max < i$6) return caml_call1(dec_invalid, 3);
                            var b3$1 = caml_bytes_unsafe_get(b, i$6);
                            return not_in_x80_to_xBF(b3$1) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$2, b2$1, b3$1));
                        case 7:
                            var i$10 = i + 1 | 0;
                            if (max < i$10) return caml_call1(dec_invalid, 1);
                            var b1$0 = caml_bytes_unsafe_get(b, i$10);
                            if (not_in_x80_to_x8F(b1$0)) return caml_call1(dec_invalid, 1);
                            var i$11 = i$10 + 1 | 0;
                            if (max < i$11) return caml_call1(dec_invalid, 2);
                            var b2 = caml_bytes_unsafe_get(b, i$11);
                            if (not_in_x80_to_xBF(b2)) return caml_call1(dec_invalid, 2);
                            var i$12 = i$11 + 1 | 0;
                            if (max < i$12) return caml_call1(dec_invalid, 3);
                            var b3 = caml_bytes_unsafe_get(b, i$12);
                            return not_in_x80_to_xBF(b3) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$0, b2, b3));
                        case 1:
                        case 2:
                            break;
                        default:
                            var i$7 = i + 1 | 0;
                            if (max < i$7) return caml_call1(dec_invalid, 1);
                            var b1$1 = caml_bytes_unsafe_get(b, i$7);
                            if (not_in_x80_to_xBF(b1$1)) return caml_call1(dec_invalid, 1);
                            var i$8 = i$7 + 1 | 0;
                            if (max < i$8) return caml_call1(dec_invalid, 2);
                            var b2$0 = caml_bytes_unsafe_get(b, i$8);
                            if (not_in_x80_to_xBF(b2$0)) return caml_call1(dec_invalid, 2);
                            var i$9 = i$8 + 1 | 0;
                            if (max < i$9) return caml_call1(dec_invalid, 3);
                            var b3$0 = caml_bytes_unsafe_get(b, i$9);
                            return not_in_x80_to_xBF(b3$0) ? caml_call1(dec_invalid, 3) : dec_ret(4, utf_8_uchar_4(b0, b1$1, b2$0, b3$0));
                    }
                } else if (225 > b0) {
                    var i$13 = i + 1 | 0;
                    if (max < i$13) return caml_call1(dec_invalid, 1);
                    var b1$5 = caml_bytes_unsafe_get(b, i$13);
                    if (not_in_xA0_to_xBF(b1$5)) return caml_call1(dec_invalid, 1);
                    var i$14 = i$13 + 1 | 0;
                    if (max < i$14) return caml_call1(dec_invalid, 2);
                    var b2$4 = caml_bytes_unsafe_get(b, i$14);
                    return not_in_x80_to_xBF(b2$4) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$5, b2$4));
                }
                var i$2 = i + 1 | 0;
                if (max < i$2) return caml_call1(dec_invalid, 1);
                var b1$3 = caml_bytes_unsafe_get(b, i$2);
                if (not_in_x80_to_xBF(b1$3)) return caml_call1(dec_invalid, 1);
                var i$3 = i$2 + 1 | 0;
                if (max < i$3) return caml_call1(dec_invalid, 2);
                var b2$2 = caml_bytes_unsafe_get(b, i$3);
                return not_in_x80_to_xBF(b2$2) ? caml_call1(dec_invalid, 2) : dec_ret(3, utf_8_uchar_3(b0, b1$3, b2$2));
            }
            if (128 > b0) return dec_ret(1, b0);
            if (194 <= b0) {
                var i$15 = i + 1 | 0;
                if (max < i$15) return caml_call1(dec_invalid, 1);
                var b1 = caml_bytes_unsafe_get(b, i$15);
                return not_in_x80_to_xBF(b1) ? caml_call1(dec_invalid, 1) : dec_ret(2, (b0 & 31) << 6 | b1 & 63);
            }
        }
        return caml_call1(dec_invalid, 1);
    }
    function set_utf_8_uchar(b, i, u) {
        function set(_i_, _h_, _g_) {
            caml_bytes_unsafe_set(_i_, _h_, _g_);
        }
        var max = caml_ml_bytes_length(b) - 1 | 0, u$0 = caml_call1(Stdlib_Uchar[10], u);
        if (0 > u$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        if (127 >= u$0) {
            caml_bytes_set(b, i, u$0);
            return 1;
        }
        if (2047 >= u$0) {
            var last$1 = i + 1 | 0;
            return max < last$1 ? 0 : (caml_bytes_set(b, i, 192 | u$0 >>> 6 | 0), set(b, last$1, 128 | u$0 & 63), 2);
        }
        if (65535 >= u$0) {
            var last$0 = i + 2 | 0;
            return max < last$0 ? 0 : (caml_bytes_set(b, i, 224 | u$0 >>> 12 | 0), set(b, i + 1 | 0, 128 | (u$0 >>> 6 | 0) & 63), set(b, last$0, 128 | u$0 & 63), 3);
        }
        if (1114111 < u$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
        var last = i + 3 | 0;
        return max < last ? 0 : (caml_bytes_set(b, i, 240 | u$0 >>> 18 | 0), set(b, i + 1 | 0, 128 | (u$0 >>> 12 | 0) & 63), set(b, i + 2 | 0, 128 | (u$0 >>> 6 | 0) & 63), set(b, last, 128 | u$0 & 63), 4);
    }
    function is_valid_utf_8(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            var match = caml_bytes_unsafe_get(b, i);
            a: {
                if (224 <= match) {
                    if (237 <= match) {
                        if (245 <= match) break a;
                        switch(match - 237 | 0){
                            case 0:
                                var last = i + 2 | 0;
                                if (max >= last && !not_in_x80_to_x9F(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last))) {
                                    var i$0 = last + 1 | 0;
                                    i = i$0;
                                    continue;
                                }
                                return 0;
                            case 3:
                                var last$1 = i + 3 | 0;
                                if (max >= last$1 && !not_in_x90_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$1))) {
                                    var i$2 = last$1 + 1 | 0;
                                    i = i$2;
                                    continue;
                                }
                                return 0;
                            case 7:
                                var last$3 = i + 3 | 0;
                                if (max >= last$3 && !not_in_x80_to_x8F(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$3))) {
                                    var i$4 = last$3 + 1 | 0;
                                    i = i$4;
                                    continue;
                                }
                                return 0;
                            case 1:
                            case 2:
                                break;
                            default:
                                var last$2 = i + 3 | 0;
                                if (max >= last$2 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 2 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$2))) {
                                    var i$3 = last$2 + 1 | 0;
                                    i = i$3;
                                    continue;
                                }
                                return 0;
                        }
                    } else if (225 > match) {
                        var last$4 = i + 2 | 0;
                        if (max >= last$4 && !not_in_xA0_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$4))) {
                            var i$5 = last$4 + 1 | 0;
                            i = i$5;
                            continue;
                        }
                        return 0;
                    }
                    var last$0 = i + 2 | 0;
                    if (max >= last$0 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, i + 1 | 0)) && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$0))) {
                        var i$1 = last$0 + 1 | 0;
                        i = i$1;
                        continue;
                    }
                    return 0;
                }
                if (128 > match) {
                    var i$7 = i + 1 | 0;
                    i = i$7;
                    continue;
                }
                if (194 <= match) {
                    var last$5 = i + 1 | 0;
                    if (max >= last$5 && !not_in_x80_to_xBF(caml_bytes_unsafe_get(b, last$5))) {
                        var i$6 = last$5 + 1 | 0;
                        i = i$6;
                        continue;
                    }
                    return 0;
                }
            }
            return 0;
        }
    }
    function get_utf_16be_uchar(b, i) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            if (i === max) return caml_call1(dec_invalid, 1);
            var hi = unsafe_get_uint16_be(b, i);
            if (55296 <= hi && 57343 >= hi) {
                if (56319 < hi) return caml_call1(dec_invalid, 2);
                var last = i + 3 | 0;
                if (max < last) return caml_call1(dec_invalid, (max - i | 0) + 1 | 0);
                var lo = unsafe_get_uint16_be(b, i + 2 | 0);
                if (56320 <= lo && 57343 >= lo) {
                    var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
                    return dec_ret(4, u);
                }
                return caml_call1(dec_invalid, 2);
            }
            return dec_ret(2, hi);
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds);
    }
    function set_utf_16be_uchar(b, i, u) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            var u$0 = caml_call1(Stdlib_Uchar[10], u);
            if (0 > u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _d_
            ], 1);
            if (65535 >= u$0) {
                var last$0 = i + 1 | 0;
                return max < last$0 ? 0 : (unsafe_set_uint16_be(b, i, u$0), 2);
            }
            if (1114111 < u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _c_
            ], 1);
            var last = i + 3 | 0;
            if (max < last) return 0;
            var u$1 = u$0 - 65536 | 0, hi = 55296 | u$1 >>> 10 | 0, lo = 56320 | u$1 & 1023;
            unsafe_set_uint16_be(b, i, hi);
            unsafe_set_uint16_be(b, i + 2 | 0, lo);
            return 4;
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$0);
    }
    function is_valid_utf_16be(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            if (i === max) return 0;
            var u = unsafe_get_uint16_be(b, i);
            if (55296 <= u && 57343 >= u) {
                if (56319 < u) return 0;
                var last = i + 3 | 0;
                if (max < last) return 0;
                var u$0 = unsafe_get_uint16_be(b, i + 2 | 0);
                if (56320 <= u$0 && 57343 >= u$0) {
                    var i$1 = i + 4 | 0;
                    i = i$1;
                    continue;
                }
                return 0;
            }
            var i$0 = i + 2 | 0;
            i = i$0;
        }
    }
    function get_utf_16le_uchar(b, i) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            if (i === max) return caml_call1(dec_invalid, 1);
            var hi = unsafe_get_uint16_le(b, i);
            if (55296 <= hi && 57343 >= hi) {
                if (56319 < hi) return caml_call1(dec_invalid, 2);
                var last = i + 3 | 0;
                if (max < last) return caml_call1(dec_invalid, (max - i | 0) + 1 | 0);
                var lo = unsafe_get_uint16_le(b, i + 2 | 0);
                if (56320 <= lo && 57343 >= lo) {
                    var u = ((hi & 1023) << 10 | lo & 1023) + 65536 | 0;
                    return dec_ret(4, u);
                }
                return caml_call1(dec_invalid, 2);
            }
            return dec_ret(2, hi);
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$1);
    }
    function set_utf_16le_uchar(b, i, u) {
        var max = caml_ml_bytes_length(b) - 1 | 0;
        if (0 <= i && max >= i) {
            var u$0 = caml_call1(Stdlib_Uchar[10], u);
            if (0 > u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
            if (65535 >= u$0) {
                var last$0 = i + 1 | 0;
                return max < last$0 ? 0 : (unsafe_set_uint16_le(b, i, u$0), 2);
            }
            if (1114111 < u$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _e_
            ], 1);
            var last = i + 3 | 0;
            if (max < last) return 0;
            var u$1 = u$0 - 65536 | 0, hi = 55296 | u$1 >>> 10 | 0, lo = 56320 | u$1 & 1023;
            unsafe_set_uint16_le(b, i, hi);
            unsafe_set_uint16_le(b, i + 2 | 0, lo);
            return 4;
        }
        return caml_call1(Stdlib[1], cst_index_out_of_bounds$2);
    }
    function is_valid_utf_16le(b) {
        var max = caml_ml_bytes_length(b) - 1 | 0, i = 0;
        for(;;){
            if (max < i) return 1;
            if (i === max) return 0;
            var u = unsafe_get_uint16_le(b, i);
            if (55296 <= u && 57343 >= u) {
                if (56319 < u) return 0;
                var last = i + 3 | 0;
                if (max < last) return 0;
                var u$0 = unsafe_get_uint16_le(b, i + 2 | 0);
                if (56320 <= u$0 && 57343 >= u$0) {
                    var i$1 = i + 4 | 0;
                    i = i$1;
                    continue;
                }
                return 0;
            }
            var i$0 = i + 2 | 0;
            i = i$0;
        }
    }
    var Stdlib_Bytes = [
        0,
        make,
        init,
        empty,
        copy,
        of_string,
        to_string,
        sub,
        sub_string,
        extend,
        fill,
        blit,
        blit_string,
        concat,
        cat,
        iter,
        iteri,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        index,
        index_opt,
        rindex,
        rindex_opt,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        contains,
        contains_from,
        rcontains_from,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        compare,
        runtime.caml_bytes_equal,
        starts_with,
        ends_with,
        caml_string_of_bytes,
        caml_bytes_of_string,
        split_on_char,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        set_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        set_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        set_utf_16le_uchar,
        is_valid_utf_16le,
        caml_bytes_get,
        get_int8,
        caml_bytes_get16,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        caml_bytes_get32,
        get_int32_be,
        get_int32_le,
        caml_bytes_get64,
        get_int64_be,
        get_int64_le,
        set_uint8,
        caml_bytes_set,
        set_uint16_ne,
        set_int16_be,
        set_int16_le,
        caml_bytes_set16,
        set_int16_be,
        set_int16_le,
        caml_bytes_set32,
        set_int32_be,
        set_int32_le,
        caml_bytes_set64,
        set_int64_be,
        set_int64_le,
        unsafe_escape
    ];
    runtime.caml_register_global(30, Stdlib_Bytes, "Stdlib__Bytes");
    return;
})(globalThis);
//# 5139 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$0 = "", caml_blit_string = runtime.caml_blit_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_equal = runtime.caml_string_equal, caml_string_hash = runtime.caml_string_hash, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$0, empty = cst$0, Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, bts = Stdlib_Bytes[44], bos = Stdlib_Bytes[45];
    function make(n, c) {
        return caml_call1(bts, caml_call2(Stdlib_Bytes[1], n, c));
    }
    function init(n, f) {
        return caml_call1(bts, caml_call2(Stdlib_Bytes[2], n, f));
    }
    var of_bytes = Stdlib_Bytes[6], to_bytes = Stdlib_Bytes[5];
    function sub(s, ofs, len) {
        var _X_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call3(Stdlib_Bytes[7], _X_, ofs, len));
    }
    var blit = Stdlib_Bytes[12], cst_String_concat = "String.concat";
    function concat(sep, l) {
        if (!l) return cst;
        var seplen = caml_ml_string_length(sep);
        a: {
            b: {
                var acc = 0, param = l, pos$1 = 0;
                for(;;){
                    if (!param) break;
                    var hd = param[1];
                    if (!param[2]) break b;
                    var tl = param[2], x = (caml_ml_string_length(hd) + seplen | 0) + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_String_concat);
                    acc = acc$0;
                    param = tl;
                }
                var _W_ = acc;
                break a;
            }
            var _W_ = caml_ml_string_length(hd) + acc | 0;
        }
        var dst = runtime.caml_create_bytes(_W_), pos = pos$1, param$0 = l;
        for(;;){
            if (param$0) {
                var hd$0 = param$0[1];
                if (param$0[2]) {
                    var tl$0 = param$0[2];
                    caml_blit_string(hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
                    caml_blit_string(sep, 0, dst, pos + caml_ml_string_length(hd$0) | 0, seplen);
                    var pos$0 = (pos + caml_ml_string_length(hd$0) | 0) + seplen | 0;
                    pos = pos$0;
                    param$0 = tl$0;
                    continue;
                }
                caml_blit_string(hd$0, 0, dst, pos, caml_ml_string_length(hd$0));
            }
            return caml_call1(bts, dst);
        }
    }
    var cat = Stdlib[28], cst_String_index_from_Bytes_in = "String.index_from / Bytes.index_from", cst_String_index_from_opt_Byte = "String.index_from_opt / Bytes.index_from_opt", cst_String_rindex_from_Bytes_r = "String.rindex_from / Bytes.rindex_from", cst_String_rindex_from_opt_Byt = "String.rindex_from_opt / Bytes.rindex_from_opt", cst_String_contains_from_Bytes = "String.contains_from / Bytes.contains_from", cst_String_rcontains_from_Byte = "String.rcontains_from / Bytes.rcontains_from";
    function iter(f, s) {
        var _U_ = caml_ml_string_length(s) - 1 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_call1(f, caml_string_unsafe_get(s, i));
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return 0;
    }
    function iteri(f, s) {
        var _R_ = caml_ml_string_length(s) - 1 | 0, _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                caml_call2(f, i, caml_string_unsafe_get(s, i));
                var _S_ = i + 1 | 0;
                if (_R_ === i) break;
                i = _S_;
            }
        }
        return 0;
    }
    function map(f, s) {
        var _P_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call2(Stdlib_Bytes[17], f, _P_));
    }
    function mapi(f, s) {
        var _O_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call2(Stdlib_Bytes[18], f, _O_));
    }
    function fold_right(f, x, a) {
        var _N_ = caml_call1(bos, x);
        return caml_call3(Stdlib_Bytes[20], f, _N_, a);
    }
    function fold_left(f, a, x) {
        var _M_ = caml_call1(bos, x);
        return caml_call3(Stdlib_Bytes[19], f, a, _M_);
    }
    function exists(f, s) {
        var _L_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[22], f, _L_);
    }
    function for_all(f, s) {
        var _K_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[21], f, _K_);
    }
    function is_space(param) {
        var _J_ = param - 9 | 0;
        a: {
            if (4 < _J_ >>> 0) {
                if (23 !== _J_) break a;
            } else if (2 === _J_) break a;
            return 1;
        }
        return 0;
    }
    function trim(s) {
        if (s === cst$0) return s;
        if (!is_space(caml_string_unsafe_get(s, 0)) && !is_space(caml_string_unsafe_get(s, caml_ml_string_length(s) - 1 | 0))) return s;
        var _I_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[23], _I_));
    }
    function escaped(s) {
        var b = caml_call1(bos, s), b$0 = caml_call1(Stdlib_Bytes[87], b);
        return b === b$0 ? s : caml_call1(bts, b$0);
    }
    function index_rec(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_string_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index(s, c) {
        return index_rec(s, caml_ml_string_length(s), 0, c);
    }
    function index_rec_opt(s, lim, i, c) {
        var i$0 = i;
        for(;;){
            if (lim <= i$0) return 0;
            if (caml_string_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 + 1 | 0;
            i$0 = i$1;
        }
    }
    function index_opt(s, c) {
        return index_rec_opt(s, caml_ml_string_length(s), 0, c);
    }
    function index_from(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) return index_rec(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_Bytes_in);
    }
    function index_from_opt(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) return index_rec_opt(s, l, i, c);
        return caml_call1(Stdlib[1], cst_String_index_from_opt_Byte);
    }
    function rindex_rec(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            if (caml_string_unsafe_get(s, i$0) === c) return i$0;
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex(s, c) {
        return rindex_rec(s, caml_ml_string_length(s) - 1 | 0, c);
    }
    function rindex_from(s, i, c) {
        if (-1 <= i && caml_ml_string_length(s) > i) return rindex_rec(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_Bytes_r);
    }
    function rindex_rec_opt(s, i, c) {
        var i$0 = i;
        for(;;){
            if (0 > i$0) return 0;
            if (caml_string_unsafe_get(s, i$0) === c) return [
                0,
                i$0
            ];
            var i$1 = i$0 - 1 | 0;
            i$0 = i$1;
        }
    }
    function rindex_opt(s, c) {
        return rindex_rec_opt(s, caml_ml_string_length(s) - 1 | 0, c);
    }
    function rindex_from_opt(s, i, c) {
        if (-1 <= i && caml_ml_string_length(s) > i) return rindex_rec_opt(s, i, c);
        return caml_call1(Stdlib[1], cst_String_rindex_from_opt_Byt);
    }
    function contains_from(s, i, c) {
        var l = caml_ml_string_length(s);
        if (0 <= i && l >= i) try {
            index_rec(s, l, i, c);
            var _G_ = 1;
            return _G_;
        } catch (_H_) {
            var _F_ = caml_wrap_exception(_H_);
            if (_F_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_F_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_contains_from_Bytes);
    }
    function contains(s, c) {
        return contains_from(s, 0, c);
    }
    function rcontains_from(s, i, c) {
        if (0 <= i && caml_ml_string_length(s) > i) try {
            rindex_rec(s, i, c);
            var _D_ = 1;
            return _D_;
        } catch (_E_) {
            var _C_ = caml_wrap_exception(_E_);
            if (_C_ === Stdlib[8]) return 0;
            throw caml_maybe_attach_backtrace(_C_, 0);
        }
        return caml_call1(Stdlib[1], cst_String_rcontains_from_Byte);
    }
    function uppercase_ascii(s) {
        var _B_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[36], _B_));
    }
    function lowercase_ascii(s) {
        var _A_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[37], _A_));
    }
    function capitalize_ascii(s) {
        var _z_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[38], _z_));
    }
    function uncapitalize_ascii(s) {
        var _y_ = caml_call1(bos, s);
        return caml_call1(bts, caml_call1(Stdlib_Bytes[39], _y_));
    }
    function starts_with(prefix, s) {
        var len_s = caml_ml_string_length(s), len_pre = caml_ml_string_length(prefix), _x_ = len_pre <= len_s ? 1 : 0;
        if (!_x_) return _x_;
        var i = 0;
        for(;;){
            if (i === len_pre) return 1;
            if (caml_string_unsafe_get(s, i) !== caml_string_unsafe_get(prefix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function ends_with(suffix, s) {
        var len_s = caml_ml_string_length(s), len_suf = caml_ml_string_length(suffix), diff = len_s - len_suf | 0, _w_ = 0 <= diff ? 1 : 0;
        if (!_w_) return _w_;
        var i = 0;
        for(;;){
            if (i === len_suf) return 1;
            if (caml_string_unsafe_get(s, diff + i | 0) !== caml_string_unsafe_get(suffix, i)) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function hash(x) {
        return caml_string_hash(0, x);
    }
    function split_on_char(sep, s) {
        var r = [
            0,
            0
        ], j = [
            0,
            caml_ml_string_length(s)
        ], _s_ = caml_ml_string_length(s) - 1 | 0;
        if (_s_ >= 0) {
            var i = _s_;
            for(;;){
                if (caml_string_unsafe_get(s, i) === sep) {
                    var _u_ = r[1];
                    r[1] = [
                        0,
                        sub(s, i + 1 | 0, (j[1] - i | 0) - 1 | 0),
                        _u_
                    ];
                    j[1] = i;
                }
                var _v_ = i - 1 | 0;
                if (0 === i) break;
                i = _v_;
            }
        }
        var _t_ = r[1];
        return [
            0,
            sub(s, 0, j[1]),
            _t_
        ];
    }
    var compare = runtime.caml_string_compare;
    function to_seq(s) {
        var _r_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[47], _r_);
    }
    function to_seqi(s) {
        var _q_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[48], _q_);
    }
    function of_seq(g) {
        return caml_call1(bts, caml_call1(Stdlib_Bytes[49], g));
    }
    function get_utf_8_uchar(s, i) {
        var _p_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[50], _p_, i);
    }
    function is_valid_utf_8(s) {
        var _o_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[52], _o_);
    }
    function get_utf_16be_uchar(s, i) {
        var _n_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[53], _n_, i);
    }
    function is_valid_utf_16be(s) {
        var _m_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[55], _m_);
    }
    function get_utf_16le_uchar(s, i) {
        var _l_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[56], _l_, i);
    }
    function is_valid_utf_16le(s) {
        var _k_ = caml_call1(bos, s);
        return caml_call1(Stdlib_Bytes[58], _k_);
    }
    function get_int8(s, i) {
        var _j_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[60], _j_, i);
    }
    function get_uint16_le(s, i) {
        var _i_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[63], _i_, i);
    }
    function get_uint16_be(s, i) {
        var _h_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[62], _h_, i);
    }
    function get_int16_ne(s, i) {
        var _g_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[64], _g_, i);
    }
    function get_int16_le(s, i) {
        var _f_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[66], _f_, i);
    }
    function get_int16_be(s, i) {
        var _e_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[65], _e_, i);
    }
    function get_int32_le(s, i) {
        var _d_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[69], _d_, i);
    }
    function get_int32_be(s, i) {
        var _c_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[68], _c_, i);
    }
    function get_int64_le(s, i) {
        var _b_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[72], _b_, i);
    }
    function get_int64_be(s, i) {
        var _a_ = caml_call1(bos, s);
        return caml_call2(Stdlib_Bytes[71], _a_, i);
    }
    var Stdlib_String = [
        0,
        make,
        init,
        empty,
        of_bytes,
        to_bytes,
        blit,
        concat,
        cat,
        caml_string_equal,
        compare,
        starts_with,
        ends_with,
        contains_from,
        rcontains_from,
        contains,
        sub,
        split_on_char,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        iter,
        iteri,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        index,
        index_opt,
        rindex,
        rindex_opt,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        is_valid_utf_16le,
        runtime.caml_string_get,
        get_int8,
        runtime.caml_string_get16,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        runtime.caml_string_get32,
        hash,
        caml_string_hash,
        get_int32_be,
        get_int32_le,
        runtime.caml_string_get64,
        get_int64_be,
        get_int64_le
    ];
    runtime.caml_register_global(12, Stdlib_String, "Stdlib__String");
    return;
})(globalThis);
//# 5702 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_make = runtime.caml_array_make, caml_array_sub = runtime.caml_array_sub, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "", Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, Stdlib_String = global_data.Stdlib__String, Assert_failure = global_data.Assert_failure, Floatarray = [
        0
    ], cst_Array_init = "Array.init", cst_Array_make_matrix = "Array.make_matrix", cst_Array_init_matrix = "Array.init_matrix", cst_Array_sub = "Array.sub", cst_Array_fill = "Array.fill", cst_Array_blit = "Array.blit", cst_Array_iter2_arrays_must_ha = "Array.iter2: arrays must have the same length", cst_Array_map2_arrays_must_hav = "Array.map2: arrays must have the same length", cst_Array_for_all2 = "Array.for_all2", cst_Array_exists2 = "Array.exists2", cst_Array_combine = "Array.combine";
    function init(l, f) {
        if (0 === l) return [
            0
        ];
        if (0 > l) return caml_call1(Stdlib[1], cst_Array_init);
        var res = caml_array_make(l, caml_call1(f, 0)), _aL_ = l - 1 | 0, _aK_ = 1;
        if (_aL_ >= 1) {
            var i = _aK_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _aM_ = i + 1 | 0;
                if (_aL_ === i) break;
                i = _aM_;
            }
        }
        return res;
    }
    function make_matrix(sx, sy, init) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Array_make_matrix);
        var res = caml_array_make(sx, [
            0
        ]);
        if (0 < sy) {
            var _aI_ = sx - 1 | 0, _aH_ = 0;
            if (_aI_ >= 0) {
                var x = _aH_;
                for(;;){
                    res[1 + x] = caml_array_make(sy, init);
                    var _aJ_ = x + 1 | 0;
                    if (_aI_ === x) break;
                    x = _aJ_;
                }
            }
        }
        return res;
    }
    function init_matrix(sx, sy, f) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Array_init_matrix);
        var res = caml_array_make(sx, [
            0
        ]);
        if (0 < sy) {
            var _aC_ = sx - 1 | 0, _aB_ = 0;
            if (_aC_ >= 0) {
                var x = _aB_;
                for(;;){
                    var row = caml_array_make(sy, caml_call2(f, x, 0)), _aE_ = sy - 1 | 0, _aD_ = 1;
                    if (_aE_ >= 1) {
                        var y = _aD_;
                        for(;;){
                            row[1 + y] = caml_call2(f, x, y);
                            var _aG_ = y + 1 | 0;
                            if (_aE_ === y) break;
                            y = _aG_;
                        }
                    }
                    res[1 + x] = row;
                    var _aF_ = x + 1 | 0;
                    if (_aC_ === x) break;
                    x = _aF_;
                }
            }
        }
        return res;
    }
    function copy(a) {
        var l = a.length - 1;
        return 0 === l ? [
            0
        ] : caml_array_sub(a, 0, l);
    }
    function append(a1, a2) {
        var l1 = a1.length - 1;
        return 0 === l1 ? copy(a2) : 0 === a2.length - 1 ? caml_array_sub(a1, 0, l1) : runtime.caml_array_append(a1, a2);
    }
    function sub(a, ofs, len) {
        if (0 <= ofs && 0 <= len && (a.length - 1 - len | 0) >= ofs) return caml_array_sub(a, ofs, len);
        return caml_call1(Stdlib[1], cst_Array_sub);
    }
    function fill(a, ofs, len, v) {
        if (0 <= ofs && 0 <= len && (a.length - 1 - len | 0) >= ofs) return runtime.caml_array_fill(a, ofs, len, v);
        return caml_call1(Stdlib[1], cst_Array_fill);
    }
    function blit(a1, ofs1, a2, ofs2, len) {
        if (0 <= len && 0 <= ofs1 && (a1.length - 1 - len | 0) >= ofs1 && 0 <= ofs2 && (a2.length - 1 - len | 0) >= ofs2) return runtime.caml_array_blit(a1, ofs1, a2, ofs2, len);
        return caml_call1(Stdlib[1], cst_Array_blit);
    }
    function iter(f, a) {
        var _az_ = a.length - 2 | 0, _ay_ = 0;
        if (_az_ >= 0) {
            var i = _ay_;
            for(;;){
                caml_call1(f, a[1 + i]);
                var _aA_ = i + 1 | 0;
                if (_az_ === i) break;
                i = _aA_;
            }
        }
        return 0;
    }
    function iter2(f, a, b) {
        if (a.length - 1 !== b.length - 1) return caml_call1(Stdlib[1], cst_Array_iter2_arrays_must_ha);
        var _aw_ = a.length - 2 | 0, _av_ = 0;
        if (_aw_ >= 0) {
            var i = _av_;
            for(;;){
                caml_call2(f, a[1 + i], b[1 + i]);
                var _ax_ = i + 1 | 0;
                if (_aw_ === i) break;
                i = _ax_;
            }
        }
        return 0;
    }
    function map(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_array_make(l, caml_call1(f, a[1])), _at_ = l - 1 | 0, _as_ = 1;
        if (_at_ >= 1) {
            var i = _as_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _au_ = i + 1 | 0;
                if (_at_ === i) break;
                i = _au_;
            }
        }
        return r;
    }
    function map_inplace(f, a) {
        var _aq_ = a.length - 2 | 0, _ap_ = 0;
        if (_aq_ >= 0) {
            var i = _ap_;
            for(;;){
                a[1 + i] = caml_call1(f, a[1 + i]);
                var _ar_ = i + 1 | 0;
                if (_aq_ === i) break;
                i = _ar_;
            }
        }
        return 0;
    }
    function mapi_inplace(f, a) {
        var _an_ = a.length - 2 | 0, _am_ = 0;
        if (_an_ >= 0) {
            var i = _am_;
            for(;;){
                a[1 + i] = caml_call2(f, i, a[1 + i]);
                var _ao_ = i + 1 | 0;
                if (_an_ === i) break;
                i = _ao_;
            }
        }
        return 0;
    }
    function map2(f, a, b) {
        var la = a.length - 1, lb = b.length - 1;
        if (la !== lb) return caml_call1(Stdlib[1], cst_Array_map2_arrays_must_hav);
        if (0 === la) return [
            0
        ];
        var r = caml_array_make(la, caml_call2(f, a[1], b[1])), _ak_ = la - 1 | 0, _aj_ = 1;
        if (_ak_ >= 1) {
            var i = _aj_;
            for(;;){
                r[1 + i] = caml_call2(f, a[1 + i], b[1 + i]);
                var _al_ = i + 1 | 0;
                if (_ak_ === i) break;
                i = _al_;
            }
        }
        return r;
    }
    function iteri(f, a) {
        var _ah_ = a.length - 2 | 0, _ag_ = 0;
        if (_ah_ >= 0) {
            var i = _ag_;
            for(;;){
                caml_call2(f, i, a[1 + i]);
                var _ai_ = i + 1 | 0;
                if (_ah_ === i) break;
                i = _ai_;
            }
        }
        return 0;
    }
    function mapi(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_array_make(l, caml_call2(f, 0, a[1])), _ae_ = l - 1 | 0, _ad_ = 1;
        if (_ae_ >= 1) {
            var i = _ad_;
            for(;;){
                r[1 + i] = caml_call2(f, i, a[1 + i]);
                var _af_ = i + 1 | 0;
                if (_ae_ === i) break;
                i = _af_;
            }
        }
        return r;
    }
    function to_list(a) {
        var i$1 = a.length - 2 | 0, i = i$1, res = 0;
        for(;;){
            if (0 > i) return res;
            var res$0 = [
                0,
                a[1 + i],
                res
            ], i$0 = i - 1 | 0;
            i = i$0;
            res = res$0;
        }
    }
    function list_length(accu, param) {
        var accu$0 = accu, param$0 = param;
        for(;;){
            if (!param$0) return accu$0;
            var t = param$0[2], accu$1 = accu$0 + 1 | 0;
            accu$0 = accu$1;
            param$0 = t;
        }
    }
    function of_list(l) {
        if (!l) return [
            0
        ];
        var tl = l[2], hd = l[1], a = caml_array_make(list_length(0, l), hd), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = hd$0;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = tl$0;
        }
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _ab_ = a.length - 2 | 0, _aa_ = 0;
        if (_ab_ >= 0) {
            var i = _aa_;
            for(;;){
                r[1] = caml_call2(f, r[1], a[1 + i]);
                var _ac_ = i + 1 | 0;
                if (_ab_ === i) break;
                i = _ac_;
            }
        }
        return r[1];
    }
    function fold_left_map(f, acc, input_array) {
        var len = input_array.length - 1;
        if (0 === len) return [
            0,
            acc,
            [
                0
            ]
        ];
        var match = caml_call2(f, acc, input_array[1]), elt = match[2], acc$0 = match[1], output_array = caml_array_make(len, elt), acc$1 = [
            0,
            acc$0
        ], ___ = len - 1 | 0, _Z_ = 1;
        if (___ >= 1) {
            var i = _Z_;
            for(;;){
                var match$0 = caml_call2(f, acc$1[1], input_array[1 + i]), elt$0 = match$0[2], acc$2 = match$0[1];
                acc$1[1] = acc$2;
                output_array[1 + i] = elt$0;
                var _$_ = i + 1 | 0;
                if (___ === i) break;
                i = _$_;
            }
        }
        return [
            0,
            acc$1[1],
            output_array
        ];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _X_ = a.length - 2 | 0;
        if (_X_ >= 0) {
            var i = _X_;
            for(;;){
                r[1] = caml_call2(f, a[1 + i], r[1]);
                var _Y_ = i - 1 | 0;
                if (0 === i) break;
                i = _Y_;
            }
        }
        return r[1];
    }
    function exists(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, a[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all2(p, l1, l2) {
        var n1 = l1.length - 1, n2 = l2.length - 1;
        if (n1 !== n2) return caml_call1(Stdlib[1], cst_Array_for_all2);
        var i = 0;
        for(;;){
            if (i === n1) return 1;
            if (!caml_call2(p, l1[1 + i], l2[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function exists2(p, l1, l2) {
        var n1 = l1.length - 1, n2 = l2.length - 1;
        if (n1 !== n2) return caml_call1(Stdlib[1], cst_Array_exists2);
        var i = 0;
        for(;;){
            if (i === n1) return 0;
            if (caml_call2(p, l1[1 + i], l2[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (0 === runtime.caml_compare(a[1 + i], x)) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function memq(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (x === a[1 + i]) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_opt(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var x = a[1 + i];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_index(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_map(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call1(f, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_mapi(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call2(f, i, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function split(x) {
        if (runtime.caml_equal(x, [
            0
        ])) return [
            0,
            [
                0
            ],
            [
                0
            ]
        ];
        var match = x[1], b0 = match[2], a0 = match[1], n = x.length - 1, a = caml_array_make(n, a0), b = caml_array_make(n, b0), _V_ = n - 1 | 0, _U_ = 1;
        if (_V_ >= 1) {
            var i = _U_;
            for(;;){
                var match$0 = x[1 + i], bi = match$0[2], ai = match$0[1];
                a[1 + i] = ai;
                b[1 + i] = bi;
                var _W_ = i + 1 | 0;
                if (_V_ === i) break;
                i = _W_;
            }
        }
        return [
            0,
            a,
            b
        ];
    }
    function combine(a, b) {
        var na = a.length - 1, nb = b.length - 1;
        if (na !== nb) caml_call1(Stdlib[1], cst_Array_combine);
        if (0 === na) return [
            0
        ];
        var x = caml_array_make(na, [
            0,
            a[1],
            b[1]
        ]), _S_ = na - 1 | 0, _R_ = 1;
        if (_S_ >= 1) {
            var i = _R_;
            for(;;){
                x[1 + i] = [
                    0,
                    a[1 + i],
                    b[1 + i]
                ];
                var _T_1 = i + 1 | 0;
                if (_S_ === i) break;
                i = _T_1;
            }
        }
        return x;
    }
    var Bottom = [
        248,
        "Stdlib.Array.Bottom",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        "array.ml",
        369,
        4
    ], _b_ = [
        0,
        "]",
        0
    ], cst_out_of_expected_range_0 = ", out of expected range [0; ", cst_returned = "' returned ", cst_Array_shuffle_rand = "Array.shuffle: 'rand ";
    function sort(cmp, a) {
        function maxson(l, i) {
            var i31 = ((i + i | 0) + i | 0) + 1 | 0, x = [
                0,
                i31
            ];
            if ((i31 + 2 | 0) < l) {
                var _K_ = i31 + 1 | 0, _L_ = caml_check_bound(a, _K_)[1 + _K_];
                if (caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _L_) < 0) x[1] = i31 + 1 | 0;
                var _M_ = i31 + 2 | 0, _N_ = caml_check_bound(a, _M_)[1 + _M_], _O_ = x[1];
                if (caml_call2(cmp, caml_check_bound(a, _O_)[1 + _O_], _N_) < 0) x[1] = i31 + 2 | 0;
                return x[1];
            }
            if ((i31 + 1 | 0) < l) {
                var _P_ = i31 + 1 | 0, _Q_ = caml_check_bound(a, _P_)[1 + _P_];
                if (0 > caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _Q_)) return i31 + 1 | 0;
            }
            if (i31 < l) return i31;
            throw caml_maybe_attach_backtrace([
                0,
                Bottom,
                i
            ], 1);
        }
        var l = a.length - 1, _E_ = ((l + 1 | 0) / 3 | 0) - 1 | 0;
        if (_E_ >= 0) {
            var i$6 = _E_;
            for(;;){
                var e$1 = caml_check_bound(a, i$6)[1 + i$6];
                try {
                    var i = i$6;
                    for(;;){
                        var j = maxson(l, i);
                        if (0 >= caml_call2(cmp, caml_check_bound(a, j)[1 + j], e$1)) break;
                        var _B_ = caml_check_bound(a, j)[1 + j];
                        caml_check_bound(a, i)[1 + i] = _B_;
                        i = j;
                    }
                    caml_check_bound(a, i)[1 + i] = e$1;
                } catch (exn$0) {
                    var exn = caml_wrap_exception(exn$0);
                    if (exn[1] !== Bottom) throw caml_maybe_attach_backtrace(exn, 0);
                    var i$0 = exn[2];
                    caml_check_bound(a, i$0)[1 + i$0] = e$1;
                }
                var _J_ = i$6 - 1 | 0;
                if (0 === i$6) break;
                i$6 = _J_;
            }
        }
        var _F_ = l - 1 | 0;
        if (_F_ >= 2) {
            var i$4 = _F_;
            for(;;){
                var e$0 = caml_check_bound(a, i$4)[1 + i$4];
                a[1 + i$4] = caml_check_bound(a, 0)[1];
                var i$5 = 0;
                try {
                    var i$1 = i$5;
                    for(;;){
                        var j$0 = maxson(i$4, i$1), _C_ = caml_check_bound(a, j$0)[1 + j$0];
                        caml_check_bound(a, i$1)[1 + i$1] = _C_;
                        i$1 = j$0;
                    }
                } catch (exn) {
                    var exn$0 = caml_wrap_exception(exn);
                    if (exn$0[1] !== Bottom) throw caml_maybe_attach_backtrace(exn$0, 0);
                    var i$2 = exn$0[2];
                    a: {
                        b: {
                            var i$3 = i$2;
                            for(;;){
                                var father = (i$3 - 1 | 0) / 3 | 0;
                                if (i$3 === father) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _a_
                                ], 1);
                                if (0 <= caml_call2(cmp, caml_check_bound(a, father)[1 + father], e$0)) break;
                                var _D_ = caml_check_bound(a, father)[1 + father];
                                caml_check_bound(a, i$3)[1 + i$3] = _D_;
                                if (0 >= father) break b;
                                i$3 = father;
                            }
                            caml_check_bound(a, i$3)[1 + i$3] = e$0;
                            break a;
                        }
                        caml_check_bound(a, 0)[1] = e$0;
                    }
                    var _I_ = i$4 - 1 | 0;
                    if (2 === i$4) break;
                    i$4 = _I_;
                }
            }
        }
        var _G_ = 1 < l ? 1 : 0;
        if (_G_) {
            var e = caml_check_bound(a, 1)[2];
            a[2] = caml_check_bound(a, 0)[1];
            a[1] = e;
            var _H_ = 0;
        } else var _H_ = _G_;
        return _H_;
    }
    function stable_sort(cmp, a) {
        function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
            var src1r = src1ofs + src1len | 0, src2r = src2ofs + src2len | 0, s2$1 = caml_check_bound(src2, src2ofs)[1 + src2ofs], s1$1 = caml_check_bound(a, src1ofs)[1 + src1ofs], i1 = src1ofs, s1 = s1$1, i2 = src2ofs, s2 = s2$1, d = dstofs;
            for(;;)if (0 < caml_call2(cmp, s1, s2)) {
                caml_check_bound(dst, d)[1 + d] = s2;
                var i2$0 = i2 + 1 | 0;
                if (i2$0 >= src2r) return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
                var d$0 = d + 1 | 0, s2$0 = caml_check_bound(src2, i2$0)[1 + i2$0];
                i2 = i2$0;
                s2 = s2$0;
                d = d$0;
            } else {
                caml_check_bound(dst, d)[1 + d] = s1;
                var i1$0 = i1 + 1 | 0;
                if (i1$0 >= src1r) return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                var d$1 = d + 1 | 0, s1$0 = caml_check_bound(a, i1$0)[1 + i1$0];
                i1 = i1$0;
                s1 = s1$0;
                d = d$1;
            }
        }
        function isortto(srcofs, dst, dstofs, len) {
            var _t_ = len - 1 | 0, _s_ = 0;
            if (_t_ >= 0) {
                var i = _s_;
                for(;;){
                    var _u_ = srcofs + i | 0, e = caml_check_bound(a, _u_)[1 + _u_], j = [
                        0,
                        (dstofs + i | 0) - 1 | 0
                    ];
                    for(;;){
                        if (dstofs > j[1]) break;
                        var _v_ = j[1];
                        if (0 >= caml_call2(cmp, caml_check_bound(dst, _v_)[1 + _v_], e)) break;
                        var _w_ = j[1], _x_ = caml_check_bound(dst, _w_)[1 + _w_], _y_ = j[1] + 1 | 0;
                        caml_check_bound(dst, _y_)[1 + _y_] = _x_;
                        j[1]--;
                    }
                    var _z_ = j[1] + 1 | 0;
                    caml_check_bound(dst, _z_)[1 + _z_] = e;
                    var _A_ = i + 1 | 0;
                    if (_t_ === i) break;
                    i = _A_;
                }
            }
            return 0;
        }
        function sortto(srcofs, dst, dstofs, len) {
            if (len <= 5) return isortto(srcofs, dst, dstofs, len);
            var l1 = len / 2 | 0, l2 = len - l1 | 0;
            sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
            sortto(srcofs, a, srcofs + l2 | 0, l1);
            return merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
        }
        var l = a.length - 1;
        if (l <= 5) return isortto(0, a, 0, l);
        var l1 = l / 2 | 0, l2 = l - l1 | 0, t = caml_array_make(l2, caml_check_bound(a, 0)[1]);
        sortto(l1, t, 0, l2);
        sortto(0, a, l2, l1);
        return merge(l2, l1, t, 0, l2, a, 0);
    }
    function shuffle(rand, a) {
        var _o_ = a.length - 2 | 0;
        if (_o_ >= 1) {
            var i = _o_;
            for(;;){
                var j = caml_call1(rand, i + 1 | 0), _p_ = 0 <= j ? 1 : 0, _q_ = _p_ ? j <= i ? 1 : 0 : _p_;
                if (1 - _q_) {
                    var int$0 = Stdlib[33], _k_ = [
                        0,
                        cst_out_of_expected_range_0,
                        [
                            0,
                            caml_call1(int$0, i),
                            _b_
                        ]
                    ], _l_ = [
                        0,
                        cst_returned,
                        [
                            0,
                            caml_call1(int$0, j),
                            _k_
                        ]
                    ], _m_ = [
                        0,
                        cst_Array_shuffle_rand,
                        [
                            0,
                            caml_call1(int$0, i + 1 | 0),
                            _l_
                        ]
                    ], _n_ = caml_call2(Stdlib_String[7], cst, _m_);
                    caml_call1(Stdlib[1], _n_);
                }
                var v = a[1 + i];
                a[1 + i] = a[1 + j];
                a[1 + j] = v;
                var _r_ = i - 1 | 0;
                if (1 === i) break;
                i = _r_;
            }
        }
        return 0;
    }
    function to_seq(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _i_ = i + 1 | 0;
            return [
                0,
                x,
                function(_j_) {
                    return aux(_i_, _j_);
                }
            ];
        }
        var _g_ = 0;
        return function(_h_) {
            return aux(_g_, _h_);
        };
    }
    function to_seqi(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _e_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_f_) {
                    return aux(_e_, _f_);
                }
            ];
        }
        var _c_ = 0;
        return function(_d_) {
            return aux(_c_, _d_);
        };
    }
    function of_seq(i$2) {
        var l = caml_call3(Stdlib_Seq[5], function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        }, 0, i$2);
        if (!l) return [
            0
        ];
        var tl = l[2], hd = l[1], len = list_length(0, l), a = caml_array_make(len, hd), i$1 = len - 2 | 0, i = i$1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = hd$0;
            var i$0 = i - 1 | 0;
            i = i$0;
            param = tl$0;
        }
    }
    var Stdlib_Array = [
        0,
        init,
        make_matrix,
        init_matrix,
        append,
        runtime.caml_array_concat,
        sub,
        copy,
        fill,
        blit,
        to_list,
        of_list,
        iter,
        iteri,
        map,
        map_inplace,
        mapi,
        mapi_inplace,
        fold_left,
        fold_left_map,
        fold_right,
        iter2,
        map2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        split,
        combine,
        sort,
        stable_sort,
        stable_sort,
        shuffle,
        to_seq,
        to_seqi,
        of_seq,
        Floatarray
    ];
    runtime.caml_register_global(22, Stdlib_Array, "Stdlib__Array");
    return;
})(globalThis);
//# 6512 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Float_array_blit$1 = "Float.array.blit", cst_float_ml = "float.ml", caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_float_compare = runtime.caml_float_compare, caml_floatarray_blit = runtime.caml_floatarray_blit, caml_floatarray_create = runtime.caml_floatarray_create, caml_floatarray_make = runtime.caml_floatarray_make, caml_floatarray_sub = runtime.caml_floatarray_sub, caml_hash = runtime.caml_hash, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_nextafter_float = runtime.caml_nextafter_float, caml_signbit_float = runtime.caml_signbit_float, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, infinity = Stdlib[22], neg_infinity = Stdlib[23], nan = Stdlib[24], signaling_nan = runtime.caml_int64_float_of_bits(runtime.caml_int64_create_lo_mi_hi(1, 0, 32752));
    function is_finite(x) {
        return x - x === 0. ? 1 : 0;
    }
    function is_infinite(x) {
        return 1. / x === 0. ? 1 : 0;
    }
    function is_nan(x) {
        return x !== x ? 1 : 0;
    }
    var max_float = Stdlib[25], min_float = Stdlib[26], epsilon = Stdlib[27], of_string_opt = Stdlib[36], to_string = Stdlib[35];
    function is_integer(x) {
        var _aV_ = x === runtime.caml_trunc_float(x) ? 1 : 0;
        return _aV_ ? is_finite(x) : _aV_;
    }
    function succ(x) {
        return caml_nextafter_float(x, infinity);
    }
    function pred(x) {
        return caml_nextafter_float(x, neg_infinity);
    }
    function equal(x, y) {
        return 0 === caml_float_compare(x, y) ? 1 : 0;
    }
    function min(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return x !== x ? x : y;
        }
        return y !== y ? y : x;
    }
    function max(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return y !== y ? y : x;
        }
        return x !== x ? x : y;
    }
    function min_max(x, y) {
        if (x === x && y === y) {
            a: if (!(x < y)) {
                if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
                return [
                    0,
                    y,
                    x
                ];
            }
            return [
                0,
                x,
                y
            ];
        }
        return [
            0,
            nan,
            nan
        ];
    }
    function min_num(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return y !== y ? x : y;
        }
        return x !== x ? y : x;
    }
    function max_num(x, y) {
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return x !== x ? y : x;
        }
        return y !== y ? x : y;
    }
    function min_max_num(x, y) {
        if (x !== x) return [
            0,
            y,
            y
        ];
        if (y !== y) return [
            0,
            x,
            x
        ];
        a: if (!(x < y)) {
            if (!caml_signbit_float(y) && caml_signbit_float(x)) break a;
            return [
                0,
                y,
                x
            ];
        }
        return [
            0,
            x,
            y
        ];
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    function check(a, ofs, len, msg) {
        var _aR_ = ofs < 0 ? 1 : 0;
        if (_aR_) var _aS_ = _aR_;
        else {
            var _aT_ = len < 0 ? 1 : 0;
            if (_aT_) var _aS_ = _aT_;
            else var _aU_ = (ofs + len | 0) < 0 ? 1 : 0, _aS_ = _aU_ || (a.length - 1 < (ofs + len | 0) ? 1 : 0);
        }
        return _aS_ ? caml_call1(Stdlib[1], msg) : _aS_;
    }
    var empty = caml_floatarray_create(0), cst_Float_Array_init = "Float.Array.init", cst_Float_Array_make_matrix = "Float.Array.make_matrix", cst_Float_Array_init_matrix = "Float.Array.init_matrix", cst_Float_Array_concat = "Float.Array.concat", _a_ = [
        0,
        cst_float_ml,
        250,
        14
    ], cst_Float_Array_sub = "Float.Array.sub", cst_Float_Array_fill = "Float.Array.fill", cst_Float_array_blit = cst_Float_array_blit$1, cst_Float_array_blit$0 = cst_Float_array_blit$1, cst_Float_Array_iter2_arrays_m = "Float.Array.iter2: arrays must have the same length", cst_Float_Array_map2_arrays_mu = "Float.Array.map2: arrays must have the same length";
    function init(l, f) {
        if (0 > l) return caml_call1(Stdlib[1], cst_Float_Array_init);
        var res = caml_floatarray_create(l), _aP_ = l - 1 | 0, _aO_ = 0;
        if (_aP_ >= 0) {
            var i = _aO_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _aQ_ = i + 1 | 0;
                if (_aP_ === i) break;
                i = _aQ_;
            }
        }
        return res;
    }
    function make_matrix(sx, sy, v) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Float_Array_make_matrix);
        var res = caml_array_make(sx, caml_floatarray_create(0));
        if (0 < sy) {
            var _aM_ = sx - 1 | 0, _aL_ = 0;
            if (_aM_ >= 0) {
                var x = _aL_;
                for(;;){
                    res[1 + x] = caml_floatarray_make(sy, v);
                    var _aN_ = x + 1 | 0;
                    if (_aM_ === x) break;
                    x = _aN_;
                }
            }
        }
        return res;
    }
    function init_matrix(sx, sy, f) {
        if (sy < 0) caml_call1(Stdlib[1], cst_Float_Array_init_matrix);
        var res = caml_array_make(sx, caml_floatarray_create(0));
        if (0 < sy) {
            var _aG_ = sx - 1 | 0, _aF_ = 0;
            if (_aG_ >= 0) {
                var x = _aF_;
                for(;;){
                    var row = caml_floatarray_create(sy), _aI_ = sy - 1 | 0, _aH_ = 0;
                    if (_aI_ >= 0) {
                        var y = _aH_;
                        for(;;){
                            row[1 + y] = caml_call2(f, x, y);
                            var _aK_ = y + 1 | 0;
                            if (_aI_ === y) break;
                            y = _aK_;
                        }
                    }
                    res[1 + x] = row;
                    var _aJ_ = x + 1 | 0;
                    if (_aG_ === x) break;
                    x = _aJ_;
                }
            }
        }
        return res;
    }
    function concat(l) {
        var acc = 0, param = l;
        for(;;){
            if (!param) break;
            var tl = param[2], hd = param[1], x = hd.length - 1 + acc | 0, acc$0 = acc <= x ? x : caml_call1(Stdlib[1], cst_Float_Array_concat);
            acc = acc$0;
            param = tl;
        }
        var result = caml_floatarray_create(acc), l$0 = l, i = 0;
        for(;;){
            if (!l$0) {
                if (i === acc) return result;
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
            }
            var tl$0 = l$0[2], hd$0 = l$0[1], hlen = hd$0.length - 1;
            caml_floatarray_blit(hd$0, 0, result, i, hlen);
            var i$0 = i + hlen | 0;
            l$0 = tl$0;
            i = i$0;
        }
    }
    function sub(a, ofs, len) {
        check(a, ofs, len, cst_Float_Array_sub);
        return caml_floatarray_sub(a, ofs, len);
    }
    function copy(a) {
        var l = a.length - 1;
        return 0 === l ? empty : caml_floatarray_sub(a, 0, l);
    }
    function append(a1, a2) {
        var l1 = a1.length - 1;
        return 0 === l1 ? copy(a2) : 0 === a2.length - 1 ? caml_floatarray_sub(a1, 0, l1) : runtime.caml_floatarray_append(a1, a2);
    }
    function fill(a, ofs, len, v) {
        check(a, ofs, len, cst_Float_Array_fill);
        return runtime.caml_floatarray_fill(a, ofs, len, v);
    }
    function blit(src, sofs, dst, dofs, len) {
        check(src, sofs, len, cst_Float_array_blit);
        check(dst, dofs, len, cst_Float_array_blit$0);
        return caml_floatarray_blit(src, sofs, dst, dofs, len);
    }
    function to_list(a) {
        return caml_call2(Stdlib_List[11], a.length - 1, function(_aE_) {
            return a[1 + _aE_];
        });
    }
    function of_list(l) {
        var result = caml_floatarray_create(caml_call1(Stdlib_List[1], l)), i = 0, l$0 = l;
        for(;;){
            if (!l$0) return result;
            var t = l$0[2], h = l$0[1];
            result[1 + i] = h;
            var i$0 = i + 1 | 0;
            i = i$0;
            l$0 = t;
        }
    }
    function iter(f, a) {
        var _aC_ = a.length - 2 | 0, _aB_ = 0;
        if (_aC_ >= 0) {
            var i = _aB_;
            for(;;){
                caml_call1(f, a[1 + i]);
                var _aD_ = i + 1 | 0;
                if (_aC_ === i) break;
                i = _aD_;
            }
        }
        return 0;
    }
    function iter2(f, a, b) {
        if (a.length - 1 !== b.length - 1) return caml_call1(Stdlib[1], cst_Float_Array_iter2_arrays_m);
        var _az_ = a.length - 2 | 0, _ay_ = 0;
        if (_az_ >= 0) {
            var i = _ay_;
            for(;;){
                caml_call2(f, a[1 + i], b[1 + i]);
                var _aA_ = i + 1 | 0;
                if (_az_ === i) break;
                i = _aA_;
            }
        }
        return 0;
    }
    function map(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _aw_ = l - 1 | 0, _av_ = 0;
        if (_aw_ >= 0) {
            var i = _av_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _ax_ = i + 1 | 0;
                if (_aw_ === i) break;
                i = _ax_;
            }
        }
        return r;
    }
    function map_inplace(f, a) {
        var _at_ = a.length - 2 | 0, _as_ = 0;
        if (_at_ >= 0) {
            var i = _as_;
            for(;;){
                a[1 + i] = caml_call1(f, a[1 + i]);
                var _au_ = i + 1 | 0;
                if (_at_ === i) break;
                i = _au_;
            }
        }
        return 0;
    }
    function map2(f, a, b) {
        var la = a.length - 1, lb = b.length - 1;
        if (la !== lb) return caml_call1(Stdlib[1], cst_Float_Array_map2_arrays_mu);
        var r = caml_floatarray_create(la), _aq_ = la - 1 | 0, _ap_ = 0;
        if (_aq_ >= 0) {
            var i = _ap_;
            for(;;){
                r[1 + i] = caml_call2(f, a[1 + i], b[1 + i]);
                var _ar_ = i + 1 | 0;
                if (_aq_ === i) break;
                i = _ar_;
            }
        }
        return r;
    }
    function iteri(f, a) {
        var _an_ = a.length - 2 | 0, _am_ = 0;
        if (_an_ >= 0) {
            var i = _am_;
            for(;;){
                caml_call2(f, i, a[1 + i]);
                var _ao_ = i + 1 | 0;
                if (_an_ === i) break;
                i = _ao_;
            }
        }
        return 0;
    }
    function mapi(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _ak_ = l - 1 | 0, _aj_ = 0;
        if (_ak_ >= 0) {
            var i = _aj_;
            for(;;){
                r[1 + i] = caml_call2(f, i, a[1 + i]);
                var _al_ = i + 1 | 0;
                if (_ak_ === i) break;
                i = _al_;
            }
        }
        return r;
    }
    function mapi_inplace(f, a) {
        var _ah_ = a.length - 2 | 0, _ag_ = 0;
        if (_ah_ >= 0) {
            var i = _ag_;
            for(;;){
                a[1 + i] = caml_call2(f, i, a[1 + i]);
                var _ai_ = i + 1 | 0;
                if (_ah_ === i) break;
                i = _ai_;
            }
        }
        return 0;
    }
    function fold_left(f, x, a) {
        var r = [
            0,
            x
        ], _ae_ = a.length - 2 | 0, _ad_ = 0;
        if (_ae_ >= 0) {
            var i = _ad_;
            for(;;){
                r[1] = caml_call2(f, r[1], a[1 + i]);
                var _af_ = i + 1 | 0;
                if (_ae_ === i) break;
                i = _af_;
            }
        }
        return r[1];
    }
    function fold_right(f, a, x) {
        var r = [
            0,
            x
        ], _ab_ = a.length - 2 | 0;
        if (_ab_ >= 0) {
            var i = _ab_;
            for(;;){
                r[1] = caml_call2(f, a[1 + i], r[1]);
                var _ac_ = i - 1 | 0;
                if (0 === i) break;
                i = _ac_;
            }
        }
        return r[1];
    }
    function exists(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function for_all(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 1;
            if (!caml_call1(p, a[1 + i])) return 0;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (0 === caml_float_compare(a[1 + i], x)) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function mem_ieee(x, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (x === a[1 + i]) return 1;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_opt(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var x = a[1 + i];
            if (caml_call1(p, x)) return [
                0,
                x
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_index(p, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            if (caml_call1(p, a[1 + i])) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_map(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call1(f, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    function find_mapi(f, a) {
        var n = a.length - 1, i = 0;
        for(;;){
            if (i === n) return 0;
            var r = caml_call2(f, i, a[1 + i]);
            if (r) return r;
            var i$0 = i + 1 | 0;
            i = i$0;
        }
    }
    var Bottom = [
        248,
        "Stdlib.Float.Array.Bottom",
        runtime.caml_fresh_oo_id(0)
    ], _b_ = [
        0,
        cst_float_ml,
        483,
        6
    ];
    function sort(cmp, a) {
        function maxson(l, i) {
            var i31 = ((i + i | 0) + i | 0) + 1 | 0, x = [
                0,
                i31
            ];
            if ((i31 + 2 | 0) < l) {
                var _W_ = i31 + 1 | 0, _X_ = caml_check_bound(a, _W_)[1 + _W_];
                if (caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _X_) < 0) x[1] = i31 + 1 | 0;
                var _Y_ = i31 + 2 | 0, _Z_ = caml_check_bound(a, _Y_)[1 + _Y_], ___ = x[1];
                if (caml_call2(cmp, caml_check_bound(a, ___)[1 + ___], _Z_) < 0) x[1] = i31 + 2 | 0;
                return x[1];
            }
            if ((i31 + 1 | 0) < l) {
                var _$_ = i31 + 1 | 0, _aa_ = caml_check_bound(a, _$_)[1 + _$_];
                if (0 > caml_call2(cmp, caml_check_bound(a, i31)[1 + i31], _aa_)) return i31 + 1 | 0;
            }
            if (i31 < l) return i31;
            throw caml_maybe_attach_backtrace([
                0,
                Bottom,
                i
            ], 1);
        }
        var l = a.length - 1, _Q_ = ((l + 1 | 0) / 3 | 0) - 1 | 0;
        if (_Q_ >= 0) {
            var i$6 = _Q_;
            for(;;){
                var e$1 = caml_check_bound(a, i$6)[1 + i$6];
                try {
                    var i = i$6;
                    for(;;){
                        var j = maxson(l, i);
                        if (0 >= caml_call2(cmp, caml_check_bound(a, j)[1 + j], e$1)) break;
                        var _N_ = caml_check_bound(a, j)[1 + j];
                        caml_check_bound(a, i)[1 + i] = _N_;
                        i = j;
                    }
                    caml_check_bound(a, i)[1 + i] = e$1;
                } catch (exn$0) {
                    var exn = caml_wrap_exception(exn$0);
                    if (exn[1] !== Bottom) throw caml_maybe_attach_backtrace(exn, 0);
                    var i$0 = exn[2];
                    caml_check_bound(a, i$0)[1 + i$0] = e$1;
                }
                var _V_ = i$6 - 1 | 0;
                if (0 === i$6) break;
                i$6 = _V_;
            }
        }
        var _R_ = l - 1 | 0;
        if (_R_ >= 2) {
            var i$4 = _R_;
            for(;;){
                var e$0 = caml_check_bound(a, i$4)[1 + i$4];
                a[1 + i$4] = caml_check_bound(a, 0)[1];
                var i$5 = 0;
                try {
                    var i$1 = i$5;
                    for(;;){
                        var j$0 = maxson(i$4, i$1), _O_ = caml_check_bound(a, j$0)[1 + j$0];
                        caml_check_bound(a, i$1)[1 + i$1] = _O_;
                        i$1 = j$0;
                    }
                } catch (exn) {
                    var exn$0 = caml_wrap_exception(exn);
                    if (exn$0[1] !== Bottom) throw caml_maybe_attach_backtrace(exn$0, 0);
                    var i$2 = exn$0[2];
                    a: {
                        b: {
                            var i$3 = i$2;
                            for(;;){
                                var father = (i$3 - 1 | 0) / 3 | 0;
                                if (i$3 === father) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _b_
                                ], 1);
                                if (0 <= caml_call2(cmp, caml_check_bound(a, father)[1 + father], e$0)) break;
                                var _P_ = caml_check_bound(a, father)[1 + father];
                                caml_check_bound(a, i$3)[1 + i$3] = _P_;
                                if (0 >= father) break b;
                                i$3 = father;
                            }
                            caml_check_bound(a, i$3)[1 + i$3] = e$0;
                            break a;
                        }
                        caml_check_bound(a, 0)[1] = e$0;
                    }
                    var _U_ = i$4 - 1 | 0;
                    if (2 === i$4) break;
                    i$4 = _U_;
                }
            }
        }
        var _S_ = 1 < l ? 1 : 0;
        if (_S_) {
            var e = caml_check_bound(a, 1)[2];
            a[2] = caml_check_bound(a, 0)[1];
            a[1] = e;
            var _T_1 = 0;
        } else var _T_1 = _S_;
        return _T_1;
    }
    function stable_sort(cmp, a) {
        function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
            var src1r = src1ofs + src1len | 0, src2r = src2ofs + src2len | 0, s2$1 = caml_check_bound(src2, src2ofs)[1 + src2ofs], s1$1 = caml_check_bound(a, src1ofs)[1 + src1ofs], i1 = src1ofs, s1 = s1$1, i2 = src2ofs, s2 = s2$1, d = dstofs;
            for(;;)if (0 < caml_call2(cmp, s1, s2)) {
                caml_check_bound(dst, d)[1 + d] = s2;
                var i2$0 = i2 + 1 | 0;
                if (i2$0 >= src2r) return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
                var d$0 = d + 1 | 0, s2$0 = caml_check_bound(src2, i2$0)[1 + i2$0];
                i2 = i2$0;
                s2 = s2$0;
                d = d$0;
            } else {
                caml_check_bound(dst, d)[1 + d] = s1;
                var i1$0 = i1 + 1 | 0;
                if (i1$0 >= src1r) return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                var d$1 = d + 1 | 0, s1$0 = caml_check_bound(a, i1$0)[1 + i1$0];
                i1 = i1$0;
                s1 = s1$0;
                d = d$1;
            }
        }
        function isortto(srcofs, dst, dstofs, len) {
            var _F_ = len - 1 | 0, _E_ = 0;
            if (_F_ >= 0) {
                var i = _E_;
                for(;;){
                    var _G_ = srcofs + i | 0, e = caml_check_bound(a, _G_)[1 + _G_], j = [
                        0,
                        (dstofs + i | 0) - 1 | 0
                    ];
                    for(;;){
                        if (dstofs > j[1]) break;
                        var _H_ = j[1];
                        if (0 >= caml_call2(cmp, caml_check_bound(dst, _H_)[1 + _H_], e)) break;
                        var _I_ = j[1], _J_ = caml_check_bound(dst, _I_)[1 + _I_], _K_ = j[1] + 1 | 0;
                        caml_check_bound(dst, _K_)[1 + _K_] = _J_;
                        j[1]--;
                    }
                    var _L_ = j[1] + 1 | 0;
                    caml_check_bound(dst, _L_)[1 + _L_] = e;
                    var _M_ = i + 1 | 0;
                    if (_F_ === i) break;
                    i = _M_;
                }
            }
            return 0;
        }
        function sortto(srcofs, dst, dstofs, len) {
            if (len <= 5) return isortto(srcofs, dst, dstofs, len);
            var l1 = len / 2 | 0, l2 = len - l1 | 0;
            sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
            sortto(srcofs, a, srcofs + l2 | 0, l1);
            return merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
        }
        var l = a.length - 1;
        if (l <= 5) return isortto(0, a, 0, l);
        var l1 = l / 2 | 0, l2 = l - l1 | 0, t = caml_floatarray_create(l2);
        sortto(l1, t, 0, l2);
        sortto(0, a, l2, l1);
        return merge(l2, l1, t, 0, l2, a, 0);
    }
    function shuffle(rand, a) {
        var _C_ = a.length - 2 | 0;
        if (_C_ >= 1) {
            var i = _C_;
            for(;;){
                var j = caml_call1(rand, i + 1 | 0), v = a[1 + i];
                a[1 + i] = caml_check_bound(a, j)[1 + j];
                a[1 + j] = v;
                var _D_ = i - 1 | 0;
                if (1 === i) break;
                i = _D_;
            }
        }
        return 0;
    }
    function to_seq(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _A_ = i + 1 | 0;
            return [
                0,
                x,
                function(_B_) {
                    return aux(_A_, _B_);
                }
            ];
        }
        var _y_ = 0;
        return function(_z_) {
            return aux(_y_, _z_);
        };
    }
    function to_seqi(a) {
        function aux(i, param) {
            if (i >= a.length - 1) return 0;
            var x = a[1 + i], _w_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_x_) {
                    return aux(_w_, _x_);
                }
            ];
        }
        var _u_ = 0;
        return function(_v_) {
            return aux(_u_, _v_);
        };
    }
    function of_seq(i$2) {
        var l = caml_call3(Stdlib_Seq[5], function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        }, 0, i$2), len = caml_call1(Stdlib_List[1], l), a = caml_floatarray_create(len), i$1 = len - 1 | 0, i = i$1, param = l;
        for(;;){
            if (!param) return a;
            var tl = param[2], hd = param[1];
            a[1 + i] = hd;
            var i$0 = i - 1 | 0;
            i = i$0;
            param = tl;
        }
    }
    function map_to_array(f, a) {
        var l = a.length - 1;
        if (0 === l) return [
            0
        ];
        var r = caml_array_make(l, caml_call1(f, a[1])), _s_ = l - 1 | 0, _r_ = 1;
        if (_s_ >= 1) {
            var i = _r_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _t_ = i + 1 | 0;
                if (_s_ === i) break;
                i = _t_;
            }
        }
        return r;
    }
    function map_from_array(f, a) {
        var l = a.length - 1, r = caml_floatarray_create(l), _p_ = l - 1 | 0, _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                r[1 + i] = caml_call1(f, a[1 + i]);
                var _q_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _q_;
            }
        }
        return r;
    }
    var Stdlib_Float = [
        0,
        0.,
        1.,
        -1,
        succ,
        pred,
        infinity,
        neg_infinity,
        nan,
        signaling_nan,
        nan,
        3.141592653589793,
        max_float,
        min_float,
        epsilon,
        is_finite,
        is_infinite,
        is_nan,
        is_integer,
        of_string_opt,
        to_string,
        caml_float_compare,
        equal,
        min,
        max,
        min_max,
        min_num,
        max_num,
        min_max_num,
        seeded_hash,
        hash,
        [
            0,
            function(_n_) {
                return _n_.length - 1;
            },
            function(_m_, _l_) {
                return caml_check_bound(_m_, _l_)[1 + _l_];
            },
            function(_k_, _j_, _i_) {
                caml_check_bound(_k_, _j_)[1 + _j_] = _i_;
                return 0;
            },
            caml_floatarray_make,
            caml_floatarray_create,
            init,
            make_matrix,
            init_matrix,
            append,
            concat,
            sub,
            copy,
            fill,
            blit,
            to_list,
            of_list,
            iter,
            iteri,
            map,
            map_inplace,
            mapi,
            mapi_inplace,
            fold_left,
            fold_right,
            iter2,
            map2,
            for_all,
            exists,
            mem,
            mem_ieee,
            find_opt,
            find_index,
            find_map,
            find_mapi,
            sort,
            stable_sort,
            stable_sort,
            shuffle,
            to_seq,
            to_seqi,
            of_seq,
            map_to_array,
            map_from_array
        ],
        [
            0,
            function(_h_) {
                return _h_.length - 1;
            },
            function(_g_, _f_) {
                return caml_check_bound(_g_, _f_)[1 + _f_];
            },
            function(_e_, _d_, _c_) {
                caml_check_bound(_e_, _d_)[1 + _d_] = _c_;
                return 0;
            },
            caml_floatarray_make,
            caml_floatarray_create,
            init,
            make_matrix,
            init_matrix,
            append,
            concat,
            sub,
            copy,
            fill,
            blit,
            to_list,
            of_list,
            iter,
            iteri,
            map,
            map_inplace,
            mapi,
            mapi_inplace,
            fold_left,
            fold_right,
            iter2,
            map2,
            for_all,
            exists,
            mem,
            mem_ieee,
            find_opt,
            find_index,
            find_map,
            find_mapi,
            sort,
            stable_sort,
            stable_sort,
            shuffle,
            to_seq,
            to_seqi,
            of_seq,
            map_to_array,
            map_from_array
        ]
    ];
    runtime.caml_register_global(25, Stdlib_Float, "Stdlib__Float");
    return;
})(globalThis);
//# 7412 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, Assert_failure = global_data.Assert_failure, zero = 0, one = 1;
    function succ(n) {
        return n + 1 | 0;
    }
    function pred(n) {
        return n - 1 | 0;
    }
    function abs(n) {
        return caml_greaterequal(n, 0) ? n : -n | 0;
    }
    function lognot(n) {
        return n ^ -1;
    }
    var _a_ = Stdlib_Sys[9], _b_ = [
        0,
        "int32.ml",
        69,
        6
    ], minus_one = -1, min_int = -2147483648, max_int = 2147483647;
    if (32 === _a_) var max_int$0 = Stdlib[19], unsigned_to_int = function(n) {
        if (caml_greaterequal(n, 0) && caml_lessequal(n, max_int$0)) return [
            0,
            n
        ];
        return 0;
    };
    else {
        if (64 !== _a_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var unsigned_to_int = function(n) {
            return [
                0,
                n & -1
            ];
        };
    }
    function to_string(n) {
        return runtime.caml_format_int("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _d_ = [
                0,
                runtime.caml_int_of_string(s)
            ];
            return _d_;
        } catch (_e_) {
            var _c_ = caml_wrap_exception(_e_);
            if (_c_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_c_, 0);
        }
    }
    var compare = caml_int_compare, equal = runtime.caml_equal;
    function unsigned_compare(n, m) {
        var y = m + 2147483648 | 0, x = n + 2147483648 | 0;
        return caml_int_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(n + 2147483648 | 0, m + 2147483648 | 0);
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, 0)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_div(n >>> 1 | 0, d) << 1, r = n - caml_mul(q, d) | 0;
        return unsigned_lt(r, d) ? q : q + 1 | 0;
    }
    function unsigned_rem(n, d) {
        return n - caml_mul(unsigned_div(n, d), d) | 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int32 = [
        0,
        zero,
        one,
        minus_one,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(15, Stdlib_Int32, "Stdlib__Int32");
    return;
})(globalThis);
//# 7515 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int64_add = runtime.caml_int64_add, caml_int64_compare = runtime.caml_int64_compare, caml_int64_mul = runtime.caml_int64_mul, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), _a_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), zero = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), one = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), minus_one = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), min_int = runtime.caml_int64_create_lo_mi_hi(0, 0, 32768), max_int = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767), Stdlib = global_data.Stdlib, _b_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535);
    function succ(n) {
        return caml_int64_add(n, _a_);
    }
    function pred(n) {
        return caml_int64_sub(n, _b_);
    }
    function abs(n) {
        return caml_greaterequal(n, _c_) ? n : runtime.caml_int64_neg(n);
    }
    function lognot(n) {
        return runtime.caml_int64_xor(n, _d_);
    }
    var max_int$0 = runtime.caml_int64_of_int32(Stdlib[19]), _e_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0);
    function unsigned_to_int(n) {
        if (caml_greaterequal(n, _e_) && caml_lessequal(n, max_int$0)) return [
            0,
            runtime.caml_int64_to_int32(n)
        ];
        return 0;
    }
    function to_string(n) {
        return runtime.caml_int64_format("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _g_ = [
                0,
                runtime.caml_int64_of_string(s)
            ];
            return _g_;
        } catch (_h_) {
            var _f_ = caml_wrap_exception(_h_);
            if (_f_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_f_, 0);
        }
    }
    function compare(x, y) {
        return caml_int64_compare(x, y);
    }
    var equal = runtime.caml_equal;
    function unsigned_compare(n, m) {
        var y = caml_int64_sub(m, min_int), x = caml_int64_sub(n, min_int);
        return caml_int64_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(caml_int64_sub(n, min_int), caml_int64_sub(m, min_int));
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, zero)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_int64_shift_left(runtime.caml_int64_div(runtime.caml_int64_shift_right_unsigned(n, 1), d), 1), r = caml_int64_sub(n, caml_int64_mul(q, d));
        return unsigned_lt(r, d) ? q : caml_int64_add(q, _a_);
    }
    function unsigned_rem(n, d) {
        return caml_int64_sub(n, caml_int64_mul(unsigned_div(n, d), d));
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Int64 = [
        0,
        zero,
        one,
        minus_one,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(12, Stdlib_Int64, "Stdlib__Int64");
    return;
})(globalThis);
//# 7623 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_hash = runtime.caml_hash, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul, caml_wrap_exception = runtime.caml_wrap_exception, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, zero = 0, one = 1;
    function succ(n) {
        return n + 1 | 0;
    }
    function pred(n) {
        return n - 1 | 0;
    }
    function abs(n) {
        return caml_greaterequal(n, 0) ? n : -n | 0;
    }
    var size = Stdlib_Sys[9], min_int = 1 << (size - 1 | 0), max_int = min_int - 1 | 0;
    function lognot(n) {
        return n ^ -1;
    }
    var max_int$0 = Stdlib[19];
    function unsigned_to_int(n) {
        if (caml_greaterequal(n, 0) && caml_lessequal(n, max_int$0)) return [
            0,
            n
        ];
        return 0;
    }
    function to_string(n) {
        return runtime.caml_format_int("%d", n);
    }
    function of_string_opt(s) {
        try {
            var _b_ = [
                0,
                runtime.caml_int_of_string(s)
            ];
            return _b_;
        } catch (_c_) {
            var _a_ = caml_wrap_exception(_c_);
            if (_a_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_a_, 0);
        }
    }
    var compare = caml_int_compare;
    function equal(x, y) {
        return 0 === caml_int_compare(x, y) ? 1 : 0;
    }
    function unsigned_compare(n, m) {
        var y = m - min_int | 0, x = n - min_int | 0;
        return caml_int_compare(x, y);
    }
    function unsigned_lt(n, m) {
        return caml_lessthan(n - min_int | 0, m - min_int | 0);
    }
    function min(x, y) {
        return caml_lessequal(x, y) ? x : y;
    }
    function max(x, y) {
        return caml_greaterequal(x, y) ? x : y;
    }
    function unsigned_div(n, d) {
        if (caml_lessthan(d, 0)) return unsigned_lt(n, d) ? zero : one;
        var q = runtime.caml_div(n >>> 1 | 0, d) << 1, r = n - caml_mul(q, d) | 0;
        return unsigned_lt(r, d) ? q : q + 1 | 0;
    }
    function unsigned_rem(n, d) {
        return n - caml_mul(unsigned_div(n, d), d) | 0;
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    var Stdlib_Nativeint = [
        0,
        zero,
        one,
        -1,
        unsigned_div,
        unsigned_rem,
        succ,
        pred,
        abs,
        size,
        max_int,
        min_int,
        lognot,
        unsigned_to_int,
        of_string_opt,
        to_string,
        compare,
        unsigned_compare,
        equal,
        min,
        max,
        seeded_hash,
        hash
    ];
    runtime.caml_register_global(13, Stdlib_Nativeint, "Stdlib__Nativeint");
    return;
})(globalThis);
//# 7716 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", caml_bytes_get = runtime.caml_bytes_get, caml_check_bound = runtime.caml_check_bound, caml_create_bytes = runtime.caml_create_bytes, caml_ml_bytes_length = runtime.caml_ml_bytes_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), dummy_pos = [
        0,
        cst,
        0,
        0,
        -1
    ], zero_pos = [
        0,
        cst,
        1,
        0,
        0
    ], Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib = global_data.Stdlib, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, cst_Lexing_lex_refill_cannot_g = "Lexing.lex_refill: cannot grow buffer";
    function engine(tbl, state, buf) {
        var result = runtime.caml_lex_engine(tbl, state, buf), _n_ = 0 <= result ? 1 : 0, _o_ = _n_ ? buf[12] !== dummy_pos ? 1 : 0 : _n_;
        if (_o_) {
            buf[11] = buf[12];
            var _p_ = buf[12];
            buf[12] = [
                0,
                _p_[1],
                _p_[2],
                _p_[3],
                buf[4] + buf[6] | 0
            ];
        }
        return result;
    }
    function new_engine(tbl, state, buf) {
        var result = runtime.caml_new_lex_engine(tbl, state, buf), _k_ = 0 <= result ? 1 : 0, _l_ = _k_ ? buf[12] !== dummy_pos ? 1 : 0 : _k_;
        if (_l_) {
            buf[11] = buf[12];
            var _m_ = buf[12];
            buf[12] = [
                0,
                _m_[1],
                _m_[2],
                _m_[3],
                buf[4] + buf[6] | 0
            ];
        }
        return result;
    }
    function from_function(opt, read_fun) {
        var with_positions = opt ? opt[1] : 1, _f_ = with_positions ? zero_pos : dummy_pos, _g_ = with_positions ? zero_pos : dummy_pos, aux_buffer = caml_create_bytes(512);
        return [
            0,
            function(lexbuf) {
                var read = caml_call2(read_fun, aux_buffer, caml_ml_bytes_length(aux_buffer)), n = 0 < read ? read : (lexbuf[9] = 1, 0);
                if (caml_ml_bytes_length(lexbuf[2]) < (lexbuf[3] + n | 0)) {
                    if (((lexbuf[3] - lexbuf[5] | 0) + n | 0) <= caml_ml_bytes_length(lexbuf[2])) caml_call5(Stdlib_Bytes[11], lexbuf[2], lexbuf[5], lexbuf[2], 0, lexbuf[3] - lexbuf[5] | 0);
                    else {
                        var newlen = caml_call2(Stdlib_Int[10], 2 * caml_ml_bytes_length(lexbuf[2]) | 0, Stdlib_Sys[12]);
                        if (newlen < ((lexbuf[3] - lexbuf[5] | 0) + n | 0)) caml_call1(Stdlib[2], cst_Lexing_lex_refill_cannot_g);
                        var newbuf = caml_create_bytes(newlen);
                        caml_call5(Stdlib_Bytes[11], lexbuf[2], lexbuf[5], newbuf, 0, lexbuf[3] - lexbuf[5] | 0);
                        lexbuf[2] = newbuf;
                    }
                    var s = lexbuf[5];
                    lexbuf[4] = lexbuf[4] + s | 0;
                    lexbuf[6] = lexbuf[6] - s | 0;
                    lexbuf[5] = 0;
                    lexbuf[7] = lexbuf[7] - s | 0;
                    lexbuf[3] = lexbuf[3] - s | 0;
                    var t = lexbuf[10], _i_ = t.length - 2 | 0, _h_ = 0;
                    if (_i_ >= 0) {
                        var i = _h_;
                        for(;;){
                            var v = caml_check_bound(t, i)[1 + i];
                            if (0 <= v) caml_check_bound(t, i)[1 + i] = v - s | 0;
                            var _j_ = i + 1 | 0;
                            if (_i_ === i) break;
                            i = _j_;
                        }
                    }
                }
                caml_call5(Stdlib_Bytes[11], aux_buffer, 0, lexbuf[2], lexbuf[3], n);
                lexbuf[3] = lexbuf[3] + n | 0;
                return 0;
            },
            caml_create_bytes(1024),
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0
            ],
            _g_,
            _f_
        ];
    }
    function from_channel(with_positions, ic) {
        return from_function(with_positions, function(buf, n) {
            return caml_call4(Stdlib[84], ic, buf, 0, n);
        });
    }
    function from_string(opt, s) {
        var with_positions = opt ? opt[1] : 1, lex_buffer = caml_call1(Stdlib_Bytes[5], s), _d_ = with_positions ? zero_pos : dummy_pos, _e_ = with_positions ? zero_pos : dummy_pos;
        return [
            0,
            function(lexbuf) {
                lexbuf[9] = 1;
                return 0;
            },
            lex_buffer,
            caml_ml_bytes_length(lex_buffer),
            0,
            0,
            0,
            0,
            0,
            1,
            [
                0
            ],
            _e_,
            _d_
        ];
    }
    function set_position(lexbuf, position) {
        lexbuf[12] = [
            0,
            lexbuf[12][1],
            position[2],
            position[3],
            position[4]
        ];
        lexbuf[4] = position[4];
        return 0;
    }
    function set_filename(lexbuf, fname) {
        var _c_ = lexbuf[12];
        lexbuf[12] = [
            0,
            fname,
            _c_[2],
            _c_[3],
            _c_[4]
        ];
        return 0;
    }
    function with_positions(lexbuf) {
        return lexbuf[12] !== dummy_pos ? 1 : 0;
    }
    function lexeme(lexbuf) {
        var len = lexbuf[6] - lexbuf[5] | 0;
        return caml_call3(Stdlib_Bytes[8], lexbuf[2], lexbuf[5], len);
    }
    function sub_lexeme(lexbuf, i1, i2) {
        var len = i2 - i1 | 0;
        return caml_call3(Stdlib_Bytes[8], lexbuf[2], i1, len);
    }
    function sub_lexeme_opt(lexbuf, i1, i2) {
        if (0 > i1) return 0;
        var len = i2 - i1 | 0;
        return [
            0,
            caml_call3(Stdlib_Bytes[8], lexbuf[2], i1, len)
        ];
    }
    function sub_lexeme_char(lexbuf, i) {
        return caml_bytes_get(lexbuf[2], i);
    }
    function sub_lexeme_char_opt(lexbuf, i) {
        return 0 <= i ? [
            0,
            caml_bytes_get(lexbuf[2], i)
        ] : 0;
    }
    function lexeme_char(lexbuf, i) {
        return caml_bytes_get(lexbuf[2], lexbuf[5] + i | 0);
    }
    function lexeme_start(lexbuf) {
        return lexbuf[11][4];
    }
    function lexeme_end(lexbuf) {
        return lexbuf[12][4];
    }
    function lexeme_start_p(lexbuf) {
        return lexbuf[11];
    }
    function lexeme_end_p(lexbuf) {
        return lexbuf[12];
    }
    function new_line(lexbuf) {
        var lcp = lexbuf[12], _a_ = lcp !== dummy_pos ? 1 : 0, _b_ = _a_ ? (lexbuf[12] = [
            0,
            lcp[1],
            lcp[2] + 1 | 0,
            lcp[4],
            lcp[4]
        ], 0) : _a_;
        return _b_;
    }
    function flush_input(lb) {
        lb[6] = 0;
        lb[4] = 0;
        var lcp = lb[12];
        if (lcp !== dummy_pos) lb[12] = [
            0,
            lcp[1],
            zero_pos[2],
            zero_pos[3],
            zero_pos[4]
        ];
        lb[3] = 0;
        return 0;
    }
    var Stdlib_Lexing = [
        0,
        dummy_pos,
        from_channel,
        from_string,
        from_function,
        set_position,
        set_filename,
        with_positions,
        lexeme,
        lexeme_char,
        lexeme_start,
        lexeme_end,
        lexeme_start_p,
        lexeme_end_p,
        new_line,
        flush_input,
        sub_lexeme,
        sub_lexeme_opt,
        sub_lexeme_char,
        sub_lexeme_char_opt,
        engine,
        new_engine
    ];
    runtime.caml_register_global(7, Stdlib_Lexing, "Stdlib__Lexing");
    return;
})(globalThis);
//# 7972 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Lexing = global_data.Stdlib__Lexing, YYexit = [
        248,
        "Stdlib.Parsing.YYexit",
        caml_fresh_oo_id(0)
    ], Parse_error = [
        248,
        "Stdlib.Parsing.Parse_error",
        caml_fresh_oo_id(0)
    ], env = [
        0,
        caml_array_make(100, 0),
        caml_array_make(100, 0),
        caml_array_make(100, Stdlib_Lexing[1]),
        caml_array_make(100, Stdlib_Lexing[1]),
        100,
        0,
        0,
        0,
        Stdlib_Lexing[1],
        Stdlib_Lexing[1],
        0,
        0,
        0,
        0,
        0,
        0
    ], dummy = 0;
    function grow_stacks(param) {
        var oldsize = env[5], newsize = oldsize * 2 | 0, new_s = caml_array_make(newsize, 0), new_v = caml_array_make(newsize, 0), new_start = caml_array_make(newsize, Stdlib_Lexing[1]), new_end = caml_array_make(newsize, Stdlib_Lexing[1]);
        caml_call5(Stdlib_Array[9], env[1], 0, new_s, 0, oldsize);
        env[1] = new_s;
        caml_call5(Stdlib_Array[9], env[2], 0, new_v, 0, oldsize);
        env[2] = new_v;
        caml_call5(Stdlib_Array[9], env[3], 0, new_start, 0, oldsize);
        env[3] = new_start;
        caml_call5(Stdlib_Array[9], env[4], 0, new_end, 0, oldsize);
        env[4] = new_end;
        env[5] = newsize;
    }
    function clear_parser(param) {
        caml_call4(Stdlib_Array[8], env[2], 0, env[5], 0);
        env[8] = 0;
        return 0;
    }
    var current_lookahead_fun = [
        0,
        function(param) {
            return 0;
        }
    ], cst_syntax_error = "syntax error";
    function yyparse(tables, start, lexer, lexbuf) {
        var init_asp = env[11], init_sp = env[14], init_stackbase = env[6], init_state = env[15], init_curr_char = env[7], init_lval = env[8], init_errflag = env[16];
        env[6] = env[14] + 1 | 0;
        env[7] = start;
        env[10] = lexbuf[12];
        try {
            var cmd = 0, arg = 0;
            for(;;)switch(runtime.caml_parse_engine(tables, env, cmd, arg)){
                case 0:
                    var arg$0 = caml_call1(lexer, lexbuf);
                    env[9] = lexbuf[11];
                    env[10] = lexbuf[12];
                    cmd = 1;
                    arg = arg$0;
                    break;
                case 1:
                    throw caml_maybe_attach_backtrace(Parse_error, 1);
                case 2:
                    grow_stacks(0);
                    cmd = 2;
                    arg = 0;
                    break;
                case 3:
                    grow_stacks(0);
                    cmd = 3;
                    arg = 0;
                    break;
                case 4:
                    try {
                        var _i_ = env[13], _j_ = caml_call1(caml_check_bound(tables[1], _i_)[1 + _i_], env), _k_ = 4, value = _j_, action = _k_;
                    } catch (_m_) {
                        var _h_ = caml_wrap_exception(_m_);
                        if (_h_ !== Parse_error) throw caml_maybe_attach_backtrace(_h_, 0);
                        var value = 0, action = 5;
                    }
                    cmd = action;
                    arg = value;
                    break;
                default:
                    caml_call1(tables[14], cst_syntax_error);
                    cmd = 5;
                    arg = 0;
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), curr_char = env[7];
            env[11] = init_asp;
            env[14] = init_sp;
            env[6] = init_stackbase;
            env[15] = init_state;
            env[7] = init_curr_char;
            env[8] = init_lval;
            env[16] = init_errflag;
            if (exn[1] === YYexit) {
                var v = exn[2];
                return v;
            }
            current_lookahead_fun[1] = function(tok) {
                if (!caml_call1(Stdlib_Obj[1], tok)) return caml_check_bound(tables[2], tok)[1 + tok] === curr_char ? 1 : 0;
                var _l_ = runtime.caml_obj_tag(tok);
                return caml_check_bound(tables[3], _l_)[1 + _l_] === curr_char ? 1 : 0;
            };
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function peek_val(env, n) {
        var _g_ = env[11] - n | 0;
        return caml_check_bound(env[2], _g_)[1 + _g_];
    }
    function symbol_start_pos(param) {
        var i$1 = env[12], i = i$1;
        for(;;){
            if (0 >= i) {
                var _f_ = env[11];
                return caml_check_bound(env[4], _f_)[1 + _f_];
            }
            var _d_ = (env[11] - i | 0) + 1 | 0, st = caml_check_bound(env[3], _d_)[1 + _d_], _e_ = (env[11] - i | 0) + 1 | 0, en = caml_check_bound(env[4], _e_)[1 + _e_];
            if (runtime.caml_notequal(st, en)) return st;
            var i$0 = i - 1 | 0;
            i = i$0;
        }
    }
    function symbol_end_pos(param) {
        var _c_ = env[11];
        return caml_check_bound(env[4], _c_)[1 + _c_];
    }
    function rhs_start_pos(n) {
        var _b_ = env[11] - (env[12] - n | 0) | 0;
        return caml_check_bound(env[3], _b_)[1 + _b_];
    }
    function rhs_end_pos(n) {
        var _a_ = env[11] - (env[12] - n | 0) | 0;
        return caml_check_bound(env[4], _a_)[1 + _a_];
    }
    function symbol_start(param) {
        return symbol_start_pos(0)[4];
    }
    function symbol_end(param) {
        return symbol_end_pos(0)[4];
    }
    function rhs_start(n) {
        return rhs_start_pos(n)[4];
    }
    function rhs_end(n) {
        return rhs_end_pos(n)[4];
    }
    function is_current_lookahead(tok) {
        return caml_call1(current_lookahead_fun[1], tok);
    }
    function parse_error(param) {
        return 0;
    }
    var Stdlib_Parsing = [
        0,
        symbol_start,
        symbol_end,
        rhs_start,
        rhs_end,
        symbol_start_pos,
        symbol_end_pos,
        rhs_start_pos,
        rhs_end_pos,
        clear_parser,
        Parse_error,
        runtime.caml_set_parser_trace,
        YYexit,
        yyparse,
        peek_val,
        is_current_lookahead,
        parse_error
    ];
    runtime.caml_register_global(7, Stdlib_Parsing, "Stdlib__Parsing");
    return;
})(globalThis);
//# 8185 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Set_bal$3 = "Set.bal", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure, cst_Set_bal = cst_Set_bal$3, cst_Set_bal$0 = cst_Set_bal$3, cst_Set_bal$1 = cst_Set_bal$3, cst_Set_bal$2 = cst_Set_bal$3, cst_Set_remove_min_elt = "Set.remove_min_elt", _a_ = [
        0,
        0,
        0,
        0
    ], _b_ = [
        0,
        0,
        0
    ], _c_ = [
        0,
        "set.ml",
        571,
        18
    ], Stdlib_Set = [
        0,
        function(Ord) {
            function height(param) {
                if (!param) return 0;
                var h = param[4];
                return h;
            }
            function create(l, v, r) {
                if (l) var h = l[4], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[4], hr = h$0;
                else var hr = 0;
                var _Y_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                return [
                    0,
                    l,
                    v,
                    r,
                    _Y_
                ];
            }
            function bal(l, v, r) {
                if (l) var h = l[4], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[4], hr = h$0;
                else var hr = 0;
                if ((hr + 2 | 0) < hl) {
                    if (!l) return caml_call1(Stdlib[1], cst_Set_bal$0);
                    var lr = l[3], lv = l[2], ll = l[1], _T_1 = height(lr);
                    if (_T_1 <= height(ll)) return create(ll, lv, create(lr, v, r));
                    if (!lr) return caml_call1(Stdlib[1], cst_Set_bal);
                    var lrr = lr[3], lrv = lr[2], lrl = lr[1], _U_ = create(lrr, v, r);
                    return create(create(ll, lv, lrl), lrv, _U_);
                }
                if ((hl + 2 | 0) >= hr) {
                    var _X_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                    return [
                        0,
                        l,
                        v,
                        r,
                        _X_
                    ];
                }
                if (!r) return caml_call1(Stdlib[1], cst_Set_bal$2);
                var rr = r[3], rv = r[2], rl = r[1], _V_ = height(rl);
                if (_V_ <= height(rr)) return create(create(l, v, rl), rv, rr);
                if (!rl) return caml_call1(Stdlib[1], cst_Set_bal$1);
                var rlr = rl[3], rlv = rl[2], rll = rl[1], _W_ = create(rlr, rv, rr);
                return create(create(l, v, rll), rlv, _W_);
            }
            function add(x, t) {
                if (!t) return [
                    0,
                    0,
                    x,
                    0,
                    1
                ];
                var r = t[3], v = t[2], l = t[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return t;
                if (0 <= c) {
                    var rr = add(x, r);
                    return r === rr ? t : bal(l, v, rr);
                }
                var ll = add(x, l);
                return l === ll ? t : bal(ll, v, r);
            }
            function singleton(x) {
                return [
                    0,
                    0,
                    x,
                    0,
                    1
                ];
            }
            function add_min_element(x, param) {
                if (!param) return singleton(x);
                var r = param[3], v = param[2], l = param[1];
                return bal(add_min_element(x, l), v, r);
            }
            function add_max_element(x, param) {
                if (!param) return singleton(x);
                var r = param[3], v = param[2], l = param[1];
                return bal(l, v, add_max_element(x, r));
            }
            function join(l, v, r) {
                if (!l) return add_min_element(v, r);
                if (!r) return add_max_element(v, l);
                var rh = r[4], rr = r[3], rv = r[2], rl = r[1], lh = l[4], lr = l[3], lv = l[2], ll = l[1];
                return (rh + 2 | 0) < lh ? bal(ll, lv, join(lr, v, r)) : (lh + 2 | 0) < rh ? bal(join(l, v, rl), rv, rr) : create(l, v, r);
            }
            function min_elt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var l = param$0[1];
                    if (!l) {
                        var v = param$0[2];
                        return v;
                    }
                    param$0 = l;
                }
            }
            function min_elt_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var l = param$0[1];
                    if (!l) {
                        var v = param$0[2];
                        return [
                            0,
                            v
                        ];
                    }
                    param$0 = l;
                }
            }
            function max_elt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    if (!param$0[3]) {
                        var v = param$0[2];
                        return v;
                    }
                    var r = param$0[3];
                    param$0 = r;
                }
            }
            function max_elt_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    if (!param$0[3]) {
                        var v = param$0[2];
                        return [
                            0,
                            v
                        ];
                    }
                    var r = param$0[3];
                    param$0 = r;
                }
            }
            function remove_min_elt(param) {
                if (!param) return caml_call1(Stdlib[1], cst_Set_remove_min_elt);
                var l = param[1];
                if (l) {
                    var r = param[3], v = param[2];
                    return bal(remove_min_elt(l), v, r);
                }
                var r$0 = param[3];
                return r$0;
            }
            function concat(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var _S_ = remove_min_elt(t2);
                return join(t1, min_elt(t2), _S_);
            }
            function split(x, param) {
                if (!param) return _a_;
                var r = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return [
                    0,
                    l,
                    1,
                    r
                ];
                if (0 <= c) {
                    var match = split(x, r), rr = match[3], pres = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, lr),
                        pres,
                        rr
                    ];
                }
                var match$0 = split(x, l), rl = match$0[3], pres$0 = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    pres$0,
                    join(rl, v, r)
                ];
            }
            var empty = 0;
            function is_empty(param) {
                return param ? 0 : 1;
            }
            function mem(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v), _R_ = 0 === c ? 1 : 0;
                    if (_R_) return _R_;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function remove(x, t) {
                if (!t) return 0;
                var t2 = t[3], v = t[2], t1 = t[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) {
                    if (!t1) return t2;
                    if (!t2) return t1;
                    var _Q_ = remove_min_elt(t2);
                    return bal(t1, min_elt(t2), _Q_);
                }
                if (0 <= c) {
                    var rr = remove(x, t2);
                    return t2 === rr ? t : bal(t1, v, rr);
                }
                var ll = remove(x, t1);
                return t1 === ll ? t : bal(ll, v, t2);
            }
            function union(s1, s2) {
                if (!s1) return s2;
                if (!s2) return s1;
                var h2 = s2[4], r2 = s2[3], v2 = s2[2], l2 = s2[1], h1 = s1[4], r1 = s1[3], v1 = s1[2], l1 = s1[1];
                if (h2 <= h1) {
                    if (1 === h2) return add(v2, s1);
                    var match = split(v1, s2), r2$0 = match[3], l2$0 = match[1], _O_ = union(r1, r2$0);
                    return join(union(l1, l2$0), v1, _O_);
                }
                if (1 === h1) return add(v1, s2);
                var match$0 = split(v2, s1), r1$0 = match$0[3], l1$0 = match$0[1], _P_ = union(r1$0, r2);
                return join(union(l1$0, l2), v2, _P_);
            }
            function inter(s1, s2) {
                if (!s1) return 0;
                if (!s2) return 0;
                var r1 = s1[3], v1 = s1[2], l1 = s1[1], _L_ = split(v1, s2), l2 = _L_[1];
                if (_L_[2]) {
                    var r2 = _L_[3], _M_ = inter(r1, r2);
                    return join(inter(l1, l2), v1, _M_);
                }
                var r2$0 = _L_[3], _N_ = inter(r1, r2$0);
                return concat(inter(l1, l2), _N_);
            }
            function split_bis(x, param) {
                if (!param) return [
                    0,
                    0,
                    function(param) {
                        return 0;
                    }
                ];
                var r = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return 0;
                if (0 <= c) {
                    var match = split_bis(x, r);
                    if (!match) return 0;
                    var rr = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, lr),
                        rr
                    ];
                }
                var match$0 = split_bis(x, l);
                if (!match$0) return 0;
                var rl = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    function(param) {
                        return join(rl(0), v, r);
                    }
                ];
            }
            function disjoint(s1, s2) {
                var s1$0 = s1, s2$0 = s2;
                for(;;){
                    if (s1$0 && s2$0) {
                        var r1 = s1$0[3], v1 = s1$0[2], l1 = s1$0[1];
                        if (s1$0 === s2$0) return 0;
                        var match = split_bis(v1, s2$0);
                        if (!match) return 0;
                        var r2 = match[2], l2 = match[1], _K_ = disjoint(l1, l2);
                        if (!_K_) return _K_;
                        var s2$1 = r2(0);
                        s1$0 = r1;
                        s2$0 = s2$1;
                        continue;
                    }
                    return 1;
                }
            }
            function diff(s1, s2) {
                if (!s1) return 0;
                if (!s2) return s1;
                var r1 = s1[3], v1 = s1[2], l1 = s1[1], _H_ = split(v1, s2), l2 = _H_[1];
                if (_H_[2]) {
                    var r2 = _H_[3], _I_ = diff(r1, r2);
                    return concat(diff(l1, l2), _I_);
                }
                var r2$0 = _H_[3], _J_ = diff(r1, r2$0);
                return join(diff(l1, l2), v1, _J_);
            }
            function cons_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        r,
                        e$0
                    ];
                    s$0 = l;
                    e$0 = e$1;
                }
            }
            function compare(s1, s2) {
                var e2$2 = cons_enum(s2, 0), e1$2 = cons_enum(s1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? -1 : 0;
                    if (!e2) return 1;
                    var e2$0 = e2[3], r2 = e2[2], v2 = e2[1], e1$0 = e1[3], r1 = e1[2], v1 = e1[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 !== c) return c;
                    var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                    e1 = e1$1;
                    e2 = e2$1;
                }
            }
            function equal(s1, s2) {
                return 0 === compare(s1, s2) ? 1 : 0;
            }
            function subset(s1, s2) {
                var s1$0 = s1, s2$0 = s2;
                for(;;){
                    if (!s1$0) return 1;
                    if (!s2$0) return 0;
                    var r2 = s2$0[3], v2 = s2$0[2], l2 = s2$0[1], r1 = s1$0[3], v1 = s1$0[2], l1 = s1$0[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 === c) {
                        var _E_ = subset(l1, l2);
                        if (!_E_) return _E_;
                        s1$0 = r1;
                        s2$0 = r2;
                    } else if (0 <= c) {
                        var _F_ = subset([
                            0,
                            0,
                            v1,
                            r1,
                            0
                        ], r2);
                        if (!_F_) return _F_;
                        s1$0 = l1;
                    } else {
                        var _G_ = subset([
                            0,
                            l1,
                            v1,
                            0,
                            0
                        ], l2);
                        if (!_G_) return _G_;
                        s1$0 = r1;
                    }
                }
            }
            function iter(f, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1];
                    iter(f, l);
                    caml_call1(f, v);
                    param$0 = r;
                }
            }
            function fold(f, s, accu) {
                var s$0 = s, accu$0 = accu;
                for(;;){
                    if (!s$0) return accu$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], accu$1 = caml_call2(f, v, fold(f, l, accu$0));
                    s$0 = r;
                    accu$0 = accu$1;
                }
            }
            function for_all(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 1;
                    var r = param$0[3], v = param$0[2], l = param$0[1], _B_ = caml_call1(p, v);
                    if (_B_) {
                        var _C_ = for_all(p, l);
                        if (_C_) {
                            param$0 = r;
                            continue;
                        }
                        var _D_ = _C_;
                    } else var _D_ = _B_;
                    return _D_;
                }
            }
            function exists(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], _y_ = caml_call1(p, v);
                    if (_y_) var _z_ = _y_;
                    else {
                        var _A_ = exists(p, l);
                        if (!_A_) {
                            param$0 = r;
                            continue;
                        }
                        var _z_ = _A_;
                    }
                    return _z_;
                }
            }
            function filter(p, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], l$0 = filter(p, l), pv = caml_call1(p, v), r$0 = filter(p, r);
                if (!pv) return concat(l$0, r$0);
                if (l === l$0 && r === r$0) return t;
                return join(l$0, v, r$0);
            }
            function partition(p, param) {
                if (!param) return _b_;
                var r = param[3], v = param[2], l = param[1], match = partition(p, l), lf = match[2], lt = match[1], pv = caml_call1(p, v), match$0 = partition(p, r), rf = match$0[2], rt = match$0[1];
                if (pv) {
                    var _w_ = concat(lf, rf);
                    return [
                        0,
                        join(lt, v, rt),
                        _w_
                    ];
                }
                var _x_ = join(lf, v, rf);
                return [
                    0,
                    concat(lt, rt),
                    _x_
                ];
            }
            function cardinal(param) {
                if (!param) return 0;
                var r = param[3], l = param[1], _v_ = cardinal(r);
                return (cardinal(l) + 1 | 0) + _v_ | 0;
            }
            function elements_aux(accu, param) {
                var accu$0 = accu, param$0 = param;
                for(;;){
                    if (!param$0) return accu$0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], accu$1 = [
                        0,
                        v,
                        elements_aux(accu$0, r)
                    ];
                    accu$0 = accu$1;
                    param$0 = l;
                }
            }
            function elements(s) {
                return elements_aux(0, s);
            }
            function find(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return v;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function find_first(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = l$0;
                        for(;;){
                            if (!param) return v0;
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_first_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0
                            ];
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_last(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = r$0;
                        for(;;){
                            if (!param) return v0;
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_last_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0
                            ];
                            var r = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_opt(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return [
                        0,
                        v
                    ];
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function try_join(l, v, r) {
                a: {
                    if (0 !== l) {
                        var _u_ = max_elt(l);
                        if (0 <= caml_call2(Ord[1], _u_, v)) break a;
                    }
                    if (0 !== r) {
                        var _t_ = min_elt(r);
                        if (0 <= caml_call2(Ord[1], v, _t_)) break a;
                    }
                    return join(l, v, r);
                }
                return union(l, add(v, r));
            }
            function map(f, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], l$0 = map(f, l), v$0 = caml_call1(f, v), r$0 = map(f, r);
                if (l === l$0 && v === v$0 && r === r$0) return t;
                return try_join(l$0, v$0, r$0);
            }
            function filter_map(f, t) {
                if (!t) return 0;
                var r = t[3], v = t[2], l = t[1], t1 = filter_map(f, l), v$0 = caml_call1(f, v), t2 = filter_map(f, r);
                if (v$0) {
                    var v$1 = v$0[1];
                    if (l === t1 && v === v$1 && r === t2) return t;
                    return try_join(t1, v$1, t2);
                }
                if (!t1) return t2;
                if (!t2) return t1;
                var _s_ = remove_min_elt(t2);
                return try_join(t1, min_elt(t2), _s_);
            }
            function of_list(l) {
                if (!l) return empty;
                var _n_ = l[2], x0 = l[1];
                if (!_n_) return singleton(x0);
                var _o_ = _n_[2], x1 = _n_[1];
                if (!_o_) return add(x1, singleton(x0));
                var _p_ = _o_[2], x2 = _o_[1];
                if (!_p_) return add(x2, add(x1, singleton(x0)));
                var _q_ = _p_[2], x3 = _p_[1];
                if (!_q_) return add(x3, add(x2, add(x1, singleton(x0))));
                if (_q_[2]) {
                    var l$0 = caml_call2(Stdlib_List[66], Ord[1], l), sub = function(n, l) {
                        if (3 >= n >>> 0) switch(n){
                            case 0:
                                return [
                                    0,
                                    0,
                                    l
                                ];
                            case 1:
                                if (l) {
                                    var l$3 = l[2], x0 = l[1];
                                    return [
                                        0,
                                        [
                                            0,
                                            0,
                                            x0,
                                            0,
                                            1
                                        ],
                                        l$3
                                    ];
                                }
                                break;
                            case 2:
                                if (l) {
                                    var match$1 = l[2];
                                    if (match$1) {
                                        var l$4 = match$1[2], x1 = match$1[1], x0$0 = l[1];
                                        return [
                                            0,
                                            [
                                                0,
                                                [
                                                    0,
                                                    0,
                                                    x0$0,
                                                    0,
                                                    1
                                                ],
                                                x1,
                                                0,
                                                2
                                            ],
                                            l$4
                                        ];
                                    }
                                }
                                break;
                            default:
                                if (l) {
                                    var _r_ = l[2];
                                    if (_r_) {
                                        var match$2 = _r_[2];
                                        if (match$2) {
                                            var l$5 = match$2[2], x2 = match$2[1], x1$0 = _r_[1], x0$1 = l[1];
                                            return [
                                                0,
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        0,
                                                        x0$1,
                                                        0,
                                                        1
                                                    ],
                                                    x1$0,
                                                    [
                                                        0,
                                                        0,
                                                        x2,
                                                        0,
                                                        1
                                                    ],
                                                    2
                                                ],
                                                l$5
                                            ];
                                        }
                                    }
                                }
                        }
                        var nl = n / 2 | 0, match = sub(nl, l), l$0 = match[2], left = match[1];
                        if (!l$0) throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _c_
                        ], 1);
                        var l$1 = l$0[2], mid = l$0[1], match$0 = sub((n - nl | 0) - 1 | 0, l$1), l$2 = match$0[2], right = match$0[1];
                        return [
                            0,
                            create(left, mid, right),
                            l$2
                        ];
                    };
                    return sub(caml_call1(Stdlib_List[1], l$0), l$0)[1];
                }
                var x4 = _q_[1];
                return add(x4, add(x3, add(x2, add(x1, singleton(x0)))));
            }
            function add_seq(i, m) {
                return caml_call3(Stdlib_Seq[5], function(s, x) {
                    return add(x, s);
                }, m, i);
            }
            function of_seq(i) {
                return add_seq(i, empty);
            }
            function seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[3], t = c[2], x = c[1], _l_ = cons_enum(t, rest);
                return [
                    0,
                    x,
                    function(_m_) {
                        return seq_of_enum(_l_, _m_);
                    }
                ];
            }
            function to_seq(c) {
                var _j_ = cons_enum(c, 0);
                return function(_k_) {
                    return seq_of_enum(_j_, _k_);
                };
            }
            function snoc_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        l,
                        e$0
                    ];
                    s$0 = r;
                    e$0 = e$1;
                }
            }
            function rev_seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[3], t = c[2], x = c[1], _h_ = snoc_enum(t, rest);
                return [
                    0,
                    x,
                    function(_i_) {
                        return rev_seq_of_enum(_h_, _i_);
                    }
                ];
            }
            function to_rev_seq(c) {
                var _f_ = snoc_enum(c, 0);
                return function(_g_) {
                    return rev_seq_of_enum(_f_, _g_);
                };
            }
            function to_seq_from(low, s) {
                a: {
                    b: {
                        var s$0 = s, c = 0;
                        for(;;){
                            if (!s$0) break;
                            var r = s$0[3], v = s$0[2], l = s$0[1], n = caml_call2(Ord[1], v, low);
                            if (0 === n) break b;
                            if (0 <= n) {
                                var c$0 = [
                                    0,
                                    v,
                                    r,
                                    c
                                ];
                                s$0 = l;
                                c = c$0;
                            } else s$0 = r;
                        }
                        var _d_ = c;
                        break a;
                    }
                    var _d_ = [
                        0,
                        v,
                        r,
                        c
                    ];
                }
                return function(_e_) {
                    return seq_of_enum(_d_, _e_);
                };
            }
            return [
                0,
                empty,
                add,
                singleton,
                remove,
                union,
                inter,
                disjoint,
                diff,
                cardinal,
                elements,
                min_elt,
                min_elt_opt,
                max_elt,
                max_elt_opt,
                min_elt,
                min_elt_opt,
                find,
                find_opt,
                find_first,
                find_first_opt,
                find_last,
                find_last_opt,
                iter,
                fold,
                map,
                filter,
                filter_map,
                partition,
                split,
                is_empty,
                mem,
                equal,
                compare,
                subset,
                for_all,
                exists,
                elements,
                of_list,
                to_seq_from,
                to_seq,
                to_rev_seq,
                add_seq,
                of_seq
            ];
        }
    ];
    runtime.caml_register_global(12, Stdlib_Set, "Stdlib__Set");
    return;
})(globalThis);
//# 9004 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Map_bal$3 = "Map.bal", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Assert_failure = global_data.Assert_failure, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, cst_Map_bal = cst_Map_bal$3, cst_Map_bal$0 = cst_Map_bal$3, cst_Map_bal$1 = cst_Map_bal$3, cst_Map_bal$2 = cst_Map_bal$3, cst_Map_remove_min_elt = "Map.remove_min_elt", _a_ = [
        0,
        0,
        0,
        0
    ], _b_ = [
        0,
        "map.ml",
        408,
        10
    ], _c_ = [
        0,
        0,
        0
    ], Stdlib_Map = [
        0,
        function(Ord) {
            function height(param) {
                if (!param) return 0;
                var h = param[5];
                return h;
            }
            function create(l, x, d, r) {
                var hl = height(l), hr = height(r), _K_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                return [
                    0,
                    l,
                    x,
                    d,
                    r,
                    _K_
                ];
            }
            function singleton(x, d) {
                return [
                    0,
                    0,
                    x,
                    d,
                    0,
                    1
                ];
            }
            function bal(l, x, d, r) {
                if (l) var h = l[5], hl = h;
                else var hl = 0;
                if (r) var h$0 = r[5], hr = h$0;
                else var hr = 0;
                if ((hr + 2 | 0) < hl) {
                    if (!l) return caml_call1(Stdlib[1], cst_Map_bal$0);
                    var lr = l[4], ld = l[3], lv = l[2], ll = l[1], _F_ = height(lr);
                    if (_F_ <= height(ll)) return create(ll, lv, ld, create(lr, x, d, r));
                    if (!lr) return caml_call1(Stdlib[1], cst_Map_bal);
                    var lrr = lr[4], lrd = lr[3], lrv = lr[2], lrl = lr[1], _G_ = create(lrr, x, d, r);
                    return create(create(ll, lv, ld, lrl), lrv, lrd, _G_);
                }
                if ((hl + 2 | 0) >= hr) {
                    var _J_ = hr <= hl ? hl + 1 | 0 : hr + 1 | 0;
                    return [
                        0,
                        l,
                        x,
                        d,
                        r,
                        _J_
                    ];
                }
                if (!r) return caml_call1(Stdlib[1], cst_Map_bal$2);
                var rr = r[4], rd = r[3], rv = r[2], rl = r[1], _H_ = height(rl);
                if (_H_ <= height(rr)) return create(create(l, x, d, rl), rv, rd, rr);
                if (!rl) return caml_call1(Stdlib[1], cst_Map_bal$1);
                var rlr = rl[4], rld = rl[3], rlv = rl[2], rll = rl[1], _I_ = create(rlr, rv, rd, rr);
                return create(create(l, x, d, rll), rlv, rld, _I_);
            }
            var empty = 0;
            function is_empty(param) {
                return param ? 0 : 1;
            }
            function add(x, data, m) {
                if (!m) return [
                    0,
                    0,
                    x,
                    data,
                    0,
                    1
                ];
                var h = m[5], r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return d === data ? m : [
                    0,
                    l,
                    x,
                    data,
                    r,
                    h
                ];
                if (0 <= c) {
                    var rr = add(x, data, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = add(x, data, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function find(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return d;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function find_first(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0,
                                d0
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_first_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = l$0;
                        for(;;){
                            if (!param) return [
                                0,
                                [
                                    0,
                                    v0,
                                    d0
                                ]
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = l;
                            } else param = r;
                        }
                    } else param$1 = r$0;
                }
            }
            function find_last(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                v0,
                                d0
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_last_opt(f, param$0) {
                var param$1 = param$0;
                for(;;){
                    if (!param$1) return 0;
                    var r$0 = param$1[4], d0$1 = param$1[3], v0$1 = param$1[2], l$0 = param$1[1];
                    if (caml_call1(f, v0$1)) {
                        var v0 = v0$1, d0 = d0$1, param = r$0;
                        for(;;){
                            if (!param) return [
                                0,
                                [
                                    0,
                                    v0,
                                    d0
                                ]
                            ];
                            var r = param[4], d0$0 = param[3], v0$0 = param[2], l = param[1];
                            if (caml_call1(f, v0$0)) {
                                v0 = v0$0;
                                d0 = d0$0;
                                param = r;
                            } else param = l;
                        }
                    } else param$1 = l$0;
                }
            }
            function find_opt(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v);
                    if (0 === c) return [
                        0,
                        d
                    ];
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function mem(x, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], v = param$0[2], l = param$0[1], c = caml_call2(Ord[1], x, v), _E_ = 0 === c ? 1 : 0;
                    if (_E_) return _E_;
                    var r$0 = 0 <= c ? r : l;
                    param$0 = r$0;
                }
            }
            function min_binding(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var l = param$0[1];
                    if (!l) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            v,
                            d
                        ];
                    }
                    param$0 = l;
                }
            }
            function min_binding_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var l = param$0[1];
                    if (!l) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            [
                                0,
                                v,
                                d
                            ]
                        ];
                    }
                    param$0 = l;
                }
            }
            function max_binding(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    if (!param$0[4]) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            v,
                            d
                        ];
                    }
                    var r = param$0[4];
                    param$0 = r;
                }
            }
            function max_binding_opt(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    if (!param$0[4]) {
                        var d = param$0[3], v = param$0[2];
                        return [
                            0,
                            [
                                0,
                                v,
                                d
                            ]
                        ];
                    }
                    var r = param$0[4];
                    param$0 = r;
                }
            }
            function remove_min_binding(param) {
                if (!param) return caml_call1(Stdlib[1], cst_Map_remove_min_elt);
                var l = param[1];
                if (l) {
                    var r = param[4], d = param[3], v = param[2];
                    return bal(remove_min_binding(l), v, d, r);
                }
                var r$0 = param[4];
                return r$0;
            }
            function _d_(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var match = min_binding(t2), d = match[2], x = match[1];
                return bal(t1, x, d, remove_min_binding(t2));
            }
            function remove(x, m) {
                if (!m) return 0;
                var r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return _d_(l, r);
                if (0 <= c) {
                    var rr = remove(x, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = remove(x, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function update(x, f, m) {
                if (!m) {
                    var match$0 = caml_call1(f, 0);
                    if (!match$0) return 0;
                    var data$0 = match$0[1];
                    return [
                        0,
                        0,
                        x,
                        data$0,
                        0,
                        1
                    ];
                }
                var h = m[5], r = m[4], d = m[3], v = m[2], l = m[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) {
                    var match = caml_call1(f, [
                        0,
                        d
                    ]);
                    if (!match) return _d_(l, r);
                    var data = match[1];
                    return d === data ? m : [
                        0,
                        l,
                        x,
                        data,
                        r,
                        h
                    ];
                }
                if (0 <= c) {
                    var rr = update(x, f, r);
                    return r === rr ? m : bal(l, v, d, rr);
                }
                var ll = update(x, f, l);
                return l === ll ? m : bal(ll, v, d, r);
            }
            function add_to_list(x, data, m) {
                function add(param) {
                    if (!param) return [
                        0,
                        [
                            0,
                            data,
                            0
                        ]
                    ];
                    var l = param[1];
                    return [
                        0,
                        [
                            0,
                            data,
                            l
                        ]
                    ];
                }
                return update(x, add, m);
            }
            function iter(f, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1];
                    iter(f, l);
                    caml_call2(f, v, d);
                    param$0 = r;
                }
            }
            function map(f, param) {
                if (!param) return 0;
                var h = param[5], r = param[4], d = param[3], v = param[2], l = param[1], l$0 = map(f, l), d$0 = caml_call1(f, d), r$0 = map(f, r);
                return [
                    0,
                    l$0,
                    v,
                    d$0,
                    r$0,
                    h
                ];
            }
            function mapi(f, param) {
                if (!param) return 0;
                var h = param[5], r = param[4], d = param[3], v = param[2], l = param[1], l$0 = mapi(f, l), d$0 = caml_call2(f, v, d), r$0 = mapi(f, r);
                return [
                    0,
                    l$0,
                    v,
                    d$0,
                    r$0,
                    h
                ];
            }
            function fold(f, m, accu) {
                var m$0 = m, accu$0 = accu;
                for(;;){
                    if (!m$0) return accu$0;
                    var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], accu$1 = caml_call3(f, v, d, fold(f, l, accu$0));
                    m$0 = r;
                    accu$0 = accu$1;
                }
            }
            function for_all(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 1;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], _B_ = caml_call2(p, v, d);
                    if (_B_) {
                        var _C_ = for_all(p, l);
                        if (_C_) {
                            param$0 = r;
                            continue;
                        }
                        var _D_ = _C_;
                    } else var _D_ = _B_;
                    return _D_;
                }
            }
            function exists(p, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], _y_ = caml_call2(p, v, d);
                    if (_y_) var _z_ = _y_;
                    else {
                        var _A_ = exists(p, l);
                        if (!_A_) {
                            param$0 = r;
                            continue;
                        }
                        var _z_ = _A_;
                    }
                    return _z_;
                }
            }
            function add_min_binding(k, x, param) {
                if (!param) return singleton(k, x);
                var r = param[4], d = param[3], v = param[2], l = param[1];
                return bal(add_min_binding(k, x, l), v, d, r);
            }
            function add_max_binding(k, x, param) {
                if (!param) return singleton(k, x);
                var r = param[4], d = param[3], v = param[2], l = param[1];
                return bal(l, v, d, add_max_binding(k, x, r));
            }
            function join(l, v, d, r) {
                if (!l) return add_min_binding(v, d, r);
                if (!r) return add_max_binding(v, d, l);
                var rh = r[5], rr = r[4], rd = r[3], rv = r[2], rl = r[1], lh = l[5], lr = l[4], ld = l[3], lv = l[2], ll = l[1];
                return (rh + 2 | 0) < lh ? bal(ll, lv, ld, join(lr, v, d, r)) : (lh + 2 | 0) < rh ? bal(join(l, v, d, rl), rv, rd, rr) : create(l, v, d, r);
            }
            function concat(t1, t2) {
                if (!t1) return t2;
                if (!t2) return t1;
                var match = min_binding(t2), d = match[2], x = match[1];
                return join(t1, x, d, remove_min_binding(t2));
            }
            function concat_or_join(t1, v, d, t2) {
                if (!d) return concat(t1, t2);
                var d$0 = d[1];
                return join(t1, v, d$0, t2);
            }
            function split(x, param) {
                if (!param) return _a_;
                var r = param[4], d = param[3], v = param[2], l = param[1], c = caml_call2(Ord[1], x, v);
                if (0 === c) return [
                    0,
                    l,
                    [
                        0,
                        d
                    ],
                    r
                ];
                if (0 <= c) {
                    var match = split(x, r), rr = match[3], pres = match[2], lr = match[1];
                    return [
                        0,
                        join(l, v, d, lr),
                        pres,
                        rr
                    ];
                }
                var match$0 = split(x, l), rl = match$0[3], pres$0 = match$0[2], ll = match$0[1];
                return [
                    0,
                    ll,
                    pres$0,
                    join(rl, v, d, r)
                ];
            }
            function merge(f, s1, s2) {
                if (s1) {
                    var h1 = s1[5], r1 = s1[4], d1 = s1[3], v1 = s1[2], l1 = s1[1];
                    if (height(s2) <= h1) {
                        var match = split(v1, s2), r2 = match[3], d2 = match[2], l2 = match[1], _u_ = merge(f, r1, r2), _v_ = caml_call3(f, v1, [
                            0,
                            d1
                        ], d2);
                        return concat_or_join(merge(f, l1, l2), v1, _v_, _u_);
                    }
                } else if (!s2) return 0;
                if (!s2) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _b_
                ], 1);
                var r2$0 = s2[4], d2$0 = s2[3], v2 = s2[2], l2$0 = s2[1], match$0 = split(v2, s1), r1$0 = match$0[3], d1$0 = match$0[2], l1$0 = match$0[1], _w_ = merge(f, r1$0, r2$0), _x_ = caml_call3(f, v2, d1$0, [
                    0,
                    d2$0
                ]);
                return concat_or_join(merge(f, l1$0, l2$0), v2, _x_, _w_);
            }
            function union(f, s1, s2) {
                if (s1) {
                    if (s2) {
                        var h2 = s2[5], r2 = s2[4], d2 = s2[3], v2 = s2[2], l2 = s2[1], h1 = s1[5], r1 = s1[4], d1 = s1[3], v1 = s1[2], l1 = s1[1];
                        if (h2 <= h1) {
                            var match = split(v1, s2), r2$0 = match[3], d2$0 = match[2], l2$0 = match[1], l = union(f, l1, l2$0), r = union(f, r1, r2$0);
                            if (!d2$0) return join(l, v1, d1, r);
                            var d2$1 = d2$0[1];
                            return concat_or_join(l, v1, caml_call3(f, v1, d1, d2$1), r);
                        }
                        var match$0 = split(v2, s1), r1$0 = match$0[3], d1$0 = match$0[2], l1$0 = match$0[1], l$0 = union(f, l1$0, l2), r$0 = union(f, r1$0, r2);
                        if (!d1$0) return join(l$0, v2, d2, r$0);
                        var d1$1 = d1$0[1];
                        return concat_or_join(l$0, v2, caml_call3(f, v2, d1$1, d2), r$0);
                    }
                    var s = s1;
                } else var s = s2;
                return s;
            }
            function filter(p, m) {
                if (!m) return 0;
                var r = m[4], d = m[3], v = m[2], l = m[1], l$0 = filter(p, l), pvd = caml_call2(p, v, d), r$0 = filter(p, r);
                if (!pvd) return concat(l$0, r$0);
                if (l === l$0 && r === r$0) return m;
                return join(l$0, v, d, r$0);
            }
            function filter_map(f, param) {
                if (!param) return 0;
                var r = param[4], d = param[3], v = param[2], l = param[1], l$0 = filter_map(f, l), fvd = caml_call2(f, v, d), r$0 = filter_map(f, r);
                if (!fvd) return concat(l$0, r$0);
                var d$0 = fvd[1];
                return join(l$0, v, d$0, r$0);
            }
            function partition(p, param) {
                if (!param) return _c_;
                var r = param[4], d = param[3], v = param[2], l = param[1], match = partition(p, l), lf = match[2], lt = match[1], pvd = caml_call2(p, v, d), match$0 = partition(p, r), rf = match$0[2], rt = match$0[1];
                if (pvd) {
                    var _s_ = concat(lf, rf);
                    return [
                        0,
                        join(lt, v, d, rt),
                        _s_
                    ];
                }
                var _t_ = join(lf, v, d, rf);
                return [
                    0,
                    concat(lt, rt),
                    _t_
                ];
            }
            function cons_enum(m, e) {
                var m$0 = m, e$0 = e;
                for(;;){
                    if (!m$0) return e$0;
                    var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], e$1 = [
                        0,
                        v,
                        d,
                        r,
                        e$0
                    ];
                    m$0 = l;
                    e$0 = e$1;
                }
            }
            function compare(cmp, m1, m2) {
                var e2$2 = cons_enum(m2, 0), e1$2 = cons_enum(m1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? -1 : 0;
                    if (!e2) return 1;
                    var e2$0 = e2[4], r2 = e2[3], d2 = e2[2], v2 = e2[1], e1$0 = e1[4], r1 = e1[3], d1 = e1[2], v1 = e1[1], c = caml_call2(Ord[1], v1, v2);
                    if (0 !== c) return c;
                    var c$0 = caml_call2(cmp, d1, d2);
                    if (0 !== c$0) return c$0;
                    var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                    e1 = e1$1;
                    e2 = e2$1;
                }
            }
            function equal(cmp, m1, m2) {
                var e2$2 = cons_enum(m2, 0), e1$2 = cons_enum(m1, 0), e1 = e1$2, e2 = e2$2;
                for(;;){
                    if (!e1) return e2 ? 0 : 1;
                    if (!e2) return 0;
                    var e2$0 = e2[4], r2 = e2[3], d2 = e2[2], v2 = e2[1], e1$0 = e1[4], r1 = e1[3], d1 = e1[2], v1 = e1[1], _p_ = 0 === caml_call2(Ord[1], v1, v2) ? 1 : 0;
                    if (_p_) {
                        var _q_ = caml_call2(cmp, d1, d2);
                        if (_q_) {
                            var e2$1 = cons_enum(r2, e2$0), e1$1 = cons_enum(r1, e1$0);
                            e1 = e1$1;
                            e2 = e2$1;
                            continue;
                        }
                        var _r_ = _q_;
                    } else var _r_ = _p_;
                    return _r_;
                }
            }
            function cardinal(param) {
                if (!param) return 0;
                var r = param[4], l = param[1], _o_ = cardinal(r);
                return (cardinal(l) + 1 | 0) + _o_ | 0;
            }
            function bindings_aux(accu, param) {
                var accu$0 = accu, param$0 = param;
                for(;;){
                    if (!param$0) return accu$0;
                    var r = param$0[4], d = param$0[3], v = param$0[2], l = param$0[1], accu$1 = [
                        0,
                        [
                            0,
                            v,
                            d
                        ],
                        bindings_aux(accu$0, r)
                    ];
                    accu$0 = accu$1;
                    param$0 = l;
                }
            }
            function bindings(s) {
                return bindings_aux(0, s);
            }
            function of_list(bs) {
                return caml_call3(Stdlib_List[26], function(m, param) {
                    var v = param[2], k = param[1];
                    return add(k, v, m);
                }, empty, bs);
            }
            function add_seq(i, m) {
                return caml_call3(Stdlib_Seq[5], function(m, param) {
                    var v = param[2], k = param[1];
                    return add(k, v, m);
                }, m, i);
            }
            function of_seq(i) {
                return add_seq(i, empty);
            }
            function seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[4], t = c[3], v = c[2], k = c[1], _m_ = cons_enum(t, rest);
                return [
                    0,
                    [
                        0,
                        k,
                        v
                    ],
                    function(_n_) {
                        return seq_of_enum(_m_, _n_);
                    }
                ];
            }
            function to_seq(m) {
                var _k_ = cons_enum(m, 0);
                return function(_l_) {
                    return seq_of_enum(_k_, _l_);
                };
            }
            function snoc_enum(s, e) {
                var s$0 = s, e$0 = e;
                for(;;){
                    if (!s$0) return e$0;
                    var r = s$0[4], d = s$0[3], v = s$0[2], l = s$0[1], e$1 = [
                        0,
                        v,
                        d,
                        l,
                        e$0
                    ];
                    s$0 = r;
                    e$0 = e$1;
                }
            }
            function rev_seq_of_enum(c, param) {
                if (!c) return 0;
                var rest = c[4], t = c[3], v = c[2], k = c[1], _i_ = snoc_enum(t, rest);
                return [
                    0,
                    [
                        0,
                        k,
                        v
                    ],
                    function(_j_) {
                        return rev_seq_of_enum(_i_, _j_);
                    }
                ];
            }
            function to_rev_seq(c) {
                var _g_ = snoc_enum(c, 0);
                return function(_h_) {
                    return rev_seq_of_enum(_g_, _h_);
                };
            }
            function to_seq_from(low, m) {
                a: {
                    b: {
                        var m$0 = m, c = 0;
                        for(;;){
                            if (!m$0) break;
                            var r = m$0[4], d = m$0[3], v = m$0[2], l = m$0[1], n = caml_call2(Ord[1], v, low);
                            if (0 === n) break b;
                            if (0 <= n) {
                                var c$0 = [
                                    0,
                                    v,
                                    d,
                                    r,
                                    c
                                ];
                                m$0 = l;
                                c = c$0;
                            } else m$0 = r;
                        }
                        var _e_ = c;
                        break a;
                    }
                    var _e_ = [
                        0,
                        v,
                        d,
                        r,
                        c
                    ];
                }
                return function(_f_) {
                    return seq_of_enum(_e_, _f_);
                };
            }
            return [
                0,
                empty,
                add,
                add_to_list,
                update,
                singleton,
                remove,
                merge,
                union,
                cardinal,
                bindings,
                min_binding,
                min_binding_opt,
                max_binding,
                max_binding_opt,
                min_binding,
                min_binding_opt,
                find,
                find_opt,
                find_first,
                find_first_opt,
                find_last,
                find_last_opt,
                iter,
                fold,
                map,
                mapi,
                filter,
                filter_map,
                partition,
                split,
                is_empty,
                mem,
                equal,
                compare,
                for_all,
                exists,
                bindings,
                of_list,
                to_seq,
                to_rev_seq,
                to_seq_from,
                add_seq,
                of_seq
            ];
        }
    ];
    runtime.caml_register_global(12, Stdlib_Map, "Stdlib__Map");
    return;
})(globalThis);
//# 9892 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_List = global_data.Stdlib__List, Empty = [
        248,
        "Stdlib.Stack.Empty",
        runtime.caml_fresh_oo_id(0)
    ];
    function create(param) {
        return [
            0,
            0,
            0
        ];
    }
    function clear(s) {
        s[1] = 0;
        s[2] = 0;
        return 0;
    }
    function copy(s) {
        return [
            0,
            s[1],
            s[2]
        ];
    }
    function push(x, s) {
        s[1] = [
            0,
            x,
            s[1]
        ];
        s[2] = s[2] + 1 | 0;
        return 0;
    }
    function pop(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var tl = match[2], hd = match[1];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return hd;
    }
    function pop_opt(s) {
        var match = s[1];
        if (!match) return 0;
        var tl = match[2], hd = match[1];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return [
            0,
            hd
        ];
    }
    function drop(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var tl = match[2];
        s[1] = tl;
        s[2] = s[2] - 1 | 0;
        return 0;
    }
    function top(s) {
        var match = s[1];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var hd = match[1];
        return hd;
    }
    function top_opt(s) {
        var match = s[1];
        if (!match) return 0;
        var hd = match[1];
        return [
            0,
            hd
        ];
    }
    function is_empty(s) {
        return 0 === s[1] ? 1 : 0;
    }
    function length(s) {
        return s[2];
    }
    function iter(f, s) {
        return caml_call2(Stdlib_List[18], f, s[1]);
    }
    function fold(f, acc, s) {
        return caml_call3(Stdlib_List[26], f, acc, s[1]);
    }
    function to_seq(s) {
        return caml_call1(Stdlib_List[68], s[1]);
    }
    function add_seq(q, i) {
        return caml_call2(Stdlib_Seq[4], function(x) {
            return push(x, q);
        }, i);
    }
    function of_seq(g) {
        var s = create(0);
        add_seq(s, g);
        return s;
    }
    var Stdlib_Stack = [
        0,
        Empty,
        create,
        push,
        pop,
        pop_opt,
        drop,
        top,
        top_opt,
        clear,
        copy,
        is_empty,
        length,
        iter,
        fold,
        to_seq,
        add_seq,
        of_seq
    ];
    runtime.caml_register_global(3, Stdlib_Stack, "Stdlib__Stack");
    return;
})(globalThis);
//# 9994 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Seq = global_data.Stdlib__Seq, Empty = [
        248,
        "Stdlib.Queue.Empty",
        runtime.caml_fresh_oo_id(0)
    ];
    function create(param) {
        return [
            0,
            0,
            0,
            0
        ];
    }
    function clear(q) {
        q[1] = 0;
        q[2] = 0;
        q[3] = 0;
        return 0;
    }
    function add(x, q) {
        var cell = [
            0,
            x,
            0
        ], match = q[3];
        return match ? (q[1] = q[1] + 1 | 0, match[2] = cell, q[3] = cell, 0) : (q[1] = 1, q[2] = cell, q[3] = cell, 0);
    }
    function peek(q) {
        var match = q[2];
        if (!match) throw caml_maybe_attach_backtrace(Empty, 1);
        var content = match[1];
        return content;
    }
    function peek_opt(q) {
        var match = q[2];
        if (!match) return 0;
        var content = match[1];
        return [
            0,
            content
        ];
    }
    function take(q) {
        var _g_ = q[2];
        if (!_g_) throw caml_maybe_attach_backtrace(Empty, 1);
        var content = _g_[1];
        if (_g_[2]) {
            var next = _g_[2];
            q[1] = q[1] - 1 | 0;
            q[2] = next;
            return content;
        }
        clear(q);
        return content;
    }
    function take_opt(q) {
        var _f_ = q[2];
        if (!_f_) return 0;
        var content = _f_[1];
        if (_f_[2]) {
            var next = _f_[2];
            q[1] = q[1] - 1 | 0;
            q[2] = next;
            return [
                0,
                content
            ];
        }
        clear(q);
        return [
            0,
            content
        ];
    }
    function drop(q) {
        var _e_ = q[2];
        if (!_e_) throw caml_maybe_attach_backtrace(Empty, 1);
        if (!_e_[2]) return clear(q);
        var next = _e_[2];
        q[1] = q[1] - 1 | 0;
        q[2] = next;
        return 0;
    }
    function copy(q) {
        var cell$0 = q[2], q_res = [
            0,
            q[1],
            0,
            0
        ], prev = 0, cell = cell$0;
        for(;;){
            if (!cell) {
                q_res[3] = prev;
                return q_res;
            }
            var content = cell[1], next = cell[2], prev$0 = [
                0,
                content,
                0
            ];
            if (prev) prev[2] = prev$0;
            else q_res[2] = prev$0;
            prev = prev$0;
            cell = next;
        }
    }
    function is_empty(q) {
        return 0 === q[1] ? 1 : 0;
    }
    function length(q) {
        return q[1];
    }
    function iter(f, q) {
        var cell$0 = q[2], cell = cell$0;
        for(;;){
            if (!cell) return 0;
            var content = cell[1], next = cell[2];
            caml_call1(f, content);
            cell = next;
        }
    }
    function fold(f, accu$1, q) {
        var cell$0 = q[2], accu = accu$1, cell = cell$0;
        for(;;){
            if (!cell) return accu;
            var content = cell[1], next = cell[2], accu$0 = caml_call2(f, accu, content);
            accu = accu$0;
            cell = next;
        }
    }
    function transfer(q1, q2) {
        var _d_ = 0 < q1[1] ? 1 : 0;
        if (!_d_) return _d_;
        var match = q2[3];
        return match ? (q2[1] = q2[1] + q1[1] | 0, match[2] = q1[2], q2[3] = q1[3], clear(q1)) : (q2[1] = q1[1], q2[2] = q1[2], q2[3] = q1[3], clear(q1));
    }
    function to_seq(q) {
        function aux(c, param) {
            if (!c) return 0;
            var x = c[1], next = c[2];
            return [
                0,
                x,
                function(_c_) {
                    return aux(next, _c_);
                }
            ];
        }
        var _a_ = q[2];
        return function(_b_) {
            return aux(_a_, _b_);
        };
    }
    function add_seq(q, i) {
        return caml_call2(Stdlib_Seq[4], function(x) {
            return add(x, q);
        }, i);
    }
    function of_seq(g) {
        var q = create(0);
        add_seq(q, g);
        return q;
    }
    var Stdlib_Queue = [
        0,
        Empty,
        create,
        add,
        add,
        take,
        take_opt,
        take,
        peek,
        peek_opt,
        peek,
        drop,
        clear,
        copy,
        is_empty,
        length,
        iter,
        fold,
        transfer,
        to_seq,
        add_seq,
        of_seq
    ];
    runtime.caml_register_global(2, Stdlib_Queue, "Stdlib__Queue");
    return;
})(globalThis);
//# 10159 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bswap16 = runtime.caml_bswap16, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_set16 = runtime.caml_bytes_set16, caml_bytes_set32 = runtime.caml_bytes_set32, caml_bytes_set64 = runtime.caml_bytes_set64, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_int32_bswap = runtime.caml_int32_bswap, caml_int64_bswap = runtime.caml_int64_bswap, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, Stdlib_String = global_data.Stdlib__String, Assert_failure = global_data.Assert_failure, cst_Buffer_sub = "Buffer.sub", cst_Buffer_blit = "Buffer.blit", cst_Buffer_nth = "Buffer.nth", cst_Buffer_add_cannot_grow_buf = "Buffer.add: cannot grow buffer", dummy = 0;
    function create(n) {
        var n$0 = 1 <= n ? n : 1, n$1 = Stdlib_Sys[12] < n$0 ? Stdlib_Sys[12] : n$0, s = caml_create_bytes(n$1);
        return [
            0,
            [
                0,
                s,
                n$1
            ],
            0,
            s
        ];
    }
    function contents(b) {
        return caml_call3(Stdlib_Bytes[8], b[1][1], 0, b[2]);
    }
    function to_bytes(b) {
        return caml_call3(Stdlib_Bytes[7], b[1][1], 0, b[2]);
    }
    function sub(b, ofs, len) {
        if (0 <= ofs && 0 <= len && (b[2] - len | 0) >= ofs) return caml_call3(Stdlib_Bytes[8], b[1][1], ofs, len);
        return caml_call1(Stdlib[1], cst_Buffer_sub);
    }
    function blit(src, srcoff, dst, dstoff, len) {
        if (0 <= len && 0 <= srcoff && (src[2] - len | 0) >= srcoff && 0 <= dstoff && (caml_ml_bytes_length(dst) - len | 0) >= dstoff) return caml_call5(Stdlib_Bytes[11], src[1][1], srcoff, dst, dstoff, len);
        return caml_call1(Stdlib[1], cst_Buffer_blit);
    }
    function nth(b, ofs) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1];
        if (0 <= ofs && position > ofs && length >= position) return runtime.caml_bytes_unsafe_get(buffer, ofs);
        return caml_call1(Stdlib[1], cst_Buffer_nth);
    }
    function length(b) {
        return b[2];
    }
    function clear(b) {
        b[2] = 0;
        return 0;
    }
    function reset(b) {
        b[2] = 0;
        var inner = [
            0,
            b[3],
            caml_ml_bytes_length(b[3])
        ];
        b[1] = inner;
        return 0;
    }
    function resize(b, more) {
        var old_pos = b[2], old_len = b[1][2], new_len = [
            0,
            old_len
        ];
        for(;;){
            if (new_len[1] >= (old_pos + more | 0)) break;
            new_len[1] = 2 * new_len[1] | 0;
        }
        if (Stdlib_Sys[12] < new_len[1]) {
            if ((old_pos + more | 0) <= Stdlib_Sys[12]) new_len[1] = Stdlib_Sys[12];
            else caml_call1(Stdlib[2], cst_Buffer_add_cannot_grow_buf);
        }
        var new_buffer = caml_create_bytes(new_len[1]);
        caml_call5(Stdlib_Bytes[11], b[1][1], 0, new_buffer, 0, b[2]);
        b[1] = [
            0,
            new_buffer,
            new_len[1]
        ];
    }
    function add_char(b, c) {
        var pos = b[2], match = b[1], length = match[2], buffer = match[1];
        if (length <= pos) {
            resize(b, 1);
            caml_bytes_set(b[1][1], b[2], c);
        } else caml_bytes_unsafe_set(buffer, pos, c);
        b[2] = pos + 1 | 0;
        return 0;
    }
    var uchar_utf_8_byte_length_max = 4, uchar_utf_16_byte_length_max = 4, cst_Buffer_add_substring = "Buffer.add_substring", cst_Buffer_add_subbytes = "Buffer.add_subbytes", cst_Buffer_add_channel = "Buffer.add_channel", _a_ = [
        0,
        "buffer.ml",
        222,
        9
    ], cst_Buffer_truncate = "Buffer.truncate";
    function add_utf_8_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_8_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[51], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_8_byte_length_max);
        }
    }
    function add_utf_16be_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_16_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[54], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_16_byte_length_max);
        }
    }
    function add_utf_16le_uchar(b, u) {
        for(;;){
            var pos = b[2];
            if (b[1][2] <= pos) resize(b, uchar_utf_16_byte_length_max);
            var n = caml_call3(Stdlib_Bytes[57], b[1][1], pos, u);
            if (0 !== n) {
                b[2] = pos + n | 0;
                return 0;
            }
            resize(b, uchar_utf_16_byte_length_max);
        }
    }
    function add_substring(b, s, offset, len) {
        var _v_ = offset < 0 ? 1 : 0;
        if (_v_) var _w_ = _v_;
        else var _x_ = len < 0 ? 1 : 0, _w_ = _x_ || ((caml_ml_string_length(s) - len | 0) < offset ? 1 : 0);
        if (_w_) caml_call1(Stdlib[1], cst_Buffer_add_substring);
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + len | 0;
        if (length < new_position) {
            resize(b, len);
            caml_call5(Stdlib_Bytes[12], s, offset, b[1][1], b[2], len);
        } else runtime.caml_blit_string(s, offset, buffer, position, len);
        b[2] = new_position;
        return 0;
    }
    function add_subbytes(b, bytes, offset, len) {
        var _s_ = offset < 0 ? 1 : 0;
        if (_s_) var _t_ = _s_;
        else var _u_ = len < 0 ? 1 : 0, _t_ = _u_ || ((caml_ml_bytes_length(bytes) - len | 0) < offset ? 1 : 0);
        if (_t_) caml_call1(Stdlib[1], cst_Buffer_add_subbytes);
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + len | 0;
        if (length < new_position) {
            resize(b, len);
            caml_call5(Stdlib_Bytes[11], bytes, offset, b[1][1], b[2], len);
        } else runtime.caml_blit_bytes(bytes, offset, buffer, position, len);
        b[2] = new_position;
        return 0;
    }
    function add_string(b, s) {
        return add_substring(b, s, 0, caml_ml_string_length(s));
    }
    function add_bytes(b, bytes) {
        return add_subbytes(b, bytes, 0, caml_ml_bytes_length(bytes));
    }
    function add_buffer(b, bs) {
        return add_subbytes(b, bs[1][1], 0, bs[2]);
    }
    function add_channel(b, ic, to_read$1) {
        var _q_ = to_read$1 < 0 ? 1 : 0, _r_ = _q_ || (Stdlib_Sys[12] < to_read$1 ? 1 : 0);
        if (_r_) caml_call1(Stdlib[1], cst_Buffer_add_channel);
        if (b[1][2] < (b[2] + to_read$1 | 0)) resize(b, to_read$1);
        var ofs$1 = b[2], buf = b[1][1], already_read = 0, ofs = ofs$1, to_read = to_read$1;
        for(;;){
            if (0 !== to_read) {
                var r = caml_call4(Stdlib[84], ic, buf, ofs, to_read);
                if (0 !== r) {
                    var already_read$0 = already_read + r | 0, ofs$0 = ofs + r | 0, to_read$0 = to_read - r | 0;
                    already_read = already_read$0;
                    ofs = ofs$0;
                    to_read = to_read$0;
                    continue;
                }
            }
            b[2] = b[2] + already_read | 0;
            if (already_read < to_read$1) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            return 0;
        }
    }
    function output_buffer(oc, b) {
        return caml_call4(Stdlib[68], oc, b[1][1], 0, b[2]);
    }
    function add_substitute(b, f, s) {
        var lim$1 = caml_ml_string_length(s), previous = 32, i$4 = 0;
        for(;;){
            if (i$4 >= lim$1) {
                var _o_ = 92 === previous ? 1 : 0;
                return _o_ ? add_char(b, previous) : _o_;
            }
            var previous$0 = caml_string_get(s, i$4);
            if (36 === previous$0) {
                if (92 === previous) {
                    add_char(b, previous$0);
                    var i$5 = i$4 + 1 | 0;
                    previous = 32;
                    i$4 = i$5;
                } else {
                    var start = i$4 + 1 | 0;
                    try {
                        if (lim$1 <= start) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                        var opening = caml_string_get(s, start);
                        a: {
                            if (40 !== opening && 123 !== opening) {
                                var lim$0 = caml_ml_string_length(s);
                                b: {
                                    c: {
                                        d: {
                                            var i$2 = start;
                                            for(;;){
                                                if (lim$0 <= i$2) break c;
                                                var match = caml_string_get(s, i$2);
                                                if (91 <= match) {
                                                    if (97 <= match) {
                                                        if (123 <= match) break d;
                                                    } else if (95 !== match) break d;
                                                } else if (58 <= match) {
                                                    if (65 > match) break;
                                                } else if (48 > match) break d;
                                                var i$3 = i$2 + 1 | 0;
                                                i$2 = i$3;
                                            }
                                        }
                                        var stop$0 = i$2;
                                        break b;
                                    }
                                    var stop$0 = lim$0;
                                }
                                if (stop$0 === start) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                var val = [
                                    0,
                                    caml_call3(Stdlib_String[16], s, start, stop$0 - start | 0),
                                    stop$0
                                ];
                                break a;
                            }
                            var new_start = start + 1 | 0, k$2 = 0;
                            if (40 === opening) var closing = 41;
                            else {
                                if (123 !== opening) throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _a_
                                ], 1);
                                var closing = 125;
                            }
                            var lim = caml_ml_string_length(s), k = k$2, stop = new_start;
                            for(;;){
                                if (lim <= stop) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                if (caml_string_get(s, stop) === opening) {
                                    var i = stop + 1 | 0, k$0 = k + 1 | 0;
                                    k = k$0;
                                    stop = i;
                                } else if (caml_string_get(s, stop) === closing) {
                                    if (0 === k) break;
                                    var i$0 = stop + 1 | 0, k$1 = k - 1 | 0;
                                    k = k$1;
                                    stop = i$0;
                                } else {
                                    var i$1 = stop + 1 | 0;
                                    stop = i$1;
                                }
                            }
                            var val = [
                                0,
                                caml_call3(Stdlib_String[16], s, new_start, (stop - start | 0) - 1 | 0),
                                stop + 1 | 0
                            ];
                        }
                    } catch (_p_) {
                        var _n_ = caml_wrap_exception(_p_);
                        if (_n_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_n_, 0);
                        add_char(b, 36);
                        previous = 32;
                        i$4 = start;
                        continue;
                    }
                    var next_i = val[2], ident = val[1];
                    add_string(b, caml_call1(f, ident));
                    previous = 32;
                    i$4 = next_i;
                }
            } else {
                if (92 === previous) add_char(b, previous);
                if (92 !== previous$0) add_char(b, previous$0);
                var i$6 = i$4 + 1 | 0;
                previous = previous$0;
                i$4 = i$6;
            }
        }
    }
    function truncate(b, len) {
        if (0 <= len && b[2] >= len) {
            b[2] = len;
            return 0;
        }
        return caml_call1(Stdlib[1], cst_Buffer_truncate);
    }
    function to_seq(b) {
        function aux(i, param) {
            if (b[2] <= i) return 0;
            var x = caml_bytes_get(b[1][1], i), _l_ = i + 1 | 0;
            return [
                0,
                x,
                function(_m_) {
                    return aux(_l_, _m_);
                }
            ];
        }
        var _j_ = 0;
        return function(_k_) {
            return aux(_j_, _k_);
        };
    }
    function to_seqi(b) {
        function aux(i, param) {
            if (b[2] <= i) return 0;
            var x = caml_bytes_get(b[1][1], i), _h_ = i + 1 | 0;
            return [
                0,
                [
                    0,
                    i,
                    x
                ],
                function(_i_) {
                    return aux(_h_, _i_);
                }
            ];
        }
        var _f_ = 0;
        return function(_g_) {
            return aux(_f_, _g_);
        };
    }
    function add_seq(b, seq) {
        return caml_call2(Stdlib_Seq[4], function(_e_) {
            return add_char(b, _e_);
        }, seq);
    }
    function of_seq(i) {
        var b = create(32);
        add_seq(b, i);
        return b;
    }
    function add_int8(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 1 | 0;
        if (length < new_position) {
            resize(b, 1);
            caml_bytes_set(b[1][1], b[2], x);
        } else caml_bytes_unsafe_set(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int16_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 2 | 0;
        if (length < new_position) {
            resize(b, 2);
            caml_bytes_set16(b[1][1], b[2], x);
        } else caml_bytes_set16(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int32_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 4 | 0;
        if (length < new_position) {
            resize(b, 4);
            caml_bytes_set32(b[1][1], b[2], x);
        } else caml_bytes_set32(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int64_ne(b, x) {
        var position = b[2], match = b[1], length = match[2], buffer = match[1], new_position = position + 8 | 0;
        if (length < new_position) {
            resize(b, 8);
            caml_bytes_set64(b[1][1], b[2], x);
        } else caml_bytes_set64(buffer, position, x);
        b[2] = new_position;
        return 0;
    }
    function add_int16_le(b, x) {
        var _d_ = Stdlib_Sys[11] ? caml_bswap16(x) : x;
        return add_int16_ne(b, _d_);
    }
    function add_int16_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_bswap16(x);
        return add_int16_ne(b, x$0);
    }
    function add_int32_le(b, x) {
        var _c_ = Stdlib_Sys[11] ? caml_int32_bswap(x) : x;
        return add_int32_ne(b, _c_);
    }
    function add_int32_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_int32_bswap(x);
        return add_int32_ne(b, x$0);
    }
    function add_int64_le(b, x) {
        var _b_ = Stdlib_Sys[11] ? caml_int64_bswap(x) : x;
        return add_int64_ne(b, _b_);
    }
    function add_int64_be(b, x) {
        var x$0 = Stdlib_Sys[11] ? x : caml_int64_bswap(x);
        return add_int64_ne(b, x$0);
    }
    var Stdlib_Buffer = [
        0,
        create,
        contents,
        to_bytes,
        sub,
        blit,
        nth,
        length,
        clear,
        reset,
        output_buffer,
        truncate,
        add_char,
        add_utf_8_uchar,
        add_utf_16le_uchar,
        add_utf_16be_uchar,
        add_string,
        add_bytes,
        add_substring,
        add_subbytes,
        add_substitute,
        add_buffer,
        add_channel,
        to_seq,
        to_seqi,
        add_seq,
        of_seq,
        add_int8,
        add_int8,
        add_int16_ne,
        add_int16_be,
        add_int16_le,
        add_int16_ne,
        add_int16_be,
        add_int16_le,
        add_int32_ne,
        add_int32_be,
        add_int32_le,
        add_int64_ne,
        add_int64_be,
        add_int64_le
    ];
    runtime.caml_register_global(15, Stdlib_Buffer, "Stdlib__Buffer");
    return;
})(globalThis);
//# 10688 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_mutex_lock = runtime.caml_ml_mutex_lock, caml_ml_mutex_unlock = runtime.caml_ml_mutex_unlock, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function protect(m, f) {
        caml_ml_mutex_lock(m);
        try {
            var x = caml_call1(f, 0);
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            caml_ml_mutex_unlock(m);
            throw caml_maybe_attach_backtrace(e, 0);
        }
        caml_ml_mutex_unlock(m);
        return x;
    }
    var Stdlib_Mutex = [
        0,
        runtime.caml_ml_mutex_new,
        caml_ml_mutex_lock,
        runtime.caml_ml_mutex_try_lock,
        caml_ml_mutex_unlock,
        protect
    ];
    runtime.caml_register_global(0, Stdlib_Mutex, "Stdlib__Mutex");
    return;
})(globalThis);
//# 10726 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Stdlib_Condition = [
        0,
        runtime.caml_ml_condition_new,
        runtime.caml_ml_condition_wait,
        runtime.caml_ml_condition_signal,
        runtime.caml_ml_condition_broadcast
    ];
    runtime.caml_register_global(0, Stdlib_Condition, "Stdlib__Condition");
    return;
})(globalThis);
//# 10834 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_domain_dls_get = runtime.caml_domain_dls_get, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_domain_id = runtime.caml_ml_domain_id, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Stdlib_Condition = global_data.Stdlib__Condition, Stdlib_Mutex = global_data.Stdlib__Mutex, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Assert_failure = global_data.Assert_failure;
    function cpu_relax(param) {
        return runtime.caml_ml_domain_cpu_relax(0);
    }
    var none = [
        0,
        0
    ];
    function create_dls(param) {
        var st = caml_array_make(8, none);
        runtime.caml_domain_dls_set(st);
    }
    create_dls(0);
    var key_counter = caml_call1(Stdlib_Atomic[1], 0), parent_keys = caml_call1(Stdlib_Atomic[1], 0), _a_ = [
        0,
        "domain.ml",
        184,
        13
    ];
    function new_key(split_from_parent, init_orphan) {
        var idx = caml_call2(Stdlib_Atomic[7], key_counter, 1), k = [
            0,
            idx,
            init_orphan
        ];
        if (split_from_parent) {
            var split = split_from_parent[1], ki = [
                0,
                k,
                split
            ];
            for(;;){
                var l = caml_call1(Stdlib_Atomic[3], parent_keys);
                if (!(1 - caml_call3(Stdlib_Atomic[6], parent_keys, l, [
                    0,
                    ki,
                    l
                ]))) break;
            }
        }
        return k;
    }
    function maybe_grow(idx) {
        for(;;){
            var st = caml_domain_dls_get(0), sz = st.length - 1;
            if (idx < sz) return st;
            var new_sz = sz;
            for(;;){
                if (idx < new_sz) break;
                var s = 2 * new_sz | 0;
                new_sz = s;
            }
            var new_st = caml_array_make(new_sz, none);
            caml_call5(Stdlib_Array[9], st, 0, new_st, 0, sz);
            if (runtime.caml_domain_dls_compare_and_set(st, new_st)) return new_st;
        }
    }
    function set(param, x) {
        var idx = param[1], st = maybe_grow(idx);
        caml_check_bound(st, idx)[1 + idx] = x;
        return 0;
    }
    function get(param) {
        var init = param[2], idx = param[1], st = maybe_grow(idx), oldval = caml_check_bound(st, idx)[1 + idx];
        if (oldval !== none) return oldval;
        var new_obj = caml_call1(init, 0), st$0 = caml_domain_dls_get(0), curval = caml_check_bound(st$0, idx)[1 + idx], _e_ = curval === oldval ? (st$0[1 + idx] = new_obj, 1) : 0;
        if (_e_) return new_obj;
        var updated_obj = caml_check_bound(st$0, idx)[1 + idx];
        if (updated_obj !== none) return updated_obj;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function get_id(param) {
        var domain = param[1];
        return domain;
    }
    function self1(param) {
        return caml_ml_domain_id(0);
    }
    function is_main_domain(param) {
        return 0 === caml_ml_domain_id(0) ? 1 : 0;
    }
    var first_domain_spawned = caml_call1(Stdlib_Atomic[1], 0), first_spawn_function = [
        0,
        function(param) {}
    ], cst_first_domain_already_spawn = "first domain already spawned";
    function before_first_spawn(f) {
        if (caml_call1(Stdlib_Atomic[3], first_domain_spawned)) throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            cst_first_domain_already_spawn
        ], 1);
        var old_f = first_spawn_function[1];
        function new_f(param) {
            caml_call1(old_f, 0);
            return caml_call1(f, 0);
        }
        first_spawn_function[1] = new_f;
        return 0;
    }
    var at_exit_key = new_key(0, function(param) {
        return function(param) {
            return 0;
        };
    });
    function at_exit(f) {
        var old_exit = get(at_exit_key);
        function new_exit(param) {
            caml_call1(f, 0);
            return caml_call1(old_exit, 0);
        }
        return set(at_exit_key, new_exit);
    }
    function do_at_exit(param) {
        var f = get(at_exit_key);
        return caml_call1(f, 0);
    }
    Stdlib[104][1] = do_at_exit;
    function spawn(f) {
        if (1 - caml_call1(Stdlib_Atomic[3], first_domain_spawned)) {
            caml_call2(Stdlib_Atomic[4], first_domain_spawned, 1);
            caml_call1(first_spawn_function[1], 0);
            first_spawn_function[1] = function(param) {
                return 0;
            };
        }
        var _b_ = caml_call1(Stdlib_Atomic[3], parent_keys), pk = caml_call2(Stdlib_List[20], function(param) {
            var split = param[2], k = param[1];
            return [
                0,
                k,
                caml_call1(split, get(k))
            ];
        }, _b_), _c_ = caml_call1(Stdlib_Condition[1], 0), term_sync = [
            0,
            0,
            caml_call1(Stdlib_Mutex[1], 0),
            _c_
        ];
        function body(param) {
            try {
                create_dls(0);
                caml_call2(Stdlib_List[18], function(param) {
                    var v = param[2], k = param[1];
                    return set(k, v);
                }, pk);
                var res = caml_call1(f, 0);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                try {
                    do_at_exit(0);
                } catch (_d_) {}
                throw caml_maybe_attach_backtrace(exn, 0);
            }
            do_at_exit(0);
            return res;
        }
        var domain = runtime.caml_domain_spawn(body, term_sync);
        return [
            0,
            domain,
            term_sync
        ];
    }
    function join(param) {
        var term_sync = param[2];
        function loop(param) {
            for(;;){
                var match = term_sync[1];
                if (match) {
                    var res = match[1];
                    return res;
                }
                caml_call2(Stdlib_Condition[2], term_sync[3], term_sync[2]);
            }
        }
        var match = caml_call2(Stdlib_Mutex[5], term_sync[2], loop);
        if (0 === match[0]) {
            var x = match[1];
            return x;
        }
        var ex = match[1];
        throw caml_maybe_attach_backtrace(ex, 1);
    }
    var recommended_domain_count = runtime.caml_recommended_domain_count, Stdlib_Domain = [
        0,
        spawn,
        join,
        get_id,
        self1,
        before_first_spawn,
        at_exit,
        cpu_relax,
        is_main_domain,
        recommended_domain_count,
        runtime.caml_ml_domain_index,
        [
            0,
            new_key,
            get,
            set
        ]
    ];
    runtime.caml_register_global(9, Stdlib_Domain, "Stdlib__Domain");
    return;
})(globalThis);
//# 11039 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$43 = "", cst_and = " and ", cst_Li$3 = "%Li", cst_i$3 = "%i", cst_li$3 = "%li", cst_ni$3 = "%ni", cst_u$0 = "%u", cst$42 = "' '", cst$41 = "'#'", cst$39 = "'*'", cst$40 = "'+'", cst$44 = ", ", cst_0$3 = "0", cst_at_character_number = ": at character number ", cst$38 = "@[", cst$37 = "@{", cst_bad_input_format_type_mism = "bad input: format type mismatch between ", cst_bad_input_format_type_mism$0 = "bad input: format type mismatch between %S and %S", cst_camlinternalFormat_ml = "camlinternalFormat.ml", cst_invalid_format = "invalid format ", cst_precision$3 = "precision", caml_blit_string = runtime.caml_blit_string, caml_bytes_set = runtime.caml_bytes_set, caml_create_bytes = runtime.caml_create_bytes, caml_format_float = runtime.caml_format_float, caml_format_int = runtime.caml_format_int, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst$9 = "%{", cst$10 = "%}", cst$11 = "%(", cst$12 = "%)", cst$13 = "%?", cst$18 = cst$37, cst$19 = cst$38, cst$20 = cst$37, cst$21 = cst$38, cst$22 = cst$37, cst$23 = cst$38, cst$26 = cst$39, cst$24 = "'-'", cst$25 = cst$39, cst$27 = cst$40, cst$28 = cst$41, cst$29 = cst$42, cst$30 = cst$40, cst$31 = "'_'", sub_format = [
        0,
        0,
        cst$43
    ], formatting_lit = [
        0,
        "@;",
        1,
        0
    ], cst$35 = cst$41, cst$32 = cst$40, cst$33 = cst$40, cst$34 = cst$42, cst$36 = cst$40, cst_unexpected_end_of_format = "unexpected end of format", cst$17 = ".", cst$14 = "%!", cst$15 = cst$37, cst$16 = cst$38, cst$8 = "%%", cst$0 = "@]", cst$1 = "@}", cst$2 = "@?", cst$3 = "@\n", cst$4 = "@.", cst$5 = "@@", cst$6 = "@%", cst$7 = "@", cst = ".*", Assert_failure = global_data.Assert_failure, CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_String = global_data.Stdlib__String, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Char = global_data.Stdlib__Char, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Int = global_data.Stdlib__Int, _a_ = [
        0,
        0,
        0
    ], cst_c = "%c", cst_s = "%s", cst_i = cst_i$3, cst_li = cst_li$3, cst_ni = cst_ni$3, cst_Li = cst_Li$3, cst_f = "%f", cst_B = "%B", cst_a = "%a", cst_t = "%t", cst_r = "%r", cst_r$0 = "%_r", cst_0c = "0c", _b_ = [
        0,
        cst_camlinternalFormat_ml,
        850,
        23
    ], _c_ = [
        0,
        cst_camlinternalFormat_ml,
        837,
        26
    ], _d_ = [
        0,
        cst_camlinternalFormat_ml,
        847,
        28
    ], _e_ = [
        0,
        cst_camlinternalFormat_ml,
        815,
        21
    ], _f_ = [
        0,
        cst_camlinternalFormat_ml,
        819,
        21
    ], _g_ = [
        0,
        cst_camlinternalFormat_ml,
        823,
        19
    ], _h_ = [
        0,
        cst_camlinternalFormat_ml,
        827,
        22
    ], _i_ = [
        0,
        cst_camlinternalFormat_ml,
        832,
        30
    ], _j_ = [
        0,
        cst_camlinternalFormat_ml,
        851,
        23
    ], _k_ = [
        0,
        cst_camlinternalFormat_ml,
        836,
        26
    ], _l_ = [
        0,
        cst_camlinternalFormat_ml,
        846,
        28
    ], _m_ = [
        0,
        cst_camlinternalFormat_ml,
        814,
        21
    ], _n_ = [
        0,
        cst_camlinternalFormat_ml,
        818,
        21
    ], _o_ = [
        0,
        cst_camlinternalFormat_ml,
        822,
        19
    ], _p_ = [
        0,
        cst_camlinternalFormat_ml,
        826,
        22
    ], _q_ = [
        0,
        cst_camlinternalFormat_ml,
        831,
        30
    ];
    function create_char_set(param) {
        return caml_call2(Stdlib_Bytes[1], 32, 0);
    }
    function add_in_char_set(char_set, c) {
        var str_ind = c >>> 3 | 0, mask = 1 << (c & 7), _cU_ = runtime.caml_bytes_get(char_set, str_ind) | mask;
        return caml_bytes_set(char_set, str_ind, caml_call1(Stdlib[29], _cU_));
    }
    function freeze_char_set(char_set) {
        return caml_call1(Stdlib_Bytes[6], char_set);
    }
    function rev_char_set(char_set) {
        var char_set$0 = create_char_set(0), i = 0;
        for(;;){
            var _cS_ = caml_string_get(char_set, i) ^ 255;
            caml_bytes_set(char_set$0, i, caml_call1(Stdlib[29], _cS_));
            var _cT_ = i + 1 | 0;
            if (31 === i) return caml_call1(Stdlib_Bytes[44], char_set$0);
            i = _cT_;
        }
    }
    function is_in_char_set(char_set, c) {
        var str_ind = c >>> 3 | 0, mask = 1 << (c & 7);
        return 0 !== (caml_string_get(char_set, str_ind) & mask) ? 1 : 0;
    }
    function pad_of_pad_opt(pad_opt) {
        if (!pad_opt) return 0;
        var width = pad_opt[1];
        return [
            0,
            1,
            width
        ];
    }
    function param_format_of_ignored_format(ign, fmt) {
        if (typeof ign === "number") switch(ign){
            case 0:
                return [
                    0,
                    [
                        0,
                        fmt
                    ]
                ];
            case 1:
                return [
                    0,
                    [
                        1,
                        fmt
                    ]
                ];
            case 2:
                return [
                    0,
                    [
                        19,
                        fmt
                    ]
                ];
            default:
                return [
                    0,
                    [
                        22,
                        fmt
                    ]
                ];
        }
        switch(ign[0]){
            case 0:
                var pad_opt = ign[1];
                return [
                    0,
                    [
                        2,
                        pad_of_pad_opt(pad_opt),
                        fmt
                    ]
                ];
            case 1:
                var pad_opt$0 = ign[1];
                return [
                    0,
                    [
                        3,
                        pad_of_pad_opt(pad_opt$0),
                        fmt
                    ]
                ];
            case 2:
                var pad_opt$1 = ign[2], iconv = ign[1];
                return [
                    0,
                    [
                        4,
                        iconv,
                        pad_of_pad_opt(pad_opt$1),
                        0,
                        fmt
                    ]
                ];
            case 3:
                var pad_opt$2 = ign[2], iconv$0 = ign[1];
                return [
                    0,
                    [
                        5,
                        iconv$0,
                        pad_of_pad_opt(pad_opt$2),
                        0,
                        fmt
                    ]
                ];
            case 4:
                var pad_opt$3 = ign[2], iconv$1 = ign[1];
                return [
                    0,
                    [
                        6,
                        iconv$1,
                        pad_of_pad_opt(pad_opt$3),
                        0,
                        fmt
                    ]
                ];
            case 5:
                var pad_opt$4 = ign[2], iconv$2 = ign[1];
                return [
                    0,
                    [
                        7,
                        iconv$2,
                        pad_of_pad_opt(pad_opt$4),
                        0,
                        fmt
                    ]
                ];
            case 6:
                var prec_opt = ign[2], pad_opt$5 = ign[1];
                if (prec_opt) var ndec = prec_opt[1], _cR_ = [
                    0,
                    ndec
                ];
                else var _cR_ = 0;
                return [
                    0,
                    [
                        8,
                        _a_,
                        pad_of_pad_opt(pad_opt$5),
                        _cR_,
                        fmt
                    ]
                ];
            case 7:
                var pad_opt$6 = ign[1];
                return [
                    0,
                    [
                        9,
                        pad_of_pad_opt(pad_opt$6),
                        fmt
                    ]
                ];
            case 8:
                var fmtty = ign[2], pad_opt$7 = ign[1];
                return [
                    0,
                    [
                        13,
                        pad_opt$7,
                        fmtty,
                        fmt
                    ]
                ];
            case 9:
                var fmtty$0 = ign[2], pad_opt$8 = ign[1];
                return [
                    0,
                    [
                        14,
                        pad_opt$8,
                        fmtty$0,
                        fmt
                    ]
                ];
            case 10:
                var char_set = ign[2], width_opt = ign[1];
                return [
                    0,
                    [
                        20,
                        width_opt,
                        char_set,
                        fmt
                    ]
                ];
            default:
                var counter = ign[1];
                return [
                    0,
                    [
                        21,
                        counter,
                        fmt
                    ]
                ];
        }
    }
    function default_float_precision(fconv) {
        return 5 === fconv[2] ? 12 : -6;
    }
    function buffer_create(init_size) {
        return [
            0,
            0,
            caml_create_bytes(init_size)
        ];
    }
    function buffer_check_size(buf, overhead) {
        var len = runtime.caml_ml_bytes_length(buf[2]), min_len = buf[1] + overhead | 0;
        if (len < min_len) {
            var new_len = caml_call2(Stdlib_Int[11], len * 2 | 0, min_len), new_str = caml_create_bytes(new_len);
            caml_call5(Stdlib_Bytes[11], buf[2], 0, new_str, 0, len);
            buf[2] = new_str;
        }
    }
    function buffer_add_char(buf, c) {
        buffer_check_size(buf, 1);
        caml_bytes_set(buf[2], buf[1], c);
        buf[1] = buf[1] + 1 | 0;
    }
    function buffer_add_string(buf, s) {
        var str_len = caml_ml_string_length(s);
        buffer_check_size(buf, str_len);
        caml_call5(Stdlib_String[6], s, 0, buf[2], buf[1], str_len);
        buf[1] = buf[1] + str_len | 0;
    }
    function buffer_contents(buf) {
        return caml_call3(Stdlib_Bytes[8], buf[2], 0, buf[1]);
    }
    function char_of_iconv(iconv) {
        switch(iconv){
            case 6:
            case 7:
                return 120;
            case 8:
            case 9:
                return 88;
            case 10:
            case 11:
                return 111;
            case 12:
            case 15:
                return 117;
            case 0:
            case 1:
            case 2:
            case 13:
                return 100;
            default:
                return 105;
        }
    }
    function char_of_fconv(opt, fconv) {
        var cF = opt ? opt[1] : 70;
        switch(fconv[2]){
            case 0:
                return 102;
            case 1:
                return 101;
            case 2:
                return 69;
            case 3:
                return 103;
            case 4:
                return 71;
            case 5:
                return cF;
            case 6:
                return 104;
            case 7:
                return 72;
            default:
                return 70;
        }
    }
    function bprint_padty(buf, padty) {
        switch(padty){
            case 0:
                return buffer_add_char(buf, 45);
            case 1:
                return;
            default:
                return buffer_add_char(buf, 48);
        }
    }
    function bprint_ignored_flag(buf, ign_flag) {
        return ign_flag ? buffer_add_char(buf, 95) : ign_flag;
    }
    function bprint_pad_opt(buf, pad_opt) {
        if (!pad_opt) return;
        var width = pad_opt[1];
        return buffer_add_string(buf, caml_call1(Stdlib_Int[12], width));
    }
    function bprint_padding(buf, pad) {
        if (typeof pad === "number") return;
        if (0 === pad[0]) {
            var n = pad[2], padty = pad[1];
            bprint_padty(buf, padty);
            return buffer_add_string(buf, caml_call1(Stdlib_Int[12], n));
        }
        var padty$0 = pad[1];
        bprint_padty(buf, padty$0);
        return buffer_add_char(buf, 42);
    }
    function bprint_precision(buf, prec) {
        if (typeof prec !== "number") {
            var n = prec[1];
            buffer_add_char(buf, 46);
            return buffer_add_string(buf, caml_call1(Stdlib_Int[12], n));
        }
        if (prec) return buffer_add_string(buf, cst);
    }
    function bprint_iconv_flag(buf, iconv) {
        switch(iconv){
            case 1:
            case 4:
                return buffer_add_char(buf, 43);
            case 2:
            case 5:
                return buffer_add_char(buf, 32);
            case 7:
            case 9:
            case 11:
            case 13:
            case 14:
            case 15:
                return buffer_add_char(buf, 35);
            default:
                return;
        }
    }
    function bprint_altint_fmt(buf, ign_flag, iconv, pad, prec, c) {
        buffer_add_char(buf, 37);
        bprint_ignored_flag(buf, ign_flag);
        bprint_iconv_flag(buf, iconv);
        bprint_padding(buf, pad);
        bprint_precision(buf, prec);
        buffer_add_char(buf, c);
        return buffer_add_char(buf, char_of_iconv(iconv));
    }
    function bprint_fconv_flag(buf, fconv) {
        switch(fconv[1]){
            case 0:
                break;
            case 1:
                buffer_add_char(buf, 43);
                break;
            default:
                buffer_add_char(buf, 32);
        }
        if (8 <= fconv[2]) return buffer_add_char(buf, 35);
    }
    function string_of_formatting_lit(formatting_lit) {
        if (typeof formatting_lit === "number") switch(formatting_lit){
            case 0:
                return cst$0;
            case 1:
                return cst$1;
            case 2:
                return cst$2;
            case 3:
                return cst$3;
            case 4:
                return cst$4;
            case 5:
                return cst$5;
            default:
                return cst$6;
        }
        switch(formatting_lit[0]){
            case 0:
                var str = formatting_lit[1];
                return str;
            case 1:
                var str$0 = formatting_lit[1];
                return str$0;
            default:
                var c = formatting_lit[1], _cQ_ = caml_call2(Stdlib_String[1], 1, c);
                return caml_call2(Stdlib[28], cst$7, _cQ_);
        }
    }
    function bprint_char_literal(buf, chr) {
        return 37 === chr ? buffer_add_string(buf, cst$8) : buffer_add_char(buf, chr);
    }
    function bprint_string_literal(buf, str) {
        var _cO_ = caml_ml_string_length(str) - 1 | 0, _cN_ = 0;
        if (_cO_ >= 0) {
            var i = _cN_;
            for(;;){
                bprint_char_literal(buf, caml_string_get(str, i));
                var _cP_ = i + 1 | 0;
                if (_cO_ === i) break;
                i = _cP_;
            }
        }
    }
    function bprint_fmtty(buf, fmtty) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") return;
            switch(fmtty$0[0]){
                case 0:
                    var fmtty$1 = fmtty$0[1];
                    buffer_add_string(buf, cst_c);
                    fmtty$0 = fmtty$1;
                    break;
                case 1:
                    var fmtty$2 = fmtty$0[1];
                    buffer_add_string(buf, cst_s);
                    fmtty$0 = fmtty$2;
                    break;
                case 2:
                    var fmtty$3 = fmtty$0[1];
                    buffer_add_string(buf, cst_i);
                    fmtty$0 = fmtty$3;
                    break;
                case 3:
                    var fmtty$4 = fmtty$0[1];
                    buffer_add_string(buf, cst_li);
                    fmtty$0 = fmtty$4;
                    break;
                case 4:
                    var fmtty$5 = fmtty$0[1];
                    buffer_add_string(buf, cst_ni);
                    fmtty$0 = fmtty$5;
                    break;
                case 5:
                    var fmtty$6 = fmtty$0[1];
                    buffer_add_string(buf, cst_Li);
                    fmtty$0 = fmtty$6;
                    break;
                case 6:
                    var fmtty$7 = fmtty$0[1];
                    buffer_add_string(buf, cst_f);
                    fmtty$0 = fmtty$7;
                    break;
                case 7:
                    var fmtty$8 = fmtty$0[1];
                    buffer_add_string(buf, cst_B);
                    fmtty$0 = fmtty$8;
                    break;
                case 8:
                    var fmtty$9 = fmtty$0[2], sub_fmtty = fmtty$0[1];
                    buffer_add_string(buf, cst$9);
                    bprint_fmtty(buf, sub_fmtty);
                    buffer_add_string(buf, cst$10);
                    fmtty$0 = fmtty$9;
                    break;
                case 9:
                    var fmtty$10 = fmtty$0[3], sub_fmtty$0 = fmtty$0[1];
                    buffer_add_string(buf, cst$11);
                    bprint_fmtty(buf, sub_fmtty$0);
                    buffer_add_string(buf, cst$12);
                    fmtty$0 = fmtty$10;
                    break;
                case 10:
                    var fmtty$11 = fmtty$0[1];
                    buffer_add_string(buf, cst_a);
                    fmtty$0 = fmtty$11;
                    break;
                case 11:
                    var fmtty$12 = fmtty$0[1];
                    buffer_add_string(buf, cst_t);
                    fmtty$0 = fmtty$12;
                    break;
                case 12:
                    var fmtty$13 = fmtty$0[1];
                    buffer_add_string(buf, cst$13);
                    fmtty$0 = fmtty$13;
                    break;
                case 13:
                    var fmtty$14 = fmtty$0[1];
                    buffer_add_string(buf, cst_r);
                    fmtty$0 = fmtty$14;
                    break;
                default:
                    var fmtty$15 = fmtty$0[1];
                    buffer_add_string(buf, cst_r$0);
                    fmtty$0 = fmtty$15;
            }
        }
    }
    function int_of_custom_arity(param) {
        if (!param) return 0;
        var x = param[1];
        return 1 + int_of_custom_arity(x) | 0;
    }
    function string_of_fmt(fmt) {
        var buf = buffer_create(16);
        function fmtiter(fmt, ign_flag) {
            var fmt$0 = fmt, ign_flag$0 = ign_flag;
            for(;;){
                if (typeof fmt$0 === "number") return;
                switch(fmt$0[0]){
                    case 0:
                        var rest = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 99);
                        fmt$0 = rest;
                        ign_flag$0 = 0;
                        break;
                    case 1:
                        var rest$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 67);
                        fmt$0 = rest$0;
                        ign_flag$0 = 0;
                        break;
                    case 2:
                        var rest$1 = fmt$0[2], pad = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad);
                        buffer_add_char(buf, 115);
                        fmt$0 = rest$1;
                        ign_flag$0 = 0;
                        break;
                    case 3:
                        var rest$2 = fmt$0[2], pad$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad$0);
                        buffer_add_char(buf, 83);
                        fmt$0 = rest$2;
                        ign_flag$0 = 0;
                        break;
                    case 4:
                        var rest$3 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_iconv_flag(buf, iconv);
                        bprint_padding(buf, pad$1);
                        bprint_precision(buf, prec);
                        buffer_add_char(buf, char_of_iconv(iconv));
                        fmt$0 = rest$3;
                        ign_flag$0 = 0;
                        break;
                    case 5:
                        var rest$4 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$0, pad$2, prec$0, 108);
                        fmt$0 = rest$4;
                        ign_flag$0 = 0;
                        break;
                    case 6:
                        var rest$5 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$1, pad$3, prec$1, 110);
                        fmt$0 = rest$5;
                        ign_flag$0 = 0;
                        break;
                    case 7:
                        var rest$6 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1];
                        bprint_altint_fmt(buf, ign_flag$0, iconv$2, pad$4, prec$2, 76);
                        fmt$0 = rest$6;
                        ign_flag$0 = 0;
                        break;
                    case 8:
                        var rest$7 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2], fconv = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_fconv_flag(buf, fconv);
                        bprint_padding(buf, pad$5);
                        bprint_precision(buf, prec$3);
                        buffer_add_char(buf, char_of_fconv(0, fconv));
                        fmt$0 = rest$7;
                        ign_flag$0 = 0;
                        break;
                    case 9:
                        var rest$8 = fmt$0[2], pad$6 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_padding(buf, pad$6);
                        buffer_add_char(buf, 66);
                        fmt$0 = rest$8;
                        ign_flag$0 = 0;
                        break;
                    case 10:
                        var rest$9 = fmt$0[1];
                        buffer_add_string(buf, cst$14);
                        fmt$0 = rest$9;
                        break;
                    case 11:
                        var rest$10 = fmt$0[2], str = fmt$0[1];
                        bprint_string_literal(buf, str);
                        fmt$0 = rest$10;
                        break;
                    case 12:
                        var rest$11 = fmt$0[2], chr = fmt$0[1];
                        bprint_char_literal(buf, chr);
                        fmt$0 = rest$11;
                        break;
                    case 13:
                        var rest$12 = fmt$0[3], fmtty = fmt$0[2], pad_opt = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, pad_opt);
                        buffer_add_char(buf, 123);
                        bprint_fmtty(buf, fmtty);
                        buffer_add_char(buf, 37);
                        buffer_add_char(buf, 125);
                        fmt$0 = rest$12;
                        ign_flag$0 = 0;
                        break;
                    case 14:
                        var rest$13 = fmt$0[3], fmtty$0 = fmt$0[2], pad_opt$0 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, pad_opt$0);
                        buffer_add_char(buf, 40);
                        bprint_fmtty(buf, fmtty$0);
                        buffer_add_char(buf, 37);
                        buffer_add_char(buf, 41);
                        fmt$0 = rest$13;
                        ign_flag$0 = 0;
                        break;
                    case 15:
                        var rest$14 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 97);
                        fmt$0 = rest$14;
                        ign_flag$0 = 0;
                        break;
                    case 16:
                        var rest$15 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 116);
                        fmt$0 = rest$15;
                        ign_flag$0 = 0;
                        break;
                    case 17:
                        var rest$16 = fmt$0[2], fmting_lit = fmt$0[1];
                        bprint_string_literal(buf, string_of_formatting_lit(fmting_lit));
                        fmt$0 = rest$16;
                        break;
                    case 18:
                        var rest$17 = fmt$0[2], fmting_gen = fmt$0[1];
                        if (0 === fmting_gen[0]) {
                            var str$0 = fmting_gen[1][2];
                            buffer_add_string(buf, cst$15);
                            buffer_add_string(buf, str$0);
                        } else {
                            var str$1 = fmting_gen[1][2];
                            buffer_add_string(buf, cst$16);
                            buffer_add_string(buf, str$1);
                        }
                        fmt$0 = rest$17;
                        break;
                    case 19:
                        var rest$18 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        buffer_add_char(buf, 114);
                        fmt$0 = rest$18;
                        ign_flag$0 = 0;
                        break;
                    case 20:
                        var rest$19 = fmt$0[3], char_set = fmt$0[2], width_opt = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_pad_opt(buf, width_opt);
                        var print_char = function(buf, i) {
                            var c = caml_call1(Stdlib[29], i);
                            return 37 === c ? (buffer_add_char(buf, 37), buffer_add_char(buf, 37)) : 64 === c ? (buffer_add_char(buf, 37), buffer_add_char(buf, 64)) : buffer_add_char(buf, c);
                        };
                        buffer_add_char(buf, 91);
                        var set = is_in_char_set(char_set, 0) ? (buffer_add_char(buf, 94), rev_char_set(char_set)) : char_set;
                        let set$0 = set;
                        var is_alone = function(c) {
                            var after = caml_call1(Stdlib_Char[1], c + 1 | 0), before = caml_call1(Stdlib_Char[1], c - 1 | 0), _cJ_ = is_in_char_set(set$0, c);
                            if (_cJ_) var _cK_ = is_in_char_set(set$0, before), _cL_ = _cK_ ? is_in_char_set(set$0, after) : _cK_, _cM_ = 1 - _cL_;
                            else var _cM_ = _cJ_;
                            return _cM_;
                        };
                        if (is_alone(93)) buffer_add_char(buf, 93);
                        a: b: {
                            c: {
                                d: {
                                    var i = 1;
                                    for(;;){
                                        if (i >= 256) break;
                                        if (is_in_char_set(set, caml_call1(Stdlib[29], i))) {
                                            var switcher = caml_call1(Stdlib[29], i) - 45 | 0;
                                            if (48 < switcher >>> 0) {
                                                if (210 <= switcher) break d;
                                            } else if (46 < switcher - 1 >>> 0) {
                                                var i$2 = i + 1 | 0;
                                                i = i$2;
                                                continue;
                                            }
                                            var i$1 = i + 1 | 0;
                                            if (is_in_char_set(set, caml_call1(Stdlib[29], i$1))) {
                                                var switcher$0 = caml_call1(Stdlib[29], i$1) - 45 | 0;
                                                if (48 < switcher$0 >>> 0) {
                                                    if (210 <= switcher$0) break c;
                                                } else if (46 < switcher$0 - 1 >>> 0 && !is_in_char_set(set, caml_call1(Stdlib[29], i$1 + 1 | 0))) {
                                                    print_char(buf, i$1 - 1 | 0);
                                                    var i$5 = i$1 + 1 | 0;
                                                    i = i$5;
                                                    continue;
                                                }
                                                if (is_in_char_set(set, caml_call1(Stdlib[29], i$1 + 1 | 0))) {
                                                    var j = i$1 + 2 | 0, i$3 = i$1 - 1 | 0, j$0 = j;
                                                    for(;;){
                                                        if (256 === j$0) break;
                                                        if (!is_in_char_set(set, caml_call1(Stdlib[29], j$0))) break;
                                                        var j$1 = j$0 + 1 | 0;
                                                        j$0 = j$1;
                                                    }
                                                    print_char(buf, i$3);
                                                    print_char(buf, 45);
                                                    print_char(buf, j$0 - 1 | 0);
                                                    if (j$0 >= 256) break b;
                                                    var i$7 = j$0 + 1 | 0;
                                                    i = i$7;
                                                } else {
                                                    print_char(buf, i$1 - 1 | 0);
                                                    print_char(buf, i$1);
                                                    var i$4 = i$1 + 2 | 0;
                                                    i = i$4;
                                                }
                                            } else {
                                                print_char(buf, i$1 - 1 | 0);
                                                var i$6 = i$1 + 1 | 0;
                                                i = i$6;
                                            }
                                        } else {
                                            var i$0 = i + 1 | 0;
                                            i = i$0;
                                        }
                                    }
                                    break a;
                                }
                                print_char(buf, 255);
                                break a;
                            }
                            print_char(buf, 254);
                            print_char(buf, 255);
                            break a;
                        }
                        if (is_alone(45)) buffer_add_char(buf, 45);
                        buffer_add_char(buf, 93);
                        fmt$0 = rest$19;
                        ign_flag$0 = 0;
                        break;
                    case 21:
                        var rest$20 = fmt$0[2], counter = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        switch(counter){
                            case 0:
                                var _cF_ = 108;
                                break;
                            case 1:
                                var _cF_ = 110;
                                break;
                            default:
                                var _cF_ = 78;
                        }
                        buffer_add_char(buf, _cF_);
                        fmt$0 = rest$20;
                        ign_flag$0 = 0;
                        break;
                    case 22:
                        var rest$21 = fmt$0[1];
                        buffer_add_char(buf, 37);
                        bprint_ignored_flag(buf, ign_flag$0);
                        bprint_string_literal(buf, cst_0c);
                        fmt$0 = rest$21;
                        ign_flag$0 = 0;
                        break;
                    case 23:
                        var rest$22 = fmt$0[2], ign = fmt$0[1], fmt$1 = param_format_of_ignored_format(ign, rest$22)[1];
                        fmt$0 = fmt$1;
                        ign_flag$0 = 1;
                        break;
                    default:
                        var rest$23 = fmt$0[3], arity = fmt$0[1], _cH_ = int_of_custom_arity(arity), _cG_ = 1;
                        if (_cH_ >= 1) {
                            var i$8 = _cG_;
                            for(;;){
                                buffer_add_char(buf, 37);
                                bprint_ignored_flag(buf, ign_flag$0);
                                buffer_add_char(buf, 63);
                                var _cI_ = i$8 + 1 | 0;
                                if (_cH_ === i$8) break;
                                i$8 = _cI_;
                            }
                        }
                        fmt$0 = rest$23;
                        ign_flag$0 = 0;
                }
            }
        }
        fmtiter(fmt, 0);
        return buffer_contents(buf);
    }
    function symm(param) {
        if (typeof param === "number") return 0;
        switch(param[0]){
            case 0:
                var rest = param[1];
                return [
                    0,
                    symm(rest)
                ];
            case 1:
                var rest$0 = param[1];
                return [
                    1,
                    symm(rest$0)
                ];
            case 2:
                var rest$1 = param[1];
                return [
                    2,
                    symm(rest$1)
                ];
            case 3:
                var rest$2 = param[1];
                return [
                    3,
                    symm(rest$2)
                ];
            case 4:
                var rest$3 = param[1];
                return [
                    4,
                    symm(rest$3)
                ];
            case 5:
                var rest$4 = param[1];
                return [
                    5,
                    symm(rest$4)
                ];
            case 6:
                var rest$5 = param[1];
                return [
                    6,
                    symm(rest$5)
                ];
            case 7:
                var rest$6 = param[1];
                return [
                    7,
                    symm(rest$6)
                ];
            case 8:
                var rest$7 = param[2], ty = param[1];
                return [
                    8,
                    ty,
                    symm(rest$7)
                ];
            case 9:
                var rest$8 = param[3], ty2 = param[2], ty1 = param[1];
                return [
                    9,
                    ty2,
                    ty1,
                    symm(rest$8)
                ];
            case 10:
                var rest$9 = param[1];
                return [
                    10,
                    symm(rest$9)
                ];
            case 11:
                var rest$10 = param[1];
                return [
                    11,
                    symm(rest$10)
                ];
            case 12:
                var rest$11 = param[1];
                return [
                    12,
                    symm(rest$11)
                ];
            case 13:
                var rest$12 = param[1];
                return [
                    13,
                    symm(rest$12)
                ];
            default:
                var rest$13 = param[1];
                return [
                    14,
                    symm(rest$13)
                ];
        }
    }
    function fmtty_rel_det(param) {
        if (typeof param === "number") return [
            0,
            ,
            function(param) {},
            ,
            function(param) {}
        ];
        switch(param[0]){
            case 0:
                var rest = param[1], match = fmtty_rel_det(rest), de = match[4], af = match[2];
                return [
                    0,
                    ,
                    function(param) {
                        af(0);
                    },
                    ,
                    de
                ];
            case 1:
                var rest$0 = param[1], match$0 = fmtty_rel_det(rest$0), de$0 = match$0[4], af$0 = match$0[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$0(0);
                    },
                    ,
                    de$0
                ];
            case 2:
                var rest$1 = param[1], match$1 = fmtty_rel_det(rest$1), de$1 = match$1[4], af$1 = match$1[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$1(0);
                    },
                    ,
                    de$1
                ];
            case 3:
                var rest$2 = param[1], match$2 = fmtty_rel_det(rest$2), de$2 = match$2[4], af$2 = match$2[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$2(0);
                    },
                    ,
                    de$2
                ];
            case 4:
                var rest$3 = param[1], match$3 = fmtty_rel_det(rest$3), de$3 = match$3[4], af$3 = match$3[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$3(0);
                    },
                    ,
                    de$3
                ];
            case 5:
                var rest$4 = param[1], match$4 = fmtty_rel_det(rest$4), de$4 = match$4[4], af$4 = match$4[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$4(0);
                    },
                    ,
                    de$4
                ];
            case 6:
                var rest$5 = param[1], match$5 = fmtty_rel_det(rest$5), de$5 = match$5[4], af$5 = match$5[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$5(0);
                    },
                    ,
                    de$5
                ];
            case 7:
                var rest$6 = param[1], match$6 = fmtty_rel_det(rest$6), de$6 = match$6[4], af$6 = match$6[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$6(0);
                    },
                    ,
                    de$6
                ];
            case 8:
                var rest$7 = param[2], match$7 = fmtty_rel_det(rest$7), de$7 = match$7[4], af$7 = match$7[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$7(0);
                    },
                    ,
                    de$7
                ];
            case 9:
                var rest$8 = param[3], ty2 = param[2], ty1 = param[1], match$8 = fmtty_rel_det(rest$8), de$8 = match$8[4], af$8 = match$8[2], ty = trans(symm(ty1), ty2), match$9 = fmtty_rel_det(ty), jd = match$9[4], ga = match$9[2];
                return [
                    0,
                    ,
                    function(param) {
                        ga(0);
                        af$8(0);
                    },
                    ,
                    function(param) {
                        jd(0);
                        de$8(0);
                    }
                ];
            case 10:
                var rest$9 = param[1], match$10 = fmtty_rel_det(rest$9), de$9 = match$10[4], af$9 = match$10[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$9(0);
                    },
                    ,
                    de$9
                ];
            case 11:
                var rest$10 = param[1], match$11 = fmtty_rel_det(rest$10), de$10 = match$11[4], af$10 = match$11[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$10(0);
                    },
                    ,
                    de$10
                ];
            case 12:
                var rest$11 = param[1], match$12 = fmtty_rel_det(rest$11), de$11 = match$12[4], af$11 = match$12[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$11(0);
                    },
                    ,
                    de$11
                ];
            case 13:
                var rest$12 = param[1], match$13 = fmtty_rel_det(rest$12), de$12 = match$13[4], af$12 = match$13[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$12(0);
                    },
                    ,
                    function(param) {
                        de$12(0);
                    }
                ];
            default:
                var rest$13 = param[1], match$14 = fmtty_rel_det(rest$13), de$13 = match$14[4], af$13 = match$14[2];
                return [
                    0,
                    ,
                    function(param) {
                        af$13(0);
                    },
                    ,
                    function(param) {
                        de$13(0);
                    }
                ];
        }
    }
    function trans(ty1, ty2) {
        a: {
            b: {
                c: {
                    d: {
                        e: {
                            f: {
                                g: {
                                    if (typeof ty1 !== "number") {
                                        switch(ty1[0]){
                                            case 0:
                                                var rest1 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 0:
                                                        var rest2 = ty2[1];
                                                        return [
                                                            0,
                                                            trans(rest1, rest2)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 1:
                                                var rest1$0 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 1:
                                                        var rest2$0 = ty2[1];
                                                        return [
                                                            1,
                                                            trans(rest1$0, rest2$0)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 2:
                                                var rest1$1 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 2:
                                                        var rest2$1 = ty2[1];
                                                        return [
                                                            2,
                                                            trans(rest1$1, rest2$1)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 3:
                                                var rest1$2 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 3:
                                                        var rest2$2 = ty2[1];
                                                        return [
                                                            3,
                                                            trans(rest1$2, rest2$2)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 4:
                                                var rest1$3 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 4:
                                                        var rest2$3 = ty2[1];
                                                        return [
                                                            4,
                                                            trans(rest1$3, rest2$3)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 5:
                                                var rest1$4 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 5:
                                                        var rest2$4 = ty2[1];
                                                        return [
                                                            5,
                                                            trans(rest1$4, rest2$4)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 6:
                                                var rest1$5 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 6:
                                                        var rest2$5 = ty2[1];
                                                        return [
                                                            6,
                                                            trans(rest1$5, rest2$5)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 7:
                                                var rest1$6 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 7:
                                                        var rest2$6 = ty2[1];
                                                        return [
                                                            7,
                                                            trans(rest1$6, rest2$6)
                                                        ];
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        break g;
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                break;
                                            case 8:
                                                var rest1$7 = ty1[2], ty1$0 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 8:
                                                        var rest2$7 = ty2[2], ty2$0 = ty2[1], _cE_ = trans(rest1$7, rest2$7);
                                                        return [
                                                            8,
                                                            trans(ty1$0, ty2$0),
                                                            _cE_
                                                        ];
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _k_
                                                ], 1);
                                            case 9:
                                                var rest1$8 = ty1[3], ty12 = ty1[2], ty11 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 8:
                                                        break f;
                                                    case 9:
                                                        var rest2$8 = ty2[3], ty22 = ty2[2], ty21 = ty2[1], ty = trans(symm(ty12), ty21), match = fmtty_rel_det(ty), f4 = match[4], f2 = match[2];
                                                        f2(0);
                                                        f4(0);
                                                        return [
                                                            9,
                                                            ty11,
                                                            ty22,
                                                            trans(rest1$8, rest2$8)
                                                        ];
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        break e;
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _l_
                                                ], 1);
                                            case 10:
                                                var rest1$9 = ty1[1];
                                                if (typeof ty2 !== "number" && 10 === ty2[0]) {
                                                    var rest2$9 = ty2[1];
                                                    return [
                                                        10,
                                                        trans(rest1$9, rest2$9)
                                                    ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _m_
                                                ], 1);
                                            case 11:
                                                var rest1$10 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        var rest2$10 = ty2[1];
                                                        return [
                                                            11,
                                                            trans(rest1$10, rest2$10)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _n_
                                                ], 1);
                                            case 12:
                                                var rest1$11 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        var rest2$11 = ty2[1];
                                                        return [
                                                            12,
                                                            trans(rest1$11, rest2$11)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _o_
                                                ], 1);
                                            case 13:
                                                var rest1$12 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        var rest2$12 = ty2[1];
                                                        return [
                                                            13,
                                                            trans(rest1$12, rest2$12)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _p_
                                                ], 1);
                                            default:
                                                var rest1$13 = ty1[1];
                                                if (typeof ty2 !== "number") switch(ty2[0]){
                                                    case 10:
                                                        break a;
                                                    case 11:
                                                        break b;
                                                    case 12:
                                                        break c;
                                                    case 13:
                                                        break d;
                                                    case 14:
                                                        var rest2$13 = ty2[1];
                                                        return [
                                                            14,
                                                            trans(rest1$13, rest2$13)
                                                        ];
                                                }
                                                throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _q_
                                                ], 1);
                                        }
                                        throw caml_maybe_attach_backtrace([
                                            0,
                                            Assert_failure,
                                            _j_
                                        ], 1);
                                    }
                                    if (typeof ty2 === "number") return 0;
                                    switch(ty2[0]){
                                        case 10:
                                            break a;
                                        case 11:
                                            break b;
                                        case 12:
                                            break c;
                                        case 13:
                                            break d;
                                        case 14:
                                            break e;
                                        case 8:
                                            break f;
                                        case 9:
                                            break;
                                        default:
                                            throw caml_maybe_attach_backtrace([
                                                0,
                                                Assert_failure,
                                                _b_
                                            ], 1);
                                    }
                                }
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _d_
                                ], 1);
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _c_
                            ], 1);
                        }
                        throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _i_
                        ], 1);
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _h_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _g_
                ], 1);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function fmtty_of_fmt(fmtty) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") return 0;
            switch(fmtty$0[0]){
                case 0:
                    var rest = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest)
                    ];
                case 1:
                    var rest$0 = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest$0)
                    ];
                case 2:
                    var rest$1 = fmtty$0[2], pad = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad, [
                        1,
                        fmtty_of_fmt(rest$1)
                    ]);
                case 3:
                    var rest$2 = fmtty$0[2], pad$0 = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad$0, [
                        1,
                        fmtty_of_fmt(rest$2)
                    ]);
                case 4:
                    var rest$3 = fmtty$0[4], prec = fmtty$0[3], pad$1 = fmtty$0[2], ty_rest = fmtty_of_fmt(rest$3), prec_ty = fmtty_of_precision_fmtty(prec, [
                        2,
                        ty_rest
                    ]);
                    return fmtty_of_padding_fmtty(pad$1, prec_ty);
                case 5:
                    var rest$4 = fmtty$0[4], prec$0 = fmtty$0[3], pad$2 = fmtty$0[2], ty_rest$0 = fmtty_of_fmt(rest$4), prec_ty$0 = fmtty_of_precision_fmtty(prec$0, [
                        3,
                        ty_rest$0
                    ]);
                    return fmtty_of_padding_fmtty(pad$2, prec_ty$0);
                case 6:
                    var rest$5 = fmtty$0[4], prec$1 = fmtty$0[3], pad$3 = fmtty$0[2], ty_rest$1 = fmtty_of_fmt(rest$5), prec_ty$1 = fmtty_of_precision_fmtty(prec$1, [
                        4,
                        ty_rest$1
                    ]);
                    return fmtty_of_padding_fmtty(pad$3, prec_ty$1);
                case 7:
                    var rest$6 = fmtty$0[4], prec$2 = fmtty$0[3], pad$4 = fmtty$0[2], ty_rest$2 = fmtty_of_fmt(rest$6), prec_ty$2 = fmtty_of_precision_fmtty(prec$2, [
                        5,
                        ty_rest$2
                    ]);
                    return fmtty_of_padding_fmtty(pad$4, prec_ty$2);
                case 8:
                    var rest$7 = fmtty$0[4], prec$3 = fmtty$0[3], pad$5 = fmtty$0[2], ty_rest$3 = fmtty_of_fmt(rest$7), prec_ty$3 = fmtty_of_precision_fmtty(prec$3, [
                        6,
                        ty_rest$3
                    ]);
                    return fmtty_of_padding_fmtty(pad$5, prec_ty$3);
                case 9:
                    var rest$8 = fmtty$0[2], pad$6 = fmtty$0[1];
                    return fmtty_of_padding_fmtty(pad$6, [
                        7,
                        fmtty_of_fmt(rest$8)
                    ]);
                case 10:
                    var fmtty$1 = fmtty$0[1];
                    fmtty$0 = fmtty$1;
                    break;
                case 11:
                    var fmtty$2 = fmtty$0[2];
                    fmtty$0 = fmtty$2;
                    break;
                case 12:
                    var fmtty$3 = fmtty$0[2];
                    fmtty$0 = fmtty$3;
                    break;
                case 13:
                    var rest$9 = fmtty$0[3], ty = fmtty$0[2];
                    return [
                        8,
                        ty,
                        fmtty_of_fmt(rest$9)
                    ];
                case 14:
                    var rest$10 = fmtty$0[3], ty$0 = fmtty$0[2];
                    return [
                        9,
                        ty$0,
                        ty$0,
                        fmtty_of_fmt(rest$10)
                    ];
                case 15:
                    var rest$11 = fmtty$0[1];
                    return [
                        10,
                        fmtty_of_fmt(rest$11)
                    ];
                case 16:
                    var rest$12 = fmtty$0[1];
                    return [
                        11,
                        fmtty_of_fmt(rest$12)
                    ];
                case 17:
                    var fmtty$4 = fmtty$0[2];
                    fmtty$0 = fmtty$4;
                    break;
                case 18:
                    var rest$13 = fmtty$0[2], formatting_gen = fmtty$0[1], _cB_ = fmtty_of_fmt(rest$13);
                    if (0 === formatting_gen[0]) var fmt = formatting_gen[1][1], _cC_ = fmtty_of_fmt(fmt);
                    else var fmt$0 = formatting_gen[1][1], _cC_ = fmtty_of_fmt(fmt$0);
                    return caml_call2(CamlinternalFormatBasics[1], _cC_, _cB_);
                case 19:
                    var rest$14 = fmtty$0[1];
                    return [
                        13,
                        fmtty_of_fmt(rest$14)
                    ];
                case 20:
                    var rest$15 = fmtty$0[3];
                    return [
                        1,
                        fmtty_of_fmt(rest$15)
                    ];
                case 21:
                    var rest$16 = fmtty$0[2];
                    return [
                        2,
                        fmtty_of_fmt(rest$16)
                    ];
                case 22:
                    var rest$17 = fmtty$0[1];
                    return [
                        0,
                        fmtty_of_fmt(rest$17)
                    ];
                case 23:
                    var fmtty$5 = fmtty$0[2], ign = fmtty$0[1];
                    if (typeof ign === "number") switch(ign){
                        case 0:
                            fmtty$0 = fmtty$5;
                            break;
                        case 1:
                            fmtty$0 = fmtty$5;
                            break;
                        case 2:
                            return [
                                14,
                                fmtty_of_fmt(fmtty$5)
                            ];
                        default:
                            fmtty$0 = fmtty$5;
                    }
                    else switch(ign[0]){
                        case 0:
                            fmtty$0 = fmtty$5;
                            break;
                        case 1:
                            fmtty$0 = fmtty$5;
                            break;
                        case 2:
                            fmtty$0 = fmtty$5;
                            break;
                        case 3:
                            fmtty$0 = fmtty$5;
                            break;
                        case 4:
                            fmtty$0 = fmtty$5;
                            break;
                        case 5:
                            fmtty$0 = fmtty$5;
                            break;
                        case 6:
                            fmtty$0 = fmtty$5;
                            break;
                        case 7:
                            fmtty$0 = fmtty$5;
                            break;
                        case 8:
                            fmtty$0 = fmtty$5;
                            break;
                        case 9:
                            var fmtty$6 = ign[2], _cD_ = fmtty_of_fmt(fmtty$5);
                            return caml_call2(CamlinternalFormatBasics[1], fmtty$6, _cD_);
                        case 10:
                            fmtty$0 = fmtty$5;
                            break;
                        default:
                            fmtty$0 = fmtty$5;
                    }
                    break;
                default:
                    var rest$18 = fmtty$0[3], arity = fmtty$0[1];
                    return fmtty_of_custom(arity, fmtty_of_fmt(rest$18));
            }
        }
    }
    function fmtty_of_custom(arity, fmtty) {
        if (!arity) return fmtty;
        var arity$0 = arity[1];
        return [
            12,
            fmtty_of_custom(arity$0, fmtty)
        ];
    }
    function fmtty_of_padding_fmtty(pad, fmtty) {
        return typeof pad === "number" ? fmtty : 0 === pad[0] ? fmtty : [
            2,
            fmtty
        ];
    }
    function fmtty_of_precision_fmtty(prec, fmtty) {
        return typeof prec === "number" ? prec ? [
            2,
            fmtty
        ] : fmtty : fmtty;
    }
    var Type_mismatch = [
        248,
        "CamlinternalFormat.Type_mismatch",
        runtime.caml_fresh_oo_id(0)
    ], cst_d = "%d", cst_d$0 = "%+d", cst_d$1 = "% d", cst_i$0 = cst_i$3, cst_i$1 = "%+i", cst_i$2 = "% i", cst_x = "%x", cst_x$0 = "%#x", cst_X = "%X", cst_X$0 = "%#X", cst_o = "%o", cst_o$0 = "%#o", cst_u = cst_u$0, cst_Ld = "%Ld", cst_Ld$0 = "%+Ld", cst_Ld$1 = "% Ld", cst_Li$0 = cst_Li$3, cst_Li$1 = "%+Li", cst_Li$2 = "% Li", cst_Lx = "%Lx", cst_Lx$0 = "%#Lx", cst_LX = "%LX", cst_LX$0 = "%#LX", cst_Lo = "%Lo", cst_Lo$0 = "%#Lo", cst_Lu = "%Lu", cst_ld = "%ld", cst_ld$0 = "%+ld", cst_ld$1 = "% ld", cst_li$0 = cst_li$3, cst_li$1 = "%+li", cst_li$2 = "% li", cst_lx = "%lx", cst_lx$0 = "%#lx", cst_lX = "%lX", cst_lX$0 = "%#lX", cst_lo = "%lo", cst_lo$0 = "%#lo", cst_lu = "%lu", cst_nd = "%nd", cst_nd$0 = "%+nd", cst_nd$1 = "% nd", cst_ni$0 = cst_ni$3, cst_ni$1 = "%+ni", cst_ni$2 = "% ni", cst_nx = "%nx", cst_nx$0 = "%#nx", cst_nX = "%nX", cst_nX$0 = "%#nX", cst_no = "%no", cst_no$0 = "%#no", cst_nu = "%nu", _r_ = [
        0,
        103
    ], cst_neg_infinity = "neg_infinity", cst_infinity = "infinity", cst_nan = "nan", _s_ = [
        0,
        cst_camlinternalFormat_ml,
        1558,
        4
    ], cst_Printf_bad_conversion = "Printf: bad conversion %[", _t_ = [
        0,
        cst_camlinternalFormat_ml,
        1626,
        39
    ], _u_ = [
        0,
        cst_camlinternalFormat_ml,
        1649,
        31
    ], _v_ = [
        0,
        cst_camlinternalFormat_ml,
        1650,
        31
    ], cst_Printf_bad_conversion$0 = "Printf: bad conversion %_", _w_ = [
        0,
        cst_camlinternalFormat_ml,
        1830,
        8
    ], _x_ = [
        0,
        0,
        4
    ], _y_ = [
        0,
        [
            11,
            "invalid box description ",
            [
                3,
                0,
                0
            ]
        ],
        "invalid box description %S"
    ], _z_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s"
    ], cst_non_zero_widths_are_unsupp = "non-zero widths are unsupported for %c conversions", _A_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", '",
                            [
                                0,
                                [
                                    11,
                                    "' without ",
                                    [
                                        2,
                                        0,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, '%c' without %s"
    ], _B_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                [
                                    11,
                                    " expected, read ",
                                    [
                                        1,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s expected, read %C"
    ], _C_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", duplicate flag ",
                            [
                                1,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, duplicate flag %C"
    ], cst_padding = "padding", _D_ = [
        0,
        1,
        0
    ], cst_0 = cst_0$3, _E_ = [
        0,
        0
    ], cst_precision = cst_precision$3, _F_ = [
        1,
        0
    ], _G_ = [
        1,
        1
    ], cst_precision$0 = cst_precision$3, _H_ = [
        1,
        1
    ], cst_precision$1 = cst_precision$3, cst_0$0 = cst_0$3, _I_ = [
        1,
        1
    ], cst_0$1 = cst_0$3, cst_0$2 = "'0'", _J_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ', invalid conversion "',
                            [
                                12,
                                37,
                                [
                                    0,
                                    [
                                        12,
                                        34,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'invalid format %S: at character number %d, invalid conversion "%%%c"'
    ], _K_ = [
        0,
        0
    ], cst_padding$0 = "`padding'", _L_ = [
        0,
        0
    ], cst_precision$2 = "`precision'", _M_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", flag ",
                            [
                                1,
                                [
                                    11,
                                    " is only allowed after the '",
                                    [
                                        12,
                                        37,
                                        [
                                            11,
                                            "', before padding and precision",
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, flag %C is only allowed after the '%%', before padding and precision"
    ], _N_ = [
        0,
        [
            12,
            64,
            0
        ]
    ], _O_ = [
        0,
        "@ ",
        1,
        0
    ], _P_ = [
        0,
        "@,",
        0,
        0
    ], _Q_ = [
        2,
        60
    ], _R_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ": '",
                    [
                        12,
                        37,
                        [
                            11,
                            "' alone is not accepted in character sets, use ",
                            [
                                12,
                                37,
                                [
                                    12,
                                    37,
                                    [
                                        11,
                                        " instead at position ",
                                        [
                                            4,
                                            0,
                                            0,
                                            0,
                                            [
                                                12,
                                                46,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: '%%' alone is not accepted in character sets, use %%%% instead at position %d."
    ], _S_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ": integer ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " is greater than the limit ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: integer %d is greater than the limit %d"
    ], _T_1 = [
        0,
        cst_camlinternalFormat_ml,
        2837,
        11
    ], cst_digit = "digit", _U_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    ': unclosed sub-format, expected "',
                    [
                        12,
                        37,
                        [
                            0,
                            [
                                11,
                                '" at character number ',
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'invalid format %S: unclosed sub-format, expected "%%%c" at character number %d'
    ], cst_character = "character ')'", cst_character$0 = "character '}'", _V_ = [
        0,
        cst_camlinternalFormat_ml,
        2899,
        34
    ], _W_ = [
        0,
        cst_camlinternalFormat_ml,
        2935,
        28
    ], _X_ = [
        0,
        cst_camlinternalFormat_ml,
        2957,
        11
    ], _Y_ = [
        0,
        [
            11,
            cst_invalid_format,
            [
                3,
                0,
                [
                    11,
                    cst_at_character_number,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst$44,
                            [
                                2,
                                0,
                                [
                                    11,
                                    " is incompatible with '",
                                    [
                                        0,
                                        [
                                            11,
                                            "' in sub-format ",
                                            [
                                                3,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "invalid format %S: at character number %d, %s is incompatible with '%c' in sub-format %S"
    ], _Z_ = [
        0,
        [
            11,
            cst_bad_input_format_type_mism,
            [
                3,
                0,
                [
                    11,
                    cst_and,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_bad_input_format_type_mism$0
    ], ___ = [
        0,
        [
            11,
            cst_bad_input_format_type_mism,
            [
                3,
                0,
                [
                    11,
                    cst_and,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_bad_input_format_type_mism$0
    ];
    function type_padding(pad, fmtty) {
        if (typeof pad === "number") return [
            0,
            0,
            fmtty
        ];
        if (0 === pad[0]) {
            var w = pad[2], padty = pad[1];
            return [
                0,
                [
                    0,
                    padty,
                    w
                ],
                fmtty
            ];
        }
        if (typeof fmtty !== "number" && 2 === fmtty[0]) {
            var rest = fmtty[1], padty$0 = pad[1];
            return [
                0,
                [
                    1,
                    padty$0
                ],
                rest
            ];
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_padprec(pad, prec, fmtty) {
        var match = type_padding(pad, fmtty);
        if (typeof prec !== "number") {
            var rest$1 = match[2], pad$2 = match[1], p = prec[1];
            return [
                0,
                pad$2,
                [
                    0,
                    p
                ],
                rest$1
            ];
        }
        if (!prec) {
            var rest$0 = match[2], pad$1 = match[1];
            return [
                0,
                pad$1,
                0,
                rest$0
            ];
        }
        var match$0 = match[2];
        if (typeof match$0 !== "number" && 2 === match$0[0]) {
            var rest = match$0[1], pad$0 = match[1];
            return [
                0,
                pad$0,
                1,
                rest
            ];
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_format(fmt, fmtty) {
        var _cA_ = type_format_gen(fmt, fmtty);
        if (typeof _cA_[2] !== "number") throw caml_maybe_attach_backtrace(Type_mismatch, 1);
        var fmt$0 = _cA_[1];
        return fmt$0;
    }
    function type_format_gen(fmt, fmtty0) {
        if (typeof fmt === "number") return [
            0,
            0,
            fmtty0
        ];
        switch(fmt[0]){
            case 0:
                if (typeof fmtty0 !== "number" && 0 === fmtty0[0]) {
                    var fmtty_rest = fmtty0[1], fmt_rest = fmt[1], match = type_format_gen(fmt_rest, fmtty_rest), fmtty = match[2], fmt$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            fmt$0
                        ],
                        fmtty
                    ];
                }
                break;
            case 1:
                if (typeof fmtty0 !== "number" && 0 === fmtty0[0]) {
                    var fmtty_rest$0 = fmtty0[1], fmt_rest$0 = fmt[1], match$0 = type_format_gen(fmt_rest$0, fmtty_rest$0), fmtty$0 = match$0[2], fmt$1 = match$0[1];
                    return [
                        0,
                        [
                            1,
                            fmt$1
                        ],
                        fmtty$0
                    ];
                }
                break;
            case 2:
                var fmt_rest$1 = fmt[2], pad = fmt[1], match$1 = type_padding(pad, fmtty0), pad$0 = match$1[1], match$2 = match$1[2];
                if (typeof match$2 !== "number" && 1 === match$2[0]) {
                    var fmtty_rest$1 = match$2[1], match$3 = type_format_gen(fmt_rest$1, fmtty_rest$1), fmtty$1 = match$3[2], fmt$2 = match$3[1];
                    return [
                        0,
                        [
                            2,
                            pad$0,
                            fmt$2
                        ],
                        fmtty$1
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 3:
                var fmt_rest$2 = fmt[2], pad$1 = fmt[1], match$4 = type_padding(pad$1, fmtty0), pad$2 = match$4[1], match$5 = match$4[2];
                if (typeof match$5 !== "number" && 1 === match$5[0]) {
                    var fmtty_rest$2 = match$5[1], match$6 = type_format_gen(fmt_rest$2, fmtty_rest$2), fmtty$2 = match$6[2], fmt$3 = match$6[1];
                    return [
                        0,
                        [
                            3,
                            pad$2,
                            fmt$3
                        ],
                        fmtty$2
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 4:
                var fmt_rest$3 = fmt[4], prec = fmt[3], pad$3 = fmt[2], iconv = fmt[1], match$7 = type_padprec(pad$3, prec, fmtty0), pad$4 = match$7[1], match$8 = match$7[3];
                if (typeof match$8 !== "number" && 2 === match$8[0]) {
                    var fmtty_rest$3 = match$8[1], prec$0 = match$7[2], match$9 = type_format_gen(fmt_rest$3, fmtty_rest$3), fmtty$3 = match$9[2], fmt$4 = match$9[1];
                    return [
                        0,
                        [
                            4,
                            iconv,
                            pad$4,
                            prec$0,
                            fmt$4
                        ],
                        fmtty$3
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 5:
                var fmt_rest$4 = fmt[4], prec$1 = fmt[3], pad$5 = fmt[2], iconv$0 = fmt[1], match$10 = type_padprec(pad$5, prec$1, fmtty0), pad$6 = match$10[1], match$11 = match$10[3];
                if (typeof match$11 !== "number" && 3 === match$11[0]) {
                    var fmtty_rest$4 = match$11[1], prec$2 = match$10[2], match$12 = type_format_gen(fmt_rest$4, fmtty_rest$4), fmtty$4 = match$12[2], fmt$5 = match$12[1];
                    return [
                        0,
                        [
                            5,
                            iconv$0,
                            pad$6,
                            prec$2,
                            fmt$5
                        ],
                        fmtty$4
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 6:
                var fmt_rest$5 = fmt[4], prec$3 = fmt[3], pad$7 = fmt[2], iconv$1 = fmt[1], match$13 = type_padprec(pad$7, prec$3, fmtty0), pad$8 = match$13[1], match$14 = match$13[3];
                if (typeof match$14 !== "number" && 4 === match$14[0]) {
                    var fmtty_rest$5 = match$14[1], prec$4 = match$13[2], match$15 = type_format_gen(fmt_rest$5, fmtty_rest$5), fmtty$5 = match$15[2], fmt$6 = match$15[1];
                    return [
                        0,
                        [
                            6,
                            iconv$1,
                            pad$8,
                            prec$4,
                            fmt$6
                        ],
                        fmtty$5
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 7:
                var fmt_rest$6 = fmt[4], prec$5 = fmt[3], pad$9 = fmt[2], iconv$2 = fmt[1], match$16 = type_padprec(pad$9, prec$5, fmtty0), pad$10 = match$16[1], match$17 = match$16[3];
                if (typeof match$17 !== "number" && 5 === match$17[0]) {
                    var fmtty_rest$6 = match$17[1], prec$6 = match$16[2], match$18 = type_format_gen(fmt_rest$6, fmtty_rest$6), fmtty$6 = match$18[2], fmt$7 = match$18[1];
                    return [
                        0,
                        [
                            7,
                            iconv$2,
                            pad$10,
                            prec$6,
                            fmt$7
                        ],
                        fmtty$6
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 8:
                var fmt_rest$7 = fmt[4], prec$7 = fmt[3], pad$11 = fmt[2], fconv = fmt[1], match$19 = type_padprec(pad$11, prec$7, fmtty0), pad$12 = match$19[1], match$20 = match$19[3];
                if (typeof match$20 !== "number" && 6 === match$20[0]) {
                    var fmtty_rest$7 = match$20[1], prec$8 = match$19[2], match$21 = type_format_gen(fmt_rest$7, fmtty_rest$7), fmtty$7 = match$21[2], fmt$8 = match$21[1];
                    return [
                        0,
                        [
                            8,
                            fconv,
                            pad$12,
                            prec$8,
                            fmt$8
                        ],
                        fmtty$7
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 9:
                var fmt_rest$8 = fmt[2], pad$13 = fmt[1], match$22 = type_padding(pad$13, fmtty0), pad$14 = match$22[1], match$23 = match$22[2];
                if (typeof match$23 !== "number" && 7 === match$23[0]) {
                    var fmtty_rest$8 = match$23[1], match$24 = type_format_gen(fmt_rest$8, fmtty_rest$8), fmtty$8 = match$24[2], fmt$9 = match$24[1];
                    return [
                        0,
                        [
                            9,
                            pad$14,
                            fmt$9
                        ],
                        fmtty$8
                    ];
                }
                throw caml_maybe_attach_backtrace(Type_mismatch, 1);
            case 10:
                var fmt_rest$9 = fmt[1], match$25 = type_format_gen(fmt_rest$9, fmtty0), fmtty$9 = match$25[2], fmt$10 = match$25[1];
                return [
                    0,
                    [
                        10,
                        fmt$10
                    ],
                    fmtty$9
                ];
            case 11:
                var fmt_rest$10 = fmt[2], str = fmt[1], match$26 = type_format_gen(fmt_rest$10, fmtty0), fmtty$10 = match$26[2], fmt$11 = match$26[1];
                return [
                    0,
                    [
                        11,
                        str,
                        fmt$11
                    ],
                    fmtty$10
                ];
            case 12:
                var fmt_rest$11 = fmt[2], chr = fmt[1], match$27 = type_format_gen(fmt_rest$11, fmtty0), fmtty$11 = match$27[2], fmt$12 = match$27[1];
                return [
                    0,
                    [
                        12,
                        chr,
                        fmt$12
                    ],
                    fmtty$11
                ];
            case 13:
                if (typeof fmtty0 !== "number" && 8 === fmtty0[0]) {
                    var fmtty_rest$9 = fmtty0[2], sub_fmtty = fmtty0[1], fmt_rest$12 = fmt[3], sub_fmtty$0 = fmt[2], pad_opt = fmt[1];
                    if (caml_notequal([
                        0,
                        sub_fmtty$0
                    ], [
                        0,
                        sub_fmtty
                    ])) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$28 = type_format_gen(fmt_rest$12, fmtty_rest$9), fmtty$12 = match$28[2], fmt$13 = match$28[1];
                    return [
                        0,
                        [
                            13,
                            pad_opt,
                            sub_fmtty,
                            fmt$13
                        ],
                        fmtty$12
                    ];
                }
                break;
            case 14:
                if (typeof fmtty0 !== "number" && 9 === fmtty0[0]) {
                    var fmtty_rest$10 = fmtty0[3], sub_fmtty1 = fmtty0[1], fmt_rest$13 = fmt[3], sub_fmtty$1 = fmt[2], pad_opt$0 = fmt[1], _cy_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub_fmtty1)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub_fmtty$1)
                    ], _cy_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$29 = type_format_gen(fmt_rest$13, caml_call1(CamlinternalFormatBasics[2], fmtty_rest$10)), fmtty$13 = match$29[2], fmt$14 = match$29[1];
                    return [
                        0,
                        [
                            14,
                            pad_opt$0,
                            sub_fmtty1,
                            fmt$14
                        ],
                        fmtty$13
                    ];
                }
                break;
            case 15:
                if (typeof fmtty0 !== "number" && 10 === fmtty0[0]) {
                    var fmtty_rest$11 = fmtty0[1], fmt_rest$14 = fmt[1], match$30 = type_format_gen(fmt_rest$14, fmtty_rest$11), fmtty$14 = match$30[2], fmt$15 = match$30[1];
                    return [
                        0,
                        [
                            15,
                            fmt$15
                        ],
                        fmtty$14
                    ];
                }
                break;
            case 16:
                if (typeof fmtty0 !== "number" && 11 === fmtty0[0]) {
                    var fmtty_rest$12 = fmtty0[1], fmt_rest$15 = fmt[1], match$31 = type_format_gen(fmt_rest$15, fmtty_rest$12), fmtty$15 = match$31[2], fmt$16 = match$31[1];
                    return [
                        0,
                        [
                            16,
                            fmt$16
                        ],
                        fmtty$15
                    ];
                }
                break;
            case 17:
                var fmt_rest$16 = fmt[2], formatting_lit = fmt[1], match$32 = type_format_gen(fmt_rest$16, fmtty0), fmtty$16 = match$32[2], fmt$17 = match$32[1];
                return [
                    0,
                    [
                        17,
                        formatting_lit,
                        fmt$17
                    ],
                    fmtty$16
                ];
            case 18:
                var fmt_rest$17 = fmt[2], formatting_gen = fmt[1];
                if (0 === formatting_gen[0]) {
                    var match$36 = formatting_gen[1], str$0 = match$36[2], fmt1 = match$36[1], match$37 = type_format_gen(fmt1, fmtty0), fmtty2 = match$37[2], fmt2 = match$37[1], match$38 = type_format_gen(fmt_rest$17, fmtty2), fmtty3 = match$38[2], fmt3 = match$38[1];
                    return [
                        0,
                        [
                            18,
                            [
                                0,
                                [
                                    0,
                                    fmt2,
                                    str$0
                                ]
                            ],
                            fmt3
                        ],
                        fmtty3
                    ];
                }
                var match$39 = formatting_gen[1], str$1 = match$39[2], fmt1$0 = match$39[1], match$40 = type_format_gen(fmt1$0, fmtty0), fmtty2$0 = match$40[2], fmt2$0 = match$40[1], match$41 = type_format_gen(fmt_rest$17, fmtty2$0), fmtty3$0 = match$41[2], fmt3$0 = match$41[1];
                return [
                    0,
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                fmt2$0,
                                str$1
                            ]
                        ],
                        fmt3$0
                    ],
                    fmtty3$0
                ];
            case 19:
                if (typeof fmtty0 !== "number" && 13 === fmtty0[0]) {
                    var fmtty_rest$13 = fmtty0[1], fmt_rest$18 = fmt[1], match$33 = type_format_gen(fmt_rest$18, fmtty_rest$13), fmtty$17 = match$33[2], fmt$18 = match$33[1];
                    return [
                        0,
                        [
                            19,
                            fmt$18
                        ],
                        fmtty$17
                    ];
                }
                break;
            case 20:
                if (typeof fmtty0 !== "number" && 1 === fmtty0[0]) {
                    var fmtty_rest$14 = fmtty0[1], fmt_rest$19 = fmt[3], char_set = fmt[2], width_opt = fmt[1], match$34 = type_format_gen(fmt_rest$19, fmtty_rest$14), fmtty$18 = match$34[2], fmt$19 = match$34[1];
                    return [
                        0,
                        [
                            20,
                            width_opt,
                            char_set,
                            fmt$19
                        ],
                        fmtty$18
                    ];
                }
                break;
            case 21:
                if (typeof fmtty0 !== "number" && 2 === fmtty0[0]) {
                    var fmtty_rest$15 = fmtty0[1], fmt_rest$20 = fmt[2], counter = fmt[1], match$35 = type_format_gen(fmt_rest$20, fmtty_rest$15), fmtty$19 = match$35[2], fmt$20 = match$35[1];
                    return [
                        0,
                        [
                            21,
                            counter,
                            fmt$20
                        ],
                        fmtty$19
                    ];
                }
                break;
            case 23:
                var rest = fmt[2], ign = fmt[1];
                if (typeof ign !== "number") switch(ign[0]){
                    case 0:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 1:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 2:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 3:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 4:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 5:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 6:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 7:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 8:
                        var sub_fmtty$2 = ign[2], pad_opt$1 = ign[1];
                        return type_ignored_param_one([
                            8,
                            pad_opt$1,
                            sub_fmtty$2
                        ], rest, fmtty0);
                    case 9:
                        var sub_fmtty$3 = ign[2], pad_opt$2 = ign[1], _cz_ = type_ignored_format_substituti(sub_fmtty$3, rest, fmtty0), match$43 = _cz_[2], fmtty$21 = match$43[2], fmt$22 = match$43[1], sub_fmtty$4 = _cz_[1];
                        return [
                            0,
                            [
                                23,
                                [
                                    9,
                                    pad_opt$2,
                                    sub_fmtty$4
                                ],
                                fmt$22
                            ],
                            fmtty$21
                        ];
                    case 10:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    default:
                        return type_ignored_param_one(ign, rest, fmtty0);
                }
                switch(ign){
                    case 0:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 1:
                        return type_ignored_param_one(ign, rest, fmtty0);
                    case 2:
                        if (typeof fmtty0 !== "number" && 14 === fmtty0[0]) {
                            var fmtty_rest$16 = fmtty0[1], match$42 = type_format_gen(rest, fmtty_rest$16), fmtty$20 = match$42[2], fmt$21 = match$42[1];
                            return [
                                0,
                                [
                                    23,
                                    2,
                                    fmt$21
                                ],
                                fmtty$20
                            ];
                        }
                        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    default:
                        return type_ignored_param_one(ign, rest, fmtty0);
                }
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function type_ignored_param_one(ign, fmt, fmtty) {
        var match = type_format_gen(fmt, fmtty), fmtty$0 = match[2], fmt$0 = match[1];
        return [
            0,
            [
                23,
                ign,
                fmt$0
            ],
            fmtty$0
        ];
    }
    function type_ignored_format_substituti(sub_fmtty, fmt, fmtty) {
        if (typeof sub_fmtty === "number") return [
            0,
            0,
            type_format_gen(fmt, fmtty)
        ];
        switch(sub_fmtty[0]){
            case 0:
                if (typeof fmtty !== "number" && 0 === fmtty[0]) {
                    var fmtty_rest = fmtty[1], sub_fmtty_rest = sub_fmtty[1], match = type_ignored_format_substituti(sub_fmtty_rest, fmt, fmtty_rest), fmt$0 = match[2], sub_fmtty_rest$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            sub_fmtty_rest$0
                        ],
                        fmt$0
                    ];
                }
                break;
            case 1:
                if (typeof fmtty !== "number" && 1 === fmtty[0]) {
                    var fmtty_rest$0 = fmtty[1], sub_fmtty_rest$1 = sub_fmtty[1], match$0 = type_ignored_format_substituti(sub_fmtty_rest$1, fmt, fmtty_rest$0), fmt$1 = match$0[2], sub_fmtty_rest$2 = match$0[1];
                    return [
                        0,
                        [
                            1,
                            sub_fmtty_rest$2
                        ],
                        fmt$1
                    ];
                }
                break;
            case 2:
                if (typeof fmtty !== "number" && 2 === fmtty[0]) {
                    var fmtty_rest$1 = fmtty[1], sub_fmtty_rest$3 = sub_fmtty[1], match$1 = type_ignored_format_substituti(sub_fmtty_rest$3, fmt, fmtty_rest$1), fmt$2 = match$1[2], sub_fmtty_rest$4 = match$1[1];
                    return [
                        0,
                        [
                            2,
                            sub_fmtty_rest$4
                        ],
                        fmt$2
                    ];
                }
                break;
            case 3:
                if (typeof fmtty !== "number" && 3 === fmtty[0]) {
                    var fmtty_rest$2 = fmtty[1], sub_fmtty_rest$5 = sub_fmtty[1], match$2 = type_ignored_format_substituti(sub_fmtty_rest$5, fmt, fmtty_rest$2), fmt$3 = match$2[2], sub_fmtty_rest$6 = match$2[1];
                    return [
                        0,
                        [
                            3,
                            sub_fmtty_rest$6
                        ],
                        fmt$3
                    ];
                }
                break;
            case 4:
                if (typeof fmtty !== "number" && 4 === fmtty[0]) {
                    var fmtty_rest$3 = fmtty[1], sub_fmtty_rest$7 = sub_fmtty[1], match$3 = type_ignored_format_substituti(sub_fmtty_rest$7, fmt, fmtty_rest$3), fmt$4 = match$3[2], sub_fmtty_rest$8 = match$3[1];
                    return [
                        0,
                        [
                            4,
                            sub_fmtty_rest$8
                        ],
                        fmt$4
                    ];
                }
                break;
            case 5:
                if (typeof fmtty !== "number" && 5 === fmtty[0]) {
                    var fmtty_rest$4 = fmtty[1], sub_fmtty_rest$9 = sub_fmtty[1], match$4 = type_ignored_format_substituti(sub_fmtty_rest$9, fmt, fmtty_rest$4), fmt$5 = match$4[2], sub_fmtty_rest$10 = match$4[1];
                    return [
                        0,
                        [
                            5,
                            sub_fmtty_rest$10
                        ],
                        fmt$5
                    ];
                }
                break;
            case 6:
                if (typeof fmtty !== "number" && 6 === fmtty[0]) {
                    var fmtty_rest$5 = fmtty[1], sub_fmtty_rest$11 = sub_fmtty[1], match$5 = type_ignored_format_substituti(sub_fmtty_rest$11, fmt, fmtty_rest$5), fmt$6 = match$5[2], sub_fmtty_rest$12 = match$5[1];
                    return [
                        0,
                        [
                            6,
                            sub_fmtty_rest$12
                        ],
                        fmt$6
                    ];
                }
                break;
            case 7:
                if (typeof fmtty !== "number" && 7 === fmtty[0]) {
                    var fmtty_rest$6 = fmtty[1], sub_fmtty_rest$13 = sub_fmtty[1], match$6 = type_ignored_format_substituti(sub_fmtty_rest$13, fmt, fmtty_rest$6), fmt$7 = match$6[2], sub_fmtty_rest$14 = match$6[1];
                    return [
                        0,
                        [
                            7,
                            sub_fmtty_rest$14
                        ],
                        fmt$7
                    ];
                }
                break;
            case 8:
                if (typeof fmtty !== "number" && 8 === fmtty[0]) {
                    var fmtty_rest$7 = fmtty[2], sub2_fmtty = fmtty[1], sub_fmtty_rest$15 = sub_fmtty[2], sub2_fmtty$0 = sub_fmtty[1];
                    if (caml_notequal([
                        0,
                        sub2_fmtty$0
                    ], [
                        0,
                        sub2_fmtty
                    ])) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var match$7 = type_ignored_format_substituti(sub_fmtty_rest$15, fmt, fmtty_rest$7), fmt$8 = match$7[2], sub_fmtty_rest$16 = match$7[1];
                    return [
                        0,
                        [
                            8,
                            sub2_fmtty,
                            sub_fmtty_rest$16
                        ],
                        fmt$8
                    ];
                }
                break;
            case 9:
                if (typeof fmtty !== "number" && 9 === fmtty[0]) {
                    var fmtty_rest$8 = fmtty[3], sub2_fmtty$1 = fmtty[2], sub1_fmtty = fmtty[1], sub_fmtty_rest$17 = sub_fmtty[3], sub2_fmtty$2 = sub_fmtty[2], sub1_fmtty$0 = sub_fmtty[1], _cw_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub1_fmtty)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub1_fmtty$0)
                    ], _cw_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var _cx_ = [
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub2_fmtty$1)
                    ];
                    if (caml_notequal([
                        0,
                        caml_call1(CamlinternalFormatBasics[2], sub2_fmtty$2)
                    ], _cx_)) throw caml_maybe_attach_backtrace(Type_mismatch, 1);
                    var sub_fmtty$0 = trans(symm(sub1_fmtty), sub2_fmtty$1), match$8 = fmtty_rel_det(sub_fmtty$0), f4 = match$8[4], f2 = match$8[2];
                    f2(0);
                    f4(0);
                    var match$9 = type_ignored_format_substituti(caml_call1(CamlinternalFormatBasics[2], sub_fmtty_rest$17), fmt, fmtty_rest$8), fmt$9 = match$9[2], sub_fmtty_rest$18 = match$9[1];
                    return [
                        0,
                        [
                            9,
                            sub1_fmtty,
                            sub2_fmtty$1,
                            symm(sub_fmtty_rest$18)
                        ],
                        fmt$9
                    ];
                }
                break;
            case 10:
                if (typeof fmtty !== "number" && 10 === fmtty[0]) {
                    var fmtty_rest$9 = fmtty[1], sub_fmtty_rest$19 = sub_fmtty[1], match$10 = type_ignored_format_substituti(sub_fmtty_rest$19, fmt, fmtty_rest$9), fmt$10 = match$10[2], sub_fmtty_rest$20 = match$10[1];
                    return [
                        0,
                        [
                            10,
                            sub_fmtty_rest$20
                        ],
                        fmt$10
                    ];
                }
                break;
            case 11:
                if (typeof fmtty !== "number" && 11 === fmtty[0]) {
                    var fmtty_rest$10 = fmtty[1], sub_fmtty_rest$21 = sub_fmtty[1], match$11 = type_ignored_format_substituti(sub_fmtty_rest$21, fmt, fmtty_rest$10), fmt$11 = match$11[2], sub_fmtty_rest$22 = match$11[1];
                    return [
                        0,
                        [
                            11,
                            sub_fmtty_rest$22
                        ],
                        fmt$11
                    ];
                }
                break;
            case 13:
                if (typeof fmtty !== "number" && 13 === fmtty[0]) {
                    var fmtty_rest$11 = fmtty[1], sub_fmtty_rest$23 = sub_fmtty[1], match$12 = type_ignored_format_substituti(sub_fmtty_rest$23, fmt, fmtty_rest$11), fmt$12 = match$12[2], sub_fmtty_rest$24 = match$12[1];
                    return [
                        0,
                        [
                            13,
                            sub_fmtty_rest$24
                        ],
                        fmt$12
                    ];
                }
                break;
            case 14:
                if (typeof fmtty !== "number" && 14 === fmtty[0]) {
                    var fmtty_rest$12 = fmtty[1], sub_fmtty_rest$25 = sub_fmtty[1], match$13 = type_ignored_format_substituti(sub_fmtty_rest$25, fmt, fmtty_rest$12), fmt$13 = match$13[2], sub_fmtty_rest$26 = match$13[1];
                    return [
                        0,
                        [
                            14,
                            sub_fmtty_rest$26
                        ],
                        fmt$13
                    ];
                }
                break;
        }
        throw caml_maybe_attach_backtrace(Type_mismatch, 1);
    }
    function recast(fmt, fmtty) {
        var _cv_ = symm(fmtty);
        return type_format(fmt, caml_call1(CamlinternalFormatBasics[2], _cv_));
    }
    function fix_padding(padty, width, str) {
        var len = caml_ml_string_length(str), padty$0 = 0 <= width ? padty : 0, width$0 = caml_call1(Stdlib[18], width);
        if (width$0 <= len) return str;
        var _cu_ = 2 === padty$0 ? 48 : 32, res = caml_call2(Stdlib_Bytes[1], width$0, _cu_);
        switch(padty$0){
            case 0:
                caml_call5(Stdlib_String[6], str, 0, res, 0, len);
                break;
            case 1:
                caml_call5(Stdlib_String[6], str, 0, res, width$0 - len | 0, len);
                break;
            default:
                a: if (0 < len) {
                    if (43 !== caml_string_get(str, 0) && 45 !== caml_string_get(str, 0) && 32 !== caml_string_get(str, 0)) break a;
                    caml_bytes_set(res, 0, caml_string_get(str, 0));
                    caml_call5(Stdlib_String[6], str, 1, res, (width$0 - len | 0) + 1 | 0, len - 1 | 0);
                    break;
                }
                a: if (1 < len && 48 === caml_string_get(str, 0)) {
                    if (120 !== caml_string_get(str, 1) && 88 !== caml_string_get(str, 1)) break a;
                    caml_bytes_set(res, 1, caml_string_get(str, 1));
                    caml_call5(Stdlib_String[6], str, 2, res, (width$0 - len | 0) + 2 | 0, len - 2 | 0);
                    break;
                }
                caml_call5(Stdlib_String[6], str, 0, res, width$0 - len | 0, len);
        }
        return caml_call1(Stdlib_Bytes[44], res);
    }
    function fix_int_precision(prec, str) {
        var prec$0 = caml_call1(Stdlib[18], prec), len = caml_ml_string_length(str), c = caml_string_get(str, 0);
        a: {
            b: {
                if (58 > c) {
                    if (32 !== c) {
                        if (43 > c) break a;
                        switch(c - 43 | 0){
                            case 5:
                                c: if (len < (prec$0 + 2 | 0) && 1 < len) {
                                    if (120 !== caml_string_get(str, 1) && 88 !== caml_string_get(str, 1)) break c;
                                    var res$1 = caml_call2(Stdlib_Bytes[1], prec$0 + 2 | 0, 48);
                                    caml_bytes_set(res$1, 1, caml_string_get(str, 1));
                                    caml_call5(Stdlib_String[6], str, 2, res$1, (prec$0 - len | 0) + 4 | 0, len - 2 | 0);
                                    return caml_call1(Stdlib_Bytes[44], res$1);
                                }
                                break b;
                            case 0:
                            case 2:
                                break;
                            case 1:
                            case 3:
                            case 4:
                                break a;
                            default:
                                break b;
                        }
                    }
                    if (len >= (prec$0 + 1 | 0)) break a;
                    var res$0 = caml_call2(Stdlib_Bytes[1], prec$0 + 1 | 0, 48);
                    caml_bytes_set(res$0, 0, c);
                    caml_call5(Stdlib_String[6], str, 1, res$0, (prec$0 - len | 0) + 2 | 0, len - 1 | 0);
                    return caml_call1(Stdlib_Bytes[44], res$0);
                }
                if (71 <= c) {
                    if (5 < c - 97 >>> 0) break a;
                } else if (65 > c) break a;
            }
            if (len < prec$0) {
                var res = caml_call2(Stdlib_Bytes[1], prec$0, 48);
                caml_call5(Stdlib_String[6], str, 0, res, prec$0 - len | 0, len);
                return caml_call1(Stdlib_Bytes[44], res);
            }
        }
        return str;
    }
    function string_to_caml_string(str) {
        var str$0 = caml_call1(Stdlib_String[25], str), l = caml_ml_string_length(str$0), res = caml_call2(Stdlib_Bytes[1], l + 2 | 0, 34);
        caml_blit_string(str$0, 0, res, 1, l);
        return caml_call1(Stdlib_Bytes[44], res);
    }
    function format_of_fconv(fconv, prec) {
        var prec$0 = caml_call1(Stdlib[18], prec), symb = char_of_fconv(_r_, fconv), buf = buffer_create(16);
        buffer_add_char(buf, 37);
        bprint_fconv_flag(buf, fconv);
        buffer_add_char(buf, 46);
        buffer_add_string(buf, caml_call1(Stdlib_Int[12], prec$0));
        buffer_add_char(buf, symb);
        return buffer_contents(buf);
    }
    function transform_int_alt(iconv, s) {
        if (13 > iconv) return s;
        var n = [
            0,
            0
        ], _cp_ = caml_ml_string_length(s) - 1 | 0, _co_ = 0;
        if (_cp_ >= 0) {
            var i$0 = _co_;
            for(;;){
                if (9 >= caml_string_unsafe_get(s, i$0) - 48 >>> 0) n[1]++;
                var _ct_ = i$0 + 1 | 0;
                if (_cp_ === i$0) break;
                i$0 = _ct_;
            }
        }
        var digits = n[1], buf = caml_create_bytes(caml_ml_string_length(s) + ((digits - 1 | 0) / 3 | 0) | 0), pos = [
            0,
            0
        ];
        function put(c) {
            caml_bytes_set(buf, pos[1], c);
            pos[1]++;
        }
        var left = [
            0,
            ((digits - 1 | 0) % 3 | 0) + 1 | 0
        ], _cr_ = caml_ml_string_length(s) - 1 | 0, _cq_ = 0;
        if (_cr_ >= 0) {
            var i = _cq_;
            for(;;){
                var c = caml_string_unsafe_get(s, i);
                if (9 < c - 48 >>> 0) put(c);
                else {
                    if (0 === left[1]) {
                        put(95);
                        left[1] = 3;
                    }
                    left[1]--;
                    put(c);
                }
                var _cs_ = i + 1 | 0;
                if (_cr_ === i) break;
                i = _cs_;
            }
        }
        return caml_call1(Stdlib_Bytes[44], buf);
    }
    function convert_int(iconv, n) {
        switch(iconv){
            case 1:
                var _cn_ = cst_d$0;
                break;
            case 2:
                var _cn_ = cst_d$1;
                break;
            case 4:
                var _cn_ = cst_i$1;
                break;
            case 5:
                var _cn_ = cst_i$2;
                break;
            case 6:
                var _cn_ = cst_x;
                break;
            case 7:
                var _cn_ = cst_x$0;
                break;
            case 8:
                var _cn_ = cst_X;
                break;
            case 9:
                var _cn_ = cst_X$0;
                break;
            case 10:
                var _cn_ = cst_o;
                break;
            case 11:
                var _cn_ = cst_o$0;
                break;
            case 0:
            case 13:
                var _cn_ = cst_d;
                break;
            case 3:
            case 14:
                var _cn_ = cst_i$0;
                break;
            default:
                var _cn_ = cst_u;
        }
        return transform_int_alt(iconv, caml_format_int(_cn_, n));
    }
    function convert_int32(iconv, n) {
        switch(iconv){
            case 1:
                var _cm_ = cst_ld$0;
                break;
            case 2:
                var _cm_ = cst_ld$1;
                break;
            case 4:
                var _cm_ = cst_li$1;
                break;
            case 5:
                var _cm_ = cst_li$2;
                break;
            case 6:
                var _cm_ = cst_lx;
                break;
            case 7:
                var _cm_ = cst_lx$0;
                break;
            case 8:
                var _cm_ = cst_lX;
                break;
            case 9:
                var _cm_ = cst_lX$0;
                break;
            case 10:
                var _cm_ = cst_lo;
                break;
            case 11:
                var _cm_ = cst_lo$0;
                break;
            case 0:
            case 13:
                var _cm_ = cst_ld;
                break;
            case 3:
            case 14:
                var _cm_ = cst_li$0;
                break;
            default:
                var _cm_ = cst_lu;
        }
        return transform_int_alt(iconv, caml_format_int(_cm_, n));
    }
    function convert_nativeint(iconv, n) {
        switch(iconv){
            case 1:
                var _cl_ = cst_nd$0;
                break;
            case 2:
                var _cl_ = cst_nd$1;
                break;
            case 4:
                var _cl_ = cst_ni$1;
                break;
            case 5:
                var _cl_ = cst_ni$2;
                break;
            case 6:
                var _cl_ = cst_nx;
                break;
            case 7:
                var _cl_ = cst_nx$0;
                break;
            case 8:
                var _cl_ = cst_nX;
                break;
            case 9:
                var _cl_ = cst_nX$0;
                break;
            case 10:
                var _cl_ = cst_no;
                break;
            case 11:
                var _cl_ = cst_no$0;
                break;
            case 0:
            case 13:
                var _cl_ = cst_nd;
                break;
            case 3:
            case 14:
                var _cl_ = cst_ni$0;
                break;
            default:
                var _cl_ = cst_nu;
        }
        return transform_int_alt(iconv, caml_format_int(_cl_, n));
    }
    function convert_int64(iconv, n) {
        switch(iconv){
            case 1:
                var _ck_ = cst_Ld$0;
                break;
            case 2:
                var _ck_ = cst_Ld$1;
                break;
            case 4:
                var _ck_ = cst_Li$1;
                break;
            case 5:
                var _ck_ = cst_Li$2;
                break;
            case 6:
                var _ck_ = cst_Lx;
                break;
            case 7:
                var _ck_ = cst_Lx$0;
                break;
            case 8:
                var _ck_ = cst_LX;
                break;
            case 9:
                var _ck_ = cst_LX$0;
                break;
            case 10:
                var _ck_ = cst_Lo;
                break;
            case 11:
                var _ck_ = cst_Lo$0;
                break;
            case 0:
            case 13:
                var _ck_ = cst_Ld;
                break;
            case 3:
            case 14:
                var _ck_ = cst_Li$0;
                break;
            default:
                var _ck_ = cst_Lu;
        }
        return transform_int_alt(iconv, runtime.caml_int64_format(_ck_, n));
    }
    function convert_float(fconv, prec, x) {
        function hex(param) {
            switch(fconv[1]){
                case 0:
                    var sign = 45;
                    break;
                case 1:
                    var sign = 43;
                    break;
                default:
                    var sign = 32;
            }
            return runtime.caml_hexstring_of_float(x, prec, sign);
        }
        function caml_special_val(str) {
            var match = runtime.caml_classify_float(x);
            return 3 === match ? x < 0. ? cst_neg_infinity : cst_infinity : 4 <= match ? cst_nan : str;
        }
        switch(fconv[2]){
            case 5:
                var str = caml_format_float(format_of_fconv(fconv, prec), x), len = caml_ml_string_length(str), i = 0;
                for(;;){
                    if (i === len) var _ch_ = 0;
                    else {
                        var _cg_ = caml_string_get(str, i) - 46 | 0;
                        a: {
                            if (23 < _cg_ >>> 0) {
                                if (55 === _cg_) break a;
                            } else if (21 < _cg_ - 1 >>> 0) break a;
                            var i$0 = i + 1 | 0;
                            i = i$0;
                            continue;
                        }
                        var _ch_ = 1;
                    }
                    var _ci_ = _ch_ ? str : caml_call2(Stdlib[28], str, cst$17);
                    return caml_special_val(_ci_);
                }
            case 6:
                return hex(0);
            case 7:
                var _cj_ = hex(0);
                return caml_call1(Stdlib_String[26], _cj_);
            case 8:
                return caml_special_val(hex(0));
            default:
                return caml_format_float(format_of_fconv(fconv, prec), x);
        }
    }
    function string_of_fmtty(fmtty) {
        var buf = buffer_create(16);
        bprint_fmtty(buf, fmtty);
        return buffer_contents(buf);
    }
    function make_printf$0(counter, k, acc, fmt) {
        var k$0 = k, acc$0 = acc, fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k$0, acc$0);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    return function(c) {
                        var new_acc = [
                            5,
                            acc$0,
                            c
                        ];
                        return make_printf(k$0, new_acc, rest);
                    };
                case 1:
                    var rest$0 = fmt$0[1];
                    return function(c) {
                        var str = caml_call1(Stdlib_Char[2], c), l = caml_ml_string_length(str), res = caml_call2(Stdlib_Bytes[1], l + 2 | 0, 39);
                        caml_blit_string(str, 0, res, 1, l);
                        var new_acc = [
                            4,
                            acc$0,
                            caml_call1(Stdlib_Bytes[44], res)
                        ];
                        return make_printf(k$0, new_acc, rest$0);
                    };
                case 2:
                    var rest$1 = fmt$0[2], pad = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$1, pad, function(str) {
                        return str;
                    });
                case 3:
                    var rest$2 = fmt$0[2], pad$0 = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$2, pad$0, string_to_caml_string);
                case 4:
                    var rest$3 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$3, pad$1, prec, convert_int, iconv);
                case 5:
                    var rest$4 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$4, pad$2, prec$0, convert_int32, iconv$0);
                case 6:
                    var rest$5 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$5, pad$3, prec$1, convert_nativeint, iconv$1);
                case 7:
                    var rest$6 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1];
                    return make_int_padding_precision(k$0, acc$0, rest$6, pad$4, prec$2, convert_int64, iconv$2);
                case 8:
                    var rest$7 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2], fconv = fmt$0[1];
                    if (typeof pad$5 === "number") {
                        if (typeof prec$3 === "number") return prec$3 ? function(p, x) {
                            var str = convert_float(fconv, p, x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        } : function(x) {
                            var str = convert_float(fconv, default_float_precision(fconv), x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                        var p = prec$3[1];
                        return function(x) {
                            var str = convert_float(fconv, p, x);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                    }
                    if (0 === pad$5[0]) {
                        var w = pad$5[2], padty = pad$5[1];
                        if (typeof prec$3 === "number") return prec$3 ? function(p, x) {
                            var str = fix_padding(padty, w, convert_float(fconv, p, x));
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        } : function(x) {
                            var str = convert_float(fconv, default_float_precision(fconv), x), str$0 = fix_padding(padty, w, str);
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str$0
                            ], rest$7);
                        };
                        var p$0 = prec$3[1];
                        return function(x) {
                            var str = fix_padding(padty, w, convert_float(fconv, p$0, x));
                            return make_printf(k$0, [
                                4,
                                acc$0,
                                str
                            ], rest$7);
                        };
                    }
                    var padty$0 = pad$5[1];
                    if (typeof prec$3 === "number") return prec$3 ? function(w, p, x) {
                        var str = fix_padding(padty$0, w, convert_float(fconv, p, x));
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str
                        ], rest$7);
                    } : function(w, x) {
                        var str = convert_float(fconv, default_float_precision(fconv), x), str$0 = fix_padding(padty$0, w, str);
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str$0
                        ], rest$7);
                    };
                    var p$1 = prec$3[1];
                    return function(w, x) {
                        var str = fix_padding(padty$0, w, convert_float(fconv, p$1, x));
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            str
                        ], rest$7);
                    };
                case 9:
                    var rest$8 = fmt$0[2], pad$6 = fmt$0[1];
                    return make_padding(k$0, acc$0, rest$8, pad$6, Stdlib[30]);
                case 10:
                    var rest$9 = fmt$0[1], acc$1 = [
                        7,
                        acc$0
                    ];
                    acc$0 = acc$1;
                    fmt$0 = rest$9;
                    break;
                case 11:
                    var rest$10 = fmt$0[2], str = fmt$0[1], acc$2 = [
                        2,
                        acc$0,
                        str
                    ];
                    acc$0 = acc$2;
                    fmt$0 = rest$10;
                    break;
                case 12:
                    var rest$11 = fmt$0[2], chr = fmt$0[1], acc$3 = [
                        3,
                        acc$0,
                        chr
                    ];
                    acc$0 = acc$3;
                    fmt$0 = rest$11;
                    break;
                case 13:
                    var rest$12 = fmt$0[3], sub_fmtty = fmt$0[2], ty = string_of_fmtty(sub_fmtty);
                    return function(str) {
                        return make_printf(k$0, [
                            4,
                            acc$0,
                            ty
                        ], rest$12);
                    };
                case 14:
                    var rest$13 = fmt$0[3], fmtty = fmt$0[2];
                    return function(param) {
                        var fmt = param[1], _cf_ = recast(fmt, fmtty);
                        return make_printf(k$0, acc$0, caml_call2(CamlinternalFormatBasics[3], _cf_, rest$13));
                    };
                case 15:
                    var rest$14 = fmt$0[1];
                    return function(f, x) {
                        return make_printf(k$0, [
                            6,
                            acc$0,
                            function(o) {
                                return caml_call2(f, o, x);
                            }
                        ], rest$14);
                    };
                case 16:
                    var rest$15 = fmt$0[1];
                    return function(f) {
                        return make_printf(k$0, [
                            6,
                            acc$0,
                            f
                        ], rest$15);
                    };
                case 17:
                    var rest$16 = fmt$0[2], fmting_lit = fmt$0[1], acc$4 = [
                        0,
                        acc$0,
                        fmting_lit
                    ];
                    acc$0 = acc$4;
                    fmt$0 = rest$16;
                    break;
                case 18:
                    var _cd_ = fmt$0[1];
                    if (0 === _cd_[0]) {
                        var rest$17 = fmt$0[2], fmt$1 = _cd_[1][1];
                        let acc = acc$0, k = k$0, rest = rest$17;
                        var k$1 = function(kacc) {
                            return make_printf(k, [
                                1,
                                acc,
                                [
                                    0,
                                    kacc
                                ]
                            ], rest);
                        };
                        k$0 = k$1;
                        acc$0 = 0;
                        fmt$0 = fmt$1;
                    } else {
                        var rest$18 = fmt$0[2], fmt$2 = _cd_[1][1];
                        let acc = acc$0, k = k$0, rest = rest$18;
                        var k$2 = function(kacc) {
                            return make_printf(k, [
                                1,
                                acc,
                                [
                                    1,
                                    kacc
                                ]
                            ], rest);
                        };
                        k$0 = k$2;
                        acc$0 = 0;
                        fmt$0 = fmt$2;
                    }
                    break;
                case 19:
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _s_
                    ], 1);
                case 20:
                    var rest$19 = fmt$0[3], new_acc = [
                        8,
                        acc$0,
                        cst_Printf_bad_conversion
                    ];
                    return function(param) {
                        return make_printf(k$0, new_acc, rest$19);
                    };
                case 21:
                    var rest$20 = fmt$0[2];
                    return function(n) {
                        var new_acc = [
                            4,
                            acc$0,
                            caml_format_int(cst_u$0, n)
                        ];
                        return make_printf(k$0, new_acc, rest$20);
                    };
                case 22:
                    var rest$21 = fmt$0[1];
                    return function(c) {
                        var new_acc = [
                            5,
                            acc$0,
                            c
                        ];
                        return make_printf(k$0, new_acc, rest$21);
                    };
                case 23:
                    var rest$22 = fmt$0[2], ign = fmt$0[1];
                    if (counter >= 50) return caml_trampoline_return(make_ignored_param$0, [
                        0,
                        k$0,
                        acc$0,
                        ign,
                        rest$22
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return make_ignored_param$0(counter$1, k$0, acc$0, ign, rest$22);
                default:
                    var rest$23 = fmt$0[3], f = fmt$0[2], arity = fmt$0[1], _ce_ = caml_call1(f, 0);
                    if (counter >= 50) return caml_trampoline_return(make_custom$0, [
                        0,
                        k$0,
                        acc$0,
                        rest$23,
                        arity,
                        _ce_
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return make_custom$0(counter$0, k$0, acc$0, rest$23, arity, _ce_);
            }
        }
    }
    function make_printf(k, acc, fmt) {
        return caml_trampoline(make_printf$0(0, k, acc, fmt));
    }
    function make_ignored_param$0(counter, k, acc, ign, fmt) {
        if (typeof ign === "number") switch(ign){
            case 0:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$0 = counter + 1 | 0;
                return make_invalid_arg(counter$0, k, acc, fmt);
            case 1:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$1 = counter + 1 | 0;
                return make_invalid_arg(counter$1, k, acc, fmt);
            case 2:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _t_
                ], 1);
            default:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$2 = counter + 1 | 0;
                return make_invalid_arg(counter$2, k, acc, fmt);
        }
        switch(ign[0]){
            case 0:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$3 = counter + 1 | 0;
                return make_invalid_arg(counter$3, k, acc, fmt);
            case 1:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$4 = counter + 1 | 0;
                return make_invalid_arg(counter$4, k, acc, fmt);
            case 2:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$5 = counter + 1 | 0;
                return make_invalid_arg(counter$5, k, acc, fmt);
            case 3:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$6 = counter + 1 | 0;
                return make_invalid_arg(counter$6, k, acc, fmt);
            case 4:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$7 = counter + 1 | 0;
                return make_invalid_arg(counter$7, k, acc, fmt);
            case 5:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$8 = counter + 1 | 0;
                return make_invalid_arg(counter$8, k, acc, fmt);
            case 6:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$9 = counter + 1 | 0;
                return make_invalid_arg(counter$9, k, acc, fmt);
            case 7:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$10 = counter + 1 | 0;
                return make_invalid_arg(counter$10, k, acc, fmt);
            case 8:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$11 = counter + 1 | 0;
                return make_invalid_arg(counter$11, k, acc, fmt);
            case 9:
                var fmtty = ign[2];
                if (counter >= 50) return caml_trampoline_return(make_from_fmtty$0, [
                    0,
                    k,
                    acc,
                    fmtty,
                    fmt
                ]);
                var counter$14 = counter + 1 | 0;
                return make_from_fmtty$0(counter$14, k, acc, fmtty, fmt);
            case 10:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$12 = counter + 1 | 0;
                return make_invalid_arg(counter$12, k, acc, fmt);
            default:
                if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
                    0,
                    k,
                    acc,
                    fmt
                ]);
                var counter$13 = counter + 1 | 0;
                return make_invalid_arg(counter$13, k, acc, fmt);
        }
    }
    function make_ignored_param(k, acc, ign, fmt) {
        return caml_trampoline(make_ignored_param$0(0, k, acc, ign, fmt));
    }
    function make_from_fmtty$0(counter, k, acc, fmtty, fmt) {
        if (typeof fmtty !== "number") switch(fmtty[0]){
            case 0:
                var rest = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest, fmt);
                };
            case 1:
                var rest$0 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$0, fmt);
                };
            case 2:
                var rest$1 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$1, fmt);
                };
            case 3:
                var rest$2 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$2, fmt);
                };
            case 4:
                var rest$3 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$3, fmt);
                };
            case 5:
                var rest$4 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$4, fmt);
                };
            case 6:
                var rest$5 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$5, fmt);
                };
            case 7:
                var rest$6 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$6, fmt);
                };
            case 8:
                var rest$7 = fmtty[2];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$7, fmt);
                };
            case 9:
                var rest$8 = fmtty[3], ty2 = fmtty[2], ty1 = fmtty[1], ty = trans(symm(ty1), ty2);
                return function(param) {
                    return make_from_fmtty(k, acc, caml_call2(CamlinternalFormatBasics[1], ty, rest$8), fmt);
                };
            case 10:
                var rest$9 = fmtty[1];
                return function(_cc_, param) {
                    return make_from_fmtty(k, acc, rest$9, fmt);
                };
            case 11:
                var rest$10 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$10, fmt);
                };
            case 12:
                var rest$11 = fmtty[1];
                return function(param) {
                    return make_from_fmtty(k, acc, rest$11, fmt);
                };
            case 13:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _u_
                ], 1);
            default:
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _v_
                ], 1);
        }
        if (counter >= 50) return caml_trampoline_return(make_invalid_arg, [
            0,
            k,
            acc,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_invalid_arg(counter$0, k, acc, fmt);
    }
    function make_from_fmtty(k, acc, fmtty, fmt) {
        return caml_trampoline(make_from_fmtty$0(0, k, acc, fmtty, fmt));
    }
    function make_invalid_arg(counter, k, acc, fmt) {
        var _cb_ = [
            8,
            acc,
            cst_Printf_bad_conversion$0
        ];
        if (counter >= 50) return caml_trampoline_return(make_printf$0, [
            0,
            k,
            _cb_,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_printf$0(counter$0, k, _cb_, fmt);
    }
    function make_padding(k, acc, fmt, pad, trans) {
        if (typeof pad === "number") return function(x) {
            var new_acc = [
                4,
                acc,
                caml_call1(trans, x)
            ];
            return make_printf(k, new_acc, fmt);
        };
        if (0 === pad[0]) {
            var width = pad[2], padty = pad[1];
            return function(x) {
                var new_acc = [
                    4,
                    acc,
                    fix_padding(padty, width, caml_call1(trans, x))
                ];
                return make_printf(k, new_acc, fmt);
            };
        }
        var padty$0 = pad[1];
        return function(w, x) {
            var new_acc = [
                4,
                acc,
                fix_padding(padty$0, w, caml_call1(trans, x))
            ];
            return make_printf(k, new_acc, fmt);
        };
    }
    function make_int_padding_precision(k, acc, fmt, pad, prec, trans, iconv) {
        if (typeof pad === "number") {
            if (typeof prec === "number") return prec ? function(p, x) {
                var str = fix_int_precision(p, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            } : function(x) {
                var str = caml_call2(trans, iconv, x);
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
            var p = prec[1];
            return function(x) {
                var str = fix_int_precision(p, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
        }
        if (0 === pad[0]) {
            var w = pad[2], padty = pad[1];
            if (typeof prec === "number") return prec ? function(p, x) {
                var str = fix_padding(padty, w, fix_int_precision(p, caml_call2(trans, iconv, x)));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            } : function(x) {
                var str = fix_padding(padty, w, caml_call2(trans, iconv, x));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
            var p$0 = prec[1];
            return function(x) {
                var str = fix_padding(padty, w, fix_int_precision(p$0, caml_call2(trans, iconv, x)));
                return make_printf(k, [
                    4,
                    acc,
                    str
                ], fmt);
            };
        }
        var padty$0 = pad[1];
        if (typeof prec === "number") return prec ? function(w, p, x) {
            var str = fix_padding(padty$0, w, fix_int_precision(p, caml_call2(trans, iconv, x)));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        } : function(w, x) {
            var str = fix_padding(padty$0, w, caml_call2(trans, iconv, x));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        };
        var p$1 = prec[1];
        return function(w, x) {
            var str = fix_padding(padty$0, w, fix_int_precision(p$1, caml_call2(trans, iconv, x)));
            return make_printf(k, [
                4,
                acc,
                str
            ], fmt);
        };
    }
    function make_custom$0(counter, k, acc, rest, arity, f) {
        if (arity) {
            var arity$0 = arity[1];
            return function(x) {
                return make_custom(k, acc, rest, arity$0, caml_call1(f, x));
            };
        }
        var _ca_ = [
            4,
            acc,
            f
        ];
        if (counter >= 50) return caml_trampoline_return(make_printf$0, [
            0,
            k,
            _ca_,
            rest
        ]);
        var counter$0 = counter + 1 | 0;
        return make_printf$0(counter$0, k, _ca_, rest);
    }
    function make_custom(k, acc, rest, arity, f) {
        return caml_trampoline(make_custom$0(0, k, acc, rest, arity, f));
    }
    function make_iprintf$0(counter, k, o, fmt) {
        var k$0 = k, fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k$0, o);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1], x = make_iprintf(k$0, o, rest);
                    return function(_b$_) {
                        return x;
                    };
                case 1:
                    var rest$0 = fmt$0[1], x$0 = make_iprintf(k$0, o, rest$0);
                    return function(_b__) {
                        return x$0;
                    };
                case 2:
                    var _bM_ = fmt$0[1];
                    if (typeof _bM_ === "number") {
                        var rest$1 = fmt$0[2], x$1 = make_iprintf(k$0, o, rest$1);
                        return function(_b9_) {
                            return x$1;
                        };
                    }
                    if (0 === _bM_[0]) {
                        var rest$2 = fmt$0[2], x$2 = make_iprintf(k$0, o, rest$2);
                        return function(_b8_) {
                            return x$2;
                        };
                    }
                    var rest$3 = fmt$0[2], x$3 = make_iprintf(k$0, o, rest$3), x$4 = function(_b7_) {
                        return x$3;
                    };
                    return function(_b6_) {
                        return x$4;
                    };
                case 3:
                    var _bN_ = fmt$0[1];
                    if (typeof _bN_ === "number") {
                        var rest$4 = fmt$0[2], x$5 = make_iprintf(k$0, o, rest$4);
                        return function(_b5_) {
                            return x$5;
                        };
                    }
                    if (0 === _bN_[0]) {
                        var rest$5 = fmt$0[2], x$6 = make_iprintf(k$0, o, rest$5);
                        return function(_b4_) {
                            return x$6;
                        };
                    }
                    var rest$6 = fmt$0[2], x$7 = make_iprintf(k$0, o, rest$6), x$8 = function(_b3_) {
                        return x$7;
                    };
                    return function(_b2_) {
                        return x$8;
                    };
                case 4:
                    var rest$7 = fmt$0[4], prec = fmt$0[3], pad = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$7, pad, prec);
                case 5:
                    var rest$8 = fmt$0[4], prec$0 = fmt$0[3], pad$0 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$8, pad$0, prec$0);
                case 6:
                    var rest$9 = fmt$0[4], prec$1 = fmt$0[3], pad$1 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$9, pad$1, prec$1);
                case 7:
                    var rest$10 = fmt$0[4], prec$2 = fmt$0[3], pad$2 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$10, pad$2, prec$2);
                case 8:
                    var rest$11 = fmt$0[4], prec$3 = fmt$0[3], pad$3 = fmt$0[2];
                    return fn_of_padding_precision(k$0, o, rest$11, pad$3, prec$3);
                case 9:
                    var _bO_ = fmt$0[1];
                    if (typeof _bO_ === "number") {
                        var rest$12 = fmt$0[2], x$9 = make_iprintf(k$0, o, rest$12);
                        return function(_b1_) {
                            return x$9;
                        };
                    }
                    if (0 === _bO_[0]) {
                        var rest$13 = fmt$0[2], x$10 = make_iprintf(k$0, o, rest$13);
                        return function(_b0_) {
                            return x$10;
                        };
                    }
                    var rest$14 = fmt$0[2], x$11 = make_iprintf(k$0, o, rest$14), x$12 = function(_bZ_) {
                        return x$11;
                    };
                    return function(_bY_) {
                        return x$12;
                    };
                case 10:
                    var rest$15 = fmt$0[1];
                    fmt$0 = rest$15;
                    break;
                case 11:
                    var rest$16 = fmt$0[2];
                    fmt$0 = rest$16;
                    break;
                case 12:
                    var rest$17 = fmt$0[2];
                    fmt$0 = rest$17;
                    break;
                case 13:
                    var rest$18 = fmt$0[3], x$13 = make_iprintf(k$0, o, rest$18);
                    return function(_bX_) {
                        return x$13;
                    };
                case 14:
                    var rest$19 = fmt$0[3], fmtty = fmt$0[2];
                    return function(param) {
                        var fmt = param[1], _bW_ = recast(fmt, fmtty);
                        return make_iprintf(k$0, o, caml_call2(CamlinternalFormatBasics[3], _bW_, rest$19));
                    };
                case 15:
                    var rest$20 = fmt$0[1], x$14 = make_iprintf(k$0, o, rest$20), x$15 = function(_bV_) {
                        return x$14;
                    };
                    return function(_bU_) {
                        return x$15;
                    };
                case 16:
                    var rest$21 = fmt$0[1], x$16 = make_iprintf(k$0, o, rest$21);
                    return function(_bT_) {
                        return x$16;
                    };
                case 17:
                    var rest$22 = fmt$0[2];
                    fmt$0 = rest$22;
                    break;
                case 18:
                    var _bP_ = fmt$0[1];
                    if (0 === _bP_[0]) {
                        var rest$23 = fmt$0[2], fmt$1 = _bP_[1][1];
                        let k = k$0, rest = rest$23;
                        var k$1 = function(koc) {
                            return make_iprintf(k, koc, rest);
                        };
                        k$0 = k$1;
                        fmt$0 = fmt$1;
                    } else {
                        var rest$24 = fmt$0[2], fmt$2 = _bP_[1][1];
                        let k = k$0, rest = rest$24;
                        var k$2 = function(koc) {
                            return make_iprintf(k, koc, rest);
                        };
                        k$0 = k$2;
                        fmt$0 = fmt$2;
                    }
                    break;
                case 19:
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _w_
                    ], 1);
                case 20:
                    var rest$25 = fmt$0[3], x$17 = make_iprintf(k$0, o, rest$25);
                    return function(_bS_) {
                        return x$17;
                    };
                case 21:
                    var rest$26 = fmt$0[2], x$18 = make_iprintf(k$0, o, rest$26);
                    return function(_bR_) {
                        return x$18;
                    };
                case 22:
                    var rest$27 = fmt$0[1], x$19 = make_iprintf(k$0, o, rest$27);
                    return function(_bQ_) {
                        return x$19;
                    };
                case 23:
                    var rest$28 = fmt$0[2], ign = fmt$0[1];
                    return make_ignored_param(function(param) {
                        return caml_call1(k$0, o);
                    }, 0, ign, rest$28);
                default:
                    var rest$29 = fmt$0[3], arity = fmt$0[1];
                    if (counter >= 50) return caml_trampoline_return(fn_of_custom_arity$0, [
                        0,
                        k$0,
                        o,
                        rest$29,
                        arity
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return fn_of_custom_arity$0(counter$0, k$0, o, rest$29, arity);
            }
        }
    }
    function make_iprintf(k, o, fmt) {
        return caml_trampoline(make_iprintf$0(0, k, o, fmt));
    }
    function fn_of_padding_precision(k, o, fmt, pad, prec) {
        if (typeof pad === "number") {
            if (typeof prec !== "number") {
                var x$2 = make_iprintf(k, o, fmt);
                return function(_bL_) {
                    return x$2;
                };
            }
            if (prec) {
                var x = make_iprintf(k, o, fmt), x$0 = function(_bK_) {
                    return x;
                };
                return function(_bJ_) {
                    return x$0;
                };
            }
            var x$1 = make_iprintf(k, o, fmt);
            return function(_bI_) {
                return x$1;
            };
        }
        if (0 === pad[0]) {
            if (typeof prec !== "number") {
                var x$6 = make_iprintf(k, o, fmt);
                return function(_bH_) {
                    return x$6;
                };
            }
            if (prec) {
                var x$3 = make_iprintf(k, o, fmt), x$4 = function(_bG_) {
                    return x$3;
                };
                return function(_bF_) {
                    return x$4;
                };
            }
            var x$5 = make_iprintf(k, o, fmt);
            return function(_bE_) {
                return x$5;
            };
        }
        if (typeof prec !== "number") {
            var x$12 = make_iprintf(k, o, fmt), x$13 = function(_bD_) {
                return x$12;
            };
            return function(_bC_) {
                return x$13;
            };
        }
        if (prec) {
            var x$7 = make_iprintf(k, o, fmt), x$8 = function(_bB_) {
                return x$7;
            }, x$9 = function(_bA_) {
                return x$8;
            };
            return function(_bz_) {
                return x$9;
            };
        }
        var x$10 = make_iprintf(k, o, fmt);
        function x$11(_by_) {
            return x$10;
        }
        return function(_bx_) {
            return x$11;
        };
    }
    function fn_of_custom_arity$0(counter, k, o, fmt, param) {
        if (param) {
            var arity = param[1], x = fn_of_custom_arity(k, o, fmt, arity);
            return function(_bw_) {
                return x;
            };
        }
        if (counter >= 50) return caml_trampoline_return(make_iprintf$0, [
            0,
            k,
            o,
            fmt
        ]);
        var counter$0 = counter + 1 | 0;
        return make_iprintf$0(counter$0, k, o, fmt);
    }
    function fn_of_custom_arity(k, o, fmt, param) {
        return caml_trampoline(fn_of_custom_arity$0(0, k, o, fmt, param));
    }
    function output_acc(o, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    output_acc(o, p);
                    return caml_call2(Stdlib[66], o, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        output_acc(o, p$0);
                        caml_call2(Stdlib[66], o, cst$18);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        output_acc(o, p$0);
                        caml_call2(Stdlib[66], o, cst$19);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    output_acc(o, p$3);
                    return caml_call1(f, o);
                case 7:
                    var p$4 = acc$0[1];
                    output_acc(o, p$4);
                    return caml_call1(Stdlib[63], o);
                case 8:
                    var msg = acc$0[2], p$5 = acc$0[1];
                    output_acc(o, p$5);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    output_acc(o, p$1);
                    return caml_call2(Stdlib[66], o, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    output_acc(o, p$2);
                    return caml_call2(Stdlib[65], o, c);
            }
        }
    }
    function bufput_acc(b, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    bufput_acc(b, p);
                    return caml_call2(Stdlib_Buffer[16], b, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        bufput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$20);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        bufput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$21);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    bufput_acc(b, p$3);
                    return caml_call1(f, b);
                case 7:
                    var acc$3 = acc$0[1];
                    acc$0 = acc$3;
                    break;
                case 8:
                    var msg = acc$0[2], p$4 = acc$0[1];
                    bufput_acc(b, p$4);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    bufput_acc(b, p$1);
                    return caml_call2(Stdlib_Buffer[16], b, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    bufput_acc(b, p$2);
                    return caml_call2(Stdlib_Buffer[12], b, c);
            }
        }
    }
    function strput_acc(b, acc) {
        var acc$0 = acc;
        for(;;){
            if (typeof acc$0 === "number") return 0;
            switch(acc$0[0]){
                case 0:
                    var fmting_lit = acc$0[2], p = acc$0[1], s = string_of_formatting_lit(fmting_lit);
                    strput_acc(b, p);
                    return caml_call2(Stdlib_Buffer[16], b, s);
                case 1:
                    var match = acc$0[2], p$0 = acc$0[1];
                    if (0 === match[0]) {
                        var acc$1 = match[1];
                        strput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$22);
                        acc$0 = acc$1;
                    } else {
                        var acc$2 = match[1];
                        strput_acc(b, p$0);
                        caml_call2(Stdlib_Buffer[16], b, cst$23);
                        acc$0 = acc$2;
                    }
                    break;
                case 6:
                    var f = acc$0[2], p$3 = acc$0[1];
                    strput_acc(b, p$3);
                    var _bv_ = caml_call1(f, 0);
                    return caml_call2(Stdlib_Buffer[16], b, _bv_);
                case 7:
                    var acc$3 = acc$0[1];
                    acc$0 = acc$3;
                    break;
                case 8:
                    var msg = acc$0[2], p$4 = acc$0[1];
                    strput_acc(b, p$4);
                    return caml_call1(Stdlib[1], msg);
                case 2:
                case 4:
                    var s$0 = acc$0[2], p$1 = acc$0[1];
                    strput_acc(b, p$1);
                    return caml_call2(Stdlib_Buffer[16], b, s$0);
                default:
                    var c = acc$0[2], p$2 = acc$0[1];
                    strput_acc(b, p$2);
                    return caml_call2(Stdlib_Buffer[12], b, c);
            }
        }
    }
    function failwith_message(param) {
        var fmt = param[1], buf = caml_call1(Stdlib_Buffer[1], 256);
        function k(acc) {
            strput_acc(buf, acc);
            var _bu_ = caml_call1(Stdlib_Buffer[2], buf);
            return caml_call1(Stdlib[2], _bu_);
        }
        return make_printf(k, 0, fmt);
    }
    function open_box_of_string(str) {
        if (str === cst$43) return _x_;
        var len = caml_ml_string_length(str);
        function invalid_box(param) {
            return caml_call1(failwith_message(_y_), str);
        }
        function parse_spaces(i) {
            var i$0 = i;
            for(;;){
                if (i$0 === len) return i$0;
                var match = caml_string_get(str, i$0);
                if (9 !== match && 32 !== match) return i$0;
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
            }
        }
        var wstart = parse_spaces(0);
        a: b: {
            var wend = wstart;
            for(;;){
                if (wend === len) break b;
                if (25 < caml_string_get(str, wend) - 97 >>> 0) break;
                var j = wend + 1 | 0;
                wend = j;
            }
            break a;
        }
        var box_name = caml_call3(Stdlib_String[16], str, wstart, wend - wstart | 0), nstart = parse_spaces(wend);
        a: b: {
            var nend = nstart;
            for(;;){
                if (nend === len) break b;
                var match = caml_string_get(str, nend);
                if (48 <= match) {
                    if (58 <= match) break;
                } else if (45 !== match) break;
                var j$0 = nend + 1 | 0;
                nend = j$0;
            }
            break a;
        }
        if (nstart === nend) var indent = 0;
        else try {
            var _bs_ = runtime.caml_int_of_string(caml_call3(Stdlib_String[16], str, nstart, nend - nstart | 0)), indent = _bs_;
        } catch (_bt_) {
            var _br_ = caml_wrap_exception(_bt_);
            if (_br_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_br_, 0);
            var indent = invalid_box(0);
        }
        var exp_end = parse_spaces(nend);
        if (exp_end !== len) invalid_box(0);
        a: {
            if (box_name !== cst$43 && box_name !== "b") {
                if (box_name === "h") {
                    var box_type = 0;
                    break a;
                }
                if (box_name === "hov") {
                    var box_type = 3;
                    break a;
                }
                if (box_name === "hv") {
                    var box_type = 2;
                    break a;
                }
                if (box_name !== "v") {
                    var box_type = invalid_box(0);
                    break a;
                }
                var box_type = 1;
                break a;
            }
            var box_type = 4;
        }
        return [
            0,
            indent,
            box_type
        ];
    }
    function make_padding_fmt_ebb(pad, fmt) {
        if (typeof pad === "number") return [
            0,
            0,
            fmt
        ];
        if (0 === pad[0]) {
            var w = pad[2], s = pad[1];
            return [
                0,
                [
                    0,
                    s,
                    w
                ],
                fmt
            ];
        }
        var s$0 = pad[1];
        return [
            0,
            [
                1,
                s$0
            ],
            fmt
        ];
    }
    function make_padprec_fmt_ebb(pad, prec, fmt) {
        if (typeof prec === "number") var match = prec ? [
            0,
            1
        ] : [
            0,
            0
        ];
        else var p = prec[1], match = [
            0,
            [
                0,
                p
            ]
        ];
        var prec$0 = match[1];
        if (typeof pad === "number") return [
            0,
            0,
            prec$0,
            fmt
        ];
        if (0 === pad[0]) {
            var w = pad[2], s = pad[1];
            return [
                0,
                [
                    0,
                    s,
                    w
                ],
                prec$0,
                fmt
            ];
        }
        var s$0 = pad[1];
        return [
            0,
            [
                1,
                s$0
            ],
            prec$0,
            fmt
        ];
    }
    function fmt_ebb_of_string(legacy_behavior, str) {
        if (legacy_behavior) var flag = legacy_behavior[1], legacy_behavior$0 = flag;
        else var legacy_behavior$0 = 1;
        function invalid_format_message(str_ind, msg) {
            return caml_call3(failwith_message(_z_), str, str_ind, msg);
        }
        function invalid_format_without(str_ind, c, s) {
            return caml_call4(failwith_message(_A_), str, str_ind, c, s);
        }
        function expected_character(str_ind, expected, read) {
            return caml_call4(failwith_message(_B_), str, str_ind, expected, read);
        }
        function parse(lit_start, end_ind) {
            a: {
                var str_ind = lit_start;
                for(;;){
                    if (str_ind === end_ind) return add_literal(lit_start, str_ind, 0);
                    var match = caml_string_get(str, str_ind);
                    if (37 === match) break;
                    if (64 === match) break a;
                    var str_ind$1 = str_ind + 1 | 0;
                    str_ind = str_ind$1;
                }
                var str_ind$2 = str_ind + 1 | 0;
                if (str_ind$2 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var match$1 = 95 === caml_string_get(str, str_ind$2) ? parse_flags(str_ind, str_ind$2 + 1 | 0, end_ind, 1) : parse_flags(str_ind, str_ind$2, end_ind, 0), fmt_rest = match$1[1];
                return add_literal(lit_start, str_ind, fmt_rest);
            }
            var str_ind$0 = str_ind + 1 | 0;
            a: if (str_ind$0 === end_ind) var match$0 = _N_;
            else {
                var c = caml_string_get(str, str_ind$0);
                if (65 <= c) {
                    if (94 <= c) {
                        var switcher = c - 123 | 0;
                        if (2 >= switcher >>> 0) switch(switcher){
                            case 0:
                                var match$0 = parse_tag(1, str_ind$0 + 1 | 0, end_ind);
                                break a;
                            case 1:
                                break;
                            default:
                                var fmt_rest$2 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                    0,
                                    [
                                        17,
                                        1,
                                        fmt_rest$2
                                    ]
                                ];
                                break a;
                        }
                    } else if (91 <= c) switch(c - 91 | 0){
                        case 0:
                            var match$0 = parse_tag(0, str_ind$0 + 1 | 0, end_ind);
                            break a;
                        case 1:
                            break;
                        default:
                            var fmt_rest$3 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    0,
                                    fmt_rest$3
                                ]
                            ];
                            break a;
                    }
                } else {
                    if (10 === c) {
                        var fmt_rest$4 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                            0,
                            [
                                17,
                                3,
                                fmt_rest$4
                            ]
                        ];
                        break a;
                    }
                    if (32 <= c) switch(c - 32 | 0){
                        case 0:
                            var fmt_rest$5 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    _O_,
                                    fmt_rest$5
                                ]
                            ];
                            break a;
                        case 5:
                            if ((str_ind$0 + 1 | 0) < end_ind && 37 === caml_string_get(str, str_ind$0 + 1 | 0)) {
                                var fmt_rest$6 = parse(str_ind$0 + 2 | 0, end_ind)[1], match$0 = [
                                    0,
                                    [
                                        17,
                                        6,
                                        fmt_rest$6
                                    ]
                                ];
                                break a;
                            }
                            var fmt_rest$7 = parse(str_ind$0, end_ind)[1], match$0 = [
                                0,
                                [
                                    12,
                                    64,
                                    fmt_rest$7
                                ]
                            ];
                            break a;
                        case 12:
                            var fmt_rest$8 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    _P_,
                                    fmt_rest$8
                                ]
                            ];
                            break a;
                        case 14:
                            var fmt_rest$9 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    4,
                                    fmt_rest$9
                                ]
                            ];
                            break a;
                        case 27:
                            var str_ind$3 = str_ind$0 + 1 | 0;
                            b: try {
                                var _bg_ = str_ind$3 === end_ind ? 1 : 0, _bh_ = _bg_ || (60 !== caml_string_get(str, str_ind$3) ? 1 : 0);
                                if (_bh_) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                var str_ind_1 = parse_spaces(str_ind$3 + 1 | 0, end_ind), match$2 = caml_string_get(str, str_ind_1);
                                c: {
                                    if (48 <= match$2) {
                                        if (58 > match$2) break c;
                                    } else if (45 === match$2) break c;
                                    throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                }
                                var match$3 = parse_integer(str_ind_1, end_ind), width = match$3[2], str_ind_2 = match$3[1], str_ind_3 = parse_spaces(str_ind_2, end_ind), switcher$0 = caml_string_get(str, str_ind_3) - 45 | 0;
                                if (12 < switcher$0 >>> 0) {
                                    if (17 === switcher$0) {
                                        var s = caml_call3(Stdlib_String[16], str, str_ind$3 - 2 | 0, (str_ind_3 - str_ind$3 | 0) + 3 | 0), _bi_ = [
                                            0,
                                            s,
                                            width,
                                            0
                                        ], _bj_ = str_ind_3 + 1 | 0, formatting_lit$0 = _bi_, next_ind = _bj_;
                                        break b;
                                    }
                                } else if (1 < switcher$0 - 1 >>> 0) {
                                    var match$4 = parse_integer(str_ind_3, end_ind), offset = match$4[2], str_ind_4 = match$4[1], str_ind_5 = parse_spaces(str_ind_4, end_ind);
                                    if (62 !== caml_string_get(str, str_ind_5)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                    var s$0 = caml_call3(Stdlib_String[16], str, str_ind$3 - 2 | 0, (str_ind_5 - str_ind$3 | 0) + 3 | 0), _bk_ = [
                                        0,
                                        s$0,
                                        width,
                                        offset
                                    ], _bl_ = str_ind_5 + 1 | 0, formatting_lit$0 = _bk_, next_ind = _bl_;
                                    break b;
                                }
                                throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                            } catch (_bq_) {
                                var _bf_ = caml_wrap_exception(_bq_);
                                if (_bf_ !== Stdlib[8] && _bf_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bf_, 0);
                                var formatting_lit$0 = formatting_lit, next_ind = str_ind$3;
                            }
                            var fmt_rest$12 = parse(next_ind, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    formatting_lit$0,
                                    fmt_rest$12
                                ]
                            ];
                            break a;
                        case 28:
                            var str_ind$4 = str_ind$0 + 1 | 0;
                            try {
                                var str_ind_1$0 = parse_spaces(str_ind$4, end_ind), match$6 = caml_string_get(str, str_ind_1$0);
                                b: {
                                    c: {
                                        if (48 <= match$6) {
                                            if (58 > match$6) break c;
                                        } else if (45 === match$6) break c;
                                        var _bo_ = 0;
                                        break b;
                                    }
                                    var match$7 = parse_integer(str_ind_1$0, end_ind), size = match$7[2], str_ind_2$0 = match$7[1], str_ind_3$0 = parse_spaces(str_ind_2$0, end_ind);
                                    if (62 !== caml_string_get(str, str_ind_3$0)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                                    var s$1 = caml_call3(Stdlib_String[16], str, str_ind$4 - 2 | 0, (str_ind_3$0 - str_ind$4 | 0) + 3 | 0), _bo_ = [
                                        0,
                                        [
                                            0,
                                            str_ind_3$0 + 1 | 0,
                                            [
                                                1,
                                                s$1,
                                                size
                                            ]
                                        ]
                                    ];
                                }
                                var _bn_ = _bo_;
                            } catch (_bp_) {
                                var _bm_ = caml_wrap_exception(_bp_);
                                if (_bm_ !== Stdlib[8] && _bm_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bm_, 0);
                                var _bn_ = 0;
                            }
                            if (_bn_) var match$5 = _bn_[1], formatting_lit$1 = match$5[2], next_ind$0 = match$5[1], fmt_rest$13 = parse(next_ind$0, end_ind)[1], _be_ = [
                                0,
                                [
                                    17,
                                    formatting_lit$1,
                                    fmt_rest$13
                                ]
                            ];
                            else var fmt_rest$14 = parse(str_ind$4, end_ind)[1], _be_ = [
                                0,
                                [
                                    17,
                                    _Q_,
                                    fmt_rest$14
                                ]
                            ];
                            var match$0 = _be_;
                            break a;
                        case 31:
                            var fmt_rest$10 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    2,
                                    fmt_rest$10
                                ]
                            ];
                            break a;
                        case 32:
                            var fmt_rest$11 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                                0,
                                [
                                    17,
                                    5,
                                    fmt_rest$11
                                ]
                            ];
                            break a;
                    }
                }
                var fmt_rest$1 = parse(str_ind$0 + 1 | 0, end_ind)[1], match$0 = [
                    0,
                    [
                        17,
                        [
                            2,
                            c
                        ],
                        fmt_rest$1
                    ]
                ];
            }
            var fmt_rest$0 = match$0[1];
            return add_literal(lit_start, str_ind, fmt_rest$0);
        }
        function parse_flags(pct_ind, str_ind, end_ind, ign) {
            var zero = [
                0,
                0
            ], minus = [
                0,
                0
            ], plus = [
                0,
                0
            ], space = [
                0,
                0
            ], hash = [
                0,
                0
            ];
            function set_flag(str_ind, flag) {
                var _bb_ = flag[1], _bc_ = _bb_ ? 1 - legacy_behavior$0 : _bb_;
                if (_bc_) {
                    var _bd_ = caml_string_get(str, str_ind);
                    caml_call3(failwith_message(_C_), str, str_ind, _bd_);
                }
                flag[1] = 1;
            }
            a: b: {
                var str_ind$0 = str_ind;
                c: for(;;){
                    if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                    var switcher = caml_string_get(str, str_ind$0) - 32 | 0;
                    if (16 < switcher >>> 0) break b;
                    switch(switcher){
                        case 0:
                            set_flag(str_ind$0, space);
                            var str_ind$1 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$1;
                            break;
                        case 3:
                            set_flag(str_ind$0, hash);
                            var str_ind$2 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$2;
                            break;
                        case 11:
                            set_flag(str_ind$0, plus);
                            var str_ind$3 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$3;
                            break;
                        case 13:
                            set_flag(str_ind$0, minus);
                            var str_ind$4 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$4;
                            break;
                        case 16:
                            set_flag(str_ind$0, zero);
                            var str_ind$5 = str_ind$0 + 1 | 0;
                            str_ind$0 = str_ind$5;
                            break;
                        default:
                            break c;
                    }
                }
                break a;
            }
            var space$0 = space[1], hash$0 = hash[1], plus$0 = plus[1], minus$0 = minus[1], zero$0 = zero[1];
            if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var padty = zero$0 ? minus$0 ? legacy_behavior$0 ? 0 : incompatible_flag(pct_ind, str_ind$0, 45, cst_0) : 2 : minus$0 ? 0 : 1, match = caml_string_get(str, str_ind$0);
            if (48 <= match) {
                if (58 > match) {
                    var match$0 = parse_positive(str_ind$0, end_ind, 0), width = match$0[2], new_ind = match$0[1];
                    return parse_after_padding(pct_ind, new_ind, end_ind, minus$0, plus$0, hash$0, space$0, ign, [
                        0,
                        padty,
                        width
                    ]);
                }
            } else if (42 === match) return parse_after_padding(pct_ind, str_ind$0 + 1 | 0, end_ind, minus$0, plus$0, hash$0, space$0, ign, [
                1,
                padty
            ]);
            switch(padty){
                case 0:
                    if (1 - legacy_behavior$0) invalid_format_without(str_ind$0 - 1 | 0, 45, cst_padding);
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, 0);
                case 1:
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, 0);
                default:
                    return parse_after_padding(pct_ind, str_ind$0, end_ind, minus$0, plus$0, hash$0, space$0, ign, _D_);
            }
        }
        function parse_after_padding(pct_ind, str_ind, end_ind, minus, plus, hash, space, ign, pad) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var symb = caml_string_get(str, str_ind);
            if (46 !== symb) return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, hash, space, ign, pad, 0, pad, symb);
            var str_ind$0 = str_ind + 1 | 0;
            if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            function parse_literal(minus, str_ind) {
                var match = parse_positive(str_ind, end_ind, 0), prec = match[2], new_ind = match[1];
                return parse_after_precision(pct_ind, new_ind, end_ind, minus, plus, hash, space, ign, pad, [
                    0,
                    prec
                ]);
            }
            var symb$0 = caml_string_get(str, str_ind$0);
            if (48 <= symb$0) {
                if (58 > symb$0) return parse_literal(minus, str_ind$0);
            } else if (42 <= symb$0) switch(symb$0 - 42 | 0){
                case 0:
                    return parse_after_precision(pct_ind, str_ind$0 + 1 | 0, end_ind, minus, plus, hash, space, ign, pad, 1);
                case 1:
                case 3:
                    if (legacy_behavior$0) {
                        var _ba_ = str_ind$0 + 1 | 0, minus$0 = minus || (45 === symb$0 ? 1 : 0);
                        return parse_literal(minus$0, _ba_);
                    }
                    break;
            }
            return legacy_behavior$0 ? parse_after_precision(pct_ind, str_ind$0, end_ind, minus, plus, hash, space, ign, pad, _E_) : invalid_format_without(str_ind$0 - 1 | 0, 46, cst_precision);
        }
        function parse_after_precision(pct_ind, str_ind, end_ind, minus, plus, hash, space, ign, pad, prec) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            function parse_conv(padprec) {
                return parse_conversion(pct_ind, str_ind + 1 | 0, end_ind, plus, hash, space, ign, pad, prec, padprec, caml_string_get(str, str_ind));
            }
            if (typeof pad !== "number") return parse_conv(pad);
            if (typeof prec === "number" && !prec) return parse_conv(0);
            if (minus) {
                if (typeof prec === "number") return parse_conv(_F_);
                var n = prec[1];
                return parse_conv([
                    0,
                    0,
                    n
                ]);
            }
            if (typeof prec === "number") return parse_conv(_G_);
            var n$0 = prec[1];
            return parse_conv([
                0,
                1,
                n$0
            ]);
        }
        function parse_conversion(pct_ind, str_ind, end_ind, plus, hash, space, ign, pad, prec, padprec, symb) {
            var plus_used = [
                0,
                0
            ], hash_used = [
                0,
                0
            ], space_used = [
                0,
                0
            ], ign_used = [
                0,
                0
            ], pad_used = [
                0,
                0
            ], prec_used = [
                0,
                0
            ];
            function get_plus(param) {
                plus_used[1] = 1;
                return plus;
            }
            function get_hash(param) {
                hash_used[1] = 1;
                return hash;
            }
            function get_space(param) {
                space_used[1] = 1;
                return space;
            }
            function get_ign(param) {
                ign_used[1] = 1;
                return ign;
            }
            function get_pad(param) {
                pad_used[1] = 1;
                return pad;
            }
            function get_prec(param) {
                prec_used[1] = 1;
                return prec;
            }
            function get_padprec(param) {
                pad_used[1] = 1;
                return padprec;
            }
            function get_int_pad(param) {
                var pad = get_pad(0), match = get_prec(0);
                if (typeof match === "number" && !match) return pad;
                if (typeof pad === "number") return 0;
                if (0 !== pad[0]) return 2 <= pad[1] ? legacy_behavior$0 ? _H_ : incompatible_flag(pct_ind, str_ind, 48, cst_precision$1) : pad;
                if (2 > pad[1]) return pad;
                var n = pad[2];
                return legacy_behavior$0 ? [
                    0,
                    1,
                    n
                ] : incompatible_flag(pct_ind, str_ind, 48, cst_precision$0);
            }
            function check_no_0(symb, pad) {
                if (typeof pad === "number") return pad;
                if (0 !== pad[0]) return 2 <= pad[1] ? legacy_behavior$0 ? _I_ : incompatible_flag(pct_ind, str_ind, symb, cst_0$1) : pad;
                if (2 > pad[1]) return pad;
                var width = pad[2];
                return legacy_behavior$0 ? [
                    0,
                    1,
                    width
                ] : incompatible_flag(pct_ind, str_ind, symb, cst_0$0);
            }
            function opt_of_pad(c, pad) {
                if (typeof pad === "number") return 0;
                if (0 === pad[0]) switch(pad[1]){
                    case 0:
                        var width = pad[2];
                        return legacy_behavior$0 ? [
                            0,
                            width
                        ] : incompatible_flag(pct_ind, str_ind, c, cst$24);
                    case 1:
                        var width$0 = pad[2];
                        return [
                            0,
                            width$0
                        ];
                    default:
                        var width$1 = pad[2];
                        return legacy_behavior$0 ? [
                            0,
                            width$1
                        ] : incompatible_flag(pct_ind, str_ind, c, cst_0$2);
                }
                return incompatible_flag(pct_ind, str_ind, c, cst$25);
            }
            function get_pad_opt(c) {
                return opt_of_pad(c, get_pad(0));
            }
            function get_padprec_opt(c) {
                return opt_of_pad(c, get_padprec(0));
            }
            a: {
                if (124 > symb) switch(symb){
                    case 33:
                        var fmt_rest$5 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                10,
                                fmt_rest$5
                            ]
                        ];
                        break a;
                    case 40:
                        var sub_end = search_subformat_end(str_ind, end_ind, 41), fmt_rest$7 = parse(sub_end + 2 | 0, end_ind)[1], sub_fmt = parse(str_ind, sub_end)[1], sub_fmtty = fmtty_of_fmt(sub_fmt);
                        if (get_ign(0)) var ignored$2 = [
                            9,
                            get_pad_opt(95),
                            sub_fmtty
                        ], _aJ_ = [
                            0,
                            [
                                23,
                                ignored$2,
                                fmt_rest$7
                            ]
                        ];
                        else var _aJ_ = [
                            0,
                            [
                                14,
                                get_pad_opt(40),
                                sub_fmtty,
                                fmt_rest$7
                            ]
                        ];
                        var fmt_result = _aJ_;
                        break a;
                    case 44:
                        var fmt_result = parse(str_ind, end_ind);
                        break a;
                    case 67:
                        var fmt_rest$10 = parse(str_ind, end_ind)[1], _aL_ = get_ign(0) ? [
                            0,
                            [
                                23,
                                1,
                                fmt_rest$10
                            ]
                        ] : [
                            0,
                            [
                                1,
                                fmt_rest$10
                            ]
                        ], fmt_result = _aL_;
                        break a;
                    case 78:
                        var fmt_rest$14 = parse(str_ind, end_ind)[1], counter$0 = 2;
                        if (get_ign(0)) var ignored$6 = [
                            11,
                            counter$0
                        ], _aR_ = [
                            0,
                            [
                                23,
                                ignored$6,
                                fmt_rest$14
                            ]
                        ];
                        else var _aR_ = [
                            0,
                            [
                                21,
                                counter$0,
                                fmt_rest$14
                            ]
                        ];
                        var fmt_result = _aR_;
                        break a;
                    case 83:
                        var pad$6 = check_no_0(symb, get_padprec(0)), fmt_rest$15 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$7 = [
                            1,
                            get_padprec_opt(95)
                        ], _aS_ = [
                            0,
                            [
                                23,
                                ignored$7,
                                fmt_rest$15
                            ]
                        ];
                        else var match$5 = make_padding_fmt_ebb(pad$6, fmt_rest$15), fmt_rest$16 = match$5[2], pad$7 = match$5[1], _aS_ = [
                            0,
                            [
                                3,
                                pad$7,
                                fmt_rest$16
                            ]
                        ];
                        var fmt_result = _aS_;
                        break a;
                    case 91:
                        if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        var char_set = create_char_set(0), add_range = function(c$0, c) {
                            if (c >= c$0) {
                                var i = c$0;
                                for(;;){
                                    add_in_char_set(char_set, caml_call1(Stdlib[29], i));
                                    var _a$_ = i + 1 | 0;
                                    if (c === i) break;
                                    i = _a$_;
                                }
                            }
                        }, fail_single_percent = function(str_ind) {
                            return caml_call2(failwith_message(_R_), str, str_ind);
                        }, parse_char_set_content = function(counter, str_ind, end_ind) {
                            var str_ind$0 = str_ind;
                            for(;;){
                                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                var c = caml_string_get(str, str_ind$0);
                                if (45 !== c) {
                                    if (93 === c) return str_ind$0 + 1 | 0;
                                    var _a__ = str_ind$0 + 1 | 0;
                                    if (counter >= 50) return caml_trampoline_return(parse_char_set_after_char$0, [
                                        0,
                                        _a__,
                                        end_ind,
                                        c
                                    ]);
                                    var counter$0 = counter + 1 | 0;
                                    return parse_char_set_after_char$0(counter$0, _a__, end_ind, c);
                                }
                                add_in_char_set(char_set, 45);
                                var str_ind$1 = str_ind$0 + 1 | 0;
                                str_ind$0 = str_ind$1;
                            }
                        }, parse_char_set_after_char$0 = function(counter, str_ind, end_ind, c) {
                            var str_ind$0 = str_ind, c$0 = c;
                            for(;;){
                                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                var c$1 = caml_string_get(str, str_ind$0);
                                a: {
                                    if (46 <= c$1) {
                                        if (64 !== c$1) {
                                            if (93 !== c$1) break a;
                                            add_in_char_set(char_set, c$0);
                                            return str_ind$0 + 1 | 0;
                                        }
                                    } else if (37 !== c$1) {
                                        if (45 > c$1) break a;
                                        var str_ind$2 = str_ind$0 + 1 | 0;
                                        if (str_ind$2 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                        var c$2 = caml_string_get(str, str_ind$2);
                                        if (37 === c$2) {
                                            if ((str_ind$2 + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                                            var c$3 = caml_string_get(str, str_ind$2 + 1 | 0);
                                            if (37 !== c$3 && 64 !== c$3) return fail_single_percent(str_ind$2);
                                            add_range(c$0, c$3);
                                            var _a8_ = str_ind$2 + 2 | 0;
                                            if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                                0,
                                                _a8_,
                                                end_ind
                                            ]);
                                            var counter$1 = counter + 1 | 0;
                                            return parse_char_set_content(counter$1, _a8_, end_ind);
                                        }
                                        if (93 === c$2) {
                                            add_in_char_set(char_set, c$0);
                                            add_in_char_set(char_set, 45);
                                            return str_ind$2 + 1 | 0;
                                        }
                                        add_range(c$0, c$2);
                                        var _a9_ = str_ind$2 + 1 | 0;
                                        if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                            0,
                                            _a9_,
                                            end_ind
                                        ]);
                                        var counter$0 = counter + 1 | 0;
                                        return parse_char_set_content(counter$0, _a9_, end_ind);
                                    }
                                    if (37 === c$0) {
                                        add_in_char_set(char_set, c$1);
                                        var _a7_ = str_ind$0 + 1 | 0;
                                        if (counter >= 50) return caml_trampoline_return(parse_char_set_content, [
                                            0,
                                            _a7_,
                                            end_ind
                                        ]);
                                        var counter$2 = counter + 1 | 0;
                                        return parse_char_set_content(counter$2, _a7_, end_ind);
                                    }
                                }
                                if (37 === c$0) fail_single_percent(str_ind$0);
                                add_in_char_set(char_set, c$0);
                                var str_ind$1 = str_ind$0 + 1 | 0;
                                str_ind$0 = str_ind$1;
                                c$0 = c$1;
                            }
                        }, parse_char_set_after_char = function(str_ind, end_ind, c) {
                            return caml_trampoline(parse_char_set_after_char$0(0, str_ind, end_ind, c));
                        };
                        if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        if (94 === caml_string_get(str, str_ind)) var str_ind$0 = str_ind + 1 | 0, reverse = 1, str_ind$1 = str_ind$0;
                        else var reverse = 0, str_ind$1 = str_ind;
                        if (str_ind$1 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                        var c = caml_string_get(str, str_ind$1), next_ind = parse_char_set_after_char(str_ind$1 + 1 | 0, end_ind, c), char_set$0 = freeze_char_set(char_set), char_set$1 = reverse ? rev_char_set(char_set$0) : char_set$0, fmt_rest$19 = parse(next_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$9 = [
                            10,
                            get_pad_opt(95),
                            char_set$1
                        ], _aX_ = [
                            0,
                            [
                                23,
                                ignored$9,
                                fmt_rest$19
                            ]
                        ];
                        else var _aX_ = [
                            0,
                            [
                                20,
                                get_pad_opt(91),
                                char_set$1,
                                fmt_rest$19
                            ]
                        ];
                        var fmt_result = _aX_;
                        break a;
                    case 97:
                        var fmt_rest$20 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                15,
                                fmt_rest$20
                            ]
                        ];
                        break a;
                    case 99:
                        var char_format = function(fmt_rest) {
                            return get_ign(0) ? [
                                0,
                                [
                                    23,
                                    0,
                                    fmt_rest
                                ]
                            ] : [
                                0,
                                [
                                    0,
                                    fmt_rest
                                ]
                            ];
                        }, fmt_rest$21 = parse(str_ind, end_ind)[1], match$7 = get_pad_opt(99);
                        if (match$7) {
                            if (0 === match$7[1]) var _aY_ = get_ign(0) ? [
                                0,
                                [
                                    23,
                                    3,
                                    fmt_rest$21
                                ]
                            ] : [
                                0,
                                [
                                    22,
                                    fmt_rest$21
                                ]
                            ], _aZ_ = _aY_;
                            else var _aZ_ = legacy_behavior$0 ? char_format(fmt_rest$21) : invalid_format_message(str_ind, cst_non_zero_widths_are_unsupp);
                            var _a0_ = _aZ_;
                        } else var _a0_ = char_format(fmt_rest$21);
                        var fmt_result = _a0_;
                        break a;
                    case 114:
                        var fmt_rest$22 = parse(str_ind, end_ind)[1], _a1_ = get_ign(0) ? [
                            0,
                            [
                                23,
                                2,
                                fmt_rest$22
                            ]
                        ] : [
                            0,
                            [
                                19,
                                fmt_rest$22
                            ]
                        ], fmt_result = _a1_;
                        break a;
                    case 115:
                        var pad$9 = check_no_0(symb, get_padprec(0)), fmt_rest$23 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$10 = [
                            0,
                            get_padprec_opt(95)
                        ], _a2_ = [
                            0,
                            [
                                23,
                                ignored$10,
                                fmt_rest$23
                            ]
                        ];
                        else var match$8 = make_padding_fmt_ebb(pad$9, fmt_rest$23), fmt_rest$24 = match$8[2], pad$10 = match$8[1], _a2_ = [
                            0,
                            [
                                2,
                                pad$10,
                                fmt_rest$24
                            ]
                        ];
                        var fmt_result = _a2_;
                        break a;
                    case 116:
                        var fmt_rest$25 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                16,
                                fmt_rest$25
                            ]
                        ];
                        break a;
                    case 123:
                        var sub_end$0 = search_subformat_end(str_ind, end_ind, 125), sub_fmt$0 = parse(str_ind, sub_end$0)[1], fmt_rest$26 = parse(sub_end$0 + 2 | 0, end_ind)[1], sub_fmtty$0 = fmtty_of_fmt(sub_fmt$0);
                        if (get_ign(0)) var ignored$11 = [
                            8,
                            get_pad_opt(95),
                            sub_fmtty$0
                        ], _a3_ = [
                            0,
                            [
                                23,
                                ignored$11,
                                fmt_rest$26
                            ]
                        ];
                        else var _a3_ = [
                            0,
                            [
                                13,
                                get_pad_opt(123),
                                sub_fmtty$0,
                                fmt_rest$26
                            ]
                        ];
                        var fmt_result = _a3_;
                        break a;
                    case 66:
                    case 98:
                        var pad$3 = check_no_0(symb, get_padprec(0)), fmt_rest$8 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$3 = [
                            7,
                            get_padprec_opt(95)
                        ], _aK_ = [
                            0,
                            [
                                23,
                                ignored$3,
                                fmt_rest$8
                            ]
                        ];
                        else var match$3 = make_padding_fmt_ebb(pad$3, fmt_rest$8), fmt_rest$9 = match$3[2], pad$4 = match$3[1], _aK_ = [
                            0,
                            [
                                9,
                                pad$4,
                                fmt_rest$9
                            ]
                        ];
                        var fmt_result = _aK_;
                        break a;
                    case 37:
                    case 64:
                        var fmt_rest$6 = parse(str_ind, end_ind)[1], fmt_result = [
                            0,
                            [
                                12,
                                symb,
                                fmt_rest$6
                            ]
                        ];
                        break a;
                    case 76:
                    case 108:
                    case 110:
                        if (str_ind !== end_ind) {
                            var symb$0 = caml_string_get(str, str_ind), _a4_ = symb$0 - 88 | 0;
                            b: {
                                if (32 >= _a4_ >>> 0) switch(_a4_){
                                    case 0:
                                    case 12:
                                    case 17:
                                    case 23:
                                    case 29:
                                    case 32:
                                        var _aQ_ = 1;
                                        break b;
                                }
                                var _aQ_ = 0;
                            }
                            if (_aQ_) break;
                        }
                        var fmt_rest$13 = parse(str_ind, end_ind)[1];
                        b: {
                            if (108 <= symb) {
                                if (111 > symb) switch(symb - 108 | 0){
                                    case 0:
                                        var counter = 0;
                                        break b;
                                    case 1:
                                        break;
                                    default:
                                        var counter = 1;
                                        break b;
                                }
                            } else if (76 === symb) {
                                var counter = 2;
                                break b;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _V_
                            ], 1);
                        }
                        if (get_ign(0)) var ignored$5 = [
                            11,
                            counter
                        ], _aP_ = [
                            0,
                            [
                                23,
                                ignored$5,
                                fmt_rest$13
                            ]
                        ];
                        else var _aP_ = [
                            0,
                            [
                                21,
                                counter,
                                fmt_rest$13
                            ]
                        ];
                        var fmt_result = _aP_;
                        break a;
                    case 32:
                    case 35:
                    case 43:
                    case 45:
                    case 95:
                        var fmt_result = caml_call3(failwith_message(_M_), str, pct_ind, symb);
                        break a;
                    case 88:
                    case 100:
                    case 105:
                    case 111:
                    case 117:
                    case 120:
                        var _aT_ = get_space(0), _aU_ = get_hash(0), iconv$2 = compute_int_conv(pct_ind, str_ind, get_plus(0), _aU_, _aT_, symb), fmt_rest$17 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) var ignored$8 = [
                            2,
                            iconv$2,
                            get_pad_opt(95)
                        ], _aV_ = [
                            0,
                            [
                                23,
                                ignored$8,
                                fmt_rest$17
                            ]
                        ];
                        else var _aW_ = get_prec(0), match$6 = make_padprec_fmt_ebb(get_int_pad(0), _aW_, fmt_rest$17), fmt_rest$18 = match$6[3], prec$4 = match$6[2], pad$8 = match$6[1], _aV_ = [
                            0,
                            [
                                4,
                                iconv$2,
                                pad$8,
                                prec$4,
                                fmt_rest$18
                            ]
                        ];
                        var fmt_result = _aV_;
                        break a;
                    case 69:
                    case 70:
                    case 71:
                    case 72:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                        var space$1 = get_space(0), hash$1 = get_hash(0), plus$2 = get_plus(0), flag = plus$2 ? space$1 ? legacy_behavior$0 ? 1 : incompatible_flag(pct_ind, str_ind, 32, cst$36) : 1 : space$1 ? 2 : 0;
                        b: {
                            c: if (73 <= symb) {
                                var switcher = symb - 101 | 0;
                                if (3 >= switcher >>> 0) {
                                    switch(switcher){
                                        case 0:
                                            var _a5_ = 1;
                                            break;
                                        case 1:
                                            var _a5_ = 0;
                                            break;
                                        case 2:
                                            var _a5_ = 3;
                                            break;
                                        default:
                                            var _a5_ = 6;
                                    }
                                    var kind = _a5_;
                                    break b;
                                }
                            } else if (69 <= symb) {
                                switch(symb - 69 | 0){
                                    case 0:
                                        var _a6_ = 2;
                                        break;
                                    case 1:
                                        break c;
                                    case 2:
                                        var _a6_ = 4;
                                        break;
                                    default:
                                        var _a6_ = 7;
                                }
                                var kind = _a6_;
                                break b;
                            }
                            if (hash$1) {
                                if (70 === symb) {
                                    var kind = 8;
                                    break b;
                                }
                            } else if (70 === symb) {
                                var kind = 5;
                                break b;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _X_
                            ], 1);
                        }
                        var fconv = [
                            0,
                            flag,
                            kind
                        ], fmt_rest$11 = parse(str_ind, end_ind)[1];
                        if (get_ign(0)) {
                            var match = get_prec(0);
                            if (typeof match === "number") var _aM_ = match ? incompatible_flag(pct_ind, str_ind, 95, cst$26) : 0;
                            else var ndec = match[1], _aM_ = [
                                0,
                                ndec
                            ];
                            var ignored$4 = [
                                6,
                                get_pad_opt(95),
                                _aM_
                            ], _aN_ = [
                                0,
                                [
                                    23,
                                    ignored$4,
                                    fmt_rest$11
                                ]
                            ];
                        } else var _aO_ = get_prec(0), match$4 = make_padprec_fmt_ebb(get_pad(0), _aO_, fmt_rest$11), fmt_rest$12 = match$4[3], prec$3 = match$4[2], pad$5 = match$4[1], _aN_ = [
                            0,
                            [
                                8,
                                fconv,
                                pad$5,
                                prec$3,
                                fmt_rest$12
                            ]
                        ];
                        var fmt_result = _aN_;
                        break a;
                }
                b: if (108 <= symb) {
                    if (111 > symb) {
                        switch(symb - 108 | 0){
                            case 0:
                                var _at_ = caml_string_get(str, str_ind), _au_ = get_space(0), _av_ = get_hash(0), iconv = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _av_, _au_, _at_), fmt_rest = parse(str_ind + 1 | 0, end_ind)[1];
                                if (get_ign(0)) var ignored = [
                                    3,
                                    iconv,
                                    get_pad_opt(95)
                                ], _aw_ = [
                                    0,
                                    [
                                        23,
                                        ignored,
                                        fmt_rest
                                    ]
                                ];
                                else var _ay_ = get_prec(0), match$0 = make_padprec_fmt_ebb(get_int_pad(0), _ay_, fmt_rest), fmt_rest$0 = match$0[3], prec$0 = match$0[2], pad$0 = match$0[1], _aw_ = [
                                    0,
                                    [
                                        5,
                                        iconv,
                                        pad$0,
                                        prec$0,
                                        fmt_rest$0
                                    ]
                                ];
                                var _ax_ = _aw_;
                                break;
                            case 1:
                                break b;
                            default:
                                var _az_ = caml_string_get(str, str_ind), _aA_ = get_space(0), _aB_ = get_hash(0), iconv$0 = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _aB_, _aA_, _az_), fmt_rest$1 = parse(str_ind + 1 | 0, end_ind)[1];
                                if (get_ign(0)) var ignored$0 = [
                                    4,
                                    iconv$0,
                                    get_pad_opt(95)
                                ], _aC_ = [
                                    0,
                                    [
                                        23,
                                        ignored$0,
                                        fmt_rest$1
                                    ]
                                ];
                                else var _aD_ = get_prec(0), match$1 = make_padprec_fmt_ebb(get_int_pad(0), _aD_, fmt_rest$1), fmt_rest$2 = match$1[3], prec$1 = match$1[2], pad$1 = match$1[1], _aC_ = [
                                    0,
                                    [
                                        6,
                                        iconv$0,
                                        pad$1,
                                        prec$1,
                                        fmt_rest$2
                                    ]
                                ];
                                var _ax_ = _aC_;
                        }
                        var fmt_result = _ax_;
                        break a;
                    }
                } else if (76 === symb) {
                    var _aE_ = caml_string_get(str, str_ind), _aF_ = get_space(0), _aG_ = get_hash(0), iconv$1 = compute_int_conv(pct_ind, str_ind + 1 | 0, get_plus(0), _aG_, _aF_, _aE_), fmt_rest$3 = parse(str_ind + 1 | 0, end_ind)[1];
                    if (get_ign(0)) var ignored$1 = [
                        5,
                        iconv$1,
                        get_pad_opt(95)
                    ], _aH_ = [
                        0,
                        [
                            23,
                            ignored$1,
                            fmt_rest$3
                        ]
                    ];
                    else var _aI_ = get_prec(0), match$2 = make_padprec_fmt_ebb(get_int_pad(0), _aI_, fmt_rest$3), fmt_rest$4 = match$2[3], prec$2 = match$2[2], pad$2 = match$2[1], _aH_ = [
                        0,
                        [
                            7,
                            iconv$1,
                            pad$2,
                            prec$2,
                            fmt_rest$4
                        ]
                    ];
                    var fmt_result = _aH_;
                    break a;
                }
                var fmt_result = caml_call3(failwith_message(_J_), str, str_ind - 1 | 0, symb);
            }
            if (1 - legacy_behavior$0) {
                var _ak_ = 1 - plus_used[1], plus$0 = _ak_ ? plus : _ak_;
                if (plus$0) incompatible_flag(pct_ind, str_ind, symb, cst$27);
                var _al_ = 1 - hash_used[1], hash$0 = _al_ ? hash : _al_;
                if (hash$0) incompatible_flag(pct_ind, str_ind, symb, cst$28);
                var _am_ = 1 - space_used[1], space$0 = _am_ ? space : _am_;
                if (space$0) incompatible_flag(pct_ind, str_ind, symb, cst$29);
                var _an_ = 1 - pad_used[1], _ao_ = _an_ ? caml_notequal([
                    0,
                    pad
                ], _K_) : _an_;
                if (_ao_) incompatible_flag(pct_ind, str_ind, symb, cst_padding$0);
                var _ap_ = 1 - prec_used[1], _aq_ = _ap_ ? caml_notequal([
                    0,
                    prec
                ], _L_) : _ap_;
                if (_aq_) {
                    var _ar_ = ign ? 95 : symb;
                    incompatible_flag(pct_ind, str_ind, _ar_, cst_precision$2);
                }
                var plus$1 = ign ? plus : ign;
                if (plus$1) incompatible_flag(pct_ind, str_ind, 95, cst$30);
            }
            var _as_ = 1 - ign_used[1], ign$0 = _as_ ? ign : _as_;
            a: if (ign$0) {
                b: {
                    if (38 <= symb) {
                        if (44 !== symb && 64 !== symb) break b;
                    } else if (33 !== symb && 37 > symb) break b;
                    if (legacy_behavior$0) break a;
                }
                incompatible_flag(pct_ind, str_ind, symb, cst$31);
            }
            return fmt_result;
        }
        function parse_tag(is_open_tag, str_ind, end_ind) {
            try {
                if (str_ind === end_ind) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                if (60 !== caml_string_get(str, str_ind)) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var ind = caml_call3(Stdlib_String[32], str, str_ind + 1 | 0, 62);
                if (end_ind <= ind) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var sub_str = caml_call3(Stdlib_String[16], str, str_ind, (ind - str_ind | 0) + 1 | 0), fmt_rest$0 = parse(ind + 1 | 0, end_ind)[1], sub_fmt = parse(str_ind, ind + 1 | 0)[1], sub_format$0 = [
                    0,
                    sub_fmt,
                    sub_str
                ], formatting$0 = is_open_tag ? [
                    0,
                    sub_format$0
                ] : [
                    1,
                    sub_format$0
                ], _ai_ = [
                    0,
                    [
                        18,
                        formatting$0,
                        fmt_rest$0
                    ]
                ];
                return _ai_;
            } catch (_aj_) {
                var _ah_ = caml_wrap_exception(_aj_);
                if (_ah_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_ah_, 0);
                var fmt_rest = parse(str_ind, end_ind)[1], formatting = is_open_tag ? [
                    0,
                    sub_format
                ] : [
                    1,
                    sub_format
                ];
                return [
                    0,
                    [
                        18,
                        formatting,
                        fmt_rest
                    ]
                ];
            }
        }
        function parse_spaces(str_ind, end_ind) {
            var str_ind$0 = str_ind;
            for(;;){
                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                if (32 !== caml_string_get(str, str_ind$0)) return str_ind$0;
                var str_ind$1 = str_ind$0 + 1 | 0;
                str_ind$0 = str_ind$1;
            }
        }
        function parse_positive(str_ind, end_ind, acc) {
            var str_ind$0 = str_ind, acc$0 = acc;
            for(;;){
                if (str_ind$0 === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var c = caml_string_get(str, str_ind$0);
                if (9 < c - 48 >>> 0) return [
                    0,
                    str_ind$0,
                    acc$0
                ];
                var new_acc = (acc$0 * 10 | 0) + (c - 48 | 0) | 0;
                if (Stdlib_Sys[12] < new_acc) {
                    var _ag_ = Stdlib_Sys[12];
                    return caml_call3(failwith_message(_S_), str, new_acc, _ag_);
                }
                var str_ind$1 = str_ind$0 + 1 | 0;
                str_ind$0 = str_ind$1;
                acc$0 = new_acc;
            }
        }
        function parse_integer(str_ind, end_ind) {
            if (str_ind === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
            var match = caml_string_get(str, str_ind);
            if (48 <= match) {
                if (58 > match) return parse_positive(str_ind, end_ind, 0);
            } else if (45 === match) {
                if ((str_ind + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                var c = caml_string_get(str, str_ind + 1 | 0);
                if (9 < c - 48 >>> 0) return expected_character(str_ind + 1 | 0, cst_digit, c);
                var match$0 = parse_positive(str_ind + 1 | 0, end_ind, 0), n = match$0[2], next_ind = match$0[1];
                return [
                    0,
                    next_ind,
                    -n | 0
                ];
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _T_1
            ], 1);
        }
        function add_literal(lit_start, str_ind, fmt) {
            var size = str_ind - lit_start | 0;
            return 0 === size ? [
                0,
                fmt
            ] : 1 === size ? [
                0,
                [
                    12,
                    caml_string_get(str, lit_start),
                    fmt
                ]
            ] : [
                0,
                [
                    11,
                    caml_call3(Stdlib_String[16], str, lit_start, size),
                    fmt
                ]
            ];
        }
        function search_subformat_end(str_ind, end_ind, c) {
            var str_ind$0 = str_ind;
            for(;;){
                if (str_ind$0 === end_ind) caml_call3(failwith_message(_U_), str, c, end_ind);
                if (37 === caml_string_get(str, str_ind$0)) {
                    if ((str_ind$0 + 1 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                    if (caml_string_get(str, str_ind$0 + 1 | 0) === c) return str_ind$0;
                    var match = caml_string_get(str, str_ind$0 + 1 | 0);
                    if (95 <= match) {
                        if (123 <= match) {
                            if (126 > match) switch(match - 123 | 0){
                                case 0:
                                    var sub_end = search_subformat_end(str_ind$0 + 2 | 0, end_ind, 125), str_ind$2 = sub_end + 2 | 0;
                                    str_ind$0 = str_ind$2;
                                    continue;
                                case 1:
                                    break;
                                default:
                                    return expected_character(str_ind$0 + 1 | 0, cst_character, 125);
                            }
                        } else if (96 > match) {
                            if ((str_ind$0 + 2 | 0) === end_ind) invalid_format_message(end_ind, cst_unexpected_end_of_format);
                            var match$0 = caml_string_get(str, str_ind$0 + 2 | 0);
                            if (40 === match$0) {
                                var sub_end$0 = search_subformat_end(str_ind$0 + 3 | 0, end_ind, 41), str_ind$3 = sub_end$0 + 2 | 0;
                                str_ind$0 = str_ind$3;
                                continue;
                            }
                            if (123 === match$0) {
                                var sub_end$1 = search_subformat_end(str_ind$0 + 3 | 0, end_ind, 125), str_ind$4 = sub_end$1 + 2 | 0;
                                str_ind$0 = str_ind$4;
                                continue;
                            }
                            var str_ind$5 = str_ind$0 + 3 | 0;
                            str_ind$0 = str_ind$5;
                            continue;
                        }
                    } else {
                        if (40 === match) {
                            var sub_end$2 = search_subformat_end(str_ind$0 + 2 | 0, end_ind, 41), str_ind$6 = sub_end$2 + 2 | 0;
                            str_ind$0 = str_ind$6;
                            continue;
                        }
                        if (41 === match) return expected_character(str_ind$0 + 1 | 0, cst_character$0, 41);
                    }
                    var str_ind$1 = str_ind$0 + 2 | 0;
                    str_ind$0 = str_ind$1;
                } else {
                    var str_ind$7 = str_ind$0 + 1 | 0;
                    str_ind$0 = str_ind$7;
                }
            }
        }
        function compute_int_conv(pct_ind, str_ind, plus, hash, space, symb) {
            var plus$0 = plus, hash$0 = hash, space$0 = space;
            for(;;){
                a: {
                    if (plus$0) {
                        if (!hash$0) {
                            if (space$0) break a;
                            if (100 === symb) return 1;
                            if (105 === symb) return 4;
                            break a;
                        }
                    } else {
                        if (!hash$0) {
                            if (space$0) {
                                if (100 === symb) return 2;
                                if (105 === symb) return 5;
                                break a;
                            }
                            var switcher$1 = symb - 88 | 0;
                            if (32 < switcher$1 >>> 0) break a;
                            switch(switcher$1){
                                case 0:
                                    return 8;
                                case 12:
                                    return 0;
                                case 17:
                                    return 3;
                                case 23:
                                    return 10;
                                case 29:
                                    return 12;
                                case 32:
                                    return 6;
                                default:
                                    break a;
                            }
                        }
                        if (!space$0) {
                            var switcher$0 = symb - 88 | 0;
                            if (32 >= switcher$0 >>> 0) switch(switcher$0){
                                case 0:
                                    return 9;
                                case 12:
                                    return 13;
                                case 17:
                                    return 14;
                                case 23:
                                    return 11;
                                case 29:
                                    return 15;
                                case 32:
                                    return 7;
                            }
                        }
                    }
                    var switcher = symb - 88 | 0;
                    if (32 >= switcher >>> 0) switch(switcher){
                        case 0:
                            if (legacy_behavior$0) return 9;
                            break;
                        case 23:
                            if (legacy_behavior$0) return 11;
                            break;
                        case 32:
                            if (legacy_behavior$0) return 7;
                            break;
                        case 12:
                        case 17:
                        case 29:
                            if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$35);
                            hash$0 = 0;
                            continue;
                    }
                }
                if (plus$0) {
                    if (space$0) {
                        if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, 32, cst$32);
                        space$0 = 0;
                    } else {
                        if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$33);
                        plus$0 = 0;
                    }
                } else {
                    if (!space$0) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _W_
                    ], 1);
                    if (!legacy_behavior$0) return incompatible_flag(pct_ind, str_ind, symb, cst$34);
                    space$0 = 0;
                }
            }
        }
        function incompatible_flag(pct_ind, str_ind, symb, option) {
            var subfmt = caml_call3(Stdlib_String[16], str, pct_ind, str_ind - pct_ind | 0);
            return caml_call5(failwith_message(_Y_), str, pct_ind, option, symb, subfmt);
        }
        return parse(0, caml_ml_string_length(str));
    }
    function format_of_string_fmtty(str, fmtty) {
        var fmt = fmt_ebb_of_string(0, str)[1];
        try {
            var _ae_ = [
                0,
                type_format(fmt, fmtty),
                str
            ];
            return _ae_;
        } catch (_af_) {
            var _ac_ = caml_wrap_exception(_af_);
            if (_ac_ !== Type_mismatch) throw caml_maybe_attach_backtrace(_ac_, 0);
            var _ad_ = string_of_fmtty(fmtty);
            return caml_call2(failwith_message(_Z_), str, _ad_);
        }
    }
    function format_of_string_format(str, param) {
        var str$0 = param[2], fmt = param[1], fmt$0 = fmt_ebb_of_string(0, str)[1];
        try {
            var _aa_ = [
                0,
                type_format(fmt$0, fmtty_of_fmt(fmt)),
                str
            ];
            return _aa_;
        } catch (_ab_) {
            var _$_ = caml_wrap_exception(_ab_);
            if (_$_ === Type_mismatch) return caml_call2(failwith_message(___), str, str$0);
            throw caml_maybe_attach_backtrace(_$_, 0);
        }
    }
    var CamlinternalFormat = [
        0,
        is_in_char_set,
        rev_char_set,
        create_char_set,
        add_in_char_set,
        freeze_char_set,
        param_format_of_ignored_format,
        make_printf,
        make_iprintf,
        output_acc,
        bufput_acc,
        strput_acc,
        type_format,
        fmt_ebb_of_string,
        format_of_string_fmtty,
        format_of_string_format,
        char_of_iconv,
        string_of_formatting_lit,
        string_of_fmtty,
        string_of_fmt,
        open_box_of_string,
        symm,
        trans,
        recast
    ];
    runtime.caml_register_global(197, CamlinternalFormat, "CamlinternalFormat");
    return;
})(globalThis);
//# 16242 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Buffer = global_data.Stdlib__Buffer, CamlinternalFormat = global_data.CamlinternalFormat, Stdlib = global_data.Stdlib;
    function kfprintf(k, o, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            caml_call2(CamlinternalFormat[9], o, acc);
            return caml_call1(k, o);
        }, 0, fmt);
    }
    function kbprintf(k, b, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            caml_call2(CamlinternalFormat[10], b, acc);
            return caml_call1(k, b);
        }, 0, fmt);
    }
    function ikfprintf(k, oc, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], k, oc, fmt);
    }
    function fprintf(oc, fmt) {
        return kfprintf(function(_d_) {
            return 0;
        }, oc, fmt);
    }
    function bprintf(b, fmt) {
        return kbprintf(function(_c_) {
            return 0;
        }, b, fmt);
    }
    function ifprintf(oc, fmt) {
        return ikfprintf(function(_b_) {
            return 0;
        }, oc, fmt);
    }
    function ibprintf(b, fmt) {
        return ikfprintf(function(_a_) {
            return 0;
        }, b, fmt);
    }
    function printf(fmt) {
        return fprintf(Stdlib[39], fmt);
    }
    function eprintf(fmt) {
        return fprintf(Stdlib[40], fmt);
    }
    function ksprintf(k, param) {
        var fmt = param[1];
        function k$0(acc) {
            var buf = caml_call1(Stdlib_Buffer[1], 64);
            caml_call2(CamlinternalFormat[11], buf, acc);
            return caml_call1(k, caml_call1(Stdlib_Buffer[2], buf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function sprintf(fmt) {
        return ksprintf(function(s) {
            return s;
        }, fmt);
    }
    var Stdlib_Printf = [
        0,
        fprintf,
        printf,
        eprintf,
        sprintf,
        bprintf,
        ifprintf,
        ibprintf,
        kfprintf,
        ikfprintf,
        ksprintf,
        kbprintf,
        ikfprintf,
        ksprintf
    ];
    runtime.caml_register_global(3, Stdlib_Printf, "Stdlib__Printf");
    return;
})(globalThis);
//# 16339 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$8 = "", cst$10 = "  ", cst_Display_this_list_of_optio$1 = " Display this list of options", cst_s = "%s", cst_help$4 = "--help", cst_help$3 = "-help", cst$9 = ".\n", cst_a_float$1 = "a float", cst_an_integer$1 = "an integer", caml_check_bound = runtime.caml_check_bound, caml_equal = runtime.caml_equal, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_sys_argv = runtime.caml_sys_argv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$7 = "\n", cst$4 = cst$8, cst$5 = " ", cst$6 = cst$8, cst$2 = "(?)", cst$3 = "-", cst = "}", cst$0 = "|", cst$1 = "{", Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Int = global_data.Stdlib__Int, Bad = [
        248,
        "Stdlib.Arg.Bad",
        caml_fresh_oo_id(0)
    ], Help = [
        248,
        "Stdlib.Arg.Help",
        caml_fresh_oo_id(0)
    ], Stop = [
        248,
        "Stdlib.Arg.Stop",
        caml_fresh_oo_id(0)
    ], cst_none = "<none>", _a_ = [
        0,
        [
            11,
            cst$10,
            [
                2,
                0,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "  %s %s\n"
    ], _b_ = [
        0,
        [
            11,
            cst$10,
            [
                2,
                0,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            [
                                12,
                                10,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "  %s %s%s\n"
    ], _c_ = [
        0,
        cst_help$3
    ], cst_Display_this_list_of_optio = cst_Display_this_list_of_optio$1, cst_help = cst_help$3, cst_Display_this_list_of_optio$0 = cst_Display_this_list_of_optio$1, cst_help$0 = cst_help$4, cst_help$1 = cst_help$4, cst_help$2 = cst_help$3, _d_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        "%s\n"
    ], _e_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ];
    function assoc3(x, l) {
        var l$0 = l;
        for(;;){
            if (!l$0) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var match = l$0[1], y2 = match[2], y1 = match[1];
            if (caml_equal(y1, x)) return y2;
            var t = l$0[2];
            l$0 = t;
        }
    }
    function make_symlist(prefix, sep, suffix, l) {
        if (!l) return cst_none;
        var t = l[2], h = l[1], _az_ = caml_call2(Stdlib[28], prefix, h), _aA_ = caml_call3(Stdlib_List[26], function(x, y) {
            var _aB_ = caml_call2(Stdlib[28], sep, y);
            return caml_call2(Stdlib[28], x, _aB_);
        }, _az_, t);
        return caml_call2(Stdlib[28], _aA_, suffix);
    }
    function help_action(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Stop,
            _c_
        ], 1);
    }
    function add_help(speclist) {
        try {
            assoc3(cst_help$2, speclist);
            var _aw_ = 0, add1 = _aw_;
        } catch (_ay_) {
            var _as_ = caml_wrap_exception(_ay_);
            if (_as_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_as_, 0);
            var add1 = [
                0,
                [
                    0,
                    cst_help,
                    [
                        0,
                        help_action
                    ],
                    cst_Display_this_list_of_optio
                ],
                0
            ];
        }
        try {
            assoc3(cst_help$1, speclist);
            var _av_ = 0, add2 = _av_;
        } catch (_ax_) {
            var _at_ = caml_wrap_exception(_ax_);
            if (_at_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_at_, 0);
            var add2 = [
                0,
                [
                    0,
                    cst_help$0,
                    [
                        0,
                        help_action
                    ],
                    cst_Display_this_list_of_optio$0
                ],
                0
            ];
        }
        var _au_ = caml_call2(Stdlib[37], add1, add2);
        return caml_call2(Stdlib[37], speclist, _au_);
    }
    function usage_b(buf, speclist, errmsg) {
        caml_call3(Stdlib_Printf[5], buf, _d_, errmsg);
        var _ap_ = add_help(speclist);
        return caml_call2(Stdlib_List[18], function(param) {
            var doc = param[3], spec = param[2], key = param[1], _aq_ = 0 < caml_ml_string_length(doc) ? 1 : 0;
            if (!_aq_) return _aq_;
            if (11 !== spec[0]) return caml_call4(Stdlib_Printf[5], buf, _a_, key, doc);
            var l = spec[1], _ar_ = make_symlist(cst$1, cst$0, cst, l);
            return caml_call5(Stdlib_Printf[5], buf, _b_, key, _ar_, doc);
        }, _ap_);
    }
    function usage_string(speclist, errmsg) {
        var b = caml_call1(Stdlib_Buffer[1], 200);
        usage_b(b, speclist, errmsg);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function usage(speclist, errmsg) {
        var _ao_ = usage_string(speclist, errmsg);
        return caml_call2(Stdlib_Printf[3], _e_, _ao_);
    }
    var current = [
        0,
        0
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": unknown option '",
                [
                    2,
                    0,
                    [
                        11,
                        "'.\n",
                        0
                    ]
                ]
            ]
        ],
        "%s: unknown option '%s'.\n"
    ], _g_ = [
        0,
        cst_help$3
    ], _h_ = [
        0,
        cst_help$4
    ], _i_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": wrong argument '",
                [
                    2,
                    0,
                    [
                        11,
                        "'; option '",
                        [
                            2,
                            0,
                            [
                                11,
                                "' expects ",
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        cst$9,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s: wrong argument '%s'; option '%s' expects %s.\n"
    ], _j_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": option '",
                [
                    2,
                    0,
                    [
                        11,
                        "' needs an argument.\n",
                        0
                    ]
                ]
            ]
        ],
        "%s: option '%s' needs an argument.\n"
    ], _k_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": ",
                [
                    2,
                    0,
                    [
                        11,
                        cst$9,
                        0
                    ]
                ]
            ]
        ],
        "%s: %s.\n"
    ], cst_no_argument = "no argument", cst_a_boolean = "a boolean", cst_an_integer = cst_an_integer$1, cst_an_integer$0 = cst_an_integer$1, cst_a_float = cst_a_float$1, cst_a_float$0 = cst_a_float$1, cst_one_of = "one of: ", cst_Arg_Expand_is_is_only_allo = "Arg.Expand is is only allowed with Arg.parse_and_expand_argv_dynamic", _l_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _m_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _n_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _o_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _p_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], _q_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s
    ], dummy = 0;
    function int_of_string_opt(x) {
        try {
            var _am_ = [
                0,
                runtime.caml_int_of_string(x)
            ];
            return _am_;
        } catch (_an_) {
            var _al_ = caml_wrap_exception(_an_);
            if (_al_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_al_, 0);
        }
    }
    function float_of_string_opt(x) {
        try {
            var _aj_ = [
                0,
                runtime.caml_float_of_string(x)
            ];
            return _aj_;
        } catch (_ak_) {
            var _ai_ = caml_wrap_exception(_ak_);
            if (_ai_[1] === Stdlib[7]) return 0;
            throw caml_maybe_attach_backtrace(_ai_, 0);
        }
    }
    function parse_and_expand_argv_dynamic_(allow_expand, current, argv, speclist, anonfun, errmsg) {
        var initpos = current[1];
        function convert_error(error) {
            var b = caml_call1(Stdlib_Buffer[1], 200), progname = initpos < argv[1].length - 1 ? caml_check_bound(argv[1], initpos)[1 + initpos] : cst$2;
            switch(error[0]){
                case 0:
                    var s = error[1];
                    if (s !== cst_help$4 && s !== cst_help$3) caml_call4(Stdlib_Printf[5], b, _f_, progname, s);
                    break;
                case 1:
                    var expected = error[3], arg = error[2], opt = error[1];
                    caml_call6(Stdlib_Printf[5], b, _i_, progname, arg, opt, expected);
                    break;
                case 2:
                    var s$0 = error[1];
                    caml_call4(Stdlib_Printf[5], b, _j_, progname, s$0);
                    break;
                default:
                    var s$1 = error[1];
                    caml_call4(Stdlib_Printf[5], b, _k_, progname, s$1);
            }
            usage_b(b, speclist[1], errmsg);
            if (!caml_equal(error, _g_) && !caml_equal(error, _h_)) return [
                0,
                Bad,
                caml_call1(Stdlib_Buffer[2], b)
            ];
            return [
                0,
                Help,
                caml_call1(Stdlib_Buffer[2], b)
            ];
        }
        current[1]++;
        for(;;){
            if (current[1] >= argv[1].length - 1) return 0;
            try {
                var _V_ = current[1], s = caml_check_bound(argv[1], _V_)[1 + _V_];
                if (caml_call2(Stdlib_String[11], cst$3, s)) {
                    try {
                        var follow$1 = 0, _Z_ = assoc3(s, speclist[1]), follow$0 = follow$1, action = _Z_;
                    } catch (_ag_) {
                        var _W_ = caml_wrap_exception(_ag_);
                        if (_W_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_W_, 0);
                        try {
                            var i = caml_call2(Stdlib_String[36], s, 61), len = caml_ml_string_length(s), arg = caml_call3(Stdlib_String[16], s, i + 1 | 0, len - (i + 1 | 0) | 0), keyword = caml_call3(Stdlib_String[16], s, 0, i), follow = [
                                0,
                                arg
                            ], _Y_ = assoc3(keyword, speclist[1]), follow$0 = follow, action = _Y_;
                        } catch (_ah_) {
                            var _X_ = caml_wrap_exception(_ah_);
                            if (_X_ === Stdlib[8]) throw caml_maybe_attach_backtrace([
                                0,
                                Stop,
                                [
                                    0,
                                    s
                                ]
                            ], 1);
                            throw caml_maybe_attach_backtrace(_X_, 0);
                        }
                    }
                    let s$0 = s, follow$2 = follow$0;
                    var no_arg = function(param) {
                        if (!follow$2) return;
                        var arg = follow$2[1];
                        throw caml_maybe_attach_backtrace([
                            0,
                            Stop,
                            [
                                1,
                                s$0,
                                arg,
                                cst_no_argument
                            ]
                        ], 1);
                    }, get_arg = function(param) {
                        if (follow$2) {
                            var arg = follow$2[1];
                            return arg;
                        }
                        if ((current[1] + 1 | 0) >= argv[1].length - 1) throw caml_maybe_attach_backtrace([
                            0,
                            Stop,
                            [
                                2,
                                s$0
                            ]
                        ], 1);
                        var _af_ = current[1] + 1 | 0;
                        return caml_check_bound(argv[1], _af_)[1 + _af_];
                    }, consume_arg = function(param) {
                        return follow$2 ? 0 : (current[1]++, 0);
                    }, treat_action = function(param) {
                        switch(param[0]){
                            case 0:
                                var f = param[1];
                                no_arg$0(0);
                                return caml_call1(f, 0);
                            case 1:
                                var f$0 = param[1], arg = get_arg$0(0);
                                try {
                                    var _$_ = [
                                        0,
                                        caml_call1(Stdlib[32], arg)
                                    ], match = _$_;
                                } catch (_ae_) {
                                    var ___ = caml_wrap_exception(_ae_);
                                    if (___[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(___, 0);
                                    var match = 0;
                                }
                                if (!match) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg,
                                        cst_a_boolean
                                    ]
                                ], 1);
                                var s = match[1];
                                caml_call1(f$0, s);
                                return consume_arg$0(0);
                            case 2:
                                var r = param[1];
                                no_arg$0(0);
                                r[1] = 1;
                                return 0;
                            case 3:
                                var r$0 = param[1];
                                no_arg$0(0);
                                r$0[1] = 0;
                                return 0;
                            case 4:
                                var f$1 = param[1], arg$0 = get_arg$0(0);
                                caml_call1(f$1, arg$0);
                                return consume_arg$0(0);
                            case 5:
                                var r$1 = param[1];
                                r$1[1] = get_arg$0(0);
                                return consume_arg$0(0);
                            case 6:
                                var f$2 = param[1], arg$1 = get_arg$0(0), match$0 = int_of_string_opt(arg$1);
                                if (!match$0) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$1,
                                        cst_an_integer
                                    ]
                                ], 1);
                                var x = match$0[1];
                                caml_call1(f$2, x);
                                return consume_arg$0(0);
                            case 7:
                                var r$2 = param[1], arg$2 = get_arg$0(0), match$1 = int_of_string_opt(arg$2);
                                if (!match$1) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$2,
                                        cst_an_integer$0
                                    ]
                                ], 1);
                                var x$0 = match$1[1];
                                r$2[1] = x$0;
                                return consume_arg$0(0);
                            case 8:
                                var f$3 = param[1], arg$3 = get_arg$0(0), match$2 = float_of_string_opt(arg$3);
                                if (!match$2) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$3,
                                        cst_a_float
                                    ]
                                ], 1);
                                var x$1 = match$2[1];
                                caml_call1(f$3, x$1);
                                return consume_arg$0(0);
                            case 9:
                                var r$3 = param[1], arg$4 = get_arg$0(0), match$3 = float_of_string_opt(arg$4);
                                if (!match$3) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$4,
                                        cst_a_float$0
                                    ]
                                ], 1);
                                var x$2 = match$3[1];
                                r$3[1] = x$2;
                                return consume_arg$0(0);
                            case 10:
                                var specs = param[1];
                                no_arg$0(0);
                                return caml_call2(Stdlib_List[18], treat_action$0, specs);
                            case 11:
                                var f$4 = param[2], symb = param[1], arg$5 = get_arg$0(0);
                                if (caml_call2(Stdlib_List[37], arg$5, symb)) {
                                    caml_call1(f$4, arg$5);
                                    return consume_arg$0(0);
                                }
                                var _aa_ = make_symlist(cst$6, cst$5, cst$4, symb);
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Stop,
                                    [
                                        1,
                                        s$0,
                                        arg$5,
                                        caml_call2(Stdlib[28], cst_one_of, _aa_)
                                    ]
                                ], 1);
                            case 12:
                                var f$5 = param[1];
                                no_arg$0(0);
                                for(;;){
                                    if (current[1] >= (argv[1].length - 2 | 0)) return 0;
                                    var _ab_ = current[1] + 1 | 0;
                                    caml_call1(f$5, caml_check_bound(argv[1], _ab_)[1 + _ab_]);
                                    consume_arg$0(0);
                                }
                                break;
                            case 13:
                                var f$6 = param[1];
                                no_arg$0(0);
                                var acc = [
                                    0,
                                    0
                                ];
                                for(;;){
                                    if (current[1] >= (argv[1].length - 2 | 0)) return caml_call1(f$6, caml_call1(Stdlib_List[10], acc[1]));
                                    var _ad_ = current[1] + 1 | 0, _ac_ = acc[1];
                                    acc[1] = [
                                        0,
                                        caml_check_bound(argv[1], _ad_)[1 + _ad_],
                                        _ac_
                                    ];
                                    consume_arg$0(0);
                                }
                                break;
                            default:
                                var f$7 = param[1];
                                if (1 - allow_expand) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stdlib[6],
                                    cst_Arg_Expand_is_is_only_allo
                                ], 1);
                                var arg$6 = get_arg$0(0), newarg = caml_call1(f$7, arg$6);
                                consume_arg$0(0);
                                var before = caml_call3(Stdlib_Array[6], argv[1], 0, current[1] + 1 | 0), after = caml_call3(Stdlib_Array[6], argv[1], current[1] + 1 | 0, (argv[1].length - 1 - current[1] | 0) - 1 | 0);
                                argv[1] = caml_call1(Stdlib_Array[5], [
                                    0,
                                    before,
                                    [
                                        0,
                                        newarg,
                                        [
                                            0,
                                            after,
                                            0
                                        ]
                                    ]
                                ]);
                                return 0;
                        }
                    };
                    let no_arg$0 = no_arg, get_arg$0 = get_arg, consume_arg$0 = consume_arg, treat_action$0 = treat_action;
                    treat_action(action);
                } else caml_call1(anonfun, s);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                if (exn[1] === Bad) {
                    var m = exn[2];
                    throw caml_maybe_attach_backtrace(convert_error([
                        3,
                        m
                    ]), 1);
                }
                if (exn[1] !== Stop) throw caml_maybe_attach_backtrace(exn, 0);
                var e = exn[2];
                throw caml_maybe_attach_backtrace(convert_error(e), 1);
            }
            current[1]++;
        }
    }
    function parse_and_expand_argv_dynamic(current, argv, speclist, anonfun, errmsg) {
        return parse_and_expand_argv_dynamic_(1, current, argv, speclist, anonfun, errmsg);
    }
    function parse_argv_dynamic(opt, argv, speclist, anonfun, errmsg) {
        var current$0 = opt ? opt[1] : current;
        return parse_and_expand_argv_dynamic_(0, current$0, [
            0,
            argv
        ], speclist, anonfun, errmsg);
    }
    function parse_argv(opt, argv, speclist, anonfun, errmsg) {
        var current$0 = opt ? opt[1] : current;
        return parse_argv_dynamic([
            0,
            current$0
        ], argv, [
            0,
            speclist
        ], anonfun, errmsg);
    }
    function parse(l, f, msg) {
        try {
            var _U_ = parse_argv(0, caml_sys_argv(0), l, f, msg);
            return _U_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _l_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _m_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function parse_dynamic(l, f, msg) {
        try {
            var _T_1 = parse_argv_dynamic(0, caml_sys_argv(0), l, f, msg);
            return _T_1;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _n_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _o_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function parse_expand(l, f, msg) {
        try {
            var argv = [
                0,
                caml_sys_argv(0)
            ], spec = [
                0,
                l
            ], current$0 = [
                0,
                current[1]
            ], _S_ = parse_and_expand_argv_dynamic(current$0, argv, spec, f, msg);
            return _S_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Bad) {
                var msg$0 = exn[2];
                caml_call2(Stdlib_Printf[3], _p_, msg$0);
                return caml_call1(Stdlib[99], 2);
            }
            if (exn[1] !== Help) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$1 = exn[2];
            caml_call2(Stdlib_Printf[2], _q_, msg$1);
            return caml_call1(Stdlib[99], 0);
        }
    }
    function second_word(s) {
        var len = caml_ml_string_length(s);
        function loop(n) {
            var n$0 = n;
            for(;;){
                if (len <= n$0) return len;
                if (32 !== caml_string_get(s, n$0)) return n$0;
                var n$1 = n$0 + 1 | 0;
                n$0 = n$1;
            }
        }
        try {
            var n$0 = caml_call2(Stdlib_String[36], s, 9);
        } catch (_Q_) {
            var _O_ = caml_wrap_exception(_Q_);
            if (_O_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_O_, 0);
            try {
                var n = caml_call2(Stdlib_String[36], s, 32);
            } catch (_R_) {
                var _P_ = caml_wrap_exception(_R_);
                if (_P_ === Stdlib[8]) return len;
                throw caml_maybe_attach_backtrace(_P_, 0);
            }
            return loop(n + 1 | 0);
        }
        return loop(n$0 + 1 | 0);
    }
    function max_arg_len(cur, param) {
        var doc = param[3], spec = param[2], kwd = param[1];
        if (11 === spec[0]) return caml_call2(Stdlib_Int[11], cur, caml_ml_string_length(kwd));
        var _N_ = caml_ml_string_length(kwd) + second_word(doc) | 0;
        return caml_call2(Stdlib_Int[11], cur, _N_);
    }
    function replace_leading_tab(s) {
        var seen = [
            0,
            0
        ];
        return caml_call2(Stdlib_String[18], function(c) {
            if (9 === c && !seen[1]) {
                seen[1] = 1;
                return 32;
            }
            return c;
        }, s);
    }
    function align(opt, speclist) {
        var limit = opt ? opt[1] : Stdlib[19], completed = add_help(speclist), len = caml_call3(Stdlib_List[26], max_arg_len, 0, completed), len$0 = caml_call2(Stdlib_Int[10], len, limit);
        return caml_call2(Stdlib_List[20], function(ksd) {
            var kwd = ksd[1], spec = ksd[2];
            if (ksd[3] === cst$8) return ksd;
            if (11 === spec[0]) {
                var msg$0 = ksd[3], cutcol$0 = second_word(msg$0), _K_ = caml_call2(Stdlib_Int[11], 0, len$0 - cutcol$0 | 0) + 3 | 0, spaces$0 = caml_call2(Stdlib_String[1], _K_, 32), _L_ = replace_leading_tab(msg$0), _M_ = caml_call2(Stdlib[28], spaces$0, _L_);
                return [
                    0,
                    kwd,
                    spec,
                    caml_call2(Stdlib[28], cst$7, _M_)
                ];
            }
            var msg = ksd[3], spec$0 = ksd[2], cutcol = second_word(msg), kwd_len = caml_ml_string_length(kwd), diff = (len$0 - kwd_len | 0) - cutcol | 0;
            if (0 >= diff) return [
                0,
                kwd,
                spec$0,
                replace_leading_tab(msg)
            ];
            var spaces = caml_call2(Stdlib_String[1], diff, 32), _I_ = replace_leading_tab(msg), prefix = caml_call3(Stdlib_String[16], _I_, 0, cutcol), suffix = caml_call3(Stdlib_String[16], msg, cutcol, caml_ml_string_length(msg) - cutcol | 0), _J_ = caml_call2(Stdlib[28], spaces, suffix);
            return [
                0,
                kwd,
                spec$0,
                caml_call2(Stdlib[28], prefix, _J_)
            ];
        }, completed);
    }
    function read_aux(trim, sep, file) {
        var ic = caml_call1(Stdlib[80], file), buf = caml_call1(Stdlib_Buffer[1], 200), words = [
            0,
            0
        ];
        function stash(param) {
            var word = caml_call1(Stdlib_Buffer[2], buf);
            if (trim) {
                var len = caml_ml_string_length(word);
                a: {
                    if (0 < len && 13 === caml_string_get(word, len - 1 | 0)) {
                        var _H_ = caml_call3(Stdlib_String[16], word, 0, len - 1 | 0);
                        break a;
                    }
                    var _H_ = word;
                }
                var word$0 = _H_;
            } else var word$0 = word;
            words[1] = [
                0,
                word$0,
                words[1]
            ];
            return caml_call1(Stdlib_Buffer[8], buf);
        }
        try {
            for(;;){
                var c = caml_call1(Stdlib[82], ic);
                if (c === sep) stash(0);
                else caml_call2(Stdlib_Buffer[12], buf, c);
            }
        } catch (_G_) {
            var _E_ = caml_wrap_exception(_G_);
            if (_E_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_E_, 0);
            if (0 < caml_call1(Stdlib_Buffer[7], buf)) stash(0);
            caml_call1(Stdlib[93], ic);
            var _F_ = caml_call1(Stdlib_List[10], words[1]);
            return caml_call1(Stdlib_Array[11], _F_);
        }
    }
    var _r_ = 10, _s_ = 1;
    function read_arg(_D_) {
        return read_aux(_s_, _r_, _D_);
    }
    var _t_ = 0, _u_ = 0, _v_ = [
        0,
        [
            2,
            0,
            [
                0,
                0
            ]
        ],
        "%s%c"
    ];
    function read_arg0(_C_) {
        return read_aux(_u_, _t_, _C_);
    }
    function write_aux(sep, file, args) {
        var oc = caml_call1(Stdlib[61], file);
        caml_call2(Stdlib_Array[12], function(s) {
            return caml_call4(Stdlib_Printf[1], oc, _v_, s, sep);
        }, args);
        return caml_call1(Stdlib[76], oc);
    }
    var _w_ = 10;
    function write_arg(_A_, _B_) {
        return write_aux(_w_, _A_, _B_);
    }
    var _x_ = 0;
    function write_arg0(_y_, _z_) {
        return write_aux(_x_, _y_, _z_);
    }
    var Stdlib_Arg = [
        0,
        parse,
        parse_dynamic,
        parse_argv,
        parse_argv_dynamic,
        parse_and_expand_argv_dynamic,
        parse_expand,
        Help,
        Bad,
        usage,
        usage_string,
        align,
        current,
        read_arg,
        read_arg0,
        write_arg,
        write_arg0
    ];
    runtime.caml_register_global(55, Stdlib_Arg, "Stdlib__Arg");
    return;
})(globalThis);
//# 17050 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst_s = "%s\n", cst_Program_not_linked_with_g_$0 = "(Program not linked with -g, cannot print stack backtrace)\n", cst_characters = ", characters ", cst_Fatal_error_exception = "Fatal error: exception ", cst_Fatal_error_exception_s = "Fatal error: exception %s\n", cst_Uncaught_exception = "Uncaught exception: ", cst_Uncaught_exception_s = "Uncaught exception: %s\n", caml_check_bound = runtime.caml_check_bound, caml_get_exception_raw_backtra = runtime.caml_get_exception_raw_backtrace, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$4, cst$3 = cst$4, partial = [
        4,
        0,
        0,
        0,
        [
            12,
            45,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ]
    ], cst$1 = cst$4, cst$2 = cst$4, cst = "_", locfmt = [
        0,
        [
            11,
            'File "',
            [
                2,
                0,
                [
                    11,
                    '", line ',
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst_characters,
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            ": ",
                                            [
                                                2,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        'File "%s", line %d, characters %d-%d: %s'
    ], Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Obj = global_data.Stdlib__Obj, printers = caml_call1(Stdlib_Atomic[1], 0), _a_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _b_ = [
        0,
        [
            4,
            0,
            0,
            0,
            0
        ],
        "%d"
    ], _c_ = [
        0,
        [
            11,
            ", ",
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        ", %s%s"
    ], _d_ = [
        0,
        [
            12,
            40,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        41,
                        0
                    ]
                ]
            ]
        ],
        "(%s%s)"
    ], _e_ = [
        0,
        [
            12,
            40,
            [
                2,
                0,
                [
                    12,
                    41,
                    0
                ]
            ]
        ],
        "(%s)"
    ], cst_Out_of_memory = "Out of memory", cst_Stack_overflow = "Stack overflow", cst_Pattern_matching_failed = "Pattern matching failed", cst_Assertion_failed = "Assertion failed", cst_Undefined_recursive_module = "Undefined recursive module", _f_ = [
        0,
        [
            11,
            cst_Uncaught_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Uncaught_exception_s
    ], _g_ = [
        0,
        [
            11,
            cst_Uncaught_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Uncaught_exception_s
    ], cst_Raised_at = "Raised at", cst_Re_raised_at = "Re-raised at", cst_Raised_by_primitive_operat = "Raised by primitive operation at", cst_Called_from = "Called from", _h_ = [
        0,
        [
            12,
            32,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        " %d"
    ], cst_inlined = " (inlined)", _i_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        11,
                        ' in file "',
                        [
                            2,
                            0,
                            [
                                12,
                                34,
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        ", line",
                                        [
                                            2,
                                            0,
                                            [
                                                11,
                                                cst_characters,
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        '%s %s in file "%s"%s, line%s, characters %d-%d'
    ], _j_ = [
        0,
        [
            11,
            "s ",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    45,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "s %d-%d"
    ], _k_ = [
        0,
        [
            2,
            0,
            [
                11,
                " unknown location",
                0
            ]
        ],
        "%s unknown location"
    ], _l_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        cst_s
    ], _m_ = [
        0,
        [
            11,
            cst_Program_not_linked_with_g_$0,
            0
        ],
        cst_Program_not_linked_with_g_$0
    ], _n_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        cst_s
    ], cst_Program_not_linked_with_g_ = cst_Program_not_linked_with_g_$0;
    function field(x, i) {
        var f = x[1 + i];
        if (!caml_call1(Stdlib_Obj[1], f)) return caml_call2(Stdlib_Printf[4], _b_, f);
        var _ah_ = Stdlib_Obj[15];
        if (caml_obj_tag(f) === _ah_) return caml_call2(Stdlib_Printf[4], _a_, f);
        var _ai_ = Stdlib_Obj[16];
        return caml_obj_tag(f) === _ai_ ? caml_call1(Stdlib[35], f) : cst;
    }
    function other_fields(x, i) {
        if (x.length - 1 <= i) return cst$0;
        var _af_ = other_fields(x, i + 1 | 0), _ag_ = field(x, i);
        return caml_call3(Stdlib_Printf[4], _c_, _ag_, _af_);
    }
    function use_printers(x) {
        var param = caml_call1(Stdlib_Atomic[3], printers);
        for(;;){
            if (!param) return 0;
            var tl = param[2], hd = param[1];
            a: {
                try {
                    var val = caml_call1(hd, x);
                } catch (_ae_) {
                    break a;
                }
                if (val) {
                    var s = val[1];
                    return [
                        0,
                        s
                    ];
                }
            }
            param = tl;
        }
    }
    function string_of_extension_constructo(t) {
        if (0 === caml_obj_tag(t)) {
            var constructor = t[1][1], match = t.length - 1;
            if (2 < match >>> 0) var _aa_ = other_fields(t, 2), _ab_ = field(t, 1), _ad_ = caml_call3(Stdlib_Printf[4], _d_, _ab_, _aa_);
            else switch(match){
                case 0:
                    var _ad_ = cst$1;
                    break;
                case 1:
                    var _ad_ = cst$2;
                    break;
                default:
                    var _ac_ = field(t, 1), _ad_ = caml_call2(Stdlib_Printf[4], _e_, _ac_);
            }
            var match$0 = [
                0,
                constructor,
                [
                    0,
                    _ad_
                ]
            ];
        } else var match$0 = [
            0,
            t[1],
            0
        ];
        var fields_opt = match$0[2], constructor$0 = match$0[1];
        if (!fields_opt) return constructor$0;
        var f = fields_opt[1];
        return caml_call2(Stdlib[28], constructor$0, f);
    }
    function to_string_default(x) {
        if (x === Stdlib[9]) return cst_Out_of_memory;
        if (x === Stdlib[10]) return cst_Stack_overflow;
        if (x[1] === Stdlib[4]) {
            var match = x[2], char$0 = match[3], line = match[2], file = match[1];
            return caml_call6(Stdlib_Printf[4], locfmt, file, line, char$0, char$0 + 5 | 0, cst_Pattern_matching_failed);
        }
        if (x[1] === Stdlib[5]) {
            var match$0 = x[2], char$1 = match$0[3], line$0 = match$0[2], file$0 = match$0[1];
            return caml_call6(Stdlib_Printf[4], locfmt, file$0, line$0, char$1, char$1 + 6 | 0, cst_Assertion_failed);
        }
        if (x[1] !== Stdlib[15]) return string_of_extension_constructo(x);
        var match$1 = x[2], char$2 = match$1[3], line$1 = match$1[2], file$1 = match$1[1];
        return caml_call6(Stdlib_Printf[4], locfmt, file$1, line$1, char$2, char$2 + 6 | 0, cst_Undefined_recursive_module);
    }
    function to_string(e) {
        var match = use_printers(e);
        if (!match) return to_string_default(e);
        var s = match[1];
        return s;
    }
    function print(fct, arg) {
        try {
            var _$_ = caml_call1(fct, arg);
            return _$_;
        } catch (x$0) {
            var x = caml_wrap_exception(x$0), ___ = to_string(x);
            caml_call2(Stdlib_Printf[3], _f_, ___);
            caml_call1(Stdlib[63], Stdlib[40]);
            throw caml_maybe_attach_backtrace(x, 0);
        }
    }
    function catch$0(fct, arg) {
        try {
            var _Z_ = caml_call1(fct, arg);
            return _Z_;
        } catch (x$0) {
            var x = caml_wrap_exception(x$0);
            caml_call1(Stdlib[63], Stdlib[39]);
            var _Y_ = to_string(x);
            caml_call2(Stdlib_Printf[3], _g_, _Y_);
            return caml_call1(Stdlib[99], 2);
        }
    }
    function raw_backtrace_entries(bt) {
        return bt;
    }
    function convert_raw_backtrace(bt) {
        return [
            0,
            runtime.caml_convert_raw_backtrace(bt)
        ];
    }
    function format_backtrace_slot(pos, slot) {
        function info(is_raise) {
            return is_raise ? 0 === pos ? cst_Raised_at : cst_Re_raised_at : 0 === pos ? cst_Raised_by_primitive_operat : cst_Called_from;
        }
        if (0 === slot[0]) {
            var lines = slot[3] === slot[6] ? caml_call2(Stdlib_Printf[4], _h_, slot[3]) : caml_call3(Stdlib_Printf[4], _j_, slot[3], slot[6]), _R_ = slot[7], _S_ = slot[4], _T_1 = slot[8] ? cst_inlined : cst$3, _U_ = slot[2], _V_ = slot[9], _W_ = info(slot[1]);
            return [
                0,
                caml_call8(Stdlib_Printf[4], _i_, _W_, _V_, _U_, _T_1, lines, _S_, _R_)
            ];
        }
        if (slot[1]) return 0;
        var _X_ = info(0);
        return [
            0,
            caml_call2(Stdlib_Printf[4], _k_, _X_)
        ];
    }
    function print_raw_backtrace(outchan, raw_backtrace) {
        var backtrace = convert_raw_backtrace(raw_backtrace);
        if (!backtrace) return caml_call2(Stdlib_Printf[1], outchan, _m_);
        var a = backtrace[1], _P_ = a.length - 2 | 0, _O_ = 0;
        if (_P_ >= 0) {
            var i = _O_;
            for(;;){
                var match = format_backtrace_slot(i, caml_check_bound(a, i)[1 + i]);
                if (match) {
                    var str = match[1];
                    caml_call3(Stdlib_Printf[1], outchan, _l_, str);
                }
                var _Q_ = i + 1 | 0;
                if (_P_ === i) break;
                i = _Q_;
            }
        }
        return 0;
    }
    function print_backtrace(outchan) {
        return print_raw_backtrace(outchan, caml_get_exception_raw_backtra(0));
    }
    function raw_backtrace_to_string(raw_backtrace) {
        var backtrace = convert_raw_backtrace(raw_backtrace);
        if (!backtrace) return cst_Program_not_linked_with_g_;
        var a = backtrace[1], b = caml_call1(Stdlib_Buffer[1], 1024), _M_ = a.length - 2 | 0, _L_ = 0;
        if (_M_ >= 0) {
            var i = _L_;
            for(;;){
                var match = format_backtrace_slot(i, caml_check_bound(a, i)[1 + i]);
                if (match) {
                    var str = match[1];
                    caml_call3(Stdlib_Printf[5], b, _n_, str);
                }
                var _N_ = i + 1 | 0;
                if (_M_ === i) break;
                i = _N_;
            }
        }
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function backtrace_slot_is_raise(param) {
        return 0 === param[0] ? param[1] : param[1];
    }
    function backtrace_slot_is_inline(param) {
        return 0 === param[0] ? param[8] : 0;
    }
    function backtrace_slot_location(param) {
        return 0 === param[0] ? [
            0,
            [
                0,
                param[2],
                param[3],
                param[4],
                param[5],
                param[6],
                param[7]
            ]
        ] : 0;
    }
    function backtrace_slot_defname(param) {
        if (0 === param[0] && param[9] !== cst$4) return [
            0,
            param[9]
        ];
        return 0;
    }
    function backtrace_slots(raw_backtrace) {
        var match = convert_raw_backtrace(raw_backtrace);
        if (!match) return 0;
        var backtrace = match[1], i$1 = backtrace.length - 2 | 0, i = i$1;
        for(;;){
            if (-1 === i) var _K_ = 0;
            else {
                var _J_ = 0 === caml_check_bound(backtrace, i)[1 + i][0] ? 1 : 0;
                if (!_J_) {
                    var i$0 = i - 1 | 0;
                    i = i$0;
                    continue;
                }
                var _K_ = _J_;
            }
            return _K_ ? [
                0,
                backtrace
            ] : 0;
        }
    }
    function backtrace_slots_of_raw_entry(entry) {
        return backtrace_slots([
            0,
            entry
        ]);
    }
    function raw_backtrace_length(bt) {
        return bt.length - 1;
    }
    function get_backtrace(param) {
        return raw_backtrace_to_string(caml_get_exception_raw_backtra(0));
    }
    function register_printer(fn) {
        for(;;){
            var old_printers = caml_call1(Stdlib_Atomic[3], printers), new_printers = [
                0,
                fn,
                old_printers
            ], success = caml_call3(Stdlib_Atomic[6], printers, old_printers, new_printers), _I_ = 1 - success;
            if (!_I_) return _I_;
        }
    }
    function exn_slot(x) {
        return 0 === caml_obj_tag(x) ? x[1] : x;
    }
    function exn_slot_id(x) {
        var slot = exn_slot(x);
        return slot[2];
    }
    function exn_slot_name(x) {
        var slot = exn_slot(x);
        return slot[1];
    }
    var errors = [
        0,
        cst$4,
        "(Cannot print locations:\n bytecode executable program file not found)",
        "(Cannot print locations:\n bytecode executable program file appears to be corrupt)",
        "(Cannot print locations:\n bytecode executable program file has wrong magic number)",
        "(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)"
    ].slice(), _o_ = [
        0,
        [
            11,
            cst_Fatal_error_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Fatal_error_exception_s
    ];
    function default_uncaught_exception_han(exn, raw_backtrace) {
        var _F_ = to_string(exn);
        caml_call2(Stdlib_Printf[3], _o_, _F_);
        print_raw_backtrace(Stdlib[40], raw_backtrace);
        var status = runtime.caml_ml_debug_info_status(0);
        if (status < 0) {
            var _G_ = caml_call1(Stdlib[18], status), _H_ = caml_check_bound(errors, _G_)[1 + _G_];
            caml_call1(Stdlib[53], _H_);
        }
        return caml_call1(Stdlib[63], Stdlib[40]);
    }
    var uncaught_exception_handler = [
        0,
        default_uncaught_exception_han
    ];
    function set_uncaught_exception_handler(fn) {
        uncaught_exception_handler[1] = fn;
        return 0;
    }
    var empty_backtrace = [
        0
    ], cst_Fatal_error_out_of_memory_ = "Fatal error: out of memory in uncaught exception handler", _p_ = [
        0,
        [
            11,
            cst_Fatal_error_exception,
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        cst_Fatal_error_exception_s
    ], _q_ = [
        0,
        [
            11,
            "Fatal error in uncaught exception handler: exception ",
            [
                2,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        "Fatal error in uncaught exception handler: exception %s\n"
    ];
    function handle_uncaught_exception(exn$0, debugger_in_use) {
        try {
            try {
                var raw_backtrace = debugger_in_use ? empty_backtrace : caml_get_exception_raw_backtra(0);
                try {
                    caml_call1(Stdlib[103], 0);
                } catch (_E_) {}
                try {
                    var _A_ = caml_call2(uncaught_exception_handler[1], exn$0, raw_backtrace), _z_ = _A_;
                } catch (exn$1) {
                    var exn = caml_wrap_exception(exn$1), raw_backtrace$0 = caml_get_exception_raw_backtra(0), _x_ = to_string(exn$0);
                    caml_call2(Stdlib_Printf[3], _p_, _x_);
                    print_raw_backtrace(Stdlib[40], raw_backtrace);
                    var _y_ = to_string(exn);
                    caml_call2(Stdlib_Printf[3], _q_, _y_);
                    print_raw_backtrace(Stdlib[40], raw_backtrace$0);
                    var _z_ = caml_call1(Stdlib[63], Stdlib[40]);
                }
                var _B_ = _z_;
            } catch (_D_) {
                var _w_ = caml_wrap_exception(_D_);
                if (_w_ !== Stdlib[9]) throw caml_maybe_attach_backtrace(_w_, 0);
                var _B_ = caml_call1(Stdlib[53], cst_Fatal_error_out_of_memory_);
            }
            return _B_;
        } catch (_C_) {
            return 0;
        }
    }
    runtime.caml_register_named_value("Printexc.handle_uncaught_exception", handle_uncaught_exception);
    var Stdlib_Printexc = [
        0,
        to_string,
        to_string_default,
        print,
        catch$0,
        print_backtrace,
        get_backtrace,
        runtime.caml_record_backtrace,
        runtime.caml_backtrace_status,
        register_printer,
        use_printers,
        raw_backtrace_entries,
        function(_v_) {
            return caml_get_exception_raw_backtra(_v_);
        },
        print_raw_backtrace,
        raw_backtrace_to_string,
        default_uncaught_exception_han,
        set_uncaught_exception_handler,
        backtrace_slots,
        backtrace_slots_of_raw_entry,
        [
            0,
            backtrace_slot_is_raise,
            backtrace_slot_is_inline,
            backtrace_slot_location,
            backtrace_slot_defname,
            format_backtrace_slot
        ],
        raw_backtrace_length,
        function(_u_, _t_) {
            return runtime.caml_raw_backtrace_slot(_u_, _t_);
        },
        function(_s_) {
            return runtime.caml_convert_raw_backtrace_slot(_s_);
        },
        function(_r_) {
            return runtime.caml_raw_backtrace_next_slot(_r_);
        },
        exn_slot_id,
        exn_slot_name,
        string_of_extension_constructo
    ];
    runtime.caml_register_global(43, Stdlib_Printexc, "Stdlib__Printexc");
    return;
})(globalThis);
//# 17545 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_restore_raw_backtrace = runtime.caml_restore_raw_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib = global_data.Stdlib;
    function const$0(c, param) {
        return c;
    }
    function compose(f, g, x) {
        return caml_call1(f, caml_call1(g, x));
    }
    function flip(f, x, y) {
        return caml_call2(f, y, x);
    }
    function negate(p, v) {
        return 1 - caml_call1(p, v);
    }
    var Finally_raised = [
        248,
        "Stdlib.Fun.Finally_raised",
        runtime.caml_fresh_oo_id(0)
    ], cst_Fun_Finally_raised = "Fun.Finally_raised: ";
    caml_call1(Stdlib_Printexc[9], function(param) {
        if (param[1] !== Finally_raised) return 0;
        var exn = param[2], _a_ = caml_call1(Stdlib_Printexc[1], exn);
        return [
            0,
            caml_call2(Stdlib[28], cst_Fun_Finally_raised, _a_)
        ];
    });
    var dummy = 0;
    function protect(finally$0, work) {
        function finally_no_exn(param) {
            try {
                caml_call1(finally$0, 0);
                return;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0), bt = caml_call1(Stdlib_Printexc[12], 0), exn = [
                    0,
                    Finally_raised,
                    e
                ];
                caml_restore_raw_backtrace(exn, bt);
                throw caml_maybe_attach_backtrace(exn, 0);
            }
        }
        try {
            var result = caml_call1(work, 0);
        } catch (work_exn$0) {
            var work_exn = caml_wrap_exception(work_exn$0), work_bt = caml_call1(Stdlib_Printexc[12], 0);
            finally_no_exn(0);
            caml_restore_raw_backtrace(work_exn, work_bt);
            throw caml_maybe_attach_backtrace(work_exn, 0);
        }
        finally_no_exn(0);
        return result;
    }
    var Stdlib_Fun = [
        0,
        const$0,
        compose,
        flip,
        negate,
        protect,
        Finally_raised
    ];
    runtime.caml_register_global(4, Stdlib_Fun, "Stdlib__Fun");
    return;
})(globalThis);
//# 17797 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_ba_dim_1 = runtime.caml_ba_dim_1, caml_create_bytes = runtime.caml_create_bytes, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_input_bigarray = runtime.caml_ml_input_bigarray, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Fun = global_data.Stdlib__Fun, stdin = Stdlib[38], open_bin = Stdlib[80], open_text = Stdlib[79], open_gen = Stdlib[81];
    function with_open(openfun, s, f) {
        var ic = caml_call1(openfun, s);
        return caml_call2(Stdlib_Fun[5], function(param) {
            return caml_call1(Stdlib[94], ic);
        }, function(param) {
            return caml_call1(f, ic);
        });
    }
    function with_open_bin(s, f) {
        return with_open(Stdlib[80], s, f);
    }
    function with_open_text(s, f) {
        return with_open(Stdlib[79], s, f);
    }
    function with_open_gen(flags, perm, s, f) {
        return with_open(caml_call2(Stdlib[81], flags, perm), s, f);
    }
    var seek = Stdlib[96][4], pos = Stdlib[96][5], length = Stdlib[96][6], close = Stdlib[93], close_noerr = Stdlib[94];
    function input_char(ic) {
        try {
            var c = caml_call1(Stdlib[82], ic);
        } catch (_x_) {
            var _w_ = caml_wrap_exception(_x_);
            if (_w_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_w_, 0);
        }
        return [
            0,
            c
        ];
    }
    function input_byte(ic) {
        try {
            var n = caml_call1(Stdlib[87], ic);
        } catch (_v_) {
            var _u_ = caml_wrap_exception(_v_);
            if (_u_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_u_, 0);
        }
        return [
            0,
            n
        ];
    }
    function input_line(ic) {
        try {
            var s = caml_call1(Stdlib[83], ic);
        } catch (_t_) {
            var _s_ = caml_wrap_exception(_t_);
            if (_s_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_s_, 0);
        }
        return [
            0,
            s
        ];
    }
    var input = Stdlib[84], cst_input_bigarray = "input_bigarray", _a_ = [
        0,
        0
    ], _b_ = [
        0,
        0
    ], cst_really_input_bigarray = "really_input_bigarray", cst_In_channel_input_all_chann = "In_channel.input_all: channel content is larger than maximum string length";
    function input_bigarray(ic, buf, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ba_dim_1(buf) - len | 0) >= ofs) return caml_ml_input_bigarray(ic, buf, ofs, len);
        return caml_call1(Stdlib[1], cst_input_bigarray);
    }
    function really_input(ic, buf, pos, len) {
        try {
            caml_call4(Stdlib[85], ic, buf, pos, len);
            return _a_;
        } catch (_r_) {
            var _q_ = caml_wrap_exception(_r_);
            if (_q_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_q_, 0);
        }
    }
    function really_input_bigarray(ic, buf, ofs$1, len$1) {
        if (0 <= ofs$1 && 0 <= len$1 && (caml_ba_dim_1(buf) - len$1 | 0) >= ofs$1) {
            var ofs = ofs$1, len = len$1;
            for(;;){
                if (0 >= len) return _b_;
                var r = caml_ml_input_bigarray(ic, buf, ofs, len);
                if (0 === r) return 0;
                var len$0 = len - r | 0, ofs$0 = ofs + r | 0;
                ofs = ofs$0;
                len = len$0;
            }
        }
        return caml_call1(Stdlib[1], cst_really_input_bigarray);
    }
    function really_input_string(ic, len) {
        try {
            var s = caml_call2(Stdlib[86], ic, len);
        } catch (_p_) {
            var _o_ = caml_wrap_exception(_p_);
            if (_o_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_o_, 0);
        }
        return [
            0,
            s
        ];
    }
    function read_upto(ic, buf, ofs, len) {
        var ofs$0 = ofs, len$0 = len;
        for(;;){
            if (0 !== len$0) {
                var r = caml_call4(Stdlib[84], ic, buf, ofs$0, len$0);
                if (0 !== r) {
                    var len$1 = len$0 - r | 0, ofs$1 = ofs$0 + r | 0;
                    ofs$0 = ofs$1;
                    len$0 = len$1;
                    continue;
                }
            }
            return ofs$0 - ofs | 0;
        }
    }
    function ensure(buf, ofs, n) {
        var len = caml_ml_bytes_length(buf);
        if ((ofs + n | 0) <= len) return buf;
        var new_len = [
            0,
            len
        ];
        for(;;){
            if (new_len[1] >= (ofs + n | 0)) break;
            new_len[1] = (2 * new_len[1] | 0) + 1 | 0;
        }
        var new_len$0 = new_len[1], new_len$1 = new_len$0 <= Stdlib_Sys[12] ? new_len$0 : ofs < Stdlib_Sys[12] ? Stdlib_Sys[12] : caml_call1(Stdlib[2], cst_In_channel_input_all_chann), new_buf = caml_create_bytes(new_len$1);
        caml_call5(Stdlib_Bytes[11], buf, 0, new_buf, 0, ofs);
        return new_buf;
    }
    function input_all(ic) {
        var chunk_size = 65536;
        try {
            var _k_ = caml_call1(Stdlib[91], ic), _l_ = caml_call1(Stdlib[92], ic) - _k_ | 0, initial_size = _l_;
        } catch (_n_) {
            var _i_ = caml_wrap_exception(_n_);
            if (_i_[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(_i_, 0);
            var initial_size = -1;
        }
        var initial_size$0 = 0 <= initial_size ? initial_size : chunk_size, initial_size$1 = initial_size$0 <= Stdlib_Sys[12] ? initial_size$0 : Stdlib_Sys[12], buf = caml_create_bytes(initial_size$1), nread = read_upto(ic, buf, 0, initial_size$1);
        if (nread < initial_size$1) return caml_call3(Stdlib_Bytes[8], buf, 0, nread);
        try {
            var c = caml_call1(Stdlib[82], ic);
        } catch (_m_) {
            var _j_ = caml_wrap_exception(_m_);
            if (_j_ === Stdlib[12]) return caml_call1(Stdlib_Bytes[44], buf);
            throw caml_maybe_attach_backtrace(_j_, 0);
        }
        var buf$2 = ensure(buf, nread, 65537);
        runtime.caml_bytes_set(buf$2, nread, c);
        var ofs$1 = nread + 1 | 0, buf$0 = buf$2, ofs = ofs$1;
        for(;;){
            var buf$1 = ensure(buf$0, ofs, chunk_size), rem = caml_ml_bytes_length(buf$1) - ofs | 0, r = read_upto(ic, buf$1, ofs, rem);
            if (r < rem) return caml_call3(Stdlib_Bytes[8], buf$1, 0, ofs + r | 0);
            var ofs$0 = ofs + rem | 0;
            buf$0 = buf$1;
            ofs = ofs$0;
        }
    }
    function input_lines(ic) {
        try {
            var line = caml_call1(Stdlib[83], ic);
        } catch (_h_) {
            var _e_ = caml_wrap_exception(_h_);
            if (_e_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_e_, 0);
        }
        var block = [
            0,
            line,
            24029
        ], dst = block, offset = 1;
        for(;;){
            try {
                var line$0 = caml_call1(Stdlib[83], ic);
            } catch (_g_) {
                var _f_ = caml_wrap_exception(_g_);
                if (_f_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_f_, 0);
                dst[1 + offset] = 0;
                return block;
            }
            var dst$0 = [
                0,
                line$0,
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
        }
    }
    function fold_lines(f, accu, ic) {
        var accu$0 = accu;
        for(;;){
            try {
                var line = caml_call1(Stdlib[83], ic);
            } catch (_d_) {
                var _c_ = caml_wrap_exception(_d_);
                if (_c_ === Stdlib[12]) return accu$0;
                throw caml_maybe_attach_backtrace(_c_, 0);
            }
            var accu$1 = caml_call2(f, accu$0, line);
            accu$0 = accu$1;
        }
    }
    var set_binary_mode = Stdlib[95], Stdlib_In_channel = [
        0,
        stdin,
        open_bin,
        open_text,
        open_gen,
        with_open_bin,
        with_open_text,
        with_open_gen,
        close,
        close_noerr,
        input_char,
        input_byte,
        input_line,
        really_input_string,
        input_all,
        input_lines,
        input,
        input_bigarray,
        really_input,
        really_input_bigarray,
        fold_lines,
        seek,
        pos,
        length,
        set_binary_mode,
        runtime.caml_ml_is_binary_mode,
        runtime.caml_sys_isatty
    ];
    runtime.caml_register_global(9, Stdlib_In_channel, "Stdlib__In_channel");
    return;
})(globalThis);
//# 18174 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_Digest_of_hex$1 = "Digest.of_hex", cst_Digest_subbytes$1 = "Digest.subbytes", cst_Digest_substring$1 = "Digest.substring", cst_Digest_to_hex$1 = "Digest.to_hex", caml_blake2_bytes = runtime.caml_blake2_bytes, caml_blake2_final = runtime.caml_blake2_final, caml_blake2_string = runtime.caml_blake2_string, caml_blake2_update = runtime.caml_blake2_update, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_md5_bytes = runtime.caml_md5_bytes, caml_md5_chan = runtime.caml_md5_chan, caml_md5_string = runtime.caml_md5_string, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_In_channel = global_data.Stdlib__In_channel, Stdlib_Int = global_data.Stdlib__Int, Stdlib_String = global_data.Stdlib__String, Stdlib_Char = global_data.Stdlib__Char, Stdlib_Bytes = global_data.Stdlib__Bytes, cst_Digest_of_hex = cst_Digest_of_hex$1, cst_Digest_BLAKE2_wrong_hash_s = "Digest.BLAKE2: wrong hash size", cst_Digest_substring = cst_Digest_substring$1, cst_Digest_subbytes = cst_Digest_subbytes$1, cst_Digest_to_hex = cst_Digest_to_hex$1, cst_Digest_of_hex$0 = cst_Digest_of_hex$1;
    function hex_of_string(d) {
        function char_hex(n) {
            var _o_ = 10 <= n ? (97 + n | 0) - 10 | 0 : 48 + n | 0;
            return caml_call1(Stdlib_Char[1], _o_);
        }
        var len = caml_ml_string_length(d), result = caml_create_bytes(len * 2 | 0), _m_ = len - 1 | 0, _l_ = 0;
        if (_m_ >= 0) {
            var i = _l_;
            for(;;){
                var x = caml_string_get(d, i);
                caml_bytes_unsafe_set(result, i * 2 | 0, char_hex(x >>> 4 | 0));
                caml_bytes_unsafe_set(result, (i * 2 | 0) + 1 | 0, char_hex(x & 15));
                var _n_ = i + 1 | 0;
                if (_m_ === i) break;
                i = _n_;
            }
        }
        return caml_call1(Stdlib_Bytes[44], result);
    }
    function string_of_hex(s) {
        function digit(c) {
            if (65 <= c) {
                if (97 <= c) {
                    if (103 > c) return (c - 97 | 0) + 10 | 0;
                } else if (71 > c) return (c - 65 | 0) + 10 | 0;
            } else if (9 >= c - 48 >>> 0) return c - 48 | 0;
            return caml_call1(Stdlib[1], cst_Digest_of_hex);
        }
        return caml_call2(Stdlib_String[2], caml_ml_string_length(s) / 2 | 0, function(i) {
            var i$0 = 2 * i | 0, _j_ = digit(caml_string_get(s, i$0 + 1 | 0)), _k_ = (digit(caml_string_get(s, i$0)) << 4) + _j_ | 0;
            return caml_call1(Stdlib_Char[1], _k_);
        });
    }
    function BLAKE2(X) {
        var _a_ = X[1] < 1 ? 1 : 0, _b_ = _a_ || (64 < X[1] ? 1 : 0);
        if (_b_) caml_call1(Stdlib[1], cst_Digest_BLAKE2_wrong_hash_s);
        var hash_length = X[1], compare = Stdlib_String[10], equal = Stdlib_String[9];
        function string(str) {
            return caml_blake2_string(hash_length, cst, str, 0, caml_ml_string_length(str));
        }
        function bytes(b) {
            return caml_blake2_bytes(hash_length, cst, b, 0, caml_ml_bytes_length(b));
        }
        function substring(str, ofs, len) {
            var _g_ = ofs < 0 ? 1 : 0;
            if (_g_) var _h_ = _g_;
            else var _i_ = len < 0 ? 1 : 0, _h_ = _i_ || ((caml_ml_string_length(str) - len | 0) < ofs ? 1 : 0);
            if (_h_) caml_call1(Stdlib[1], cst_Digest_substring);
            return caml_blake2_string(hash_length, cst, str, ofs, len);
        }
        function subbytes(b, ofs, len) {
            var _d_ = ofs < 0 ? 1 : 0;
            if (_d_) var _e_ = _d_;
            else var _f_ = len < 0 ? 1 : 0, _e_ = _f_ || ((caml_ml_bytes_length(b) - len | 0) < ofs ? 1 : 0);
            if (_e_) caml_call1(Stdlib[1], cst_Digest_subbytes);
            return caml_blake2_bytes(hash_length, cst, b, ofs, len);
        }
        function channel(ic, toread) {
            var buf_size = 4096, buf = caml_create_bytes(4096), ctx = runtime.caml_blake2_create(hash_length, cst);
            if (0 <= toread) {
                var toread$0 = toread;
                for(;;){
                    if (0 === toread$0) return caml_blake2_final(ctx, hash_length);
                    var _c_ = caml_call2(Stdlib_Int[10], buf_size, toread$0), n = caml_call4(Stdlib_In_channel[16], ic, buf, 0, _c_);
                    if (0 === n) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
                    caml_blake2_update(ctx, buf, 0, n);
                    var toread$1 = toread$0 - n | 0;
                    toread$0 = toread$1;
                }
            } else for(;;){
                var n$0 = caml_call4(Stdlib_In_channel[16], ic, buf, 0, buf_size);
                if (0 === n$0) return caml_blake2_final(ctx, hash_length);
                caml_blake2_update(ctx, buf, 0, n$0);
            }
        }
        function file(filename) {
            return caml_call2(Stdlib_In_channel[5], filename, function(ic) {
                return channel(ic, -1);
            });
        }
        function output(chan, digest) {
            return caml_call2(Stdlib[66], chan, digest);
        }
        function input(chan) {
            return caml_call2(Stdlib[86], chan, hash_length);
        }
        function to_hex(d) {
            if (caml_ml_string_length(d) !== hash_length) caml_call1(Stdlib[1], cst_Digest_to_hex);
            return hex_of_string(d);
        }
        function of_hex(s) {
            if (caml_ml_string_length(s) !== (hash_length * 2 | 0)) caml_call1(Stdlib[1], cst_Digest_of_hex$0);
            return string_of_hex(s);
        }
        return [
            0,
            hash_length,
            compare,
            equal,
            string,
            bytes,
            substring,
            subbytes,
            channel,
            file,
            output,
            input,
            to_hex,
            of_hex
        ];
    }
    var BLAKE128 = BLAKE2([
        0,
        16
    ]), BLAKE256 = BLAKE2([
        0,
        32
    ]), BLAKE512 = BLAKE2([
        0,
        64
    ]), compare = Stdlib_String[10], equal = Stdlib_String[9], cst_Digest_substring$0 = cst_Digest_substring$1, cst_Digest_subbytes$0 = cst_Digest_subbytes$1, cst_Digest_to_hex$0 = cst_Digest_to_hex$1, cst_Digest_from_hex = "Digest.from_hex";
    function string(str) {
        return caml_md5_string(str, 0, caml_ml_string_length(str));
    }
    function bytes(b) {
        return caml_md5_bytes(b, 0, caml_ml_bytes_length(b));
    }
    function substring(str, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_string_length(str) - len | 0) >= ofs) return caml_md5_string(str, ofs, len);
        return caml_call1(Stdlib[1], cst_Digest_substring$0);
    }
    function subbytes(b, ofs, len) {
        if (0 <= ofs && 0 <= len && (caml_ml_bytes_length(b) - len | 0) >= ofs) return caml_md5_bytes(b, ofs, len);
        return caml_call1(Stdlib[1], cst_Digest_subbytes$0);
    }
    function file(filename) {
        return caml_call2(Stdlib_In_channel[5], filename, function(ic) {
            return caml_md5_chan(ic, -1);
        });
    }
    function output(chan, digest) {
        return caml_call2(Stdlib[66], chan, digest);
    }
    function input(chan) {
        return caml_call2(Stdlib[86], chan, 16);
    }
    function to_hex(d) {
        if (16 !== caml_ml_string_length(d)) caml_call1(Stdlib[1], cst_Digest_to_hex$0);
        return hex_of_string(d);
    }
    function of_hex(s) {
        if (32 !== caml_ml_string_length(s)) caml_call1(Stdlib[1], cst_Digest_from_hex);
        return string_of_hex(s);
    }
    var Stdlib_Digest = [
        0,
        compare,
        equal,
        string,
        bytes,
        substring,
        subbytes,
        caml_md5_chan,
        file,
        output,
        input,
        to_hex,
        of_hex,
        of_hex,
        BLAKE128,
        BLAKE256,
        BLAKE512,
        [
            0,
            16,
            compare,
            equal,
            string,
            bytes,
            substring,
            subbytes,
            caml_md5_chan,
            file,
            output,
            input,
            to_hex,
            of_hex
        ]
    ];
    runtime.caml_register_global(21, Stdlib_Digest, "Stdlib__Digest");
    return;
})(globalThis);
//# 18449 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Bigarray_Array3_of_array_n$1 = "Bigarray.Array3.of_array: non-cubic data", caml_array_make = runtime.caml_array_make, caml_ba_change_layout = runtime.caml_ba_change_layout, caml_ba_create = runtime.caml_ba_create, caml_ba_dim_1 = runtime.caml_ba_dim_1, caml_ba_dim_2 = runtime.caml_ba_dim_2, caml_ba_kind = runtime.caml_ba_kind, caml_ba_num_dims = runtime.caml_ba_num_dims, caml_ba_reshape = runtime.caml_ba_reshape, caml_ba_set_1 = runtime.caml_ba_set_1, caml_ba_set_2 = runtime.caml_ba_set_2, caml_ba_set_3 = runtime.caml_ba_set_3, caml_ba_set_generic = runtime.caml_ba_set_generic, caml_ba_slice = runtime.caml_ba_slice, caml_check_bound = runtime.caml_check_bound, caml_mul = runtime.caml_mul;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Sys = global_data.Stdlib__Sys;
    function kind_size_in_bytes(param) {
        switch(param){
            case 0:
                return 4;
            case 1:
                return 8;
            case 2:
                return 1;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 2;
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
                return Stdlib_Sys[9] / 8 | 0;
            case 9:
                return Stdlib_Sys[9] / 8 | 0;
            case 10:
                return 8;
            case 11:
                return 16;
            case 12:
                return 1;
            default:
                return 2;
        }
    }
    var cst_Bigarray_Array2_of_array_n = "Bigarray.Array2.of_array: non-rectangular data", cst_Bigarray_Array3_of_array_n = cst_Bigarray_Array3_of_array_n$1, cst_Bigarray_Array3_of_array_n$0 = cst_Bigarray_Array3_of_array_n$1, cst_Bigarray_array0_of_genarra = "Bigarray.array0_of_genarray", cst_Bigarray_array1_of_genarra = "Bigarray.array1_of_genarray", cst_Bigarray_array2_of_genarra = "Bigarray.array2_of_genarray", cst_Bigarray_array3_of_genarra = "Bigarray.array3_of_genarray";
    function cloop(arr, idx, f, col, max) {
        if (col === idx.length - 1) {
            caml_ba_set_generic(arr, idx, caml_call1(f, idx));
            return;
        }
        var _am_ = caml_check_bound(max, col)[1 + col] - 1 | 0, _al_ = 0;
        if (_am_ >= 0) {
            var j = _al_;
            for(;;){
                caml_check_bound(idx, col)[1 + col] = j;
                cloop(arr, idx, f, col + 1 | 0, max);
                var _an_ = j + 1 | 0;
                if (_am_ === j) break;
                j = _an_;
            }
        }
    }
    function floop(arr, idx, f, col, max) {
        if (0 > col) {
            caml_ba_set_generic(arr, idx, caml_call1(f, idx));
            return;
        }
        var _aj_ = caml_check_bound(max, col)[1 + col], _ai_ = 1;
        if (_aj_ >= 1) {
            var j = _ai_;
            for(;;){
                caml_check_bound(idx, col)[1 + col] = j;
                floop(arr, idx, f, col - 1 | 0, max);
                var _ak_ = j + 1 | 0;
                if (_aj_ === j) break;
                j = _ak_;
            }
        }
    }
    function init(kind, layout, dims, f) {
        var arr = caml_ba_create(kind, layout, dims), dlen = dims.length - 1;
        return layout ? (floop(arr, caml_array_make(dlen, 1), f, dlen - 1 | 0, dims), arr) : (cloop(arr, caml_array_make(dlen, 0), f, 0, dims), arr);
    }
    function dims(a) {
        var n = caml_ba_num_dims(a), d = caml_array_make(n, 0), _af_ = n - 1 | 0, _ae_ = 0;
        if (_af_ >= 0) {
            var i = _ae_;
            for(;;){
                var _ag_ = runtime.caml_ba_dim(a, i);
                caml_check_bound(d, i)[1 + i] = _ag_;
                var _ah_ = i + 1 | 0;
                if (_af_ === i) break;
                i = _ah_;
            }
        }
        return d;
    }
    function size_in_bytes(arr) {
        var _ac_ = dims(arr), _ad_ = caml_call3(Stdlib_Array[18], caml_mul, 1, _ac_);
        return caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _ad_);
    }
    function create(kind, layout) {
        return caml_ba_create(kind, layout, [
            0
        ]);
    }
    function get(arr) {
        return runtime.caml_ba_get_generic(arr, [
            0
        ]);
    }
    function set(arr) {
        var _aa_ = [
            0
        ];
        return function(_ab_) {
            return caml_ba_set_generic(arr, _aa_, _ab_);
        };
    }
    function size_in_bytes$0(arr) {
        return kind_size_in_bytes(caml_ba_kind(arr));
    }
    function of_value(kind, layout, v) {
        var a = create(kind, layout);
        set(a)(v);
        return a;
    }
    function create$0(kind, layout, dim) {
        return caml_ba_create(kind, layout, [
            0,
            dim
        ]);
    }
    function size_in_bytes$1(arr) {
        var _$_ = caml_ba_dim_1(arr);
        return caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _$_);
    }
    function slice(a, n) {
        return runtime.caml_ba_layout(a) ? caml_ba_slice(a, [
            0,
            n
        ]) : caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$0(kind, layout, dim, f) {
        var arr = create$0(kind, layout, dim);
        if (layout) {
            var _Z_ = 1;
            if (dim >= 1) {
                var i$0 = _Z_;
                for(;;){
                    caml_ba_set_1(arr, i$0, caml_call1(f, i$0));
                    var ___ = i$0 + 1 | 0;
                    if (dim === i$0) break;
                    i$0 = ___;
                }
            }
            return arr;
        }
        var _X_ = dim - 1 | 0, _W_ = 0;
        if (_X_ >= 0) {
            var i = _W_;
            for(;;){
                caml_ba_set_1(arr, i, caml_call1(f, i));
                var _Y_ = i + 1 | 0;
                if (_X_ === i) break;
                i = _Y_;
            }
        }
        return arr;
    }
    function of_array(kind, layout, data) {
        var ba = create$0(kind, layout, data.length - 1), ofs = layout ? 1 : 0, _U_ = data.length - 2 | 0, _T_1 = 0;
        if (_U_ >= 0) {
            var i = _T_1;
            for(;;){
                caml_ba_set_1(ba, i + ofs | 0, caml_check_bound(data, i)[1 + i]);
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return ba;
    }
    function create$1(kind, layout, dim1, dim2) {
        return caml_ba_create(kind, layout, [
            0,
            dim1,
            dim2
        ]);
    }
    function size_in_bytes$2(arr) {
        var _R_ = caml_ba_dim_2(arr), _S_ = caml_ba_dim_1(arr);
        return caml_mul(caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _S_), _R_);
    }
    function slice_left(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function slice_right(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$1(kind, layout, dim1, dim2, f) {
        var arr = create$1(kind, layout, dim1, dim2);
        if (layout) {
            var _N_ = 1;
            if (dim2 >= 1) {
                var j$0 = _N_;
                for(;;){
                    var _O_ = 1;
                    if (dim1 >= 1) {
                        var i$0 = _O_;
                        for(;;){
                            caml_ba_set_2(arr, i$0, j$0, caml_call2(f, i$0, j$0));
                            var _Q_ = i$0 + 1 | 0;
                            if (dim1 === i$0) break;
                            i$0 = _Q_;
                        }
                    }
                    var _P_ = j$0 + 1 | 0;
                    if (dim2 === j$0) break;
                    j$0 = _P_;
                }
            }
            return arr;
        }
        var _I_ = dim1 - 1 | 0, _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                var _K_ = dim2 - 1 | 0, _J_ = 0;
                if (_K_ >= 0) {
                    var j = _J_;
                    for(;;){
                        caml_ba_set_2(arr, i, j, caml_call2(f, i, j));
                        var _M_ = j + 1 | 0;
                        if (_K_ === j) break;
                        j = _M_;
                    }
                }
                var _L_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _L_;
            }
        }
        return arr;
    }
    function of_array$0(kind, layout, data) {
        var dim1 = data.length - 1, dim2 = 0 === dim1 ? 0 : caml_check_bound(data, 0)[1].length - 1, ba = create$1(kind, layout, dim1, dim2), ofs = layout ? 1 : 0, _C_ = dim1 - 1 | 0, _B_ = 0;
        if (_C_ >= 0) {
            var i = _B_;
            for(;;){
                var row = caml_check_bound(data, i)[1 + i];
                if (row.length - 1 !== dim2) caml_call1(Stdlib[1], cst_Bigarray_Array2_of_array_n);
                var _E_ = dim2 - 1 | 0, _D_ = 0;
                if (_E_ >= 0) {
                    var j = _D_;
                    for(;;){
                        caml_ba_set_2(ba, i + ofs | 0, j + ofs | 0, caml_check_bound(row, j)[1 + j]);
                        var _G_ = j + 1 | 0;
                        if (_E_ === j) break;
                        j = _G_;
                    }
                }
                var _F_ = i + 1 | 0;
                if (_C_ === i) break;
                i = _F_;
            }
        }
        return ba;
    }
    function create$2(kind, layout, dim1, dim2, dim3) {
        return caml_ba_create(kind, layout, [
            0,
            dim1,
            dim2,
            dim3
        ]);
    }
    function size_in_bytes$3(arr) {
        var _y_ = runtime.caml_ba_dim_3(arr), _z_ = caml_ba_dim_2(arr), _A_ = caml_ba_dim_1(arr);
        return caml_mul(caml_mul(caml_mul(kind_size_in_bytes(caml_ba_kind(arr)), _A_), _z_), _y_);
    }
    function slice_left_1(a, n, m) {
        return caml_ba_slice(a, [
            0,
            n,
            m
        ]);
    }
    function slice_right_1(a, n, m) {
        return caml_ba_slice(a, [
            0,
            n,
            m
        ]);
    }
    function slice_left_2(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function slice_right_2(a, n) {
        return caml_ba_slice(a, [
            0,
            n
        ]);
    }
    function init$2(kind, layout, dim1, dim2, dim3, f) {
        var arr = create$2(kind, layout, dim1, dim2, dim3);
        if (layout) {
            var _s_ = 1;
            if (dim3 >= 1) {
                var k$0 = _s_;
                for(;;){
                    var _t_ = 1;
                    if (dim2 >= 1) {
                        var j$0 = _t_;
                        for(;;){
                            var _v_ = 1;
                            if (dim1 >= 1) {
                                var i$0 = _v_;
                                for(;;){
                                    caml_ba_set_3(arr, i$0, j$0, k$0, caml_call3(f, i$0, j$0, k$0));
                                    var _x_ = i$0 + 1 | 0;
                                    if (dim1 === i$0) break;
                                    i$0 = _x_;
                                }
                            }
                            var _w_ = j$0 + 1 | 0;
                            if (dim2 === j$0) break;
                            j$0 = _w_;
                        }
                    }
                    var _u_ = k$0 + 1 | 0;
                    if (dim3 === k$0) break;
                    k$0 = _u_;
                }
            }
            return arr;
        }
        var _k_ = dim1 - 1 | 0, _j_ = 0;
        if (_k_ >= 0) {
            var i = _j_;
            for(;;){
                var _m_ = dim2 - 1 | 0, _l_ = 0;
                if (_m_ >= 0) {
                    var j = _l_;
                    for(;;){
                        var _p_ = dim3 - 1 | 0, _o_ = 0;
                        if (_p_ >= 0) {
                            var k = _o_;
                            for(;;){
                                caml_ba_set_3(arr, i, j, k, caml_call3(f, i, j, k));
                                var _r_ = k + 1 | 0;
                                if (_p_ === k) break;
                                k = _r_;
                            }
                        }
                        var _q_ = j + 1 | 0;
                        if (_m_ === j) break;
                        j = _q_;
                    }
                }
                var _n_ = i + 1 | 0;
                if (_k_ === i) break;
                i = _n_;
            }
        }
        return arr;
    }
    function of_array$1(kind, layout, data) {
        var dim1 = data.length - 1, dim2 = 0 === dim1 ? 0 : caml_check_bound(data, 0)[1].length - 1, dim3 = 0 === dim2 ? 0 : caml_check_bound(caml_check_bound(data, 0)[1], 0)[1].length - 1, ba = create$2(kind, layout, dim1, dim2, dim3), ofs = layout ? 1 : 0, _b_ = dim1 - 1 | 0, _a_ = 0;
        if (_b_ >= 0) {
            var i = _a_;
            for(;;){
                var row = caml_check_bound(data, i)[1 + i];
                if (row.length - 1 !== dim2) caml_call1(Stdlib[1], cst_Bigarray_Array3_of_array_n);
                var _d_ = dim2 - 1 | 0, _c_ = 0;
                if (_d_ >= 0) {
                    var j = _c_;
                    for(;;){
                        var col = caml_check_bound(row, j)[1 + j];
                        if (col.length - 1 !== dim3) caml_call1(Stdlib[1], cst_Bigarray_Array3_of_array_n$0);
                        var _g_ = dim3 - 1 | 0, _f_ = 0;
                        if (_g_ >= 0) {
                            var k = _f_;
                            for(;;){
                                caml_ba_set_3(ba, i + ofs | 0, j + ofs | 0, k + ofs | 0, caml_check_bound(col, k)[1 + k]);
                                var _i_ = k + 1 | 0;
                                if (_g_ === k) break;
                                k = _i_;
                            }
                        }
                        var _h_ = j + 1 | 0;
                        if (_d_ === j) break;
                        j = _h_;
                    }
                }
                var _e_ = i + 1 | 0;
                if (_b_ === i) break;
                i = _e_;
            }
        }
        return ba;
    }
    function array0_of_genarray(a) {
        return 0 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array0_of_genarra);
    }
    function array1_of_genarray(a) {
        return 1 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array1_of_genarra);
    }
    function array2_of_genarray(a) {
        return 2 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array2_of_genarra);
    }
    function array3_of_genarray(a) {
        return 3 === caml_ba_num_dims(a) ? a : caml_call1(Stdlib[1], cst_Bigarray_array3_of_genarra);
    }
    function reshape_0(a) {
        return caml_ba_reshape(a, [
            0
        ]);
    }
    function reshape_1(a, dim1) {
        return caml_ba_reshape(a, [
            0,
            dim1
        ]);
    }
    function reshape_2(a, dim1, dim2) {
        return caml_ba_reshape(a, [
            0,
            dim1,
            dim2
        ]);
    }
    function reshape_3(a, dim1, dim2, dim3) {
        return caml_ba_reshape(a, [
            0,
            dim1,
            dim2,
            dim3
        ]);
    }
    var Stdlib_Bigarray = [
        0,
        13,
        0,
        1,
        10,
        11,
        2,
        3,
        4,
        5,
        8,
        6,
        7,
        9,
        12,
        kind_size_in_bytes,
        0,
        1,
        [
            0,
            init,
            dims,
            size_in_bytes
        ],
        [
            0,
            create,
            of_value,
            caml_ba_change_layout,
            size_in_bytes$0,
            get,
            set,
            of_value
        ],
        [
            0,
            create$0,
            init$0,
            caml_ba_change_layout,
            size_in_bytes$1,
            slice,
            of_array
        ],
        [
            0,
            create$1,
            init$1,
            caml_ba_change_layout,
            size_in_bytes$2,
            slice_left,
            slice_right,
            of_array$0
        ],
        [
            0,
            create$2,
            init$2,
            caml_ba_change_layout,
            size_in_bytes$3,
            slice_left_1,
            slice_right_1,
            slice_left_2,
            slice_right_2,
            of_array$1
        ],
        array0_of_genarray,
        array1_of_genarray,
        array2_of_genarray,
        array3_of_genarray,
        caml_ba_reshape,
        reshape_0,
        reshape_1,
        reshape_2,
        reshape_3
    ];
    runtime.caml_register_global(10, Stdlib_Bigarray, "Stdlib__Bigarray");
    return;
})(globalThis);
//# 18981 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_ba_blit = runtime.caml_ba_blit, caml_ba_set_1 = runtime.caml_ba_set_1, caml_bytes_set = runtime.caml_bytes_set, caml_create_bytes = runtime.caml_create_bytes, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_lxm_next = runtime.caml_lxm_next, caml_mod = runtime.caml_mod, caml_notequal = runtime.caml_notequal, caml_sys_random_seed = runtime.caml_sys_random_seed;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), serialization_prefix = "lxm1:", Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib = global_data.Stdlib, Stdlib_Bytes = global_data.Stdlib__Bytes, Stdlib_Digest = global_data.Stdlib__Digest, Stdlib_String = global_data.Stdlib__String, Stdlib_Bigarray = global_data.Stdlib__Bigarray, Stdlib_Nativeint = global_data.Stdlib__Nativeint, _a_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _b_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), _e_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0);
    function create(param) {
        return caml_call3(Stdlib_Bigarray[20][1], 7, 0, 4);
    }
    function set(s, i1, i2, i3, i4) {
        caml_ba_set_1(s, 0, runtime.caml_int64_or(i1, _a_));
        caml_ba_set_1(s, 1, i2);
        var i3$0 = caml_notequal(i3, _b_) ? i3 : _e_;
        caml_ba_set_1(s, 2, i3$0);
        var i4$0 = caml_notequal(i4, _c_) ? i4 : _d_;
        return caml_ba_set_1(s, 3, i4$0);
    }
    function mk(i1, i2, i3, i4) {
        var s = create(0);
        set(s, i1, i2, i3, i4);
        return s;
    }
    var serialization_prefix_len = 5, cst_Random_State_of_binary_str = "Random.State.of_binary_string: expected a format compatible with OCaml ";
    function to_binary_string(s) {
        var buf = caml_create_bytes(37);
        caml_call5(Stdlib_Bytes[12], serialization_prefix, 0, buf, 0, serialization_prefix_len);
        var i = 0;
        for(;;){
            var _y_ = runtime.caml_ba_get_1(s, i);
            caml_call3(Stdlib_Bytes[86], buf, 5 + (i * 8 | 0) | 0, _y_);
            var _z_ = i + 1 | 0;
            if (3 === i) return caml_call1(Stdlib_Bytes[44], buf);
            i = _z_;
        }
    }
    function of_binary_string(buf) {
        var _v_ = runtime.caml_ml_string_length(buf) !== 37 ? 1 : 0, _w_ = _v_ || 1 - caml_call2(Stdlib_String[11], serialization_prefix, buf);
        if (_w_) {
            var _x_ = caml_call2(Stdlib[28], cst_Random_State_of_binary_str, Stdlib_Sys[46]);
            caml_call1(Stdlib[2], _x_);
        }
        var i1 = caml_call2(Stdlib_String[64], buf, 5), i2 = caml_call2(Stdlib_String[64], buf, 13), i3 = caml_call2(Stdlib_String[64], buf, 21), i4 = caml_call2(Stdlib_String[64], buf, 29);
        return mk(i1, i2, i3, i4);
    }
    function copy(src) {
        var dst = create(0);
        caml_ba_blit(src, dst);
        return dst;
    }
    function reinit(s, seed) {
        var n = seed.length - 1, b = caml_create_bytes((n * 8 | 0) + 1 | 0), _p_ = n - 1 | 0, _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                var _t_ = caml_int64_of_int32(runtime.caml_check_bound(seed, i)[1 + i]);
                caml_call3(Stdlib_Bytes[86], b, i * 8 | 0, _t_);
                var _u_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _u_;
            }
        }
        caml_bytes_set(b, n * 8 | 0, 1);
        var d1 = caml_call1(Stdlib_Digest[4], b);
        caml_bytes_set(b, n * 8 | 0, 2);
        var d2 = caml_call1(Stdlib_Digest[4], b), _q_ = caml_call2(Stdlib_String[64], d2, 8), _r_ = caml_call2(Stdlib_String[64], d2, 0), _s_ = caml_call2(Stdlib_String[64], d1, 8);
        return set(s, caml_call2(Stdlib_String[64], d1, 0), _s_, _r_, _q_);
    }
    function make(seed) {
        var s = create(0);
        reinit(s, seed);
        return s;
    }
    function make_self_init(param) {
        return make(caml_sys_random_seed(0));
    }
    var max_int31 = 1073741823, max_int32 = 2147483647, cst_Random_int = "Random.int", cst_Random_full_int = "Random.full_int", cst_Random_int_in_range = "Random.int_in_range", cst_Random_int32 = "Random.int32", cst_Random_int32_in_range = "Random.int32_in_range";
    function bits(s) {
        return caml_int64_to_int32(caml_lxm_next(s)) & 1073741823;
    }
    function int_aux(s, n, mask) {
        for(;;){
            var r = caml_int64_to_int32(caml_lxm_next(s)) & mask, v = caml_mod(r, n);
            if (((mask - n | 0) + 1 | 0) >= (r - v | 0)) return v;
        }
    }
    function int$0(s, bound) {
        if (1073741823 >= bound && 0 < bound) return int_aux(s, bound, max_int31);
        return caml_call1(Stdlib[1], cst_Random_int);
    }
    function full_int(s, bound) {
        if (0 >= bound) return caml_call1(Stdlib[1], cst_Random_full_int);
        var _n_ = bound <= 1073741823 ? max_int31 : bound <= 2147483647 ? max_int32 : Stdlib[19];
        return int_aux(s, bound, _n_);
    }
    function int_in_range_aux(s, min, max, mask, nbits) {
        var span = (max - min | 0) + 1 | 0;
        if (span <= mask && 0 < span) return min + int_aux(s, span, mask) | 0;
        for(;;){
            var drop = Stdlib_Sys[10] - nbits | 0, r = caml_int64_to_int32(caml_lxm_next(s)) << drop >> drop;
            if (r >= min && max >= r) return r;
        }
    }
    function int_in_range(s, min, max) {
        if (max < min) caml_call1(Stdlib[1], cst_Random_int_in_range);
        if (-1073741824 <= min && max <= 1073741823) return int_in_range_aux(s, min, max, max_int31, 31);
        if (-2147483648 <= min && max <= 2147483647) return int_in_range_aux(s, min, max, max_int32, 32);
        return int_in_range_aux(s, min, max, Stdlib[19], Stdlib_Sys[10]);
    }
    function bits32(s) {
        return caml_int64_to_int32(caml_lxm_next(s));
    }
    function int32aux(s, n) {
        for(;;){
            var r = bits32(s) >>> 1 | 0, v = caml_mod(r, n);
            if (!caml_greaterthan(r - v | 0, (Stdlib_Int32[9] - n | 0) + 1 | 0)) return v;
        }
    }
    function int32(s, bound) {
        return caml_lessequal(bound, 0) ? caml_call1(Stdlib[1], cst_Random_int32) : int32aux(s, bound);
    }
    function int32_in_range(s, min, max) {
        if (caml_greaterthan(min, max)) return caml_call1(Stdlib[1], cst_Random_int32_in_range);
        var span = caml_call1(Stdlib_Int32[6], max - min | 0);
        if (!caml_lessequal(span, Stdlib_Int32[1])) return min + int32aux(s, span) | 0;
        for(;;){
            var r = caml_int64_to_int32(caml_lxm_next(s));
            if (!caml_lessthan(r, min) && !caml_greaterthan(r, max)) return r;
        }
    }
    var bits64 = caml_lxm_next, _f_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_Random_int64 = "Random.int64", cst_Random_int64_in_range = "Random.int64_in_range";
    function int64aux(s, n) {
        for(;;){
            var r = caml_int64_shift_right_unsigne(caml_lxm_next(s), 1), v = runtime.caml_int64_mod(r, n);
            if (!caml_greaterthan(caml_int64_sub(r, v), caml_int64_add(caml_int64_sub(Stdlib_Int64[9], n), _f_))) return v;
        }
    }
    function int64(s, bound) {
        return caml_lessequal(bound, _g_) ? caml_call1(Stdlib[1], cst_Random_int64) : int64aux(s, bound);
    }
    function int64_in_range(s, min, max) {
        if (caml_greaterthan(min, max)) return caml_call1(Stdlib[1], cst_Random_int64_in_range);
        var span = caml_call1(Stdlib_Int64[6], caml_int64_sub(max, min));
        if (!caml_lessequal(span, Stdlib_Int64[1])) return caml_int64_add(min, int64aux(s, span));
        for(;;){
            var r = caml_lxm_next(s);
            if (!caml_lessthan(r, min) && !caml_greaterthan(r, max)) return r;
        }
    }
    var _j_ = runtime.caml_int64_create_lo_mi_hi(14371852, 15349651, 22696), _k_ = runtime.caml_int64_create_lo_mi_hi(12230193, 11438743, 35013), _l_ = runtime.caml_int64_create_lo_mi_hi(1424933, 15549263, 2083), _m_ = runtime.caml_int64_create_lo_mi_hi(9492471, 4696708, 43520), _h_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _i_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), nativebits = 32 === Stdlib_Nativeint[9] ? function(s) {
        return bits32(s);
    } : function(s) {
        return caml_int64_to_int32(caml_lxm_next(s));
    }, nativeint = 32 === Stdlib_Nativeint[9] ? function(s, bound) {
        return int32(s, bound);
    } : function(s, bound) {
        return caml_int64_to_int32(int64(s, caml_int64_of_int32(bound)));
    }, nativeint_in_range = 32 === Stdlib_Nativeint[9] ? function(s, min, max) {
        return int32_in_range(s, min, max);
    } : function(s, min, max) {
        return caml_int64_to_int32(int64_in_range(s, caml_int64_of_int32(min), caml_int64_of_int32(max)));
    };
    function float$0(s, bound) {
        for(;;){
            var b = caml_lxm_next(s), n = caml_int64_shift_right_unsigne(b, 11);
            if (caml_notequal(n, _h_)) return runtime.caml_int64_to_float(n) * 1.1102230246251565e-16 * bound;
        }
    }
    function bool(s) {
        return caml_lessthan(caml_lxm_next(s), _i_);
    }
    function split(s) {
        var i1 = caml_lxm_next(s), i2 = caml_lxm_next(s), i3 = caml_lxm_next(s), i4 = caml_lxm_next(s);
        return mk(i1, i2, i3, i4);
    }
    function mk_default(param) {
        return mk(_m_, _l_, _k_, _j_);
    }
    var random_key = caml_call2(Stdlib_Domain[11][1], [
        0,
        split
    ], mk_default);
    function bits$0(param) {
        return bits(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function int$1(bound) {
        return int$0(caml_call1(Stdlib_Domain[11][2], random_key), bound);
    }
    function full_int$0(bound) {
        return full_int(caml_call1(Stdlib_Domain[11][2], random_key), bound);
    }
    function int_in_range$0(min, max) {
        return int_in_range(caml_call1(Stdlib_Domain[11][2], random_key), min, max);
    }
    function int32$0(bound) {
        return int32(caml_call1(Stdlib_Domain[11][2], random_key), bound);
    }
    function int32_in_range$0(min, max) {
        return int32_in_range(caml_call1(Stdlib_Domain[11][2], random_key), min, max);
    }
    function nativeint$0(bound) {
        return nativeint(caml_call1(Stdlib_Domain[11][2], random_key), bound);
    }
    function nativeint_in_range$0(min, max) {
        return nativeint_in_range(caml_call1(Stdlib_Domain[11][2], random_key), min, max);
    }
    function int64$0(bound) {
        return int64(caml_call1(Stdlib_Domain[11][2], random_key), bound);
    }
    function int64_in_range$0(min, max) {
        return int64_in_range(caml_call1(Stdlib_Domain[11][2], random_key), min, max);
    }
    function float$1(scale) {
        return float$0(caml_call1(Stdlib_Domain[11][2], random_key), scale);
    }
    function bool$0(param) {
        return bool(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function bits32$0(param) {
        return bits32(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function bits64$0(param) {
        var s = caml_call1(Stdlib_Domain[11][2], random_key);
        return caml_lxm_next(s);
    }
    function nativebits$0(param) {
        return nativebits(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function full_init(seed) {
        return reinit(caml_call1(Stdlib_Domain[11][2], random_key), seed);
    }
    function init(seed) {
        return full_init([
            0,
            seed
        ]);
    }
    function self_init(param) {
        return full_init(caml_sys_random_seed(0));
    }
    function split$0(param) {
        return split(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function get_state(param) {
        return copy(caml_call1(Stdlib_Domain[11][2], random_key));
    }
    function set_state(src) {
        var dst = caml_call1(Stdlib_Domain[11][2], random_key);
        return caml_ba_blit(src, dst);
    }
    var Stdlib_Random = [
        0,
        init,
        full_init,
        self_init,
        bits$0,
        int$1,
        full_int$0,
        int_in_range$0,
        int32$0,
        int32_in_range$0,
        nativeint$0,
        nativeint_in_range$0,
        int64$0,
        int64_in_range$0,
        float$1,
        bool$0,
        bits32$0,
        bits64$0,
        nativebits$0,
        [
            0,
            make,
            make_self_init,
            copy,
            bits,
            int$0,
            full_int,
            int_in_range,
            int32,
            int32_in_range,
            nativeint,
            nativeint_in_range,
            int64,
            int64_in_range,
            float$0,
            bool,
            bits32,
            bits64,
            nativebits,
            split,
            to_binary_string,
            of_binary_string
        ],
        get_state,
        set_state,
        split$0
    ];
    runtime.caml_register_global(35, Stdlib_Random, "Stdlib__Random");
    return;
})(globalThis);
//# 19396 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_compare = runtime.caml_compare, caml_hash = runtime.caml_hash, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), _d_ = [
        0,
        0
    ], cst = "", Stdlib_Sys = global_data.Stdlib__Sys, Stdlib = global_data.Stdlib, Stdlib_Atomic = global_data.Stdlib__Atomic, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Array = global_data.Stdlib__Array;
    global_data.Assert_failure;
    var Stdlib_String = global_data.Stdlib__String;
    function ongoing_traversal(h) {
        var _an_ = h.length - 1 < 4 ? 1 : 0, _ao_ = _an_ || (h[4] < 0 ? 1 : 0);
        return _ao_;
    }
    function flip_ongoing_traversal(h) {
        h[4] = -h[4] | 0;
        return 0;
    }
    var cst_Hashtbl_unsupported_hash_t = "Hashtbl: unsupported hash table format";
    try {
        var _f_ = caml_sys_getenv("OCAMLRUNPARAM"), params = _f_;
    } catch (_al_) {
        var _a_ = caml_wrap_exception(_al_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        try {
            var _e_ = caml_sys_getenv("CAMLRUNPARAM"), _c_ = _e_;
        } catch (_am_) {
            var _b_ = caml_wrap_exception(_am_);
            if (_b_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_b_, 0);
            var _c_ = cst;
        }
        var params = _c_;
    }
    var randomized_default = caml_call2(Stdlib_String[15], params, 82), randomized = caml_call1(Stdlib_Atomic[1], randomized_default);
    function randomize(param) {
        return caml_call2(Stdlib_Atomic[4], randomized, 1);
    }
    function is_randomized(param) {
        return caml_call1(Stdlib_Atomic[3], randomized);
    }
    var prng_key = caml_call2(Stdlib_Domain[11][1], 0, Stdlib_Random[19][2]);
    function power_2_above(x, n) {
        var x$0 = x;
        for(;;){
            if (n <= x$0) return x$0;
            if (Stdlib_Sys[13] < (x$0 * 2 | 0)) return x$0;
            var x$1 = x$0 * 2 | 0;
            x$0 = x$1;
        }
    }
    function create(opt, initial_size) {
        var random = opt ? opt[1] : caml_call1(Stdlib_Atomic[3], randomized), s = power_2_above(16, initial_size);
        if (random) var _ak_ = caml_call1(Stdlib_Domain[11][2], prng_key), seed = caml_call1(Stdlib_Random[19][4], _ak_);
        else var seed = 0;
        return [
            0,
            0,
            caml_array_make(s, 0),
            seed,
            s
        ];
    }
    function clear(h) {
        var _aj_ = 0 < h[1] ? 1 : 0;
        return _aj_ ? (h[1] = 0, caml_call4(Stdlib_Array[8], h[2], 0, h[2].length - 1, 0)) : _aj_;
    }
    function reset(h) {
        var len = h[2].length - 1;
        if (4 <= h.length - 1 && len !== caml_call1(Stdlib[18], h[4])) {
            h[1] = 0;
            h[2] = caml_array_make(caml_call1(Stdlib[18], h[4]), 0);
            return 0;
        }
        return clear(h);
    }
    function copy_bucketlist(param) {
        if (!param) return 0;
        var key = param[1], data = param[2], next = param[3], prec$1 = [
            0,
            key,
            data,
            next
        ], prec = prec$1, param$0 = next;
        for(;;){
            if (!param$0) return prec$1;
            var key$0 = param$0[1], data$0 = param$0[2], next$0 = param$0[3], prec$0 = [
                0,
                key$0,
                data$0,
                next$0
            ];
            prec[3] = prec$0;
            prec = prec$0;
            param$0 = next$0;
        }
    }
    function copy(h) {
        var _ag_ = h[4], _ah_ = h[3], _ai_ = caml_call2(Stdlib_Array[14], copy_bucketlist, h[2]);
        return [
            0,
            h[1],
            _ai_,
            _ah_,
            _ag_
        ];
    }
    function length(h) {
        return h[1];
    }
    function insert_all_buckets(indexfun, inplace, odata, ndata) {
        var nsize = ndata.length - 1, ndata_tail = caml_array_make(nsize, 0), _aa_ = odata.length - 2 | 0, _$_ = 0;
        if (_aa_ >= 0) {
            var i$0 = _$_;
            for(;;){
                var cell$1 = caml_check_bound(odata, i$0)[1 + i$0], cell = cell$1;
                for(;;){
                    if (!cell) break;
                    var key = cell[1], data = cell[2], next = cell[3], cell$0 = inplace ? cell : [
                        0,
                        key,
                        data,
                        0
                    ], nidx = caml_call1(indexfun, key), match = caml_check_bound(ndata_tail, nidx)[1 + nidx];
                    if (match) match[3] = cell$0;
                    else caml_check_bound(ndata, nidx)[1 + nidx] = cell$0;
                    caml_check_bound(ndata_tail, nidx)[1 + nidx] = cell$0;
                    cell = next;
                }
                var _af_ = i$0 + 1 | 0;
                if (_aa_ === i$0) break;
                i$0 = _af_;
            }
        }
        if (inplace) {
            var _ac_ = nsize - 1 | 0, _ab_ = 0;
            if (_ac_ >= 0) {
                var i = _ab_;
                for(;;){
                    var match$0 = caml_check_bound(ndata_tail, i)[1 + i];
                    if (match$0) match$0[3] = 0;
                    var _ae_ = i + 1 | 0;
                    if (_ac_ === i) break;
                    i = _ae_;
                }
            }
            var _ad_ = 0;
        } else var _ad_ = inplace;
        return _ad_;
    }
    function resize(indexfun, h) {
        var odata = h[2], osize = odata.length - 1, nsize = osize * 2 | 0, ___ = nsize < Stdlib_Sys[13] ? 1 : 0;
        if (!___) return ___;
        var ndata = caml_array_make(nsize, 0), inplace = 1 - ongoing_traversal(h);
        h[2] = ndata;
        return insert_all_buckets(caml_call1(indexfun, h), inplace, odata, ndata);
    }
    function iter(f, h) {
        var old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var d = h[2], _W_ = d.length - 2 | 0, _V_ = 0;
            if (_W_ >= 0) {
                var i = _V_;
                for(;;){
                    var param = caml_check_bound(d, i)[1 + i];
                    for(;;){
                        if (!param) break;
                        var key = param[1], data = param[2], next = param[3];
                        caml_call2(f, key, data);
                        param = next;
                    }
                    var _Z_ = i + 1 | 0;
                    if (_W_ === i) break;
                    i = _Z_;
                }
            }
            var _X_ = 1 - old_trav, _Y_ = _X_ ? flip_ongoing_traversal(h) : _X_;
            return _Y_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function filter_map_inplace(f, h) {
        var d = h[2], old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var _R_ = d.length - 2 | 0, _Q_ = 0;
            if (_R_ >= 0) {
                var i = _Q_;
                for(;;){
                    var slot$0 = caml_check_bound(h[2], i)[1 + i], prec = 0, slot = slot$0;
                    for(;;){
                        if (!slot) break;
                        var key = slot[1], data = slot[2], next = slot[3], match = caml_call2(f, key, data);
                        if (match) {
                            var data$0 = match[1];
                            if (prec) prec[3] = slot;
                            else caml_check_bound(h[2], i)[1 + i] = slot;
                            slot[2] = data$0;
                            prec = slot;
                            slot = next;
                        } else {
                            h[1] = h[1] - 1 | 0;
                            slot = next;
                        }
                    }
                    if (prec) prec[3] = 0;
                    else caml_check_bound(h[2], i)[1 + i] = 0;
                    var _U_ = i + 1 | 0;
                    if (_R_ === i) break;
                    i = _U_;
                }
            }
            var _S_ = 1 - old_trav, _T_1 = _S_ ? flip_ongoing_traversal(h) : _S_;
            return _T_1;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function fold(f, h, init) {
        var old_trav = ongoing_traversal(h);
        if (1 - old_trav) flip_ongoing_traversal(h);
        try {
            var d = h[2], accu$1 = [
                0,
                init
            ], _N_ = d.length - 2 | 0, _M_ = 0;
            if (_N_ >= 0) {
                var i = _M_;
                for(;;){
                    var accu$2 = accu$1[1], b$0 = caml_check_bound(d, i)[1 + i], b = b$0, accu = accu$2;
                    for(;;){
                        if (!b) break;
                        var key = b[1], data = b[2], next = b[3], accu$0 = caml_call3(f, key, data, accu);
                        b = next;
                        accu = accu$0;
                    }
                    accu$1[1] = accu;
                    var _P_ = i + 1 | 0;
                    if (_N_ === i) break;
                    i = _P_;
                }
            }
            if (1 - old_trav) flip_ongoing_traversal(h);
            var _O_ = accu$1[1];
            return _O_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (old_trav) throw caml_maybe_attach_backtrace(exn, 0);
            flip_ongoing_traversal(h);
            throw caml_maybe_attach_backtrace(exn, 0);
        }
    }
    function bucket_length(accu, param) {
        var accu$0 = accu, param$0 = param;
        for(;;){
            if (!param$0) return accu$0;
            var next = param$0[3], accu$1 = accu$0 + 1 | 0;
            accu$0 = accu$1;
            param$0 = next;
        }
    }
    function stats(h) {
        var mbl = caml_call3(Stdlib_Array[18], function(m, b) {
            var _L_ = bucket_length(0, b);
            return caml_call2(Stdlib_Int[11], m, _L_);
        }, 0, h[2]), histo = caml_array_make(mbl + 1 | 0, 0);
        caml_call2(Stdlib_Array[12], function(b) {
            var l = bucket_length(0, b);
            histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
            return 0;
        }, h[2]);
        return [
            0,
            h[1],
            h[2].length - 1,
            mbl,
            histo
        ];
    }
    function to_seq(tbl) {
        var tbl_data = tbl[2];
        function aux(i, buck, param) {
            var i$0 = i, buck$0 = buck;
            for(;;){
                if (buck$0) {
                    var key = buck$0[1], data = buck$0[2], next = buck$0[3];
                    return [
                        0,
                        [
                            0,
                            key,
                            data
                        ],
                        function(_K_) {
                            return aux(i$0, next, _K_);
                        }
                    ];
                }
                if (i$0 === tbl_data.length - 1) return 0;
                var buck$1 = caml_check_bound(tbl_data, i$0)[1 + i$0], i$1 = i$0 + 1 | 0;
                i$0 = i$1;
                buck$0 = buck$1;
            }
        }
        var _H_ = 0, _I_ = 0;
        return function(_J_) {
            return aux(_I_, _H_, _J_);
        };
    }
    function to_seq_keys(m) {
        var _F_ = to_seq(m);
        return caml_call2(Stdlib_Seq[29], function(_G_) {
            return _G_[1];
        }, _F_);
    }
    function to_seq_values(m) {
        var _D_ = to_seq(m);
        return caml_call2(Stdlib_Seq[29], function(_E_) {
            return _E_[2];
        }, _D_);
    }
    function MakeSeeded(H) {
        function key_index(h, key) {
            var _C_ = h[2].length - 2 | 0;
            return caml_call2(H[2], h[3], key) & _C_;
        }
        function add(h, key, data) {
            var i = key_index(h, key), bucket = [
                0,
                key,
                data,
                caml_check_bound(h[2], i)[1 + i]
            ];
            caml_check_bound(h[2], i)[1 + i] = bucket;
            h[1] = h[1] + 1 | 0;
            var _B_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
            return _B_ ? resize(key_index, h) : _B_;
        }
        function remove(h, key) {
            var i = key_index(h, key), c = caml_check_bound(h[2], i)[1 + i], prec$0 = 0, prec = c;
            for(;;){
                if (!prec) return 0;
                var k = prec[1], next = prec[3];
                if (caml_call2(H[1], k, key)) {
                    h[1] = h[1] - 1 | 0;
                    return prec$0 ? (prec$0[3] = next, 0) : (caml_check_bound(h[2], i)[1 + i] = next, 0);
                }
                prec$0 = prec;
                prec = next;
            }
        }
        function find(h, key) {
            var _A_ = key_index(h, key), match = caml_check_bound(h[2], _A_)[1 + _A_];
            if (!match) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k1 = match[1], d1 = match[2], next1 = match[3];
            if (caml_call2(H[1], key, k1)) return d1;
            if (!next1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k2 = next1[1], d2 = next1[2], next2 = next1[3];
            if (caml_call2(H[1], key, k2)) return d2;
            if (!next2) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k3 = next2[1], d3 = next2[2], next3 = next2[3];
            if (caml_call2(H[1], key, k3)) return d3;
            var param = next3;
            for(;;){
                if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var k = param[1], data = param[2], next = param[3];
                if (caml_call2(H[1], key, k)) return data;
                param = next;
            }
        }
        function find_opt(h, key) {
            var _z_ = key_index(h, key), match = caml_check_bound(h[2], _z_)[1 + _z_];
            if (!match) return 0;
            var k1 = match[1], d1 = match[2], next1 = match[3];
            if (caml_call2(H[1], key, k1)) return [
                0,
                d1
            ];
            if (!next1) return 0;
            var k2 = next1[1], d2 = next1[2], next2 = next1[3];
            if (caml_call2(H[1], key, k2)) return [
                0,
                d2
            ];
            if (!next2) return 0;
            var k3 = next2[1], d3 = next2[2], next3 = next2[3];
            if (caml_call2(H[1], key, k3)) return [
                0,
                d3
            ];
            var param = next3;
            for(;;){
                if (!param) return 0;
                var k = param[1], data = param[2], next = param[3];
                if (caml_call2(H[1], key, k)) return [
                    0,
                    data
                ];
                param = next;
            }
        }
        function find_all(h, key) {
            var _y_ = key_index(h, key), param = caml_check_bound(h[2], _y_)[1 + _y_];
            for(;;){
                if (!param) return 0;
                var k = param[1], d = param[2], next = param[3];
                if (caml_call2(H[1], k, key)) break;
                param = next;
            }
            var block = [
                0,
                d,
                24029
            ], dst = block, offset = 1, param$0 = next;
            for(;;){
                if (!param$0) {
                    dst[1 + offset] = 0;
                    return block;
                }
                var k$0 = param$0[1], d$0 = param$0[2], next$0 = param$0[3];
                if (caml_call2(H[1], k$0, key)) {
                    var dst$0 = [
                        0,
                        d$0,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    param$0 = next$0;
                } else param$0 = next$0;
            }
        }
        function replace(h, key, data) {
            var i = key_index(h, key), l = caml_check_bound(h[2], i)[1 + i], slot = l;
            for(;;){
                if (slot) {
                    var k = slot[1], next = slot[3];
                    if (!caml_call2(H[1], k, key)) {
                        slot = next;
                        continue;
                    }
                    slot[1] = key;
                    slot[2] = data;
                    var _v_ = 0;
                } else var _v_ = 1;
                if (_v_) {
                    caml_check_bound(h[2], i)[1 + i] = [
                        0,
                        key,
                        data,
                        l
                    ];
                    h[1] = h[1] + 1 | 0;
                    var _w_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                    if (_w_) return resize(key_index, h);
                    var _x_ = _w_;
                } else var _x_ = _v_;
                return _x_;
            }
        }
        function mem(h, key) {
            var _u_ = key_index(h, key), param = caml_check_bound(h[2], _u_)[1 + _u_];
            for(;;){
                if (!param) return 0;
                var k = param[1], next = param[3], _t_ = caml_call2(H[1], k, key);
                if (_t_) return _t_;
                param = next;
            }
        }
        function add_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return add(tbl, k, v);
            }, i);
        }
        function replace_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return replace(tbl, k, v);
            }, i);
        }
        function of_seq(i) {
            var tbl = create(0, 16);
            replace_seq(tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            iter,
            filter_map_inplace,
            fold,
            length,
            stats,
            to_seq,
            to_seq_keys,
            to_seq_values,
            add_seq,
            replace_seq,
            of_seq
        ];
    }
    function Make(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded([
            0,
            equal,
            seeded_hash
        ]), _s_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], iter = include[12], filter_map_inplace = include[13], fold = include[14], length = include[15], stats = include[16], to_seq = include[17], to_seq_keys = include[18], to_seq_values = include[19], add_seq = include[20], replace_seq = include[21];
        function create(sz) {
            return caml_call2(_s_, _d_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_s_, _d_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            iter,
            filter_map_inplace,
            fold,
            length,
            stats,
            to_seq,
            to_seq_keys,
            to_seq_values,
            add_seq,
            replace_seq,
            of_seq
        ];
    }
    function hash(x) {
        return caml_hash(10, 100, 0, x);
    }
    function hash_param(n1, n2, x) {
        return caml_hash(n1, n2, 0, x);
    }
    function seeded_hash(seed, x) {
        return caml_hash(10, 100, seed, x);
    }
    function key_index(h, key) {
        return 4 <= h.length - 1 ? caml_hash(10, 100, h[3], key) & (h[2].length - 2 | 0) : caml_call1(Stdlib[1], cst_Hashtbl_unsupported_hash_t);
    }
    function add(h, key, data) {
        var i = key_index(h, key), bucket = [
            0,
            key,
            data,
            caml_check_bound(h[2], i)[1 + i]
        ];
        caml_check_bound(h[2], i)[1 + i] = bucket;
        h[1] = h[1] + 1 | 0;
        var _r_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
        return _r_ ? resize(key_index, h) : _r_;
    }
    function remove(h, key) {
        var i = key_index(h, key), c = caml_check_bound(h[2], i)[1 + i], prec$0 = 0, prec = c;
        for(;;){
            if (!prec) return 0;
            var k = prec[1], next = prec[3];
            if (0 === caml_compare(k, key)) {
                h[1] = h[1] - 1 | 0;
                return prec$0 ? (prec$0[3] = next, 0) : (caml_check_bound(h[2], i)[1 + i] = next, 0);
            }
            prec$0 = prec;
            prec = next;
        }
    }
    function find(h, key) {
        var _q_ = key_index(h, key), match = caml_check_bound(h[2], _q_)[1 + _q_];
        if (!match) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k1 = match[1], d1 = match[2], next1 = match[3];
        if (0 === caml_compare(key, k1)) return d1;
        if (!next1) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k2 = next1[1], d2 = next1[2], next2 = next1[3];
        if (0 === caml_compare(key, k2)) return d2;
        if (!next2) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
        var k3 = next2[1], d3 = next2[2], next3 = next2[3];
        if (0 === caml_compare(key, k3)) return d3;
        var param = next3;
        for(;;){
            if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(key, k)) return data;
            param = next;
        }
    }
    function find_opt(h, key) {
        var _p_ = key_index(h, key), match = caml_check_bound(h[2], _p_)[1 + _p_];
        if (!match) return 0;
        var k1 = match[1], d1 = match[2], next1 = match[3];
        if (0 === caml_compare(key, k1)) return [
            0,
            d1
        ];
        if (!next1) return 0;
        var k2 = next1[1], d2 = next1[2], next2 = next1[3];
        if (0 === caml_compare(key, k2)) return [
            0,
            d2
        ];
        if (!next2) return 0;
        var k3 = next2[1], d3 = next2[2], next3 = next2[3];
        if (0 === caml_compare(key, k3)) return [
            0,
            d3
        ];
        var param = next3;
        for(;;){
            if (!param) return 0;
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(key, k)) return [
                0,
                data
            ];
            param = next;
        }
    }
    function find_all(h, key) {
        var _o_ = key_index(h, key), param = caml_check_bound(h[2], _o_)[1 + _o_];
        for(;;){
            if (!param) return 0;
            var k = param[1], data = param[2], next = param[3];
            if (0 === caml_compare(k, key)) break;
            param = next;
        }
        var block = [
            0,
            data,
            24029
        ], dst = block, offset = 1, param$0 = next;
        for(;;){
            if (!param$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var k$0 = param$0[1], data$0 = param$0[2], next$0 = param$0[3];
            if (0 === caml_compare(k$0, key)) {
                var dst$0 = [
                    0,
                    data$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                param$0 = next$0;
            } else param$0 = next$0;
        }
    }
    function replace(h, key, data) {
        var i = key_index(h, key), l = caml_check_bound(h[2], i)[1 + i], slot = l;
        for(;;){
            if (slot) {
                var k = slot[1], next = slot[3];
                if (0 !== caml_compare(k, key)) {
                    slot = next;
                    continue;
                }
                slot[1] = key;
                slot[2] = data;
                var _l_ = 0;
            } else var _l_ = 1;
            if (_l_) {
                caml_check_bound(h[2], i)[1 + i] = [
                    0,
                    key,
                    data,
                    l
                ];
                h[1] = h[1] + 1 | 0;
                var _m_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                if (_m_) return resize(key_index, h);
                var _n_ = _m_;
            } else var _n_ = _l_;
            return _n_;
        }
    }
    function mem(h, key) {
        var _k_ = key_index(h, key), param = caml_check_bound(h[2], _k_)[1 + _k_];
        for(;;){
            if (!param) return 0;
            var k = param[1], next = param[3], _j_ = 0 === caml_compare(k, key) ? 1 : 0;
            if (_j_) return _j_;
            param = next;
        }
    }
    function add_seq(tbl, i) {
        return caml_call2(Stdlib_Seq[4], function(param) {
            var v = param[2], k = param[1];
            return add(tbl, k, v);
        }, i);
    }
    function replace_seq(tbl, i) {
        return caml_call2(Stdlib_Seq[4], function(param) {
            var v = param[2], k = param[1];
            return replace(tbl, k, v);
        }, i);
    }
    function of_seq(i) {
        var tbl = create(0, 16);
        replace_seq(tbl, i);
        return tbl;
    }
    function rebuild(opt, h) {
        var random = opt ? opt[1] : caml_call1(Stdlib_Atomic[3], randomized), s = power_2_above(16, h[2].length - 1);
        if (random) var _g_ = caml_call1(Stdlib_Domain[11][2], prng_key), seed = caml_call1(Stdlib_Random[19][4], _g_);
        else var seed = 4 <= h.length - 1 ? h[3] : 0;
        var _h_ = 4 <= h.length - 1 ? h[4] : s, h$0 = [
            0,
            h[1],
            caml_array_make(s, 0),
            seed,
            _h_
        ];
        insert_all_buckets(function(_i_) {
            return key_index(h$0, _i_);
        }, 0, h[2], h$0[2]);
        return h$0;
    }
    var Stdlib_Hashtbl = [
        0,
        create,
        clear,
        reset,
        copy,
        add,
        find,
        find_opt,
        find_all,
        mem,
        remove,
        replace,
        iter,
        filter_map_inplace,
        fold,
        length,
        randomize,
        is_randomized,
        rebuild,
        stats,
        to_seq,
        to_seq_keys,
        to_seq_values,
        add_seq,
        replace_seq,
        of_seq,
        Make,
        MakeSeeded,
        hash,
        seeded_hash,
        hash_param,
        caml_hash
    ];
    runtime.caml_register_global(16, Stdlib_Hashtbl, "Stdlib__Hashtbl");
    return;
})(globalThis);
//# 20697 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$16 = "", cst$15 = ">", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst$14 = ".", cst$11 = cst$15, cst$12 = "<\/", cst$13 = cst$16, cst$8 = cst$15, cst$9 = "<", cst$10 = cst$16, cst$7 = "\n", cst$3 = cst$16, cst$4 = cst$16, cst$5 = cst$16, cst$6 = cst$16, cst = cst$16, cst$0 = cst$16, cst$1 = cst$16, cst$2 = cst$16, _a_ = [
        0,
        cst$16,
        0,
        cst$16
    ], Stdlib_Queue = global_data.Stdlib__Queue, CamlinternalFormat = global_data.CamlinternalFormat, Stdlib = global_data.Stdlib, Stdlib_String = global_data.Stdlib__String, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Bytes = global_data.Stdlib__Bytes;
    function id(x) {
        return x;
    }
    var zero = 0, unknown = -1, String_tag = [
        248,
        "Stdlib.Format.String_tag",
        runtime.caml_fresh_oo_id(0)
    ];
    function pp_enqueue(state, token) {
        state[13] = state[13] + token[3] | 0;
        return caml_call2(Stdlib_Queue[3], token, state[28]);
    }
    var pp_infinity = 1000000010, _b_ = [
        0,
        cst$16
    ], _c_ = [
        1,
        "margin <= max_indent"
    ], _d_ = [
        1,
        "margin >= pp_infinity"
    ], _e_ = [
        0,
        0
    ], _f_ = [
        1,
        "max_indent < 2"
    ], cst_Format_pp_set_geometry = "Format.pp_set_geometry: ";
    function pp_output_string(state, s) {
        return caml_call3(state[17], s, 0, caml_ml_string_length(s));
    }
    function pp_output_newline(state) {
        return caml_call1(state[19], 0);
    }
    function format_pp_text(state, size, text) {
        state[9] = state[9] - size | 0;
        pp_output_string(state, text);
        state[11] = 0;
    }
    function format_string(state, s) {
        var _a$_ = s !== cst$16 ? 1 : 0;
        return _a$_ ? format_pp_text(state, caml_ml_string_length(s), s) : _a$_;
    }
    function break_new_line(state, param, width) {
        var after = param[3], offset = param[2], before = param[1];
        format_string(state, before);
        pp_output_newline(state);
        state[11] = 1;
        var indent = (state[6] - width | 0) + offset | 0, real_indent = caml_call2(Stdlib_Int[10], state[8], indent);
        state[10] = real_indent;
        state[9] = state[6] - state[10] | 0;
        var n = state[10];
        caml_call1(state[21], n);
        return format_string(state, after);
    }
    function break_same_line(state, param) {
        var after = param[3], width = param[2], before = param[1];
        format_string(state, before);
        state[9] = state[9] - width | 0;
        caml_call1(state[20], width);
        return format_string(state, after);
    }
    function format_pp_token(state, size$0, param) {
        if (typeof param === "number") switch(param){
            case 0:
                var match$3 = caml_call1(Stdlib_Stack[8], state[3]);
                if (!match$3) return;
                var tabs = match$3[1][1], add_tab = function(n, ls) {
                    if (!ls) return [
                        0,
                        n,
                        0
                    ];
                    var l = ls[2], x = ls[1];
                    return runtime.caml_lessthan(n, x) ? [
                        0,
                        n,
                        ls
                    ] : [
                        0,
                        x,
                        add_tab(n, l)
                    ];
                };
                tabs[1] = add_tab(state[6] - state[9] | 0, tabs[1]);
                return;
            case 1:
                caml_call1(Stdlib_Stack[5], state[2]);
                return;
            case 2:
                caml_call1(Stdlib_Stack[5], state[3]);
                return;
            case 3:
                var match$4 = caml_call1(Stdlib_Stack[8], state[2]);
                if (!match$4) return pp_output_newline(state);
                var width$0 = match$4[1][2];
                return break_new_line(state, _a_, width$0);
            case 4:
                var _a9_ = state[10] !== (state[6] - state[9] | 0) ? 1 : 0;
                if (!_a9_) return _a9_;
                var match$1 = caml_call1(Stdlib_Queue[6], state[28]);
                if (!match$1) return;
                var match$2 = match$1[1], size = match$2[1], length = match$2[3];
                state[12] = state[12] - length | 0;
                state[9] = state[9] + size | 0;
                return;
            default:
                var match$5 = caml_call1(Stdlib_Stack[5], state[5]);
                if (!match$5) return;
                var tag_name = match$5[1], marker = caml_call1(state[25], tag_name);
                return pp_output_string(state, marker);
        }
        switch(param[0]){
            case 0:
                var s = param[1];
                return format_pp_text(state, size$0, s);
            case 1:
                var len = param[3], pos = param[2], source = param[1];
                state[9] = state[9] - size$0 | 0;
                caml_call3(state[17], source, pos, len);
                state[11] = 0;
                return;
            case 2:
                var breaks = param[2], fits = param[1], off = breaks[2], before = breaks[1], match$6 = caml_call1(Stdlib_Stack[8], state[2]);
                if (!match$6) return;
                var match$7 = match$6[1], width$1 = match$7[2], box_type$0 = match$7[1];
                switch(box_type$0){
                    case 0:
                        return break_same_line(state, fits);
                    case 1:
                        return break_new_line(state, breaks, width$1);
                    case 2:
                        return break_new_line(state, breaks, width$1);
                    case 3:
                        return state[9] < (size$0 + caml_ml_string_length(before) | 0) ? break_new_line(state, breaks, width$1) : break_same_line(state, fits);
                    case 4:
                        return state[11] ? break_same_line(state, fits) : state[9] < (size$0 + caml_ml_string_length(before) | 0) ? break_new_line(state, breaks, width$1) : ((state[6] - width$1 | 0) + off | 0) < state[10] ? break_new_line(state, breaks, width$1) : break_same_line(state, fits);
                    default:
                        return break_same_line(state, fits);
                }
            case 3:
                var off$0 = param[2], n = param[1], insertion_point = state[6] - state[9] | 0, match$8 = caml_call1(Stdlib_Stack[8], state[3]);
                if (!match$8) return;
                var tabs$0 = match$8[1][1], match$9 = tabs$0[1];
                if (match$9) {
                    var first = match$9[1], param$0 = tabs$0[1];
                    for(;;){
                        if (param$0) {
                            var tail = param$0[2], head = param$0[1];
                            if (insertion_point > head) {
                                param$0 = tail;
                                continue;
                            }
                            var _a__ = head;
                        } else var _a__ = first;
                        var tab = _a__;
                        break;
                    }
                } else var tab = insertion_point;
                var offset = tab - insertion_point | 0;
                return 0 <= offset ? break_same_line(state, [
                    0,
                    cst$0,
                    offset + n | 0,
                    cst
                ]) : break_new_line(state, [
                    0,
                    cst$2,
                    tab + off$0 | 0,
                    cst$1
                ], state[6]);
            case 4:
                var ty = param[2], off$1 = param[1], insertion_point$0 = state[6] - state[9] | 0;
                if (state[8] < insertion_point$0) {
                    var match = caml_call1(Stdlib_Stack[8], state[2]);
                    if (match) {
                        var match$0 = match[1], width = match$0[2], box_type = match$0[1];
                        if (state[9] < width && 3 >= box_type - 1 >>> 0) break_new_line(state, _a_, width);
                    } else pp_output_newline(state);
                }
                var width$2 = state[9] - off$1 | 0, box_type$1 = 1 === ty ? 1 : state[9] < size$0 ? ty : 5;
                return caml_call2(Stdlib_Stack[3], [
                    0,
                    box_type$1,
                    width$2
                ], state[2]);
            case 5:
                var tbox = param[1];
                return caml_call2(Stdlib_Stack[3], tbox, state[3]);
            default:
                var tag_name$0 = param[1], marker$0 = caml_call1(state[24], tag_name$0);
                pp_output_string(state, marker$0);
                return caml_call2(Stdlib_Stack[3], tag_name$0, state[5]);
        }
    }
    function advance_left(state) {
        for(;;){
            var match = caml_call1(Stdlib_Queue[9], state[28]);
            if (!match) return 0;
            var match$0 = match[1], size = match$0[1], length = match$0[3], token = match$0[2], pending_count = state[13] - state[12] | 0, _a7_ = 0 <= size ? 1 : 0, _a8_ = _a7_ || (state[9] <= pending_count ? 1 : 0);
            if (!_a8_) return _a8_;
            caml_call1(Stdlib_Queue[5], state[28]);
            var size$0 = 0 <= size ? size : pp_infinity;
            format_pp_token(state, size$0, token);
            state[12] = length + state[12] | 0;
        }
    }
    function enqueue_advance(state, tok) {
        pp_enqueue(state, tok);
        return advance_left(state);
    }
    function enqueue_string_as(state, size, s) {
        return enqueue_advance(state, [
            0,
            size,
            [
                0,
                s
            ],
            size
        ]);
    }
    function initialize_scan_stack(stack) {
        caml_call1(Stdlib_Stack[9], stack);
        var queue_elem = [
            0,
            unknown,
            _b_,
            0
        ];
        return caml_call2(Stdlib_Stack[3], [
            0,
            -1,
            queue_elem
        ], stack);
    }
    function set_size(state, ty) {
        var match = caml_call1(Stdlib_Stack[8], state[1]);
        if (!match) return;
        var match$0 = match[1], queue_elem = match$0[2], left_total = match$0[1], size = queue_elem[1];
        if (left_total < state[12]) return initialize_scan_stack(state[1]);
        var _a6_ = queue_elem[2];
        if (typeof _a6_ !== "number") switch(_a6_[0]){
            case 4:
                if (1 - ty) {
                    var x$0 = state[13] + size | 0;
                    queue_elem[1] = x$0;
                    caml_call1(Stdlib_Stack[5], state[1]);
                }
                return;
            case 2:
            case 3:
                if (ty) {
                    var x = state[13] + size | 0;
                    queue_elem[1] = x;
                    caml_call1(Stdlib_Stack[5], state[1]);
                }
                return;
        }
    }
    function scan_push(state, b, token) {
        pp_enqueue(state, token);
        if (b) set_size(state, 1);
        var elem = [
            0,
            state[13],
            token
        ];
        return caml_call2(Stdlib_Stack[3], elem, state[1]);
    }
    function pp_open_box_gen(state, indent, br_ty) {
        state[14] = state[14] + 1 | 0;
        if (state[14] < state[15]) {
            var size = -state[13] | 0, elem = [
                0,
                size,
                [
                    4,
                    indent,
                    br_ty
                ],
                0
            ];
            return scan_push(state, 0, elem);
        }
        var _a5_ = state[14] === state[15] ? 1 : 0;
        if (!_a5_) return _a5_;
        var s = state[16], x = caml_ml_string_length(s);
        return enqueue_string_as(state, x, s);
    }
    function pp_close_box(state, param) {
        var _a3_ = 1 < state[14] ? 1 : 0;
        if (_a3_) {
            if (state[14] < state[15]) {
                pp_enqueue(state, [
                    0,
                    zero,
                    1,
                    0
                ]);
                set_size(state, 1);
                set_size(state, 0);
            }
            state[14] = state[14] - 1 | 0;
            var _a4_ = 0;
        } else var _a4_ = _a3_;
        return _a4_;
    }
    function pp_open_stag(state, tag_name) {
        if (state[22]) {
            caml_call2(Stdlib_Stack[3], tag_name, state[4]);
            caml_call1(state[26], tag_name);
        }
        var _a2_ = state[23];
        if (!_a2_) return _a2_;
        var token = [
            6,
            tag_name
        ];
        return pp_enqueue(state, [
            0,
            zero,
            token,
            0
        ]);
    }
    function pp_close_stag(state, param) {
        if (state[23]) pp_enqueue(state, [
            0,
            zero,
            5,
            0
        ]);
        var _a0_ = state[22];
        if (_a0_) {
            var match = caml_call1(Stdlib_Stack[5], state[4]);
            if (match) {
                var tag_name = match[1];
                return caml_call1(state[27], tag_name);
            }
            var _a1_ = 0;
        } else var _a1_ = _a0_;
        return _a1_;
    }
    function pp_set_print_tags(state, b) {
        state[22] = b;
        return 0;
    }
    function pp_set_mark_tags(state, b) {
        state[23] = b;
        return 0;
    }
    function pp_get_print_tags(state, param) {
        return state[22];
    }
    function pp_get_mark_tags(state, param) {
        return state[23];
    }
    function pp_set_tags(state, b) {
        pp_set_print_tags(state, b);
        return pp_set_mark_tags(state, b);
    }
    function pp_get_formatter_stag_function(state, param) {
        return [
            0,
            state[24],
            state[25],
            state[26],
            state[27]
        ];
    }
    function pp_set_formatter_stag_function(state, param) {
        var pct = param[4], pot = param[3], mct = param[2], mot = param[1];
        state[24] = mot;
        state[25] = mct;
        state[26] = pot;
        state[27] = pct;
        return 0;
    }
    function pp_rinit(state) {
        state[12] = 1;
        state[13] = 1;
        caml_call1(Stdlib_Queue[12], state[28]);
        initialize_scan_stack(state[1]);
        caml_call1(Stdlib_Stack[9], state[2]);
        caml_call1(Stdlib_Stack[9], state[3]);
        caml_call1(Stdlib_Stack[9], state[4]);
        caml_call1(Stdlib_Stack[9], state[5]);
        state[10] = 0;
        state[14] = 0;
        state[9] = state[6];
        return pp_open_box_gen(state, 0, 3);
    }
    function pp_flush_queue(state, end_with_newline) {
        caml_call2(Stdlib_Stack[13], function(param) {
            return pp_close_stag(state, 0);
        }, state[4]);
        for(;;){
            if (1 >= state[14]) {
                state[13] = pp_infinity;
                advance_left(state);
                if (end_with_newline) pp_output_newline(state);
                return pp_rinit(state);
            }
            pp_close_box(state, 0);
        }
    }
    function pp_print_as_size(state, size, s) {
        var _aZ_ = state[14] < state[15] ? 1 : 0;
        return _aZ_ ? enqueue_string_as(state, size, s) : _aZ_;
    }
    function pp_print_as(state, isize, s) {
        return pp_print_as_size(state, isize, s);
    }
    function pp_print_string(state, s) {
        var isize = caml_ml_string_length(s);
        return pp_print_as_size(state, isize, s);
    }
    function pp_print_substring_as(pos, len, state, size, source) {
        var _aY_ = state[14] < state[15] ? 1 : 0;
        if (!_aY_) return _aY_;
        var token = [
            1,
            source,
            pos,
            len
        ];
        return enqueue_advance(state, [
            0,
            size,
            token,
            size
        ]);
    }
    function pp_print_substring(pos, len, state, s) {
        return pp_print_substring_as(pos, len, state, len, s);
    }
    function pp_print_bytes(state, s) {
        var s$0 = caml_call1(Stdlib_Bytes[6], s), isize = runtime.caml_ml_bytes_length(s);
        return pp_print_as_size(state, isize, s$0);
    }
    function pp_print_int(state, i) {
        return pp_print_string(state, caml_call1(Stdlib_Int[12], i));
    }
    function pp_print_float(state, f) {
        return pp_print_string(state, caml_call1(Stdlib[35], f));
    }
    function pp_print_bool(state, b) {
        return pp_print_string(state, caml_call1(Stdlib[30], b));
    }
    function pp_print_char(state, c) {
        var s = caml_call2(Stdlib_String[1], 1, c);
        return pp_print_as_size(state, 1, s);
    }
    function pp_print_nothing(state, param) {
        return 0;
    }
    function pp_open_hbox(state, param) {
        return pp_open_box_gen(state, 0, 0);
    }
    function pp_open_vbox(state, indent) {
        return pp_open_box_gen(state, indent, 1);
    }
    function pp_open_hvbox(state, indent) {
        return pp_open_box_gen(state, indent, 2);
    }
    function pp_open_hovbox(state, indent) {
        return pp_open_box_gen(state, indent, 3);
    }
    function pp_open_box(state, indent) {
        return pp_open_box_gen(state, indent, 4);
    }
    function pp_print_newline(state, param) {
        pp_flush_queue(state, 1);
        return caml_call1(state[18], 0);
    }
    function pp_print_flush(state, param) {
        pp_flush_queue(state, 0);
        return caml_call1(state[18], 0);
    }
    function pp_force_newline(state, param) {
        var _aX_ = state[14] < state[15] ? 1 : 0;
        return _aX_ ? enqueue_advance(state, [
            0,
            zero,
            3,
            0
        ]) : _aX_;
    }
    function pp_print_if_newline(state, param) {
        var _aW_ = state[14] < state[15] ? 1 : 0;
        return _aW_ ? enqueue_advance(state, [
            0,
            zero,
            4,
            0
        ]) : _aW_;
    }
    function pp_print_custom_break(state, fits, breaks) {
        var after = fits[3], width = fits[2], before = fits[1], _aV_ = state[14] < state[15] ? 1 : 0;
        if (!_aV_) return _aV_;
        var size = -state[13] | 0, token = [
            2,
            fits,
            breaks
        ], length = (caml_ml_string_length(before) + width | 0) + caml_ml_string_length(after) | 0, elem = [
            0,
            size,
            token,
            length
        ];
        return scan_push(state, 1, elem);
    }
    function pp_print_break(state, width, offset) {
        return pp_print_custom_break(state, [
            0,
            cst$6,
            width,
            cst$5
        ], [
            0,
            cst$4,
            offset,
            cst$3
        ]);
    }
    function pp_print_space(state, param) {
        return pp_print_break(state, 1, 0);
    }
    function pp_print_cut(state, param) {
        return pp_print_break(state, 0, 0);
    }
    function pp_open_tbox(state, param) {
        state[14] = state[14] + 1 | 0;
        var _aU_ = state[14] < state[15] ? 1 : 0;
        if (!_aU_) return _aU_;
        var elem = [
            0,
            zero,
            [
                5,
                [
                    0,
                    [
                        0,
                        0
                    ]
                ]
            ],
            0
        ];
        return enqueue_advance(state, elem);
    }
    function pp_close_tbox(state, param) {
        var _aR_ = 1 < state[14] ? 1 : 0;
        if (_aR_) {
            var _aS_ = state[14] < state[15] ? 1 : 0;
            if (_aS_) {
                var elem = [
                    0,
                    zero,
                    2,
                    0
                ];
                enqueue_advance(state, elem);
                state[14] = state[14] - 1 | 0;
                var _aT_ = 0;
            } else var _aT_ = _aS_;
        } else var _aT_ = _aR_;
        return _aT_;
    }
    function pp_print_tbreak(state, width, offset) {
        var _aQ_ = state[14] < state[15] ? 1 : 0;
        if (!_aQ_) return _aQ_;
        var size = -state[13] | 0, elem = [
            0,
            size,
            [
                3,
                width,
                offset
            ],
            width
        ];
        return scan_push(state, 1, elem);
    }
    function pp_print_tab(state, param) {
        return pp_print_tbreak(state, 0, 0);
    }
    function pp_set_tab(state, param) {
        var _aP_ = state[14] < state[15] ? 1 : 0;
        if (!_aP_) return _aP_;
        var elem = [
            0,
            zero,
            0,
            0
        ];
        return enqueue_advance(state, elem);
    }
    function pp_set_max_boxes(state, n) {
        var _aN_ = 1 < n ? 1 : 0, _aO_ = _aN_ ? (state[15] = n, 0) : _aN_;
        return _aO_;
    }
    function pp_get_max_boxes(state, param) {
        return state[15];
    }
    function pp_over_max_boxes(state, param) {
        return state[14] === state[15] ? 1 : 0;
    }
    function pp_set_ellipsis_text(state, s) {
        state[16] = s;
        return 0;
    }
    function pp_get_ellipsis_text(state, param) {
        return state[16];
    }
    function pp_limit(n) {
        return n < 1000000010 ? n : 1000000009;
    }
    function pp_set_max_indent(state, n$0) {
        var _aM_ = 1 < n$0 ? 1 : 0;
        if (!_aM_) return _aM_;
        var n$1 = state[6] - n$0 | 0, _aL_ = 1 <= n$1 ? 1 : 0;
        if (!_aL_) return _aL_;
        var n = pp_limit(n$1);
        state[7] = n;
        state[8] = state[6] - state[7] | 0;
        return pp_rinit(state);
    }
    function pp_get_max_indent(state, param) {
        return state[8];
    }
    function pp_set_margin(state, n) {
        var _aJ_ = 1 <= n ? 1 : 0;
        if (!_aJ_) return _aJ_;
        var n$0 = pp_limit(n);
        state[6] = n$0;
        if (state[8] <= state[6]) var new_max_indent = state[8];
        else var _aK_ = caml_call2(Stdlib_Int[11], state[6] - state[7] | 0, state[6] / 2 | 0), new_max_indent = caml_call2(Stdlib_Int[11], _aK_, 1);
        return pp_set_max_indent(state, new_max_indent);
    }
    function validate_geometry(param) {
        var margin = param[2], max_indent = param[1];
        return 2 <= max_indent ? margin <= max_indent ? _c_ : 1000000010 <= margin ? _d_ : _e_ : _f_;
    }
    function check_geometry(geometry) {
        return 0 === validate_geometry(geometry)[0] ? 1 : 0;
    }
    function pp_get_margin(state, param) {
        return state[6];
    }
    function pp_set_full_geometry(state, param) {
        var margin = param[2], max_indent = param[1];
        pp_set_margin(state, margin);
        pp_set_max_indent(state, max_indent);
        return 0;
    }
    function pp_set_geometry(state, max_indent, margin) {
        var geometry = [
            0,
            max_indent,
            margin
        ], match = validate_geometry(geometry);
        if (0 === match[0]) return pp_set_full_geometry(state, geometry);
        var msg = match[1], _aI_ = caml_call2(Stdlib[28], cst_Format_pp_set_geometry, msg);
        throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            _aI_
        ], 1);
    }
    function pp_safe_set_geometry(state, max_indent, margin) {
        var geometry = [
            0,
            max_indent,
            margin
        ];
        return 0 === validate_geometry(geometry)[0] ? pp_set_full_geometry(state, geometry) : 0;
    }
    function pp_get_geometry(state, param) {
        return [
            0,
            state[8],
            state[6]
        ];
    }
    function pp_update_geometry(state, update) {
        var geometry = pp_get_geometry(state, 0);
        return pp_set_full_geometry(state, caml_call1(update, geometry));
    }
    function pp_set_formatter_out_functions(state, param) {
        var j = param[5], i = param[4], h = param[3], g = param[2], f = param[1];
        state[17] = f;
        state[18] = g;
        state[19] = h;
        state[20] = i;
        state[21] = j;
        return 0;
    }
    function pp_get_formatter_out_functions(state, param) {
        return [
            0,
            state[17],
            state[18],
            state[19],
            state[20],
            state[21]
        ];
    }
    function pp_set_formatter_output_functi(state, f, g) {
        state[17] = f;
        state[18] = g;
        return 0;
    }
    function pp_get_formatter_output_functi(state, param) {
        return [
            0,
            state[17],
            state[18]
        ];
    }
    function display_newline(state, param) {
        return caml_call3(state[17], cst$7, 0, 1);
    }
    var blank_line = caml_call2(Stdlib_String[1], 80, 32), _g_ = [
        4,
        0,
        3
    ];
    function display_blanks(state, n) {
        var n$0 = n;
        for(;;){
            var _aH_ = 0 < n$0 ? 1 : 0;
            if (!_aH_) return _aH_;
            if (80 >= n$0) return caml_call3(state[17], blank_line, 0, n$0);
            caml_call3(state[17], blank_line, 0, 80);
            var n$1 = n$0 - 80 | 0;
            n$0 = n$1;
        }
    }
    function pp_set_formatter_out_channel(state, oc) {
        state[17] = caml_call1(Stdlib[69], oc);
        state[18] = function(param) {
            return caml_call1(Stdlib[63], oc);
        };
        state[19] = function(_aG_) {
            return display_newline(state, _aG_);
        };
        state[20] = function(_aF_) {
            return display_blanks(state, _aF_);
        };
        state[21] = function(_aE_) {
            return display_blanks(state, _aE_);
        };
        return 0;
    }
    function default_pp_mark_open_tag(param) {
        if (param[1] !== String_tag) return cst$10;
        var s = param[2], _aD_ = caml_call2(Stdlib[28], s, cst$8);
        return caml_call2(Stdlib[28], cst$9, _aD_);
    }
    function default_pp_mark_close_tag(param) {
        if (param[1] !== String_tag) return cst$13;
        var s = param[2], _aC_ = caml_call2(Stdlib[28], s, cst$11);
        return caml_call2(Stdlib[28], cst$12, _aC_);
    }
    function default_pp_print_open_tag(_aB_) {
        return 0;
    }
    function default_pp_print_close_tag(_aA_) {
        return 0;
    }
    function pp_make_formatter(f, g, h, i, j) {
        var pp_queue = caml_call1(Stdlib_Queue[2], 0), sys_tok = [
            0,
            unknown,
            _g_,
            0
        ];
        caml_call2(Stdlib_Queue[3], sys_tok, pp_queue);
        var scan_stack = caml_call1(Stdlib_Stack[2], 0);
        initialize_scan_stack(scan_stack);
        caml_call2(Stdlib_Stack[3], [
            0,
            1,
            sys_tok
        ], scan_stack);
        var pp_margin = 78, _aw_ = Stdlib[19], _ax_ = caml_call1(Stdlib_Stack[2], 0), _ay_ = caml_call1(Stdlib_Stack[2], 0), _az_ = caml_call1(Stdlib_Stack[2], 0);
        return [
            0,
            scan_stack,
            caml_call1(Stdlib_Stack[2], 0),
            _az_,
            _ay_,
            _ax_,
            pp_margin,
            10,
            68,
            pp_margin,
            0,
            1,
            1,
            1,
            1,
            _aw_,
            cst$14,
            f,
            g,
            h,
            i,
            j,
            0,
            0,
            default_pp_mark_open_tag,
            default_pp_mark_close_tag,
            default_pp_print_open_tag,
            default_pp_print_close_tag,
            pp_queue
        ];
    }
    function formatter_of_out_functions(out_funs) {
        return pp_make_formatter(out_funs[1], out_funs[2], out_funs[3], out_funs[4], out_funs[5]);
    }
    function make_formatter(output, flush) {
        var ppf = pp_make_formatter(output, flush, function(_av_) {
            return 0;
        }, function(_au_) {
            return 0;
        }, function(_at_) {
            return 0;
        });
        ppf[19] = function(_as_) {
            return display_newline(ppf, _as_);
        };
        ppf[20] = function(_ar_) {
            return display_blanks(ppf, _ar_);
        };
        ppf[21] = function(_aq_) {
            return display_blanks(ppf, _aq_);
        };
        return ppf;
    }
    function formatter_of_out_channel(oc) {
        return make_formatter(caml_call1(Stdlib[69], oc), function(param) {
            return caml_call1(Stdlib[63], oc);
        });
    }
    function formatter_of_buffer(b) {
        return make_formatter(caml_call1(Stdlib_Buffer[18], b), function(_ap_) {
            return 0;
        });
    }
    var pp_buffer_size = 512;
    function pp_make_buffer(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }
    var stdbuf = pp_make_buffer(0), std_formatter = formatter_of_out_channel(Stdlib[39]), err_formatter = formatter_of_out_channel(Stdlib[40]), str_formatter = formatter_of_buffer(stdbuf), stdbuf_key = caml_call2(Stdlib_Domain[11][1], 0, pp_make_buffer);
    caml_call2(Stdlib_Domain[11][3], stdbuf_key, stdbuf);
    var str_formatter_key = caml_call2(Stdlib_Domain[11][1], 0, function(param) {
        return formatter_of_buffer(caml_call1(Stdlib_Domain[11][2], stdbuf_key));
    });
    caml_call2(Stdlib_Domain[11][3], str_formatter_key, str_formatter);
    function buffered_out_string(key, str, ofs, len) {
        var _ao_ = caml_call1(Stdlib_Domain[11][2], key);
        return caml_call4(Stdlib_Buffer[18], _ao_, str, ofs, len);
    }
    function buffered_out_flush(oc, key, param) {
        var buf = caml_call1(Stdlib_Domain[11][2], key), len = caml_call1(Stdlib_Buffer[7], buf), str = caml_call1(Stdlib_Buffer[2], buf);
        caml_call4(Stdlib[69], oc, str, 0, len);
        caml_call1(Stdlib[63], oc);
        return caml_call1(Stdlib_Buffer[8], buf);
    }
    var std_buf_key = caml_call2(Stdlib_Domain[11][1], 0, function(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }), err_buf_key = caml_call2(Stdlib_Domain[11][1], 0, function(param) {
        return caml_call1(Stdlib_Buffer[1], pp_buffer_size);
    }), std_formatter_key = caml_call2(Stdlib_Domain[11][1], 0, function(param) {
        var _ac_ = Stdlib[39], ppf = pp_make_formatter(function(_al_, _am_, _an_) {
            return buffered_out_string(std_buf_key, _al_, _am_, _an_);
        }, function(_ak_) {
            return buffered_out_flush(_ac_, std_buf_key, _ak_);
        }, function(_aj_) {
            return 0;
        }, function(_ai_) {
            return 0;
        }, function(_ah_) {
            return 0;
        });
        ppf[19] = function(_ag_) {
            return display_newline(ppf, _ag_);
        };
        ppf[20] = function(_af_) {
            return display_blanks(ppf, _af_);
        };
        ppf[21] = function(_ae_) {
            return display_blanks(ppf, _ae_);
        };
        caml_call1(Stdlib_Domain[6], function(_ad_) {
            return pp_print_flush(ppf, _ad_);
        });
        return ppf;
    });
    caml_call2(Stdlib_Domain[11][3], std_formatter_key, std_formatter);
    var err_formatter_key = caml_call2(Stdlib_Domain[11][1], 0, function(param) {
        var _S_ = Stdlib[40], ppf = pp_make_formatter(function(_$_, _aa_, _ab_) {
            return buffered_out_string(err_buf_key, _$_, _aa_, _ab_);
        }, function(___) {
            return buffered_out_flush(_S_, err_buf_key, ___);
        }, function(_Z_) {
            return 0;
        }, function(_Y_) {
            return 0;
        }, function(_X_) {
            return 0;
        });
        ppf[19] = function(_W_) {
            return display_newline(ppf, _W_);
        };
        ppf[20] = function(_V_) {
            return display_blanks(ppf, _V_);
        };
        ppf[21] = function(_U_) {
            return display_blanks(ppf, _U_);
        };
        caml_call1(Stdlib_Domain[6], function(_T_1) {
            return pp_print_flush(ppf, _T_1);
        });
        return ppf;
    });
    caml_call2(Stdlib_Domain[11][3], err_formatter_key, err_formatter);
    function get_std_formatter(param) {
        return caml_call1(Stdlib_Domain[11][2], std_formatter_key);
    }
    function get_err_formatter(param) {
        return caml_call1(Stdlib_Domain[11][2], err_formatter_key);
    }
    function get_str_formatter(param) {
        return caml_call1(Stdlib_Domain[11][2], str_formatter_key);
    }
    function get_stdbuf(param) {
        return caml_call1(Stdlib_Domain[11][2], stdbuf_key);
    }
    function flush_buffer_formatter(buf, ppf) {
        pp_flush_queue(ppf, 0);
        var s = caml_call1(Stdlib_Buffer[2], buf);
        caml_call1(Stdlib_Buffer[9], buf);
        return s;
    }
    function flush_str_formatter(param) {
        var stdbuf = caml_call1(Stdlib_Domain[11][2], stdbuf_key), str_formatter = caml_call1(Stdlib_Domain[11][2], str_formatter_key);
        return flush_buffer_formatter(stdbuf, str_formatter);
    }
    function make_synchronized_formatter(output, flush) {
        return caml_call2(Stdlib_Domain[11][1], 0, function(param) {
            var buf = caml_call1(Stdlib_Buffer[1], pp_buffer_size), output$0 = caml_call1(Stdlib_Buffer[18], buf);
            function flush$0(param) {
                var _R_ = caml_call1(Stdlib_Buffer[7], buf);
                caml_call3(output, caml_call1(Stdlib_Buffer[2], buf), 0, _R_);
                caml_call1(Stdlib_Buffer[8], buf);
                return caml_call1(flush, 0);
            }
            return make_formatter(output$0, flush$0);
        });
    }
    function synchronized_formatter_of_out_(oc) {
        return make_synchronized_formatter(caml_call1(Stdlib[69], oc), function(param) {
            return caml_call1(Stdlib[63], oc);
        });
    }
    function make_symbolic_output_buffer(param) {
        return [
            0,
            0
        ];
    }
    function clear_symbolic_output_buffer(sob) {
        sob[1] = 0;
        return 0;
    }
    function get_symbolic_output_buffer(sob) {
        return caml_call1(Stdlib_List[10], sob[1]);
    }
    function flush_symbolic_output_buffer(sob) {
        var items = get_symbolic_output_buffer(sob);
        clear_symbolic_output_buffer(sob);
        return items;
    }
    function add_symbolic_output_item(sob, item) {
        sob[1] = [
            0,
            item,
            sob[1]
        ];
        return 0;
    }
    function formatter_of_symbolic_output_b(sob) {
        function f(s, i, n) {
            return add_symbolic_output_item(sob, [
                0,
                caml_call3(Stdlib_String[16], s, i, n)
            ]);
        }
        function g(_Q_) {
            return add_symbolic_output_item(sob, 0);
        }
        function h(_P_) {
            return add_symbolic_output_item(sob, 1);
        }
        function i(n) {
            return add_symbolic_output_item(sob, [
                1,
                n
            ]);
        }
        function j(n) {
            return add_symbolic_output_item(sob, [
                2,
                n
            ]);
        }
        return pp_make_formatter(f, g, h, i, j);
    }
    function open_hbox(v) {
        return pp_open_hbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_vbox(v) {
        return pp_open_vbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_hvbox(v) {
        return pp_open_hvbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_hovbox(v) {
        return pp_open_hovbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_box(v) {
        return pp_open_box(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function close_box(v) {
        return pp_close_box(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_stag(v) {
        return pp_open_stag(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function close_stag(v) {
        return pp_close_stag(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_as(isize, w) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return pp_print_as_size(state, isize, w);
    }
    function print_string(v) {
        return pp_print_string(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_substring(pos, len, v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return pp_print_substring_as(pos, len, state, len, v);
    }
    function print_substring_as(pos, len, as_len, v) {
        return pp_print_substring_as(pos, len, caml_call1(Stdlib_Domain[11][2], std_formatter_key), as_len, v);
    }
    function print_bytes(v) {
        return pp_print_bytes(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_int(v) {
        return pp_print_int(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_float(v) {
        return pp_print_float(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_char(v) {
        return pp_print_char(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_bool(v) {
        return pp_print_bool(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_break(v, w) {
        return pp_print_break(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v, w);
    }
    function print_cut(v) {
        return pp_print_cut(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_space(v) {
        return pp_print_space(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function force_newline(v) {
        return pp_force_newline(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_flush(v) {
        return pp_print_flush(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_newline(v) {
        return pp_print_newline(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_if_newline(v) {
        return pp_print_if_newline(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function open_tbox(v) {
        return pp_open_tbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function close_tbox(v) {
        return pp_close_tbox(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_tbreak(v, w) {
        return pp_print_tbreak(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v, w);
    }
    function set_tab(v) {
        return pp_set_tab(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function print_tab(v) {
        return pp_print_tab(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_margin(v) {
        return pp_set_margin(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_margin(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[6];
    }
    function set_max_indent(v) {
        return pp_set_max_indent(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_max_indent(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[8];
    }
    function set_geometry(max_indent, margin) {
        return pp_set_geometry(caml_call1(Stdlib_Domain[11][2], std_formatter_key), max_indent, margin);
    }
    function safe_set_geometry(max_indent, margin) {
        return pp_safe_set_geometry(caml_call1(Stdlib_Domain[11][2], std_formatter_key), max_indent, margin);
    }
    function get_geometry(v) {
        return pp_get_geometry(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function update_geometry(v) {
        return pp_update_geometry(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_max_boxes(v) {
        return pp_set_max_boxes(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_max_boxes(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[15];
    }
    function over_max_boxes(v) {
        return pp_over_max_boxes(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_ellipsis_text(v) {
        return pp_set_ellipsis_text(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_ellipsis_text(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[16];
    }
    function set_formatter_out_channel(v) {
        return pp_set_formatter_out_channel(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_formatter_out_functions(v) {
        return pp_set_formatter_out_functions(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_formatter_out_functions(v) {
        return pp_get_formatter_out_functions(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_formatter_output_functions(v, w) {
        return pp_set_formatter_output_functi(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v, w);
    }
    function get_formatter_output_functions(v) {
        return pp_get_formatter_output_functi(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_formatter_stag_functions(v) {
        return pp_set_formatter_stag_function(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_formatter_stag_functions(v) {
        return pp_get_formatter_stag_function(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function set_print_tags(v) {
        return pp_set_print_tags(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_print_tags(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[22];
    }
    function set_mark_tags(v) {
        return pp_set_mark_tags(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function get_mark_tags(v) {
        var state = caml_call1(Stdlib_Domain[11][2], std_formatter_key);
        return state[23];
    }
    function set_tags(v) {
        return pp_set_tags(caml_call1(Stdlib_Domain[11][2], std_formatter_key), v);
    }
    function pp_print_iter(opt, iter, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut, is_first = [
            0,
            1
        ];
        function pp_v$0(v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_v, ppf, v);
        }
        return caml_call2(iter, pp_v$0, v);
    }
    function pp_print_list(opt, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_List[18], pp_v, ppf, v);
    }
    function pp_print_array(opt, pp_v, ppf, v) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_Array[12], pp_v, ppf, v);
    }
    function pp_print_seq(opt, pp_v, ppf, seq) {
        var pp_sep = opt ? opt[1] : pp_print_cut;
        return pp_print_iter([
            0,
            pp_sep
        ], Stdlib_Seq[4], pp_v, ppf, seq);
    }
    function pp_print_text(state, s) {
        var len = caml_ml_string_length(s), left = [
            0,
            0
        ], right = [
            0,
            0
        ];
        function flush(param) {
            var len = right[1] - left[1] | 0, pos = left[1];
            pp_print_substring_as(pos, len, state, len, s);
            right[1]++;
            left[1] = right[1];
            return 0;
        }
        for(;;){
            if (right[1] === len) {
                var _O_ = left[1] !== len ? 1 : 0;
                return _O_ ? flush(0) : _O_;
            }
            var match = runtime.caml_string_get(s, right[1]);
            if (10 === match) {
                flush(0);
                pp_force_newline(state, 0);
            } else if (32 === match) {
                flush(0);
                pp_print_space(state, 0);
            } else right[1]++;
        }
    }
    function pp_print_option(opt, pp_v, ppf, param) {
        var none = opt ? opt[1] : function(_N_, param) {
            return 0;
        };
        if (!param) return caml_call2(none, ppf, 0);
        var v = param[1];
        return caml_call2(pp_v, ppf, v);
    }
    function pp_print_result(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call2(ok, ppf, v);
        }
        var e = param[1];
        return caml_call2(error, ppf, e);
    }
    function pp_print_either(left, right, ppf, param) {
        if (0 === param[0]) {
            var l = param[1];
            return caml_call2(left, ppf, l);
        }
        var r = param[1];
        return caml_call2(right, ppf, r);
    }
    function compute_tag(output, tag_acc) {
        var buf = caml_call1(Stdlib_Buffer[1], 16), ppf = formatter_of_buffer(buf);
        caml_call2(output, ppf, tag_acc);
        pp_print_flush(ppf, 0);
        var len = caml_call1(Stdlib_Buffer[7], buf);
        return 2 <= len ? caml_call3(Stdlib_Buffer[4], buf, 1, len - 2 | 0) : caml_call1(Stdlib_Buffer[2], buf);
    }
    function output_formatting_lit(ppf, fmting_lit) {
        if (typeof fmting_lit === "number") switch(fmting_lit){
            case 0:
                return pp_close_box(ppf, 0);
            case 1:
                return pp_close_stag(ppf, 0);
            case 2:
                return pp_print_flush(ppf, 0);
            case 3:
                return pp_force_newline(ppf, 0);
            case 4:
                return pp_print_newline(ppf, 0);
            case 5:
                return pp_print_char(ppf, 64);
            default:
                return pp_print_char(ppf, 37);
        }
        switch(fmting_lit[0]){
            case 0:
                var offset = fmting_lit[3], width = fmting_lit[2];
                return pp_print_break(ppf, width, offset);
            case 1:
                return 0;
            default:
                var c = fmting_lit[1];
                pp_print_char(ppf, 64);
                return pp_print_char(ppf, c);
        }
    }
    function output_acc(ppf, acc) {
        if (typeof acc === "number") return 0;
        a: {
            b: {
                c: {
                    switch(acc[0]){
                        case 0:
                            var f = acc[2], p = acc[1];
                            output_acc(ppf, p);
                            return output_formatting_lit(ppf, f);
                        case 1:
                            var match = acc[2], p$0 = acc[1];
                            if (0 === match[0]) {
                                var acc$0 = match[1];
                                output_acc(ppf, p$0);
                                return pp_open_stag(ppf, [
                                    0,
                                    String_tag,
                                    compute_tag(output_acc, acc$0)
                                ]);
                            }
                            var acc$1 = match[1];
                            output_acc(ppf, p$0);
                            var _E_ = compute_tag(output_acc, acc$1), match$0 = caml_call1(CamlinternalFormat[20], _E_), bty = match$0[2], indent = match$0[1];
                            return pp_open_box_gen(ppf, indent, bty);
                        case 2:
                            var _F_ = acc[1];
                            if (typeof _F_ !== "number" && 0 === _F_[0]) {
                                var _G_ = _F_[2];
                                if (typeof _G_ !== "number" && 1 === _G_[0]) {
                                    var s$0 = acc[2], size = _G_[2], p$2 = _F_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _F_;
                            break a;
                        case 3:
                            var _H_ = acc[1];
                            if (typeof _H_ !== "number" && 0 === _H_[0]) {
                                var _I_ = _H_[2];
                                if (typeof _I_ !== "number" && 1 === _I_[0]) {
                                    var c$0 = acc[2], size$0 = _I_[2], p$4 = _H_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _H_;
                            break c;
                        case 4:
                            var _J_ = acc[1];
                            if (typeof _J_ !== "number" && 0 === _J_[0]) {
                                var _K_ = _J_[2];
                                if (typeof _K_ !== "number" && 1 === _K_[0]) {
                                    var s$0 = acc[2], size = _K_[2], p$2 = _J_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _J_;
                            break a;
                        case 5:
                            var _L_ = acc[1];
                            if (typeof _L_ !== "number" && 0 === _L_[0]) {
                                var _M_ = _L_[2];
                                if (typeof _M_ !== "number" && 1 === _M_[0]) {
                                    var c$0 = acc[2], size$0 = _M_[2], p$4 = _L_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _L_;
                            break c;
                        case 6:
                            var f$0 = acc[2], p$5 = acc[1];
                            output_acc(ppf, p$5);
                            return caml_call1(f$0, ppf);
                        case 7:
                            var p$6 = acc[1];
                            output_acc(ppf, p$6);
                            return pp_print_flush(ppf, 0);
                        default:
                            var msg = acc[2], p$7 = acc[1];
                            output_acc(ppf, p$7);
                            return caml_call1(Stdlib[1], msg);
                    }
                    output_acc(ppf, p$4);
                    return pp_print_as_size(ppf, size$0, caml_call2(Stdlib_String[1], 1, c$0));
                }
                output_acc(ppf, p$3);
                return pp_print_char(ppf, c);
            }
            output_acc(ppf, p$2);
            return pp_print_as_size(ppf, size, s$0);
        }
        output_acc(ppf, p$1);
        return pp_print_string(ppf, s);
    }
    function strput_acc(ppf, acc) {
        if (typeof acc === "number") return 0;
        a: {
            b: {
                c: {
                    switch(acc[0]){
                        case 0:
                            var f = acc[2], p = acc[1];
                            strput_acc(ppf, p);
                            return output_formatting_lit(ppf, f);
                        case 1:
                            var match = acc[2], p$0 = acc[1];
                            if (0 === match[0]) {
                                var acc$0 = match[1];
                                strput_acc(ppf, p$0);
                                return pp_open_stag(ppf, [
                                    0,
                                    String_tag,
                                    compute_tag(strput_acc, acc$0)
                                ]);
                            }
                            var acc$1 = match[1];
                            strput_acc(ppf, p$0);
                            var _v_ = compute_tag(strput_acc, acc$1), match$0 = caml_call1(CamlinternalFormat[20], _v_), bty = match$0[2], indent = match$0[1];
                            return pp_open_box_gen(ppf, indent, bty);
                        case 2:
                            var _w_ = acc[1];
                            if (typeof _w_ !== "number" && 0 === _w_[0]) {
                                var _x_ = _w_[2];
                                if (typeof _x_ !== "number" && 1 === _x_[0]) {
                                    var s$0 = acc[2], size = _x_[2], p$2 = _w_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _w_;
                            break a;
                        case 3:
                            var _y_ = acc[1];
                            if (typeof _y_ !== "number" && 0 === _y_[0]) {
                                var _z_ = _y_[2];
                                if (typeof _z_ !== "number" && 1 === _z_[0]) {
                                    var c$0 = acc[2], size$0 = _z_[2], p$4 = _y_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _y_;
                            break c;
                        case 4:
                            var _A_ = acc[1];
                            if (typeof _A_ !== "number" && 0 === _A_[0]) {
                                var _B_ = _A_[2];
                                if (typeof _B_ !== "number" && 1 === _B_[0]) {
                                    var s$0 = acc[2], size = _B_[2], p$2 = _A_[1];
                                    break b;
                                }
                            }
                            var s = acc[2], p$1 = _A_;
                            break a;
                        case 5:
                            var _C_ = acc[1];
                            if (typeof _C_ !== "number" && 0 === _C_[0]) {
                                var _D_ = _C_[2];
                                if (typeof _D_ !== "number" && 1 === _D_[0]) {
                                    var c$0 = acc[2], size$0 = _D_[2], p$4 = _C_[1];
                                    break;
                                }
                            }
                            var c = acc[2], p$3 = _C_;
                            break c;
                        case 6:
                            var p$5 = acc[1];
                            if (typeof p$5 !== "number" && 0 === p$5[0]) {
                                var match$1 = p$5[2];
                                if (typeof match$1 !== "number" && 1 === match$1[0]) {
                                    var f$1 = acc[2], size$1 = match$1[2], p$6 = p$5[1];
                                    strput_acc(ppf, p$6);
                                    return pp_print_as_size(ppf, size$1, caml_call1(f$1, 0));
                                }
                            }
                            var f$0 = acc[2];
                            strput_acc(ppf, p$5);
                            return pp_print_string(ppf, caml_call1(f$0, 0));
                        case 7:
                            var p$7 = acc[1];
                            strput_acc(ppf, p$7);
                            return pp_print_flush(ppf, 0);
                        default:
                            var msg = acc[2], p$8 = acc[1];
                            strput_acc(ppf, p$8);
                            return caml_call1(Stdlib[1], msg);
                    }
                    strput_acc(ppf, p$4);
                    return pp_print_as_size(ppf, size$0, caml_call2(Stdlib_String[1], 1, c$0));
                }
                strput_acc(ppf, p$3);
                return pp_print_char(ppf, c);
            }
            strput_acc(ppf, p$2);
            return pp_print_as_size(ppf, size, s$0);
        }
        strput_acc(ppf, p$1);
        return pp_print_string(ppf, s);
    }
    function kfprintf(k, ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            output_acc(ppf, acc);
            return caml_call1(k, ppf);
        }, 0, fmt);
    }
    function ikfprintf(k, ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], k, ppf, fmt);
    }
    function ifprintf(ppf, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[8], function(_u_) {
            return 0;
        }, 0, fmt);
    }
    function fprintf(ppf) {
        function _r_(_t_) {
            return 0;
        }
        return function(_s_) {
            return kfprintf(_r_, ppf, _s_);
        };
    }
    function printf(param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return output_acc(caml_call1(Stdlib_Domain[11][2], std_formatter_key), acc);
        }, 0, fmt);
    }
    function eprintf(param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return output_acc(caml_call1(Stdlib_Domain[11][2], err_formatter_key), acc);
        }, 0, fmt);
    }
    function kdprintf(k, param) {
        var fmt = param[1];
        return caml_call3(CamlinternalFormat[7], function(acc) {
            return caml_call1(k, function(ppf) {
                return output_acc(ppf, acc);
            });
        }, 0, fmt);
    }
    function dprintf(fmt) {
        return kdprintf(function(i) {
            return i;
        }, fmt);
    }
    function ksprintf(k, param) {
        var fmt = param[1], b = pp_make_buffer(0), ppf = formatter_of_buffer(b);
        function k$0(acc) {
            strput_acc(ppf, acc);
            return caml_call1(k, flush_buffer_formatter(b, ppf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function sprintf(fmt) {
        return ksprintf(id, fmt);
    }
    function kasprintf(k, param) {
        var fmt = param[1], b = pp_make_buffer(0), ppf = formatter_of_buffer(b);
        function k$0(acc) {
            output_acc(ppf, acc);
            return caml_call1(k, flush_buffer_formatter(b, ppf));
        }
        return caml_call3(CamlinternalFormat[7], k$0, 0, fmt);
    }
    function asprintf(fmt) {
        return kasprintf(id, fmt);
    }
    function flush_standard_formatters(param) {
        pp_print_flush(caml_call1(Stdlib_Domain[11][2], std_formatter_key), 0);
        return pp_print_flush(caml_call1(Stdlib_Domain[11][2], err_formatter_key), 0);
    }
    caml_call1(Stdlib[100], flush_standard_formatters);
    caml_call1(Stdlib_Domain[5], function(param) {
        flush_standard_formatters(0);
        var fs = pp_get_formatter_out_functions(std_formatter, 0), _h_ = Stdlib[39];
        pp_set_formatter_out_functions(std_formatter, [
            0,
            function(_o_, _p_, _q_) {
                return buffered_out_string(std_buf_key, _o_, _p_, _q_);
            },
            function(_n_) {
                return buffered_out_flush(_h_, std_buf_key, _n_);
            },
            fs[3],
            fs[4],
            fs[5]
        ]);
        var fs$0 = pp_get_formatter_out_functions(err_formatter, 0), _i_ = Stdlib[40];
        return pp_set_formatter_out_functions(err_formatter, [
            0,
            function(_k_, _l_, _m_) {
                return buffered_out_string(err_buf_key, _k_, _l_, _m_);
            },
            function(_j_) {
                return buffered_out_flush(_i_, err_buf_key, _j_);
            },
            fs$0[3],
            fs$0[4],
            fs$0[5]
        ]);
    });
    var Stdlib_Format = [
        0,
        pp_open_box,
        open_box,
        pp_close_box,
        close_box,
        pp_open_hbox,
        open_hbox,
        pp_open_vbox,
        open_vbox,
        pp_open_hvbox,
        open_hvbox,
        pp_open_hovbox,
        open_hovbox,
        pp_print_string,
        print_string,
        pp_print_substring,
        print_substring,
        pp_print_bytes,
        print_bytes,
        pp_print_as,
        print_as,
        pp_print_substring_as,
        print_substring_as,
        pp_print_int,
        print_int,
        pp_print_float,
        print_float,
        pp_print_char,
        print_char,
        pp_print_bool,
        print_bool,
        pp_print_nothing,
        pp_print_space,
        print_space,
        pp_print_cut,
        print_cut,
        pp_print_break,
        print_break,
        pp_print_custom_break,
        pp_force_newline,
        force_newline,
        pp_print_if_newline,
        print_if_newline,
        pp_print_flush,
        print_flush,
        pp_print_newline,
        print_newline,
        pp_infinity,
        pp_set_margin,
        set_margin,
        pp_get_margin,
        get_margin,
        pp_set_max_indent,
        set_max_indent,
        pp_get_max_indent,
        get_max_indent,
        check_geometry,
        pp_set_geometry,
        set_geometry,
        pp_safe_set_geometry,
        safe_set_geometry,
        pp_update_geometry,
        update_geometry,
        pp_get_geometry,
        get_geometry,
        pp_set_max_boxes,
        set_max_boxes,
        pp_get_max_boxes,
        get_max_boxes,
        pp_over_max_boxes,
        over_max_boxes,
        pp_open_tbox,
        open_tbox,
        pp_close_tbox,
        close_tbox,
        pp_set_tab,
        set_tab,
        pp_print_tab,
        print_tab,
        pp_print_tbreak,
        print_tbreak,
        pp_set_ellipsis_text,
        set_ellipsis_text,
        pp_get_ellipsis_text,
        get_ellipsis_text,
        String_tag,
        pp_open_stag,
        open_stag,
        pp_close_stag,
        close_stag,
        pp_set_tags,
        set_tags,
        pp_set_print_tags,
        set_print_tags,
        pp_set_mark_tags,
        set_mark_tags,
        pp_get_print_tags,
        get_print_tags,
        pp_get_mark_tags,
        get_mark_tags,
        pp_set_formatter_out_channel,
        set_formatter_out_channel,
        pp_set_formatter_output_functi,
        set_formatter_output_functions,
        pp_get_formatter_output_functi,
        get_formatter_output_functions,
        pp_set_formatter_out_functions,
        set_formatter_out_functions,
        pp_get_formatter_out_functions,
        get_formatter_out_functions,
        pp_set_formatter_stag_function,
        set_formatter_stag_functions,
        pp_get_formatter_stag_function,
        get_formatter_stag_functions,
        formatter_of_out_channel,
        synchronized_formatter_of_out_,
        std_formatter,
        get_std_formatter,
        err_formatter,
        get_err_formatter,
        formatter_of_buffer,
        stdbuf,
        get_stdbuf,
        str_formatter,
        get_str_formatter,
        flush_str_formatter,
        make_formatter,
        make_synchronized_formatter,
        formatter_of_out_functions,
        make_symbolic_output_buffer,
        clear_symbolic_output_buffer,
        get_symbolic_output_buffer,
        flush_symbolic_output_buffer,
        add_symbolic_output_item,
        formatter_of_symbolic_output_b,
        pp_print_iter,
        pp_print_list,
        pp_print_array,
        pp_print_seq,
        pp_print_text,
        pp_print_option,
        pp_print_result,
        pp_print_either,
        fprintf,
        printf,
        eprintf,
        sprintf,
        asprintf,
        dprintf,
        ifprintf,
        kfprintf,
        kdprintf,
        ikfprintf,
        ksprintf,
        kasprintf
    ];
    runtime.caml_register_global(38, Stdlib_Format, "Stdlib__Format");
    return;
})(globalThis);
//# 22421 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$5 = '"', cst$6 = "-", cst_character = "character ", cst_scanf_ml = "scanf.ml", cst_scanf_bad_conversion$3 = 'scanf: bad conversion "%*"', cst_scanning_of = "scanning of ", caml_bytes_get = runtime.caml_bytes_get, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$3 = cst$5, cst$4 = cst$5, cst$1 = cst$5, cst$2 = cst$5, cst$0 = cst$5, cst_not_a_valid_float_in_hexad = "not a valid float in hexadecimal notation", cst_no_dot_or_exponent_part_fo = "no dot or exponent part found in float token", cst = cst$6, cst_binary = "binary", cst_octal = "octal", cst_hexadecimal = "hexadecimal", cst_a_Char = "a Char", cst_a_String = "a String", CamlinternalFormat = global_data.CamlinternalFormat, CamlinternalFormatBasics = global_data.CamlinternalFormatBasics, Stdlib_String = global_data.Stdlib__String, Stdlib = global_data.Stdlib, Assert_failure = global_data.Assert_failure, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Buffer = global_data.Stdlib__Buffer, null_char = 0, cst_unnamed_function = "unnamed function", cst_unnamed_character_string = "unnamed character string", cst_unnamed_Stdlib_input_chann = "unnamed Stdlib input channel";
    function next_char(ib) {
        try {
            var c = caml_call1(ib[7], 0);
            ib[2] = c;
            ib[3] = 1;
            ib[4] = ib[4] + 1 | 0;
            if (10 === c) ib[5] = ib[5] + 1 | 0;
            return c;
        } catch (_aY_) {
            var _aX_ = caml_wrap_exception(_aY_);
            if (_aX_ !== Stdlib[12]) throw caml_maybe_attach_backtrace(_aX_, 0);
            ib[2] = null_char;
            ib[3] = 0;
            ib[1] = 1;
            return null_char;
        }
    }
    function peek_char(ib) {
        return ib[3] ? ib[2] : next_char(ib);
    }
    function checked_peek_char(ib) {
        var c = peek_char(ib);
        if (ib[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
        return c;
    }
    function end_of_input(ib) {
        peek_char(ib);
        return ib[1];
    }
    function beginning_of_input(ib) {
        return 0 === ib[4] ? 1 : 0;
    }
    function name_of_input(ib) {
        var match = ib[9];
        if (typeof match === "number") return 0 === match ? cst_unnamed_function : cst_unnamed_character_string;
        if (0 === match[0]) return cst_unnamed_Stdlib_input_chann;
        var fname = match[1];
        return fname;
    }
    function char_count(ib) {
        return ib[3] ? ib[4] - 1 | 0 : ib[4];
    }
    function invalidate_current_char(ib) {
        ib[3] = 0;
        return 0;
    }
    function token_string(ib) {
        var token_buffer = ib[8], tok = caml_call1(Stdlib_Buffer[2], token_buffer);
        caml_call1(Stdlib_Buffer[8], token_buffer);
        ib[6] = ib[6] + 1 | 0;
        return tok;
    }
    function ignore_char(width, ib) {
        var width$0 = width - 1 | 0;
        invalidate_current_char(ib);
        return width$0;
    }
    function store_char(width, ib, c) {
        caml_call2(Stdlib_Buffer[12], ib[8], c);
        return ignore_char(width, ib);
    }
    var default_token_buffer_size = 1024;
    function create(iname, next) {
        return [
            0,
            0,
            null_char,
            0,
            0,
            0,
            0,
            next,
            caml_call1(Stdlib_Buffer[1], default_token_buffer_size),
            iname
        ];
    }
    function from_string(s) {
        var i = [
            0,
            0
        ], len = caml_ml_string_length(s);
        function next(param) {
            if (len <= i[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            var c = caml_string_get(s, i[1]);
            i[1]++;
            return c;
        }
        return create(1, next);
    }
    var _a_ = 0;
    function from_function(_aW_) {
        return create(_a_, _aW_);
    }
    var len = 1024;
    function scan_close_at_end(ic) {
        caml_call1(Stdlib[93], ic);
        throw caml_maybe_attach_backtrace(Stdlib[12], 1);
    }
    function scan_raise_at_end(ic) {
        throw caml_maybe_attach_backtrace(Stdlib[12], 1);
    }
    function from_ic(scan_close_ic, iname, ic) {
        var buf = runtime.caml_create_bytes(1024), i = [
            0,
            0
        ], lim = [
            0,
            0
        ], eof = [
            0,
            0
        ];
        function next(param) {
            if (i[1] < lim[1]) {
                var c = caml_bytes_get(buf, i[1]);
                i[1]++;
                return c;
            }
            if (eof[1]) throw caml_maybe_attach_backtrace(Stdlib[12], 1);
            lim[1] = caml_call4(Stdlib[84], ic, buf, 0, len);
            return 0 === lim[1] ? (eof[1] = 1, caml_call1(scan_close_ic, ic)) : (i[1] = 1, caml_bytes_get(buf, 0));
        }
        return create(iname, next);
    }
    var stdin = from_ic(scan_raise_at_end, [
        1,
        cst,
        Stdlib[38]
    ], Stdlib[38]);
    function open_in_file(open_in, fname) {
        if (fname === cst$6) return stdin;
        var ic = caml_call1(open_in, fname);
        return from_ic(scan_close_at_end, [
            1,
            fname,
            ic
        ], ic);
    }
    var _b_ = Stdlib[79];
    function open_in(_aV_) {
        return open_in_file(_b_, _aV_);
    }
    var _c_ = Stdlib[80];
    function open_in_bin(_aU_) {
        return open_in_file(_c_, _aU_);
    }
    function from_channel(ic) {
        return from_ic(scan_raise_at_end, [
            0,
            ic
        ], ic);
    }
    function close_in(ib) {
        var match = ib[9];
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var ic = match[1];
            return caml_call1(Stdlib[93], ic);
        }
        var ic$0 = match[2];
        return caml_call1(Stdlib[93], ic$0);
    }
    var Scan_failure = [
        248,
        "Stdlib.Scanf.Scan_failure",
        runtime.caml_fresh_oo_id(0)
    ], _d_ = [
        0,
        [
            11,
            "illegal escape character ",
            [
                1,
                0
            ]
        ],
        "illegal escape character %C"
    ], _e_ = [
        0,
        [
            11,
            cst_scanning_of,
            [
                2,
                0,
                [
                    11,
                    " failed: the specified length was too short for token",
                    0
                ]
            ]
        ],
        "scanning of %s failed: the specified length was too short for token"
    ], _f_ = [
        0,
        [
            11,
            cst_scanning_of,
            [
                2,
                0,
                [
                    11,
                    " failed: premature end of file occurred before end of token",
                    0
                ]
            ]
        ],
        "scanning of %s failed: premature end of file occurred before end of token"
    ], _g_ = [
        0,
        [
            11,
            "looking for ",
            [
                1,
                [
                    11,
                    ", found ",
                    [
                        1,
                        0
                    ]
                ]
            ]
        ],
        "looking for %C, found %C"
    ], _h_ = [
        0,
        [
            11,
            "invalid boolean '",
            [
                2,
                0,
                [
                    12,
                    39,
                    0
                ]
            ]
        ],
        "invalid boolean '%s'"
    ], _i_ = [
        0,
        cst_scanf_ml,
        516,
        9
    ], cst_0b = "0b", cst_0o = "0o", cst_0u = "0u", cst_0x = "0x", cst_decimal_digits = "decimal digits", _j_ = [
        0,
        [
            11,
            cst_character,
            [
                1,
                [
                    11,
                    " is not a decimal digit",
                    0
                ]
            ]
        ],
        "character %C is not a decimal digit"
    ], cst_digits = "digits", _k_ = [
        0,
        [
            11,
            cst_character,
            [
                1,
                [
                    11,
                    " is not a valid ",
                    [
                        2,
                        0,
                        [
                            11,
                            " digit",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "character %C is not a valid %s digit"
    ], cst_an = "an", cst_nfinity = "nfinity", cst_x = "x", _l_ = [
        0,
        [
            11,
            "bad character decimal encoding \\",
            [
                0,
                [
                    0,
                    [
                        0,
                        0
                    ]
                ]
            ]
        ],
        "bad character decimal encoding \\%c%c%c"
    ], _m_ = [
        0,
        [
            11,
            "bad character hexadecimal encoding \\",
            [
                0,
                [
                    0,
                    0
                ]
            ]
        ],
        "bad character hexadecimal encoding \\%c%c"
    ], _n_ = [
        0,
        [
            11,
            "the character ",
            [
                1,
                [
                    11,
                    " cannot start a boolean",
                    0
                ]
            ]
        ],
        "the character %C cannot start a boolean"
    ], _o_ = [
        0,
        [
            11,
            "scanf: bad input at char number ",
            [
                4,
                3,
                0,
                0,
                [
                    11,
                    ": ",
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "scanf: bad input at char number %i: %s"
    ], _p_ = [
        0,
        37,
        ""
    ], _q_ = [
        0,
        123
    ], _r_ = [
        0,
        91
    ], cst_end_of_input_not_found = "end of input not found", cst_scanf_bad_conversion_a = 'scanf: bad conversion "%a"', cst_scanf_bad_conversion_t = 'scanf: bad conversion "%t"', cst_scanf_missing_reader = "scanf: missing reader", _s_ = [
        0,
        cst_scanf_ml,
        1414,
        13
    ], cst_scanf_bad_conversion_custo = 'scanf: bad conversion "%?" (custom converter)', cst_scanf_bad_conversion = cst_scanf_bad_conversion$3, cst_scanf_bad_conversion$0 = cst_scanf_bad_conversion$3, cst_scanf_bad_conversion$1 = 'scanf: bad conversion "%-"', cst_scanf_bad_conversion$2 = cst_scanf_bad_conversion$3, cst_in_format = ' in format "', _t_ = [
        0,
        [
            3,
            0,
            [
                10,
                0
            ]
        ],
        "%S%!"
    ];
    function bad_input(s) {
        throw caml_maybe_attach_backtrace([
            0,
            Scan_failure,
            s
        ], 1);
    }
    function bad_input_escape(c) {
        return bad_input(caml_call2(Stdlib_Printf[4], _d_, c));
    }
    function bad_token_length(message) {
        return bad_input(caml_call2(Stdlib_Printf[4], _e_, message));
    }
    function bad_hex_float(param) {
        return bad_input(cst_not_a_valid_float_in_hexad);
    }
    function character_mismatch(c, ci) {
        return bad_input(caml_call3(Stdlib_Printf[4], _g_, c, ci));
    }
    function check_char(ib, c$0) {
        if (10 === c$0) {
            var ci = checked_peek_char(ib);
            return 10 === ci ? invalidate_current_char(ib) : 13 === ci ? (invalidate_current_char(ib), check_this_char(ib, 10)) : character_mismatch(10, ci);
        }
        if (32 !== c$0) return check_this_char(ib, c$0);
        for(;;){
            var c = peek_char(ib), _aS_ = 1 - ib[1];
            if (!_aS_) return _aS_;
            var _aT_ = c - 9 | 0;
            a: {
                if (4 < _aT_ >>> 0) {
                    if (23 === _aT_) break a;
                } else if (1 < _aT_ - 2 >>> 0) break a;
                return 0;
            }
            invalidate_current_char(ib);
        }
    }
    function check_this_char(ib, c) {
        var ci = checked_peek_char(ib);
        return ci === c ? invalidate_current_char(ib) : character_mismatch(c, ci);
    }
    function token_char(ib) {
        return caml_string_get(token_string(ib), 0);
    }
    function token_bool(ib) {
        var s = token_string(ib);
        return s !== "false" ? s !== "true" ? bad_input(caml_call2(Stdlib_Printf[4], _h_, s)) : 1 : 0;
    }
    function integer_conversion_of_char(param) {
        var switcher = param - 88 | 0;
        if (32 >= switcher >>> 0) switch(switcher){
            case 10:
                return 0;
            case 12:
                return 1;
            case 17:
                return 2;
            case 23:
                return 3;
            case 29:
                return 4;
            case 0:
            case 32:
                return 5;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _i_
        ], 1);
    }
    function token_int_literal(conv, ib) {
        switch(conv){
            case 0:
                var _aO_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0b, _aO_);
                break;
            case 3:
                var _aP_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0o, _aP_);
                break;
            case 4:
                var _aQ_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0u, _aQ_);
                break;
            case 5:
                var _aR_ = token_string(ib), tok = caml_call2(Stdlib[28], cst_0x, _aR_);
                break;
            default:
                var tok = token_string(ib);
        }
        var l = caml_ml_string_length(tok);
        if (0 !== l && 43 === caml_string_get(tok, 0)) return caml_call3(Stdlib_String[16], tok, 1, l - 1 | 0);
        return tok;
    }
    function token_float(ib) {
        return runtime.caml_float_of_string(token_string(ib));
    }
    function scan_decimal_digit_star(width, ib) {
        var width$0 = width;
        for(;;){
            if (0 === width$0) return width$0;
            var c = peek_char(ib);
            if (ib[1]) return width$0;
            if (58 <= c) {
                if (95 === c) {
                    var width$1 = ignore_char(width$0, ib);
                    width$0 = width$1;
                    continue;
                }
            } else if (48 <= c) {
                var width$2 = store_char(width$0, ib, c);
                width$0 = width$2;
                continue;
            }
            return width$0;
        }
    }
    function scan_decimal_digit_plus(width, ib) {
        if (0 === width) return bad_token_length(cst_decimal_digits);
        var c = checked_peek_char(ib);
        if (9 < c - 48 >>> 0) return bad_input(caml_call2(Stdlib_Printf[4], _j_, c));
        var width$0 = store_char(width, ib, c);
        return scan_decimal_digit_star(width$0, ib);
    }
    function scan_digit_plus(basis, digitp, width$2, ib) {
        if (0 === width$2) return bad_token_length(cst_digits);
        var c$0 = checked_peek_char(ib);
        if (!caml_call1(digitp, c$0)) return bad_input(caml_call3(Stdlib_Printf[4], _k_, c$0, basis));
        var width$3 = store_char(width$2, ib, c$0), width = width$3;
        for(;;){
            if (0 === width) return width;
            var c = peek_char(ib);
            if (ib[1]) return width;
            if (caml_call1(digitp, c)) {
                var width$0 = store_char(width, ib, c);
                width = width$0;
            } else {
                if (95 !== c) return width;
                var width$1 = ignore_char(width, ib);
                width = width$1;
            }
        }
    }
    function is_binary_digit(param) {
        return 1 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_octal_digit(param) {
        return 7 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_hexa_digit(param) {
        var _aN_ = param - 48 | 0;
        a: {
            if (22 < _aN_ >>> 0) {
                if (5 < _aN_ - 49 >>> 0) break a;
            } else if (6 >= _aN_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function scan_sign(width, ib) {
        var c = checked_peek_char(ib), switcher = c - 43 | 0;
        if (2 >= switcher >>> 0) switch(switcher){
            case 0:
                return store_char(width, ib, c);
            case 1:
                break;
            default:
                return store_char(width, ib, c);
        }
        return width;
    }
    function scan_optionally_signed_decimal(width, ib) {
        var width$0 = scan_sign(width, ib);
        return scan_decimal_digit_plus(width$0, ib);
    }
    function scan_int_conversion(conv, width$1, ib) {
        switch(conv){
            case 0:
                return scan_digit_plus(cst_binary, is_binary_digit, width$1, ib);
            case 1:
                return scan_optionally_signed_decimal(width$1, ib);
            case 2:
                var width$0 = scan_sign(width$1, ib), c = checked_peek_char(ib);
                if (48 !== c) return scan_decimal_digit_plus(width$0, ib);
                var width = store_char(width$0, ib, c);
                if (0 === width) return width;
                var c$0 = peek_char(ib);
                if (ib[1]) return width;
                a: {
                    if (99 <= c$0) {
                        if (111 === c$0) return scan_digit_plus(cst_octal, is_octal_digit, store_char(width, ib, c$0), ib);
                        if (120 === c$0) break a;
                    } else {
                        if (88 === c$0) break a;
                        if (98 <= c$0) return scan_digit_plus(cst_binary, is_binary_digit, store_char(width, ib, c$0), ib);
                    }
                    return scan_decimal_digit_star(width, ib);
                }
                return scan_digit_plus(cst_hexadecimal, is_hexa_digit, store_char(width, ib, c$0), ib);
            case 3:
                return scan_digit_plus(cst_octal, is_octal_digit, width$1, ib);
            case 4:
                return scan_decimal_digit_plus(width$1, ib);
            default:
                return scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$1, ib);
        }
    }
    function scan_fractional_part(width, ib) {
        if (0 === width) return width;
        var c = peek_char(ib);
        return ib[1] ? width : 9 < c - 48 >>> 0 ? width : scan_decimal_digit_star(store_char(width, ib, c), ib);
    }
    function scan_exponent_part(width, ib) {
        if (0 === width) return width;
        var c = peek_char(ib);
        if (ib[1]) return width;
        if (69 !== c && 101 !== c) return width;
        return scan_optionally_signed_decimal(store_char(width, ib, c), ib);
    }
    function scan_float(width$1, precision, ib) {
        var width = scan_sign(width$1, ib), width$0 = scan_decimal_digit_star(width, ib);
        if (0 === width$0) return [
            0,
            width$0,
            precision
        ];
        var c = peek_char(ib);
        if (ib[1]) return [
            0,
            width$0,
            precision
        ];
        if (46 !== c) return [
            0,
            scan_exponent_part(width$0, ib),
            precision
        ];
        var width$2 = store_char(width$0, ib, c), precision$0 = caml_call2(Stdlib_Int[10], width$2, precision), width$3 = width$2 - (precision$0 - scan_fractional_part(precision$0, ib) | 0) | 0;
        return [
            0,
            scan_exponent_part(width$3, ib),
            precision$0
        ];
    }
    function check_case_insensitive_string(width, ib, error, str) {
        function lowercase(c) {
            return 25 < c - 65 >>> 0 ? c : caml_call1(Stdlib[29], (c - 65 | 0) + 97 | 0);
        }
        var len = caml_ml_string_length(str), width$0 = [
            0,
            width
        ], _aK_ = len - 1 | 0, _aJ_ = 0;
        if (_aK_ >= 0) {
            var i = _aJ_;
            for(;;){
                var c = peek_char(ib), _aL_ = lowercase(caml_string_get(str, i));
                if (lowercase(c) !== _aL_) caml_call1(error, 0);
                if (0 === width$0[1]) caml_call1(error, 0);
                width$0[1] = store_char(width$0[1], ib, c);
                var _aM_ = i + 1 | 0;
                if (_aK_ === i) break;
                i = _aM_;
            }
        }
        return width$0[1];
    }
    function scan_hex_float(width, precision, ib) {
        var _aw_ = 0 === width ? 1 : 0, _ax_ = _aw_ || end_of_input(ib);
        if (_ax_) bad_input(cst_not_a_valid_float_in_hexad);
        var width$0 = scan_sign(width, ib), _ay_ = 0 === width$0 ? 1 : 0, _az_ = _ay_ || end_of_input(ib);
        if (_az_) bad_input(cst_not_a_valid_float_in_hexad);
        var c = peek_char(ib);
        a: {
            if (78 <= c) {
                var switcher = c - 79 | 0;
                if (30 < switcher >>> 0) {
                    if (32 <= switcher) break a;
                    var width$1 = store_char(width$0, ib, c), _aA_ = 0 === width$1 ? 1 : 0, _aB_ = _aA_ || end_of_input(ib);
                    if (_aB_) bad_input(cst_not_a_valid_float_in_hexad);
                    return check_case_insensitive_string(width$1, ib, bad_hex_float, cst_an);
                }
                if (26 !== switcher) break a;
            } else {
                if (48 === c) {
                    var width$3 = store_char(width$0, ib, c), _aE_ = 0 === width$3 ? 1 : 0, _aF_ = _aE_ || end_of_input(ib);
                    if (_aF_) bad_input(cst_not_a_valid_float_in_hexad);
                    var width$4 = check_case_insensitive_string(width$3, ib, bad_hex_float, cst_x);
                    if (0 !== width$4 && !end_of_input(ib)) {
                        var _aG_ = peek_char(ib) - 46 | 0;
                        b: {
                            c: {
                                if (34 < _aG_ >>> 0) {
                                    if (66 === _aG_) break c;
                                } else if (32 < _aG_ - 1 >>> 0) break c;
                                var width$5 = scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$4, ib);
                                break b;
                            }
                            var width$5 = width$4;
                        }
                        if (0 !== width$5 && !end_of_input(ib)) {
                            var c$0 = peek_char(ib);
                            if (46 === c$0) {
                                var width$6 = store_char(width$5, ib, c$0);
                                b: {
                                    if (0 !== width$6 && !end_of_input(ib)) {
                                        var match = peek_char(ib);
                                        c: {
                                            if (80 !== match && 112 !== match) {
                                                var precision$0 = caml_call2(Stdlib_Int[10], width$6, precision), width$10 = width$6 - (precision$0 - scan_digit_plus(cst_hexadecimal, is_hexa_digit, precision$0, ib) | 0) | 0;
                                                break c;
                                            }
                                            var width$10 = width$6;
                                        }
                                        var width$7 = width$10;
                                        break b;
                                    }
                                    var width$7 = width$6;
                                }
                                var width$8 = width$7;
                            } else var width$8 = width$5;
                            if (0 !== width$8 && !end_of_input(ib)) {
                                var c$1 = peek_char(ib);
                                if (80 !== c$1 && 112 !== c$1) return width$8;
                                var width$9 = store_char(width$8, ib, c$1), _aH_ = 0 === width$9 ? 1 : 0, _aI_ = _aH_ || end_of_input(ib);
                                if (_aI_) bad_input(cst_not_a_valid_float_in_hexad);
                                return scan_optionally_signed_decimal(width$9, ib);
                            }
                            return width$8;
                        }
                        return width$5;
                    }
                    return width$4;
                }
                if (73 !== c) break a;
            }
            var width$2 = store_char(width$0, ib, c), _aC_ = 0 === width$2 ? 1 : 0, _aD_ = _aC_ || end_of_input(ib);
            if (_aD_) bad_input(cst_not_a_valid_float_in_hexad);
            return check_case_insensitive_string(width$2, ib, bad_hex_float, cst_nfinity);
        }
        return bad_input(cst_not_a_valid_float_in_hexad);
    }
    function scan_caml_float_rest(width, precision, ib) {
        var _as_ = 0 === width ? 1 : 0, _at_ = _as_ || end_of_input(ib);
        if (_at_) bad_input(cst_no_dot_or_exponent_part_fo);
        var width$0 = scan_decimal_digit_star(width, ib), _au_ = 0 === width$0 ? 1 : 0, _av_ = _au_ || end_of_input(ib);
        if (_av_) bad_input(cst_no_dot_or_exponent_part_fo);
        var c = peek_char(ib), switcher = c - 69 | 0;
        if (32 < switcher >>> 0) {
            if (-23 === switcher) {
                var width$1 = store_char(width$0, ib, c), precision$0 = caml_call2(Stdlib_Int[10], width$1, precision), width_precision = scan_fractional_part(precision$0, ib), frac_width = precision$0 - width_precision | 0, width$2 = width$1 - frac_width | 0;
                return scan_exponent_part(width$2, ib);
            }
        } else if (30 < switcher - 1 >>> 0) return scan_exponent_part(width$0, ib);
        return bad_input(cst_no_dot_or_exponent_part_fo);
    }
    function scan_caml_float(width, precision, ib) {
        var _ae_ = 0 === width ? 1 : 0, _af_ = _ae_ || end_of_input(ib);
        if (_af_) bad_input(cst_no_dot_or_exponent_part_fo);
        var width$0 = scan_sign(width, ib), _ag_ = 0 === width$0 ? 1 : 0, _ah_ = _ag_ || end_of_input(ib);
        if (_ah_) bad_input(cst_no_dot_or_exponent_part_fo);
        var c = peek_char(ib);
        if (49 <= c) {
            if (58 > c) {
                var width$1 = store_char(width$0, ib, c), _ai_ = 0 === width$1 ? 1 : 0, _aj_ = _ai_ || end_of_input(ib);
                if (_aj_) bad_input(cst_no_dot_or_exponent_part_fo);
                return scan_caml_float_rest(width$1, precision, ib);
            }
        } else if (48 <= c) {
            var width$2 = store_char(width$0, ib, c), _ak_ = 0 === width$2 ? 1 : 0, _al_ = _ak_ || end_of_input(ib);
            if (_al_) bad_input(cst_no_dot_or_exponent_part_fo);
            var c$0 = peek_char(ib);
            if (88 !== c$0 && 120 !== c$0) return scan_caml_float_rest(width$2, precision, ib);
            var width$3 = store_char(width$2, ib, c$0), _am_ = 0 === width$3 ? 1 : 0, _an_ = _am_ || end_of_input(ib);
            if (_an_) bad_input(cst_no_dot_or_exponent_part_fo);
            var width$10 = scan_digit_plus(cst_hexadecimal, is_hexa_digit, width$3, ib), _ao_ = 0 === width$10 ? 1 : 0, _ap_ = _ao_ || end_of_input(ib);
            if (_ap_) bad_input(cst_no_dot_or_exponent_part_fo);
            var c$1 = peek_char(ib), switcher = c$1 - 80 | 0;
            a: {
                b: {
                    if (32 < switcher >>> 0) {
                        if (-34 === switcher) {
                            var width$4 = store_char(width$10, ib, c$1);
                            c: {
                                if (0 !== width$4 && !end_of_input(ib)) {
                                    var match = peek_char(ib);
                                    d: {
                                        if (80 !== match && 112 !== match) {
                                            var precision$0 = caml_call2(Stdlib_Int[10], width$4, precision), width$9 = width$4 - (precision$0 - scan_digit_plus(cst_hexadecimal, is_hexa_digit, precision$0, ib) | 0) | 0;
                                            break d;
                                        }
                                        var width$9 = width$4;
                                    }
                                    var width$5 = width$9;
                                    break c;
                                }
                                var width$5 = width$4;
                            }
                            var width$6 = width$5;
                            break b;
                        }
                    } else if (30 < switcher - 1 >>> 0) {
                        var width$6 = width$10;
                        break b;
                    }
                    var width$7 = bad_input(cst_no_dot_or_exponent_part_fo);
                    break a;
                }
                var width$7 = width$6;
            }
            if (0 !== width$7 && !end_of_input(ib)) {
                var c$2 = peek_char(ib);
                if (80 !== c$2 && 112 !== c$2) return width$7;
                var width$8 = store_char(width$7, ib, c$2), _aq_ = 0 === width$8 ? 1 : 0, _ar_ = _aq_ || end_of_input(ib);
                if (_ar_) bad_input(cst_not_a_valid_float_in_hexad);
                return scan_optionally_signed_decimal(width$8, ib);
            }
            return width$7;
        }
        return bad_input(cst_no_dot_or_exponent_part_fo);
    }
    function scan_string(stp, width, ib) {
        var width$0 = width;
        for(;;){
            if (0 === width$0) return width$0;
            var c = peek_char(ib);
            if (ib[1]) return width$0;
            if (!stp) {
                var _ad_ = c - 9 | 0;
                a: {
                    if (4 < _ad_ >>> 0) {
                        if (23 === _ad_) break a;
                    } else if (1 < _ad_ - 2 >>> 0) break a;
                    var width$2 = store_char(width$0, ib, c);
                    width$0 = width$2;
                    continue;
                }
                return width$0;
            }
            var c$0 = stp[1];
            if (c === c$0) {
                invalidate_current_char(ib);
                return width$0;
            }
            var width$1 = store_char(width$0, ib, c);
            width$0 = width$1;
        }
    }
    function hexadecimal_value_of_char(c) {
        return 97 <= c ? c - 87 | 0 : 65 <= c ? c - 55 | 0 : c - 48 | 0;
    }
    function check_next_char(message, width, ib) {
        if (0 === width) return bad_token_length(message);
        var c = peek_char(ib);
        return ib[1] ? bad_input(caml_call2(Stdlib_Printf[4], _f_, message)) : c;
    }
    function scan_backslash_char(width, ib) {
        var c0 = check_next_char(cst_a_Char, width, ib);
        a: {
            if (40 <= c0) {
                if (58 > c0) {
                    if (48 > c0) break a;
                    var get_digit$0 = function(param) {
                        var c = next_char(ib);
                        return 9 < c - 48 >>> 0 ? bad_input_escape(c) : c;
                    }, c1$0 = get_digit$0(0), c2$0 = get_digit$0(0), c = ((100 * (c0 - 48 | 0) | 0) + (10 * (c1$0 - 48 | 0) | 0) | 0) + (c2$0 - 48 | 0) | 0;
                    b: {
                        if (0 <= c && 255 >= c) {
                            var _ab_ = caml_call1(Stdlib[29], c);
                            break b;
                        }
                        var _ab_ = bad_input(caml_call4(Stdlib_Printf[4], _l_, c0, c1$0, c2$0));
                    }
                    return store_char(width - 2 | 0, ib, _ab_);
                }
                var switcher = c0 - 92 | 0;
                if (28 < switcher >>> 0) break a;
                switch(switcher){
                    case 28:
                        var get_digit = function(param) {
                            var c = next_char(ib), _ac_ = c - 48 | 0;
                            a: {
                                if (22 < _ac_ >>> 0) {
                                    if (5 < _ac_ - 49 >>> 0) break a;
                                } else if (6 >= _ac_ - 10 >>> 0) break a;
                                return c;
                            }
                            return bad_input_escape(c);
                        }, c1 = get_digit(0), c2 = get_digit(0), ___ = hexadecimal_value_of_char(c2), c$0 = (16 * hexadecimal_value_of_char(c1) | 0) + ___ | 0;
                        b: {
                            if (0 <= c$0 && 255 >= c$0) {
                                var _aa_ = caml_call1(Stdlib[29], c$0);
                                break b;
                            }
                            var _aa_ = bad_input(caml_call3(Stdlib_Printf[4], _m_, c1, c2));
                        }
                        return store_char(width - 2 | 0, ib, _aa_);
                    case 0:
                    case 6:
                    case 18:
                    case 22:
                    case 24:
                        break;
                    default:
                        break a;
                }
            } else if (34 !== c0 && 39 > c0) break a;
            b: {
                if (110 <= c0) {
                    if (117 > c0) switch(c0 - 110 | 0){
                        case 0:
                            var _$_ = 10;
                            break b;
                        case 4:
                            var _$_ = 13;
                            break b;
                        case 6:
                            var _$_ = 9;
                            break b;
                    }
                } else if (98 === c0) {
                    var _$_ = 8;
                    break b;
                }
                var _$_ = c0;
            }
            return store_char(width, ib, _$_);
        }
        return bad_input_escape(c0);
    }
    function scan_caml_string(width, ib) {
        function find_stop$0(counter, width) {
            var width$0 = width;
            for(;;){
                var c = check_next_char(cst_a_String, width$0, ib);
                if (34 === c) return ignore_char(width$0, ib);
                if (92 === c) {
                    var width$1 = ignore_char(width$0, ib), match = check_next_char(cst_a_String, width$1, ib);
                    if (10 === match) {
                        var _Y_ = ignore_char(width$1, ib);
                        if (counter >= 50) return caml_trampoline_return(skip_spaces, [
                            0,
                            _Y_
                        ]);
                        var counter$0 = counter + 1 | 0;
                        return skip_spaces(counter$0, _Y_);
                    }
                    if (13 === match) {
                        var width$3 = ignore_char(width$1, ib);
                        if (10 === check_next_char(cst_a_String, width$3, ib)) {
                            var _Z_ = ignore_char(width$3, ib);
                            if (counter >= 50) return caml_trampoline_return(skip_spaces, [
                                0,
                                _Z_
                            ]);
                            var counter$1 = counter + 1 | 0;
                            return skip_spaces(counter$1, _Z_);
                        }
                        var width$5 = store_char(width$3, ib, 13);
                        width$0 = width$5;
                    } else {
                        var width$4 = scan_backslash_char(width$1, ib);
                        width$0 = width$4;
                    }
                } else {
                    var width$2 = store_char(width$0, ib, c);
                    width$0 = width$2;
                }
            }
        }
        function find_stop(width) {
            return caml_trampoline(find_stop$0(0, width));
        }
        function skip_spaces(counter, width) {
            var width$0 = width;
            for(;;){
                if (32 !== check_next_char(cst_a_String, width$0, ib)) {
                    if (counter >= 50) return caml_trampoline_return(find_stop$0, [
                        0,
                        width$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return find_stop$0(counter$0, width$0);
                }
                var width$1 = ignore_char(width$0, ib);
                width$0 = width$1;
            }
        }
        var c = checked_peek_char(ib);
        return 34 === c ? find_stop(ignore_char(width, ib)) : character_mismatch(34, c);
    }
    function scan_chars_in_char_set(char_set, scan_indic, width, ib) {
        function scan_chars(i, stp) {
            var i$0 = i;
            for(;;){
                var c = peek_char(ib), _U_ = 0 < i$0 ? 1 : 0;
                if (_U_) {
                    var _V_ = 1 - ib[1];
                    if (_V_) var _W_ = caml_call2(CamlinternalFormat[1], char_set, c), _X_ = _W_ ? c !== stp ? 1 : 0 : _W_;
                    else var _X_ = _V_;
                } else var _X_ = _U_;
                if (!_X_) return _X_;
                store_char(Stdlib[19], ib, c);
                var i$1 = i$0 - 1 | 0;
                i$0 = i$1;
            }
        }
        if (!scan_indic) return scan_chars(width, -1);
        var c = scan_indic[1];
        scan_chars(width, c);
        var _T_1 = 1 - ib[1];
        if (!_T_1) return _T_1;
        var ci = peek_char(ib);
        return c === ci ? invalidate_current_char(ib) : character_mismatch(c, ci);
    }
    function scanf_bad_input(ib, x) {
        if (x[1] === Scan_failure) var s = x[2];
        else {
            if (x[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(x, 1);
            var s = x[2];
        }
        var i = char_count(ib);
        return bad_input(caml_call3(Stdlib_Printf[4], _o_, i, s));
    }
    function width_of_pad_opt(pad_opt) {
        if (!pad_opt) return Stdlib[19];
        var width = pad_opt[1];
        return width;
    }
    function stopper_of_formatting_lit(fmting) {
        if (6 === fmting) return _p_;
        var str = caml_call1(CamlinternalFormat[17], fmting), stp = caml_string_get(str, 1), sub_str = caml_call3(Stdlib_String[16], str, 2, caml_ml_string_length(str) - 2 | 0);
        return [
            0,
            stp,
            sub_str
        ];
    }
    function take_format_readers$0(counter, k, fmt) {
        var fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return caml_call1(k, 0);
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    fmt$0 = rest;
                    break;
                case 1:
                    var rest$0 = fmt$0[1];
                    fmt$0 = rest$0;
                    break;
                case 2:
                    var rest$1 = fmt$0[2];
                    fmt$0 = rest$1;
                    break;
                case 3:
                    var rest$2 = fmt$0[2];
                    fmt$0 = rest$2;
                    break;
                case 4:
                    var rest$3 = fmt$0[4];
                    fmt$0 = rest$3;
                    break;
                case 5:
                    var rest$4 = fmt$0[4];
                    fmt$0 = rest$4;
                    break;
                case 6:
                    var rest$5 = fmt$0[4];
                    fmt$0 = rest$5;
                    break;
                case 7:
                    var rest$6 = fmt$0[4];
                    fmt$0 = rest$6;
                    break;
                case 8:
                    var rest$7 = fmt$0[4];
                    fmt$0 = rest$7;
                    break;
                case 9:
                    var rest$8 = fmt$0[2];
                    fmt$0 = rest$8;
                    break;
                case 10:
                    var rest$9 = fmt$0[1];
                    fmt$0 = rest$9;
                    break;
                case 11:
                    var rest$10 = fmt$0[2];
                    fmt$0 = rest$10;
                    break;
                case 12:
                    var rest$11 = fmt$0[2];
                    fmt$0 = rest$11;
                    break;
                case 13:
                    var rest$12 = fmt$0[3];
                    fmt$0 = rest$12;
                    break;
                case 14:
                    var rest$13 = fmt$0[3], fmtty = fmt$0[2], _Q_ = caml_call1(CamlinternalFormat[21], fmtty), _R_ = caml_call1(CamlinternalFormatBasics[2], _Q_);
                    if (counter >= 50) return caml_trampoline_return(take_fmtty_format_readers$0, [
                        0,
                        k,
                        _R_,
                        rest$13
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return take_fmtty_format_readers$0(counter$0, k, _R_, rest$13);
                case 15:
                    var rest$14 = fmt$0[1];
                    fmt$0 = rest$14;
                    break;
                case 16:
                    var rest$15 = fmt$0[1];
                    fmt$0 = rest$15;
                    break;
                case 17:
                    var rest$16 = fmt$0[2];
                    fmt$0 = rest$16;
                    break;
                case 18:
                    var _S_ = fmt$0[1];
                    if (0 === _S_[0]) {
                        var rest$17 = fmt$0[2], fmt$1 = _S_[1][1], fmt$2 = caml_call2(CamlinternalFormatBasics[3], fmt$1, rest$17);
                        fmt$0 = fmt$2;
                    } else {
                        var rest$18 = fmt$0[2], fmt$3 = _S_[1][1], fmt$4 = caml_call2(CamlinternalFormatBasics[3], fmt$3, rest$18);
                        fmt$0 = fmt$4;
                    }
                    break;
                case 19:
                    var fmt_rest = fmt$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_format_readers(new_k, fmt_rest);
                    };
                case 20:
                    var rest$19 = fmt$0[3];
                    fmt$0 = rest$19;
                    break;
                case 21:
                    var rest$20 = fmt$0[2];
                    fmt$0 = rest$20;
                    break;
                case 22:
                    var rest$21 = fmt$0[1];
                    fmt$0 = rest$21;
                    break;
                case 23:
                    var rest$22 = fmt$0[2], ign = fmt$0[1];
                    if (typeof ign === "number") switch(ign){
                        case 0:
                            fmt$0 = rest$22;
                            break;
                        case 1:
                            fmt$0 = rest$22;
                            break;
                        case 2:
                            return function(reader) {
                                function new_k(readers_rest) {
                                    return caml_call1(k, [
                                        0,
                                        reader,
                                        readers_rest
                                    ]);
                                }
                                return take_format_readers(new_k, rest$22);
                            };
                        default:
                            fmt$0 = rest$22;
                    }
                    else switch(ign[0]){
                        case 0:
                            fmt$0 = rest$22;
                            break;
                        case 1:
                            fmt$0 = rest$22;
                            break;
                        case 2:
                            fmt$0 = rest$22;
                            break;
                        case 3:
                            fmt$0 = rest$22;
                            break;
                        case 4:
                            fmt$0 = rest$22;
                            break;
                        case 5:
                            fmt$0 = rest$22;
                            break;
                        case 6:
                            fmt$0 = rest$22;
                            break;
                        case 7:
                            fmt$0 = rest$22;
                            break;
                        case 8:
                            fmt$0 = rest$22;
                            break;
                        case 9:
                            var fmtty$0 = ign[2];
                            if (counter >= 50) return caml_trampoline_return(take_fmtty_format_readers$0, [
                                0,
                                k,
                                fmtty$0,
                                rest$22
                            ]);
                            var counter$1 = counter + 1 | 0;
                            return take_fmtty_format_readers$0(counter$1, k, fmtty$0, rest$22);
                        case 10:
                            fmt$0 = rest$22;
                            break;
                        default:
                            fmt$0 = rest$22;
                    }
                    break;
                default:
                    var rest$23 = fmt$0[3];
                    fmt$0 = rest$23;
            }
        }
    }
    function take_format_readers(k, fmt) {
        return caml_trampoline(take_format_readers$0(0, k, fmt));
    }
    function take_fmtty_format_readers$0(counter, k, fmtty, fmt) {
        var fmtty$0 = fmtty;
        for(;;){
            if (typeof fmtty$0 === "number") {
                if (counter >= 50) return caml_trampoline_return(take_format_readers$0, [
                    0,
                    k,
                    fmt
                ]);
                var counter$0 = counter + 1 | 0;
                return take_format_readers$0(counter$0, k, fmt);
            }
            switch(fmtty$0[0]){
                case 0:
                    var fmtty$1 = fmtty$0[1];
                    fmtty$0 = fmtty$1;
                    break;
                case 1:
                    var fmtty$2 = fmtty$0[1];
                    fmtty$0 = fmtty$2;
                    break;
                case 2:
                    var fmtty$3 = fmtty$0[1];
                    fmtty$0 = fmtty$3;
                    break;
                case 3:
                    var fmtty$4 = fmtty$0[1];
                    fmtty$0 = fmtty$4;
                    break;
                case 4:
                    var fmtty$5 = fmtty$0[1];
                    fmtty$0 = fmtty$5;
                    break;
                case 5:
                    var fmtty$6 = fmtty$0[1];
                    fmtty$0 = fmtty$6;
                    break;
                case 6:
                    var fmtty$7 = fmtty$0[1];
                    fmtty$0 = fmtty$7;
                    break;
                case 7:
                    var fmtty$8 = fmtty$0[1];
                    fmtty$0 = fmtty$8;
                    break;
                case 8:
                    var fmtty$9 = fmtty$0[2];
                    fmtty$0 = fmtty$9;
                    break;
                case 9:
                    var rest = fmtty$0[3], ty2 = fmtty$0[2], ty1 = fmtty$0[1], _P_ = caml_call1(CamlinternalFormat[21], ty1), ty = caml_call2(CamlinternalFormat[22], _P_, ty2), fmtty$10 = caml_call2(CamlinternalFormatBasics[1], ty, rest);
                    fmtty$0 = fmtty$10;
                    break;
                case 10:
                    var fmtty$11 = fmtty$0[1];
                    fmtty$0 = fmtty$11;
                    break;
                case 11:
                    var fmtty$12 = fmtty$0[1];
                    fmtty$0 = fmtty$12;
                    break;
                case 12:
                    var fmtty$13 = fmtty$0[1];
                    fmtty$0 = fmtty$13;
                    break;
                case 13:
                    var fmt_rest = fmtty$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_fmtty_format_readers(new_k, fmt_rest, fmt);
                    };
                default:
                    var fmt_rest$0 = fmtty$0[1];
                    return function(reader) {
                        function new_k(readers_rest) {
                            return caml_call1(k, [
                                0,
                                reader,
                                readers_rest
                            ]);
                        }
                        return take_fmtty_format_readers(new_k, fmt_rest$0, fmt);
                    };
            }
        }
    }
    function take_fmtty_format_readers(k, fmtty, fmt) {
        return caml_trampoline(take_fmtty_format_readers$0(0, k, fmtty, fmt));
    }
    function make_scanf(ib, fmt, readers) {
        var fmt$0 = fmt;
        for(;;){
            if (typeof fmt$0 === "number") return 0;
            switch(fmt$0[0]){
                case 0:
                    var rest = fmt$0[1];
                    store_char(0, ib, checked_peek_char(ib));
                    var c$0 = token_char(ib);
                    return [
                        0,
                        c$0,
                        make_scanf(ib, rest, readers)
                    ];
                case 1:
                    var rest$0 = fmt$0[1], find_stop = function(width) {
                        var c = check_next_char(cst_a_Char, width, ib);
                        return 39 === c ? ignore_char(width, ib) : character_mismatch(39, c);
                    }, c = checked_peek_char(ib), width$0 = 0;
                    if (39 === c) {
                        var width = ignore_char(width$0, ib), c$3 = check_next_char(cst_a_Char, width, ib);
                        if (92 === c$3) find_stop(scan_backslash_char(ignore_char(width, ib), ib));
                        else find_stop(store_char(width, ib, c$3));
                    } else character_mismatch(39, c);
                    var c$1 = token_char(ib);
                    return [
                        0,
                        c$1,
                        make_scanf(ib, rest$0, readers)
                    ];
                case 2:
                    var pad = fmt$0[1], match = fmt$0[2];
                    if (typeof match !== "number") switch(match[0]){
                        case 17:
                            var rest$2 = match[2], fmting_lit = match[1], match$0 = stopper_of_formatting_lit(fmting_lit), str = match$0[2], stp = match$0[1], scan$0 = function(width, param, ib) {
                                return scan_string([
                                    0,
                                    stp
                                ], width, ib);
                            }, str_rest = [
                                11,
                                str,
                                rest$2
                            ];
                            return pad_prec_scanf(ib, str_rest, readers, pad, 0, scan$0, token_string);
                        case 18:
                            var _D_ = match[1];
                            if (0 === _D_[0]) {
                                var rest$3 = match[2], fmt$1 = _D_[1][1], scan$1 = function(width, param, ib) {
                                    return scan_string(_q_, width, ib);
                                };
                                return pad_prec_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$1, rest$3), readers, pad, 0, scan$1, token_string);
                            }
                            var rest$4 = match[2], fmt$2 = _D_[1][1], scan$2 = function(width, param, ib) {
                                return scan_string(_r_, width, ib);
                            };
                            return pad_prec_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$2, rest$4), readers, pad, 0, scan$2, token_string);
                    }
                    var rest$1 = fmt$0[2], scan = function(width, param, ib) {
                        return scan_string(0, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$1, readers, pad, 0, scan, token_string);
                case 3:
                    var rest$5 = fmt$0[2], pad$0 = fmt$0[1], scan$3 = function(width, param, ib) {
                        return scan_caml_string(width, ib);
                    };
                    return pad_prec_scanf(ib, rest$5, readers, pad$0, 0, scan$3, token_string);
                case 4:
                    var rest$6 = fmt$0[4], prec = fmt$0[3], pad$1 = fmt$0[2], iconv = fmt$0[1], conv = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv)), scan$4 = function(width, param, ib) {
                        return scan_int_conversion(conv, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$6, readers, pad$1, prec, scan$4, function(ib) {
                        return caml_int_of_string(token_int_literal(conv, ib));
                    });
                case 5:
                    var rest$7 = fmt$0[4], prec$0 = fmt$0[3], pad$2 = fmt$0[2], iconv$0 = fmt$0[1], conv$0 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$0)), scan$5 = function(width, param, ib) {
                        return scan_int_conversion(conv$0, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$7, readers, pad$2, prec$0, scan$5, function(ib) {
                        return caml_int_of_string(token_int_literal(conv$0, ib));
                    });
                case 6:
                    var rest$8 = fmt$0[4], prec$1 = fmt$0[3], pad$3 = fmt$0[2], iconv$1 = fmt$0[1], conv$1 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$1)), scan$6 = function(width, param, ib) {
                        return scan_int_conversion(conv$1, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$8, readers, pad$3, prec$1, scan$6, function(ib) {
                        return caml_int_of_string(token_int_literal(conv$1, ib));
                    });
                case 7:
                    var rest$9 = fmt$0[4], prec$2 = fmt$0[3], pad$4 = fmt$0[2], iconv$2 = fmt$0[1], conv$2 = integer_conversion_of_char(caml_call1(CamlinternalFormat[16], iconv$2)), scan$7 = function(width, param, ib) {
                        return scan_int_conversion(conv$2, width, ib);
                    };
                    return pad_prec_scanf(ib, rest$9, readers, pad$4, prec$2, scan$7, function(ib) {
                        return runtime.caml_int64_of_string(token_int_literal(conv$2, ib));
                    });
                case 8:
                    switch(fmt$0[1][2]){
                        case 5:
                        case 8:
                            var rest$11 = fmt$0[4], prec$4 = fmt$0[3], pad$6 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$11, readers, pad$6, prec$4, scan_caml_float, token_float);
                        case 6:
                        case 7:
                            var rest$12 = fmt$0[4], prec$5 = fmt$0[3], pad$7 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$12, readers, pad$7, prec$5, scan_hex_float, token_float);
                        default:
                            var rest$10 = fmt$0[4], prec$3 = fmt$0[3], pad$5 = fmt$0[2];
                            return pad_prec_scanf(ib, rest$10, readers, pad$5, prec$3, scan_float, token_float);
                    }
                case 9:
                    var rest$13 = fmt$0[2], pad$8 = fmt$0[1], scan$8 = function(_O_, param, ib) {
                        var c = checked_peek_char(ib), m = 102 === c ? 5 : 116 === c ? 4 : bad_input(caml_call2(Stdlib_Printf[4], _n_, c));
                        return scan_string(0, m, ib);
                    };
                    return pad_prec_scanf(ib, rest$13, readers, pad$8, 0, scan$8, token_bool);
                case 10:
                    var rest$14 = fmt$0[1];
                    if (!end_of_input(ib)) return bad_input(cst_end_of_input_not_found);
                    fmt$0 = rest$14;
                    break;
                case 11:
                    var rest$15 = fmt$0[2], str$0 = fmt$0[1];
                    caml_call2(Stdlib_String[30], function(_N_) {
                        return check_char(ib, _N_);
                    }, str$0);
                    fmt$0 = rest$15;
                    break;
                case 12:
                    var rest$16 = fmt$0[2], chr = fmt$0[1];
                    check_char(ib, chr);
                    fmt$0 = rest$16;
                    break;
                case 13:
                    var rest$17 = fmt$0[3], fmtty = fmt$0[2], pad_opt = fmt$0[1];
                    scan_caml_string(width_of_pad_opt(pad_opt), ib);
                    var s = token_string(ib);
                    try {
                        var _E_ = caml_call2(CamlinternalFormat[14], s, fmtty), fmt$3 = _E_;
                    } catch (exn$0) {
                        var exn = caml_wrap_exception(exn$0);
                        if (exn[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn, 0);
                        var msg = exn[2], fmt$3 = bad_input(msg);
                    }
                    return [
                        0,
                        fmt$3,
                        make_scanf(ib, rest$17, readers)
                    ];
                case 14:
                    var rest$18 = fmt$0[3], fmtty$0 = fmt$0[2], pad_opt$0 = fmt$0[1];
                    scan_caml_string(width_of_pad_opt(pad_opt$0), ib);
                    var s$0 = token_string(ib);
                    try {
                        var fmt$6 = caml_call2(CamlinternalFormat[13], 0, s$0)[1], fmt$7 = caml_call2(CamlinternalFormat[13], 0, s$0)[1], _G_ = caml_call1(CamlinternalFormat[21], fmtty$0), _H_ = caml_call1(CamlinternalFormatBasics[2], _G_), fmt$8 = caml_call2(CamlinternalFormat[12], fmt$7, _H_), _I_ = caml_call1(CamlinternalFormatBasics[2], fmtty$0), _J_ = caml_call2(CamlinternalFormat[12], fmt$6, _I_), fmt$5 = fmt$8, fmt$4 = _J_;
                    } catch (exn) {
                        var exn$0 = caml_wrap_exception(exn);
                        if (exn$0[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn$0, 0);
                        var msg$0 = exn$0[2], _F_ = bad_input(msg$0), fmt$5 = _F_[2], fmt$4 = _F_[1];
                    }
                    return [
                        0,
                        [
                            0,
                            fmt$4,
                            s$0
                        ],
                        make_scanf(ib, caml_call2(CamlinternalFormatBasics[3], fmt$5, rest$18), readers)
                    ];
                case 15:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_a);
                case 16:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_t);
                case 17:
                    var rest$19 = fmt$0[2], formatting_lit = fmt$0[1], _K_ = caml_call1(CamlinternalFormat[17], formatting_lit);
                    caml_call2(Stdlib_String[30], function(_M_) {
                        return check_char(ib, _M_);
                    }, _K_);
                    fmt$0 = rest$19;
                    break;
                case 18:
                    var _L_ = fmt$0[1];
                    if (0 === _L_[0]) {
                        var rest$20 = fmt$0[2], fmt$9 = _L_[1][1];
                        check_char(ib, 64);
                        check_char(ib, 123);
                        var fmt$10 = caml_call2(CamlinternalFormatBasics[3], fmt$9, rest$20);
                        fmt$0 = fmt$10;
                    } else {
                        var rest$21 = fmt$0[2], fmt$11 = _L_[1][1];
                        check_char(ib, 64);
                        check_char(ib, 91);
                        var fmt$12 = caml_call2(CamlinternalFormatBasics[3], fmt$11, rest$21);
                        fmt$0 = fmt$12;
                    }
                    break;
                case 19:
                    var fmt_rest = fmt$0[1];
                    if (!readers) return caml_call1(Stdlib[1], cst_scanf_missing_reader);
                    var readers_rest = readers[2], reader = readers[1], x = caml_call1(reader, ib);
                    return [
                        0,
                        x,
                        make_scanf(ib, fmt_rest, readers_rest)
                    ];
                case 20:
                    var width_opt = fmt$0[1], match$1 = fmt$0[3];
                    if (typeof match$1 !== "number" && 17 === match$1[0]) {
                        var rest$23 = match$1[2], fmting_lit$0 = match$1[1], char_set$0 = fmt$0[2], match$2 = stopper_of_formatting_lit(fmting_lit$0), str$1 = match$2[2], stp$0 = match$2[1], width$2 = width_of_pad_opt(width_opt);
                        scan_chars_in_char_set(char_set$0, [
                            0,
                            stp$0
                        ], width$2, ib);
                        var s$2 = token_string(ib), str_rest$0 = [
                            11,
                            str$1,
                            rest$23
                        ];
                        return [
                            0,
                            s$2,
                            make_scanf(ib, str_rest$0, readers)
                        ];
                    }
                    var rest$22 = fmt$0[3], char_set = fmt$0[2], width$1 = width_of_pad_opt(width_opt);
                    scan_chars_in_char_set(char_set, 0, width$1, ib);
                    var s$1 = token_string(ib);
                    return [
                        0,
                        s$1,
                        make_scanf(ib, rest$22, readers)
                    ];
                case 21:
                    var rest$24 = fmt$0[2], counter = fmt$0[1];
                    switch(counter){
                        case 0:
                            var count = ib[5];
                            break;
                        case 1:
                            var count = char_count(ib);
                            break;
                        default:
                            var count = ib[6];
                    }
                    return [
                        0,
                        count,
                        make_scanf(ib, rest$24, readers)
                    ];
                case 22:
                    var rest$25 = fmt$0[1], c$2 = checked_peek_char(ib);
                    return [
                        0,
                        c$2,
                        make_scanf(ib, rest$25, readers)
                    ];
                case 23:
                    var rest$26 = fmt$0[2], ign = fmt$0[1], fmt$13 = caml_call2(CamlinternalFormat[6], ign, rest$26)[1], match$3 = make_scanf(ib, fmt$13, readers);
                    if (!match$3) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _s_
                    ], 1);
                    var arg_rest = match$3[2];
                    return arg_rest;
                default:
                    return caml_call1(Stdlib[1], cst_scanf_bad_conversion_custo);
            }
        }
    }
    function pad_prec_scanf(ib, fmt, readers, pad, prec, scan, token) {
        if (typeof pad === "number") {
            if (typeof prec !== "number") {
                var p = prec[1];
                caml_call3(scan, Stdlib[19], p, ib);
                var x$0 = caml_call1(token, ib);
                return [
                    0,
                    x$0,
                    make_scanf(ib, fmt, readers)
                ];
            }
            if (prec) return caml_call1(Stdlib[1], cst_scanf_bad_conversion);
            caml_call3(scan, Stdlib[19], Stdlib[19], ib);
            var x = caml_call1(token, ib);
            return [
                0,
                x,
                make_scanf(ib, fmt, readers)
            ];
        }
        if (0 !== pad[0]) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$2);
        if (!pad[1]) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$1);
        var w = pad[2];
        if (typeof prec !== "number") {
            var p$0 = prec[1];
            caml_call3(scan, w, p$0, ib);
            var x$2 = caml_call1(token, ib);
            return [
                0,
                x$2,
                make_scanf(ib, fmt, readers)
            ];
        }
        if (prec) return caml_call1(Stdlib[1], cst_scanf_bad_conversion$0);
        caml_call3(scan, w, Stdlib[19], ib);
        var x$1 = caml_call1(token, ib);
        return [
            0,
            x$1,
            make_scanf(ib, fmt, readers)
        ];
    }
    function kscanf_gen(ib, ef, af, param) {
        var str = param[2], fmt = param[1];
        function k(readers, f$1) {
            caml_call1(Stdlib_Buffer[9], ib[8]);
            try {
                var args$1 = make_scanf(ib, fmt, readers);
            } catch (exc$0) {
                var exc = caml_wrap_exception(exc$0);
                if (exc[1] !== Scan_failure && exc[1] !== Stdlib[7] && exc !== Stdlib[12]) {
                    if (exc[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(exc, 0);
                    var msg = exc[2], _z_ = caml_call1(Stdlib_String[25], str), _A_ = caml_call2(Stdlib[28], _z_, cst$0), _B_ = caml_call2(Stdlib[28], cst_in_format, _A_), _C_ = caml_call2(Stdlib[28], msg, _B_);
                    return caml_call1(Stdlib[1], _C_);
                }
                return caml_call2(ef, ib, exc);
            }
            var f = f$1, args = args$1;
            for(;;){
                if (!args) return caml_call1(af, f);
                var args$0 = args[2], x = args[1], f$0 = caml_call1(f, x);
                f = f$0;
                args = args$0;
            }
        }
        return take_format_readers(k, fmt);
    }
    function kscanf(ib, ef, fmt) {
        return kscanf_gen(ib, ef, function(x) {
            return x;
        }, fmt);
    }
    function kscanf_opt(ib, fmt) {
        return kscanf_gen(ib, function(_y_, param) {
            return 0;
        }, function(x) {
            return [
                0,
                x
            ];
        }, fmt);
    }
    function bscanf(ib, fmt) {
        return kscanf(ib, scanf_bad_input, fmt);
    }
    function bscanf_opt(ib, fmt) {
        return kscanf_opt(ib, fmt);
    }
    function ksscanf(s, ef, fmt) {
        return kscanf(from_string(s), ef, fmt);
    }
    function sscanf(s, fmt) {
        return kscanf(from_string(s), scanf_bad_input, fmt);
    }
    function sscanf_opt(s, fmt) {
        return kscanf_opt(from_string(s), fmt);
    }
    function scanf(fmt) {
        return kscanf(stdin, scanf_bad_input, fmt);
    }
    function scanf_opt(fmt) {
        return kscanf_opt(stdin, fmt);
    }
    function bscanf_format(ib, format, f) {
        scan_caml_string(Stdlib[19], ib);
        var str = token_string(ib);
        try {
            var _x_ = caml_call2(CamlinternalFormat[15], str, format), fmt = _x_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg = exn[2], fmt = bad_input(msg);
        }
        return caml_call1(f, fmt);
    }
    function sscanf_format(s, format, f) {
        return bscanf_format(from_string(s), format, f);
    }
    function format_from_string(s, fmt) {
        var _v_ = caml_call1(Stdlib_String[25], s), _w_ = caml_call2(Stdlib[28], _v_, cst$1);
        return sscanf_format(caml_call2(Stdlib[28], cst$2, _w_), fmt, function(x) {
            return x;
        });
    }
    function unescaped(s) {
        var _u_ = caml_call2(Stdlib[28], s, cst$3);
        return caml_call1(sscanf(caml_call2(Stdlib[28], cst$4, _u_), _t_), function(x) {
            return x;
        });
    }
    var Stdlib_Scanf = [
        0,
        [
            0,
            stdin,
            open_in,
            open_in_bin,
            close_in,
            open_in,
            open_in_bin,
            from_string,
            from_function,
            from_channel,
            end_of_input,
            beginning_of_input,
            name_of_input
        ],
        Scan_failure,
        bscanf,
        bscanf_opt,
        sscanf,
        sscanf_opt,
        scanf,
        scanf_opt,
        kscanf,
        ksscanf,
        bscanf_format,
        sscanf_format,
        format_from_string,
        unescaped
    ];
    runtime.caml_register_global(64, Stdlib_Scanf, "Stdlib__Scanf");
    return;
})(globalThis);
//# 24183 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_register_named_value = runtime.caml_register_named_value, global_data = runtime.caml_get_global_data(), Stdlib_Obj = global_data.Stdlib__Obj, register = caml_register_named_value;
    function register_exception(name, exn) {
        var _a_ = Stdlib_Obj[10], slot = runtime.caml_obj_tag(exn) === _a_ ? exn : exn[1];
        return caml_register_named_value(name, slot);
    }
    var Stdlib_Callback = [
        0,
        register,
        register_exception
    ];
    runtime.caml_register_global(1, Stdlib_Callback, "Stdlib__Callback");
    return;
})(globalThis);
//# 24206 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_camlinternalOO_ml = "camlinternalOO.ml", caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_div = runtime.caml_div, caml_get_public_method = runtime.caml_get_public_method, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_block = runtime.caml_obj_block, caml_set_oo_id = runtime.caml_set_oo_id, caml_string_compare = runtime.caml_string_compare, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Stdlib_Map = global_data.Stdlib__Map;
    function copy(o) {
        var o$0 = o.slice();
        return caml_set_oo_id(o$0);
    }
    var params = [
        0,
        1,
        1,
        1,
        3,
        16
    ];
    function public_method_label(s) {
        var accu = [
            0,
            0
        ], _al_ = runtime.caml_ml_string_length(s) - 1 | 0, _ak_ = 0;
        if (_al_ >= 0) {
            var i = _ak_;
            for(;;){
                var _am_ = runtime.caml_string_get(s, i);
                accu[1] = (223 * accu[1] | 0) + _am_ | 0;
                var _an_ = i + 1 | 0;
                if (_al_ === i) break;
                i = _an_;
            }
        }
        accu[1] = accu[1] & 2147483647;
        var tag = 1073741823 < accu[1] ? accu[1] + 2147483648 | 0 : accu[1];
        return tag;
    }
    var compare = caml_string_compare, Vars = caml_call1(Stdlib_Map[1], [
        0,
        compare
    ]), compare$0 = caml_string_compare, Meths = caml_call1(Stdlib_Map[1], [
        0,
        compare$0
    ]), compare$1 = runtime.caml_int_compare, Labs = caml_call1(Stdlib_Map[1], [
        0,
        compare$1
    ]), dummy_table = [
        0,
        0,
        [
            0,
            0
        ],
        Meths[1],
        Labs[1],
        0,
        0,
        Vars[1],
        0
    ], table_count = [
        0,
        0
    ], dummy_met = caml_obj_block(0, 0), initial_object_size = 2;
    function fit_size(n) {
        return 2 < n ? fit_size((n + 1 | 0) / 2 | 0) * 2 | 0 : n;
    }
    function new_table(pub_labels) {
        table_count[1]++;
        var len = pub_labels.length - 1, methods = caml_array_make((len * 2 | 0) + 2 | 0, dummy_met);
        caml_check_bound(methods, 0)[1] = len;
        var _ad_ = Stdlib_Sys[9], _ae_ = (runtime.caml_mul(fit_size(len), _ad_) / 8 | 0) - 1 | 0;
        caml_check_bound(methods, 1)[2] = _ae_;
        var _ag_ = len - 1 | 0, _af_ = 0;
        if (_ag_ >= 0) {
            var i = _af_;
            for(;;){
                var _ai_ = (i * 2 | 0) + 3 | 0, _ah_ = caml_check_bound(pub_labels, i)[1 + i];
                caml_check_bound(methods, _ai_)[1 + _ai_] = _ah_;
                var _aj_ = i + 1 | 0;
                if (_ag_ === i) break;
                i = _aj_;
            }
        }
        return [
            0,
            initial_object_size,
            methods,
            Meths[1],
            Labs[1],
            0,
            0,
            Vars[1],
            0
        ];
    }
    function resize(array, new_size) {
        var old_size = array[2].length - 1, _ab_ = old_size < new_size ? 1 : 0;
        if (_ab_) {
            var new_buck = caml_array_make(new_size, dummy_met);
            caml_call5(Stdlib_Array[9], array[2], 0, new_buck, 0, old_size);
            array[2] = new_buck;
            var _ac_ = 0;
        } else var _ac_ = _ab_;
        return _ac_;
    }
    var method_count = [
        0,
        0
    ], inst_var_count = [
        0,
        0
    ], _a_ = [
        0,
        cst_camlinternalOO_ml,
        279,
        50
    ], _b_ = [
        0,
        cst_camlinternalOO_ml,
        407,
        13
    ], _c_ = [
        0,
        cst_camlinternalOO_ml,
        410,
        13
    ], _d_ = [
        0,
        cst_camlinternalOO_ml,
        413,
        13
    ], _e_ = [
        0,
        cst_camlinternalOO_ml,
        416,
        13
    ], _f_ = [
        0,
        cst_camlinternalOO_ml,
        419,
        13
    ], _g_ = [
        0,
        cst_camlinternalOO_ml,
        437,
        17
    ];
    function new_method(table) {
        var index = table[2].length - 1;
        resize(table, index + 1 | 0);
        return index;
    }
    function get_method_label(table, name) {
        try {
            var _$_ = caml_call2(Meths[17], name, table[3]);
            return _$_;
        } catch (_aa_) {
            var ___ = caml_wrap_exception(_aa_);
            if (___ !== Stdlib[8]) throw caml_maybe_attach_backtrace(___, 0);
            var label = new_method(table);
            table[3] = caml_call3(Meths[2], name, label, table[3]);
            table[4] = caml_call3(Labs[2], label, 1, table[4]);
            return label;
        }
    }
    function get_method_labels(table, names) {
        return caml_call2(Stdlib_Array[14], function(_Z_) {
            return get_method_label(table, _Z_);
        }, names);
    }
    function set_method(table, label, element) {
        method_count[1]++;
        return caml_call2(Labs[17], label, table[4]) ? (resize(table, label + 1 | 0), caml_check_bound(table[2], label)[1 + label] = element, 0) : (table[6] = [
            0,
            [
                0,
                label,
                element
            ],
            table[6]
        ], 0);
    }
    function get_method(table, label) {
        try {
            var _X_ = caml_call2(Stdlib_List[53], label, table[6]);
            return _X_;
        } catch (_Y_) {
            var _W_ = caml_wrap_exception(_Y_);
            if (_W_ === Stdlib[8]) return caml_check_bound(table[2], label)[1 + label];
            throw caml_maybe_attach_backtrace(_W_, 0);
        }
    }
    function to_list(arr) {
        return 0 === arr ? 0 : caml_call1(Stdlib_Array[10], arr);
    }
    function narrow(table, vars, virt_meths, concr_meths) {
        var vars$0 = to_list(vars), virt_meths$0 = to_list(virt_meths), concr_meths$0 = to_list(concr_meths), virt_meth_labs = caml_call2(Stdlib_List[20], function(_V_) {
            return get_method_label(table, _V_);
        }, virt_meths$0), concr_meth_labs = caml_call2(Stdlib_List[20], function(_U_) {
            return get_method_label(table, _U_);
        }, concr_meths$0);
        table[5] = [
            0,
            [
                0,
                table[3],
                table[4],
                table[6],
                table[7],
                virt_meth_labs,
                vars$0
            ],
            table[5]
        ];
        table[7] = caml_call3(Vars[24], function(lab, info, tvars) {
            return caml_call2(Stdlib_List[37], lab, vars$0) ? caml_call3(Vars[2], lab, info, tvars) : tvars;
        }, table[7], Vars[1]);
        var by_name = [
            0,
            Meths[1]
        ], by_label = [
            0,
            Labs[1]
        ];
        caml_call3(Stdlib_List[28], function(met, label) {
            by_name[1] = caml_call3(Meths[2], met, label, by_name[1]);
            var _P_ = by_label[1];
            try {
                var _S_ = caml_call2(Labs[17], label, table[4]), _R_ = _S_;
            } catch (_T_1) {
                var _Q_ = caml_wrap_exception(_T_1);
                if (_Q_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_Q_, 0);
                var _R_ = 1;
            }
            by_label[1] = caml_call3(Labs[2], label, _R_, _P_);
            return 0;
        }, concr_meths$0, concr_meth_labs);
        caml_call3(Stdlib_List[28], function(met, label) {
            by_name[1] = caml_call3(Meths[2], met, label, by_name[1]);
            by_label[1] = caml_call3(Labs[2], label, 0, by_label[1]);
            return 0;
        }, virt_meths$0, virt_meth_labs);
        table[3] = by_name[1];
        table[4] = by_label[1];
        table[6] = caml_call3(Stdlib_List[27], function(met, hm) {
            var lab = met[1];
            return caml_call2(Stdlib_List[37], lab, virt_meth_labs) ? hm : [
                0,
                met,
                hm
            ];
        }, table[6], 0);
        return 0;
    }
    function widen(table) {
        var match = caml_call1(Stdlib_List[6], table[5]), vars = match[6], virt_meths = match[5], saved_vars = match[4], saved_hidden_meths = match[3], by_label = match[2], by_name = match[1];
        table[5] = caml_call1(Stdlib_List[7], table[5]);
        table[7] = caml_call3(Stdlib_List[26], function(s, v) {
            var _O_ = caml_call2(Vars[17], v, table[7]);
            return caml_call3(Vars[2], v, _O_, s);
        }, saved_vars, vars);
        table[3] = by_name;
        table[4] = by_label;
        table[6] = caml_call3(Stdlib_List[27], function(met, hm) {
            var lab = met[1];
            return caml_call2(Stdlib_List[37], lab, virt_meths) ? hm : [
                0,
                met,
                hm
            ];
        }, table[6], saved_hidden_meths);
        return 0;
    }
    function new_variable(table, name) {
        try {
            var _M_ = caml_call2(Vars[17], name, table[7]);
            return _M_;
        } catch (_N_) {
            var _L_ = caml_wrap_exception(_N_);
            if (_L_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_L_, 0);
            var index = table[1];
            table[1] = index + 1 | 0;
            if (name !== "") table[7] = caml_call3(Vars[2], name, index, table[7]);
            return index;
        }
    }
    function to_array(arr) {
        return runtime.caml_equal(arr, 0) ? [
            0
        ] : arr;
    }
    function new_methods_variables(table, meths, vals) {
        var meths$0 = to_array(meths), nmeths = meths$0.length - 1, nvals = vals.length - 1, res = caml_array_make(nmeths + nvals | 0, 0), _D_ = nmeths - 1 | 0, _C_ = 0;
        if (_D_ >= 0) {
            var i$0 = _C_;
            for(;;){
                var _J_ = get_method_label(table, caml_check_bound(meths$0, i$0)[1 + i$0]);
                caml_check_bound(res, i$0)[1 + i$0] = _J_;
                var _K_ = i$0 + 1 | 0;
                if (_D_ === i$0) break;
                i$0 = _K_;
            }
        }
        var _F_ = nvals - 1 | 0, _E_ = 0;
        if (_F_ >= 0) {
            var i = _E_;
            for(;;){
                var _H_ = i + nmeths | 0, _G_ = new_variable(table, caml_check_bound(vals, i)[1 + i]);
                caml_check_bound(res, _H_)[1 + _H_] = _G_;
                var _I_ = i + 1 | 0;
                if (_F_ === i) break;
                i = _I_;
            }
        }
        return res;
    }
    function get_variable(table, name) {
        try {
            var _A_ = caml_call2(Vars[17], name, table[7]);
            return _A_;
        } catch (_B_) {
            var _z_ = caml_wrap_exception(_B_);
            if (_z_ === Stdlib[8]) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _a_
            ], 1);
            throw caml_maybe_attach_backtrace(_z_, 0);
        }
    }
    function get_variables(table, names) {
        return caml_call2(Stdlib_Array[14], function(_y_) {
            return get_variable(table, _y_);
        }, names);
    }
    function add_initializer(table, f) {
        table[8] = [
            0,
            f,
            table[8]
        ];
        return 0;
    }
    function create_table(public_methods) {
        if (0 === public_methods) return new_table([
            0
        ]);
        var tags = caml_call2(Stdlib_Array[14], public_method_label, public_methods), table = new_table(tags);
        caml_call2(Stdlib_Array[13], function(i, met) {
            var lab = (i * 2 | 0) + 2 | 0;
            table[3] = caml_call3(Meths[2], met, lab, table[3]);
            table[4] = caml_call3(Labs[2], lab, 1, table[4]);
            return 0;
        }, public_methods);
        return table;
    }
    function init_class(table) {
        inst_var_count[1] = (inst_var_count[1] + table[1] | 0) - 1 | 0;
        table[8] = caml_call1(Stdlib_List[10], table[8]);
        var _x_ = Stdlib_Sys[9];
        return resize(table, 3 + caml_div(caml_check_bound(table[2], 1)[2] * 16 | 0, _x_) | 0);
    }
    function inherits(cla, vals, virt_meths, concr_meths, param, top) {
        var env = param[3], super$0 = param[2];
        narrow(cla, vals, virt_meths, concr_meths);
        var init = top ? caml_call2(super$0, cla, env) : caml_call1(super$0, cla);
        widen(cla);
        var _s_ = to_array(concr_meths), _t_ = [
            0,
            caml_call2(Stdlib_Array[14], function(nm) {
                return get_method(cla, get_method_label(cla, nm));
            }, _s_),
            0
        ], _u_ = to_array(vals), _v_ = [
            0,
            [
                0,
                init
            ],
            [
                0,
                caml_call2(Stdlib_Array[14], function(_w_) {
                    return get_variable(cla, _w_);
                }, _u_),
                _t_
            ]
        ];
        return caml_call1(Stdlib_Array[5], _v_);
    }
    function make_class(pub_meths, class_init) {
        var table = create_table(pub_meths), env_init = caml_call1(class_init, table);
        init_class(table);
        return [
            0,
            caml_call1(env_init, 0),
            class_init,
            0
        ];
    }
    function make_class_store(pub_meths, class_init, init_table) {
        var table = create_table(pub_meths), env_init = caml_call1(class_init, table);
        init_class(table);
        init_table[2] = class_init;
        init_table[1] = env_init;
        return 0;
    }
    function dummy_class(loc) {
        function undef(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Stdlib[15],
                loc
            ], 1);
        }
        return [
            0,
            undef,
            undef,
            0
        ];
    }
    function create_object(table) {
        var obj = caml_obj_block(Stdlib_Obj[10], table[1]);
        obj[1] = table[2];
        return caml_set_oo_id(obj);
    }
    function create_object_opt(obj_0, table) {
        if (obj_0) return obj_0;
        var obj = caml_obj_block(Stdlib_Obj[10], table[1]);
        obj[1] = table[2];
        return caml_set_oo_id(obj);
    }
    function iter_f(obj, param) {
        var param$0 = param;
        for(;;){
            if (!param$0) return 0;
            var l = param$0[2], f = param$0[1];
            caml_call1(f, obj);
            param$0 = l;
        }
    }
    function run_initializers(obj, table) {
        var inits = table[8], _r_ = 0 !== inits ? 1 : 0;
        return _r_ ? iter_f(obj, inits) : _r_;
    }
    function run_initializers_opt(obj_0, obj, table) {
        if (obj_0) return obj;
        var inits = table[8];
        if (0 !== inits) iter_f(obj, inits);
        return obj;
    }
    function create_object_and_run_initiali(obj_0, table) {
        if (obj_0) return obj_0;
        var obj = create_object(table);
        run_initializers(obj, table);
        return obj;
    }
    function get_data(param) {
        if (param) return param[2];
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function build_path(n, keys, tables) {
        var res = [
            0,
            0,
            0,
            0
        ], r = [
            0,
            res
        ], _o_ = 0;
        if (n >= 0) {
            var i = _o_;
            for(;;){
                var _p_ = r[1];
                r[1] = [
                    0,
                    caml_check_bound(keys, i)[1 + i],
                    _p_,
                    0
                ];
                var _q_ = i + 1 | 0;
                if (n === i) break;
                i = _q_;
            }
        }
        var v = r[1];
        if (!tables) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        tables[2] = v;
        return res;
    }
    function lookup_tables(root, keys) {
        var root_data = get_data(root);
        if (!root_data) return build_path(keys.length - 2 | 0, keys, root);
        var i$1 = keys.length - 2 | 0, i = i$1, tables$0 = root_data;
        for(;;){
            if (0 > i) return tables$0;
            var key = caml_check_bound(keys, i)[1 + i], tables$1 = tables$0;
            for(;;){
                if (!tables$1) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _d_
                ], 1);
                if (tables$1[1] === key) break;
                if (!tables$1) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _f_
                ], 1);
                var tables = tables$1[3];
                if (!tables) {
                    var next = [
                        0,
                        key,
                        0,
                        0
                    ];
                    if (!tables$1) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _c_
                    ], 1);
                    tables$1[3] = next;
                    return build_path(i - 1 | 0, keys, next);
                }
                tables$1 = tables;
            }
            var tables_data = get_data(tables$1);
            if (!tables_data) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _g_
            ], 1);
            var i$0 = i - 1 | 0;
            i = i$0;
            tables$0 = tables_data;
        }
    }
    function new_cache(table) {
        var n = new_method(table);
        a: {
            if (0 !== (n % 2 | 0)) {
                var _n_ = Stdlib_Sys[9];
                if ((2 + caml_div(caml_check_bound(table[2], 1)[2] * 16 | 0, _n_) | 0) >= n) {
                    var n$0 = new_method(table);
                    break a;
                }
            }
            var n$0 = n;
        }
        caml_check_bound(table[2], n$0)[1 + n$0] = 0;
        return n$0;
    }
    function set_methods(table, methods) {
        var len = methods.length - 1, i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= len) return 0;
            var _h_ = i[1], label = caml_check_bound(methods, _h_)[1 + _h_], next = function(param) {
                i[1]++;
                var _m_ = i[1];
                return caml_check_bound(methods, _m_)[1 + _m_];
            }, clo = next(0);
            if (typeof clo === "number") switch(clo){
                case 0:
                    var x = next(0);
                    let x$20 = x;
                    var clo$0 = function(obj) {
                        return x$20;
                    };
                    break;
                case 1:
                    var n = next(0);
                    let n$38 = n;
                    var clo$0 = function(obj) {
                        return obj[1 + n$38];
                    };
                    break;
                case 2:
                    var e = next(0), n$0 = next(0);
                    let e$10 = e, n$37 = n$0;
                    var clo$0 = function(obj) {
                        return obj[1 + e$10][1 + n$37];
                    };
                    break;
                case 3:
                    var n$1 = next(0);
                    let n$36 = n$1;
                    var clo$0 = function(obj) {
                        return caml_call1(obj[1][1 + n$36], obj);
                    };
                    break;
                case 4:
                    var n$2 = next(0);
                    let n$35 = n$2;
                    var clo$0 = function(obj, x) {
                        obj[1 + n$35] = x;
                        return 0;
                    };
                    break;
                case 5:
                    var f = next(0), x$0 = next(0);
                    let f$20 = f, x$19 = x$0;
                    var clo$0 = function(obj) {
                        return caml_call1(f$20, x$19);
                    };
                    break;
                case 6:
                    var f$0 = next(0), n$3 = next(0);
                    let f$19 = f$0, n$34 = n$3;
                    var clo$0 = function(obj) {
                        return caml_call1(f$19, obj[1 + n$34]);
                    };
                    break;
                case 7:
                    var f$1 = next(0), e$0 = next(0), n$4 = next(0);
                    let f$18 = f$1, e$9 = e$0, n$33 = n$4;
                    var clo$0 = function(obj) {
                        return caml_call1(f$18, obj[1 + e$9][1 + n$33]);
                    };
                    break;
                case 8:
                    var f$2 = next(0), n$5 = next(0);
                    let f$17 = f$2, n$32 = n$5;
                    var clo$0 = function(obj) {
                        return caml_call1(f$17, caml_call1(obj[1][1 + n$32], obj));
                    };
                    break;
                case 9:
                    var f$3 = next(0), x$1 = next(0), y = next(0);
                    let f$16 = f$3, x$18 = x$1, y$0 = y;
                    var clo$0 = function(obj) {
                        return caml_call2(f$16, x$18, y$0);
                    };
                    break;
                case 10:
                    var f$4 = next(0), x$2 = next(0), n$6 = next(0);
                    let f$15 = f$4, x$17 = x$2, n$31 = n$6;
                    var clo$0 = function(obj) {
                        return caml_call2(f$15, x$17, obj[1 + n$31]);
                    };
                    break;
                case 11:
                    var f$5 = next(0), x$3 = next(0), e$1 = next(0), n$7 = next(0);
                    let f$14 = f$5, x$16 = x$3, e$8 = e$1, n$30 = n$7;
                    var clo$0 = function(obj) {
                        return caml_call2(f$14, x$16, obj[1 + e$8][1 + n$30]);
                    };
                    break;
                case 12:
                    var f$6 = next(0), x$4 = next(0), n$8 = next(0);
                    let f$13 = f$6, x$15 = x$4, n$29 = n$8;
                    var clo$0 = function(obj) {
                        return caml_call2(f$13, x$15, caml_call1(obj[1][1 + n$29], obj));
                    };
                    break;
                case 13:
                    var f$7 = next(0), n$9 = next(0), x$5 = next(0);
                    let f$12 = f$7, n$28 = n$9, x$14 = x$5;
                    var clo$0 = function(obj) {
                        return caml_call2(f$12, obj[1 + n$28], x$14);
                    };
                    break;
                case 14:
                    var f$8 = next(0), e$2 = next(0), n$10 = next(0), x$6 = next(0);
                    let f$11 = f$8, e$7 = e$2, n$27 = n$10, x$13 = x$6;
                    var clo$0 = function(obj) {
                        return caml_call2(f$11, obj[1 + e$7][1 + n$27], x$13);
                    };
                    break;
                case 15:
                    var f$9 = next(0), n$11 = next(0), x$7 = next(0);
                    let f$10 = f$9, n$26 = n$11, x$12 = x$7;
                    var clo$0 = function(obj) {
                        return caml_call2(f$10, caml_call1(obj[1][1 + n$26], obj), x$12);
                    };
                    break;
                case 16:
                    var n$12 = next(0), x$8 = next(0);
                    let n$25 = n$12, x$11 = x$8;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$25], obj, x$11);
                    };
                    break;
                case 17:
                    var n$13 = next(0), m = next(0);
                    let n$24 = n$13, m$12 = m;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$24], obj, obj[1 + m$12]);
                    };
                    break;
                case 18:
                    var n$14 = next(0), e$3 = next(0), m$0 = next(0);
                    let n$23 = n$14, e$6 = e$3, m$11 = m$0;
                    var clo$0 = function(obj) {
                        return caml_call2(obj[1][1 + n$23], obj, obj[1 + e$6][1 + m$11]);
                    };
                    break;
                case 19:
                    var n$15 = next(0), m$1 = next(0);
                    let n$22 = n$15, m$10 = m$1;
                    var clo$0 = function(obj) {
                        var _l_ = caml_call1(obj[1][1 + m$10], obj);
                        return caml_call2(obj[1][1 + n$22], obj, _l_);
                    };
                    break;
                case 20:
                    var m$2 = next(0), x$9 = next(0);
                    new_cache(table);
                    let m$9 = m$2, x$10 = x$9;
                    var clo$0 = function(obj) {
                        return caml_call1(caml_get_public_method(x$10, m$9, 0), x$10);
                    };
                    break;
                case 21:
                    var m$3 = next(0), n$16 = next(0);
                    new_cache(table);
                    let m$8 = m$3, n$21 = n$16;
                    var clo$0 = function(obj) {
                        var _k_ = obj[1 + n$21];
                        return caml_call1(caml_get_public_method(_k_, m$8, 0), _k_);
                    };
                    break;
                case 22:
                    var m$4 = next(0), e$4 = next(0), n$17 = next(0);
                    new_cache(table);
                    let m$7 = m$4, e$5 = e$4, n$20 = n$17;
                    var clo$0 = function(obj) {
                        var _j_ = obj[1 + e$5][1 + n$20];
                        return caml_call1(caml_get_public_method(_j_, m$7, 0), _j_);
                    };
                    break;
                default:
                    var m$5 = next(0), n$18 = next(0);
                    new_cache(table);
                    let m$6 = m$5, n$19 = n$18;
                    var clo$0 = function(obj) {
                        var _i_ = caml_call1(obj[1][1 + n$19], obj);
                        return caml_call1(caml_get_public_method(_i_, m$6, 0), _i_);
                    };
            }
            else var clo$0 = clo;
            set_method(table, label, clo$0);
            i[1]++;
        }
    }
    function stats(param) {
        return [
            0,
            table_count[1],
            method_count[1],
            inst_var_count[1]
        ];
    }
    var CamlinternalOO = [
        0,
        public_method_label,
        new_method,
        new_variable,
        new_methods_variables,
        get_variable,
        get_variables,
        get_method_label,
        get_method_labels,
        get_method,
        set_method,
        set_methods,
        narrow,
        widen,
        add_initializer,
        dummy_table,
        create_table,
        init_class,
        inherits,
        make_class,
        make_class_store,
        dummy_class,
        copy,
        create_object,
        create_object_opt,
        run_initializers,
        run_initializers_opt,
        create_object_and_run_initiali,
        lookup_tables,
        params,
        stats
    ];
    runtime.caml_register_global(17, CamlinternalOO, "CamlinternalOO");
    return;
})(globalThis);
//# 24993 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_camlinternalMod_ml = "camlinternalMod.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, CamlinternalLazy = global_data.CamlinternalLazy, CamlinternalOO = global_data.CamlinternalOO, Assert_failure = global_data.Assert_failure, cst_CamlinternalMod_init_mod_n = "CamlinternalMod.init_mod: not a module", _a_ = [
        0,
        cst_camlinternalMod_ml,
        72,
        5
    ], _b_ = [
        0,
        cst_camlinternalMod_ml,
        81,
        2
    ], cst_CamlinternalMod_update_mod = "CamlinternalMod.update_mod: not a module";
    function init_mod_block(loc, comps$0) {
        var length = comps$0.length - 1, modu = runtime.caml_obj_block(0, length), _h_ = length - 1 | 0, _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                var shape = caml_check_bound(comps$0, i)[1 + i];
                if (typeof shape === "number") switch(shape){
                    case 0:
                        let i$1 = i;
                        var fn = function(x) {
                            var fn = modu[1 + i$1];
                            if (fn$0 === fn) throw caml_maybe_attach_backtrace([
                                0,
                                Stdlib[15],
                                loc
                            ], 1);
                            return caml_call1(fn, x);
                        };
                        let fn$0 = fn;
                        var init = fn;
                        break;
                    case 1:
                        var l = [];
                        let l$0 = l, i$0 = i;
                        runtime.caml_update_dummy(l, [
                            246,
                            function(param) {
                                var l = modu[1 + i$0];
                                if (l$0 === l) throw caml_maybe_attach_backtrace([
                                    0,
                                    Stdlib[15],
                                    loc
                                ], 1);
                                var _j_ = caml_obj_tag(l);
                                if (250 === _j_) return l[1];
                                if (246 !== _j_ && 244 !== _j_) return l;
                                return caml_call1(CamlinternalLazy[2], l);
                            }
                        ]);
                        var init = l;
                        break;
                    default:
                        var init = caml_call1(CamlinternalOO[21], loc);
                }
                else if (0 === shape[0]) var comps = shape[1], init = init_mod_block(loc, comps);
                else var v = shape[1], init = v;
                modu[1 + i] = init;
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return modu;
    }
    function init_mod(loc, shape) {
        if (typeof shape !== "number" && 0 === shape[0]) {
            var comps = shape[1];
            return init_mod_block(loc, comps);
        }
        return caml_call1(Stdlib[2], cst_CamlinternalMod_init_mod_n);
    }
    function update_mod_block(comps$0, modu, n) {
        if (0 === caml_obj_tag(n) && comps$0.length - 1 <= n.length - 1) {
            var _e_ = comps$0.length - 2 | 0, _d_ = 0;
            if (_e_ >= 0) {
                var i = _d_;
                for(;;){
                    var n$0 = n[1 + i], shape = caml_check_bound(comps$0, i)[1 + i];
                    a: if (typeof shape === "number") {
                        if (2 === shape) {
                            if (0 === caml_obj_tag(n$0) && 3 === n$0.length - 1) {
                                var cl = modu[1 + i], j = 0;
                                for(;;){
                                    cl[1 + j] = n$0[1 + j];
                                    var _c_ = j + 1 | 0;
                                    if (2 === j) break;
                                    j = _c_;
                                }
                                break a;
                            }
                            throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _a_
                            ], 1);
                        }
                        modu[1 + i] = n$0;
                    } else if (0 === shape[0]) {
                        var comps = shape[1];
                        update_mod_block(comps, modu[1 + i], n$0);
                    }
                    var _f_ = i + 1 | 0;
                    if (_e_ === i) break;
                    i = _f_;
                }
            }
            return 0;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function update_mod(shape, o, n) {
        if (typeof shape !== "number" && 0 === shape[0]) {
            var comps = shape[1];
            return update_mod_block(comps, o, n);
        }
        return caml_call1(Stdlib[2], cst_CamlinternalMod_update_mod);
    }
    var CamlinternalMod = [
        0,
        init_mod,
        update_mod
    ];
    runtime.caml_register_global(8, CamlinternalMod, "CamlinternalMod");
    return;
})(globalThis);
//# 26228 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_array_make = runtime.caml_array_make, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), _c_ = [
        0,
        0
    ], _b_ = [
        0,
        0
    ], _a_ = [
        0,
        0
    ], Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Random = global_data.Stdlib__Random;
    function MakeSeeded(H) {
        var prng = [
            246,
            function(_at_) {
                return caml_call1(Stdlib_Random[19][2], 0);
            }
        ];
        function create(opt, initial_size) {
            var random = opt ? opt[1] : caml_call1(Stdlib_Hashtbl[17], 0);
            a: b: {
                var x = 16;
                for(;;){
                    if (initial_size <= x) break b;
                    if (Stdlib_Sys[13] < (x * 2 | 0)) break;
                    var x$0 = x * 2 | 0;
                    x = x$0;
                }
                break a;
            }
            if (random) {
                var _ar_ = runtime.caml_obj_tag(prng);
                a: if (250 === _ar_) var _as_ = prng[1];
                else {
                    if (246 !== _ar_ && 244 !== _ar_) {
                        var _as_ = prng;
                        break a;
                    }
                    var _as_ = caml_call1(CamlinternalLazy[2], prng);
                }
                var seed = caml_call1(Stdlib_Random[19][4], _as_);
            } else var seed = 0;
            return [
                0,
                0,
                caml_array_make(x, 0),
                seed,
                x
            ];
        }
        function clear(h) {
            h[1] = 0;
            var len = h[2].length - 1, _ap_ = len - 1 | 0, _ao_ = 0;
            if (_ap_ >= 0) {
                var i = _ao_;
                for(;;){
                    caml_check_bound(h[2], i)[1 + i] = 0;
                    var _aq_ = i + 1 | 0;
                    if (_ap_ === i) break;
                    i = _aq_;
                }
            }
            return 0;
        }
        function reset(h) {
            var len = h[2].length - 1;
            return len === h[4] ? clear(h) : (h[1] = 0, h[2] = caml_array_make(h[4], 0), 0);
        }
        function copy(h) {
            var _al_ = h[4], _am_ = h[3], _an_ = caml_call1(Stdlib_Array[7], h[2]);
            return [
                0,
                h[1],
                _an_,
                _am_,
                _al_
            ];
        }
        function key_index(h, hkey) {
            return hkey & (h[2].length - 2 | 0);
        }
        function clean(h) {
            function do_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hkey = param$0[1], rest = param$0[3], c = param$0[2];
                    if (caml_call1(H[6], c)) {
                        var rest$0 = param$0[3], c$0 = param$0[2];
                        return [
                            0,
                            hkey,
                            c$0,
                            do_bucket(rest$0)
                        ];
                    }
                    h[1] = h[1] - 1 | 0;
                    param$0 = rest;
                }
            }
            var d = h[2], _aj_ = d.length - 2 | 0, _ai_ = 0;
            if (_aj_ >= 0) {
                var i = _ai_;
                for(;;){
                    d[1 + i] = do_bucket(caml_check_bound(d, i)[1 + i]);
                    var _ak_ = i + 1 | 0;
                    if (_aj_ === i) break;
                    i = _ak_;
                }
            }
            return 0;
        }
        function resize(h) {
            var odata = h[2], osize = odata.length - 1, nsize = osize * 2 | 0;
            clean(h);
            var _ac_ = nsize < Stdlib_Sys[13] ? 1 : 0, _ad_ = _ac_ ? (osize >>> 1 | 0) <= h[1] ? 1 : 0 : _ac_;
            if (_ad_) {
                var ndata = caml_array_make(nsize, 0);
                h[2] = ndata;
                var insert_bucket = function(param) {
                    if (!param) return;
                    var rest = param[3], data = param[2], hkey = param[1];
                    insert_bucket(rest);
                    var nidx = key_index(h, hkey);
                    ndata[1 + nidx] = [
                        0,
                        hkey,
                        data,
                        caml_check_bound(ndata, nidx)[1 + nidx]
                    ];
                }, _af_ = osize - 1 | 0, _ae_ = 0;
                if (_af_ >= 0) {
                    var i = _ae_;
                    for(;;){
                        insert_bucket(caml_check_bound(odata, i)[1 + i]);
                        var _ah_ = i + 1 | 0;
                        if (_af_ === i) break;
                        i = _ah_;
                    }
                }
                var _ag_ = 0;
            } else var _ag_ = _ad_;
            return _ag_;
        }
        function add(h, key, info) {
            var hkey = caml_call2(H[2], h[3], key), i = key_index(h, hkey), container = caml_call2(H[1], key, info), bucket = [
                0,
                hkey,
                container,
                caml_check_bound(h[2], i)[1 + i]
            ];
            caml_check_bound(h[2], i)[1 + i] = bucket;
            h[1] = h[1] + 1 | 0;
            var _ab_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
            return _ab_ ? resize(h) : _ab_;
        }
        function remove(h, key) {
            var hkey = caml_call2(H[2], h[3], key);
            function remove_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hk = param$0[1], next = param$0[3], c = param$0[2];
                    if (hkey !== hk) {
                        var next$0 = param$0[3], c$0 = param$0[2];
                        return [
                            0,
                            hk,
                            c$0,
                            remove_bucket(next$0)
                        ];
                    }
                    switch(caml_call2(H[3], c, key)){
                        case 0:
                            h[1] = h[1] - 1 | 0;
                            return next;
                        case 1:
                            return [
                                0,
                                hk,
                                c,
                                remove_bucket(next)
                            ];
                        default:
                            h[1] = h[1] - 1 | 0;
                            param$0 = next;
                    }
                }
            }
            var i = key_index(h, hkey), _aa_ = remove_bucket(caml_check_bound(h[2], i)[1 + i]);
            caml_check_bound(h[2], i)[1 + i] = _aa_;
            return 0;
        }
        function find(h, key) {
            var hkey = caml_call2(H[2], h[3], key), _$_ = key_index(h, hkey), param = caml_check_bound(h[2], _$_)[1 + _$_];
            for(;;){
                if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                var hk = param[1], rest = param[3], c = param[2];
                if (hkey === hk) switch(caml_call2(H[3], c, key)){
                    case 0:
                        var match = caml_call1(H[4], c);
                        if (match) {
                            var d = match[1];
                            return d;
                        }
                        param = rest;
                        break;
                    case 1:
                        param = rest;
                        break;
                    default:
                        param = rest;
                }
                else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function find_opt(h, key) {
            var hkey = caml_call2(H[2], h[3], key), ___ = key_index(h, hkey), param = caml_check_bound(h[2], ___)[1 + ___];
            for(;;){
                if (!param) return 0;
                var hk = param[1], rest = param[3], c = param[2];
                if (hkey === hk) switch(caml_call2(H[3], c, key)){
                    case 0:
                        var d = caml_call1(H[4], c);
                        if (d) return d;
                        param = rest;
                        break;
                    case 1:
                        param = rest;
                        break;
                    default:
                        param = rest;
                }
                else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function find_all(h, key) {
            var hkey = caml_call2(H[2], h[3], key);
            function find_in_bucket(param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) return 0;
                    var hk = param$0[1], rest = param$0[3], c = param$0[2];
                    if (hkey === hk) switch(caml_call2(H[3], c, key)){
                        case 0:
                            var match = caml_call1(H[4], c);
                            if (match) {
                                var d = match[1];
                                return [
                                    0,
                                    d,
                                    find_in_bucket(rest)
                                ];
                            }
                            param$0 = rest;
                            break;
                        case 1:
                            param$0 = rest;
                            break;
                        default:
                            param$0 = rest;
                    }
                    else {
                        var rest$0 = param$0[3];
                        param$0 = rest$0;
                    }
                }
            }
            var _Z_ = key_index(h, hkey);
            return find_in_bucket(caml_check_bound(h[2], _Z_)[1 + _Z_]);
        }
        function replace(h, key, info) {
            var hkey = caml_call2(H[2], h[3], key), i = key_index(h, hkey), l = caml_check_bound(h[2], i)[1 + i];
            try {
                var param = l;
                for(;;){
                    if (!param) throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                    var hk = param[1], next = param[3], c = param[2];
                    if (hkey === hk) {
                        if (!caml_call2(H[3], c, key)) {
                            var _V_ = caml_call3(H[5], c, key, info);
                            return _V_;
                        }
                        param = next;
                    } else {
                        var next$0 = param[3];
                        param = next$0;
                    }
                }
            } catch (_Y_) {
                var _W_ = caml_wrap_exception(_Y_);
                if (_W_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_W_, 0);
                var container = caml_call2(H[1], key, info);
                caml_check_bound(h[2], i)[1 + i] = [
                    0,
                    hkey,
                    container,
                    l
                ];
                h[1] = h[1] + 1 | 0;
                var _X_ = h[2].length - 1 << 1 < h[1] ? 1 : 0;
                return _X_ ? resize(h) : _X_;
            }
        }
        function mem(h, key) {
            var hkey = caml_call2(H[2], h[3], key), _U_ = key_index(h, hkey), param = caml_check_bound(h[2], _U_)[1 + _U_];
            for(;;){
                if (!param) return 0;
                var hk = param[1], rest = param[3], c = param[2];
                if (hk === hkey) {
                    if (!caml_call2(H[3], c, key)) return 1;
                    param = rest;
                } else {
                    var rest$0 = param[3];
                    param = rest$0;
                }
            }
        }
        function length(h) {
            return h[1];
        }
        function bucket_length(accu, param) {
            var accu$0 = accu, param$0 = param;
            for(;;){
                if (!param$0) return accu$0;
                var rest = param$0[3], accu$1 = accu$0 + 1 | 0;
                accu$0 = accu$1;
                param$0 = rest;
            }
        }
        function stats(h) {
            var mbl = caml_call3(Stdlib_Array[18], function(m, b) {
                var _T_1 = bucket_length(0, b);
                return caml_call2(Stdlib_Int[11], m, _T_1);
            }, 0, h[2]), histo = caml_array_make(mbl + 1 | 0, 0);
            caml_call2(Stdlib_Array[12], function(b) {
                var l = bucket_length(0, b);
                histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
                return 0;
            }, h[2]);
            return [
                0,
                h[1],
                h[2].length - 1,
                mbl,
                histo
            ];
        }
        function bucket_length_alive(accu, param) {
            var accu$0 = accu, param$0 = param;
            for(;;){
                if (!param$0) return accu$0;
                var rest = param$0[3], c = param$0[2];
                if (caml_call1(H[6], c)) {
                    var accu$1 = accu$0 + 1 | 0;
                    accu$0 = accu$1;
                    param$0 = rest;
                } else {
                    var rest$0 = param$0[3];
                    param$0 = rest$0;
                }
            }
        }
        function stats_alive(h) {
            var size = [
                0,
                0
            ], mbl = caml_call3(Stdlib_Array[18], function(m, b) {
                var _S_ = bucket_length_alive(0, b);
                return caml_call2(Stdlib_Int[11], m, _S_);
            }, 0, h[2]), histo = caml_array_make(mbl + 1 | 0, 0);
            caml_call2(Stdlib_Array[12], function(b) {
                var l = bucket_length_alive(0, b);
                size[1] = size[1] + l | 0;
                histo[1 + l] = caml_check_bound(histo, l)[1 + l] + 1 | 0;
                return 0;
            }, h[2]);
            return [
                0,
                size[1],
                h[2].length - 1,
                mbl,
                histo
            ];
        }
        function add_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return add(tbl, k, v);
            }, i);
        }
        function replace_seq(tbl, i) {
            return caml_call2(Stdlib_Seq[4], function(param) {
                var v = param[2], k = param[1];
                return replace(tbl, k, v);
            }, i);
        }
        function of_seq(i) {
            var tbl = create(0, 16);
            replace_seq(tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function create(param) {
        return caml_call1(Stdlib_Obj[23][1], 1);
    }
    function get_key(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 0);
        return x;
    }
    function set_key(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 0, k);
    }
    function check_key(t) {
        return caml_call2(Stdlib_Obj[23][7], t, 0);
    }
    function get_data(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make(key, data) {
        var eph = create(0);
        set_data(eph, data);
        set_key(eph, key);
        return eph;
    }
    function query(eph, key) {
        var match = get_key(eph);
        if (!match) return 0;
        var k = match[1];
        return k === key ? get_data(eph) : 0;
    }
    function MakeSeeded$0(H) {
        function create$0(k, d) {
            var c = create(0);
            set_data(c, d);
            set_key(c, k);
            return c;
        }
        var seeded_hash = H[2];
        function equal(c, k) {
            var match = get_key(c);
            if (!match) return 2;
            var k$0 = match[1];
            return caml_call2(H[1], k, k$0) ? 0 : 1;
        }
        function set_key_data(c, k, d) {
            caml_call1(Stdlib_Obj[23][12], c);
            set_key(c, k);
            return set_data(c, d);
        }
        return MakeSeeded([
            0,
            create$0,
            seeded_hash,
            equal,
            get_data,
            set_key_data,
            check_key
        ]);
    }
    function Make(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded$0([
            0,
            equal,
            seeded_hash
        ]), _R_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_R_, _a_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_R_, _a_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$0(param) {
        return [
            0,
            0
        ];
    }
    function add(b, k, d) {
        var _Q_ = b[1];
        b[1] = [
            0,
            make(k, d),
            _Q_
        ];
        return 0;
    }
    function test_key(k, e) {
        var match = get_key(e);
        if (match) {
            var x = match[1];
            if (x === k) return 1;
        }
        return 0;
    }
    function remove(b, k) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_key(k, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find(b, k) {
        var match = caml_call2(Stdlib_List[40], function(_P_) {
            return test_key(k, _P_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data(e);
    }
    function length(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear(b) {
        b[1] = 0;
        return 0;
    }
    function create$0(param) {
        return caml_call1(Stdlib_Obj[23][1], 2);
    }
    function get_key1(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 0);
        return x;
    }
    function set_key1(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 0, k);
    }
    function get_key2(t) {
        var x = caml_call2(Stdlib_Obj[23][3], t, 1);
        return x;
    }
    function set_key2(t, k) {
        return caml_call3(Stdlib_Obj[23][5], t, 1, k);
    }
    function get_data$0(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data$0(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make$1(key1, key2, data) {
        var eph = create$0(0);
        set_data$0(eph, data);
        set_key1(eph, key1);
        set_key2(eph, key2);
        return eph;
    }
    function query$0(eph, key1, key2) {
        var match = get_key1(eph);
        if (!match) return 0;
        var k = match[1];
        if (k !== key1) return 0;
        var match$0 = get_key2(eph);
        if (!match$0) return 0;
        var k$0 = match$0[1];
        return k$0 === key2 ? get_data$0(eph) : 0;
    }
    function MakeSeeded$1(H1, H2) {
        function create(param, d) {
            var k2 = param[2], k1 = param[1], c = create$0(0);
            set_data$0(c, d);
            set_key1(c, k1);
            set_key2(c, k2);
            return c;
        }
        function seeded_hash(seed, param) {
            var k2 = param[2], k1 = param[1], _O_ = caml_call2(H2[2], seed, k2) * 65599 | 0;
            return caml_call2(H1[2], seed, k1) + _O_ | 0;
        }
        function equal(c, param) {
            var k2 = param[2], k1 = param[1], match = get_key1(c), match$0 = get_key2(c);
            if (match && match$0) {
                var k2$0 = match$0[1], k1$0 = match[1];
                if (caml_call2(H1[1], k1, k1$0) && caml_call2(H2[1], k2, k2$0)) return 0;
                return 1;
            }
            return 2;
        }
        function set_key_data(c, param, d) {
            var k2 = param[2], k1 = param[1];
            caml_call1(Stdlib_Obj[23][12], c);
            set_key1(c, k1);
            set_key2(c, k2);
            return set_data$0(c, d);
        }
        function check_key(c) {
            var _N_ = caml_call2(Stdlib_Obj[23][7], c, 0);
            return _N_ ? caml_call2(Stdlib_Obj[23][7], c, 1) : _N_;
        }
        return MakeSeeded([
            0,
            create,
            seeded_hash,
            equal,
            get_data$0,
            set_key_data,
            check_key
        ]);
    }
    function Make$0(H1, H2) {
        var equal = H2[1];
        function seeded_hash(seed, x) {
            return caml_call1(H2[2], x);
        }
        var equal$0 = H1[1];
        function seeded_hash$0(seed, x) {
            return caml_call1(H1[2], x);
        }
        var include = MakeSeeded$1([
            0,
            equal$0,
            seeded_hash$0
        ], [
            0,
            equal,
            seeded_hash
        ]), _M_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_M_, _b_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_M_, _b_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$2(param) {
        return [
            0,
            0
        ];
    }
    function add$0(b, k1, k2, d) {
        var _L_ = b[1];
        b[1] = [
            0,
            make$1(k1, k2, d),
            _L_
        ];
        return 0;
    }
    function test_keys(k1, k2, e) {
        var match = get_key1(e), match$0 = get_key2(e);
        if (match && match$0) {
            var x2 = match$0[1], x1 = match[1];
            if (x1 === k1 && x2 === k2) return 1;
        }
        return 0;
    }
    function remove$0(b, k1, k2) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_keys(k1, k2, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find$0(b, k1, k2) {
        var match = caml_call2(Stdlib_List[40], function(_K_) {
            return test_keys(k1, k2, _K_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data$0(e);
    }
    function length$0(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear$0(b) {
        b[1] = 0;
        return 0;
    }
    function create$1(n) {
        return caml_call1(Stdlib_Obj[23][1], n);
    }
    function length$1(k) {
        return caml_call1(Stdlib_Obj[23][2], k);
    }
    function get_key$0(t, n) {
        var x = caml_call2(Stdlib_Obj[23][3], t, n);
        return x;
    }
    function set_key$0(t, n, k) {
        return caml_call3(Stdlib_Obj[23][5], t, n, k);
    }
    function get_data$1(t) {
        var x = caml_call1(Stdlib_Obj[23][9], t);
        return x;
    }
    function set_data$1(t, d) {
        return caml_call2(Stdlib_Obj[23][11], t, d);
    }
    function make$3(keys, data) {
        var l = keys.length - 1, eph = create$1(l);
        set_data$1(eph, data);
        var _I_ = l - 1 | 0, _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                set_key$0(eph, i, caml_check_bound(keys, i)[1 + i]);
                var _J_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _J_;
            }
        }
        return eph;
    }
    function query$1(eph, keys) {
        var l = length$1(eph);
        try {
            if (l !== keys.length - 1) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
            var _D_ = l - 1 | 0, _C_ = 0;
            if (_D_ >= 0) {
                var i = _C_;
                for(;;){
                    var match = get_key$0(eph, i);
                    if (!match) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                    var k = match[1];
                    if (k !== caml_check_bound(keys, i)[1 + i]) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                    var _F_ = i + 1 | 0;
                    if (_D_ === i) break;
                    i = _F_;
                }
            }
            var _E_ = get_data$1(eph);
            return _E_;
        } catch (_G_) {
            var _B_ = caml_wrap_exception(_G_);
            if (_B_ === Stdlib[3]) return 0;
            throw caml_maybe_attach_backtrace(_B_, 0);
        }
    }
    function MakeSeeded$2(H) {
        function create(k, d) {
            var c = create$1(k.length - 1);
            set_data$1(c, d);
            var _z_ = k.length - 2 | 0, _y_ = 0;
            if (_z_ >= 0) {
                var i = _y_;
                for(;;){
                    set_key$0(c, i, caml_check_bound(k, i)[1 + i]);
                    var _A_ = i + 1 | 0;
                    if (_z_ === i) break;
                    i = _A_;
                }
            }
            return c;
        }
        function seeded_hash(seed, k) {
            var h = [
                0,
                0
            ], _u_ = k.length - 2 | 0, _t_ = 0;
            if (_u_ >= 0) {
                var i = _t_;
                for(;;){
                    var _v_ = h[1], _w_ = caml_check_bound(k, i)[1 + i];
                    h[1] = (caml_call2(H[2], seed, _w_) * 65599 | 0) + _v_ | 0;
                    var _x_ = i + 1 | 0;
                    if (_u_ === i) break;
                    i = _x_;
                }
            }
            return h[1];
        }
        function equal(c, k) {
            var len = k.length - 1, len$0 = length$1(c);
            if (len !== len$0) return 1;
            var i$1 = len - 1 | 0, i = i$1;
            for(;;){
                if (0 > i) return 0;
                var match = get_key$0(c, i);
                if (!match) return 2;
                var ki = match[1], _s_ = caml_check_bound(k, i)[1 + i];
                if (!caml_call2(H[1], _s_, ki)) return 1;
                var i$0 = i - 1 | 0;
                i = i$0;
            }
        }
        function set_key_data(c, k, d) {
            caml_call1(Stdlib_Obj[23][12], c);
            var _q_ = k.length - 2 | 0, _p_ = 0;
            if (_q_ >= 0) {
                var i = _p_;
                for(;;){
                    set_key$0(c, i, caml_check_bound(k, i)[1 + i]);
                    var _r_ = i + 1 | 0;
                    if (_q_ === i) break;
                    i = _r_;
                }
            }
            return set_data$1(c, d);
        }
        function check_key(c) {
            var i$1 = length$1(c) - 1 | 0, i = i$1;
            for(;;){
                var _n_ = i < 0 ? 1 : 0;
                if (_n_) var _o_ = _n_;
                else {
                    var _m_ = caml_call2(Stdlib_Obj[23][7], c, i);
                    if (_m_) {
                        var i$0 = i - 1 | 0;
                        i = i$0;
                        continue;
                    }
                    var _o_ = _m_;
                }
                return _o_;
            }
        }
        return MakeSeeded([
            0,
            create,
            seeded_hash,
            equal,
            get_data$1,
            set_key_data,
            check_key
        ]);
    }
    function Make$1(H) {
        var equal = H[1];
        function seeded_hash(seed, x) {
            return caml_call1(H[2], x);
        }
        var include = MakeSeeded$2([
            0,
            equal,
            seeded_hash
        ]), _l_ = include[1], clear = include[2], reset = include[3], copy = include[4], add = include[5], remove = include[6], find = include[7], find_opt = include[8], find_all = include[9], replace = include[10], mem = include[11], length = include[12], stats = include[13], add_seq = include[14], replace_seq = include[15], clean = include[17], stats_alive = include[18];
        function create(sz) {
            return caml_call2(_l_, _c_, sz);
        }
        function of_seq(i) {
            var tbl = caml_call2(_l_, _c_, 16);
            caml_call2(replace_seq, tbl, i);
            return tbl;
        }
        return [
            0,
            create,
            clear,
            reset,
            copy,
            add,
            remove,
            find,
            find_opt,
            find_all,
            replace,
            mem,
            length,
            stats,
            add_seq,
            replace_seq,
            of_seq,
            clean,
            stats_alive
        ];
    }
    function make$4(param) {
        return [
            0,
            0
        ];
    }
    function add$1(b, k, d) {
        var _k_ = b[1];
        b[1] = [
            0,
            make$3(k, d),
            _k_
        ];
        return 0;
    }
    function test_keys$0(k, e) {
        try {
            if (length$1(e) !== k.length - 1) throw caml_maybe_attach_backtrace(Stdlib[3], 1);
            var _g_ = k.length - 2 | 0, _f_ = 0;
            if (_g_ >= 0) {
                var i = _f_;
                for(;;){
                    var match = get_key$0(e, i);
                    if (match) {
                        var x = match[1];
                        if (x === caml_check_bound(k, i)[1 + i]) {
                            var _i_ = i + 1 | 0;
                            if (_g_ === i) break;
                            i = _i_;
                            continue;
                        }
                    }
                    throw caml_maybe_attach_backtrace(Stdlib[3], 1);
                }
            }
            var _h_ = 1;
            return _h_;
        } catch (_j_) {
            var _e_ = caml_wrap_exception(_j_);
            if (_e_ === Stdlib[3]) return 0;
            throw caml_maybe_attach_backtrace(_e_, 0);
        }
    }
    function remove$1(b, k) {
        var l$0 = b[1], l = l$0, acc = 0;
        for(;;){
            if (!l) return 0;
            var h = l[1], t = l[2];
            if (test_keys$0(k, h)) {
                b[1] = caml_call2(Stdlib_List[13], acc, t);
                return 0;
            }
            var t$0 = l[2], acc$0 = [
                0,
                h,
                acc
            ];
            l = t$0;
            acc = acc$0;
        }
    }
    function find$1(b, k) {
        var match = caml_call2(Stdlib_List[40], function(_d_) {
            return test_keys$0(k, _d_);
        }, b[1]);
        if (!match) return 0;
        var e = match[1];
        return get_data$1(e);
    }
    function length$2(b) {
        return caml_call1(Stdlib_List[1], b[1]);
    }
    function clear$1(b) {
        b[1] = 0;
        return 0;
    }
    var Stdlib_Ephemeron = [
        0,
        [
            0,
            make,
            query,
            Make,
            MakeSeeded$0,
            [
                0,
                make$0,
                add,
                remove,
                find,
                length,
                clear
            ]
        ],
        [
            0,
            make$1,
            query$0,
            Make$0,
            MakeSeeded$1,
            [
                0,
                make$2,
                add$0,
                remove$0,
                find$0,
                length$0,
                clear$0
            ]
        ],
        [
            0,
            make$3,
            query$1,
            Make$1,
            MakeSeeded$2,
            [
                0,
                make$4,
                add$1,
                remove$1,
                find$1,
                length$2,
                clear$1
            ]
        ]
    ];
    runtime.caml_register_global(13, Stdlib_Ephemeron, "Stdlib__Ephemeron");
    return;
})(globalThis);
//# 27211 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$19 = "", cst$23 = " ", cst_2$1 = " 2>", cst_2_1$1 = " 2>&1", cst$22 = " <", cst$21 = " >", cst$20 = '"', cst$24 = ".", cst$25 = "..", cst$28 = "../", cst$27 = "./", cst$26 = "/", cst_dev_null = "/dev/null", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_sys_getenv = runtime.caml_sys_getenv, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$18 = cst$19, cst$17 = cst$19, cst$16 = cst$19, cst$8 = cst$21, cst$15 = cst$19, cst$9 = cst$22, cst$14 = cst$19, cst$10 = cst$23, cst$11 = cst$23, cst$12 = cst$20, cst$13 = cst$19, cst$6 = cst$20, cst$7 = cst$19, cst$4 = cst$19, cst = cst$21, cst$3 = cst$19, cst$0 = cst$22, cst$2 = cst$19, cst$1 = cst$23, null$0 = cst_dev_null, current_dir_name = cst$24, parent_dir_name = cst$25, dir_sep = cst$26, quotequote = "'\\''", null$1 = "NUL", current_dir_name$0 = cst$24, parent_dir_name$0 = cst$25, dir_sep$0 = "\\", cst$5 = cst$24, null$2 = cst_dev_null, current_dir_name$1 = cst$24, parent_dir_name$1 = cst$25, dir_sep$1 = cst$26, Stdlib = global_data.Stdlib, Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_String = global_data.Stdlib__String, Stdlib_List = global_data.Stdlib__List, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Sys = global_data.Stdlib__Sys;
    function generic_basename(is_dir_sep, current_dir_name, name) {
        if (name === cst$19) return current_dir_name;
        var n$3 = caml_ml_string_length(name) - 1 | 0, n = n$3;
        for(;;){
            if (0 > n) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n)) break;
            var n$0 = n - 1 | 0;
            n = n$0;
        }
        var p = n + 1 | 0, n$1 = n;
        for(;;){
            if (0 > n$1) return caml_call3(Stdlib_String[16], name, 0, p);
            if (caml_call2(is_dir_sep, name, n$1)) return caml_call3(Stdlib_String[16], name, n$1 + 1 | 0, (p - n$1 | 0) - 1 | 0);
            var n$2 = n$1 - 1 | 0;
            n$1 = n$2;
        }
    }
    function generic_dirname(is_dir_sep, current_dir_name, name) {
        if (name === cst$19) return current_dir_name;
        var n$5 = caml_ml_string_length(name) - 1 | 0, n = n$5;
        for(;;){
            if (0 > n) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n)) break;
            var n$0 = n - 1 | 0;
            n = n$0;
        }
        var n$1 = n;
        for(;;){
            if (0 > n$1) return current_dir_name;
            if (caml_call2(is_dir_sep, name, n$1)) break;
            var n$2 = n$1 - 1 | 0;
            n$1 = n$2;
        }
        var n$3 = n$1;
        for(;;){
            if (0 > n$3) return caml_call3(Stdlib_String[16], name, 0, 1);
            if (!caml_call2(is_dir_sep, name, n$3)) return caml_call3(Stdlib_String[16], name, 0, n$3 + 1 | 0);
            var n$4 = n$3 - 1 | 0;
            n$3 = n$4;
        }
    }
    function is_dir_sep(s, i) {
        return 47 === caml_string_get(s, i) ? 1 : 0;
    }
    function is_relative(n) {
        var _aH_ = caml_ml_string_length(n) < 1 ? 1 : 0, _aI_ = _aH_ || (47 !== caml_string_get(n, 0) ? 1 : 0);
        return _aI_;
    }
    function is_implicit(n) {
        var _aC_ = is_relative(n);
        if (_aC_) {
            var _aD_ = caml_ml_string_length(n) < 2 ? 1 : 0, _aE_ = _aD_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== cst$27 ? 1 : 0);
            if (_aE_) var _aF_ = caml_ml_string_length(n) < 3 ? 1 : 0, _aG_ = _aF_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== cst$28 ? 1 : 0);
            else var _aG_ = _aE_;
        } else var _aG_ = _aC_;
        return _aG_;
    }
    function check_suffix(name, suff) {
        return caml_call2(Stdlib_String[12], suff, name);
    }
    function chop_suffix_opt(suffix, filename) {
        var len_s = caml_ml_string_length(suffix), len_f = caml_ml_string_length(filename);
        if (len_s > len_f) return 0;
        var r = caml_call3(Stdlib_String[16], filename, len_f - len_s | 0, len_s);
        return r === suffix ? [
            0,
            caml_call3(Stdlib_String[16], filename, 0, len_f - len_s | 0)
        ] : 0;
    }
    var dummy = 0, _h_ = [
        0,
        7,
        0
    ], _g_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                5,
                0
            ]
        ]
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                4,
                6,
                [
                    0,
                    2,
                    6
                ],
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s%06x%s"
    ], cst_Filename_chop_extension = "Filename.chop_extension", cst_Filename_chop_suffix = "Filename.chop_suffix", _d_ = [
        0,
        cst$20,
        0
    ], cst_2_1$0 = cst_2_1$1, cst_2$0 = cst_2$1, cst_Filename_quote_command_bad = "Filename.quote_command: bad file name ", _c_ = [
        0,
        cst$20,
        0
    ], cst_2_1 = cst_2_1$1, cst_2 = cst_2$1, cst_tmp = "/tmp";
    try {
        var _j_ = caml_sys_getenv("TMPDIR"), temp_dir_name = _j_;
    } catch (_aB_) {
        var _a_ = caml_wrap_exception(_aB_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        var temp_dir_name = cst_tmp;
    }
    function quote(s) {
        var l = caml_ml_string_length(s), b = caml_call1(Stdlib_Buffer[1], l + 20 | 0);
        caml_call2(Stdlib_Buffer[12], b, 39);
        var _ay_ = l - 1 | 0, _ax_ = 0;
        if (_ay_ >= 0) {
            var i = _ax_;
            for(;;){
                if (39 === caml_string_get(s, i)) caml_call2(Stdlib_Buffer[16], b, quotequote);
                else {
                    var _aA_ = caml_string_get(s, i);
                    caml_call2(Stdlib_Buffer[12], b, _aA_);
                }
                var _az_ = i + 1 | 0;
                if (_ay_ === i) break;
                i = _az_;
            }
        }
        caml_call2(Stdlib_Buffer[12], b, 39);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function quote_command(cmd, stdin, stdout, stderr, args) {
        if (stderr) {
            var f = stderr[1];
            if (caml_equal(stderr, stdout)) var _am_ = cst_2_1;
            else var _aw_ = quote(f), _am_ = caml_call2(Stdlib[28], cst_2, _aw_);
            var _an_ = _am_;
        } else var _an_ = cst$4;
        if (stdout) var f$0 = stdout[1], _ao_ = quote(f$0), _ap_ = caml_call2(Stdlib[28], cst, _ao_);
        else var _ap_ = cst$3;
        var _aq_ = caml_call2(Stdlib[28], _ap_, _an_);
        if (stdin) var f$1 = stdin[1], _ar_ = quote(f$1), _as_ = caml_call2(Stdlib[28], cst$0, _ar_);
        else var _as_ = cst$2;
        var _at_ = caml_call2(Stdlib[28], _as_, _aq_), _au_ = caml_call2(Stdlib_List[20], quote, [
            0,
            cmd,
            args
        ]), _av_ = caml_call2(Stdlib_String[7], cst$1, _au_);
        return caml_call2(Stdlib[28], _av_, _at_);
    }
    function basename(_al_) {
        return generic_basename(is_dir_sep, current_dir_name, _al_);
    }
    function dirname(_ak_) {
        return generic_dirname(is_dir_sep, current_dir_name, _ak_);
    }
    var Unix = [
        0,
        null$0,
        current_dir_name,
        parent_dir_name,
        dir_sep,
        is_dir_sep,
        is_relative,
        is_implicit,
        check_suffix,
        chop_suffix_opt,
        temp_dir_name,
        quote,
        quote_command,
        basename,
        dirname
    ];
    function is_dir_sep$0(s, i) {
        var c = caml_string_get(s, i), _ah_ = 47 === c ? 1 : 0;
        if (_ah_) var _ai_ = _ah_;
        else var _aj_ = 92 === c ? 1 : 0, _ai_ = _aj_ || (58 === c ? 1 : 0);
        return _ai_;
    }
    function is_relative$0(n) {
        var _ab_ = caml_ml_string_length(n) < 1 ? 1 : 0, _ac_ = _ab_ || (47 !== caml_string_get(n, 0) ? 1 : 0);
        if (_ac_) {
            var _ad_ = caml_ml_string_length(n) < 1 ? 1 : 0, _ae_ = _ad_ || (92 !== caml_string_get(n, 0) ? 1 : 0);
            if (_ae_) var _af_ = caml_ml_string_length(n) < 2 ? 1 : 0, _ag_ = _af_ || (58 !== caml_string_get(n, 1) ? 1 : 0);
            else var _ag_ = _ae_;
        } else var _ag_ = _ac_;
        return _ag_;
    }
    function is_implicit$0(n) {
        var _U_ = is_relative$0(n);
        if (_U_) {
            var _V_ = caml_ml_string_length(n) < 2 ? 1 : 0, _W_ = _V_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== cst$27 ? 1 : 0);
            if (_W_) {
                var _X_ = caml_ml_string_length(n) < 2 ? 1 : 0, _Y_ = _X_ || (caml_call3(Stdlib_String[16], n, 0, 2) !== ".\\" ? 1 : 0);
                if (_Y_) {
                    var _Z_ = caml_ml_string_length(n) < 3 ? 1 : 0, ___ = _Z_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== cst$28 ? 1 : 0);
                    if (___) var _$_ = caml_ml_string_length(n) < 3 ? 1 : 0, _aa_ = _$_ || (caml_call3(Stdlib_String[16], n, 0, 3) !== "..\\" ? 1 : 0);
                    else var _aa_ = ___;
                } else var _aa_ = _Y_;
            } else var _aa_ = _W_;
        } else var _aa_ = _U_;
        return _aa_;
    }
    function check_suffix$0(name, suff) {
        var _R_ = caml_ml_string_length(suff) <= caml_ml_string_length(name) ? 1 : 0;
        if (_R_) var s = caml_call3(Stdlib_String[16], name, caml_ml_string_length(name) - caml_ml_string_length(suff) | 0, caml_ml_string_length(suff)), _S_ = caml_call1(Stdlib_String[27], suff), _T_1 = caml_call1(Stdlib_String[27], s) === _S_ ? 1 : 0;
        else var _T_1 = _R_;
        return _T_1;
    }
    function chop_suffix_opt$0(suffix, filename) {
        var len_s = caml_ml_string_length(suffix), len_f = caml_ml_string_length(filename);
        if (len_s > len_f) return 0;
        var r = caml_call3(Stdlib_String[16], filename, len_f - len_s | 0, len_s), _Q_ = caml_call1(Stdlib_String[27], suffix);
        return caml_call1(Stdlib_String[27], r) === _Q_ ? [
            0,
            caml_call3(Stdlib_String[16], filename, 0, len_f - len_s | 0)
        ] : 0;
    }
    try {
        var _i_ = caml_sys_getenv("TEMP"), temp_dir_name$0 = _i_;
    } catch (_P_) {
        var _b_ = caml_wrap_exception(_P_);
        if (_b_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_b_, 0);
        var temp_dir_name$0 = cst$5;
    }
    function quote$0(s) {
        var l = caml_ml_string_length(s), b = caml_call1(Stdlib_Buffer[1], l + 20 | 0);
        caml_call2(Stdlib_Buffer[12], b, 34);
        function loop$0(counter, i) {
            var i$0 = i;
            for(;;){
                if (i$0 === l) return caml_call2(Stdlib_Buffer[12], b, 34);
                var c = caml_string_get(s, i$0);
                if (34 === c) {
                    var _N_ = 0;
                    if (counter >= 50) return caml_trampoline_return(loop_bs, [
                        0,
                        _N_,
                        i$0
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return loop_bs(counter$1, _N_, i$0);
                }
                if (92 === c) {
                    var _O_ = 0;
                    if (counter >= 50) return caml_trampoline_return(loop_bs, [
                        0,
                        _O_,
                        i$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return loop_bs(counter$0, _O_, i$0);
                }
                caml_call2(Stdlib_Buffer[12], b, c);
                var i$1 = i$0 + 1 | 0;
                i$0 = i$1;
            }
        }
        function loop(i) {
            return caml_trampoline(loop$0(0, i));
        }
        function loop_bs(counter, n, i) {
            var n$0 = n, i$0 = i;
            for(;;){
                if (i$0 === l) {
                    caml_call2(Stdlib_Buffer[12], b, 34);
                    return add_bs(n$0);
                }
                var match = caml_string_get(s, i$0);
                if (34 === match) {
                    add_bs((2 * n$0 | 0) + 1 | 0);
                    caml_call2(Stdlib_Buffer[12], b, 34);
                    var _M_ = i$0 + 1 | 0;
                    if (counter >= 50) return caml_trampoline_return(loop$0, [
                        0,
                        _M_
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return loop$0(counter$1, _M_);
                }
                if (92 !== match) {
                    add_bs(n$0);
                    if (counter >= 50) return caml_trampoline_return(loop$0, [
                        0,
                        i$0
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return loop$0(counter$0, i$0);
                }
                var i$1 = i$0 + 1 | 0, n$1 = n$0 + 1 | 0;
                n$0 = n$1;
                i$0 = i$1;
            }
        }
        function add_bs(n) {
            var _K_ = 1;
            if (n >= 1) {
                var j = _K_;
                for(;;){
                    caml_call2(Stdlib_Buffer[12], b, 92);
                    var _L_ = j + 1 | 0;
                    if (n === j) break;
                    j = _L_;
                }
            }
        }
        loop(0);
        return caml_call1(Stdlib_Buffer[2], b);
    }
    function quote_cmd_filename(f) {
        var f$0 = caml_call2(Stdlib_String[15], f, 47) ? caml_call2(Stdlib_String[18], function(c) {
            return 47 === c ? 92 : c;
        }, f) : f;
        if (!caml_call2(Stdlib_String[23], function(param) {
            if (34 !== param && 37 !== param) return 0;
            return 1;
        }, f$0)) return caml_call2(Stdlib_String[15], f$0, 32) ? caml_call2(Stdlib_String[7], cst$7, [
            0,
            cst$6,
            [
                0,
                f$0,
                _c_
            ]
        ]) : f$0;
        var _J_ = caml_call2(Stdlib[28], cst_Filename_quote_command_bad, f$0);
        return caml_call1(Stdlib[2], _J_);
    }
    function quote_command$0(cmd, stdin, stdout, stderr, args) {
        if (stderr) {
            var f = stderr[1];
            if (caml_equal(stderr, stdout)) var _w_ = cst_2_1$0;
            else var _H_ = quote_cmd_filename(f), _w_ = caml_call2(Stdlib[28], cst_2$0, _H_);
            var _x_ = _w_;
        } else var _x_ = cst$16;
        var _y_ = [
            0,
            _x_,
            _d_
        ];
        if (stdout) var f$0 = stdout[1], _z_ = quote_cmd_filename(f$0), _A_ = caml_call2(Stdlib[28], cst$8, _z_);
        else var _A_ = cst$15;
        var _B_ = [
            0,
            _A_,
            _y_
        ];
        if (stdin) var f$1 = stdin[1], _C_ = quote_cmd_filename(f$1), _D_ = caml_call2(Stdlib[28], cst$9, _C_);
        else var _D_ = cst$14;
        var _E_ = caml_call2(Stdlib_List[20], quote$0, args), s = caml_call2(Stdlib_String[7], cst$10, _E_), b = caml_call1(Stdlib_Buffer[1], caml_ml_string_length(s) + 20 | 0);
        caml_call2(Stdlib_String[30], function(c) {
            a: {
                if (62 <= c) {
                    var _I_ = c - 63 | 0;
                    if (60 < _I_ >>> 0) {
                        if (62 <= _I_) break a;
                    } else if (31 !== _I_) break a;
                } else if (42 <= c) {
                    if (60 !== c) break a;
                } else {
                    if (33 > c) break a;
                    switch(c - 33 | 0){
                        case 2:
                        case 3:
                        case 6:
                            break a;
                    }
                }
                caml_call2(Stdlib_Buffer[12], b, 94);
                return caml_call2(Stdlib_Buffer[12], b, c);
            }
            return caml_call2(Stdlib_Buffer[12], b, c);
        }, s);
        var _F_ = [
            0,
            cst$11,
            [
                0,
                caml_call1(Stdlib_Buffer[2], b),
                [
                    0,
                    _D_,
                    _B_
                ]
            ]
        ], _G_ = [
            0,
            cst$12,
            [
                0,
                quote_cmd_filename(cmd),
                _F_
            ]
        ];
        return caml_call2(Stdlib_String[7], cst$13, _G_);
    }
    function drive_and_path(s) {
        var _s_ = 2 <= caml_ml_string_length(s) ? 1 : 0;
        if (_s_) {
            var param = caml_string_get(s, 0);
            a: {
                b: {
                    if (91 <= param) {
                        if (25 < param - 97 >>> 0) break b;
                    } else if (65 > param) break b;
                    var _t_ = 1;
                    break a;
                }
                var _t_ = 0;
            }
            var _u_ = _t_ ? 58 === caml_string_get(s, 1) ? 1 : 0 : _t_;
        } else var _u_ = _s_;
        if (!_u_) return [
            0,
            cst$17,
            s
        ];
        var _v_ = caml_call3(Stdlib_String[16], s, 2, caml_ml_string_length(s) - 2 | 0);
        return [
            0,
            caml_call3(Stdlib_String[16], s, 0, 2),
            _v_
        ];
    }
    function dirname$0(s) {
        var match = drive_and_path(s), path = match[2], drive = match[1], dir = generic_dirname(is_dir_sep$0, current_dir_name$0, path);
        return caml_call2(Stdlib[28], drive, dir);
    }
    function basename$0(s) {
        var path = drive_and_path(s)[2];
        return generic_basename(is_dir_sep$0, current_dir_name$0, path);
    }
    var Win32 = [
        0,
        null$1,
        current_dir_name$0,
        parent_dir_name$0,
        dir_sep$0,
        is_dir_sep$0,
        is_relative$0,
        is_implicit$0,
        check_suffix$0,
        chop_suffix_opt$0,
        temp_dir_name$0,
        quote$0,
        quote_command$0,
        basename$0,
        dirname$0
    ];
    function basename$1(_r_) {
        return generic_basename(is_dir_sep$0, current_dir_name$1, _r_);
    }
    function dirname$1(_q_) {
        return generic_dirname(is_dir_sep$0, current_dir_name$1, _q_);
    }
    var Cygwin = [
        0,
        null$2,
        current_dir_name$1,
        parent_dir_name$1,
        dir_sep$1,
        is_dir_sep$0,
        is_relative$0,
        is_implicit$0,
        check_suffix$0,
        chop_suffix_opt$0,
        temp_dir_name,
        quote,
        quote_command,
        basename$1,
        dirname$1
    ], _e_ = Stdlib_Sys[4], Sysdeps = _e_ !== "Cygwin" ? _e_ !== "Win32" ? Unix : Win32 : Cygwin, null$3 = Sysdeps[1], current_dir_name$2 = Sysdeps[2], parent_dir_name$2 = Sysdeps[3], dir_sep$2 = Sysdeps[4], is_dir_sep$1 = Sysdeps[5], is_relative$1 = Sysdeps[6], is_implicit$1 = Sysdeps[7], check_suffix$1 = Sysdeps[8], chop_suffix_opt$1 = Sysdeps[9], temp_dir_name$1 = Sysdeps[10], quote$1 = Sysdeps[11], quote_command$1 = Sysdeps[12], basename$2 = Sysdeps[13], dirname$2 = Sysdeps[14];
    function concat(dirname, filename) {
        var l = caml_ml_string_length(dirname);
        if (0 !== l && !is_dir_sep$1(dirname, l - 1 | 0)) {
            var _p_ = caml_call2(Stdlib[28], dir_sep$2, filename);
            return caml_call2(Stdlib[28], dirname, _p_);
        }
        return caml_call2(Stdlib[28], dirname, filename);
    }
    function chop_suffix(name, suff) {
        return check_suffix$1(name, suff) ? caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - caml_ml_string_length(suff) | 0) : caml_call1(Stdlib[1], cst_Filename_chop_suffix);
    }
    function extension_len(name) {
        var i$3 = caml_ml_string_length(name) - 1 | 0, i0 = i$3;
        for(;;){
            if (0 <= i0 && !is_dir_sep$1(name, i0)) {
                if (46 === caml_string_get(name, i0)) break;
                var i$2 = i0 - 1 | 0;
                i0 = i$2;
                continue;
            }
            return 0;
        }
        var i$1 = i0 - 1 | 0, i = i$1;
        for(;;){
            if (0 <= i && !is_dir_sep$1(name, i)) {
                if (46 !== caml_string_get(name, i)) return caml_ml_string_length(name) - i0 | 0;
                var i$0 = i - 1 | 0;
                i = i$0;
                continue;
            }
            return 0;
        }
    }
    function extension(name) {
        var l = extension_len(name);
        return 0 === l ? cst$18 : caml_call3(Stdlib_String[16], name, caml_ml_string_length(name) - l | 0, l);
    }
    function chop_extension(name) {
        var l = extension_len(name);
        return 0 === l ? caml_call1(Stdlib[1], cst_Filename_chop_extension) : caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - l | 0);
    }
    function remove_extension(name) {
        var l = extension_len(name);
        return 0 === l ? name : caml_call3(Stdlib_String[16], name, 0, caml_ml_string_length(name) - l | 0);
    }
    var prng_key = caml_call2(Stdlib_Domain[11][1], 0, Stdlib_Random[19][2]);
    function temp_file_name(temp_dir, prefix, suffix) {
        var random_state = caml_call1(Stdlib_Domain[11][2], prng_key), rnd = caml_call1(Stdlib_Random[19][4], random_state) & 16777215;
        return concat(temp_dir, caml_call4(Stdlib_Printf[4], _f_, prefix, rnd, suffix));
    }
    var current_temp_dir_name = caml_call2(Stdlib_Domain[11][1], [
        0,
        function(_o_) {
            return _o_;
        }
    ], function(param) {
        return temp_dir_name$1;
    });
    function set_temp_dir_name(s) {
        return caml_call2(Stdlib_Domain[11][3], current_temp_dir_name, s);
    }
    function get_temp_dir_name(param) {
        return caml_call1(Stdlib_Domain[11][2], current_temp_dir_name);
    }
    function temp_file(opt, prefix, suffix) {
        var temp_dir = opt ? opt[1] : caml_call1(Stdlib_Domain[11][2], current_temp_dir_name), counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                runtime.caml_sys_close(runtime.caml_sys_open(name, _g_, 384));
                return name;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    function open_temp_file(_m_, _l_, opt, prefix, suffix) {
        var mode = _m_ ? _m_[1] : _h_, perms = _l_ ? _l_[1] : 384, temp_dir = opt ? opt[1] : caml_call1(Stdlib_Domain[11][2], current_temp_dir_name), counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                var _n_ = [
                    0,
                    name,
                    caml_call3(Stdlib[62], [
                        0,
                        1,
                        [
                            0,
                            3,
                            [
                                0,
                                5,
                                mode
                            ]
                        ]
                    ], perms, name)
                ];
                return _n_;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    function temp_dir(_k_, opt, prefix, suffix) {
        var temp_dir = _k_ ? _k_[1] : caml_call1(Stdlib_Domain[11][2], current_temp_dir_name), perms = opt ? opt[1] : 448, counter = 0;
        for(;;){
            var name = temp_file_name(temp_dir, prefix, suffix);
            try {
                runtime.caml_sys_mkdir(name, perms);
                return name;
            } catch (e$0) {
                var e = caml_wrap_exception(e$0);
                if (e[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace(e, 0);
                if (20 <= counter) throw caml_maybe_attach_backtrace(e, 0);
                var counter$0 = counter + 1 | 0;
                counter = counter$0;
            }
        }
    }
    var Stdlib_Filename = [
        0,
        current_dir_name$2,
        parent_dir_name$2,
        dir_sep$2,
        concat,
        is_relative$1,
        is_implicit$1,
        check_suffix$1,
        chop_suffix,
        chop_suffix_opt$1,
        extension,
        remove_extension,
        chop_extension,
        basename$2,
        dirname$2,
        null$3,
        temp_file,
        open_temp_file,
        temp_dir,
        get_temp_dir_name,
        set_temp_dir_name,
        quote$1,
        quote_command$1
    ];
    runtime.caml_register_global(66, Stdlib_Filename, "Stdlib__Filename");
    return;
})(globalThis);
//# 28094 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Array = global_data.Stdlib__Array, init = Stdlib_Array[1], make_matrix = Stdlib_Array[2], init_matrix = Stdlib_Array[3], append = Stdlib_Array[4], concat = Stdlib_Array[5], sub = Stdlib_Array[6], copy = Stdlib_Array[7], fill = Stdlib_Array[8], blit = Stdlib_Array[9], to_list = Stdlib_Array[10], of_list = Stdlib_Array[11], iter = Stdlib_Array[12], iteri = Stdlib_Array[13], map = Stdlib_Array[14], map_inplace = Stdlib_Array[15], mapi = Stdlib_Array[16], mapi_inplace = Stdlib_Array[17], fold_left = Stdlib_Array[18], fold_left_map = Stdlib_Array[19], fold_right = Stdlib_Array[20], iter2 = Stdlib_Array[21], map2 = Stdlib_Array[22], for_all = Stdlib_Array[23], exists = Stdlib_Array[24], for_all2 = Stdlib_Array[25], exists2 = Stdlib_Array[26], mem = Stdlib_Array[27], memq = Stdlib_Array[28], find_opt = Stdlib_Array[29], find_index = Stdlib_Array[30], find_map = Stdlib_Array[31], find_mapi = Stdlib_Array[32], split = Stdlib_Array[33], combine = Stdlib_Array[34], sort = Stdlib_Array[35], stable_sort = Stdlib_Array[36], fast_sort = Stdlib_Array[37], shuffle = Stdlib_Array[38], to_seq = Stdlib_Array[39], to_seqi = Stdlib_Array[40], of_seq = Stdlib_Array[41], Floatarray = Stdlib_Array[42], Stdlib_ArrayLabels = [
        0,
        init,
        make_matrix,
        init_matrix,
        append,
        concat,
        sub,
        copy,
        fill,
        blit,
        to_list,
        of_list,
        iter,
        iteri,
        map,
        map_inplace,
        mapi,
        mapi_inplace,
        fold_left,
        fold_left_map,
        fold_right,
        iter2,
        map2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        split,
        combine,
        sort,
        stable_sort,
        fast_sort,
        shuffle,
        to_seq,
        to_seqi,
        of_seq,
        Floatarray
    ];
    runtime.caml_register_global(1, Stdlib_ArrayLabels, "Stdlib__ArrayLabels");
    return;
})(globalThis);
//# 28194 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_List = global_data.Stdlib__List, length = Stdlib_List[1], compare_lengths = Stdlib_List[2], compare_length_with = Stdlib_List[3], is_empty = Stdlib_List[4], cons = Stdlib_List[5], hd = Stdlib_List[6], tl = Stdlib_List[7], nth = Stdlib_List[8], nth_opt = Stdlib_List[9], rev = Stdlib_List[10], init = Stdlib_List[11], append = Stdlib_List[12], rev_append = Stdlib_List[13], concat = Stdlib_List[14], flatten = Stdlib_List[15], equal = Stdlib_List[16], compare = Stdlib_List[17], iter = Stdlib_List[18], iteri = Stdlib_List[19], map = Stdlib_List[20], mapi = Stdlib_List[21], rev_map = Stdlib_List[22], filter_map = Stdlib_List[23], concat_map = Stdlib_List[24], fold_left_map = Stdlib_List[25], fold_left = Stdlib_List[26], fold_right = Stdlib_List[27], iter2 = Stdlib_List[28], map2 = Stdlib_List[29], rev_map2 = Stdlib_List[30], fold_left2 = Stdlib_List[31], fold_right2 = Stdlib_List[32], for_all = Stdlib_List[33], exists = Stdlib_List[34], for_all2 = Stdlib_List[35], exists2 = Stdlib_List[36], mem = Stdlib_List[37], memq = Stdlib_List[38], find = Stdlib_List[39], find_opt = Stdlib_List[40], find_index = Stdlib_List[41], find_map = Stdlib_List[42], find_mapi = Stdlib_List[43], filter = Stdlib_List[44], find_all = Stdlib_List[45], filteri = Stdlib_List[46], take = Stdlib_List[47], drop = Stdlib_List[48], take_while = Stdlib_List[49], drop_while = Stdlib_List[50], partition = Stdlib_List[51], partition_map = Stdlib_List[52], assoc = Stdlib_List[53], assoc_opt = Stdlib_List[54], assq = Stdlib_List[55], assq_opt = Stdlib_List[56], mem_assoc = Stdlib_List[57], mem_assq = Stdlib_List[58], remove_assoc = Stdlib_List[59], remove_assq = Stdlib_List[60], split = Stdlib_List[61], combine = Stdlib_List[62], sort = Stdlib_List[63], stable_sort = Stdlib_List[64], fast_sort = Stdlib_List[65], sort_uniq = Stdlib_List[66], merge = Stdlib_List[67], to_seq = Stdlib_List[68], of_seq = Stdlib_List[69], Stdlib_ListLabels = [
        0,
        length,
        compare_lengths,
        compare_length_with,
        is_empty,
        cons,
        hd,
        tl,
        nth,
        nth_opt,
        rev,
        init,
        append,
        rev_append,
        concat,
        flatten,
        equal,
        compare,
        iter,
        iteri,
        map,
        mapi,
        rev_map,
        filter_map,
        concat_map,
        fold_left_map,
        fold_left,
        fold_right,
        iter2,
        map2,
        rev_map2,
        fold_left2,
        fold_right2,
        for_all,
        exists,
        for_all2,
        exists2,
        mem,
        memq,
        find,
        find_opt,
        find_index,
        find_map,
        find_mapi,
        filter,
        find_all,
        filteri,
        take,
        drop,
        take_while,
        drop_while,
        partition,
        partition_map,
        assoc,
        assoc_opt,
        assq,
        assq_opt,
        mem_assoc,
        mem_assq,
        remove_assoc,
        remove_assq,
        split,
        combine,
        sort,
        stable_sort,
        fast_sort,
        sort_uniq,
        merge,
        to_seq,
        of_seq
    ];
    runtime.caml_register_global(1, Stdlib_ListLabels, "Stdlib__ListLabels");
    return;
})(globalThis);
//# 28348 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Bytes = global_data.Stdlib__Bytes, make = Stdlib_Bytes[1], init = Stdlib_Bytes[2], empty = Stdlib_Bytes[3], copy = Stdlib_Bytes[4], of_string = Stdlib_Bytes[5], to_string = Stdlib_Bytes[6], sub = Stdlib_Bytes[7], sub_string = Stdlib_Bytes[8], extend = Stdlib_Bytes[9], fill = Stdlib_Bytes[10], blit = Stdlib_Bytes[11], blit_string = Stdlib_Bytes[12], concat = Stdlib_Bytes[13], cat = Stdlib_Bytes[14], iter = Stdlib_Bytes[15], iteri = Stdlib_Bytes[16], map = Stdlib_Bytes[17], mapi = Stdlib_Bytes[18], fold_left = Stdlib_Bytes[19], fold_right = Stdlib_Bytes[20], for_all = Stdlib_Bytes[21], exists = Stdlib_Bytes[22], trim = Stdlib_Bytes[23], escaped = Stdlib_Bytes[24], index = Stdlib_Bytes[25], index_opt = Stdlib_Bytes[26], rindex = Stdlib_Bytes[27], rindex_opt = Stdlib_Bytes[28], index_from = Stdlib_Bytes[29], index_from_opt = Stdlib_Bytes[30], rindex_from = Stdlib_Bytes[31], rindex_from_opt = Stdlib_Bytes[32], contains = Stdlib_Bytes[33], contains_from = Stdlib_Bytes[34], rcontains_from = Stdlib_Bytes[35], uppercase_ascii = Stdlib_Bytes[36], lowercase_ascii = Stdlib_Bytes[37], capitalize_ascii = Stdlib_Bytes[38], uncapitalize_ascii = Stdlib_Bytes[39], compare = Stdlib_Bytes[40], equal = Stdlib_Bytes[41], starts_with = Stdlib_Bytes[42], ends_with = Stdlib_Bytes[43], unsafe_to_string = Stdlib_Bytes[44], unsafe_of_string = Stdlib_Bytes[45], split_on_char = Stdlib_Bytes[46], to_seq = Stdlib_Bytes[47], to_seqi = Stdlib_Bytes[48], of_seq = Stdlib_Bytes[49], get_utf_8_uchar = Stdlib_Bytes[50], set_utf_8_uchar = Stdlib_Bytes[51], is_valid_utf_8 = Stdlib_Bytes[52], get_utf_16be_uchar = Stdlib_Bytes[53], set_utf_16be_uchar = Stdlib_Bytes[54], is_valid_utf_16be = Stdlib_Bytes[55], get_utf_16le_uchar = Stdlib_Bytes[56], set_utf_16le_uchar = Stdlib_Bytes[57], is_valid_utf_16le = Stdlib_Bytes[58], get_uint8 = Stdlib_Bytes[59], get_int8 = Stdlib_Bytes[60], get_uint16_ne = Stdlib_Bytes[61], get_uint16_be = Stdlib_Bytes[62], get_uint16_le = Stdlib_Bytes[63], get_int16_ne = Stdlib_Bytes[64], get_int16_be = Stdlib_Bytes[65], get_int16_le = Stdlib_Bytes[66], get_int32_ne = Stdlib_Bytes[67], get_int32_be = Stdlib_Bytes[68], get_int32_le = Stdlib_Bytes[69], get_int64_ne = Stdlib_Bytes[70], get_int64_be = Stdlib_Bytes[71], get_int64_le = Stdlib_Bytes[72], set_uint8 = Stdlib_Bytes[73], set_int8 = Stdlib_Bytes[74], set_uint16_ne = Stdlib_Bytes[75], set_uint16_be = Stdlib_Bytes[76], set_uint16_le = Stdlib_Bytes[77], set_int16_ne = Stdlib_Bytes[78], set_int16_be = Stdlib_Bytes[79], set_int16_le = Stdlib_Bytes[80], set_int32_ne = Stdlib_Bytes[81], set_int32_be = Stdlib_Bytes[82], set_int32_le = Stdlib_Bytes[83], set_int64_ne = Stdlib_Bytes[84], set_int64_be = Stdlib_Bytes[85], set_int64_le = Stdlib_Bytes[86], unsafe_escape = Stdlib_Bytes[87], Stdlib_BytesLabels = [
        0,
        make,
        init,
        empty,
        copy,
        of_string,
        to_string,
        sub,
        sub_string,
        extend,
        fill,
        blit,
        blit_string,
        concat,
        cat,
        iter,
        iteri,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        index,
        index_opt,
        rindex,
        rindex_opt,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        contains,
        contains_from,
        rcontains_from,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        compare,
        equal,
        starts_with,
        ends_with,
        unsafe_to_string,
        unsafe_of_string,
        split_on_char,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        set_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        set_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        set_utf_16le_uchar,
        is_valid_utf_16le,
        get_uint8,
        get_int8,
        get_uint16_ne,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        get_int32_ne,
        get_int32_be,
        get_int32_le,
        get_int64_ne,
        get_int64_be,
        get_int64_le,
        set_uint8,
        set_int8,
        set_uint16_ne,
        set_uint16_be,
        set_uint16_le,
        set_int16_ne,
        set_int16_be,
        set_int16_le,
        set_int32_ne,
        set_int32_be,
        set_int32_le,
        set_int64_ne,
        set_int64_be,
        set_int64_le,
        unsafe_escape
    ];
    runtime.caml_register_global(1, Stdlib_BytesLabels, "Stdlib__BytesLabels");
    return;
})(globalThis);
//# 28538 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_String = global_data.Stdlib__String, make = Stdlib_String[1], init = Stdlib_String[2], empty = Stdlib_String[3], of_bytes = Stdlib_String[4], to_bytes = Stdlib_String[5], blit = Stdlib_String[6], concat = Stdlib_String[7], cat = Stdlib_String[8], equal = Stdlib_String[9], compare = Stdlib_String[10], starts_with = Stdlib_String[11], ends_with = Stdlib_String[12], contains_from = Stdlib_String[13], rcontains_from = Stdlib_String[14], contains = Stdlib_String[15], sub = Stdlib_String[16], split_on_char = Stdlib_String[17], map = Stdlib_String[18], mapi = Stdlib_String[19], fold_left = Stdlib_String[20], fold_right = Stdlib_String[21], for_all = Stdlib_String[22], exists = Stdlib_String[23], trim = Stdlib_String[24], escaped = Stdlib_String[25], uppercase_ascii = Stdlib_String[26], lowercase_ascii = Stdlib_String[27], capitalize_ascii = Stdlib_String[28], uncapitalize_ascii = Stdlib_String[29], iter = Stdlib_String[30], iteri = Stdlib_String[31], index_from = Stdlib_String[32], index_from_opt = Stdlib_String[33], rindex_from = Stdlib_String[34], rindex_from_opt = Stdlib_String[35], index = Stdlib_String[36], index_opt = Stdlib_String[37], rindex = Stdlib_String[38], rindex_opt = Stdlib_String[39], to_seq = Stdlib_String[40], to_seqi = Stdlib_String[41], of_seq = Stdlib_String[42], get_utf_8_uchar = Stdlib_String[43], is_valid_utf_8 = Stdlib_String[44], get_utf_16be_uchar = Stdlib_String[45], is_valid_utf_16be = Stdlib_String[46], get_utf_16le_uchar = Stdlib_String[47], is_valid_utf_16le = Stdlib_String[48], get_uint8 = Stdlib_String[49], get_int8 = Stdlib_String[50], get_uint16_ne = Stdlib_String[51], get_uint16_be = Stdlib_String[52], get_uint16_le = Stdlib_String[53], get_int16_ne = Stdlib_String[54], get_int16_be = Stdlib_String[55], get_int16_le = Stdlib_String[56], get_int32_ne = Stdlib_String[57], hash = Stdlib_String[58], seeded_hash = Stdlib_String[59], get_int32_be = Stdlib_String[60], get_int32_le = Stdlib_String[61], get_int64_ne = Stdlib_String[62], get_int64_be = Stdlib_String[63], get_int64_le = Stdlib_String[64], Stdlib_StringLabels = [
        0,
        make,
        init,
        empty,
        of_bytes,
        to_bytes,
        blit,
        concat,
        cat,
        equal,
        compare,
        starts_with,
        ends_with,
        contains_from,
        rcontains_from,
        contains,
        sub,
        split_on_char,
        map,
        mapi,
        fold_left,
        fold_right,
        for_all,
        exists,
        trim,
        escaped,
        uppercase_ascii,
        lowercase_ascii,
        capitalize_ascii,
        uncapitalize_ascii,
        iter,
        iteri,
        index_from,
        index_from_opt,
        rindex_from,
        rindex_from_opt,
        index,
        index_opt,
        rindex,
        rindex_opt,
        to_seq,
        to_seqi,
        of_seq,
        get_utf_8_uchar,
        is_valid_utf_8,
        get_utf_16be_uchar,
        is_valid_utf_16be,
        get_utf_16le_uchar,
        is_valid_utf_16le,
        get_uint8,
        get_int8,
        get_uint16_ne,
        get_uint16_be,
        get_uint16_le,
        get_int16_ne,
        get_int16_be,
        get_int16_le,
        get_int32_ne,
        hash,
        seeded_hash,
        get_int32_be,
        get_int32_le,
        get_int64_ne,
        get_int64_be,
        get_int64_le
    ];
    runtime.caml_register_global(1, Stdlib_StringLabels, "Stdlib__StringLabels");
    return;
})(globalThis);
//# 28683 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_MoreLabels = [
        0,
        Stdlib_Hashtbl,
        Stdlib_Map,
        Stdlib_Set
    ];
    runtime.caml_register_global(3, Stdlib_MoreLabels, "Stdlib__MoreLabels");
    return;
})(globalThis);
//# 28699 "../.js/default/stdlib/stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Stdlib_StdLabels = [
        0
    ];
    runtime.caml_register_global(0, Stdlib_StdLabels, "Stdlib__StdLabels");
    return;
})(globalThis);
//# 17 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, s = "6.0.1", git_version = "", Jsoo_runtime_Runtime_version = [
        0,
        s,
        git_version
    ];
    runtime.caml_register_global(2, Jsoo_runtime_Runtime_version, "Jsoo_runtime__Runtime_version");
    return;
})(globalThis);
//# 32 "../.js/default/js_of_ocaml-compiler.runtime/jsoo_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Jsoo_runtime_Runtime_version = global_data.Jsoo_runtime__Runtime_version, Stdlib_Callback = global_data.Stdlib__Callback, Js = [
        0
    ], _a_ = [
        0,
        "lib/runtime/jsoo_runtime.ml",
        143,
        13
    ];
    function effects(param) {
        var match = runtime.caml_jsoo_flags_effects(0);
        if (match === "cps") return 3356934;
        if (match === "disabled") return -709493348;
        if (match !== "double-translation") throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
        return -766114909;
    }
    var Config = [
        0,
        effects
    ], version = Jsoo_runtime_Runtime_version[1], git_version = Jsoo_runtime_Runtime_version[2], Sys = [
        0,
        Config,
        version,
        git_version
    ], Exn = [
        248,
        "Jsoo_runtime.Error.Exn",
        runtime.caml_fresh_oo_id(0)
    ];
    caml_call2(Stdlib_Callback[2], "jsError", [
        0,
        Exn,
        [
            0
        ]
    ]);
    function raise(exn) {
        throw exn;
    }
    var Error1 = [
        0,
        raise,
        runtime.caml_exn_with_js_backtrace,
        runtime.caml_js_error_option_of_exception,
        Exn
    ], For_compatibility_only = [
        0
    ], Bigstring = [
        0
    ], Typed_array = [
        0,
        Bigstring
    ], Int64 = [
        0
    ], Effect = [
        0
    ], Jsoo_runtime = [
        0,
        Js,
        Sys,
        Error1,
        For_compatibility_only,
        Typed_array,
        Int64,
        Effect
    ];
    runtime.caml_register_global(10, Jsoo_runtime, "Jsoo_runtime");
    return;
})(globalThis);
//# 5 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_equal = runtime.caml_equal, caml_js_meth_call = runtime.caml_js_meth_call, caml_list_of_js_array = runtime.caml_list_of_js_array;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Uchar = global_data.Stdlib__Uchar, Stdlib = global_data.Stdlib, jv_global = globalThis1;
    function length(s) {
        return s.length;
    }
    function jstr_of_int(opt, i) {
        var base = opt ? opt[1] : 10;
        return i.toString(base);
    }
    function get(s, i) {
        if (s.length <= i) {
            var len = s.length, s1 = jstr_of_int(0, len - 1 | 0), s1$0 = jstr_of_int(0, i), s0 = "index ".concat(s1$0), s0$1 = s0.concat(" not in bounds [0;"), s0$0 = s0$1.concat(s1), _b_ = runtime.caml_string_of_jsstring(s0$0.concat("]"));
            return caml_call1(Stdlib[1], _b_);
        }
        var u = s.codePointAt(i);
        a: {
            if (55296 <= u && 57343 >= u) {
                var u$0 = 65533;
                break a;
            }
            var u$0 = u;
        }
        return caml_call1(Stdlib_Uchar[9], u$0);
    }
    function jstr_of_uchar_int(i) {
        return jv_global.String.fromCodePoint(i);
    }
    function get_jstr(s, i) {
        var _a_ = get(s, i);
        return jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], _a_));
    }
    var empty = "", sp = " ", nl = "\n";
    function append(s0, s1) {
        return s0.concat(s1);
    }
    function concat(opt, ss) {
        var sep = opt ? opt[1] : empty;
        return runtime.caml_list_to_js_array(ss).join(sep);
    }
    function pad_start(opt, len, s) {
        var pad = opt ? opt[1] : sp;
        return s.padStart(len, pad);
    }
    function pad_end(opt, len, s) {
        var pad = opt ? opt[1] : sp;
        return s.padEnd(len, pad);
    }
    function repeat(n, s) {
        return s.repeat(n);
    }
    function find_sub(opt, sub, s) {
        var start = opt ? opt[1] : 0, i = s.indexOf(sub, start);
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function find_last_sub(before, sub, s) {
        if (before) var b = before[1], before$0 = b;
        else var before$0 = s.length;
        var pos = before$0 - sub.length | 0;
        if (0 > pos) return 0;
        var i = s.lastIndexOf(sub, pos);
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function slice(opt, stop, s) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], args = [
            0,
            start,
            stop$0
        ];
        else var args = [
            0,
            start
        ];
        return caml_js_meth_call(s, "slice", args);
    }
    function sub(opt, len, s) {
        var start = opt ? opt[1] : 0;
        if (len) var len$0 = len[1], args = [
            0,
            start,
            len$0
        ];
        else var args = [
            0,
            start
        ];
        return caml_js_meth_call(s, "substr", args);
    }
    function cuts(sep, s) {
        return caml_list_of_js_array(s.split(sep));
    }
    var iterator = Symbol.iterator;
    function fold_uchars(f, s, acc) {
        var it = s[iterator](), acc$0 = acc;
        for(;;){
            var r = it.next();
            if (r.done | 0) return acc$0;
            var u = r.value.codePointAt(0);
            a: {
                if (55296 <= u && 57343 >= u) {
                    var u$0 = 65533;
                    break a;
                }
                var u$0 = u;
            }
            var acc$1 = caml_call2(f, caml_call1(Stdlib_Uchar[9], u$0), acc$0);
            acc$0 = acc$1;
        }
    }
    function fold_jstr_uchars(f, s, acc) {
        function f$0(u, acc) {
            return caml_call2(f, jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], u)), acc);
        }
        return fold_uchars(f$0, s, acc);
    }
    function trim(s) {
        return s.trim();
    }
    function normalized(nf, s) {
        var nf$0 = 868484048 <= nf ? 868484049 <= nf ? "NFKD" : "NFKC" : 3894540 <= nf ? "NFD" : "NFC";
        return s.normalize(nf$0);
    }
    function lowercased(s) {
        return s.toLowerCase();
    }
    function uppercased(s) {
        return s.toUpperCase();
    }
    function is_empty(s) {
        return 0 === s.length ? 1 : 0;
    }
    function starts_with(prefix, s) {
        return s.startsWith(prefix) | 0;
    }
    function includes(affix, s) {
        return s.includes(affix) | 0;
    }
    function ends_with(suffix, s) {
        return s.endsWith(suffix) | 0;
    }
    var equal = caml_equal, compare = runtime.caml_compare;
    function of_uchar(u) {
        return jstr_of_uchar_int(caml_call1(Stdlib_Uchar[10], u));
    }
    function of_char(c) {
        return jstr_of_uchar_int(c);
    }
    var number = jv_global.Number;
    function to_int(base, s) {
        if (base) var b = base[1], args = [
            0,
            s,
            b
        ];
        else var args = [
            0,
            s
        ];
        var n = caml_js_meth_call(number, "parseInt", args);
        return caml_equal(n, n) ? [
            0,
            n
        ] : 0;
    }
    function to_float(s) {
        return number.parseFloat(s);
    }
    function of_float(frac, n) {
        if (!frac) return n.toString();
        var frac$0 = frac[1];
        return n.toFixed(frac$0);
    }
    var Jstr = [
        0,
        length,
        get,
        get_jstr,
        empty,
        sp,
        nl,
        append,
        append,
        concat,
        pad_start,
        pad_end,
        repeat,
        find_sub,
        find_last_sub,
        slice,
        sub,
        cuts,
        fold_uchars,
        fold_jstr_uchars,
        trim,
        normalized,
        lowercased,
        uppercased,
        is_empty,
        starts_with,
        includes,
        ends_with,
        equal,
        compare,
        of_uchar,
        of_char,
        to_int,
        jstr_of_int,
        to_float,
        of_float
    ];
    runtime.caml_register_global(46, Jstr, "Jstr");
    return;
})(globalThis);
//# 195 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_js_get = runtime.caml_js_get, caml_js_set = runtime.caml_js_set, caml_js_strict_equals = runtime.caml_js_strict_equals, caml_js_to_bool = runtime.caml_js_to_bool, caml_js_wrap_callback_strict = runtime.caml_js_wrap_callback_strict, caml_string_compare = runtime.caml_string_compare, caml_string_of_jsstring = runtime.caml_string_of_jsstring;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Array = global_data.Stdlib__Array, Stdlib_List = global_data.Stdlib__List, Jsoo_runtime = global_data.Jsoo_runtime, null$0 = null, undefined$0 = undefined;
    function is_null(v) {
        return v === null$0 ? 1 : 0;
    }
    function is_undefined(v) {
        return v === undefined$0 ? 1 : 0;
    }
    function is_none(v) {
        var _g_ = v === null$0 ? 1 : 0;
        return _g_ ? _g_ : v === undefined$0 ? 1 : 0;
    }
    function is_some(v) {
        return 1 - is_none(v);
    }
    function to_option(conv, v) {
        return is_none(v) ? 0 : [
            0,
            caml_call1(conv, v)
        ];
    }
    function of_option(none, conv, param) {
        if (!param) return none;
        var v = param[1];
        return caml_call1(conv, v);
    }
    var global = globalThis1;
    function set_if_some(o, p, param) {
        if (!param) return 0;
        var v = param[1];
        return o[p] = v;
    }
    function find(o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            v
        ];
    }
    function find_map(f, o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            caml_call1(f, v)
        ];
    }
    function find_path(o, param) {
        var o$0 = o, param$0 = param;
        for(;;){
            if (!param$0) return [
                0,
                o$0
            ];
            var ps = param$0[2], p = param$0[1], match = find(o$0, p);
            if (!match) return 0;
            var o$1 = match[1];
            o$0 = o$1;
            param$0 = ps;
        }
    }
    var true$0 = true, false$0 = false;
    function find$0(o, p) {
        var b = o[p];
        return is_none(b) ? 0 : [
            0,
            b | 0
        ];
    }
    function get(o, p) {
        return o[p] | 0;
    }
    function set(o, p, b) {
        return o[p] = !!b;
    }
    function set_if_some$0(o, p, param) {
        if (!param) return 0;
        var b = param[1];
        return set(o, p, b);
    }
    var Bool = [
        0,
        find$0,
        get,
        set,
        set_if_some$0
    ];
    function find$1(o, p) {
        var i = o[p];
        return is_none(i) ? 0 : [
            0,
            i
        ];
    }
    var get$0 = caml_js_get, set$0 = caml_js_set;
    function set_if_some$1(o, p, param) {
        if (!param) return 0;
        var i = param[1];
        return o[p] = i;
    }
    var Int = [
        0,
        find$1,
        get$0,
        set$0,
        set_if_some$1
    ];
    function find$2(o, p) {
        var f = o[p];
        return is_none(f) ? 0 : [
            0,
            f
        ];
    }
    var get$1 = caml_js_get, set$1 = caml_js_set;
    function set_if_some$2(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    var Float = [
        0,
        find$2,
        get$1,
        set$1,
        set_if_some$2
    ];
    function find$3(o, p) {
        var f = o[p];
        return is_none(f) ? 0 : [
            0,
            f | 0
        ];
    }
    function get$2(o, p) {
        return o[p] | 0;
    }
    var set$2 = caml_js_set;
    function set_if_some$3(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    var Int32 = [
        0,
        find$3,
        get$2,
        set$2,
        set_if_some$3
    ];
    function find$4(o, p) {
        var s = o[p];
        return is_none(s) ? 0 : [
            0,
            s
        ];
    }
    var get$3 = caml_js_get, set$3 = caml_js_set;
    function set_if_some$4(o, p, param) {
        if (!param) return 0;
        var f = param[1];
        return o[p] = f;
    }
    function is_array(jv) {
        return global.Array.isArray(jv) | 0;
    }
    function create(n) {
        return new global.Array(n);
    }
    function length(a) {
        return a.length;
    }
    var Jarray = [
        0,
        create,
        length
    ];
    function to_array(conv, v) {
        var len = caml_call1(Jarray[2], v);
        return caml_call2(Stdlib_Array[1], len, function(i) {
            return caml_call1(conv, v[i]);
        });
    }
    function of_array(conv, a) {
        var len = a.length - 1, ja = caml_call1(Jarray[1], len), _e_ = len - 1 | 0, _d_ = 0;
        if (_e_ >= 0) {
            var i = _d_;
            for(;;){
                ja[i] = caml_call1(conv, runtime.caml_check_bound(a, i)[1 + i]);
                var _f_ = i + 1 | 0;
                if (_e_ === i) break;
                i = _f_;
            }
        }
        return ja;
    }
    function to_list(conv, v) {
        var len = caml_call1(Jarray[2], v);
        return caml_call2(Stdlib_List[11], len, function(i) {
            return caml_call1(conv, v[i]);
        });
    }
    function of_list(conv, l) {
        var ja = caml_call1(Jarray[1], 0), i = 0, param = l;
        for(;;){
            if (!param) return ja;
            var vs = param[2], v = param[1];
            ja[i] = caml_call1(conv, v);
            var i$0 = i + 1 | 0;
            i = i$0;
            param = vs;
        }
    }
    function v(name, msg) {
        var e = new global.Error(msg);
        if (!name) return e;
        var n = name[1];
        e.name = n;
        return e;
    }
    function name(e) {
        return e.name;
    }
    function enum$0(e) {
        var match = caml_string_of_jsstring(e.name), switch$0 = caml_string_compare(match, "NotAllowedError");
        if (0 <= switch$0) {
            if (0 >= switch$0) return 971339429;
            var switch$1 = caml_string_compare(match, "SyntaxError");
            if (0 <= switch$1) {
                if (0 >= switch$1) return 148000204;
                if (match === "TimeoutError") return -129520566;
                if (match === "TransactionInactiveError") return -28376747;
                if (match === "TypeMismatchError") return -823442212;
                if (match === "URLMismatchError") return 147573767;
                if (match === "UnknownError") return -1064646157;
                if (match === "VersionError") return -1025659903;
                if (match === "WrongDocumentError") return -937074026;
            } else {
                if (match === "NotFoundError") return 829592127;
                if (match === "NotReadableError") return -119831547;
                if (match === "NotSupportedError") return -935732949;
                if (match === "OperationError") return 115193424;
                if (match === "QuotaExceededError") return 246360739;
                if (match === "ReadOnlyError") return 842968798;
                if (match === "SecurityError") return 496062953;
            }
        } else {
            var switch$2 = caml_string_compare(match, "InvalidAccessError");
            if (0 <= switch$2) {
                if (0 >= switch$2) return 753062229;
                if (match === "InvalidCharacterError") return 197539530;
                if (match === "InvalidModificationError") return 943132429;
                if (match === "InvalidNodeTypeError") return -94613768;
                if (match === "InvalidStateError") return 986514226;
                if (match === "NamespaceError") return 861236164;
                if (match === "NetworkError") return 943709719;
                if (match === "NoModificationAllowedError") return 320841004;
            } else {
                if (match === "AbortError") return 183065241;
                if (match === "ConstraintError") return 539235142;
                if (match === "DataCloneError") return 1031143793;
                if (match === "DataError") return 483354835;
                if (match === "EncodingError") return 518067260;
                if (match === "HierarchyRequestError") return 227342318;
                if (match === "IndexSizeError") return 89185783;
            }
        }
        return -912009552;
    }
    function message(e) {
        return e.message;
    }
    function stack(e) {
        return e.stack;
    }
    function throw$0(name, msg) {
        var e = v(name, msg);
        return caml_call1(function(exn) {
            throw exn;
        }, e);
    }
    var Error1 = Jsoo_runtime[3][4], symbol = Symbol.iterator;
    function iterable(o) {
        var match = to_option(function(_c_) {
            return _c_;
        }, o[symbol]);
        if (!match) return 0;
        var func = match[1];
        return func();
    }
    function iterator(o) {
        return o[symbol]();
    }
    function next(it) {
        return it.next();
    }
    function result_done(o) {
        var match = to_option(caml_js_to_bool, o.done);
        if (!match) return 0;
        var d = match[1];
        return d;
    }
    function result_value(o) {
        return to_option(function(_b_) {
            return _b_;
        }, o.value);
    }
    function get_result_value(o) {
        return o.value;
    }
    function fold(of_jv, f, it, acc) {
        var acc$0 = acc;
        for(;;){
            var r = it.next();
            if (result_done(r)) return acc$0;
            var acc$1 = caml_call2(f, caml_call1(of_jv, r.value), acc$0);
            acc$0 = acc$1;
        }
    }
    function fold_bindings(key, value, f, it, acc) {
        var acc$0 = acc;
        for(;;){
            var r = it.next();
            if (result_done(r)) return acc$0;
            var arr = r.value, _a_ = caml_call1(value, arr[1]), acc$1 = caml_call3(f, caml_call1(key, arr[0]), _a_, acc$0);
            acc$0 = acc$1;
        }
    }
    var promise = global.Promise;
    function create$0(f) {
        function g(res, rej) {
            return caml_call2(f, function(x) {
                return res(x);
            }, function(x) {
                return rej(x);
            });
        }
        return new promise(caml_js_wrap_callback_strict(2, g));
    }
    function resolve(v) {
        return promise.resolve(v);
    }
    function reject(v) {
        return promise.reject(v);
    }
    function await$0(p, k) {
        p.then(caml_js_wrap_callback_strict(1, k));
        return 0;
    }
    function bind(p, res) {
        return p.then(caml_js_wrap_callback_strict(1, res));
    }
    function then(p, res, rej) {
        return p.then(caml_js_wrap_callback_strict(1, res), caml_js_wrap_callback_strict(1, rej));
    }
    function all(arr) {
        return promise.all(arr);
    }
    function find$5(o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            v
        ];
    }
    function find_map$0(f, o, p) {
        var v = o[p];
        return is_none(v) ? 0 : [
            0,
            caml_call1(f, v)
        ];
    }
    function obj(props) {
        return runtime.caml_js_object(caml_call2(Stdlib_Array[14], function(param) {
            var v = param[2], p = param[1];
            return [
                0,
                caml_string_of_jsstring(p),
                v
            ];
        }, props));
    }
    function call(o, m, args) {
        return runtime.caml_js_meth_call(o, caml_string_of_jsstring(m), args);
    }
    function has(p, v) {
        return is_some(v[p]);
    }
    function defined(v) {
        return is_some(v);
    }
    var Id = [
        0
    ], Jv = [
        0,
        caml_js_strict_equals,
        runtime.caml_js_typeof,
        runtime.caml_js_instanceof,
        null$0,
        undefined$0,
        is_null,
        is_undefined,
        is_none,
        is_some,
        to_option,
        of_option,
        global,
        find,
        find_map,
        find_path,
        set_if_some,
        true$0,
        false$0,
        Bool,
        Int,
        Float,
        Int32,
        [
            0,
            find$4,
            get$3,
            set$3,
            set_if_some$4
        ],
        runtime.caml_jsstring_of_string,
        caml_string_of_jsstring,
        is_array,
        to_array,
        of_array,
        to_list,
        of_list,
        Jarray,
        [
            0,
            v,
            name,
            enum$0,
            message,
            stack
        ],
        Error1,
        throw$0,
        [
            0,
            result_done,
            result_value,
            get_result_value,
            iterable,
            iterator,
            next,
            fold,
            fold_bindings
        ],
        [
            0,
            create$0,
            resolve,
            reject,
            await$0,
            bind,
            then,
            all
        ],
        find$5,
        find_map$0,
        obj,
        call,
        has,
        defined,
        Id
    ];
    runtime.caml_register_global(62, Jv, "Jv");
    return;
})(globalThis);
//# 562 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Result = global_data.Stdlib__Result, Jv = global_data.Jv, Assert_failure = global_data.Assert_failure, _a_ = [
        0,
        "src/fut.ml",
        34,
        25
    ];
    function promise(f) {
        return f.fut;
    }
    function create(param) {
        function not_set(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _a_
            ], 1);
        }
        function is_set(param) {
            return caml_call2(Jv[34], 0, "The future is already set");
        }
        var setter = [
            0,
            not_set
        ];
        function set_setter(resolve, reject) {
            setter[1] = resolve;
            return 0;
        }
        var p = caml_call1(Jv[36][1], set_setter);
        function set(v) {
            caml_call1(setter[1], v);
            setter[1] = is_set;
            return 0;
        }
        return [
            0,
            {
                fut: p
            },
            set
        ];
    }
    function await$0(f, k) {
        return caml_call2(Jv[36][4], f.fut, k);
    }
    function return$0(v) {
        var p = caml_call1(Jv[36][2], v);
        return {
            fut: p
        };
    }
    function bind(f, fn) {
        var p = caml_call2(Jv[36][5], f.fut, function(v) {
            var f = caml_call1(fn, v);
            return f.fut;
        });
        return {
            fut: p
        };
    }
    function map(fn, f) {
        return bind(f, function(v) {
            return return$0(caml_call1(fn, v));
        });
    }
    function pair(f0, f1) {
        var p = caml_call1(caml_call1(Jv[36][5], f0.fut), function(v0) {
            return caml_call1(caml_call1(Jv[36][5], f1.fut), function(v1) {
                return caml_call1(Jv[36][2], [
                    0,
                    v0,
                    v1
                ]);
            });
        });
        return {
            fut: p
        };
    }
    function of_list(fs) {
        var arr = caml_call2(Jv[30], promise, fs), all = caml_call1(Jv[36][7], arr);
        function to_list(l) {
            var _f_ = caml_call2(Jv[29], function(_g_) {
                return _g_;
            }, l);
            return caml_call1(Jv[36][2], _f_);
        }
        var p = caml_call2(Jv[36][5], all, to_list);
        return {
            fut: p
        };
    }
    function tick(ms) {
        var p = caml_call1(Jv[36][1], function(res, rej) {
            Jv[12].setTimeout(runtime.caml_js_wrap_callback_strict(1, res), ms);
            return 0;
        });
        return {
            fut: p
        };
    }
    function ok(v) {
        return return$0([
            0,
            v
        ]);
    }
    function error(e) {
        return return$0([
            1,
            e
        ]);
    }
    function of_promise(ok, error, p) {
        function ok$0(v) {
            var _e_ = [
                0,
                caml_call1(ok, v)
            ];
            return caml_call1(Jv[36][2], _e_);
        }
        function error$0(e) {
            var _d_ = [
                1,
                caml_call1(error, e)
            ];
            return caml_call1(Jv[36][2], _d_);
        }
        var p$0 = caml_call3(Jv[36][6], p, ok$0, error$0);
        return {
            fut: p$0
        };
    }
    function to_promise(ok, error, f) {
        return caml_call1(Jv[36][1], function(res, rej) {
            return await$0(f, function(param) {
                if (0 === param[0]) {
                    var v = param[1];
                    return caml_call1(res, caml_call1(ok, v));
                }
                var e = param[1];
                return caml_call1(rej, caml_call1(error, e));
            });
        });
    }
    function of_promise$0(ok, v) {
        return of_promise(ok, function(_c_) {
            return _c_;
        }, v);
    }
    function to_promise$0(ok, v) {
        return to_promise(ok, function(_b_) {
            return _b_;
        }, v);
    }
    function let$0(f, fn) {
        return map(fn, f);
    }
    var Syntax = [
        0,
        bind,
        pair,
        let$0,
        pair
    ];
    function result_pair(r0, r1) {
        if (0 === r0[0]) {
            var v0 = r0[1];
            if (0 === r1[0]) {
                var v1 = r1[1];
                return [
                    0,
                    [
                        0,
                        v0,
                        v1
                    ]
                ];
            }
            var r = r1;
        } else var r = r0;
        return r;
    }
    function let$1(f, fn) {
        return bind(f, function(e) {
            if (0 !== e[0]) return return$0(e);
            var v = e[1];
            return caml_call1(fn, v);
        });
    }
    function and(f0, f1) {
        return map(result_pair, pair(f0, f1));
    }
    function let$2(f, fn) {
        return map(caml_call1(Stdlib_Result[8], fn), f);
    }
    var Fut = [
        0,
        create,
        await$0,
        return$0,
        map,
        bind,
        pair,
        of_list,
        tick,
        ok,
        error,
        of_promise$0,
        to_promise$0,
        of_promise,
        to_promise,
        Syntax,
        [
            0,
            let$1,
            and,
            let$2,
            and
        ]
    ];
    runtime.caml_register_global(9, Fut, "Fut");
    return;
})(globalThis);
//# 736 "../.js/default/brr/brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = " ", cst_Float32Array = "Float32Array", cst_Float64Array = "Float64Array", cst_Int16Array = "Int16Array", cst_Int32Array = "Int32Array", cst_Int8Array = "Int8Array", cst_Uint16Array = "Uint16Array", cst_Uint32Array = "Uint32Array", cst_Uint8Array = "Uint8Array", cst_Uint8ClampedArray = "Uint8ClampedArray", cst_abort = "abort", cst_altKey$1 = "altKey", cst_append = "append", cst_auto = "auto", cst_blur = "blur", cst_body = "body", cst_bubbles$1 = "bubbles", cst_button$0 = "button", cst_byteLength$1 = "byteLength", cst_cancelable$1 = "cancelable", cst_checked = "checked", cst_clear$0 = "clear", cst_click = "click", cst_close = "close", cst_code$0 = "code", cst_composed$1 = "composed", cst_copy = "copy", cst_ctrlKey$1 = "ctrlKey", cst_data$1 = "data", cst_dataTransfer$1 = "dataTransfer", cst_dblclick = "dblclick", cst_dir$0 = "dir", cst_dropEffect$1 = "dropEffect", cst_effectAllowed$1 = "effectAllowed", cst_error$0 = "error", cst_focus = "focus", cst_hash$2 = "hash", cst_head = "head", cst_height$1 = "height", cst_hidden = "hidden", cst_hostname$1 = "hostname", cst_id = "id", cst_input = "input", cst_isComposing$1 = "isComposing", cst_lastModified$1 = "lastModified", cst_length$4 = "length", cst_link = "link", cst_location$0 = "location", cst_map = "map", cst_mark = "mark", cst_measure = "measure", cst_metaKey$1 = "metaKey", cst_name$2 = "name", cst_nodeType$1 = "nodeType", cst_open = "open", cst_pathname$1 = "pathname", cst_port$1 = "port", cst_progress = "progress", cst_protocol$1 = "protocol", cst_relatedTarget$1 = "relatedTarget", cst_reload = "reload", cst_scrollRestoration$1 = "scrollRestoration", cst_search$2 = "search", cst_select = "select", cst_shiftKey$1 = "shiftKey", cst_style = "style", cst_table$0 = "table", cst_time$0 = "time", cst_timeStamp$1 = "timeStamp", cst_title$1 = "title", cst_type$4 = "type", cst_value = "value", cst_width$1 = "width", caml_js_from_bool = runtime.caml_js_from_bool, caml_js_get = runtime.caml_js_get, caml_js_meth_call = runtime.caml_js_meth_call, caml_js_set = runtime.caml_js_set, caml_js_wrap_callback_strict = runtime.caml_js_wrap_callback_strict, caml_list_of_js_array = runtime.caml_list_of_js_array, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Jv = global_data.Jv, Jstr = global_data.Jstr, Fut = global_data.Fut, Stdlib_List = global_data.Stdlib__List, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Bigarray = global_data.Stdlib__Bigarray, Stdlib_Sys = global_data.Stdlib__Sys, Type = [
        0
    ], cst_bubbles = cst_bubbles$1, cst_cancelable = cst_cancelable$1, cst_composed = cst_composed$1;
    function init(bubbles, cancelable, composed, param) {
        var o = {};
        caml_call3(Jv[19][4], o, cst_bubbles, bubbles);
        caml_call3(Jv[19][4], o, cst_cancelable, cancelable);
        caml_call3(Jv[19][4], o, cst_composed, composed);
        return o;
    }
    var event = Jv[12].Event, cst_type = cst_type$4, cst_eventPhase = "eventPhase", cst_bubbles$0 = cst_bubbles$1, cst_cancelable$0 = cst_cancelable$1, cst_defaultPrevented = "defaultPrevented", cst_composed$0 = cst_composed$1, cst_isTrusted = "isTrusted", cst_timeStamp = cst_timeStamp$1, cst_capture = "capture", cst_once = "once", cst_passive = "passive", _a_ = [
        0,
        1
    ];
    function create(opt, t) {
        var init = opt ? opt[1] : {};
        return new event(t, init);
    }
    function type(e) {
        return caml_call2(Jv[23][2], e, cst_type);
    }
    function target(e) {
        return e.target;
    }
    function current_target(e) {
        return e.currentTarget;
    }
    function composed_path(e) {
        var _c8_ = e.composedPath();
        return caml_call2(Jv[29], function(_c9_) {
            return _c9_;
        }, _c8_);
    }
    function event_phase(e) {
        var switcher = caml_call2(Jv[20][2], e, cst_eventPhase) - 1 | 0;
        if (2 < switcher >>> 0) return 870530776;
        switch(switcher){
            case 0:
                return 497141539;
            case 1:
                return -276077507;
            default:
                return 608305129;
        }
    }
    function bubbles(e) {
        return caml_call2(Jv[19][2], e, cst_bubbles$0);
    }
    function stop_propagation(e) {
        e.stopPropagation();
        return 0;
    }
    function stop_immediate_propagation(e) {
        e.stopImmediatePropagation();
        return 0;
    }
    function cancelable(e) {
        return caml_call2(Jv[19][2], e, cst_cancelable$0);
    }
    function prevent_default(e) {
        e.preventDefault();
        return 0;
    }
    function default_prevented(e) {
        return caml_call2(Jv[19][2], e, cst_defaultPrevented);
    }
    function composed(e) {
        return caml_call2(Jv[19][2], e, cst_composed$0);
    }
    function is_trusted(e) {
        return caml_call2(Jv[19][2], e, cst_isTrusted);
    }
    function timestamp_ms(e) {
        return caml_call2(Jv[21][2], e, cst_timeStamp);
    }
    function dispatch(e, t) {
        return t.dispatchEvent(e) | 0;
    }
    function listen_opts(capture, once, passive, param) {
        var o = {};
        caml_call3(Jv[19][4], o, cst_capture, capture);
        caml_call3(Jv[19][4], o, cst_once, once);
        caml_call3(Jv[19][4], o, cst_passive, passive);
        return o;
    }
    function listen(opt, type, f, t) {
        var opts = opt ? opt[1] : {}, f$0 = caml_js_wrap_callback_strict(1, f);
        function unlisten(param) {
            t.removeEventListener(type, f$0, opts);
            return 0;
        }
        t.addEventListener(type, f$0, opts);
        return unlisten;
    }
    function unlisten(unlisten) {
        return caml_call1(unlisten, 0);
    }
    function next(capture, type, t) {
        var match = caml_call1(Fut[1], 0), set = match[2], fut = match[1], opts = listen_opts(capture, _a_, 0, 0);
        listen([
            0,
            opts
        ], type, set, t);
        return fut;
    }
    var none = "none", copy = cst_copy, copy_link = "copyLink", copy_move = "copyMove", link = cst_link, link_move = "linkMove", move = "move", all = "all", uninitialized = "uninitialized", Effect = [
        0,
        none,
        copy,
        copy_link,
        copy_move,
        link,
        link_move,
        move,
        all,
        uninitialized
    ], file = "file", string = "string", Kind = [
        0,
        file,
        string
    ], cst_kind = "kind", cst_type$0 = cst_type$4;
    function kind(i) {
        return caml_call2(Jv[23][2], i, cst_kind);
    }
    function type$0(i) {
        return caml_call2(Jv[23][2], i, cst_type$0);
    }
    function get_file(i) {
        var _c6_ = i.getAsFile();
        return caml_call2(Jv[10], function(_c7_) {
            return _c7_;
        }, _c6_);
    }
    function get_jstr(i) {
        var match = caml_call1(Fut[1], 0), set_str = match[2], str = match[1], set_str$0 = caml_js_wrap_callback_strict(1, set_str);
        i.getAsString(set_str$0);
        return str;
    }
    var Item = [
        0,
        Kind,
        kind,
        type$0,
        get_file,
        get_jstr
    ], cst_length = cst_length$4, cst_dropEffect = cst_dropEffect$1, cst_dropEffect$0 = cst_dropEffect$1, cst_effectAllowed = cst_effectAllowed$1, cst_effectAllowed$0 = cst_effectAllowed$1, cst_clipboardData = "clipboardData";
    function length(l) {
        return caml_call2(Jv[20][2], l, cst_length);
    }
    function add_jstr(l, type, str) {
        var _c4_ = l.add(str, type);
        return caml_call1(caml_call1(Jv[10], function(_c5_) {
            return _c5_;
        }), _c4_);
    }
    function add_file(t, file) {
        var _c2_ = t.add(file);
        return caml_call1(caml_call1(Jv[10], function(_c3_) {
            return _c3_;
        }), _c2_);
    }
    function remove(l, i) {
        l.remove(i);
        return 0;
    }
    function clear(l) {
        l.clear();
        return 0;
    }
    function items(l) {
        var acc = [
            0,
            0
        ], _cZ_ = length(l) - 1 | 0;
        if (_cZ_ >= 0) {
            var i = _cZ_;
            for(;;){
                var _c0_ = acc[1];
                acc[1] = [
                    0,
                    l[i],
                    _c0_
                ];
                var _c1_ = i - 1 | 0;
                if (0 === i) break;
                i = _c1_;
            }
        }
        return acc[1];
    }
    function drop_effect(d) {
        return caml_call2(Jv[23][2], d, cst_dropEffect);
    }
    function set_drop_effect(d, e) {
        return caml_call3(Jv[23][3], d, cst_dropEffect$0, e);
    }
    function effect_allowed(d) {
        return caml_call2(Jv[23][2], d, cst_effectAllowed);
    }
    function set_effect_allowed(d, e) {
        return caml_call3(Jv[23][3], d, cst_effectAllowed$0, e);
    }
    function items$0(d) {
        return d.items;
    }
    function data(c) {
        return caml_call3(Jv[14], function(_cY_) {
            return _cY_;
        }, c, cst_clipboardData);
    }
    var Clipboard = [
        0,
        data
    ], cst_data = cst_data$1;
    function data$0(i) {
        return caml_call2(Jv[23][2], i, cst_data);
    }
    var Composition = [
        0,
        data$0
    ], cst_message = "message", cst_filename = "filename", cst_lineno = "lineno", cst_colno = "colno";
    function message(e) {
        return caml_call2(Jv[23][2], e, cst_message);
    }
    function filename(e) {
        return caml_call2(Jv[23][2], e, cst_filename);
    }
    function lineno(e) {
        return caml_call2(Jv[20][2], e, cst_lineno);
    }
    function colno(e) {
        return caml_call2(Jv[20][2], e, cst_colno);
    }
    function error(e) {
        return e.error;
    }
    var Error1 = [
        0,
        message,
        filename,
        lineno,
        colno,
        error
    ];
    function wait_until(e, fut) {
        e.waitUntil(caml_call2(Fut[12], function(_cX_) {
            return _cX_;
        }, fut));
        return 0;
    }
    var Extendable = [
        0,
        wait_until
    ], cst_relatedTarget = cst_relatedTarget$1;
    function related_target(m) {
        return caml_call3(Jv[14], function(_cW_) {
            return _cW_;
        }, m, cst_relatedTarget);
    }
    var Focus = [
        0,
        related_target
    ], cst_oldURL = "oldURL", cst_newURL = "newURL";
    function old_url(e) {
        return caml_call2(Jv[23][2], e, cst_oldURL);
    }
    function new_url(e) {
        return caml_call2(Jv[23][2], e, cst_newURL);
    }
    var Hash_change = [
        0,
        old_url,
        new_url
    ], cst_data$0 = cst_data$1, cst_dataTransfer = cst_dataTransfer$1, cst_inputType = "inputType", cst_isComposing = cst_isComposing$1;
    function data$1(i) {
        return caml_call2(Jv[23][2], i, cst_data$0);
    }
    function data_transfer(i) {
        return caml_call2(Jv[13], i, cst_dataTransfer);
    }
    function input_type(i) {
        return caml_call2(Jv[23][2], i, cst_inputType);
    }
    function is_composing(i) {
        return caml_call2(Jv[19][2], i, cst_isComposing);
    }
    var Input = [
        0,
        data$1,
        data_transfer,
        input_type,
        is_composing
    ], Location = [
        0,
        0,
        1,
        2,
        3
    ], cst_key = "key", cst_code = cst_code$0, cst_location = cst_location$0, cst_repeat = "repeat", cst_isComposing$0 = cst_isComposing$1, cst_altKey = cst_altKey$1, cst_ctrlKey = cst_ctrlKey$1, cst_shiftKey = cst_shiftKey$1, cst_metaKey = cst_metaKey$1;
    function key(k) {
        return caml_call2(Jv[23][2], k, cst_key);
    }
    function code(k) {
        return caml_call2(Jv[23][2], k, cst_code);
    }
    function location(k) {
        return caml_call2(Jv[20][2], k, cst_location);
    }
    function repeat(k) {
        return caml_call2(Jv[19][2], k, cst_repeat);
    }
    function is_composing$0(k) {
        return caml_call2(Jv[19][2], k, cst_isComposing$0);
    }
    function alt_key(k) {
        return caml_call2(Jv[19][2], k, cst_altKey);
    }
    function ctrl_key(k) {
        return caml_call2(Jv[19][2], k, cst_ctrlKey);
    }
    function shift_key(k) {
        return caml_call2(Jv[19][2], k, cst_shiftKey);
    }
    function meta_key(k) {
        return caml_call2(Jv[19][2], k, cst_metaKey);
    }
    function get_modifier_state(k, key) {
        return k.getModifierState(key) | 0;
    }
    var Keyboard = [
        0,
        Location,
        key,
        code,
        location,
        repeat,
        is_composing$0,
        alt_key,
        ctrl_key,
        shift_key,
        meta_key,
        get_modifier_state
    ], cst_relatedTarget$0 = cst_relatedTarget$1, cst_offsetX = "offsetX", cst_offsetY = "offsetY", cst_clientX = "clientX", cst_clientY = "clientY", cst_pageX = "pageX", cst_pageY = "pageY", cst_screenX = "screenX", cst_screenY = "screenY", cst_movementX = "movementX", cst_movementY = "movementY", cst_button = cst_button$0, cst_buttons = "buttons", cst_altKey$0 = cst_altKey$1, cst_ctrlKey$0 = cst_ctrlKey$1, cst_shiftKey$0 = cst_shiftKey$1, cst_metaKey$0 = cst_metaKey$1;
    function related_target$0(m) {
        return caml_call3(Jv[14], function(_cV_) {
            return _cV_;
        }, m, cst_relatedTarget$0);
    }
    function offset_x(m) {
        return caml_call2(Jv[21][2], m, cst_offsetX);
    }
    function offset_y(m) {
        return caml_call2(Jv[21][2], m, cst_offsetY);
    }
    function client_x(m) {
        return caml_call2(Jv[21][2], m, cst_clientX);
    }
    function client_y(m) {
        return caml_call2(Jv[21][2], m, cst_clientY);
    }
    function page_x(m) {
        return caml_call2(Jv[21][2], m, cst_pageX);
    }
    function page_y(m) {
        return caml_call2(Jv[21][2], m, cst_pageY);
    }
    function screen_x(m) {
        return caml_call2(Jv[21][2], m, cst_screenX);
    }
    function screen_y(m) {
        return caml_call2(Jv[21][2], m, cst_screenY);
    }
    function movement_x(m) {
        return caml_call2(Jv[21][2], m, cst_movementX);
    }
    function movement_y(m) {
        return caml_call2(Jv[21][2], m, cst_movementY);
    }
    function button(m) {
        return caml_call2(Jv[20][2], m, cst_button);
    }
    function buttons(m) {
        return caml_call2(Jv[20][2], m, cst_buttons);
    }
    function alt_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_altKey$0);
    }
    function ctrl_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_ctrlKey$0);
    }
    function shift_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_shiftKey$0);
    }
    function meta_key$0(m) {
        return caml_call2(Jv[19][2], m, cst_metaKey$0);
    }
    function get_modifier_state$0(m, key) {
        return m.getModifierState(key) | 0;
    }
    var Mouse = [
        0,
        related_target$0,
        offset_x,
        offset_y,
        client_x,
        client_y,
        page_x,
        page_y,
        screen_x,
        screen_y,
        movement_x,
        movement_y,
        button,
        buttons,
        alt_key$0,
        ctrl_key$0,
        shift_key$0,
        meta_key$0,
        get_modifier_state$0
    ], cst_dataTransfer$0 = cst_dataTransfer$1;
    function data_transfer$0(d) {
        return caml_call3(Jv[14], function(_cU_) {
            return _cU_;
        }, d, cst_dataTransfer$0);
    }
    var Drag = [
        0,
        data_transfer$0
    ], cst_pointerId = "pointerId", cst_width = cst_width$1, cst_height = cst_height$1, cst_pressure = "pressure", cst_tangentialPressure = "tangentialPressure", cst_tiltX = "tiltX", cst_tiltY = "tiltY", cst_twist = "twist", cst_altitudeAngle = "altitudeAngle", cst_azimuthAngle = "azimuthAngle", cst_pointerType = "pointerType", cst_isPrimary = "isPrimary";
    function id(p) {
        return caml_call2(Jv[20][2], p, cst_pointerId);
    }
    function width(p) {
        return caml_call2(Jv[21][2], p, cst_width);
    }
    function height(p) {
        return caml_call2(Jv[21][2], p, cst_height);
    }
    function pressure(p) {
        return caml_call2(Jv[21][2], p, cst_pressure);
    }
    function tangential_pressure(p) {
        return caml_call2(Jv[21][2], p, cst_tangentialPressure);
    }
    function tilt_x(p) {
        return caml_call2(Jv[20][2], p, cst_tiltX);
    }
    function tilt_y(p) {
        return caml_call2(Jv[20][2], p, cst_tiltY);
    }
    function twist(p) {
        return caml_call2(Jv[20][2], p, cst_twist);
    }
    function altitude_angle(p) {
        return caml_call2(Jv[21][2], p, cst_altitudeAngle);
    }
    function azimuth_angle(p) {
        return caml_call2(Jv[21][2], p, cst_azimuthAngle);
    }
    function type$1(p) {
        return caml_call2(Jv[23][2], p, cst_pointerType);
    }
    function is_primary(p) {
        return caml_call2(Jv[19][2], p, cst_isPrimary);
    }
    function get_coalesced_events(p) {
        var _cS_ = p.getCoalescedEvents();
        return caml_call2(Jv[29], function(_cT_) {
            return _cT_;
        }, _cS_);
    }
    function get_predicted_events(p) {
        var _cQ_ = p.getPredictedEvents();
        return caml_call2(Jv[29], function(_cR_) {
            return _cR_;
        }, _cQ_);
    }
    var Pointer = [
        0,
        id,
        width,
        height,
        pressure,
        tangential_pressure,
        tilt_x,
        tilt_y,
        twist,
        altitude_angle,
        azimuth_angle,
        type$1,
        is_primary,
        get_coalesced_events,
        get_predicted_events
    ], Delta_mode = [
        0,
        0,
        1,
        2
    ], cst_deltaX = "deltaX", cst_deltaY = "deltaY", cst_deltaZ = "deltaZ", cst_deltaMode = "deltaMode";
    function delta_x(w) {
        return caml_call2(Jv[21][2], w, cst_deltaX);
    }
    function delta_y(w) {
        return caml_call2(Jv[21][2], w, cst_deltaY);
    }
    function delta_z(w) {
        return caml_call2(Jv[21][2], w, cst_deltaZ);
    }
    function delta_mode(w) {
        return caml_call2(Jv[20][2], w, cst_deltaMode);
    }
    var Wheel = [
        0,
        Delta_mode,
        delta_x,
        delta_y,
        delta_z,
        delta_mode
    ], abort = cst_abort, activate = "activate", auxclick = cst_dblclick, beforeinput = "beforeinput", beforeunload = "beforeunload", blur = cst_blur, canplay = "canplay", canplaythrough = "canplaythrough", change = "change", click = cst_click, clipboardchange = "clipboardchange", close = cst_close, compositionend = "compositionend", compositionstart = "compositionstart", compositionudpate = "compositionupdate", controllerchange = "controllerchange", copy$0 = cst_copy, cut = "cut", dblclick = cst_dblclick, dom_content_loaded = "DOMContentLoaded", drag = "drag", dragend = "dragend", dragenter = "dragenter", dragexit = "dragexit", dragleave = "dragleave", dragover = "dragover", dragstart = "dragstart", drop = "drop", durationchange = "durationchange", emptied = "emptied", ended = "ended", error$0 = cst_error$0, focus = cst_focus, focusin = "focusin", focusout = "focusout", fullscreenchange = "fullscreenchange", fullscreenerror = "fullscreenerror", gotpointercapture = "gotpointercapture", hashchange = "hashchange", input = cst_input, install = "install", keydown = "keydown", keyup = "keyup", languagechange = "languagechange", load = "load", loadeddata = "loadeddata", loadedmetadata = "loadedmetadata", loadstart = "loadstart", lostpointercapture = "lostpointercapture", mousedown = "mousedown", mouseenter = "mouseenter", mouseleave = "mouseleave", mousemove = "mousemove", mouseout = "mouseout", mouseover = "mouseover", mouseup = "mouseup", open = cst_open, paste = "paste", pause = "pause", play = "play", playing = "playing", pointercancel = "pointercancel", pointerdown = "pointerdown", pointerenter = "pointerenter", pointerleave = "pointerleave", pointerlockchange = "pointerlockchange", pointerlockerror = "pointerlockerror", pointermove = "pointermove", pointerout = "pointerout", pointerover = "pointerover", pointerrawupdate = "pointerrawupdate", pointerup = "pointerup", progress = cst_progress, ratechange = "ratechange", reset = "reset", resize = "resize", scroll = "scroll", seeked = "seeked", seeking = "seeking", select = cst_select, stalled = "stalled", statechange = "statechange", suspend = "suspend", timeupdate = "timeupdate", unload = "unload", updatefound = "updatefound", visibilitychange = "visibilitychange", volumechange = "volumechange", waiting = "waiting", wheel = "wheel", array_buffer = Jv[12].ArrayBuffer, cst_byteLength = cst_byteLength$1, cst_byteOffset = "byteOffset", cst_byteLength$0 = cst_byteLength$1;
    function create$0(n) {
        return new array_buffer(n);
    }
    function byte_length(a) {
        return caml_call2(Jv[20][2], a, cst_byteLength);
    }
    function slice(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length(a);
        return a.slice(start, stop$1);
    }
    function buffer(o) {
        return o.buffer;
    }
    function byte_offset(o) {
        return caml_call2(Jv[20][2], o, cst_byteOffset);
    }
    function byte_length$0(o) {
        return caml_call2(Jv[20][2], o, cst_byteLength$0);
    }
    var dataview = Jv[12].DataView, cst_length$0 = cst_length$4, cst_name = cst_name$2;
    function of_buffer(opt, byte_length$0, b) {
        var byte_offset = opt ? opt[1] : 0;
        if (byte_length$0) var l = byte_length$0[1], byte_length$1 = l;
        else var byte_length$1 = byte_length(b);
        return new dataview(b, byte_offset, byte_length$1);
    }
    function get_int8(b, i) {
        return b.getInt8(i);
    }
    function get_int16_be(b, i) {
        return b.getInt16(i);
    }
    function get_int16_le(b, i) {
        return b.getInt16(i, Jv[17]);
    }
    function get_int32_be(b, i) {
        return b.getInt32(i) | 0;
    }
    function get_int32_le(b, i) {
        return b.getInt32(i, Jv[17]) | 0;
    }
    function get_uint8(b, i) {
        return b.getUint8(i);
    }
    function get_uint16_be(b, i) {
        return b.getUint16(i);
    }
    function get_uint16_le(b, i) {
        return b.getUint16(i, Jv[17]);
    }
    function get_uint32_be(b, i) {
        return b.getUint32(i) | 0;
    }
    function get_uint32_le(b, i) {
        return b.getUint32(i, Jv[17]) | 0;
    }
    function get_float32_be(b, i) {
        return b.getFloat32(i);
    }
    function get_float32_le(b, i) {
        return b.getFloat32(i, Jv[17]);
    }
    function get_float64_be(b, i) {
        return b.getFloat64(i);
    }
    function get_float64_le(b, i) {
        return b.getFloat64(i, Jv[17]);
    }
    function set_int8(b, i, v) {
        b.setInt8(i, v);
        return 0;
    }
    function set_int16_be(b, i, v) {
        b.setInt16(i, v);
        return 0;
    }
    function set_int16_le(b, i, v) {
        b.setInt16(i, v, Jv[17]);
        return 0;
    }
    function set_int32_be(b, i, v) {
        b.setInt32(i, v);
        return 0;
    }
    function set_int32_le(b, i, v) {
        b.setInt32(i, v, Jv[17]);
        return 0;
    }
    function set_uint8(b, i, v) {
        b.setUint8(i, v);
        return 0;
    }
    function set_uint16_be(b, i, v) {
        b.setUint16(i, v);
        return 0;
    }
    function set_uint16_le(b, i, v) {
        b.setUint16(i, v, Jv[17]);
        return 0;
    }
    function set_uint32_be(b, i, v) {
        b.setUint32(i, v);
        return 0;
    }
    function set_uint32_le(b, i, v) {
        b.setUint32(i, v, Jv[17]);
        return 0;
    }
    function set_float32_be(b, i, v) {
        b.setFloat32(i, v);
        return 0;
    }
    function set_float32_le(b, i, v) {
        b.setFloat32(i, v, Jv[17]);
        return 0;
    }
    function set_float64_be(b, i, v) {
        b.setFloat64(i, v);
        return 0;
    }
    function set_float64_le(b, i, v) {
        b.setFloat64(i, v, Jv[17]);
        return 0;
    }
    function type_size_in_bytes(param) {
        switch(param){
            case 8:
                return 8;
            case 1:
            case 5:
                return 2;
            case 0:
            case 3:
            case 4:
                return 1;
            default:
                return 4;
        }
    }
    function cons_of_type(param) {
        switch(param){
            case 0:
                return Jv[12].Int8Array;
            case 1:
                return Jv[12].Int16Array;
            case 2:
                return Jv[12].Int32Array;
            case 3:
                return Jv[12].Uint8Array;
            case 4:
                return Jv[12].Uint8ClampedArray;
            case 5:
                return Jv[12].Uint16Array;
            case 6:
                return Jv[12].Uint32Array;
            case 7:
                return Jv[12].Float32Array;
            default:
                return Jv[12].Float64Array;
        }
    }
    function create$1(t, n) {
        return new (cons_of_type(t))(n);
    }
    function of_buffer$0(t, opt, length, b) {
        var byte_offset = opt ? opt[1] : 0;
        if (length) var l = length[1], args = [
            0,
            b,
            byte_offset,
            l
        ];
        else var args = [
            0,
            b,
            byte_offset
        ];
        return runtime.caml_js_new(cons_of_type(t), args);
    }
    function length$0(a) {
        return caml_call2(Jv[20][2], a, cst_length$0);
    }
    function type$2(a) {
        var s = runtime.caml_string_of_jsstring(caml_call2(Jv[23][2], a.constructor, cst_name));
        if (s === cst_Float32Array) return 7;
        if (s === cst_Float64Array) return 8;
        if (s === cst_Int16Array) return 1;
        if (s === cst_Int32Array) return 2;
        if (s === cst_Int8Array) return 0;
        if (s === cst_Uint16Array) return 5;
        if (s === cst_Uint32Array) return 6;
        if (s === cst_Uint8Array) return 3;
        if (s === cst_Uint8ClampedArray) return 4;
        var t = runtime.caml_jsstring_of_string(s), _cP_ = caml_call2(Jstr[7], "Unknown typed array: ", t);
        return caml_call2(Jv[34], 0, _cP_);
    }
    function elt_to_jv(a) {
        switch(type$2(a)){
            case 0:
                return function(_cO_) {
                    return _cO_;
                };
            case 1:
                return function(_cN_) {
                    return _cN_;
                };
            case 2:
                return function(_cM_) {
                    return _cM_;
                };
            case 3:
                return function(_cL_) {
                    return _cL_;
                };
            case 4:
                return function(_cK_) {
                    return _cK_;
                };
            case 5:
                return function(_cJ_) {
                    return _cJ_;
                };
            case 6:
                return function(_cI_) {
                    return _cI_;
                };
            case 7:
                return function(_cH_) {
                    return _cH_;
                };
            default:
                return function(_cG_) {
                    return _cG_;
                };
        }
    }
    function elt_of_jv(a) {
        switch(type$2(a)){
            case 0:
                return function(_cF_) {
                    return _cF_;
                };
            case 1:
                return function(_cE_) {
                    return _cE_;
                };
            case 2:
                return function(_cD_) {
                    return _cD_ | 0;
                };
            case 3:
                return function(_cC_) {
                    return _cC_;
                };
            case 4:
                return function(_cB_) {
                    return _cB_;
                };
            case 5:
                return function(_cA_) {
                    return _cA_;
                };
            case 6:
                return function(_cz_) {
                    return _cz_ | 0;
                };
            case 7:
                return function(_cy_) {
                    return _cy_;
                };
            default:
                return function(_cx_) {
                    return _cx_;
                };
        }
    }
    var _b_ = Stdlib_Sys[5];
    a: {
        var cst_timeOrigin = "timeOrigin", cst_redirectCount = "redirectCount", cst_type$3 = "type'", cst_loadEventEnd = "loadEventEnd", cst_loadEventStart = "loadEventStart", cst_domComplete = "domComplete", cst_domContentLoadedEventEnd = "domContentLoadedEventEnd", cst_domContentLoadedEventStart = "domContentLoadedEventStart", cst_domInteractive = "domInteractive", cst_unloadEventEnd = "unloadEventEnd", cst_unloadEventStart = "unloadEventStart", cst_decodedBodySize = "decodedBodySize", cst_encodedBodySize = "encodedBodySize", cst_transferSize = "transferSize", cst_responseEnd = "responseEnd", cst_responseStart = "responseStart", cst_requestStart = "requestStart", cst_secureConnectionStart = "secureConnectionStart", cst_connectEnd = "connectEnd", cst_connectStart = "connectStart", cst_domainLookupEnd = "domainLookupEnd", cst_domainLookupStart = "domainLookupStart", cst_fetchStart = "fetchStart", cst_redirectEnd = "redirectEnd", cst_redirectStart = "redirectStart", cst_workerStart = "workerStart", cst_nextHopProtocol = "nextHopProtocol", cst_initiatorType = "initiatorType", cst_duration = "duration", cst_endTime = "endTime", cst_startTime = "startTime", cst_entryType = "entryType", cst_name$1 = cst_name$2, cst_onLine = "onLine", cst_languages = "languages", cst_language = "language", cst_scrollRestoration$0 = cst_scrollRestoration$1, cst_scrollRestoration = cst_scrollRestoration$1, cst_length$3 = cst_length$4, cst_matches = "matches", cst_devicePixelRatio = "devicePixelRatio", cst_scrollY = "scrollY", cst_scrollX = "scrollX", cst_closed = "closed", cst_timeStamp$0 = cst_timeStamp$1, cst_profileEnd = "profileEnd", cst_profile = "profile", cst_timeEnd = "timeEnd", cst_timeLog = "timeLog", cst_time = cst_time$0, cst_countReset = "countReset", cst_count = "count", cst_groupCollapsed = "groupCollapsed", cst_group = "group", cst_groupEnd = "groupEnd", cst_table = cst_table$0, cst_dir = cst_dir$0, cst_assert = "assert", cst_debug = "debug", cst_info = "info", cst_warn = "warn", cst_error = cst_error$0, cst_trace = "trace", cst_log = "log", cst_clear = cst_clear$0, cst_aborted = "aborted", cst_fullscreenEnabled = "fullscreenEnabled", cst_visibilityState = "visibilityState", cst_title$0 = cst_title$1, cst_title = cst_title$1, cst_referrer = "referrer", cst_files = "files", cst_navigationUI = "navigationUI", _q_ = [
            0,
            0
        ], _p_ = [
            0,
            1
        ], cst_scrollHeight = "scrollHeight", cst_scrollWidth = "scrollWidth", cst_scrollTop = "scrollTop", cst_scrollLeft = "scrollLeft", cst_height$0 = cst_height$1, cst_width$0 = cst_width$1, cst_y = "y", cst_x = "x", cst_clientHeight = "clientHeight", cst_clientWidth = "clientWidth", cst_clientTop = "clientTop", cst_clientLeft = "clientLeft", cst_nextElementSibling = "nextElementSibling", cst_previousElementSibling = "previousElementSibling", cst_parentNode = "parentNode", cst_length$2 = cst_length$4, cst_nodeValue = "nodeValue", cst_nodeName = "nodeName", cst_nodeType$0 = cst_nodeType$1, cst_nodeType = cst_nodeType$1, cst_length$1 = cst_length$4, cst_hash$1 = cst_hash$2, cst_search$1 = cst_search$2, _n_ = [
            0,
            1
        ], cst_hash$0 = cst_hash$2, _m_ = [
            0,
            1
        ], cst_search$0 = cst_search$2, _l_ = [
            0,
            1
        ], cst_pathname$0 = cst_pathname$1, cst_port$0 = cst_port$1, cst_hostname$0 = cst_hostname$1, cst_protocol$0 = cst_protocol$1, _k_ = [
            0,
            -1
        ], cst_protocol = cst_protocol$1, cst_hostname = cst_hostname$1, cst_port = cst_port$1, cst_pathname = cst_pathname$1, cst_search = cst_search$2, cst_hash = cst_hash$2, cst_lastModified$0 = cst_lastModified$1, cst_webkitRelativePath = "webkitRelativePath", cst_name$0 = cst_name$2, cst_lastModified = cst_lastModified$1, cst_lengthComputable = "lengthComputable", cst_loaded = "loaded", cst_total = "total", _j_ = [
            0,
            1
        ], cst_type$2 = cst_type$4, cst_size = "size", cst_type$1 = cst_type$4, cst_endings = "endings", _c_ = [
            0,
            7
        ], _d_ = [
            0,
            8
        ], _e_ = [
            0,
            0
        ], _f_ = [
            0,
            3
        ], _g_ = [
            0,
            1
        ], _h_ = [
            0,
            5
        ], _i_ = [
            0,
            2
        ], cst_utf_8 = "utf-8", cst_isSecureContext = "isSecureContext";
        if (typeof _b_ !== "number" && _b_[1] === "wasm_of_ocaml") {
            var compiled_to_wasm = 1;
            break a;
        }
        var compiled_to_wasm = 0;
    }
    var get = compiled_to_wasm ? function(a, i) {
        var _cw_ = a[i];
        return elt_of_jv(a)(_cw_);
    } : caml_js_get, set = compiled_to_wasm ? function(a, i, v) {
        return a[i] = elt_to_jv(a)(v);
    } : caml_js_set;
    function set_tarray(a, dst, b) {
        a.set(b, dst);
        return 0;
    }
    function fill(opt, stop, v, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = length$0(a);
        a.fill(elt_to_jv(a)(v), start, stop$1);
        return 0;
    }
    function copy_within(opt, stop, dst, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = length$0(a);
        a.copyWithin(dst, start, stop$1);
        return 0;
    }
    function slice$0(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$0(a);
        return a.slice(start, stop$1);
    }
    function sub(opt, stop, a) {
        var start = opt ? opt[1] : 0;
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$0(a);
        return a.subArray(start, stop$1);
    }
    function find(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        var _cv_ = a.find(caml_js_wrap_callback_strict(2, sat$0));
        return caml_call2(Jv[10], of_jv, _cv_);
    }
    function find_index(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        var i = a.findIndex(caml_js_wrap_callback_strict(2, sat$0));
        return -1 === i ? 0 : [
            0,
            i
        ];
    }
    function for_all(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.every(caml_js_wrap_callback_strict(2, sat$0)) | 0;
    }
    function exists(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.every(caml_js_wrap_callback_strict(2, sat$0)) | 0;
    }
    function filter(sat, a) {
        var of_jv = elt_of_jv(a);
        function sat$0(v, i) {
            return !!caml_call2(sat, i, of_jv(v));
        }
        return a.filter(caml_js_wrap_callback_strict(2, sat$0));
    }
    function iter(f, a) {
        var of_jv = elt_of_jv(a);
        function f$0(v, i) {
            return caml_call2(f, i, of_jv(v));
        }
        a.forEach(caml_js_wrap_callback_strict(2, f$0));
        return 0;
    }
    function map(f, a) {
        var of_jv = elt_of_jv(a);
        function f$0(v) {
            return caml_call1(f, of_jv(v));
        }
        return a.map(caml_js_wrap_callback_strict(1, f$0));
    }
    function fold_left(f, acc, a) {
        var of_jv = elt_of_jv(a);
        function f$0(acc, v) {
            return caml_call2(f, acc, of_jv(v));
        }
        return a.reduce(caml_js_wrap_callback_strict(2, f$0), acc);
    }
    function fold_right(f, a, acc) {
        var of_jv = elt_of_jv(a);
        function f$0(acc, v) {
            return caml_call2(f, of_jv(v), acc);
        }
        return a.reduceRight(caml_js_wrap_callback_strict(2, f$0), acc);
    }
    function reverse(a) {
        return a.reverse();
    }
    function of_tarray(t, a) {
        return new (cons_of_type(t))(a);
    }
    function of_int_array(t, a) {
        var _ct_ = caml_call2(Jv[28], function(_cu_) {
            return _cu_;
        }, a);
        return new (cons_of_type(t))(_ct_);
    }
    function of_float_array(t, a) {
        var _cr_ = caml_call2(Jv[28], function(_cs_) {
            return _cs_;
        }, a);
        return new (cons_of_type(t))(_cr_);
    }
    function to_int_jstr(opt, b) {
        var sep = opt ? opt[1] : Jstr[5];
        return b.join(sep);
    }
    function to_hex_jstr(opt, a) {
        var sep = opt ? opt[1] : Jstr[4], hex = "0123456789abcdef", d = of_buffer(0, 0, a.buffer), s = [
            0,
            Jstr[4]
        ], _cl_ = byte_length$0(d) - 1 | 0, _ck_ = 0;
        if (_cl_ >= 0) {
            var i = _ck_;
            for(;;){
                var b = d.getUint8(i), sep$0 = 0 === i ? Jstr[4] : sep, _cm_ = caml_call2(Jstr[3], hex, b & 15), _cn_ = caml_call2(Jstr[3], hex, b >>> 4 | 0), _co_ = caml_call2(Jstr[8], s[1], sep$0), _cp_ = caml_call2(Jstr[8], _co_, _cn_);
                s[1] = caml_call2(Jstr[8], _cp_, _cm_);
                var _cq_ = i + 1 | 0;
                if (_cl_ === i) break;
                i = _cq_;
            }
        }
        return s[1];
    }
    function uint8_of_buffer(b) {
        return of_buffer$0(3, 0, 0, b);
    }
    function of_jstr(s) {
        var enc = new Jv[12].TextEncoder;
        return enc.encode(s);
    }
    function to_jstr(a) {
        var _ci_ = {
            fatal: Jv[17]
        }, _cj_ = caml_call1(Jv[24], cst_utf_8), dec = new Jv[12].TextDecoder(_cj_, _ci_);
        try {
            var s = dec.decode(a);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            s
        ];
    }
    function of_binary_jstr(s) {
        try {
            var n = caml_call1(Jstr[1], s), b = new array_buffer(n), d = of_buffer(0, 0, b), _ce_ = caml_call1(Jstr[1], s) - 1 | 0, _cd_ = 0;
            if (_ce_ >= 0) {
                var i = _cd_;
                for(;;){
                    var c = s.charCodeAt(i);
                    if (255 < c) var _b__ = caml_call2(Jstr[33], 0, c), _b$_ = caml_call2(Jstr[33], 0, i), _ca_ = caml_call2(Jstr[8], _b$_, ": char code "), _cb_ = caml_call2(Jstr[8], _ca_, _b__), _cc_ = caml_call2(Jstr[8], _cb_, "exceeds 255"), _cg_ = caml_call2(Jv[34], 0, _cc_);
                    else var _cg_ = c;
                    set_int8(d, i, _cg_);
                    var _ch_ = i + 1 | 0;
                    if (_ce_ === i) break;
                    i = _ch_;
                }
            }
            var _cf_ = [
                0,
                of_buffer$0(0, 0, 0, b)
            ];
            return _cf_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function to_binary_jstr(a) {
        var d = of_buffer(0, 0, a.buffer), s = [
            0,
            Jstr[4]
        ], _b8_ = byte_length$0(d) - 1 | 0, _b7_ = 0;
        if (_b8_ >= 0) {
            var i = _b7_;
            for(;;){
                var b = d.getUint8(i), _b6_ = Jv[12].String.fromCharCode(b);
                s[1] = caml_call2(Jstr[8], s[1], _b6_);
                var _b9_ = i + 1 | 0;
                if (_b8_ === i) break;
                i = _b9_;
            }
        }
        return s[1];
    }
    function type_to_bigarray_kind(param) {
        switch(param){
            case 0:
                return Stdlib_Bigarray[6];
            case 1:
                return Stdlib_Bigarray[8];
            case 2:
                return Stdlib_Bigarray[11];
            case 3:
                return Stdlib_Bigarray[7];
            case 4:
                return Stdlib_Bigarray[7];
            case 5:
                return Stdlib_Bigarray[9];
            case 6:
                return Stdlib_Bigarray[11];
            case 7:
                return Stdlib_Bigarray[2];
            default:
                return Stdlib_Bigarray[3];
        }
    }
    function type_of_bigarray_kind(param) {
        switch(param){
            case 0:
                return _c_;
            case 1:
                return _d_;
            case 2:
                return _e_;
            case 3:
                return _f_;
            case 4:
                return _g_;
            case 5:
                return _h_;
            case 6:
                return _i_;
            default:
                return 0;
        }
    }
    var transparent = "transparent", native$0 = "native", Ending_type = [
        0,
        transparent,
        native$0
    ];
    function init$0(type, endings, param) {
        var o = {};
        caml_call3(Jv[23][4], o, cst_type$1, type);
        caml_call3(Jv[23][4], o, cst_endings, endings);
        return o;
    }
    var blob = Jv[12].Blob;
    function of_jstr$0(opt, s) {
        var init = opt ? opt[1] : Jv[5], a = caml_call1(Jv[31][1], 1);
        a[0] = s;
        return new blob(a, init);
    }
    function of_array_buffer(opt, b) {
        var init = opt ? opt[1] : Jv[5];
        return new blob(runtime.caml_js_from_array([
            0,
            b
        ]), init);
    }
    function byte_length$1(b) {
        return caml_call2(Jv[20][2], b, cst_size);
    }
    function type$3(b) {
        return caml_call2(Jv[23][2], b, cst_type$2);
    }
    function slice$1(_b5_, stop, opt, b) {
        var start = _b5_ ? _b5_[1] : 0, type = opt ? opt[1] : Jstr[4];
        if (stop) var stop$0 = stop[1], stop$1 = stop$0;
        else var stop$1 = byte_length$1(b);
        return b.slice(start, stop$1, type);
    }
    function stream(b) {
        return b.stream;
    }
    function file_reader(progress$0, conv) {
        function progress_data(e) {
            if (!caml_call2(Jv[19][2], e, cst_lengthComputable)) return 0;
            var loaded = caml_call2(Jv[21][2], e, cst_loaded), total = caml_call2(Jv[21][2], e, cst_total);
            return [
                0,
                [
                    0,
                    loaded,
                    total
                ]
            ];
        }
        var reader = new Jv[12].FileReader, match = caml_call1(Fut[1], 0), set_fut = match[2], fut = match[1];
        function ok(e) {
            if (progress$0) {
                var progress = progress$0[1];
                caml_call1(progress, progress_data(e));
            }
            return caml_call1(set_fut, [
                0,
                caml_call1(conv, reader.result)
            ]);
        }
        function error(e) {
            return caml_call1(set_fut, [
                1,
                reader.error
            ]);
        }
        var opts = listen_opts(0, _j_, 0, 0);
        listen([
            0,
            opts
        ], load, ok, reader);
        listen([
            0,
            opts
        ], error$0, error, reader);
        if (progress$0) {
            var progress$1 = progress$0[1], progress$2 = function(e) {
                return caml_call1(progress$1, progress_data(e));
            };
            listen(0, progress, progress$2, reader);
        }
        return [
            0,
            fut,
            reader
        ];
    }
    function array_buffer$0(progress, b) {
        if (progress) {
            var match = file_reader(progress, function(_b4_) {
                return _b4_;
            }), reader = match[2], fut = match[1];
            reader.readAsArrayBuffer(b);
            return fut;
        }
        var _b2_ = b.arrayBuffer();
        return caml_call2(Fut[11], function(_b3_) {
            return _b3_;
        }, _b2_);
    }
    function text(progress, b) {
        if (progress) {
            var match = file_reader(progress, function(_b1_) {
                return _b1_;
            }), reader = match[2], fut = match[1];
            reader.readAsText(b);
            return fut;
        }
        var _bZ_ = b.text();
        return caml_call2(Fut[11], function(_b0_) {
            return _b0_;
        }, _bZ_);
    }
    function data_uri(progress, b) {
        var match = file_reader(progress, function(_bY_) {
            return _bY_;
        }), reader = match[2], fut = match[1];
        reader.readAsDataURL(b);
        return fut;
    }
    function init$1(blob_init, last_modified_ms, param) {
        if (blob_init) var b = blob_init[1], o = b;
        else var o = {};
        caml_call3(Jv[20][4], o, cst_lastModified, last_modified_ms);
        return o;
    }
    var file$0 = Jv[12].File;
    function of_blob(opt, name, b) {
        var init = opt ? opt[1] : {};
        return new file$0(b, name, init);
    }
    function name(f) {
        return caml_call2(Jv[23][2], f, cst_name$0);
    }
    function relative_path(f) {
        var p = caml_call3(Jv[14], function(_bX_) {
            return _bX_;
        }, f, cst_webkitRelativePath);
        return caml_call2(Stdlib_Option[3], p, Jstr[4]);
    }
    function last_modified_ms(f) {
        return caml_call2(Jv[20][2], f, cst_lastModified$0);
    }
    function data_utf_8_of_jstr(s) {
        return to_binary_jstr(of_jstr(s));
    }
    function data_utf_8_to_jstr(d) {
        var e = of_binary_jstr(d);
        if (0 !== e[0]) return e;
        var t = e[1];
        return to_jstr(t);
    }
    function data_of_binary_jstr(_bW_) {
        return _bW_;
    }
    function data_to_binary_jstr(_bV_) {
        return _bV_;
    }
    function encode(bs) {
        try {
            var v = Jv[12].btoa(bs);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    function decode(s) {
        try {
            var v = Jv[12].atob(s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    var Base64 = [
        0,
        data_utf_8_of_jstr,
        data_utf_8_to_jstr,
        data_of_binary_jstr,
        data_to_binary_jstr,
        encode,
        decode
    ], json = Jv[12].JSON;
    function encode$0(v) {
        return json.stringify(v);
    }
    function decode$0(s) {
        try {
            var v = json.parse(s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    var encode$1 = Jv[12].encodeURI, decode$1 = Jv[12].decodeURI, encode_component = Jv[12].encodeURIComponent, decode_component = Jv[12].decodeURIComponent, url = Jv[12].URL;
    function v(base, s) {
        if (!base) return new url(s);
        var b = base[1];
        return new url(s, b);
    }
    function with_uri(scheme, host, port, path, query, fragment, u) {
        var u$0 = new url(u);
        try {
            caml_call3(Jv[23][4], u$0, cst_protocol, scheme);
            caml_call3(Jv[23][4], u$0, cst_hostname, host);
            if (port) {
                var p = port[1], arg = Jstr[33], _bT_ = caml_call2(Stdlib_Option[7], function(eta) {
                    return caml_call2(arg, 0, eta);
                }, p);
                caml_call3(Jv[23][4], u$0, cst_port, _bT_);
            }
            caml_call3(Jv[23][4], u$0, cst_pathname, path);
            caml_call3(Jv[23][4], u$0, cst_search, query);
            caml_call3(Jv[23][4], u$0, cst_hash, fragment);
            var _bU_ = [
                0,
                u$0
            ];
            return _bU_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function scheme(u) {
        var p = caml_call2(Jv[23][2], u, cst_protocol$0);
        return 0 === caml_call1(Jstr[1], p) ? p : caml_call3(Jstr[15], 0, _k_, p);
    }
    function host(u) {
        return caml_call2(Jv[23][2], u, cst_hostname$0);
    }
    function port(u) {
        var p = caml_call2(Jv[23][2], u, cst_port$0);
        return caml_call1(Jstr[24], p) ? 0 : caml_call2(Jstr[32], 0, p);
    }
    var prefix = "/";
    function path(u) {
        return caml_call2(Jv[23][2], u, cst_pathname$0);
    }
    function query(u) {
        var q = caml_call2(Jv[23][2], u, cst_search$0);
        return caml_call1(Jstr[24], q) ? q : caml_call3(Jstr[15], _l_, 0, q);
    }
    function fragment(u) {
        var f = caml_call2(Jv[23][2], u, cst_hash$0);
        return caml_call1(Jstr[24], f) ? f : caml_call3(Jstr[15], _m_, 0, f);
    }
    function path_segments(u) {
        function decode_seg(s) {
            return decode_component(s);
        }
        try {
            var p = path(u), p$0 = caml_call2(Jstr[25], prefix, p) ? caml_call3(Jstr[15], _n_, 0, p) : p, _bR_ = caml_call2(Jstr[17], prefix, p$0), _bS_ = [
                0,
                caml_call2(Stdlib_List[20], decode_seg, _bR_)
            ];
            return _bS_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    function with_path_segments(u, segs) {
        function encode_seg(s) {
            var _bQ_ = encode_component(s);
            return caml_call2(Jstr[7], prefix, _bQ_);
        }
        try {
            var u$0 = new url(u), _bO_ = caml_call2(Stdlib_List[20], encode_seg, segs), path = caml_call2(Jstr[9], 0, _bO_);
            u$0.pathname = path;
            var _bP_ = [
                0,
                u$0
            ];
            return _bP_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
    }
    var usp = Jv[12].URLSearchParams;
    function is_empty(p) {
        var _bM_ = p.entries(), _bN_ = caml_call1(Jv[35][6], _bM_);
        return caml_call1(Jv[35][1], _bN_);
    }
    function mem(k, p) {
        return p.has(k) | 0;
    }
    function find$0(k, p) {
        var _bK_ = p.get(k);
        return caml_call2(Jv[10], function(_bL_) {
            return _bL_;
        }, _bK_);
    }
    function find_all(k, p) {
        return caml_list_of_js_array(p.getAll(k));
    }
    function fold(f, p, acc) {
        function key(_bJ_) {
            return _bJ_;
        }
        function value(_bI_) {
            return _bI_;
        }
        var _bH_ = p.entries();
        return caml_call5(Jv[35][8], key, value, f, _bH_, acc);
    }
    function of_jstr$1(s) {
        return new usp(s);
    }
    function to_jstr$0(p) {
        return p.toString();
    }
    function of_assoc(l) {
        var s = Jstr[4], p = new usp(s);
        caml_call2(Stdlib_List[18], function(param) {
            var v = param[2], k = param[1];
            p.append(k, v);
            return 0;
        }, l);
        return p;
    }
    function to_assoc(p) {
        var _bG_ = fold(function(k, v, acc) {
            return [
                0,
                [
                    0,
                    k,
                    v
                ],
                acc
            ];
        }, p, 0);
        return caml_call1(Stdlib_List[10], _bG_);
    }
    function of_obj(o) {
        return new usp(o);
    }
    function query_params(u) {
        var s = query(u);
        return new usp(s);
    }
    function with_query_params(u, ps) {
        var u$0 = new url(u), _bF_ = ps.toString();
        caml_call3(Jv[23][3], u$0, cst_search$1, _bF_);
        return u$0;
    }
    function fragment_params(u) {
        var s = fragment(u);
        return new usp(s);
    }
    function with_fragment_params(u, ps) {
        var u$0 = new url(u), _bE_ = ps.toString();
        caml_call3(Jv[23][3], u$0, cst_hash$1, _bE_);
        return u$0;
    }
    function to_jstr$1(u) {
        return u.toString();
    }
    function of_jstr$2(base, s) {
        try {
            var v$0 = v(base, s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v$0
        ];
    }
    function code$0(f, s) {
        try {
            var v = f(s);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Jv[33]) throw caml_maybe_attach_backtrace(exn, 0);
            var e = exn[2];
            return [
                1,
                e
            ];
        }
        return [
            0,
            v
        ];
    }
    function encode$2(s) {
        return code$0(encode$1, s);
    }
    function decode$2(s) {
        return code$0(decode$1, s);
    }
    function encode_component$0(s) {
        return code$0(encode_component, s);
    }
    function decode_component$0(s) {
        return code$0(decode_component, s);
    }
    function v$0(n, v) {
        return [
            0,
            n,
            v
        ];
    }
    var void$0 = [
        0,
        Jstr[4],
        Jstr[4]
    ];
    function is_void(param) {
        var v = param[2], n = param[1], _bD_ = caml_call1(Jstr[24], n);
        return _bD_ ? caml_call1(Jstr[24], v) : _bD_;
    }
    function if$0(b, at) {
        return b ? at : void$0;
    }
    function if_some(param) {
        if (!param) return void$0;
        var at = param[1];
        return at;
    }
    function true$0(n) {
        return [
            0,
            n,
            Jstr[4]
        ];
    }
    function int$0(n, i) {
        return [
            0,
            n,
            caml_call2(Jstr[33], 0, i)
        ];
    }
    function float$0(n, f) {
        return [
            0,
            n,
            caml_call2(Jstr[35], 0, f)
        ];
    }
    function to_pair(_bC_) {
        return _bC_;
    }
    function add_if(b, at, l) {
        return b ? [
            0,
            at,
            l
        ] : l;
    }
    function add_if_some(name, o, l) {
        if (!o) return l;
        var a = o[1];
        return [
            0,
            [
                0,
                name,
                a
            ],
            l
        ];
    }
    var accesskey = "accesskey", action = "action", autocomplete = "autocomplete", autofocus = "autofocus", charset = "charset", checked = cst_checked, class$0 = "class", cols = "cols", content = "content", contenteditable = "contenteditable", defer = "defer", dir = cst_dir$0, disabled = "disabled", download = "download", draggable = "draggable", for$0 = "for", height$0 = cst_height$1, hidden = cst_hidden, href = "href", id$0 = cst_id, lang = "lang", list = "list", media = "media", method = "method", name$0 = cst_name$2, placeholder = "placeholder", rel = "rel", required = "required", rows = "rows", selected = "selected", spellcheck = "spellcheck", src = "src", style = cst_style, tabindex = "tabindex", title = cst_title$1, type$4 = cst_type$4, value = cst_value, width$0 = cst_width$1, wrap = "wrap", Name = [
        0,
        accesskey,
        action,
        autocomplete,
        autofocus,
        charset,
        checked,
        class$0,
        cols,
        content,
        contenteditable,
        defer,
        dir,
        disabled,
        download,
        draggable,
        for$0,
        height$0,
        hidden,
        href,
        id$0,
        lang,
        list,
        media,
        method,
        name$0,
        placeholder,
        rel,
        required,
        rows,
        selected,
        spellcheck,
        src,
        style,
        tabindex,
        title,
        type$4,
        value,
        width$0,
        wrap
    ];
    function accesskey$0(s) {
        var n = Name[1];
        return [
            0,
            n,
            s
        ];
    }
    function action$0(s) {
        var n = Name[2];
        return [
            0,
            n,
            s
        ];
    }
    function autocomplete$0(s) {
        var n = Name[3];
        return [
            0,
            n,
            s
        ];
    }
    var autofocus$0 = true$0(Name[4]), n = Name[5];
    function charset$0(v) {
        return [
            0,
            n,
            v
        ];
    }
    var checked$0 = true$0(Name[6]);
    function class$1(s) {
        var n = Name[7];
        return [
            0,
            n,
            s
        ];
    }
    function cols$0(i) {
        return int$0(Name[8], i);
    }
    function content$0(s) {
        var n = Name[9];
        return [
            0,
            n,
            s
        ];
    }
    function contenteditable$0(s) {
        return true$0(Name[10]);
    }
    var defer$0 = true$0(Name[11]);
    function dir$0(s) {
        var n = Name[12];
        return [
            0,
            n,
            s
        ];
    }
    var disabled$0 = true$0(Name[13]);
    function download$0(s) {
        var n = Name[14];
        return [
            0,
            n,
            s
        ];
    }
    function draggable$0(s) {
        var n = Name[15];
        return [
            0,
            n,
            s
        ];
    }
    function for$1(s) {
        var n = Name[16];
        return [
            0,
            n,
            s
        ];
    }
    function height$1(i) {
        return int$0(Name[17], i);
    }
    var hidden$0 = true$0(Name[18]);
    function href$0(s) {
        var n = Name[19];
        return [
            0,
            n,
            s
        ];
    }
    function id$1(s) {
        var n = Name[20];
        return [
            0,
            n,
            s
        ];
    }
    function lang$0(s) {
        var n = Name[21];
        return [
            0,
            n,
            s
        ];
    }
    function list$0(s) {
        var n = Name[22];
        return [
            0,
            n,
            s
        ];
    }
    function media$0(s) {
        var n = Name[23];
        return [
            0,
            n,
            s
        ];
    }
    function method$0(s) {
        var n = Name[24];
        return [
            0,
            n,
            s
        ];
    }
    function name$1(s) {
        var n = Name[25];
        return [
            0,
            n,
            s
        ];
    }
    function placeholder$0(s) {
        var n = Name[26];
        return [
            0,
            n,
            s
        ];
    }
    function rel$0(s) {
        var n = Name[27];
        return [
            0,
            n,
            s
        ];
    }
    var required$0 = true$0(Name[28]);
    function rows$0(i) {
        return int$0(Name[29], i);
    }
    var selected$0 = true$0(Name[30]), n$0 = Name[31];
    function spellcheck$0(v) {
        return [
            0,
            n$0,
            v
        ];
    }
    function src$0(s) {
        var n = Name[32];
        return [
            0,
            n,
            s
        ];
    }
    function style$0(s) {
        var n = Name[33];
        return [
            0,
            n,
            s
        ];
    }
    function tabindex$0(i) {
        return int$0(Name[34], i);
    }
    function title$0(s) {
        var n = Name[35];
        return [
            0,
            n,
            s
        ];
    }
    function type$5(s) {
        var n = Name[36];
        return [
            0,
            n,
            s
        ];
    }
    function value$0(s) {
        var n = Name[37];
        return [
            0,
            n,
            s
        ];
    }
    function width$1(i) {
        return int$0(Name[38], i);
    }
    function wrap$0(s) {
        var n = Name[37];
        return [
            0,
            n,
            s
        ];
    }
    var global_document = Jv[12].document;
    function document1(e) {
        return e.ownerDocument;
    }
    var global_root = caml_call1(Jv[8], global_document) ? Jv[5] : global_document.documentElement;
    function el_list_of_node_list(nl) {
        var acc = [
            0,
            0
        ], len = caml_call2(Jv[20][2], nl, cst_length$1), _bz_ = len - 1 | 0;
        if (_bz_ >= 0) {
            var i = _bz_;
            for(;;){
                var _bA_ = acc[1];
                acc[1] = [
                    0,
                    nl[i],
                    _bA_
                ];
                var _bB_ = i - 1 | 0;
                if (0 === i) break;
                i = _bB_;
            }
        }
        return acc[1];
    }
    function _o_(e, n) {
        e.appendChild(n);
        return 0;
    }
    function v$1(_bx_, opt, name, cs) {
        var d = _bx_ ? _bx_[1] : global_document, at$0 = opt ? opt[1] : 0, e = d.createElement(name), ss = 0, clss = 0, param = at$0;
        for(;;){
            if (!param) break;
            var at = param[2], match = param[1], v = match[2], a = match[1];
            if (caml_call1(Jstr[24], a)) param = at;
            else if (caml_call2(Jstr[28], a, Name[33])) {
                var ss$0 = [
                    0,
                    v,
                    ss
                ];
                ss = ss$0;
                param = at;
            } else if (caml_call2(Jstr[28], a, Name[7])) {
                var clss$0 = caml_call1(Jstr[24], v) ? clss : [
                    0,
                    v,
                    clss
                ];
                clss = clss$0;
                param = at;
            } else {
                e.setAttribute(a, v);
                param = at;
            }
        }
        if (0 !== ss) {
            var a$0 = Name[33], _bv_ = caml_call1(Stdlib_List[10], ss), v$0 = caml_call2(Jstr[9], [
                0,
                ";"
            ], _bv_);
            e.setAttribute(a$0, v$0);
        }
        if (0 !== clss) {
            var a$1 = Name[7], _bw_ = caml_call1(Stdlib_List[10], clss), v$1 = caml_call2(Jstr[9], [
                0,
                cst
            ], _bw_);
            e.setAttribute(a$1, v$1);
        }
        caml_call2(Stdlib_List[18], function(_by_) {
            return _o_(e, _by_);
        }, cs);
        return e;
    }
    function txt(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(s);
    }
    function txt$0(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(caml_call1(Jv[24], s));
    }
    function sp(opt, param) {
        return txt(0, cst);
    }
    function nbsp(opt, param) {
        return txt(0, "\xa0");
    }
    function is_txt(e) {
        return 3 === caml_call2(Jv[20][2], e, cst_nodeType) ? 1 : 0;
    }
    function is_el(e) {
        return 1 === caml_call2(Jv[20][2], e, cst_nodeType$0) ? 1 : 0;
    }
    function tag_name(e) {
        var _bu_ = caml_call2(Jv[23][2], e, cst_nodeName);
        return caml_call1(Jstr[22], _bu_);
    }
    function has_tag_name(n, e) {
        var _bt_ = tag_name(e);
        return caml_call2(Jstr[28], n, _bt_);
    }
    function txt_text(txt) {
        return is_txt(txt) ? caml_call2(Jv[23][2], txt, cst_nodeValue) : Jstr[4];
    }
    function find_by_class(opt, c) {
        var root = opt ? opt[1] : global_root;
        return el_list_of_node_list(root.getElementsByClassName(c));
    }
    function find_by_tag_name(opt, n) {
        var root = opt ? opt[1] : global_root;
        return el_list_of_node_list(root.getElementsByTagName(n));
    }
    function find_first_by_selector(opt, sel) {
        var root = opt ? opt[1] : global_root, _br_ = root.querySelector(sel);
        return caml_call1(caml_call1(Jv[10], function(_bs_) {
            return _bs_;
        }), _br_);
    }
    function fold_find_by_selector(opt, f, sel, acc) {
        var root = opt ? opt[1] : global_root, nl = root.querySelectorAll(sel), acc$0 = [
            0,
            acc
        ], _bo_ = caml_call2(Jv[20][2], nl, cst_length$2) - 1 | 0, _bn_ = 0;
        if (_bo_ >= 0) {
            var i = _bn_;
            for(;;){
                var _bp_ = acc$0[1];
                acc$0[1] = caml_call2(f, nl[i], _bp_);
                var _bq_ = i + 1 | 0;
                if (_bo_ === i) break;
                i = _bq_;
            }
        }
        return acc$0[1];
    }
    function parent(e) {
        var match = caml_call2(Jv[13], e, cst_parentNode);
        if (match) {
            var e$0 = match[1];
            if (is_el(e$0)) return [
                0,
                e$0
            ];
        }
        return 0;
    }
    function children(opt, e) {
        var only_els = opt ? opt[1] : 0;
        return only_els ? el_list_of_node_list(e.children) : el_list_of_node_list(e.childNodes);
    }
    function set_children(e, l) {
        for(;;){
            if (caml_call1(Jv[6], e.firstChild)) break;
            e.removeChild(e.firstChild);
        }
        return caml_call2(Stdlib_List[18], function(_bm_) {
            return _o_(e, _bm_);
        }, l);
    }
    function prepend_children(e, l) {
        caml_js_meth_call(e, "prepend", caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function append_children(e, l) {
        caml_js_meth_call(e, cst_append, caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function previous_sibling(e) {
        return caml_call2(Jv[13], e, cst_previousElementSibling);
    }
    function next_sibling(e) {
        return caml_call2(Jv[13], e, cst_nextElementSibling);
    }
    function insert_siblings(loc, e, l) {
        if (-126259180 === loc) caml_js_meth_call(e, "replaceWith", caml_call1(Stdlib_Array[11], l));
        else if (818927100 <= loc) caml_js_meth_call(e, "after", caml_call1(Stdlib_Array[11], l));
        else caml_js_meth_call(e, "before", caml_call1(Stdlib_Array[11], l));
        return 0;
    }
    function remove$0(e) {
        e.remove(e);
        return 0;
    }
    function at(a, e) {
        var _bk_ = e.getAttribute(a);
        return caml_call2(Jv[10], function(_bl_) {
            return _bl_;
        }, _bk_);
    }
    function set_at(a, v, e) {
        if (caml_call1(Jstr[24], a)) return 0;
        if (v) {
            var v$0 = v[1];
            e.setAttribute(a, v$0);
            return 0;
        }
        e.removeAttribute(a);
        return 0;
    }
    function jv_to_bool(b) {
        return caml_call1(Jv[7], b) ? 0 : b | 0;
    }
    function jv_to_int(i) {
        return caml_call1(Jv[7], i) ? 0 : i;
    }
    function jv_to_float(f) {
        return caml_call1(Jv[7], f) ? 0. : f;
    }
    function jv_to_jstr(s) {
        return caml_call1(Jv[7], s) ? Jstr[4] : s;
    }
    function bool(n) {
        return [
            0,
            n,
            jv_to_bool,
            caml_js_from_bool
        ];
    }
    function int$1(n) {
        return [
            0,
            n,
            jv_to_int,
            function(_bj_) {
                return _bj_;
            }
        ];
    }
    function float$1(n) {
        return [
            0,
            n,
            jv_to_float,
            function(_bi_) {
                return _bi_;
            }
        ];
    }
    function jstr(n) {
        return [
            0,
            n,
            jv_to_jstr,
            function(_bh_) {
                return _bh_;
            }
        ];
    }
    var checked$1 = bool(cst_checked), height$2 = int$1(cst_height$1), id$2 = jstr(cst_id), name$2 = jstr(cst_name$2), title$1 = jstr(cst_title$1), value$1 = jstr(cst_value), width$2 = int$1(cst_width$1);
    function prop(p, e) {
        var _bg_ = e[p[1]];
        return caml_call1(p[2], _bg_);
    }
    function set_prop(p, v, e) {
        var _bf_ = caml_call1(p[3], v);
        e[p[1]] = _bf_;
        return 0;
    }
    function class$2(c, e) {
        return e.classList.contains(c) | 0;
    }
    function set_class(c, b, e) {
        return b ? (e.classList.add(c), 0) : (e.classList.remove(c), 0);
    }
    var background_color = "background-color", bottom = "bottom", color = "color", cursor = "cursor", display = "display", height$3 = cst_height$1, left = "left", position = "position", right = "right", top = "top", visibility = "visibility", width$3 = cst_width$1, z_index = "z-index", Style = [
        0,
        background_color,
        bottom,
        color,
        cursor,
        display,
        height$3,
        left,
        position,
        right,
        top,
        visibility,
        width$3,
        z_index
    ];
    function computed_style(opt, p, e) {
        var w = opt ? opt[1] : Jv[12].window, style = w.getComputedStyle(e), v = style[p];
        return caml_call1(Jv[8], v) ? Jstr[4] : v;
    }
    function inline_style(p, e) {
        var style = e.style;
        if (caml_call1(Jv[8], style)) return Jstr[4];
        var v = style[p];
        return caml_call1(Jv[8], v) ? Jstr[4] : v;
    }
    function set_inline_style(opt, p, v, e) {
        var important = opt ? opt[1] : 0, priority = important ? "important" : Jstr[4], style = e.style;
        return caml_call1(Jv[8], style) ? 0 : (style.setProperty(p, v, priority), 0);
    }
    function remove_inline_style(p, e) {
        var style = e.style;
        return caml_call1(Jv[8], style) ? 0 : (style.removeProperty(p), 0);
    }
    function inner_x(e) {
        return caml_call2(Jv[21][2], e, cst_clientLeft);
    }
    function inner_y(e) {
        return caml_call2(Jv[21][2], e, cst_clientTop);
    }
    function inner_w(e) {
        return caml_call2(Jv[21][2], e, cst_clientWidth);
    }
    function inner_h(e) {
        return caml_call2(Jv[21][2], e, cst_clientHeight);
    }
    function bound_x(e) {
        var _be_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _be_, cst_x);
    }
    function bound_y(e) {
        var _bd_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bd_, cst_y);
    }
    function bound_w(e) {
        var _bc_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bc_, cst_width$0);
    }
    function bound_h(e) {
        var _bb_ = e.getBoundingClientRect();
        return caml_call2(Jv[21][2], _bb_, cst_height$0);
    }
    function scroll_x(e) {
        return caml_call2(Jv[21][2], e, cst_scrollLeft);
    }
    function scroll_y(e) {
        return caml_call2(Jv[21][2], e, cst_scrollTop);
    }
    function scroll_w(e) {
        return caml_call2(Jv[21][2], e, cst_scrollWidth);
    }
    function scroll_h(e) {
        return caml_call2(Jv[21][2], e, cst_scrollHeight);
    }
    function scroll_into_view(opt, e) {
        var align_v = opt ? opt[1] : 389604418, align = 389604418 <= align_v ? 1 : 0;
        e.scrollIntoView(!!align);
        return 0;
    }
    function has_focus(e) {
        var match = caml_call2(Jv[10], function(_ba_) {
            return _ba_;
        }, e.ownerDocument.activeElement);
        if (!match) return 0;
        var e$0 = match[1];
        return e === e$0 ? 1 : 0;
    }
    function set_has_focus(b, e) {
        if (b) e.focus();
        else e.blur();
        return 0;
    }
    function is_locking_pointer(e) {
        var match = caml_call2(Jv[10], function(_a$_) {
            return _a$_;
        }, e.ownerDocument.pointerLockElement);
        if (!match) return 0;
        var e$0 = match[1];
        return e === e$0 ? 1 : 0;
    }
    function request_pointer_lock(e) {
        var match = caml_call1(Fut[1], 0), set = match[2], fut = match[1], d = e.ownerDocument, opts = listen_opts(0, _p_, 0, 0), unlisten$0 = [
            0,
            function(param) {
                return 0;
            }
        ];
        function locked(ev) {
            caml_call1(set, _q_);
            return caml_call1(unlisten$0[1], 0);
        }
        function error(ev) {
            var err = caml_call2(Jv[32][1], 0, "Could not lock pointer");
            caml_call1(set, [
                1,
                err
            ]);
            return caml_call1(unlisten$0[1], 0);
        }
        var k = listen([
            0,
            opts
        ], pointerlockchange, locked, d), k$0 = listen([
            0,
            opts
        ], pointerlockerror, error, d);
        unlisten$0[1] = function(param) {
            unlisten(k);
            return unlisten(k$0);
        };
        e.requestPointerLock();
        return fut;
    }
    function click$0(e) {
        e.click();
        return 0;
    }
    function select_text(e) {
        e.select();
        return 0;
    }
    var auto = cst_auto, hide = "hide", show = "show", Navigation_ui = [
        0,
        auto,
        hide,
        show
    ];
    function fullscreen_opts(navigation_ui, param) {
        var o = {};
        caml_call3(Jv[23][4], o, cst_navigationUI, navigation_ui);
        return o;
    }
    function request_fullscreen(opt, e) {
        var opts = opt ? opt[1] : {}, _a9_ = e.requestFullscreen(opts);
        return caml_call1(caml_call1(Fut[11], function(_a__) {
            return 0;
        }), _a9_);
    }
    function files(e) {
        var match = caml_call2(Jv[13], e, cst_files);
        if (!match) return 0;
        var files = match[1];
        return caml_call2(Jv[29], function(_a8_) {
            return _a8_;
        }, files);
    }
    var Input$0 = [
        0,
        files
    ], a = "a", abbr = "abbr", address = "address", area = "area", article = "article", aside = "aside", audio = "audio", b = "b", base = "base", bdi = "bdi", bdo = "bdo", blockquote = "blockquote", body = cst_body, br = "br", button$0 = cst_button$0, canvas = "canvas", caption = "caption", cite = "cite", code$1 = cst_code$0, col = "col", colgroup = "colgroup", command = "command", datalist = "datalist", dd = "dd", del = "del", details = "details", dfn = "dfn", div = "div", dl = "dl", dt = "dt", em = "em", embed = "embed", fieldset = "fieldset", figcaption = "figcaption", figure = "figure", footer = "footer", form = "form", h1 = "h1", h2 = "h2", h3 = "h3", h4 = "h4", h5 = "h5", h6 = "h6", head = cst_head, header = "header", hgroup = "hgroup", hr = "hr", html = "html", i = "i", iframe = "iframe", img = "img", input$0 = cst_input, ins = "ins", kbd = "kbd", keygen = "keygen", label = "label", legend = "legend", li = "li", link$0 = cst_link, map$0 = cst_map, mark = cst_mark, menu = "menu", meta = "meta", meter = "meter", nav = "nav", noscript = "noscript", object = "object", ol = "ol", optgroup = "optgroup", option = "option", output = "output", p = "p", pre = "pre", progress$0 = cst_progress, q = "q", rp = "rp", rt = "rt", ruby = "ruby", s = "s", samp = "samp", script = "script", section = "section", select$0 = cst_select, small = "small", source = "source", span = "span", strong = "strong", style$1 = cst_style, sub$0 = "sub", summary = "summary", sup = "sup", table = cst_table$0, tbody = "tbody", td = "td", textarea = "textarea", tfoot = "tfoot", th = "th", thead = "thead", time = cst_time$0, title$2 = cst_title$1, tr = "tr", track = "track", u = "u", ul = "ul", var$0 = "var", video = "video", wbr = "wbr", Name$0 = [
        0,
        a,
        abbr,
        address,
        area,
        article,
        aside,
        audio,
        b,
        base,
        bdi,
        bdo,
        blockquote,
        body,
        br,
        button$0,
        canvas,
        caption,
        cite,
        code$1,
        col,
        colgroup,
        command,
        datalist,
        dd,
        del,
        details,
        dfn,
        div,
        dl,
        dt,
        em,
        embed,
        fieldset,
        figcaption,
        figure,
        footer,
        form,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        head,
        header,
        hgroup,
        hr,
        html,
        i,
        iframe,
        img,
        input$0,
        ins,
        kbd,
        keygen,
        label,
        legend,
        li,
        link$0,
        map$0,
        mark,
        menu,
        meta,
        meter,
        nav,
        noscript,
        object,
        ol,
        optgroup,
        option,
        output,
        p,
        "param",
        pre,
        progress$0,
        q,
        rp,
        rt,
        ruby,
        s,
        samp,
        script,
        section,
        select$0,
        small,
        source,
        span,
        strong,
        style$1,
        sub$0,
        summary,
        sup,
        table,
        tbody,
        td,
        textarea,
        tfoot,
        th,
        thead,
        time,
        title$2,
        tr,
        track,
        u,
        ul,
        var$0,
        video,
        wbr
    ];
    function void_cons(name, d, at, param) {
        return v$1(d, at, name, 0);
    }
    var name$3 = Name$0[1];
    function a$0(d, at, cs) {
        return v$1(d, at, name$3, cs);
    }
    var name$4 = Name$0[2];
    function abbr$0(d, at, cs) {
        return v$1(d, at, name$4, cs);
    }
    var name$5 = Name$0[3];
    function address$0(d, at, cs) {
        return v$1(d, at, name$5, cs);
    }
    var _r_ = Name$0[4];
    function area$0(_a5_, _a6_, _a7_) {
        return void_cons(_r_, _a5_, _a6_, _a7_);
    }
    var name$6 = Name$0[5];
    function article$0(d, at, cs) {
        return v$1(d, at, name$6, cs);
    }
    var name$7 = Name$0[6];
    function aside$0(d, at, cs) {
        return v$1(d, at, name$7, cs);
    }
    var name$8 = Name$0[7];
    function audio$0(d, at, cs) {
        return v$1(d, at, name$8, cs);
    }
    var name$9 = Name$0[8];
    function b$0(d, at, cs) {
        return v$1(d, at, name$9, cs);
    }
    var _s_ = Name$0[9];
    function base$0(_a2_, _a3_, _a4_) {
        return void_cons(_s_, _a2_, _a3_, _a4_);
    }
    var name$10 = Name$0[10];
    function bdi$0(d, at, cs) {
        return v$1(d, at, name$10, cs);
    }
    var name$11 = Name$0[11];
    function bdo$0(d, at, cs) {
        return v$1(d, at, name$11, cs);
    }
    var name$12 = Name$0[12];
    function blockquote$0(d, at, cs) {
        return v$1(d, at, name$12, cs);
    }
    var name$13 = Name$0[13];
    function body$0(d, at, cs) {
        return v$1(d, at, name$13, cs);
    }
    var _t_ = Name$0[14];
    function br$0(_aZ_, _a0_, _a1_) {
        return void_cons(_t_, _aZ_, _a0_, _a1_);
    }
    var name$14 = Name$0[15];
    function button$1(d, at, cs) {
        return v$1(d, at, name$14, cs);
    }
    var name$15 = Name$0[16];
    function canvas$0(d, at, cs) {
        return v$1(d, at, name$15, cs);
    }
    var name$16 = Name$0[17];
    function caption$0(d, at, cs) {
        return v$1(d, at, name$16, cs);
    }
    var name$17 = Name$0[18];
    function cite$0(d, at, cs) {
        return v$1(d, at, name$17, cs);
    }
    var name$18 = Name$0[19];
    function code$2(d, at, cs) {
        return v$1(d, at, name$18, cs);
    }
    var _u_ = Name$0[20];
    function col$0(_aW_, _aX_, _aY_) {
        return void_cons(_u_, _aW_, _aX_, _aY_);
    }
    var name$19 = Name$0[21];
    function colgroup$0(d, at, cs) {
        return v$1(d, at, name$19, cs);
    }
    var name$20 = Name$0[22];
    function command$0(d, at, cs) {
        return v$1(d, at, name$20, cs);
    }
    var name$21 = Name$0[23];
    function datalist$0(d, at, cs) {
        return v$1(d, at, name$21, cs);
    }
    var name$22 = Name$0[24];
    function dd$0(d, at, cs) {
        return v$1(d, at, name$22, cs);
    }
    var name$23 = Name$0[25];
    function del$0(d, at, cs) {
        return v$1(d, at, name$23, cs);
    }
    var name$24 = Name$0[26];
    function details$0(d, at, cs) {
        return v$1(d, at, name$24, cs);
    }
    var name$25 = Name$0[27];
    function dfn$0(d, at, cs) {
        return v$1(d, at, name$25, cs);
    }
    var name$26 = Name$0[28];
    function div$0(d, at, cs) {
        return v$1(d, at, name$26, cs);
    }
    var name$27 = Name$0[29];
    function dl$0(d, at, cs) {
        return v$1(d, at, name$27, cs);
    }
    var name$28 = Name$0[30];
    function dt$0(d, at, cs) {
        return v$1(d, at, name$28, cs);
    }
    var name$29 = Name$0[31];
    function em$0(d, at, cs) {
        return v$1(d, at, name$29, cs);
    }
    var _v_ = Name$0[32];
    function embed$0(_aT_, _aU_, _aV_) {
        return void_cons(_v_, _aT_, _aU_, _aV_);
    }
    var name$30 = Name$0[33];
    function fieldset$0(d, at, cs) {
        return v$1(d, at, name$30, cs);
    }
    var name$31 = Name$0[34];
    function figcaption$0(d, at, cs) {
        return v$1(d, at, name$31, cs);
    }
    var name$32 = Name$0[35];
    function figure$0(d, at, cs) {
        return v$1(d, at, name$32, cs);
    }
    var name$33 = Name$0[36];
    function footer$0(d, at, cs) {
        return v$1(d, at, name$33, cs);
    }
    var name$34 = Name$0[37];
    function form$0(d, at, cs) {
        return v$1(d, at, name$34, cs);
    }
    var name$35 = Name$0[38];
    function h1$0(d, at, cs) {
        return v$1(d, at, name$35, cs);
    }
    var name$36 = Name$0[39];
    function h2$0(d, at, cs) {
        return v$1(d, at, name$36, cs);
    }
    var name$37 = Name$0[40];
    function h3$0(d, at, cs) {
        return v$1(d, at, name$37, cs);
    }
    var name$38 = Name$0[41];
    function h4$0(d, at, cs) {
        return v$1(d, at, name$38, cs);
    }
    var name$39 = Name$0[42];
    function h5$0(d, at, cs) {
        return v$1(d, at, name$39, cs);
    }
    var name$40 = Name$0[43];
    function h6$0(d, at, cs) {
        return v$1(d, at, name$40, cs);
    }
    var name$41 = Name$0[44];
    function head$0(d, at, cs) {
        return v$1(d, at, name$41, cs);
    }
    var name$42 = Name$0[45];
    function header$0(d, at, cs) {
        return v$1(d, at, name$42, cs);
    }
    var name$43 = Name$0[46];
    function hgroup$0(d, at, cs) {
        return v$1(d, at, name$43, cs);
    }
    var _w_ = Name$0[47];
    function hr$0(_aQ_, _aR_, _aS_) {
        return void_cons(_w_, _aQ_, _aR_, _aS_);
    }
    var name$44 = Name$0[48];
    function html$0(d, at, cs) {
        return v$1(d, at, name$44, cs);
    }
    var name$45 = Name$0[49];
    function i$0(d, at, cs) {
        return v$1(d, at, name$45, cs);
    }
    var name$46 = Name$0[50];
    function iframe$0(d, at, cs) {
        return v$1(d, at, name$46, cs);
    }
    var _x_ = Name$0[51];
    function img$0(_aN_, _aO_, _aP_) {
        return void_cons(_x_, _aN_, _aO_, _aP_);
    }
    var _y_ = Name$0[52];
    function input$1(_aK_, _aL_, _aM_) {
        return void_cons(_y_, _aK_, _aL_, _aM_);
    }
    var name$47 = Name$0[53];
    function ins$0(d, at, cs) {
        return v$1(d, at, name$47, cs);
    }
    var name$48 = Name$0[54];
    function kbd$0(d, at, cs) {
        return v$1(d, at, name$48, cs);
    }
    var name$49 = Name$0[55];
    function keygen$0(d, at, cs) {
        return v$1(d, at, name$49, cs);
    }
    var name$50 = Name$0[56];
    function label$0(d, at, cs) {
        return v$1(d, at, name$50, cs);
    }
    var name$51 = Name$0[57];
    function legend$0(d, at, cs) {
        return v$1(d, at, name$51, cs);
    }
    var name$52 = Name$0[58];
    function li$0(d, at, cs) {
        return v$1(d, at, name$52, cs);
    }
    var _z_ = Name$0[59];
    function link$1(_aH_, _aI_, _aJ_) {
        return void_cons(_z_, _aH_, _aI_, _aJ_);
    }
    var name$53 = Name$0[60];
    function map$1(d, at, cs) {
        return v$1(d, at, name$53, cs);
    }
    var name$54 = Name$0[61];
    function mark$0(d, at, cs) {
        return v$1(d, at, name$54, cs);
    }
    var name$55 = Name$0[62];
    function menu$0(d, at, cs) {
        return v$1(d, at, name$55, cs);
    }
    var _A_ = Name$0[63];
    function meta$0(_aE_, _aF_, _aG_) {
        return void_cons(_A_, _aE_, _aF_, _aG_);
    }
    var name$56 = Name$0[64];
    function meter$0(d, at, cs) {
        return v$1(d, at, name$56, cs);
    }
    var name$57 = Name$0[65];
    function nav$0(d, at, cs) {
        return v$1(d, at, name$57, cs);
    }
    var name$58 = Name$0[66];
    function noscript$0(d, at, cs) {
        return v$1(d, at, name$58, cs);
    }
    var name$59 = Name$0[67];
    function object$0(d, at, cs) {
        return v$1(d, at, name$59, cs);
    }
    var name$60 = Name$0[68];
    function ol$0(d, at, cs) {
        return v$1(d, at, name$60, cs);
    }
    var name$61 = Name$0[69];
    function optgroup$0(d, at, cs) {
        return v$1(d, at, name$61, cs);
    }
    var name$62 = Name$0[70];
    function option$0(d, at, cs) {
        return v$1(d, at, name$62, cs);
    }
    var name$63 = Name$0[71];
    function output$0(d, at, cs) {
        return v$1(d, at, name$63, cs);
    }
    var name$64 = Name$0[72];
    function p$0(d, at, cs) {
        return v$1(d, at, name$64, cs);
    }
    var _B_ = Name$0[73], name$65 = Name$0[74];
    function pre$0(d, at, cs) {
        return v$1(d, at, name$65, cs);
    }
    var name$66 = Name$0[75];
    function progress$1(d, at, cs) {
        return v$1(d, at, name$66, cs);
    }
    var name$67 = Name$0[76];
    function q$0(d, at, cs) {
        return v$1(d, at, name$67, cs);
    }
    var name$68 = Name$0[77];
    function rp$0(d, at, cs) {
        return v$1(d, at, name$68, cs);
    }
    var name$69 = Name$0[78];
    function rt$0(d, at, cs) {
        return v$1(d, at, name$69, cs);
    }
    var name$70 = Name$0[79];
    function ruby$0(d, at, cs) {
        return v$1(d, at, name$70, cs);
    }
    var name$71 = Name$0[80];
    function s$0(d, at, cs) {
        return v$1(d, at, name$71, cs);
    }
    var name$72 = Name$0[81];
    function samp$0(d, at, cs) {
        return v$1(d, at, name$72, cs);
    }
    var name$73 = Name$0[82];
    function script$0(d, at, cs) {
        return v$1(d, at, name$73, cs);
    }
    var name$74 = Name$0[83];
    function section$0(d, at, cs) {
        return v$1(d, at, name$74, cs);
    }
    var name$75 = Name$0[84];
    function select$1(d, at, cs) {
        return v$1(d, at, name$75, cs);
    }
    var name$76 = Name$0[85];
    function small$0(d, at, cs) {
        return v$1(d, at, name$76, cs);
    }
    var _C_ = Name$0[86];
    function source$0(_aB_, _aC_, _aD_) {
        return void_cons(_C_, _aB_, _aC_, _aD_);
    }
    var name$77 = Name$0[87];
    function span$0(d, at, cs) {
        return v$1(d, at, name$77, cs);
    }
    var name$78 = Name$0[88];
    function strong$0(d, at, cs) {
        return v$1(d, at, name$78, cs);
    }
    var name$79 = Name$0[89];
    function style$2(d, at, cs) {
        return v$1(d, at, name$79, cs);
    }
    var name$80 = Name$0[90];
    function sub$1(d, at, cs) {
        return v$1(d, at, name$80, cs);
    }
    var name$81 = Name$0[91];
    function summary$0(d, at, cs) {
        return v$1(d, at, name$81, cs);
    }
    var name$82 = Name$0[92];
    function sup$0(d, at, cs) {
        return v$1(d, at, name$82, cs);
    }
    var name$83 = Name$0[93];
    function table$0(d, at, cs) {
        return v$1(d, at, name$83, cs);
    }
    var name$84 = Name$0[94];
    function tbody$0(d, at, cs) {
        return v$1(d, at, name$84, cs);
    }
    var name$85 = Name$0[95];
    function td$0(d, at, cs) {
        return v$1(d, at, name$85, cs);
    }
    var name$86 = Name$0[96];
    function textarea$0(d, at, cs) {
        return v$1(d, at, name$86, cs);
    }
    var name$87 = Name$0[97];
    function tfoot$0(d, at, cs) {
        return v$1(d, at, name$87, cs);
    }
    var name$88 = Name$0[98];
    function th$0(d, at, cs) {
        return v$1(d, at, name$88, cs);
    }
    var name$89 = Name$0[99];
    function thead$0(d, at, cs) {
        return v$1(d, at, name$89, cs);
    }
    var name$90 = Name$0[100];
    function time$0(d, at, cs) {
        return v$1(d, at, name$90, cs);
    }
    var name$91 = Name$0[101];
    function title$3(d, at, cs) {
        return v$1(d, at, name$91, cs);
    }
    var name$92 = Name$0[102];
    function tr$0(d, at, cs) {
        return v$1(d, at, name$92, cs);
    }
    var _D_ = Name$0[103];
    function track$0(_ay_, _az_, _aA_) {
        return void_cons(_D_, _ay_, _az_, _aA_);
    }
    var name$93 = Name$0[104];
    function u$0(d, at, cs) {
        return v$1(d, at, name$93, cs);
    }
    var name$94 = Name$0[105];
    function ul$0(d, at, cs) {
        return v$1(d, at, name$94, cs);
    }
    var name$95 = Name$0[106];
    function var$1(d, at, cs) {
        return v$1(d, at, name$95, cs);
    }
    var name$96 = Name$0[107];
    function video$0(d, at, cs) {
        return v$1(d, at, name$96, cs);
    }
    var _E_ = Name$0[108];
    function wbr$0(_av_, _aw_, _ax_) {
        return void_cons(_E_, _av_, _aw_, _ax_);
    }
    function as_target(d) {
        return d;
    }
    function root(d) {
        return d.documentElement;
    }
    function body$1(d) {
        var b = d.body;
        return caml_call1(Jv[9], b) ? b : caml_call2(Jv[34], 0, "Document body is null. Try to defer your script execution.");
    }
    function head$1(d) {
        return d.head;
    }
    function active_el(d) {
        return caml_call2(Jv[10], function(_au_) {
            return _au_;
        }, d.activeElement);
    }
    function find_el_by_id(d, id) {
        var _as_ = d.getElementById(id);
        return caml_call2(Jv[10], function(_at_) {
            return _at_;
        }, _as_);
    }
    function find_els_by_name(d, n) {
        return el_list_of_node_list(d.getElementsByName(n));
    }
    function referrer(d) {
        return caml_call2(Jv[23][2], d, cst_referrer);
    }
    function title$4(d) {
        return caml_call2(Jv[23][2], d, cst_title);
    }
    function set_title(d, t) {
        return caml_call3(Jv[23][3], d, cst_title$0, t);
    }
    var hidden$1 = cst_hidden, visible = "visible", Visibility_state = [
        0,
        hidden$1,
        visible
    ];
    function visibility_state(d) {
        return caml_call2(Jv[23][2], d, cst_visibilityState);
    }
    function pointer_lock_element(d) {
        var _aq_ = d.pointerLockElement;
        return caml_call1(caml_call1(Jv[10], function(_ar_) {
            return _ar_;
        }), _aq_);
    }
    function exit_pointer_lock(d) {
        var fut = next(0, pointerlockchange, d);
        d.exitPointerLock();
        return fut;
    }
    function fullscreen_available(d) {
        return caml_call2(Jv[19][2], d, cst_fullscreenEnabled);
    }
    function fullscreen_element(d) {
        var _ao_ = d.fullscreenElement;
        return caml_call1(caml_call1(Jv[10], function(_ap_) {
            return _ap_;
        }), _ao_);
    }
    function exit_fullscreen(d) {
        var _am_ = d.exitFullscreen();
        return caml_call1(caml_call1(Fut[11], function(_an_) {
            return 0;
        }), _am_);
    }
    function aborted(s) {
        return caml_call2(Jv[19][2], s, cst_aborted);
    }
    var abort$0 = cst_abort, Signal = [
        0,
        aborted,
        abort$0
    ];
    function controller(param) {
        return new Jv[12].AbortController;
    }
    function signal(c) {
        return c.signal;
    }
    function abort$1(c) {
        c.abort();
        return 0;
    }
    var Abort = [
        0,
        Signal,
        controller,
        signal,
        abort$1
    ];
    function call(c, meth, args) {
        caml_js_meth_call(c, meth, args);
        return 0;
    }
    var c = [
        0,
        Jv[12].console
    ];
    function get$0(param) {
        return c[1];
    }
    function set$0(n) {
        c[1] = n;
        return 0;
    }
    function clear$0(param) {
        return call(c[1], cst_clear, [
            0
        ]);
    }
    function msg(v) {
        return [
            0,
            v,
            0
        ];
    }
    function str(v) {
        return caml_call1(Jv[6], v) ? "null" : caml_call1(Jv[7], v) ? "undefined" : v.toString();
    }
    function msg_to_jv_array(msg) {
        var a = caml_call1(Jv[31][1], 0), i = 0, param = msg;
        for(;;){
            if (!param) return runtime.caml_js_to_array(a);
            var vs = param[2], v = param[1];
            a[i] = v;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = vs;
        }
    }
    function log(msg) {
        var _al_ = msg_to_jv_array(msg);
        return call(c[1], cst_log, _al_);
    }
    function trace(msg) {
        var _ak_ = msg_to_jv_array(msg);
        return call(c[1], cst_trace, _ak_);
    }
    function error$1(msg) {
        var _aj_ = msg_to_jv_array(msg);
        return call(c[1], cst_error, _aj_);
    }
    function warn(msg) {
        var _ai_ = msg_to_jv_array(msg);
        return call(c[1], cst_warn, _ai_);
    }
    function info(msg) {
        var _ah_ = msg_to_jv_array(msg);
        return call(c[1], cst_info, _ah_);
    }
    function debug(msg) {
        var _ag_ = msg_to_jv_array(msg);
        return call(c[1], cst_debug, _ag_);
    }
    function assert(b, msg) {
        var _af_ = msg_to_jv_array([
            0,
            !!b,
            msg
        ]);
        return call(c[1], cst_assert, _af_);
    }
    function dir$1(o) {
        return call(c[1], cst_dir, [
            0,
            o
        ]);
    }
    function table$1(cols, v) {
        if (cols) var l = cols[1], msg = [
            0,
            v,
            runtime.caml_list_to_js_array(l)
        ];
        else var msg = [
            0,
            v
        ];
        return call(c[1], cst_table, msg);
    }
    function group_end(param) {
        return call(c[1], cst_groupEnd, [
            0
        ]);
    }
    function group(opt, msg) {
        var closed = opt ? opt[1] : 0;
        if (closed) {
            var _ad_ = msg_to_jv_array(msg);
            return call(c[1], cst_groupCollapsed, _ad_);
        }
        var _ae_ = msg_to_jv_array(msg);
        return call(c[1], cst_group, _ae_);
    }
    function count(label) {
        return call(c[1], cst_count, [
            0,
            label
        ]);
    }
    function count_reset(label) {
        return call(c[1], cst_countReset, [
            0,
            label
        ]);
    }
    function time$1(label) {
        return call(c[1], cst_time, [
            0,
            label
        ]);
    }
    function time_log(label, msg) {
        var _ac_ = msg_to_jv_array([
            0,
            label,
            msg
        ]);
        return call(c[1], cst_timeLog, _ac_);
    }
    function time_end(label) {
        return call(c[1], cst_timeEnd, [
            0,
            label
        ]);
    }
    function profile(label) {
        return call(c[1], cst_profile, [
            0,
            label
        ]);
    }
    function profile_end(label) {
        return call(c[1], cst_profileEnd, [
            0,
            label
        ]);
    }
    function time_stamp(label) {
        return call(c[1], cst_timeStamp$0, [
            0,
            label
        ]);
    }
    function log_result(_ab_, opt, r) {
        var ok = _ab_ ? _ab_[1] : function(v) {
            return [
                0,
                v,
                0
            ];
        }, err = opt ? opt[1] : function(e) {
            return [
                0,
                str(e),
                0
            ];
        };
        if (0 === r[0]) {
            var v = r[1];
            log(caml_call1(ok, v));
        } else {
            var e = r[1];
            error$1(caml_call1(err, e));
        }
        return r;
    }
    function log_if_error(_aa_, opt, use, param) {
        var l = _aa_ ? _aa_[1] : error$1, error_msg = opt ? opt[1] : function(e) {
            return [
                0,
                str(e),
                0
            ];
        };
        if (0 === param[0]) {
            var v = param[1];
            return v;
        }
        var e = param[1];
        caml_call1(l, caml_call1(error_msg, e));
        return use;
    }
    function log_if_error$0(l, error_msg, use, r) {
        return [
            0,
            log_if_error(l, error_msg, use, r)
        ];
    }
    function as_target$0(w) {
        return w;
    }
    function closed(w) {
        return caml_call2(Jv[19][2], w, cst_closed);
    }
    function scroll_x$0(w) {
        return caml_call2(Jv[21][2], w, cst_scrollX);
    }
    function scroll_y$0(w) {
        return caml_call2(Jv[21][2], w, cst_scrollY);
    }
    function device_pixel_ratio(w) {
        return caml_call2(Jv[21][2], w, cst_devicePixelRatio);
    }
    function matches_media(w, s) {
        var o = w.matchMedia(s);
        return caml_call2(Jv[19][2], o, cst_matches);
    }
    function prefers_dark_color_scheme(w) {
        return matches_media(w, "(prefers-color-scheme: dark)");
    }
    function open$0(_Z_, opt, w, u) {
        var features = _Z_ ? _Z_[1] : Jstr[4], name = opt ? opt[1] : Jstr[4], ___ = w.open(u, name, features);
        return caml_call1(caml_call1(Jv[10], function(_$_) {
            return _$_;
        }), ___);
    }
    function close$0(w) {
        w.close();
        return 0;
    }
    function print(w) {
        w.print();
        return 0;
    }
    function reload(w) {
        w.location.reload();
        return 0;
    }
    function location$0(w) {
        return new url(w.location);
    }
    function set_location(w, u) {
        return w.location = u;
    }
    var auto$0 = cst_auto, manual = "manual", Scroll_restoration = [
        0,
        auto$0,
        manual
    ];
    function length$1(h) {
        return caml_call2(Jv[20][2], h, cst_length$3);
    }
    function scroll_restoration(h) {
        return caml_call2(Jv[23][2], h, cst_scrollRestoration);
    }
    function set_scroll_restoration(h, r) {
        return caml_call3(Jv[23][3], h, cst_scrollRestoration$0, r);
    }
    function back(h) {
        h.back();
        return 0;
    }
    function forward(h) {
        h.forward();
        return 0;
    }
    function go(h, d) {
        h.go(d);
        return 0;
    }
    function state(h) {
        return h.state;
    }
    function push_state(_Y_, _X_, opt, h) {
        var state = _Y_ ? _Y_[1] : Jv[4], title = _X_ ? _X_[1] : Jstr[4], uri = opt ? opt[1] : Jv[4];
        h.pushState(state, title, uri);
        return 0;
    }
    function replace_state(_W_, _V_, opt, h) {
        var state = _W_ ? _W_[1] : Jv[4], title = _V_ ? _V_[1] : Jstr[4], uri = opt ? opt[1] : Jv[4];
        h.replaceState(state, title, uri);
        return 0;
    }
    function state$0(e) {
        return e.state;
    }
    var Popstate = [
        0,
        state$0
    ], popstate = "popstate", Ev = [
        0,
        Popstate,
        popstate
    ], History = [
        0,
        Scroll_restoration,
        length$1,
        scroll_restoration,
        set_scroll_restoration,
        back,
        forward,
        go,
        state,
        push_state,
        replace_state,
        Ev
    ];
    function history(w) {
        return w.history;
    }
    var Window = [
        0,
        as_target$0,
        closed,
        scroll_x$0,
        scroll_y$0,
        device_pixel_ratio,
        matches_media,
        prefers_dark_color_scheme,
        open$0,
        close$0,
        print,
        reload,
        location$0,
        set_location,
        History,
        history
    ];
    function languages(n) {
        var match = caml_call2(Jv[13], n, cst_languages);
        if (match) {
            var a = match[1];
            return caml_list_of_js_array(a);
        }
        var match$0 = caml_call2(Jv[23][1], n, cst_language);
        if (!match$0) return 0;
        var v = match$0[1];
        return [
            0,
            v,
            0
        ];
    }
    function max_touch_points(n) {
        var t = n.maxTouchPoints;
        return caml_call1(Jv[8], t) ? 0 : t;
    }
    function online(n) {
        return caml_call2(Jv[19][2], n, cst_onLine);
    }
    var Navigator = [
        0,
        languages,
        max_touch_points,
        online
    ], frame = "frame", navigation = "navigation", resource = "resource", mark$1 = cst_mark, measure = cst_measure, paint = "paint", longtask = "longtask", Type$0 = [
        0,
        frame,
        navigation,
        resource,
        mark$1,
        measure,
        paint,
        longtask
    ];
    function name$97(e) {
        return caml_call2(Jv[23][2], e, cst_name$1);
    }
    function type$6(e) {
        return caml_call2(Jv[23][2], e, cst_entryType);
    }
    function start_time(e) {
        return caml_call2(Jv[21][2], e, cst_startTime);
    }
    function end_time(e) {
        return caml_call2(Jv[21][2], e, cst_endTime);
    }
    function duration(e) {
        return caml_call2(Jv[21][2], e, cst_duration);
    }
    function to_json(e) {
        return e.toJSON();
    }
    function as_entry(_U_) {
        return _U_;
    }
    function initiator_type(e) {
        return caml_call2(Jv[23][2], e, cst_initiatorType);
    }
    function next_hop_protocol(e) {
        return caml_call2(Jv[23][2], e, cst_nextHopProtocol);
    }
    function worker_start(e) {
        return caml_call2(Jv[21][2], e, cst_workerStart);
    }
    function redirect_start(e) {
        return caml_call2(Jv[21][2], e, cst_redirectStart);
    }
    function redirect_end(e) {
        return caml_call2(Jv[21][2], e, cst_redirectEnd);
    }
    function fetch_start(e) {
        return caml_call2(Jv[21][2], e, cst_fetchStart);
    }
    function domain_lookup_start(e) {
        return caml_call2(Jv[21][2], e, cst_domainLookupStart);
    }
    function domain_lookup_end(e) {
        return caml_call2(Jv[21][2], e, cst_domainLookupEnd);
    }
    function connect_start(e) {
        return caml_call2(Jv[21][2], e, cst_connectStart);
    }
    function connect_end(e) {
        return caml_call2(Jv[21][2], e, cst_connectEnd);
    }
    function secure_connection_start(e) {
        return caml_call2(Jv[21][2], e, cst_secureConnectionStart);
    }
    function request_start(e) {
        return caml_call2(Jv[21][2], e, cst_requestStart);
    }
    function response_start(e) {
        return caml_call2(Jv[21][2], e, cst_responseStart);
    }
    function response_end(e) {
        return caml_call2(Jv[21][2], e, cst_responseEnd);
    }
    function transfer_size(e) {
        return caml_call2(Jv[20][2], e, cst_transferSize);
    }
    function encoded_body_size(e) {
        return caml_call2(Jv[20][2], e, cst_encodedBodySize);
    }
    function decoded_body_size(e) {
        return caml_call2(Jv[20][2], e, cst_decodedBodySize);
    }
    var Resource_timing = [
        0,
        as_entry,
        initiator_type,
        next_hop_protocol,
        worker_start,
        redirect_start,
        redirect_end,
        fetch_start,
        domain_lookup_start,
        domain_lookup_end,
        connect_start,
        connect_end,
        secure_connection_start,
        request_start,
        response_start,
        response_end,
        transfer_size,
        encoded_body_size,
        decoded_body_size
    ], navigate = "navigate", reload$0 = cst_reload, back_forward = "back_forward", prerender = "prerender", Type$1 = [
        0,
        navigate,
        reload$0,
        back_forward,
        prerender
    ];
    function as_resource_timing(_T_1) {
        return _T_1;
    }
    function as_entry$0(_S_) {
        return _S_;
    }
    function unload_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_unloadEventStart);
    }
    function unload_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_unloadEventEnd);
    }
    function dom_interactive(e) {
        return caml_call2(Jv[21][2], e, cst_domInteractive);
    }
    function dom_content_loaded_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_domContentLoadedEventStart);
    }
    function dom_content_loaded_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_domContentLoadedEventEnd);
    }
    function dom_complete(e) {
        return caml_call2(Jv[21][2], e, cst_domComplete);
    }
    function load_event_start(e) {
        return caml_call2(Jv[21][2], e, cst_loadEventStart);
    }
    function load_event_end(e) {
        return caml_call2(Jv[21][2], e, cst_loadEventEnd);
    }
    function type$7(e) {
        return caml_call2(Jv[23][2], e, cst_type$3);
    }
    function redirect_count(e) {
        return caml_call2(Jv[20][2], e, cst_redirectCount);
    }
    function as_resource_timing$0(_R_) {
        return _R_;
    }
    function as_navigation_timing(_Q_) {
        return _Q_;
    }
    function time_origin_ms(p) {
        return caml_call2(Jv[21][2], p, cst_timeOrigin);
    }
    function clear_marks(p, n) {
        if (n) var n$0 = n[1], args = [
            0,
            n$0
        ];
        else var args = [
            0
        ];
        caml_js_meth_call(p, "clearMarks", args);
        return 0;
    }
    function clear_measures(p, n) {
        if (n) var n$0 = n[1], args = [
            0,
            n$0
        ];
        else var args = [
            0
        ];
        caml_js_meth_call(p, "clearMeasures", args);
        return 0;
    }
    function clear_resource_timings(p) {
        p.clearResourceTimings();
        return 0;
    }
    function get_entries(type, name, p) {
        if (name) {
            var n = name[1];
            if (type) {
                var t = type[1], _I_ = p.getEntriesByName(n, t);
                return caml_call1(caml_call1(Jv[29], function(_P_) {
                    return _P_;
                }), _I_);
            }
            var _J_ = p.getEntriesByName(n);
            return caml_call1(caml_call1(Jv[29], function(_O_) {
                return _O_;
            }), _J_);
        }
        if (type) {
            var t$0 = type[1], _K_ = p.getEntriesByType(t$0);
            return caml_call1(caml_call1(Jv[29], function(_N_) {
                return _N_;
            }), _K_);
        }
        var _L_ = p.getEntries();
        return caml_call1(caml_call1(Jv[29], function(_M_) {
            return _M_;
        }), _L_);
    }
    function mark$2(p, n) {
        p.mark(n);
        return 0;
    }
    function measure$0(start, stop, p, n) {
        if (start) {
            var s = start[1];
            if (stop) {
                var e = stop[1];
                p.measure(s, e);
                return 0;
            }
            p.measure(s);
            return 0;
        }
        if (stop) {
            var e$0 = stop[1];
            p.measure(Jv[5], e$0);
            return 0;
        }
        p.measure();
        return 0;
    }
    function now_ms(p) {
        return p.now();
    }
    function to_json$0(p) {
        return p.toJSON();
    }
    var console1 = Jv[12].console, navigator = Jv[12].navigator, performance1 = Jv[12].performance, window = Jv[12].window, is_secure_context = caml_call2(Jv[19][2], Jv[12], cst_isSecureContext), target$0 = Jv[12];
    function set_timeout(ms, f) {
        return Jv[12].setTimeout(caml_js_wrap_callback_strict(1, f), ms);
    }
    function set_interval(ms, f) {
        return Jv[12].setInterval(caml_js_wrap_callback_strict(1, f), ms);
    }
    function stop_timer(tid) {
        Jv[12].clearTimeout(tid);
        return 0;
    }
    function request_animation_frame(f) {
        return Jv[12].requestAnimationFrame(caml_js_wrap_callback_strict(1, f));
    }
    function cancel_animation_frame(fid) {
        Jv[12].cancelAnimationFrame(fid);
        return 0;
    }
    var Brr = [
        0,
        [
            0,
            [
                0,
                create$0,
                byte_length,
                slice
            ],
            [
                0,
                of_buffer,
                buffer,
                byte_offset,
                byte_length$0,
                get_int8,
                get_int16_be,
                get_int16_le,
                get_int32_be,
                get_int32_le,
                get_uint8,
                get_uint16_be,
                get_uint16_le,
                get_uint32_be,
                get_uint32_le,
                get_float32_be,
                get_float32_le,
                get_float64_be,
                get_float64_le,
                set_int8,
                set_int16_be,
                set_int16_le,
                set_int32_be,
                set_int32_le,
                set_uint8,
                set_uint16_be,
                set_uint16_le,
                set_uint32_be,
                set_uint32_le,
                set_float32_be,
                set_float32_le,
                set_float64_be,
                set_float64_le
            ],
            type_size_in_bytes,
            create$1,
            of_buffer$0,
            buffer,
            byte_offset,
            byte_length$0,
            length$0,
            type$2,
            get,
            set,
            set_tarray,
            fill,
            copy_within,
            slice$0,
            sub,
            find,
            find_index,
            for_all,
            exists,
            filter,
            iter,
            map,
            fold_left,
            fold_right,
            reverse,
            of_tarray,
            uint8_of_buffer,
            of_int_array,
            of_float_array,
            of_jstr,
            to_jstr,
            of_binary_jstr,
            to_binary_jstr,
            to_int_jstr,
            to_hex_jstr,
            type_to_bigarray_kind,
            type_of_bigarray_kind
        ],
        [
            0,
            Ending_type,
            init$0,
            of_jstr$0,
            of_array_buffer,
            byte_length$1,
            type$3,
            slice$1,
            array_buffer$0,
            stream,
            text,
            data_uri
        ],
        [
            0,
            init$1,
            of_blob,
            name,
            relative_path,
            last_modified_ms
        ],
        Base64,
        [
            0,
            encode$0,
            decode$0
        ],
        [
            0,
            v,
            scheme,
            host,
            port,
            path,
            query,
            fragment,
            with_uri,
            path_segments,
            with_path_segments,
            [
                0,
                is_empty,
                mem,
                find$0,
                find_all,
                fold,
                of_obj,
                of_jstr$1,
                to_jstr$0,
                of_assoc,
                to_assoc
            ],
            query_params,
            with_query_params,
            fragment_params,
            with_fragment_params,
            of_jstr$2,
            to_jstr$1,
            encode$2,
            decode$2,
            encode_component$0,
            decode_component$0
        ],
        [
            0,
            Type,
            init,
            create,
            type,
            target,
            current_target,
            composed_path,
            event_phase,
            bubbles,
            stop_propagation,
            stop_immediate_propagation,
            cancelable,
            prevent_default,
            default_prevented,
            composed,
            is_trusted,
            timestamp_ms,
            dispatch,
            listen_opts,
            listen,
            unlisten,
            next,
            [
                0,
                Effect,
                Item,
                [
                    0,
                    length,
                    add_jstr,
                    add_file,
                    remove,
                    clear,
                    caml_js_get,
                    items
                ],
                drop_effect,
                set_drop_effect,
                effect_allowed,
                set_effect_allowed,
                items$0
            ],
            Clipboard,
            Composition,
            Error1,
            Extendable,
            Focus,
            Hash_change,
            Input,
            Keyboard,
            Mouse,
            Drag,
            Pointer,
            Wheel,
            abort,
            activate,
            auxclick,
            beforeinput,
            beforeunload,
            blur,
            canplay,
            canplaythrough,
            change,
            click,
            clipboardchange,
            close,
            compositionend,
            compositionstart,
            compositionudpate,
            controllerchange,
            copy$0,
            cut,
            dblclick,
            dom_content_loaded,
            drag,
            dragend,
            dragenter,
            dragexit,
            dragleave,
            dragover,
            dragstart,
            drop,
            durationchange,
            emptied,
            ended,
            error$0,
            focus,
            focusin,
            focusout,
            fullscreenchange,
            fullscreenerror,
            gotpointercapture,
            hashchange,
            input,
            install,
            keydown,
            keyup,
            languagechange,
            load,
            loadeddata,
            loadedmetadata,
            loadstart,
            lostpointercapture,
            mousedown,
            mouseenter,
            mouseleave,
            mousemove,
            mouseout,
            mouseover,
            mouseup,
            open,
            paste,
            pause,
            play,
            playing,
            pointercancel,
            pointerdown,
            pointerenter,
            pointerleave,
            pointerlockchange,
            pointerlockerror,
            pointermove,
            pointerout,
            pointerover,
            pointerrawupdate,
            pointerup,
            progress,
            ratechange,
            reset,
            resize,
            scroll,
            seeked,
            seeking,
            select,
            statechange,
            stalled,
            suspend,
            timeupdate,
            unload,
            updatefound,
            visibilitychange,
            volumechange,
            waiting,
            wheel
        ],
        [
            0,
            v$0,
            void$0,
            is_void,
            true$0,
            int$0,
            float$0,
            if$0,
            if_some,
            to_pair,
            add_if,
            add_if_some,
            Name,
            accesskey$0,
            action$0,
            autocomplete$0,
            autofocus$0,
            charset$0,
            checked$0,
            class$1,
            cols$0,
            content$0,
            contenteditable$0,
            defer$0,
            dir$0,
            disabled$0,
            download$0,
            draggable$0,
            for$1,
            height$1,
            hidden$0,
            href$0,
            id$1,
            lang$0,
            list$0,
            media$0,
            method$0,
            name$1,
            placeholder$0,
            rel$0,
            required$0,
            rows$0,
            selected$0,
            spellcheck$0,
            src$0,
            style$0,
            tabindex$0,
            title$0,
            type$5,
            value$0,
            wrap$0,
            width$1
        ],
        [
            0,
            v$1,
            txt,
            txt$0,
            sp,
            nbsp,
            is_txt,
            is_el,
            tag_name,
            has_tag_name,
            txt_text,
            document1,
            find_by_class,
            find_by_tag_name,
            find_first_by_selector,
            fold_find_by_selector,
            parent,
            children,
            set_children,
            prepend_children,
            append_children,
            previous_sibling,
            next_sibling,
            insert_siblings,
            remove$0,
            at,
            set_at,
            [
                0,
                bool,
                int$1,
                float$1,
                jstr,
                checked$1,
                height$2,
                id$2,
                name$2,
                title$1,
                value$1,
                width$2
            ],
            prop,
            set_prop,
            class$2,
            set_class,
            Style,
            computed_style,
            inline_style,
            set_inline_style,
            remove_inline_style,
            inner_x,
            inner_y,
            inner_w,
            inner_h,
            bound_x,
            bound_y,
            bound_w,
            bound_h,
            scroll_x,
            scroll_y,
            scroll_w,
            scroll_h,
            scroll_into_view,
            has_focus,
            set_has_focus,
            is_locking_pointer,
            request_pointer_lock,
            Navigation_ui,
            fullscreen_opts,
            request_fullscreen,
            click$0,
            select_text,
            Input$0,
            Name$0,
            a$0,
            abbr$0,
            address$0,
            area$0,
            article$0,
            aside$0,
            audio$0,
            b$0,
            base$0,
            bdi$0,
            bdo$0,
            blockquote$0,
            body$0,
            br$0,
            button$1,
            canvas$0,
            caption$0,
            cite$0,
            code$2,
            col$0,
            colgroup$0,
            command$0,
            datalist$0,
            dd$0,
            del$0,
            details$0,
            dfn$0,
            div$0,
            dl$0,
            dt$0,
            em$0,
            embed$0,
            fieldset$0,
            figcaption$0,
            figure$0,
            footer$0,
            form$0,
            h1$0,
            h2$0,
            h3$0,
            h4$0,
            h5$0,
            h6$0,
            head$0,
            header$0,
            hgroup$0,
            hr$0,
            html$0,
            i$0,
            iframe$0,
            img$0,
            input$1,
            ins$0,
            kbd$0,
            keygen$0,
            label$0,
            legend$0,
            li$0,
            link$1,
            map$1,
            mark$0,
            menu$0,
            meta$0,
            meter$0,
            nav$0,
            noscript$0,
            object$0,
            ol$0,
            optgroup$0,
            option$0,
            output$0,
            p$0,
            function(_F_, _G_, _H_) {
                return void_cons(_B_, _F_, _G_, _H_);
            },
            pre$0,
            progress$1,
            q$0,
            rp$0,
            rt$0,
            ruby$0,
            s$0,
            samp$0,
            script$0,
            section$0,
            select$1,
            small$0,
            source$0,
            span$0,
            strong$0,
            style$2,
            sub$1,
            summary$0,
            sup$0,
            table$0,
            tbody$0,
            td$0,
            textarea$0,
            tfoot$0,
            th$0,
            thead$0,
            time$0,
            title$3,
            tr$0,
            track$0,
            u$0,
            ul$0,
            var$1,
            video$0,
            wbr$0
        ],
        [
            0,
            as_target,
            find_el_by_id,
            find_els_by_name,
            root,
            body$1,
            head$1,
            active_el,
            referrer,
            title$4,
            set_title,
            Visibility_state,
            visibility_state,
            pointer_lock_element,
            exit_pointer_lock,
            fullscreen_available,
            fullscreen_element,
            exit_fullscreen
        ],
        Abort,
        [
            0,
            get$0,
            set$0,
            clear$0,
            msg,
            str,
            log_result,
            log_if_error,
            log_if_error$0,
            log,
            trace,
            error$1,
            warn,
            info,
            debug,
            assert,
            dir$1,
            table$1,
            group,
            group_end,
            count,
            count_reset,
            time$1,
            time_log,
            time_end,
            profile,
            profile_end,
            time_stamp
        ],
        Window,
        Navigator,
        [
            0,
            [
                0,
                Type$0,
                name$97,
                type$6,
                start_time,
                end_time,
                duration,
                to_json,
                Resource_timing,
                [
                    0,
                    Type$1,
                    as_entry$0,
                    as_resource_timing,
                    unload_event_start,
                    unload_event_end,
                    dom_interactive,
                    dom_content_loaded_event_start,
                    dom_content_loaded_event_end,
                    dom_complete,
                    load_event_start,
                    load_event_end,
                    type$7,
                    redirect_count
                ],
                as_resource_timing$0,
                as_navigation_timing
            ],
            time_origin_ms,
            clear_marks,
            clear_measures,
            clear_resource_timings,
            get_entries,
            mark$2,
            measure$0,
            now_ms,
            to_json$0
        ],
        [
            0,
            console1,
            global_document,
            navigator,
            performance1,
            window,
            target$0,
            is_secure_context,
            set_timeout,
            set_interval,
            stop_timer,
            request_animation_frame,
            cancel_animation_frame
        ]
    ];
    runtime.caml_register_global(774, Brr, "Brr");
    return;
})(globalThis);
//# 5 "../.js/default/brr_svg/brr_svg.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_color_profile = "color-profile", cst_cursor = "cursor", cst_filter = "filter", cst_glyphRef = "glyphRef", cst_mask = "mask", cst_path = "path", cst_style = "style", cst_title = "title";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Jv = global_data.Jv, Stdlib_List = global_data.Stdlib__List, Jstr = global_data.Jstr, xlink = "http://www.w3.org/1999/xlink", xml = "http://www.w3.org/XML/1998/namespace", NS = [
        0,
        xlink,
        xml
    ], accentheight = "accent-height", accumulate = "accumulate", additive = "additive", alignmentbaseline = "alignment-baseline", alphabetic = "alphabetic", amplitude = "amplitude", arabicform = "arabic-form", ascent = "ascent", attributename = "attributeName", attributetype = "attributeType", azimuth = "azimuth", basefrequency = "baseFrequency", baselineshift = "baseline-shift", baseprofile = "baseProfile", bbox = "bbox", begin = "begin", bias = "bias", by = "by", calcmode = "calcMode", capheight = "cap-height", class$0 = "class", clip = "clip", clippath = "clip-path", clippathunits = "clipPathUnits", cliprule = "clip-rule", color = "color", colorinterpolation = "color-interpolation", colorinterpolationfilters = "color-interpolation-filters", colorprofile = cst_color_profile, colorrendering = "color-rendering", contentscripttype = "contentScriptType", contentstyletype = "contentStyleType", cursor = cst_cursor, cx = "cx", cy = "cy", d = "d", descent = "descent", diffuseconstant = "diffuseConstant", direction = "direction", display = "display", divisor = "divisor", dominantbaseline = "dominant-baseline", dur = "dur", dx = "dx", dy = "dy", edgemode = "edgeMode", elevation = "elevation", enablebackground = "enable-background", end = "end", exponent = "exponent", externalresourcesrequired = "externalResourcesRequired", fill = "fill", fillopacity = "fill-opacity", fillrule = "fill-rule", filter = cst_filter, filterres = "filterRes", filterunits = "filterUnits", floodcolor = "flood-color", floodopacity = "flood-opacity", fontfamily = "font-family", fontsize = "font-size", fontsizeadjust = "font-size-adjust", fontstretch = "font-stretch", fontstyle = "font-style", fontvariant = "font-variant", fontweight = "font-weight", format = "format", from = "from", fx = "fx", fy = "fy", g1 = "g1", g2 = "g2", glyphname = "glyph-name", glyphorientationhorizontal = "glyph-orientation-horizontal", glyphorientationvertical = "glyph-orientation-vertical", glyphref = cst_glyphRef, gradienttransform = "gradientTransform", gradientunits = "gradientUnits", hanging = "hanging", height = "height", horizadvx = "horiz-adv-x", horizoriginx = "horiz-origin-x", horizoriginy = "horiz-origin-y", id = "id", ideographic = "ideographic", imagerendering = "image-rendering", in$0 = "in", in2 = "in2", intercept = "intercept", k = "k", k1 = "k1", k2 = "k2", k3 = "k3", k4 = "k4", kernelmatrix = "kernelMatrix", kernelunitlength = "kernelUnitLength", kerning = "kerning", keypoints = "keyPoints", keysplines = "keySplines", keyTimes = "keyTimes", lang = "lang", lengthadjust = "lengthAdjust", letterspacing = "letter-spacing", lightingcolor = "lighting-color", limitingconeangle = "limitingConeAngle", local = "local", markerend = "marker-end", markerheight = "markerHeight", markermid = "marker-mid", markerstart = "marker-start", markerunits = "markerUnits", markerwidth = "markerWidth", mask = cst_mask, maskcontentunits = "maskContentUnits", maskunits = "maskUnits", mathematical = "mathematical", max = "max", media = "media", method = "method", min = "min", mode = "mode", name = "name", numoctaves = "numOctaves", offset = "offset", opacity = "opacity", operator = "operator", order = "order", orient = "orient", orientation = "orientation", origin = "origin", overflow = "overflow", overlineposition = "overline-position", overlinethickness = "overline-thickness", panose1 = "panose-1", path = cst_path, pathlength = "pathLength", patterncontentunits = "patternContentUnits", patterntransform = "patternTransform", patternunits = "patternUnits", pointerevents = "pointer-events", points = "points", pointsatx = "pointsAtX", pointsaty = "pointsAtY", pointsatz = "pointsAtZ", preservealpha = "preserveAlpha", preserveaspectratio = "preserveAspectRatio", primitiveunits = "primitiveUnits", r = "r", radius = "radius", refx = "refX", refy = "refY", renderingintent = "rendering-intent", repeatcount = "repeatCount", repeatdur = "repeatDur", requiredextensions = "requiredExtensions", requiredfeatures = "requiredFeatures", restart = "restart", result = "result", rotate = "rotate", rx = "rx", ry = "ry", scale = "scale", seed = "seed", shaperendering = "shape-rendering", slope = "slope", spacing = "spacing", specularconstant = "specularConstant", specularexponent = "specularExponent", spreadmethod = "spreadMethod", startoffset = "startOffset", stddeviation = "stdDeviation", stemh = "stemh", stemv = "stemv", stitchtiles = "stitchTiles", stopcolor = "stop-color", stopopacity = "stop-opacity", strikethroughposition = "strikethrough-position", strikethroughthickness = "strikethrough-thickness", string = "string", stroke = "stroke", strokedasharray = "stroke-dasharray", strokedashoffset = "stroke-dashoffset", strokelinecap = "stroke-linecap", strokelinejoin = "stroke-linejoin", strokemiterlimit = "stroke-miterlimit", strokeopacity = "stroke-opacity", strokewidth = "stroke-width", style = cst_style, surfacescale = "surfaceScale", systemlanguage = "systemLanguage", tablevalues = "tableValues", target = "target", targetx = "targetX", targety = "targetY", textanchor = "text-anchor", textdecoration = "text-decoration", textlength = "textLength", textrendering = "text-rendering", title = cst_title, to = "to", transform = "transform", type = "type", u1 = "u1", u2 = "u2", underlineposition = "underline-position", underlinethickness = "underline-thickness", unicode = "unicode", unicodebidi = "unicode-bidi", unicoderange = "unicode-range", unitsperem = "units-per-em", valphabetic = "v-alphabetic", values = "values", version = "version", vertadvy = "vert-adv-y", vertoriginx = "vert-origin-x", vertoriginy = "vert-origin-y", vhanging = "v-hanging", videographic = "v-ideographic", viewbox = "viewBox", viewtarget = "viewTarget", visibility = "visibility", vmathematical = "v-mathematical", width = "width", widths = "widths", wordspacing = "word-spacing", writingmode = "writing-mode", x = "x", x1 = "x1", x2 = "x2", xchannelselector = "xChannelSelector", xheight = "x-height", xlinkactuate = "xlink:actuate", xlinkarcrole = "xlink:arcrole", xlinkhref = "xlink:href", xlinkrole = "xlink:role", xlinkshow = "xlink:show", xlinktitle = "xlink:title", xlinktype = "xlink:type", xmlbase = "xml:base", xmllang = "xml:lang", xmlspace = "xml:space", y = "y", y1 = "y1", y2 = "y2", ychannelselector = "yChannelSelector", z = "z", zoomandpan = "zoomAndPan", Name = [
        0,
        accentheight,
        accumulate,
        additive,
        alignmentbaseline,
        alphabetic,
        amplitude,
        arabicform,
        ascent,
        attributename,
        attributetype,
        azimuth,
        basefrequency,
        baselineshift,
        baseprofile,
        bbox,
        begin,
        bias,
        by,
        calcmode,
        capheight,
        class$0,
        clip,
        clippath,
        clippathunits,
        cliprule,
        color,
        colorinterpolation,
        colorinterpolationfilters,
        colorprofile,
        colorrendering,
        contentscripttype,
        contentstyletype,
        cursor,
        cx,
        cy,
        d,
        descent,
        diffuseconstant,
        direction,
        display,
        divisor,
        dominantbaseline,
        dur,
        dx,
        dy,
        edgemode,
        elevation,
        enablebackground,
        end,
        exponent,
        externalresourcesrequired,
        fill,
        fillopacity,
        fillrule,
        filter,
        filterres,
        filterunits,
        floodcolor,
        floodopacity,
        fontfamily,
        fontsize,
        fontsizeadjust,
        fontstretch,
        fontstyle,
        fontvariant,
        fontweight,
        format,
        from,
        fx,
        fy,
        g1,
        g2,
        glyphname,
        glyphorientationhorizontal,
        glyphorientationvertical,
        glyphref,
        gradienttransform,
        gradientunits,
        hanging,
        height,
        horizadvx,
        horizoriginx,
        horizoriginy,
        id,
        ideographic,
        imagerendering,
        in$0,
        in2,
        intercept,
        k,
        k1,
        k2,
        k3,
        k4,
        kernelmatrix,
        kernelunitlength,
        kerning,
        keypoints,
        keysplines,
        keyTimes,
        lang,
        lengthadjust,
        letterspacing,
        lightingcolor,
        limitingconeangle,
        local,
        markerend,
        markerheight,
        markermid,
        markerstart,
        markerunits,
        markerwidth,
        mask,
        maskcontentunits,
        maskunits,
        mathematical,
        max,
        media,
        method,
        min,
        mode,
        name,
        numoctaves,
        offset,
        opacity,
        operator,
        order,
        orient,
        orientation,
        origin,
        overflow,
        overlineposition,
        overlinethickness,
        panose1,
        path,
        pathlength,
        patterncontentunits,
        patterntransform,
        patternunits,
        pointerevents,
        points,
        pointsatx,
        pointsaty,
        pointsatz,
        preservealpha,
        preserveaspectratio,
        primitiveunits,
        r,
        radius,
        refx,
        refy,
        renderingintent,
        repeatcount,
        repeatdur,
        requiredextensions,
        requiredfeatures,
        restart,
        result,
        rotate,
        rx,
        ry,
        scale,
        seed,
        shaperendering,
        slope,
        spacing,
        specularconstant,
        specularexponent,
        spreadmethod,
        startoffset,
        stddeviation,
        stemh,
        stemv,
        stitchtiles,
        stopcolor,
        stopopacity,
        strikethroughposition,
        strikethroughthickness,
        string,
        stroke,
        strokedasharray,
        strokedashoffset,
        strokelinecap,
        strokelinejoin,
        strokemiterlimit,
        strokeopacity,
        strokewidth,
        style,
        surfacescale,
        systemlanguage,
        tablevalues,
        target,
        targetx,
        targety,
        textanchor,
        textdecoration,
        textlength,
        textrendering,
        title,
        to,
        transform,
        type,
        u1,
        u2,
        underlineposition,
        underlinethickness,
        unicode,
        unicodebidi,
        unicoderange,
        unitsperem,
        valphabetic,
        values,
        version,
        vertadvy,
        vertoriginx,
        vertoriginy,
        vhanging,
        videographic,
        viewbox,
        viewtarget,
        visibility,
        vmathematical,
        width,
        widths,
        wordspacing,
        writingmode,
        x,
        x1,
        x2,
        xchannelselector,
        xheight,
        xlinkactuate,
        xlinkarcrole,
        xlinkhref,
        xlinkrole,
        xlinkshow,
        xlinktitle,
        xlinktype,
        xmlbase,
        xmllang,
        xmlspace,
        y,
        y1,
        y2,
        ychannelselector,
        z,
        zoomandpan
    ];
    function v(ns, n, v) {
        return [
            0,
            ns,
            n,
            v
        ];
    }
    function accentheight$0(s) {
        var n = Name[1];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function accumulate$0(s) {
        var n = Name[2];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function additive$0(s) {
        var n = Name[3];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function alignmentbaseline$0(s) {
        var n = Name[4];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function alphabetic$0(s) {
        var n = Name[5];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function amplitude$0(s) {
        var n = Name[6];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function arabicform$0(s) {
        var n = Name[7];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ascent$0(s) {
        var n = Name[8];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function attributename$0(s) {
        var n = Name[9];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function attributetype$0(s) {
        var n = Name[10];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function azimuth$0(s) {
        var n = Name[11];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function basefrequency$0(s) {
        var n = Name[12];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function baselineshift$0(s) {
        var n = Name[13];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function baseprofile$0(s) {
        var n = Name[14];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function bbox$0(s) {
        var n = Name[15];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function begin$0(s) {
        var n = Name[16];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function bias$0(s) {
        var n = Name[17];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function by$0(s) {
        var n = Name[18];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function calcmode$0(s) {
        var n = Name[19];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function capheight$0(s) {
        var n = Name[20];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function class$1(s) {
        var n = Name[21];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clip$0(s) {
        var n = Name[22];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clippath$0(s) {
        var n = Name[23];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function clippathunits$0(s) {
        var n = Name[24];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cliprule$0(s) {
        var n = Name[25];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function color$0(s) {
        var n = Name[26];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorinterpolation$0(s) {
        var n = Name[27];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorinterpolationfilters$0(s) {
        var n = Name[28];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorprofile$0(s) {
        var n = Name[29];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function colorrendering$0(s) {
        var n = Name[30];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function contentscripttype$0(s) {
        var n = Name[31];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function contentstyletype$0(s) {
        var n = Name[32];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cursor$0(s) {
        var n = Name[33];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cx$0(s) {
        var n = Name[34];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function cy$0(s) {
        var n = Name[35];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function d$0(s) {
        var n = Name[36];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function descent$0(s) {
        var n = Name[37];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function diffuseconstant$0(s) {
        var n = Name[38];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function direction$0(s) {
        var n = Name[39];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function display$0(s) {
        var n = Name[40];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function divisor$0(s) {
        var n = Name[41];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dominantbaseline$0(s) {
        var n = Name[42];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dur$0(s) {
        var n = Name[43];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dx$0(s) {
        var n = Name[44];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function dy$0(s) {
        var n = Name[45];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function edgemode$0(s) {
        var n = Name[46];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function elevation$0(s) {
        var n = Name[47];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function enablebackground$0(s) {
        var n = Name[48];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function end$0(s) {
        var n = Name[49];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function exponent$0(s) {
        var n = Name[50];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function externalresourcesrequired$0(s) {
        var n = Name[51];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fill$0(s) {
        var n = Name[52];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fillopacity$0(s) {
        var n = Name[53];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fillrule$0(s) {
        var n = Name[54];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filter$0(s) {
        var n = Name[55];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filterres$0(s) {
        var n = Name[56];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function filterunits$0(s) {
        var n = Name[57];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function floodcolor$0(s) {
        var n = Name[58];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function floodopacity$0(s) {
        var n = Name[59];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontfamily$0(s) {
        var n = Name[60];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontsize$0(s) {
        var n = Name[61];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontsizeadjust$0(s) {
        var n = Name[62];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontstretch$0(s) {
        var n = Name[63];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontstyle$0(s) {
        var n = Name[64];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontvariant$0(s) {
        var n = Name[65];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fontweight$0(s) {
        var n = Name[66];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function format$0(s) {
        var n = Name[67];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function from$0(s) {
        var n = Name[68];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fx$0(s) {
        var n = Name[69];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function fy$0(s) {
        var n = Name[70];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function g1$0(s) {
        var n = Name[71];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function g2$0(s) {
        var n = Name[72];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphname$0(s) {
        var n = Name[73];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphorientationhorizontal$0(s) {
        var n = Name[74];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphorientationvertical$0(s) {
        var n = Name[75];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function glyphref$0(s) {
        var n = Name[76];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function gradienttransform$0(s) {
        var n = Name[77];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function gradientunits$0(s) {
        var n = Name[78];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function hanging$0(s) {
        var n = Name[79];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function height$0(s) {
        var n = Name[80];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizadvx$0(s) {
        var n = Name[81];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizoriginx$0(s) {
        var n = Name[82];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function horizoriginy$0(s) {
        var n = Name[83];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function id$0(s) {
        var n = Name[84];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ideographic$0(s) {
        var n = Name[85];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function imagerendering$0(s) {
        var n = Name[86];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function in$1(s) {
        var n = Name[87];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function in2$0(s) {
        var n = Name[88];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function intercept$0(s) {
        var n = Name[89];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k$0(s) {
        var n = Name[90];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k1$0(s) {
        var n = Name[91];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k2$0(s) {
        var n = Name[92];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k3$0(s) {
        var n = Name[93];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function k4$0(s) {
        var n = Name[94];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kernelmatrix$0(s) {
        var n = Name[95];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kernelunitlength$0(s) {
        var n = Name[96];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function kerning$0(s) {
        var n = Name[97];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keypoints$0(s) {
        var n = Name[98];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keysplines$0(s) {
        var n = Name[99];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function keyTimes$0(s) {
        var n = Name[100];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lang$0(s) {
        var n = Name[101];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lengthadjust$0(s) {
        var n = Name[102];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function letterspacing$0(s) {
        var n = Name[103];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function lightingcolor$0(s) {
        var n = Name[104];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function limitingconeangle$0(s) {
        var n = Name[105];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function local$0(s) {
        var n = Name[106];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerend$0(s) {
        var n = Name[107];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerheight$0(s) {
        var n = Name[108];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markermid$0(s) {
        var n = Name[109];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerstart$0(s) {
        var n = Name[110];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerunits$0(s) {
        var n = Name[111];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function markerwidth$0(s) {
        var n = Name[112];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mask$0(s) {
        var n = Name[113];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function maskcontentunits$0(s) {
        var n = Name[114];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function maskunits$0(s) {
        var n = Name[115];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mathematical$0(s) {
        var n = Name[116];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function max$0(s) {
        var n = Name[117];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function media$0(s) {
        var n = Name[118];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function method$0(s) {
        var n = Name[119];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function min$0(s) {
        var n = Name[120];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function mode$0(s) {
        var n = Name[121];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function name$0(s) {
        var n = Name[122];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function numoctaves$0(s) {
        var n = Name[123];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function offset$0(s) {
        var n = Name[124];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function opacity$0(s) {
        var n = Name[125];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function operator$0(s) {
        var n = Name[126];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function order$0(s) {
        var n = Name[127];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function orient$0(s) {
        var n = Name[128];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function orientation$0(s) {
        var n = Name[129];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function origin$0(s) {
        var n = Name[130];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overflow$0(s) {
        var n = Name[131];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overlineposition$0(s) {
        var n = Name[132];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function overlinethickness$0(s) {
        var n = Name[133];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function panose1$0(s) {
        var n = Name[134];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function path$0(s) {
        var n = Name[135];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pathlength$0(s) {
        var n = Name[136];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patterncontentunits$0(s) {
        var n = Name[137];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patterntransform$0(s) {
        var n = Name[138];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function patternunits$0(s) {
        var n = Name[139];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointerevents$0(s) {
        var n = Name[140];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function points$0(s) {
        var n = Name[141];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsatx$0(s) {
        var n = Name[142];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsaty$0(s) {
        var n = Name[143];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function pointsatz$0(s) {
        var n = Name[144];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function preservealpha$0(s) {
        var n = Name[145];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function preserveaspectratio$0(s) {
        var n = Name[146];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function primitiveunits$0(s) {
        var n = Name[147];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function r$0(s) {
        var n = Name[148];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function radius$0(s) {
        var n = Name[149];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function refx$0(s) {
        var n = Name[150];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function refy$0(s) {
        var n = Name[151];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function renderingintent$0(s) {
        var n = Name[152];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function repeatcount$0(s) {
        var n = Name[153];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function repeatdur$0(s) {
        var n = Name[154];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function requiredextensions$0(s) {
        var n = Name[155];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function requiredfeatures$0(s) {
        var n = Name[156];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function restart$0(s) {
        var n = Name[157];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function result$0(s) {
        var n = Name[158];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function rotate$0(s) {
        var n = Name[159];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function rx$0(s) {
        var n = Name[160];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ry$0(s) {
        var n = Name[161];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function scale$0(s) {
        var n = Name[162];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function seed$0(s) {
        var n = Name[163];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function shaperendering$0(s) {
        var n = Name[164];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function slope$0(s) {
        var n = Name[165];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function spacing$0(s) {
        var n = Name[166];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function specularconstant$0(s) {
        var n = Name[167];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function specularexponent$0(s) {
        var n = Name[168];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function spreadmethod$0(s) {
        var n = Name[169];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function startoffset$0(s) {
        var n = Name[170];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stddeviation$0(s) {
        var n = Name[171];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stemh$0(s) {
        var n = Name[172];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stemv$0(s) {
        var n = Name[173];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stitchtiles$0(s) {
        var n = Name[174];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stopcolor$0(s) {
        var n = Name[175];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stopopacity$0(s) {
        var n = Name[176];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strikethroughposition$0(s) {
        var n = Name[177];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strikethroughthickness$0(s) {
        var n = Name[178];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function string$0(s) {
        var n = Name[179];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function stroke$0(s) {
        var n = Name[180];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokedasharray$0(s) {
        var n = Name[181];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokedashoffset$0(s) {
        var n = Name[182];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokelinecap$0(s) {
        var n = Name[183];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokelinejoin$0(s) {
        var n = Name[184];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokemiterlimit$0(s) {
        var n = Name[185];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokeopacity$0(s) {
        var n = Name[186];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function strokewidth$0(s) {
        var n = Name[187];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function style$0(s) {
        var n = Name[188];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function surfacescale$0(s) {
        var n = Name[189];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function systemlanguage$0(s) {
        var n = Name[190];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function tablevalues$0(s) {
        var n = Name[191];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function target$0(s) {
        var n = Name[192];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function targetx$0(s) {
        var n = Name[193];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function targety$0(s) {
        var n = Name[194];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textanchor$0(s) {
        var n = Name[195];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textdecoration$0(s) {
        var n = Name[196];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textlength$0(s) {
        var n = Name[197];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function textrendering$0(s) {
        var n = Name[198];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function title$0(s) {
        var n = Name[199];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function to$0(s) {
        var n = Name[200];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function transform$0(s) {
        var n = Name[201];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function type$0(s) {
        var n = Name[202];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function u1$0(s) {
        var n = Name[203];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function u2$0(s) {
        var n = Name[204];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function underlineposition$0(s) {
        var n = Name[205];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function underlinethickness$0(s) {
        var n = Name[206];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicode$0(s) {
        var n = Name[207];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicodebidi$0(s) {
        var n = Name[208];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unicoderange$0(s) {
        var n = Name[209];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function unitsperem$0(s) {
        var n = Name[210];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function valphabetic$0(s) {
        var n = Name[211];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function values$0(s) {
        var n = Name[212];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function version$0(s) {
        var n = Name[213];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertadvy$0(s) {
        var n = Name[214];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertoriginx$0(s) {
        var n = Name[215];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vertoriginy$0(s) {
        var n = Name[216];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vhanging$0(s) {
        var n = Name[217];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function videographic$0(s) {
        var n = Name[218];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function viewbox$0(s) {
        var n = Name[219];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function viewtarget$0(s) {
        var n = Name[220];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function visibility$0(s) {
        var n = Name[221];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function vmathematical$0(s) {
        var n = Name[222];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function width$0(s) {
        var n = Name[223];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function widths$0(s) {
        var n = Name[224];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function wordspacing$0(s) {
        var n = Name[225];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function writingmode$0(s) {
        var n = Name[226];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x$0(s) {
        var n = Name[227];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x1$0(s) {
        var n = Name[228];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function x2$0(s) {
        var n = Name[229];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xchannelselector$0(s) {
        var n = Name[230];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xheight$0(s) {
        var n = Name[231];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function xlinkactuate$0(s) {
        var n = Name[232], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkarcrole$0(s) {
        var n = Name[233], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkhref$0(s) {
        var n = Name[234], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkrole$0(s) {
        var n = Name[235], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinkshow$0(s) {
        var n = Name[236], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinktitle$0(s) {
        var n = Name[237], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xlinktype$0(s) {
        var n = Name[238], ns = [
            0,
            NS[1]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmlbase$0(s) {
        var n = Name[239], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmllang$0(s) {
        var n = Name[240], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function xmlspace$0(s) {
        var n = Name[241], ns = [
            0,
            NS[2]
        ];
        return [
            0,
            ns,
            n,
            s
        ];
    }
    function y$0(s) {
        var n = Name[242];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function y1$0(s) {
        var n = Name[243];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function y2$0(s) {
        var n = Name[244];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function ychannelselector$0(s) {
        var n = Name[245];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function z$0(s) {
        var n = Name[246];
        return [
            0,
            0,
            n,
            s
        ];
    }
    function zoomandpan$0(s) {
        var n = Name[247];
        return [
            0,
            0,
            n,
            s
        ];
    }
    var a = "a", altglyph = "altGlyph", altglyphdef = "altGlyphDef", altglyphitem = "altGlyphItem", animate = "animate", animatecolor = "animateColor", animatemotion = "animateMotion", animatetransform = "animateTransform", circle = "circle", clippath$1 = "clipPath", colorprofile$1 = cst_color_profile, cursor$1 = cst_cursor, defs = "defs", desc = "desc", ellipse = "ellipse", feblend = "feBlend", fecolormatrix = "feColorMatrix", fecomponenttransfer = "feComponentTransfer", fecomposite = "feComposite", feconvolvematrix = "feConvolveMatrix", fediffuselighting = "feDiffuseLighting", fedisplacementmap = "feDisplacementMap", fedistantlight = "feDistantLight", feflood = "feFlood", fefunca = "feFuncA", fefuncb = "feFuncB", fefuncg = "feFuncG", fefuncr = "feFuncR", fegaussianblur = "feGaussianBlur", feimage = "feImage", femerge = "feMerge", femergenode = "feMergeNode", femorphology = "feMorphology", feoffset = "feOffset", fepointlight = "fePointLight", fespecularlighting = "feSpecularLighting", fespotlight = "feSpotLight", fetile = "feTile", feturbulence = "feTurbulence", filter$1 = cst_filter, font = "font", fontface = "fontFace", fontfaceformat = "fontFaceFormat", fontfacename = "fontFaceName", fontfacesrc = "fontFaceSrc", fontfaceuri = "fontFaceUri", foreignobject = "foreignObject", g = "g", glyph = "glyph", glyphref$1 = cst_glyphRef, hkern = "hkern", image = "image", line = "line", lineargradient = "linearGradient", marker = "marker", mask$1 = cst_mask, metadata = "metadata", missingglyph = "missingGlyph", mpath = "mpath", path$1 = cst_path, pattern = "pattern", polygon = "svpolygong", polyline = "polyline", radialgradient = "radialGradient", rect = "rect", script = "script", set = "set", stop = "stop", style$1 = cst_style, svg = "svg", switch$0 = "switch", symbol = "symbol", text = "text'", textpath = "textPath", title$1 = cst_title, tref = "tref", tspan = "tspan", use = "use", view = "view", vkern = "vkern", Name$0 = [
        0,
        a,
        altglyph,
        altglyphdef,
        altglyphitem,
        animate,
        animatecolor,
        animatemotion,
        animatetransform,
        circle,
        clippath$1,
        colorprofile$1,
        cursor$1,
        defs,
        desc,
        ellipse,
        feblend,
        fecolormatrix,
        fecomponenttransfer,
        fecomposite,
        feconvolvematrix,
        fediffuselighting,
        fedisplacementmap,
        fedistantlight,
        feflood,
        fefunca,
        fefuncb,
        fefuncg,
        fefuncr,
        fegaussianblur,
        feimage,
        femerge,
        femergenode,
        femorphology,
        feoffset,
        fepointlight,
        fespecularlighting,
        fespotlight,
        fetile,
        feturbulence,
        filter$1,
        font,
        fontface,
        fontfaceformat,
        fontfacename,
        fontfacesrc,
        fontfaceuri,
        foreignobject,
        g,
        glyph,
        glyphref$1,
        hkern,
        image,
        line,
        lineargradient,
        marker,
        mask$1,
        metadata,
        missingglyph,
        mpath,
        path$1,
        pattern,
        polygon,
        polyline,
        radialgradient,
        rect,
        script,
        set,
        stop,
        style$1,
        svg,
        switch$0,
        symbol,
        text,
        textpath,
        title$1,
        tref,
        tspan,
        use,
        view,
        vkern
    ], global_document = Jv[12].document;
    function v$0(_a_, opt, name, cs) {
        var d = _a_ ? _a_[1] : global_document, at = opt ? opt[1] : 0, e = d.createElementNS("http://www.w3.org/2000/svg", name);
        caml_call2(Stdlib_List[18], function(param) {
            var v = param[3], a = param[2], ns = param[1];
            return caml_call2(Jstr[28], a, Name[21]) ? caml_call1(Jstr[24], v) ? 0 : (e.classList.add(v), 0) : (e.setAttributeNS(caml_call3(Jv[11], Jv[5], function(_b_) {
                return _b_;
            }, ns), a, v), 0);
        }, at);
        caml_call2(Stdlib_List[18], function(n) {
            e.appendChild(n);
            return 0;
        }, cs);
        return e;
    }
    function txt(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(s);
    }
    function txt$0(opt, s) {
        var d = opt ? opt[1] : global_document;
        return d.createTextNode(caml_call1(Jv[24], s));
    }
    var name$1 = Name$0[1];
    function a$0(d, at, cs) {
        return v$0(d, at, name$1, cs);
    }
    var name$2 = Name$0[2];
    function altglyph$0(d, at, cs) {
        return v$0(d, at, name$2, cs);
    }
    var name$3 = Name$0[3];
    function altglyphdef$0(d, at, cs) {
        return v$0(d, at, name$3, cs);
    }
    var name$4 = Name$0[4];
    function altglyphitem$0(d, at, cs) {
        return v$0(d, at, name$4, cs);
    }
    var name$5 = Name$0[5];
    function animate$0(d, at, cs) {
        return v$0(d, at, name$5, cs);
    }
    var name$6 = Name$0[6];
    function animatecolor$0(d, at, cs) {
        return v$0(d, at, name$6, cs);
    }
    var name$7 = Name$0[7];
    function animatemotion$0(d, at, cs) {
        return v$0(d, at, name$7, cs);
    }
    var name$8 = Name$0[8];
    function animatetransform$0(d, at, cs) {
        return v$0(d, at, name$8, cs);
    }
    var name$9 = Name$0[9];
    function circle$0(d, at, cs) {
        return v$0(d, at, name$9, cs);
    }
    var name$10 = Name$0[10];
    function clippath$2(d, at, cs) {
        return v$0(d, at, name$10, cs);
    }
    var name$11 = Name$0[11];
    function colorprofile$2(d, at, cs) {
        return v$0(d, at, name$11, cs);
    }
    var name$12 = Name$0[12];
    function cursor$2(d, at, cs) {
        return v$0(d, at, name$12, cs);
    }
    var name$13 = Name$0[13];
    function defs$0(d, at, cs) {
        return v$0(d, at, name$13, cs);
    }
    var name$14 = Name$0[14];
    function desc$0(d, at, cs) {
        return v$0(d, at, name$14, cs);
    }
    var name$15 = Name$0[15];
    function ellipse$0(d, at, cs) {
        return v$0(d, at, name$15, cs);
    }
    var name$16 = Name$0[16];
    function feblend$0(d, at, cs) {
        return v$0(d, at, name$16, cs);
    }
    var name$17 = Name$0[17];
    function fecolormatrix$0(d, at, cs) {
        return v$0(d, at, name$17, cs);
    }
    var name$18 = Name$0[18];
    function fecomponenttransfer$0(d, at, cs) {
        return v$0(d, at, name$18, cs);
    }
    var name$19 = Name$0[19];
    function fecomposite$0(d, at, cs) {
        return v$0(d, at, name$19, cs);
    }
    var name$20 = Name$0[20];
    function feconvolvematrix$0(d, at, cs) {
        return v$0(d, at, name$20, cs);
    }
    var name$21 = Name$0[21];
    function fediffuselighting$0(d, at, cs) {
        return v$0(d, at, name$21, cs);
    }
    var name$22 = Name$0[22];
    function fedisplacementmap$0(d, at, cs) {
        return v$0(d, at, name$22, cs);
    }
    var name$23 = Name$0[23];
    function fedistantlight$0(d, at, cs) {
        return v$0(d, at, name$23, cs);
    }
    var name$24 = Name$0[24];
    function feflood$0(d, at, cs) {
        return v$0(d, at, name$24, cs);
    }
    var name$25 = Name$0[25];
    function fefunca$0(d, at, cs) {
        return v$0(d, at, name$25, cs);
    }
    var name$26 = Name$0[26];
    function fefuncb$0(d, at, cs) {
        return v$0(d, at, name$26, cs);
    }
    var name$27 = Name$0[27];
    function fefuncg$0(d, at, cs) {
        return v$0(d, at, name$27, cs);
    }
    var name$28 = Name$0[28];
    function fefuncr$0(d, at, cs) {
        return v$0(d, at, name$28, cs);
    }
    var name$29 = Name$0[29];
    function fegaussianblur$0(d, at, cs) {
        return v$0(d, at, name$29, cs);
    }
    var name$30 = Name$0[30];
    function feimage$0(d, at, cs) {
        return v$0(d, at, name$30, cs);
    }
    var name$31 = Name$0[31];
    function femerge$0(d, at, cs) {
        return v$0(d, at, name$31, cs);
    }
    var name$32 = Name$0[32];
    function femergenode$0(d, at, cs) {
        return v$0(d, at, name$32, cs);
    }
    var name$33 = Name$0[33];
    function femorphology$0(d, at, cs) {
        return v$0(d, at, name$33, cs);
    }
    var name$34 = Name$0[34];
    function feoffset$0(d, at, cs) {
        return v$0(d, at, name$34, cs);
    }
    var name$35 = Name$0[35];
    function fepointlight$0(d, at, cs) {
        return v$0(d, at, name$35, cs);
    }
    var name$36 = Name$0[36];
    function fespecularlighting$0(d, at, cs) {
        return v$0(d, at, name$36, cs);
    }
    var name$37 = Name$0[37];
    function fespotlight$0(d, at, cs) {
        return v$0(d, at, name$37, cs);
    }
    var name$38 = Name$0[38];
    function fetile$0(d, at, cs) {
        return v$0(d, at, name$38, cs);
    }
    var name$39 = Name$0[39];
    function feturbulence$0(d, at, cs) {
        return v$0(d, at, name$39, cs);
    }
    var name$40 = Name$0[40];
    function filter$2(d, at, cs) {
        return v$0(d, at, name$40, cs);
    }
    var name$41 = Name$0[41];
    function font$0(d, at, cs) {
        return v$0(d, at, name$41, cs);
    }
    var name$42 = Name$0[42];
    function fontface$0(d, at, cs) {
        return v$0(d, at, name$42, cs);
    }
    var name$43 = Name$0[43];
    function fontfaceformat$0(d, at, cs) {
        return v$0(d, at, name$43, cs);
    }
    var name$44 = Name$0[44];
    function fontfacename$0(d, at, cs) {
        return v$0(d, at, name$44, cs);
    }
    var name$45 = Name$0[45];
    function fontfacesrc$0(d, at, cs) {
        return v$0(d, at, name$45, cs);
    }
    var name$46 = Name$0[46];
    function fontfaceuri$0(d, at, cs) {
        return v$0(d, at, name$46, cs);
    }
    var name$47 = Name$0[47];
    function foreignobject$0(d, at, cs) {
        return v$0(d, at, name$47, cs);
    }
    var name$48 = Name$0[48];
    function g$0(d, at, cs) {
        return v$0(d, at, name$48, cs);
    }
    var name$49 = Name$0[49];
    function glyph$0(d, at, cs) {
        return v$0(d, at, name$49, cs);
    }
    var name$50 = Name$0[50];
    function glyphref$2(d, at, cs) {
        return v$0(d, at, name$50, cs);
    }
    var name$51 = Name$0[51];
    function hkern$0(d, at, cs) {
        return v$0(d, at, name$51, cs);
    }
    var name$52 = Name$0[52];
    function image$0(d, at, cs) {
        return v$0(d, at, name$52, cs);
    }
    var name$53 = Name$0[53];
    function line$0(d, at, cs) {
        return v$0(d, at, name$53, cs);
    }
    var name$54 = Name$0[54];
    function lineargradient$0(d, at, cs) {
        return v$0(d, at, name$54, cs);
    }
    var name$55 = Name$0[55];
    function marker$0(d, at, cs) {
        return v$0(d, at, name$55, cs);
    }
    var name$56 = Name$0[56];
    function mask$2(d, at, cs) {
        return v$0(d, at, name$56, cs);
    }
    var name$57 = Name$0[57];
    function metadata$0(d, at, cs) {
        return v$0(d, at, name$57, cs);
    }
    var name$58 = Name$0[58];
    function missingglyph$0(d, at, cs) {
        return v$0(d, at, name$58, cs);
    }
    var name$59 = Name$0[59];
    function mpath$0(d, at, cs) {
        return v$0(d, at, name$59, cs);
    }
    var name$60 = Name$0[60];
    function path$2(d, at, cs) {
        return v$0(d, at, name$60, cs);
    }
    var name$61 = Name$0[61];
    function pattern$0(d, at, cs) {
        return v$0(d, at, name$61, cs);
    }
    var name$62 = Name$0[62];
    function polygon$0(d, at, cs) {
        return v$0(d, at, name$62, cs);
    }
    var name$63 = Name$0[63];
    function polyline$0(d, at, cs) {
        return v$0(d, at, name$63, cs);
    }
    var name$64 = Name$0[64];
    function radialgradient$0(d, at, cs) {
        return v$0(d, at, name$64, cs);
    }
    var name$65 = Name$0[65];
    function rect$0(d, at, cs) {
        return v$0(d, at, name$65, cs);
    }
    var name$66 = Name$0[66];
    function script$0(d, at, cs) {
        return v$0(d, at, name$66, cs);
    }
    var name$67 = Name$0[67];
    function set$0(d, at, cs) {
        return v$0(d, at, name$67, cs);
    }
    var name$68 = Name$0[68];
    function stop$0(d, at, cs) {
        return v$0(d, at, name$68, cs);
    }
    var name$69 = Name$0[69];
    function style$2(d, at, cs) {
        return v$0(d, at, name$69, cs);
    }
    var name$70 = Name$0[70];
    function svg$0(d, at, cs) {
        return v$0(d, at, name$70, cs);
    }
    var name$71 = Name$0[71];
    function switch$1(d, at, cs) {
        return v$0(d, at, name$71, cs);
    }
    var name$72 = Name$0[72];
    function symbol$0(d, at, cs) {
        return v$0(d, at, name$72, cs);
    }
    var name$73 = Name$0[73];
    function text$0(d, at, cs) {
        return v$0(d, at, name$73, cs);
    }
    var name$74 = Name$0[74];
    function textpath$0(d, at, cs) {
        return v$0(d, at, name$74, cs);
    }
    var name$75 = Name$0[75];
    function title$2(d, at, cs) {
        return v$0(d, at, name$75, cs);
    }
    var name$76 = Name$0[76];
    function tref$0(d, at, cs) {
        return v$0(d, at, name$76, cs);
    }
    var name$77 = Name$0[77];
    function tspan$0(d, at, cs) {
        return v$0(d, at, name$77, cs);
    }
    var name$78 = Name$0[78];
    function use$0(d, at, cs) {
        return v$0(d, at, name$78, cs);
    }
    var name$79 = Name$0[79];
    function view$0(d, at, cs) {
        return v$0(d, at, name$79, cs);
    }
    var name$80 = Name$0[80];
    function vkern$0(d, at, cs) {
        return v$0(d, at, name$80, cs);
    }
    var Brr_svg = [
        0,
        NS,
        [
            0,
            v,
            Name,
            accentheight$0,
            accumulate$0,
            additive$0,
            alignmentbaseline$0,
            alphabetic$0,
            amplitude$0,
            arabicform$0,
            ascent$0,
            attributename$0,
            attributetype$0,
            azimuth$0,
            basefrequency$0,
            baselineshift$0,
            baseprofile$0,
            bbox$0,
            begin$0,
            bias$0,
            by$0,
            calcmode$0,
            capheight$0,
            class$1,
            clip$0,
            clippath$0,
            clippathunits$0,
            cliprule$0,
            color$0,
            colorinterpolation$0,
            colorinterpolationfilters$0,
            colorprofile$0,
            colorrendering$0,
            contentscripttype$0,
            contentstyletype$0,
            cursor$0,
            cx$0,
            cy$0,
            d$0,
            descent$0,
            diffuseconstant$0,
            direction$0,
            display$0,
            divisor$0,
            dominantbaseline$0,
            dur$0,
            dx$0,
            dy$0,
            edgemode$0,
            elevation$0,
            enablebackground$0,
            end$0,
            exponent$0,
            externalresourcesrequired$0,
            fill$0,
            fillopacity$0,
            fillrule$0,
            filter$0,
            filterres$0,
            filterunits$0,
            floodcolor$0,
            floodopacity$0,
            fontfamily$0,
            fontsize$0,
            fontsizeadjust$0,
            fontstretch$0,
            fontstyle$0,
            fontvariant$0,
            fontweight$0,
            format$0,
            from$0,
            fx$0,
            fy$0,
            g1$0,
            g2$0,
            glyphname$0,
            glyphorientationhorizontal$0,
            glyphorientationvertical$0,
            glyphref$0,
            gradienttransform$0,
            gradientunits$0,
            hanging$0,
            height$0,
            horizadvx$0,
            horizoriginx$0,
            horizoriginy$0,
            id$0,
            ideographic$0,
            imagerendering$0,
            in$1,
            in2$0,
            intercept$0,
            k$0,
            k1$0,
            k2$0,
            k3$0,
            k4$0,
            kernelmatrix$0,
            kernelunitlength$0,
            kerning$0,
            keypoints$0,
            keysplines$0,
            keyTimes$0,
            lang$0,
            lengthadjust$0,
            letterspacing$0,
            lightingcolor$0,
            limitingconeangle$0,
            local$0,
            markerend$0,
            markerheight$0,
            markermid$0,
            markerstart$0,
            markerunits$0,
            markerwidth$0,
            mask$0,
            maskcontentunits$0,
            maskunits$0,
            mathematical$0,
            max$0,
            media$0,
            method$0,
            min$0,
            mode$0,
            name$0,
            numoctaves$0,
            offset$0,
            opacity$0,
            operator$0,
            order$0,
            orient$0,
            orientation$0,
            origin$0,
            overflow$0,
            overlineposition$0,
            overlinethickness$0,
            panose1$0,
            path$0,
            pathlength$0,
            patterncontentunits$0,
            patterntransform$0,
            patternunits$0,
            pointerevents$0,
            points$0,
            pointsatx$0,
            pointsaty$0,
            pointsatz$0,
            preservealpha$0,
            preserveaspectratio$0,
            primitiveunits$0,
            r$0,
            radius$0,
            refx$0,
            refy$0,
            renderingintent$0,
            repeatcount$0,
            repeatdur$0,
            requiredextensions$0,
            requiredfeatures$0,
            restart$0,
            result$0,
            rotate$0,
            rx$0,
            ry$0,
            scale$0,
            seed$0,
            shaperendering$0,
            slope$0,
            spacing$0,
            specularconstant$0,
            specularexponent$0,
            spreadmethod$0,
            startoffset$0,
            stddeviation$0,
            stemh$0,
            stemv$0,
            stitchtiles$0,
            stopcolor$0,
            stopopacity$0,
            strikethroughposition$0,
            strikethroughthickness$0,
            string$0,
            stroke$0,
            strokedasharray$0,
            strokedashoffset$0,
            strokelinecap$0,
            strokelinejoin$0,
            strokemiterlimit$0,
            strokeopacity$0,
            strokewidth$0,
            style$0,
            surfacescale$0,
            systemlanguage$0,
            tablevalues$0,
            target$0,
            targetx$0,
            targety$0,
            textanchor$0,
            textdecoration$0,
            textlength$0,
            textrendering$0,
            title$0,
            to$0,
            transform$0,
            type$0,
            u1$0,
            u2$0,
            underlineposition$0,
            underlinethickness$0,
            unicode$0,
            unicodebidi$0,
            unicoderange$0,
            unitsperem$0,
            valphabetic$0,
            values$0,
            version$0,
            vertadvy$0,
            vertoriginx$0,
            vertoriginy$0,
            vhanging$0,
            videographic$0,
            viewbox$0,
            viewtarget$0,
            visibility$0,
            vmathematical$0,
            width$0,
            widths$0,
            wordspacing$0,
            writingmode$0,
            x$0,
            x1$0,
            x2$0,
            xchannelselector$0,
            xheight$0,
            xlinkactuate$0,
            xlinkarcrole$0,
            xlinkhref$0,
            xlinkrole$0,
            xlinkshow$0,
            xlinktitle$0,
            xlinktype$0,
            xmlbase$0,
            xmllang$0,
            xmlspace$0,
            y$0,
            y1$0,
            y2$0,
            ychannelselector$0,
            z$0,
            zoomandpan$0
        ],
        [
            0,
            v$0,
            Name$0,
            txt,
            txt$0,
            a$0,
            altglyph$0,
            altglyphdef$0,
            altglyphitem$0,
            animate$0,
            animatecolor$0,
            animatemotion$0,
            animatetransform$0,
            circle$0,
            clippath$2,
            colorprofile$2,
            cursor$2,
            defs$0,
            desc$0,
            ellipse$0,
            feblend$0,
            fecolormatrix$0,
            fecomponenttransfer$0,
            fecomposite$0,
            feconvolvematrix$0,
            fediffuselighting$0,
            fedisplacementmap$0,
            fedistantlight$0,
            feflood$0,
            fefunca$0,
            fefuncb$0,
            fefuncg$0,
            fefuncr$0,
            fegaussianblur$0,
            feimage$0,
            femerge$0,
            femergenode$0,
            femorphology$0,
            feoffset$0,
            fepointlight$0,
            fespecularlighting$0,
            fespotlight$0,
            fetile$0,
            feturbulence$0,
            filter$2,
            font$0,
            fontface$0,
            fontfaceformat$0,
            fontfacename$0,
            fontfacesrc$0,
            fontfaceuri$0,
            foreignobject$0,
            g$0,
            glyph$0,
            glyphref$2,
            hkern$0,
            image$0,
            line$0,
            lineargradient$0,
            marker$0,
            mask$2,
            metadata$0,
            missingglyph$0,
            mpath$0,
            path$2,
            pattern$0,
            polygon$0,
            polyline$0,
            radialgradient$0,
            rect$0,
            script$0,
            set$0,
            stop$0,
            style$2,
            svg$0,
            switch$1,
            symbol$0,
            text$0,
            textpath$0,
            title$2,
            tref$0,
            tspan$0,
            use$0,
            view$0,
            vkern$0
        ]
    ];
    runtime.caml_register_global(341, Brr_svg, "Brr_svg");
    return;
})(globalThis);
//# 5 "../.js/default/fmt/fmt.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$20 = "", cst_02x = "%02x", cst_Ld_s = "%Ld%s", cst_Ld_Ld_s = "%Ld.%Ld%s", cst_Lda = "%Lda", cst_d_s_s = "%d%s%s", cst_d_d_s_s = "%d.%d%s%s", cst_g = "%g", cst_0$0 = "0", cst_30$1 = "30", cst_31$1 = "31", cst_32$1 = "32", cst_33$1 = "33", cst_34$1 = "34", cst_35$1 = "35", cst_36$1 = "36", cst_37$1 = "37", cst$19 = ";", cst_1$0 = "<1>", cst_2$0 = "<2>", cst_v = "<v>", cst$18 = "@ ", cst$21 = "@,", cst_A$0 = "A", cst_N$0 = "N", cst_None = "None", cst_Unknown = "Unknown", cst_f$0 = "f", cst_h$1 = "h", cst_hashtbl = "hashtbl", cst_m$0 = "m", cst_min$1 = "min", cst_ok$0 = "ok", cst_queue = "queue", cst_s$1 = "s", cst_src_fmt_ml = "src/fmt.ml", cst_stack = "stack", cst_t$0 = "t", caml_check_bound = runtime.caml_check_bound, caml_div = runtime.caml_div, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_int64_add = runtime.caml_int64_add, caml_int64_div = runtime.caml_int64_div, caml_int64_mul = runtime.caml_int64_mul, caml_int64_sub = runtime.caml_int64_sub, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_mod = runtime.caml_mod, caml_mul = runtime.caml_mul, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    function caml_call9(f, a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 9 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8
        ]);
    }
    function caml_call11(f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 11 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8,
            a9,
            a10
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst_us = "us", cst_ms = "ms", cst_s = cst_s$1, _ap_ = runtime.caml_int64_create_lo_mi_hi(60, 0, 0), cst_s$0 = cst_s$1, cst_min = cst_min$1, _aq_ = runtime.caml_int64_create_lo_mi_hi(60, 0, 0), cst_min$0 = cst_min$1, cst_h = cst_h$1, _ar_ = runtime.caml_int64_create_lo_mi_hi(24, 0, 0), cst_h$0 = cst_h$1, cst_d = "d", y = runtime.caml_int64_create_lo_mi_hi(366, 0, 0), fmt$13 = [
        0,
        [
            12,
            58,
            [
                17,
                [
                    0,
                    cst$18,
                    1,
                    0
                ],
                0
            ]
        ],
        ":@ "
    ], zero = cst_0$0, cst$17 = cst$19, cst$16 = "\x1b[", cst$15 = cst$20, fmt$12 = [
        0,
        [
            11,
            cst_Unknown,
            0
        ],
        cst_Unknown
    ], partial = [
        15,
        [
            11,
            " ?",
            [
                17,
                0,
                0
            ]
        ]
    ], cst$14 = "...", cst$13 = cst$20, cst$12 = ": ", fmt$11 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                8
            ],
            0,
            0
        ],
        "%08x"
    ], kstr$0 = "K", i = "i", fmt$3 = [
        0,
        [
            12,
            59,
            [
                17,
                [
                    0,
                    cst$21,
                    0,
                    0
                ],
                0
            ]
        ],
        ";@,"
    ], cst$10 = " }", cst$11 = "{ ", fmt$2 = [
        0,
        [
            11,
            cst_queue,
            0
        ],
        cst_queue
    ], fmt$1 = [
        0,
        [
            11,
            cst_stack,
            0
        ],
        cst_stack
    ], fmt$0 = [
        0,
        [
            11,
            cst_hashtbl,
            0
        ],
        cst_hashtbl
    ], cst$9 = '"', cst$7 = "}", cst$8 = "{", cst$5 = "|]", cst$6 = "[|", cst$3 = "]", cst$4 = "[", cst$1 = ")", cst$2 = "(", cst$0 = cst$19, cst = ",", us_span = runtime.caml_int64_create_lo_mi_hi(1000, 0, 0), ms_span = runtime.caml_int64_create_lo_mi_hi(1000000, 0, 0), sec_span = runtime.caml_int64_create_lo_mi_hi(10144256, 59, 0), min_span = runtime.caml_int64_create_lo_mi_hi(4675584, 3576, 0), hour_span = runtime.caml_int64_create_lo_mi_hi(12099584, 214576, 0), day_span = runtime.caml_int64_create_lo_mi_hi(5177344, 5149841, 0), year_span = runtime.caml_int64_create_lo_mi_hi(16171008, 1931345, 112), fmt$4 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                7
            ],
            0,
            0
        ],
        "%07x"
    ], fmt$5 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                6
            ],
            0,
            0
        ],
        "%06x"
    ], fmt$6 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                5
            ],
            0,
            0
        ],
        "%05x"
    ], fmt$7 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                4
            ],
            0,
            0
        ],
        "%04x"
    ], fmt$8 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                3
            ],
            0,
            0
        ],
        "%03x"
    ], fmt$9 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                2
            ],
            0,
            0
        ],
        cst_02x
    ], fmt$10 = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                1
            ],
            0,
            0
        ],
        "%01x"
    ], Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_String = global_data.Stdlib__String, Stdlib_Fun = global_data.Stdlib__Fun, Stdlib_Format = global_data.Stdlib__Format, Stdlib_Buffer = global_data.Stdlib__Buffer, Assert_failure = global_data.Assert_failure, Stdlib_Option = global_data.Stdlib__Option, Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_Uchar = global_data.Stdlib__Uchar, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Int = global_data.Stdlib__Int, Stdlib_Map = global_data.Stdlib__Map, stdout = Stdlib_Format[116], stderr = Stdlib_Format[118], pf = Stdlib_Format[143], pr = Stdlib_Format[144], epr = Stdlib_Format[145], str = Stdlib_Format[147], kpf = Stdlib_Format[150], kstr = Stdlib_Format[154], _a_ = [
        0,
        1
    ], _b_ = [
        0,
        1
    ], _d_ = [
        0,
        1
    ], _e_ = [
        0,
        1
    ];
    function failwith(fmt) {
        return caml_call2(kstr, Stdlib[2], fmt);
    }
    function failwith_notrace(fmt) {
        return caml_call2(kstr, function(s) {
            throw [
                0,
                Stdlib[7],
                s
            ];
        }, fmt);
    }
    function invalid_arg(fmt) {
        return caml_call2(kstr, Stdlib[1], fmt);
    }
    function error(fmt) {
        return caml_call2(kstr, function(s) {
            return [
                1,
                s
            ];
        }, fmt);
    }
    function error_msg(fmt) {
        return caml_call2(kstr, function(s) {
            return [
                1,
                [
                    0,
                    3854881,
                    s
                ]
            ];
        }, fmt);
    }
    function flush(ppf, param) {
        return caml_call2(Stdlib_Format[43], ppf, 0);
    }
    function nop(fmt, ppf) {
        return 0;
    }
    function any(fmt, ppf, param) {
        return caml_call2(pf, ppf, fmt);
    }
    function using(f, pp, ppf, v) {
        return caml_call2(pp, ppf, caml_call1(f, v));
    }
    function const$0(pp_v, v, ppf, param) {
        return caml_call2(pp_v, ppf, v);
    }
    function fmt(fmt, ppf) {
        return caml_call2(pf, ppf, fmt);
    }
    function cut(ppf, param) {
        return caml_call2(Stdlib_Format[34], ppf, 0);
    }
    function sp(ppf, param) {
        return caml_call2(Stdlib_Format[32], ppf, 0);
    }
    function sps(n, ppf, param) {
        return caml_call3(Stdlib_Format[36], ppf, n, 0);
    }
    function comma(ppf, param) {
        caml_call2(Stdlib_Format[13], ppf, cst);
        return sp(ppf, 0);
    }
    function semi(ppf, param) {
        caml_call2(Stdlib_Format[13], ppf, cst$0);
        return sp(ppf, 0);
    }
    function iter(opt, iter, pp_elt, ppf, v) {
        var pp_sep = opt ? opt[1] : cut, is_first = [
            0,
            1
        ];
        function pp_elt$0(v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_elt, ppf, v);
        }
        return caml_call2(iter, pp_elt$0, v);
    }
    function iter_bindings(opt, iter, pp_binding, ppf, v) {
        var pp_sep = opt ? opt[1] : cut, is_first = [
            0,
            1
        ];
        function pp_binding$0(k, v) {
            if (is_first[1]) is_first[1] = 0;
            else caml_call2(pp_sep, ppf, 0);
            return caml_call2(pp_binding, ppf, [
                0,
                k,
                v
            ]);
        }
        return caml_call2(iter, pp_binding$0, v);
    }
    function append(pp_v0, pp_v1, ppf, v) {
        caml_call2(pp_v0, ppf, v);
        return caml_call2(pp_v1, ppf, v);
    }
    function concat(sep, pps, ppf, v) {
        return iter(sep, Stdlib_List[18], function(ppf, pp) {
            return caml_call2(pp, ppf, v);
        }, ppf, pps);
    }
    function box(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[1], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hbox(pp_v, ppf, v) {
        caml_call2(Stdlib_Format[5], ppf, 0);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function vbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[7], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hvbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[9], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function hovbox(opt, pp_v, ppf, v) {
        var indent = opt ? opt[1] : 0;
        caml_call2(Stdlib_Format[11], ppf, indent);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[3], ppf, 0);
    }
    function surround(s1, s2, pp_v, ppf, v) {
        caml_call2(Stdlib_Format[13], ppf, s1);
        caml_call2(pp_v, ppf, v);
        return caml_call2(Stdlib_Format[13], ppf, s2);
    }
    function parens(pp_v) {
        function _dH_(_dK_, _dL_) {
            return surround(cst$2, cst$1, pp_v, _dK_, _dL_);
        }
        return function(_dI_, _dJ_) {
            return box(_a_, _dH_, _dI_, _dJ_);
        };
    }
    function brackets(pp_v) {
        function _dC_(_dF_, _dG_) {
            return surround(cst$4, cst$3, pp_v, _dF_, _dG_);
        }
        return function(_dD_, _dE_) {
            return box(_b_, _dC_, _dD_, _dE_);
        };
    }
    function braces(pp_v) {
        function _dx_(_dA_, _dB_) {
            return surround(cst$8, cst$7, pp_v, _dA_, _dB_);
        }
        return function(_dy_, _dz_) {
            return box(_d_, _dx_, _dy_, _dz_);
        };
    }
    function quote(opt, pp_v) {
        var mark = opt ? opt[1] : cst$9;
        function pp_mark(ppf, param) {
            return caml_call3(Stdlib_Format[19], ppf, 1, mark);
        }
        function _dp_(_dv_, _dw_) {
            return append(pp_mark, pp_v, _dv_, _dw_);
        }
        function _dq_(_dt_, _du_) {
            return append(_dp_, pp_mark, _dt_, _du_);
        }
        return function(_dr_, _ds_) {
            return box(_e_, _dq_, _dr_, _ds_);
        };
    }
    var bool = Stdlib_Format[29], int$0 = Stdlib_Format[23], _f_ = [
        0,
        [
            6,
            0,
            0,
            0,
            0
        ],
        "%nd"
    ], _g_ = [
        0,
        [
            5,
            0,
            0,
            0,
            0
        ],
        "%ld"
    ], _h_ = [
        0,
        [
            7,
            0,
            0,
            0,
            0
        ],
        "%Ld"
    ], _i_ = [
        0,
        [
            4,
            12,
            0,
            0,
            0
        ],
        "%u"
    ], _j_ = [
        0,
        [
            5,
            12,
            0,
            0,
            0
        ],
        "%lu"
    ], _k_ = [
        0,
        [
            7,
            12,
            0,
            0,
            0
        ],
        "%Lu"
    ], _l_ = [
        0,
        [
            6,
            12,
            0,
            0,
            0
        ],
        "%nu"
    ];
    function nativeint(ppf, v) {
        return caml_call3(pf, ppf, _f_, v);
    }
    function int32(ppf, v) {
        return caml_call3(pf, ppf, _g_, v);
    }
    function int64(ppf, v) {
        return caml_call3(pf, ppf, _h_, v);
    }
    function uint(ppf, v) {
        return caml_call3(pf, ppf, _i_, v);
    }
    function uint32(ppf, v) {
        return caml_call3(pf, ppf, _j_, v);
    }
    function uint64(ppf, v) {
        return caml_call3(pf, ppf, _k_, v);
    }
    function unativeint(ppf, v) {
        return caml_call3(pf, ppf, _l_, v);
    }
    var char$0 = Stdlib_Format[27], string = Stdlib_Format[13], cst_No_backtrace_available = "No backtrace available.", _m_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_v,
                        0
                    ],
                    cst_v
                ]
            ],
            [
                11,
                "Exception: ",
                [
                    15,
                    [
                        17,
                        [
                            0,
                            cst$21,
                            0,
                            0
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<v>Exception: %a@,%a@]"
    ], _n_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ], _o_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ], _p_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            0,
            0
        ],
        cst_g
    ];
    function buffer(ppf, b) {
        return caml_call2(string, ppf, caml_call1(Stdlib_Buffer[2], b));
    }
    function exn(ppf, e) {
        return caml_call2(string, ppf, caml_call1(Stdlib_Printexc[1], e));
    }
    function exn_backtrace(ppf, param) {
        var bt = param[2], e = param[1];
        function pp_backtrace_str(ppf, s) {
            var stop = caml_ml_string_length(s) - 1 | 0;
            if (s === cst$20) return caml_call2(string, ppf, cst_No_backtrace_available);
            var left = 0, right = 0;
            for(;;){
                if (right === stop) return caml_call2(string, ppf, caml_call3(Stdlib_String[16], s, left, right - left | 0));
                if (10 === caml_string_get(s, right)) {
                    caml_call2(string, ppf, caml_call3(Stdlib_String[16], s, left, right - left | 0));
                    cut(ppf, 0);
                    var right$0 = right + 1 | 0, left$0 = right + 1 | 0;
                    left = left$0;
                    right = right$0;
                } else {
                    var right$1 = right + 1 | 0;
                    right = right$1;
                }
            }
        }
        return caml_call6(pf, ppf, _m_, exn, e, pp_backtrace_str, caml_call1(Stdlib_Printexc[14], bt));
    }
    function float$0(ppf, v) {
        return caml_call3(pf, ppf, _n_, v);
    }
    function round_dfrac(d, x) {
        if (x - Math.floor(x + 0.5) === 0.) return x;
        var m = Math.pow(10., d);
        return Math.floor(x * m + 0.5) / m;
    }
    function float_dfrac(d, ppf, f) {
        return caml_call3(pf, ppf, _o_, round_dfrac(d, f));
    }
    function float_dsig(d, ppf, f) {
        if (f === 0.) var _do_ = 0.;
        else var m = Math.pow(10., Math.floor(runtime.caml_log10_float(Math.abs(f)))), _do_ = round_dfrac(d, f / m) * m;
        return caml_call3(pf, ppf, _p_, _do_);
    }
    function pair(opt, pp_fst, pp_snd, ppf, param) {
        var pp_sep = opt ? opt[1] : cut, snd = param[2], fst = param[1];
        caml_call2(pp_fst, ppf, fst);
        caml_call2(pp_sep, ppf, 0);
        return caml_call2(pp_snd, ppf, snd);
    }
    function option(opt, pp_v, ppf, param) {
        var pp_none = opt ? opt[1] : nop;
        if (!param) return caml_call2(pp_none, ppf, 0);
        var v = param[1];
        return caml_call2(pp_v, ppf, v);
    }
    function result(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call2(ok, ppf, v);
        }
        var e = param[1];
        return caml_call2(error, ppf, e);
    }
    function list(sep, pp_elt) {
        var _dl_ = Stdlib_List[18];
        return function(_dm_, _dn_) {
            return iter(sep, _dl_, pp_elt, _dm_, _dn_);
        };
    }
    function array(sep, pp_elt) {
        var _di_ = Stdlib_Array[12];
        return function(_dj_, _dk_) {
            return iter(sep, _di_, pp_elt, _dj_, _dk_);
        };
    }
    function seq(sep, pp_elt) {
        var _df_ = Stdlib_Seq[4];
        return function(_dg_, _dh_) {
            return iter(sep, _df_, pp_elt, _dg_, _dh_);
        };
    }
    function hashtbl(sep, pp_binding) {
        var _dc_ = Stdlib_Hashtbl[12];
        return function(_dd_, _de_) {
            return iter_bindings(sep, _dc_, pp_binding, _dd_, _de_);
        };
    }
    function queue(sep, pp_elt) {
        var _c__ = Stdlib_Queue[16], _c$_ = 0;
        return function(_da_, _db_) {
            return iter(_c$_, _c__, pp_elt, _da_, _db_);
        };
    }
    function stack(sep, pp_elt) {
        var _c6_ = Stdlib_Stack[13], _c7_ = 0;
        return function(_c8_, _c9_) {
            return iter(_c7_, _c6_, pp_elt, _c8_, _c9_);
        };
    }
    var sig_names = [
        0,
        [
            0,
            Stdlib_Sys[16],
            "SIGABRT"
        ],
        [
            0,
            [
                0,
                Stdlib_Sys[17],
                "SIGALRM"
            ],
            [
                0,
                [
                    0,
                    Stdlib_Sys[18],
                    "SIGFPE"
                ],
                [
                    0,
                    [
                        0,
                        Stdlib_Sys[19],
                        "SIGHUP"
                    ],
                    [
                        0,
                        [
                            0,
                            Stdlib_Sys[20],
                            "SIGILL"
                        ],
                        [
                            0,
                            [
                                0,
                                Stdlib_Sys[21],
                                "SIGINT"
                            ],
                            [
                                0,
                                [
                                    0,
                                    Stdlib_Sys[22],
                                    "SIGKILL"
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        Stdlib_Sys[23],
                                        "SIGPIPE"
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            Stdlib_Sys[24],
                                            "SIGQUIT"
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                Stdlib_Sys[25],
                                                "SIGSEGV"
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    Stdlib_Sys[26],
                                                    "SIGTERM"
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        Stdlib_Sys[27],
                                                        "SIGUSR1"
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            Stdlib_Sys[28],
                                                            "SIGUSR2"
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                Stdlib_Sys[29],
                                                                "SIGCHLD"
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    Stdlib_Sys[30],
                                                                    "SIGCONT"
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        Stdlib_Sys[31],
                                                                        "SIGSTOP"
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            Stdlib_Sys[32],
                                                                            "SIGTSTP"
                                                                        ],
                                                                        [
                                                                            0,
                                                                            [
                                                                                0,
                                                                                Stdlib_Sys[33],
                                                                                "SIGTTIN"
                                                                            ],
                                                                            [
                                                                                0,
                                                                                [
                                                                                    0,
                                                                                    Stdlib_Sys[34],
                                                                                    "SIGTTOU"
                                                                                ],
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        Stdlib_Sys[35],
                                                                                        "SIGVTALRM"
                                                                                    ],
                                                                                    [
                                                                                        0,
                                                                                        [
                                                                                            0,
                                                                                            Stdlib_Sys[36],
                                                                                            "SIGPROF"
                                                                                        ],
                                                                                        [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                Stdlib_Sys[37],
                                                                                                "SIGBUS"
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                [
                                                                                                    0,
                                                                                                    Stdlib_Sys[38],
                                                                                                    "SIGPOLL"
                                                                                                ],
                                                                                                [
                                                                                                    0,
                                                                                                    [
                                                                                                        0,
                                                                                                        Stdlib_Sys[39],
                                                                                                        "SIGSYS"
                                                                                                    ],
                                                                                                    [
                                                                                                        0,
                                                                                                        [
                                                                                                            0,
                                                                                                            Stdlib_Sys[40],
                                                                                                            "SIGTRAP"
                                                                                                        ],
                                                                                                        [
                                                                                                            0,
                                                                                                            [
                                                                                                                0,
                                                                                                                Stdlib_Sys[41],
                                                                                                                "SIGURG"
                                                                                                            ],
                                                                                                            [
                                                                                                                0,
                                                                                                                [
                                                                                                                    0,
                                                                                                                    Stdlib_Sys[42],
                                                                                                                    "SIGXCPU"
                                                                                                                ],
                                                                                                                [
                                                                                                                    0,
                                                                                                                    [
                                                                                                                        0,
                                                                                                                        Stdlib_Sys[43],
                                                                                                                        "SIGXFSZ"
                                                                                                                    ],
                                                                                                                    0
                                                                                                                ]
                                                                                                            ]
                                                                                                        ]
                                                                                                    ]
                                                                                                ]
                                                                                            ]
                                                                                        ]
                                                                                    ]
                                                                                ]
                                                                            ]
                                                                        ]
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], _c_ = [
        0,
        2
    ], _q_ = [
        0,
        [
            11,
            "SIG(",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    41,
                    0
                ]
            ]
        ],
        "SIG(%d)"
    ], _r_ = [
        0,
        [
            11,
            "U+",
            [
                4,
                8,
                [
                    0,
                    2,
                    4
                ],
                0,
                0
            ]
        ],
        "U+%04X"
    ], _s_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _t_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Some",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Some@ @[%a@]@]"
    ], _u_ = [
        0,
        [
            11,
            cst_None,
            0
        ],
        cst_None
    ], _v_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Ok",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Ok@ @[%a@]@]"
    ], _w_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2$0,
                        0
                    ],
                    cst_2$0
                ]
            ],
            [
                11,
                "Error",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$20
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Error@ @[%a@]@]"
    ], _x_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_1$0,
                        0
                    ],
                    cst_1$0
                ]
            ],
            [
                15,
                [
                    11,
                    " =",
                    [
                        17,
                        [
                            0,
                            cst$18,
                            1,
                            0
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<1>%a =@ %a@]"
    ], _y_ = [
        0,
        2
    ];
    function signal(ppf, s) {
        var match = caml_call2(Stdlib_List[56], s, sig_names);
        if (!match) return caml_call3(pf, ppf, _q_, s);
        var name = match[1];
        return caml_call2(string, ppf, name);
    }
    function uchar(ppf, u) {
        return caml_call3(pf, ppf, _r_, caml_call1(Stdlib_Uchar[10], u));
    }
    function string$0(ppf, s) {
        return caml_call3(pf, ppf, _s_, s);
    }
    function pair$0(pp_fst, pp_snd) {
        var _c3_ = 0, _c4_ = 0;
        function _c5_(ppf, v) {
            return box(_c4_, pp_fst, ppf, v[1]);
        }
        return parens(function(ppf, v) {
            append(_c5_, comma, ppf, v);
            return box(_c3_, pp_snd, ppf, v[2]);
        });
    }
    function option$0(pp_v, ppf, param) {
        if (!param) return caml_call2(pf, ppf, _u_);
        var v = param[1];
        return caml_call4(pf, ppf, _t_, pp_v, v);
    }
    function result$0(ok, error, ppf, param) {
        if (0 === param[0]) {
            var v = param[1];
            return caml_call4(pf, ppf, _v_, ok, v);
        }
        var e = param[1];
        return caml_call4(pf, ppf, _w_, error, e);
    }
    function iter$0(iter_f, pp_name, pp_elt) {
        var _cY_ = 0;
        function _cZ_(_c1_, _c2_) {
            return box(_cY_, pp_elt, _c1_, _c2_);
        }
        var _c0_ = [
            0,
            sp
        ];
        return parens(function(ppf, v) {
            append(pp_name, sp, ppf, v);
            return iter(_c0_, iter_f, _cZ_, ppf, v);
        });
    }
    function iter_bindings$0(iter_f, pp_name, pp_k, pp_v) {
        var _cW_ = pair$0(pp_k, pp_v), _cX_ = [
            0,
            sp
        ];
        return parens(function(ppf, v) {
            append(pp_name, sp, ppf, v);
            return iter_bindings(_cX_, iter_f, _cW_, ppf, v);
        });
    }
    function list$0(pp_elt) {
        var _cT_ = 0;
        return brackets(list([
            0,
            semi
        ], function(_cU_, _cV_) {
            return box(_cT_, pp_elt, _cU_, _cV_);
        }));
    }
    function array$0(pp_elt) {
        var _cM_ = 0, pp_v = array([
            0,
            semi
        ], function(_cR_, _cS_) {
            return box(_cM_, pp_elt, _cR_, _cS_);
        });
        function _cL_(_cP_, _cQ_) {
            return surround(cst$6, cst$5, pp_v, _cP_, _cQ_);
        }
        return function(_cN_, _cO_) {
            return box(_c_, _cL_, _cN_, _cO_);
        };
    }
    function seq$0(pp_elt) {
        var _cI_ = 0;
        return brackets(seq([
            0,
            semi
        ], function(_cJ_, _cK_) {
            return box(_cI_, pp_elt, _cJ_, _cK_);
        }));
    }
    function hashtbl$0(pp_k, pp_v) {
        return iter_bindings$0(Stdlib_Hashtbl[12], function(ppf, _cH_) {
            return caml_call2(pf, ppf, fmt$0);
        }, pp_k, pp_v);
    }
    function stack$0(pp_elt) {
        return iter$0(Stdlib_Stack[13], function(ppf, _cG_) {
            return caml_call2(pf, ppf, fmt$1);
        }, pp_elt);
    }
    function queue$0(pp_elt) {
        return iter$0(Stdlib_Queue[16], function(ppf, _cF_) {
            return caml_call2(pf, ppf, fmt$2);
        }, pp_elt);
    }
    function field(opt, l, prj, pp_v, ppf, v) {
        var label = opt ? opt[1] : string$0;
        return caml_call6(pf, ppf, _x_, label, l, pp_v, caml_call1(prj, v));
    }
    function record(pps) {
        var _cr_ = [
            0,
            function(ppf, _cE_) {
                return caml_call2(pf, ppf, fmt$3);
            }
        ];
        function _cs_(_cC_, _cD_) {
            return concat(_cr_, pps, _cC_, _cD_);
        }
        var _ct_ = 0;
        function _cu_(_cA_, _cB_) {
            return vbox(_ct_, _cs_, _cA_, _cB_);
        }
        function _cv_(_cy_, _cz_) {
            return surround(cst$11, cst$10, _cu_, _cy_, _cz_);
        }
        return function(_cw_, _cx_) {
            return box(_y_, _cv_, _cw_, _cx_);
        };
    }
    function ipow10(n) {
        var acc = 1, n$0 = n;
        for(;;){
            if (0 === n$0) return acc;
            var n$1 = n$0 - 1 | 0, acc$0 = acc * 10 | 0;
            acc = acc$0;
            n$0 = n$1;
        }
    }
    var si_symb = [
        0,
        "y",
        "z",
        "a",
        cst_f$0,
        "p",
        "n",
        "u",
        cst_m$0,
        cst$20,
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ].slice(), si_symb_max = 16, _z_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _A_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _B_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_d_d_s_s
    ], _C_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], _D_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_d_d_s_s
    ], _E_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    [
                        0,
                        2,
                        2
                    ],
                    0,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%d.%02d%s%s"
    ], _F_ = [
        0,
        [
            11,
            "~scale is ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    ", must be in [-8;8]",
                    0
                ]
            ]
        ],
        "~scale is %d, must be in [-8;8]"
    ], _G_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        cst_d_s_s
    ], cst_B = "B", _H_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                66,
                0
            ]
        ],
        "%dB"
    ], _I_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%d%s%sB"
    ], _J_ = [
        0,
        [
            15,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%a%s%sB"
    ], _K_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                77,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dM%sB"
    ], _L_ = [
        0,
        [
            15,
            [
                12,
                77,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aM%sB"
    ], _M_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                71,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dG%sB"
    ], _N_ = [
        0,
        [
            15,
            [
                12,
                71,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aG%sB"
    ], _O_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                84,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dT%sB"
    ], _P_ = [
        0,
        [
            15,
            [
                12,
                84,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aT%sB"
    ], _Q_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                80,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%dP%sB"
    ], _R_ = [
        0,
        [
            15,
            [
                12,
                80,
                [
                    2,
                    0,
                    [
                        12,
                        66,
                        0
                    ]
                ]
            ]
        ],
        "%aP%sB"
    ], _S_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _T_1 = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _U_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _V_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _W_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _X_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _Y_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _Z_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), ___ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_Ld_Ld_s
    ], _$_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _aa_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _ab_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _ac_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _ad_ = runtime.caml_int64_create_lo_mi_hi(100, 0, 0), _ae_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _af_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _ag_ = runtime.caml_int64_create_lo_mi_hi(10, 0, 0), _ah_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        cst_Ld_Ld_s
    ], _ai_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    7,
                    0,
                    [
                        0,
                        2,
                        2
                    ],
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%Ld.%02Ld%s"
    ], _aj_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _ak_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _al_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                0
            ]
        ],
        cst_Ld_s
    ], _am_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _an_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                2,
                0,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        2,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%Ld%s%Ld%s"
    ], _ao_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                11,
                "ns",
                0
            ]
        ],
        "%Ldns"
    ], _as_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _at_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                0
            ]
        ],
        cst_Lda
    ], _au_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _av_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                0
            ]
        ],
        cst_Lda
    ], _aw_ = [
        0,
        [
            7,
            0,
            0,
            0,
            [
                12,
                97,
                [
                    7,
                    0,
                    0,
                    0,
                    [
                        12,
                        100,
                        0
                    ]
                ]
            ]
        ],
        "%Lda%Ldd"
    ];
    function si_size(scale, u, ppf, s$2) {
        var s$3 = s$2;
        for(;;){
            var _cp_ = scale < -8 ? 1 : 0, _cq_ = _cp_ || (8 < scale ? 1 : 0);
            if (_cq_) return caml_call1(invalid_arg(_F_), scale);
            if (0 === s$3) var pow_div_3 = 0;
            else {
                var p = -1, x = s$3;
                for(;;){
                    if (0 === x) break;
                    var x$0 = x / 10 | 0, p$0 = p + 1 | 0;
                    p = p$0;
                    x = x$0;
                }
                var pow_div_3 = p / 3 | 0;
            }
            var symb = (scale + 8 | 0) + pow_div_3 | 0;
            if (16 < symb) var factor = ipow10((8 - scale | 0) * 3 | 0), symb$0 = si_symb_max;
            else var factor$0 = ipow10(pow_div_3 * 3 | 0), factor = factor$0, symb$0 = symb;
            if (1 === factor) return caml_call5(pf, ppf, _G_, s$3, caml_check_bound(si_symb, symb$0)[1 + symb$0], u);
            var symb$1 = caml_check_bound(si_symb, symb$0)[1 + symb$0], m = caml_div(s$3, factor), n = caml_mod(s$3, factor);
            if (100 <= m) {
                var m_up = 0 < n ? m + 1 | 0 : m;
                if (1000 > m_up) return caml_call5(pf, ppf, _z_, m_up, symb$1, u);
                var s = caml_mul(m_up, factor);
                s$3 = s;
            } else if (10 <= m) {
                var f_factor = factor / 10 | 0, f_m = caml_div(n, f_factor), f_n = caml_mod(n, f_factor), f_m_up = 0 < f_n ? f_m + 1 | 0 : f_m;
                if (0 === f_m_up) return caml_call5(pf, ppf, _A_, m, symb$1, u);
                if (10 > f_m_up) return caml_call6(pf, ppf, _B_, m, f_m_up, symb$1, u);
                var s$0 = caml_mul(m, factor) + caml_mul(f_m_up, f_factor) | 0;
                s$3 = s$0;
            } else {
                var f_factor$0 = factor / 100 | 0, f_m$0 = caml_div(n, f_factor$0), f_n$0 = caml_mod(n, f_factor$0), f_m_up$0 = 0 < f_n$0 ? f_m$0 + 1 | 0 : f_m$0;
                if (0 === f_m_up$0) return caml_call5(pf, ppf, _C_, m, symb$1, u);
                if (100 > f_m_up$0) return 0 === (f_m_up$0 % 10 | 0) ? caml_call6(pf, ppf, _D_, m, f_m_up$0 / 10 | 0, symb$1, u) : caml_call6(pf, ppf, _E_, m, f_m_up$0, symb$1, u);
                var s$1 = caml_mul(m, factor) + caml_mul(f_m_up$0, f_factor$0) | 0;
                s$3 = s$1;
            }
        }
    }
    function byte_size(ppf, s) {
        return si_size(0, cst_B, ppf, s);
    }
    function bi_byte_size(ppf, s) {
        var _cm_ = 1;
        function pp_frac(_cn_, _co_) {
            return float_dfrac(_cm_, _cn_, _co_);
        }
        function div_round_up(m, n) {
            return caml_div((m + n | 0) - 1 | 0, n);
        }
        var k = 1024;
        if (s < 1024) return caml_call3(pf, ppf, _H_, s);
        var m = 1048576;
        if (s < 1048576) {
            var sk = s / 1024 | 0;
            return 10 <= sk ? caml_call5(pf, ppf, _I_, div_round_up(s, k), kstr$0, i) : caml_call6(pf, ppf, _J_, pp_frac, s / 1024, kstr$0, i);
        }
        var g = 1073741824;
        if (s < 1073741824) {
            var sm = s / 1048576 | 0;
            return 10 <= sm ? caml_call4(pf, ppf, _K_, div_round_up(s, m), i) : caml_call5(pf, ppf, _L_, pp_frac, s / 1048576, i);
        }
        var t = 0;
        if (s < 0) {
            var sg = s / 1073741824 | 0;
            return 10 <= sg ? caml_call4(pf, ppf, _M_, div_round_up(s, g), i) : caml_call5(pf, ppf, _N_, pp_frac, s / 1073741824, i);
        }
        var p = 0;
        if (s < 0) {
            var st = caml_div(s, 0);
            return 10 <= st ? caml_call4(pf, ppf, _O_, div_round_up(s, t), i) : caml_call5(pf, ppf, _P_, pp_frac, s / 0, i);
        }
        var sp = caml_div(s, 0);
        return 10 <= sp ? caml_call4(pf, ppf, _Q_, div_round_up(s, p), i) : caml_call5(pf, ppf, _R_, pp_frac, s / 0, i);
    }
    function unsigned_compare(x0, x1) {
        return caml_call2(Stdlib_Int64[15], caml_int64_sub(x0, Stdlib_Int64[10]), caml_int64_sub(x1, Stdlib_Int64[10]));
    }
    function unsigned_div(n, d) {
        if (runtime.caml_lessthan(d, Stdlib_Int64[1])) return 0 <= unsigned_compare(n, d) ? Stdlib_Int64[2] : Stdlib_Int64[1];
        var q = runtime.caml_int64_shift_left(caml_int64_div(runtime.caml_int64_shift_right_unsigned(n, 1), d), 1), r = caml_int64_sub(n, caml_int64_mul(q, d));
        return 0 <= unsigned_compare(r, d) ? caml_call1(Stdlib_Int64[6], q) : q;
    }
    function unsigned_rem(n, d) {
        return caml_int64_sub(n, caml_int64_mul(caml_call2(Stdlib_Int64[4], n, d), d));
    }
    function pp_si_span(counter, unit_str, si_unit, si_higher_unit, ppf, span) {
        function geq(x, y) {
            return 0 <= unsigned_compare(x, y) ? 1 : 0;
        }
        var m = unsigned_div(span, si_unit), n = unsigned_rem(span, si_unit);
        if (geq(m, _S_)) {
            var m_up = caml_call2(Stdlib_Int64[17], n, _T_1) ? m : caml_call1(Stdlib_Int64[6], m), span$0 = caml_int64_mul(m_up, si_unit);
            if (!geq(span$0, si_higher_unit)) return caml_call4(pf, ppf, _U_, m_up, unit_str);
            if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
                0,
                ppf,
                span$0
            ]);
            var counter$0 = counter + 1 | 0;
            return uint64_ns_span$0(counter$0, ppf, span$0);
        }
        if (geq(m, _V_)) {
            var f_factor = unsigned_div(si_unit, _W_), f_m = unsigned_div(n, f_factor), f_n = unsigned_rem(n, f_factor), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _X_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
            if (!caml_notequal(f_m_up, _Y_)) return caml_call4(pf, ppf, _$_, m, unit_str);
            if (!geq(f_m_up, _Z_)) return caml_call5(pf, ppf, ___, m, f_m_up, unit_str);
            var _cj_ = caml_int64_add(caml_int64_mul(m, si_unit), caml_int64_mul(f_m_up, f_factor));
            if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
                0,
                ppf,
                _cj_
            ]);
            var counter$1 = counter + 1 | 0;
            return uint64_ns_span$0(counter$1, ppf, _cj_);
        }
        var f_factor$0 = unsigned_div(si_unit, _aa_), f_m$0 = unsigned_div(n, f_factor$0), f_n$0 = unsigned_rem(n, f_factor$0), f_m_up$0 = caml_call2(Stdlib_Int64[17], f_n$0, _ab_) ? f_m$0 : caml_call1(Stdlib_Int64[6], f_m$0);
        if (!caml_notequal(f_m_up$0, _ac_)) return caml_call4(pf, ppf, _aj_, m, unit_str);
        if (!geq(f_m_up$0, _ad_)) {
            var _cl_ = runtime.caml_int64_mod(f_m_up$0, _af_);
            return caml_call2(Stdlib_Int64[17], _cl_, _ae_) ? caml_call5(pf, ppf, _ah_, m, caml_int64_div(f_m_up$0, _ag_), unit_str) : caml_call5(pf, ppf, _ai_, m, f_m_up$0, unit_str);
        }
        var _ck_ = caml_int64_add(caml_int64_mul(m, si_unit), caml_int64_mul(f_m_up$0, f_factor$0));
        if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
            0,
            ppf,
            _ck_
        ]);
        var counter$2 = counter + 1 | 0;
        return uint64_ns_span$0(counter$2, ppf, _ck_);
    }
    function pp_non_si(counter, unit_str, unit, unit_lo_str, unit_lo, unit_lo_size, ppf, span) {
        var m = unsigned_div(span, unit), n = unsigned_rem(span, unit);
        if (caml_call2(Stdlib_Int64[17], n, _ak_)) return caml_call4(pf, ppf, _al_, m, unit_str);
        var f_m = unsigned_div(n, unit_lo), f_n = unsigned_rem(n, unit_lo), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _am_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
        if (0 > unsigned_compare(f_m_up, unit_lo_size)) return caml_call6(pf, ppf, _an_, m, unit_str, f_m_up, unit_lo_str);
        var _ci_ = caml_int64_add(caml_int64_mul(m, unit), caml_int64_mul(f_m_up, unit_lo));
        if (counter >= 50) return caml_trampoline_return(uint64_ns_span$0, [
            0,
            ppf,
            _ci_
        ]);
        var counter$0 = counter + 1 | 0;
        return uint64_ns_span$0(counter$0, ppf, _ci_);
    }
    function uint64_ns_span$0(counter, ppf, span) {
        function lt(x, y) {
            return -1 === unsigned_compare(x, y) ? 1 : 0;
        }
        if (lt(span, us_span)) return caml_call3(pf, ppf, _ao_, span);
        if (lt(span, ms_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_us,
                us_span,
                ms_span,
                ppf,
                span
            ]);
            var counter$3 = counter + 1 | 0;
            return pp_si_span(counter$3, cst_us, us_span, ms_span, ppf, span);
        }
        if (lt(span, sec_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_ms,
                ms_span,
                sec_span,
                ppf,
                span
            ]);
            var counter$4 = counter + 1 | 0;
            return pp_si_span(counter$4, cst_ms, ms_span, sec_span, ppf, span);
        }
        if (lt(span, min_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_si_span, [
                0,
                cst_s,
                sec_span,
                min_span,
                ppf,
                span
            ]);
            var counter$5 = counter + 1 | 0;
            return pp_si_span(counter$5, cst_s, sec_span, min_span, ppf, span);
        }
        if (lt(span, hour_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_min,
                min_span,
                cst_s$0,
                sec_span,
                _ap_,
                ppf,
                span
            ]);
            var counter$0 = counter + 1 | 0;
            return pp_non_si(counter$0, cst_min, min_span, cst_s$0, sec_span, _ap_, ppf, span);
        }
        if (lt(span, day_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_h,
                hour_span,
                cst_min$0,
                min_span,
                _aq_,
                ppf,
                span
            ]);
            var counter$1 = counter + 1 | 0;
            return pp_non_si(counter$1, cst_h, hour_span, cst_min$0, min_span, _aq_, ppf, span);
        }
        if (lt(span, year_span)) {
            if (counter >= 50) return caml_trampoline_return(pp_non_si, [
                0,
                cst_d,
                day_span,
                cst_h$0,
                hour_span,
                _ar_,
                ppf,
                span
            ]);
            var counter$2 = counter + 1 | 0;
            return pp_non_si(counter$2, cst_d, day_span, cst_h$0, hour_span, _ar_, ppf, span);
        }
        var m = unsigned_div(span, year_span), n = unsigned_rem(span, year_span);
        if (caml_call2(Stdlib_Int64[17], n, _as_)) return caml_call3(pf, ppf, _at_, m);
        var f_m = unsigned_div(n, day_span), f_n = unsigned_rem(n, day_span), f_m_up = caml_call2(Stdlib_Int64[17], f_n, _au_) ? f_m : caml_call1(Stdlib_Int64[6], f_m);
        return 0 <= unsigned_compare(f_m_up, y) ? caml_call3(pf, ppf, _av_, caml_call1(Stdlib_Int64[6], m)) : caml_call4(pf, ppf, _aw_, m, f_m_up);
    }
    function uint64_ns_span(ppf, span) {
        return caml_trampoline(uint64_ns_span$0(0, ppf, span));
    }
    function iter_vec(f, param) {
        var get = param[2], n = param[1], _cg_ = n - 1 | 0, _cf_ = 0;
        if (_cg_ >= 0) {
            var i = _cf_;
            for(;;){
                caml_call2(f, i, caml_call1(get, i));
                var _ch_ = i + 1 | 0;
                if (_cg_ === i) break;
                i = _ch_;
            }
        }
        return 0;
    }
    function vec(sep) {
        return function(_cc_, _cd_, _ce_) {
            return iter_bindings(sep, iter_vec, _cc_, _cd_, _ce_);
        };
    }
    function _ax_(s) {
        return [
            0,
            caml_ml_string_length(s),
            function(_cb_) {
                return caml_string_get(s, _cb_);
            }
        ];
    }
    function on_string(_b__, _b$_, _ca_) {
        return using(_ax_, _b__, _b$_, _ca_);
    }
    function _ay_(b) {
        return [
            0,
            runtime.caml_ml_bytes_length(b),
            function(_b9_) {
                return runtime.caml_bytes_get(b, _b9_);
            }
        ];
    }
    function on_bytes(_b6_, _b7_, _b8_) {
        return using(_ay_, _b6_, _b7_, _b8_);
    }
    var prefix0x = [
        0,
        [
            0,
            15,
            function(ppf) {
                return caml_call2(pf, ppf, fmt$10);
            }
        ],
        [
            0,
            [
                0,
                255,
                function(ppf) {
                    return caml_call2(pf, ppf, fmt$9);
                }
            ],
            [
                0,
                [
                    0,
                    4095,
                    function(ppf) {
                        return caml_call2(pf, ppf, fmt$8);
                    }
                ],
                [
                    0,
                    [
                        0,
                        65535,
                        function(ppf) {
                            return caml_call2(pf, ppf, fmt$7);
                        }
                    ],
                    [
                        0,
                        [
                            0,
                            1048575,
                            function(ppf) {
                                return caml_call2(pf, ppf, fmt$6);
                            }
                        ],
                        [
                            0,
                            [
                                0,
                                16777215,
                                function(ppf) {
                                    return caml_call2(pf, ppf, fmt$5);
                                }
                            ],
                            [
                                0,
                                [
                                    0,
                                    268435455,
                                    function(ppf) {
                                        return caml_call2(pf, ppf, fmt$4);
                                    }
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], _az_ = [
        0,
        [
            4,
            6,
            [
                0,
                2,
                2
            ],
            0,
            0
        ],
        cst_02x
    ], _aA_ = [
        0,
        cst_src_fmt_ml,
        549,
        13
    ], _aB_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    0
                ]
            ]
        ],
        "%d.%d"
    ], _aC_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                12,
                46,
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        12,
                        45,
                        [
                            4,
                            0,
                            0,
                            0,
                            [
                                12,
                                46,
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%d.%d-%d.%d"
    ], _aD_ = [
        0,
        [
            15,
            [
                12,
                44,
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    0
                ]
            ]
        ],
        "%a,@ "
    ], _aE_ = [
        0,
        [
            11,
            "or",
            [
                17,
                [
                    0,
                    cst$18,
                    1,
                    0
                ],
                [
                    15,
                    0
                ]
            ]
        ],
        "or@ %a"
    ], _aF_ = [
        0,
        cst_src_fmt_ml,
        587,
        12
    ], _aG_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                11,
                "one",
                [
                    17,
                    [
                        0,
                        cst$18,
                        1,
                        0
                    ],
                    [
                        11,
                        "of",
                        [
                            17,
                            [
                                0,
                                cst$18,
                                1,
                                0
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[one@ of@ %a@]"
    ], _aH_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                11,
                "either ",
                [
                    15,
                    [
                        11,
                        " or",
                        [
                            17,
                            [
                                0,
                                cst$18,
                                1,
                                0
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[either %a or@ %a@]"
    ], _aI_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                15,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            32,
                            [
                                15,
                                [
                                    15,
                                    [
                                        12,
                                        46,
                                        [
                                            17,
                                            [
                                                0,
                                                cst$18,
                                                1,
                                                0
                                            ],
                                            [
                                                11,
                                                "Did you mean ",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[%a %s %a%a.@ Did you mean %a ?@]"
    ], _aJ_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$20
                ]
            ],
            [
                15,
                [
                    12,
                    32,
                    [
                        2,
                        0,
                        [
                            12,
                            32,
                            [
                                15,
                                [
                                    15,
                                    [
                                        12,
                                        46,
                                        [
                                            17,
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[%a %s %a%a.@]"
    ];
    function ascii(_b3_, opt, param, ppf, v) {
        var w = _b3_ ? _b3_[1] : 0;
        if (opt) var subst = opt[1];
        else var v$0 = 46, subst = function(ppf, _b5_) {
            return caml_call2(char$0, ppf, v$0);
        };
        var n = v[1];
        function pp_char(ppf, param) {
            var c = param[2];
            if (32 <= c && 127 > c) return caml_call2(char$0, ppf, c);
            return caml_call2(subst, ppf, 0);
        }
        vec(0)(pp_char, ppf, v);
        var _b4_ = n < w ? 1 : 0;
        return _b4_ ? sps(w - n | 0, ppf, 0) : _b4_;
    }
    function octets(_bY_, opt, param, ppf, v) {
        var w = _bY_ ? _bY_[1] : 0, sep = opt ? opt[1] : sp, n = v[1];
        function pp_sep(ppf, i) {
            var _b1_ = 0 < i ? 1 : 0, _b2_ = _b1_ ? 0 === (i % 2 | 0) ? 1 : 0 : _b1_;
            return _b2_ ? caml_call2(sep, ppf, 0) : _b2_;
        }
        function pp_char(ppf, param) {
            var c = param[2], i = param[1];
            pp_sep(ppf, i);
            return caml_call3(pf, ppf, _az_, c);
        }
        vec([
            0,
            nop
        ])(pp_char, ppf, v);
        var _bZ_ = w - 1 | 0;
        if (_bZ_ >= n) {
            var i = n;
            for(;;){
                pp_sep(ppf, i);
                sps(2, ppf, 0);
                var _b0_ = i + 1 | 0;
                if (_bZ_ === i) break;
                i = _b0_;
            }
        }
        return 0;
    }
    function addresses(addr, opt, pp_vec, ppf, v) {
        var w = opt ? opt[1] : 16, n$0 = v[1];
        if (addr) var pp$0 = addr[1], addr$0 = pp$0;
        else {
            var max = caml_mul(caml_div(n$0 - 1 | 0, w), w), match = caml_call2(Stdlib_List[40], function(param) {
                var x = param[1];
                return max <= x ? 1 : 0;
            }, prefix0x);
            if (match) var pp = match[1][2], pp_v0 = pp;
            else var pp_v0 = function(ppf) {
                return caml_call2(pf, ppf, fmt$11);
            };
            var addr$0 = function(ppf, v) {
                caml_call2(pp_v0, ppf, v);
                return caml_call2(string, ppf, cst$12);
            };
        }
        function pp_sub(ppf, param) {
            var sub = param[2], i = param[1];
            caml_call2(addr$0, ppf, caml_mul(i, w));
            return box(0, pp_vec, ppf, sub);
        }
        var get = v[2], n = v[1], _bS_ = [
            0,
            caml_div(n - 1 | 0, w) + 1 | 0,
            function(j) {
                var off = caml_mul(w, j);
                return [
                    0,
                    caml_call2(Stdlib[16], w, n - off | 0),
                    function(i) {
                        return caml_call1(get, i + off | 0);
                    }
                ];
            }
        ], _bT_ = vec(0);
        return vbox(0, function(_bU_, _bV_) {
            var _bX_ = _bV_, _bW_ = _bU_;
            return _bT_(pp_sub, _bW_, _bX_);
        }, ppf, _bS_);
    }
    function hex(opt, param) {
        var w = opt ? opt[1] : 16, _by_ = 0, _bz_ = 0, _bA_ = [
            0,
            w
        ], _bE_ = 0, _bF_ = 0, _bG_ = [
            0,
            w
        ];
        function _bB_(_bQ_, _bR_) {
            return ascii(_bA_, _bz_, _by_, _bQ_, _bR_);
        }
        var _bC_ = 0, _bD_ = 2;
        function _bH_(_bO_, _bP_) {
            return octets(_bG_, _bF_, _bE_, _bO_, _bP_);
        }
        var _bI_ = 0;
        function _bJ_(ppf, v) {
            box(_bI_, _bH_, ppf, v);
            sps(_bD_, ppf, v);
            return box(_bC_, _bB_, ppf, v);
        }
        var _bK_ = [
            0,
            w
        ], _bL_ = 0;
        return function(_bM_, _bN_) {
            return addresses(_bL_, _bK_, _bJ_, _bM_, _bN_);
        };
    }
    function is_nl(c) {
        return 10 === c ? 1 : 0;
    }
    function is_nl_or_sp(c) {
        var _bx_ = 10 === c ? 1 : 0, _bw_ = _bx_ || (32 === c ? 1 : 0);
        return _bw_;
    }
    function is_white(param) {
        a: {
            if (14 <= param) {
                if (32 === param) break a;
            } else if (9 <= param) break a;
            return 0;
        }
        return 1;
    }
    function not_white(c) {
        return 1 - is_white(c);
    }
    function not_white_or_nl(c) {
        var _bv_ = 10 === c ? 1 : 0;
        return _bv_ ? _bv_ : not_white(c);
    }
    function stop_at(sat, start, max, s) {
        var start$0 = start;
        for(;;){
            if (max < start$0) return start$0;
            if (caml_call1(sat, caml_string_get(s, start$0))) return start$0;
            var start$1 = start$0 + 1 | 0;
            start$0 = start$1;
        }
    }
    function sub(s, start, stop, max) {
        if (start === stop) return cst$13;
        if (0 === start && max < stop) return s;
        return caml_call3(Stdlib_String[16], s, start, stop - start | 0);
    }
    function words(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start$1 = stop_at(not_white, 0, max, s);
        if (max < start$1) return 0;
        var start = start$1;
        for(;;){
            var stop = stop_at(is_white, start, max, s);
            if (max < stop) {
                var _bt_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bt_);
            }
            var _bu_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bu_);
            var start$0 = stop_at(not_white, stop, max, s);
            if (max < start$0) return 0;
            caml_call2(Stdlib_Format[32], ppf, 0);
            start = start$0;
        }
    }
    function paragraphs(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start$3 = stop_at(not_white, 0, max, s);
        if (max < start$3) return 0;
        var start = start$3;
        for(;;){
            var stop = stop_at(is_white, start, max, s);
            if (max < stop) {
                var _br_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _br_);
            }
            var _bs_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bs_);
            var start$0 = stop_at(not_white_or_nl, stop, max, s);
            if (max < start$0) return 0;
            if (10 === caml_string_get(s, start$0)) {
                var start$1 = stop_at(not_white_or_nl, start$0 + 1 | 0, max, s);
                if (max < start$1) return 0;
                if (10 === caml_string_get(s, start$1)) {
                    var start$2 = stop_at(not_white, start$1 + 1 | 0, max, s);
                    if (max < start$2) return 0;
                    caml_call2(Stdlib_Format[39], ppf, 0);
                    caml_call2(Stdlib_Format[39], ppf, 0);
                    start = start$2;
                } else {
                    caml_call2(Stdlib_Format[32], ppf, 0);
                    start = start$1;
                }
            } else {
                caml_call2(Stdlib_Format[32], ppf, 0);
                start = start$0;
            }
        }
    }
    function text(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start = 0;
        for(;;){
            var stop = stop_at(is_nl_or_sp, start, max, s);
            if (max < stop) {
                var _bp_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bp_);
            }
            var _bq_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bq_);
            var match = caml_string_get(s, stop);
            if (10 === match) caml_call2(Stdlib_Format[39], ppf, 0);
            else {
                if (32 !== match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _aA_
                ], 1);
                caml_call2(Stdlib_Format[32], ppf, 0);
            }
            var start$0 = stop + 1 | 0;
            start = start$0;
        }
    }
    function lines(ppf, s) {
        var max = caml_ml_string_length(s) - 1 | 0, start = 0;
        for(;;){
            var stop = stop_at(is_nl, start, max, s);
            if (max < stop) {
                var _bn_ = sub(s, start, stop, max);
                return caml_call2(Stdlib_Format[13], ppf, _bn_);
            }
            var _bo_ = sub(s, start, stop, max);
            caml_call2(Stdlib_Format[13], ppf, _bo_);
            caml_call2(Stdlib_Format[39], ppf, 0);
            var start$0 = stop + 1 | 0;
            start = start$0;
        }
    }
    function truncated(max, ppf, s) {
        if (caml_ml_string_length(s) <= max) return caml_call2(Stdlib_Format[13], ppf, s);
        var _bk_ = max - 4 | 0, _bj_ = 0;
        if (_bk_ >= 0) {
            var i = _bj_;
            for(;;){
                var _bl_ = caml_string_get(s, i);
                caml_call2(Stdlib_Format[27], ppf, _bl_);
                var _bm_ = i + 1 | 0;
                if (_bk_ === i) break;
                i = _bm_;
            }
        }
        return caml_call2(Stdlib_Format[13], ppf, cst$14);
    }
    function text_loc(ppf, param) {
        var _bi_ = param[2], c1 = _bi_[2], l1 = _bi_[1], match = param[1], c0 = match[2], l0 = match[1];
        if (l0 === l1 && c0 === c1) return caml_call4(pf, ppf, _aB_, l0, c0);
        return caml_call6(pf, ppf, _aC_, l0, c0, l1, c1);
    }
    function one_of(opt, pp_v, ppf, vs) {
        var empty = opt ? opt[1] : nop;
        if (!vs) return caml_call2(empty, ppf, 0);
        var v = vs[1], _bh_ = vs[2];
        if (!_bh_) return caml_call2(pp_v, ppf, v);
        if (_bh_[2]) {
            var loop = function(ppf, param) {
                var param$0 = param;
                for(;;){
                    if (!param$0) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _aF_
                    ], 1);
                    var v = param$0[1];
                    if (!param$0[2]) return caml_call4(pf, ppf, _aE_, pp_v, v);
                    var vs = param$0[2];
                    caml_call4(pf, ppf, _aD_, pp_v, v);
                    param$0 = vs;
                }
            };
            return caml_call4(pf, ppf, _aG_, loop, vs);
        }
        var v1 = _bh_[1];
        return caml_call6(pf, ppf, _aH_, pp_v, v, pp_v, v1);
    }
    function did_you_mean(_bc_, opt, kind, pp_v, ppf, param) {
        var pre = _bc_ ? _bc_[1] : function(ppf, _bg_) {
            return caml_call2(pf, ppf, fmt$12);
        }, post = opt ? opt[1] : nop, hints = param[2], v = param[1];
        if (!hints) return caml_call9(pf, ppf, _aJ_, pre, 0, kind, pp_v, v, post, 0);
        var _bd_ = 0;
        return caml_call11(pf, ppf, _aI_, pre, 0, kind, pp_v, v, post, 0, function(_be_, _bf_) {
            return one_of(_bd_, pp_v, _be_, _bf_);
        }, hints);
    }
    var Imap = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_Int[9]
    ]), id = [
        0,
        0
    ];
    function attr(enc, dec) {
        id[1]++;
        return [
            0,
            id[1],
            enc,
            dec
        ];
    }
    var Fmt_store_get = [
        248,
        "Fmt.Fmt_store_get",
        caml_fresh_oo_id(0)
    ], Fmt_store_set = [
        248,
        "Fmt.Fmt_store_set",
        caml_fresh_oo_id(0)
    ], cst_ok = cst_ok$0, cst_t = cst_t$0, cst_f = cst_f$0, _aK_ = [
        0,
        cst_src_fmt_ml,
        638,
        55
    ];
    function store_op(op, ppf) {
        var funs = caml_call2(Stdlib_Format[112], ppf, 0);
        return caml_call1(funs[1], op);
    }
    function get(attr, ppf) {
        var dec = attr[3], s = store_op([
            0,
            Fmt_store_get,
            attr
        ], ppf);
        return s !== cst$20 ? [
            0,
            caml_call1(dec, s)
        ] : 0;
    }
    function set(attr, v, ppf) {
        for(;;){
            if (store_op([
                0,
                Fmt_store_set,
                attr,
                v
            ], ppf) === cst_ok$0) return 0;
            var funs = caml_call2(Stdlib_Format[112], ppf, 0), other = funs[1], s = [
                0,
                Imap[1]
            ];
            let s$0 = s, other$0 = other;
            var mark_open_stag = function(stag) {
                if (stag[1] === Fmt_store_get) {
                    var id = stag[2][1], _a$_ = caml_call2(Imap[18], id, s$0[1]);
                    return caml_call2(Stdlib_Option[3], _a$_, cst$15);
                }
                if (stag[1] !== Fmt_store_set) return caml_call1(other$0, stag);
                var v = stag[3], match = stag[2], enc = match[2], id$0 = match[1], _ba_ = s$0[1], _bb_ = caml_call1(enc, v);
                s$0[1] = caml_call3(Imap[2], id$0, _bb_, _ba_);
                return cst_ok;
            };
            caml_call2(Stdlib_Format[110], ppf, [
                0,
                mark_open_stag,
                funs[2],
                funs[3],
                funs[4]
            ]);
        }
    }
    function def(x, param) {
        if (!param) return x;
        var y = param[1];
        return y;
    }
    function enc(param) {
        return param ? cst_t : cst_f;
    }
    function dec(param) {
        if (param === cst_f$0) return 0;
        if (param !== cst_t$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _aK_
        ], 1);
        return 1;
    }
    var utf_8_attr = attr(enc, dec), cst_N = cst_N$0, cst_A = cst_A$0, _aL_ = [
        0,
        cst_src_fmt_ml,
        647,
        60
    ];
    function utf_8(ppf) {
        return def(1, get(utf_8_attr, ppf));
    }
    function set_utf_8(ppf, x) {
        return set(utf_8_attr, x, ppf);
    }
    function enc$0(param) {
        return 870530776 <= param ? cst_N : cst_A;
    }
    function dec$0(param) {
        if (param === cst_A$0) return 323557469;
        if (param !== cst_N$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _aL_
        ], 1);
        return 870530776;
    }
    var style_renderer_attr = attr(enc$0, dec$0), cst_m = cst_m$0;
    function style_renderer(ppf) {
        return def(870530776, get(style_renderer_attr, ppf));
    }
    function set_style_renderer(ppf, x) {
        return set(style_renderer_attr, x, ppf);
    }
    function with_buffer(like, buf) {
        var ppf = caml_call1(Stdlib_Format[120], buf);
        if (!like) return ppf;
        var like$0 = like[1], funs = caml_call2(Stdlib_Format[112], like$0, 0);
        caml_call2(Stdlib_Format[110], ppf, funs);
        return ppf;
    }
    function str_like(ppf, fmt) {
        var buf = caml_call1(Stdlib_Buffer[1], 64), bppf = with_buffer([
            0,
            ppf
        ], buf);
        function flush(ppf) {
            caml_call2(Stdlib_Format[43], ppf, 0);
            var s = caml_call1(Stdlib_Buffer[2], buf);
            caml_call1(Stdlib_Buffer[9], buf);
            return s;
        }
        return caml_call3(Stdlib_Format[150], flush, bppf, fmt);
    }
    function if_utf_8(pp_u, pp) {
        return function(ppf, v) {
            var pp_u$0 = utf_8(ppf) ? pp_u : pp;
            return caml_call2(pp_u$0, ppf, v);
        };
    }
    function pp_sgr(ppf, style) {
        caml_call3(Stdlib_Format[19], ppf, 0, cst$16);
        caml_call3(Stdlib_Format[19], ppf, 0, style);
        return caml_call3(Stdlib_Format[19], ppf, 0, cst_m);
    }
    var curr_style = attr(function(_a__) {
        return _a__;
    }, function(_a9_) {
        return _a9_;
    }), cst_3 = "3", cst_0 = cst_0$0, cst_32 = cst_32$1, cst_36 = cst_36$1, cst_34 = cst_34$1, cst_1 = "1", cst_4 = "4", cst_2 = "2", cst_33 = cst_33$1, cst_31 = cst_31$1, cst_7 = "7", cst_35 = cst_35$1, cst_37 = cst_37$1, cst_30 = cst_30$1, cst_32$0 = cst_32$1, cst_36$0 = cst_36$1, cst_34$0 = cst_34$1, cst_33$0 = cst_33$1, cst_31$0 = cst_31$1, cst_37$0 = cst_37$1, cst_35$0 = cst_35$1, cst_30$0 = cst_30$1, cst_92 = "92", cst_96 = "96", cst_94 = "94", cst_93 = "93", cst_91 = "91", cst_97 = "97", cst_95 = "95", cst_90 = "90", cst_42 = "42", cst_46 = "46", cst_44 = "44", cst_43 = "43", cst_41 = "41", cst_47 = "47", cst_45 = "45", cst_40 = "40", cst_102 = "102", cst_106 = "106", cst_104 = "104", cst_103 = "103", cst_101 = "101", cst_107 = "107", cst_105 = "105", cst_100 = "100", _aM_ = [
        0,
        15713,
        82908052
    ], _aN_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_1$0,
                        0
                    ],
                    cst_1$0
                ]
            ],
            [
                15,
                [
                    15,
                    [
                        15,
                        [
                            17,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[<1>%a%a%a@]"
    ], _aO_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ];
    function styled(style, pp_v, ppf, v) {
        if (870530776 <= style_renderer(ppf)) return caml_call2(pp_v, ppf, v);
        var match = get(curr_style, ppf);
        if (match) var s = match[1], prev = s;
        else {
            set(curr_style, zero, ppf);
            var prev = zero;
        }
        if (typeof style === "number") var here = 698610924 <= style ? 749039939 <= style ? 870530776 <= style ? 989373200 <= style ? cst_3 : cst_0 : 756711075 <= style ? cst_32 : cst_36 : 737308346 === style ? cst_34 : 737455525 <= style ? cst_1 : cst_4 : -397582078 <= style ? 82908052 <= style ? 242899572 <= style ? cst_2 : cst_33 : 4100401 <= style ? cst_31 : cst_7 : -605101559 === style ? cst_35 : -588596599 <= style ? cst_37 : cst_30;
        else if (15713 <= style[1]) {
            var _a5_ = style[2];
            if (typeof _a5_ === "number") var here = 82908052 <= _a5_ ? 749039939 <= _a5_ ? 756711075 <= _a5_ ? cst_32$0 : cst_36$0 : 737308346 <= _a5_ ? cst_34$0 : cst_33$0 : -588596599 <= _a5_ ? 4100401 <= _a5_ ? cst_31$0 : cst_37$0 : -605101559 <= _a5_ ? cst_35$0 : cst_30$0;
            else var _a6_ = _a5_[2], here = 82908052 <= _a6_ ? 749039939 <= _a6_ ? 756711075 <= _a6_ ? cst_92 : cst_96 : 737308346 <= _a6_ ? cst_94 : cst_93 : -588596599 <= _a6_ ? 4100401 <= _a6_ ? cst_91 : cst_97 : -605101559 <= _a6_ ? cst_95 : cst_90;
        } else {
            var _a7_ = style[2];
            if (typeof _a7_ === "number") var here = 82908052 <= _a7_ ? 749039939 <= _a7_ ? 756711075 <= _a7_ ? cst_42 : cst_46 : 737308346 <= _a7_ ? cst_44 : cst_43 : -588596599 <= _a7_ ? 4100401 <= _a7_ ? cst_41 : cst_47 : -605101559 <= _a7_ ? cst_45 : cst_40;
            else var _a8_ = _a7_[2], here = 82908052 <= _a8_ ? 749039939 <= _a8_ ? 756711075 <= _a8_ ? cst_102 : cst_106 : 737308346 <= _a8_ ? cst_104 : cst_103 : -588596599 <= _a8_ ? 4100401 <= _a8_ ? cst_101 : cst_107 : -605101559 <= _a8_ ? cst_105 : cst_100;
        }
        a: {
            if (typeof style === "number" && 870530776 === style) {
                var curr = here;
                break a;
            }
            var curr = caml_call2(Stdlib_String[7], cst$17, [
                0,
                prev,
                [
                    0,
                    here,
                    0
                ]
            ]);
        }
        function finally$0(param) {
            return set(curr_style, prev, ppf);
        }
        set(curr_style, curr, ppf);
        return caml_call1(caml_call1(Stdlib_Fun[5], finally$0), function(param) {
            pp_sgr(ppf, here);
            caml_call2(pp_v, ppf, v);
            return pp_sgr(ppf, prev);
        });
    }
    function id$0(_a4_) {
        return _a4_;
    }
    function label(_a2_, _a3_) {
        return styled(_aM_, string, _a2_, _a3_);
    }
    function field$0(_a0_, opt, l, prj, pp_v, ppf, v) {
        var label$0 = _a0_ ? _a0_[1] : label, sep = opt ? opt[1] : function(ppf, _a1_) {
            return caml_call2(pf, ppf, fmt$13);
        };
        return caml_call8(pf, ppf, _aN_, label$0, l, sep, 0, pp_v, caml_call1(prj, v));
    }
    function record$0(opt, pps) {
        var sep = opt ? opt[1] : cut, _aT_ = [
            0,
            sep
        ];
        function _aU_(_aY_, _aZ_) {
            return concat(_aT_, pps, _aY_, _aZ_);
        }
        var _aV_ = 0;
        return function(_aW_, _aX_) {
            return vbox(_aV_, _aU_, _aW_, _aX_);
        };
    }
    function of_to_string(f, ppf, v) {
        return caml_call2(string, ppf, caml_call1(f, v));
    }
    function to_to_string(pp_v, v) {
        return caml_call3(str, _aO_, pp_v, v);
    }
    function prefix(pp_p, pp_v, ppf, v) {
        caml_call2(pp_p, ppf, 0);
        return caml_call2(pp_v, ppf, v);
    }
    function suffix(pp_s, pp_v, ppf, v) {
        caml_call2(pp_v, ppf, v);
        return caml_call2(pp_s, ppf, 0);
    }
    function styled_unit(style, fmt) {
        function _aP_(ppf, _aS_) {
            return caml_call2(pf, ppf, fmt);
        }
        return function(_aQ_, _aR_) {
            return styled(style, _aP_, _aQ_, _aR_);
        };
    }
    var Fmt = [
        0,
        stdout,
        stderr,
        pf,
        pr,
        epr,
        str,
        kpf,
        kstr,
        str_like,
        with_buffer,
        failwith,
        failwith_notrace,
        invalid_arg,
        error,
        error_msg,
        flush,
        nop,
        any,
        using,
        const$0,
        fmt,
        cut,
        sp,
        sps,
        comma,
        semi,
        append,
        append,
        concat,
        iter,
        iter_bindings,
        box,
        hbox,
        vbox,
        hvbox,
        hovbox,
        parens,
        brackets,
        braces,
        quote,
        id$0,
        field$0,
        record$0,
        bool,
        int$0,
        nativeint,
        int32,
        int64,
        uint,
        unativeint,
        uint32,
        uint64,
        float$0,
        float_dfrac,
        float_dsig,
        char$0,
        string,
        buffer,
        exn,
        exn_backtrace,
        pair,
        option,
        result,
        list,
        array,
        seq,
        hashtbl,
        queue,
        stack,
        [
            0,
            signal,
            uchar,
            string$0,
            pair$0,
            option$0,
            result$0,
            list$0,
            array$0,
            seq$0,
            hashtbl$0,
            queue$0,
            stack$0,
            field,
            record,
            iter$0,
            iter_bindings$0
        ],
        si_size,
        byte_size,
        bi_byte_size,
        uint64_ns_span,
        on_bytes,
        on_string,
        ascii,
        octets,
        addresses,
        hex,
        words,
        paragraphs,
        text,
        lines,
        truncated,
        text_loc,
        one_of,
        did_you_mean,
        if_utf_8,
        utf_8,
        set_utf_8,
        styled,
        style_renderer,
        set_style_renderer,
        of_to_string,
        to_to_string,
        str,
        kstr,
        str_like,
        any,
        any,
        prefix,
        suffix,
        styled_unit
    ];
    runtime.caml_register_global(267, Fmt, "Fmt");
    return;
})(globalThis);
//# 5 "../.js/default/note/note.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_option_is_None$1 = "option is None", cst_src_note_ml = "src/note.ml", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Stdlib_Format = global_data.Stdlib__Format, CamlinternalMod = global_data.CamlinternalMod, Stdlib_Set = global_data.Stdlib__Set, Src = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        19,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), C = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        99,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), Logr = caml_call2(CamlinternalMod[1], [
        0,
        cst_src_note_ml,
        232,
        6
    ], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ]), Srcs = caml_call1(Stdlib_Set[1], [
        0,
        Src[1]
    ]);
    function create(srcs) {
        return [
            0,
            srcs,
            Srcs[1],
            0
        ];
    }
    function create$0(param) {
        return create(Srcs[1]);
    }
    var nil = create$0(0), delayed = create$0(0), cst_step_already_executed = "step already executed";
    function add_src(step, src) {
        step[1] = caml_call2(Srcs[2], src, step[1]);
    }
    function add_delayed(step, src) {
        step[2] = caml_call2(Srcs[2], src, step[2]);
        return 0;
    }
    function add_cleanup(step, clean) {
        step[3] = [
            0,
            clean,
            step[3]
        ];
        return 0;
    }
    function already_executed(param) {
        return caml_call1(Stdlib[1], cst_step_already_executed);
    }
    function execute_delayed$0(counter, srcs) {
        var ds = create(srcs);
        delayed[1] = srcs;
        caml_call2(Srcs[23], function(param) {
            var s = param[1], c = caml_call1(Src[3], s);
            caml_call2(C[15], delayed, c);
            return caml_call2(C[7], c, ds);
        }, srcs);
        if (counter >= 50) return caml_trampoline_return(execute$0, [
            0,
            ds
        ]);
        var counter$0 = counter + 1 | 0;
        return execute$0(counter$0, ds);
    }
    function execute_delayed(srcs) {
        return caml_trampoline(execute_delayed$0(0, srcs));
    }
    function execute$0(counter, step) {
        function update_src_logs(src) {
            var _dO_ = caml_call1(Src[5], src), _dP_ = caml_call1(Logr[9], step);
            return caml_call2(Stdlib_List[18], _dP_, _dO_);
        }
        caml_call2(Srcs[23], update_src_logs, step[1]);
        caml_call2(Srcs[23], Src[8], step[1]);
        caml_call2(Stdlib_List[18], function(f) {
            return caml_call1(f, 0);
        }, step[3]);
        step[3] = 0;
        add_cleanup(step, already_executed);
        if (caml_call1(Srcs[30], step[2])) return 0;
        var _dN_ = step[2];
        if (counter >= 50) return caml_trampoline_return(execute_delayed$0, [
            0,
            _dN_
        ]);
        var counter$0 = counter + 1 | 0;
        return execute_delayed$0(counter$0, _dN_);
    }
    function execute(step) {
        return caml_trampoline(execute$0(0, step));
    }
    function id(param) {
        var s = param[1];
        return s[1];
    }
    function cell(s) {
        return s[2];
    }
    function untyped(s) {
        return s[4];
    }
    function compare(_dM_, param) {
        var t = param[1], s = _dM_[1];
        return runtime.caml_int_compare(s[1], t[1]);
    }
    function logrs(param) {
        var s = param[1];
        return s[3];
    }
    function add_logr(logr, param) {
        var s = param[1];
        s[3] = [
            0,
            logr,
            s[3]
        ];
        return 0;
    }
    function rem_logr(logr, param) {
        var s = param[1], acc = 0, param$0 = s[3];
        for(;;){
            if (param$0) {
                var v = param$0[1], vs = param$0[2];
                if (v !== logr) {
                    var vs$0 = param$0[2], acc$0 = [
                        0,
                        v,
                        acc
                    ];
                    acc = acc$0;
                    param$0 = vs$0;
                    continue;
                }
                var _dL_ = caml_call2(Stdlib_List[13], vs, acc);
            } else var _dL_ = acc;
            s[3] = _dL_;
            return 0;
        }
    }
    function reset_stamp(param) {
        var s = param[1];
        return caml_call2(C[7], s[2], nil);
    }
    var Step = [
        248,
        "Note.Src.Step",
        runtime.caml_fresh_oo_id(0)
    ];
    function find_active_step(step, ss) {
        if (step !== nil) return step;
        function find_not_nil(param) {
            var s = param[1], step = caml_call1(C[6], s[2]), _dK_ = step !== nil ? 1 : 0;
            if (_dK_) throw [
                0,
                Step,
                step
            ];
            return _dK_;
        }
        try {
            caml_call2(Srcs[23], find_not_nil, ss);
            return nil;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Step) throw caml_maybe_attach_backtrace(exn, 0);
            var s = exn[2];
            return s;
        }
    }
    var id$0 = [
        0,
        0
    ];
    function create$1(eq, v) {
        function update(_dJ_, param) {
            return 0;
        }
        var cell = caml_call5(C[1], eq, nil, Srcs[1], v, update), src = [];
        id$0[1]++;
        runtime.caml_update_dummy(src, [
            0,
            id$0[1],
            cell,
            0,
            [
                0,
                src
            ]
        ]);
        var _dI_ = caml_call1(Srcs[3], src[4]);
        caml_call2(C[10], cell, _dI_);
        caml_call2(C[11], cell, 0);
        return src;
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], Src, [
        0,
        compare,
        id,
        cell,
        untyped,
        logrs,
        add_logr,
        rem_logr,
        reset_stamp,
        find_active_step,
        create$1
    ]);
    var cst_TOOD = "TOOD", _a_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    ""
                ]
            ],
            [
                12,
                123,
                [
                    15,
                    [
                        12,
                        125,
                        [
                            17,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[{%a}@]"
    ];
    function create$2(opt, step, srcs, value, update) {
        var eq = opt ? opt[1] : caml_equal;
        return [
            0,
            eq,
            step,
            srcs,
            1,
            value,
            1,
            update
        ];
    }
    function const$0(opt, v) {
        var eq = opt ? opt[1] : caml_equal;
        return [
            0,
            eq,
            nil,
            Srcs[1],
            0,
            v,
            0,
            function(_dH_, param) {
                return 0;
            }
        ];
    }
    function eq(c) {
        return c[1];
    }
    function set_eq(c, eq) {
        c[1] = eq;
        return 0;
    }
    function with_eq(eq, c) {
        return [
            0,
            eq,
            c[2],
            c[3],
            c[4],
            c[5],
            c[6],
            c[7]
        ];
    }
    function stamp(c) {
        return c[2];
    }
    function set_stamp(c, stamp) {
        c[2] = stamp;
        return 0;
    }
    function srcs_changed(c) {
        return c[4];
    }
    function set_srcs_changed(c, bool) {
        c[4] = bool;
        return 0;
    }
    function srcs(c) {
        return c[3];
    }
    function set_srcs(c, srcs) {
        c[4] = 1;
        c[3] = srcs;
        return 0;
    }
    function value(c) {
        return c[5];
    }
    function value_changed(c) {
        return c[6];
    }
    function set_value(c, v) {
        return caml_call2(c[1], v, c[5]) ? 0 : (c[6] = 1, c[5] = v, 0);
    }
    function update(step, c) {
        var _dE_ = step !== nil ? 1 : 0, _dF_ = _dE_ ? c[2] !== step ? 1 : 0 : _dE_;
        if (!_dF_) return _dF_;
        c[2] = step;
        c[4] = 0;
        c[6] = 0;
        var _dG_ = caml_call2(Srcs[6], c[3], step[1]);
        return caml_call1(Srcs[30], _dG_) ? 0 : caml_call2(c[7], step, c);
    }
    function set_update(c, u) {
        c[7] = u;
        return 0;
    }
    function src_update(step, c, v) {
        c[6] = 0;
        return caml_call2(c[1], v, c[5]) ? 0 : (c[2] = step, c[6] = 1, c[5] = v, 1);
    }
    function up_to_date_value(c) {
        var step = caml_call2(Src[9], nil, c[3]);
        update(step, c);
        return c[5];
    }
    function reset_instant(c) {
        c[6] = 0;
        c[5] = 0;
        return 0;
    }
    function set_instant(step, c, v) {
        return v ? (c[6] = 1, c[5] = v, add_cleanup(step, function(param) {
            return reset_instant(c);
        })) : 0;
    }
    function create_instant(step, srcs, value, update) {
        var value_changed = value ? 1 : 0, c = [
            0,
            caml_equal,
            step,
            srcs,
            1,
            value,
            value_changed,
            update
        ], _dD_ = value_changed ? runtime.caml_notequal(step, nil) : value_changed;
        if (_dD_) add_cleanup(step, function(param) {
            return reset_instant(c);
        });
        return c;
    }
    function delay(i, z) {
        return caml_call1(Stdlib[2], cst_TOOD);
    }
    function fix(eq, i, cf) {
        var src = caml_call2(Src[10], eq, i), src$0 = [
            0,
            src
        ], d = caml_call1(Src[3], src), match = caml_call1(cf, d), r = match[2], c = match[1], c_update = c[7];
        function c_update$0(step, self1) {
            caml_call2(c_update, step, self1);
            var _dC_ = c[6];
            return _dC_ ? add_delayed(step, src$0) : _dC_;
        }
        function d_update(step, self1) {
            return step === delayed ? set_value(self1, c[5]) : 0;
        }
        c[7] = c_update$0;
        d[7] = d_update;
        var _dB_ = caml_call1(C[8], c), step = caml_call2(Src[9], nil, _dB_);
        update(step, c);
        if (step === nil) execute_delayed(caml_call1(Srcs[3], src$0));
        return r;
    }
    function defer(init, c) {
        var src = caml_call2(Src[10], [
            0,
            c[1]
        ], init), src$0 = [
            0,
            src
        ], d = caml_call1(Src[3], src);
        function update(step, self1) {
            if (step === delayed) return set_value(self1, c[5]);
            caml_call2(C[15], step, c);
            if (caml_call1(C[9], c)) {
                var _dz_ = caml_call1(C[8], c);
                caml_call2(C[10], d, _dz_);
            }
            var _dA_ = caml_call1(C[13], c);
            return _dA_ ? add_delayed(step, src$0) : _dA_;
        }
        d[7] = update;
        var step = caml_call2(Src[9], nil, c[3]);
        update(step, c);
        update(step, d);
        if (step === nil) execute_delayed(caml_call1(Srcs[3], src$0));
        return d;
    }
    function dump_src_ids(ppf, c) {
        var _dw_ = caml_call1(Srcs[10], c[3]), _dx_ = caml_call2(Stdlib_List[20], function(s) {
            return caml_call1(Src[2], s);
        }, _dw_), _dy_ = caml_call2(Stdlib_Format[136], [
            0,
            Stdlib_Format[32]
        ], Stdlib_Format[23]);
        return caml_call4(Stdlib_Format[143], ppf, _a_, _dy_, _dx_);
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], C, [
        0,
        create$2,
        const$0,
        eq,
        set_eq,
        with_eq,
        stamp,
        set_stamp,
        srcs,
        srcs_changed,
        set_srcs,
        set_srcs_changed,
        value,
        value_changed,
        set_value,
        update,
        set_update,
        src_update,
        up_to_date_value,
        create_instant,
        reset_instant,
        set_instant,
        delay,
        fix,
        defer,
        dump_src_ids
    ]);
    function const$1(v) {
        return [
            0,
            0,
            function(param) {
                return v;
            }
        ];
    }
    function obs_cell(c) {
        return [
            0,
            [
                0,
                [
                    0,
                    c
                ],
                0
            ],
            function(param) {
                return caml_call1(C[12], c);
            }
        ];
    }
    function app(_du_, param) {
        var v = param[2], vcs = param[1], f = _du_[2], fcs = _du_[1];
        return [
            0,
            caml_call2(Stdlib_List[13], fcs, vcs),
            function(param) {
                var _dv_ = caml_call1(v, 0);
                return caml_call1(caml_call1(f, 0), _dv_);
            }
        ];
    }
    function update_srcs(l) {
        function add_cell(acc, param) {
            var c = param[1], _dt_ = caml_call1(C[8], c);
            return caml_call2(Srcs[5], acc, _dt_);
        }
        var new_srcs = caml_call3(Stdlib_List[26], add_cell, Srcs[1], l[3]), rems = caml_call2(Srcs[8], l[2], new_srcs), adds = caml_call2(Srcs[8], new_srcs, l[2]), _dr_ = caml_call1(Src[7], l);
        caml_call2(Srcs[23], _dr_, rems);
        var _ds_ = caml_call1(Src[6], l);
        caml_call2(Srcs[23], _ds_, adds);
        l[2] = new_srcs;
    }
    function update$0(step, l) {
        var _dp_ = step !== nil ? 1 : 0, _dq_ = _dp_ ? step !== l[1] ? 1 : 0 : _dp_;
        if (!_dq_) return _dq_;
        l[1] = step;
        var srcs_changed = 0, value_changed = 0, param = l[3];
        for(;;){
            if (!param) {
                if (srcs_changed) update_srcs(l);
                return value_changed ? caml_call1(l[4], 0) : value_changed;
            }
            var cs = param[2], c = param[1][1];
            caml_call2(C[15], step, c);
            var value_changed$0 = value_changed || caml_call1(C[13], c), srcs_changed$0 = srcs_changed || caml_call1(C[9], c);
            srcs_changed = srcs_changed$0;
            value_changed = value_changed$0;
            param = cs;
        }
    }
    function force(l) {
        var step = caml_call2(Src[9], nil, l[2]);
        update$0(step, l);
        return caml_call1(l[4], 0);
    }
    function create$3(opt, param) {
        var now = opt ? opt[1] : 1, log = param[2], cells = param[1], l = [
            0,
            nil,
            Srcs[1],
            cells,
            log
        ];
        update_srcs(l);
        if (now) force(l);
        return l;
    }
    function for_cell(now, c, log) {
        return create$3(now, [
            0,
            [
                0,
                [
                    0,
                    c
                ],
                0
            ],
            function(param) {
                return caml_call1(log, caml_call1(C[12], c));
            }
        ]);
    }
    function destroy(l) {
        var _dn_ = l[2], _do_ = caml_call1(Src[7], l);
        return caml_call2(Srcs[23], _do_, _dn_);
    }
    var held = [
        0,
        0
    ];
    function hold(l) {
        held[1] = [
            0,
            l,
            held[1]
        ];
        return 0;
    }
    function may_hold(param) {
        if (!param) return 0;
        var l = param[1];
        return hold(l);
    }
    function unhold_all(param) {
        caml_call2(Stdlib_List[18], destroy, held[1]);
        held[1] = 0;
        return 0;
    }
    caml_call3(CamlinternalMod[2], [
        0,
        [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ], Logr, [
        0,
        const$1,
        obs_cell,
        app,
        app,
        create$3,
        for_cell,
        force,
        destroy,
        update$0,
        hold,
        may_hold,
        unhold_all
    ]);
    var obs = Logr[2];
    function log(now, e, f) {
        function wrap(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }
        return [
            0,
            caml_call3(Logr[6], now, e, wrap)
        ];
    }
    function create$4(param) {
        var src = caml_call2(Src[10], 0, 0);
        function send(step, v) {
            if (step) var step$0 = step[1], exec = 0, step$1 = step$0;
            else var step$2 = create$0(0), exec = 1, step$1 = step$2;
            var _dl_ = caml_call1(Src[3], src);
            caml_call2(C[7], _dl_, step$1);
            var _dm_ = caml_call1(Src[3], src);
            caml_call3(C[21], step$1, _dm_, [
                0,
                v
            ]);
            add_src(step$1, caml_call1(Src[4], src));
            return exec ? execute(step$1) : exec;
        }
        return [
            0,
            caml_call1(Src[3], src),
            send
        ];
    }
    var value$0 = C[18], never = caml_call2(C[2], 0, 0), cst_option_is_None = cst_option_is_None$1;
    function bind(e, f) {
        var _c9_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _c9_);
        caml_call2(C[15], step, e);
        var match = caml_call1(C[12], e);
        if (match) var curr = match[1], current = caml_call1(f, curr);
        else var current = never;
        var current$0 = [
            0,
            current
        ];
        function update(step, self1) {
            caml_call2(C[15], step, e);
            var match = caml_call1(C[12], e);
            if (match) {
                var curr = match[1];
                current$0[1] = caml_call1(f, curr);
                caml_call2(C[15], step, current$0[1]);
                var _db_ = caml_call1(C[8], current$0[1]), _dc_ = caml_call1(C[8], e), _dd_ = caml_call2(Srcs[5], _dc_, _db_);
                caml_call2(C[10], self1, _dd_);
                var _de_ = caml_call1(C[12], current$0[1]);
                return caml_call3(C[21], step, self1, _de_);
            }
            caml_call2(C[15], step, current$0[1]);
            var _df_ = caml_call1(C[9], e), _dg_ = _df_ || caml_call1(C[9], current$0[1]);
            if (_dg_) {
                var _dh_ = caml_call1(C[8], current$0[1]), _di_ = caml_call1(C[8], e), _dj_ = caml_call2(Srcs[5], _di_, _dh_);
                caml_call2(C[10], self1, _dj_);
            }
            var _dk_ = caml_call1(C[12], current$0[1]);
            return caml_call3(C[21], step, self1, _dk_);
        }
        var _c__ = caml_call1(C[8], current$0[1]), step$0 = caml_call2(Src[9], step, _c__);
        caml_call2(C[15], step$0, current$0[1]);
        var _c$_ = caml_call1(C[8], current$0[1]), _da_ = caml_call1(C[8], e), srcs = caml_call2(Srcs[5], _da_, _c$_), init = caml_call1(C[12], current$0[1]);
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function join(ee) {
        return bind(ee, function(e) {
            return e;
        });
    }
    function swap(es) {
        var _cW_ = caml_call1(C[8], es), step = caml_call2(Src[9], nil, _cW_);
        caml_call2(C[15], step, es);
        var current = [
            0,
            caml_call1(C[12], es)
        ];
        function update(step, self1) {
            caml_call2(C[15], step, es);
            if (caml_call1(C[13], es)) {
                current[1] = caml_call1(C[12], es);
                caml_call2(C[15], step, current[1]);
                var _c0_ = caml_call1(C[8], current[1]), _c1_ = caml_call1(C[8], es), _c2_ = caml_call2(Srcs[5], _c1_, _c0_);
                caml_call2(C[10], self1, _c2_);
            } else {
                caml_call2(C[15], step, current[1]);
                var _c4_ = caml_call1(C[9], es), _c5_ = _c4_ || caml_call1(C[9], current[1]);
                if (_c5_) {
                    var _c6_ = caml_call1(C[8], current[1]), _c7_ = caml_call1(C[8], es), _c8_ = caml_call2(Srcs[5], _c7_, _c6_);
                    caml_call2(C[10], self1, _c8_);
                }
            }
            var _c3_ = caml_call1(C[12], current[1]);
            return caml_call3(C[21], step, self1, _c3_);
        }
        var _cX_ = caml_call1(C[8], current[1]), step$0 = caml_call2(Src[9], step, _cX_);
        caml_call2(C[15], step$0, current[1]);
        var _cY_ = caml_call1(C[8], current[1]), _cZ_ = caml_call1(C[8], es), srcs = caml_call2(Srcs[5], _cZ_, _cY_), init = caml_call1(C[12], current[1]);
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function map(f, e) {
        function map(f, param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cU_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cU_);
            }
            var _cV_ = map(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cV_);
        }
        var _cR_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cR_);
        caml_call2(C[15], step, e);
        var _cS_ = map(f, caml_call1(C[12], e)), _cT_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cT_, _cS_, update);
    }
    function stamp$0(e, v) {
        function stamp(param) {
            return param ? [
                0,
                v
            ] : 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cP_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cP_);
            }
            var _cQ_ = stamp(caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cQ_);
        }
        var _cN_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cN_);
        caml_call2(C[15], step, e);
        var init = stamp(caml_call1(C[12], e)), _cO_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cO_, init, update);
    }
    function filter(f, e) {
        function filter(f, occ) {
            if (!occ) return 0;
            var v = occ[1];
            return caml_call1(f, v) ? occ : 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cL_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cL_);
            }
            var _cM_ = filter(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cM_);
        }
        var _cJ_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cJ_);
        caml_call2(C[15], step, e);
        var init = filter(f, caml_call1(C[12], e)), _cK_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cK_, init, update);
    }
    function filter_map(f, e) {
        function filter_map(f, param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cH_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cH_);
            }
            var _cI_ = filter_map(f, caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cI_);
        }
        var _cF_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cF_);
        caml_call2(C[15], step, e);
        var init = filter_map(f, caml_call1(C[12], e)), _cG_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _cG_, init, update);
    }
    function select(es) {
        function add_srcs(acc, e) {
            var _cE_ = caml_call1(C[8], e);
            return caml_call2(Srcs[5], acc, _cE_);
        }
        function or_srcs_changed(acc, e) {
            return acc ? acc : caml_call1(C[9], e);
        }
        function update(step, self1) {
            var _cA_ = caml_call1(C[15], step);
            caml_call2(Stdlib_List[18], _cA_, es);
            var srcs_changed = caml_call3(Stdlib_List[26], or_srcs_changed, 0, es);
            if (srcs_changed) {
                var _cB_ = caml_call3(Stdlib_List[26], add_srcs, Srcs[1], es);
                caml_call2(C[10], self1, _cB_);
            }
            a: {
                try {
                    var e = caml_call2(Stdlib_List[39], function(e) {
                        return 0 !== caml_call1(C[12], e) ? 1 : 0;
                    }, es);
                } catch (_cD_) {
                    var _cC_ = caml_wrap_exception(_cD_);
                    if (_cC_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_cC_, 0);
                    var v = 0;
                    break a;
                }
                var v = caml_call1(C[12], e);
            }
            return caml_call3(C[21], step, self1, v);
        }
        function find_step(step, e) {
            var _cz_ = caml_call1(C[8], e);
            return caml_call2(Src[9], step, _cz_);
        }
        var step = caml_call3(Stdlib_List[26], find_step, nil, es), _cw_ = caml_call1(C[15], step);
        caml_call2(Stdlib_List[18], _cw_, es);
        a: {
            try {
                var e = caml_call2(Stdlib_List[39], function(e) {
                    return 0 !== caml_call1(C[12], e) ? 1 : 0;
                }, es);
            } catch (_cy_) {
                var _cx_ = caml_wrap_exception(_cy_);
                if (_cx_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_cx_, 0);
                var init = 0;
                break a;
            }
            var init = caml_call1(C[12], e);
        }
        var srcs = caml_call3(Stdlib_List[26], add_srcs, Srcs[1], es);
        return caml_call4(C[19], step, srcs, init, update);
    }
    function accum(acc, e) {
        var acc$0 = [
            0,
            acc
        ];
        function accum(param) {
            if (!param) return 0;
            var f = param[1];
            acc$0[1] = caml_call1(f, acc$0[1]);
            return [
                0,
                acc$0[1]
            ];
        }
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _cu_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _cu_);
            }
            var _cv_ = accum(caml_call1(C[12], e));
            return caml_call3(C[21], step, self1, _cv_);
        }
        var _cs_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _cs_);
        caml_call2(C[15], step, e);
        var init = accum(caml_call1(C[12], e)), _ct_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _ct_, init, update);
    }
    function until(opt, next, e) {
        var limit = opt ? opt[1] : 0;
        function nop(step, self1) {
            return 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, next);
            caml_call2(C[15], step, e);
            if (caml_call1(C[12], next)) {
                caml_call2(C[10], self1, Srcs[1]);
                caml_call2(C[16], self1, nop);
                var _cl_ = limit ? caml_call1(C[12], e) : 0;
                return caml_call3(C[21], step, self1, _cl_);
            }
            var _cm_ = caml_call1(C[9], next), _cn_ = _cm_ || caml_call1(C[9], e);
            if (_cn_) {
                var _co_ = caml_call1(C[8], e), _cp_ = caml_call1(C[8], next), _cq_ = caml_call2(Srcs[5], _cp_, _co_);
                caml_call2(C[10], self1, _cq_);
            }
            var _cr_ = caml_call1(C[12], e);
            return caml_call3(C[21], step, self1, _cr_);
        }
        var _cg_ = caml_call1(C[8], next), step = caml_call2(Src[9], nil, _cg_), _ch_ = caml_call1(C[8], e), step$0 = caml_call2(Src[9], step, _ch_);
        caml_call2(C[15], step$0, next);
        caml_call2(C[15], step$0, e);
        if (caml_call1(C[12], next)) {
            var init = limit ? caml_call1(C[12], e) : 0;
            return caml_call4(C[19], step$0, Srcs[1], init, nop);
        }
        var _ci_ = caml_call1(C[8], e), _cj_ = caml_call1(C[8], next), srcs = caml_call2(Srcs[5], _cj_, _ci_), _ck_ = caml_call1(C[12], e);
        return caml_call4(C[19], step$0, srcs, _ck_, update);
    }
    function follow(e, on) {
        function deps_srcs(e, on) {
            var _ce_ = caml_call1(C[8], on), _cf_ = caml_call1(C[8], e);
            return caml_call2(Srcs[5], _cf_, _ce_);
        }
        function update_deps(step, e, on) {
            caml_call2(C[15], step, e);
            return caml_call2(C[15], step, on);
        }
        function follow(e, on) {
            if (e && on) return e;
            return 0;
        }
        function update(step, self1) {
            update_deps(step, e, on);
            var _b$_ = caml_call1(C[9], e), _ca_ = _b$_ || caml_call1(C[9], on);
            if (_ca_) {
                var _cb_ = deps_srcs(e, on);
                caml_call2(C[10], self1, _cb_);
            }
            var _cc_ = caml_call1(C[12], on), _cd_ = follow(caml_call1(C[12], e), _cc_);
            return caml_call3(C[21], step, self1, _cd_);
        }
        var _b7_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _b7_), _b8_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _b8_);
        update_deps(step$0, e, on);
        var _b9_ = caml_call1(C[12], on), init = follow(caml_call1(C[12], e), _b9_), _b__ = deps_srcs(e, on);
        return caml_call4(C[19], step$0, _b__, init, update);
    }
    function defer$0(e) {
        return caml_call2(C[24], 0, e);
    }
    function fix$0(ef) {
        return caml_call3(C[23], 0, 0, ef);
    }
    function on_some(e) {
        return filter_map(function(x) {
            return x;
        }, e);
    }
    function some(e) {
        return map(function(v) {
            return [
                0,
                v
            ];
        }, e);
    }
    function value$1(e, default$0) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _b6_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _b6_);
            }
            var match = caml_call1(C[12], e);
            if (match) var v = match[1], v$0 = v || (caml_call2(C[15], step, default$0), [
                0,
                caml_call1(C[12], default$0)
            ]), occ = v$0;
            else var occ = 0;
            return caml_call3(C[21], step, self1, occ);
        }
        var _b4_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _b4_);
        caml_call2(C[15], step, e);
        caml_call2(C[15], step, default$0);
        var match = caml_call1(C[12], e);
        if (match) var v = match[1], v$0 = v || [
            0,
            caml_call1(C[12], default$0)
        ], init = v$0;
        else var init = 0;
        var _b5_ = caml_call1(C[8], e);
        return caml_call4(C[19], step, _b5_, init, update);
    }
    function get(e) {
        return map(function(param) {
            if (!param) return caml_call1(Stdlib[1], cst_option_is_None);
            var v = param[1];
            return v;
        }, e);
    }
    function bind$0(e, f) {
        return map(function(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }, e);
    }
    function join$0(e) {
        return map(function(param) {
            if (param) {
                var o = param[1];
                if (o) return o;
            }
            return 0;
        }, e);
    }
    function is_none(e) {
        return map(function(param) {
            return param ? 0 : 1;
        }, e);
    }
    function is_some(e) {
        return map(function(param) {
            return param ? 1 : 0;
        }, e);
    }
    function map$0(f, e) {
        return map(function(param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }, e);
    }
    function fst(e) {
        return map(function(_b3_) {
            return _b3_[1];
        }, e);
    }
    function snd(e) {
        return map(function(_b2_) {
            return _b2_[2];
        }, e);
    }
    function v(e0, e1) {
        function update(step, self1) {
            caml_call2(C[15], step, e0);
            caml_call2(C[15], step, e1);
            var _bX_ = caml_call1(C[9], e0), _bY_ = _bX_ || caml_call1(C[9], e1);
            if (_bY_) {
                var _bZ_ = caml_call1(C[8], e1), _b0_ = caml_call1(C[8], e0), _b1_ = caml_call2(Srcs[5], _b0_, _bZ_);
                caml_call2(C[10], self1, _b1_);
            }
            var match = caml_call1(C[12], e0), match$0 = caml_call1(C[12], e1);
            a: {
                if (match && match$0) {
                    var v1 = match$0[1], v0 = match[1], occ = [
                        0,
                        [
                            0,
                            v0,
                            v1
                        ]
                    ];
                    break a;
                }
                var occ = 0;
            }
            return caml_call3(C[21], step, self1, occ);
        }
        var _bT_ = caml_call1(C[8], e0), step = caml_call2(Src[9], nil, _bT_), _bU_ = caml_call1(C[8], e1), step$0 = caml_call2(Src[9], step, _bU_), _bV_ = caml_call1(C[8], e1), _bW_ = caml_call1(C[8], e0), srcs = caml_call2(Srcs[5], _bW_, _bV_), match = caml_call1(C[12], e0), match$0 = caml_call1(C[12], e1);
        a: {
            if (match && match$0) {
                var v1 = match$0[1], v0 = match[1], init = [
                    0,
                    [
                        0,
                        v0,
                        v1
                    ]
                ];
                break a;
            }
            var init = 0;
        }
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    var Pair = [
        0,
        fst,
        snd,
        v
    ], dump_src_ids$0 = C[25], log$0 = Logr[6], obs$0 = Logr[2], eq$0 = C[3], with_eq$0 = C[5];
    function create$5(eq, v) {
        var src = caml_call2(Src[10], eq, v);
        function set(step, v) {
            if (step) var step$0 = step[1], exec = 0, step$1 = step$0;
            else var step$2 = create$0(0), exec = 1, step$1 = step$2;
            var cell = caml_call1(Src[3], src);
            if (caml_call3(C[17], step$1, cell, v)) add_src(step$1, caml_call1(Src[4], src));
            return exec ? execute(step$1) : exec;
        }
        return [
            0,
            caml_call1(Src[3], src),
            set
        ];
    }
    var value$2 = C[18], rough_value = C[12], const$2 = C[2];
    function bind$1(v, f) {
        var _bC_ = caml_call1(C[8], v), step = caml_call2(Src[9], nil, _bC_);
        caml_call2(C[15], step, v);
        var current = [
            0,
            caml_call1(f, caml_call1(C[12], v))
        ];
        function update(step, self1) {
            caml_call2(C[15], step, v);
            if (caml_call1(C[13], v)) {
                current[1] = caml_call1(f, caml_call1(C[12], v));
                caml_call2(C[15], step, current[1]);
                var _bH_ = caml_call1(C[3], current[1]);
                caml_call2(C[4], self1, _bH_);
                var _bI_ = caml_call1(C[8], current[1]), _bJ_ = caml_call1(C[8], v), _bK_ = caml_call2(Srcs[5], _bJ_, _bI_);
                caml_call2(C[10], self1, _bK_);
                var _bL_ = caml_call1(C[12], current[1]);
                return caml_call2(C[14], self1, _bL_);
            }
            caml_call2(C[15], step, current[1]);
            var _bM_ = caml_call1(C[9], v), _bN_ = _bM_ || caml_call1(C[9], current[1]);
            if (_bN_) {
                var _bO_ = caml_call1(C[8], current[1]), _bP_ = caml_call1(C[8], v), _bQ_ = caml_call2(Srcs[5], _bP_, _bO_);
                caml_call2(C[10], self1, _bQ_);
            }
            var _bR_ = caml_call1(C[13], current[1]);
            if (!_bR_) return _bR_;
            var _bS_ = caml_call1(C[12], current[1]);
            return caml_call2(C[14], self1, _bS_);
        }
        var _bD_ = caml_call1(C[8], current[1]), step$0 = caml_call2(Src[9], step, _bD_);
        caml_call2(C[15], step$0, current[1]);
        var _bE_ = caml_call1(C[8], current[1]), _bF_ = caml_call1(C[8], v), srcs = caml_call2(Srcs[5], _bF_, _bE_), init = caml_call1(C[12], current[1]), _bG_ = [
            0,
            caml_call1(C[3], current[1])
        ];
        return caml_call5(C[1], _bG_, step$0, srcs, init, update);
    }
    function hold$0(eq, i, e) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _bB_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _bB_);
            }
            var match = caml_call1(C[12], e);
            if (!match) return 0;
            var v = match[1];
            return caml_call2(C[14], self1, v);
        }
        var _bz_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _bz_);
        caml_call2(C[15], step, e);
        var match = caml_call1(C[12], e);
        if (match) var v = match[1], init = v;
        else var init = i;
        var _bA_ = caml_call1(C[8], e);
        return caml_call5(C[1], eq, step, _bA_, init, update);
    }
    function join$1(ss) {
        return bind$1(ss, function(s) {
            return s;
        });
    }
    function swap$0(s, se) {
        return join$1(hold$0([
            0,
            function(_by_, _bx_) {
                return _by_ === _bx_ ? 1 : 0;
            }
        ], s, se));
    }
    function changes(s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _bu_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _bu_);
            }
            var _bv_ = caml_call1(C[13], s);
            if (!_bv_) return _bv_;
            var _bw_ = [
                0,
                caml_call1(C[12], s)
            ];
            return caml_call3(C[21], step, self1, _bw_);
        }
        var _bs_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _bs_);
        caml_call2(C[15], step, s);
        var _bt_ = caml_call1(C[8], s);
        return caml_call4(C[19], step, _bt_, 0, update);
    }
    function sample(s, on, f) {
        function update(step, self1) {
            caml_call2(C[15], step, on);
            caml_call2(C[15], step, s);
            var _bm_ = caml_call1(C[9], on), _bn_ = _bm_ || caml_call1(C[9], s);
            if (_bn_) {
                var _bo_ = caml_call1(C[8], on), _bp_ = caml_call1(C[8], s), _bq_ = caml_call2(Srcs[5], _bp_, _bo_);
                caml_call2(C[10], self1, _bq_);
            }
            var match = caml_call1(C[12], on);
            if (!match) return 0;
            var v = match[1], _br_ = [
                0,
                caml_call2(f, caml_call1(C[12], s), v)
            ];
            return caml_call3(C[21], step, self1, _br_);
        }
        var _bi_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _bi_), _bj_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _bj_);
        caml_call2(C[15], step$0, on);
        caml_call2(C[15], step$0, s);
        var _bk_ = caml_call1(C[8], on), _bl_ = caml_call1(C[8], s), srcs = caml_call2(Srcs[5], _bl_, _bk_), match = caml_call1(C[12], on);
        if (match) var v = match[1], init = [
            0,
            caml_call2(f, caml_call1(C[12], s), v)
        ];
        else var init = 0;
        return caml_call4(C[19], step$0, srcs, init, update);
    }
    function sample_filter(s, on, f) {
        return on_some(sample(s, on, f));
    }
    function snapshot(s, on) {
        return sample(s, on, function(v, param) {
            return v;
        });
    }
    function map$1(eq, f, v) {
        function update(step, self1) {
            caml_call2(C[15], step, v);
            if (caml_call1(C[9], v)) {
                var _bf_ = caml_call1(C[8], v);
                caml_call2(C[10], self1, _bf_);
            }
            var _bg_ = caml_call1(C[13], v);
            if (!_bg_) return _bg_;
            var _bh_ = caml_call1(f, caml_call1(C[12], v));
            return caml_call2(C[14], self1, _bh_);
        }
        var _bc_ = caml_call1(C[8], v), step = caml_call2(Src[9], nil, _bc_);
        caml_call2(C[15], step, v);
        var _bd_ = caml_call1(f, caml_call1(C[12], v)), _be_ = caml_call1(C[8], v);
        return caml_call5(C[1], eq, step, _be_, _bd_, update);
    }
    function app$0(eq, f, v) {
        function update(step, self1) {
            caml_call2(C[15], step, f);
            caml_call2(C[15], step, v);
            var _a5_ = caml_call1(C[9], f), _a6_ = _a5_ || caml_call1(C[9], v);
            if (_a6_) {
                var _a7_ = caml_call1(C[8], v), _a8_ = caml_call1(C[8], f), _a9_ = caml_call2(Srcs[5], _a8_, _a7_);
                caml_call2(C[10], self1, _a9_);
            }
            var _a__ = caml_call1(C[13], f), _a$_ = _a__ || caml_call1(C[13], v);
            if (!_a$_) return _a$_;
            var _ba_ = caml_call1(C[12], v), _bb_ = caml_call1(caml_call1(C[12], f), _ba_);
            return caml_call2(C[14], self1, _bb_);
        }
        var _a0_ = caml_call1(C[8], f), step = caml_call2(Src[9], nil, _a0_), _a1_ = caml_call1(C[8], v), step$0 = caml_call2(Src[9], step, _a1_);
        caml_call2(C[15], step$0, f);
        caml_call2(C[15], step$0, v);
        var _a2_ = caml_call1(C[8], v), _a3_ = caml_call1(C[8], f), srcs = caml_call2(Srcs[5], _a3_, _a2_), _a4_ = caml_call1(C[12], v), init = caml_call1(caml_call1(C[12], f), _a4_);
        return caml_call5(C[1], eq, step$0, srcs, init, update);
    }
    function accum$0(eq, i, e) {
        return hold$0(eq, i, accum(i, e));
    }
    function until$0(opt, init, next, s) {
        var limit = opt ? opt[1] : 0;
        function nop(step, self1) {
            return 0;
        }
        function update(step, self1) {
            caml_call2(C[15], step, next);
            caml_call2(C[15], step, s);
            if (caml_call1(C[12], next)) {
                caml_call2(C[10], self1, Srcs[1]);
                caml_call2(C[16], self1, nop);
                if (!limit) return 0;
                var _aT_ = caml_call1(C[12], s);
                return caml_call2(C[14], self1, _aT_);
            }
            var _aU_ = caml_call1(C[9], next), _aV_ = _aU_ || caml_call1(C[9], s);
            if (_aV_) {
                var _aW_ = caml_call1(C[8], s), _aX_ = caml_call1(C[8], next), _aY_ = caml_call2(Srcs[5], _aX_, _aW_);
                caml_call2(C[10], self1, _aY_);
            }
            var _aZ_ = caml_call1(C[12], s);
            return caml_call2(C[14], self1, _aZ_);
        }
        var _aL_ = caml_call1(C[8], next), step = caml_call2(Src[9], nil, _aL_), _aM_ = caml_call1(C[8], s), step$0 = caml_call2(Src[9], step, _aM_);
        caml_call2(C[15], step$0, next);
        caml_call2(C[15], step$0, s);
        if (!caml_call1(C[12], next)) {
            var _aP_ = caml_call1(C[8], s), _aQ_ = caml_call1(C[8], next), srcs = caml_call2(Srcs[5], _aQ_, _aP_), _aR_ = caml_call1(C[12], s), _aS_ = [
                0,
                caml_call1(eq$0, s)
            ];
            return caml_call5(C[1], _aS_, step$0, srcs, _aR_, update);
        }
        if (init) var i = init[1], init$0 = i;
        else var init$0 = caml_call1(C[12], s);
        var _aN_ = Srcs[1], _aO_ = [
            0,
            caml_call1(eq$0, s)
        ];
        return caml_call5(C[1], _aO_, step$0, _aN_, init$0, nop);
    }
    function follow$0(init, s, on) {
        function deps_srcs(s, on) {
            var _aJ_ = caml_call1(C[8], on), _aK_ = caml_call1(C[8], s);
            return caml_call2(Srcs[5], _aK_, _aJ_);
        }
        function update_deps(step, s, on) {
            caml_call2(C[15], step, s);
            return caml_call2(C[15], step, on);
        }
        function update(step, self1) {
            update_deps(step, s, on);
            var _aE_ = caml_call1(C[9], s), _aF_ = _aE_ || caml_call1(C[9], on);
            if (_aF_) {
                var _aG_ = deps_srcs(s, on);
                caml_call2(C[10], self1, _aG_);
            }
            var _aH_ = caml_call1(C[12], on);
            if (!_aH_) return _aH_;
            var _aI_ = caml_call1(C[12], s);
            return caml_call2(C[14], self1, _aI_);
        }
        var _aA_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _aA_), _aB_ = caml_call1(C[8], on), step$0 = caml_call2(Src[9], step, _aB_);
        update_deps(step$0, s, on);
        if (init) var i = init[1], init$0 = i;
        else var init$0 = caml_call1(C[12], s);
        var _aC_ = deps_srcs(s, on), _aD_ = [
            0,
            caml_call1(eq$0, s)
        ];
        return caml_call5(C[1], _aD_, step$0, _aC_, init$0, update);
    }
    var delay$0 = C[22];
    function defer$1(init, s) {
        if (init) var init$0 = init[1], init$1 = init$0;
        else {
            var _az_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _az_);
            caml_call2(C[15], step, s);
            var init$1 = caml_call1(C[12], s);
        }
        return caml_call2(C[24], init$1, s);
    }
    var fix$1 = C[23];
    function l1(eq, f, x) {
        return map$1(eq, f, x);
    }
    function l2(eq, f, x, y) {
        function update(step, self1) {
            caml_call2(C[15], step, x);
            caml_call2(C[15], step, y);
            var _aq_ = caml_call1(C[9], x), _ar_ = _aq_ || caml_call1(C[9], y);
            if (_ar_) {
                var _as_ = caml_call1(C[8], y), _at_ = caml_call1(C[8], x), _au_ = caml_call2(Srcs[5], _at_, _as_);
                caml_call2(C[10], self1, _au_);
            }
            var _av_ = caml_call1(C[13], x), _aw_ = _av_ || caml_call1(C[13], y);
            if (!_aw_) return _aw_;
            var _ax_ = caml_call1(C[12], y), _ay_ = caml_call2(f, caml_call1(C[12], x), _ax_);
            return caml_call2(C[14], self1, _ay_);
        }
        var _al_ = caml_call1(C[8], x), step = caml_call2(Src[9], nil, _al_), _am_ = caml_call1(C[8], y), step$0 = caml_call2(Src[9], step, _am_);
        caml_call2(C[15], step$0, x);
        caml_call2(C[15], step$0, y);
        var _an_ = caml_call1(C[8], y), _ao_ = caml_call1(C[8], x), srcs = caml_call2(Srcs[5], _ao_, _an_), _ap_ = caml_call1(C[12], y), init = caml_call2(f, caml_call1(C[12], x), _ap_);
        return caml_call5(C[1], eq, step$0, srcs, init, update);
    }
    function l3(eq, f, x, y, z) {
        function srcs_union(x, y, z) {
            var _ah_ = caml_call1(C[8], z), _ai_ = caml_call1(C[8], y), _aj_ = caml_call2(Srcs[5], _ai_, _ah_), _ak_ = caml_call1(C[8], x);
            return caml_call2(Srcs[5], _ak_, _aj_);
        }
        function update(step, self1) {
            caml_call2(C[15], step, x);
            caml_call2(C[15], step, y);
            caml_call2(C[15], step, z);
            var _Z_ = caml_call1(C[9], x);
            if (_Z_) var ___ = _Z_;
            else var _ag_ = caml_call1(C[9], y), ___ = _ag_ || caml_call1(C[9], z);
            if (___) {
                var _$_ = srcs_union(x, y, z);
                caml_call2(C[10], self1, _$_);
            }
            var _aa_ = caml_call1(C[13], x);
            if (_aa_) var _ab_ = _aa_;
            else var _af_ = caml_call1(C[13], y), _ab_ = _af_ || caml_call1(C[13], z);
            if (!_ab_) return _ab_;
            var _ac_ = caml_call1(C[12], z), _ad_ = caml_call1(C[12], y), _ae_ = caml_call3(f, caml_call1(C[12], x), _ad_, _ac_);
            return caml_call2(C[14], self1, _ae_);
        }
        var _U_ = caml_call1(C[8], x), step = caml_call2(Src[9], nil, _U_), _V_ = caml_call1(C[8], y), step$0 = caml_call2(Src[9], step, _V_), _W_ = caml_call1(C[8], z), step$1 = caml_call2(Src[9], step$0, _W_);
        caml_call2(C[15], step$1, x);
        caml_call2(C[15], step$1, y);
        caml_call2(C[15], step$1, z);
        var srcs = srcs_union(x, y, z), _X_ = caml_call1(C[12], z), _Y_ = caml_call1(C[12], y), init = caml_call3(f, caml_call1(C[12], x), _Y_, _X_);
        return caml_call5(C[1], eq, step$1, srcs, init, update);
    }
    function eq$1(_T_1, _S_) {
        return _T_1 === _S_ ? 1 : 0;
    }
    var false$0 = caml_call2(const$2, 0, 0), true$0 = caml_call2(const$2, 0, 1);
    function not(s) {
        return map$1([
            0,
            eq$1
        ], function(_R_) {
            return 1 - _R_;
        }, s);
    }
    function _b_(_P_, _O_) {
        var _Q_ = _P_ ? _O_ : _P_;
        return _Q_;
    }
    var _c_ = 0;
    function symbol(_M_, _N_) {
        return l2(_c_, _b_, _M_, _N_);
    }
    function _d_(_K_, _J_) {
        var _L_ = _K_ || _J_;
        return _L_;
    }
    var _e_ = 0, _f_ = [
        0,
        0
    ];
    function symbol$0(_H_, _I_) {
        return l2(_e_, _d_, _H_, _I_);
    }
    function edge(s) {
        return changes(s);
    }
    function edge_detect(edge, s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _E_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _E_);
            }
            var _F_ = caml_call1(C[13], s), _G_ = _F_ ? caml_equal(caml_call1(C[12], s), edge) : _F_;
            return _G_ ? caml_call3(C[21], step, self1, _f_) : _G_;
        }
        var _C_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _C_);
        caml_call2(C[15], step, s);
        var _D_ = caml_call1(C[8], s);
        return caml_call4(C[19], step, _D_, 0, update);
    }
    function rise(s) {
        return edge_detect(1, s);
    }
    function fall(s) {
        return edge_detect(0, s);
    }
    function flip(init, e) {
        function update(step, self1) {
            caml_call2(C[15], step, e);
            if (caml_call1(C[9], e)) {
                var _A_ = caml_call1(C[8], e);
                caml_call2(C[10], self1, _A_);
            }
            if (!caml_call1(C[12], e)) return 0;
            var _B_ = 1 - caml_call1(C[12], self1);
            return caml_call2(C[14], self1, _B_);
        }
        var _y_ = caml_call1(C[8], e), step = caml_call2(Src[9], nil, _y_);
        caml_call2(C[15], step, e);
        var init$0 = caml_call1(C[12], e) ? 1 - init : init, _z_ = caml_call1(C[8], e);
        return caml_call5(C[1], [
            0,
            eq$1
        ], step, _z_, init$0, update);
    }
    function eq$2(eq) {
        return function(v0, v1) {
            if (v0) {
                if (v1) {
                    var v1$0 = v1[1], v0$0 = v0[1];
                    return caml_call2(eq, v0$0, v1$0);
                }
            } else if (!v1) return 1;
            return 0;
        };
    }
    var none = caml_call2(const$2, 0, 0), cst_option_is_None$0 = cst_option_is_None$1;
    function some$0(s) {
        return map$1([
            0,
            eq$2(caml_call1(eq$0, s))
        ], function(v) {
            return [
                0,
                v
            ];
        }, s);
    }
    function hold_value(i, s) {
        function update(step, self1) {
            caml_call2(C[15], step, s);
            if (caml_call1(C[9], s)) {
                var _x_ = caml_call1(C[8], s);
                caml_call2(C[10], self1, _x_);
            }
            var match = caml_call1(C[12], s);
            if (!match) return 0;
            var v = match[1];
            return caml_call2(C[14], self1, v);
        }
        function eq(v$0, v) {
            return caml_call3(C[3], s, [
                0,
                v$0
            ], [
                0,
                v
            ]);
        }
        var _v_ = caml_call1(C[8], s), step = caml_call2(Src[9], nil, _v_);
        caml_call2(C[15], step, s);
        var match = caml_call1(C[12], s);
        if (match) var v = match[1], init = v;
        else var init = i;
        var _w_ = caml_call1(C[8], s);
        return caml_call5(C[1], [
            0,
            eq
        ], step, _w_, init, update);
    }
    function value$3(s, default$0) {
        function update(step, self1) {
            caml_call2(C[15], step, default$0);
            caml_call2(C[15], step, s);
            var _n_ = caml_call1(C[9], default$0), _o_ = _n_ || caml_call1(C[9], s);
            if (_o_) {
                var _p_ = caml_call1(C[8], s), _q_ = caml_call1(C[8], default$0), _r_ = caml_call2(Srcs[5], _q_, _p_);
                caml_call2(C[10], self1, _r_);
            }
            var _s_ = caml_call1(C[13], default$0), _t_ = _s_ || caml_call1(C[13], s);
            if (!_t_) return _t_;
            var match = caml_call1(C[12], s);
            if (match) {
                var v = match[1];
                return caml_call2(C[14], self1, v);
            }
            var _u_ = caml_call1(C[12], default$0);
            return caml_call2(C[14], self1, _u_);
        }
        var _i_ = caml_call1(C[8], default$0), step = caml_call2(Src[9], nil, _i_), _j_ = caml_call1(C[8], s), step$0 = caml_call2(Src[9], step, _j_);
        caml_call2(C[15], step$0, default$0);
        caml_call2(C[15], step$0, s);
        var match = caml_call1(C[12], s);
        if (match) var v = match[1], init = v;
        else var init = caml_call1(C[12], default$0);
        var _k_ = caml_call1(C[8], s), _l_ = caml_call1(C[8], default$0), srcs = caml_call2(Srcs[5], _l_, _k_), _m_ = [
            0,
            caml_call1(eq$0, default$0)
        ];
        return caml_call5(C[1], _m_, step$0, srcs, init, update);
    }
    function get$0(eq, s) {
        return map$1(eq, function(param) {
            if (!param) return caml_call1(Stdlib[1], cst_option_is_None$0);
            var v = param[1];
            return v;
        }, s);
    }
    function bind$2(eq, s, f) {
        return map$1(eq, function(param) {
            if (!param) return 0;
            var v = param[1];
            return caml_call1(f, v);
        }, s);
    }
    function join$2(eq, s) {
        return map$1(eq, function(param) {
            if (param) {
                var o = param[1];
                if (o) return o;
            }
            return 0;
        }, s);
    }
    function is_none$0(s) {
        return map$1([
            0,
            eq$1
        ], function(param) {
            return param ? 0 : 1;
        }, s);
    }
    function is_some$0(s) {
        return map$1([
            0,
            eq$1
        ], function(param) {
            return param ? 1 : 0;
        }, s);
    }
    function map$2(eq, f, s) {
        return map$1(eq, function(param) {
            if (!param) return 0;
            var v = param[1];
            return [
                0,
                caml_call1(f, v)
            ];
        }, s);
    }
    function fst$0(eq, s) {
        return map$1(eq, function(_h_) {
            return _h_[1];
        }, s);
    }
    function snd$0(eq, s) {
        return map$1(eq, function(_g_) {
            return _g_[2];
        }, s);
    }
    function v$0(s0, s1) {
        return l2(0, function(x, y) {
            return [
                0,
                x,
                y
            ];
        }, s0, s1);
    }
    var Pair$0 = [
        0,
        fst$0,
        snd$0,
        v$0
    ], dump_src_ids$1 = C[25], Note = [
        0,
        [
            0,
            create$0,
            execute
        ],
        [
            0,
            Logr[1],
            Logr[3],
            Logr[4],
            Logr[5],
            Logr[7],
            Logr[8],
            Logr[10],
            Logr[11],
            Logr[12]
        ],
        [
            0,
            obs,
            log,
            create$4,
            value$0,
            never,
            bind,
            join,
            swap,
            map,
            stamp$0,
            filter,
            filter_map,
            select,
            accum,
            until,
            follow,
            defer$0,
            fix$0,
            [
                0,
                on_some,
                some,
                value$1,
                get,
                bind$0,
                join$0,
                map$0,
                is_none,
                is_some
            ],
            Pair,
            dump_src_ids$0
        ],
        [
            0,
            obs$0,
            log$0,
            create$5,
            eq$0,
            with_eq$0,
            value$2,
            rough_value,
            const$2,
            hold$0,
            bind$1,
            join$1,
            swap$0,
            changes,
            map$1,
            app$0,
            sample,
            sample_filter,
            snapshot,
            accum$0,
            until$0,
            follow$0,
            defer$1,
            delay$0,
            fix$1,
            l1,
            l2,
            l3,
            [
                0,
                false$0,
                true$0,
                not,
                symbol,
                symbol$0,
                edge,
                rise,
                fall,
                flip
            ],
            [
                0,
                eq$2,
                hold_value,
                none,
                some$0,
                value$3,
                get$0,
                bind$2,
                join$2,
                map$2,
                is_none$0,
                is_some$0
            ],
            Pair$0,
            dump_src_ids$1
        ]
    ];
    runtime.caml_register_global(21, Note, "Note");
    return;
})(globalThis);
//# 5 "../.js/default/note.brr/note_brr.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_brr_add$1 = "brr_add", cst_brr_rem$1 = "brr_rem", cst_length$3 = "length", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst = "*", cst_brr_rem = cst_brr_rem$1, Note = global_data.Note, Brr = global_data.Brr, Jv = global_data.Jv, Stdlib_List = global_data.Stdlib__List, Jstr = global_data.Jstr, Assert_failure = global_data.Assert_failure, Fut = global_data.Fut, _a_ = [
        0,
        "src/brr/note_brr.ml",
        23,
        16
    ], _b_ = [
        0,
        1
    ];
    function to_event(f) {
        var match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function send_e$0(v) {
            caml_call1(caml_call1(Brr[16][8], 0), function(param) {
                return caml_call2(send_e, 0, v);
            });
            return 0;
        }
        caml_call2(Fut[2], f, send_e$0);
        return e;
    }
    function of_event(e) {
        var match = caml_call1(Fut[1], 0), set_fut = match[2], fut = match[1], logr = [
            0,
            0
        ];
        function set_fut$0(v) {
            caml_call1(caml_call1(Brr[16][8], 0), function(param) {
                var match = logr[1];
                if (!match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
                var logr$0 = match[1];
                caml_call1(Note[2][6], logr$0);
                return caml_call1(set_fut, v);
            });
            return 0;
        }
        var s = caml_call3(Note[3][2], _b_, e, set_fut$0);
        return s ? (logr[1] = s, [
            0,
            fut
        ]) : 0;
    }
    var Futr = [
        0,
        to_event,
        of_event
    ];
    function tick(param) {
        return [
            0,
            "tick",
            0
        ];
    }
    function log_value(_x_, opt, id, x) {
        var l = _x_ ? _x_[1] : Brr[12][14], v = opt ? opt[1] : function(v) {
            return [
                0,
                v,
                0
            ];
        }, _y_ = caml_call1(v, x);
        caml_call1(l, [
            0,
            caml_call2(Jstr[8], runtime.caml_jsstring_of_string(id), ":"),
            _y_
        ]);
        return x;
    }
    function log(opt, l, v, id, e) {
        var obs = opt ? opt[1] : 0;
        if (!obs) return caml_call2(Note[3][9], function(_w_) {
            return log_value(l, v, id, _w_);
        }, e);
        var _v_ = caml_call3(Note[3][2], 0, e, function(ev) {
            log_value(l, v, id, ev);
            return 0;
        });
        caml_call1(Note[2][8], _v_);
        return e;
    }
    var E = [
        0,
        log
    ];
    function log$0(opt, l, v, id, s) {
        var obs = opt ? opt[1] : 0;
        if (obs) {
            var _s_ = caml_call3(Note[4][2], 0, s, function(sv) {
                log_value(l, v, id, sv);
                return 0;
            });
            caml_call1(Note[2][7], _s_);
            return s;
        }
        var _t_ = [
            0,
            caml_call1(Note[4][4], s)
        ];
        return caml_call3(Note[4][14], _t_, function(_u_) {
            return log_value(l, v, id, _u_);
        }, s);
    }
    var S = [
        0,
        log$0
    ], Consoler = [
        0,
        tick,
        log_value,
        E,
        S
    ], cst_length = cst_length$3, cst_length$0 = cst_length$3, cst_length$1 = cst_length$3, cst_length$2 = cst_length$3, cst_brr_rem$0 = cst_brr_rem$1, cst_brr_add$0 = cst_brr_add$1;
    function instruct(_r_, opt, e) {
        var propagate = _r_ ? _r_[1] : 1, default$0 = opt ? opt[1] : 1;
        if (!default$0) caml_call1(Brr[7][13], e);
        return propagate ? 0 : caml_call1(Brr[7][10], e);
    }
    function endless_listen(opt, propagate, default$0, t, type, f) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0;
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call1(f, ev);
        }
        caml_call4(Brr[7][20], opts, type, f$0, t);
        return 0;
    }
    function on_target(opt, propagate, default$0, type, f, t) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call1(f, ev));
        }
        caml_call4(Brr[7][20], opts, type, f$0, t);
        return e;
    }
    function on_targets(opt, propagate, default$0, type, f, ts) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call2(f, caml_call1(Brr[7][5], ev), ev));
        }
        caml_call2(Stdlib_List[18], function(t) {
            caml_call4(Brr[7][20], opts, type, f$0, t);
            return 0;
        }, ts);
        return e;
    }
    function on_el(capture, propagate, default$0, type, f, el) {
        return on_target(capture, propagate, default$0, type, f, el);
    }
    function on_els(opt, propagate, default$0, type, f, els) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0, match = caml_call1(Note[3][3], 0), send_e = match[2], e = match[1];
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call2(send_e, 0, caml_call2(f, caml_call1(Brr[7][5], ev), ev));
        }
        caml_call2(Stdlib_List[18], function(el) {
            caml_call4(Brr[7][20], opts, type, f$0, el);
            return 0;
        }, els);
        return e;
    }
    function unit(e) {
        return 0;
    }
    function stamp(v, e) {
        return v;
    }
    function listen(opt, propagate, default$0, t, type, f) {
        var capture = opt ? opt[1] : 0, opts = capture ? [
            0,
            caml_call4(Brr[7][19], [
                0,
                capture
            ], 0, 0, 0)
        ] : 0;
        function f$0(ev) {
            instruct(propagate, default$0, ev);
            return caml_call1(f, ev);
        }
        var k = caml_call4(Brr[7][20], opts, type, f$0, t);
        return function(param) {
            return caml_call1(Brr[7][21], k);
        };
    }
    function add_xxx_fun(xxx, f, e) {
        var fs = e[xxx], fs$0 = caml_call1(Jv[7], fs) ? [
            0,
            f,
            0
        ] : [
            0,
            f,
            fs
        ];
        return e[xxx] = fs$0;
    }
    function invoke_funs(xxx, node) {
        var star = caml_call1(Jv[24], cst);
        if (!caml_call1(Brr[9][7], node)) return;
        function invoke_node_funs(n) {
            var funs = n[xxx];
            caml_call2(Stdlib_List[18], function(f) {
                return caml_call1(f, 0);
            }, funs);
            n[xxx] = 0;
        }
        var ns = node.querySelectorAll(star), _p_ = caml_call2(Jv[20][2], ns, cst_length) - 1 | 0, _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                var n = ns.item(i);
                invoke_node_funs(n);
                var _q_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _q_;
            }
        }
        return invoke_node_funs(node);
    }
    function obs(records, obs) {
        function in_html_dom(n) {
            var _n_ = Brr[16][2];
            return n.getRootNode() === _n_ ? 1 : 0;
        }
        var _f_ = caml_call2(Jv[20][2], records, cst_length$0) - 1 | 0, _e_ = 0;
        if (_f_ >= 0) {
            var i = _e_;
            for(;;){
                var r = records[i], adds = r.addedNodes, _h_ = caml_call2(Jv[20][2], adds, cst_length$1) - 1 | 0, _g_ = 0;
                if (_h_ >= 0) {
                    var i$1 = _g_;
                    for(;;){
                        var n$0 = adds.item(i$1);
                        if (in_html_dom(n$0)) invoke_funs(cst_brr_add$0, n$0);
                        var _m_ = i$1 + 1 | 0;
                        if (_h_ === i$1) break;
                        i$1 = _m_;
                    }
                }
                var rems = r.removedNodes, _j_ = caml_call2(Jv[20][2], rems, cst_length$2) - 1 | 0, _i_ = 0;
                if (_j_ >= 0) {
                    var i$0 = _i_;
                    for(;;){
                        var n = rems.item(i$0);
                        if (1 - in_html_dom(n)) invoke_funs(cst_brr_rem$0, n);
                        var _l_ = i$0 + 1 | 0;
                        if (_j_ === i$0) break;
                        i$0 = _l_;
                    }
                }
                var _k_ = i + 1 | 0;
                if (_f_ === i) break;
                i = _k_;
            }
        }
        return 0;
    }
    var mutation_observer = Jv[12].MutationObserver;
    a: {
        var cst_brr_add = cst_brr_add$1;
        if (!caml_call1(Jv[8], mutation_observer) && !caml_call1(Jv[8], Brr[16][2])) {
            var obs$0 = new mutation_observer(runtime.caml_js_wrap_callback_strict(2, obs)), opts = {
                childList: Jv[17],
                subtree: Jv[17]
            }, root = caml_call1(Brr[10][4], Brr[16][2]);
            obs$0.observe(root, opts);
            break a;
        }
    }
    function add_logr(e, l) {
        return add_xxx_fun(cst_brr_rem, function(param) {
            return caml_call1(Note[2][6], l);
        }, e);
    }
    function may_add_logr(e, param) {
        if (!param) return 0;
        var l = param[1];
        return add_logr(e, l);
    }
    function set_children(e, on) {
        var _d_ = caml_call1(Brr[9][18], e);
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, _d_));
    }
    function def_children(e, cs) {
        var _c_ = caml_call1(Brr[9][18], e);
        return add_logr(e, caml_call3(Note[4][2], 0, cs, _c_));
    }
    function set_at(a, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][26], a, v, e);
        }));
    }
    function def_at(a, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call3(Brr[9][26], a, v, e);
        }));
    }
    function set_class(c, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][31], c, v, e);
        }));
    }
    function def_class(c, bs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, bs, function(v) {
            return caml_call3(Brr[9][31], c, v, e);
        }));
    }
    function set_prop(p, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call3(Brr[9][29], p, v, e);
        }));
    }
    function def_prop(p, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call3(Brr[9][29], p, v, e);
        }));
    }
    function set_inline_style(important, p, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call4(Brr[9][35], important, p, v, e);
        }));
    }
    function def_inline_style(important, p, vs, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, vs, function(v) {
            return caml_call4(Brr[9][35], important, p, v, e);
        }));
    }
    function set_has_focus(on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call2(Brr[9][51], v, e);
        }));
    }
    function def_has_focus(b, e) {
        return add_logr(e, caml_call3(Note[4][2], 0, b, function(v) {
            return caml_call2(Brr[9][51], v, e);
        }));
    }
    function on_add(f, e) {
        return add_xxx_fun(cst_brr_add, f, e);
    }
    function on_rem(f, e) {
        return add_xxx_fun(cst_brr_rem, f, e);
    }
    function call(f, on, e) {
        return may_add_logr(e, caml_call3(Note[3][2], 0, on, function(v) {
            return caml_call2(f, v, e);
        }));
    }
    function hold_logr(e, l) {
        return add_logr(e, l);
    }
    function may_hold_logr(e, l) {
        return may_add_logr(e, l);
    }
    var Note_brr = [
        0,
        Futr,
        Consoler,
        [
            0,
            on_target,
            on_targets,
            on_el,
            on_els,
            unit,
            stamp,
            instruct,
            listen,
            endless_listen
        ],
        [
            0,
            set_children,
            def_children,
            set_at,
            def_at,
            set_prop,
            def_prop,
            set_class,
            def_class,
            set_inline_style,
            def_inline_style,
            set_has_focus,
            def_has_focus,
            on_add,
            on_rem,
            call,
            hold_logr,
            may_hold_logr
        ]
    ];
    runtime.caml_register_global(33, Note_brr, "Note_brr");
    return;
})(globalThis);
//# 4 "../.js/default/ppx_inline_test.config/inline_test_config.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function pre_test_hook(_a_) {
        return 0;
    }
    var Inline_test_config = [
        0,
        pre_test_hook
    ];
    runtime.caml_register_global(0, Inline_test_config, "Inline_test_config");
    return;
})(globalThis);
//# 4 "../.js/default/base.base_internalhash_types/base_internalhash_types.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_internalhash_types = [
        0
    ];
    runtime.caml_register_global(0, Base_internalhash_types, "Base_internalhash_types");
    return;
})(globalThis);
//# 18 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$11 = "(", cst$12 = "()", cst$13 = ")", caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_string_unsafe_get = runtime.caml_string_unsafe_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$2 = cst$11, cst$3 = cst$12, cst$4 = cst$13, cst$5 = " ", cst$6 = cst$11, cst$7 = cst$12, cst$8 = cst$13, cst$10 = cst$12, cst$9 = cst$12, cst = "\\", cst$0 = ' "', cst$1 = '"', Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_Format = global_data.Stdlib__Format, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Stdlib_Char = global_data.Stdlib__Char, Stdlib_Bytes = global_data.Stdlib__Bytes;
    function sexp_of_t(t) {
        return t;
    }
    function t_of_sexp(t) {
        return t;
    }
    function compare(a$0, b$0) {
        if (a$0 === b$0) return 0;
        if (0 === a$0[0]) {
            var a$1 = a$0[1];
            if (0 !== b$0[0]) return -1;
            var b$1 = b$0[1];
            return caml_call2(Stdlib_StringLabels[10], a$1, b$1);
        }
        var a$2 = a$0[1];
        if (0 === b$0[0]) return 1;
        var b$2 = b$0[1], a = a$2, b = b$2;
        for(;;){
            if (!a) return b ? -1 : 0;
            if (!b) return 1;
            var ys = b[2], y = b[1], xs = a[2], x = a[1], res = compare(x, y);
            if (0 !== res) return res;
            a = xs;
            b = ys;
        }
    }
    function equal(a, b) {
        var _D_ = a === b ? 1 : 0;
        if (_D_) var _E_ = _D_;
        else {
            if (0 === a[0]) {
                var a$0 = a[1];
                if (0 === b[0]) {
                    var b$0 = b[1];
                    return caml_call2(Stdlib_StringLabels[9], a$0, b$0);
                }
            } else {
                var a$1 = a[1];
                if (0 !== b[0]) {
                    var b$1 = b[1];
                    return caml_call3(Stdlib_ListLabels[16], equal, a$1, b$1);
                }
            }
            var _E_ = 0;
        }
        return _E_;
    }
    var Not_found_s = [
        248,
        "Sexplib0__Sexp.Not_found_s",
        caml_fresh_oo_id(0)
    ], Of_sexp_error = [
        248,
        "Sexplib0__Sexp.Of_sexp_error",
        caml_fresh_oo_id(0)
    ], default_indent = [
        0,
        1
    ], cst_n = "\\n", _a_ = [
        0,
        0,
        0
    ], _b_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        "%a@?"
    ];
    function must_escape(str) {
        var len = caml_ml_string_length(str), _t_ = 0 === len ? 1 : 0;
        if (_t_) return _t_;
        var ix$1 = len - 1 | 0, ix = ix$1;
        for(;;){
            var match = caml_string_get(str, ix);
            a: {
                b: {
                    if (92 <= match) {
                        var switcher = match - 93 | 0;
                        if (33 < switcher >>> 0) {
                            if (0 <= switcher) break a;
                            break b;
                        }
                        if (31 === switcher) {
                            var _u_ = 0 < ix ? 1 : 0;
                            if (_u_) {
                                var next = ix - 1 | 0, _v_ = caml_string_get(str, next), _w_ = caml_call2(Stdlib_Char[6], _v_, 35);
                                if (!_w_) {
                                    ix = next;
                                    continue;
                                }
                                var _x_ = _w_;
                            } else var _x_ = _u_;
                            return _x_;
                        }
                    } else if (42 <= match) {
                        if (59 === match) break b;
                    } else {
                        if (33 > match) break a;
                        switch(match - 33 | 0){
                            case 2:
                                var _z_ = 0 < ix ? 1 : 0;
                                if (_z_) {
                                    var next$0 = ix - 1 | 0, _A_ = caml_string_get(str, next$0), _B_ = caml_call2(Stdlib_Char[6], _A_, 124);
                                    if (!_B_) {
                                        ix = next$0;
                                        continue;
                                    }
                                    var _C_ = _B_;
                                } else var _C_ = _z_;
                                return _C_;
                            case 1:
                            case 7:
                            case 8:
                                break b;
                        }
                    }
                    var _y_ = 0 < ix ? 1 : 0;
                    if (!_y_) return _y_;
                    var ix$0 = ix - 1 | 0;
                    ix = ix$0;
                    continue;
                }
                return 1;
            }
            return 1;
        }
    }
    function escaped(s) {
        var n = [
            0,
            0
        ], _j_ = caml_ml_string_length(s) - 1 | 0, _i_ = 0;
        if (_j_ >= 0) {
            var i$0 = _i_;
            for(;;){
                var match = caml_string_unsafe_get(s, i$0);
                a: {
                    b: {
                        c: {
                            if (32 <= match) {
                                var _q_ = match - 34 | 0;
                                if (58 < _q_ >>> 0) {
                                    if (93 <= _q_) break c;
                                } else if (56 < _q_ - 1 >>> 0) break b;
                                var _r_ = 1;
                                break a;
                            }
                            if (11 <= match) {
                                if (13 === match) break b;
                            } else if (8 <= match) break b;
                        }
                        var _r_ = 4;
                        break a;
                    }
                    var _r_ = 2;
                }
                n[1] = n[1] + _r_ | 0;
                var _s_ = i$0 + 1 | 0;
                if (_j_ === i$0) break;
                i$0 = _s_;
            }
        }
        if (n[1] === caml_ml_string_length(s)) return s;
        var s$0 = caml_create_bytes(n[1]);
        n[1] = 0;
        var _l_ = caml_ml_string_length(s) - 1 | 0, _k_ = 0;
        if (_l_ >= 0) {
            var i = _k_;
            for(;;){
                var c = caml_string_unsafe_get(s, i);
                a: {
                    b: {
                        c: {
                            if (35 <= c) {
                                if (92 !== c) {
                                    if (127 <= c) break c;
                                    break b;
                                }
                            } else {
                                if (32 > c) {
                                    if (14 <= c) break c;
                                    switch(c){
                                        case 8:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 98);
                                            break a;
                                        case 9:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 116);
                                            break a;
                                        case 10:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 110);
                                            break a;
                                        case 13:
                                            caml_bytes_unsafe_set(s$0, n[1], 92);
                                            n[1]++;
                                            caml_bytes_unsafe_set(s$0, n[1], 114);
                                            break a;
                                        default:
                                            break c;
                                    }
                                }
                                if (34 > c) break b;
                            }
                            caml_bytes_unsafe_set(s$0, n[1], 92);
                            n[1]++;
                            caml_bytes_unsafe_set(s$0, n[1], c);
                            break a;
                        }
                        caml_bytes_unsafe_set(s$0, n[1], 92);
                        n[1]++;
                        var _n_ = caml_call1(Stdlib_Char[1], 48 + (c / 100 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _n_);
                        n[1]++;
                        var _o_ = caml_call1(Stdlib_Char[1], 48 + ((c / 10 | 0) % 10 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _o_);
                        n[1]++;
                        var _p_ = caml_call1(Stdlib_Char[1], 48 + (c % 10 | 0) | 0);
                        caml_bytes_unsafe_set(s$0, n[1], _p_);
                        break a;
                    }
                    caml_bytes_unsafe_set(s$0, n[1], c);
                }
                n[1]++;
                var _m_ = i + 1 | 0;
                if (_l_ === i) break;
                i = _m_;
            }
        }
        return caml_call1(Stdlib_BytesLabels[44], s$0);
    }
    function esc_str(str) {
        var estr = escaped(str), elen = caml_ml_string_length(estr), res = caml_create_bytes(elen + 2 | 0);
        caml_call5(Stdlib_Bytes[12], estr, 0, res, 1, elen);
        caml_bytes_unsafe_set(res, 0, 34);
        caml_bytes_unsafe_set(res, elen + 1 | 0, 34);
        return caml_call1(Stdlib_BytesLabels[44], res);
    }
    function index_of_newline(str, start) {
        return caml_call3(Stdlib_StringLabels[33], str, start, 10);
    }
    function mach_maybe_esc_str(str) {
        return must_escape(str) ? esc_str(str) : str;
    }
    function pp_hum_indent(indent, ppf, param) {
        if (0 === param[0]) {
            var str = param[1];
            if (!must_escape(str)) return caml_call2(Stdlib_Format[13], ppf, str);
            var match = index_of_newline(str, 0);
            if (match) var index = match[1], _f_ = (index + 1 | 0) === caml_ml_string_length(str) ? 1 : 0;
            else var _f_ = 1;
            if (_f_) {
                var _g_ = esc_str(str);
                return caml_call2(Stdlib_Format[13], ppf, _g_);
            }
            caml_call2(Stdlib_Format[1], ppf, 0);
            caml_call2(Stdlib_Format[13], ppf, cst$0);
            var index$0 = 0;
            for(;;){
                var next_newline = index_of_newline(str, index$0);
                if (next_newline) var end_pos = next_newline[1], end_pos$0 = end_pos;
                else var end_pos$0 = caml_ml_string_length(str);
                var next_line = caml_call3(Stdlib_StringLabels[16], str, index$0, end_pos$0 - index$0 | 0), _h_ = escaped(next_line);
                caml_call2(Stdlib_Format[13], ppf, _h_);
                if (!next_newline) {
                    caml_call2(Stdlib_Format[13], ppf, cst$1);
                    return caml_call2(Stdlib_Format[3], ppf, 0);
                }
                var newline_index = next_newline[1];
                caml_call2(Stdlib_Format[13], ppf, cst);
                caml_call2(Stdlib_Format[39], ppf, 0);
                caml_call2(Stdlib_Format[13], ppf, cst_n);
                var index$1 = newline_index + 1 | 0;
                index$0 = index$1;
            }
        } else {
            var match$0 = param[1];
            if (!match$0) return caml_call2(Stdlib_Format[13], ppf, cst$3);
            var t = match$0[2], h = match$0[1];
            caml_call2(Stdlib_Format[1], ppf, indent);
            caml_call2(Stdlib_Format[13], ppf, cst$2);
            pp_hum_indent(indent, ppf, h);
            var param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(Stdlib_Format[13], ppf, cst$4);
                    return caml_call2(Stdlib_Format[3], ppf, 0);
                }
                var t$0 = param$0[2], h$0 = param$0[1];
                caml_call2(Stdlib_Format[32], ppf, 0);
                pp_hum_indent(indent, ppf, h$0);
                param$0 = t$0;
            }
        }
    }
    function pp_mach_internal(may_need_space, ppf, param) {
        if (0 === param[0]) {
            var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
            if (new_may_need_space$0) caml_call2(Stdlib_Format[13], ppf, cst$5);
            caml_call2(Stdlib_Format[13], ppf, str$0);
            return new_may_need_space;
        }
        var match = param[1];
        if (!match) {
            caml_call2(Stdlib_Format[13], ppf, cst$7);
            return 0;
        }
        var t = match[2], h = match[1];
        caml_call2(Stdlib_Format[13], ppf, cst$6);
        var may_need_space$0 = pp_mach_internal(0, ppf, h), may_need_space$1 = may_need_space$0, param$0 = t;
        for(;;){
            if (!param$0) {
                caml_call2(Stdlib_Format[13], ppf, cst$8);
                return 0;
            }
            var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = pp_mach_internal(may_need_space$1, ppf, h$0);
            may_need_space$1 = may_need_space$2;
            param$0 = t$0;
        }
    }
    function pp_hum(ppf, sexp) {
        return pp_hum_indent(default_indent[1], ppf, sexp);
    }
    function pp_mach(ppf, sexp) {
        pp_mach_internal(0, ppf, sexp);
        return 0;
    }
    function size_loop(acc, param) {
        var c = acc[2], v = acc[1];
        if (0 === param[0]) {
            var str = param[1];
            return [
                0,
                v + 1 | 0,
                c + caml_ml_string_length(str) | 0
            ];
        }
        var lst = param[1];
        return caml_call3(Stdlib_ListLabels[26], size_loop, acc, lst);
    }
    function size(sexp) {
        return size_loop(_a_, sexp);
    }
    function to_buffer_hum(buf, opt, sexp) {
        var indent = opt ? opt[1] : default_indent[1], ppf = caml_call1(Stdlib_Format[120], buf);
        return caml_call4(Stdlib_Format[143], ppf, _b_, function(_d_, _e_) {
            return pp_hum_indent(indent, _d_, _e_);
        }, sexp);
    }
    function to_buffer_mach(buf, sexp) {
        function loop(may_need_space, param) {
            if (0 === param[0]) {
                var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
                if (new_may_need_space$0) caml_call2(Stdlib_Buffer[12], buf, 32);
                caml_call2(Stdlib_Buffer[16], buf, str$0);
                return new_may_need_space;
            }
            var match = param[1];
            if (!match) {
                caml_call2(Stdlib_Buffer[16], buf, cst$9);
                return 0;
            }
            var t = match[2], h = match[1];
            caml_call2(Stdlib_Buffer[12], buf, 40);
            var may_need_space$0 = loop(0, h), may_need_space$1 = may_need_space$0, param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(Stdlib_Buffer[12], buf, 41);
                    return 0;
                }
                var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = loop(may_need_space$1, h$0);
                may_need_space$1 = may_need_space$2;
                param$0 = t$0;
            }
        }
        loop(0, sexp);
        return 0;
    }
    function to_buffer_gen(buf, add_char, add_string, sexp) {
        function loop(may_need_space, param) {
            if (0 === param[0]) {
                var str = param[1], str$0 = mach_maybe_esc_str(str), new_may_need_space = str$0 === str ? 1 : 0, new_may_need_space$0 = may_need_space ? new_may_need_space : may_need_space;
                if (new_may_need_space$0) caml_call2(add_char, buf, 32);
                caml_call2(add_string, buf, str$0);
                return new_may_need_space;
            }
            var match = param[1];
            if (!match) {
                caml_call2(add_string, buf, cst$10);
                return 0;
            }
            var t = match[2], h = match[1];
            caml_call2(add_char, buf, 40);
            var may_need_space$0 = loop(0, h), may_need_space$1 = may_need_space$0, param$0 = t;
            for(;;){
                if (!param$0) {
                    caml_call2(add_char, buf, 41);
                    return 0;
                }
                var t$0 = param$0[2], h$0 = param$0[1], may_need_space$2 = loop(may_need_space$1, h$0);
                may_need_space$1 = may_need_space$2;
                param$0 = t$0;
            }
        }
        loop(0, sexp);
        return 0;
    }
    function buffer(param) {
        return caml_call1(Stdlib_Buffer[1], 1024);
    }
    function to_string_hum(indent, sexp) {
        if (0 === sexp[0]) {
            var str = sexp[1], _c_ = index_of_newline(str, 0) ? 0 : 1;
            if (_c_) return mach_maybe_esc_str(str);
        }
        var buf = buffer(0);
        to_buffer_hum(buf, indent, sexp);
        return caml_call1(Stdlib_Buffer[2], buf);
    }
    function to_string_mach(sexp) {
        if (0 === sexp[0]) {
            var str = sexp[1];
            return mach_maybe_esc_str(str);
        }
        var buf = buffer(0);
        to_buffer_mach(buf, sexp);
        return caml_call1(Stdlib_Buffer[2], buf);
    }
    var of_float_style = [
        0,
        1009018843
    ], of_int_style = [
        0,
        1009018843
    ];
    function message(name, fields) {
        function conv_fields(param) {
            if (!param) return 0;
            var rest = param[2], match = param[1], fsexp = match[2], fname = match[1];
            return fname !== "" ? [
                0,
                [
                    1,
                    [
                        0,
                        [
                            0,
                            fname
                        ],
                        [
                            0,
                            fsexp,
                            0
                        ]
                    ]
                ],
                conv_fields(rest)
            ] : [
                0,
                fsexp,
                conv_fields(rest)
            ];
        }
        return [
            1,
            [
                0,
                [
                    0,
                    name
                ],
                conv_fields(fields)
            ]
        ];
    }
    var Sexplib0_Sexp = [
        0,
        t_of_sexp,
        sexp_of_t,
        equal,
        compare,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp_mach,
        to_string_hum,
        to_string_mach,
        to_string_mach,
        of_float_style,
        of_int_style,
        [
            0,
            size,
            buffer,
            to_buffer_mach,
            to_buffer_hum,
            to_buffer_mach,
            to_buffer_gen,
            mach_maybe_esc_str,
            must_escape,
            esc_str
        ]
    ];
    runtime.caml_register_global(25, Sexplib0_Sexp, "Sexplib0__Sexp");
    return;
})(globalThis);
//# 574 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, doc_comment_tag = "sexp_grammar.doc_comment", type_name_tag = "sexp_grammar.type_name", assoc_tag = "sexp_grammar.assoc", assoc_key_tag = "sexp_grammar.assoc.key", assoc_value_tag = "sexp_grammar.assoc.value", completion_suggested = "sexp_grammar.completion-suggested";
    function coerce(t) {
        return t;
    }
    function tag(param, key, value) {
        return [
            5,
            [
                0,
                key,
                value,
                param
            ]
        ];
    }
    var Sexplib0_Sexp_grammar = [
        0,
        coerce,
        tag,
        doc_comment_tag,
        type_name_tag,
        assoc_tag,
        assoc_key_tag,
        assoc_value_tag,
        completion_suggested
    ];
    runtime.caml_register_global(6, Sexplib0_Sexp_grammar, "Sexplib0__Sexp_grammar");
    return;
})(globalThis);
//# 605 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), unit_sexp_grammar = [
        2,
        0
    ], sexp_t_sexp_grammar = [
        0,
        "Sexp.t"
    ], empty_sexp_grammar = [
        4,
        0
    ], Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Stdlib_ListLabels = global_data.Stdlib__ListLabels;
    function sexp_grammar_with_tags(grammar, tags) {
        return caml_call3(Stdlib_ListLabels[27], function(param, grammar) {
            var value = param[2], key = param[1];
            return [
                5,
                [
                    0,
                    key,
                    value,
                    grammar
                ]
            ];
        }, tags, grammar);
    }
    function sexp_grammar_with_tag_list(x, tags) {
        return caml_call3(Stdlib_ListLabels[27], function(param, grammar) {
            var value = param[2], key = param[1];
            return [
                0,
                [
                    0,
                    key,
                    value,
                    grammar
                ]
            ];
        }, tags, x);
    }
    function ref_sexp_grammar(grammar) {
        return caml_call1(Sexplib0_Sexp_grammar[1], grammar);
    }
    function lazy_t_sexp_grammar(grammar) {
        return caml_call1(Sexplib0_Sexp_grammar[1], grammar);
    }
    function option_sexp_grammar(param) {
        return [
            1,
            param
        ];
    }
    function list_sexp_grammar(param) {
        return [
            2,
            [
                1,
                param
            ]
        ];
    }
    function array_sexp_grammar(param) {
        return [
            2,
            [
                1,
                param
            ]
        ];
    }
    var Sexplib0_Sexp_conv_grammar = [
        0,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        0,
        4,
        4,
        1,
        2,
        3,
        2,
        2,
        2,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        empty_sexp_grammar,
        empty_sexp_grammar
    ];
    runtime.caml_register_global(5, Sexplib0_Sexp_conv_grammar, "Sexplib0__Sexp_conv_grammar");
    return;
})(globalThis);
//# 686 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Assert_failure$0 = "Assert_failure", cst_None = "None", cst_Some = "Some", cst_none = "none", cst_option_of_sexp_only_none_c$1 = "option_of_sexp: only none can be atom", cst_some = "some", cst_src_sexp_conv_ml = "src/sexp_conv.ml", caml_check_bound = runtime.caml_check_bound, caml_float_of_string = runtime.caml_float_of_string, caml_format_float = runtime.caml_format_float, caml_int_of_string = runtime.caml_int_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Stdlib = global_data.Stdlib, Sexplib0_Sexp = global_data.Sexplib0__Sexp, Stdlib_Arg = global_data.Stdlib__Arg, Stdlib_Lazy = global_data.Stdlib__Lazy, Stdlib_Parsing = global_data.Stdlib__Parsing, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Scanf = global_data.Stdlib__Scanf, Stdlib_Stack = global_data.Stdlib__Stack, Stdlib_Sys = global_data.Stdlib__Sys, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_MoreLabels = global_data.Stdlib__MoreLabels, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Stdlib_Printexc = global_data.Stdlib__Printexc, Stdlib_Obj = global_data.Stdlib__Obj, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_Ephemeron = global_data.Stdlib__Ephemeron, Sexplib0_Sexp_conv_grammar = global_data.Sexplib0__Sexp_conv_grammar, default_string_of_float = [
        0,
        function(x) {
            var y = caml_format_float("%.15G", x);
            return caml_float_of_string(y) === x ? y : caml_format_float("%.17G", x);
        }
    ], read_old_option_format = [
        0,
        1
    ], write_old_option_format = [
        0,
        1
    ], _a_ = [
        1,
        0
    ], _b_ = [
        0,
        cst_some
    ], _c_ = [
        1,
        0
    ], _d_ = [
        0,
        cst_none
    ], _e_ = [
        0,
        "<opaque>"
    ], _f_ = [
        0,
        "<fun>"
    ];
    function list_map(f, l) {
        return caml_call2(Stdlib_ListLabels[20], f, l);
    }
    function sexp_of_unit(param) {
        return _a_;
    }
    function sexp_of_bool(b) {
        return [
            0,
            caml_call1(Stdlib[30], b)
        ];
    }
    function sexp_of_string(str) {
        return [
            0,
            str
        ];
    }
    function sexp_of_bytes(bytes) {
        return [
            0,
            caml_call1(Stdlib_BytesLabels[6], bytes)
        ];
    }
    function sexp_of_char(c) {
        return [
            0,
            caml_call2(Stdlib_StringLabels[1], 1, c)
        ];
    }
    function sexp_of_int(n) {
        return [
            0,
            caml_call1(Stdlib[33], n)
        ];
    }
    function sexp_of_float(n) {
        return [
            0,
            caml_call1(default_string_of_float[1], n)
        ];
    }
    function sexp_of_int32(n) {
        return [
            0,
            caml_call1(Stdlib_Int32[14], n)
        ];
    }
    function sexp_of_int64(n) {
        return [
            0,
            caml_call1(Stdlib_Int64[14], n)
        ];
    }
    function sexp_of_nativeint(n) {
        return [
            0,
            caml_call1(Stdlib_Nativeint[15], n)
        ];
    }
    function sexp_of_ref(sexp_of_a, rf) {
        return caml_call1(sexp_of_a, rf[1]);
    }
    function sexp_of_lazy_t(sexp_of_a, lv) {
        var _aJ_ = runtime.caml_obj_tag(lv);
        a: if (250 === _aJ_) var _aK_ = lv[1];
        else {
            if (246 !== _aJ_ && 244 !== _aJ_) {
                var _aK_ = lv;
                break a;
            }
            var _aK_ = caml_call1(CamlinternalLazy[2], lv);
        }
        return caml_call1(sexp_of_a, _aK_);
    }
    function sexp_of_option(sexp_of_a, param) {
        if (!param) return write_old_option_format[1] ? _c_ : _d_;
        var x = param[1];
        return write_old_option_format[1] ? [
            1,
            [
                0,
                caml_call1(sexp_of_a, x),
                0
            ]
        ] : [
            1,
            [
                0,
                _b_,
                [
                    0,
                    caml_call1(sexp_of_a, x),
                    0
                ]
            ]
        ];
    }
    function sexp_of_pair(sexp_of_a, sexp_of_b, param) {
        var b = param[2], a = param[1], _aI_ = [
            0,
            caml_call1(sexp_of_b, b),
            0
        ];
        return [
            1,
            [
                0,
                caml_call1(sexp_of_a, a),
                _aI_
            ]
        ];
    }
    function sexp_of_triple(sexp_of_a, sexp_of_b, sexp_of_c, param) {
        var c = param[3], b = param[2], a = param[1], _aG_ = [
            0,
            caml_call1(sexp_of_c, c),
            0
        ], _aH_ = [
            0,
            caml_call1(sexp_of_b, b),
            _aG_
        ];
        return [
            1,
            [
                0,
                caml_call1(sexp_of_a, a),
                _aH_
            ]
        ];
    }
    function sexp_of_list(sexp_of_a, lst) {
        return [
            1,
            caml_call2(Stdlib_ListLabels[20], sexp_of_a, lst)
        ];
    }
    function sexp_of_array(sexp_of_a, ar) {
        var lst_ref = [
            0,
            0
        ], _aD_ = ar.length - 2 | 0;
        if (_aD_ >= 0) {
            var i = _aD_;
            for(;;){
                var _aE_ = lst_ref[1];
                lst_ref[1] = [
                    0,
                    caml_call1(sexp_of_a, caml_check_bound(ar, i)[1 + i]),
                    _aE_
                ];
                var _aF_ = i - 1 | 0;
                if (0 === i) break;
                i = _aF_;
            }
        }
        return [
            1,
            lst_ref[1]
        ];
    }
    function sexp_of_hashtbl(sexp_of_key, sexp_of_val, htbl) {
        function coll(k, v, acc) {
            var _aC_ = [
                0,
                caml_call1(sexp_of_val, v),
                0
            ];
            return [
                0,
                [
                    1,
                    [
                        0,
                        caml_call1(sexp_of_key, k),
                        _aC_
                    ]
                ],
                acc
            ];
        }
        return [
            1,
            caml_call3(Stdlib_MoreLabels[1][14], coll, htbl, 0)
        ];
    }
    function sexp_of_opaque(param) {
        return _e_;
    }
    function sexp_of_fun(param) {
        return _f_;
    }
    function equal(_aB_, _aA_) {
        return _aB_ === _aA_ ? 1 : 0;
    }
    var hash = Stdlib_Obj[22][3], Exn_table = caml_call1(Stdlib_Ephemeron[1][3], [
        0,
        equal,
        hash
    ]), the_exn_table = caml_call1(Exn_table[1], 17);
    function add(opt, param, extension_constructor, sexp_of_exn) {
        var printexc = opt ? opt[1] : 1;
        return caml_call3(Exn_table[5], the_exn_table, extension_constructor, [
            0,
            sexp_of_exn,
            printexc
        ]);
    }
    function find_auto(for_printexc, exn) {
        var extension_constructor = caml_call1(Stdlib_Obj[22][1], exn), match = caml_call2(Exn_table[8], the_exn_table, extension_constructor);
        if (!match) return 0;
        var match$0 = match[1], printexc = match$0[2], sexp_of_exn = match$0[1];
        if (for_printexc && !printexc) return 0;
        return [
            0,
            caml_call1(sexp_of_exn, exn)
        ];
    }
    function size(param) {
        return caml_call1(Exn_table[18], the_exn_table)[1];
    }
    var For_unit_tests_only = [
        0,
        size
    ], _g_ = [
        0,
        2
    ];
    function sexp_of_exn_opt(exn) {
        return find_auto(0, exn);
    }
    function sexp_of_exn(exn) {
        var match = sexp_of_exn_opt(exn);
        if (!match) return [
            1,
            [
                0,
                [
                    0,
                    caml_call1(Stdlib_Printexc[1], exn)
                ],
                0
            ]
        ];
        var sexp = match[1];
        return sexp;
    }
    function exn_to_string(e) {
        var _az_ = sexp_of_exn(e);
        return caml_call2(Sexplib0_Sexp[13], 0, _az_);
    }
    caml_call1(Stdlib_Printexc[9], function(exn) {
        var match = find_auto(1, exn);
        if (!match) return 0;
        var sexp = match[1];
        return [
            0,
            caml_call2(Sexplib0_Sexp[13], _g_, sexp)
        ];
    });
    var _h_ = [
        0,
        2
    ];
    function printexc_prefer_sexp(exn) {
        var match = sexp_of_exn_opt(exn);
        if (!match) return caml_call1(Stdlib_Printexc[1], exn);
        var sexp = match[1];
        return caml_call2(Sexplib0_Sexp[13], _h_, sexp);
    }
    var Of_sexp_error = Sexplib0_Sexp[6], record_check_extra_fields = [
        0,
        1
    ], cst_unit_of_sexp_empty_list_ne = "unit_of_sexp: empty list needed", cst_bool_of_sexp_unknown_strin = "bool_of_sexp: unknown string", cst_bool_of_sexp_atom_needed = "bool_of_sexp: atom needed", cst_string_of_sexp_atom_needed = "string_of_sexp: atom needed", cst_bytes_of_sexp_atom_needed = "bytes_of_sexp: atom needed", cst_char_of_sexp_atom_string_m = "char_of_sexp: atom string must contain one character only", cst_char_of_sexp_atom_needed = "char_of_sexp: atom needed", cst_int_of_sexp = "int_of_sexp: ", cst_int_of_sexp_atom_needed = "int_of_sexp: atom needed", cst_float_of_sexp = "float_of_sexp: ", cst_float_of_sexp_atom_needed = "float_of_sexp: atom needed", cst_int32_of_sexp = "int32_of_sexp: ", cst_int32_of_sexp_atom_needed = "int32_of_sexp: atom needed", cst_int64_of_sexp = "int64_of_sexp: ", cst_int64_of_sexp_atom_needed = "int64_of_sexp: atom needed", cst_nativeint_of_sexp = "nativeint_of_sexp: ", cst_nativeint_of_sexp_atom_nee = "nativeint_of_sexp: atom needed", cst_option_of_sexp_only_none_c = cst_option_of_sexp_only_none_c$1, cst_option_of_sexp_list_must_r = "option_of_sexp: list must represent optional value", cst_option_of_sexp_only_none_c$0 = cst_option_of_sexp_only_none_c$1, cst_option_of_sexp_list_must_b = "option_of_sexp: list must be (some el)", cst_pair_of_sexp_list_needed = "pair_of_sexp: list needed", cst_pair_of_sexp_list_must_con = "pair_of_sexp: list must contain exactly two elements only", cst_triple_of_sexp_list_needed = "triple_of_sexp: list needed", cst_triple_of_sexp_list_must_c = "triple_of_sexp: list must contain exactly three elements only", cst_list_of_sexp_list_needed = "list_of_sexp: list needed", cst_array_of_sexp_list_needed = "array_of_sexp: list needed", cst_hashtbl_of_sexp_list_neede = "hashtbl_of_sexp: list needed", cst_hashtbl_of_sexp_tuple_list = "hashtbl_of_sexp: tuple list needed", cst_opaque_of_sexp_cannot_conv = "opaque_of_sexp: cannot convert opaque values", cst_fun_of_sexp_cannot_convert = "fun_of_sexp: cannot convert function values";
    function of_sexp_error_exn(exc, sexp) {
        throw caml_maybe_attach_backtrace([
            0,
            Of_sexp_error,
            exc,
            sexp
        ], 1);
    }
    function of_sexp_error(what, sexp) {
        throw caml_maybe_attach_backtrace([
            0,
            Of_sexp_error,
            [
                0,
                Stdlib[7],
                what
            ],
            sexp
        ], 1);
    }
    function unit_of_sexp(sexp) {
        if (1 === sexp[0] && !sexp[1]) return 0;
        return of_sexp_error(cst_unit_of_sexp_empty_list_ne, sexp);
    }
    function bool_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_bool_of_sexp_atom_needed, sexp);
        var _ay_ = sexp[1];
        a: if (_ay_ !== "False") {
            if (_ay_ !== "True") {
                if (_ay_ === "false") break a;
                if (_ay_ !== "true") return of_sexp_error(cst_bool_of_sexp_unknown_strin, sexp);
            }
            return 1;
        }
        return 0;
    }
    function string_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_string_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        return str;
    }
    function bytes_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_bytes_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        return caml_call1(Stdlib_BytesLabels[5], str);
    }
    function char_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_char_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        if (1 !== runtime.caml_ml_string_length(str)) of_sexp_error(cst_char_of_sexp_atom_string_m, sexp);
        return runtime.caml_string_get(str, 0);
    }
    function int_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _ax_ = caml_int_of_string(str);
            return _ax_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _aw_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int_of_sexp, _aw_), sexp);
        }
    }
    function float_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_float_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _av_ = caml_float_of_string(str);
            return _av_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _au_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_float_of_sexp, _au_), sexp);
        }
    }
    function int32_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int32_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _at_ = caml_int_of_string(str);
            return _at_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _as_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int32_of_sexp, _as_), sexp);
        }
    }
    function int64_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_int64_of_sexp_atom_needed, sexp);
        var str = sexp[1];
        try {
            var _ar_ = runtime.caml_int64_of_string(str);
            return _ar_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _aq_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_int64_of_sexp, _aq_), sexp);
        }
    }
    function nativeint_of_sexp(sexp) {
        if (0 !== sexp[0]) return of_sexp_error(cst_nativeint_of_sexp_atom_nee, sexp);
        var str = sexp[1];
        try {
            var _ap_ = caml_int_of_string(str);
            return _ap_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), _ao_ = exn_to_string(exc);
            return of_sexp_error(caml_call2(Stdlib[28], cst_nativeint_of_sexp, _ao_), sexp);
        }
    }
    function ref_of_sexp(a_of_sexp, sexp) {
        return [
            0,
            caml_call1(a_of_sexp, sexp)
        ];
    }
    function lazy_t_of_sexp(a_of_sexp, sexp) {
        var _an_ = caml_call1(a_of_sexp, sexp);
        return caml_call1(Stdlib_Lazy[4], _an_);
    }
    function option_of_sexp(a_of_sexp, sexp) {
        if (!read_old_option_format[1]) {
            if (0 === sexp[0]) {
                var _ai_ = sexp[1];
                if (_ai_ !== cst_None && _ai_ !== cst_none) return of_sexp_error(cst_option_of_sexp_only_none_c$0, sexp);
                return 0;
            }
            var _aj_ = sexp[1];
            a: if (_aj_) {
                var _ak_ = _aj_[1];
                if (0 === _ak_[0]) {
                    var _al_ = _ak_[1];
                    if (_al_ !== cst_Some && _al_ !== cst_some) break a;
                    var _am_ = _aj_[2];
                    if (_am_ && !_am_[2]) {
                        var el$0 = _am_[1];
                        return [
                            0,
                            caml_call1(a_of_sexp, el$0)
                        ];
                    }
                }
            }
            return of_sexp_error(cst_option_of_sexp_list_must_b, sexp);
        }
        if (0 === sexp[0]) {
            var _ad_ = sexp[1];
            if (_ad_ !== cst_None && _ad_ !== cst_none) return of_sexp_error(cst_option_of_sexp_only_none_c, sexp);
        } else {
            var _ae_ = sexp[1];
            if (_ae_) {
                var _af_ = _ae_[1];
                a: {
                    if (_ae_[2]) {
                        b: if (0 === _af_[0]) {
                            var _ag_ = _af_[1];
                            if (_ag_ !== cst_Some && _ag_ !== cst_some) break b;
                            var _ah_ = _ae_[2];
                            if (!_ah_[2]) {
                                var el = _ah_[1];
                                break a;
                            }
                        }
                        return of_sexp_error(cst_option_of_sexp_list_must_r, sexp);
                    }
                    var el = _af_;
                }
                return [
                    0,
                    caml_call1(a_of_sexp, el)
                ];
            }
        }
        return 0;
    }
    function pair_of_sexp(a_of_sexp, b_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_pair_of_sexp_list_needed, sexp);
        var _ab_ = sexp[1];
        if (_ab_) {
            var _ac_ = _ab_[2];
            if (_ac_ && !_ac_[2]) {
                var b_sexp = _ac_[1], a_sexp = _ab_[1], a = caml_call1(a_of_sexp, a_sexp), b = caml_call1(b_of_sexp, b_sexp);
                return [
                    0,
                    a,
                    b
                ];
            }
        }
        return of_sexp_error(cst_pair_of_sexp_list_must_con, sexp);
    }
    function triple_of_sexp(a_of_sexp, b_of_sexp, c_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_triple_of_sexp_list_needed, sexp);
        var ___ = sexp[1];
        if (___) {
            var _$_ = ___[2];
            if (_$_) {
                var _aa_ = _$_[2];
                if (_aa_ && !_aa_[2]) {
                    var c_sexp = _aa_[1], b_sexp = _$_[1], a_sexp = ___[1], a = caml_call1(a_of_sexp, a_sexp), b = caml_call1(b_of_sexp, b_sexp), c = caml_call1(c_of_sexp, c_sexp);
                    return [
                        0,
                        a,
                        b,
                        c
                    ];
                }
            }
        }
        return of_sexp_error(cst_triple_of_sexp_list_must_c, sexp);
    }
    function list_of_sexp(a_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_list_of_sexp_list_needed, sexp);
        var lst = sexp[1];
        return caml_call2(Stdlib_ListLabels[20], a_of_sexp, lst);
    }
    function array_of_sexp(a_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_array_of_sexp_list_needed, sexp);
        var match = sexp[1];
        if (!match) return [
            0
        ];
        var t = match[2], h = match[1], len = caml_call1(Stdlib_ListLabels[1], t) + 1 | 0, res = runtime.caml_array_make(len, caml_call1(a_of_sexp, h)), i = 1, param = t;
        for(;;){
            if (!param) return res;
            var t$0 = param[2], h$0 = param[1], _Z_ = caml_call1(a_of_sexp, h$0);
            caml_check_bound(res, i)[1 + i] = _Z_;
            var i$0 = i + 1 | 0;
            i = i$0;
            param = t$0;
        }
    }
    function hashtbl_of_sexp(key_of_sexp, val_of_sexp, sexp) {
        if (0 === sexp[0]) return of_sexp_error(cst_hashtbl_of_sexp_list_neede, sexp);
        var lst = sexp[1], htbl = caml_call2(Stdlib_MoreLabels[1][1], 0, 0);
        function act(param) {
            if (1 === param[0]) {
                var _V_ = param[1];
                if (_V_) {
                    var _W_ = _V_[2];
                    if (_W_ && !_W_[2]) {
                        var v_sexp = _W_[1], k_sexp = _V_[1], _X_ = caml_call1(val_of_sexp, v_sexp), _Y_ = caml_call1(key_of_sexp, k_sexp);
                        return caml_call3(Stdlib_MoreLabels[1][5], htbl, _Y_, _X_);
                    }
                }
            }
            return of_sexp_error(cst_hashtbl_of_sexp_tuple_list, sexp);
        }
        caml_call2(Stdlib_ListLabels[18], act, lst);
        return htbl;
    }
    function opaque_of_sexp(sexp) {
        return of_sexp_error(cst_opaque_of_sexp_cannot_conv, sexp);
    }
    function fun_of_sexp(sexp) {
        return of_sexp_error(cst_fun_of_sexp_cannot_convert, sexp);
    }
    var sexp_grammar_with_tags = Sexplib0_Sexp_conv_grammar[1], sexp_grammar_with_tag_list = Sexplib0_Sexp_conv_grammar[2], unit_sexp_grammar = Sexplib0_Sexp_conv_grammar[3], bool_sexp_grammar = Sexplib0_Sexp_conv_grammar[4], string_sexp_grammar = Sexplib0_Sexp_conv_grammar[5], bytes_sexp_grammar = Sexplib0_Sexp_conv_grammar[6], char_sexp_grammar = Sexplib0_Sexp_conv_grammar[7], int_sexp_grammar = Sexplib0_Sexp_conv_grammar[8], float_sexp_grammar = Sexplib0_Sexp_conv_grammar[9], int32_sexp_grammar = Sexplib0_Sexp_conv_grammar[10], int64_sexp_grammar = Sexplib0_Sexp_conv_grammar[11], nativeint_sexp_grammar = Sexplib0_Sexp_conv_grammar[12], sexp_t_sexp_grammar = Sexplib0_Sexp_conv_grammar[13], ref_sexp_grammar = Sexplib0_Sexp_conv_grammar[14], lazy_t_sexp_grammar = Sexplib0_Sexp_conv_grammar[15], option_sexp_grammar = Sexplib0_Sexp_conv_grammar[16], list_sexp_grammar = Sexplib0_Sexp_conv_grammar[17], array_sexp_grammar = Sexplib0_Sexp_conv_grammar[18], opaque_sexp_grammar = Sexplib0_Sexp_conv_grammar[19], fun_sexp_grammar = Sexplib0_Sexp_conv_grammar[20], _i_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        58,
                        [
                            4,
                            0,
                            0,
                            0,
                            [
                                12,
                                58,
                                [
                                    4,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s:%d:%d"
    ];
    function get_flc_error(name, param) {
        var chr = param[3], line = param[2], file = param[1];
        return [
            0,
            caml_call5(Stdlib_Printf[4], _i_, name, file, line, chr)
        ];
    }
    var _j_ = [
        0,
        "Sys.Break"
    ], _k_ = [
        0,
        cst_src_sexp_conv_ml,
        394,
        15
    ], _l_ = [
        0,
        "Stack.Empty"
    ], _m_ = [
        0,
        cst_src_sexp_conv_ml,
        390,
        15
    ], _n_ = [
        0,
        "Scanf.Scan_failure"
    ], _o_ = [
        0,
        cst_src_sexp_conv_ml,
        386,
        15
    ], _p_ = [
        0,
        "Queue.Empty"
    ], _q_ = [
        0,
        cst_src_sexp_conv_ml,
        382,
        15
    ], _r_ = [
        0,
        "Parsing.Parse_error"
    ], _s_ = [
        0,
        cst_src_sexp_conv_ml,
        378,
        15
    ], _t_ = [
        0,
        "Lazy.Undefined"
    ], _u_ = [
        0,
        cst_src_sexp_conv_ml,
        374,
        15
    ], _v_ = [
        0,
        "Arg.Bad"
    ], _w_ = [
        0,
        cst_src_sexp_conv_ml,
        370,
        15
    ], _x_ = [
        0,
        "Arg.Help"
    ], _y_ = [
        0,
        cst_src_sexp_conv_ml,
        366,
        15
    ], _z_ = [
        0,
        "Sys_error"
    ], _A_ = [
        0,
        cst_src_sexp_conv_ml,
        362,
        15
    ], _B_ = [
        0,
        "Not_found_s"
    ], _C_ = [
        0,
        cst_src_sexp_conv_ml,
        358,
        15
    ], cst_Match_failure = "Match_failure", _D_ = [
        0,
        cst_src_sexp_conv_ml,
        354,
        15
    ], _E_ = [
        0,
        "Invalid_argument"
    ], _F_ = [
        0,
        cst_src_sexp_conv_ml,
        350,
        15
    ], _G_ = [
        0,
        "Not_found"
    ], _H_ = [
        0,
        cst_src_sexp_conv_ml,
        346,
        15
    ], _I_ = [
        0,
        "Failure"
    ], _J_ = [
        0,
        cst_src_sexp_conv_ml,
        342,
        15
    ], _K_ = [
        0,
        "End_of_file"
    ], _L_ = [
        0,
        cst_src_sexp_conv_ml,
        338,
        15
    ], _M_ = [
        0,
        "Exit"
    ], _N_ = [
        0,
        cst_src_sexp_conv_ml,
        334,
        15
    ], cst_Assert_failure = cst_Assert_failure$0, _O_ = [
        0,
        cst_src_sexp_conv_ml,
        330,
        15
    ], _P_ = [
        0,
        0
    ], _Q_ = [
        0,
        0
    ];
    caml_call2(Stdlib_ListLabels[18], function(param) {
        var handler = param[2], extension_constructor = param[1];
        return add(_Q_, _P_, extension_constructor, handler);
    }, [
        0,
        [
            0,
            Stdlib[5],
            function(param) {
                if (param[1] !== Stdlib[5]) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _O_
                ], 1);
                var arg = param[2];
                return get_flc_error(cst_Assert_failure, arg);
            }
        ],
        [
            0,
            [
                0,
                Stdlib[3],
                function(param) {
                    if (param === Stdlib[3]) return _M_;
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _N_
                    ], 1);
                }
            ],
            [
                0,
                [
                    0,
                    Stdlib[12],
                    function(param) {
                        if (param === Stdlib[12]) return _K_;
                        throw caml_maybe_attach_backtrace([
                            0,
                            Assert_failure,
                            _L_
                        ], 1);
                    }
                ],
                [
                    0,
                    [
                        0,
                        Stdlib[7],
                        function(param) {
                            if (param[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace([
                                0,
                                Assert_failure,
                                _J_
                            ], 1);
                            var arg = param[2];
                            return [
                                1,
                                [
                                    0,
                                    _I_,
                                    [
                                        0,
                                        [
                                            0,
                                            arg
                                        ],
                                        0
                                    ]
                                ]
                            ];
                        }
                    ],
                    [
                        0,
                        [
                            0,
                            Stdlib[8],
                            function(param) {
                                if (param === Stdlib[8]) return _G_;
                                throw caml_maybe_attach_backtrace([
                                    0,
                                    Assert_failure,
                                    _H_
                                ], 1);
                            }
                        ],
                        [
                            0,
                            [
                                0,
                                Stdlib[6],
                                function(param) {
                                    if (param[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace([
                                        0,
                                        Assert_failure,
                                        _F_
                                    ], 1);
                                    var arg = param[2];
                                    return [
                                        1,
                                        [
                                            0,
                                            _E_,
                                            [
                                                0,
                                                [
                                                    0,
                                                    arg
                                                ],
                                                0
                                            ]
                                        ]
                                    ];
                                }
                            ],
                            [
                                0,
                                [
                                    0,
                                    Stdlib[4],
                                    function(param) {
                                        if (param[1] !== Stdlib[4]) throw caml_maybe_attach_backtrace([
                                            0,
                                            Assert_failure,
                                            _D_
                                        ], 1);
                                        var arg = param[2];
                                        return get_flc_error(cst_Match_failure, arg);
                                    }
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        Sexplib0_Sexp[5],
                                        function(param) {
                                            if (param[1] !== Sexplib0_Sexp[5]) throw caml_maybe_attach_backtrace([
                                                0,
                                                Assert_failure,
                                                _C_
                                            ], 1);
                                            var arg = param[2];
                                            return [
                                                1,
                                                [
                                                    0,
                                                    _B_,
                                                    [
                                                        0,
                                                        arg,
                                                        0
                                                    ]
                                                ]
                                            ];
                                        }
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            Stdlib[11],
                                            function(param) {
                                                if (param[1] !== Stdlib[11]) throw caml_maybe_attach_backtrace([
                                                    0,
                                                    Assert_failure,
                                                    _A_
                                                ], 1);
                                                var arg = param[2];
                                                return [
                                                    1,
                                                    [
                                                        0,
                                                        _z_,
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                arg
                                                            ],
                                                            0
                                                        ]
                                                    ]
                                                ];
                                            }
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                Stdlib_Arg[7],
                                                function(param) {
                                                    if (param[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace([
                                                        0,
                                                        Assert_failure,
                                                        _y_
                                                    ], 1);
                                                    var arg = param[2];
                                                    return [
                                                        1,
                                                        [
                                                            0,
                                                            _x_,
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    arg
                                                                ],
                                                                0
                                                            ]
                                                        ]
                                                    ];
                                                }
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    Stdlib_Arg[8],
                                                    function(param) {
                                                        if (param[1] !== Stdlib_Arg[8]) throw caml_maybe_attach_backtrace([
                                                            0,
                                                            Assert_failure,
                                                            _w_
                                                        ], 1);
                                                        var arg = param[2];
                                                        return [
                                                            1,
                                                            [
                                                                0,
                                                                _v_,
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        arg
                                                                    ],
                                                                    0
                                                                ]
                                                            ]
                                                        ];
                                                    }
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        Stdlib_Lazy[1],
                                                        function(param) {
                                                            if (param === Stdlib_Lazy[1]) return _t_;
                                                            throw caml_maybe_attach_backtrace([
                                                                0,
                                                                Assert_failure,
                                                                _u_
                                                            ], 1);
                                                        }
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            Stdlib_Parsing[10],
                                                            function(param) {
                                                                if (param === Stdlib_Parsing[10]) return _r_;
                                                                throw caml_maybe_attach_backtrace([
                                                                    0,
                                                                    Assert_failure,
                                                                    _s_
                                                                ], 1);
                                                            }
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                Stdlib_Queue[1],
                                                                function(param) {
                                                                    if (param === Stdlib_Queue[1]) return _p_;
                                                                    throw caml_maybe_attach_backtrace([
                                                                        0,
                                                                        Assert_failure,
                                                                        _q_
                                                                    ], 1);
                                                                }
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    Stdlib_Scanf[2],
                                                                    function(param) {
                                                                        if (param[1] !== Stdlib_Scanf[2]) throw caml_maybe_attach_backtrace([
                                                                            0,
                                                                            Assert_failure,
                                                                            _o_
                                                                        ], 1);
                                                                        var arg = param[2];
                                                                        return [
                                                                            1,
                                                                            [
                                                                                0,
                                                                                _n_,
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        arg
                                                                                    ],
                                                                                    0
                                                                                ]
                                                                            ]
                                                                        ];
                                                                    }
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        Stdlib_Stack[1],
                                                                        function(param) {
                                                                            if (param === Stdlib_Stack[1]) return _l_;
                                                                            throw caml_maybe_attach_backtrace([
                                                                                0,
                                                                                Assert_failure,
                                                                                _m_
                                                                            ], 1);
                                                                        }
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            Stdlib_Sys[44],
                                                                            function(param) {
                                                                                if (param === Stdlib_Sys[44]) return _j_;
                                                                                throw caml_maybe_attach_backtrace([
                                                                                    0,
                                                                                    Assert_failure,
                                                                                    _k_
                                                                                ], 1);
                                                                            }
                                                                        ],
                                                                        0
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ]);
    var _R_ = [
        0,
        "Sexplib.Conv.Of_sexp_error"
    ], _S_ = [
        0,
        cst_src_sexp_conv_ml,
        406,
        15
    ], _T_1 = [
        0,
        0
    ], _U_ = [
        0,
        1
    ];
    caml_call2(Stdlib_ListLabels[18], function(param) {
        var handler = param[2], extension_constructor = param[1];
        return add(_U_, _T_1, extension_constructor, handler);
    }, [
        0,
        [
            0,
            Of_sexp_error,
            function(param) {
                if (param[1] !== Of_sexp_error) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _S_
                ], 1);
                var sexp = param[3], exc = param[2];
                return [
                    1,
                    [
                        0,
                        _R_,
                        [
                            0,
                            sexp_of_exn(exc),
                            [
                                0,
                                sexp,
                                0
                            ]
                        ]
                    ]
                ];
            }
        ],
        0
    ]);
    var Sexplib0_Sexp_conv = [
        0,
        default_string_of_float,
        write_old_option_format,
        read_old_option_format,
        list_map,
        sexp_of_unit,
        sexp_of_bool,
        sexp_of_string,
        sexp_of_bytes,
        sexp_of_char,
        sexp_of_int,
        sexp_of_float,
        sexp_of_int32,
        sexp_of_int64,
        sexp_of_nativeint,
        sexp_of_ref,
        sexp_of_lazy_t,
        sexp_of_option,
        sexp_of_pair,
        sexp_of_triple,
        sexp_of_list,
        sexp_of_array,
        sexp_of_hashtbl,
        sexp_of_opaque,
        sexp_of_fun,
        Of_sexp_error,
        record_check_extra_fields,
        of_sexp_error,
        of_sexp_error_exn,
        unit_of_sexp,
        bool_of_sexp,
        string_of_sexp,
        bytes_of_sexp,
        char_of_sexp,
        int_of_sexp,
        float_of_sexp,
        int32_of_sexp,
        int64_of_sexp,
        nativeint_of_sexp,
        ref_of_sexp,
        lazy_t_of_sexp,
        option_of_sexp,
        pair_of_sexp,
        triple_of_sexp,
        list_of_sexp,
        array_of_sexp,
        hashtbl_of_sexp,
        opaque_of_sexp,
        fun_of_sexp,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        bool_sexp_grammar,
        string_sexp_grammar,
        bytes_sexp_grammar,
        char_sexp_grammar,
        int_sexp_grammar,
        float_sexp_grammar,
        int32_sexp_grammar,
        int64_sexp_grammar,
        nativeint_sexp_grammar,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        opaque_sexp_grammar,
        fun_sexp_grammar,
        sexp_of_exn,
        printexc_prefer_sexp,
        sexp_of_exn_opt,
        [
            0,
            add,
            For_unit_tests_only
        ]
    ];
    runtime.caml_register_global(117, Sexplib0_Sexp_conv, "Sexplib0__Sexp_conv");
    return;
})(globalThis);
//# 1512 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = " ", cst_has_incorrect_number_of_ar = " has incorrect number of arguments", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, msg = "this constructor does not take arguments", msg$0 = "this constructor requires arguments", msg$1 = "expected a variant type, saw a nested list", msg$2 = "expected a variant type, saw an empty list", msg$3 = "unexpected variant constructor", msg$4 = "record conversion: a [sexp.bool] field was given a payload.", msg$5 = "record conversion: only pairs expected, their first element must be an atom", msg$6 = "list instead of atom for record expected", msg$7 = "cannot convert values of types resulting from polymorphic record fields", msg$8 = "no matching variant found", msg$9 = "polymorphic variant does not take arguments", msg$10 = "polymorphic variant tag takes an argument", msg$11 = "a nested list is an invalid polymorphic variant", msg$12 = "the empty list is an invalid polymorphic variant", msg$13 = "trying to convert an empty type", Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Stdlib_Printf = global_data.Stdlib__Printf, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Of_sexp_error = Sexplib0_Sexp_conv[25], _a_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s_of_sexp: %s"
    ], _b_ = [
        0,
        [
            11,
            "tuple of size ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " expected",
                    0
                ]
            ]
        ],
        "tuple of size %d expected"
    ], _c_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: expected a pair beginning with label ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s_of_sexp: expected a pair beginning with label %s"
    ], _d_ = [
        0,
        [
            2,
            0,
            [
                11,
                "_of_sexp: incorrect label for element ",
                [
                    2,
                    0,
                    [
                        11,
                        " at position ",
                        [
                            4,
                            3,
                            0,
                            0,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s_of_sexp: incorrect label for element %s at position %i"
    ], _e_ = [
        0,
        [
            11,
            "sum tag ",
            [
                3,
                0,
                [
                    11,
                    cst_has_incorrect_number_of_ar,
                    0
                ]
            ]
        ],
        "sum tag %S has incorrect number of arguments"
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": ",
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s: %s"
    ], cst_duplicate_fields = "duplicate fields", cst_extra_fields = "extra fields", _g_ = [
        0,
        [
            11,
            "the following record elements were undefined: ",
            [
                2,
                0,
                0
            ]
        ],
        "the following record elements were undefined: %s"
    ];
    function error(loc, sexp, msg) {
        var _k_ = caml_call3(Stdlib_Printf[4], _a_, loc, msg);
        return caml_call2(Sexplib0_Sexp_conv[27], _k_, sexp);
    }
    function simple_error(msg, loc, sexp) {
        return error(loc, sexp, msg);
    }
    function tuple_of_size_n_expected(loc, n, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _b_, n));
    }
    function tuple_pair_expected(loc, name, sexp) {
        var msg = caml_call3(Stdlib_Printf[4], _c_, loc, name);
        return caml_call2(Sexplib0_Sexp_conv[27], msg, sexp);
    }
    function tuple_incorrect_label(loc, name, pos, sexp) {
        var msg = caml_call4(Stdlib_Printf[4], _d_, loc, name, pos);
        return caml_call2(Sexplib0_Sexp_conv[27], msg, sexp);
    }
    function stag_no_args(loc, sexp) {
        return error(loc, sexp, msg);
    }
    function stag_incorrect_n_args(loc, tag, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _e_, tag));
    }
    function stag_takes_args(loc, sexp) {
        return error(loc, sexp, msg$0);
    }
    function nested_list_invalid_sum(loc, sexp) {
        return error(loc, sexp, msg$1);
    }
    function empty_list_invalid_sum(loc, sexp) {
        return error(loc, sexp, msg$2);
    }
    function unexpected_stag(loc, sexp) {
        return error(loc, sexp, msg$3);
    }
    function record_sexp_bool_with_payload(loc, sexp) {
        return error(loc, sexp, msg$4);
    }
    function record_only_pairs_expected(loc, sexp) {
        return error(loc, sexp, msg$5);
    }
    function record_invalid_fields(what, loc, fld_names, sexp) {
        var fld_names_str = caml_call2(Stdlib_StringLabels[7], cst, fld_names);
        return error(loc, sexp, caml_call3(Stdlib_Printf[4], _f_, what, fld_names_str));
    }
    function record_duplicate_fields(loc, fld_names, sexp) {
        return record_invalid_fields(cst_duplicate_fields, loc, fld_names, sexp);
    }
    function record_extra_fields(loc, fld_names, sexp) {
        return record_invalid_fields(cst_extra_fields, loc, fld_names, sexp);
    }
    function record_get_undefined_loop(fields, param) {
        var fields$0 = fields, param$0 = param;
        for(;;){
            if (!param$0) {
                var _j_ = caml_call1(Stdlib_ListLabels[10], fields$0);
                return caml_call2(Stdlib_StringLabels[7], cst$0, _j_);
            }
            var _i_ = param$0[1];
            if (_i_[1]) {
                var rest = param$0[2], field = _i_[2], fields$1 = [
                    0,
                    field,
                    fields$0
                ];
                fields$0 = fields$1;
                param$0 = rest;
            } else {
                var rest$0 = param$0[2];
                param$0 = rest$0;
            }
        }
    }
    function record_undefined_elements(loc, sexp, lst) {
        var undefined$0 = record_get_undefined_loop(0, lst), msg = caml_call2(Stdlib_Printf[4], _g_, undefined$0);
        return error(loc, sexp, msg);
    }
    function record_list_instead_atom(loc, sexp) {
        return error(loc, sexp, msg$6);
    }
    function record_poly_field_value(loc, sexp) {
        return error(loc, sexp, msg$7);
    }
    var No_variant_match = [
        248,
        "Sexplib0__Sexp_conv_error.No_variant_match",
        runtime.caml_fresh_oo_id(0)
    ], _h_ = [
        0,
        [
            11,
            "polymorphic variant tag ",
            [
                3,
                0,
                [
                    11,
                    cst_has_incorrect_number_of_ar,
                    0
                ]
            ]
        ],
        "polymorphic variant tag %S has incorrect number of arguments"
    ];
    function no_variant_match(param) {
        throw caml_maybe_attach_backtrace(No_variant_match, 1);
    }
    function no_matching_variant_found(loc, sexp) {
        return error(loc, sexp, msg$8);
    }
    function ptag_no_args(loc, sexp) {
        return error(loc, sexp, msg$9);
    }
    function ptag_incorrect_n_args(loc, cnstr, sexp) {
        return error(loc, sexp, caml_call2(Stdlib_Printf[4], _h_, cnstr));
    }
    function ptag_takes_args(loc, sexp) {
        return error(loc, sexp, msg$10);
    }
    function nested_list_invalid_poly_var(loc, sexp) {
        return error(loc, sexp, msg$11);
    }
    function empty_list_invalid_poly_var(loc, sexp) {
        return error(loc, sexp, msg$12);
    }
    function empty_type(loc, sexp) {
        return error(loc, sexp, msg$13);
    }
    var Sexplib0_Sexp_conv_error = [
        0,
        Of_sexp_error,
        error,
        simple_error,
        tuple_of_size_n_expected,
        tuple_pair_expected,
        tuple_incorrect_label,
        stag_no_args,
        stag_incorrect_n_args,
        stag_takes_args,
        nested_list_invalid_sum,
        empty_list_invalid_sum,
        unexpected_stag,
        record_sexp_bool_with_payload,
        record_only_pairs_expected,
        record_invalid_fields,
        record_duplicate_fields,
        record_extra_fields,
        record_get_undefined_loop,
        record_undefined_elements,
        record_list_instead_atom,
        record_poly_field_value,
        No_variant_match,
        no_variant_match,
        no_matching_variant_found,
        ptag_no_args,
        ptag_incorrect_n_args,
        ptag_takes_args,
        nested_list_invalid_poly_var,
        empty_list_invalid_poly_var,
        empty_type
    ];
    runtime.caml_register_global(32, Sexplib0_Sexp_conv_error, "Sexplib0__Sexp_conv_error");
    return;
})(globalThis);
//# 2351 "../.js/default/sexplib0/sexplib0.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Sexplib0_Sexpable = [
        0
    ];
    runtime.caml_register_global(0, Sexplib0_Sexpable, "Sexplib0__Sexpable");
    return;
})(globalThis);
//# 5 "../.js/default/base.shadow_stdlib/shadow_stdlib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, invalid_arg = Stdlib[1], failwith = Stdlib[2], Exit = Stdlib[3], Not_found = Stdlib[8], min = Stdlib[16], max = Stdlib[17], abs = Stdlib[18], max_int = Stdlib[19], min_int = Stdlib[20], lnot = Stdlib[21], infinity = Stdlib[22], neg_infinity = Stdlib[23], nan = Stdlib[24], max_float = Stdlib[25], min_float = Stdlib[26], epsilon_float = Stdlib[27], symbol_concat = Stdlib[28], char_of_int = Stdlib[29], string_of_bool = Stdlib[30], bool_of_string_opt = Stdlib[31], bool_of_string = Stdlib[32], string_of_int = Stdlib[33], int_of_string_opt = Stdlib[34], string_of_float = Stdlib[35], float_of_string_opt = Stdlib[36], symbol = Stdlib[37], stdin = Stdlib[38], stdout = Stdlib[39], stderr = Stdlib[40], print_char = Stdlib[41], print_string = Stdlib[42], print_bytes = Stdlib[43], print_int = Stdlib[44], print_float = Stdlib[45], print_endline = Stdlib[46], print_newline = Stdlib[47], prerr_char = Stdlib[48], prerr_string = Stdlib[49], prerr_bytes = Stdlib[50], prerr_int = Stdlib[51], prerr_float = Stdlib[52], prerr_endline = Stdlib[53], prerr_newline = Stdlib[54], read_line = Stdlib[55], read_int_opt = Stdlib[56], read_int = Stdlib[57], read_float_opt = Stdlib[58], read_float = Stdlib[59], open_out = Stdlib[60], open_out_bin = Stdlib[61], open_out_gen = Stdlib[62], flush = Stdlib[63], flush_all = Stdlib[64], output_char = Stdlib[65], output_string = Stdlib[66], output_bytes = Stdlib[67], output = Stdlib[68], output_substring = Stdlib[69], output_byte = Stdlib[70], output_binary_int = Stdlib[71], output_value = Stdlib[72], seek_out = Stdlib[73], pos_out = Stdlib[74], out_channel_length = Stdlib[75], close_out = Stdlib[76], close_out_noerr = Stdlib[77], set_binary_mode_out = Stdlib[78], open_in = Stdlib[79], open_in_bin = Stdlib[80], open_in_gen = Stdlib[81], input_char = Stdlib[82], input_line = Stdlib[83], input = Stdlib[84], really_input = Stdlib[85], really_input_string = Stdlib[86], input_byte = Stdlib[87], input_binary_int = Stdlib[88], input_value = Stdlib[89], seek_in = Stdlib[90], pos_in = Stdlib[91], in_channel_length = Stdlib[92], close_in = Stdlib[93], close_in_noerr = Stdlib[94], set_binary_mode_in = Stdlib[95], string_of_format = Stdlib[97], symbol$0 = Stdlib[98], exit = Stdlib[99], at_exit = Stdlib[100], valid_float_lexem = Stdlib[101], unsafe_really_input = Stdlib[102], do_at_exit = Stdlib[103], do_domain_local_at_exit = Stdlib[104], Shadow_stdlib = [
        0,
        invalid_arg,
        failwith,
        Exit,
        Not_found,
        min,
        max,
        abs,
        max_int,
        min_int,
        lnot,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        symbol_concat,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        symbol,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol$0,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit
    ];
    runtime.caml_register_global(1, Shadow_stdlib, "Shadow_stdlib");
    return;
})(globalThis);
//# 367 "../.js/default/ocaml_intrinsics_kernel/ocaml_intrinsics_kernel.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Ocaml_intrinsics_kernel_Float = [
        0
    ];
    runtime.caml_register_global(0, Ocaml_intrinsics_kernel_Float, "Ocaml_intrinsics_kernel__Float");
    return;
})(globalThis);
//# 14 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Bool0 = [
        0
    ];
    runtime.caml_register_global(0, Base_Bool0, "Base__Bool0");
    return;
})(globalThis);
//# 23 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_obj_dup = runtime.caml_obj_dup;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function globalize_bool(b) {
        return b;
    }
    function globalize_char(c) {
        return c;
    }
    function globalize_unit(u) {
        return u;
    }
    function globalize_array(param, a) {
        return a.slice();
    }
    function globalize_list(f, param) {
        if (!param) return 0;
        var xs = param[2], x = param[1], _b_ = globalize_list(f, xs);
        return [
            0,
            caml_call1(f, x),
            _b_
        ];
    }
    function globalize_option(f, param) {
        if (!param) return 0;
        var x = param[1];
        return [
            0,
            caml_call1(f, x)
        ];
    }
    function globalize_result(globalize_a, globalize_b, t) {
        if (0 === t[0]) {
            var a = t[1];
            return [
                0,
                caml_call1(globalize_a, a)
            ];
        }
        var b = t[1];
        return [
            1,
            caml_call1(globalize_b, b)
        ];
    }
    function globalize_ref(param, r) {
        return [
            0,
            r[1]
        ];
    }
    function globalize_lazy_t(param, t) {
        return t;
    }
    var Base_Globalize = [
        0,
        globalize_bool,
        globalize_char,
        caml_obj_dup,
        function(_a_) {
            return _a_;
        },
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        caml_obj_dup,
        globalize_unit,
        globalize_array,
        globalize_lazy_t,
        globalize_list,
        globalize_option,
        globalize_result,
        globalize_ref
    ];
    runtime.caml_register_global(0, Base_Globalize, "Base__Globalize");
    return;
})(globalThis);
//# 78 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_compare = runtime.caml_compare;
    function descending(x, y) {
        return caml_compare(y, x);
    }
    function max(x, y) {
        return runtime.caml_csel_value(runtime.caml_greaterequal(x, y), x, y);
    }
    function min(x, y) {
        return runtime.caml_csel_value(runtime.caml_lessequal(x, y), x, y);
    }
    var Base_Poly0 = [
        0,
        caml_compare,
        descending,
        min,
        max
    ];
    runtime.caml_register_global(0, Base_Poly0, "Base__Poly0");
    return;
})(globalThis);
//# 97 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_compare = runtime.caml_bytes_compare, caml_bytes_equal = runtime.caml_bytes_equal, caml_bytes_greaterequal = runtime.caml_bytes_greaterequal, caml_bytes_lessequal = runtime.caml_bytes_lessequal, caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int_compare = runtime.caml_int_compare, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_notequal = runtime.caml_notequal, caml_string_compare = runtime.caml_string_compare, caml_string_equal = runtime.caml_string_equal, caml_string_greaterequal = runtime.caml_string_greaterequal, caml_string_lessequal = runtime.caml_string_lessequal;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Poly0 = global_data.Base__Poly0, Shadow_stdlib = global_data.Shadow_stdlib, Stdlib = global_data.Stdlib, Stdlib_MoreLabels = global_data.Stdlib__MoreLabels, Exit = Shadow_stdlib[3], Not_found = Shadow_stdlib[4], max_int = Shadow_stdlib[8], min_int = Shadow_stdlib[9], infinity = Shadow_stdlib[11], neg_infinity = Shadow_stdlib[12], nan = Shadow_stdlib[13], max_float = Shadow_stdlib[14], min_float = Shadow_stdlib[15], epsilon_float = Shadow_stdlib[16], char_of_int = Shadow_stdlib[18], string_of_bool = Shadow_stdlib[19], bool_of_string_opt = Shadow_stdlib[20], bool_of_string = Shadow_stdlib[21], string_of_int = Shadow_stdlib[22], int_of_string_opt = Shadow_stdlib[23], string_of_float = Shadow_stdlib[24], float_of_string_opt = Shadow_stdlib[25], stdin = Shadow_stdlib[27], stdout = Shadow_stdlib[28], stderr = Shadow_stdlib[29], print_char = Shadow_stdlib[30], print_string = Shadow_stdlib[31], print_bytes = Shadow_stdlib[32], print_int = Shadow_stdlib[33], print_float = Shadow_stdlib[34], print_endline = Shadow_stdlib[35], print_newline = Shadow_stdlib[36], prerr_char = Shadow_stdlib[37], prerr_string = Shadow_stdlib[38], prerr_bytes = Shadow_stdlib[39], prerr_int = Shadow_stdlib[40], prerr_float = Shadow_stdlib[41], prerr_endline = Shadow_stdlib[42], prerr_newline = Shadow_stdlib[43], read_line = Shadow_stdlib[44], read_int_opt = Shadow_stdlib[45], read_int = Shadow_stdlib[46], read_float_opt = Shadow_stdlib[47], read_float = Shadow_stdlib[48], open_out = Shadow_stdlib[49], open_out_bin = Shadow_stdlib[50], open_out_gen = Shadow_stdlib[51], flush = Shadow_stdlib[52], flush_all = Shadow_stdlib[53], output_char = Shadow_stdlib[54], output_string = Shadow_stdlib[55], output_bytes = Shadow_stdlib[56], output = Shadow_stdlib[57], output_substring = Shadow_stdlib[58], output_byte = Shadow_stdlib[59], output_binary_int = Shadow_stdlib[60], output_value = Shadow_stdlib[61], seek_out = Shadow_stdlib[62], pos_out = Shadow_stdlib[63], out_channel_length = Shadow_stdlib[64], close_out = Shadow_stdlib[65], close_out_noerr = Shadow_stdlib[66], set_binary_mode_out = Shadow_stdlib[67], open_in = Shadow_stdlib[68], open_in_bin = Shadow_stdlib[69], open_in_gen = Shadow_stdlib[70], input_char = Shadow_stdlib[71], input_line = Shadow_stdlib[72], input = Shadow_stdlib[73], really_input = Shadow_stdlib[74], really_input_string = Shadow_stdlib[75], input_byte = Shadow_stdlib[76], input_binary_int = Shadow_stdlib[77], input_value = Shadow_stdlib[78], seek_in = Shadow_stdlib[79], pos_in = Shadow_stdlib[80], in_channel_length = Shadow_stdlib[81], close_in = Shadow_stdlib[82], close_in_noerr = Shadow_stdlib[83], set_binary_mode_in = Shadow_stdlib[84], string_of_format = Shadow_stdlib[85], symbol = Shadow_stdlib[86], exit = Shadow_stdlib[87], at_exit = Shadow_stdlib[88], valid_float_lexem = Shadow_stdlib[89], unsafe_really_input = Shadow_stdlib[90], do_at_exit = Shadow_stdlib[91], do_domain_local_at_exit = Shadow_stdlib[92], invalid_arg = Stdlib[1], failwith = Stdlib[2], Exit$0 = Stdlib[3], Match_failure = Stdlib[4], Assert_failure = Stdlib[5], Invalid_argument = Stdlib[6], Failure = Stdlib[7], Not_found$0 = Stdlib[8], Out_of_memory = Stdlib[9], Stack_overflow = Stdlib[10], Sys_error = Stdlib[11], End_of_file = Stdlib[12], Division_by_zero = Stdlib[13], Sys_blocked_io = Stdlib[14], Undefined_recursive_module = Stdlib[15], min = Stdlib[16], max = Stdlib[17], abs = Stdlib[18], max_int$0 = Stdlib[19], min_int$0 = Stdlib[20], lnot = Stdlib[21], infinity$0 = Stdlib[22], neg_infinity$0 = Stdlib[23], nan$0 = Stdlib[24], max_float$0 = Stdlib[25], min_float$0 = Stdlib[26], epsilon_float$0 = Stdlib[27], symbol_concat = Stdlib[28], char_of_int$0 = Stdlib[29], string_of_bool$0 = Stdlib[30], bool_of_string_opt$0 = Stdlib[31], bool_of_string$0 = Stdlib[32], string_of_int$0 = Stdlib[33], int_of_string_opt$0 = Stdlib[34], string_of_float$0 = Stdlib[35], float_of_string_opt$0 = Stdlib[36], symbol$0 = Stdlib[37], stdin$0 = Stdlib[38], stdout$0 = Stdlib[39], stderr$0 = Stdlib[40], print_char$0 = Stdlib[41], print_string$0 = Stdlib[42], print_bytes$0 = Stdlib[43], print_int$0 = Stdlib[44], print_float$0 = Stdlib[45], print_endline$0 = Stdlib[46], print_newline$0 = Stdlib[47], prerr_char$0 = Stdlib[48], prerr_string$0 = Stdlib[49], prerr_bytes$0 = Stdlib[50], prerr_int$0 = Stdlib[51], prerr_float$0 = Stdlib[52], prerr_endline$0 = Stdlib[53], prerr_newline$0 = Stdlib[54], read_line$0 = Stdlib[55], read_int_opt$0 = Stdlib[56], read_int$0 = Stdlib[57], read_float_opt$0 = Stdlib[58], read_float$0 = Stdlib[59], open_out$0 = Stdlib[60], open_out_bin$0 = Stdlib[61], open_out_gen$0 = Stdlib[62], flush$0 = Stdlib[63], flush_all$0 = Stdlib[64], output_char$0 = Stdlib[65], output_string$0 = Stdlib[66], output_bytes$0 = Stdlib[67], output$0 = Stdlib[68], output_substring$0 = Stdlib[69], output_byte$0 = Stdlib[70], output_binary_int$0 = Stdlib[71], output_value$0 = Stdlib[72], seek_out$0 = Stdlib[73], pos_out$0 = Stdlib[74], out_channel_length$0 = Stdlib[75], close_out$0 = Stdlib[76], close_out_noerr$0 = Stdlib[77], set_binary_mode_out$0 = Stdlib[78], open_in$0 = Stdlib[79], open_in_bin$0 = Stdlib[80], open_in_gen$0 = Stdlib[81], input_char$0 = Stdlib[82], input_line$0 = Stdlib[83], input$0 = Stdlib[84], really_input$0 = Stdlib[85], really_input_string$0 = Stdlib[86], input_byte$0 = Stdlib[87], input_binary_int$0 = Stdlib[88], input_value$0 = Stdlib[89], seek_in$0 = Stdlib[90], pos_in$0 = Stdlib[91], in_channel_length$0 = Stdlib[92], close_in$0 = Stdlib[93], close_in_noerr$0 = Stdlib[94], set_binary_mode_in$0 = Stdlib[95], LargeFile = Stdlib[96], string_of_format$0 = Stdlib[97], symbol$1 = Stdlib[98], exit$0 = Stdlib[99], at_exit$0 = Stdlib[100], valid_float_lexem$0 = Stdlib[101], unsafe_really_input$0 = Stdlib[102], do_at_exit$0 = Stdlib[103], do_domain_local_at_exit$0 = Stdlib[104], Hashtbl = Stdlib_MoreLabels[1], Map = Stdlib_MoreLabels[2], Set = Stdlib_MoreLabels[3], Stdlib$0 = [
        0,
        invalid_arg,
        failwith,
        Exit$0,
        Match_failure,
        Assert_failure,
        Invalid_argument,
        Failure,
        Not_found$0,
        Out_of_memory,
        Stack_overflow,
        Sys_error,
        End_of_file,
        Division_by_zero,
        Sys_blocked_io,
        Undefined_recursive_module,
        min,
        max,
        abs,
        max_int$0,
        min_int$0,
        lnot,
        infinity$0,
        neg_infinity$0,
        nan$0,
        max_float$0,
        min_float$0,
        epsilon_float$0,
        symbol_concat,
        char_of_int$0,
        string_of_bool$0,
        bool_of_string_opt$0,
        bool_of_string$0,
        string_of_int$0,
        int_of_string_opt$0,
        string_of_float$0,
        float_of_string_opt$0,
        symbol$0,
        stdin$0,
        stdout$0,
        stderr$0,
        print_char$0,
        print_string$0,
        print_bytes$0,
        print_int$0,
        print_float$0,
        print_endline$0,
        print_newline$0,
        prerr_char$0,
        prerr_string$0,
        prerr_bytes$0,
        prerr_int$0,
        prerr_float$0,
        prerr_endline$0,
        prerr_newline$0,
        read_line$0,
        read_int_opt$0,
        read_int$0,
        read_float_opt$0,
        read_float$0,
        open_out$0,
        open_out_bin$0,
        open_out_gen$0,
        flush$0,
        flush_all$0,
        output_char$0,
        output_string$0,
        output_bytes$0,
        output$0,
        output_substring$0,
        output_byte$0,
        output_binary_int$0,
        output_value$0,
        seek_out$0,
        pos_out$0,
        out_channel_length$0,
        close_out$0,
        close_out_noerr$0,
        set_binary_mode_out$0,
        open_in$0,
        open_in_bin$0,
        open_in_gen$0,
        input_char$0,
        input_line$0,
        input$0,
        really_input$0,
        really_input_string$0,
        input_byte$0,
        input_binary_int$0,
        input_value$0,
        seek_in$0,
        pos_in$0,
        in_channel_length$0,
        close_in$0,
        close_in_noerr$0,
        set_binary_mode_in$0,
        LargeFile,
        string_of_format$0,
        symbol$1,
        exit$0,
        at_exit$0,
        valid_float_lexem$0,
        unsafe_really_input$0,
        do_at_exit$0,
        do_domain_local_at_exit$0,
        Hashtbl,
        Map,
        Set
    ];
    function bool_to_int(x) {
        return x;
    }
    function symbol$2(_F_, _E_) {
        return _F_ !== _E_ ? 1 : 0;
    }
    var symbol$3 = runtime.caml_mul;
    function symbol$4(_D_, _C_) {
        return Math.pow(_D_, _C_);
    }
    function symbol$5(_B_, _A_) {
        return _B_ * _A_;
    }
    function symbol$6(_z_, _y_) {
        return _z_ + _y_ | 0;
    }
    function symbol$7(_x_, _w_) {
        return _x_ + _w_;
    }
    function symbol$8(_v_, _u_) {
        return _v_ - _u_ | 0;
    }
    function symbol$9(_t_, _s_) {
        return _t_ - _s_;
    }
    var symbol$10 = runtime.caml_div;
    function symbol$11(_r_, _q_) {
        return _r_ / _q_;
    }
    var ascending = caml_int_compare;
    function descending(x, y) {
        return caml_int_compare(y, x);
    }
    function max$0(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$0(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Int_replace_polymorphic_compar = [
        0,
        ascending,
        descending,
        max$0,
        min$0
    ], ascending$0 = Int_replace_polymorphic_compar[1], descending$0 = Int_replace_polymorphic_compar[2], max$1 = Int_replace_polymorphic_compar[3], min$1 = Int_replace_polymorphic_compar[4], symbol$12 = caml_lessthan, symbol$13 = caml_lessequal, symbol$14 = caml_notequal, symbol$15 = caml_equal, symbol$16 = caml_greaterthan, symbol$17 = caml_greaterequal;
    function ascending$1(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$1(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare = caml_int_compare, compare_local = caml_int_compare, equal = caml_equal, equal_local = caml_equal;
    function max$2(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$2(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Int32_replace_polymorphic_comp = [
        0,
        symbol$12,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        symbol$17,
        ascending$1,
        descending$1,
        compare,
        compare_local,
        equal,
        equal_local,
        max$2,
        min$2
    ];
    function ascending$2(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$2(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    function max$3(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$3(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Int64_replace_polymorphic_comp = [
        0,
        ascending$2,
        descending$2,
        max$3,
        min$3
    ], symbol$18 = caml_lessthan, symbol$19 = caml_lessequal, symbol$20 = caml_notequal, symbol$21 = caml_equal, symbol$22 = caml_greaterthan, symbol$23 = caml_greaterequal;
    function ascending$3(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$3(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$0 = caml_int_compare, compare_local$0 = caml_int_compare, equal$0 = caml_equal, equal_local$0 = caml_equal;
    function max$4(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function min$4(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    var Nativeint_replace_polymorphic_ = [
        0,
        symbol$18,
        symbol$19,
        symbol$20,
        symbol$21,
        symbol$22,
        symbol$23,
        ascending$3,
        descending$3,
        compare$0,
        compare_local$0,
        equal$0,
        equal_local$0,
        max$4,
        min$4
    ];
    function symbol$24(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$25(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$26(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$27(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$28(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$29(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$4(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$4(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$1 = caml_int_compare, compare_local$1 = caml_int_compare;
    function equal$1(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local$1(x, y) {
        return x === y ? 1 : 0;
    }
    function max$5(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$5(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Bool_replace_polymorphic_compa = [
        0,
        symbol$24,
        symbol$25,
        symbol$26,
        symbol$27,
        symbol$28,
        symbol$29,
        ascending$4,
        descending$4,
        compare$1,
        compare_local$1,
        equal$1,
        equal_local$1,
        max$5,
        min$5
    ];
    function symbol$30(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$31(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$32(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$33(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$34(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$35(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$5(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$5(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$2 = caml_int_compare, compare_local$2 = caml_int_compare;
    function equal$2(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local$2(x, y) {
        return x === y ? 1 : 0;
    }
    function max$6(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$6(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Char_replace_polymorphic_compa = [
        0,
        symbol$30,
        symbol$31,
        symbol$32,
        symbol$33,
        symbol$34,
        symbol$35,
        ascending$5,
        descending$5,
        compare$2,
        compare_local$2,
        equal$2,
        equal_local$2,
        max$6,
        min$6
    ];
    function symbol$36(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$37(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$38(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$39(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$40(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$41(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending$6(x, y) {
        return caml_call2(Int_replace_polymorphic_compar[1], x, y);
    }
    function descending$6(x, y) {
        return caml_call2(Int_replace_polymorphic_compar[2], x, y);
    }
    var compare$3 = caml_int_compare;
    function equal$3(x, y) {
        return x === y ? 1 : 0;
    }
    var compare_local$3 = caml_int_compare;
    function equal_local$3(x, y) {
        return x === y ? 1 : 0;
    }
    function max$7(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$7(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Uchar_replace_polymorphic_comp = [
        0,
        symbol$36,
        symbol$37,
        symbol$38,
        symbol$39,
        symbol$40,
        symbol$41,
        ascending$6,
        descending$6,
        compare$3,
        equal$3,
        compare_local$3,
        equal_local$3,
        max$7,
        min$7
    ];
    function ascending$7(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$7(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare_local$4 = runtime.caml_float_compare;
    function equal_local$4(x, y) {
        return x === y ? 1 : 0;
    }
    function max$8(x, y) {
        return runtime.caml_csel_value(y <= x ? 1 : 0, x, y);
    }
    function min$8(x, y) {
        return runtime.caml_csel_value(x <= y ? 1 : 0, x, y);
    }
    var Float_replace_polymorphic_comp = [
        0,
        ascending$7,
        descending$7,
        compare_local$4,
        equal_local$4,
        max$8,
        min$8
    ], symbol$42 = runtime.caml_string_lessthan, symbol$43 = caml_string_lessequal, symbol$44 = runtime.caml_string_notequal, symbol$45 = caml_string_equal, symbol$46 = runtime.caml_string_greaterthan, symbol$47 = caml_string_greaterequal;
    function ascending$8(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$8(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$4 = caml_string_compare, compare_local$5 = caml_string_compare, equal$4 = caml_string_equal, equal_local$5 = caml_string_equal;
    function max$9(x, y) {
        return runtime.caml_csel_value(caml_string_greaterequal(x, y), x, y);
    }
    function min$9(x, y) {
        return runtime.caml_csel_value(caml_string_lessequal(x, y), x, y);
    }
    var String_replace_polymorphic_com = [
        0,
        symbol$42,
        symbol$43,
        symbol$44,
        symbol$45,
        symbol$46,
        symbol$47,
        ascending$8,
        descending$8,
        compare$4,
        compare_local$5,
        equal$4,
        equal_local$5,
        max$9,
        min$9
    ], symbol$48 = runtime.caml_bytes_lessthan, symbol$49 = caml_bytes_lessequal, symbol$50 = runtime.caml_bytes_notequal, symbol$51 = caml_bytes_equal, symbol$52 = runtime.caml_bytes_greaterthan, symbol$53 = caml_bytes_greaterequal;
    function ascending$9(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending$9(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$5 = caml_bytes_compare, compare_local$6 = caml_bytes_compare, equal$5 = caml_bytes_equal, equal_local$6 = caml_bytes_equal;
    function max$10(x, y) {
        return runtime.caml_csel_value(caml_bytes_greaterequal(x, y), x, y);
    }
    function min$10(x, y) {
        return runtime.caml_csel_value(caml_bytes_lessequal(x, y), x, y);
    }
    var Bytes_replace_polymorphic_comp = [
        0,
        symbol$48,
        symbol$49,
        symbol$50,
        symbol$51,
        symbol$52,
        symbol$53,
        ascending$9,
        descending$9,
        compare$5,
        compare_local$6,
        equal$5,
        equal_local$6,
        max$10,
        min$10
    ], symbol$54 = Stdlib$0[37], symbol_concat$0 = Stdlib$0[28];
    function symbol$55(_p_) {
        return -_p_ | 0;
    }
    function symbol$56(_o_) {
        return -_o_;
    }
    function asr(_n_, _m_) {
        return _n_ >> _m_;
    }
    function land(_l_, _k_) {
        return _l_ & _k_;
    }
    var lnot$0 = Stdlib$0[21];
    function lor(_j_, _i_) {
        return _j_ | _i_;
    }
    function lsl(_h_, _g_) {
        return _h_ << _g_;
    }
    function lsr(_f_, _e_) {
        return _f_ >>> _e_ | 0;
    }
    function lxor(_d_, _c_) {
        return _d_ ^ _c_;
    }
    var mod = runtime.caml_mod, abs$0 = Stdlib$0[18], failwith$0 = Stdlib$0[2];
    function fst(_b_) {
        return _b_[1];
    }
    var invalid_arg$0 = Stdlib$0[1];
    function snd(_a_) {
        return _a_[2];
    }
    var float_of_string = runtime.caml_float_of_string, am_testing = runtime.Base_am_testing(0), Base_Import0 = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Stdlib$0,
        bool_to_int,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        symbol$9,
        symbol$10,
        symbol$11,
        Int_replace_polymorphic_compar,
        ascending$0,
        descending$0,
        max$1,
        min$1,
        Int32_replace_polymorphic_comp,
        Int64_replace_polymorphic_comp,
        Nativeint_replace_polymorphic_,
        Bool_replace_polymorphic_compa,
        Char_replace_polymorphic_compa,
        Uchar_replace_polymorphic_comp,
        Float_replace_polymorphic_comp,
        String_replace_polymorphic_com,
        Bytes_replace_polymorphic_comp,
        symbol$54,
        symbol_concat$0,
        symbol$55,
        symbol$56,
        asr,
        land,
        lnot$0,
        lor,
        lsl,
        lsr,
        lxor,
        mod,
        abs$0,
        failwith$0,
        fst,
        invalid_arg$0,
        snd,
        float_of_string,
        am_testing
    ];
    runtime.caml_register_global(4, Base_Import0, "Base__Import0");
    return;
})(globalThis);
//# 870 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, to_string = Stdlib[33], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib[34];
    function to_float(_d_) {
        return _d_;
    }
    function of_float(_c_) {
        return _c_ | 0;
    }
    var max_value = Stdlib[19], min_value = Stdlib[20];
    function succ(_b_) {
        return _b_ + 1 | 0;
    }
    function pred(_a_) {
        return _a_ - 1 | 0;
    }
    var Base_Int0 = [
        0,
        to_string,
        of_string,
        of_string_opt,
        to_float,
        of_float,
        max_value,
        min_value,
        succ,
        pred
    ];
    runtime.caml_register_global(1, Base_Int0, "Base__Int0");
    return;
})(globalThis);
//# 904 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Stdlib_Printf = global_data.Stdlib__Printf, sprintf = Stdlib_Printf[4], bprintf = Stdlib_Printf[5], ifprintf = Stdlib_Printf[6], ksprintf = Stdlib_Printf[10], kbprintf = Stdlib_Printf[11];
    function failwithf(fmt) {
        return caml_call2(ksprintf, function(s, param) {
            return caml_call1(Base_Import0[124], s);
        }, fmt);
    }
    function invalid_argf(fmt) {
        return caml_call2(ksprintf, function(s, param) {
            return caml_call1(Base_Import0[126], s);
        }, fmt);
    }
    var Base_Printf = [
        0,
        ifprintf,
        sprintf,
        bprintf,
        ksprintf,
        kbprintf,
        failwithf,
        invalid_argf
    ];
    runtime.caml_register_global(2, Base_Printf, "Base__Printf");
    return;
})(globalThis);
//# 956 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_sys_argv = runtime.caml_sys_argv, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Printf = global_data.Base__Printf, Stdlib_Sys = global_data.Stdlib__Sys, backend_type = Stdlib_Sys[5], interactive = Stdlib_Sys[3], os_type = Stdlib_Sys[4], unix = Stdlib_Sys[6], win32 = Stdlib_Sys[7], cygwin = Stdlib_Sys[8], word_size_in_bits = Stdlib_Sys[9], int_size_in_bits = Stdlib_Sys[10], big_endian = Stdlib_Sys[11], max_string_length = Stdlib_Sys[12], max_array_length = Stdlib_Sys[13], runtime_variant = runtime.caml_runtime_variant, runtime_parameters = runtime.caml_runtime_parameters, argv = caml_sys_argv(0);
    function get_argv(param) {
        return caml_sys_argv(0);
    }
    var ocaml_version = Stdlib_Sys[46], enable_runtime_warnings = Stdlib_Sys[49], runtime_warnings_enabled = Stdlib_Sys[50], _a_ = [
        0,
        [
            11,
            "Sys.getenv_exn: environment variable ",
            [
                2,
                0,
                [
                    11,
                    " is not set",
                    0
                ]
            ]
        ],
        "Sys.getenv_exn: environment variable %s is not set"
    ];
    function Make_immediate64(_h_, _g_) {
        return caml_call1(caml_call1(Stdlib_Sys[51][1], _h_), _g_);
    }
    function getenv_exn(var$0) {
        try {
            var _e_ = caml_sys_getenv(var$0);
            return _e_;
        } catch (_f_) {
            var _d_ = caml_wrap_exception(_f_);
            if (_d_ === Base_Import0[85][8]) return caml_call3(Base_Printf[6], _a_, var$0, 0);
            throw caml_maybe_attach_backtrace(_d_, 0);
        }
    }
    function getenv(var$0) {
        try {
            var x = caml_sys_getenv(var$0);
        } catch (_c_) {
            var _b_ = caml_wrap_exception(_c_);
            if (_b_ === Base_Import0[85][8]) return 0;
            throw caml_maybe_attach_backtrace(_b_, 0);
        }
        return [
            0,
            x
        ];
    }
    var Break = Stdlib_Sys[44], Base_Sys0 = [
        0,
        backend_type,
        interactive,
        os_type,
        unix,
        win32,
        cygwin,
        word_size_in_bits,
        int_size_in_bits,
        big_endian,
        max_string_length,
        max_array_length,
        runtime_variant,
        runtime_parameters,
        argv,
        get_argv,
        ocaml_version,
        enable_runtime_warnings,
        runtime_warnings_enabled,
        Make_immediate64,
        getenv_exn,
        getenv,
        Break
    ];
    runtime.caml_register_global(4, Base_Sys0, "Base__Sys0");
    return;
})(globalThis);
//# 1059 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_make_vect = runtime.caml_make_vect;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_ArrayLabels = global_data.Stdlib__ArrayLabels, Base_Import0 = global_data.Base__Import0, Base_Int0 = global_data.Base__Int0;
    global_data.Stdlib;
    var Base_Printf = global_data.Base__Printf, Base_Sys0 = global_data.Base__Sys0, invalid_argf = Base_Printf[7], Array1 = [
        0
    ], max_length = Base_Sys0[11];
    function create(len, x) {
        return caml_make_vect(len, x);
    }
    function create_local(len, x) {
        return caml_make_vect(len, x);
    }
    function create_float_uninitialized(len) {
        return runtime.caml_make_float_vect(len);
    }
    var append = Stdlib_ArrayLabels[4], blit = Stdlib_ArrayLabels[9], concat = Stdlib_ArrayLabels[5], copy = Stdlib_ArrayLabels[7], fill = Stdlib_ArrayLabels[8], cst_Array_init = "Array.init";
    function init(len, f) {
        if (0 === len) return [
            0
        ];
        if (0 > len) return caml_call1(Base_Import0[126], cst_Array_init);
        var x = caml_call1(f, 0), res = caml_make_vect(len, x), _s_ = caml_call1(Base_Int0[9], len), _r_ = 1;
        if (_s_ >= 1) {
            var i = _r_;
            for(;;){
                res[1 + i] = caml_call1(f, i);
                var _t_ = i + 1 | 0;
                if (_s_ === i) break;
                i = _t_;
            }
        }
        return res;
    }
    var make_matrix = Stdlib_ArrayLabels[2], of_list = Stdlib_ArrayLabels[11], sub = Stdlib_ArrayLabels[6], to_list = Stdlib_ArrayLabels[10];
    function fold(t, init, f) {
        var r = [
            0,
            init
        ], _p_ = caml_call2(Base_Import0[93], t.length - 1, 1), _o_ = 0;
        if (_p_ >= 0) {
            var i = _o_;
            for(;;){
                r[1] = caml_call2(f, r[1], t[1 + i]);
                var _q_ = i + 1 | 0;
                if (_p_ === i) break;
                i = _q_;
            }
        }
        return r[1];
    }
    function fold_right(t, f, init) {
        var r = [
            0,
            init
        ], _m_ = caml_call2(Base_Import0[93], t.length - 1, 1);
        if (_m_ >= 0) {
            var i = _m_;
            for(;;){
                r[1] = caml_call2(f, t[1 + i], r[1]);
                var _n_ = i - 1 | 0;
                if (0 === i) break;
                i = _n_;
            }
        }
        return r[1];
    }
    function iter(t, f) {
        var _k_ = caml_call2(Base_Import0[93], t.length - 1, 1), _j_ = 0;
        if (_k_ >= 0) {
            var i = _j_;
            for(;;){
                caml_call1(f, t[1 + i]);
                var _l_ = i + 1 | 0;
                if (_k_ === i) break;
                i = _l_;
            }
        }
        return 0;
    }
    function iteri(t, f) {
        var _h_ = caml_call2(Base_Import0[93], t.length - 1, 1), _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                caml_call2(f, i, t[1 + i]);
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return 0;
    }
    function map(t, f) {
        var len = t.length - 1;
        if (0 === len) return [
            0
        ];
        var x = caml_call1(f, t[1]), r = caml_make_vect(len, x), _e_ = caml_call2(Base_Import0[93], len, 1), _d_ = 1;
        if (_e_ >= 1) {
            var i = _d_;
            for(;;){
                r[1 + i] = caml_call1(f, t[1 + i]);
                var _f_ = i + 1 | 0;
                if (_e_ === i) break;
                i = _f_;
            }
        }
        return r;
    }
    function mapi(t, f) {
        var len = t.length - 1;
        if (0 === len) return [
            0
        ];
        var x = caml_call2(f, 0, t[1]), r = caml_make_vect(len, x), _b_ = caml_call2(Base_Import0[93], len, 1), _a_ = 1;
        if (_b_ >= 1) {
            var i = _a_;
            for(;;){
                r[1 + i] = caml_call2(f, i, t[1 + i]);
                var _c_ = i + 1 | 0;
                if (_b_ === i) break;
                i = _c_;
            }
        }
        return r;
    }
    function stable_sort(t, compare) {
        return caml_call2(Stdlib_ArrayLabels[36], compare, t);
    }
    function swap(t, i, j) {
        var elt_i = caml_check_bound(t, i)[1 + i], elt_j = caml_check_bound(t, j)[1 + j];
        t[1 + i] = elt_j;
        t[1 + j] = elt_i;
        return 0;
    }
    var Base_Array0 = [
        0,
        invalid_argf,
        Array1,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        append,
        blit,
        concat,
        copy,
        fill,
        init,
        make_matrix,
        of_list,
        sub,
        to_list,
        fold,
        fold_right,
        iter,
        iteri,
        map,
        mapi,
        stable_sort,
        swap
    ];
    runtime.caml_register_global(10, Base_Array0, "Base__Array0");
    return;
})(globalThis);
//# 1262 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Printf = global_data.Base__Printf, Stdlib_Char = global_data.Stdlib__Char, failwithf = Base_Printf[6], escaped = Stdlib_Char[2], lowercase = Stdlib_Char[3];
    function to_int(_e_) {
        return _e_;
    }
    function unsafe_of_int(_d_) {
        return _d_;
    }
    var uppercase = Stdlib_Char[4];
    function int_is_ok(i) {
        var _b_ = 0 <= i ? 1 : 0, _c_ = _b_ ? i <= 255 ? 1 : 0 : _b_;
        return _c_;
    }
    var _a_ = [
        0,
        [
            11,
            "Char.of_int_exn got integer out of range: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Char.of_int_exn got integer out of range: %d"
    ];
    function of_int(i) {
        return int_is_ok(i) ? [
            0,
            i
        ] : 0;
    }
    function of_int_exn(i) {
        return int_is_ok(i) ? i : caml_call3(failwithf, _a_, i, 0);
    }
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var Base_Char0 = [
        0,
        failwithf,
        escaped,
        lowercase,
        to_int,
        unsafe_of_int,
        uppercase,
        int_is_ok,
        0,
        255,
        of_int,
        of_int_exn,
        equal
    ];
    runtime.caml_register_global(3, Base_Char0, "Base__Char0");
    return;
})(globalThis);
//# 1316 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Hash_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Hash_intf, "Base__Hash_intf");
    return;
})(globalThis);
//# 1326 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Stdlib_ListLabels = global_data.Stdlib__ListLabels, hd_exn = Stdlib_ListLabels[6], rev_append = Stdlib_ListLabels[13], tl_exn = Stdlib_ListLabels[7], unzip = Stdlib_ListLabels[61], cst_List_exists2 = "List.exists2", cst_List_fold_left2 = "List.fold_left2", cst_List_for_all2 = "List.for_all2", cst_List_iter2 = "List.iter2", cst_List_rev_map2 = "List.rev_map2";
    function length(l$0) {
        var len = 0, param = l$0;
        for(;;){
            if (!param) return len;
            var l = param[2], len$0 = caml_call2(Base_Import0[91], len, 1);
            len = len$0;
            param = l;
        }
    }
    function exists(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var xs = t$0[2], x = t$0[1];
            if (caml_call1(f, x)) return 1;
            t$0 = xs;
        }
    }
    function exists2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _c_ = caml_call2(f, a1, a2);
                    if (_c_) return _c_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Base_Import0[126], cst_List_exists2);
        }
    }
    function fold(t, init, f) {
        var t$0 = t, init$0 = init;
        for(;;){
            if (!t$0) return init$0;
            var l = t$0[2], a = t$0[1], init$1 = caml_call2(f, init$0, a);
            t$0 = l;
            init$0 = init$1;
        }
    }
    function fold2_ok(l1, l2, init, f) {
        var l1$0 = l1, l2$0 = l2, init$0 = init;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], init$1 = caml_call3(f, init$0, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    init$0 = init$1;
                    continue;
                }
            } else if (!l2$0) return init$0;
            return caml_call1(Base_Import0[126], cst_List_fold_left2);
        }
    }
    function for_all(t, f) {
        return 1 - exists(t, function(x) {
            return 1 - caml_call1(f, x);
        });
    }
    function for_all2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1], _b_ = caml_call2(f, a1, a2);
                    if (!_b_) return _b_;
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 1;
            return caml_call1(Base_Import0[126], cst_List_for_all2);
        }
    }
    function iter(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], a = t$0[1];
            caml_call1(f, a);
            t$0 = l;
        }
    }
    function iter2_ok(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (l1$0) {
                if (l2$0) {
                    var l2$1 = l2$0[2], a2 = l2$0[1], l1$1 = l1$0[2], a1 = l1$0[1];
                    caml_call2(f, a1, a2);
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    continue;
                }
            } else if (!l2$0) return 0;
            return caml_call1(Base_Import0[126], cst_List_iter2);
        }
    }
    function nontail_map(t, f) {
        if (!t) return 0;
        var xs = t[2], x = t[1], y = caml_call1(f, x);
        return [
            0,
            y,
            nontail_map(xs, f)
        ];
    }
    function nontail_mapi(t, f) {
        return caml_call2(Stdlib_ListLabels[21], f, t);
    }
    function partition(t, f) {
        return caml_call2(Stdlib_ListLabels[51], f, t);
    }
    function rev_map(l$0, f) {
        var accu = 0, param = l$0;
        for(;;){
            if (!param) return accu;
            var l = param[2], a = param[1], accu$0 = [
                0,
                caml_call1(f, a),
                accu
            ];
            accu = accu$0;
            param = l;
        }
    }
    function rev_map2_ok(l1$1, l2$1, f) {
        var accu = 0, l1 = l1$1, l2 = l2$1;
        for(;;){
            if (l1) {
                if (l2) {
                    var l2$0 = l2[2], a2 = l2[1], l1$0 = l1[2], a1 = l1[1], accu$0 = [
                        0,
                        caml_call2(f, a1, a2),
                        accu
                    ];
                    accu = accu$0;
                    l1 = l1$0;
                    l2 = l2$0;
                    continue;
                }
            } else if (!l2) return accu;
            return caml_call1(Base_Import0[126], cst_List_rev_map2);
        }
    }
    function rev(res) {
        if (res) {
            var match = res[2];
            if (match) {
                var rest = match[2], y = match[1], x = res[1];
                return caml_call2(rev_append, rest, [
                    0,
                    y,
                    [
                        0,
                        x,
                        0
                    ]
                ]);
            }
        }
        return res;
    }
    function fold_right(l, f, init) {
        return l ? fold(rev(l), init, function(a, b) {
            return caml_call2(f, b, a);
        }) : init;
    }
    function fold_right2_ok(l1, l2, f, init) {
        if (!l1 && !l2) return init;
        var _a_ = rev(l2);
        return fold2_ok(rev(l1), _a_, init, function(a, b, c) {
            return caml_call3(f, b, c, a);
        });
    }
    var Base_List0 = [
        0,
        hd_exn,
        rev_append,
        tl_exn,
        unzip,
        length,
        exists,
        exists2_ok,
        fold,
        fold2_ok,
        for_all,
        for_all2_ok,
        iter,
        iter2_ok,
        nontail_map,
        nontail_mapi,
        partition,
        rev_map,
        rev_map2_ok,
        rev,
        fold_right,
        fold_right2_ok
    ];
    runtime.caml_register_global(7, Base_List0, "Base__List0");
    return;
})(globalThis);
//# 1570 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), description = "internalhash", Base_Import0 = global_data.Base__Import0, Base_Int0 = global_data.Base__Int0, CamlinternalLazy = global_data.CamlinternalLazy, Base_List0 = global_data.Base__List0, Base_Char0 = global_data.Base__Char0;
    function Folding(Hash) {
        function hash_fold_unit(s, param) {
            return s;
        }
        var hash_fold_int = Hash[2], hash_fold_int64 = Hash[3], hash_fold_float = Hash[4], hash_fold_string = Hash[5];
        function as_int(f, s, x) {
            return caml_call2(hash_fold_int, s, caml_call1(f, x));
        }
        function _H_(_ah_) {
            return _ah_;
        }
        function hash_fold_int32(_af_, _ag_) {
            return as_int(_H_, _af_, _ag_);
        }
        var _I_ = Base_Char0[4];
        function hash_fold_char(_ad_, _ae_) {
            return as_int(_I_, _ad_, _ae_);
        }
        function _J_(param) {
            return param ? 1 : 0;
        }
        function hash_fold_bool(_ab_, _ac_) {
            return as_int(_J_, _ab_, _ac_);
        }
        function hash_fold_nativeint(s, x) {
            return caml_call2(hash_fold_int64, s, runtime.caml_int64_of_int32(x));
        }
        function hash_fold_option(hash_fold_elem, s, param) {
            if (!param) return caml_call2(hash_fold_int, s, 0);
            var x = param[1];
            return caml_call2(hash_fold_elem, caml_call2(hash_fold_int, s, 1), x);
        }
        function hash_fold_list(hash_fold_elem, s$1, list$1) {
            var s$2 = caml_call2(hash_fold_int, s$1, caml_call1(Base_List0[5], list$1)), s = s$2, list = list$1;
            for(;;){
                if (!list) return s;
                var list$0 = list[2], x = list[1], s$0 = caml_call2(hash_fold_elem, s, x);
                s = s$0;
                list = list$0;
            }
        }
        function hash_fold_lazy_t(hash_fold_elem, s, x) {
            var _$_ = runtime.caml_obj_tag(x);
            a: if (250 === _$_) var _aa_ = x[1];
            else {
                if (246 !== _$_ && 244 !== _$_) {
                    var _aa_ = x;
                    break a;
                }
                var _aa_ = caml_call1(CamlinternalLazy[2], x);
            }
            return caml_call2(hash_fold_elem, s, _aa_);
        }
        function hash_fold_ref_frozen(hash_fold_elem, s, x) {
            return caml_call2(hash_fold_elem, s, x[1]);
        }
        function hash_fold_array_frozen(hash_fold_elem, s$1, array) {
            var s$2 = caml_call2(hash_fold_int, s$1, array.length - 1), s = s$2, i = 0;
            for(;;){
                if (i === array.length - 1) return s;
                var e = array[1 + i], i$0 = caml_call2(Base_Import0[91], i, 1), s$0 = caml_call2(hash_fold_elem, s, e);
                s = s$0;
                i = i$0;
            }
        }
        function hash_nativeint(x) {
            var _Z_ = caml_call1(Hash[6], 0), ___ = hash_fold_nativeint(caml_call2(Hash[7], 0, _Z_), x);
            return caml_call1(Hash[8], ___);
        }
        function hash_int64(x) {
            var _X_ = caml_call1(Hash[6], 0), _Y_ = caml_call2(hash_fold_int64, caml_call2(Hash[7], 0, _X_), x);
            return caml_call1(Hash[8], _Y_);
        }
        function hash_int32(x) {
            var _V_ = caml_call1(Hash[6], 0), _W_ = as_int(_H_, caml_call2(Hash[7], 0, _V_), x);
            return caml_call1(Hash[8], _W_);
        }
        function hash_char(x) {
            var _T_1 = caml_call1(Hash[6], 0), _U_ = as_int(_I_, caml_call2(Hash[7], 0, _T_1), x);
            return caml_call1(Hash[8], _U_);
        }
        function hash_int(x) {
            var _R_ = caml_call1(Hash[6], 0), _S_ = caml_call2(hash_fold_int, caml_call2(Hash[7], 0, _R_), x);
            return caml_call1(Hash[8], _S_);
        }
        function hash_bool(x) {
            var _P_ = caml_call1(Hash[6], 0), _Q_ = as_int(_J_, caml_call2(Hash[7], 0, _P_), x);
            return caml_call1(Hash[8], _Q_);
        }
        function hash_string(x) {
            var _N_ = caml_call1(Hash[6], 0), _O_ = caml_call2(hash_fold_string, caml_call2(Hash[7], 0, _N_), x);
            return caml_call1(Hash[8], _O_);
        }
        function hash_float(x) {
            var _L_ = caml_call1(Hash[6], 0), _M_ = caml_call2(hash_fold_float, caml_call2(Hash[7], 0, _L_), x);
            return caml_call1(Hash[8], _M_);
        }
        function hash_unit(x) {
            var _K_ = caml_call1(Hash[6], 0), s = caml_call2(Hash[7], 0, _K_);
            return caml_call1(Hash[8], s);
        }
        return [
            0,
            hash_fold_nativeint,
            hash_fold_int64,
            hash_fold_int32,
            hash_fold_char,
            hash_fold_int,
            hash_fold_bool,
            hash_fold_string,
            hash_fold_float,
            hash_fold_unit,
            hash_fold_option,
            hash_fold_list,
            hash_fold_lazy_t,
            hash_fold_ref_frozen,
            hash_fold_array_frozen,
            hash_nativeint,
            hash_int64,
            hash_int32,
            hash_char,
            hash_int,
            hash_bool,
            hash_string,
            hash_float,
            hash_unit
        ];
    }
    function F(Hash) {
        var description = Hash[1], fold_int = Hash[2], fold_int64 = Hash[3], fold_float = Hash[4], fold_string = Hash[5], alloc = Hash[6], reset = Hash[7], get_hash_value = Hash[8], For_tests = Hash[9];
        function create(seed, param) {
            return caml_call2(reset, seed, caml_call1(alloc, 0));
        }
        function of_fold(hash_fold_t, t) {
            return caml_call1(get_hash_value, caml_call2(hash_fold_t, create(0, 0), t));
        }
        var Builtin = Folding(Hash);
        function run(seed, folder, x) {
            var _F_ = caml_call1(Hash[6], 0), _G_ = caml_call2(folder, caml_call2(Hash[7], seed, _F_), x);
            return caml_call1(Hash[8], _G_);
        }
        return [
            0,
            description,
            fold_int,
            fold_int64,
            fold_float,
            fold_string,
            alloc,
            reset,
            get_hash_value,
            For_tests,
            create,
            of_fold,
            Builtin,
            run
        ];
    }
    function alloc(param) {
        return 0;
    }
    function reset(opt, t) {
        var seed = opt ? opt[1] : 0;
        return seed;
    }
    var compare_state = runtime.caml_int_compare;
    function state_to_string(state) {
        return caml_call1(Base_Int0[1], state);
    }
    var For_tests = [
        0,
        compare_state,
        state_to_string
    ];
    function create(seed, param) {
        return reset(seed, 0);
    }
    function run(seed, folder, x) {
        return runtime.Base_internalhash_get_hash_value(caml_call2(folder, reset(seed, 0), x));
    }
    function of_fold(hash_fold_t, t) {
        return runtime.Base_internalhash_get_hash_value(caml_call2(hash_fold_t, create(0, 0), t));
    }
    var Folding$0 = Folding([
        0,
        description,
        function(_E_, _D_) {
            return runtime.Base_internalhash_fold_int(_E_, _D_);
        },
        function(_C_, _B_) {
            return runtime.Base_internalhash_fold_int64(_C_, _B_);
        },
        function(_A_, _z_) {
            return runtime.Base_internalhash_fold_float(_A_, _z_);
        },
        function(_y_, _x_) {
            return runtime.Base_internalhash_fold_string(_y_, _x_);
        },
        alloc,
        reset,
        function(_w_) {
            return runtime.Base_internalhash_get_hash_value(_w_);
        },
        For_tests
    ]), hash_fold_nativeint = Folding$0[1], hash_fold_int64 = Folding$0[2], hash_fold_int32 = Folding$0[3], hash_fold_char = Folding$0[4], hash_fold_int = Folding$0[5], hash_fold_bool = Folding$0[6], hash_fold_string = Folding$0[7], hash_fold_float = Folding$0[8], hash_fold_unit = Folding$0[9], hash_fold_option = Folding$0[10], hash_fold_list = Folding$0[11], hash_fold_lazy_t = Folding$0[12], hash_fold_ref_frozen = Folding$0[13], hash_fold_array_frozen = Folding$0[14], hash_nativeint = Folding$0[15], hash_int64 = Folding$0[16], hash_int32 = Folding$0[17], hash_string = Folding$0[21], hash_char = Base_Char0[4];
    function hash_int(t) {
        var _k_ = caml_call2(Base_Import0[119], t, 21), _l_ = caml_call1(Base_Import0[117], t), t$0 = caml_call2(Base_Import0[91], _l_, _k_), _m_ = caml_call2(Base_Import0[120], t$0, 24), t$1 = caml_call2(Base_Import0[121], t$0, _m_), _n_ = caml_call2(Base_Import0[119], t$1, 8), _o_ = caml_call2(Base_Import0[119], t$1, 3), _p_ = caml_call2(Base_Import0[91], t$1, _o_), t$2 = caml_call2(Base_Import0[91], _p_, _n_), _q_ = caml_call2(Base_Import0[120], t$2, 14), t$3 = caml_call2(Base_Import0[121], t$2, _q_), _r_ = caml_call2(Base_Import0[119], t$3, 4), _s_ = caml_call2(Base_Import0[119], t$3, 2), _t_ = caml_call2(Base_Import0[91], t$3, _s_), t$4 = caml_call2(Base_Import0[91], _t_, _r_), _u_ = caml_call2(Base_Import0[120], t$4, 28), t$5 = caml_call2(Base_Import0[121], t$4, _u_), _v_ = caml_call2(Base_Import0[119], t$5, 31);
        return caml_call2(Base_Import0[91], t$5, _v_);
    }
    function hash_bool(x) {
        return x ? 1 : 0;
    }
    function hash_unit(param) {
        return 0;
    }
    var Base_Hash = [
        0,
        F,
        description,
        function(_j_, _i_) {
            return runtime.Base_internalhash_fold_int(_j_, _i_);
        },
        function(_h_, _g_) {
            return runtime.Base_internalhash_fold_int64(_h_, _g_);
        },
        function(_f_, _e_) {
            return runtime.Base_internalhash_fold_float(_f_, _e_);
        },
        function(_d_, _c_) {
            return runtime.Base_internalhash_fold_string(_d_, _c_);
        },
        alloc,
        reset,
        function(_b_) {
            return runtime.Base_internalhash_get_hash_value(_b_);
        },
        For_tests,
        create,
        of_fold,
        [
            0,
            hash_fold_nativeint,
            hash_fold_int64,
            hash_fold_int32,
            hash_fold_char,
            hash_fold_int,
            hash_fold_bool,
            hash_fold_string,
            hash_fold_float,
            hash_fold_unit,
            hash_fold_option,
            hash_fold_list,
            hash_fold_lazy_t,
            hash_fold_ref_frozen,
            hash_fold_array_frozen,
            hash_nativeint,
            hash_int64,
            hash_int32,
            hash_char,
            hash_int,
            hash_bool,
            hash_string,
            function(_a_) {
                return runtime.Base_hash_double(_a_);
            },
            hash_unit
        ],
        run
    ];
    runtime.caml_register_global(6, Base_Hash, "Base__Hash");
    return;
})(globalThis);
//# 1909 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_which_is_abstract_in_an_im = ", which is abstract in an implementation.", caml_bytes_compare = runtime.caml_bytes_compare, caml_bytes_equal = runtime.caml_bytes_equal, caml_equal = runtime.caml_equal, caml_float_compare = runtime.caml_float_compare, caml_int64_compare = runtime.caml_int64_compare, caml_int_compare = runtime.caml_int_compare, caml_string_compare = runtime.caml_string_compare, caml_string_equal = runtime.caml_string_equal;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Printf = global_data.Base__Printf, _a_ = [
        0,
        [
            11,
            "Compare called on the type ",
            [
                2,
                0,
                [
                    11,
                    cst_which_is_abstract_in_an_im,
                    0
                ]
            ]
        ],
        "Compare called on the type %s, which is abstract in an implementation."
    ], _b_ = [
        0,
        [
            11,
            "Equal called on the type ",
            [
                2,
                0,
                [
                    11,
                    cst_which_is_abstract_in_an_im,
                    0
                ]
            ]
        ],
        "Equal called on the type %s, which is abstract in an implementation."
    ];
    function compare_abstract(type_name, _F_, param) {
        return caml_call3(Base_Printf[4], Base_Import0[124], _a_, type_name);
    }
    function equal_abstract(type_name, _E_, param) {
        return caml_call3(Base_Printf[4], Base_Import0[124], _b_, type_name);
    }
    var Comparable = [
        0
    ], Equal = [
        0
    ], compare_bool = caml_int_compare, compare_bool_local = caml_int_compare, compare_char = caml_int_compare, compare_char_local = caml_int_compare, compare_float = caml_float_compare, compare_float_local = caml_float_compare, compare_int = caml_int_compare, compare_int_local = caml_int_compare, compare_int32 = caml_int_compare, compare_int32_local = caml_int_compare;
    function compare_int64(_D_, _C_) {
        return caml_int64_compare(_D_, _C_);
    }
    function compare_int64_local(_B_, _A_) {
        return caml_int64_compare(_B_, _A_);
    }
    var compare_nativeint = caml_int_compare, compare_nativeint_local = caml_int_compare, compare_string = caml_string_compare, compare_string_local = caml_string_compare, compare_bytes = caml_bytes_compare, compare_bytes_local = caml_bytes_compare, compare_unit = caml_int_compare, compare_unit_local = caml_int_compare;
    function compare_array_local(compare_elt, a, b) {
        if (a === b) return 0;
        var len_a = a.length - 1, len_b = b.length - 1, ret = caml_int_compare(len_a, len_b);
        if (0 !== ret) return ret;
        var i = 0;
        for(;;){
            if (i === len_a) return 0;
            var l = a[1 + i], r = b[1 + i], res = caml_call2(compare_elt, l, r);
            if (0 !== res) return res;
            var i$0 = caml_call2(Base_Import0[91], i, 1);
            i = i$0;
        }
    }
    function compare_array(compare_elt, a, b) {
        return compare_array_local(compare_elt, a, b);
    }
    function compare_list(compare_elt, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], res = caml_call2(compare_elt, x, y);
            if (0 !== res) return res;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_list_local(compare_elt_local, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], res = caml_call2(compare_elt_local, x, y);
            if (0 !== res) return res;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_option(compare_elt, a, b) {
        if (!a) return b ? -1 : 0;
        var a$0 = a[1];
        if (!b) return 1;
        var b$0 = b[1];
        return caml_call2(compare_elt, a$0, b$0);
    }
    function compare_option_local(compare_elt_local, a, b) {
        if (!a) return b ? -1 : 0;
        var a$0 = a[1];
        if (!b) return 1;
        var b$0 = b[1];
        return caml_call2(compare_elt_local, a$0, b$0);
    }
    function compare_ref(compare_elt, a, b) {
        return caml_call2(compare_elt, a[1], b[1]);
    }
    function compare_ref_local(compare_elt, a, b) {
        return caml_call2(compare_elt, a[1], b[1]);
    }
    function equal_bool(_z_, _y_) {
        return _z_ === _y_ ? 1 : 0;
    }
    function equal_bool_local(_x_, _w_) {
        return _x_ === _w_ ? 1 : 0;
    }
    function equal_char(_v_, _u_) {
        return _v_ === _u_ ? 1 : 0;
    }
    function equal_char_local(_t_, _s_) {
        return _t_ === _s_ ? 1 : 0;
    }
    function equal_int(_r_, _q_) {
        return _r_ === _q_ ? 1 : 0;
    }
    function equal_int_local(_p_, _o_) {
        return _p_ === _o_ ? 1 : 0;
    }
    var equal_int32 = caml_equal, equal_int32_local = caml_equal, equal_int64 = caml_equal, equal_int64_local = caml_equal, equal_nativeint = caml_equal, equal_nativeint_local = caml_equal, equal_string = caml_string_equal, equal_string_local = caml_string_equal, equal_bytes = caml_bytes_equal, equal_bytes_local = caml_bytes_equal;
    function equal_unit(_n_, _m_) {
        return _n_ === _m_ ? 1 : 0;
    }
    function equal_unit_local(_l_, _k_) {
        return _l_ === _k_ ? 1 : 0;
    }
    function equal_float(x, y) {
        return caml_float_compare(x, y) === 0 ? 1 : 0;
    }
    function equal_float_local(x, y) {
        return caml_float_compare(x, y) === 0 ? 1 : 0;
    }
    function equal_array_local(equal_elt, a, b) {
        var _e_ = a === b ? 1 : 0;
        if (_e_) var _f_ = _e_;
        else {
            var len_a = a.length - 1, len_b = b.length - 1, _g_ = len_a === len_b ? 1 : 0;
            if (_g_) {
                var i = 0;
                for(;;){
                    var _h_ = i === len_a ? 1 : 0;
                    if (_h_) var _i_ = _h_;
                    else {
                        var l = a[1 + i], r = b[1 + i], _j_ = caml_call2(equal_elt, l, r);
                        if (_j_) {
                            var i$0 = caml_call2(Base_Import0[91], i, 1);
                            i = i$0;
                            continue;
                        }
                        var _i_ = _j_;
                    }
                    return _i_;
                }
            }
            var _f_ = _g_;
        }
        return _f_;
    }
    function equal_array(equal_elt, a, b) {
        return equal_array_local(equal_elt, a, b);
    }
    function equal_list(equal_elt, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (a$0) {
                if (b$0) {
                    var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], _d_ = caml_call2(equal_elt, x, y);
                    if (!_d_) return _d_;
                    a$0 = xs;
                    b$0 = ys;
                    continue;
                }
            } else if (!b$0) return 1;
            return 0;
        }
    }
    function equal_list_local(equal_elt_local, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (a$0) {
                if (b$0) {
                    var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], _c_ = caml_call2(equal_elt_local, x, y);
                    if (!_c_) return _c_;
                    a$0 = xs;
                    b$0 = ys;
                    continue;
                }
            } else if (!b$0) return 1;
            return 0;
        }
    }
    function equal_option(equal_elt, a, b) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return caml_call2(equal_elt, a$0, b$0);
            }
        } else if (!b) return 1;
        return 0;
    }
    function equal_option_local(equal_elt_local, a, b) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return caml_call2(equal_elt_local, a$0, b$0);
            }
        } else if (!b) return 1;
        return 0;
    }
    function equal_ref(equal_elt, a, b) {
        return caml_call2(equal_elt, a[1], b[1]);
    }
    function equal_ref_local(equal_elt, a, b) {
        return caml_call2(equal_elt, a[1], b[1]);
    }
    var Base_Ppx_compare_lib = [
        0,
        compare_abstract,
        equal_abstract,
        Comparable,
        Equal,
        [
            0,
            compare_bool,
            compare_char,
            compare_float,
            compare_int,
            compare_int32,
            compare_int64,
            compare_nativeint,
            compare_string,
            compare_bytes,
            compare_unit,
            compare_array,
            compare_list,
            compare_option,
            compare_ref,
            equal_bool,
            equal_char,
            equal_float,
            equal_int,
            equal_int32,
            equal_int64,
            equal_nativeint,
            equal_string,
            equal_bytes,
            equal_unit,
            equal_array,
            equal_list,
            equal_option,
            equal_ref,
            compare_bool_local,
            compare_char_local,
            compare_float_local,
            compare_int_local,
            compare_int32_local,
            compare_int64_local,
            compare_nativeint_local,
            compare_string_local,
            compare_bytes_local,
            compare_unit_local,
            compare_array_local,
            compare_list_local,
            compare_option_local,
            compare_ref_local,
            equal_bool_local,
            equal_char_local,
            equal_float_local,
            equal_int_local,
            equal_int32_local,
            equal_int64_local,
            equal_nativeint_local,
            equal_string_local,
            equal_bytes_local,
            equal_unit_local,
            equal_array_local,
            equal_list_local,
            equal_option_local,
            equal_ref_local
        ]
    ];
    runtime.caml_register_global(4, Base_Ppx_compare_lib, "Base__Ppx_compare_lib");
    return;
})(globalThis);
//# 2261 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Ppx_compare_lib = global_data.Base__Ppx_compare_lib, Base_Globalize = global_data.Base__Globalize, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp = global_data.Sexplib0__Sexp, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, t_of_sexp = Sexplib0_Sexp[1], sexp_of_t = Sexplib0_Sexp[2], equal = Sexplib0_Sexp[3], Not_found_s = Sexplib0_Sexp[5], Of_sexp_error = Sexplib0_Sexp[6], message = Sexplib0_Sexp[7], default_indent = Sexplib0_Sexp[8], pp_hum = Sexplib0_Sexp[9], pp_hum_indent = Sexplib0_Sexp[10], pp_mach = Sexplib0_Sexp[11], pp = Sexplib0_Sexp[12], to_string_hum = Sexplib0_Sexp[13], to_string_mach = Sexplib0_Sexp[14], to_string = Sexplib0_Sexp[15], of_float_style = Sexplib0_Sexp[16], of_int_style = Sexplib0_Sexp[17], Private = Sexplib0_Sexp[18];
    function compare_local(a_001, b_002) {
        if (a_001 === b_002) return 0;
        if (0 === a_001[0]) {
            var a_003 = a_001[1];
            if (0 !== b_002[0]) return -1;
            var b_004 = b_002[1];
            return caml_call2(Base_Ppx_compare_lib[5][36], a_003, b_004);
        }
        var a_005 = a_001[1];
        if (0 === b_002[0]) return 1;
        var b_006 = b_002[1];
        return caml_call3(Base_Ppx_compare_lib[5][40], compare_local, a_005, b_006);
    }
    function compare(a, b) {
        return compare_local(a, b);
    }
    function globalize(x_009) {
        if (0 === x_009[0]) {
            var arg_010 = x_009[1];
            return [
                0,
                caml_call1(Base_Globalize[9], arg_010)
            ];
        }
        var arg_011 = x_009[1];
        return [
            1,
            caml_call2(Base_Globalize[13], globalize, arg_011)
        ];
    }
    var letrec_function_context = [];
    function hash_fold_t(hsv, arg) {
        if (0 === arg[0]) {
            var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
            return caml_call2(Base_Hash[13][7], hsv$0, a0);
        }
        var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
        return caml_call3(Base_Hash[13][11], hash_fold_t, hsv$1, a0$0);
    }
    function hash(x) {
        return caml_call1(letrec_function_context[1], x);
    }
    function func(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _a_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _a_);
    }
    runtime.caml_update_dummy(letrec_function_context, [
        0,
        func
    ]);
    var t_sexp_grammar = Sexplib0_Sexp_conv[61];
    function invariant(param) {
        return 0;
    }
    function equal_local(a, b) {
        return 0 === compare_local(a, b) ? 1 : 0;
    }
    var Base_Sexp = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        equal,
        compare,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        Private,
        equal_local,
        compare_local,
        t_sexp_grammar,
        invariant,
        0
    ];
    runtime.caml_register_global(5, Base_Sexp, "Base__Sexp");
    return;
})(globalThis);
//# 2381 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Hash = global_data.Base__Hash, Base_Ppx_compare_lib = global_data.Base__Ppx_compare_lib, Base_Globalize = global_data.Base__Globalize, Base_Sexp = global_data.Base__Sexp, Exit = Base_Import0[1], Not_found = Base_Import0[2], max_int = Base_Import0[3], min_int = Base_Import0[4], infinity = Base_Import0[5], neg_infinity = Base_Import0[6], nan = Base_Import0[7], max_float = Base_Import0[8], min_float = Base_Import0[9], epsilon_float = Base_Import0[10], char_of_int = Base_Import0[11], string_of_bool = Base_Import0[12], bool_of_string_opt = Base_Import0[13], bool_of_string = Base_Import0[14], string_of_int = Base_Import0[15], int_of_string_opt = Base_Import0[16], string_of_float = Base_Import0[17], float_of_string_opt = Base_Import0[18], stdin = Base_Import0[19], stdout = Base_Import0[20], stderr = Base_Import0[21], print_char = Base_Import0[22], print_string = Base_Import0[23], print_bytes = Base_Import0[24], print_int = Base_Import0[25], print_float = Base_Import0[26], print_endline = Base_Import0[27], print_newline = Base_Import0[28], prerr_char = Base_Import0[29], prerr_string = Base_Import0[30], prerr_bytes = Base_Import0[31], prerr_int = Base_Import0[32], prerr_float = Base_Import0[33], prerr_endline = Base_Import0[34], prerr_newline = Base_Import0[35], read_line = Base_Import0[36], read_int_opt = Base_Import0[37], read_int = Base_Import0[38], read_float_opt = Base_Import0[39], read_float = Base_Import0[40], open_out = Base_Import0[41], open_out_bin = Base_Import0[42], open_out_gen = Base_Import0[43], flush = Base_Import0[44], flush_all = Base_Import0[45], output_char = Base_Import0[46], output_string = Base_Import0[47], output_bytes = Base_Import0[48], output = Base_Import0[49], output_substring = Base_Import0[50], output_byte = Base_Import0[51], output_binary_int = Base_Import0[52], output_value = Base_Import0[53], seek_out = Base_Import0[54], pos_out = Base_Import0[55], out_channel_length = Base_Import0[56], close_out = Base_Import0[57], close_out_noerr = Base_Import0[58], set_binary_mode_out = Base_Import0[59], open_in = Base_Import0[60], open_in_bin = Base_Import0[61], open_in_gen = Base_Import0[62], input_char = Base_Import0[63], input_line = Base_Import0[64], input = Base_Import0[65], really_input = Base_Import0[66], really_input_string = Base_Import0[67], input_byte = Base_Import0[68], input_binary_int = Base_Import0[69], input_value = Base_Import0[70], seek_in = Base_Import0[71], pos_in = Base_Import0[72], in_channel_length = Base_Import0[73], close_in = Base_Import0[74], close_in_noerr = Base_Import0[75], set_binary_mode_in = Base_Import0[76], string_of_format = Base_Import0[77], symbol = Base_Import0[78], exit = Base_Import0[79], at_exit = Base_Import0[80], valid_float_lexem = Base_Import0[81], unsafe_really_input = Base_Import0[82], do_at_exit = Base_Import0[83], do_domain_local_at_exit = Base_Import0[84], Stdlib = Base_Import0[85], bool_to_int = Base_Import0[86], symbol$0 = Base_Import0[87], symbol$1 = Base_Import0[88], symbol$2 = Base_Import0[89], symbol$3 = Base_Import0[90], symbol$4 = Base_Import0[91], symbol$5 = Base_Import0[92], symbol$6 = Base_Import0[93], symbol$7 = Base_Import0[94], symbol$8 = Base_Import0[95], symbol$9 = Base_Import0[96], Int_replace_polymorphic_compar = Base_Import0[97], ascending = Base_Import0[98], descending = Base_Import0[99], max = Base_Import0[100], min = Base_Import0[101], Int32_replace_polymorphic_comp = Base_Import0[102], Int64_replace_polymorphic_comp = Base_Import0[103], Nativeint_replace_polymorphic_ = Base_Import0[104], Bool_replace_polymorphic_compa = Base_Import0[105], Char_replace_polymorphic_compa = Base_Import0[106], Uchar_replace_polymorphic_comp = Base_Import0[107], Float_replace_polymorphic_comp = Base_Import0[108], String_replace_polymorphic_com = Base_Import0[109], Bytes_replace_polymorphic_comp = Base_Import0[110], symbol$10 = Base_Import0[111], symbol_concat = Base_Import0[112], symbol$11 = Base_Import0[113], symbol$12 = Base_Import0[114], asr = Base_Import0[115], land = Base_Import0[116], lnot = Base_Import0[117], lor = Base_Import0[118], lsl = Base_Import0[119], lsr = Base_Import0[120], lxor = Base_Import0[121], mod = Base_Import0[122], abs = Base_Import0[123], failwith = Base_Import0[124], fst = Base_Import0[125], invalid_arg = Base_Import0[126], snd = Base_Import0[127], float_of_string = Base_Import0[128], am_testing = Base_Import0[129], default_string_of_float = Sexplib0_Sexp_conv[1], write_old_option_format = Sexplib0_Sexp_conv[2], read_old_option_format = Sexplib0_Sexp_conv[3], list_map = Sexplib0_Sexp_conv[4], sexp_of_unit = Sexplib0_Sexp_conv[5], sexp_of_bool = Sexplib0_Sexp_conv[6], sexp_of_string = Sexplib0_Sexp_conv[7], sexp_of_bytes = Sexplib0_Sexp_conv[8], sexp_of_char = Sexplib0_Sexp_conv[9], sexp_of_int = Sexplib0_Sexp_conv[10], sexp_of_float = Sexplib0_Sexp_conv[11], sexp_of_int32 = Sexplib0_Sexp_conv[12], sexp_of_int64 = Sexplib0_Sexp_conv[13], sexp_of_nativeint = Sexplib0_Sexp_conv[14], sexp_of_ref = Sexplib0_Sexp_conv[15], sexp_of_lazy_t = Sexplib0_Sexp_conv[16], sexp_of_option = Sexplib0_Sexp_conv[17], sexp_of_pair = Sexplib0_Sexp_conv[18], sexp_of_triple = Sexplib0_Sexp_conv[19], sexp_of_list = Sexplib0_Sexp_conv[20], sexp_of_array = Sexplib0_Sexp_conv[21], sexp_of_hashtbl = Sexplib0_Sexp_conv[22], sexp_of_opaque = Sexplib0_Sexp_conv[23], sexp_of_fun = Sexplib0_Sexp_conv[24], Of_sexp_error = Sexplib0_Sexp_conv[25], record_check_extra_fields = Sexplib0_Sexp_conv[26], of_sexp_error = Sexplib0_Sexp_conv[27], of_sexp_error_exn = Sexplib0_Sexp_conv[28], unit_of_sexp = Sexplib0_Sexp_conv[29], bool_of_sexp = Sexplib0_Sexp_conv[30], string_of_sexp = Sexplib0_Sexp_conv[31], bytes_of_sexp = Sexplib0_Sexp_conv[32], char_of_sexp = Sexplib0_Sexp_conv[33], int_of_sexp = Sexplib0_Sexp_conv[34], float_of_sexp = Sexplib0_Sexp_conv[35], int32_of_sexp = Sexplib0_Sexp_conv[36], int64_of_sexp = Sexplib0_Sexp_conv[37], nativeint_of_sexp = Sexplib0_Sexp_conv[38], ref_of_sexp = Sexplib0_Sexp_conv[39], lazy_t_of_sexp = Sexplib0_Sexp_conv[40], option_of_sexp = Sexplib0_Sexp_conv[41], pair_of_sexp = Sexplib0_Sexp_conv[42], triple_of_sexp = Sexplib0_Sexp_conv[43], list_of_sexp = Sexplib0_Sexp_conv[44], array_of_sexp = Sexplib0_Sexp_conv[45], hashtbl_of_sexp = Sexplib0_Sexp_conv[46], opaque_of_sexp = Sexplib0_Sexp_conv[47], fun_of_sexp = Sexplib0_Sexp_conv[48], sexp_grammar_with_tags = Sexplib0_Sexp_conv[49], sexp_grammar_with_tag_list = Sexplib0_Sexp_conv[50], unit_sexp_grammar = Sexplib0_Sexp_conv[51], bool_sexp_grammar = Sexplib0_Sexp_conv[52], string_sexp_grammar = Sexplib0_Sexp_conv[53], bytes_sexp_grammar = Sexplib0_Sexp_conv[54], char_sexp_grammar = Sexplib0_Sexp_conv[55], int_sexp_grammar = Sexplib0_Sexp_conv[56], float_sexp_grammar = Sexplib0_Sexp_conv[57], int32_sexp_grammar = Sexplib0_Sexp_conv[58], int64_sexp_grammar = Sexplib0_Sexp_conv[59], nativeint_sexp_grammar = Sexplib0_Sexp_conv[60], sexp_t_sexp_grammar = Sexplib0_Sexp_conv[61], ref_sexp_grammar = Sexplib0_Sexp_conv[62], lazy_t_sexp_grammar = Sexplib0_Sexp_conv[63], option_sexp_grammar = Sexplib0_Sexp_conv[64], list_sexp_grammar = Sexplib0_Sexp_conv[65], array_sexp_grammar = Sexplib0_Sexp_conv[66], opaque_sexp_grammar = Sexplib0_Sexp_conv[67], fun_sexp_grammar = Sexplib0_Sexp_conv[68], sexp_of_exn = Sexplib0_Sexp_conv[69], printexc_prefer_sexp = Sexplib0_Sexp_conv[70], sexp_of_exn_opt = Sexplib0_Sexp_conv[71], Exn_converter = Sexplib0_Sexp_conv[72], _a_ = Base_Hash[13], hash_fold_nativeint = _a_[1], hash_fold_int64 = _a_[2], hash_fold_int32 = _a_[3], hash_fold_char = _a_[4], hash_fold_int = _a_[5], hash_fold_bool = _a_[6], hash_fold_string = _a_[7], hash_fold_float = _a_[8], hash_fold_unit = _a_[9], hash_fold_option = _a_[10], hash_fold_list = _a_[11], hash_fold_lazy_t = _a_[12], hash_fold_ref_frozen = _a_[13], hash_fold_array_frozen = _a_[14], hash_nativeint = _a_[15], hash_int64 = _a_[16], hash_int32 = _a_[17], hash_char = _a_[18], hash_int = _a_[19], hash_bool = _a_[20], hash_string = _a_[21], hash_float = _a_[22], hash_unit = _a_[23], _b_ = Base_Ppx_compare_lib[5], compare_bool = _b_[1], compare_char = _b_[2], compare_float = _b_[3], compare_int = _b_[4], compare_int32 = _b_[5], compare_int64 = _b_[6], compare_nativeint = _b_[7], compare_string = _b_[8], compare_bytes = _b_[9], compare_unit = _b_[10], compare_array = _b_[11], compare_list = _b_[12], compare_option = _b_[13], compare_ref = _b_[14], equal_bool = _b_[15], equal_char = _b_[16], equal_float = _b_[17], equal_int = _b_[18], equal_int32 = _b_[19], equal_int64 = _b_[20], equal_nativeint = _b_[21], equal_string = _b_[22], equal_bytes = _b_[23], equal_unit = _b_[24], equal_array = _b_[25], equal_list = _b_[26], equal_option = _b_[27], equal_ref = _b_[28], compare_bool_local = _b_[29], compare_char_local = _b_[30], compare_float_local = _b_[31], compare_int_local = _b_[32], compare_int32_local = _b_[33], compare_int64_local = _b_[34], compare_nativeint_local = _b_[35], compare_string_local = _b_[36], compare_bytes_local = _b_[37], compare_unit_local = _b_[38], compare_array_local = _b_[39], compare_list_local = _b_[40], compare_option_local = _b_[41], compare_ref_local = _b_[42], equal_bool_local = _b_[43], equal_char_local = _b_[44], equal_float_local = _b_[45], equal_int_local = _b_[46], equal_int32_local = _b_[47], equal_int64_local = _b_[48], equal_nativeint_local = _b_[49], equal_string_local = _b_[50], equal_bytes_local = _b_[51], equal_unit_local = _b_[52], equal_array_local = _b_[53], equal_list_local = _b_[54], equal_option_local = _b_[55], equal_ref_local = _b_[56], globalize_bool = Base_Globalize[1], globalize_char = Base_Globalize[2], globalize_float = Base_Globalize[3], globalize_int = Base_Globalize[4], globalize_int32 = Base_Globalize[5], globalize_int64 = Base_Globalize[6], globalize_nativeint = Base_Globalize[7], globalize_bytes = Base_Globalize[8], globalize_string = Base_Globalize[9], globalize_unit = Base_Globalize[10], globalize_array = Base_Globalize[11], globalize_lazy_t = Base_Globalize[12], globalize_list = Base_Globalize[13], globalize_option = Base_Globalize[14], globalize_result = Base_Globalize[15], globalize_ref = Base_Globalize[16], Not_found_s = Base_Sexp[8], Base_Import = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Stdlib,
        bool_to_int,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        symbol$9,
        Int_replace_polymorphic_compar,
        ascending,
        descending,
        max,
        min,
        Int32_replace_polymorphic_comp,
        Int64_replace_polymorphic_comp,
        Nativeint_replace_polymorphic_,
        Bool_replace_polymorphic_compa,
        Char_replace_polymorphic_compa,
        Uchar_replace_polymorphic_comp,
        Float_replace_polymorphic_comp,
        String_replace_polymorphic_com,
        Bytes_replace_polymorphic_comp,
        symbol$10,
        symbol_concat,
        symbol$11,
        symbol$12,
        asr,
        land,
        lnot,
        lor,
        lsl,
        lsr,
        lxor,
        mod,
        abs,
        failwith,
        fst,
        invalid_arg,
        snd,
        float_of_string,
        am_testing,
        default_string_of_float,
        write_old_option_format,
        read_old_option_format,
        list_map,
        sexp_of_unit,
        sexp_of_bool,
        sexp_of_string,
        sexp_of_bytes,
        sexp_of_char,
        sexp_of_int,
        sexp_of_float,
        sexp_of_int32,
        sexp_of_int64,
        sexp_of_nativeint,
        sexp_of_ref,
        sexp_of_lazy_t,
        sexp_of_option,
        sexp_of_pair,
        sexp_of_triple,
        sexp_of_list,
        sexp_of_array,
        sexp_of_hashtbl,
        sexp_of_opaque,
        sexp_of_fun,
        Of_sexp_error,
        record_check_extra_fields,
        of_sexp_error,
        of_sexp_error_exn,
        unit_of_sexp,
        bool_of_sexp,
        string_of_sexp,
        bytes_of_sexp,
        char_of_sexp,
        int_of_sexp,
        float_of_sexp,
        int32_of_sexp,
        int64_of_sexp,
        nativeint_of_sexp,
        ref_of_sexp,
        lazy_t_of_sexp,
        option_of_sexp,
        pair_of_sexp,
        triple_of_sexp,
        list_of_sexp,
        array_of_sexp,
        hashtbl_of_sexp,
        opaque_of_sexp,
        fun_of_sexp,
        sexp_grammar_with_tags,
        sexp_grammar_with_tag_list,
        unit_sexp_grammar,
        bool_sexp_grammar,
        string_sexp_grammar,
        bytes_sexp_grammar,
        char_sexp_grammar,
        int_sexp_grammar,
        float_sexp_grammar,
        int32_sexp_grammar,
        int64_sexp_grammar,
        nativeint_sexp_grammar,
        sexp_t_sexp_grammar,
        ref_sexp_grammar,
        lazy_t_sexp_grammar,
        option_sexp_grammar,
        list_sexp_grammar,
        array_sexp_grammar,
        opaque_sexp_grammar,
        fun_sexp_grammar,
        sexp_of_exn,
        printexc_prefer_sexp,
        sexp_of_exn_opt,
        Exn_converter,
        hash_fold_nativeint,
        hash_fold_int64,
        hash_fold_int32,
        hash_fold_char,
        hash_fold_int,
        hash_fold_bool,
        hash_fold_string,
        hash_fold_float,
        hash_fold_unit,
        hash_fold_option,
        hash_fold_list,
        hash_fold_lazy_t,
        hash_fold_ref_frozen,
        hash_fold_array_frozen,
        hash_nativeint,
        hash_int64,
        hash_int32,
        hash_char,
        hash_int,
        hash_bool,
        hash_string,
        hash_float,
        hash_unit,
        compare_bool,
        compare_char,
        compare_float,
        compare_int,
        compare_int32,
        compare_int64,
        compare_nativeint,
        compare_string,
        compare_bytes,
        compare_unit,
        compare_array,
        compare_list,
        compare_option,
        compare_ref,
        equal_bool,
        equal_char,
        equal_float,
        equal_int,
        equal_int32,
        equal_int64,
        equal_nativeint,
        equal_string,
        equal_bytes,
        equal_unit,
        equal_array,
        equal_list,
        equal_option,
        equal_ref,
        compare_bool_local,
        compare_char_local,
        compare_float_local,
        compare_int_local,
        compare_int32_local,
        compare_int64_local,
        compare_nativeint_local,
        compare_string_local,
        compare_bytes_local,
        compare_unit_local,
        compare_array_local,
        compare_list_local,
        compare_option_local,
        compare_ref_local,
        equal_bool_local,
        equal_char_local,
        equal_float_local,
        equal_int_local,
        equal_int32_local,
        equal_int64_local,
        equal_nativeint_local,
        equal_string_local,
        equal_bytes_local,
        equal_unit_local,
        equal_array_local,
        equal_list_local,
        equal_option_local,
        equal_ref_local,
        globalize_bool,
        globalize_char,
        globalize_float,
        globalize_int,
        globalize_int32,
        globalize_int64,
        globalize_nativeint,
        globalize_bytes,
        globalize_string,
        globalize_unit,
        globalize_array,
        globalize_lazy_t,
        globalize_list,
        globalize_option,
        globalize_result,
        globalize_ref,
        Not_found_s
    ];
    runtime.caml_register_global(6, Base_Import, "Base__Import");
    return;
})(globalThis);
//# 2998 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Sys0 = global_data.Base__Sys0, Base_Import = global_data.Base__Import, _a_ = [
        0,
        "W64"
    ], _b_ = [
        0,
        "W32"
    ];
    function sexp_of_t(param) {
        return param ? _a_ : _b_;
    }
    function num_bits(param) {
        return param ? 64 : 32;
    }
    var _c_ = Base_Sys0[7], cst_unknown_word_size = "unknown word size", word_size = 32 === _c_ ? 0 : 64 === _c_ ? 1 : caml_call1(Base_Import[124], cst_unknown_word_size), Base_Word_size = [
        0,
        sexp_of_t,
        num_bits,
        word_size
    ];
    runtime.caml_register_global(5, Base_Word_size, "Base__Word_size");
    return;
})(globalThis);
//# 3039 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Format = global_data.Stdlib__Format, Base_Import = global_data.Base__Import, r = [
        0,
        [
            0,
            "Base.Sexp.pp_hum",
            0
        ]
    ], cst_pp = ".pp";
    function all(param) {
        return r[1];
    }
    function register(p) {
        r[1] = [
            0,
            p,
            r[1]
        ];
        return 0;
    }
    function Register_pp(M) {
        var pp = M[1];
        register(caml_call2(Base_Import[112], M[2], cst_pp));
        return [
            0,
            pp
        ];
    }
    var Base_Pretty_printer = [
        0,
        all,
        function(M) {
            var module_name = M[1];
            function pp(formatter, t) {
                var _b_ = caml_call1(M[2], t);
                return caml_call2(Stdlib_Format[13], formatter, _b_);
            }
            return [
                0,
                Register_pp([
                    0,
                    pp,
                    module_name
                ])[1]
            ];
        },
        function(_a_) {
            return [
                0,
                Register_pp(_a_)[1]
            ];
        },
        register
    ];
    runtime.caml_register_global(4, Base_Pretty_printer, "Base__Pretty_printer");
    return;
})(globalThis);
//# 3088 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_2 = "<2>", cst_src_exn_ml = "src/exn.ml", caml_fresh_oo_id = runtime.caml_fresh_oo_id, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Exn", Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Import = global_data.Base__Import, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Base_Sexp = global_data.Base__Sexp, Base_Printf = global_data.Base__Printf, Assert_failure = global_data.Assert_failure, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Pretty_printer = global_data.Base__Pretty_printer, sexp_of_t = Base_Import[198], exit = Base_Import[85][99], Finally = [
        248,
        "Base__Exn.Finally",
        caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        "exn.ml.Finally"
    ], _b_ = [
        0,
        cst_src_exn_ml,
        19,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Finally, function(param) {
        if (param[1] !== Finally) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var arg1_002 = param[3], arg0_001 = param[2], res0_003 = caml_call1(sexp_of_t, arg0_001), res1_004 = caml_call1(sexp_of_t, arg1_002);
        return [
            1,
            [
                0,
                _a_,
                [
                    0,
                    res0_003,
                    [
                        0,
                        res1_004,
                        0
                    ]
                ]
            ]
        ];
    });
    var Reraised = [
        248,
        "Base__Exn.Reraised",
        caml_fresh_oo_id(0)
    ], _c_ = [
        0,
        "exn.ml.Reraised"
    ], _d_ = [
        0,
        cst_src_exn_ml,
        32,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Reraised, function(param) {
        if (param[1] !== Reraised) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _d_
        ], 1);
        var arg1_006 = param[3], arg0_005 = param[2], res0_007 = caml_call1(Base_Import[136], arg0_005), res1_008 = caml_call1(sexp_of_t, arg1_006);
        return [
            1,
            [
                0,
                _c_,
                [
                    0,
                    res0_007,
                    [
                        0,
                        res1_008,
                        0
                    ]
                ]
            ]
        ];
    });
    var Sexp = [
        248,
        "Base__Exn.Sexp",
        caml_fresh_oo_id(0)
    ], _e_ = [
        0,
        cst_src_exn_ml,
        53,
        6
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Sexp, function(param) {
        if (param[1] !== Sexp) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
        var t = param[2];
        return t;
    });
    var _f_ = [
        0,
        2
    ];
    function create_s(sexp) {
        return [
            0,
            Sexp,
            sexp
        ];
    }
    function raise_with_original_backtrace(t, backtrace) {
        runtime.caml_restore_raw_backtrace(t, backtrace);
        throw caml_maybe_attach_backtrace(t, 0);
    }
    function reraise(exn, str) {
        var exn$0 = [
            0,
            Reraised,
            str,
            exn
        ];
        if (!runtime.Base_caml_exn_is_most_recent_exn(exn)) throw caml_maybe_attach_backtrace(exn$0, 1);
        var bt = caml_call1(Stdlib_Printexc[12], 0);
        return raise_with_original_backtrace(exn$0, bt);
    }
    function reraisef(exc, format) {
        return caml_call2(Base_Printf[4], function(str, param) {
            return reraise(exc, str);
        }, format);
    }
    function to_string(exc) {
        var _u_ = caml_call1(Base_Import[198], exc);
        return caml_call2(Base_Sexp[16], _f_, _u_);
    }
    function to_string_mach(exc) {
        var _t_ = caml_call1(Base_Import[198], exc);
        return caml_call1(Base_Sexp[17], _t_);
    }
    var sexp_of_t$0 = Base_Import[198];
    function protectx(f, x, finally$0) {
        try {
            var res = caml_call1(f, x);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
            try {
                caml_call1(finally$0, x);
            } catch (final_exn$0) {
                var final_exn = caml_wrap_exception(final_exn$0);
                return raise_with_original_backtrace([
                    0,
                    Finally,
                    exn,
                    final_exn
                ], bt);
            }
            return raise_with_original_backtrace(exn, bt);
        }
        caml_call1(finally$0, x);
        return res;
    }
    function protect(f, finally$0) {
        return protectx(f, 0, finally$0);
    }
    function does_raise(f) {
        try {
            caml_call1(f, 0);
            var _r_ = 0;
            return _r_;
        } catch (_s_) {
            return 1;
        }
    }
    function pp(ppf, t) {
        var match = caml_call1(Base_Import[200], t);
        if (match) {
            var sexp = match[1];
            return caml_call2(Base_Sexp[12], ppf, sexp);
        }
        var _q_ = caml_call1(Stdlib_Printexc[1], t);
        return caml_call2(Stdlib_Format[13], ppf, _q_);
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], _g_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    [
                        11,
                        cst_2,
                        0
                    ],
                    cst_2
                ]
            ],
            [
                11,
                "Uncaught exception:",
                [
                    17,
                    3,
                    [
                        17,
                        3,
                        [
                            18,
                            [
                                1,
                                [
                                    0,
                                    0,
                                    ""
                                ]
                            ],
                            [
                                15,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        0,
                                        [
                                            17,
                                            3,
                                            [
                                                17,
                                                4,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[<2>Uncaught exception:@\n@\n@[%a@]@]@\n@."
    ], _h_ = [
        0,
        [
            11,
            "Exn.handle_uncaught could not print; exiting anyway\n",
            [
                10,
                0
            ]
        ],
        "Exn.handle_uncaught could not print; exiting anyway\n%!"
    ];
    function print_with_backtrace(exc, raw_backtrace) {
        caml_call3(Stdlib_Format[145], _g_, pp$0, exc);
        if (caml_call1(Stdlib_Printexc[8], 0)) caml_call2(Stdlib_Printexc[13], Base_Import[85][40], raw_backtrace);
        return caml_call1(Base_Import[85][63], Base_Import[85][40]);
    }
    function handle_uncaught_aux(do_at_exit, exit, f) {
        try {
            var _m_ = caml_call1(f, 0);
            return _m_;
        } catch (exc$0) {
            var exc = caml_wrap_exception(exc$0), raw_backtrace = caml_call1(Stdlib_Printexc[12], 0);
            if (do_at_exit) try {
                caml_call1(Base_Import[85][103], 0);
            } catch (_p_) {}
            try {
                print_with_backtrace(exc, raw_backtrace);
            } catch (_n_) {
                try {
                    caml_call1(Stdlib_Printf[3], _h_);
                } catch (_o_) {}
            }
            return caml_call1(exit, 1);
        }
    }
    function handle_uncaught_and_exit(f) {
        return handle_uncaught_aux(1, exit, f);
    }
    function handle_uncaught(must_exit, f) {
        var exit$0 = must_exit ? exit : function(_l_) {
            return 0;
        };
        return handle_uncaught_aux(must_exit, exit$0, f);
    }
    function reraise_uncaught(str, func) {
        try {
            var _k_ = caml_call1(func, 0);
            return _k_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
            return raise_with_original_backtrace([
                0,
                Reraised,
                str,
                exn
            ], bt);
        }
    }
    function raise_without_backtrace(e) {
        runtime.Base_clear_caml_backtrace_pos(0);
        throw e;
    }
    function initialize_module(param) {
        return caml_call1(Stdlib_Printexc[16], print_with_backtrace);
    }
    function clear_backtrace(_j_) {
        return runtime.Base_clear_caml_backtrace_pos(_j_);
    }
    var Private = [
        0,
        clear_backtrace
    ], Base_Exn = [
        0,
        sexp_of_t$0,
        pp$0,
        Finally,
        Reraised,
        create_s,
        raise_without_backtrace,
        raise_with_original_backtrace,
        reraise,
        reraisef,
        to_string,
        to_string_mach,
        protectx,
        protect,
        handle_uncaught,
        handle_uncaught_and_exit,
        reraise_uncaught,
        does_raise,
        function(_i_) {
            return runtime.Base_caml_exn_is_most_recent_exn(_i_);
        },
        initialize_module,
        Private
    ];
    runtime.caml_register_global(21, Base_Exn, "Base__Exn");
    return;
})(globalThis);
//# 3334 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Exn = global_data.Base__Exn, cst_Return = "Return", cst_use_of_return_from_a_with_ = "use of [return] from a [with_return] that already returned";
    function with_return(f) {
        var Return = [
            248,
            cst_Return,
            runtime.caml_fresh_oo_id(0)
        ], is_alive = [
            0,
            1
        ];
        function return$0(a) {
            if (1 - is_alive[1]) caml_call1(Base_Import[124], cst_use_of_return_from_a_with_);
            return caml_call1(Base_Exn[6], [
                0,
                Return,
                a
            ]);
        }
        try {
            var a$0 = caml_call1(f, return$0);
            is_alive[1] = 0;
            return a$0;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            is_alive[1] = 0;
            if (exn[1] !== Return) throw caml_maybe_attach_backtrace(exn, 0);
            var a = exn[2];
            return a;
        }
    }
    function with_return_option(f) {
        return with_return(function(return$0) {
            caml_call1(f, function(a) {
                return caml_call1(return$0, [
                    0,
                    a
                ]);
            });
            return 0;
        });
    }
    function prepend(param, f) {
        return function(x) {
            return caml_call1(param, caml_call1(f, x));
        };
    }
    var Base_With_return = [
        0,
        with_return,
        with_return_option,
        prepend
    ];
    runtime.caml_register_global(4, Base_With_return, "Base__With_return");
    return;
})(globalThis);
//# 3450 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function S_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Monad_infix = X[3], bind = X[4], return$0 = X[5], map = X[6], join = X[7], ignore_m = X[8], all = X[9], all_unit = X[10], Let_syntax = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S2_to_S3(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S_to_S_indexed(X) {
        var symbol_bind = X[1], symbol_map = X[2], Monad_infix = X[3], bind = X[4], return$0 = X[5], map = X[6], join = X[7], ignore_m = X[8], all = X[9], all_unit = X[10], Let_syntax = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S2_to_S(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit,
            Let_syntax
        ];
    }
    function S3_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function S_indexed_to_S2(X) {
        var symbol_bind = X[1], symbol_map = X[2], Let_syntax = X[3], Monad_infix = X[4], bind = X[5], return$0 = X[6], map = X[7], join = X[8], ignore_m = X[9], all = X[10], all_unit = X[11];
        return [
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    var Base_Monad_intf = [
        0,
        S_to_S2,
        S2_to_S3,
        S_to_S_indexed,
        S2_to_S,
        S3_to_S2,
        S_indexed_to_S2
    ];
    runtime.caml_register_global(0, Base_Monad_intf, "Base__Monad_intf");
    return;
})(globalThis);
//# 3625 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Base_List0 = global_data.Base__List0;
    function Make_general(_A_) {
        var bind = _A_[1], return$0 = _A_[3];
        function map_via_bind(ma, f) {
            return caml_call2(_A_[1], ma, function(a) {
                var _B_ = caml_call1(f, a);
                return caml_call1(_A_[3], _B_);
            });
        }
        var match = _A_[2];
        if (typeof match === "number") var map = map_via_bind;
        else var x = match[2], map = x;
        function symbol_bind(t, f) {
            return caml_call2(bind, t, f);
        }
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        var Monad_infix = [
            0,
            symbol_bind,
            symbol_map
        ], symbol_bind$0 = Monad_infix[1], symbol_map$0 = Monad_infix[2], symbol_bind$1 = Monad_infix[1], symbol_map$1 = Monad_infix[2];
        function both(a, b) {
            return caml_call2(symbol_bind$1, a, function(a) {
                return caml_call2(symbol_map$1, b, function(b) {
                    return [
                        0,
                        a,
                        b
                    ];
                });
            });
        }
        var Open_on_rhs = [
            0
        ], Let_syntax = [
            0,
            return$0,
            bind,
            map,
            both,
            Open_on_rhs
        ], Let_syntax$0 = [
            0,
            return$0,
            symbol_bind$1,
            symbol_map$1,
            Let_syntax
        ];
        function join(t) {
            return caml_call2(symbol_bind$0, t, function(t) {
                return t;
            });
        }
        function ignore_m(t) {
            return caml_call2(map, t, function(param) {
                return 0;
            });
        }
        function loop(vs, param) {
            if (!param) return caml_call1(return$0, caml_call1(Base_List0[19], vs));
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(v) {
                return loop([
                    0,
                    v,
                    vs
                ], ts);
            });
        }
        function all(ts) {
            return loop(0, ts);
        }
        function all_unit(param) {
            if (!param) return caml_call1(return$0, 0);
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(param) {
                return all_unit(ts);
            });
        }
        return [
            0,
            bind,
            return$0,
            ,
            map,
            Monad_infix,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function Make_indexed(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _z_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _z_[6],
            _z_[7],
            _z_[8],
            _z_[5],
            _z_[1],
            _z_[2],
            _z_[4],
            _z_[9],
            _z_[10],
            _z_[11],
            _z_[12]
        ];
    }
    function Make3(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _y_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _y_[6],
            _y_[7],
            _y_[8],
            _y_[5],
            _y_[1],
            _y_[2],
            _y_[4],
            _y_[9],
            _y_[10],
            _y_[11],
            _y_[12]
        ];
    }
    function Make2(M) {
        var bind = M[1], map = M[2], return$0 = M[3], _x_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _x_[6],
            _x_[7],
            _x_[8],
            _x_[5],
            _x_[1],
            _x_[2],
            _x_[4],
            _x_[9],
            _x_[10],
            _x_[11],
            _x_[12]
        ];
    }
    function Make(M) {
        var bind = M[1], return$0 = M[2], map = M[3], _w_ = Make_general([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _w_[6],
            _w_[7],
            _w_[5],
            _w_[1],
            _w_[2],
            _w_[4],
            _w_[9],
            _w_[10],
            _w_[11],
            _w_[12],
            _w_[8]
        ];
    }
    function Make2_local(_t_) {
        var bind = _t_[1], return$0 = _t_[3];
        function map_via_bind(ma, f) {
            var res = caml_call2(_t_[1], ma, function(a) {
                var _v_ = caml_call1(f, a);
                return caml_call1(_t_[3], _v_);
            });
            return res;
        }
        var match = _t_[2];
        if (typeof match === "number") var map = map_via_bind;
        else var x = match[2], map = x;
        function symbol_bind(t, f) {
            return caml_call2(bind, t, f);
        }
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        var Monad_infix = [
            0,
            symbol_bind,
            symbol_map
        ], symbol_bind$0 = Monad_infix[1], symbol_map$0 = Monad_infix[2], symbol_bind$1 = Monad_infix[1], symbol_map$1 = Monad_infix[2];
        function both(a, b) {
            var res = caml_call2(bind, a, function(a) {
                var res = caml_call2(map, b, function(b) {
                    return [
                        0,
                        a,
                        b
                    ];
                });
                return res;
            });
            return res;
        }
        var Open_on_rhs = [
            0
        ], Let_syntax = [
            0,
            return$0,
            bind,
            map,
            both,
            Open_on_rhs
        ], Let_syntax$0 = [
            0,
            return$0,
            symbol_bind$1,
            symbol_map$1,
            Let_syntax
        ];
        function join(t) {
            return caml_call2(symbol_bind$0, t, function(_u_) {
                return _u_;
            });
        }
        function ignore_m(t) {
            var res = caml_call2(map, t, function(param) {
                return 0;
            });
            return res;
        }
        function loop(vs, param) {
            if (!param) return caml_call1(return$0, caml_call1(Base_List0[19], vs));
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(v) {
                return loop([
                    0,
                    v,
                    vs
                ], ts);
            });
        }
        function all(ts) {
            return loop(0, ts);
        }
        function all_unit(param) {
            if (!param) return caml_call1(return$0, 0);
            var ts = param[2], t = param[1];
            return caml_call2(symbol_bind$0, t, function(param) {
                return all_unit(ts);
            });
        }
        return [
            0,
            bind,
            return$0,
            ,
            map,
            Monad_infix,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            join,
            ignore_m,
            all,
            all_unit
        ];
    }
    function Make_local(M) {
        var bind = M[1], return$0 = M[2], map = M[3], _s_ = Make2_local([
            0,
            bind,
            map,
            return$0
        ]);
        return [
            0,
            _s_[6],
            _s_[7],
            _s_[5],
            _s_[1],
            _s_[2],
            _s_[4],
            _s_[9],
            _s_[10],
            _s_[11],
            _s_[12],
            _s_[8]
        ];
    }
    function Of_monad_general(Monad, M) {
        function return$0(a) {
            var _r_ = caml_call1(Monad[3], a);
            return caml_call1(M[2], _r_);
        }
        function bind(t, f) {
            var _o_ = caml_call1(M[1], t), _p_ = caml_call2(Monad[1], _o_, function(a) {
                var _q_ = caml_call1(f, a);
                return caml_call1(M[1], _q_);
            });
            return caml_call1(M[2], _p_);
        }
        var map = [
            0,
            -198771759,
            function(t, f) {
                var _m_ = caml_call1(M[1], t), _n_ = caml_call2(Monad[2], _m_, f);
                return caml_call1(M[2], _n_);
            }
        ];
        return Make_general([
            0,
            bind,
            map,
            return$0
        ]);
    }
    function bind(a, f) {
        return caml_call1(f, a);
    }
    function map(a, f) {
        return caml_call1(f, a);
    }
    function symbol_map(a, f) {
        return caml_call1(f, a);
    }
    function symbol_bind(a, f) {
        return caml_call1(f, a);
    }
    function return$0(_l_) {
        return _l_;
    }
    function both(a, b) {
        return [
            0,
            a,
            b
        ];
    }
    var Open_on_rhs = [
        0
    ], Let_syntax = [
        0,
        return$0,
        bind,
        map,
        both,
        Open_on_rhs
    ], Base_Monad = [
        0,
        Make,
        Make2,
        Make3,
        Make_indexed,
        Make_local,
        function(_j_) {
            var _k_ = Make2_local(_j_);
            return [
                0,
                _k_[6],
                _k_[7],
                _k_[8],
                _k_[5],
                _k_[1],
                _k_[2],
                _k_[4],
                _k_[9],
                _k_[10],
                _k_[11],
                _k_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[4], return$0 = Monad[5], map = Monad[6], _i_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _i_[6],
                _i_[7],
                _i_[5],
                _i_[1],
                _i_[2],
                _i_[4],
                _i_[9],
                _i_[10],
                _i_[11],
                _i_[12],
                _i_[8]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _h_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _h_[6],
                _h_[7],
                _h_[8],
                _h_[5],
                _h_[1],
                _h_[2],
                _h_[4],
                _h_[9],
                _h_[10],
                _h_[11],
                _h_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _g_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _g_[6],
                _g_[7],
                _g_[8],
                _g_[5],
                _g_[1],
                _g_[2],
                _g_[4],
                _g_[9],
                _g_[10],
                _g_[11],
                _g_[12]
            ];
        },
        function(Monad, M) {
            var to_monad = M[1], of_monad = M[2], bind = Monad[5], return$0 = Monad[6], map = Monad[7], _f_ = Of_monad_general([
                0,
                bind,
                map,
                return$0
            ], [
                0,
                to_monad,
                of_monad
            ]);
            return [
                0,
                _f_[6],
                _f_[7],
                _f_[8],
                _f_[5],
                _f_[1],
                _f_[2],
                _f_[4],
                _f_[9],
                _f_[10],
                _f_[11],
                _f_[12]
            ];
        },
        [
            0,
            symbol_bind,
            symbol_map,
            [
                0,
                symbol_bind,
                symbol_map
            ],
            bind,
            function(_e_) {
                return _e_;
            },
            map,
            function(_d_) {
                return _d_;
            },
            function(_c_) {
                return 0;
            },
            function(_b_) {
                return _b_;
            },
            function(_a_) {
                return 0;
            },
            [
                0,
                return$0,
                symbol_bind,
                symbol_map,
                Let_syntax
            ]
        ]
    ];
    runtime.caml_register_global(1, Base_Monad, "Base__Monad");
    return;
})(globalThis);
//# 4050 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_T = [
        0
    ];
    runtime.caml_register_global(0, Base_T, "Base__T");
    return;
})(globalThis);
//# 4059 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Applicative_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Applicative_intf, "Base__Applicative_intf");
    return;
})(globalThis);
//# 4070 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_List0 = global_data.Base__List0;
    function S_to_S2(X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S2_to_S(T, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S2_to_S3(X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S3_to_S2(T, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function S3_to_S(T1, T2, X) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], apply = X[8], map2 = X[9], map3 = X[10], all = X[11], all_unit = X[12], Applicative_infix = X[13];
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function Make3(_O_) {
        var return$0 = _O_[1], symbol = _O_[2];
        function derived_map(t, f) {
            return caml_call2(symbol, caml_call1(return$0, f), t);
        }
        var match = _O_[3];
        if (typeof match === "number") var map = derived_map;
        else var x = match[2], map = x;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function map2(ta, tb, f) {
            return caml_call2(symbol, caml_call2(map, ta, f), tb);
        }
        function map3(ta, tb, tc, f) {
            return caml_call2(symbol, caml_call2(symbol, caml_call2(map, ta, f), tb), tc);
        }
        function all(ts) {
            function _R_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _Q_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_S_) {
                return function(_T_1) {
                    return map2(_S_, _T_1, _R_);
                };
            }, _Q_);
        }
        function both(ta, tb) {
            return map2(ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function symbol$0(u, v) {
            return caml_call2(symbol, caml_call2(symbol, caml_call1(return$0, function(param, y) {
                return y;
            }), u), v);
        }
        function symbol$1(u, v) {
            return caml_call2(symbol, caml_call2(symbol, caml_call1(return$0, function(x, param) {
                return x;
            }), u), v);
        }
        function all_unit(ts) {
            var _P_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _P_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2(X) {
        var return$0 = X[1], apply = X[2], map = X[3];
        return Make3([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Make(X) {
        var return$0 = X[1], apply = X[2], map = X[3];
        return Make2([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Make_let_syntax3(X, Intf, Impl) {
        var return$0 = X[1], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], return$1 = X[1], map = X[2], both = X[3], Let_syntax = [
            0,
            return$1,
            map,
            both,
            ,
            ,
            ,
            ,
            Impl
        ], Let_syntax$0 = [
            0,
            return$0,
            ,
            ,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            Let_syntax
        ];
        return [
            0,
            Let_syntax$0
        ];
    }
    function Make_let_syntax2(X, Intf, Impl) {
        var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7];
        return Make_let_syntax3([
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map
        ], Intf, Impl);
    }
    function Make3_using_map2(_H_) {
        var return$0 = _H_[1], map2 = _H_[2];
        function symbol(tf, ta) {
            return caml_call3(map2, tf, ta, function(f, a) {
                return caml_call1(f, a);
            });
        }
        function derived_map(t, f) {
            return symbol(caml_call1(return$0, f), t);
        }
        var match = _H_[3];
        if (typeof match === "number") var map = derived_map;
        else var x = match[2], map = x;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function both(ta, tb) {
            return caml_call3(map2, ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function map3(ta, tb, tc, f) {
            return caml_call3(map2, caml_call3(map2, ta, tb, f), tc, function(fab, c) {
                return caml_call1(fab, c);
            });
        }
        function all(ts) {
            function _K_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _J_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_L_) {
                var _M_ = caml_call1(map2, _L_);
                return function(_N_) {
                    return caml_call2(_M_, _N_, _K_);
                };
            }, _J_);
        }
        function symbol$0(u, v) {
            return caml_call3(map2, u, v, function(param, y) {
                return y;
            });
        }
        function symbol$1(u, v) {
            return caml_call3(map2, u, v, function(x, param) {
                return x;
            });
        }
        function all_unit(ts) {
            var _I_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _I_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2_using_map2(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make3_using_map2([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make_using_map2(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make2_using_map2([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make3_using_map2_local(_A_) {
        var return$0 = _A_[1], map2 = _A_[2];
        function symbol(tf, ta) {
            return caml_call3(map2, tf, ta, function(f, a) {
                return caml_call1(f, a);
            });
        }
        function derived_map(t, f) {
            return caml_call3(map2, caml_call1(return$0, 0), t, function(param) {
                return f;
            });
        }
        var match = _A_[3];
        if (typeof match === "number") var map = derived_map;
        else var map$0 = match[2], map = map$0;
        function symbol_map(t, f) {
            return caml_call2(map, t, f);
        }
        function both(ta, tb) {
            return caml_call3(map2, ta, tb, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
        }
        function map3(ta, tb, tc, f) {
            var res = caml_call3(map2, both(ta, tb), tc, function(param, c) {
                var b = param[2], a = param[1];
                return caml_call3(f, a, b, c);
            });
            return res;
        }
        function all(ts) {
            function _D_(x, xs) {
                return [
                    0,
                    x,
                    xs
                ];
            }
            var _C_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[20], ts, function(_E_) {
                var _F_ = caml_call1(map2, _E_);
                return function(_G_) {
                    return caml_call2(_F_, _G_, _D_);
                };
            }, _C_);
        }
        function symbol$0(u, v) {
            return caml_call3(map2, u, v, function(param, y) {
                return y;
            });
        }
        function symbol$1(u, v) {
            return caml_call3(map2, u, v, function(x, param) {
                return x;
            });
        }
        function all_unit(ts) {
            var _B_ = caml_call1(return$0, 0);
            return caml_call3(Base_List0[8], ts, _B_, symbol$0);
        }
        return [
            0,
            return$0,
            map,
            both,
            symbol,
            symbol$1,
            symbol$0,
            symbol_map,
            symbol,
            map2,
            map3,
            all,
            all_unit,
            [
                0,
                symbol,
                symbol$1,
                symbol$0,
                symbol_map
            ]
        ];
    }
    function Make2_using_map2_local(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make3_using_map2_local([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Make_using_map2_local(X) {
        var return$0 = X[1], map2 = X[2], map = X[3];
        return Make2_using_map2_local([
            0,
            return$0,
            map2,
            map
        ]);
    }
    function Of_monad2(M) {
        var return$0 = M[6];
        function apply(mf, mx) {
            return caml_call2(M[5], mf, function(f) {
                return caml_call2(M[7], mx, f);
            });
        }
        var map = [
            0,
            -198771759,
            M[7]
        ];
        return Make2([
            0,
            return$0,
            apply,
            map
        ]);
    }
    function Of_monad(M) {
        var symbol_bind = M[1], symbol_map = M[2], Monad_infix = M[3], bind = M[4], return$0 = M[5], map = M[6], join = M[7], ignore_m = M[8], all = M[9], all_unit = M[10], Let_syntax = M[11];
        return Of_monad2([
            0,
            symbol_bind,
            symbol_map,
            Let_syntax,
            Monad_infix,
            bind,
            return$0,
            map,
            join,
            ignore_m,
            all,
            all_unit
        ]);
    }
    function Compose(F, G) {
        function return$0(a) {
            var _z_ = caml_call1(F[1], a);
            return caml_call1(G[1], _z_);
        }
        function apply(tf, tx) {
            var _y_ = caml_call2(G[2], tf, F[8]);
            return caml_call2(G[8], _y_, tx);
        }
        function custom_map(t, f) {
            var _w_ = F[2];
            return caml_call2(G[2], t, function(_x_) {
                return caml_call2(_w_, _x_, f);
            });
        }
        var map = [
            0,
            -198771759,
            custom_map
        ], include = Make([
            0,
            return$0,
            apply,
            map
        ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply$0 = include[8], map2 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13];
        return [
            0,
            return$1,
            map$0,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply$0,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function Pair(F, G) {
        function return$0(a) {
            var _v_ = caml_call1(G[1], a);
            return [
                0,
                caml_call1(F[1], a),
                _v_
            ];
        }
        function apply(tf, tx) {
            var _q_ = caml_call1(Base_Import[127], tx), _r_ = caml_call1(Base_Import[127], tf), _s_ = caml_call2(G[8], _r_, _q_), _t_ = caml_call1(Base_Import[125], tx), _u_ = caml_call1(Base_Import[125], tf);
            return [
                0,
                caml_call2(F[8], _u_, _t_),
                _s_
            ];
        }
        function custom_map(t, f) {
            var _n_ = caml_call1(Base_Import[127], t), _o_ = caml_call2(G[2], _n_, f), _p_ = caml_call1(Base_Import[125], t);
            return [
                0,
                caml_call2(F[2], _p_, f),
                _o_
            ];
        }
        var map = [
            0,
            -198771759,
            custom_map
        ], include = Make([
            0,
            return$0,
            apply,
            map
        ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply$0 = include[8], map2 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13];
        return [
            0,
            return$1,
            map$0,
            both,
            symbol,
            symbol$0,
            symbol$1,
            symbol_map,
            apply$0,
            map2,
            map3,
            all,
            all_unit,
            Applicative_infix
        ];
    }
    function return$0(_m_) {
        return _m_;
    }
    function map2(a, b, f) {
        return caml_call2(f, a, b);
    }
    var map = [
        0,
        -198771759,
        function(a, f) {
            return caml_call1(f, a);
        }
    ], include = Make_using_map2_local([
        0,
        return$0,
        map2,
        map
    ]), return$1 = include[1], map$0 = include[2], both = include[3], symbol = include[4], symbol$0 = include[5], symbol$1 = include[6], symbol_map = include[7], apply = include[8], map2$0 = include[9], map3 = include[10], all = include[11], all_unit = include[12], Applicative_infix = include[13], Ident = [
        0,
        return$1,
        map$0,
        both,
        symbol,
        symbol$0,
        symbol$1,
        symbol_map,
        apply,
        map2$0,
        map3,
        all,
        all_unit,
        Applicative_infix
    ], Base_Applicative = [
        0,
        Ident,
        S2_to_S,
        S_to_S2,
        S3_to_S2,
        S3_to_S,
        S2_to_S3,
        Make,
        Make2,
        Make3,
        function(X, Intf, Impl) {
            var return$0 = X[1], map = X[2], both = X[3], symbol = X[4], symbol$0 = X[5], symbol$1 = X[6], symbol_map = X[7], _k_ = Make_let_syntax2([
                0,
                return$0,
                map,
                both,
                symbol,
                symbol$0,
                symbol$1,
                symbol_map
            ], Intf, Impl)[1], _l_ = _k_[8];
            return [
                0,
                [
                    0,
                    _k_[1],
                    _k_[4],
                    _k_[5],
                    _k_[6],
                    _k_[7],
                    [
                        0,
                        _l_[1],
                        _l_[2],
                        _l_[3],
                        _l_[8]
                    ]
                ]
            ];
        },
        function(_h_, _g_, _f_) {
            var _i_ = Make_let_syntax2(_h_, _g_, _f_)[1], _j_ = _i_[8];
            return [
                0,
                [
                    0,
                    _i_[1],
                    _i_[4],
                    _i_[5],
                    _i_[6],
                    _i_[7],
                    [
                        0,
                        _j_[1],
                        _j_[2],
                        _j_[3],
                        _j_[8]
                    ]
                ]
            ];
        },
        function(_c_, _b_, _a_) {
            var _d_ = Make_let_syntax3(_c_, _b_, _a_)[1], _e_ = _d_[8];
            return [
                0,
                [
                    0,
                    _d_[1],
                    _d_[4],
                    _d_[5],
                    _d_[6],
                    _d_[7],
                    [
                        0,
                        _e_[1],
                        _e_[2],
                        _e_[3],
                        _e_[8]
                    ]
                ]
            ];
        },
        Make_using_map2,
        Make2_using_map2,
        Make3_using_map2,
        Make_using_map2_local,
        Make2_using_map2_local,
        Make3_using_map2_local,
        Of_monad,
        Of_monad2,
        Compose,
        Pair
    ];
    runtime.caml_register_global(2, Base_Applicative, "Base__Applicative");
    return;
})(globalThis);
//# 4732 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var Module = [
        0
    ];
    function of_module(M) {
        return M[1];
    }
    function to_module(t) {
        return [
            0,
            t
        ];
    }
    function make(compare, sexp_of_t) {
        var comparator = [
            0,
            compare,
            sexp_of_t
        ];
        return [
            0,
            comparator
        ];
    }
    function S_to_S1(S) {
        var comparator = S[1];
        return [
            0,
            comparator
        ];
    }
    function Make1(M) {
        var comparator = [
            0,
            M[1],
            M[2]
        ];
        return [
            0,
            comparator
        ];
    }
    var compare = runtime.caml_compare, _a_ = [
        0,
        "_"
    ];
    function sexp_of_t(param) {
        return _a_;
    }
    var include = Make1([
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], Poly = [
        0,
        comparator
    ];
    function Derived(M) {
        function comparator(a) {
            var _e_ = caml_call1(M[2], a[2]);
            return [
                0,
                caml_call1(M[1], a[1]),
                _e_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived2(M) {
        function comparator(a, b) {
            var _d_ = caml_call2(M[2], a[2], b[2]);
            return [
                0,
                caml_call2(M[1], a[1], b[1]),
                _d_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived_phantom(M) {
        function comparator(a) {
            var _c_ = caml_call1(M[2], a[2]);
            return [
                0,
                caml_call1(M[1], a[1]),
                _c_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    function Derived2_phantom(M) {
        function comparator(a, b) {
            var _b_ = caml_call2(M[2], a[2], b[2]);
            return [
                0,
                caml_call2(M[1], a[1], b[1]),
                _b_
            ];
        }
        return [
            0,
            comparator
        ];
    }
    var Base_Comparator = [
        0,
        make,
        Poly,
        Module,
        of_module,
        to_module,
        S_to_S1,
        function(M) {
            var comparator = [
                0,
                M[1],
                M[2]
            ];
            return [
                0,
                comparator
            ];
        },
        Make1,
        Derived,
        Derived2,
        Derived_phantom,
        Derived2_phantom
    ];
    runtime.caml_register_global(1, Base_Comparator, "Base__Comparator");
    return;
})(globalThis);
//# 5024 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_int$3 = "int", cst_int32$3 = "int32", cst_int64$3 = "int64", cst_nativeint$2 = "nativeint", cst_src_int_conversions_ml = "src/int_conversions.ml", caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right = runtime.caml_int64_shift_right, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Sys0 = global_data.Base__Sys0, Base_Word_size = global_data.Base__Word_size, Assert_failure = global_data.Assert_failure, Stdlib_Int32 = global_data.Stdlib__Int32, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Base_Int0 = global_data.Base__Int0, _a_ = [
        0,
        [
            11,
            "conversion from ",
            [
                2,
                0,
                [
                    11,
                    " to ",
                    [
                        2,
                        0,
                        [
                            11,
                            " failed: ",
                            [
                                2,
                                0,
                                [
                                    11,
                                    " is out of range",
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "conversion from %s to %s failed: %s is out of range"
    ];
    function convert_failure(x, a, b, to_string) {
        var _H_ = caml_call1(to_string, x);
        return caml_call5(Base_Printf[6], _a_, a, b, _H_, 0);
    }
    var num_bits_int = Base_Sys0[8], num_bits_nativeint = caml_call1(Base_Word_size[2], Base_Word_size[3]), cst_int63 = "int63", cst_int64$2 = cst_int64$3, cst_nativeint$1 = cst_nativeint$2, cst_int64$1 = cst_int64$3, cst_int32$2 = cst_int32$3, cst_nativeint$0 = cst_nativeint$2, cst_int32$1 = cst_int32$3, cst_int64$0 = cst_int64$3, cst_int$2 = cst_int$3, cst_nativeint = cst_nativeint$2, cst_int$1 = cst_int$3, cst_int64 = cst_int64$3, _d_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_int$0 = cst_int$3, cst_int32$0 = cst_int32$3, cst_int32 = cst_int32$3, cst_int = cst_int$3, _k_ = [
        0,
        cst_src_int_conversions_ml,
        19,
        9
    ], _j_ = [
        0,
        cst_src_int_conversions_ml,
        82,
        9
    ], _i_ = [
        0,
        cst_src_int_conversions_ml,
        103,
        9
    ], _h_ = [
        0,
        cst_src_int_conversions_ml,
        155,
        9
    ], _g_ = [
        0,
        cst_src_int_conversions_ml,
        183,
        9
    ], num_bits_int32 = 32, num_bits_int64 = 64;
    if (63 !== num_bits_int && 31 !== num_bits_int && 32 !== num_bits_int) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _k_
    ], 1);
    var min_int32 = Stdlib_Int32[10], max_int32 = Stdlib_Int32[9], min_int64 = Stdlib_Int64[10], max_int64 = Stdlib_Int64[9], min_nativeint = Stdlib_Nativeint[11], max_nativeint = Stdlib_Nativeint[10], int64_to_string = Stdlib_Int64[14], nativeint_to_string = Stdlib_Nativeint[15];
    function int32_to_int_trunc(_G_) {
        return _G_;
    }
    function int_to_int32_trunc(_F_) {
        return _F_;
    }
    var _b_ = Base_Import[85][33], _c_ = Stdlib_Int32[14], int_is_representable_as_int32 = num_bits_int <= 32 ? function(param) {
        return 1;
    } : function(x) {
        var _D_ = caml_call2(Base_Import[228], min_int32, x) <= 0 ? 1 : 0, _E_ = _D_ ? caml_call2(Base_Import[228], x, max_int32) <= 0 ? 1 : 0 : _D_;
        return _E_;
    };
    if (32 <= num_bits_int) var int32_is_representable_as_int = function(param) {
        return 1;
    };
    else var min$1 = Base_Int0[7], max$1 = Base_Int0[6], int32_is_representable_as_int = function(x) {
        var _B_ = caml_call2(Base_Import[229], min$1, x) <= 0 ? 1 : 0, _C_ = _B_ ? caml_call2(Base_Import[229], x, max$1) <= 0 ? 1 : 0 : _B_;
        return _C_;
    };
    function int_to_int32(x) {
        return int_is_representable_as_int32(x) ? [
            0,
            x
        ] : 0;
    }
    function int32_to_int(x) {
        return int32_is_representable_as_int(x) ? [
            0,
            x
        ] : 0;
    }
    function int_to_int32_exn(x) {
        return int_is_representable_as_int32(x) ? x : convert_failure(x, cst_int, cst_int32, _b_);
    }
    function int32_to_int_exn(x) {
        return int32_is_representable_as_int(x) ? x : convert_failure(x, cst_int32$0, cst_int$0, _c_);
    }
    if (num_bits_int >= 64) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _j_
    ], 1);
    var int_to_int64 = caml_int64_of_int32, int64_to_int_trunc = caml_int64_to_int32, min$4 = caml_int64_of_int32(Base_Int0[7]), max$4 = caml_int64_of_int32(Base_Int0[6]);
    function int64_is_representable_as_int(x) {
        var _z_ = caml_call2(Base_Import[230], min$4, x) <= 0 ? 1 : 0, _A_ = _z_ ? caml_call2(Base_Import[230], x, max$4) <= 0 ? 1 : 0 : _z_;
        return _A_;
    }
    function int64_to_int(x) {
        return int64_is_representable_as_int(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_int_exn(x) {
        return int64_is_representable_as_int(x) ? caml_int64_to_int32(x) : convert_failure(runtime.caml_int64_add(x, _d_), cst_int64, cst_int$1, int64_to_string);
    }
    if (num_bits_int > num_bits_nativeint) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _i_
    ], 1);
    function int_to_nativeint(_y_) {
        return _y_;
    }
    function nativeint_to_int_trunc(_x_) {
        return _x_;
    }
    if (num_bits_nativeint <= num_bits_int) var _e_ = function(param) {
        return 1;
    };
    else var min$0 = Base_Int0[7], max$0 = Base_Int0[6], _e_ = function(x) {
        var _v_ = caml_call2(Base_Import[231], min$0, x) <= 0 ? 1 : 0, _w_ = _v_ ? caml_call2(Base_Import[231], x, max$0) <= 0 ? 1 : 0 : _v_;
        return _w_;
    };
    function nativeint_to_int(x) {
        return _e_(x) ? [
            0,
            x
        ] : 0;
    }
    function nativeint_to_int_exn(x) {
        return _e_(x) ? x : convert_failure(x, cst_nativeint, cst_int$2, nativeint_to_string);
    }
    var int32_to_int64 = caml_int64_of_int32, int64_to_int32_trunc = caml_int64_to_int32, min$3 = caml_int64_of_int32(min_int32), max$3 = caml_int64_of_int32(max_int32);
    function int64_is_representable_as_int3(x) {
        var _t_ = caml_call2(Base_Import[230], min$3, x) <= 0 ? 1 : 0, _u_ = _t_ ? caml_call2(Base_Import[230], x, max$3) <= 0 ? 1 : 0 : _t_;
        return _u_;
    }
    function int64_to_int32(x) {
        return int64_is_representable_as_int3(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_int32_exn(x) {
        return int64_is_representable_as_int3(x) ? caml_int64_to_int32(x) : convert_failure(x, cst_int64$0, cst_int32$1, int64_to_string);
    }
    if (32 > num_bits_nativeint) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _h_
    ], 1);
    function int32_to_nativeint(_s_) {
        return _s_;
    }
    function nativeint_to_int32_trunc(_r_) {
        return _r_;
    }
    var _f_ = num_bits_nativeint <= 32 ? function(param) {
        return 1;
    } : function(x) {
        var _p_ = caml_call2(Base_Import[231], min_int32, x) <= 0 ? 1 : 0, _q_ = _p_ ? caml_call2(Base_Import[231], x, max_int32) <= 0 ? 1 : 0 : _p_;
        return _q_;
    };
    function nativeint_to_int32(x) {
        return _f_(x) ? [
            0,
            x
        ] : 0;
    }
    function nativeint_to_int32_exn(x) {
        return _f_(x) ? x : convert_failure(x, cst_nativeint$0, cst_int32$2, nativeint_to_string);
    }
    if (num_bits_nativeint > 64) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _g_
    ], 1);
    var int64_to_nativeint_trunc = caml_int64_to_int32, nativeint_to_int64 = caml_int64_of_int32;
    if (64 <= num_bits_nativeint) var int64_is_representable_as_nati = function(param) {
        return 1;
    };
    else var min$2 = caml_int64_of_int32(min_nativeint), max$2 = caml_int64_of_int32(max_nativeint), int64_is_representable_as_nati = function(x) {
        var _n_ = caml_call2(Base_Import[230], min$2, x) <= 0 ? 1 : 0, _o_ = _n_ ? caml_call2(Base_Import[230], x, max$2) <= 0 ? 1 : 0 : _n_;
        return _o_;
    };
    function int64_to_nativeint(x) {
        return int64_is_representable_as_nati(x) ? [
            0,
            caml_int64_to_int32(x)
        ] : 0;
    }
    function int64_to_nativeint_exn(x) {
        return int64_is_representable_as_nati(x) ? caml_int64_to_int32(x) : convert_failure(x, cst_int64$1, cst_nativeint$1, int64_to_string);
    }
    var min = caml_int64_shift_right(min_int64, 1), max = caml_int64_shift_right(max_int64, 1);
    function int64_is_representable_as_int6(x) {
        var _l_ = caml_call2(Base_Import[230], min, x) <= 0 ? 1 : 0, _m_ = _l_ ? caml_call2(Base_Import[230], x, max) <= 0 ? 1 : 0 : _l_;
        return _m_;
    }
    function int64_fit_on_int63_exn(x) {
        return int64_is_representable_as_int6(x) ? 0 : convert_failure(x, cst_int64$2, cst_int63, int64_to_string);
    }
    var Base_Int_conversions = [
        0,
        int_to_int32,
        int_to_int32_exn,
        int_to_int32_trunc,
        int_to_int64,
        int_to_nativeint,
        int32_to_int,
        int32_to_int_exn,
        int32_to_int_trunc,
        int32_to_int64,
        int32_to_nativeint,
        int32_is_representable_as_int,
        int64_to_int,
        int64_to_int_exn,
        int64_to_int_trunc,
        int64_to_int32,
        int64_to_int32_exn,
        int64_to_int32_trunc,
        int64_to_nativeint,
        int64_to_nativeint_exn,
        int64_to_nativeint_trunc,
        int64_fit_on_int63_exn,
        int64_is_representable_as_int6,
        nativeint_to_int,
        nativeint_to_int_exn,
        nativeint_to_int_trunc,
        nativeint_to_int32,
        nativeint_to_int32_exn,
        nativeint_to_int32_trunc,
        nativeint_to_int64,
        num_bits_int,
        num_bits_int32,
        num_bits_int64,
        num_bits_nativeint
    ];
    runtime.caml_register_global(33, Base_Int_conversions, "Base__Int_conversions");
    return;
})(globalThis);
//# 5341 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdlib_Uchar = global_data.Stdlib__Uchar, succ = Stdlib_Uchar[5], pred = Stdlib_Uchar[6], is_valid = Stdlib_Uchar[7], is_char = Stdlib_Uchar[11], unsafe_to_char = Stdlib_Uchar[14], unsafe_of_int = Stdlib_Uchar[9], of_int = Stdlib_Uchar[8], to_int = Stdlib_Uchar[10], of_char = Stdlib_Uchar[12], compare = Stdlib_Uchar[16], equal = Stdlib_Uchar[15], min_value = Stdlib_Uchar[1], max_value = Stdlib_Uchar[2], byte_order_mark = Stdlib_Uchar[3], replacement_char = Stdlib_Uchar[4], utf_8_byte_length = Stdlib_Uchar[24], utf_16_byte_length = Stdlib_Uchar[25], utf_decode_is_valid = Stdlib_Uchar[19], utf_decode_uchar = Stdlib_Uchar[20], utf_decode_length = Stdlib_Uchar[21], utf_decode = Stdlib_Uchar[22], utf_decode_invalid = Stdlib_Uchar[23], Base_Uchar0 = [
        0,
        succ,
        pred,
        is_valid,
        is_char,
        unsafe_to_char,
        unsafe_of_int,
        of_int,
        to_int,
        of_char,
        compare,
        equal,
        min_value,
        max_value,
        byte_order_mark,
        replacement_char,
        utf_8_byte_length,
        utf_16_byte_length,
        utf_decode_is_valid,
        utf_decode_uchar,
        utf_decode_length,
        utf_decode,
        utf_decode_invalid
    ];
    runtime.caml_register_global(1, Base_Uchar0, "Base__Uchar0");
    return;
})(globalThis);
//# 5401 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, Base_Import0 = global_data.Base__Import0, Base_Char0 = global_data.Base__Char0, Stdlib_StringLabels = global_data.Stdlib__StringLabels, Base_Int_conversions = global_data.Base__Int_conversions, Base_Uchar0 = global_data.Base__Uchar0, Stdlib = global_data.Stdlib, Base_Sys0 = global_data.Base__Sys0, String1 = [
        0
    ], max_length = Base_Sys0[10], symbol_concat = Base_Import0[112], capitalize = Stdlib_StringLabels[28], compare = Stdlib_StringLabels[10], escaped = Stdlib_StringLabels[25], lowercase = Stdlib_StringLabels[27], make = Stdlib_StringLabels[1], sub = Stdlib_StringLabels[16], uncapitalize = Stdlib_StringLabels[29], uppercase = Stdlib_StringLabels[26], is_valid_utf_8 = Stdlib_StringLabels[44], is_valid_utf_16le = Stdlib_StringLabels[48], is_valid_utf_16be = Stdlib_StringLabels[46], cst_index_out_of_bounds = "index out of bounds", dummy = 0;
    function get_utf_8_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[43], t, byte_pos);
    }
    function get_utf_16le_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[47], t, byte_pos);
    }
    function get_utf_16be_uchar(t, byte_pos) {
        return caml_call2(Stdlib_StringLabels[45], t, byte_pos);
    }
    function get_utf_32_uchar(get_int32, t, byte_pos) {
        var len = caml_ml_string_length(t), _j_ = 0 <= byte_pos ? 1 : 0, _k_ = _j_ ? byte_pos < len ? 1 : 0 : _j_;
        if (!_k_) throw caml_maybe_attach_backtrace([
            0,
            Stdlib[6],
            cst_index_out_of_bounds
        ], 1);
        var bytes_read = caml_call2(Base_Import0[93], len, byte_pos);
        if (2 >= bytes_read - 1 >>> 0) return caml_call1(Base_Uchar0[22], bytes_read);
        var int32 = caml_call2(get_int32, t, byte_pos);
        if (!caml_call1(Base_Int_conversions[11], int32)) return caml_call1(Base_Uchar0[22], 4);
        var int$0 = caml_call1(Base_Int_conversions[8], int32);
        if (!caml_call1(Base_Uchar0[3], int$0)) return caml_call1(Base_Uchar0[22], 4);
        var _l_ = caml_call1(Base_Uchar0[6], int$0);
        return caml_call2(Base_Uchar0[21], 4, _l_);
    }
    function get_utf_32le_uchar(t, byte_pos) {
        return get_utf_32_uchar(Stdlib_StringLabels[61], t, byte_pos);
    }
    function get_utf_32be_uchar(t, byte_pos) {
        return get_utf_32_uchar(Stdlib_StringLabels[60], t, byte_pos);
    }
    function concat(opt, l) {
        var sep = opt ? opt[1] : cst$0;
        if (!l) return cst;
        if (l[2]) return caml_call2(Stdlib_StringLabels[7], sep, l);
        var x = l[1];
        return x;
    }
    function iter(t, f) {
        var _h_ = caml_call2(Base_Import0[93], caml_ml_string_length(t), 1), _g_ = 0;
        if (_h_ >= 0) {
            var i = _g_;
            for(;;){
                caml_call1(f, runtime.caml_string_unsafe_get(t, i));
                var _i_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _i_;
            }
        }
        return 0;
    }
    function back_up_at_newline(t, pos, eol) {
        a: {
            if (0 < pos[1]) {
                var _e_ = caml_string_get(t, caml_call2(Base_Import0[93], pos[1], 1));
                if (caml_call2(Base_Char0[12], _e_, 13)) {
                    var _f_ = 2;
                    break a;
                }
            }
            var _f_ = 1;
        }
        pos[1] = caml_call2(Base_Import0[93], pos[1], _f_);
        eol[1] = caml_call2(Base_Import0[91], pos[1], 1);
    }
    function split_lines(t) {
        var n = caml_ml_string_length(t);
        if (0 === n) return 0;
        var pos = [
            0,
            caml_call2(Base_Import0[93], n, 1)
        ], eol = [
            0,
            n
        ], ac = [
            0,
            0
        ], _a_ = caml_string_get(t, pos[1]);
        if (caml_call2(Base_Char0[12], _a_, 10)) back_up_at_newline(t, pos, eol);
        for(;;){
            if (0 > pos[1]) {
                var _d_ = ac[1];
                return [
                    0,
                    caml_call3(sub, t, 0, eol[1]),
                    _d_
                ];
            }
            var _b_ = caml_string_get(t, pos[1]);
            if (caml_call2(Base_Char0[12], _b_, 10)) {
                var start = caml_call2(Base_Import0[91], pos[1], 1), _c_ = ac[1];
                ac[1] = [
                    0,
                    caml_call3(sub, t, start, caml_call2(Base_Import0[93], eol[1], start)),
                    _c_
                ];
                back_up_at_newline(t, pos, eol);
            } else pos[1]--;
        }
    }
    var Base_String0 = [
        0,
        String1,
        max_length,
        symbol_concat,
        capitalize,
        compare,
        escaped,
        lowercase,
        make,
        sub,
        uncapitalize,
        uppercase,
        is_valid_utf_8,
        is_valid_utf_16le,
        is_valid_utf_16be,
        get_utf_8_uchar,
        get_utf_16le_uchar,
        get_utf_16be_uchar,
        get_utf_32le_uchar,
        get_utf_32be_uchar,
        concat,
        iter,
        split_lines
    ];
    runtime.caml_register_global(10, Base_String0, "Base__String0");
    return;
})(globalThis);
//# 5580 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = ":";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$1, cst$0 = cst$1, Base_Import = global_data.Base__Import, Base_Int0 = global_data.Base__Int0, Base_String0 = global_data.Base__String0, Base_Hash = global_data.Base__Hash, Base_Comparator = global_data.Base__Comparator, _a_ = [
        0,
        "pos_cnum"
    ], _b_ = [
        0,
        "pos_bol"
    ], _c_ = [
        0,
        "pos_lnum"
    ], _d_ = [
        0,
        "pos_fname"
    ];
    function compare_local(a_001, b_002) {
        if (a_001 === b_002) return 0;
        var n = caml_call2(Base_Import[260], a_001[1], b_002[1]);
        if (0 !== n) return n;
        var n$0 = caml_call2(Base_Import[256], a_001[2], b_002[2]);
        if (0 !== n$0) return n$0;
        var n$1 = caml_call2(Base_Import[256], a_001[3], b_002[3]);
        return 0 === n$1 ? caml_call2(Base_Import[256], a_001[4], b_002[4]) : n$1;
    }
    function compare(a, b) {
        return compare_local(a, b);
    }
    function hash_fold_t(hsv, arg) {
        var hsv$0 = caml_call2(Base_Import[208], hsv, arg[1]), hsv$1 = caml_call2(Base_Import[206], hsv$0, arg[2]), hsv$2 = caml_call2(Base_Import[206], hsv$1, arg[3]);
        return caml_call2(Base_Import[206], hsv$2, arg[4]);
    }
    function hash(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _h_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _h_);
    }
    function sexp_of_t(param) {
        var pos_cnum_010 = param[4], pos_bol_008 = param[3], pos_lnum_006 = param[2], pos_fname_004 = param[1], arg_011 = caml_call1(Base_Import[139], pos_cnum_010), bnds_003 = [
            0,
            [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        arg_011,
                        0
                    ]
                ]
            ],
            0
        ], arg_009 = caml_call1(Base_Import[139], pos_bol_008), bnds_003$0 = [
            0,
            [
                1,
                [
                    0,
                    _b_,
                    [
                        0,
                        arg_009,
                        0
                    ]
                ]
            ],
            bnds_003
        ], arg_007 = caml_call1(Base_Import[139], pos_lnum_006), bnds_003$1 = [
            0,
            [
                1,
                [
                    0,
                    _c_,
                    [
                        0,
                        arg_007,
                        0
                    ]
                ]
            ],
            bnds_003$0
        ], arg_005 = caml_call1(Base_Import[136], pos_fname_004), bnds_003$2 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_005,
                        0
                    ]
                ]
            ],
            bnds_003$1
        ];
        return [
            1,
            bnds_003$2
        ];
    }
    var T = [
        0,
        compare_local,
        compare,
        hash_fold_t,
        hash,
        sexp_of_t
    ], compare_local$0 = T[1], compare$0 = T[2], hash_fold_t$0 = T[3], hash$0 = T[4], include = caml_call1(Base_Comparator[7], [
        0,
        T[2],
        T[5]
    ]), comparator = include[1];
    function make_location_string(pos_fname, pos_lnum, pos_cnum, pos_bol) {
        var _e_ = caml_call2(Base_Import[93], pos_cnum, pos_bol), _f_ = [
            0,
            cst,
            [
                0,
                caml_call1(Base_Int0[1], _e_),
                0
            ]
        ], _g_ = [
            0,
            pos_fname,
            [
                0,
                cst$0,
                [
                    0,
                    caml_call1(Base_Int0[1], pos_lnum),
                    _f_
                ]
            ]
        ];
        return caml_call2(Base_String0[20], 0, _g_);
    }
    function to_string(param) {
        var pos_cnum = param[4], pos_bol = param[3], pos_lnum = param[2], pos_fname = param[1];
        return make_location_string(pos_fname, pos_lnum, pos_cnum, pos_bol);
    }
    function sexp_of_t$0(t) {
        return [
            0,
            to_string(t)
        ];
    }
    var Base_Source_code_position0 = [
        0,
        T,
        compare_local$0,
        compare$0,
        hash_fold_t$0,
        hash$0,
        comparator,
        make_location_string,
        to_string,
        sexp_of_t$0
    ];
    runtime.caml_register_global(11, Base_Source_code_position0, "Base__Source_code_position0");
    return;
})(globalThis);
//# 5701 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_List0 = global_data.Base__List0, hd_exn = Base_List0[1], rev_append = Base_List0[2], tl_exn = Base_List0[3], unzip = Base_List0[4], length = Base_List0[5], exists = Base_List0[6], exists2_ok = Base_List0[7], fold = Base_List0[8], fold2_ok = Base_List0[9], for_all = Base_List0[10], for_all2_ok = Base_List0[11], iter = Base_List0[12], iter2_ok = Base_List0[13], nontail_map = Base_List0[14], nontail_mapi = Base_List0[15], partition = Base_List0[16], rev_map = Base_List0[17], rev_map2_ok = Base_List0[18], rev = Base_List0[19], fold_right = Base_List0[20], fold_right2_ok = Base_List0[21];
    function is_empty(param) {
        return param ? 0 : 1;
    }
    function partition_map(t, f) {
        var t$0 = t, fst = 0, snd = 0;
        for(;;){
            if (!t$0) {
                var _a_ = caml_call1(rev, snd);
                return [
                    0,
                    caml_call1(rev, fst),
                    _a_
                ];
            }
            var t$1 = t$0[2], x = t$0[1], match = caml_call1(f, x);
            if (0 === match[0]) {
                var y = match[1], fst$0 = [
                    0,
                    y,
                    fst
                ];
                t$0 = t$1;
                fst = fst$0;
            } else {
                var y$0 = match[1], snd$0 = [
                    0,
                    y$0,
                    snd
                ];
                t$0 = t$1;
                snd = snd$0;
            }
        }
    }
    var Base_List1 = [
        0,
        hd_exn,
        rev_append,
        tl_exn,
        unzip,
        length,
        exists,
        exists2_ok,
        fold,
        fold2_ok,
        for_all,
        for_all2_ok,
        iter,
        iter2_ok,
        nontail_map,
        nontail_mapi,
        partition,
        rev_map,
        rev_map2_ok,
        rev,
        fold_right,
        fold_right2_ok,
        is_empty,
        partition_map
    ];
    runtime.caml_register_global(1, Base_List1, "Base__List1");
    return;
})(globalThis);
//# 5784 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Error$0 = "Error", cst_Ok$0 = "Ok", cst_error = "error", cst_ok = "ok", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_005 = "result.ml.t", Base_List1 = global_data.Base__List1, Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Monad = global_data.Base__Monad, _a_ = [
        0,
        cst_Ok$0
    ], _b_ = [
        0,
        cst_Error$0
    ], cst_Error = cst_Error$0, cst_Ok = cst_Ok$0;
    function t_of_sexp(of_a_001, of_b_002, sexp_007) {
        a: {
            if (0 === sexp_007[0]) {
                var _e_ = sexp_007[1];
                b: if (_e_ !== cst_Error$0) {
                    if (_e_ !== cst_Ok$0) {
                        if (_e_ === cst_error) break b;
                        if (_e_ !== cst_ok) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_005, sexp_007);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_005, sexp_007);
            }
            var _f_ = sexp_007[1];
            if (!_f_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_005, sexp_007);
            var _g_ = _f_[1];
            if (0 !== _g_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_005, sexp_007);
            var tag_008 = _g_[1];
            b: if (tag_008 !== cst_Error$0) {
                if (tag_008 !== cst_Ok$0) {
                    if (tag_008 === cst_error) break b;
                    if (tag_008 !== cst_ok) break a;
                }
                var sexp_args_009 = _f_[2];
                if (sexp_args_009 && !sexp_args_009[2]) {
                    var arg0_010 = sexp_args_009[1], res0_011 = caml_call1(of_a_001, arg0_010);
                    return [
                        0,
                        res0_011
                    ];
                }
                return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_005, tag_008, sexp_007);
            }
            var sexp_args_014 = _f_[2];
            if (sexp_args_014 && !sexp_args_014[2]) {
                var arg0_015 = sexp_args_014[1], res0_016 = caml_call1(of_b_002, arg0_015);
                return [
                    1,
                    res0_016
                ];
            }
            return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_005, tag_008, sexp_007);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_005, sexp_007);
    }
    function sexp_of_t(of_a_019, of_b_020, param) {
        if (0 === param[0]) {
            var arg0_021 = param[1], res0_022 = caml_call1(of_a_019, arg0_021);
            return [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        res0_022,
                        0
                    ]
                ]
            ];
        }
        var arg0_023 = param[1], res0_024 = caml_call1(of_b_020, arg0_023);
        return [
            1,
            [
                0,
                _b_,
                [
                    0,
                    res0_024,
                    0
                ]
            ]
        ];
    }
    function t_sexp_grammar(a_sexp_grammar, b_sexp_grammar) {
        return [
            3,
            [
                0,
                2,
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Ok,
                            [
                                0,
                                [
                                    0,
                                    a_sexp_grammar,
                                    0
                                ]
                            ]
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Error,
                                [
                                    0,
                                    [
                                        0,
                                        b_sexp_grammar,
                                        0
                                    ]
                                ]
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ];
    }
    function compare_local(cmp_a, cmp_b, a_033, b_034) {
        if (a_033 === b_034) return 0;
        if (0 === a_033[0]) {
            var a_035 = a_033[1];
            if (0 !== b_034[0]) return -1;
            var b_036 = b_034[1];
            return caml_call2(cmp_a, a_035, b_036);
        }
        var a_037 = a_033[1];
        if (0 === b_034[0]) return 1;
        var b_038 = b_034[1];
        return caml_call2(cmp_b, a_037, b_038);
    }
    function compare(cmp_a, cmp_b, a_027, b_028) {
        if (a_027 === b_028) return 0;
        if (0 === a_027[0]) {
            var a_029 = a_027[1];
            if (0 !== b_028[0]) return -1;
            var b_030 = b_028[1];
            return caml_call2(cmp_a, a_029, b_030);
        }
        var a_031 = a_027[1];
        if (0 === b_028[0]) return 1;
        var b_032 = b_028[1];
        return caml_call2(cmp_b, a_031, b_032);
    }
    function equal_local(cmp_a, cmp_b, a_045, b_046) {
        if (a_045 === b_046) return 1;
        if (0 === a_045[0]) {
            var a_047 = a_045[1];
            if (0 !== b_046[0]) return 0;
            var b_048 = b_046[1];
            return caml_call2(cmp_a, a_047, b_048);
        }
        var a_049 = a_045[1];
        if (0 === b_046[0]) return 0;
        var b_050 = b_046[1];
        return caml_call2(cmp_b, a_049, b_050);
    }
    function equal(cmp_a, cmp_b, a_039, b_040) {
        if (a_039 === b_040) return 1;
        if (0 === a_039[0]) {
            var a_041 = a_039[1];
            if (0 !== b_040[0]) return 0;
            var b_042 = b_040[1];
            return caml_call2(cmp_a, a_041, b_042);
        }
        var a_043 = a_039[1];
        if (0 === b_040[0]) return 0;
        var b_044 = b_040[1];
        return caml_call2(cmp_b, a_043, b_044);
    }
    function hash_fold_t(hash_fold_a, hash_fold_b, hsv, arg) {
        if (0 === arg[0]) {
            var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
            return caml_call2(hash_fold_a, hsv$0, a0);
        }
        var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
        return caml_call2(hash_fold_b, hsv$1, a0$0);
    }
    var globalize = Base_Import[295];
    function bind(x, f) {
        if (0 !== x[0]) return x;
        var x$0 = x[1];
        return caml_call1(f, x$0);
    }
    var map = [
        0,
        -198771759,
        function(x, f) {
            if (0 !== x[0]) return x;
            var x$0 = x[1];
            return [
                0,
                caml_call1(f, x$0)
            ];
        }
    ];
    function return$0(x) {
        return [
            0,
            x
        ];
    }
    var include = caml_call1(Base_Monad[6], [
        0,
        bind,
        map,
        return$0
    ]), symbol_bind = include[1], symbol_map = include[2], Let_syntax = include[3], Monad_infix = include[4], bind$0 = include[5], return$1 = include[6], map$0 = include[7], join = include[8], ignore_m = include[9], all = include[10], all_unit = include[11];
    function invariant(check_ok, check_error, t) {
        if (0 === t[0]) {
            var ok = t[1];
            return caml_call1(check_ok, ok);
        }
        var error = t[1];
        return caml_call1(check_error, error);
    }
    function fail(x) {
        return [
            1,
            x
        ];
    }
    function failf(format) {
        return caml_call2(Base_Printf[4], fail, format);
    }
    function map_error(t, f) {
        if (0 === t[0]) return t;
        var x = t[1];
        return [
            1,
            caml_call1(f, x)
        ];
    }
    function bind$1(x, f) {
        if (0 === x[0]) return x;
        var e = x[1];
        return caml_call1(f, e);
    }
    var map$1 = [
        0,
        -198771759,
        map_error
    ];
    function return$2(e) {
        return [
            1,
            e
        ];
    }
    var Error1 = caml_call1(Base_Monad[6], [
        0,
        bind$1,
        map$1,
        return$2
    ]), _c_ = [
        0,
        0
    ];
    function is_ok(param) {
        return 0 === param[0] ? 1 : 0;
    }
    function is_error(param) {
        return 0 === param[0] ? 0 : 1;
    }
    function ok(param) {
        if (0 !== param[0]) return 0;
        var x = param[1];
        return [
            0,
            x
        ];
    }
    function error(param) {
        if (0 === param[0]) return 0;
        var x = param[1];
        return [
            0,
            x
        ];
    }
    function of_option(opt, error) {
        if (!opt) return [
            1,
            error
        ];
        var x = opt[1];
        return [
            0,
            x
        ];
    }
    function iter(v, f) {
        if (0 !== v[0]) return 0;
        var x = v[1];
        return caml_call1(f, x);
    }
    function iter_error(v, f) {
        if (0 === v[0]) return 0;
        var x = v[1];
        return caml_call1(f, x);
    }
    function to_either(param) {
        if (0 === param[0]) {
            var x = param[1];
            return [
                0,
                x
            ];
        }
        var x$0 = param[1];
        return [
            1,
            x$0
        ];
    }
    function of_either(param) {
        if (0 === param[0]) {
            var x = param[1];
            return [
                0,
                x
            ];
        }
        var x$0 = param[1];
        return [
            1,
            x$0
        ];
    }
    function ok_if_true(bool, error) {
        return bool ? _c_ : [
            1,
            error
        ];
    }
    function try_with(f) {
        try {
            var _d_ = [
                0,
                caml_call1(f, 0)
            ];
            return _d_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            return [
                1,
                exn
            ];
        }
    }
    function ok_exn(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var exn = param[1];
        throw caml_maybe_attach_backtrace(exn, 1);
    }
    function ok_or_failwith(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var str = param[1];
        return caml_call1(Base_Import[124], str);
    }
    function combine(t1, t2, ok, err) {
        if (0 === t1[0]) {
            var ok1 = t1[1];
            if (0 === t2[0]) {
                var ok2 = t2[1];
                return [
                    0,
                    caml_call2(ok, ok1, ok2)
                ];
            }
            var e = t2[1];
        } else {
            var err1 = t1[1];
            if (0 !== t2[0]) {
                var err2 = t2[1];
                return [
                    1,
                    caml_call2(err, err1, err2)
                ];
            }
            var e = err1;
        }
        return [
            1,
            e
        ];
    }
    function combine_errors(l) {
        var match = caml_call2(Base_List1[23], l, to_either), errs = match[2], ok = match[1];
        return errs ? [
            1,
            errs
        ] : [
            0,
            ok
        ];
    }
    function combine_errors_unit(l) {
        return caml_call2(map$0, combine_errors(l), function(param) {
            return 0;
        });
    }
    var Base_Result = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare,
        compare_local,
        equal,
        equal_local,
        hash_fold_t,
        globalize,
        symbol_bind,
        symbol_map,
        Let_syntax,
        Monad_infix,
        bind$0,
        return$1,
        join,
        ignore_m,
        all,
        all_unit,
        Error1,
        invariant,
        fail,
        failf,
        is_ok,
        is_error,
        ok,
        ok_exn,
        ok_or_failwith,
        error,
        of_option,
        iter,
        iter_error,
        map$0,
        map_error,
        combine,
        combine_errors,
        combine_errors_unit,
        to_either,
        of_either,
        ok_if_true,
        try_with,
        [
            0,
            is_ok,
            is_error
        ]
    ];
    runtime.caml_register_global(20, Base_Result, "Base__Result");
    return;
})(globalThis);
//# 6140 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Continue_or_stop = [
        0
    ], Export = [
        0,
        Continue_or_stop
    ], Continue_or_stop$0 = Export[1], Base_Container_intf = [
        0,
        Export,
        Continue_or_stop$0
    ];
    runtime.caml_register_global(0, Base_Container_intf, "Base__Container_intf");
    return;
})(globalThis);
//# 6156 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array0 = global_data.Base__Array0, Base_List0 = global_data.Base__List0, Base_Import = global_data.Base__Import, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1];
    function iter(fold, t, f) {
        return caml_call3(fold, t, 0, function(param, a) {
            return caml_call1(f, a);
        });
    }
    function count(fold, t, f) {
        return caml_call3(fold, t, 0, function(n, a) {
            return caml_call1(f, a) ? caml_call2(Base_Import[91], n, 1) : n;
        });
    }
    function sum(fold, M, t, f) {
        return caml_call3(fold, t, M[1], function(n, a) {
            var _n_ = caml_call1(f, a);
            return caml_call2(M[2], n, _n_);
        });
    }
    function fold_result(fold, init, f, t) {
        return caml_call1(with_return, function(param) {
            return [
                0,
                caml_call3(fold, t, init, function(acc, item) {
                    var e = caml_call2(f, acc, item);
                    if (0 !== e[0]) return caml_call1(param, e);
                    var x = e[1];
                    return x;
                })
            ];
        });
    }
    function fold_until(fold, init, f, finish, t) {
        return caml_call1(with_return, function(param) {
            return caml_call1(finish, caml_call3(fold, t, init, function(acc, item) {
                var match = caml_call2(f, acc, item);
                if (0 === match[0]) {
                    var x = match[1];
                    return x;
                }
                var x$0 = match[1];
                return caml_call1(param, x$0);
            }));
        });
    }
    function min_elt(fold, t, compare) {
        return caml_call3(fold, t, 0, function(acc, elt) {
            if (!acc) return [
                0,
                elt
            ];
            var min = acc[1];
            return 0 < caml_call2(compare, min, elt) ? [
                0,
                elt
            ] : acc;
        });
    }
    function max_elt(fold, t, compare) {
        return caml_call3(fold, t, 0, function(acc, elt) {
            if (!acc) return [
                0,
                elt
            ];
            var max = acc[1];
            return 0 <= caml_call2(compare, max, elt) ? acc : [
                0,
                elt
            ];
        });
    }
    function length(fold, c) {
        return caml_call3(fold, c, 0, function(acc, param) {
            return caml_call2(Base_Import[91], acc, 1);
        });
    }
    function is_empty(iter, c) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(param) {
                return caml_call1(r, 0);
            });
            return 1;
        });
    }
    function mem(iter, c, x, equal) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(y) {
                var _m_ = caml_call2(equal, x, y);
                return _m_ ? caml_call1(r, 1) : _m_;
            });
            return 0;
        });
    }
    function exists(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _l_ = caml_call1(f, x);
                return _l_ ? caml_call1(r, 1) : _l_;
            });
            return 0;
        });
    }
    function for_all(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _k_ = 1 - caml_call1(f, x);
                return _k_ ? caml_call1(r, 0) : _k_;
            });
            return 1;
        });
    }
    function find_map(iter, t, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, t, function(x) {
                var res = caml_call1(f, x);
                return res ? caml_call1(r, res) : 0;
            });
            return 0;
        });
    }
    function find(iter, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iter, c, function(x) {
                var _j_ = caml_call1(f, x);
                return _j_ ? caml_call1(r, [
                    0,
                    x
                ]) : _j_;
            });
            return 0;
        });
    }
    function to_list(fold, c) {
        var _i_ = caml_call3(fold, c, 0, function(acc, x) {
            return [
                0,
                x,
                acc
            ];
        });
        return caml_call1(Base_List0[19], _i_);
    }
    function to_array(length, iter, c) {
        var array = [
            0,
            [
                0
            ]
        ], i = [
            0,
            0
        ];
        caml_call2(iter, c, function(x) {
            if (0 === i[1]) {
                var _g_ = caml_call1(length, c);
                array[1] = caml_call2(Base_Array0[4], _g_, x);
            }
            var _h_ = i[1];
            runtime.caml_check_bound(array[1], _h_)[1 + _h_] = x;
            i[1]++;
            return 0;
        });
        return array[1];
    }
    function Make_gen(T) {
        var fold = T[1], match = T[2];
        if (typeof match === "number") var iter$0 = function(t, f) {
            return iter(fold, t, f);
        };
        else var iter$1 = match[2], iter$0 = iter$1;
        var match$0 = T[3];
        if (typeof match$0 === "number") var length$0 = function(t) {
            return length(fold, t);
        };
        else var length$1 = match$0[2], length$0 = length$1;
        function is_empty$0(t) {
            return is_empty(iter$0, t);
        }
        function mem$0(t, x, equal) {
            return mem(iter$0, t, x, equal);
        }
        function sum$0(m, t) {
            return function(_f_) {
                return sum(fold, m, t, _f_);
            };
        }
        function count$0(t, f) {
            return count(fold, t, f);
        }
        function exists$0(t, f) {
            return exists(iter$0, t, f);
        }
        function for_all$0(t, f) {
            return for_all(iter$0, t, f);
        }
        function find_map$0(t, f) {
            return find_map(iter$0, t, f);
        }
        function find$0(t, f) {
            return find(iter$0, t, f);
        }
        function to_list$0(t) {
            return to_list(fold, t);
        }
        function to_array$0(t) {
            return to_array(length$0, iter$0, t);
        }
        function min_elt$0(t, compare) {
            return min_elt(fold, t, compare);
        }
        function max_elt$0(t, compare) {
            return max_elt(fold, t, compare);
        }
        function fold_result$0(t, init, f) {
            return fold_result(fold, init, f, t);
        }
        function fold_until$0(t, init, f, finish) {
            return fold_until(fold, init, f, finish, t);
        }
        return [
            0,
            length$0,
            is_empty$0,
            mem$0,
            iter$0,
            fold,
            fold_result$0,
            fold_until$0,
            exists$0,
            for_all$0,
            count$0,
            sum$0,
            find$0,
            find_map$0,
            to_list$0,
            to_array$0,
            min_elt$0,
            max_elt$0
        ];
    }
    function Make_gen_with_creators(T) {
        var include = Make_gen([
            0,
            T[1],
            T[2],
            T[3]
        ]), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list = T[4], of_array = T[5], concat = T[6], concat_of_array = T[7];
        function append(a, b) {
            return caml_call1(concat, caml_call1(concat_of_array, [
                0,
                a,
                b
            ]));
        }
        function concat_map(t, f) {
            var _e_ = caml_call1(to_array, t);
            return caml_call1(concat, caml_call1(concat_of_array, caml_call2(Base_Array0[21], _e_, f)));
        }
        function filter_map(t, f) {
            return concat_map(t, function(x) {
                var match = caml_call1(f, x);
                if (!match) return caml_call1(of_array, [
                    0
                ]);
                var y = match[1];
                return caml_call1(of_array, [
                    0,
                    y
                ]);
            });
        }
        function map(t, f) {
            return filter_map(t, function(x) {
                return [
                    0,
                    caml_call1(f, x)
                ];
            });
        }
        function filter(t, f) {
            return filter_map(t, function(x) {
                return caml_call1(f, x) ? [
                    0,
                    x
                ] : 0;
            });
        }
        function partition_map(t, f) {
            var _c_ = caml_call1(to_array, t), array = caml_call2(Base_Array0[21], _c_, f), xs = caml_call3(Base_Array0[18], array, function(either, acc) {
                if (0 !== either[0]) return acc;
                var x = either[1];
                return [
                    0,
                    x,
                    acc
                ];
            }, 0), ys = caml_call3(Base_Array0[18], array, function(either, acc) {
                if (0 === either[0]) return acc;
                var x = either[1];
                return [
                    0,
                    x,
                    acc
                ];
            }, 0), _d_ = caml_call1(of_list, ys);
            return [
                0,
                caml_call1(of_list, xs),
                _d_
            ];
        }
        function partition_tf(t, f) {
            return partition_map(t, function(x) {
                return caml_call1(f, x) ? [
                    0,
                    x
                ] : [
                    1,
                    x
                ];
            });
        }
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            of_list,
            of_array,
            append,
            concat,
            map,
            filter,
            filter_map,
            concat_map,
            partition_tf,
            partition_map
        ];
    }
    var Base_Container = [
        0,
        iter,
        count,
        min_elt,
        max_elt,
        length,
        to_list,
        sum,
        fold_result,
        fold_until,
        is_empty,
        mem,
        exists,
        for_all,
        find,
        find_map,
        to_array,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], include = Make_gen([
                0,
                fold,
                iter,
                length
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], include = Make_gen([
                0,
                fold,
                iter,
                length
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], _b_ = include[3];
            function mem(t, x) {
                return caml_call3(_b_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt
            ];
        },
        Make_gen,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], of_list = T[4], of_array = T[5], concat = T[6], include = Make_gen_with_creators([
                0,
                fold,
                iter,
                length,
                of_list,
                of_array,
                concat,
                of_array
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list$0 = include[18], of_array$0 = include[19], append = include[20], concat$0 = include[21], map = include[22], filter = include[23], filter_map = include[24], concat_map = include[25], partition_tf = include[26], partition_map = include[27];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], of_list = T[5], of_array = T[6], concat = T[7], concat_of_array = Base_Array0[16], include = Make_gen_with_creators([
                0,
                fold,
                iter,
                length,
                of_list,
                of_array,
                concat,
                concat_of_array
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], of_list$0 = include[18], of_array$0 = include[19], append = include[20], concat$0 = include[21], map = include[22], filter = include[23], filter_map = include[24], concat_map = include[25], partition_tf = include[26], partition_map = include[27], _a_ = include[3];
            function mem(t, x) {
                return caml_call3(_a_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map
            ];
        },
        Make_gen_with_creators
    ];
    runtime.caml_register_global(4, Base_Container, "Base__Container");
    return;
})(globalThis);
//# 6778 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Indexed_container_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Indexed_container_intf, "Base__Indexed_container_intf");
    return;
})(globalThis);
//# 6789 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array0 = global_data.Base__Array0, Base_Container = global_data.Base__Container, Base_Import = global_data.Base__Import, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1];
    function iteri(fold, t, f) {
        caml_call3(fold, t, 0, function(i, x) {
            caml_call2(f, i, x);
            return caml_call2(Base_Import[91], i, 1);
        });
        return 0;
    }
    function foldi(fold, t, init, f) {
        var i = [
            0,
            0
        ];
        return caml_call3(fold, t, init, function(acc, v) {
            var acc$0 = caml_call3(f, i[1], acc, v);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return acc$0;
        });
    }
    function counti(foldi, t, f) {
        return caml_call3(foldi, t, 0, function(i, n, a) {
            return caml_call2(f, i, a) ? caml_call2(Base_Import[91], n, 1) : n;
        });
    }
    function existsi(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _h_ = caml_call2(f, i, x);
                return _h_ ? caml_call1(r, 1) : _h_;
            });
            return 0;
        });
    }
    function for_alli(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _g_ = 1 - caml_call2(f, i, x);
                return _g_ ? caml_call1(r, 0) : _g_;
            });
            return 1;
        });
    }
    function find_mapi(iteri, t, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, t, function(i, x) {
                var res = caml_call2(f, i, x);
                return res ? caml_call1(r, res) : 0;
            });
            return 0;
        });
    }
    function findi(iteri, c, f) {
        return caml_call1(with_return, function(r) {
            caml_call2(iteri, c, function(i, x) {
                var _f_ = caml_call2(f, i, x);
                return _f_ ? caml_call1(r, [
                    0,
                    [
                        0,
                        i,
                        x
                    ]
                ]) : _f_;
            });
            return 0;
        });
    }
    function Make_gen_with_container(T, _e_) {
        var length = _e_[1], is_empty = _e_[2], mem = _e_[3], iter = _e_[4], fold = _e_[5], fold_result = _e_[6], fold_until = _e_[7], exists = _e_[8], for_all = _e_[9], count = _e_[10], sum = _e_[11], find = _e_[12], find_map = _e_[13], to_list = _e_[14], to_array = _e_[15], min_elt = _e_[16], max_elt = _e_[17], match = T[4];
        if (typeof match === "number") var iteri$0 = function(t, f) {
            return iteri(fold, t, f);
        };
        else var iteri$1 = match[2], iteri$0 = iteri$1;
        var match$0 = T[5];
        if (typeof match$0 === "number") var foldi$0 = function(t, init, f) {
            return foldi(fold, t, init, f);
        };
        else var foldi$1 = match$0[2], foldi$0 = foldi$1;
        function counti$0(t, f) {
            return counti(foldi$0, t, f);
        }
        function existsi$0(t, f) {
            return existsi(iteri$0, t, f);
        }
        function for_alli$0(t, f) {
            return for_alli(iteri$0, t, f);
        }
        function find_mapi$0(t, f) {
            return find_mapi(iteri$0, t, f);
        }
        function findi$0(t, f) {
            return findi(iteri$0, t, f);
        }
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi$0,
            iteri$0,
            existsi$0,
            for_alli$0,
            counti$0,
            findi$0,
            find_mapi$0
        ];
    }
    function Make_gen(T) {
        var C = caml_call1(Base_Container[19], [
            0,
            T[1],
            T[2],
            T[3]
        ]), include = Make_gen_with_container(T, C), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi = include[18], iteri = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
        return [
            0,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi,
            iteri,
            existsi,
            for_alli,
            counti,
            findi,
            find_mapi
        ];
    }
    function Make_gen_with_creators(T) {
        var C = caml_call1(Base_Container[22], [
            0,
            T[5],
            T[6],
            T[7],
            T[2],
            T[3],
            T[4],
            T[1]
        ]), of_list = C[18], of_array = C[19], append = C[20], concat = C[21], map = C[22], filter = C[23], filter_map = C[24], concat_map = C[25], partition_tf = C[26], partition_map = C[27], include = Make_gen_with_container([
            0,
            T[5],
            T[6],
            T[7],
            T[8],
            T[9]
        ], [
            0,
            C[1],
            C[2],
            C[3],
            C[4],
            C[5],
            C[6],
            C[7],
            C[8],
            C[9],
            C[10],
            C[11],
            C[12],
            C[13],
            C[14],
            C[15],
            C[16],
            C[17]
        ]), length = include[1], is_empty = include[2], mem = include[3], iter = include[4], fold = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi = include[18], iteri = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
        function derived_init(n, f) {
            return caml_call1(of_array, caml_call2(Base_Array0[12], n, f));
        }
        var match = T[10];
        if (typeof match === "number") var derived_init$0 = derived_init;
        else var init = match[2], derived_init$0 = init;
        function derived_concat_mapi(t, f) {
            var _c_ = caml_call1(to_array, t), _d_ = caml_call2(Base_Array0[22], _c_, f);
            return caml_call1(concat, caml_call1(T[1], _d_));
        }
        var match$0 = T[11];
        if (typeof match$0 === "number") var concat_mapi = derived_concat_mapi;
        else var concat_mapi$0 = match$0[2], concat_mapi = concat_mapi$0;
        function filter_mapi(t, f) {
            return caml_call2(concat_mapi, t, function(i, x) {
                var match = caml_call2(f, i, x);
                if (!match) return caml_call1(of_array, [
                    0
                ]);
                var y = match[1];
                return caml_call1(of_array, [
                    0,
                    y
                ]);
            });
        }
        function mapi(t, f) {
            return filter_mapi(t, function(i, x) {
                return [
                    0,
                    caml_call2(f, i, x)
                ];
            });
        }
        function filteri(t, f) {
            return filter_mapi(t, function(i, x) {
                return caml_call2(f, i, x) ? [
                    0,
                    x
                ] : 0;
            });
        }
        return [
            0,
            of_list,
            of_array,
            append,
            concat,
            map,
            filter,
            filter_map,
            concat_map,
            partition_tf,
            partition_map,
            length,
            is_empty,
            mem,
            iter,
            fold,
            fold_result,
            fold_until,
            exists,
            for_all,
            count,
            sum,
            find,
            find_map,
            to_list,
            to_array,
            min_elt,
            max_elt,
            foldi,
            iteri,
            existsi,
            for_alli,
            counti,
            findi,
            find_mapi,
            derived_init$0,
            mapi,
            filteri,
            filter_mapi,
            concat_mapi
        ];
    }
    var Base_Indexed_container = [
        0,
        foldi,
        iteri,
        counti,
        existsi,
        for_alli,
        findi,
        find_mapi,
        function(T) {
            var fold = T[1], iter = T[2], length = T[3], iteri = T[4], foldi = T[5], include = Make_gen([
                0,
                fold,
                iter,
                length,
                iteri,
                foldi
            ]), length$0 = include[1], is_empty = include[2], mem = include[3], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi$0 = include[18], iteri$0 = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24];
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi
            ];
        },
        function(T) {
            var fold = T[2], iter = T[3], length = T[4], iteri = T[5], foldi = T[6], include = Make_gen([
                0,
                fold,
                iter,
                length,
                iteri,
                foldi
            ]), length$0 = include[1], is_empty = include[2], iter$0 = include[4], fold$0 = include[5], fold_result = include[6], fold_until = include[7], exists = include[8], for_all = include[9], count = include[10], sum = include[11], find = include[12], find_map = include[13], to_list = include[14], to_array = include[15], min_elt = include[16], max_elt = include[17], foldi$0 = include[18], iteri$0 = include[19], existsi = include[20], for_alli = include[21], counti = include[22], findi = include[23], find_mapi = include[24], _b_ = include[3];
            function mem(t, x) {
                return caml_call3(_b_, t, x, T[1][1]);
            }
            return [
                0,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi
            ];
        },
        Make_gen,
        function(T) {
            var of_list = T[1], of_array = T[2], concat = T[3], fold = T[4], iter = T[5], length = T[6], iteri = T[7], foldi = T[8], init = T[9], concat_mapi = T[10], include = Make_gen_with_creators([
                0,
                of_array,
                of_list,
                of_array,
                concat,
                fold,
                iter,
                length,
                iteri,
                foldi,
                init,
                concat_mapi
            ]), of_list$0 = include[1], of_array$0 = include[2], append = include[3], concat$0 = include[4], map = include[5], filter = include[6], filter_map = include[7], concat_map = include[8], partition_tf = include[9], partition_map = include[10], length$0 = include[11], is_empty = include[12], mem = include[13], iter$0 = include[14], fold$0 = include[15], fold_result = include[16], fold_until = include[17], exists = include[18], for_all = include[19], count = include[20], sum = include[21], find = include[22], find_map = include[23], to_list = include[24], to_array = include[25], min_elt = include[26], max_elt = include[27], foldi$0 = include[28], iteri$0 = include[29], existsi = include[30], for_alli = include[31], counti = include[32], findi = include[33], find_mapi = include[34], init$0 = include[35], mapi = include[36], filteri = include[37], filter_mapi = include[38], concat_mapi$0 = include[39];
            return [
                0,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi,
                init$0,
                mapi,
                filteri,
                filter_mapi,
                concat_mapi$0
            ];
        },
        function(T) {
            var of_list = T[2], of_array = T[3], concat = T[4], fold = T[5], iter = T[6], length = T[7], iteri = T[8], foldi = T[9], init = T[10], concat_mapi = T[11], concat_of_array = Base_Array0[16], include = Make_gen_with_creators([
                0,
                concat_of_array,
                of_list,
                of_array,
                concat,
                fold,
                iter,
                length,
                iteri,
                foldi,
                init,
                concat_mapi
            ]), of_list$0 = include[1], of_array$0 = include[2], append = include[3], concat$0 = include[4], map = include[5], filter = include[6], filter_map = include[7], concat_map = include[8], partition_tf = include[9], partition_map = include[10], length$0 = include[11], is_empty = include[12], iter$0 = include[14], fold$0 = include[15], fold_result = include[16], fold_until = include[17], exists = include[18], for_all = include[19], count = include[20], sum = include[21], find = include[22], find_map = include[23], to_list = include[24], to_array = include[25], min_elt = include[26], max_elt = include[27], foldi$0 = include[28], iteri$0 = include[29], existsi = include[30], for_alli = include[31], counti = include[32], findi = include[33], find_mapi = include[34], init$0 = include[35], mapi = include[36], filteri = include[37], filter_mapi = include[38], concat_mapi$0 = include[39], _a_ = include[13];
            function mem(t, x) {
                return caml_call3(_a_, t, x, T[1][1]);
            }
            return [
                0,
                of_list$0,
                of_array$0,
                append,
                concat$0,
                map,
                filter,
                filter_map,
                concat_map,
                partition_tf,
                partition_map,
                mem,
                length$0,
                is_empty,
                iter$0,
                fold$0,
                fold_result,
                fold_until,
                exists,
                for_all,
                count,
                sum,
                find,
                find_map,
                to_list,
                to_array,
                min_elt,
                max_elt,
                foldi$0,
                iteri$0,
                existsi,
                for_alli,
                counti,
                findi,
                find_mapi,
                init$0,
                mapi,
                filteri,
                filter_mapi,
                concat_mapi$0
            ];
        },
        Make_gen_with_creators
    ];
    runtime.caml_register_global(4, Base_Indexed_container, "Base__Indexed_container");
    return;
})(globalThis);
//# 7697 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Info_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Info_intf, "Base__Info_intf");
    return;
})(globalThis);
//# 7707 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, invalid_argf = Base_Printf[7], _a_ = [
        0,
        [
            11,
            "Negative position: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Negative position: %d"
    ], _b_ = [
        0,
        [
            11,
            "Negative length: ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Negative length: %d"
    ], _c_ = [
        0,
        [
            11,
            "pos + len past end: ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " + ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " > ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "pos + len past end: %d + %d > %d"
    ];
    function slow_check_pos_len_exn(pos, len, total_length) {
        if (pos < 0) caml_call3(invalid_argf, _a_, pos, 0);
        if (len < 0) caml_call3(invalid_argf, _b_, len, 0);
        var _h_ = caml_call2(Base_Import[93], total_length, len) < pos ? 1 : 0;
        return _h_ ? caml_call5(invalid_argf, _c_, pos, len, total_length, 0) : _h_;
    }
    function check_pos_len_exn(pos, len, total_length) {
        var stop = caml_call2(Base_Import[91], pos, len), _d_ = caml_call2(Base_Import[93], total_length, stop), _e_ = caml_call2(Base_Import[118], pos, len), _f_ = caml_call2(Base_Import[118], _e_, stop), _g_ = caml_call2(Base_Import[118], _f_, _d_) < 0 ? 1 : 0;
        return _g_ ? slow_check_pos_len_exn(pos, len, total_length) : _g_;
    }
    function get_pos_len_exn(opt, len, param, total_length) {
        var pos = opt ? opt[1] : 0;
        if (len) var i = len[1], len$0 = i;
        else var len$0 = caml_call2(Base_Import[93], total_length, pos);
        check_pos_len_exn(pos, len$0, total_length);
        return [
            0,
            pos,
            len$0
        ];
    }
    var Private = [
        0,
        slow_check_pos_len_exn
    ], Base_Ordered_collection_common = [
        0,
        get_pos_len_exn,
        check_pos_len_exn,
        Private
    ];
    runtime.caml_register_global(5, Base_Ordered_collection_common, "Base__Ordered_collection_common0");
    return;
})(globalThis);
//# 7781 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Domain = global_data.Stdlib__Domain, Stdlib_Random = global_data.Stdlib__Random;
    function of_state(_b_) {
        return _b_;
    }
    var Repr = [
        0,
        of_state
    ];
    function assign(t, state) {
        var _a_ = caml_call1(Stdlib_Domain[11][2], t), dst = caml_call1(Repr[1], _a_), src = caml_call1(Repr[1], state);
        return runtime.caml_ba_blit(src, dst);
    }
    function make(state) {
        function split_from_parent(v) {
            return caml_call1(Stdlib_Random[19][19], v);
        }
        var t = caml_call2(Stdlib_Domain[11][1], [
            0,
            split_from_parent
        ], function(param) {
            return state;
        });
        caml_call1(Stdlib_Domain[11][2], t);
        return t;
    }
    function make_lazy(f) {
        function split_from_parent(v) {
            return caml_call1(Stdlib_Random[19][19], v);
        }
        return caml_call2(Stdlib_Domain[11][1], [
            0,
            split_from_parent
        ], f);
    }
    function get_state(t) {
        return caml_call1(Stdlib_Domain[11][2], t);
    }
    var Base_Random_repr = [
        0,
        Repr,
        assign,
        make,
        make_lazy,
        get_state
    ];
    runtime.caml_register_global(2, Base_Random_repr, "Base__Random_repr");
    return;
})(globalThis);
//# 7836 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_greaterequal = runtime.caml_greaterequal, caml_int64_add = runtime.caml_int64_add, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_left = runtime.caml_int64_shift_left, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_int64_xor = runtime.caml_int64_xor;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Random_repr = global_data.Base__Random_repr, Base_Import = global_data.Base__Import, Stdlib_Int64 = global_data.Stdlib__Int64, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Stdlib_Int32 = global_data.Stdlib__Int32, Base_Int0 = global_data.Base__Int0, Base_Printf = global_data.Base__Printf, Stdlib_Random = global_data.Stdlib__Random, Base_Char0 = global_data.Base__Char0, Base_Word_size = global_data.Base__Word_size, cst_initializing_Random_with_a = "initializing Random with a nondeterministic seed is forbidden in inline tests", dummy = 0;
    function forbid_nondeterminism_in_tests(allow_in_tests) {
        var _D_ = Base_Import[129];
        if (!_D_) return _D_;
        if (allow_in_tests && allow_in_tests[1]) return;
        return caml_call1(Base_Import[124], cst_initializing_Random_with_a);
    }
    function bits(t) {
        var _C_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][4], _C_);
    }
    function bits64(t) {
        var _B_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][17], _B_);
    }
    function bool(t) {
        var _A_ = caml_call1(Base_Random_repr[5], t);
        return caml_call1(Stdlib_Random[19][15], _A_);
    }
    function int$0(t, x) {
        var _z_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][5], _z_, x);
    }
    function int32(t, x) {
        var _y_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][8], _y_, x);
    }
    function int64(t, x) {
        var _x_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][12], _x_, x);
    }
    function nativeint(t, x) {
        var _w_ = caml_call1(Base_Random_repr[5], t);
        return caml_call2(Stdlib_Random[19][10], _w_, x);
    }
    function make(seed) {
        var _v_ = caml_call1(Stdlib_Random[19][1], seed);
        return caml_call1(Base_Random_repr[3], _v_);
    }
    function copy(t) {
        var _t_ = caml_call1(Base_Random_repr[5], t), _u_ = caml_call1(Stdlib_Random[19][3], _t_);
        return caml_call1(Base_Random_repr[3], _u_);
    }
    function char$0(t) {
        var _s_ = int$0(t, 256);
        return caml_call1(Base_Char0[5], _s_);
    }
    function ascii(t) {
        var _r_ = int$0(t, 128);
        return caml_call1(Base_Char0[5], _r_);
    }
    function make_self_init(allow_in_tests, param) {
        forbid_nondeterminism_in_tests(allow_in_tests);
        return caml_call1(Base_Random_repr[4], Stdlib_Random[19][2]);
    }
    var assign = Base_Random_repr[2], cst_float = "float", cst_int64 = "int64", _b_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), cst_nativeint = "nativeint", cst_int32 = "int32", cst_int = "int", _a_ = [
        0,
        [
            11,
            "Random.",
            [
                2,
                0,
                [
                    11,
                    ": crossed bounds [",
                    [
                        2,
                        0,
                        [
                            11,
                            " > ",
                            [
                                2,
                                0,
                                [
                                    12,
                                    93,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Random.%s: crossed bounds [%s > %s]"
    ];
    if (Base_Import[129]) {
        var t = caml_call1(Stdlib_Random[20], 0);
        caml_call1(Stdlib_Random[1], 137);
        var default$0 = caml_call1(Base_Random_repr[3], t);
    } else var default$0 = make_self_init(0, 0);
    function int_on_64bits(t, bound) {
        return 1073741823 < bound ? caml_int64_to_int32(int64(t, caml_int64_of_int32(bound))) : int$0(t, bound);
    }
    function int_on_32bits(t, bound) {
        return 1073741823 < bound ? int32(t, bound) : int$0(t, bound);
    }
    var int$1 = Base_Word_size[3] ? int_on_64bits : int_on_32bits;
    function bits$0(state) {
        return caml_int64_of_int32(bits(state));
    }
    function full_range_int64(state) {
        var _p_ = caml_int64_shift_left(bits$0(state), 60), _q_ = caml_int64_xor(caml_int64_shift_left(bits$0(state), 30), _p_);
        return caml_int64_xor(bits$0(state), _q_);
    }
    function full_range_int32(state) {
        var _o_ = bits(state) << 30;
        return bits(state) ^ _o_;
    }
    function full_range_int_on_64bits(state) {
        return caml_int64_to_int32(full_range_int64(state));
    }
    function full_range_int_on_32bits(state) {
        return full_range_int32(state);
    }
    var full_range_int_on_64bits$0 = Base_Word_size[3] ? full_range_int_on_64bits : full_range_int_on_32bits;
    function full_range_nativeint_on_64bits(state) {
        return caml_int64_to_int32(full_range_int64(state));
    }
    function full_range_nativeint_on_32bits(state) {
        return full_range_int32(state);
    }
    var full_range_nativeint = Base_Word_size[3] ? full_range_nativeint_on_64bits : full_range_nativeint_on_32bits;
    function raise_crossed_bounds(name, lower_bound, upper_bound, string_of_bound) {
        var _m_ = caml_call1(string_of_bound, upper_bound), _n_ = caml_call1(string_of_bound, lower_bound);
        return caml_call5(Base_Printf[6], _a_, name, _n_, _m_, 0);
    }
    function int_incl(state, lo, hi) {
        if (hi < lo) raise_crossed_bounds(cst_int, lo, hi, Base_Int0[1]);
        var diff = caml_call2(Base_Import[93], hi, lo);
        if (diff === Base_Int0[6]) {
            var _i_ = Base_Int0[6], _j_ = full_range_int_on_64bits$0(state), _k_ = caml_call2(Base_Import[116], _j_, _i_);
            return caml_call2(Base_Import[91], lo, _k_);
        }
        if (0 <= diff) {
            var _l_ = int$1(state, caml_call1(Base_Int0[8], diff));
            return caml_call2(Base_Import[91], lo, _l_);
        }
        for(;;){
            var int$0 = full_range_int_on_64bits$0(state);
            if (lo <= int$0 && int$0 <= hi) return int$0;
        }
    }
    function int32_incl(state, lo, hi) {
        if (caml_call2(Base_Import[102][5], lo, hi)) raise_crossed_bounds(cst_int32, lo, hi, Stdlib_Int32[14]);
        var diff = hi - lo | 0;
        if (caml_call2(Base_Import[102][4], diff, Stdlib_Int32[9])) {
            var _h_ = Stdlib_Int32[9];
            return lo + (full_range_int32(state) & _h_) | 0;
        }
        if (caml_call2(Base_Import[102][6], diff, 0)) return lo + int32(state, caml_call1(Stdlib_Int32[6], diff)) | 0;
        for(;;){
            var int$0 = full_range_int32(state);
            if (caml_call2(Base_Import[102][6], int$0, lo) && caml_call2(Base_Import[102][2], int$0, hi)) return int$0;
        }
    }
    function nativeint_incl(state, lo, hi) {
        if (caml_call2(Base_Import[104][5], lo, hi)) raise_crossed_bounds(cst_nativeint, lo, hi, Stdlib_Nativeint[15]);
        var diff = hi - lo | 0;
        if (caml_call2(Base_Import[104][4], diff, Stdlib_Nativeint[10])) {
            var _g_ = Stdlib_Nativeint[10];
            return lo + (full_range_nativeint(state) & _g_) | 0;
        }
        if (caml_call2(Base_Import[104][6], diff, 0)) return lo + nativeint(state, caml_call1(Stdlib_Nativeint[6], diff)) | 0;
        for(;;){
            var int$0 = full_range_nativeint(state);
            if (caml_call2(Base_Import[104][6], int$0, lo) && caml_call2(Base_Import[104][2], int$0, hi)) return int$0;
        }
    }
    function int64_incl(state, lo, hi) {
        if (runtime.caml_greaterthan(lo, hi)) raise_crossed_bounds(cst_int64, lo, hi, Stdlib_Int64[14]);
        var diff = runtime.caml_int64_sub(hi, lo);
        if (runtime.caml_equal(diff, Stdlib_Int64[9])) {
            var _f_ = Stdlib_Int64[9];
            return caml_int64_add(lo, runtime.caml_int64_and(full_range_int64(state), _f_));
        }
        if (caml_greaterequal(diff, _b_)) return caml_int64_add(lo, int64(state, caml_call1(Stdlib_Int64[6], diff)));
        for(;;){
            var int$0 = full_range_int64(state);
            if (caml_greaterequal(int$0, lo) && runtime.caml_lessequal(int$0, hi)) return int$0;
        }
    }
    function float$0(state, hi) {
        for(;;){
            var scale = 9.313225746154785e-10, r1 = bits(state), r2 = bits(state), _d_ = caml_call2(Base_Import[90], r1, scale), _e_ = caml_call2(Base_Import[92], _d_, r2), result = caml_call2(Base_Import[90], _e_, scale);
            if (result < 1.) return caml_call2(Base_Import[90], result, hi);
        }
    }
    function float_range(state, lo, hi) {
        if (hi < lo) raise_crossed_bounds(cst_float, lo, hi, Base_Import[85][35]);
        var _c_ = float$0(state, caml_call2(Base_Import[94], hi, lo));
        return caml_call2(Base_Import[92], lo, _c_);
    }
    function bits$1(param) {
        return bits(default$0);
    }
    function bits64$0(param) {
        return bits64(default$0);
    }
    function int$2(x) {
        return int$1(default$0, x);
    }
    function int32$0(x) {
        return int32(default$0, x);
    }
    function nativeint$0(x) {
        return nativeint(default$0, x);
    }
    function int64$0(x) {
        return int64(default$0, x);
    }
    function float$1(x) {
        return float$0(default$0, x);
    }
    function int_incl$0(x, y) {
        return int_incl(default$0, x, y);
    }
    function int32_incl$0(x, y) {
        return int32_incl(default$0, x, y);
    }
    function nativeint_incl$0(x, y) {
        return nativeint_incl(default$0, x, y);
    }
    function int64_incl$0(x, y) {
        return int64_incl(default$0, x, y);
    }
    function float_range$0(x, y) {
        return float_range(default$0, x, y);
    }
    function bool$0(param) {
        return bool(default$0);
    }
    function char$1(param) {
        return char$0(default$0);
    }
    function ascii$0(param) {
        return ascii(default$0);
    }
    function full_init(seed) {
        return caml_call2(assign, default$0, caml_call1(Stdlib_Random[19][1], seed));
    }
    function init(seed) {
        return full_init([
            0,
            seed
        ]);
    }
    function self_init(allow_in_tests, param) {
        forbid_nondeterminism_in_tests(allow_in_tests);
        return full_init(runtime.caml_sys_random_seed(0));
    }
    function set_state(s) {
        return caml_call2(assign, default$0, caml_call1(Base_Random_repr[5], s));
    }
    var Base_Random = [
        0,
        init,
        full_init,
        self_init,
        bits$1,
        bits64$0,
        int$2,
        int32$0,
        nativeint$0,
        int64$0,
        float$1,
        int_incl$0,
        int32_incl$0,
        nativeint_incl$0,
        int64_incl$0,
        float_range$0,
        bool$0,
        char$1,
        ascii$0,
        [
            0,
            default$0,
            make,
            make_self_init,
            copy,
            bits,
            bits64,
            int$1,
            int32,
            nativeint,
            int64,
            float$0,
            int_incl,
            int32_incl,
            nativeint_incl,
            int64_incl,
            float_range,
            bool,
            char$0,
            ascii
        ],
        set_state
    ];
    runtime.caml_register_global(22, Base_Random, "Base__Random");
    return;
})(globalThis);
//# 8166 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Random = global_data.Base__Random, Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common0, Base_Array0 = global_data.Base__Array0, invalid_argf = Base_Array0[1], Array1 = Base_Array0[2], max_length = Base_Array0[3], create = Base_Array0[4], create_local = Base_Array0[5], create_float_uninitialized = Base_Array0[6], append = Base_Array0[7], blit = Base_Array0[8], concat = Base_Array0[9], copy = Base_Array0[10], fill = Base_Array0[11], init = Base_Array0[12], make_matrix = Base_Array0[13], of_list = Base_Array0[14], sub = Base_Array0[15], to_list = Base_Array0[16], fold = Base_Array0[17], fold_right = Base_Array0[18], iter = Base_Array0[19], iteri = Base_Array0[20], map = Base_Array0[21], mapi = Base_Array0[22], stable_sort = Base_Array0[23], swap = Base_Array0[24];
    function permute(_a_, opt, len, t) {
        var random_state = _a_ ? _a_[1] : Base_Random[19][1], pos = opt ? opt[1] : 0, total_length = t.length - 1;
        if (len) var l = len[1], len$0 = l;
        else var len$0 = caml_call2(Base_Import[93], total_length, pos);
        caml_call3(Base_Ordered_collection_common[2], pos, len$0, total_length);
        var num_swaps = caml_call2(Base_Import[93], len$0, 1);
        if (num_swaps >= 1) {
            var i = num_swaps;
            for(;;){
                var this_i = caml_call2(Base_Import[91], pos, i), _b_ = caml_call2(Base_Import[91], i, 1), _c_ = caml_call2(Base_Random[19][7], random_state, _b_), random_i = caml_call2(Base_Import[91], pos, _c_);
                caml_call3(swap, t, this_i, random_i);
                var _d_ = i - 1 | 0;
                if (1 === i) break;
                i = _d_;
            }
        }
        return 0;
    }
    var Base_Array_permute = [
        0,
        invalid_argf,
        Array1,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        append,
        blit,
        concat,
        copy,
        fill,
        init,
        make_matrix,
        of_list,
        sub,
        to_list,
        fold,
        fold_right,
        iter,
        iteri,
        map,
        mapi,
        stable_sort,
        swap,
        permute
    ];
    runtime.caml_register_global(4, Base_Array_permute, "Base__Array_permute");
    return;
})(globalThis);
//# 8282 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Equal = "Equal", cst_Greater = "Greater", cst_Less = "Less", cst_equal = "equal", cst_greater = "greater", cst_less = "less", caml_int_compare = runtime.caml_int_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                0
            ]
        ]
    ], error_source_005 = "ordering.ml.t", t_sexp_grammar = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Less,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Equal,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Greater,
                                0
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ]
    ], Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Hash = global_data.Base__Hash, compare_local = caml_int_compare, _a_ = [
        0,
        cst_Less
    ], _b_ = [
        0,
        cst_Equal
    ], _c_ = [
        0,
        cst_Greater
    ];
    function compare(a, b) {
        return caml_int_compare(a, b);
    }
    function hash_fold_t(hsv, arg) {
        switch(arg){
            case 0:
                var _i_ = 0;
                break;
            case 1:
                var _i_ = 1;
                break;
            default:
                var _i_ = 2;
        }
        return caml_call2(Base_Hash[3], hsv, _i_);
    }
    function hash(arg) {
        var hsv = caml_call2(Base_Hash[11], 0, 0), _h_ = hash_fold_t(hsv, arg);
        return caml_call1(Base_Hash[9], _h_);
    }
    function t_of_sexp(sexp_006) {
        a: {
            if (0 === sexp_006[0]) {
                var _d_ = sexp_006[1];
                b: if (_d_ !== cst_Equal) {
                    c: if (_d_ !== cst_Greater) {
                        if (_d_ !== cst_Less) {
                            if (_d_ === cst_equal) break b;
                            if (_d_ === cst_greater) break c;
                            if (_d_ !== cst_less) break a;
                        }
                        return 0;
                    }
                    return 2;
                }
                return 1;
            }
            var _e_ = sexp_006[1];
            if (!_e_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_005, sexp_006);
            var _f_ = _e_[1];
            if (0 !== _f_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_005, sexp_006);
            var _g_ = _f_[1];
            b: if (_g_ !== cst_Equal) {
                c: if (_g_ !== cst_Greater) {
                    if (_g_ !== cst_Less) {
                        if (_g_ === cst_equal) break b;
                        if (_g_ === cst_greater) break c;
                        if (_g_ !== cst_less) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_005, sexp_006);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_005, sexp_006);
    }
    function sexp_of_t(param) {
        switch(param){
            case 0:
                return _a_;
            case 1:
                return _b_;
            default:
                return _c_;
        }
    }
    function equal(a, b) {
        return 0 === caml_int_compare(a, b) ? 1 : 0;
    }
    function equal_local(a, b) {
        return 0 === caml_int_compare(a, b) ? 1 : 0;
    }
    var Export = [
        0
    ];
    function of_int(n) {
        return 0 <= n ? 0 === n ? 1 : 2 : 0;
    }
    function to_int(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0;
            default:
                return 1;
        }
    }
    var Base_Ordering = [
        0,
        compare,
        compare_local,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        all,
        equal,
        equal_local,
        of_int,
        to_int,
        Export
    ];
    runtime.caml_register_global(20, Base_Ordering, "Base__Ordering");
    return;
})(globalThis);
//# 8421 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = " <> ", cst$0 = ": ", cst_List_map2$1 = "List.map2", cst_List_map3$1 = "List.map3", cst_List_range_stride_function$2 = "List.range': stride function cannot change direction", cst_length_mismatch_in = "length mismatch in ", cst_src_list_ml = "src/list.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), error_source_036 = "list.ml.Assoc.t", Base_Import = global_data.Base__Import, Base_Container = global_data.Base__Container, Assert_failure = global_data.Assert_failure, Base_Random = global_data.Base__Random, Base_Array0 = global_data.Base__Array0, Base_Array_permute = global_data.Base__Array_permute, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Result = global_data.Base__Result, Base_Ordering = global_data.Base__Ordering, Base_List1 = global_data.Base__List1, Base_Printf = global_data.Base__Printf, Base_Applicative = global_data.Base__Applicative, Base_Monad = global_data.Base__Monad, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, hd_exn = Base_List1[1], rev_append = Base_List1[2], tl_exn = Base_List1[3], length = Base_List1[5], exists = Base_List1[6], exists2_ok = Base_List1[7], fold = Base_List1[8], fold2_ok = Base_List1[9], for_all = Base_List1[10], for_all2_ok = Base_List1[11], iter = Base_List1[12], iter2_ok = Base_List1[13], rev_map = Base_List1[17], rev_map2_ok = Base_List1[18], rev = Base_List1[19], fold_right = Base_List1[20], fold_right2_ok = Base_List1[21], is_empty = Base_List1[22], partition_map = Base_List1[23], invalid_argf = Base_Printf[7], globalize = Base_Import[293], t_of_sexp = Base_Import[173], sexp_of_t = Base_Import[149], _a_ = [
        0,
        "Ok"
    ], _b_ = [
        0,
        "Unequal_lengths"
    ], cst_List_range_stride_function = "List.range': stride function cannot return the same value", cst_List_range_stride_function$0 = cst_List_range_stride_function$2, cst_List_range_stride_function$1 = cst_List_range_stride_function$2, cst_List_range_stride_must_be_ = "List.range: stride must be non-zero", _c_ = [
        0,
        [
            11,
            "List.nth_exn ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " called on list of length ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "List.nth_exn %d called on list of length %d"
    ], _d_ = [
        0,
        [
            11,
            cst_length_mismatch_in,
            [
                2,
                0,
                [
                    11,
                    cst$0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst,
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d"
    ], _e_ = [
        0,
        [
            11,
            cst_length_mismatch_in,
            [
                2,
                0,
                [
                    11,
                    cst$0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            cst,
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    11,
                                    " || ",
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            cst,
                                            [
                                                4,
                                                0,
                                                0,
                                                0,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d || %d <> %d"
    ], cst_iter2_exn = "iter2_exn", cst_rev_map2_exn = "rev_map2_exn", cst_fold2_exn = "fold2_exn", cst_fold_right2_exn = "fold_right2_exn", cst_for_all2_exn = "for_all2_exn", cst_exists2_exn = "exists2_exn";
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[194], a_sexp_grammar);
    }
    function compare_local(cmp_a, a_014, b_015) {
        if (a_014 === b_015) return 0;
        if (!a_014) return b_015 ? 1 : 0;
        var a_016 = a_014[1];
        if (!b_015) return -1;
        var b_017 = b_015[1];
        return caml_call2(cmp_a, a_016, b_017);
    }
    function compare(cmp_a, a_010, b_011) {
        if (a_010 === b_011) return 0;
        if (!a_010) return b_011 ? 1 : 0;
        var a_012 = a_010[1];
        if (!b_011) return -1;
        var b_013 = b_011[1];
        return caml_call2(cmp_a, a_012, b_013);
    }
    function sexp_of_t$0(of_a_018, param) {
        if (!param) return _b_;
        var arg0_019 = param[1], res0_020 = caml_call1(of_a_018, arg0_019);
        return [
            1,
            [
                0,
                _a_,
                [
                    0,
                    res0_020,
                    0
                ]
            ]
        ];
    }
    function invariant(f, t) {
        return caml_call2(iter, t, f);
    }
    function of_list(t) {
        return t;
    }
    function singleton(x) {
        return [
            0,
            x,
            0
        ];
    }
    function range(compare, stride, _bw_, opt, start_i, stop_i) {
        var start = _bw_ ? _bw_[1] : 104758188, stop = opt ? opt[1] : -160346914, next_i = caml_call1(stride, start_i);
        function order(x, y) {
            var _bx_ = caml_call2(compare, x, y);
            return caml_call1(Base_Ordering[11], _bx_);
        }
        function raise_stride_cannot_return_sam(param) {
            return caml_call1(Base_Import[126], cst_List_range_stride_function);
        }
        switch(order(start_i, next_i)){
            case 0:
                var initial_stride_order = 847855481;
                break;
            case 1:
                var initial_stride_order = raise_stride_cannot_return_sam(0);
                break;
            default:
                var initial_stride_order = 85047514;
        }
        var start_i$0 = 104758188 <= start ? start_i : next_i, i_to_stop_order = order(start_i$0, stop_i);
        a: {
            switch(i_to_stop_order){
                case 0:
                    if (847855481 > initial_stride_order) break a;
                    break;
                case 1:
                    return 104758188 <= stop ? [
                        0,
                        start_i$0,
                        0
                    ] : 0;
                default:
                    if (847855481 <= initial_stride_order) break a;
            }
            var next_i$0 = caml_call1(stride, start_i$0);
            b: {
                switch(order(start_i$0, next_i$0)){
                    case 0:
                        if (847855481 > initial_stride_order) break b;
                        break;
                    case 1:
                        return raise_stride_cannot_return_sam(0);
                    default:
                        if (847855481 <= initial_stride_order) break b;
                }
                var block = [
                    0,
                    start_i$0,
                    24029
                ], dst = block, offset = 1, i = next_i$0;
                for(;;){
                    var i_to_stop_order$0 = order(i, stop_i);
                    c: {
                        d: {
                            switch(i_to_stop_order$0){
                                case 0:
                                    if (847855481 <= initial_stride_order) break d;
                                    break;
                                case 1:
                                    if (104758188 <= stop) {
                                        dst[1 + offset] = [
                                            0,
                                            i,
                                            0
                                        ];
                                        break c;
                                    }
                                    dst[1 + offset] = 0;
                                    break c;
                                default:
                                    if (847855481 > initial_stride_order) break d;
                            }
                            dst[1 + offset] = 0;
                            break c;
                        }
                        var next_i$1 = caml_call1(stride, i);
                        d: {
                            switch(order(i, next_i$1)){
                                case 0:
                                    if (847855481 <= initial_stride_order) break d;
                                    break;
                                case 1:
                                    dst[1 + offset] = raise_stride_cannot_return_sam(0);
                                    break c;
                                default:
                                    if (847855481 > initial_stride_order) break d;
                            }
                            dst[1 + offset] = caml_call1(Base_Import[126], cst_List_range_stride_function$1);
                            break c;
                        }
                        var dst$0 = [
                            0,
                            i,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        i = next_i$1;
                        continue;
                    }
                    return block;
                }
            }
            return caml_call1(Base_Import[126], cst_List_range_stride_function$0);
        }
        return 0;
    }
    function range$0(_bv_, _bu_, opt, start_i, stop_i) {
        var stride = _bv_ ? _bv_[1] : 1, start = _bu_ ? _bu_[1] : 104758188, stop = opt ? opt[1] : -160346914;
        if (0 === stride) caml_call1(Base_Import[126], cst_List_range_stride_must_be_);
        return range(runtime.caml_int_compare, function(x) {
            return caml_call2(Base_Import[91], x, stride);
        }, [
            0,
            start
        ], [
            0,
            stop
        ], start_i, stop_i);
    }
    function hd(t) {
        if (!t) return 0;
        var x = t[1];
        return [
            0,
            x
        ];
    }
    function tl(t) {
        if (!t) return 0;
        var t$0 = t[2];
        return [
            0,
            t$0
        ];
    }
    function nth(t, n) {
        if (0 > n) return 0;
        var t$0 = t, n$0 = n;
        for(;;){
            if (!t$0) return 0;
            var t$1 = t$0[2], a = t$0[1];
            if (0 === n$0) return [
                0,
                a
            ];
            var n$1 = caml_call2(Base_Import[93], n$0, 1);
            t$0 = t$1;
            n$0 = n$1;
        }
    }
    function nth_exn(t, n) {
        var match = nth(t, n);
        if (!match) return caml_call4(invalid_argf, _c_, n, caml_call1(length, t), 0);
        var a = match[1];
        return a;
    }
    function unordered_append(l1, l2) {
        if (l1) {
            if (l2) return caml_call2(rev_append, l1, l2);
            var l = l1;
        } else var l = l2;
        return l;
    }
    function of_lists(l1, l2) {
        var a = l1, b = l2, shared_length = 0;
        for(;;){
            if (a) {
                if (b) {
                    var b$0 = b[2], a$0 = a[2], shared_length$0 = caml_call2(Base_Import[91], shared_length, 1);
                    a = a$0;
                    b = b$0;
                    shared_length = shared_length$0;
                    continue;
                }
            } else if (!b) return [
                0,
                shared_length
            ];
            return [
                1,
                shared_length,
                a,
                b
            ];
        }
    }
    function check_length2_exn(name, l1, l2) {
        var match = of_lists(l1, l2);
        if (0 === match[0]) return;
        var tail_of_b = match[3], tail_of_a = match[2], shared_length = match[1], _br_ = caml_call1(length, tail_of_b), _bs_ = caml_call2(Base_Import[91], shared_length, _br_), _bt_ = caml_call1(length, tail_of_a);
        return caml_call5(invalid_argf, _d_, name, caml_call2(Base_Import[91], shared_length, _bt_), _bs_, 0);
    }
    function check_length2(l1, l2, f) {
        return 0 === of_lists(l1, l2)[0] ? [
            0,
            caml_call2(f, l1, l2)
        ] : 0;
    }
    function of_lists$0(l1, l2, l3) {
        var a = l1, b = l2, c = l3, shared_length = 0;
        for(;;){
            if (a) {
                if (b && c) {
                    var c$0 = c[2], b$0 = b[2], a$0 = a[2], shared_length$0 = caml_call2(Base_Import[91], shared_length, 1);
                    a = a$0;
                    b = b$0;
                    c = c$0;
                    shared_length = shared_length$0;
                    continue;
                }
            } else if (!b && !c) return [
                0,
                shared_length
            ];
            return [
                1,
                shared_length,
                a,
                b,
                c
            ];
        }
    }
    function check_length3_exn(name, l1, l2, l3) {
        var match = of_lists$0(l1, l2, l3);
        if (0 === match[0]) return;
        var tail_of_c = match[4], tail_of_b = match[3], tail_of_a = match[2], shared_length = match[1], _bo_ = caml_call1(length, tail_of_a), n1 = caml_call2(Base_Import[91], shared_length, _bo_), _bp_ = caml_call1(length, tail_of_b), n2 = caml_call2(Base_Import[91], shared_length, _bp_), _bq_ = caml_call1(length, tail_of_c), n3 = caml_call2(Base_Import[91], shared_length, _bq_);
        return caml_call7(invalid_argf, _e_, name, n1, n2, n2, n3, 0);
    }
    function check_length3(l1, l2, l3, f) {
        return 0 === of_lists$0(l1, l2, l3)[0] ? [
            0,
            caml_call3(f, l1, l2, l3)
        ] : 0;
    }
    function iter2(l1, l2, f) {
        return check_length2(l1, l2, function(_bl_) {
            var _bm_ = caml_call1(iter2_ok, _bl_);
            return function(_bn_) {
                return caml_call2(_bm_, _bn_, f);
            };
        });
    }
    function iter2_exn(l1, l2, f) {
        check_length2_exn(cst_iter2_exn, l1, l2);
        return caml_call3(iter2_ok, l1, l2, f);
    }
    function rev_map2(l1, l2, f) {
        return check_length2(l1, l2, function(_bi_) {
            var _bj_ = caml_call1(rev_map2_ok, _bi_);
            return function(_bk_) {
                return caml_call2(_bj_, _bk_, f);
            };
        });
    }
    function rev_map2_exn(l1, l2, f) {
        check_length2_exn(cst_rev_map2_exn, l1, l2);
        return caml_call3(rev_map2_ok, l1, l2, f);
    }
    function fold2(l1, l2, init, f) {
        return check_length2(l1, l2, function(_bf_) {
            var _bg_ = caml_call1(fold2_ok, _bf_);
            return function(_bh_) {
                return caml_call3(_bg_, _bh_, init, f);
            };
        });
    }
    function fold2_exn(l1, l2, init, f) {
        check_length2_exn(cst_fold2_exn, l1, l2);
        return caml_call4(fold2_ok, l1, l2, init, f);
    }
    function fold_right2(l1, l2, f, init) {
        return check_length2(l1, l2, function(_bc_) {
            var _bd_ = caml_call1(fold_right2_ok, _bc_);
            return function(_be_) {
                return caml_call3(_bd_, _be_, f, init);
            };
        });
    }
    function fold_right2_exn(l1, l2, f, init) {
        check_length2_exn(cst_fold_right2_exn, l1, l2);
        return caml_call4(fold_right2_ok, l1, l2, f, init);
    }
    function for_all2(l1, l2, f) {
        return check_length2(l1, l2, function(_a$_) {
            var _ba_ = caml_call1(for_all2_ok, _a$_);
            return function(_bb_) {
                return caml_call2(_ba_, _bb_, f);
            };
        });
    }
    function for_all2_exn(l1, l2, f) {
        check_length2_exn(cst_for_all2_exn, l1, l2);
        return caml_call3(for_all2_ok, l1, l2, f);
    }
    function exists2(l1, l2, f) {
        return check_length2(l1, l2, function(_a8_) {
            var _a9_ = caml_call1(exists2_ok, _a8_);
            return function(_a__) {
                return caml_call2(_a9_, _a__, f);
            };
        });
    }
    function exists2_exn(l1, l2, f) {
        check_length2_exn(cst_exists2_exn, l1, l2);
        return caml_call3(exists2_ok, l1, l2, f);
    }
    function mem(t, a, equal) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var bs = param[2], b = param[1], _a7_ = caml_call2(equal, a, b);
            if (_a7_) return _a7_;
            param = bs;
        }
    }
    function rev_filter(t, f) {
        var accu = 0, param = t;
        for(;;){
            if (!param) return accu;
            var l = param[2], x = param[1];
            if (caml_call1(f, x)) {
                var accu$0 = [
                    0,
                    x,
                    accu
                ];
                accu = accu$0;
                param = l;
            } else param = l;
        }
    }
    function filter(l, f) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (caml_call1(f, hd)) {
                var block = [
                    0,
                    hd,
                    24029
                ], dst = block, offset = 1, l$1 = tl;
                for(;;){
                    if (!l$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var tl$0 = l$1[2], hd$0 = l$1[1];
                    if (caml_call1(f, hd$0)) {
                        var dst$0 = [
                            0,
                            hd$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        l$1 = tl$0;
                    } else l$1 = tl$0;
                }
            } else l$0 = tl;
        }
    }
    function find_map(t, f) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1], r = caml_call1(f, x);
            if (r) return r;
            param = l;
        }
    }
    var not_found = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_map_exn: not found"
        ]
    ];
    function find_map_exn(t, f) {
        var match = find_map(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found, 1);
        var x = match[1];
        return x;
    }
    function find(t, f) {
        var param = t;
        for(;;){
            if (!param) return 0;
            var l = param[2], x = param[1];
            if (caml_call1(f, x)) return [
                0,
                x
            ];
            param = l;
        }
    }
    var not_found$0 = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_exn: not found"
        ]
    ];
    function find_exn(t, f) {
        var t$0 = t;
        for(;;){
            if (!t$0) throw caml_maybe_attach_backtrace(not_found$0, 1);
            var t$1 = t$0[2], x = t$0[1];
            if (caml_call1(f, x)) return x;
            t$0 = t$1;
        }
    }
    function findi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], x = t$0[1];
            if (caml_call2(f, i, x)) return [
                0,
                [
                    0,
                    i,
                    x
                ]
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = l;
        }
    }
    var not_found$1 = [
        0,
        Base_Import[297],
        [
            0,
            "List.findi_exn: not found"
        ]
    ];
    function findi_exn(t, f) {
        var match = findi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$1, 1);
        var x = match[1];
        return x;
    }
    function find_mapi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var l = t$0[2], x = t$0[1], result = caml_call2(f, i, x);
            if (result) return result;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = l;
        }
    }
    var not_found$2 = [
        0,
        Base_Import[297],
        [
            0,
            "List.find_mapi_exn: not found"
        ]
    ];
    function find_mapi_exn(t, f) {
        var match = find_mapi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$2, 1);
        var x = match[1];
        return x;
    }
    function for_alli(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 1;
            var tl = t$0[2], hd = t$0[1], _a6_ = caml_call2(f, i, hd);
            if (!_a6_) return _a6_;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = tl;
        }
    }
    function existsi(t, f) {
        var i = 0, t$0 = t;
        for(;;){
            if (!t$0) return 0;
            var tl = t$0[2], hd = t$0[1], _a5_ = caml_call2(f, i, hd);
            if (_a5_) return _a5_;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            t$0 = tl;
        }
    }
    var of_array = Base_Array0[16], to_array = Base_Array0[14], cst_List_map2 = cst_List_map2$1, cst_List_map2$0 = cst_List_map2$1, cst_map2_exn = "map2_exn", _f_ = [
        0,
        cst_src_list_ml,
        476,
        11
    ], cst_rev_map3_exn = "rev_map3_exn", cst_List_map3 = cst_List_map3$1, cst_List_map3$0 = cst_List_map3$1, cst_map3_exn = "map3_exn", _g_ = [
        0,
        [
            11,
            "length mismatch in zip_exn: ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    cst,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "length mismatch in zip_exn: %d <> %d"
    ], cst_List_reduce_exn = "List.reduce_exn", _h_ = [
        0,
        cst_src_list_ml,
        626,
        14
    ], cst_List_reduce_balanced_exn = "List.reduce_balanced_exn";
    function to_list(t) {
        return t;
    }
    function append(l1$0, l2) {
        if (!l2) return l1$0;
        if (!l1$0) return l2;
        var _aZ_ = l1$0[2], x1 = l1$0[1];
        if (!_aZ_) return [
            0,
            x1,
            l2
        ];
        var _a0_ = _aZ_[2], x2 = _aZ_[1];
        if (!_a0_) return [
            0,
            x1,
            [
                0,
                x2,
                l2
            ]
        ];
        var _a1_ = _a0_[2], x3 = _a0_[1];
        if (!_a1_) return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    l2
                ]
            ]
        ];
        var match = _a1_[2], x4 = _a1_[1];
        if (!match) return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    [
                        0,
                        x4,
                        l2
                    ]
                ]
            ]
        ];
        var tl = match[2], x5 = match[1], block = [
            0,
            x5,
            24029
        ], dst = block, offset = 1, l1 = tl;
        for(;;){
            if (l1) {
                var _a2_ = l1[2], x1$0 = l1[1];
                if (_a2_) {
                    var _a3_ = _a2_[2], x2$0 = _a2_[1];
                    if (_a3_) {
                        var _a4_ = _a3_[2], x3$0 = _a3_[1];
                        if (_a4_) {
                            var match$0 = _a4_[2], x4$0 = _a4_[1];
                            if (match$0) {
                                var tl$0 = match$0[2], x5$0 = match$0[1], dst$0 = [
                                    0,
                                    x5$0,
                                    24029
                                ];
                                dst[1 + offset] = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3$0,
                                            [
                                                0,
                                                x4$0,
                                                dst$0
                                            ]
                                        ]
                                    ]
                                ];
                                dst = dst$0;
                                offset = 1;
                                l1 = tl$0;
                                continue;
                            }
                            dst[1 + offset] = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3$0,
                                        [
                                            0,
                                            x4$0,
                                            l2
                                        ]
                                    ]
                                ]
                            ];
                        } else dst[1 + offset] = [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3$0,
                                    l2
                                ]
                            ]
                        ];
                    } else dst[1 + offset] = [
                        0,
                        x1$0,
                        [
                            0,
                            x2$0,
                            l2
                        ]
                    ];
                } else dst[1 + offset] = [
                    0,
                    x1$0,
                    l2
                ];
            } else dst[1 + offset] = l2;
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    [
                        0,
                        x3,
                        [
                            0,
                            x4,
                            block
                        ]
                    ]
                ]
            ];
        }
    }
    function map(l, f) {
        if (!l) return 0;
        var tl = l[2], x = l[1], block = [
            0,
            caml_call1(f, x),
            24029
        ], dst = block, offset = 1, l$0 = tl;
        for(;;){
            if (!l$0) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$0[2], x$0 = l$0[1], dst$0 = [
                0,
                caml_call1(f, x$0),
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
            l$0 = tl$0;
        }
    }
    function folding_map(t, init, f) {
        var acc = [
            0,
            init
        ];
        return map(t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_map(t, init, f) {
        var acc = [
            0,
            init
        ], result = map(t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function symbol_map(l, f) {
        return map(l, f);
    }
    function map2_ok(l1, l2, f) {
        if (l1) {
            if (l2) {
                var l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1], block = [
                    0,
                    caml_call2(f, x1, x2),
                    24029
                ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0;
                for(;;){
                    a: {
                        if (l1$1) {
                            if (l2$1) {
                                var l2$2 = l2$1[2], x2$0 = l2$1[1], l1$2 = l1$1[2], x1$0 = l1$1[1], dst$0 = [
                                    0,
                                    caml_call2(f, x1$0, x2$0),
                                    24029
                                ];
                                dst[1 + offset] = dst$0;
                                dst = dst$0;
                                offset = 1;
                                l1$1 = l1$2;
                                l2$1 = l2$2;
                                continue;
                            }
                        } else if (!l2$1) {
                            dst[1 + offset] = 0;
                            break a;
                        }
                        dst[1 + offset] = caml_call1(Base_Import[126], cst_List_map2$0);
                    }
                    return block;
                }
            }
        } else if (!l2) return 0;
        return caml_call1(Base_Import[126], cst_List_map2);
    }
    function map2(l1, l2, f) {
        return check_length2(l1, l2, function(_aX_) {
            return function(_aY_) {
                return map2_ok(_aX_, _aY_, f);
            };
        });
    }
    function map2_exn(l1, l2, f) {
        check_length2_exn(cst_map2_exn, l1, l2);
        return map2_ok(l1, l2, f);
    }
    function rev_map3_ok(l1, l2, l3, f) {
        var l1$0 = l1, l2$0 = l2, l3$0 = l3, ac = 0;
        for(;;){
            if (l1$0) {
                if (l2$0 && l3$0) {
                    var l3$1 = l3$0[2], x3 = l3$0[1], l2$1 = l2$0[2], x2 = l2$0[1], l1$1 = l1$0[2], x1 = l1$0[1], ac$0 = [
                        0,
                        caml_call3(f, x1, x2, x3),
                        ac
                    ];
                    l1$0 = l1$1;
                    l2$0 = l2$1;
                    l3$0 = l3$1;
                    ac = ac$0;
                    continue;
                }
            } else if (!l2$0 && !l3$0) return ac;
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
        }
    }
    function rev_map3(l1, l2, l3, f) {
        return check_length3(l1, l2, l3, function(_aU_) {
            return function(_aV_) {
                return function(_aW_) {
                    return rev_map3_ok(_aU_, _aV_, _aW_, f);
                };
            };
        });
    }
    function rev_map3_exn(l1, l2, l3, f) {
        check_length3_exn(cst_rev_map3_exn, l1, l2, l3);
        return rev_map3_ok(l1, l2, l3, f);
    }
    function map3_ok(l1, l2, l3, f) {
        if (l1) {
            if (l2 && l3) {
                var l3$0 = l3[2], x3 = l3[1], l2$0 = l2[2], x2 = l2[1], l1$0 = l1[2], x1 = l1[1], block = [
                    0,
                    caml_call3(f, x1, x2, x3),
                    24029
                ], dst = block, offset = 1, l1$1 = l1$0, l2$1 = l2$0, l3$1 = l3$0;
                for(;;){
                    a: {
                        if (l1$1) {
                            if (l2$1 && l3$1) {
                                var l3$2 = l3$1[2], x3$0 = l3$1[1], l2$2 = l2$1[2], x2$0 = l2$1[1], l1$2 = l1$1[2], x1$0 = l1$1[1], dst$0 = [
                                    0,
                                    caml_call3(f, x1$0, x2$0, x3$0),
                                    24029
                                ];
                                dst[1 + offset] = dst$0;
                                dst = dst$0;
                                offset = 1;
                                l1$1 = l1$2;
                                l2$1 = l2$2;
                                l3$1 = l3$2;
                                continue;
                            }
                        } else if (!l2$1 && !l3$1) {
                            dst[1 + offset] = 0;
                            break a;
                        }
                        dst[1 + offset] = caml_call1(Base_Import[126], cst_List_map3$0);
                    }
                    return block;
                }
            }
        } else if (!l2 && !l3) return 0;
        return caml_call1(Base_Import[126], cst_List_map3);
    }
    function map3(l1, l2, l3, f) {
        return check_length3(l1, l2, l3, function(_aR_) {
            return function(_aS_) {
                return function(_aT_) {
                    return map3_ok(_aR_, _aS_, _aT_, f);
                };
            };
        });
    }
    function map3_exn(l1, l2, l3, f) {
        check_length3_exn(cst_map3_exn, l1, l2, l3);
        return map3_ok(l1, l2, l3, f);
    }
    function rev_map_append(l1, l2, f) {
        var l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) return l2$0;
            var l1$1 = l1$0[2], h = l1$0[1], l2$1 = [
                0,
                caml_call1(f, h),
                l2$0
            ];
            l1$0 = l1$1;
            l2$0 = l2$1;
        }
    }
    function unzip(list) {
        var list$2 = caml_call1(rev, list), list$0 = list$2, l1 = 0, l2 = 0;
        for(;;){
            if (!list$0) return [
                0,
                l1,
                l2
            ];
            var list$1 = list$0[2], match = list$0[1], y = match[2], x = match[1], l2$0 = [
                0,
                y,
                l2
            ], l1$0 = [
                0,
                x,
                l1
            ];
            list$0 = list$1;
            l1 = l1$0;
            l2 = l2$0;
        }
    }
    function unzip3(list) {
        var list$2 = caml_call1(rev, list), list$0 = list$2, l1 = 0, l2 = 0, l3 = 0;
        for(;;){
            if (!list$0) return [
                0,
                l1,
                l2,
                l3
            ];
            var list$1 = list$0[2], match = list$0[1], z = match[3], y = match[2], x = match[1], l3$0 = [
                0,
                z,
                l3
            ], l2$0 = [
                0,
                y,
                l2
            ], l1$0 = [
                0,
                x,
                l1
            ];
            list$0 = list$1;
            l1 = l1$0;
            l2 = l2$0;
            l3 = l3$0;
        }
    }
    function zip_exn(l1, l2) {
        try {
            var _aP_ = map2_ok(l1, l2, function(a, b) {
                return [
                    0,
                    a,
                    b
                ];
            });
            return _aP_;
        } catch (_aQ_) {
            var _aO_ = caml_call1(length, l2);
            return caml_call4(invalid_argf, _g_, caml_call1(length, l1), _aO_, 0);
        }
    }
    function zip(l1, l2) {
        return map2(l1, l2, function(a, b) {
            return [
                0,
                a,
                b
            ];
        });
    }
    function rev_mapi(l, f) {
        var i = 0, acc = 0, param = l;
        for(;;){
            if (!param) return acc;
            var t = param[2], h = param[1], acc$0 = [
                0,
                caml_call2(f, i, h),
                acc
            ], i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            acc = acc$0;
            param = t;
        }
    }
    function mapi(l, f) {
        var i$2 = 0;
        if (!l) return 0;
        var t = l[2], h = l[1], block = [
            0,
            caml_call2(f, i$2, h),
            24029
        ], i = caml_call2(Base_Import[91], i$2, 1), dst = block, offset = 1, i$0 = i, param = t;
        for(;;){
            if (!param) {
                dst[1 + offset] = 0;
                return block;
            }
            var t$0 = param[2], h$0 = param[1], block0_arg0 = caml_call2(f, i$0, h$0), block$0 = [
                0,
                block0_arg0,
                24029
            ];
            dst[1 + offset] = block$0;
            var i$1 = caml_call2(Base_Import[91], i$0, 1);
            dst = block$0;
            offset = 1;
            i$0 = i$1;
            param = t$0;
        }
    }
    function folding_mapi(t, init, f) {
        var acc = [
            0,
            init
        ];
        return mapi(t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_mapi(t, init, f) {
        var acc = [
            0,
            init
        ], result = mapi(t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function iteri(l, f) {
        caml_call3(fold, l, 0, function(i, x) {
            caml_call2(f, i, x);
            return caml_call2(Base_Import[91], i, 1);
        });
        return 0;
    }
    function foldi(t, init, f) {
        var _aM_ = caml_call3(fold, t, [
            0,
            0,
            init
        ], function(param, v) {
            var acc = param[2], i = param[1], _aN_ = caml_call3(f, i, acc, v);
            return [
                0,
                caml_call2(Base_Import[91], i, 1),
                _aN_
            ];
        });
        return caml_call1(Base_Import[127], _aM_);
    }
    function filteri(l, f) {
        var pos = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (caml_call2(f, pos, hd)) break;
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$1;
            l$0 = tl;
        }
        var block = [
            0,
            hd,
            24029
        ], pos$0 = caml_call2(Base_Import[91], pos, 1), dst = block, offset = 1, pos$2 = pos$0, l$1 = tl;
        for(;;){
            if (!l$1) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$1[2], hd$0 = l$1[1];
            if (caml_call2(f, pos$2, hd$0)) {
                var block$0 = [
                    0,
                    hd$0,
                    24029
                ];
                dst[1 + offset] = block$0;
                var pos$3 = caml_call2(Base_Import[91], pos$2, 1);
                dst = block$0;
                offset = 1;
                pos$2 = pos$3;
                l$1 = tl$0;
            } else {
                var pos$4 = caml_call2(Base_Import[91], pos$2, 1);
                pos$2 = pos$4;
                l$1 = tl$0;
            }
        }
    }
    function reduce(l, f) {
        if (!l) return 0;
        var tl = l[2], hd = l[1];
        return [
            0,
            caml_call3(fold, tl, hd, f)
        ];
    }
    function reduce_exn(l, f) {
        var match = reduce(l, f);
        if (!match) return caml_call1(Base_Import[126], cst_List_reduce_exn);
        var v = match[1];
        return v;
    }
    function reduce_balanced(l, f) {
        function step_accum(num, acc, x) {
            var num$0 = num, acc$0 = acc, x$0 = x;
            for(;;){
                if (0 === caml_call2(Base_Import[116], num$0, 1)) return [
                    0,
                    x$0,
                    acc$0
                ];
                if (!acc$0) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _h_
                ], 1);
                var acc$1 = acc$0[2], y = acc$0[1], x$1 = caml_call2(f, y, x$0), num$1 = caml_call2(Base_Import[115], num$0, 1);
                num$0 = num$1;
                acc$0 = acc$1;
                x$0 = x$1;
            }
        }
        var match = foldi(l, 0, step_accum);
        if (!match) return 0;
        var xs = match[2], x = match[1];
        return [
            0,
            caml_call3(fold, xs, x, function(x, y) {
                return caml_call2(f, y, x);
            })
        ];
    }
    function reduce_balanced_exn(l, f) {
        var match = reduce_balanced(l, f);
        if (!match) return caml_call1(Base_Import[126], cst_List_reduce_balanced_exn);
        var v = match[1];
        return v;
    }
    function groupi(l, break$0) {
        var pos = [
            0,
            0
        ], l$0 = [
            0,
            l
        ];
        function take_group(param) {
            var group = l$0[1];
            if (group) {
                var tl = group[2];
                if (tl) {
                    var y = tl[1], x = group[1];
                    pos[1] = caml_call2(Base_Import[91], pos[1], 1);
                    l$0[1] = tl;
                    if (caml_call3(break$0, pos[1], x, y)) return [
                        0,
                        x,
                        0
                    ];
                    var block = [
                        0,
                        x,
                        24029
                    ], dst = block, offset = 1;
                    for(;;){
                        var group$0 = l$0[1];
                        a: {
                            if (group$0) {
                                var tl$0 = group$0[2];
                                if (tl$0) {
                                    var y$0 = tl$0[1], x$0 = group$0[1];
                                    pos[1] = caml_call2(Base_Import[91], pos[1], 1);
                                    l$0[1] = tl$0;
                                    if (caml_call3(break$0, pos[1], x$0, y$0)) {
                                        dst[1 + offset] = [
                                            0,
                                            x$0,
                                            0
                                        ];
                                        break a;
                                    }
                                    var dst$0 = [
                                        0,
                                        x$0,
                                        24029
                                    ];
                                    dst[1 + offset] = dst$0;
                                    dst = dst$0;
                                    offset = 1;
                                    continue;
                                }
                            }
                            l$0[1] = 0;
                            dst[1 + offset] = group$0;
                        }
                        return block;
                    }
                }
            }
            l$0[1] = 0;
            return group;
        }
        if (caml_call1(is_empty, l$0[1])) return 0;
        var group = take_group(0), block = [
            0,
            group,
            24029
        ], dst = block, offset = 1;
        for(;;){
            if (caml_call1(is_empty, l$0[1])) {
                dst[1 + offset] = 0;
                return block;
            }
            var group$0 = take_group(0), dst$0 = [
                0,
                group$0,
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
        }
    }
    function group(l, break$0) {
        return groupi(l, function(param, x, y) {
            return caml_call2(break$0, x, y);
        });
    }
    function merge(l1, l2, compare) {
        if (!l1) return l2;
        if (!l2) return l1;
        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
        if (0 < caml_call2(compare, h1, h2)) {
            var block = [
                0,
                h2,
                24029
            ];
            merge_dps(block, 1, l1, t2, compare);
            return block;
        }
        var block$0 = [
            0,
            h1,
            24029
        ];
        merge_dps(block$0, 1, t1, l2, compare);
        return block$0;
    }
    function merge_dps(dst, offset, l1, l2, compare) {
        var dst$0 = dst, offset$0 = offset, l1$0 = l1, l2$0 = l2;
        for(;;){
            if (!l1$0) {
                dst$0[1 + offset$0] = l2$0;
                return;
            }
            if (!l2$0) {
                dst$0[1 + offset$0] = l1$0;
                return;
            }
            var t2 = l2$0[2], h2 = l2$0[1], t1 = l1$0[2], h1 = l1$0[1];
            if (0 < caml_call2(compare, h1, h2)) {
                var dst$1 = [
                    0,
                    h2,
                    24029
                ];
                dst$0[1 + offset$0] = dst$1;
                dst$0 = dst$1;
                offset$0 = 1;
                l2$0 = t2;
            } else {
                var dst$2 = [
                    0,
                    h1,
                    24029
                ];
                dst$0[1 + offset$0] = dst$2;
                dst$0 = dst$2;
                offset$0 = 1;
                l1$0 = t1;
            }
        }
    }
    function stable_sort(l, cmp) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _aL_ = l[2];
                if (_aL_) {
                    var match$2 = _aL_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _aL_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x1$0, x3) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _aK_ = caml_call2(rev_append, l1, accu);
                } else var _aK_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _aK_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], s = 0 < caml_call2(cmp, x1, x2) ? [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _aJ_ = l[2];
                if (_aJ_) {
                    var match$2 = _aJ_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _aJ_[1], x1$0 = l[1], s$0 = 0 < caml_call2(cmp, x1$0, x2$0) ? 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x1$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x1$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x1$0,
                                [
                                    0,
                                    x3,
                                    0
                                ]
                            ]
                        ] : 0 < caml_call2(cmp, x2$0, x3) ? [
                            0,
                            x2$0,
                            [
                                0,
                                x3,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ] : [
                            0,
                            x3,
                            [
                                0,
                                x2$0,
                                [
                                    0,
                                    x1$0,
                                    0
                                ]
                            ]
                        ];
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1];
                        if (0 < caml_call2(cmp, h1, h2)) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h1,
                            accu
                        ];
                        l1 = t1;
                        accu = accu$1;
                        continue;
                    }
                    var _aI_ = caml_call2(rev_append, l1, accu);
                } else var _aI_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _aI_,
                    tl$0
                ];
            }
        }
        var len = caml_call1(length, l);
        if (2 > len) return l;
        var _aH_ = sort(len, l);
        return caml_call1(Base_Import[125], _aH_);
    }
    function sort_and_group(l, compare) {
        return group(stable_sort(l, compare), function(x, y) {
            return 0 !== caml_call2(compare, x, y) ? 1 : 0;
        });
    }
    function dedup_and_sort(l, cmp) {
        function sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2);
                        if (0 <= c$0) var _at_ = 0 < c$0 ? [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ] : [
                            0,
                            x2,
                            0
                        ], s = _at_;
                        else var s = [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _av_ = l[2];
                if (_av_) {
                    var match$2 = _av_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _av_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 <= c$1) {
                            if (0 < c$1) {
                                var c$2 = caml_call2(cmp, x1$0, x3);
                                if (0 <= c$2) {
                                    if (0 < c$2) {
                                        var c$3 = caml_call2(cmp, x2$0, x3);
                                        if (0 <= c$3) var _aw_ = 0 < c$3 ? [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ] : [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x1$0,
                                                0
                                            ]
                                        ], _ax_ = _aw_;
                                        else var _ax_ = [
                                            0,
                                            x2$0,
                                            [
                                                0,
                                                x3,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ];
                                        var _ay_ = _ax_;
                                    } else var _ay_ = [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ];
                                    var _az_ = _ay_;
                                } else var _az_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ]
                                ];
                                var _aA_ = _az_;
                            } else {
                                var c$4 = caml_call2(cmp, x2$0, x3);
                                if (0 <= c$4) var _aB_ = 0 < c$4 ? [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ] : [
                                    0,
                                    x3,
                                    0
                                ], _aC_ = _aB_;
                                else var _aC_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                var _aA_ = _aC_;
                            }
                            var s$0 = _aA_;
                        } else {
                            var c$5 = caml_call2(cmp, x2$0, x3);
                            if (0 <= c$5) {
                                if (0 < c$5) {
                                    var c$6 = caml_call2(cmp, x1$0, x3);
                                    if (0 <= c$6) var _aD_ = 0 < c$6 ? [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x1$0,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ] : [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x2$0,
                                            0
                                        ]
                                    ], _aE_ = _aD_;
                                    else var _aE_ = [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ];
                                    var _aF_ = _aE_;
                                } else var _aF_ = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                var _aG_ = _aF_;
                            } else var _aG_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            var s$0 = _aG_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = rev_sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = rev_sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 < c) {
                            var accu$0 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$0;
                            continue;
                        }
                        if (0 <= c) {
                            l1 = t1;
                            continue;
                        }
                        var accu$1 = [
                            0,
                            h2,
                            accu
                        ];
                        l2 = t2;
                        accu = accu$1;
                        continue;
                    }
                    var _au_ = caml_call2(rev_append, l1, accu);
                } else var _au_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _au_,
                    tl$0
                ];
            }
        }
        function rev_sort(n, l) {
            if (2 === n) {
                if (l) {
                    var match = l[2];
                    if (match) {
                        var tl = match[2], x2 = match[1], x1 = l[1], c$0 = caml_call2(cmp, x1, x2);
                        if (0 < c$0) var s = [
                            0,
                            x1,
                            [
                                0,
                                x2,
                                0
                            ]
                        ];
                        else var _af_ = 0 <= c$0 ? [
                            0,
                            x2,
                            0
                        ] : [
                            0,
                            x2,
                            [
                                0,
                                x1,
                                0
                            ]
                        ], s = _af_;
                        return [
                            0,
                            s,
                            tl
                        ];
                    }
                }
            } else if (3 === n && l) {
                var _ah_ = l[2];
                if (_ah_) {
                    var match$2 = _ah_[2];
                    if (match$2) {
                        var tl$1 = match$2[2], x3 = match$2[1], x2$0 = _ah_[1], x1$0 = l[1], c$1 = caml_call2(cmp, x1$0, x2$0);
                        if (0 < c$1) {
                            var c$2 = caml_call2(cmp, x2$0, x3);
                            if (0 < c$2) var _ai_ = [
                                0,
                                x1$0,
                                [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ]
                            ];
                            else {
                                if (0 <= c$2) var _aj_ = [
                                    0,
                                    x1$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                else {
                                    var c$3 = caml_call2(cmp, x1$0, x3);
                                    if (0 < c$3) var _ak_ = [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ];
                                    else var _al_ = 0 <= c$3 ? [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x2$0,
                                            0
                                        ]
                                    ] : [
                                        0,
                                        x3,
                                        [
                                            0,
                                            x1$0,
                                            [
                                                0,
                                                x2$0,
                                                0
                                            ]
                                        ]
                                    ], _ak_ = _al_;
                                    var _aj_ = _ak_;
                                }
                                var _ai_ = _aj_;
                            }
                            var s$0 = _ai_;
                        } else {
                            if (0 <= c$1) {
                                var c$4 = caml_call2(cmp, x2$0, x3);
                                if (0 < c$4) var _am_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x3,
                                        0
                                    ]
                                ];
                                else var _ao_ = 0 <= c$4 ? [
                                    0,
                                    x3,
                                    0
                                ] : [
                                    0,
                                    x3,
                                    [
                                        0,
                                        x2$0,
                                        0
                                    ]
                                ], _am_ = _ao_;
                                var _an_ = _am_;
                            } else {
                                var c$5 = caml_call2(cmp, x1$0, x3);
                                if (0 < c$5) var _ap_ = [
                                    0,
                                    x2$0,
                                    [
                                        0,
                                        x1$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ]
                                ];
                                else {
                                    if (0 <= c$5) var _aq_ = [
                                        0,
                                        x2$0,
                                        [
                                            0,
                                            x3,
                                            0
                                        ]
                                    ];
                                    else {
                                        var c$6 = caml_call2(cmp, x2$0, x3);
                                        if (0 < c$6) var _ar_ = [
                                            0,
                                            x2$0,
                                            [
                                                0,
                                                x3,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ];
                                        else var _as_ = 0 <= c$6 ? [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x1$0,
                                                0
                                            ]
                                        ] : [
                                            0,
                                            x3,
                                            [
                                                0,
                                                x2$0,
                                                [
                                                    0,
                                                    x1$0,
                                                    0
                                                ]
                                            ]
                                        ], _ar_ = _as_;
                                        var _aq_ = _ar_;
                                    }
                                    var _ap_ = _aq_;
                                }
                                var _an_ = _ap_;
                            }
                            var s$0 = _an_;
                        }
                        return [
                            0,
                            s$0,
                            tl$1
                        ];
                    }
                }
            }
            var n1 = caml_call2(Base_Import[115], n, 1), n2 = caml_call2(Base_Import[93], n, n1), match$0 = sort(n1, l), l2$0 = match$0[2], s1 = match$0[1], match$1 = sort(n2, l2$0), tl$0 = match$1[2], s2 = match$1[1], l1 = s1, l2 = s2, accu = 0;
            for(;;){
                if (l1) {
                    if (l2) {
                        var t2 = l2[2], h2 = l2[1], t1 = l1[2], h1 = l1[1], c = caml_call2(cmp, h1, h2);
                        if (0 > c) {
                            var accu$1 = [
                                0,
                                h1,
                                accu
                            ];
                            l1 = t1;
                            accu = accu$1;
                            continue;
                        }
                        if (0 < c) {
                            var accu$0 = [
                                0,
                                h2,
                                accu
                            ];
                            l2 = t2;
                            accu = accu$0;
                            continue;
                        }
                        l1 = t1;
                        continue;
                    }
                    var _ag_ = caml_call2(rev_append, l1, accu);
                } else var _ag_ = caml_call2(rev_append, l2, accu);
                return [
                    0,
                    _ag_,
                    tl$0
                ];
            }
        }
        var len = caml_call1(length, l);
        if (2 > len) return l;
        var _ae_ = sort(len, l);
        return caml_call1(Base_Import[125], _ae_);
    }
    function stable_dedup(list, compare) {
        if (list && list[2]) {
            var dedups = caml_call2(rev_map, list, function(elt) {
                return [
                    0,
                    elt,
                    1
                ];
            }), unique = dedup_and_sort(dedups, function(x, y) {
                return caml_call2(compare, x[1], y[1]);
            });
            caml_call2(iter, unique, function(dedup) {
                dedup[2] = 0;
                return 0;
            });
            return caml_call3(fold, dedups, 0, function(acc, dedup) {
                return dedup[2] ? acc : [
                    0,
                    dedup[1],
                    acc
                ];
            });
        }
        return list;
    }
    function concat_mapi(l, f) {
        function outer_loop_dps$0(counter, dst, offset, pos, param) {
            if (!param) {
                dst[1 + offset] = 0;
                return;
            }
            var tl = param[2], hd = param[1];
            if (!tl) {
                dst[1 + offset] = caml_call2(f, pos, hd);
                return;
            }
            var _ac_ = caml_call2(f, pos, hd), _ad_ = caml_call2(Base_Import[91], pos, 1);
            if (counter >= 50) return caml_trampoline_return(inner_loop_dps$0, [
                0,
                dst,
                offset,
                _ad_,
                _ac_,
                tl
            ]);
            var counter$0 = counter + 1 | 0;
            return inner_loop_dps$0(counter$0, dst, offset, _ad_, _ac_, tl);
        }
        function outer_loop_dps(dst, offset, pos, param) {
            return caml_trampoline(outer_loop_dps$0(0, dst, offset, pos, param));
        }
        function inner_loop_dps$0(counter, dst, offset, pos, l1, l2) {
            var dst$0 = dst, offset$0 = offset, l1$0 = l1;
            for(;;){
                if (!l1$0) {
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        dst$0,
                        offset$0,
                        pos,
                        l2
                    ]);
                    var counter$4 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$4, dst$0, offset$0, pos, l2);
                }
                var _T_1 = l1$0[2], x1 = l1$0[1];
                if (!_T_1) {
                    var _aa_ = [
                        0,
                        x1,
                        24029
                    ];
                    dst$0[1 + offset$0] = _aa_;
                    var _ab_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _aa_,
                        _ab_,
                        pos,
                        l2
                    ]);
                    var counter$3 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$3, _aa_, _ab_, pos, l2);
                }
                var _U_ = _T_1[2], x2 = _T_1[1];
                if (!_U_) {
                    var ___ = [
                        0,
                        x2,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        ___
                    ];
                    var _$_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        ___,
                        _$_,
                        pos,
                        l2
                    ]);
                    var counter$2 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$2, ___, _$_, pos, l2);
                }
                var _V_ = _U_[2], x3 = _U_[1];
                if (!_V_) {
                    var _Y_ = [
                        0,
                        x3,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        [
                            0,
                            x2,
                            _Y_
                        ]
                    ];
                    var _Z_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _Y_,
                        _Z_,
                        pos,
                        l2
                    ]);
                    var counter$1 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$1, _Y_, _Z_, pos, l2);
                }
                var match = _V_[2], x4 = _V_[1];
                if (!match) {
                    var _W_ = [
                        0,
                        x4,
                        24029
                    ];
                    dst$0[1 + offset$0] = [
                        0,
                        x1,
                        [
                            0,
                            x2,
                            [
                                0,
                                x3,
                                _W_
                            ]
                        ]
                    ];
                    var _X_ = 1;
                    if (counter >= 50) return caml_trampoline_return(outer_loop_dps$0, [
                        0,
                        _W_,
                        _X_,
                        pos,
                        l2
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return outer_loop_dps$0(counter$0, _W_, _X_, pos, l2);
                }
                var tl = match[2], x5 = match[1], dst$1 = [
                    0,
                    x5,
                    24029
                ];
                dst$0[1 + offset$0] = [
                    0,
                    x1,
                    [
                        0,
                        x2,
                        [
                            0,
                            x3,
                            [
                                0,
                                x4,
                                dst$1
                            ]
                        ]
                    ]
                ];
                dst$0 = dst$1;
                offset$0 = 1;
                l1$0 = tl;
            }
        }
        function inner_loop_dps(dst, offset, pos, l1, l2) {
            return caml_trampoline(inner_loop_dps$0(0, dst, offset, pos, l1, l2));
        }
        var pos = 0, param = l;
        for(;;){
            if (!param) return 0;
            var tl = param[2], hd = param[1];
            if (!tl) return caml_call2(f, pos, hd);
            var l1 = caml_call2(f, pos, hd), pos$0 = caml_call2(Base_Import[91], pos, 1);
            if (l1) break;
            pos = pos$0;
            param = tl;
        }
        var _Q_ = l1[2], x1 = l1[1];
        if (!_Q_) {
            var block$3 = [
                0,
                x1,
                24029
            ];
            outer_loop_dps(block$3, 1, pos$0, tl);
            return block$3;
        }
        var _R_ = _Q_[2], x2 = _Q_[1];
        if (!_R_) {
            var block$2 = [
                0,
                x2,
                24029
            ];
            outer_loop_dps(block$2, 1, pos$0, tl);
            return [
                0,
                x1,
                block$2
            ];
        }
        var _S_ = _R_[2], x3 = _R_[1];
        if (!_S_) {
            var block$1 = [
                0,
                x3,
                24029
            ];
            outer_loop_dps(block$1, 1, pos$0, tl);
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    block$1
                ]
            ];
        }
        var match = _S_[2], x4 = _S_[1];
        if (match) {
            var tl$0 = match[2], x5 = match[1], block = [
                0,
                x5,
                24029
            ];
            inner_loop_dps(block, 1, pos$0, tl$0, tl);
            return [
                0,
                x1,
                [
                    0,
                    x2,
                    [
                        0,
                        x3,
                        [
                            0,
                            x4,
                            block
                        ]
                    ]
                ]
            ];
        }
        var block$0 = [
            0,
            x4,
            24029
        ];
        outer_loop_dps(block$0, 1, pos$0, tl);
        return [
            0,
            x1,
            [
                0,
                x2,
                [
                    0,
                    x3,
                    block$0
                ]
            ]
        ];
    }
    function concat_map(l, f) {
        return concat_mapi(l, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function map2$0(a, b, f) {
        return concat_map(a, function(x) {
            return map(b, function(y) {
                return caml_call2(f, x, y);
            });
        });
    }
    function symbol_bind(t, f) {
        return concat_map(t, f);
    }
    var map$0 = [
        0,
        -198771759,
        map
    ], Applicative = caml_call1(Base_Applicative[13], [
        0,
        singleton,
        map2$0,
        map$0
    ]), map$1 = [
        0,
        -198771759,
        map
    ], Monad = caml_call1(Base_Monad[1], [
        0,
        concat_map,
        singleton,
        map$1
    ]), all = Monad[9], all_unit = Monad[10], ignore_m = Monad[8], join = Monad[7], apply = Applicative[8], both = Applicative[3], map3$0 = Applicative[10], symbol = Applicative[4], symbol$0 = Applicative[6], symbol$1 = Applicative[5], symbol$2 = Applicative[4], symbol$3 = Applicative[6], symbol$4 = Applicative[5], Open_on_rhs = [
        0
    ], Let_syntax = [
        0,
        singleton,
        concat_map,
        map,
        both,
        Open_on_rhs
    ], Let_syntax$0 = [
        0,
        singleton,
        symbol_bind,
        symbol_map,
        Let_syntax
    ], Monad_infix = [
        0,
        symbol_bind,
        symbol_map
    ], cst_List_last = "List.last", _i_ = [
        0,
        [
            11,
            "List.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "List.init %d"
    ], _j_ = [
        0,
        cst_src_list_ml,
        1111,
        4
    ], _k_ = [
        1,
        0
    ], _l_ = [
        1,
        0
    ], _m_ = [
        1,
        0
    ], _n_ = [
        0,
        cst_src_list_ml,
        1305,
        12
    ];
    function last_exn(list) {
        var list$0 = list;
        for(;;){
            if (!list$0) return caml_call1(Base_Import[126], cst_List_last);
            var x = list$0[1];
            if (!list$0[2]) return x;
            var list$1 = list$0[2];
            list$0 = list$1;
        }
    }
    function last(list) {
        var list$0 = list;
        for(;;){
            if (!list$0) return 0;
            var x = list$0[1];
            if (!list$0[2]) return [
                0,
                x
            ];
            var list$1 = list$0[2];
            list$0 = list$1;
        }
    }
    function is_prefix(list, prefix, equal) {
        var list$0 = list, prefix$0 = prefix;
        for(;;){
            if (!prefix$0) return 1;
            var prefix$1 = prefix$0[2], hd = prefix$0[1];
            if (!list$0) return 0;
            var list$1 = list$0[2], hd$0 = list$0[1], _P_ = caml_call2(equal, hd, hd$0);
            if (!_P_) return _P_;
            list$0 = list$1;
            prefix$0 = prefix$1;
        }
    }
    function find_consecutive_duplicate(t, equal) {
        if (!t) return 0;
        var t$0 = t[2], a1 = t[1], a1$0 = a1, t$1 = t$0;
        for(;;){
            if (!t$1) return 0;
            var t$2 = t$1[2], a2 = t$1[1];
            if (caml_call2(equal, a1$0, a2)) return [
                0,
                [
                    0,
                    a1$0,
                    a2
                ]
            ];
            a1$0 = a2;
            t$1 = t$2;
        }
    }
    function remove_consecutive_duplicates(opt, list, equal) {
        var which_to_keep = opt ? opt[1] : 847656566;
        if (!list) return 0;
        var tl$0 = list[2], to_keep$2 = list[1], to_keep = to_keep$2, accum = 0, param = tl$0;
        for(;;){
            if (!param) return caml_call1(rev, [
                0,
                to_keep,
                accum
            ]);
            var tl = param[2], to_keep$0 = param[1];
            if (caml_call2(equal, to_keep$0, to_keep)) {
                var to_keep$1 = 847656566 <= which_to_keep ? to_keep$0 : to_keep;
                to_keep = to_keep$1;
                param = tl;
            } else {
                var accum$0 = [
                    0,
                    to_keep,
                    accum
                ];
                to_keep = to_keep$0;
                accum = accum$0;
                param = tl;
            }
        }
    }
    function find_a_dup(l, compare) {
        var sorted = stable_sort(l, compare), l$0 = sorted;
        for(;;){
            if (l$0) {
                var tl = l$0[2];
                if (tl) {
                    var hd2 = tl[1], hd1 = l$0[1];
                    if (0 === caml_call2(compare, hd1, hd2)) return [
                        0,
                        hd1
                    ];
                    l$0 = tl;
                    continue;
                }
            }
            return 0;
        }
    }
    function contains_dup(lst, compare) {
        return find_a_dup(lst, compare) ? 1 : 0;
    }
    function find_all_dups(l, compare) {
        var sorted = stable_sort(l, compare);
        if (!sorted) return 0;
        var sorted$4 = sorted[2], prev$3 = sorted[1], sorted$0 = sorted$4, prev = prev$3, already_recorded = 0;
        for(;;){
            if (!sorted$0) return 0;
            var sorted$1 = sorted$0[2], prev$0 = sorted$0[1];
            if (0 === caml_call2(compare, prev, prev$0)) {
                if (!already_recorded) break;
                sorted$0 = sorted$1;
                prev = prev$0;
                already_recorded = 1;
            } else {
                sorted$0 = sorted$1;
                prev = prev$0;
                already_recorded = 0;
            }
        }
        var block = [
            0,
            prev$0,
            24029
        ], dst = block, offset = 1, sorted$2 = sorted$1, prev$1 = prev$0, already_recorded$0 = 1;
        for(;;){
            if (!sorted$2) {
                dst[1 + offset] = 0;
                return block;
            }
            var sorted$3 = sorted$2[2], prev$2 = sorted$2[1];
            if (0 === caml_call2(compare, prev$1, prev$2)) {
                if (already_recorded$0) {
                    sorted$2 = sorted$3;
                    prev$1 = prev$2;
                    already_recorded$0 = 1;
                } else {
                    var dst$0 = [
                        0,
                        prev$2,
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    sorted$2 = sorted$3;
                    prev$1 = prev$2;
                    already_recorded$0 = 1;
                }
            } else {
                sorted$2 = sorted$3;
                prev$1 = prev$2;
                already_recorded$0 = 0;
            }
        }
    }
    function all_equal(t$0, equal) {
        if (!t$0) return 0;
        var xs$0 = t$0[2], x$0 = t$0[1], t = xs$0;
        for(;;){
            if (t) {
                var xs = t[2], x = t[1], _N_ = caml_call2(equal, x, x$0);
                if (_N_) {
                    t = xs;
                    continue;
                }
                var _O_ = _N_;
            } else var _O_ = 1;
            return _O_ ? [
                0,
                x$0
            ] : 0;
        }
    }
    function count(t, f) {
        return caml_call3(Base_Container[2], fold, t, f);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function counti(t, f) {
        return foldi(t, 0, function(idx, count, a) {
            return caml_call2(f, idx, a) ? caml_call2(Base_Import[91], count, 1) : count;
        });
    }
    function init(n, f) {
        if (n < 0) caml_call3(invalid_argf, _i_, n, 0);
        var i = n, accum = 0;
        for(;;){
            if (0 > i) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _j_
            ], 1);
            if (0 === i) return accum;
            var accum$0 = [
                0,
                caml_call1(f, caml_call2(Base_Import[93], i, 1)),
                accum
            ], i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            accum = accum$0;
        }
    }
    function rev_filter_map(l, f) {
        var l$0 = l, accum = 0;
        for(;;){
            if (!l$0) return accum;
            var tl = l$0[2], hd = l$0[1], match = caml_call1(f, hd);
            if (match) {
                var x = match[1], accum$0 = [
                    0,
                    x,
                    accum
                ];
                l$0 = tl;
                accum = accum$0;
            } else l$0 = tl;
        }
    }
    function filter_map(l, f) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], match = caml_call1(f, hd);
            if (match) {
                var x = match[1], block = [
                    0,
                    x,
                    24029
                ], dst = block, offset = 1, l$1 = tl;
                for(;;){
                    if (!l$1) {
                        dst[1 + offset] = 0;
                        return block;
                    }
                    var tl$0 = l$1[2], hd$0 = l$1[1], match$0 = caml_call1(f, hd$0);
                    if (match$0) {
                        var x$0 = match$0[1], dst$0 = [
                            0,
                            x$0,
                            24029
                        ];
                        dst[1 + offset] = dst$0;
                        dst = dst$0;
                        offset = 1;
                        l$1 = tl$0;
                    } else l$1 = tl$0;
                }
            } else l$0 = tl;
        }
    }
    function rev_filter_mapi(l, f) {
        var i = 0, l$0 = l, accum = 0;
        for(;;){
            if (!l$0) return accum;
            var tl = l$0[2], hd = l$0[1], match = caml_call2(f, i, hd);
            if (match) {
                var x = match[1], accum$0 = [
                    0,
                    x,
                    accum
                ], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                l$0 = tl;
                accum = accum$0;
            } else {
                var i$1 = caml_call2(Base_Import[91], i, 1);
                i = i$1;
                l$0 = tl;
            }
        }
    }
    function filter_mapi(l, f) {
        var pos = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], match = caml_call2(f, pos, hd);
            if (match) break;
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$1;
            l$0 = tl;
        }
        var x = match[1], block = [
            0,
            x,
            24029
        ], pos$0 = caml_call2(Base_Import[91], pos, 1), dst = block, offset = 1, pos$2 = pos$0, l$1 = tl;
        for(;;){
            if (!l$1) {
                dst[1 + offset] = 0;
                return block;
            }
            var tl$0 = l$1[2], hd$0 = l$1[1], match$0 = caml_call2(f, pos$2, hd$0);
            if (match$0) {
                var x$0 = match$0[1], block$0 = [
                    0,
                    x$0,
                    24029
                ];
                dst[1 + offset] = block$0;
                var pos$3 = caml_call2(Base_Import[91], pos$2, 1);
                dst = block$0;
                offset = 1;
                pos$2 = pos$3;
                l$1 = tl$0;
            } else {
                var pos$4 = caml_call2(Base_Import[91], pos$2, 1);
                pos$2 = pos$4;
                l$1 = tl$0;
            }
        }
    }
    function filter_opt(l) {
        return filter_map(l, function(_M_) {
            return _M_;
        });
    }
    function partition3_map(t, f) {
        var t$0 = t, fst = 0, snd = 0, trd = 0;
        for(;;){
            if (!t$0) {
                var _K_ = caml_call1(rev, trd), _L_ = caml_call1(rev, snd);
                return [
                    0,
                    caml_call1(rev, fst),
                    _L_,
                    _K_
                ];
            }
            var t$1 = t$0[2], x = t$0[1], match = caml_call1(f, x), _J_ = match[1];
            if (4152137 === _J_) {
                var y = match[2], snd$0 = [
                    0,
                    y,
                    snd
                ];
                t$0 = t$1;
                snd = snd$0;
            } else if (4202758 <= _J_) {
                var y$0 = match[2], trd$0 = [
                    0,
                    y$0,
                    trd
                ];
                t$0 = t$1;
                trd = trd$0;
            } else {
                var y$1 = match[2], fst$0 = [
                    0,
                    y$1,
                    fst
                ];
                t$0 = t$1;
                fst = fst$0;
            }
        }
    }
    function partition_tf(t, f) {
        function f$0(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : [
                1,
                x
            ];
        }
        return caml_call2(partition_map, t, f$0);
    }
    function partition_result(t) {
        return caml_call2(partition_map, t, Base_Result[38]);
    }
    function t_of_sexp$0(of_a_028, of_b_029, x_037) {
        return caml_call2(Base_Import[173], function(sexp_035) {
            if (1 === sexp_035[0]) {
                var _H_ = sexp_035[1];
                if (_H_) {
                    var _I_ = _H_[2];
                    if (_I_ && !_I_[2]) {
                        var arg1_032 = _I_[1], arg0_031 = _H_[1], res0_033 = caml_call1(of_a_028, arg0_031), res1_034 = caml_call1(of_b_029, arg1_032);
                        return [
                            0,
                            res0_033,
                            res1_034
                        ];
                    }
                }
            }
            return caml_call3(Sexplib0_Sexp_conv_error[4], error_source_036, 2, sexp_035);
        }, x_037);
    }
    function sexp_of_t$1(of_a_038, of_b_039, x_044) {
        return caml_call2(Base_Import[149], function(param) {
            var arg1_041 = param[2], arg0_040 = param[1], res0_042 = caml_call1(of_a_038, arg0_040), res1_043 = caml_call1(of_b_039, arg1_041);
            return [
                1,
                [
                    0,
                    res0_042,
                    [
                        0,
                        res1_043,
                        0
                    ]
                ]
            ];
        }, x_044);
    }
    function t_sexp_grammar$0(a_sexp_grammar, b_sexp_grammar) {
        var _G_ = caml_call1(Base_Import[194], [
            2,
            [
                0,
                [
                    5,
                    [
                        0,
                        Sexplib0_Sexp_grammar[6],
                        _k_,
                        a_sexp_grammar
                    ]
                ],
                [
                    0,
                    [
                        5,
                        [
                            0,
                            Sexplib0_Sexp_grammar[7],
                            _l_,
                            b_sexp_grammar
                        ]
                    ],
                    0
                ]
            ]
        ]);
        return [
            5,
            [
                0,
                Sexplib0_Sexp_grammar[5],
                _m_,
                _G_
            ]
        ];
    }
    function pair_of_group(list) {
        if (!list) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _n_
        ], 1);
        var k = list[1][1];
        return [
            0,
            k,
            map(list, Base_Import[127])
        ];
    }
    function group$0(alist, equal) {
        return map(group(alist, function(_F_, param) {
            var y = param[1], x = _F_[1];
            return 1 - caml_call2(equal, x, y);
        }), pair_of_group);
    }
    function sort_and_group$0(alist, compare) {
        return map(sort_and_group(alist, function(_E_, param) {
            var y = param[1], x = _E_[1];
            return caml_call2(compare, x, y);
        }), pair_of_group);
    }
    function find$0(t, equal, key) {
        var match = find(t, function(param) {
            var key$0 = param[1];
            return caml_call2(equal, key, key$0);
        });
        if (!match) return 0;
        var x = match[1];
        return [
            0,
            caml_call1(Base_Import[127], x)
        ];
    }
    var not_found$3 = [
        0,
        Base_Import[297],
        [
            0,
            "List.Assoc.find_exn: not found"
        ]
    ], cst_List_sub = "List.sub", _o_ = [
        0,
        [
            11,
            "List.chunks_of: Expected length > 0, got ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "List.chunks_of: Expected length > 0, got %d"
    ], cst_List_drop_last_exn_empty_l = "List.drop_last_exn: empty list";
    function find_exn$0(t, equal, key) {
        var t$0 = t;
        for(;;){
            if (!t$0) throw caml_maybe_attach_backtrace(not_found$3, 1);
            var t$1 = t$0[2], match = t$0[1], value = match[2], key$0 = match[1];
            if (caml_call2(equal, key, key$0)) return value;
            t$0 = t$1;
        }
    }
    function mem$0(t, equal, key) {
        return find$0(t, equal, key) ? 1 : 0;
    }
    function remove(t, equal, key) {
        return filter(t, function(param) {
            var key$0 = param[1];
            return 1 - caml_call2(equal, key, key$0);
        });
    }
    function add(t, equal, key, value) {
        return [
            0,
            [
                0,
                key,
                value
            ],
            remove(t, equal, key)
        ];
    }
    function inverse(t) {
        return map(t, function(param) {
            var y = param[2], x = param[1];
            return [
                0,
                y,
                x
            ];
        });
    }
    function map$2(t, f) {
        return map(t, function(param) {
            var value = param[2], key = param[1];
            return [
                0,
                key,
                caml_call1(f, value)
            ];
        });
    }
    function sub(l, pos, len) {
        var _A_ = pos < 0 ? 1 : 0;
        if (_A_) var _B_ = _A_;
        else {
            var _C_ = len < 0 ? 1 : 0;
            if (_C_) var _B_ = _C_;
            else var _D_ = caml_call1(length, l), _B_ = caml_call2(Base_Import[93], _D_, len) < pos ? 1 : 0;
        }
        if (_B_) caml_call1(Base_Import[126], cst_List_sub);
        var stop = caml_call2(Base_Import[91], pos, len), i = 0, l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1];
            if (i >= pos) break;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            l$0 = tl;
        }
        if (i >= stop) return 0;
        var block = [
            0,
            hd,
            24029
        ], i$1 = caml_call2(Base_Import[91], i, 1), dst = block, offset = 1, i$2 = i$1, l$1 = tl;
        for(;;){
            if (l$1) {
                var tl$0 = l$1[2], hd$0 = l$1[1];
                if (i$2 < pos) {
                    var i$3 = caml_call2(Base_Import[91], i$2, 1);
                    i$2 = i$3;
                    l$1 = tl$0;
                    continue;
                }
                if (i$2 < stop) {
                    var block$0 = [
                        0,
                        hd$0,
                        24029
                    ];
                    dst[1 + offset] = block$0;
                    var i$4 = caml_call2(Base_Import[91], i$2, 1);
                    dst = block$0;
                    offset = 1;
                    i$2 = i$4;
                    l$1 = tl$0;
                    continue;
                }
                dst[1 + offset] = 0;
            } else dst[1 + offset] = 0;
            return block;
        }
    }
    function split_n(t_orig, n) {
        if (0 >= n) return [
            0,
            0,
            t_orig
        ];
        var n$0 = n, t = t_orig, accum = 0;
        for(;;){
            if (!t) return [
                0,
                t_orig,
                0
            ];
            var tl = t[2], hd = t[1];
            if (0 === n$0) return [
                0,
                caml_call1(rev, accum),
                t
            ];
            var accum$0 = [
                0,
                hd,
                accum
            ], n$1 = caml_call2(Base_Import[93], n$0, 1);
            n$0 = n$1;
            t = tl;
            accum = accum$0;
        }
    }
    function take(t_orig, n) {
        if (0 >= n) return 0;
        var n$0 = n, t = t_orig, accum = 0;
        for(;;){
            if (!t) return t_orig;
            var tl = t[2], hd = t[1];
            if (0 === n$0) return caml_call1(rev, accum);
            var accum$0 = [
                0,
                hd,
                accum
            ], n$1 = caml_call2(Base_Import[93], n$0, 1);
            n$0 = n$1;
            t = tl;
            accum = accum$0;
        }
    }
    function drop(t, n) {
        var t$0 = t, n$0 = n;
        for(;;){
            if (t$0) {
                var tl = t$0[2];
                if (0 < n$0) {
                    var n$1 = caml_call2(Base_Import[93], n$0, 1);
                    t$0 = tl;
                    n$0 = n$1;
                    continue;
                }
            }
            return t$0;
        }
    }
    function chunks_of(l, length) {
        if (length <= 0) caml_call3(invalid_argf, _o_, length, 0);
        var acc = 0, l$0 = l;
        for(;;){
            if (!l$0) return caml_call1(rev, acc);
            var match = split_n(l$0, length), l$1 = match[2], sublist = match[1], acc$0 = [
                0,
                sublist,
                acc
            ];
            acc = acc$0;
            l$0 = l$1;
        }
    }
    function split_while(xs, f) {
        var acc = 0, t = xs;
        for(;;){
            if (t) {
                var tl = t[2], hd = t[1];
                if (caml_call1(f, hd)) {
                    var acc$0 = [
                        0,
                        hd,
                        acc
                    ];
                    acc = acc$0;
                    t = tl;
                    continue;
                }
            }
            return [
                0,
                caml_call1(rev, acc),
                t
            ];
        }
    }
    function take_while(xs, f) {
        var acc = 0, param = xs;
        for(;;){
            if (param) {
                var tl = param[2], hd = param[1];
                if (caml_call1(f, hd)) {
                    var acc$0 = [
                        0,
                        hd,
                        acc
                    ];
                    acc = acc$0;
                    param = tl;
                    continue;
                }
            }
            return caml_call1(rev, acc);
        }
    }
    function drop_while(t, f) {
        var t$0 = t;
        for(;;){
            if (t$0) {
                var tl = t$0[2], hd = t$0[1];
                if (caml_call1(f, hd)) {
                    t$0 = tl;
                    continue;
                }
            }
            return t$0;
        }
    }
    function drop_last(t) {
        var match = caml_call1(rev, t);
        if (!match) return 0;
        var lst = match[2];
        return [
            0,
            caml_call1(rev, lst)
        ];
    }
    function drop_last_exn(t) {
        var match = drop_last(t);
        if (!match) return caml_call1(Base_Import[124], cst_List_drop_last_exn_empty_l);
        var lst = match[1];
        return lst;
    }
    function cartesian_product(list1, list2) {
        if (caml_call1(is_empty, list2)) return 0;
        var l1 = list1;
        for(;;){
            if (!l1) return 0;
            var l1$0 = l1[2], x1 = l1[1];
            if (list2) break;
            l1 = l1$0;
        }
        var l2 = list2[2], x2 = list2[1], block = [
            0,
            [
                0,
                x1,
                x2
            ],
            24029
        ], dst = block, offset = 1, x1$1 = x1, l1$2 = l1$0, l2$0 = l2;
        for(;;)if (l2$0) {
            var l2$1 = l2$0[2], x2$0 = l2$0[1], dst$0 = [
                0,
                [
                    0,
                    x1$1,
                    x2$0
                ],
                24029
            ];
            dst[1 + offset] = dst$0;
            dst = dst$0;
            offset = 1;
            l2$0 = l2$1;
        } else {
            if (!l1$2) {
                dst[1 + offset] = 0;
                return block;
            }
            var l1$1 = l1$2[2], x1$0 = l1$2[1];
            x1$1 = x1$0;
            l1$2 = l1$1;
            l2$0 = list2;
        }
    }
    function concat(l) {
        return caml_call3(fold_right, l, append, 0);
    }
    function concat_no_order(l) {
        return caml_call3(fold, l, 0, function(acc, l) {
            return caml_call2(rev_append, l, acc);
        });
    }
    function cons(x, l) {
        return [
            0,
            x,
            l
        ];
    }
    function is_sorted(l, compare) {
        var l$0 = l;
        for(;;){
            if (l$0) {
                var rest = l$0[2];
                if (rest) {
                    var x2 = rest[1], x1 = l$0[1], _z_ = caml_call2(compare, x1, x2) <= 0 ? 1 : 0;
                    if (!_z_) return _z_;
                    l$0 = rest;
                    continue;
                }
            }
            return 1;
        }
    }
    function is_sorted_strictly(l, compare) {
        var l$0 = l;
        for(;;){
            if (l$0) {
                var rest = l$0[2];
                if (rest) {
                    var x2 = rest[1], x1 = l$0[1], _y_ = caml_call2(compare, x1, x2) < 0 ? 1 : 0;
                    if (!_y_) return _y_;
                    l$0 = rest;
                    continue;
                }
            }
            return 1;
        }
    }
    var Infix = [
        0,
        append
    ], cst_List_random_element_exn_em = "List.random_element_exn: empty list";
    function permute(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (list) {
            var _x_ = list[2];
            if (_x_) {
                if (_x_[2]) {
                    var arr = caml_call1(Base_Array0[14], list);
                    caml_call4(Base_Array_permute[25], [
                        0,
                        random_state
                    ], 0, 0, arr);
                    return caml_call1(Base_Array0[16], arr);
                }
                var y = _x_[1], x = list[1];
                return caml_call1(Base_Random[19][17], random_state) ? [
                    0,
                    y,
                    [
                        0,
                        x,
                        0
                    ]
                ] : list;
            }
        }
        return list;
    }
    function random_element_exn(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (caml_call1(is_empty, list)) return caml_call1(Base_Import[124], cst_List_random_element_exn_em);
        var _w_ = caml_call1(length, list);
        return nth_exn(list, caml_call2(Base_Random[19][7], random_state, _w_));
    }
    function random_element(opt, list) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        try {
            var _u_ = [
                0,
                random_element_exn([
                    0,
                    random_state
                ], list)
            ];
            return _u_;
        } catch (_v_) {
            return 0;
        }
    }
    function compare$0(cmp, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], n = caml_call2(cmp, x, y);
            if (0 !== n) return n;
            a$0 = xs;
            b$0 = ys;
        }
    }
    function compare_local$0(cmp, a, b) {
        var a$0 = a, b$0 = b;
        for(;;){
            if (!a$0) return b$0 ? -1 : 0;
            if (!b$0) return 1;
            var ys = b$0[2], y = b$0[1], xs = a$0[2], x = a$0[1], n = caml_call2(cmp, x, y);
            if (0 !== n) return n;
            a$0 = xs;
            b$0 = ys;
        }
    }
    var hash_fold_t = Base_Import[212];
    function equal_with_local_closure(equal, t1, t2) {
        var t1$0 = t1, t2$0 = t2;
        for(;;){
            if (t1$0) {
                if (t2$0) {
                    var t2$1 = t2$0[2], x2 = t2$0[1], t1$1 = t1$0[2], x1 = t1$0[1], _t_ = caml_call2(equal, x1, x2);
                    if (!_t_) return _t_;
                    t1$0 = t1$1;
                    t2$0 = t2$1;
                    continue;
                }
            } else if (!t2$0) return 1;
            return 0;
        }
    }
    function equal(f, x, y) {
        return equal_with_local_closure(f, x, y);
    }
    function equal_local(equal_a_local, t1, t2) {
        var t1$0 = t1, t2$0 = t2;
        for(;;){
            if (t1$0) {
                if (t2$0) {
                    var t2$1 = t2$0[2], x2 = t2$0[1], t1$1 = t1$0[2], x1 = t1$0[1], _s_ = caml_call2(equal_a_local, x1, x2);
                    if (!_s_) return _s_;
                    t1$0 = t1$1;
                    t2$0 = t2$1;
                    continue;
                }
            } else if (!t2$0) return 1;
            return 0;
        }
    }
    function transpose(rows$0) {
        var rows = rows$0, columns = 0, do_rev = 1;
        for(;;){
            var t = rows, column_acc = 0, trimmed_rows = 0, found_empty = 0;
            for(;;){
                if (!t) break;
                var match = t[1];
                if (match) {
                    var tl = t[2], xs = match[2], x = match[1], trimmed = [
                        0,
                        xs,
                        trimmed_rows
                    ], column_acc$0 = [
                        0,
                        x,
                        column_acc
                    ];
                    t = tl;
                    column_acc = column_acc$0;
                    trimmed_rows = trimmed;
                } else {
                    var tl$0 = t[2];
                    t = tl$0;
                    found_empty = 1;
                }
            }
            if (!column_acc && !trimmed_rows) return [
                0,
                caml_call1(rev, columns)
            ];
            if (found_empty) return 0;
            var column = do_rev ? caml_call1(rev, column_acc) : column_acc, do_rev$0 = 1 - do_rev, columns$0 = [
                0,
                column,
                columns
            ];
            rows = trimmed_rows;
            columns = columns$0;
            do_rev = do_rev$0;
        }
    }
    var Transpose_got_lists_of_differe = [
        248,
        "Base__List.Transpose_got_lists_of_different_lengths",
        runtime.caml_fresh_oo_id(0)
    ], _p_ = [
        0,
        "list.ml.Transpose_got_lists_of_different_lengths"
    ], _q_ = [
        0,
        cst_src_list_ml,
        1588,
        11
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Transpose_got_lists_of_differe, function(param) {
        if (param[1] !== Transpose_got_lists_of_differe) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _q_
        ], 1);
        var arg0_045 = param[2], res0_046 = caml_call2(Base_Import[149], Base_Import[139], arg0_045);
        return [
            1,
            [
                0,
                _p_,
                [
                    0,
                    res0_046,
                    0
                ]
            ]
        ];
    });
    function transpose_exn(l) {
        var match = transpose(l);
        if (!match) throw caml_maybe_attach_backtrace([
            0,
            Transpose_got_lists_of_differe,
            map(l, length)
        ], 1);
        var l$0 = match[1];
        return l$0;
    }
    function intersperse(t, sep) {
        if (!t) return 0;
        var xs = t[2], x = t[1];
        return [
            0,
            x,
            caml_call3(fold_right, xs, function(y, acc) {
                return [
                    0,
                    sep,
                    [
                        0,
                        y,
                        acc
                    ]
                ];
            }, 0)
        ];
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function is_suffix(list, suffix, equal_elt) {
        var list_len = caml_call1(length, list), suffix_len = caml_call1(length, suffix), _r_ = suffix_len <= list_len ? 1 : 0;
        return _r_ ? equal_with_local_closure(equal_elt, drop(list, caml_call2(Base_Import[93], list_len, suffix_len)), suffix) : _r_;
    }
    var Base_List = [
        0,
        compare$0,
        compare_local$0,
        globalize,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        of_list,
        of_array,
        append,
        concat,
        filter,
        filter_map,
        concat_map,
        partition_tf,
        partition_map,
        mem,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        concat_mapi,
        length,
        invariant,
        [
            0,
            both,
            symbol,
            symbol$1,
            symbol$0,
            apply,
            map2$0,
            map3$0,
            [
                0,
                symbol$2,
                symbol$4,
                symbol$3,
                symbol_map
            ],
            symbol_bind,
            symbol_map,
            [
                0,
                symbol_bind,
                symbol_map
            ],
            concat_map,
            singleton,
            map,
            join,
            ignore_m,
            all,
            all_unit,
            [
                0,
                singleton,
                symbol_bind,
                symbol_map,
                Let_syntax
            ]
        ],
        symbol_bind,
        symbol_map,
        Monad_infix,
        concat_map,
        singleton,
        map,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax$0,
        [
            0,
            compare,
            compare_local,
            sexp_of_t$0
        ],
        singleton,
        nth,
        nth_exn,
        rev,
        rev_append,
        unordered_append,
        rev_map,
        iter2_exn,
        iter2,
        rev_map2_exn,
        rev_map2,
        fold2_exn,
        fold2,
        fold_right2_exn,
        fold_right2,
        for_all2_exn,
        for_all2,
        exists2_exn,
        exists2,
        rev_filter,
        partition3_map,
        partition_result,
        split_n,
        stable_sort,
        stable_sort,
        merge,
        hd,
        tl,
        hd_exn,
        tl_exn,
        findi_exn,
        find_exn,
        find_map_exn,
        find_mapi_exn,
        folding_map,
        folding_mapi,
        fold_map,
        fold_mapi,
        map2_exn,
        map2,
        rev_map3_exn,
        rev_map3,
        map3_exn,
        map3,
        rev_map_append,
        fold_right,
        fold,
        unzip,
        unzip3,
        zip,
        zip_exn,
        rev_mapi,
        reduce_exn,
        reduce,
        reduce_balanced,
        reduce_balanced_exn,
        group,
        groupi,
        sort_and_group,
        chunks_of,
        last,
        last_exn,
        is_prefix,
        is_suffix,
        find_consecutive_duplicate,
        remove_consecutive_duplicates,
        dedup_and_sort,
        stable_dedup,
        find_a_dup,
        contains_dup,
        find_all_dups,
        all_equal,
        range$0,
        range,
        rev_filter_map,
        rev_filter_mapi,
        filter_opt,
        [
            0,
            t_of_sexp$0,
            sexp_of_t$1,
            t_sexp_grammar$0,
            add,
            find$0,
            find_exn$0,
            mem$0,
            remove,
            map$2,
            inverse,
            group$0,
            sort_and_group$0
        ],
        sub,
        take,
        drop,
        take_while,
        drop_while,
        split_while,
        drop_last,
        drop_last_exn,
        concat_no_order,
        cons,
        cartesian_product,
        permute,
        random_element,
        random_element_exn,
        is_sorted,
        is_sorted_strictly,
        equal,
        equal_local,
        Infix,
        transpose,
        transpose_exn,
        intersperse
    ];
    runtime.caml_register_global(62, Base_List, "Base__List");
    return;
})(globalThis);
//# 11334 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag, caml_trampoline = runtime.caml_trampoline, caml_trampoline_return = runtime.caml_trampoline_return, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, _j_ = [
        0,
        [
            0,
            "cycle while computing message"
        ]
    ], t_sexp_grammar = [
        0,
        "Info.t"
    ], module_name = "Base.Info", Stdlib_Format = global_data.Stdlib__Format, Base_Exn = global_data.Base__Exn, Stdlib_Printexc = global_data.Stdlib__Printexc, Assert_failure = global_data.Assert_failure, CamlinternalLazy = global_data.CamlinternalLazy, Base_Printf = global_data.Base__Printf, Base_Sexp = global_data.Base__Sexp, Base_Hash = global_data.Base__Hash, Base_Import = global_data.Base__Import, Base_List = global_data.Base__List, Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_String0 = global_data.Base__String0, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Base_Pretty_printer = global_data.Base__Pretty_printer, _a_ = [
        0,
        "Could_not_construct"
    ], _b_ = [
        0,
        "String"
    ], _c_ = [
        0,
        "Exn"
    ], _d_ = [
        0,
        "Sexp"
    ], _e_ = [
        0,
        "Tag_sexp"
    ], _f_ = [
        0,
        "Tag_t"
    ], _g_ = [
        0,
        "Tag_arg"
    ], _h_ = [
        0,
        "Of_list"
    ], _i_ = [
        0,
        "With_backtrace"
    ];
    function sexp_of_t(param) {
        switch(param[0]){
            case 0:
                var arg0_001 = param[1], res0_002 = caml_call1(Base_Sexp[5], arg0_001);
                return [
                    1,
                    [
                        0,
                        _a_,
                        [
                            0,
                            res0_002,
                            0
                        ]
                    ]
                ];
            case 1:
                var arg0_003 = param[1], res0_004 = caml_call1(Base_Import[136], arg0_003);
                return [
                    1,
                    [
                        0,
                        _b_,
                        [
                            0,
                            res0_004,
                            0
                        ]
                    ]
                ];
            case 2:
                var arg0_005 = param[1], res0_006 = caml_call1(Base_Import[198], arg0_005);
                return [
                    1,
                    [
                        0,
                        _c_,
                        [
                            0,
                            res0_006,
                            0
                        ]
                    ]
                ];
            case 3:
                var arg0_007 = param[1], res0_008 = caml_call1(Base_Sexp[5], arg0_007);
                return [
                    1,
                    [
                        0,
                        _d_,
                        [
                            0,
                            res0_008,
                            0
                        ]
                    ]
                ];
            case 4:
                var arg2_011 = param[3], arg1_010 = param[2], arg0_009 = param[1], res0_012 = caml_call1(Base_Import[136], arg0_009), res1_013 = caml_call1(Base_Sexp[5], arg1_010), res2_014 = caml_call2(Base_Import[146], Base_Source_code_position0[9], arg2_011);
                return [
                    1,
                    [
                        0,
                        _e_,
                        [
                            0,
                            res0_012,
                            [
                                0,
                                res1_013,
                                [
                                    0,
                                    res2_014,
                                    0
                                ]
                            ]
                        ]
                    ]
                ];
            case 5:
                var arg1_016 = param[2], arg0_015 = param[1], res0_017 = caml_call1(Base_Import[136], arg0_015), res1_018 = sexp_of_t(arg1_016);
                return [
                    1,
                    [
                        0,
                        _f_,
                        [
                            0,
                            res0_017,
                            [
                                0,
                                res1_018,
                                0
                            ]
                        ]
                    ]
                ];
            case 6:
                var arg2_021 = param[3], arg1_020 = param[2], arg0_019 = param[1], res0_022 = caml_call1(Base_Import[136], arg0_019), res1_023 = caml_call1(Base_Sexp[5], arg1_020), res2_024 = sexp_of_t(arg2_021);
                return [
                    1,
                    [
                        0,
                        _g_,
                        [
                            0,
                            res0_022,
                            [
                                0,
                                res1_023,
                                [
                                    0,
                                    res2_024,
                                    0
                                ]
                            ]
                        ]
                    ]
                ];
            case 7:
                var arg1_026 = param[2], arg0_025 = param[1], res0_027 = caml_call2(Base_Import[146], Base_Import[139], arg0_025), res1_028 = caml_call2(Base_Import[149], sexp_of_t, arg1_026);
                return [
                    1,
                    [
                        0,
                        _h_,
                        [
                            0,
                            res0_027,
                            [
                                0,
                                res1_028,
                                0
                            ]
                        ]
                    ]
                ];
            default:
                var arg1_030 = param[2], arg0_029 = param[1], res0_031 = sexp_of_t(arg0_029), res1_032 = caml_call1(Base_Import[136], arg1_030);
                return [
                    1,
                    [
                        0,
                        _i_,
                        [
                            0,
                            res0_031,
                            [
                                0,
                                res1_032,
                                0
                            ]
                        ]
                    ]
                ];
        }
    }
    function to_sexps_hum(t, ac) {
        switch(t[0]){
            case 0:
                return [
                    0,
                    sexp_of_t(t),
                    ac
                ];
            case 1:
                var string = t[1];
                return [
                    0,
                    [
                        0,
                        string
                    ],
                    ac
                ];
            case 2:
                var exn = t[1];
                return [
                    0,
                    caml_call1(Base_Exn[1], exn),
                    ac
                ];
            case 3:
                var sexp = t[1];
                return [
                    0,
                    sexp,
                    ac
                ];
            case 4:
                var here = t[3], sexp$0 = t[2], tag = t[1];
                if (here) var here$0 = here[1], _R_ = [
                    0,
                    caml_call1(Base_Source_code_position0[9], here$0),
                    0
                ];
                else var _R_ = 0;
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag
                            ],
                            [
                                0,
                                sexp$0,
                                _R_
                            ]
                        ]
                    ],
                    ac
                ];
            case 5:
                var t$0 = t[2], tag$0 = t[1];
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag$0
                            ],
                            to_sexps_hum(t$0, 0)
                        ]
                    ],
                    ac
                ];
            case 6:
                var t$1 = t[3], sexp$1 = t[2], tag$1 = t[1], body = [
                    0,
                    sexp$1,
                    to_sexps_hum(t$1, 0)
                ];
                return 0 === runtime.caml_ml_string_length(tag$1) ? [
                    0,
                    [
                        1,
                        body
                    ],
                    ac
                ] : [
                    0,
                    [
                        1,
                        [
                            0,
                            [
                                0,
                                tag$1
                            ],
                            body
                        ]
                    ],
                    ac
                ];
            case 7:
                var ts = t[2], _S_ = caml_call1(Base_List[63], ts);
                return caml_call3(Base_List[20], _S_, ac, function(ac, t) {
                    return to_sexps_hum(t, ac);
                });
            default:
                var backtrace = t[2], t$2 = t[1], _T_1 = caml_call1(Base_String0[22], backtrace), _U_ = [
                    0,
                    caml_call2(Base_Import[149], Base_Import[136], _T_1),
                    0
                ];
                return [
                    0,
                    [
                        1,
                        [
                            0,
                            to_sexp_hum(t$2),
                            _U_
                        ]
                    ],
                    ac
                ];
        }
    }
    function to_sexp_hum(t) {
        var sexps = to_sexps_hum(t, 0);
        if (sexps && !sexps[2]) {
            var sexp = sexps[1];
            return sexp;
        }
        return [
            1,
            sexps
        ];
    }
    function globalize_info(param) {
        return param;
    }
    function compute_info$0(counter, info, stack) {
        var info$0 = info, stack$0 = stack;
        for(;;){
            var match = info$0[1];
            if (typeof match === "number") {
                if (counter >= 50) return caml_trampoline_return(compute_message, [
                    0,
                    _j_,
                    stack$0
                ]);
                var counter$0 = counter + 1 | 0;
                return compute_message(counter$0, _j_, stack$0);
            }
            if (0 !== match[0]) {
                var message = match[1];
                if (counter >= 50) return caml_trampoline_return(compute_message, [
                    0,
                    message,
                    stack$0
                ]);
                var counter$1 = counter + 1 | 0;
                return compute_message(counter$1, message, stack$0);
            }
            var cons = match[1];
            info$0[1] = 0;
            var stack$1 = [
                0,
                [
                    0,
                    info$0
                ],
                stack$0
            ];
            switch(cons[0]){
                case 0:
                    var lazy_info = cons[1];
                    try {
                        var _P_ = caml_obj_tag(lazy_info);
                        a: if (250 === _P_) var info$1 = lazy_info[1];
                        else {
                            if (246 !== _P_ && 244 !== _P_) {
                                var info$1 = lazy_info;
                                break a;
                            }
                            var info$1 = caml_call1(CamlinternalLazy[2], lazy_info);
                        }
                    } catch (exn$0) {
                        var exn = caml_wrap_exception(exn$0), _O_ = [
                            0,
                            caml_call1(Base_Exn[1], exn)
                        ];
                        if (counter >= 50) return caml_trampoline_return(compute_message, [
                            0,
                            _O_,
                            stack$1
                        ]);
                        var counter$2 = counter + 1 | 0;
                        return compute_message(counter$2, _O_, stack$1);
                    }
                    info$0 = info$1;
                    stack$0 = stack$1;
                    break;
                case 1:
                    var infos = cons[1], _Q_ = 0;
                    if (counter >= 50) return caml_trampoline_return(compute_info_list, [
                        0,
                        infos,
                        _Q_,
                        stack$1
                    ]);
                    var counter$3 = counter + 1 | 0;
                    return compute_info_list(counter$3, infos, _Q_, stack$1);
                case 2:
                    var info$2 = cons[3], arg = cons[2], tag = cons[1], stack$2 = [
                        0,
                        [
                            1,
                            tag,
                            arg
                        ],
                        stack$1
                    ];
                    info$0 = info$2;
                    stack$0 = stack$2;
                    break;
                default:
                    var info$3 = cons[2], tag$0 = cons[1], stack$3 = [
                        0,
                        [
                            2,
                            tag$0
                        ],
                        stack$1
                    ];
                    info$0 = info$3;
                    stack$0 = stack$3;
            }
        }
    }
    function compute_info(info, stack) {
        return caml_trampoline(compute_info$0(0, info, stack));
    }
    function compute_info_list(counter, fwd_prefix, rev_suffix, stack) {
        if (fwd_prefix) {
            var fwd_prefix$0 = fwd_prefix[2], info = fwd_prefix[1], _M_ = [
                0,
                [
                    3,
                    fwd_prefix$0,
                    rev_suffix
                ],
                stack
            ];
            if (counter >= 50) return caml_trampoline_return(compute_info$0, [
                0,
                info,
                _M_
            ]);
            var counter$1 = counter + 1 | 0;
            return compute_info$0(counter$1, info, _M_);
        }
        var infos = caml_call3(Base_List[20], rev_suffix, 0, function(tail, message) {
            if (7 !== message[0]) return [
                0,
                message,
                tail
            ];
            var messages = message[2];
            return caml_call2(Base_Import[111], messages, tail);
        }), _N_ = [
            7,
            0,
            infos
        ];
        if (counter >= 50) return caml_trampoline_return(compute_message, [
            0,
            _N_,
            stack
        ]);
        var counter$0 = counter + 1 | 0;
        return compute_message(counter$0, _N_, stack);
    }
    function compute_message(counter, message, stack) {
        var message$0 = message, stack$0 = stack;
        for(;;){
            if (!stack$0) return message$0;
            var match = stack$0[1];
            switch(match[0]){
                case 0:
                    var stack$1 = stack$0[2], info = match[1];
                    info[1] = [
                        1,
                        message$0
                    ];
                    stack$0 = stack$1;
                    break;
                case 1:
                    var stack$2 = stack$0[2], arg = match[2], tag = match[1], message$1 = [
                        6,
                        tag,
                        arg,
                        message$0
                    ];
                    message$0 = message$1;
                    stack$0 = stack$2;
                    break;
                case 2:
                    var stack$3 = stack$0[2], tag$0 = match[1], message$2 = [
                        5,
                        tag$0,
                        message$0
                    ];
                    message$0 = message$2;
                    stack$0 = stack$3;
                    break;
                default:
                    var stack$4 = stack$0[2], rev_suffix = match[2], fwd_prefix = match[1], _L_ = [
                        0,
                        message$0,
                        rev_suffix
                    ];
                    if (counter >= 50) return caml_trampoline_return(compute_info_list, [
                        0,
                        fwd_prefix,
                        _L_,
                        stack$4
                    ]);
                    var counter$0 = counter + 1 | 0;
                    return compute_info_list(counter$0, fwd_prefix, _L_, stack$4);
            }
        }
    }
    function to_message(info) {
        return compute_info(info, 0);
    }
    function of_message(message) {
        return [
            0,
            [
                1,
                message
            ]
        ];
    }
    function of_cons(cons) {
        return [
            0,
            [
                0,
                cons
            ]
        ];
    }
    function of_lazy_cons(lazy_cons) {
        return of_cons([
            0,
            [
                246,
                function(_I_) {
                    var _J_ = caml_obj_tag(lazy_cons);
                    a: if (250 === _J_) var _K_ = lazy_cons[1];
                    else {
                        if (246 !== _J_ && 244 !== _J_) {
                            var _K_ = lazy_cons;
                            break a;
                        }
                        var _K_ = caml_call1(CamlinternalLazy[2], lazy_cons);
                    }
                    return of_cons(_K_);
                }
            ]
        ]);
    }
    function of_lazy_message(lazy_message) {
        return of_cons([
            0,
            [
                246,
                function(_F_) {
                    var _G_ = caml_obj_tag(lazy_message);
                    a: if (250 === _G_) var _H_ = lazy_message[1];
                    else {
                        if (246 !== _G_ && 244 !== _G_) {
                            var _H_ = lazy_message;
                            break a;
                        }
                        var _H_ = caml_call1(CamlinternalLazy[2], lazy_message);
                    }
                    return of_message(_H_);
                }
            ]
        ]);
    }
    function invariant(param) {
        return 0;
    }
    function sexp_of_t$0(t) {
        return to_sexp_hum(to_message(t));
    }
    function t_of_sexp(sexp) {
        return of_message([
            3,
            sexp
        ]);
    }
    function compare(t1, t2) {
        var _D_ = sexp_of_t$0(t2), _E_ = sexp_of_t$0(t1);
        return caml_call2(Base_Sexp[7], _E_, _D_);
    }
    function compare_local(t1, t2) {
        return compare(t1, t2);
    }
    function equal(t1, t2) {
        var _B_ = sexp_of_t$0(t2), _C_ = sexp_of_t$0(t1);
        return caml_call2(Base_Sexp[6], _C_, _B_);
    }
    function equal_local(t1, t2) {
        return equal(t1, t2);
    }
    function hash_fold_t(state, t) {
        var _A_ = sexp_of_t$0(t);
        return caml_call2(Base_Sexp[2], state, _A_);
    }
    function hash(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t, t);
    }
    function to_string_hum(t) {
        var message = to_message(t);
        if (1 === message[0]) {
            var s = message[1];
            return s;
        }
        var _z_ = to_sexp_hum(message);
        return caml_call2(Base_Sexp[16], 0, _z_);
    }
    function to_string_mach(t) {
        var _y_ = sexp_of_t$0(t);
        return caml_call1(Base_Sexp[17], _y_);
    }
    function of_lazy(l) {
        return of_lazy_message([
            246,
            function(_v_) {
                var _w_ = caml_obj_tag(l);
                a: if (250 === _w_) var _x_ = l[1];
                else {
                    if (246 !== _w_ && 244 !== _w_) {
                        var _x_ = l;
                        break a;
                    }
                    var _x_ = caml_call1(CamlinternalLazy[2], l);
                }
                return [
                    1,
                    _x_
                ];
            }
        ]);
    }
    function of_lazy_sexp(l) {
        return of_lazy_message([
            246,
            function(_s_) {
                var _t_ = caml_obj_tag(l);
                a: if (250 === _t_) var _u_ = l[1];
                else {
                    if (246 !== _t_ && 244 !== _t_) {
                        var _u_ = l;
                        break a;
                    }
                    var _u_ = caml_call1(CamlinternalLazy[2], l);
                }
                return [
                    3,
                    _u_
                ];
            }
        ]);
    }
    function of_lazy_t(lazy_info) {
        return of_cons([
            0,
            lazy_info
        ]);
    }
    function of_string(message) {
        return of_message([
            1,
            message
        ]);
    }
    function createf(format) {
        return caml_call2(Base_Printf[4], of_string, format);
    }
    function of_thunk(f) {
        return of_lazy_message([
            246,
            function(param) {
                return [
                    1,
                    caml_call1(f, 0)
                ];
            }
        ]);
    }
    function create(here, strict, tag, x, sexp_of_x) {
        return strict ? of_message([
            4,
            tag,
            caml_call1(sexp_of_x, x),
            here
        ]) : of_lazy_message([
            246,
            function(param) {
                return [
                    4,
                    tag,
                    caml_call1(sexp_of_x, x),
                    here
                ];
            }
        ]);
    }
    function create_s(sexp) {
        return of_message([
            3,
            sexp
        ]);
    }
    function tag(t, tag) {
        return of_cons([
            3,
            tag,
            t
        ]);
    }
    function tag_s_lazy(t, tag) {
        return of_lazy_cons([
            246,
            function(_p_) {
                var _q_ = caml_obj_tag(tag);
                a: if (250 === _q_) var _r_ = tag[1];
                else {
                    if (246 !== _q_ && 244 !== _q_) {
                        var _r_ = tag;
                        break a;
                    }
                    var _r_ = caml_call1(CamlinternalLazy[2], tag);
                }
                return [
                    2,
                    cst,
                    _r_,
                    t
                ];
            }
        ]);
    }
    function tag_s(t, tag) {
        return of_cons([
            2,
            cst$0,
            tag,
            t
        ]);
    }
    function tag_arg(t, tag, x, sexp_of_x) {
        return of_lazy_cons([
            246,
            function(param) {
                return [
                    2,
                    tag,
                    caml_call1(sexp_of_x, x),
                    t
                ];
            }
        ]);
    }
    function of_list(ts) {
        return of_cons([
            1,
            ts
        ]);
    }
    var Exn = [
        248,
        "Base__Info.Exn",
        runtime.caml_fresh_oo_id(0)
    ], _k_ = [
        0,
        "src/info.ml",
        261,
        6
    ];
    caml_call4(Sexplib0_Sexp_conv[72][1], 0, 0, Exn, function(param) {
        if (param[1] !== Exn) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _k_
        ], 1);
        var t = param[2];
        return sexp_of_t$0(t);
    });
    function to_exn(info) {
        var _n_ = info[1];
        a: {
            if (typeof _n_ !== "number" && 1 === _n_[0]) {
                var _o_ = 1;
                break a;
            }
            var _o_ = 0;
        }
        if (!_o_) return [
            0,
            Exn,
            info
        ];
        var match = to_message(info);
        if (2 !== match[0]) return [
            0,
            Exn,
            info
        ];
        var exn = match[1];
        return exn;
    }
    function of_exn(backtrace, exn) {
        if (backtrace) {
            var match = backtrace[1];
            if (typeof match === "number") var _m_ = [
                0,
                caml_call1(Stdlib_Printexc[6], 0)
            ];
            else var s = match[2], _m_ = [
                0,
                s
            ];
            var backtrace$0 = _m_;
        } else var backtrace$0 = 0;
        if (exn[1] === Exn) {
            var t = exn[2];
            if (!backtrace$0) return t;
            var backtrace$1 = backtrace$0[1];
            return of_lazy_message([
                246,
                function(param) {
                    return [
                        8,
                        to_message(t),
                        backtrace$1
                    ];
                }
            ]);
        }
        if (!backtrace$0) return of_message([
            2,
            exn
        ]);
        var backtrace$2 = backtrace$0[1];
        return of_lazy_message([
            246,
            function(param) {
                return [
                    8,
                    [
                        3,
                        caml_call1(Base_Exn[1], exn)
                    ],
                    backtrace$2
                ];
            }
        ]);
    }
    function pp(ppf, t) {
        var _l_ = to_string_hum(t);
        return caml_call2(Stdlib_Format[13], ppf, _l_);
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], Base_Info = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize_info,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        t_sexp_grammar,
        invariant,
        to_string_hum,
        to_string_mach,
        of_string,
        of_lazy,
        of_lazy_sexp,
        of_thunk,
        of_lazy_t,
        create,
        create_s,
        createf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        of_list,
        of_exn,
        to_exn,
        pp$0,
        [
            0,
            sexp_of_t,
            to_message,
            of_message
        ]
    ];
    runtime.caml_register_global(30, Base_Info, "Base__Info");
    return;
})(globalThis);
//# 11890 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), t_sexp_grammar = [
        0,
        "Error.t"
    ], module_name = "Base.Error", Base_Info = global_data.Base__Info, Base_Pretty_printer = global_data.Base__Pretty_printer, compare = Base_Info[1], compare_local = Base_Info[2], equal = Base_Info[3], equal_local = Base_Info[4], globalize = Base_Info[5], hash_fold_t = Base_Info[6], hash = Base_Info[7], t_of_sexp = Base_Info[8], sexp_of_t = Base_Info[9], invariant = Base_Info[11], to_string_hum = Base_Info[12], to_string_mach = Base_Info[13], of_string = Base_Info[14], of_lazy = Base_Info[15], of_lazy_sexp = Base_Info[16], of_thunk = Base_Info[17], of_lazy_t = Base_Info[18], create = Base_Info[19], create_s = Base_Info[20], createf = Base_Info[21], tag = Base_Info[22], tag_s = Base_Info[23], tag_s_lazy = Base_Info[24], tag_arg = Base_Info[25], of_list = Base_Info[26], of_exn = Base_Info[27], to_exn = Base_Info[28], pp = Base_Info[29], Internal_repr = Base_Info[30];
    function raise(t) {
        throw caml_maybe_attach_backtrace(caml_call1(to_exn, t), 1);
    }
    function raise_s(sexp) {
        return raise(caml_call1(create_s, sexp));
    }
    function to_info(t) {
        return t;
    }
    function of_info(t) {
        return t;
    }
    var include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], Base_Error = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        invariant,
        to_string_hum,
        to_string_mach,
        of_string,
        of_lazy,
        of_lazy_sexp,
        of_thunk,
        of_lazy_t,
        create,
        create_s,
        createf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        of_list,
        of_exn,
        to_exn,
        pp$0,
        Internal_repr,
        raise,
        raise_s,
        to_info,
        of_info
    ];
    runtime.caml_register_global(4, Base_Error, "Base__Error");
    return;
})(globalThis);
//# 12057 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_List = global_data.Base__List, Base_Error = global_data.Base__Error, Base_With_return = global_data.Base__With_return, Assert_failure = global_data.Assert_failure, Base_Result = global_data.Base__Result, Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Applicative = global_data.Base__Applicative;
    function compare_local(cmp_a, a_007, b_008) {
        return caml_call4(Base_Result[5], cmp_a, Base_Error[2], a_007, b_008);
    }
    function compare(cmp_a, a_001, b_002) {
        return caml_call4(Base_Result[4], cmp_a, Base_Error[1], a_001, b_002);
    }
    function equal_local(cmp_a, a_019, b_020) {
        return caml_call4(Base_Result[7], cmp_a, Base_Error[4], a_019, b_020);
    }
    function equal(cmp_a, a_013, b_014) {
        return caml_call4(Base_Result[6], cmp_a, Base_Error[3], a_013, b_014);
    }
    function globalize(globalize_a_026, x_027) {
        return caml_call3(Base_Result[9], globalize_a_026, Base_Error[5], x_027);
    }
    function hash_fold_t(hash_fold_a, hsv, arg) {
        return caml_call4(Base_Result[8], hash_fold_a, Base_Error[6], hsv, arg);
    }
    function t_of_sexp(of_a_030, x_032) {
        return caml_call3(Base_Result[1], of_a_030, Base_Error[8], x_032);
    }
    function sexp_of_t(of_a_033, x_034) {
        return caml_call3(Base_Result[2], of_a_033, Base_Error[9], x_034);
    }
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call2(Base_Result[3], a_sexp_grammar, Base_Error[10]);
    }
    var symbol_bind = Base_Result[10], symbol_map = Base_Result[11], bind = Base_Result[14], ignore_m = Base_Result[17], join = Base_Result[16], map = Base_Result[33], return$0 = Base_Result[15];
    function invariant(invariant_a, t) {
        if (0 === t[0]) {
            var a = t[1];
            return caml_call1(invariant_a, a);
        }
        var error = t[1];
        return caml_call1(Base_Error[11], error);
    }
    function map2(a, b, f) {
        if (0 === a[0]) {
            var x = a[1];
            if (0 === b[0]) {
                var y = b[1];
                return [
                    0,
                    caml_call2(f, x, y)
                ];
            }
            var e = b;
        } else {
            var e1 = a[1];
            if (0 !== b[0]) {
                var e2 = b[1];
                return [
                    1,
                    caml_call1(Base_Error[26], [
                        0,
                        e1,
                        [
                            0,
                            e2,
                            0
                        ]
                    ])
                ];
            }
            var e = a;
        }
        return e;
    }
    var map$0 = [
        0,
        -198771759,
        map
    ], For_applicative = caml_call1(Base_Applicative[16], [
        0,
        return$0,
        map2,
        map$0
    ]), symbol = For_applicative[6], symbol$0 = For_applicative[5], symbol$1 = For_applicative[4], apply = For_applicative[8], both = For_applicative[3], map3 = For_applicative[10], include = Base_Result[13], symbol_bind$0 = include[1], symbol_map$0 = include[2], Open_on_rhs = [
        0
    ], ok = Base_Result[26], is_ok = Base_Result[24], is_error = Base_Result[25], _a_ = [
        0,
        3553398
    ];
    function try_with(opt, f) {
        var backtrace = opt ? opt[1] : 0;
        try {
            var _n_ = [
                0,
                caml_call1(f, 0)
            ];
            return _n_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), _m_ = backtrace ? _a_ : 0;
            return [
                1,
                caml_call2(Base_Error[27], _m_, exn)
            ];
        }
    }
    function try_with_join(backtrace, f) {
        return caml_call1(join, try_with(backtrace, f));
    }
    function ok_exn(param) {
        if (0 === param[0]) {
            var x = param[1];
            return x;
        }
        var err = param[1];
        return caml_call1(Base_Error[31], err);
    }
    function of_exn(backtrace, exn) {
        return [
            1,
            caml_call2(Base_Error[27], backtrace, exn)
        ];
    }
    function of_exn_result(backtrace, z) {
        if (0 === z[0]) return z;
        var exn = z[1];
        return of_exn(backtrace, exn);
    }
    var of_option = Base_Result[30], cst_unimplemented = "unimplemented", _b_ = [
        0,
        "src/or_error.ml",
        192,
        21
    ];
    function error(here, strict, message, a, sexp_of_a) {
        return [
            1,
            caml_call5(Base_Error[19], here, strict, message, a, sexp_of_a)
        ];
    }
    function error_s(sexp) {
        return [
            1,
            caml_call1(Base_Error[20], sexp)
        ];
    }
    function error_string(message) {
        return [
            1,
            caml_call1(Base_Error[14], message)
        ];
    }
    function errorf(format) {
        return caml_call2(Base_Printf[4], error_string, format);
    }
    function tag(t, tag) {
        var _k_ = Base_Error[22];
        return caml_call2(Base_Result[34], t, function(_l_) {
            return caml_call2(_k_, _l_, tag);
        });
    }
    function tag_s(t, tag) {
        var _i_ = Base_Error[23];
        return caml_call2(Base_Result[34], t, function(_j_) {
            return caml_call2(_i_, _j_, tag);
        });
    }
    function tag_s_lazy(t, tag) {
        var _g_ = Base_Error[24];
        return caml_call2(Base_Result[34], t, function(_h_) {
            return caml_call2(_g_, _h_, tag);
        });
    }
    function tag_arg(t, message, a, sexp_of_a) {
        return caml_call2(Base_Result[34], t, function(e) {
            return caml_call4(Base_Error[25], e, message, a, sexp_of_a);
        });
    }
    function unimplemented(s) {
        return error(0, 0, cst_unimplemented, s, Base_Import[136]);
    }
    function combine_internal(list, on_ok, on_error) {
        var match = caml_call1(Base_Result[36], list);
        if (0 === match[0]) {
            var x = match[1];
            return [
                0,
                caml_call1(on_ok, x)
            ];
        }
        var errs = match[1];
        return [
            1,
            caml_call1(on_error, errs)
        ];
    }
    function ignore_unit_list(param) {
        return 0;
    }
    function error_of_list_if_necessary(list) {
        if (list && !list[2]) {
            var e = list[1];
            return e;
        }
        return caml_call1(Base_Error[26], list);
    }
    function all(list) {
        return combine_internal(list, function(_f_) {
            return _f_;
        }, error_of_list_if_necessary);
    }
    function all_unit(list) {
        return combine_internal(list, ignore_unit_list, error_of_list_if_necessary);
    }
    function combine_errors(list) {
        return combine_internal(list, function(_e_) {
            return _e_;
        }, Base_Error[26]);
    }
    function combine_errors_unit(list) {
        return combine_internal(list, ignore_unit_list, Base_Error[26]);
    }
    function filter_ok_at_least_one(l) {
        var match = caml_call2(Base_List[16], l, Base_Result[38]), errs = match[2], ok = match[1];
        return ok ? [
            0,
            ok
        ] : [
            1,
            caml_call1(Base_Error[26], errs)
        ];
    }
    function find_ok(l) {
        var match = caml_call2(Base_List[28], l, Base_Result[26]);
        if (match) {
            var x = match[1];
            return [
                0,
                x
            ];
        }
        var _d_ = caml_call2(Base_List[53], l, function(param) {
            if (0 === param[0]) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _b_
            ], 1);
            var err = param[1];
            return err;
        });
        return [
            1,
            caml_call1(Base_Error[26], _d_)
        ];
    }
    function find_map_ok(l, f) {
        return caml_call1(Base_With_return[1], function(param) {
            var _c_ = caml_call2(Base_List[53], l, function(elt) {
                var x = caml_call1(f, elt);
                if (0 === x[0]) return caml_call1(param, x);
                var err = x[1];
                return err;
            });
            return [
                1,
                caml_call1(Base_Error[26], _c_)
            ];
        });
    }
    var map$1 = Base_Result[33], iter = Base_Result[31], iter_error = Base_Result[32], Base_Or_error = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        both,
        symbol$1,
        symbol$0,
        symbol,
        apply,
        map2,
        map3,
        For_applicative[13],
        invariant,
        symbol_bind,
        symbol_map,
        Base_Result[13],
        bind,
        return$0,
        join,
        ignore_m,
        all,
        all_unit,
        [
            0,
            return$0,
            symbol_bind$0,
            symbol_map$0,
            [
                0,
                return$0,
                bind,
                map,
                both,
                Open_on_rhs
            ]
        ],
        is_ok,
        is_error,
        try_with,
        try_with_join,
        ok,
        ok_exn,
        of_exn,
        of_exn_result,
        of_option,
        error,
        error_s,
        error_string,
        errorf,
        tag,
        tag_s,
        tag_s_lazy,
        tag_arg,
        unimplemented,
        map$1,
        iter,
        iter_error,
        combine_errors,
        combine_errors_unit,
        filter_ok_at_least_one,
        find_ok,
        find_map_ok
    ];
    runtime.caml_register_global(11, Base_Or_error, "Base__Or_error");
    return;
})(globalThis);
//# 12381 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Neg = "Neg", cst_Pos = "Pos", cst_Zero = "Zero", cst_neg = "neg", cst_pos = "pos", cst_zero = "zero", caml_int_compare = runtime.caml_int_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_003 = "sign0.ml.t", t_sexp_grammar = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Neg,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Zero,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Pos,
                                0
                            ]
                        ],
                        0
                    ]
                ]
            ]
        ]
    ], all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                0
            ]
        ]
    ], module_name = "Base.Sign", Base_Import = global_data.Base__Import, Base_Poly0 = global_data.Base__Poly0, Base_Hash = global_data.Base__Hash, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, _a_ = [
        0,
        cst_Neg
    ], _b_ = [
        0,
        cst_Zero
    ], _c_ = [
        0,
        cst_Pos
    ];
    function t_of_sexp(sexp_004) {
        a: {
            if (0 === sexp_004[0]) {
                var _f_ = sexp_004[1];
                b: if (_f_ !== cst_Neg) {
                    c: if (_f_ !== cst_Pos) {
                        if (_f_ !== cst_Zero) {
                            if (_f_ === cst_neg) break b;
                            if (_f_ === cst_pos) break c;
                            if (_f_ !== cst_zero) break a;
                        }
                        return 1;
                    }
                    return 2;
                }
                return 0;
            }
            var _g_ = sexp_004[1];
            if (!_g_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_003, sexp_004);
            var _h_ = _g_[1];
            if (0 !== _h_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_003, sexp_004);
            var _i_ = _h_[1];
            b: if (_i_ !== cst_Neg) {
                c: if (_i_ !== cst_Pos) {
                    if (_i_ !== cst_Zero) {
                        if (_i_ === cst_neg) break b;
                        if (_i_ === cst_pos) break c;
                        if (_i_ !== cst_zero) break a;
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_003, sexp_004);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_003, sexp_004);
    }
    function sexp_of_t(param) {
        switch(param){
            case 0:
                return _a_;
            case 1:
                return _b_;
            default:
                return _c_;
        }
    }
    var compare_local = caml_int_compare;
    function compare(a, b) {
        return caml_int_compare(a, b);
    }
    function hash_fold_t(hsv, arg) {
        switch(arg){
            case 0:
                var _e_ = 0;
                break;
            case 1:
                var _e_ = 1;
                break;
            default:
                var _e_ = 2;
        }
        return caml_call2(Base_Hash[3], hsv, _e_);
    }
    function symbol(x, y) {
        return x < y ? 1 : 0;
    }
    function symbol$0(x, y) {
        return x <= y ? 1 : 0;
    }
    function symbol$1(x, y) {
        return x !== y ? 1 : 0;
    }
    function symbol$2(x, y) {
        return x === y ? 1 : 0;
    }
    function symbol$3(x, y) {
        return y < x ? 1 : 0;
    }
    function symbol$4(x, y) {
        return y <= x ? 1 : 0;
    }
    function ascending(x, y) {
        return caml_call2(Base_Poly0[1], x, y);
    }
    function descending(x, y) {
        return caml_call2(Base_Poly0[2], x, y);
    }
    var compare$0 = caml_int_compare;
    function equal(x, y) {
        return x === y ? 1 : 0;
    }
    function equal_local(x, y) {
        return x === y ? 1 : 0;
    }
    function max(x, y) {
        return y <= x ? x : y;
    }
    function min(x, y) {
        return x <= y ? x : y;
    }
    var Replace_polymorphic_compare = [
        0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        ascending,
        descending,
        compare$0,
        equal,
        equal_local,
        max,
        min
    ];
    function of_string(s) {
        return t_of_sexp(caml_call1(Base_Import[136], s));
    }
    function to_string(t) {
        var _d_ = sexp_of_t(t);
        return caml_call1(Base_Import[160], _d_);
    }
    function to_int(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0;
            default:
                return 1;
        }
    }
    function of_int(n) {
        return 0 <= n ? 0 === n ? 1 : 2 : 0;
    }
    var Base_Sign0 = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare_local,
        compare,
        hash_fold_t,
        all,
        Replace_polymorphic_compare,
        of_string,
        to_string,
        to_int,
        to_int,
        module_name,
        of_int
    ];
    runtime.caml_register_global(23, Base_Sign0, "Base__Sign0");
    return;
})(globalThis);
//# 12550 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Comparable_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Comparable_intf, "Base__Comparable_intf");
    return;
})(globalThis);
//# 12561 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_clamp_requires_min_max$1 = "clamp requires [min <= max]", cst_max$1 = "max", cst_min$1 = "min", cst_src_comparable_ml = "src/comparable.ml", caml_compare = runtime.caml_compare, caml_equal = runtime.caml_equal, caml_greaterthan = runtime.caml_greaterthan, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Comparator = global_data.Base__Comparator, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Poly0 = global_data.Base__Poly0, Base_Sign0 = global_data.Base__Sign0, _a_ = [
        0,
        cst_src_comparable_ml,
        47,
        4
    ], cst_max = cst_max$1, cst_min = cst_min$1, cst_clamp_requires_min_max = cst_clamp_requires_min_max$1, _b_ = [
        0,
        cst_src_comparable_ml,
        135,
        4
    ], cst_max$0 = cst_max$1, cst_min$0 = cst_min$1, cst_clamp_requires_min_max$0 = cst_clamp_requires_min_max$1;
    function geq(cmp, a, b) {
        return 0 <= caml_call2(cmp, a, b) ? 1 : 0;
    }
    function leq(cmp, a, b) {
        return caml_call2(cmp, a, b) <= 0 ? 1 : 0;
    }
    function equal(cmp, a, b) {
        return 0 === caml_call2(cmp, a, b) ? 1 : 0;
    }
    function min(cmp, t$0, t) {
        return leq(cmp, t$0, t) ? t$0 : t;
    }
    function max(cmp, t$0, t) {
        return geq(cmp, t$0, t) ? t$0 : t;
    }
    function Infix(T) {
        function symbol(a, b) {
            var cmp = T[1];
            return 0 < caml_call2(cmp, a, b) ? 1 : 0;
        }
        function symbol$0(a, b) {
            var cmp = T[1];
            return caml_call2(cmp, a, b) < 0 ? 1 : 0;
        }
        function symbol$1(a, b) {
            return geq(T[1], a, b);
        }
        function symbol$2(a, b) {
            return leq(T[1], a, b);
        }
        function symbol$3(a, b) {
            return equal(T[1], a, b);
        }
        function symbol$4(a, b) {
            var cmp = T[1];
            return 0 !== caml_call2(cmp, a, b) ? 1 : 0;
        }
        return [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol,
            symbol$0,
            symbol$4
        ];
    }
    function Comparisons(T) {
        var include = Infix(T), symbol = include[1], symbol$0 = include[2], symbol$1 = include[3], symbol$2 = include[4], symbol$3 = include[5], symbol$4 = include[6], compare = T[1];
        function min$0(t$0, t) {
            return min(compare, t$0, t);
        }
        function max$0(t$0, t) {
            return max(compare, t$0, t);
        }
        return [
            0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$1,
            compare,
            min$0,
            max$0
        ];
    }
    function Make_using_comparator(T) {
        var sexp_of_t = T[1], comparator = T[2], compare = comparator[1], Replace_polymorphic_compare = Comparisons([
            0,
            compare
        ]), symbol = Replace_polymorphic_compare[1], symbol$0 = Replace_polymorphic_compare[2], symbol$1 = Replace_polymorphic_compare[3], symbol$2 = Replace_polymorphic_compare[4], symbol$3 = Replace_polymorphic_compare[5], symbol$4 = Replace_polymorphic_compare[6], equal = Replace_polymorphic_compare[7], compare$0 = Replace_polymorphic_compare[8], min = Replace_polymorphic_compare[9], max = Replace_polymorphic_compare[10];
        function descending(t$0, t) {
            return caml_call2(compare$0, t, t$0);
        }
        function between(t, low, high) {
            var _r_ = caml_call2(symbol$0, low, t);
            return _r_ ? caml_call2(symbol$0, t, high) : _r_;
        }
        function clamp_unchecked(t, min, max) {
            return caml_call2(symbol$3, t, min) ? min : caml_call2(symbol$0, t, max) ? t : max;
        }
        function clamp_exn(t, min, max) {
            if (caml_call2(symbol$0, min, max)) return clamp_unchecked(t, min, max);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _b_
            ], 1);
        }
        function clamp(t, min, max) {
            if (!caml_call2(symbol$2, min, max)) return [
                0,
                clamp_unchecked(t, min, max)
            ];
            var _o_ = [
                0,
                [
                    0,
                    cst_max$0,
                    caml_call1(sexp_of_t, max)
                ],
                0
            ], _p_ = [
                0,
                [
                    0,
                    cst_min$0,
                    caml_call1(sexp_of_t, min)
                ],
                _o_
            ], _q_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max$0, _p_);
            return caml_call1(Base_Or_error[39], _q_);
        }
        return [
            0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal,
            compare$0,
            min,
            max,
            compare$0,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator
        ];
    }
    function Make(T) {
        var sexp_of_t = T[2], include = caml_call1(Base_Comparator[7], T), comparator = include[1];
        return Make_using_comparator([
            0,
            sexp_of_t,
            comparator
        ]);
    }
    function Inherit(C, T) {
        var sexp_of_t = T[1];
        function compare(t$0, t) {
            var _m_ = caml_call1(T[2], t), _n_ = caml_call1(T[2], t$0);
            return caml_call2(C[1], _n_, _m_);
        }
        return Make([
            0,
            compare,
            sexp_of_t
        ]);
    }
    function lexicographic(cmps, x, y) {
        var param = cmps;
        for(;;){
            if (!param) return 0;
            var cmps$0 = param[2], cmp = param[1], res = caml_call2(cmp, x, y);
            if (0 !== res) return res;
            param = cmps$0;
        }
    }
    function lift(cmp, f, x, y) {
        var _l_ = caml_call1(f, y);
        return caml_call2(cmp, caml_call1(f, x), _l_);
    }
    function reverse(cmp, x, y) {
        return caml_call2(cmp, y, x);
    }
    function compare_reversed(cmp, x, y) {
        return caml_call2(cmp, y, x);
    }
    var Base_Comparable = [
        0,
        lexicographic,
        lift,
        reverse,
        compare_reversed,
        equal,
        max,
        min,
        Infix,
        Comparisons,
        Inherit,
        Make,
        Make_using_comparator,
        function(T) {
            var sexp_of_t = T[1], ascending = Base_Poly0[1], descending = Base_Poly0[2], min = Base_Poly0[3], max = Base_Poly0[4];
            function between(t, low, high) {
                var _j_ = caml_lessequal(low, t), _k_ = _j_ ? caml_lessequal(t, high) : _j_;
                return _k_;
            }
            function clamp_unchecked(t, min, max) {
                return caml_lessthan(t, min) ? min : caml_lessequal(t, max) ? t : max;
            }
            function clamp_exn(t, min, max) {
                if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
            }
            function clamp(t, min, max) {
                if (!caml_greaterthan(min, max)) return [
                    0,
                    clamp_unchecked(t, min, max)
                ];
                var _g_ = [
                    0,
                    [
                        0,
                        cst_max,
                        caml_call1(T[1], max)
                    ],
                    0
                ], _h_ = [
                    0,
                    [
                        0,
                        cst_min,
                        caml_call1(T[1], min)
                    ],
                    _g_
                ], _i_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _h_);
                return caml_call1(Base_Or_error[39], _i_);
            }
            var include = caml_call1(Base_Comparator[7], [
                0,
                caml_compare,
                sexp_of_t
            ]), comparator = include[1];
            return [
                0,
                runtime.caml_greaterequal,
                caml_lessequal,
                caml_equal,
                caml_greaterthan,
                caml_lessthan,
                runtime.caml_notequal,
                caml_equal,
                caml_compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator
            ];
        },
        function(_c_) {
            var _d_ = _c_[3], _e_ = _c_[1];
            function is_positive(t) {
                return 0 < caml_call2(_e_, t, _d_) ? 1 : 0;
            }
            function is_non_negative(t) {
                return 0 <= caml_call2(_e_, t, _d_) ? 1 : 0;
            }
            function is_negative(t) {
                return caml_call2(_e_, t, _d_) < 0 ? 1 : 0;
            }
            function is_non_positive(t) {
                return caml_call2(_e_, t, _d_) <= 0 ? 1 : 0;
            }
            function sign(t) {
                var _f_ = caml_call2(_e_, t, _d_);
                return caml_call1(Base_Sign0[14], _f_);
            }
            return [
                0,
                is_positive,
                is_non_negative,
                is_negative,
                is_non_positive,
                sign
            ];
        }
    ];
    runtime.caml_register_global(14, Base_Comparable, "Base__Comparable");
    return;
})(globalThis);
//# 12830 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import;
    function equal(a, b) {
        var _b_ = a === b ? 1 : 0;
        if (_b_) var _c_ = _b_;
        else {
            var _d_ = a[1] === b[1] ? 1 : 0;
            if (_d_) var _e_ = a[2] === b[2] ? 1 : 0, _c_ = _e_ ? a[3] === b[3] ? 1 : 0 : _e_;
            else var _c_ = _d_;
        }
        return _c_;
    }
    var hash_param = Base_Import[85][105][30], hash = Base_Import[85][105][28], _a_ = [
        0,
        "_"
    ], poly = [
        0,
        hash,
        runtime.caml_compare,
        function(param) {
            return _a_;
        }
    ];
    function of_key(Key) {
        return [
            0,
            Key[3],
            Key[1],
            Key[2]
        ];
    }
    function to_key(param) {
        var sexp_of_t = param[3], compare = param[2], hash = param[1];
        return [
            0,
            compare,
            sexp_of_t,
            hash
        ];
    }
    var Hashable = [
        0,
        equal,
        hash_param,
        hash,
        poly,
        of_key,
        to_key
    ], equal$0 = Hashable[1], hash_param$0 = Hashable[2], hash$0 = Hashable[3], poly$0 = Hashable[4], of_key$0 = Hashable[5], to_key$0 = Hashable[6], Base_Hashable_intf = [
        0,
        Hashable,
        equal$0,
        hash_param$0,
        hash$0,
        poly$0,
        of_key$0,
        to_key$0
    ];
    runtime.caml_register_global(2, Base_Hashable_intf, "Base__Hashable_intf");
    return;
})(globalThis);
//# 12879 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Hashable_intf = global_data.Base__Hashable_intf, equal = Base_Hashable_intf[2], hash_param = Base_Hashable_intf[3], hash = Base_Hashable_intf[4], poly = Base_Hashable_intf[5], of_key = Base_Hashable_intf[6], to_key = Base_Hashable_intf[7], Base_Hashable = [
        0,
        equal,
        poly,
        of_key,
        to_key,
        hash_param,
        hash
    ];
    runtime.caml_register_global(1, Base_Hashable, "Base__Hashable");
    return;
})(globalThis);
//# 12908 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Identifiable_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Identifiable_intf, "Base__Identifiable_intf");
    return;
})(globalThis);
//# 12919 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Comparable = global_data.Base__Comparable, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Identifiable = [
        0,
        function(T) {
            var hash_fold_t = T[2], hash = T[3], t_of_sexp = T[4], sexp_of_t = T[5], of_string = T[6], to_string = T[7], _b_ = caml_call1(Base_Comparable[11], [
                0,
                T[1],
                T[5]
            ]), symbol = _b_[1], symbol$0 = _b_[2], symbol$1 = _b_[3], symbol$2 = _b_[4], symbol$3 = _b_[5], symbol$4 = _b_[6], equal = _b_[7], compare = _b_[8], min = _b_[9], max = _b_[10], ascending = _b_[11], descending = _b_[12], between = _b_[13], clamp_exn = _b_[14], clamp = _b_[15], comparator = _b_[16], include = caml_call1(Base_Pretty_printer[2], [
                0,
                T[8],
                T[7]
            ]), pp = include[1], hashable = [
                0,
                hash,
                compare,
                sexp_of_t
            ];
            return [
                0,
                hash_fold_t,
                hash,
                t_of_sexp,
                sexp_of_t,
                of_string,
                to_string,
                symbol,
                symbol$0,
                symbol$1,
                symbol$2,
                symbol$3,
                symbol$4,
                equal,
                compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator,
                pp,
                hashable
            ];
        },
        function(T) {
            var hash_fold_t = T[2], hash = T[3], t_of_sexp = T[4], sexp_of_t = T[5], of_string = T[6], to_string = T[7], _a_ = caml_call1(Base_Comparable[12], [
                0,
                T[5],
                T[9]
            ]), symbol = _a_[1], symbol$0 = _a_[2], symbol$1 = _a_[3], symbol$2 = _a_[4], symbol$3 = _a_[5], symbol$4 = _a_[6], equal = _a_[7], compare = _a_[8], min = _a_[9], max = _a_[10], ascending = _a_[11], descending = _a_[12], between = _a_[13], clamp_exn = _a_[14], clamp = _a_[15], comparator = _a_[16], include = caml_call1(Base_Pretty_printer[2], [
                0,
                T[8],
                T[7]
            ]), pp = include[1], hashable = [
                0,
                hash,
                compare,
                sexp_of_t
            ];
            return [
                0,
                hash_fold_t,
                hash,
                t_of_sexp,
                sexp_of_t,
                of_string,
                to_string,
                symbol,
                symbol$0,
                symbol$1,
                symbol$2,
                symbol$3,
                symbol$4,
                equal,
                compare,
                min,
                max,
                ascending,
                descending,
                between,
                clamp_exn,
                clamp,
                comparator,
                pp,
                hashable
            ];
        }
    ];
    runtime.caml_register_global(2, Base_Identifiable, "Base__Identifiable");
    return;
})(globalThis);
//# 13049 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$0 = "()";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = cst$0, all = [
        0,
        0,
        0
    ], module_name = "Base.Unit", Base_Import = global_data.Base__Import, Base_Identifiable = global_data.Base__Identifiable, globalize = Base_Import[290], hash_fold_t = Base_Import[210], func = Base_Import[224];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[158], sexp_of_t = Base_Import[134], t_sexp_grammar = Base_Import[180], cst_Base_Unit_of_string_expect = "Base.Unit.of_string: () expected";
    function compare(_c_, param) {
        return 0;
    }
    function compare_local(_b_, param) {
        return 0;
    }
    function equal_local(_a_, param) {
        return 1;
    }
    function of_string(param) {
        return param !== cst$0 ? caml_call1(Base_Import[124], cst_Base_Unit_of_string_expect) : 0;
    }
    function to_string(param) {
        return cst;
    }
    var include = caml_call1(Base_Identifiable[1], [
        0,
        compare,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        module_name
    ]), hash_fold_t$0 = include[1], hash$0 = include[2], t_of_sexp$0 = include[3], sexp_of_t$0 = include[4], of_string$0 = include[5], to_string$0 = include[6], symbol = include[7], symbol$0 = include[8], symbol$1 = include[9], symbol$2 = include[10], symbol$3 = include[11], symbol$4 = include[12], equal = include[13], compare$0 = include[14], min = include[15], max = include[16], ascending = include[17], descending = include[18], between = include[19], clamp_exn = include[20], clamp = include[21], comparator = include[22], pp = include[23], hashable = include[24];
    function invariant(param) {
        return 0;
    }
    var Base_Unit = [
        0,
        all,
        globalize,
        t_sexp_grammar,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare$0,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        equal_local,
        compare_local,
        invariant
    ];
    runtime.caml_register_global(7, Base_Unit, "Base__Unit");
    return;
})(globalThis);
//# 13161 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib, Base_Error = global_data.Base__Error, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common0, get_pos_len_exn = Base_Ordered_collection_common[1], check_pos_len_exn = Base_Ordered_collection_common[2], Private = Base_Ordered_collection_common[3];
    function get_pos_len(pos, len, param, total_length) {
        try {
            var _a_ = [
                0,
                caml_call4(get_pos_len_exn, pos, len, 0, total_length)
            ];
            return _a_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Stdlib[6]) throw caml_maybe_attach_backtrace(exn, 0);
            var s = exn[2];
            return [
                1,
                caml_call1(Base_Error[14], s)
            ];
        }
    }
    var Base_Ordered_collection_common$0 = [
        0,
        get_pos_len_exn,
        check_pos_len_exn,
        Private,
        get_pos_len
    ];
    runtime.caml_register_global(3, Base_Ordered_collection_common$0, "Base__Ordered_collection_common");
    return;
})(globalThis);
//# 13210 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common;
    function find_first_satisfying(pos, len, t, get, length, pred) {
        var _e_ = caml_call1(length, t), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _e_), len$0 = match[2], pos$0 = match[1], _f_ = caml_call2(Base_Import[91], pos$0, len$0), hi$0 = caml_call2(Base_Import[93], _f_, 1), lo$1 = pos$0, hi = hi$0;
        for(;;){
            if (8 >= caml_call2(Base_Import[93], hi, lo$1)) break;
            var _c_ = caml_call2(Base_Import[93], hi, lo$1), _d_ = caml_call2(Base_Import[95], _c_, 2), mid = caml_call2(Base_Import[91], lo$1, _d_);
            if (caml_call1(pred, caml_call2(get, t, mid))) hi = mid;
            else {
                var lo$2 = caml_call2(Base_Import[91], mid, 1);
                lo$1 = lo$2;
            }
        }
        var lo = lo$1;
        for(;;){
            if (hi < lo) return 0;
            if (caml_call1(pred, caml_call2(get, t, lo))) return [
                0,
                lo
            ];
            var lo$0 = caml_call2(Base_Import[91], lo, 1);
            lo = lo$0;
        }
    }
    function find_last_satisfying(pos, len, t, pred, get, length) {
        var _a_ = caml_call1(length, t), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _a_), len$0 = match[2], pos$0 = match[1];
        if (0 === len$0) return 0;
        var match$0 = find_first_satisfying([
            0,
            pos$0
        ], [
            0,
            len$0
        ], t, get, length, function(x) {
            return 1 - caml_call1(pred, x);
        });
        if (match$0) {
            var i = match$0[1];
            return i === pos$0 ? 0 : [
                0,
                caml_call2(Base_Import[93], i, 1)
            ];
        }
        var _b_ = caml_call2(Base_Import[91], pos$0, len$0);
        return [
            0,
            caml_call2(Base_Import[93], _b_, 1)
        ];
    }
    function binary_search(pos, len, t, length, get, compare, how, v) {
        if (-839473056 <= how) return 200870407 <= how ? 926943384 <= how ? find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 <= caml_call2(compare, x, v) ? 1 : 0;
        }) : find_last_satisfying(pos, len, t, function(x) {
            return caml_call2(compare, x, v) < 0 ? 1 : 0;
        }, get, length) : -253007807 <= how ? find_last_satisfying(pos, len, t, function(x) {
            return caml_call2(compare, x, v) <= 0 ? 1 : 0;
        }, get, length) : find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 < caml_call2(compare, x, v) ? 1 : 0;
        });
        if (-1055410545 <= how) {
            var match = find_last_satisfying(pos, len, t, function(x) {
                return caml_call2(compare, x, v) <= 0 ? 1 : 0;
            }, get, length);
            if (match) {
                var x = match[1];
                if (0 === caml_call2(compare, caml_call2(get, t, x), v)) return [
                    0,
                    x
                ];
            }
            return 0;
        }
        var match$0 = find_first_satisfying(pos, len, t, get, length, function(x) {
            return 0 <= caml_call2(compare, x, v) ? 1 : 0;
        });
        if (match$0) {
            var x$0 = match$0[1];
            if (0 === caml_call2(compare, caml_call2(get, t, x$0), v)) return [
                0,
                x$0
            ];
        }
        return 0;
    }
    function binary_search_segmented(pos, len, t, length, get, segment_of, how) {
        function is_left(x) {
            return 847852583 <= caml_call1(segment_of, x) ? 1 : 0;
        }
        function is_right(x) {
            return 1 - is_left(x);
        }
        return 125585502 <= how ? find_last_satisfying(pos, len, t, is_left, get, length) : find_first_satisfying(pos, len, t, get, length, is_right);
    }
    var Base_Binary_search = [
        0,
        binary_search,
        binary_search_segmented
    ];
    runtime.caml_register_global(2, Base_Binary_search, "Base__Binary_search");
    return;
})(globalThis);
//# 13368 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, all = [
        0,
        200870407,
        [
            0,
            -253007807,
            [
                0,
                -1055410545,
                [
                    0,
                    -1056898635,
                    [
                        0,
                        926943384,
                        [
                            0,
                            -839473056,
                            0
                        ]
                    ]
                ]
            ]
        ]
    ], all$0 = [
        0,
        125585502,
        [
            0,
            -63348021,
            0
        ]
    ], Which_target_by_key = [
        0,
        all
    ], Which_target_by_segment = [
        0,
        all$0
    ], Base_Binary_searchable_intf = [
        0,
        Which_target_by_key,
        Which_target_by_segment
    ];
    runtime.caml_register_global(2, Base_Binary_searchable_intf, "Base__Binary_searchable_intf");
    return;
})(globalThis);
//# 13391 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Base_Binary_search = global_data.Base__Binary_search;
    function Make_gen(T) {
        var get = T[1], length = T[2];
        function binary_search(pos, len, t, compare, how, v) {
            return caml_call8(Base_Binary_search[1], pos, len, t, length, get, compare, how, v);
        }
        function binary_search_segmented(pos, len, t, segment_of, how) {
            return caml_call7(Base_Binary_search[2], pos, len, t, length, get, segment_of, how);
        }
        return [
            0,
            ,
            ,
            binary_search,
            binary_search_segmented
        ];
    }
    var Base_Binary_searchable = [
        0,
        function(T) {
            var get = T[1], length = T[2], _b_ = Make_gen([
                0,
                get,
                length
            ]);
            return [
                0,
                _b_[3],
                _b_[4]
            ];
        },
        function(T) {
            var get = T[1], length = T[2], _a_ = Make_gen([
                0,
                get,
                length
            ]);
            return [
                0,
                _a_[3],
                _a_[4]
            ];
        }
    ];
    runtime.caml_register_global(1, Base_Binary_searchable, "Base__Binary_searchable");
    return;
})(globalThis);
//# 13454 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Blit_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Blit_intf, "Base__Blit_intf");
    return;
})(globalThis);
//# 13464 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_create_bytes = runtime.caml_create_bytes, caml_ml_bytes_length = runtime.caml_ml_bytes_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import0 = global_data.Base__Import0, Base_Sys0 = global_data.Base__Sys0, Base_Uchar0 = global_data.Base__Uchar0, Base_Int_conversions = global_data.Base__Int_conversions, Stdlib_BytesLabels = global_data.Stdlib__BytesLabels, Primitives = [
        0
    ], max_length = Base_Sys0[10], blit = Stdlib_BytesLabels[11], blit_string = Stdlib_BytesLabels[12], compare = Stdlib_BytesLabels[40], copy = Stdlib_BytesLabels[4], create = caml_create_bytes, set_uchar_utf_8 = Stdlib_BytesLabels[51], set_uchar_utf_16le = Stdlib_BytesLabels[57], set_uchar_utf_16be = Stdlib_BytesLabels[54];
    function set_utf_32_uchar(set_int32, bytes, idx, uchar) {
        var _o_ = caml_call1(Base_Uchar0[8], uchar), _p_ = caml_call1(Base_Int_conversions[3], _o_);
        caml_call1(caml_call2(set_int32, bytes, idx), _p_);
        return 4;
    }
    var _a_ = Stdlib_BytesLabels[83];
    function set_uchar_utf_32le(_l_, _m_, _n_) {
        return set_utf_32_uchar(_a_, _l_, _m_, _n_);
    }
    var _b_ = Stdlib_BytesLabels[82], cst_Bytes_create_local = "Bytes.create_local";
    function set_uchar_utf_32be(_i_, _j_, _k_) {
        return set_utf_32_uchar(_b_, _i_, _j_, _k_);
    }
    function create_local(len) {
        if (Base_Sys0[10] < len) caml_call1(Base_Import0[126], cst_Bytes_create_local);
        return runtime.Base_unsafe_create_local_bytes(len);
    }
    var fill = Stdlib_BytesLabels[10], make = Stdlib_BytesLabels[1];
    function map(t, f) {
        var l = caml_ml_bytes_length(t);
        if (0 === l) return t;
        var r = caml_create_bytes(l), _g_ = caml_call2(Base_Import0[93], l, 1), _f_ = 0;
        if (_g_ >= 0) {
            var i = _f_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call1(f, caml_bytes_unsafe_get(t, i)));
                var _h_ = i + 1 | 0;
                if (_g_ === i) break;
                i = _h_;
            }
        }
        return r;
    }
    function mapi(t, f) {
        var l = caml_ml_bytes_length(t);
        if (0 === l) return t;
        var r = caml_create_bytes(l), _d_ = caml_call2(Base_Import0[93], l, 1), _c_ = 0;
        if (_d_ >= 0) {
            var i = _c_;
            for(;;){
                caml_bytes_unsafe_set(r, i, caml_call2(f, i, caml_bytes_unsafe_get(t, i)));
                var _e_ = i + 1 | 0;
                if (_d_ === i) break;
                i = _e_;
            }
        }
        return r;
    }
    var sub = Stdlib_BytesLabels[7], to_string = Stdlib_BytesLabels[6], of_string = Stdlib_BytesLabels[5], Base_Bytes0 = [
        0,
        Primitives,
        max_length,
        blit,
        blit_string,
        compare,
        copy,
        create,
        set_uchar_utf_8,
        set_uchar_utf_16le,
        set_uchar_utf_16be,
        set_utf_32_uchar,
        set_uchar_utf_32le,
        set_uchar_utf_32be,
        create_local,
        fill,
        make,
        map,
        mapi,
        sub,
        to_string,
        of_string
    ];
    runtime.caml_register_global(6, Base_Bytes0, "Base__Bytes0");
    return;
})(globalThis);
//# 13594 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_string_of_bytes = runtime.caml_string_of_bytes;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common;
    function Make_gen(Src, Dst) {
        var unsafe_blit = Dst[3];
        function blit(src, src_pos, dst, dst_pos, len) {
            var _l_ = caml_call1(Src[1], src);
            caml_call3(Base_Ordered_collection_common[2], src_pos, len, _l_);
            var _m_ = caml_call1(Dst[1], dst);
            caml_call3(Base_Ordered_collection_common[2], dst_pos, len, _m_);
            var _n_ = 0 < len ? 1 : 0;
            return _n_ ? caml_call5(unsafe_blit, src, src_pos, dst, dst_pos, len) : _n_;
        }
        function blito(src, _j_, _i_, dst, opt, param) {
            var src_pos = _j_ ? _j_[1] : 0;
            if (_i_) var src_len = _i_[1];
            else var _k_ = caml_call1(Src[1], src), src_len = caml_call2(Base_Import[93], _k_, src_pos);
            var dst_pos = opt ? opt[1] : 0;
            return blit(src, src_pos, dst, dst_pos, src_len);
        }
        function sub(src, pos, len) {
            var _h_ = caml_call1(Src[1], src);
            caml_call3(Base_Ordered_collection_common[2], pos, len, _h_);
            var dst = caml_call2(Dst[2], len, src);
            if (0 < len) caml_call5(unsafe_blit, src, pos, dst, 0, len);
            return dst;
        }
        function subo(opt, len, src) {
            var pos = opt ? opt[1] : 0;
            if (len) var i = len[1], i$0 = i;
            else var _g_ = caml_call1(Src[1], src), i$0 = caml_call2(Base_Import[93], _g_, pos);
            return sub(src, pos, i$0);
        }
        return [
            0,
            unsafe_blit,
            blit,
            blito,
            sub,
            subo
        ];
    }
    function Make_to_string(T, To_bytes) {
        function sub(src, pos, len) {
            return caml_string_of_bytes(caml_call3(To_bytes[4], src, pos, len));
        }
        function subo(pos, len, src) {
            return caml_string_of_bytes(caml_call3(To_bytes[5], pos, len, src));
        }
        return [
            0,
            sub,
            subo
        ];
    }
    var Base_Blit = [
        0,
        function(Sequence) {
            function create_like(len, param) {
                return caml_call1(Sequence[2], len);
            }
            var length = Sequence[1], unsafe_blit = Sequence[3], include = Make_gen([
                0,
                length
            ], [
                0,
                length,
                create_like,
                unsafe_blit
            ]), unsafe_blit$0 = include[1], blit = include[2], blito = include[3], sub = include[4], subo = include[5];
            return [
                0,
                blit,
                blito,
                unsafe_blit$0,
                sub,
                subo
            ];
        },
        function(Src, Dst) {
            var length = Dst[1];
            function create_like(len, param) {
                return caml_call1(Dst[2], len);
            }
            var unsafe_blit = Dst[3], length$0 = Src[1], _f_ = Make_gen([
                0,
                length$0
            ], [
                0,
                length,
                create_like,
                unsafe_blit
            ]);
            return [
                0,
                _f_[2],
                _f_[3],
                _f_[1],
                _f_[4],
                _f_[5]
            ];
        },
        Make_to_string,
        function(_c_) {
            var _d_ = [
                0,
                _c_[2],
                _c_[1],
                _c_[3]
            ], _e_ = Make_gen([
                0,
                _d_[1]
            ], _d_);
            return [
                0,
                _e_[2],
                _e_[3],
                _e_[1],
                _e_[4],
                _e_[5]
            ];
        },
        function(_a_) {
            var _b_ = Make_gen([
                0,
                _a_[2]
            ], [
                0,
                _a_[2],
                _a_[1],
                _a_[3]
            ]);
            return [
                0,
                _b_[2],
                _b_[3],
                _b_[1],
                _b_[4],
                _b_[5]
            ];
        }
    ];
    runtime.caml_register_global(2, Base_Blit, "Base__Blit");
    return;
})(globalThis);
//# 13720 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_bool_ml = "src/bool.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), all = [
        0,
        0,
        [
            0,
            1,
            0
        ]
    ], module_name = "Base.Bool", Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Printf = global_data.Base__Printf, Base_Comparator = global_data.Base__Comparator, Base_Pretty_printer = global_data.Base__Pretty_printer, invalid_argf = Base_Printf[7], compare = Base_Import[225], globalize = Base_Import[281], hash_fold_t = Base_Import[207], func = Base_Import[221];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[159], sexp_of_t = Base_Import[135], t_sexp_grammar = Base_Import[181], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], _a_ = [
        0,
        [
            11,
            "Bool.of_string: expected true or false but got ",
            [
                2,
                0,
                0
            ]
        ],
        "Bool.of_string: expected true or false but got %s"
    ];
    function of_string(s) {
        return s !== "false" ? s !== "true" ? caml_call3(invalid_argf, _a_, s, 0) : 1 : 0;
    }
    var to_string = Base_Import[85][30], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], include$0 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name,
        to_string
    ]), pp = include$0[1], _b_ = [
        0,
        cst_src_bool_ml,
        59,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _k_ = caml_call2(Base_Import[105][2], low, t);
        return _k_ ? caml_call2(Base_Import[105][2], t, high) : _k_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[105][1], t, min) ? min : caml_call2(Base_Import[105][2], t, max) ? t : max;
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[105][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[105][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _h_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _i_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _h_
        ], _j_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _i_);
        return caml_call1(Base_Or_error[39], _j_);
    }
    function to_int(x) {
        return caml_call1(Base_Import[86], x);
    }
    function symbol(a, b) {
        var _f_ = to_int(b), _g_ = to_int(a), x = caml_call2(Base_Import[118], _g_, _f_);
        return x;
    }
    function symbol$0(a, b) {
        var _d_ = to_int(b), _e_ = to_int(a), x = caml_call2(Base_Import[116], _e_, _d_);
        return x;
    }
    var _c_ = [
        0,
        cst_src_bool_ml,
        86,
        9
    ];
    if (1 === to_int(1) && 0 === to_int(0)) {
        var include$1 = Base_Import[105], symbol$1 = include$1[1], symbol$2 = include$1[2], symbol$3 = include$1[3], symbol$4 = include$1[4], symbol$5 = include$1[5], symbol$6 = include$1[6], ascending = include$1[7], descending = include$1[8], compare$0 = include$1[9], compare_local = include$1[10], equal = include$1[11], equal_local = include$1[12], max = include$1[13], min = include$1[14], Base_Bool = [
            0,
            all,
            globalize,
            t_sexp_grammar,
            hash_fold_t,
            hash,
            t_of_sexp,
            sexp_of_t,
            of_string,
            to_string,
            symbol$6,
            symbol$2,
            symbol$4,
            symbol$5,
            symbol$1,
            symbol$3,
            equal,
            compare$0,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator,
            pp,
            hashable,
            compare_local,
            equal_local,
            invariant,
            to_int,
            [
                0,
                symbol$0,
                symbol
            ]
        ];
        runtime.caml_register_global(17, Base_Bool, "Base__Bool");
        return;
    }
    throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _c_
    ], 1);
})(globalThis);
//# 14248 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "", Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_Error = global_data.Base__Error, Base_Import = global_data.Base__Import, Base_Monad = global_data.Base__Monad, Base_Applicative = global_data.Base__Applicative, compare_local = Base_Import[265], compare = Base_Import[237], globalize = Base_Import[294], hash_fold_t = Base_Import[211], t_of_sexp = Base_Import[170], sexp_of_t = Base_Import[146], cst_Option_value_exn = "Option.value_exn", cst_Option_value_exn_None = "Option.value_exn None";
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[193], a_sexp_grammar);
    }
    function is_none(param) {
        return param ? 0 : 1;
    }
    function is_some(param) {
        return param ? 1 : 0;
    }
    function value_map(o, default$0, f) {
        if (!o) return default$0;
        var x = o[1];
        return caml_call1(f, x);
    }
    function iter(o, f) {
        if (!o) return 0;
        var a = o[1];
        return caml_call1(f, a);
    }
    function invariant(f, t) {
        return iter(t, f);
    }
    function call(x, f) {
        if (!f) return 0;
        var f$0 = f[1];
        return caml_call1(f$0, x);
    }
    function value(t, default$0) {
        if (!t) return default$0;
        var x = t[1];
        return x;
    }
    function value_exn(here, error, message, t) {
        if (t) {
            var x = t[1];
            return x;
        }
        if (here) {
            var p = here[1];
            if (error) var e = error[1], _c_ = caml_call2(Base_Import[147], Base_Error[9], Base_Source_code_position0[9]), _d_ = value(message, cst), _e_ = caml_call5(Base_Error[19], 0, 0, _d_, [
                0,
                e,
                p
            ], _c_);
            else if (message) var m = message[1], _e_ = caml_call5(Base_Error[19], 0, 0, m, p, Base_Source_code_position0[9]);
            else var _e_ = caml_call5(Base_Error[19], 0, 0, cst_Option_value_exn, p, Base_Source_code_position0[9]);
            var error$0 = _e_;
        } else if (error) {
            var e$0 = error[1];
            if (message) var m$0 = message[1], _f_ = caml_call2(Base_Error[22], e$0, m$0);
            else var _f_ = e$0;
            var error$0 = _f_;
        } else if (message) var m$1 = message[1], error$0 = caml_call1(Base_Error[14], m$1);
        else var error$0 = caml_call1(Base_Error[14], cst_Option_value_exn_None);
        return caml_call1(Base_Error[31], error$0);
    }
    function value_or_thunk(o, default$0) {
        if (!o) return caml_call1(default$0, 0);
        var x = o[1];
        return x;
    }
    function to_array(t) {
        if (!t) return [
            0
        ];
        var x = t[1];
        return [
            0,
            x
        ];
    }
    function to_list(t) {
        if (!t) return 0;
        var x = t[1];
        return [
            0,
            x,
            0
        ];
    }
    function for_all(t, f) {
        if (!t) return 1;
        var x = t[1];
        return caml_call1(f, x);
    }
    function exists(t, f) {
        if (!t) return 0;
        var x = t[1];
        return caml_call1(f, x);
    }
    function mem(t, a, equal) {
        if (!t) return 0;
        var a$0 = t[1];
        return caml_call2(equal, a, a$0);
    }
    function length(t) {
        return t ? 1 : 0;
    }
    function fold(t, init, f) {
        if (!t) return init;
        var x = t[1];
        return caml_call2(f, init, x);
    }
    function find(t, f) {
        if (!t) return 0;
        var x = t[1];
        return caml_call1(f, x) ? t : 0;
    }
    function find_map(t, f) {
        if (!t) return 0;
        var a = t[1];
        return caml_call1(f, a);
    }
    function equal(f, t$0, t) {
        if (t$0) {
            if (t) {
                var x = t[1], x$0 = t$0[1];
                return caml_call2(f, x$0, x);
            }
        } else if (!t) return 1;
        return 0;
    }
    function equal_local(f, t$0, t) {
        if (t$0) {
            if (t) {
                var x = t[1], x$0 = t$0[1];
                return caml_call2(f, x$0, x);
            }
        } else if (!t) return 1;
        return 0;
    }
    function some(x) {
        return [
            0,
            x
        ];
    }
    function first_some(x, y) {
        return x ? x : y;
    }
    function some_if(cond, x) {
        return cond ? [
            0,
            x
        ] : 0;
    }
    function merge(a, b, f) {
        if (a) {
            if (b) {
                var b$0 = b[1], a$0 = a[1];
                return [
                    0,
                    caml_call2(f, a$0, b$0)
                ];
            }
            var x = a;
        } else var x = b;
        return x;
    }
    function filter(t, f) {
        if (t) {
            var v = t[1];
            if (caml_call1(f, v)) return t;
        }
        return 0;
    }
    function try_with(f) {
        try {
            var x = caml_call1(f, 0);
        } catch (_b_) {
            return 0;
        }
        return [
            0,
            x
        ];
    }
    function try_with_join(f) {
        try {
            var x = caml_call1(f, 0);
            return x;
        } catch (_a_) {
            return 0;
        }
    }
    function return$0(x) {
        return [
            0,
            x
        ];
    }
    var map = [
        0,
        -198771759,
        function(t, f) {
            if (!t) return 0;
            var a = t[1];
            return [
                0,
                caml_call1(f, a)
            ];
        }
    ];
    function bind(o, f) {
        if (!o) return 0;
        var x = o[1];
        return caml_call1(f, x);
    }
    var include = caml_call1(Base_Monad[5], [
        0,
        bind,
        return$0,
        map
    ]), symbol_bind = include[1], Monad_infix = include[3], bind$0 = include[4], join = include[7], ignore_m = include[8], Let_syntax = include[11];
    function return$1(x) {
        return [
            0,
            x
        ];
    }
    var map$0 = [
        0,
        -198771759,
        include[6]
    ];
    function map2(x, y, f) {
        if (x && y) {
            var y$0 = y[1], x$0 = x[1];
            return [
                0,
                caml_call2(f, x$0, y$0)
            ];
        }
        return 0;
    }
    var include$0 = caml_call1(Base_Applicative[16], [
        0,
        return$1,
        map2,
        map$0
    ]), return$2 = include$0[1], map$1 = include$0[2], both = include$0[3], symbol = include$0[4], symbol$0 = include$0[5], symbol$1 = include$0[6], symbol_map = include$0[7], apply = include$0[8], map2$0 = include$0[9], map3 = include$0[10], all = include$0[11], all_unit = include$0[12], Applicative_infix = include$0[13], Base_Option = [
        0,
        compare,
        compare_local,
        globalize,
        hash_fold_t,
        t_sexp_grammar,
        equal,
        equal_local,
        invariant,
        t_of_sexp,
        sexp_of_t,
        both,
        symbol,
        symbol$0,
        symbol$1,
        apply,
        map2$0,
        map3,
        Applicative_infix,
        symbol_bind,
        symbol_map,
        Monad_infix,
        bind$0,
        return$2,
        map$1,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax,
        value,
        value_exn,
        value_map,
        value_or_thunk,
        fold,
        mem,
        length,
        iter,
        exists,
        for_all,
        find,
        find_map,
        to_list,
        to_array,
        call,
        merge,
        filter,
        try_with,
        try_with_join,
        some,
        first_some,
        some_if,
        is_none,
        is_some
    ];
    runtime.caml_register_global(8, Base_Option, "Base__Option");
    return;
})(globalThis);
//# 14549 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_Both$0 = "Both", cst_Left$0 = "Left", cst_Right$0 = "Right", cst_Sequence_nth$1 = "Sequence.nth", cst_both = "both", cst_left = "left", cst_right = "right", cst_state = "state", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), error_source_057 = "sequence.ml.Merge_with_duplicates_element.t", Base_List1 = global_data.Base__List1, Base_Import = global_data.Base__Import, CamlinternalLazy = global_data.CamlinternalLazy, Base_Result = global_data.Base__Result, Base_Container = global_data.Base__Container, Base_Bool = global_data.Base__Bool, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Hash = global_data.Base__Hash, Assert_failure = global_data.Assert_failure, Base_Array0 = global_data.Base__Array0, Base_Monad = global_data.Base__Monad, _a_ = [
        0,
        "Done"
    ], _b_ = [
        0,
        cst_state
    ], _c_ = [
        0,
        "Skip"
    ], _d_ = [
        0,
        cst_state
    ], _e_ = [
        0,
        "value"
    ], _f_ = [
        0,
        "Yield"
    ];
    function sexp_of_t(of_a_001, of_s_002, param) {
        if (typeof param === "number") return _a_;
        if (0 === param[0]) {
            var state_004 = param[1], arg_005 = caml_call1(of_s_002, state_004), bnds_003 = [
                0,
                [
                    1,
                    [
                        0,
                        _b_,
                        [
                            0,
                            arg_005,
                            0
                        ]
                    ]
                ],
                0
            ];
            return [
                1,
                [
                    0,
                    _c_,
                    bnds_003
                ]
            ];
        }
        var state_009 = param[2], value_007 = param[1], arg_010 = caml_call1(of_s_002, state_009), bnds_006 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_010,
                        0
                    ]
                ]
            ],
            0
        ], arg_008 = caml_call1(of_a_001, value_007), bnds_006$0 = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        arg_008,
                        0
                    ]
                ]
            ],
            bnds_006
        ];
        return [
            1,
            [
                0,
                _f_,
                bnds_006$0
            ]
        ];
    }
    var Step = [
        0,
        sexp_of_t
    ], T = [
        0
    ], _h_ = [
        0,
        0,
        0
    ], _i_ = [
        0,
        "src/sequence.ml",
        304,
        14
    ];
    function globalize(_T_1, param) {
        var next = param[2], state = param[1];
        return [
            0,
            state,
            next
        ];
    }
    function view(t) {
        return t;
    }
    function next_step(param) {
        var f = param[2], s = param[1], match = caml_call1(f, s);
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var s$0 = match[1];
            return [
                0,
                [
                    0,
                    s$0,
                    f
                ]
            ];
        }
        var s$1 = match[2], a = match[1];
        return [
            1,
            a,
            [
                0,
                s$1,
                f
            ]
        ];
    }
    function delayed_fold_step(s, init, f, finish) {
        function loop(s, next, finish, f, acc) {
            var match = caml_call1(next, s);
            if (typeof match === "number") return caml_call1(finish, acc);
            if (0 === match[0]) {
                var s$0 = match[1];
                return caml_call3(f, acc, 0, function(_S_) {
                    return loop(s$0, next, finish, f, _S_);
                });
            }
            var s$1 = match[2], a = match[1];
            return caml_call3(f, acc, [
                0,
                a
            ], function(_R_) {
                return loop(s$1, next, finish, f, _R_);
            });
        }
        var next = s[2], s$0 = s[1];
        return loop(s$0, next, finish, f, init);
    }
    function unfold_step(init, f) {
        return [
            0,
            init,
            f
        ];
    }
    function unfold(init, f) {
        function f$0(s) {
            var match = caml_call1(f, s);
            if (!match) return 0;
            var match$0 = match[1], s$0 = match$0[2], a = match$0[1];
            return [
                1,
                a,
                s$0
            ];
        }
        return [
            0,
            init,
            f$0
        ];
    }
    function unfold_with(s, init, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                init,
                s$0
            ],
            function(param) {
                var s = param[2], seed = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            seed,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1], match$0 = caml_call2(f, seed, a);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var seed$0 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            seed$0,
                            s$1
                        ]
                    ];
                }
                var seed$1 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    a$0,
                    [
                        0,
                        seed$1,
                        s$1
                    ]
                ];
            }
        ];
    }
    function unfold_with_and_finish(s, init, running_step, inner_finished, finishing_step) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                -172306698,
                [
                    0,
                    init,
                    s$0
                ]
            ],
            function(state) {
                if (301075099 <= state[1]) {
                    var state$0 = state[2], match = caml_call1(finishing_step, state$0);
                    if (typeof match === "number") return 0;
                    if (0 === match[0]) {
                        var state$1 = match[1];
                        return [
                            0,
                            [
                                0,
                                301075099,
                                state$1
                            ]
                        ];
                    }
                    var state$2 = match[2], y = match[1];
                    return [
                        1,
                        y,
                        [
                            0,
                            301075099,
                            state$2
                        ]
                    ];
                }
                var match$0 = state[2], inner_state = match$0[2], state$3 = match$0[1], match$1 = caml_call1(next, inner_state);
                if (typeof match$1 === "number") return [
                    0,
                    [
                        0,
                        301075099,
                        caml_call1(inner_finished, state$3)
                    ]
                ];
                if (0 === match$1[0]) {
                    var inner_state$0 = match$1[1];
                    return [
                        0,
                        [
                            0,
                            -172306698,
                            [
                                0,
                                state$3,
                                inner_state$0
                            ]
                        ]
                    ];
                }
                var inner_state$1 = match$1[2], x = match$1[1], match$2 = caml_call2(running_step, state$3, x);
                if (typeof match$2 === "number") return 0;
                if (0 === match$2[0]) {
                    var state$4 = match$2[1];
                    return [
                        0,
                        [
                            0,
                            -172306698,
                            [
                                0,
                                state$4,
                                inner_state$1
                            ]
                        ]
                    ];
                }
                var state$5 = match$2[2], y$0 = match$2[1];
                return [
                    1,
                    y$0,
                    [
                        0,
                        -172306698,
                        [
                            0,
                            state$5,
                            inner_state$1
                        ]
                    ]
                ];
            }
        ];
    }
    function of_list(init) {
        function f(param) {
            if (!param) return 0;
            var l = param[2], x = param[1];
            return [
                1,
                x,
                l
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function fold(t, init, f) {
        var next = t[2], seed$2 = t[1], seed = seed$2, v = init;
        for(;;){
            var match = caml_call1(next, seed);
            if (typeof match === "number") return v;
            if (0 === match[0]) {
                var seed$0 = match[1];
                seed = seed$0;
            } else {
                var seed$1 = match[2], a = match[1], v$0 = caml_call2(f, v, a);
                seed = seed$1;
                v = v$0;
            }
        }
    }
    function to_list_rev(t) {
        return fold(t, 0, function(l, x) {
            return [
                0,
                x,
                l
            ];
        });
    }
    function to_list(param) {
        var next = param[2], s = param[1], s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) break;
            var s$1 = match[1];
            s$0 = s$1;
        }
        var s$2 = match[2], a = match[1], block = [
            0,
            a,
            24029
        ], dst = block, offset = 1, s$3 = s$2;
        for(;;){
            var match$0 = caml_call1(next, s$3);
            if (typeof match$0 === "number") {
                dst[1 + offset] = 0;
                return block;
            }
            if (0 === match$0[0]) {
                var s$4 = match$0[1];
                s$3 = s$4;
            } else {
                var s$5 = match$0[2], a$0 = match$0[1], dst$0 = [
                    0,
                    a$0,
                    24029
                ];
                dst[1 + offset] = dst$0;
                dst = dst$0;
                offset = 1;
                s$3 = s$5;
            }
        }
    }
    function sexp_of_t$0(sexp_of_a, t) {
        var _Q_ = to_list(t);
        return caml_call2(Base_Import[149], sexp_of_a, _Q_);
    }
    function range(_P_, _O_, opt, start_v, stop_v) {
        var stride = _P_ ? _P_[1] : 1, start = _O_ ? _O_[1] : 104758188, stop = opt ? opt[1] : -160346914, step = 104758188 <= stop ? 0 <= stride ? function(i) {
            return stop_v < i ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : function(i) {
            return i < stop_v ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : 0 <= stride ? function(i) {
            return stop_v <= i ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        } : function(i) {
            return i <= stop_v ? 0 : [
                1,
                i,
                caml_call2(Base_Import[91], i, stride)
            ];
        }, init = 104758188 <= start ? start_v : caml_call2(Base_Import[91], start_v, stride);
        return [
            0,
            init,
            step
        ];
    }
    function of_lazy(t_lazy) {
        function f(t_lazy) {
            var _N_ = caml_obj_tag(t_lazy);
            a: if (250 === _N_) var match = t_lazy[1];
            else {
                if (246 !== _N_ && 244 !== _N_) {
                    var match = t_lazy;
                    break a;
                }
                var match = caml_call1(CamlinternalLazy[2], t_lazy);
            }
            var next = match[2], s = match[1], match$0 = caml_call1(next, s);
            if (typeof match$0 === "number") return 0;
            if (0 === match$0[0]) {
                var s$0 = match$0[1], v = [
                    0,
                    s$0,
                    next
                ];
                return [
                    0,
                    v
                ];
            }
            var s$1 = match$0[2], x = match$0[1], v$0 = [
                0,
                s$1,
                next
            ];
            return [
                1,
                x,
                v$0
            ];
        }
        return [
            0,
            t_lazy,
            f
        ];
    }
    function _g_(t, f) {
        var next = t[2], seed = t[1];
        return [
            0,
            seed,
            function(seed) {
                var match = caml_call1(next, seed);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s = match[1];
                    return [
                        0,
                        s
                    ];
                }
                var s$0 = match[2], a = match[1];
                return [
                    1,
                    caml_call1(f, a),
                    s$0
                ];
            }
        ];
    }
    function mapi(t, f) {
        var next = t[2], s = t[1];
        return [
            0,
            [
                0,
                0,
                s
            ],
            function(param) {
                var s = param[2], i = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1], _M_ = [
                    0,
                    caml_call2(Base_Import[91], i, 1),
                    s$1
                ];
                return [
                    1,
                    caml_call2(f, i, a),
                    _M_
                ];
            }
        ];
    }
    function folding_map(t, init, f) {
        return unfold_with(t, init, function(acc, x) {
            var match = caml_call2(f, acc, x), x$0 = match[2], acc$0 = match[1];
            return [
                1,
                x$0,
                acc$0
            ];
        });
    }
    function folding_mapi(t, init, f) {
        return unfold_with(t, [
            0,
            0,
            init
        ], function(param, x) {
            var acc = param[2], i = param[1], match = caml_call3(f, i, acc, x), x$0 = match[2], acc$0 = match[1];
            return [
                1,
                x$0,
                [
                    0,
                    caml_call2(Base_Import[91], i, 1),
                    acc$0
                ]
            ];
        });
    }
    function filter(t, f) {
        var next = t[2], seed = t[1];
        return [
            0,
            seed,
            function(seed) {
                var match = caml_call1(next, seed);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s = match[1];
                    return [
                        0,
                        s
                    ];
                }
                var a = match[1], s$0 = match[2];
                if (caml_call1(f, a)) return [
                    1,
                    a,
                    s$0
                ];
                var s$1 = match[2];
                return [
                    0,
                    s$1
                ];
            }
        ];
    }
    function filteri(t, f) {
        var _L_ = Base_Import[127];
        return _g_(filter(mapi(t, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        }), _L_);
    }
    function length(t) {
        var next = t[2], seed = t[1], i = 0, s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return i;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                s = s$1;
            }
        }
    }
    function to_array(t) {
        var match = fold(t, _h_, function(param, x) {
            var i = param[2], l = param[1];
            return [
                0,
                [
                    0,
                    x,
                    l
                ],
                caml_call2(Base_Import[91], i, 1)
            ];
        }), len = match[2], l = match[1];
        if (!l) return [
            0
        ];
        var l$0 = l[2], x = l[1], a = caml_call2(Base_Array0[4], len, x), i$1 = caml_call2(Base_Import[93], len, 2), i = i$1, l$1 = l$0;
        for(;;){
            if (!l$1) {
                if (-1 === i) return a;
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _i_
                ], 1);
            }
            var l$2 = l$1[2], x$0 = l$1[1];
            runtime.caml_check_bound(a, i)[1 + i] = x$0;
            var i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            l$1 = l$2;
        }
    }
    function find(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (caml_call1(f, a)) return [
                    0,
                    a
                ];
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function find_map(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], a = match[1], some_b = caml_call1(f, a);
                if (some_b) return some_b;
                s = s$1;
            }
        }
    }
    function find_mapi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var s$1 = match[2], a = match[1], some_b = caml_call2(f, i, a);
                if (some_b) return some_b;
                var i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function for_all(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (!caml_call1(f, a)) return 0;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function for_alli(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (!caml_call2(f, i, a)) return 0;
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function exists(t, f) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var a = match[1];
                if (caml_call1(f, a)) return 1;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    function existsi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (caml_call2(f, i, a)) return 1;
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function iter(t, f) {
        var next = t[2], seed$2 = t[1], seed = seed$2;
        for(;;){
            var match = caml_call1(next, seed);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var seed$0 = match[1];
                seed = seed$0;
            } else {
                var seed$1 = match[2], a = match[1];
                caml_call1(f, a);
                seed = seed$1;
            }
        }
    }
    function is_empty(t) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 1;
            if (0 !== match[0]) return 0;
            var s$0 = match[1];
            s = s$0;
        }
    }
    function mem(t, a, equal) {
        var next = t[2], seed = t[1], s = seed;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) var s$0 = match[1];
            else {
                var b = match[1];
                if (caml_call2(equal, a, b)) return 1;
                var s$0 = match[2];
            }
            s = s$0;
        }
    }
    var empty = [
        0,
        0,
        function(param) {
            return 0;
        }
    ];
    function bind(t, f) {
        function f$0(param) {
            var rest = param[2], match = param[1], next = match[2], seed = match[1], match$0 = caml_call1(next, seed);
            if (typeof match$0 === "number") {
                var next$0 = rest[2], seed$0 = rest[1], match$1 = caml_call1(next$0, seed$0);
                if (typeof match$1 === "number") return 0;
                if (0 === match$1[0]) {
                    var s = match$1[1];
                    return [
                        0,
                        [
                            0,
                            empty,
                            [
                                0,
                                s,
                                next$0
                            ]
                        ]
                    ];
                }
                var s$0 = match$1[2], a = match$1[1];
                return [
                    0,
                    [
                        0,
                        caml_call1(f, a),
                        [
                            0,
                            s$0,
                            next$0
                        ]
                    ]
                ];
            }
            if (0 === match$0[0]) {
                var s$1 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            s$1,
                            next
                        ],
                        rest
                    ]
                ];
            }
            var s$2 = match$0[2], a$0 = match$0[1];
            return [
                1,
                a$0,
                [
                    0,
                    [
                        0,
                        s$2,
                        next
                    ],
                    rest
                ]
            ];
        }
        var init = [
            0,
            empty,
            t
        ];
        return [
            0,
            init,
            f$0
        ];
    }
    function return$0(x) {
        function f(param) {
            if (!param) return 0;
            var x = param[1];
            return [
                1,
                x,
                0
            ];
        }
        var init = [
            0,
            x
        ];
        return [
            0,
            init,
            f
        ];
    }
    var map = [
        0,
        -198771759,
        _g_
    ], include = caml_call1(Base_Monad[1], [
        0,
        bind,
        return$0,
        map
    ]), symbol_bind = include[1], symbol_map = include[2], Monad_infix = include[3], bind$0 = include[4], return$1 = include[5], map$0 = include[6], join = include[7], ignore_m = include[8], all = include[9], all_unit = include[10], Let_syntax = include[11], cst_Sequence_nth = cst_Sequence_nth$1, cst_Sequence_nth$0 = cst_Sequence_nth$1, _j_ = [
        0,
        cst_Left$0
    ], _k_ = [
        0,
        cst_Right$0
    ], _l_ = [
        0,
        cst_Both$0
    ], cst_Both = cst_Both$0, cst_Right = cst_Right$0, cst_Left = cst_Left$0, cst_hd_exn = "hd_exn", cst_Sequence_tl_exn = "Sequence.tl_exn", cst_Sequence_chunks_exn = "Sequence.chunks_exn", cst_Sequence_find_exn = "Sequence.find_exn", cst_Sequence_reduce_exn = "Sequence.reduce_exn", cst_Sequence_sub = "Sequence.sub", cst_Sequence_take = "Sequence.take", cst_Sequence_drop = "Sequence.drop";
    function nth(s, n) {
        if (0 > n) return 0;
        var next = s[2], s$3 = s[1], i = n, s$0 = s$3;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1];
                if (0 === i) return [
                    0,
                    a
                ];
                var i$0 = caml_call2(Base_Import[93], i, 1);
                i = i$0;
                s$0 = s$2;
            }
        }
    }
    function nth_exn(s, n) {
        if (0 > n) return caml_call1(Base_Import[126], cst_Sequence_nth$0);
        var match = nth(s, n);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_nth);
        var x = match[1];
        return x;
    }
    function compare_local(cmp_a, cmp_b, a_023, b_024) {
        if (a_023 === b_024) return 0;
        switch(a_023[0]){
            case 0:
                var a_025 = a_023[1];
                if (0 !== b_024[0]) return -1;
                var b_026 = b_024[1];
                return caml_call2(cmp_a, a_025, b_026);
            case 1:
                var a_027 = a_023[1];
                switch(b_024[0]){
                    case 0:
                        break;
                    case 1:
                        var b_028 = b_024[1];
                        return caml_call2(cmp_b, a_027, b_028);
                    default:
                        return -1;
                }
                break;
            default:
                var a_031 = a_023[2], a_029 = a_023[1];
                switch(b_024[0]){
                    case 0:
                        break;
                    case 1:
                        return 1;
                    default:
                        var b_032 = b_024[2], b_030 = b_024[1], n = caml_call2(cmp_a, a_029, b_030);
                        return 0 === n ? caml_call2(cmp_b, a_031, b_032) : n;
                }
        }
        return 1;
    }
    function compare(cmp_a, cmp_b, a_013, b_014) {
        if (a_013 === b_014) return 0;
        switch(a_013[0]){
            case 0:
                var a_015 = a_013[1];
                if (0 !== b_014[0]) return -1;
                var b_016 = b_014[1];
                return caml_call2(cmp_a, a_015, b_016);
            case 1:
                var a_017 = a_013[1];
                switch(b_014[0]){
                    case 0:
                        break;
                    case 1:
                        var b_018 = b_014[1];
                        return caml_call2(cmp_b, a_017, b_018);
                    default:
                        return -1;
                }
                break;
            default:
                var a_021 = a_013[2], a_019 = a_013[1];
                switch(b_014[0]){
                    case 0:
                        break;
                    case 1:
                        return 1;
                    default:
                        var b_022 = b_014[2], b_020 = b_014[1], n = caml_call2(cmp_a, a_019, b_020);
                        return 0 === n ? caml_call2(cmp_b, a_021, b_022) : n;
                }
        }
        return 1;
    }
    function equal_local(cmp_a, cmp_b, a_043, b_044) {
        if (a_043 === b_044) return 1;
        switch(a_043[0]){
            case 0:
                var a_045 = a_043[1];
                if (0 !== b_044[0]) return 0;
                var b_046 = b_044[1];
                return caml_call2(cmp_a, a_045, b_046);
            case 1:
                var a_047 = a_043[1];
                switch(b_044[0]){
                    case 0:
                        break;
                    case 1:
                        var b_048 = b_044[1];
                        return caml_call2(cmp_b, a_047, b_048);
                    default:
                        return 0;
                }
                break;
            default:
                var a_051 = a_043[2], a_049 = a_043[1];
                switch(b_044[0]){
                    case 0:
                        break;
                    case 1:
                        return 0;
                    default:
                        var b_052 = b_044[2], b_050 = b_044[1], _K_ = caml_call2(cmp_a, a_049, b_050);
                        return _K_ ? caml_call2(cmp_b, a_051, b_052) : _K_;
                }
        }
        return 0;
    }
    function equal(cmp_a, cmp_b, a_033, b_034) {
        if (a_033 === b_034) return 1;
        switch(a_033[0]){
            case 0:
                var a_035 = a_033[1];
                if (0 !== b_034[0]) return 0;
                var b_036 = b_034[1];
                return caml_call2(cmp_a, a_035, b_036);
            case 1:
                var a_037 = a_033[1];
                switch(b_034[0]){
                    case 0:
                        break;
                    case 1:
                        var b_038 = b_034[1];
                        return caml_call2(cmp_b, a_037, b_038);
                    default:
                        return 0;
                }
                break;
            default:
                var a_041 = a_033[2], a_039 = a_033[1];
                switch(b_034[0]){
                    case 0:
                        break;
                    case 1:
                        return 0;
                    default:
                        var b_042 = b_034[2], b_040 = b_034[1], _J_ = caml_call2(cmp_a, a_039, b_040);
                        return _J_ ? caml_call2(cmp_b, a_041, b_042) : _J_;
                }
        }
        return 0;
    }
    function hash_fold_t(hash_fold_a, hash_fold_b, hsv, arg) {
        switch(arg[0]){
            case 0:
                var a0 = arg[1], hsv$0 = caml_call2(Base_Hash[3], hsv, 0);
                return caml_call2(hash_fold_a, hsv$0, a0);
            case 1:
                var a0$0 = arg[1], hsv$1 = caml_call2(Base_Hash[3], hsv, 1);
                return caml_call2(hash_fold_b, hsv$1, a0$0);
            default:
                var a1 = arg[2], a0$1 = arg[1], hsv$2 = caml_call2(Base_Hash[3], hsv, 2), hsv$3 = caml_call2(hash_fold_a, hsv$2, a0$1);
                return caml_call2(hash_fold_b, hsv$3, a1);
        }
    }
    function t_of_sexp(of_a_053, of_b_054, sexp_059) {
        a: {
            if (0 === sexp_059[0]) {
                var _F_ = sexp_059[1];
                b: if (_F_ !== cst_Both$0) {
                    c: if (_F_ !== cst_Left$0) {
                        if (_F_ !== cst_Right$0) {
                            if (_F_ === cst_both) break b;
                            if (_F_ === cst_left) break c;
                            if (_F_ !== cst_right) break a;
                        }
                        return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[9], error_source_057, sexp_059);
            }
            var _G_ = sexp_059[1];
            if (!_G_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_057, sexp_059);
            var _H_ = _G_[1];
            if (0 !== _H_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_057, sexp_059);
            var tag_060 = _H_[1];
            b: if (tag_060 !== cst_Both$0) {
                c: if (tag_060 !== cst_Left$0) {
                    if (tag_060 !== cst_Right$0) {
                        if (tag_060 === cst_both) break b;
                        if (tag_060 === cst_left) break c;
                        if (tag_060 !== cst_right) break a;
                    }
                    var sexp_args_066 = _G_[2];
                    if (sexp_args_066 && !sexp_args_066[2]) {
                        var arg0_067 = sexp_args_066[1], res0_068 = caml_call1(of_b_054, arg0_067);
                        return [
                            1,
                            res0_068
                        ];
                    }
                    return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
                }
                var sexp_args_061 = _G_[2];
                if (sexp_args_061 && !sexp_args_061[2]) {
                    var arg0_062 = sexp_args_061[1], res0_063 = caml_call1(of_a_053, arg0_062);
                    return [
                        0,
                        res0_063
                    ];
                }
                return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
            }
            var sexp_args_071 = _G_[2];
            if (sexp_args_071) {
                var _I_ = sexp_args_071[2];
                if (_I_ && !_I_[2]) {
                    var arg1_073 = _I_[1], arg0_072 = sexp_args_071[1], res0_074 = caml_call1(of_a_053, arg0_072), res1_075 = caml_call1(of_b_054, arg1_073);
                    return [
                        2,
                        res0_074,
                        res1_075
                    ];
                }
            }
            return caml_call3(Sexplib0_Sexp_conv_error[8], error_source_057, tag_060, sexp_059);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_057, sexp_059);
    }
    function sexp_of_t$1(of_a_078, of_b_079, param) {
        switch(param[0]){
            case 0:
                var arg0_080 = param[1], res0_081 = caml_call1(of_a_078, arg0_080);
                return [
                    1,
                    [
                        0,
                        _j_,
                        [
                            0,
                            res0_081,
                            0
                        ]
                    ]
                ];
            case 1:
                var arg0_082 = param[1], res0_083 = caml_call1(of_b_079, arg0_082);
                return [
                    1,
                    [
                        0,
                        _k_,
                        [
                            0,
                            res0_083,
                            0
                        ]
                    ]
                ];
            default:
                var arg1_085 = param[2], arg0_084 = param[1], res0_086 = caml_call1(of_a_078, arg0_084), res1_087 = caml_call1(of_b_079, arg1_085);
                return [
                    1,
                    [
                        0,
                        _l_,
                        [
                            0,
                            res0_086,
                            [
                                0,
                                res1_087,
                                0
                            ]
                        ]
                    ]
                ];
        }
    }
    function t_sexp_grammar(a_sexp_grammar, b_sexp_grammar) {
        return [
            3,
            [
                0,
                2,
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Left,
                            [
                                0,
                                [
                                    0,
                                    a_sexp_grammar,
                                    0
                                ]
                            ]
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Right,
                                [
                                    0,
                                    [
                                        0,
                                        b_sexp_grammar,
                                        0
                                    ]
                                ]
                            ]
                        ],
                        [
                            0,
                            [
                                1,
                                [
                                    0,
                                    cst_Both,
                                    [
                                        0,
                                        [
                                            0,
                                            a_sexp_grammar,
                                            [
                                                0,
                                                b_sexp_grammar,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ],
                            0
                        ]
                    ]
                ]
            ]
        ];
    }
    function merge_with_duplicates(_E_, param, compare) {
        var next2 = param[2], s2 = param[1], next1 = _E_[2], s1 = _E_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        [
                            1,
                            b
                        ],
                        [
                            0,
                            0,
                            [
                                0,
                                s2$0
                            ]
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var s2$2 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof s2$2 === "number") return [
                    1,
                    [
                        0,
                        a
                    ],
                    [
                        0,
                        [
                            0,
                            s1$1
                        ],
                        0
                    ]
                ];
                if (0 !== s2$2[0]) {
                    var s2$3 = s2$2[2], b$0 = s2$2[1], comparison = caml_call2(compare, a, b$0);
                    return 0 <= comparison ? 0 === comparison ? [
                        1,
                        [
                            2,
                            a,
                            b$0
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        [
                            1,
                            b$0
                        ],
                        [
                            0,
                            s1,
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        [
                            0,
                            a
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            s2$2
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function merge_deduped_and_sorted(s1, s2, compare) {
        return caml_call2(map$0, merge_with_duplicates(s1, s2, compare), function(param) {
            var x = param[1];
            return x;
        });
    }
    function merge_sorted(_D_, param, compare) {
        var next2 = param[2], s2 = param[1], next1 = _D_[2], s1 = _D_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        b,
                        [
                            0,
                            0,
                            [
                                0,
                                s2$0
                            ]
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var s2$2 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof s2$2 === "number") return [
                    1,
                    a,
                    [
                        0,
                        [
                            0,
                            s1$1
                        ],
                        0
                    ]
                ];
                if (0 !== s2$2[0]) {
                    var s2$3 = s2$2[2], b$0 = s2$2[1], comparison = caml_call2(compare, a, b$0);
                    return 0 < comparison ? [
                        1,
                        b$0,
                        [
                            0,
                            s1,
                            [
                                0,
                                s2$3
                            ]
                        ]
                    ] : [
                        1,
                        a,
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            s2$2
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function hd(s) {
        var next = s[2], s$2 = s[1], s$0 = s$2;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) {
                var a = match[1];
                return [
                    0,
                    a
                ];
            }
            var s$1 = match[1];
            s$0 = s$1;
        }
    }
    function hd_exn(s) {
        var match = hd(s);
        if (!match) return caml_call1(Base_Import[124], cst_hd_exn);
        var a = match[1];
        return a;
    }
    function tl(s) {
        var next = s[2], s$2 = s[1], s$0 = s$2;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") var match$0 = 0;
            else {
                if (0 === match[0]) {
                    var s$1 = match[1];
                    s$0 = s$1;
                    continue;
                }
                var a = match[2], match$0 = [
                    0,
                    a
                ];
            }
            if (!match$0) return 0;
            var s$3 = match$0[1];
            return [
                0,
                [
                    0,
                    s$3,
                    next
                ]
            ];
        }
    }
    function tl_eagerly_exn(s) {
        var match = tl(s);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_tl_exn);
        var s$0 = match[1];
        return s$0;
    }
    function lift_identity(next, s) {
        var match = caml_call1(next, s);
        if (typeof match === "number") return 0;
        if (0 === match[0]) {
            var s$0 = match[1];
            return [
                0,
                [
                    0,
                    316735838,
                    s$0
                ]
            ];
        }
        var s$1 = match[2], a = match[1];
        return [
            1,
            a,
            [
                0,
                316735838,
                s$1
            ]
        ];
    }
    function next(s) {
        var next = s[2], s$3 = s[1], s$0 = s$3;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 !== match[0]) {
                var s$2 = match[2], a = match[1];
                return [
                    0,
                    [
                        0,
                        a,
                        [
                            0,
                            s$2,
                            next
                        ]
                    ]
                ];
            }
            var s$1 = match[1];
            s$0 = s$1;
        }
    }
    function filter_opt(s) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            s$0,
            function(s) {
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        s$0
                    ];
                }
                var match$0 = match[1];
                if (match$0) {
                    var s$1 = match[2], a = match$0[1];
                    return [
                        1,
                        a,
                        s$1
                    ];
                }
                var s$2 = match[2];
                return [
                    0,
                    s$2
                ];
            }
        ];
    }
    function filter_map(s, f) {
        return filter_opt(caml_call2(map$0, s, f));
    }
    function filter_mapi(s, f) {
        return filter_map(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        });
    }
    function split_n(s, n) {
        var next = s[2], s$3 = s[1], s$0 = s$3, i = n, accum = 0;
        for(;;){
            if (0 >= i) return [
                0,
                caml_call1(Base_List1[19], accum),
                [
                    0,
                    s$0,
                    next
                ]
            ];
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return [
                0,
                caml_call1(Base_List1[19], accum),
                empty
            ];
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], accum$0 = [
                    0,
                    a,
                    accum
                ], i$0 = caml_call2(Base_Import[93], i, 1);
                s$0 = s$2;
                i = i$0;
                accum = accum$0;
            }
        }
    }
    function chunks_exn(init, n) {
        if (0 >= n) return caml_call1(Base_Import[126], cst_Sequence_chunks_exn);
        function f(t) {
            var match = split_n(t, n), xs = match[1];
            if (!xs) return 0;
            var t$0 = match[2];
            return [
                1,
                xs,
                t$0
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function findi(t, f) {
        var next = t[2], seed = t[1], s = seed, i = 0;
        for(;;){
            var match = caml_call1(next, s);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$0 = match[1];
                s = s$0;
            } else {
                var a = match[1];
                if (caml_call2(f, i, a)) return [
                    0,
                    [
                        0,
                        i,
                        a
                    ]
                ];
                var s$1 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                s = s$1;
                i = i$0;
            }
        }
    }
    function find_exn(s, f) {
        var match = find(s, f);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_find_exn);
        var x = match[1];
        return x;
    }
    function append(s1, s2) {
        var next2 = s2[2], s2$0 = s2[1], next1 = s1[2], s1$0 = s1[1];
        return [
            0,
            [
                0,
                472258093,
                s1$0
            ],
            function(param) {
                if (472258093 <= param[1]) {
                    var s1 = param[2], match = caml_call1(next1, s1);
                    if (typeof match === "number") return [
                        0,
                        [
                            0,
                            -630817751,
                            s2$0
                        ]
                    ];
                    if (0 === match[0]) {
                        var s1$0 = match[1];
                        return [
                            0,
                            [
                                0,
                                472258093,
                                s1$0
                            ]
                        ];
                    }
                    var s1$1 = match[2], a = match[1];
                    return [
                        1,
                        a,
                        [
                            0,
                            472258093,
                            s1$1
                        ]
                    ];
                }
                var s2 = param[2], match$0 = caml_call1(next2, s2);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var s2$1 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            -630817751,
                            s2$1
                        ]
                    ];
                }
                var s2$2 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    a$0,
                    [
                        0,
                        -630817751,
                        s2$2
                    ]
                ];
            }
        ];
    }
    function concat_map(s, f) {
        return caml_call2(bind$0, s, f);
    }
    function concat(s) {
        function f(_C_) {
            return _C_;
        }
        return caml_call2(bind$0, s, f);
    }
    function concat_mapi(s, f) {
        function f$0(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        }
        var s$0 = mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        });
        return caml_call2(bind$0, s$0, f$0);
    }
    function zip(_A_, param) {
        var next2 = param[2], s2 = param[1], next1 = _A_[2], s1 = _A_[1];
        function next(param) {
            var _B_ = param[1];
            if (typeof _B_ !== "number") {
                if (1 === _B_[0]) {
                    var match = param[2], s1$0 = _B_[2], a = _B_[1];
                    if (typeof match !== "number") {
                        if (0 === match[0]) {
                            var s2$0 = param[2][1];
                            return [
                                0,
                                [
                                    0,
                                    _B_,
                                    caml_call1(next2, s2$0)
                                ]
                            ];
                        }
                        var s2$1 = match[2], b = match[1];
                        return [
                            1,
                            [
                                0,
                                a,
                                b
                            ],
                            [
                                0,
                                [
                                    0,
                                    s1$0
                                ],
                                [
                                    0,
                                    s2$1
                                ]
                            ]
                        ];
                    }
                }
                if (typeof param[2] !== "number") {
                    var s2 = param[2], s1 = _B_[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1),
                            s2
                        ]
                    ];
                }
            }
            return 0;
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function zip_full(_z_, param) {
        var next2 = param[2], s2 = param[1], next1 = _z_[2], s1 = _z_[1];
        function next(param) {
            var s1 = param[1];
            if (typeof s1 === "number") {
                var match = param[2];
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var s2$0 = match[2], b = match[1];
                    return [
                        1,
                        [
                            0,
                            -57574468,
                            b
                        ],
                        [
                            0,
                            0,
                            caml_call1(next2, s2$0)
                        ]
                    ];
                }
            } else {
                if (0 === s1[0]) {
                    var s2$1 = param[2], s1$0 = s1[1];
                    return [
                        0,
                        [
                            0,
                            caml_call1(next1, s1$0),
                            s2$1
                        ]
                    ];
                }
                var match$0 = param[2], s1$1 = s1[2], a = s1[1];
                if (typeof match$0 === "number") return [
                    1,
                    [
                        0,
                        847852583,
                        a
                    ],
                    [
                        0,
                        caml_call1(next1, s1$1),
                        0
                    ]
                ];
                if (0 !== match$0[0]) {
                    var s2$2 = match$0[2], b$0 = match$0[1];
                    return [
                        1,
                        [
                            0,
                            737457313,
                            [
                                0,
                                a,
                                b$0
                            ]
                        ],
                        [
                            0,
                            [
                                0,
                                s1$1
                            ],
                            [
                                0,
                                s2$2
                            ]
                        ]
                    ];
                }
            }
            var s2 = param[2][1];
            return [
                0,
                [
                    0,
                    s1,
                    caml_call1(next2, s2)
                ]
            ];
        }
        return [
            0,
            [
                0,
                [
                    0,
                    s1
                ],
                [
                    0,
                    s2
                ]
            ],
            next
        ];
    }
    function bounded_length(param, at_most) {
        var next = param[2], seed = param[1], i = 0, seed$0 = seed;
        for(;;){
            if (at_most < i) return 85047514;
            var match = caml_call1(next, seed$0);
            if (typeof match === "number") return [
                0,
                16394,
                i
            ];
            if (0 === match[0]) {
                var seed$1 = match[1];
                seed$0 = seed$1;
            } else {
                var seed$2 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                seed$0 = seed$2;
            }
        }
    }
    function length_is_bounded_by(opt, max, t) {
        var min = opt ? opt[1] : -1;
        if (max) {
            var max$0 = max[1], match$0 = bounded_length(t, max$0);
            if (typeof match$0 !== "number" && 16394 === match$0[1]) {
                var len = match$0[2];
                if (min <= len) return 1;
            }
            return 0;
        }
        var next = t[2], s = t[1], s$0 = s, acc = 0;
        for(;;){
            if (min <= acc) return 1;
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], acc$0 = caml_call2(Base_Import[91], acc, 1);
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function iteri(s, f) {
        return iter(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), function(param) {
            var s = param[2], i = param[1];
            return caml_call2(f, i, s);
        });
    }
    function foldi(s, init, f) {
        return fold(mapi(s, function(i, s) {
            return [
                0,
                i,
                s
            ];
        }), init, function(acc, param) {
            var s = param[2], i = param[1];
            return caml_call3(f, i, acc, s);
        });
    }
    function reduce(s, f) {
        var match = next(s);
        if (!match) return 0;
        var match$0 = match[1], s$0 = match$0[2], a = match$0[1];
        return [
            0,
            fold(s$0, a, f)
        ];
    }
    function reduce_exn(s, f) {
        var match = reduce(s, f);
        if (!match) return caml_call1(Base_Import[124], cst_Sequence_reduce_exn);
        var res = match[1];
        return res;
    }
    function group(param, break$0) {
        var next = param[2], s = param[1];
        function f(param) {
            if (!param) return 0;
            var match = param[1], s = match[2], acc = match[1], match$0 = caml_call1(next, s);
            if (typeof match$0 !== "number" && 0 === match$0[0]) {
                var s$2 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            acc,
                            s$2
                        ]
                    ]
                ];
            }
            if (acc) {
                if (typeof match$0 === "number") return [
                    1,
                    caml_call1(Base_List1[19], acc),
                    0
                ];
                var s$0 = match$0[2], cur = match$0[1], prev = acc[1];
                return caml_call2(break$0, prev, cur) ? [
                    1,
                    caml_call1(Base_List1[19], acc),
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                cur,
                                0
                            ],
                            s$0
                        ]
                    ]
                ] : [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                cur,
                                acc
                            ],
                            s$0
                        ]
                    ]
                ];
            }
            if (typeof match$0 === "number") return 0;
            var s$1 = match$0[2], cur$0 = match$0[1];
            return [
                0,
                [
                    0,
                    [
                        0,
                        [
                            0,
                            cur$0,
                            0
                        ],
                        s$1
                    ]
                ]
            ];
        }
        var init = [
            0,
            [
                0,
                0,
                s
            ]
        ];
        return [
            0,
            init,
            f
        ];
    }
    function find_consecutive_duplicate(param, equal) {
        var next = param[2], s = param[1], last_elt = 0, s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1];
                if (last_elt) {
                    var b = last_elt[1];
                    if (caml_call2(equal, a, b)) return [
                        0,
                        [
                            0,
                            b,
                            a
                        ]
                    ];
                }
                var last_elt$0 = [
                    0,
                    a
                ];
                last_elt = last_elt$0;
                s$0 = s$2;
            }
        }
    }
    function remove_consecutive_duplicates(s, equal) {
        return unfold_with(s, 0, function(prev, a) {
            if (prev) {
                var b = prev[1];
                if (caml_call2(equal, a, b)) return [
                    0,
                    [
                        0,
                        a
                    ]
                ];
            }
            return [
                1,
                a,
                [
                    0,
                    a
                ]
            ];
        });
    }
    function count(s, f) {
        return fold(s, 0, function(acc, elt) {
            var _x_ = caml_call1(f, elt), _y_ = caml_call1(Base_Bool[31], _x_);
            return caml_call2(Base_Import[91], acc, _y_);
        });
    }
    function counti(t, f) {
        return foldi(t, 0, function(i, acc, elt) {
            var _v_ = caml_call2(f, i, elt), _w_ = caml_call1(Base_Bool[31], _v_);
            return caml_call2(Base_Import[91], acc, _w_);
        });
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function init(n, f) {
        function f$0(i) {
            if (n <= i) return 0;
            var _u_ = caml_call2(Base_Import[91], i, 1);
            return [
                1,
                caml_call1(f, i),
                _u_
            ];
        }
        return [
            0,
            0,
            f$0
        ];
    }
    function sub(s, pos, len) {
        var _s_ = pos < 0 ? 1 : 0, _t_ = _s_ || (len < 0 ? 1 : 0);
        if (_t_) caml_call1(Base_Import[124], cst_Sequence_sub);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1];
                if (len <= caml_call2(Base_Import[93], i, pos)) return 0;
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var a = match[1], s$1 = match[2];
                if (pos <= i) return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
                var s$2 = match[2];
                return [
                    0,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$2
                    ]
                ];
            }
        ];
    }
    function take(s, len) {
        if (len < 0) caml_call1(Base_Import[124], cst_Sequence_take);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1];
                if (len <= i) return 0;
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var s$1 = match[2], a = match[1];
                return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
            }
        ];
    }
    function drop(s, len) {
        if (len < 0) caml_call1(Base_Import[124], cst_Sequence_drop);
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                0,
                s$0
            ],
            function(param) {
                var s = param[2], i = param[1], match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        [
                            0,
                            i,
                            s$0
                        ]
                    ];
                }
                var a = match[1], s$1 = match[2];
                if (len <= i) return [
                    1,
                    a,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$1
                    ]
                ];
                var s$2 = match[2];
                return [
                    0,
                    [
                        0,
                        caml_call2(Base_Import[91], i, 1),
                        s$2
                    ]
                ];
            }
        ];
    }
    function take_while(s, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            s$0,
            function(s) {
                var match = caml_call1(next, s);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$0 = match[1];
                    return [
                        0,
                        s$0
                    ];
                }
                var a = match[1], s$1 = match[2];
                return caml_call1(f, a) ? [
                    1,
                    a,
                    s$1
                ] : 0;
            }
        ];
    }
    function drop_while(s, f) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                -557110719,
                s$0
            ],
            function(param) {
                if (316735838 <= param[1]) {
                    var s = param[2];
                    return lift_identity(next, s);
                }
                var s$0 = param[2], match = caml_call1(next, s$0);
                if (typeof match === "number") return 0;
                if (0 === match[0]) {
                    var s$1 = match[1];
                    return [
                        0,
                        [
                            0,
                            -557110719,
                            s$1
                        ]
                    ];
                }
                var a = match[1], s$2 = match[2];
                if (caml_call1(f, a)) return [
                    0,
                    [
                        0,
                        -557110719,
                        s$2
                    ]
                ];
                var s$3 = match[2];
                return [
                    1,
                    a,
                    [
                        0,
                        316735838,
                        s$3
                    ]
                ];
            }
        ];
    }
    function shift_right(s, x) {
        var next = s[2], seed = s[1];
        return [
            0,
            [
                0,
                -433944719,
                [
                    0,
                    seed,
                    x
                ]
            ],
            function(param) {
                if (316735838 <= param[1]) {
                    var s = param[2];
                    return lift_identity(next, s);
                }
                var match = param[2], x = match[2], seed = match[1];
                return [
                    1,
                    x,
                    [
                        0,
                        316735838,
                        seed
                    ]
                ];
            }
        ];
    }
    function shift_right_with_list(s, l) {
        return append(of_list(l), s);
    }
    var Infix = [
        0,
        append
    ], cst_Sequence_cycle_list_exn = "Sequence.cycle_list_exn", cst_Bug_This_branch_should_be_ = "Bug: This branch should be unreachable";
    function intersperse(s, sep) {
        var next = s[2], s$0 = s[1];
        return [
            0,
            [
                0,
                815032112,
                s$0
            ],
            function(param) {
                var _r_ = param[1];
                if (815032112 === _r_) {
                    var s = param[2], match = caml_call1(next, s);
                    if (typeof match === "number") return 0;
                    if (0 === match[0]) {
                        var s$0 = match[1];
                        return [
                            0,
                            [
                                0,
                                815032112,
                                s$0
                            ]
                        ];
                    }
                    var s$1 = match[2], a = match[1];
                    return [
                        1,
                        a,
                        [
                            0,
                            951752159,
                            s$1
                        ]
                    ];
                }
                if (951752159 > _r_) {
                    var match$1 = param[2], s$5 = match$1[2], a$1 = match$1[1];
                    return [
                        1,
                        a$1,
                        [
                            0,
                            951752159,
                            s$5
                        ]
                    ];
                }
                var s$2 = param[2], match$0 = caml_call1(next, s$2);
                if (typeof match$0 === "number") return 0;
                if (0 === match$0[0]) {
                    var s$3 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            951752159,
                            s$3
                        ]
                    ];
                }
                var s$4 = match$0[2], a$0 = match$0[1];
                return [
                    1,
                    sep,
                    [
                        0,
                        -571577571,
                        [
                            0,
                            a$0,
                            s$4
                        ]
                    ]
                ];
            }
        ];
    }
    function repeat(init) {
        function f(x) {
            return [
                1,
                x,
                x
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function cycle_list_exn(xs) {
        if (caml_call1(Base_List1[22], xs)) caml_call1(Base_Import[126], cst_Sequence_cycle_list_exn);
        var s = of_list(xs);
        function f(param) {
            return s;
        }
        var s$0 = repeat(0);
        return caml_call2(bind$0, s$0, f);
    }
    function cartesian_product(sa, sb) {
        function f(a) {
            return zip(repeat(a), sb);
        }
        return caml_call2(bind$0, sa, f);
    }
    function singleton(x) {
        return caml_call1(return$1, x);
    }
    function delayed_fold(s, init, f, finish) {
        return delayed_fold_step(s, init, function(acc, option, k) {
            if (!option) return caml_call1(k, acc);
            var a = option[1];
            return caml_call3(f, acc, a, k);
        }, finish);
    }
    function fold_m(bind, return$0, t, init, f) {
        return delayed_fold_step(t, init, function(acc, option, k) {
            if (!option) return caml_call2(bind, caml_call1(return$0, acc), k);
            var a = option[1];
            return caml_call2(bind, caml_call2(f, acc, a), k);
        }, return$0);
    }
    function iter_m(bind, return$0, t, f) {
        return delayed_fold_step(t, 0, function(param, option, k) {
            if (!option) return caml_call2(bind, caml_call1(return$0, 0), k);
            var a = option[1];
            return caml_call2(bind, caml_call1(f, a), k);
        }, return$0);
    }
    function fold_until(s, init, f, finish) {
        var next = s[2], s$3 = s[1], s$0 = s$3, acc = init;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return caml_call1(finish, acc);
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], match$0 = caml_call2(f, acc, a);
                if (0 !== match$0[0]) {
                    var x = match$0[1];
                    return x;
                }
                var acc$0 = match$0[1];
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function fold_result(s, init, f) {
        var next = s[2], s$3 = s[1], s$0 = s$3, acc = init;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return caml_call1(Base_Result[15], acc);
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], a = match[1], e = caml_call2(f, acc, a);
                if (0 !== e[0]) return e;
                var acc$0 = e[1];
                s$0 = s$2;
                acc = acc$0;
            }
        }
    }
    function force_eagerly(t) {
        return of_list(to_list(t));
    }
    function memoize(param) {
        var next = param[2], s = param[1];
        function memoize(s) {
            return [
                0,
                [
                    246,
                    function(_q_) {
                        var s$0 = s;
                        for(;;){
                            var match = caml_call1(next, s$0);
                            if (typeof match === "number") return 0;
                            if (0 !== match[0]) {
                                var s$2 = match[2], a = match[1];
                                return [
                                    1,
                                    a,
                                    memoize(s$2)
                                ];
                            }
                            var s$1 = match[1];
                            s$0 = s$1;
                        }
                    }
                ]
            ];
        }
        return [
            0,
            memoize(s),
            function(param) {
                var l = param[1], _p_ = caml_obj_tag(l);
                if (250 === _p_) return l[1];
                if (246 !== _p_ && 244 !== _p_) return l;
                return caml_call1(CamlinternalLazy[2], l);
            }
        ];
    }
    function drop_eagerly(s, len) {
        var next = s[2], s$3 = s[1], i = 0, s$0 = s$3;
        for(;;){
            if (len <= i) return [
                0,
                s$0,
                next
            ];
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return empty;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], i$0 = caml_call2(Base_Import[91], i, 1);
                i = i$0;
                s$0 = s$2;
            }
        }
    }
    function drop_while_option(param, f) {
        var next = param[2], s = param[1], s$0 = s;
        for(;;){
            var match = caml_call1(next, s$0);
            if (typeof match === "number") return 0;
            if (0 === match[0]) {
                var s$1 = match[1];
                s$0 = s$1;
            } else {
                var s$2 = match[2], x = match[1];
                if (!caml_call1(f, x)) return [
                    0,
                    [
                        0,
                        x,
                        [
                            0,
                            s$2,
                            next
                        ]
                    ]
                ];
                s$0 = s$2;
            }
        }
    }
    function skip_loop(s, next) {
        var s$0 = s;
        for(;;){
            var next$0 = caml_call1(next, s$0);
            if (typeof next$0 !== "number" && 0 === next$0[0]) {
                var state = next$0[1];
                s$0 = state;
                continue;
            }
            return next$0;
        }
    }
    function compare$0(compare_a, l, param) {
        var next_r = param[2], s_r$1 = param[1], next_l = l[2], s_l$1 = l[1], s_l = s_l$1, s_r = s_r$1;
        for(;;){
            var l$0 = skip_loop(s_l, next_l), r = skip_loop(s_r, next_r);
            if (typeof l$0 === "number") {
                if (typeof r === "number") return 0;
                if (1 === r[0]) return -1;
            } else if (1 === l$0[0]) {
                if (typeof r === "number") return 1;
                if (1 === r[0]) {
                    var c = caml_call2(compare_a, l$0[1], r[1]);
                    if (0 !== c) return c;
                    var s_r$0 = r[2], s_l$0 = l$0[2];
                    s_l = s_l$0;
                    s_r = s_r$0;
                    continue;
                }
            }
            return caml_call1(Base_Import[124], cst_Bug_This_branch_should_be_);
        }
    }
    function compare_local$0(compare_a_local, t1, t2) {
        var _o_ = globalize(0, t2);
        return compare$0(function(x, y) {
            return caml_call2(compare_a_local, x, y);
        }, globalize(0, t1), _o_);
    }
    function equal$0(equal_a, t1, t2) {
        return for_all(zip_full(t1, t2), function(param) {
            if (737457313 !== param[1]) return 0;
            var match = param[2], a2 = match[2], a1 = match[1];
            return caml_call2(equal_a, a1, a2);
        });
    }
    function equal_local$0(equal_a_local, t1, t2) {
        var _n_ = globalize(0, t2);
        return equal$0(function(x, y) {
            return caml_call2(equal_a_local, x, y);
        }, globalize(0, t1), _n_);
    }
    function round_robin(list) {
        function next(param) {
            var done_stack = param[2], todo_stack = param[1];
            if (!todo_stack) return caml_call1(Base_List1[22], done_stack) ? 0 : [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], done_stack),
                    0
                ]
            ];
            var todo_stack$0 = todo_stack[2], match = todo_stack[1], f = match[2], s = match[1], match$0 = caml_call1(f, s);
            if (typeof match$0 === "number") return [
                0,
                [
                    0,
                    todo_stack$0,
                    done_stack
                ]
            ];
            if (0 === match$0[0]) {
                var s$0 = match$0[1];
                return [
                    0,
                    [
                        0,
                        [
                            0,
                            [
                                0,
                                s$0,
                                f
                            ],
                            todo_stack$0
                        ],
                        done_stack
                    ]
                ];
            }
            var s$1 = match$0[2], x = match$0[1];
            return [
                1,
                x,
                [
                    0,
                    todo_stack$0,
                    [
                        0,
                        [
                            0,
                            s$1,
                            f
                        ],
                        done_stack
                    ]
                ]
            ];
        }
        var state = [
            0,
            list,
            0
        ];
        return [
            0,
            state,
            next
        ];
    }
    function interleave(param) {
        var f1 = param[2], s1 = param[1];
        function next(param) {
            var s1 = param[3], done_stack = param[2], todo_stack = param[1];
            if (todo_stack) {
                var todo_stack$0 = todo_stack[2], match = todo_stack[1], f2 = match[2], s2 = match[1], match$0 = caml_call1(f2, s2);
                if (typeof match$0 === "number") return [
                    0,
                    [
                        0,
                        todo_stack$0,
                        done_stack,
                        s1
                    ]
                ];
                if (0 === match$0[0]) {
                    var s2$0 = match$0[1];
                    return [
                        0,
                        [
                            0,
                            todo_stack$0,
                            [
                                0,
                                [
                                    0,
                                    s2$0,
                                    f2
                                ],
                                done_stack
                            ],
                            s1
                        ]
                    ];
                }
                var s2$1 = match$0[2], x = match$0[1];
                return [
                    1,
                    x,
                    [
                        0,
                        todo_stack$0,
                        [
                            0,
                            [
                                0,
                                s2$1,
                                f2
                            ],
                            done_stack
                        ],
                        s1
                    ]
                ];
            }
            var match$1 = caml_call1(f1, s1);
            if (typeof match$1 === "number") return done_stack ? [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], done_stack),
                    0,
                    s1
                ]
            ] : 0;
            if (0 === match$1[0]) {
                var s1$0 = match$1[1];
                return [
                    0,
                    [
                        0,
                        caml_call1(Base_List1[19], done_stack),
                        0,
                        s1$0
                    ]
                ];
            }
            var s1$1 = match$1[2], t = match$1[1];
            return [
                0,
                [
                    0,
                    caml_call1(Base_List1[19], [
                        0,
                        t,
                        done_stack
                    ]),
                    0,
                    s1$1
                ]
            ];
        }
        var state = [
            0,
            0,
            0,
            s1
        ];
        return [
            0,
            state,
            next
        ];
    }
    function interleaved_cartesian_product(s1, s2) {
        return interleave(caml_call2(map$0, s1, function(x1) {
            return caml_call2(map$0, s2, function(x2) {
                return [
                    0,
                    x1,
                    x2
                ];
            });
        }));
    }
    function of_seq(init) {
        function f(seq) {
            var match = caml_call1(seq, 0);
            if (!match) return 0;
            var tl = match[2], hd = match[1];
            return [
                1,
                hd,
                tl
            ];
        }
        return [
            0,
            init,
            f
        ];
    }
    function to_seq(param) {
        var next = param[2], state = param[1];
        function loop(state) {
            var state$0 = state;
            for(;;){
                var match = caml_call1(next, state$0);
                if (typeof match === "number") return 0;
                if (0 !== match[0]) {
                    var state$2 = match[2], hd = match[1];
                    return [
                        0,
                        hd,
                        function(param) {
                            return loop(state$2);
                        }
                    ];
                }
                var state$1 = match[1];
                state$0 = state$1;
            }
        }
        return function(param) {
            return loop(state);
        };
    }
    function return$2(x, k) {
        return caml_call1(k, x);
    }
    function bind$1(m, f, k) {
        return caml_call1(m, function(a) {
            var m = caml_call1(f, a);
            return caml_call1(m, k);
        });
    }
    var map$1 = [
        0,
        -198771759,
        function(m, f, k) {
            return caml_call1(m, function(a) {
                return caml_call1(k, caml_call1(f, a));
            });
        }
    ], include$0 = caml_call1(Base_Monad[2], [
        0,
        bind$1,
        map$1,
        return$2
    ]), symbol_bind$0 = include$0[1], symbol_map$0 = include$0[2], Let_syntax$0 = include$0[3], Monad_infix$0 = include$0[4], bind$2 = include$0[5], return$3 = include$0[6], map$2 = include$0[7], join$0 = include$0[8], ignore_m$0 = include$0[9], all$0 = include$0[10], all_unit$0 = include$0[11], _m_ = [
        0,
        0
    ];
    function yield$0(e, k) {
        return [
            0,
            [
                1,
                e,
                k
            ]
        ];
    }
    function of_sequence(sequence) {
        return delayed_fold(sequence, 0, function(param, x, k, f) {
            return [
                0,
                [
                    1,
                    x,
                    function(param) {
                        return caml_call2(k, 0, f);
                    }
                ]
            ];
        }, return$3);
    }
    function run(t) {
        function init(param) {
            return caml_call1(t, function(param) {
                return _m_;
            });
        }
        function f(thunk) {
            var step = caml_call1(thunk, 0)[1];
            return step;
        }
        return [
            0,
            init,
            f
        ];
    }
    var Base_Sequence = [
        0,
        globalize,
        sexp_of_t$0,
        equal$0,
        equal_local$0,
        compare$0,
        compare_local$0,
        mem,
        length,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        counti,
        findi,
        find_mapi,
        symbol_bind,
        symbol_map,
        Monad_infix,
        bind$0,
        return$1,
        map$0,
        join,
        ignore_m,
        all,
        all_unit,
        Let_syntax,
        empty,
        next,
        Step,
        unfold_step,
        unfold,
        unfold_with,
        unfold_with_and_finish,
        nth,
        nth_exn,
        folding_map,
        folding_mapi,
        mapi,
        filteri,
        filter,
        merge_deduped_and_sorted,
        merge_sorted,
        [
            0,
            compare,
            compare_local,
            equal,
            equal_local,
            hash_fold_t,
            t_of_sexp,
            sexp_of_t$1,
            t_sexp_grammar
        ],
        merge_with_duplicates,
        hd,
        hd_exn,
        tl,
        tl_eagerly_exn,
        find_exn,
        for_alli,
        append,
        concat,
        concat_map,
        concat_mapi,
        interleave,
        round_robin,
        zip,
        zip_full,
        reduce_exn,
        reduce,
        group,
        find_consecutive_duplicate,
        remove_consecutive_duplicates,
        range,
        init,
        filter_map,
        filter_mapi,
        filter_opt,
        sub,
        take,
        drop,
        drop_eagerly,
        take_while,
        drop_while,
        drop_while_option,
        split_n,
        chunks_exn,
        shift_right,
        shift_right_with_list,
        drop,
        Infix,
        cartesian_product,
        interleaved_cartesian_product,
        intersperse,
        cycle_list_exn,
        repeat,
        singleton,
        delayed_fold,
        fold_m,
        iter_m,
        to_list_rev,
        of_list,
        of_lazy,
        memoize,
        force_eagerly,
        bounded_length,
        length_is_bounded_by,
        of_seq,
        to_seq,
        [
            0,
            symbol_bind$0,
            symbol_map$0,
            Let_syntax$0,
            Monad_infix$0,
            bind$2,
            return$3,
            map$2,
            join$0,
            ignore_m$0,
            all$0,
            all_unit$0,
            yield$0,
            of_sequence,
            run
        ],
        [
            0,
            next_step,
            delayed_fold_step,
            T,
            view
        ]
    ];
    runtime.caml_register_global(51, Base_Sequence, "Base__Sequence");
    return;
})(globalThis);
//# 16611 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, cst_Sexpable_Of_stringable_t_o = "Sexpable.Of_stringable.t_of_sexp expected an atom, but got a list";
    function Of_sexpable(Sexpable, M) {
        function t_of_sexp(sexp) {
            var s = caml_call1(Sexpable[1], sexp);
            try {
                var _i_ = caml_call1(M[2], s);
                return _i_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(t) {
            var _h_ = caml_call1(M[1], t);
            return caml_call1(Sexpable[2], _h_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable1(Sexpable, M) {
        function t_of_sexp(a_of_sexp, sexp) {
            var s = caml_call2(Sexpable[1], a_of_sexp, sexp);
            try {
                var _g_ = caml_call1(M[2], s);
                return _g_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, t) {
            var _f_ = caml_call1(M[1], t);
            return caml_call2(Sexpable[2], sexp_of_a, _f_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable2(Sexpable, M) {
        function t_of_sexp(a_of_sexp, b_of_sexp, sexp) {
            var s = caml_call3(Sexpable[1], a_of_sexp, b_of_sexp, sexp);
            try {
                var _e_ = caml_call1(M[2], s);
                return _e_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, sexp_of_b, t) {
            var _d_ = caml_call1(M[1], t);
            return caml_call3(Sexpable[2], sexp_of_a, sexp_of_b, _d_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_sexpable3(Sexpable, M) {
        function t_of_sexp(a_of_sexp, b_of_sexp, c_of_sexp, sexp) {
            var s = caml_call4(Sexpable[1], a_of_sexp, b_of_sexp, c_of_sexp, sexp);
            try {
                var _c_ = caml_call1(M[2], s);
                return _c_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(sexp_of_a, sexp_of_b, sexp_of_c, t) {
            var _b_ = caml_call1(M[1], t);
            return caml_call4(Sexpable[2], sexp_of_a, sexp_of_b, sexp_of_c, _b_);
        }
        return [
            0,
            t_of_sexp,
            sexp_of_t
        ];
    }
    function Of_stringable(M) {
        function t_of_sexp(sexp) {
            if (0 !== sexp[0]) return caml_call2(Base_Import[156], cst_Sexpable_Of_stringable_t_o, sexp);
            var s = sexp[1];
            try {
                var _a_ = caml_call1(M[1], s);
                return _a_;
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0);
                return caml_call2(Base_Import[157], exn, sexp);
            }
        }
        function sexp_of_t(t) {
            return [
                0,
                caml_call1(M[2], t)
            ];
        }
        var t_sexp_grammar = caml_call1(Sexplib0_Sexp_grammar[1], Base_Import[182]);
        return [
            0,
            t_sexp_grammar,
            t_of_sexp,
            sexp_of_t
        ];
    }
    var Base_Sexpable = [
        0,
        Of_sexpable,
        Of_sexpable1,
        Of_sexpable2,
        Of_sexpable3,
        Of_stringable
    ];
    runtime.caml_register_global(3, Base_Sexpable, "Base__Sexpable");
    return;
})(globalThis);
//# 16735 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_array_ml = "src/array.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_Sequence = global_data.Base__Sequence, Base_Random = global_data.Base__Random, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Bool = global_data.Base__Bool, Base_Container = global_data.Base__Container, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_Array0 = global_data.Base__Array0, Base_Array_permute = global_data.Base__Array_permute, Base_Binary_searchable = global_data.Base__Binary_searchable, Base_Blit = global_data.Base__Blit, invalid_argf = Base_Array0[1], max_length = Base_Array0[3], create = Base_Array0[4], create_local = Base_Array0[5], create_float_uninitialized = Base_Array0[6], append = Base_Array0[7], concat = Base_Array0[9], copy = Base_Array0[10], fill = Base_Array0[11], init = Base_Array0[12], make_matrix = Base_Array0[13], of_list = Base_Array0[14], sub = Base_Array0[15], to_list = Base_Array0[16], fold = Base_Array0[17], fold_right = Base_Array0[18], iter = Base_Array0[19], iteri = Base_Array0[20], map = Base_Array0[21], mapi = Base_Array0[22], stable_sort = Base_Array0[23], swap = Base_Array0[24], compare_local = Base_Import[263], compare = Base_Import[235], globalize = Base_Import[291], t_of_sexp = Base_Import[174], sexp_of_t = Base_Import[150];
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[195], a_sexp_grammar);
    }
    function Sorter(S) {
        var get = S[1], set = S[2], length = S[3];
        function swap(arr, i, j) {
            var tmp = caml_call2(get, arr, i);
            caml_call3(set, arr, i, caml_call2(get, arr, j));
            return caml_call3(set, arr, j, tmp);
        }
        function sort(arr, compare, left, right) {
            var _aR_ = caml_call2(Base_Import[91], left, 1);
            if (right >= _aR_) {
                var pos = _aR_;
                for(;;){
                    var v = caml_call2(get, arr, pos), final_pos = pos;
                    for(;;){
                        var i_next = caml_call2(Base_Import[93], final_pos, 1);
                        if (left > i_next) break;
                        if (0 >= caml_call2(compare, caml_call2(get, arr, i_next), v)) break;
                        caml_call3(set, arr, final_pos, caml_call2(get, arr, i_next));
                        final_pos = i_next;
                    }
                    caml_call3(set, arr, final_pos, v);
                    var _aS_ = pos + 1 | 0;
                    if (right === pos) break;
                    pos = _aS_;
                }
            }
            return 0;
        }
        var Insertion_sort = [
            0,
            sort
        ];
        function heapify(arr, compare, root, left, right) {
            var root$0 = root;
            for(;;){
                var relative_root = caml_call2(Base_Import[93], root$0, left), _aK_ = caml_call2(Base_Import[88], 2, relative_root), _aL_ = caml_call2(Base_Import[91], _aK_, left), left_child = caml_call2(Base_Import[91], _aL_, 1), _aM_ = caml_call2(Base_Import[88], 2, relative_root), _aN_ = caml_call2(Base_Import[91], _aM_, left), right_child = caml_call2(Base_Import[91], _aN_, 2);
                a: {
                    if (left_child <= right) {
                        var _aO_ = caml_call2(get, arr, root$0);
                        if (0 < caml_call2(compare, caml_call2(get, arr, left_child), _aO_)) {
                            var largest = left_child;
                            break a;
                        }
                    }
                    var largest = root$0;
                }
                a: {
                    if (right_child <= right) {
                        var _aP_ = caml_call2(get, arr, largest);
                        if (0 < caml_call2(compare, caml_call2(get, arr, right_child), _aP_)) {
                            var largest$0 = right_child;
                            break a;
                        }
                    }
                    var largest$0 = largest;
                }
                var _aQ_ = largest$0 !== root$0 ? 1 : 0;
                if (!_aQ_) return _aQ_;
                swap(arr, root$0, largest$0);
                root$0 = largest$0;
            }
        }
        function sort$0(arr, compare, left, right) {
            var _aF_ = caml_call2(Base_Import[91], left, right), _aG_ = caml_call2(Base_Import[95], _aF_, 2);
            if (_aG_ >= left) {
                var i = _aG_;
                for(;;){
                    heapify(arr, compare, i, left, right);
                    var _aH_ = i - 1 | 0;
                    if (left === i) break;
                    i = _aH_;
                }
            }
            var _aI_ = caml_call2(Base_Import[91], left, 1);
            if (right >= _aI_) {
                var i$0 = right;
                for(;;){
                    swap(arr, left, i$0);
                    heapify(arr, compare, left, left, caml_call2(Base_Import[93], i$0, 1));
                    var _aJ_ = i$0 - 1 | 0;
                    if (_aI_ === i$0) break;
                    i$0 = _aJ_;
                }
            }
            return 0;
        }
        var Heap_sort = [
            0,
            sort$0
        ];
        function five_element_sort(arr, compare, m1, m2, m3, m4, m5) {
            function compare_and_swap(i, j) {
                var _aD_ = caml_call2(get, arr, j), _aE_ = 0 < caml_call2(compare, caml_call2(get, arr, i), _aD_) ? 1 : 0;
                return _aE_ ? swap(arr, i, j) : _aE_;
            }
            compare_and_swap(m1, m2);
            compare_and_swap(m4, m5);
            compare_and_swap(m1, m3);
            compare_and_swap(m2, m3);
            compare_and_swap(m1, m4);
            compare_and_swap(m3, m4);
            compare_and_swap(m2, m5);
            compare_and_swap(m2, m3);
            return compare_and_swap(m4, m5);
        }
        function intro_sort(arr, max_depth, compare, left, right) {
            var max_depth$0 = max_depth, left$0 = left;
            for(;;){
                var _aC_ = caml_call2(Base_Import[93], right, left$0), len = caml_call2(Base_Import[91], _aC_, 1);
                if (32 >= len) return caml_call4(Insertion_sort[1], arr, compare, left$0, right);
                if (0 > max_depth$0) return caml_call4(Heap_sort[1], arr, compare, left$0, right);
                var max_depth$1 = caml_call2(Base_Import[93], max_depth$0, 1), _aB_ = caml_call2(Base_Import[93], right, left$0), sixth = caml_call2(Base_Import[95], _aB_, 6), m1 = caml_call2(Base_Import[91], left$0, sixth), m2 = caml_call2(Base_Import[91], m1, sixth), m3 = caml_call2(Base_Import[91], m2, sixth), m4 = caml_call2(Base_Import[91], m3, sixth), m5 = caml_call2(Base_Import[91], m4, sixth);
                five_element_sort(arr, compare, m1, m2, m3, m4, m5);
                var m2_val = caml_call2(get, arr, m2), m3_val = caml_call2(get, arr, m3), m4_val = caml_call2(get, arr, m4), match = 0 === caml_call2(compare, m2_val, m3_val) ? [
                    0,
                    m2_val,
                    m3_val,
                    1
                ] : 0 === caml_call2(compare, m3_val, m4_val) ? [
                    0,
                    m3_val,
                    m4_val,
                    1
                ] : [
                    0,
                    m2_val,
                    m4_val,
                    0
                ], middle_sorted = match[3], pivot2 = match[2], pivot1 = match[1], l$0 = left$0, p$1 = left$0, r$2 = right;
                for(;;){
                    if (r$2 < p$1) break;
                    var pv = caml_call2(get, arr, p$1);
                    if (0 <= caml_call2(compare, pv, pivot1)) {
                        if (0 < caml_call2(compare, pv, pivot2)) {
                            var r = r$2;
                            for(;;){
                                if (p$1 >= r) break;
                                if (0 >= caml_call2(compare, caml_call2(get, arr, r), pivot2)) break;
                                var r$0 = caml_call2(Base_Import[93], r, 1);
                                r = r$0;
                            }
                            swap(arr, r, p$1);
                            var r$1 = caml_call2(Base_Import[93], r, 1);
                            r$2 = r$1;
                        } else {
                            var p = caml_call2(Base_Import[91], p$1, 1);
                            p$1 = p;
                        }
                    } else {
                        swap(arr, p$1, l$0);
                        var p$0 = caml_call2(Base_Import[91], p$1, 1), l = caml_call2(Base_Import[91], l$0, 1);
                        l$0 = l;
                        p$1 = p$0;
                    }
                }
                intro_sort(arr, max_depth$1, compare, left$0, caml_call2(Base_Import[93], l$0, 1));
                if (1 - middle_sorted) intro_sort(arr, max_depth$1, compare, l$0, r$2);
                var left$1 = caml_call2(Base_Import[91], r$2, 1);
                max_depth$0 = max_depth$1;
                left$0 = left$1;
            }
        }
        function sort$1(arr, compare, left, right) {
            return intro_sort(arr, 32, compare, left, right);
        }
        var Intro_sort = [
            0,
            sort$1,
            five_element_sort
        ];
        function sort$2(pos, len, arr, compare) {
            var _ay_ = caml_call1(length, arr), match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, _ay_), len$0 = match[2], pos$0 = match[1], _az_ = caml_call2(Base_Import[91], pos$0, len$0), _aA_ = caml_call2(Base_Import[93], _az_, 1);
            return caml_call4(Intro_sort[1], arr, compare, pos$0, _aA_);
        }
        return [
            0,
            ,
            ,
            ,
            ,
            Insertion_sort,
            Heap_sort,
            Intro_sort,
            sort$2
        ];
    }
    function get(_ax_, _aw_) {
        return _ax_[1 + _aw_];
    }
    function set(_av_, _au_, _at_) {
        _av_[1 + _au_] = _at_;
        return 0;
    }
    function length(_as_) {
        return _as_.length - 1;
    }
    var Sort = Sorter([
        0,
        get,
        set,
        length
    ]), sort = Sort[8], _a_ = [
        0,
        cst_src_array_ml,
        486,
        14
    ], _b_ = [
        0,
        [
            11,
            "length mismatch in ",
            [
                2,
                0,
                [
                    11,
                    ": ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " <> ",
                            [
                                4,
                                0,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "length mismatch in %s: %d <> %d"
    ], cst_Array_iter2_exn = "Array.iter2_exn", cst_Array_map2_exn = "Array.map2_exn", cst_Array_fold2_exn = "Array.fold2_exn", cst_Array_exists2_exn = "Array.exists2_exn", cst_Array_for_all2_exn = "Array.for_all2_exn", _c_ = [
        0,
        "Array.findi_exn: not found"
    ], _d_ = [
        0,
        "Array.find_exn: not found"
    ];
    function of_array(t) {
        return t;
    }
    function to_array(t) {
        return t;
    }
    function is_empty(t) {
        return 0 === t.length - 1 ? 1 : 0;
    }
    function is_sorted(t, compare) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 < i[1] && result[1]) {
                var elt_i = t[1 + i[1]], elt_i_minus_1 = t[1 + caml_call2(Base_Import[93], i[1], 1)];
                if (0 < caml_call2(compare, elt_i_minus_1, elt_i)) result[1] = 0;
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function is_sorted_strictly(t, compare) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 < i[1] && result[1]) {
                var elt_i = t[1 + i[1]], elt_i_minus_1 = t[1 + caml_call2(Base_Import[93], i[1], 1)];
                if (0 <= caml_call2(compare, elt_i_minus_1, elt_i)) result[1] = 0;
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function merge(a1, a2, compare) {
        var l1 = a1.length - 1, l2 = a2.length - 1;
        if (0 === l1) return caml_call1(copy, a2);
        if (0 === l2) return caml_call1(copy, a1);
        var _an_ = a1[1 + caml_call2(Base_Import[93], l1, 1)];
        if (0 <= caml_call2(compare, a2[1], _an_)) return caml_call2(append, a1, a2);
        var _ao_ = a2[1 + caml_call2(Base_Import[93], l2, 1)];
        if (0 < caml_call2(compare, a1[1], _ao_)) return caml_call2(append, a2, a1);
        var len = caml_call2(Base_Import[91], l1, l2), merged = caml_call2(create, len, a1[1]), a1_index = [
            0,
            0
        ], a2_index = [
            0,
            0
        ], _aq_ = caml_call2(Base_Import[93], len, 1), _ap_ = 0;
        if (_aq_ >= 0) {
            var i = _ap_;
            for(;;){
                var use_a1 = l1 === a1_index[1] ? 0 : l2 === a2_index[1] ? 1 : caml_call2(compare, a1[1 + a1_index[1]], a2[1 + a2_index[1]]) <= 0 ? 1 : 0;
                if (use_a1) {
                    merged[1 + i] = a1[1 + a1_index[1]];
                    a1_index[1] = caml_call2(Base_Import[91], a1_index[1], 1);
                } else {
                    merged[1 + i] = a2[1 + a2_index[1]];
                    a2_index[1] = caml_call2(Base_Import[91], a2_index[1], 1);
                }
                var _ar_ = i + 1 | 0;
                if (_aq_ === i) break;
                i = _ar_;
            }
        }
        return merged;
    }
    function copy_matrix(_am_) {
        return caml_call2(map, _am_, copy);
    }
    function folding_map(t, init, f) {
        var acc = [
            0,
            init
        ];
        return caml_call2(map, t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_map(t, init, f) {
        var acc = [
            0,
            init
        ], result = caml_call2(map, t, function(x) {
            var match = caml_call2(f, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function extremal_element(t, compare, keep_left_if) {
        if (is_empty(t)) return 0;
        var result = [
            0,
            t[1]
        ], _aj_ = caml_call2(Base_Import[93], t.length - 1, 1), _ai_ = 1;
        if (_aj_ >= 1) {
            var i = _ai_;
            for(;;){
                var x = t[1 + i], _ak_ = result[1];
                result[1] = runtime.caml_csel_value(caml_call1(keep_left_if, caml_call2(compare, x, result[1])), x, _ak_);
                var _al_ = i + 1 | 0;
                if (_aj_ === i) break;
                i = _al_;
            }
        }
        return [
            0,
            result[1]
        ];
    }
    function min_elt(t, compare) {
        return extremal_element(t, compare, function(compare_result) {
            return compare_result < 0 ? 1 : 0;
        });
    }
    function max_elt(t, compare) {
        return extremal_element(t, compare, function(compare_result) {
            return 0 < compare_result ? 1 : 0;
        });
    }
    function foldi(t, init, f) {
        var acc = [
            0,
            init
        ], _ag_ = caml_call2(Base_Import[93], t.length - 1, 1), _af_ = 0;
        if (_ag_ >= 0) {
            var i = _af_;
            for(;;){
                acc[1] = caml_call3(f, i, acc[1], t[1 + i]);
                var _ah_ = i + 1 | 0;
                if (_ag_ === i) break;
                i = _ah_;
            }
        }
        return acc[1];
    }
    function folding_mapi(t, init, f) {
        var acc = [
            0,
            init
        ];
        return caml_call2(mapi, t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
    }
    function fold_mapi(t, init, f) {
        var acc = [
            0,
            init
        ], result = caml_call2(mapi, t, function(i, x) {
            var match = caml_call3(f, i, acc[1], x), y = match[2], new_acc = match[1];
            acc[1] = new_acc;
            return y;
        });
        return [
            0,
            acc[1],
            result
        ];
    }
    function count(t, f) {
        var result = [
            0,
            0
        ], _ab_ = caml_call2(Base_Import[93], t.length - 1, 1), _aa_ = 0;
        if (_ab_ >= 0) {
            var i = _aa_;
            for(;;){
                var _ac_ = caml_call1(f, t[1 + i]), _ad_ = caml_call1(Base_Bool[31], _ac_);
                result[1] = caml_call2(Base_Import[91], result[1], _ad_);
                var _ae_ = i + 1 | 0;
                if (_ab_ === i) break;
                i = _ae_;
            }
        }
        return result[1];
    }
    function counti(t, f) {
        var result = [
            0,
            0
        ], _Y_ = caml_call2(Base_Import[93], t.length - 1, 1), _X_ = 0;
        if (_Y_ >= 0) {
            var i = _X_;
            for(;;){
                var _Z_ = caml_call2(f, i, t[1 + i]), ___ = caml_call1(Base_Bool[31], _Z_);
                result[1] = caml_call2(Base_Import[91], result[1], ___);
                var _$_ = i + 1 | 0;
                if (_Y_ === i) break;
                i = _$_;
            }
        }
        return result[1];
    }
    function concat_map(t, f) {
        return caml_call1(concat, caml_call1(to_list, caml_call2(map, t, f)));
    }
    function concat_mapi(t, f) {
        return caml_call1(concat, caml_call1(to_list, caml_call2(mapi, t, f)));
    }
    function rev_inplace(t) {
        var i = [
            0,
            0
        ], j = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ];
        for(;;){
            if (i[1] >= j[1]) return 0;
            caml_call3(swap, t, i[1], j[1]);
            i[1]++;
            j[1]--;
        }
    }
    function rev(t) {
        var t$0 = caml_call1(copy, t);
        rev_inplace(t$0);
        return t$0;
    }
    function of_list_rev(l) {
        if (!l) return [
            0
        ];
        var l$0 = l[2], a = l[1], _U_ = caml_call1(Base_List[45], l$0), len = caml_call2(Base_Import[91], 1, _U_), t = caml_call2(create, len, a), r = [
            0,
            l$0
        ], _V_ = caml_call2(Base_Import[93], len, 2);
        if (_V_ >= 0) {
            var i = _V_;
            for(;;){
                var match = r[1];
                if (!match) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _a_
                ], 1);
                var l$1 = match[2], a$0 = match[1];
                caml_check_bound(t, i)[1 + i] = a$0;
                r[1] = l$1;
                var _W_ = i - 1 | 0;
                if (0 === i) break;
                i = _W_;
            }
        }
        return t;
    }
    function of_list_map(xs, f) {
        if (!xs) return [
            0
        ];
        var tl = xs[2], hd = xs[1], _S_ = caml_call1(f, hd), _T_1 = caml_call1(Base_List[45], tl), a = caml_call2(create, caml_call2(Base_Import[91], 1, _T_1), _S_), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = caml_call1(f, hd$0);
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            param = tl$0;
        }
    }
    function of_list_mapi(xs, f) {
        if (!xs) return [
            0
        ];
        var tl = xs[2], hd = xs[1], _Q_ = caml_call2(f, 0, hd), _R_ = caml_call1(Base_List[45], tl), a = caml_call2(create, caml_call2(Base_Import[91], 1, _R_), _Q_), i = 1, param = tl;
        for(;;){
            if (!param) return a;
            var tl$0 = param[2], hd$0 = param[1];
            a[1 + i] = caml_call2(f, i, hd$0);
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            param = tl$0;
        }
    }
    function of_list_rev_map(xs, f) {
        var t = of_list_map(xs, f);
        rev_inplace(t);
        return t;
    }
    function of_list_rev_mapi(xs, f) {
        var t = of_list_mapi(xs, f);
        rev_inplace(t);
        return t;
    }
    function filter_mapi(t, f) {
        var r = [
            0,
            [
                0
            ]
        ], k = [
            0,
            0
        ], _O_ = caml_call2(Base_Import[93], t.length - 1, 1), _N_ = 0;
        if (_O_ >= 0) {
            var i = _N_;
            for(;;){
                var match = caml_call2(f, i, t[1 + i]);
                if (match) {
                    var a = match[1];
                    if (0 === k[1]) r[1] = caml_call2(create, t.length - 1, a);
                    r[1][1 + k[1]] = a;
                    k[1]++;
                }
                var _P_ = i + 1 | 0;
                if (_O_ === i) break;
                i = _P_;
            }
        }
        return k[1] === t.length - 1 ? r[1] : 0 < k[1] ? caml_call3(sub, r[1], 0, k[1]) : [
            0
        ];
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(i, a) {
            return caml_call1(f, a);
        });
    }
    function filter_opt(t) {
        return filter_map(t, function(_M_) {
            return _M_;
        });
    }
    function check_length2_exn(name, t1, t2) {
        var n1 = t1.length - 1, n2 = t2.length - 1, _L_ = n1 !== n2 ? 1 : 0;
        return _L_ ? caml_call5(invalid_argf, _b_, name, n1, n2, 0) : _L_;
    }
    function iter2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_iter2_exn, t1, t2);
        return caml_call2(iteri, t1, function(i, x1) {
            return caml_call2(f, x1, t2[1 + i]);
        });
    }
    function map2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_map2_exn, t1, t2);
        return caml_call2(init, t1.length - 1, function(i) {
            return caml_call2(f, t1[1 + i], t2[1 + i]);
        });
    }
    function fold2_exn(t1, t2, init, f) {
        check_length2_exn(cst_Array_fold2_exn, t1, t2);
        return foldi(t1, init, function(i, ac, x) {
            return caml_call3(f, ac, x, t2[1 + i]);
        });
    }
    function filter(t, f) {
        return filter_map(t, function(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function filteri(t, f) {
        return filter_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function exists(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call1(f, t[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function existsi(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call2(f, i[1], t[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function mem(t, a, equal) {
        return exists(t, caml_call1(equal, a));
    }
    function for_all(t, f) {
        var i = [
            0,
            caml_call2(Base_Import[93], t.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call1(f, t[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_alli(t, f) {
        var length = t.length - 1, i = [
            0,
            caml_call2(Base_Import[93], length, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call2(f, i[1], t[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function exists2_exn(t1, t2, f) {
        check_length2_exn(cst_Array_exists2_exn, t1, t2);
        var i = [
            0,
            caml_call2(Base_Import[93], t1.length - 1, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                if (caml_call2(f, t1[1 + i[1]], t2[1 + i[1]])) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function for_all2_local_exn(t1, t2, f) {
        check_length2_exn(cst_Array_for_all2_exn, t1, t2);
        var i = [
            0,
            caml_call2(Base_Import[93], t1.length - 1, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                if (caml_call2(f, t1[1 + i[1]], t2[1 + i[1]])) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_all2_exn(t1, t2, f) {
        return for_all2_local_exn(t1, t2, f);
    }
    function equal_local(equal, t1, t2) {
        var _K_ = t1.length - 1 === t2.length - 1 ? 1 : 0;
        return _K_ ? for_all2_local_exn(t1, t2, equal) : _K_;
    }
    function equal(equal, t1, t2) {
        return equal_local(equal, t1, t2);
    }
    function map_inplace(t, f) {
        var _I_ = caml_call2(Base_Import[93], t.length - 1, 1), _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                t[1 + i] = caml_call1(f, t[1 + i]);
                var _J_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _J_;
            }
        }
        return 0;
    }
    function findi_internal(t, f, if_found, if_not_found) {
        var length = t.length - 1;
        if (0 === length) return caml_call1(if_not_found, 0);
        var i = [
            0,
            0
        ], found = [
            0,
            0
        ], value_found = [
            0,
            t[1]
        ];
        for(;;){
            if (!found[1] && i[1] < length) {
                var value = t[1 + i[1]];
                if (caml_call2(f, i[1], value)) {
                    value_found[1] = value;
                    found[1] = 1;
                } else i[1]++;
                continue;
            }
            return found[1] ? caml_call2(if_found, i[1], value_found[1]) : caml_call1(if_not_found, 0);
        }
    }
    function findi(t, f) {
        return findi_internal(t, f, function(i, value) {
            return [
                0,
                [
                    0,
                    i,
                    value
                ]
            ];
        }, function(param) {
            return 0;
        });
    }
    function findi_exn(t, f) {
        return findi_internal(t, f, function(i, value) {
            return [
                0,
                i,
                value
            ];
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _c_
            ], 1);
        });
    }
    function find_exn(t, f) {
        return findi_internal(t, function(i, x) {
            return caml_call1(f, x);
        }, function(param, value) {
            return value;
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _d_
            ], 1);
        });
    }
    function find(t, f) {
        var _G_ = findi(t, function(i, x) {
            return caml_call1(f, x);
        });
        return caml_call2(Base_Option[24], _G_, function(param) {
            var x = param[2];
            return x;
        });
    }
    function find_map(t, f) {
        var length = t.length - 1;
        if (0 === length) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length) {
                var value = t[1 + i[1]];
                value_found[1] = caml_call1(f, value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    var not_found = [
        0,
        Base_Import[297],
        [
            0,
            "Array.find_map_exn: not found"
        ]
    ];
    function find_map_exn(t, f) {
        var match = find_map(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found, 1);
        var x = match[1];
        return x;
    }
    function find_mapi(t, f) {
        var length = t.length - 1;
        if (0 === length) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length) {
                var value = t[1 + i[1]];
                value_found[1] = caml_call2(f, i[1], value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    var not_found$0 = [
        0,
        Base_Import[297],
        [
            0,
            "Array.find_mapi_exn: not found"
        ]
    ], cst_Array_reduce_exn = "Array.reduce_exn";
    function find_mapi_exn(t, f) {
        var match = find_mapi(t, f);
        if (!match) throw caml_maybe_attach_backtrace(not_found$0, 1);
        var x = match[1];
        return x;
    }
    function find_consecutive_duplicate(t, equal) {
        var n = t.length - 1;
        if (1 >= n) return 0;
        var result = [
            0,
            0
        ], i = [
            0,
            1
        ], prev = [
            0,
            t[1]
        ];
        for(;;){
            if (i[1] >= n) return result[1];
            var cur = t[1 + i[1]];
            if (caml_call2(equal, cur, prev[1])) {
                result[1] = [
                    0,
                    [
                        0,
                        prev[1],
                        cur
                    ]
                ];
                i[1] = n;
            } else {
                prev[1] = cur;
                i[1]++;
            }
        }
    }
    function reduce(t, f) {
        if (0 === t.length - 1) return 0;
        var r = [
            0,
            t[1]
        ], _E_ = caml_call2(Base_Import[93], t.length - 1, 1), _D_ = 1;
        if (_E_ >= 1) {
            var i = _D_;
            for(;;){
                r[1] = caml_call2(f, r[1], t[1 + i]);
                var _F_ = i + 1 | 0;
                if (_E_ === i) break;
                i = _F_;
            }
        }
        return [
            0,
            r[1]
        ];
    }
    function reduce_exn(t, f) {
        var match = reduce(t, f);
        if (!match) return caml_call1(Base_Import[126], cst_Array_reduce_exn);
        var v = match[1];
        return v;
    }
    var permute = Base_Array_permute[25], cst_Array_random_element_exn_e = "Array.random_element_exn: empty array", cst_Array_zip_exn = "Array.zip_exn", cst_Array_transpose_exn = "Array.transpose_exn";
    function random_element_exn(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (is_empty(t)) return caml_call1(Base_Import[124], cst_Array_random_element_exn_e);
        var _C_ = caml_call2(Base_Random[19][7], random_state, t.length - 1);
        return caml_check_bound(t, _C_)[1 + _C_];
    }
    function random_element(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        try {
            var _A_ = [
                0,
                random_element_exn([
                    0,
                    random_state
                ], t)
            ];
            return _A_;
        } catch (_B_) {
            return 0;
        }
    }
    function zip(t1, t2) {
        return t1.length - 1 !== t2.length - 1 ? 0 : [
            0,
            map2_exn(t1, t2, function(x1, x2) {
                return [
                    0,
                    x1,
                    x2
                ];
            })
        ];
    }
    function zip_exn(t1, t2) {
        return t1.length - 1 !== t2.length - 1 ? caml_call1(Base_Import[124], cst_Array_zip_exn) : map2_exn(t1, t2, function(x1, x2) {
            return [
                0,
                x1,
                x2
            ];
        });
    }
    function unzip(t) {
        var n = t.length - 1;
        if (0 === n) return [
            0,
            [
                0
            ],
            [
                0
            ]
        ];
        var match = caml_check_bound(t, 0)[1], y = match[2], x = match[1], res1 = caml_call2(create, n, x), res2 = caml_call2(create, n, y), _y_ = caml_call2(Base_Import[93], n, 1), _x_ = 1;
        if (_y_ >= 1) {
            var i = _x_;
            for(;;){
                var match$0 = caml_check_bound(t, i)[1 + i], y$0 = match$0[2], x$0 = match$0[1];
                caml_check_bound(res1, i)[1 + i] = x$0;
                caml_check_bound(res2, i)[1 + i] = y$0;
                var _z_ = i + 1 | 0;
                if (_y_ === i) break;
                i = _z_;
            }
        }
        return [
            0,
            res1,
            res2
        ];
    }
    function sorted_copy(t, compare) {
        var t1 = caml_call1(copy, t);
        sort(0, 0, t1, compare);
        return t1;
    }
    function partition_mapi(t, f) {
        var both = caml_call2(mapi, t, f), firsts = filter_map(both, function(param) {
            if (0 !== param[0]) return 0;
            var x = param[1];
            return [
                0,
                x
            ];
        }), seconds = filter_map(both, function(param) {
            if (0 === param[0]) return 0;
            var x = param[1];
            return [
                0,
                x
            ];
        });
        return [
            0,
            firsts,
            seconds
        ];
    }
    function partitioni_tf(t, f) {
        return partition_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : [
                1,
                x
            ];
        });
    }
    function partition_map(t, f) {
        return partition_mapi(t, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function partition_tf(t, f) {
        return partitioni_tf(t, function(param, x) {
            return caml_call1(f, x);
        });
    }
    function last(t) {
        var _w_ = caml_call2(Base_Import[93], t.length - 1, 1);
        return caml_check_bound(t, _w_)[1 + _w_];
    }
    function to_sequence_mutable(t) {
        return caml_call2(Base_Sequence[44], 0, function(i) {
            if (t.length - 1 <= i) return 0;
            var _v_ = caml_call2(Base_Import[91], i, 1);
            return [
                1,
                caml_check_bound(t, i)[1 + i],
                _v_
            ];
        });
    }
    function to_sequence(t) {
        return to_sequence_mutable(caml_call1(copy, t));
    }
    function cartesian_product(t1, t2) {
        if (!is_empty(t1) && !is_empty(t2)) {
            var n1 = t1.length - 1, n2 = t2.length - 1, _k_ = caml_check_bound(t2, 0)[1], _l_ = [
                0,
                caml_check_bound(t1, 0)[1],
                _k_
            ], t = caml_call2(create, caml_call2(Base_Import[88], n1, n2), _l_), r = [
                0,
                0
            ], _n_ = caml_call2(Base_Import[93], n1, 1), _m_ = 0;
            if (_n_ >= 0) {
                var i1 = _m_;
                for(;;){
                    var _p_ = caml_call2(Base_Import[93], n2, 1), _o_ = 0;
                    if (_p_ >= 0) {
                        var i2 = _o_;
                        for(;;){
                            var _r_ = caml_check_bound(t2, i2)[1 + i2], _s_ = [
                                0,
                                caml_check_bound(t1, i1)[1 + i1],
                                _r_
                            ], _t_ = r[1];
                            caml_check_bound(t, _t_)[1 + _t_] = _s_;
                            r[1]++;
                            var _u_ = i2 + 1 | 0;
                            if (_p_ === i2) break;
                            i2 = _u_;
                        }
                    }
                    var _q_ = i1 + 1 | 0;
                    if (_n_ === i1) break;
                    i1 = _q_;
                }
            }
            return t;
        }
        return [
            0
        ];
    }
    function transpose(tt) {
        if (0 === tt.length - 1) return [
            0,
            [
                0
            ]
        ];
        var width = tt.length - 1, depth = caml_check_bound(tt, 0)[1].length - 1;
        return exists(tt, function(t) {
            return t.length - 1 !== depth ? 1 : 0;
        }) ? 0 : [
            0,
            caml_call2(init, depth, function(d) {
                return caml_call2(init, width, function(w) {
                    return caml_check_bound(caml_check_bound(tt, w)[1 + w], d)[1 + d];
                });
            })
        ];
    }
    function transpose_exn(tt) {
        var match = transpose(tt);
        if (!match) return caml_call1(Base_Import[126], cst_Array_transpose_exn);
        var tt$0 = match[1];
        return tt$0;
    }
    function get$0(_j_, _i_) {
        return caml_check_bound(_j_, _i_)[1 + _i_];
    }
    function length$0(_h_) {
        return _h_.length - 1;
    }
    var include = caml_call1(Base_Binary_searchable[2], [
        0,
        get$0,
        length$0
    ]), binary_search = include[1], binary_search_segmented = include[2], _e_ = [
        0,
        cst_src_array_ml,
        917,
        6
    ];
    function length$1(_g_) {
        return _g_.length - 1;
    }
    function create_like(len, t) {
        if (0 === len) return [
            0
        ];
        if (0 < t.length - 1) return caml_call2(create, len, caml_check_bound(t, 0)[1]);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    var unsafe_blit = runtime.caml_array_blit, include$0 = caml_call1(Base_Blit[4], [
        0,
        create_like,
        length$1,
        unsafe_blit
    ]), blit = include$0[1], blito = include$0[2], unsafe_blit$0 = include$0[3], sub$0 = include$0[4], subo = include$0[5];
    function invariant(invariant_a, t) {
        return caml_call2(iter, t, invariant_a);
    }
    var Base_Array = [
        0,
        compare,
        compare_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        binary_search,
        binary_search_segmented,
        of_list,
        of_array,
        append,
        map,
        filter,
        filter_map,
        concat_map,
        partition_tf,
        partition_map,
        mem,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        concat_mapi,
        invariant,
        max_length,
        create,
        create_local,
        create_float_uninitialized,
        make_matrix,
        copy_matrix,
        concat,
        copy,
        fill,
        blit,
        blito,
        unsafe_blit$0,
        sub$0,
        subo,
        folding_map,
        folding_mapi,
        fold_map,
        fold_mapi,
        fold_right,
        sort,
        stable_sort,
        is_sorted,
        is_sorted_strictly,
        merge,
        partitioni_tf,
        cartesian_product,
        transpose,
        transpose_exn,
        filter_opt,
        iter2_exn,
        map2_exn,
        fold2_exn,
        for_all2_exn,
        exists2_exn,
        swap,
        rev_inplace,
        rev,
        of_list_rev,
        of_list_map,
        of_list_mapi,
        of_list_rev_map,
        of_list_rev_mapi,
        map_inplace,
        find_exn,
        find_map_exn,
        findi_exn,
        find_mapi_exn,
        find_consecutive_duplicate,
        reduce,
        reduce_exn,
        permute,
        random_element,
        random_element_exn,
        zip,
        zip_exn,
        unzip,
        sorted_copy,
        last,
        equal,
        equal_local,
        to_sequence,
        to_sequence_mutable,
        [
            0,
            [
                0,
                Sort[5],
                Sort[6],
                Sort[7]
            ],
            function(_f_) {
                return [
                    0,
                    Sorter(_f_)[8]
                ];
            }
        ]
    ];
    runtime.caml_register_global(29, Base_Array, "Base__Array");
    return;
})(globalThis);
//# 17982 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_float0_ml = "src/float0.ml", caml_int64_bits_of_float = runtime.caml_int64_bits_of_float, caml_int64_float_of_bits = runtime.caml_int64_float_of_bits, caml_int64_neg = runtime.caml_int64_neg, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Assert_failure = global_data.Assert_failure, Base_Option = global_data.Base__Option, Base_Printf = global_data.Base__Printf, Stdlib_Float = global_data.Stdlib__Float;
    function ceil(_p_) {
        return Math.ceil(_p_);
    }
    function floor(_o_) {
        return Math.floor(_o_);
    }
    function mod_float(_n_, _m_) {
        return _n_ % _m_;
    }
    var modf = runtime.caml_modf_float, float_of_string = runtime.caml_float_of_string, float_of_string_opt = Base_Import[85][36], nan = Base_Import[85][24], infinity = Base_Import[85][22], neg_infinity = Base_Import[85][23], max_finite_value = Base_Import[85][25], epsilon_float = Base_Import[85][27], classify_float = runtime.caml_classify_float;
    function abs_float(_l_) {
        return Math.abs(_l_);
    }
    var is_integer = Stdlib_Float[18], _a_ = [
        0,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            8,
                            [
                                0,
                                0,
                                0
                            ],
                            0,
                            0,
                            [
                                11,
                                " in float0.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%f %% %f in float0.ml: modulus should be positive"
    ];
    function symbol(_k_, _j_) {
        return Math.pow(_k_, _j_);
    }
    function symbol$0(a, b) {
        if (b < 0.) caml_call4(Base_Printf[7], _a_, a, b, 0);
        var m = a % b;
        return m < 0. ? caml_call2(Base_Import[92], m, b) : m;
    }
    var frexp = runtime.caml_frexp_float, ldexp = runtime.caml_ldexp_float, _b_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(0, 0, 0)
    ], _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), _e_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _f_ = [
        0,
        cst_src_float0_ml,
        190,
        4
    ], _g_ = [
        0,
        cst_src_float0_ml,
        186,
        4
    ];
    function is_nan(x) {
        return x !== x ? 1 : 0;
    }
    function to_int64_preserve_order(t) {
        return t !== t ? 0 : t === 0. ? _b_ : 0. < t ? [
            0,
            caml_int64_bits_of_float(t)
        ] : [
            0,
            caml_int64_neg(caml_int64_bits_of_float(caml_call1(Base_Import[114], t)))
        ];
    }
    function to_int64_preserve_order_exn(x) {
        var _i_ = to_int64_preserve_order(x);
        return caml_call4(Base_Option[31], 0, 0, 0, _i_);
    }
    function of_int64_preserve_order(x) {
        return runtime.caml_greaterequal(x, _c_) ? caml_int64_float_of_bits(x) : caml_call1(Base_Import[114], caml_int64_float_of_bits(caml_int64_neg(x)));
    }
    function one_ulp(dir, t) {
        var match = to_int64_preserve_order(t);
        if (!match) return Base_Import[85][24];
        var x = match[1], _h_ = 759637122 <= dir ? _d_ : _e_;
        return of_int64_preserve_order(runtime.caml_int64_add(x, _h_));
    }
    function upper_bound_for_int(num_bits) {
        var exp = caml_call2(Base_Import[93], num_bits, 1);
        return one_ulp(759637122, Math.pow(2., exp));
    }
    function is_x_minus_one_exact(x) {
        return 1 - runtime.caml_equal(caml_int64_bits_of_float(x), caml_int64_bits_of_float(caml_call2(Base_Import[94], x, 1.)));
    }
    function lower_bound_for_int(num_bits) {
        var exp = caml_call2(Base_Import[93], num_bits, 1), min_int_as_float = caml_call1(Base_Import[114], Math.pow(2., exp));
        if (53 <= caml_call2(Base_Import[93], num_bits, 1)) {
            if (is_x_minus_one_exact(min_int_as_float)) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _f_
            ], 1);
            return min_int_as_float;
        }
        if (is_x_minus_one_exact(min_int_as_float)) return one_ulp(19067, caml_call2(Base_Import[94], min_int_as_float, 1.));
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _g_
        ], 1);
    }
    function min(a, b) {
        return runtime.caml_sse2_float64_min_bytecode(a, b);
    }
    function max(a, b) {
        return runtime.caml_sse2_float64_max_bytecode(a, b);
    }
    var Intrinsics_with_weird_nan_beha = [
        0,
        min,
        max
    ];
    function clamp_unchecked(to_clamp_maybe_nan, min_which_is_not_nan, max_which_is_not_nan) {
        var t_maybe_nan = caml_call2(Intrinsics_with_weird_nan_beha[2], min_which_is_not_nan, to_clamp_maybe_nan);
        return caml_call2(Intrinsics_with_weird_nan_beha[1], max_which_is_not_nan, t_maybe_nan);
    }
    var x = 0.;
    function box(f) {
        return caml_call2(Base_Import[92], f, x);
    }
    var include = Base_Import[108], ascending = include[1], descending = include[2], compare_local = include[3], equal_local = include[4], max$0 = include[5], min$0 = include[6], Base_Float0 = [
        0,
        ceil,
        floor,
        mod_float,
        modf,
        float_of_string,
        float_of_string_opt,
        nan,
        infinity,
        neg_infinity,
        max_finite_value,
        epsilon_float,
        classify_float,
        abs_float,
        is_integer,
        symbol,
        symbol$0,
        frexp,
        ldexp,
        is_nan,
        to_int64_preserve_order,
        to_int64_preserve_order_exn,
        of_int64_preserve_order,
        one_ulp,
        upper_bound_for_int,
        is_x_minus_one_exact,
        lower_bound_for_int,
        Intrinsics_with_weird_nan_beha,
        clamp_unchecked,
        box,
        ascending,
        descending,
        compare_local,
        equal_local,
        max$0,
        min$0
    ];
    runtime.caml_register_global(21, Base_Float0, "Base__Float0");
    return;
})(globalThis);
//# 18195 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Int_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Int_intf, "Base__Int_intf");
    return;
})(globalThis);
//# 18205 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), overflow_bound_max_int63_on_in = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), overflow_bound_max_int64_value = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767), Base_Import = global_data.Base__Import, Base_Int_conversions = global_data.Base__Int_conversions, Assert_failure = global_data.Assert_failure, Base_Array0 = global_data.Base__Array0, int32_positive_overflow_bounds = [
        0,
        2147483647,
        2147483647,
        46340,
        1290,
        215,
        73,
        35,
        21,
        14,
        10,
        8,
        7,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ].slice(), overflow_bound_max_int_value = caml_call2(Base_Import[120], -1, 1), switcher = Base_Int_conversions[30] - 31 | 0, _g_ = [
        0,
        "src/pow_overflow_bounds.ml",
        216,
        9
    ], _a_ = runtime.caml_int64_create_lo_mi_hi(16777215, 127, 0), _b_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), _c_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383), _h_ = [
        0,
        1073741823,
        1073741823,
        32767,
        1023,
        181,
        63,
        31,
        19,
        13,
        10,
        7,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ], _d_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 16383),
        runtime.caml_int64_create_lo_mi_hi(16777215, 127, 0),
        runtime.caml_int64_create_lo_mi_hi(1664510, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(46340, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5404, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1290, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(463, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(215, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(118, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(73, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(49, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(35, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(27, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(21, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(17, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(14, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(12, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(10, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(9, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(8, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0)
    ], _e_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 32767),
        runtime.caml_int64_create_lo_mi_hi(324403, 181, 0),
        runtime.caml_int64_create_lo_mi_hi(2097151, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(55108, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6208, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1448, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(511, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(234, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(127, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(78, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(52, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(38, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(28, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(22, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(18, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(15, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(13, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(11, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(9, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(8, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(7, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(6, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(5, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(4, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(3, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(2, 0, 0),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 0)
    ], _f_ = [
        0,
        runtime.caml_int64_create_lo_mi_hi(1, 0, 32768),
        runtime.caml_int64_create_lo_mi_hi(1, 0, 32768),
        runtime.caml_int64_create_lo_mi_hi(16452813, 16777034, 65535),
        runtime.caml_int64_create_lo_mi_hi(14680065, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16722108, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16771008, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16775768, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16776705, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16776982, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777089, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777138, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777164, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777178, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777188, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777194, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777198, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777201, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777203, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777205, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777207, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777208, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777209, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777209, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777210, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777210, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777211, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777212, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777213, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535),
        runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535)
    ], overflow_bound_max_int32_value = 2147483647;
    if (1 < switcher >>> 0) {
        if (32 !== switcher) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _g_
        ], 1);
        var int_positive_overflow_bounds = [
            0,
            caml_int64_to_int32(_c_),
            caml_int64_to_int32(_b_),
            caml_int64_to_int32(_a_),
            1664510,
            46340,
            5404,
            1290,
            463,
            215,
            118,
            73,
            49,
            35,
            27,
            21,
            17,
            14,
            12,
            10,
            9,
            8,
            7,
            7,
            6,
            5,
            5,
            5,
            4,
            4,
            4,
            4,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            1,
            1
        ];
    } else var int_positive_overflow_bounds = switcher ? caml_call2(Base_Array0[21], int32_positive_overflow_bounds, function(_i_) {
        return _i_;
    }) : _h_.slice();
    var int63_on_int64_positive_overfl = _d_.slice(), int64_positive_overflow_bounds = _e_.slice(), int64_negative_overflow_bounds = _f_.slice(), Base_Pow_overflow_bounds = [
        0,
        overflow_bound_max_int32_value,
        int32_positive_overflow_bounds,
        overflow_bound_max_int_value,
        int_positive_overflow_bounds,
        overflow_bound_max_int63_on_in,
        int63_on_int64_positive_overfl,
        overflow_bound_max_int64_value,
        int64_positive_overflow_bounds,
        int64_negative_overflow_bounds
    ];
    runtime.caml_register_global(16, Base_Pow_overflow_bounds, "Base__Pow_overflow_bounds");
    return;
})(globalThis);
//# 18668 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_exponent_can_not_be_negati = "exponent can not be negative", cst_integer_overflow_in_pow = "integer overflow in pow", caml_check_bound = runtime.caml_check_bound, caml_greaterthan = runtime.caml_greaterthan, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_lessthan = runtime.caml_lessthan;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Pow_overflow_bounds = global_data.Base__Pow_overflow_bounds, Base_Printf = global_data.Base__Printf, Stdlib_Int64 = global_data.Stdlib__Int64, invalid_argf = Base_Printf[7], _a_ = [
        0,
        [
            11,
            cst_exponent_can_not_be_negati,
            0
        ],
        cst_exponent_can_not_be_negati
    ], _b_ = [
        0,
        [
            11,
            cst_integer_overflow_in_pow,
            0
        ],
        cst_integer_overflow_in_pow
    ];
    function negative_exponent(param) {
        return caml_call2(Base_Printf[7], _a_, 0);
    }
    function overflow(param) {
        return caml_call2(Base_Printf[7], _b_, 0);
    }
    function int_pow(base, exponent) {
        if (exponent < 0) negative_exponent(0);
        var _J_ = 1 < caml_call1(Base_Import[123], base) ? 1 : 0;
        if (_J_) {
            var _K_ = 63 < exponent ? 1 : 0;
            if (_K_) var _L_ = _K_;
            else var _M_ = caml_check_bound(Base_Pow_overflow_bounds[4], exponent)[1 + exponent], _L_ = _M_ < caml_call1(Base_Import[123], base) ? 1 : 0;
        } else var _L_ = _J_;
        if (_L_) overflow(0);
        return runtime.Base_int_math_int_pow_stub(base, exponent);
    }
    var abs = Stdlib_Int64[8], _c_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _d_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _e_ = runtime.caml_int64_create_lo_mi_hi(63, 0, 0), _f_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _h_ = runtime.caml_int64_create_lo_mi_hi(16777215, 16777215, 65535), _i_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0), _j_ = runtime.caml_int64_create_lo_mi_hi(1, 0, 0), _k_ = runtime.caml_int64_create_lo_mi_hi(63, 0, 0);
    function int64_pow(base, exponent) {
        if (caml_lessthan(exponent, _c_)) negative_exponent(0);
        var _A_ = caml_greaterthan(base, _d_), _B_ = _A_ || caml_lessthan(base, _h_);
        if (_B_) {
            var _C_ = caml_greaterthan(exponent, _e_);
            if (_C_) var _D_ = _C_;
            else {
                var _E_ = runtime.caml_greaterequal(base, _f_);
                if (_E_) var _F_ = caml_int64_to_int32(exponent), _G_ = caml_greaterthan(base, caml_check_bound(Base_Pow_overflow_bounds[8], _F_)[1 + _F_]);
                else var _G_ = _E_;
                if (_G_) var _D_ = _G_;
                else {
                    var _H_ = caml_lessthan(base, _g_);
                    if (_H_) var _I_ = caml_int64_to_int32(exponent), _D_ = caml_lessthan(base, caml_check_bound(Base_Pow_overflow_bounds[9], _I_)[1 + _I_]);
                    else var _D_ = _H_;
                }
            }
        } else var _D_ = _B_;
        if (_D_) overflow(0);
        return runtime.Base_int_math_int64_pow_stub(base, exponent);
    }
    function int63_pow_on_int64(base, exponent) {
        if (caml_lessthan(exponent, _i_)) negative_exponent(0);
        var _v_ = caml_greaterthan(caml_call1(abs, base), _j_);
        if (_v_) {
            var _w_ = caml_greaterthan(exponent, _k_);
            if (_w_) var _x_ = _w_;
            else var _y_ = caml_int64_to_int32(exponent), _z_ = caml_check_bound(Base_Pow_overflow_bounds[6], _y_)[1 + _y_], _x_ = caml_greaterthan(caml_call1(abs, base), _z_);
        } else var _x_ = _v_;
        if (_x_) overflow(0);
        return runtime.Base_int_math_int64_pow_stub(base, exponent);
    }
    var Private = [
        0,
        int_pow,
        int64_pow,
        int63_pow_on_int64
    ], _l_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %% %s in core_int.ml: modulus should be positive"
    ], _m_ = [
        0,
        [
            2,
            0,
            [
                11,
                " /",
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: divisor should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s /%% %s in core_int.ml: divisor should be positive"
    ], Base_Int_math = [
        0,
        function(X) {
            function symbol(x, y) {
                if (caml_call2(X[11], y, X[18])) {
                    var _u_ = caml_call1(X[4], y);
                    caml_call4(invalid_argf, _l_, caml_call1(X[4], x), _u_, 0);
                }
                var rval = caml_call2(X[20], x, y);
                return caml_call2(X[14], rval, X[18]) ? caml_call2(X[5], rval, y) : rval;
            }
            var one = caml_call1(X[19], 1);
            function symbol$0(x, y) {
                if (caml_call2(X[11], y, X[18])) {
                    var _r_ = caml_call1(X[4], y);
                    caml_call4(invalid_argf, _m_, caml_call1(X[4], x), _r_, 0);
                }
                if (!caml_call2(X[14], x, X[18])) return caml_call2(X[8], x, y);
                var _s_ = caml_call2(X[5], x, one), _t_ = caml_call2(X[8], _s_, y);
                return caml_call2(X[6], _t_, one);
            }
            function symbol$1(x, y) {
                var _p_ = caml_call1(X[2], y), _q_ = caml_call1(X[2], x);
                return caml_call2(Base_Import[96], _q_, _p_);
            }
            function round_down(i, modulus) {
                var _o_ = symbol(i, modulus);
                return caml_call2(X[6], i, _o_);
            }
            function round_up(i, modulus) {
                var remainder = symbol(i, modulus);
                if (caml_call2(X[12], remainder, X[18])) return i;
                var _n_ = caml_call2(X[5], i, modulus);
                return caml_call2(X[6], _n_, remainder);
            }
            function round_towards_zero(i, to_multiple_of) {
                return caml_call2(X[12], i, X[18]) ? X[18] : caml_call2(X[13], i, X[18]) ? round_down(i, to_multiple_of) : round_up(i, to_multiple_of);
            }
            function round_nearest(i, modulus) {
                var remainder = symbol(i, modulus), modulus_minus_remainder = caml_call2(X[6], modulus, remainder);
                return caml_call2(X[11], modulus_minus_remainder, remainder) ? caml_call2(X[5], i, modulus_minus_remainder) : caml_call2(X[6], i, remainder);
            }
            function round(opt, i, to_multiple_of) {
                var dir = opt ? opt[1] : 857423934;
                return 857423934 <= dir ? 1003109192 <= dir ? round_towards_zero(i, to_multiple_of) : round_nearest(i, to_multiple_of) : 759637122 <= dir ? round_down(i, to_multiple_of) : round_up(i, to_multiple_of);
            }
            return [
                0,
                symbol,
                symbol$0,
                symbol$1,
                round,
                round_towards_zero,
                round_down,
                round_up,
                round_nearest
            ];
        },
        Private
    ];
    runtime.caml_register_global(17, Base_Int_math, "Base__Int_math");
    return;
})(globalThis);
//# 18906 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function stage(_b_) {
        return _b_;
    }
    function unstage(_a_) {
        return _a_;
    }
    var Base_Staged = [
        0,
        stage,
        unstage
    ];
    runtime.caml_register_global(0, Base_Staged, "Base__Staged");
    return;
})(globalThis);
//# 18918 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Bytes_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Bytes_intf, "Base__Bytes_intf");
    return;
})(globalThis);
//# 18928 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Char", Base_Import = global_data.Base__Import, Base_Hash = global_data.Base__Hash, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Stdlib_Format = global_data.Stdlib__Format, Base_String0 = global_data.Base__String0, Base_Char0 = global_data.Base__Char0, Base_Identifiable = global_data.Base__Identifiable, Base_Array0 = global_data.Base__Array0, Base_Comparable = global_data.Base__Comparable, failwithf = Base_Char0[1], escaped = Base_Char0[2], lowercase = Base_Char0[3], to_int = Base_Char0[4], unsafe_of_int = Base_Char0[5], uppercase = Base_Char0[6], min_value = Base_Char0[8], max_value = Base_Char0[9], of_int = Base_Char0[10], of_int_exn = Base_Char0[11], compare = Base_Import[226], hash_fold_t = Base_Import[205], func = Base_Import[219];
    function hash(x) {
        return caml_call1(func, x);
    }
    var globalize = Base_Import[282], t_of_sexp = Base_Import[162], sexp_of_t = Base_Import[138], t_sexp_grammar = Base_Import[184], _a_ = [
        0,
        [
            11,
            "Char.of_string: ",
            [
                3,
                0,
                0
            ]
        ],
        "Char.of_string: %S"
    ];
    function to_string(t) {
        return caml_call2(Base_String0[8], 1, t);
    }
    function of_string(s) {
        return 1 === runtime.caml_ml_string_length(s) ? runtime.caml_string_get(s, 0) : caml_call3(failwithf, _a_, s, 0);
    }
    var include = caml_call1(Base_Identifiable[1], [
        0,
        compare,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        module_name
    ]), hash_fold_t$0 = include[1], hash$0 = include[2], t_of_sexp$0 = include[3], sexp_of_t$0 = include[4], of_string$0 = include[5], to_string$0 = include[6], between = include[19], clamp_exn = include[20], clamp = include[21], comparator = include[22], hashable = include[24], _b_ = [
        0,
        [
            1,
            0
        ],
        "%C"
    ];
    function pp(fmt, c) {
        return caml_call3(Stdlib_Format[143], fmt, _b_, c);
    }
    function invariant(param) {
        return 0;
    }
    var _c_ = caml_call2(Base_Array0[12], 256, unsafe_of_int), all = caml_call1(Base_Array0[16], _c_), _d_ = [
        0,
        [
            11,
            "Char.get_digit_exn ",
            [
                1,
                [
                    11,
                    ": not a digit",
                    0
                ]
            ]
        ],
        "Char.get_digit_exn %C: not a digit"
    ], cst_char = "char", cst_Char_get_hex_digit_exn_not = "Char.get_hex_digit_exn: not a hexadecimal digit";
    function is_lowercase(param) {
        return 25 < param - 97 >>> 0 ? 0 : 1;
    }
    function is_uppercase(param) {
        return 25 < param - 65 >>> 0 ? 0 : 1;
    }
    function is_print(param) {
        return 94 < param - 32 >>> 0 ? 0 : 1;
    }
    function is_whitespace(param) {
        a: {
            if (14 <= param) {
                if (32 === param) break a;
            } else if (9 <= param) break a;
            return 0;
        }
        return 1;
    }
    function is_digit(param) {
        return 9 < param - 48 >>> 0 ? 0 : 1;
    }
    function is_alpha(param) {
        a: {
            if (91 <= param) {
                if (25 < param - 97 >>> 0) break a;
            } else if (65 > param) break a;
            return 1;
        }
        return 0;
    }
    function is_alphanum(param) {
        var _v_ = param - 48 | 0;
        a: {
            if (42 < _v_ >>> 0) {
                if (25 < _v_ - 49 >>> 0) break a;
            } else if (6 >= _v_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function get_digit_unsafe(t) {
        var _t_ = caml_call1(to_int, 48), _u_ = caml_call1(to_int, t);
        return caml_call2(Base_Import[93], _u_, _t_);
    }
    function get_digit_exn(t) {
        return is_digit(t) ? get_digit_unsafe(t) : caml_call3(failwithf, _d_, t, 0);
    }
    function get_digit(t) {
        return is_digit(t) ? [
            0,
            get_digit_unsafe(t)
        ] : 0;
    }
    function is_hex_digit(param) {
        var _s_ = param - 48 | 0;
        a: {
            if (22 < _s_ >>> 0) {
                if (5 < _s_ - 49 >>> 0) break a;
            } else if (6 >= _s_ - 10 >>> 0) break a;
            return 1;
        }
        return 0;
    }
    function is_hex_digit_lower(param) {
        a: {
            if (58 <= param) {
                if (5 < param - 97 >>> 0) break a;
            } else if (48 > param) break a;
            return 1;
        }
        return 0;
    }
    function is_hex_digit_upper(param) {
        a: {
            if (58 <= param) {
                if (5 < param - 65 >>> 0) break a;
            } else if (48 > param) break a;
            return 1;
        }
        return 0;
    }
    function get_hex_digit_exn(t) {
        if (65 <= t) {
            if (97 <= t) {
                if (103 > t) {
                    var _k_ = caml_call1(to_int, 97), _l_ = caml_call1(to_int, t), _m_ = caml_call2(Base_Import[93], _l_, _k_);
                    return caml_call2(Base_Import[91], _m_, 10);
                }
            } else if (71 > t) {
                var _n_ = caml_call1(to_int, 65), _o_ = caml_call1(to_int, t), _p_ = caml_call2(Base_Import[93], _o_, _n_);
                return caml_call2(Base_Import[91], _p_, 10);
            }
        } else if (9 >= t - 48 >>> 0) {
            var _q_ = caml_call1(to_int, 48), _r_ = caml_call1(to_int, t);
            return caml_call2(Base_Import[93], _r_, _q_);
        }
        var _i_ = [
            0,
            [
                0,
                cst_char,
                caml_call1(sexp_of_t$0, t)
            ],
            0
        ], _j_ = caml_call2(Base_Sexp[10], cst_Char_get_hex_digit_exn_not, _i_);
        return caml_call1(Base_Error[32], _j_);
    }
    function get_hex_digit(t) {
        return is_hex_digit(t) ? [
            0,
            get_hex_digit_exn(t)
        ] : 0;
    }
    var symbol = Base_Import[106][6], symbol$0 = Base_Import[106][2], symbol$1 = Base_Import[106][4], symbol$2 = Base_Import[106][5], symbol$3 = Base_Import[106][1], symbol$4 = Base_Import[106][3], O = [
        0,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4
    ], t_of_sexp$1 = Base_Import[162], sexp_of_t$1 = Base_Import[138], t_sexp_grammar$0 = Base_Import[184];
    function compare$0(c1, c2) {
        var _g_ = caml_call1(lowercase, c2), _h_ = caml_call1(lowercase, c1);
        return caml_call2(Base_Import[106][9], _h_, _g_);
    }
    function compare_local(c1, c2) {
        return compare$0(c1, c2);
    }
    function hash_fold_t$1(state, t) {
        var _f_ = caml_call1(lowercase, t);
        return caml_call2(Base_Import[205], state, _f_);
    }
    function hash$1(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t$1, t);
    }
    var include$0 = caml_call1(Base_Comparable[11], [
        0,
        compare$0,
        sexp_of_t$1
    ]), symbol$5 = include$0[1], symbol$6 = include$0[2], symbol$7 = include$0[3], symbol$8 = include$0[4], symbol$9 = include$0[5], symbol$10 = include$0[6], equal = include$0[7], compare$1 = include$0[8], min = include$0[9], max = include$0[10], ascending = include$0[11], descending = include$0[12], between$0 = include$0[13], clamp_exn$0 = include$0[14], clamp$0 = include$0[15], comparator$0 = include$0[16];
    function equal_local(t1, t2) {
        var _e_ = compare$0(t1, t2);
        return caml_call2(Base_Import[242], _e_, 0);
    }
    var include$1 = Base_Import[106], symbol$11 = include$1[1], symbol$12 = include$1[2], symbol$13 = include$1[3], symbol$14 = include$1[4], symbol$15 = include$1[5], symbol$16 = include$1[6], ascending$0 = include$1[7], descending$0 = include$1[8], compare$2 = include$1[9], compare_local$0 = include$1[10], equal$0 = include$1[11], equal_local$0 = include$1[12], max$0 = include$1[13], min$0 = include$1[14], Base_Char = [
        0,
        all,
        globalize,
        t_sexp_grammar,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol$16,
        symbol$12,
        symbol$14,
        symbol$15,
        symbol$11,
        symbol$13,
        equal$0,
        compare$2,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        equal_local$0,
        compare_local$0,
        invariant,
        O,
        to_int,
        of_int,
        of_int_exn,
        unsafe_of_int,
        escaped,
        lowercase,
        uppercase,
        is_digit,
        is_lowercase,
        is_uppercase,
        is_alpha,
        is_alphanum,
        is_print,
        is_whitespace,
        get_digit,
        get_digit_exn,
        is_hex_digit,
        is_hex_digit_lower,
        is_hex_digit_upper,
        get_hex_digit,
        get_hex_digit_exn,
        min_value,
        max_value,
        [
            0,
            hash_fold_t$1,
            hash$1,
            t_of_sexp$1,
            sexp_of_t$1,
            t_sexp_grammar$0,
            symbol$5,
            symbol$6,
            symbol$7,
            symbol$8,
            symbol$9,
            symbol$10,
            equal,
            compare$1,
            min,
            max,
            ascending,
            descending,
            between$0,
            clamp_exn$0,
            clamp$0,
            comparator$0,
            equal_local,
            compare_local
        ]
    ];
    runtime.caml_register_global(16, Base_Char, "Base__Char");
    return;
})(globalThis);
//# 19279 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_unsafe_get = runtime.caml_string_unsafe_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Char = global_data.Base__Char, Base_Bytes0 = global_data.Base__Bytes0, Base_Import0 = global_data.Base__Import0;
    function tr_create_map(target, replacement) {
        var tr_map = caml_call1(Base_Bytes0[7], 256), i$3 = 0;
        for(;;){
            caml_bytes_unsafe_set(tr_map, i$3, caml_call1(Base_Char[34], i$3));
            var _j_ = i$3 + 1 | 0;
            if (255 === i$3) break;
            i$3 = _j_;
        }
        var _b_ = caml_call2(Base_Import0[97][4], caml_ml_string_length(target), caml_ml_string_length(replacement)) - 1 | 0, _a_ = 0;
        if (_b_ >= 0) {
            var i$2 = _a_;
            for(;;){
                var index$0 = caml_call1(Base_Char[32], caml_string_unsafe_get(target, i$2));
                caml_bytes_unsafe_set(tr_map, index$0, caml_string_unsafe_get(replacement, i$2));
                var _i_ = i$2 + 1 | 0;
                if (_b_ === i$2) break;
                i$2 = _i_;
            }
        }
        var last_replacement = caml_string_unsafe_get(replacement, caml_ml_string_length(replacement) - 1 | 0), _c_ = caml_call2(Base_Import0[97][4], caml_ml_string_length(target), caml_ml_string_length(replacement)), _d_ = caml_ml_string_length(target) - 1 | 0;
        if (_d_ >= _c_) {
            var i$1 = _c_;
            for(;;){
                var index = caml_call1(Base_Char[32], caml_string_unsafe_get(target, i$1));
                caml_bytes_unsafe_set(tr_map, index, last_replacement);
                var _h_ = i$1 + 1 | 0;
                if (_d_ === i$1) break;
                i$1 = _h_;
            }
        }
        var first_target = runtime.caml_string_get(target, 0), _f_ = caml_bytes_unsafe_get(tr_map, caml_call1(Base_Char[32], first_target));
        if (!caml_call2(Base_Char[15], _f_, first_target)) {
            var i = 0;
            for(;;){
                if (256 === i) var _g_ = 0;
                else {
                    var _e_ = caml_call1(Base_Char[34], i);
                    if (!caml_call2(Base_Char[15], caml_bytes_unsafe_get(tr_map, i), _e_)) {
                        var i$0 = i + 1 | 0;
                        i = i$0;
                        continue;
                    }
                    var _g_ = 1;
                }
                if (_g_) break;
                return 0;
            }
        }
        return [
            0,
            runtime.caml_string_of_bytes(tr_map)
        ];
    }
    var Base_Bytes_tr = [
        0,
        tr_create_map
    ];
    runtime.caml_register_global(3, Base_Bytes_tr, "Base__Bytes_tr");
    return;
})(globalThis);
//# 19381 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_String_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_String_intf, "Base__String_intf");
    return;
})(globalThis);
//# 19391 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$15 = "", cst_case_sensitive = "case_sensitive", cst_char$1 = "char", cst_escape_char$1 = "escape_char", cst_pattern = "pattern", cst_pos$2 = "pos", cst_src_string_ml = "src/string.ml", cst_str$1 = "str", caml_blit_string = runtime.caml_blit_string, caml_bytes_set = runtime.caml_bytes_set, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_string_of_bytes = runtime.caml_string_of_bytes, caml_string_unsafe_get = runtime.caml_string_unsafe_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst$14 = cst$15, cst$13 = cst$15, cst$12 = cst$15, cst$11 = cst$15, cst$10 = cst$15, cst$8 = cst$15, cst$9 = cst$15, cst$6 = cst$15, cst$7 = cst$15, cst$5 = cst$15, cst$4 = cst$15, cst$3 = cst$15, cst$2 = cst$15, cst$1 = cst$15, cst$0 = cst$15, cst = cst$15, codec_name = "UTF-8", module_name = "Base.String.Utf8", codec_name$0 = "UTF-16LE", module_name$0 = "Base.String.Utf16le", codec_name$1 = "UTF-16BE", module_name$1 = "Base.String.Utf16be", codec_name$2 = "UTF-32LE", module_name$2 = "Base.String.Utf32le", codec_name$3 = "UTF-32BE", module_name$3 = "Base.String.Utf32be", Base_Char = global_data.Base__Char, Base_Import = global_data.Base__Import, Base_Uchar0 = global_data.Base__Uchar0, Base_Bytes0 = global_data.Base__Bytes0, Assert_failure = global_data.Assert_failure, Base_List = global_data.Base__List, Base_Sequence = global_data.Base__Sequence, Base_Sexp = global_data.Base__Sexp, CamlinternalLazy = global_data.CamlinternalLazy, Base_Printf = global_data.Base__Printf, Base_Sexpable = global_data.Base__Sexpable, Base_Identifiable = global_data.Base__Identifiable, Base_Indexed_container = global_data.Base__Indexed_container, Base_Or_error = global_data.Base__Or_error, Base_Option = global_data.Base__Option, Base_Array0 = global_data.Base__Array0, Base_Int0 = global_data.Base__Int0, Stdlib_Format = global_data.Stdlib__Format, Base_Bytes_tr = global_data.Base__Bytes_tr, Base_Container = global_data.Base__Container, Base_Hash = global_data.Base__Hash, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_String0 = global_data.Base__String0, Base_Error = global_data.Base__Error, Base_Staged = global_data.Base__Staged, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, max_length = Base_String0[2], symbol_concat = Base_String0[3], capitalize = Base_String0[4], compare = Base_String0[5], escaped = Base_String0[6], lowercase = Base_String0[7], make = Base_String0[8], uncapitalize = Base_String0[10], uppercase = Base_String0[11], is_valid_utf_8 = Base_String0[12], is_valid_utf_16le = Base_String0[13], is_valid_utf_16be = Base_String0[14], get_utf_8_uchar = Base_String0[15], get_utf_16le_uchar = Base_String0[16], get_utf_16be_uchar = Base_String0[17], get_utf_32le_uchar = Base_String0[18], get_utf_32be_uchar = Base_String0[19], concat = Base_String0[20], iter = Base_String0[21], split_lines = Base_String0[22], invalid_argf = Base_Printf[7], raise_s = Base_Error[32], stage = Base_Staged[1], globalize = Base_Import[289], hash_fold_t = Base_Import[208], func = Base_Import[222];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[160], sexp_of_t = Base_Import[136], t_sexp_grammar = Base_Import[182], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], _a_ = [
        0,
        "String.index_exn: not found"
    ], _b_ = [
        0,
        "String.index_from_exn: not found"
    ], cst_String_index_from_exn = "String.index_from_exn", _c_ = [
        0,
        "String.rindex_exn: not found"
    ], _d_ = [
        0,
        "String.rindex_from_exn: not found"
    ], cst_String_rindex_from_exn = "String.rindex_from_exn", _e_ = [
        0,
        cst_case_sensitive
    ], _f_ = [
        0,
        cst_pattern
    ], cst_substring = "substring", cst_Substring_not_found = "Substring not found", _g_ = [
        0,
        "kmp_array"
    ], _h_ = [
        0,
        cst_case_sensitive
    ], _i_ = [
        0,
        cst_pattern
    ];
    function invariant(param) {
        return 0;
    }
    function unsafe_sub(src, pos, len) {
        if (0 === len) return cst;
        var dst = caml_call1(Base_Bytes0[7], len);
        caml_blit_string(src, pos, dst, 0, len);
        return caml_string_of_bytes(dst);
    }
    function sub(src, pos, len) {
        if (0 === pos && len === caml_ml_string_length(src)) return src;
        caml_call3(Base_Ordered_collection_common[2], pos, len, caml_ml_string_length(src));
        return unsafe_sub(src, pos, len);
    }
    function subo(opt, len, src) {
        var pos = opt ? opt[1] : 0;
        if (len) var i = len[1], i$0 = i;
        else var i$0 = caml_call2(Base_Import[93], caml_ml_string_length(src), pos);
        return sub(src, pos, i$0);
    }
    function contains(opt, len, t, char$0) {
        var pos$1 = opt ? opt[1] : 0, total_length = caml_ml_string_length(t), _ej_ = caml_call2(Base_Import[93], total_length, pos$1), len$0 = caml_call2(Base_Option[30], len, _ej_);
        caml_call3(Base_Ordered_collection_common[2], pos$1, len$0, total_length);
        var end = caml_call2(Base_Import[91], pos$1, len$0), pos = pos$1;
        for(;;){
            var _eg_ = pos < end ? 1 : 0;
            if (_eg_) {
                var _eh_ = caml_call2(Base_Char[16], caml_string_unsafe_get(t, pos), char$0);
                if (!_eh_) {
                    var pos$0 = caml_call2(Base_Import[91], pos, 1);
                    pos = pos$0;
                    continue;
                }
                var _ei_ = _eh_;
            } else var _ei_ = _eg_;
            return _ei_;
        }
    }
    function is_empty(t) {
        return 0 === caml_ml_string_length(t) ? 1 : 0;
    }
    function index_from_internal(string, len, not_found, found, char$0, pos) {
        var pos$0 = pos;
        for(;;){
            if (len <= pos$0) return caml_call1(not_found, 0);
            if (caml_call2(Base_Char[16], caml_string_unsafe_get(string, pos$0), char$0)) return caml_call1(found, pos$0);
            var pos$1 = caml_call2(Base_Import[91], pos$0, 1);
            pos$0 = pos$1;
        }
    }
    function index(t, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            return 0;
        }, Base_Option[49], char$0, 0);
    }
    function index_exn(t, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _a_
            ], 1);
        }, function(_ef_) {
            return _ef_;
        }, char$0, 0);
    }
    function index_from(t, pos, char$0) {
        return index_from_internal(t, caml_ml_string_length(t), function(param) {
            return 0;
        }, Base_Option[49], char$0, pos);
    }
    function not_found(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _b_
        ], 1);
    }
    function index_from_exn(t, pos, char$0) {
        var len = caml_ml_string_length(t);
        if (0 <= pos && len >= pos) return index_from_internal(t, len, not_found, function(_ee_) {
            return _ee_;
        }, char$0, pos);
        return caml_call1(Base_Import[126], cst_String_index_from_exn);
    }
    function rindex_from_internal(string, char$0, found, not_found, pos) {
        var pos$0 = pos;
        for(;;){
            if (0 > pos$0) return caml_call1(not_found, 0);
            if (caml_call2(Base_Char[16], caml_string_unsafe_get(string, pos$0), char$0)) return caml_call1(found, pos$0);
            var pos$1 = caml_call2(Base_Import[93], pos$0, 1);
            pos$0 = pos$1;
        }
    }
    function rindex(t, char$0) {
        var _ed_ = caml_call2(Base_Import[93], caml_ml_string_length(t), 1);
        return rindex_from_internal(t, char$0, Base_Option[49], function(param) {
            return 0;
        }, _ed_);
    }
    function rindex_exn(t, char$0) {
        return rindex_from_internal(t, char$0, function(_ec_) {
            return _ec_;
        }, function(param) {
            throw caml_maybe_attach_backtrace([
                0,
                Base_Import[297],
                _c_
            ], 1);
        }, caml_call2(Base_Import[93], caml_ml_string_length(t), 1));
    }
    function rindex_from(t, pos, char$0) {
        return rindex_from_internal(t, char$0, Base_Option[49], function(param) {
            return 0;
        }, pos);
    }
    function not_found$0(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _d_
        ], 1);
    }
    function rindex_from_exn(t, pos, char$0) {
        if (-1 <= pos && caml_ml_string_length(t) > pos) return rindex_from_internal(t, char$0, function(_eb_) {
            return _eb_;
        }, not_found$0, pos);
        return caml_call1(Base_Import[126], cst_String_rindex_from_exn);
    }
    function sexp_of_t$0(param) {
        var case_sensitive = param[2], pattern = param[1], _ea_ = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        caml_call1(Base_Import[135], case_sensitive),
                        0
                    ]
                ]
            ],
            0
        ];
        return [
            1,
            [
                0,
                [
                    1,
                    [
                        0,
                        _f_,
                        [
                            0,
                            caml_call1(Base_Import[136], pattern),
                            0
                        ]
                    ]
                ],
                _ea_
            ]
        ];
    }
    function pattern(t) {
        return t[1];
    }
    function case_sensitive(t) {
        return t[2];
    }
    function kmp_internal_loop(matched_chars, next_text_char, pattern, kmp_array, char_equal) {
        var matched_chars$0 = [
            0,
            matched_chars
        ];
        for(;;){
            if (0 < matched_chars$0[1] && !caml_call2(char_equal, next_text_char, caml_string_unsafe_get(pattern, matched_chars$0[1]))) {
                matched_chars$0[1] = kmp_array[1 + caml_call2(Base_Import[93], matched_chars$0[1], 1)];
                continue;
            }
            if (caml_call2(char_equal, next_text_char, caml_string_unsafe_get(pattern, matched_chars$0[1]))) matched_chars$0[1] = caml_call2(Base_Import[91], matched_chars$0[1], 1);
            return matched_chars$0[1];
        }
    }
    function get_char_equal(case_sensitive) {
        return case_sensitive ? Base_Char[16] : Base_Char[55][12];
    }
    function create(pattern, case_sensitive) {
        var n = caml_ml_string_length(pattern), kmp_array = caml_call2(Base_Array0[4], n, -1);
        if (0 < n) {
            var char_equal = get_char_equal(case_sensitive);
            kmp_array[1] = 0;
            var matched_chars = [
                0,
                0
            ], _d__ = caml_call2(Base_Import[93], n, 1), _d9_ = 1;
            if (_d__ >= 1) {
                var i = _d9_;
                for(;;){
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], caml_string_unsafe_get(pattern, i), pattern, kmp_array, char_equal);
                    kmp_array[1 + i] = matched_chars[1];
                    var _d$_ = i + 1 | 0;
                    if (_d__ === i) break;
                    i = _d$_;
                }
            }
        }
        return [
            0,
            pattern,
            case_sensitive,
            kmp_array
        ];
    }
    function index_internal(opt, param, text) {
        var pos = opt ? opt[1] : 0, kmp_array = param[3], case_sensitive = param[2], pattern = param[1];
        if (0 <= pos && caml_call2(Base_Import[93], caml_ml_string_length(text), caml_ml_string_length(pattern)) >= pos) {
            var char_equal = get_char_equal(case_sensitive), j = [
                0,
                pos
            ], matched_chars = [
                0,
                0
            ], k = caml_ml_string_length(pattern), n = caml_ml_string_length(text);
            for(;;){
                if (j[1] < n && matched_chars[1] < k) {
                    var next_text_char = caml_string_unsafe_get(text, j[1]);
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], next_text_char, pattern, kmp_array, char_equal);
                    j[1] = caml_call2(Base_Import[91], j[1], 1);
                    continue;
                }
                return matched_chars[1] === k ? caml_call2(Base_Import[93], j[1], k) : -1;
            }
        }
        return -1;
    }
    function matches(t, str) {
        return 0 <= index_internal(0, t, str) ? 1 : 0;
    }
    function index$0(pos, t, in$0) {
        var p = index_internal(pos, t, in$0);
        return 0 <= p ? [
            0,
            p
        ] : 0;
    }
    function index_exn$0(pos, t, in$0) {
        var p = index_internal(pos, t, in$0);
        if (0 <= p) return p;
        var _d8_ = [
            0,
            [
                0,
                cst_substring,
                caml_call1(Base_Import[136], t[1])
            ],
            0
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Substring_not_found, _d8_));
    }
    function index_all(param, may_overlap, text) {
        var kmp_array = param[3], case_sensitive = param[2], pattern = param[1];
        if (0 === caml_ml_string_length(pattern)) {
            var _d3_ = caml_call2(Base_Import[91], 1, caml_ml_string_length(text));
            return caml_call2(Base_List[40], _d3_, function(_d7_) {
                return _d7_;
            });
        }
        var char_equal = get_char_equal(case_sensitive), matched_chars = [
            0,
            0
        ], k = caml_ml_string_length(pattern), n = caml_ml_string_length(text), found = [
            0,
            0
        ], _d4_ = 0;
        if (n >= 0) {
            var j = _d4_;
            for(;;){
                if (matched_chars[1] === k) {
                    var _d5_ = found[1];
                    found[1] = [
                        0,
                        caml_call2(Base_Import[93], j, k),
                        _d5_
                    ];
                    matched_chars[1] = may_overlap ? kmp_array[1 + caml_call2(Base_Import[93], k, 1)] : 0;
                }
                if (j < n) {
                    var next_text_char = caml_string_unsafe_get(text, j);
                    matched_chars[1] = kmp_internal_loop(matched_chars[1], next_text_char, pattern, kmp_array, char_equal);
                }
                var _d6_ = j + 1 | 0;
                if (n === j) break;
                j = _d6_;
            }
        }
        return caml_call1(Base_List[63], found[1]);
    }
    function replace_first(pos, t, s, with$0) {
        var match = index$0(pos, t, s);
        if (!match) return s;
        var i = match[1], len_s = caml_ml_string_length(s), len_t = caml_ml_string_length(t[1]), len_with = caml_ml_string_length(with$0), _dX_ = caml_call2(Base_Import[91], len_s, len_with), _dY_ = caml_call2(Base_Import[93], _dX_, len_t), dst = caml_call1(Base_Bytes0[7], _dY_);
        caml_call5(Base_Bytes0[4], s, 0, dst, 0, i);
        caml_call5(Base_Bytes0[4], with$0, 0, dst, i, len_with);
        var _dZ_ = caml_call2(Base_Import[93], len_s, i), _d0_ = caml_call2(Base_Import[93], _dZ_, len_t), _d1_ = caml_call2(Base_Import[91], i, len_with), _d2_ = caml_call2(Base_Import[91], i, len_t);
        caml_call5(Base_Bytes0[4], s, _d2_, dst, _d1_, _d0_);
        return caml_string_of_bytes(dst);
    }
    function replace_all(t, s, with$0) {
        var matches = index_all(t, 0, s);
        if (!matches) return s;
        var len_s = caml_ml_string_length(s), len_t = caml_ml_string_length(t[1]), len_with = caml_ml_string_length(with$0), num_matches = caml_call1(Base_List[45], matches), _dQ_ = caml_call2(Base_Import[93], len_with, len_t), _dR_ = caml_call2(Base_Import[88], _dQ_, num_matches), _dS_ = caml_call2(Base_Import[91], len_s, _dR_), dst = caml_call1(Base_Bytes0[7], _dS_), next_dst_pos = [
            0,
            0
        ], next_src_pos = [
            0,
            0
        ];
        caml_call2(Base_List[19], matches, function(i) {
            var len = caml_call2(Base_Import[93], i, next_src_pos[1]);
            caml_call5(Base_Bytes0[4], s, next_src_pos[1], dst, next_dst_pos[1], len);
            var _dU_ = caml_call2(Base_Import[91], next_dst_pos[1], len);
            caml_call5(Base_Bytes0[4], with$0, 0, dst, _dU_, len_with);
            var _dV_ = caml_call2(Base_Import[91], next_dst_pos[1], len);
            next_dst_pos[1] = caml_call2(Base_Import[91], _dV_, len_with);
            var _dW_ = caml_call2(Base_Import[91], next_src_pos[1], len);
            next_src_pos[1] = caml_call2(Base_Import[91], _dW_, len_t);
            return 0;
        });
        var _dT_ = caml_call2(Base_Import[93], len_s, next_src_pos[1]);
        caml_call5(Base_Bytes0[4], s, next_src_pos[1], dst, next_dst_pos[1], _dT_);
        return caml_string_of_bytes(dst);
    }
    function split_on(t, s) {
        var pattern_len = caml_ml_string_length(t[1]), matches = index_all(t, 0, s), _dM_ = caml_call2(Base_Import[111], matches, [
            0,
            caml_ml_string_length(s),
            0
        ]), _dN_ = [
            0,
            caml_call1(Base_Import[113], pattern_len),
            matches
        ];
        return caml_call3(Base_List[98], _dN_, _dM_, function(i, j) {
            var _dO_ = caml_call2(Base_Import[93], j, i), _dP_ = caml_call2(Base_Import[93], _dO_, pattern_len);
            return sub(s, caml_call2(Base_Import[91], i, pattern_len), _dP_);
        });
    }
    function equal_local(a_003, b_004) {
        if (a_003 === b_004) return 1;
        var _dJ_ = caml_call2(Base_Import[274], a_003[1], b_004[1]);
        if (_dJ_) {
            var _dK_ = caml_call2(Base_Import[267], a_003[2], b_004[2]);
            if (_dK_) return caml_call3(Base_Import[277], Base_Import[270], a_003[3], b_004[3]);
            var _dL_ = _dK_;
        } else var _dL_ = _dJ_;
        return _dL_;
    }
    function equal(a, b) {
        return equal_local(a, b);
    }
    function sexp_of_t$1(param) {
        var kmp_array_012 = param[3], case_sensitive_010 = param[2], pattern_008 = param[1], arg_013 = caml_call2(Base_Import[150], Base_Import[139], kmp_array_012), bnds_007 = [
            0,
            [
                1,
                [
                    0,
                    _g_,
                    [
                        0,
                        arg_013,
                        0
                    ]
                ]
            ],
            0
        ], arg_011 = caml_call1(Base_Import[135], case_sensitive_010), bnds_007$0 = [
            0,
            [
                1,
                [
                    0,
                    _h_,
                    [
                        0,
                        arg_011,
                        0
                    ]
                ]
            ],
            bnds_007
        ], arg_009 = caml_call1(Base_Import[136], pattern_008), bnds_007$1 = [
            0,
            [
                1,
                [
                    0,
                    _i_,
                    [
                        0,
                        arg_009,
                        0
                    ]
                ]
            ],
            bnds_007$0
        ];
        return [
            1,
            bnds_007$1
        ];
    }
    function representation(_dI_) {
        return _dI_;
    }
    function substr_index_gen(case_sensitive, pos, t, pattern) {
        return index$0(pos, create(pattern, case_sensitive), t);
    }
    function substr_index_exn_gen(case_sensitive, pos, t, pattern) {
        return index_exn$0(pos, create(pattern, case_sensitive), t);
    }
    function substr_index_all_gen(case_sensitive, t, may_overlap, pattern) {
        return index_all(create(pattern, case_sensitive), may_overlap, t);
    }
    function substr_replace_first_gen(case_sensitive, pos, t, pattern) {
        var _dG_ = create(pattern, case_sensitive);
        return function(_dH_) {
            return replace_first(pos, _dG_, t, _dH_);
        };
    }
    function substr_replace_all_gen(case_sensitive, t, pattern) {
        var _dE_ = create(pattern, case_sensitive);
        return function(_dF_) {
            return replace_all(_dE_, t, _dF_);
        };
    }
    function is_substring_gen(case_sensitive, t, substring) {
        var _dD_ = substr_index_gen(case_sensitive, 0, t, substring);
        return caml_call1(Base_Option[53], _dD_);
    }
    var _j_ = 1;
    function substr_index(_dA_, _dB_, _dC_) {
        return substr_index_gen(_j_, _dA_, _dB_, _dC_);
    }
    var _k_ = 1;
    function substr_index_exn(_dx_, _dy_, _dz_) {
        return substr_index_exn_gen(_k_, _dx_, _dy_, _dz_);
    }
    var _l_ = 1;
    function substr_index_all(_du_, _dv_, _dw_) {
        return substr_index_all_gen(_l_, _du_, _dv_, _dw_);
    }
    var _m_ = 1;
    function substr_replace_first(_dr_, _ds_, _dt_) {
        return substr_replace_first_gen(_m_, _dr_, _ds_, _dt_);
    }
    var _n_ = 1;
    function substr_replace_all(_dp_, _dq_) {
        return substr_replace_all_gen(_n_, _dp_, _dq_);
    }
    var _o_ = 1, _p_ = [
        0,
        [
            11,
            "String.is_substring_at: invalid index ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " for string of length ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.is_substring_at: invalid index %d for string of length %d"
    ];
    function is_substring(_dn_, _do_) {
        return is_substring_gen(_o_, _dn_, _do_);
    }
    function is_substring_at_gen(str, str_pos$1, sub, char_equal) {
        var str_len = caml_ml_string_length(str), sub_len = caml_ml_string_length(sub), _dk_ = str_pos$1 < 0 ? 1 : 0, _dl_ = _dk_ || (str_len < str_pos$1 ? 1 : 0);
        if (_dl_) caml_call4(invalid_argf, _p_, str_pos$1, str_len, 0);
        var _dm_ = caml_call2(Base_Import[91], str_pos$1, sub_len) <= str_len ? 1 : 0;
        if (!_dm_) return _dm_;
        var str_pos = str_pos$1, sub_pos = 0;
        for(;;){
            if (sub_pos === sub_len) return 1;
            if (!caml_call2(char_equal, caml_string_unsafe_get(str, str_pos), caml_string_unsafe_get(sub, sub_pos))) return 0;
            var sub_pos$0 = caml_call2(Base_Import[91], sub_pos, 1), str_pos$0 = caml_call2(Base_Import[91], str_pos, 1);
            str_pos = str_pos$0;
            sub_pos = sub_pos$0;
        }
    }
    function is_suffix_gen(string, suffix, char_equal) {
        var string_len = caml_ml_string_length(string), suffix_len = caml_ml_string_length(suffix), _dj_ = suffix_len <= string_len ? 1 : 0;
        return _dj_ ? is_substring_at_gen(string, caml_call2(Base_Import[93], string_len, suffix_len), suffix, char_equal) : _dj_;
    }
    function is_prefix_gen(string, prefix, char_equal) {
        var string_len = caml_ml_string_length(string), prefix_len = caml_ml_string_length(prefix), _di_ = prefix_len <= string_len ? 1 : 0;
        return _di_ ? is_substring_at_gen(string, 0, prefix, char_equal) : _di_;
    }
    var t_of_sexp$0 = Base_Import[160], sexp_of_t$2 = Base_Import[136], t_sexp_grammar$0 = Base_Import[182];
    function compare_local(string1, string2) {
        if (string1 === string2) return 0;
        var len2 = caml_ml_string_length(string2), len1 = caml_ml_string_length(string1), pos = 0;
        for(;;){
            if (pos === len1) return pos === len2 ? 0 : -1;
            if (pos === len2) return 1;
            var c2 = caml_string_unsafe_get(string2, pos), c1 = caml_string_unsafe_get(string1, pos), _dg_ = caml_call1(Base_Char[37], c2), _dh_ = caml_call1(Base_Char[37], c1), c = caml_call2(Base_Char[17], _dh_, _dg_);
            if (0 !== c) return c;
            var pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
        }
    }
    function compare$0(a, b) {
        return compare_local(a, b);
    }
    function hash_fold_t$0(state, t) {
        var len = caml_ml_string_length(t), state$0 = [
            0,
            caml_call2(Base_Import[206], state, len)
        ], _dd_ = caml_call2(Base_Import[93], len, 1), _dc_ = 0;
        if (_dd_ >= 0) {
            var pos = _dc_;
            for(;;){
                var _de_ = caml_call1(Base_Char[37], caml_string_unsafe_get(t, pos));
                state$0[1] = caml_call2(Base_Import[205], state$0[1], _de_);
                var _df_ = pos + 1 | 0;
                if (_dd_ === pos) break;
                pos = _df_;
            }
        }
        return state$0[1];
    }
    function hash$0(t) {
        return caml_call3(Base_Hash[14], 0, hash_fold_t$0, t);
    }
    function is_suffix(s, suffix) {
        return is_suffix_gen(s, suffix, Base_Char[55][12]);
    }
    function is_prefix(s, prefix) {
        return is_prefix_gen(s, prefix, Base_Char[55][12]);
    }
    var _q_ = 0;
    function substr_index$0(_c$_, _da_, _db_) {
        return substr_index_gen(_q_, _c$_, _da_, _db_);
    }
    var _r_ = 0;
    function substr_index_exn$0(_c8_, _c9_, _c__) {
        return substr_index_exn_gen(_r_, _c8_, _c9_, _c__);
    }
    var _s_ = 0;
    function substr_index_all$0(_c5_, _c6_, _c7_) {
        return substr_index_all_gen(_s_, _c5_, _c6_, _c7_);
    }
    var _t_ = 0;
    function substr_replace_first$0(_c2_, _c3_, _c4_) {
        return substr_replace_first_gen(_t_, _c2_, _c3_, _c4_);
    }
    var _u_ = 0;
    function substr_replace_all$0(_c0_, _c1_) {
        return substr_replace_all_gen(_u_, _c0_, _c1_);
    }
    var _v_ = 0;
    function is_substring$0(_cY_, _cZ_) {
        return is_substring_gen(_v_, _cY_, _cZ_);
    }
    var _w_ = Base_Char[55][12];
    function is_substring_at(_cV_) {
        return function(_cW_) {
            return function(_cX_) {
                return is_substring_at_gen(_cV_, _cW_, _cX_, _w_);
            };
        };
    }
    var include$0 = caml_call1(Base_Comparable[11], [
        0,
        compare$0,
        sexp_of_t$2
    ]), symbol = include$0[1], symbol$0 = include$0[2], symbol$1 = include$0[3], symbol$2 = include$0[4], symbol$3 = include$0[5], symbol$4 = include$0[6], equal$0 = include$0[7], compare$1 = include$0[8], min = include$0[9], max = include$0[10], ascending = include$0[11], descending = include$0[12], between = include$0[13], clamp_exn = include$0[14], clamp = include$0[15], comparator$0 = include$0[16], _x_ = [
        0,
        [
            11,
            "String.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "String.init %d"
    ], _y_ = [
        0,
        "String.lsplit2_exn: not found"
    ], _z_ = [
        0,
        "String.rsplit2_exn: not found"
    ], cst_expecting_nonnegative_argu = " expecting nonnegative argument", cst_drop_prefix = "drop_prefix", cst_drop_suffix = "drop_suffix", cst_prefix = "prefix", cst_suffix = "suffix", _A_ = [
        0,
        cst_src_string_ml,
        761,
        17
    ], cst_tr_multi_replacement_is_em = "tr_multi replacement is empty string", _B_ = [
        0,
        cst_src_string_ml,
        925,
        4
    ], _C_ = [
        0,
        [
            11,
            "String.chop_prefix_exn ",
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.chop_prefix_exn %S %S"
    ], _D_ = [
        0,
        [
            11,
            "String.chop_suffix_exn ",
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        3,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "String.chop_suffix_exn %S %S"
    ], _E_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ], _F_ = [
        0,
        cst$15,
        cst$15
    ], cst_escapeworthy_map = "escapeworthy_map", cst_c_to = "c_to", cst_c_from = "c_from", cst_escapeworthy_map_not_one_t = "escapeworthy_map not one-to-one", _G_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": out of bounds",
                0
            ]
        ],
        "%s: out of bounds"
    ], cst_is_char_escaping = "is_char_escaping", cst_is_char_escaped = "is_char_escaped", cst_is_char_literal = "is_char_literal", cst_index_from = "index_from", cst_char = cst_char$1, cst_pos = cst_pos$2, cst_escape_char = cst_escape_char$1, cst_str = cst_str$1, cst_index_from_exn_not_found = "index_from_exn: not found", cst_rindex_from = "rindex_from", cst_char$0 = cst_char$1, cst_pos$0 = cst_pos$2, cst_escape_char$0 = cst_escape_char$1, cst_str$0 = cst_str$1, cst_rindex_from_exn_not_found = "rindex_from_exn: not found", _H_ = [
        0,
        cst_src_string_ml,
        1858,
        19
    ], _I_ = [
        0,
        cst_src_string_ml,
        1872,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]", _J_ = [
        0,
        [
            2,
            0,
            [
                11,
                ".get: invalid ",
                [
                    2,
                    0,
                    [
                        11,
                        " encoding at given position",
                        0
                    ]
                ]
            ]
        ],
        "%s.get: invalid %s encoding at given position"
    ], cst_pos$1 = cst_pos$2, cst_of_string_invalid = ".of_string: invalid ", _K_ = [
        0,
        cst_src_string_ml,
        1996,
        4
    ], _L_ = [
        0,
        cst_src_string_ml,
        2006,
        4
    ], _M_ = [
        0,
        cst_src_string_ml,
        2020,
        4
    ], _N_ = [
        0,
        cst$15
    ];
    function of_string(_cU_) {
        return _cU_;
    }
    function to_string(_cT_) {
        return _cT_;
    }
    function init(n, f) {
        if (n < 0) caml_call3(invalid_argf, _x_, n, 0);
        var t = caml_call1(Base_Bytes0[7], n), _cR_ = caml_call2(Base_Import[93], n, 1), _cQ_ = 0;
        if (_cR_ >= 0) {
            var i = _cQ_;
            for(;;){
                caml_bytes_set(t, i, caml_call1(f, i));
                var _cS_ = i + 1 | 0;
                if (_cR_ === i) break;
                i = _cS_;
            }
        }
        return caml_string_of_bytes(t);
    }
    function to_list(s) {
        var i$1 = caml_call2(Base_Import[93], caml_ml_string_length(s), 1), acc = 0, i = i$1;
        for(;;){
            if (0 > i) return acc;
            var i$0 = caml_call2(Base_Import[93], i, 1), acc$0 = [
                0,
                caml_string_get(s, i),
                acc
            ];
            acc = acc$0;
            i = i$0;
        }
    }
    function to_list_rev(s) {
        var len = caml_ml_string_length(s), acc = 0, i = 0;
        for(;;){
            if (i === len) return acc;
            var i$0 = caml_call2(Base_Import[91], i, 1), acc$0 = [
                0,
                caml_string_get(s, i),
                acc
            ];
            acc = acc$0;
            i = i$0;
        }
    }
    function rev(t) {
        var len = caml_ml_string_length(t), res = caml_call1(Base_Bytes0[7], len), _cN_ = caml_call2(Base_Import[93], len, 1), _cM_ = 0;
        if (_cN_ >= 0) {
            var i = _cM_;
            for(;;){
                var _cO_ = caml_call2(Base_Import[93], len, 1);
                caml_bytes_unsafe_set(res, i, caml_string_unsafe_get(t, caml_call2(Base_Import[93], _cO_, i)));
                var _cP_ = i + 1 | 0;
                if (_cN_ === i) break;
                i = _cP_;
            }
        }
        return caml_string_of_bytes(res);
    }
    function not_found$1(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _y_
        ], 1);
    }
    function lsplit2_exn(line, delim) {
        var len = caml_ml_string_length(line), pos = index_from_internal(line, len, not_found$1, function(_cL_) {
            return _cL_;
        }, delim, 0), _cI_ = caml_call2(Base_Import[93], len, pos), _cJ_ = caml_call2(Base_Import[93], _cI_, 1), _cK_ = sub(line, caml_call2(Base_Import[91], pos, 1), _cJ_);
        return [
            0,
            sub(line, 0, pos),
            _cK_
        ];
    }
    function not_found$2(param) {
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _z_
        ], 1);
    }
    function rsplit2_exn(line, delim) {
        var len = caml_ml_string_length(line), pos = rindex_from_internal(line, delim, function(_cH_) {
            return _cH_;
        }, not_found$2, caml_call2(Base_Import[93], len, 1)), _cE_ = caml_call2(Base_Import[93], len, pos), _cF_ = caml_call2(Base_Import[93], _cE_, 1), _cG_ = sub(line, caml_call2(Base_Import[91], pos, 1), _cF_);
        return [
            0,
            sub(line, 0, pos),
            _cG_
        ];
    }
    function lsplit2(line, on) {
        try {
            var _cC_ = [
                0,
                lsplit2_exn(line, on)
            ];
            return _cC_;
        } catch (_cD_) {
            var _cB_ = caml_wrap_exception(_cD_);
            if (_cB_[1] !== Base_Import[297] && _cB_ !== Base_Import[85][8]) throw caml_maybe_attach_backtrace(_cB_, 0);
            return 0;
        }
    }
    function rsplit2(line, on) {
        try {
            var _cz_ = [
                0,
                rsplit2_exn(line, on)
            ];
            return _cz_;
        } catch (_cA_) {
            var _cy_ = caml_wrap_exception(_cA_);
            if (_cy_[1] !== Base_Import[297] && _cy_ !== Base_Import[85][8]) throw caml_maybe_attach_backtrace(_cy_, 0);
            return 0;
        }
    }
    function char_list_mem(l, c) {
        var l$0 = l;
        for(;;){
            if (!l$0) return 0;
            var tl = l$0[2], hd = l$0[1], _cx_ = caml_call2(Base_Char[16], hd, c);
            if (_cx_) return _cx_;
            l$0 = tl;
        }
    }
    function split_gen(str, on) {
        if (552554919 <= on[1]) var l = on[2], is_delim = function(c) {
            return char_list_mem(l, c);
        };
        else var c = on[2], is_delim = function(c$0) {
            return caml_call2(Base_Char[16], c$0, c);
        };
        var last_pos = caml_ml_string_length(str), pos$1 = caml_call2(Base_Import[93], last_pos, 1), acc = 0, last_pos$1 = last_pos, last_pos$0 = pos$1;
        for(;;){
            if (-1 === last_pos$0) return [
                0,
                sub(str, 0, last_pos$1),
                acc
            ];
            if (is_delim(caml_string_get(str, last_pos$0))) {
                var pos1 = caml_call2(Base_Import[91], last_pos$0, 1), sub_str = sub(str, pos1, caml_call2(Base_Import[93], last_pos$1, pos1)), pos = caml_call2(Base_Import[93], last_pos$0, 1), acc$0 = [
                    0,
                    sub_str,
                    acc
                ];
                acc = acc$0;
                last_pos$1 = last_pos$0;
                last_pos$0 = pos;
            } else {
                var pos$0 = caml_call2(Base_Import[93], last_pos$0, 1);
                last_pos$0 = pos$0;
            }
        }
    }
    function split(str, on) {
        return split_gen(str, [
            0,
            -1044422954,
            on
        ]);
    }
    function split_on_chars(str, chars) {
        return split_gen(str, [
            0,
            552554919,
            chars
        ]);
    }
    function is_suffix$0(s, suffix) {
        return is_suffix_gen(s, suffix, Base_Char[16]);
    }
    function is_prefix$0(s, prefix) {
        return is_prefix_gen(s, prefix, Base_Char[16]);
    }
    function is_substring_at$0(s, pos, substring) {
        return is_substring_at_gen(s, pos, substring, Base_Char[16]);
    }
    function wrap_sub_n(t, n, name, pos, len, on_error) {
        if (0 <= n) try {
            var _cu_ = sub(t, pos, len);
            return _cu_;
        } catch (_cw_) {
            return on_error;
        }
        var _cv_ = caml_call2(symbol_concat, name, cst_expecting_nonnegative_argu);
        return caml_call1(Base_Import[126], _cv_);
    }
    function drop_prefix(t, n) {
        return wrap_sub_n(t, n, cst_drop_prefix, n, caml_call2(Base_Import[93], caml_ml_string_length(t), n), cst$0);
    }
    function drop_suffix(t, n) {
        return wrap_sub_n(t, n, cst_drop_suffix, 0, caml_call2(Base_Import[93], caml_ml_string_length(t), n), cst$1);
    }
    function prefix(t, n) {
        return wrap_sub_n(t, n, cst_prefix, 0, n, t);
    }
    function suffix(t, n) {
        return wrap_sub_n(t, n, cst_suffix, caml_call2(Base_Import[93], caml_ml_string_length(t), n), n, t);
    }
    function lfindi(opt, t, f) {
        var pos = opt ? opt[1] : 0, n = caml_ml_string_length(t), i = pos;
        for(;;){
            if (i === n) return 0;
            if (caml_call2(f, i, caml_string_get(t, i))) return [
                0,
                i
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function find(t, f) {
        var match = lfindi(0, t, function(param, c) {
            return caml_call1(f, c);
        });
        if (!match) return 0;
        var i = match[1];
        return [
            0,
            caml_string_get(t, i)
        ];
    }
    function find_map(t, f) {
        var n = caml_ml_string_length(t), i = 0;
        for(;;){
            if (i === n) return 0;
            var res = caml_call1(f, caml_string_get(t, i));
            if (res) return res;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function rfindi(pos, t, f) {
        if (pos) var pos$0 = pos[1], pos$1 = pos$0;
        else var pos$1 = caml_call2(Base_Import[93], caml_ml_string_length(t), 1);
        var i = pos$1;
        for(;;){
            if (0 > i) return 0;
            if (caml_call2(f, i, caml_string_get(t, i))) return [
                0,
                i
            ];
            var i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
        }
    }
    function last_non_drop(drop, t) {
        return rfindi(0, t, function(param, c) {
            return 1 - caml_call1(drop, c);
        });
    }
    function rstrip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], match = last_non_drop(drop, t);
        if (!match) return cst$2;
        var i = match[1];
        return i === caml_call2(Base_Import[93], caml_ml_string_length(t), 1) ? t : prefix(t, caml_call2(Base_Import[91], i, 1));
    }
    function first_non_drop(drop, t) {
        return lfindi(0, t, function(param, c) {
            return 1 - caml_call1(drop, c);
        });
    }
    function lstrip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], match = first_non_drop(drop, t);
        if (!match) return cst$3;
        var n = match[1];
        return 0 === n ? t : drop_prefix(t, n);
    }
    function strip(opt, t) {
        var drop = opt ? opt[1] : Base_Char[45], length = caml_ml_string_length(t);
        a: if (0 !== length) {
            if (!caml_call1(drop, caml_string_get(t, 0)) && !caml_call1(drop, caml_string_get(t, caml_call2(Base_Import[93], length, 1)))) break a;
            var match = first_non_drop(drop, t);
            if (!match) return cst$4;
            var first = match[1], match$0 = last_non_drop(drop, t);
            if (!match$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _A_
            ], 1);
            var last = match$0[1], _ct_ = caml_call2(Base_Import[93], last, first);
            return sub(t, first, caml_call2(Base_Import[91], _ct_, 1));
        }
        return t;
    }
    function mapi(t, f) {
        var l = caml_ml_string_length(t), t$0 = caml_call1(Base_Bytes0[7], l), _cr_ = caml_call2(Base_Import[93], l, 1), _cq_ = 0;
        if (_cr_ >= 0) {
            var i = _cq_;
            for(;;){
                caml_bytes_unsafe_set(t$0, i, caml_call2(f, i, caml_string_get(t, i)));
                var _cs_ = i + 1 | 0;
                if (_cr_ === i) break;
                i = _cs_;
            }
        }
        return caml_string_of_bytes(t$0);
    }
    function map(t, f) {
        var l = caml_ml_string_length(t), t$0 = caml_call1(Base_Bytes0[7], l), _co_ = caml_call2(Base_Import[93], l, 1), _cn_ = 0;
        if (_co_ >= 0) {
            var i = _cn_;
            for(;;){
                caml_bytes_unsafe_set(t$0, i, caml_call1(f, caml_string_get(t, i)));
                var _cp_ = i + 1 | 0;
                if (_co_ === i) break;
                i = _cp_;
            }
        }
        return caml_string_of_bytes(t$0);
    }
    function to_array(s) {
        return caml_call2(Base_Array0[12], caml_ml_string_length(s), function(i) {
            return caml_string_get(s, i);
        });
    }
    function exists(s, f) {
        var len = caml_ml_string_length(s), i = 0;
        for(;;){
            var _ck_ = i < len ? 1 : 0;
            if (_ck_) {
                var _cl_ = caml_call1(f, caml_string_get(s, i));
                if (!_cl_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _cm_ = _cl_;
            } else var _cm_ = _ck_;
            return _cm_;
        }
    }
    function for_all(s, f) {
        var len = caml_ml_string_length(s), i = 0;
        for(;;){
            var _ch_ = i === len ? 1 : 0;
            if (_ch_) var _ci_ = _ch_;
            else {
                var _cj_ = caml_call1(f, caml_string_get(s, i));
                if (_cj_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _ci_ = _cj_;
            }
            return _ci_;
        }
    }
    function fold(t, init, f) {
        var len = caml_ml_string_length(t), i = 0, ac = init;
        for(;;){
            if (i === len) return ac;
            var ac$0 = caml_call2(f, ac, caml_string_get(t, i)), i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            ac = ac$0;
        }
    }
    function foldi(t, init, f) {
        var len = caml_ml_string_length(t), i = 0, ac = init;
        for(;;){
            if (i === len) return ac;
            var ac$0 = caml_call3(f, i, ac, caml_string_get(t, i)), i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
            ac = ac$0;
        }
    }
    function iteri(t, f) {
        var _cf_ = caml_call2(Base_Import[93], caml_ml_string_length(t), 1), _ce_ = 0;
        if (_cf_ >= 0) {
            var i = _ce_;
            for(;;){
                caml_call2(f, i, caml_string_unsafe_get(t, i));
                var _cg_ = i + 1 | 0;
                if (_cf_ === i) break;
                i = _cg_;
            }
        }
        return 0;
    }
    function count(t, f) {
        return caml_call3(Base_Container[2], fold, t, f);
    }
    function sum(m, t, f) {
        return caml_call4(Base_Container[7], fold, m, t, f);
    }
    function min_elt(t) {
        return caml_call2(Base_Container[3], fold, t);
    }
    function max_elt(t) {
        return caml_call2(Base_Container[4], fold, t);
    }
    function fold_result(t, init, f) {
        return caml_call4(Base_Container[8], fold, init, f, t);
    }
    function fold_until(t, init, f, finish) {
        return caml_call5(Base_Container[9], fold, init, f, finish, t);
    }
    function find_mapi(t, f) {
        return caml_call3(Base_Indexed_container[7], iteri, t, f);
    }
    function findi(t, f) {
        return caml_call3(Base_Indexed_container[6], iteri, t, f);
    }
    function counti(t, f) {
        return caml_call3(Base_Indexed_container[3], foldi, t, f);
    }
    function for_alli(t, f) {
        return caml_call3(Base_Indexed_container[5], iteri, t, f);
    }
    function existsi(t, f) {
        return caml_call3(Base_Indexed_container[4], iteri, t, f);
    }
    function mem(t, c) {
        var len = caml_ml_string_length(t), i = 0;
        for(;;){
            var _cb_ = i < len ? 1 : 0;
            if (_cb_) {
                var _cc_ = caml_call2(Base_Char[16], c, caml_string_unsafe_get(t, i));
                if (!_cc_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _cd_ = _cc_;
            } else var _cd_ = _cb_;
            return _cd_;
        }
    }
    function tr(target, replacement, s) {
        return caml_call2(Base_Char[16], target, replacement) ? s : mem(s, target) ? map(s, function(c) {
            return caml_call2(Base_Char[16], c, target) ? replacement : c;
        }) : s;
    }
    function tr_multi(target, replacement) {
        if (is_empty(target)) return caml_call1(stage, function(_ca_) {
            return _ca_;
        });
        if (is_empty(replacement)) return caml_call1(Base_Import[126], cst_tr_multi_replacement_is_em);
        var match = caml_call2(Base_Bytes_tr[1], target, replacement);
        if (!match) return caml_call1(stage, function(_b$_) {
            return _b$_;
        });
        var tr_map = match[1];
        return caml_call1(stage, function(s) {
            return exists(s, function(c) {
                var _b__ = caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], c));
                return caml_call2(Base_Char[15], c, _b__);
            }) ? map(s, function(c) {
                return caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], c));
            }) : s;
        });
    }
    function concat_array(sep, ar) {
        return caml_call2(concat, sep, caml_call1(Base_Array0[16], ar));
    }
    function concat_map(sep, s, f) {
        var _b9_ = to_array(s);
        return concat_array(sep, caml_call2(Base_Array0[21], _b9_, f));
    }
    function concat_mapi(sep, t, f) {
        var _b8_ = to_array(t);
        return concat_array(sep, caml_call2(Base_Array0[22], _b8_, f));
    }
    function concat_lines(opt, lines$3) {
        var crlf = opt ? opt[1] : 0, newline_len = crlf ? 2 : 1, lines = lines$3, sum = 0;
        for(;;){
            if (!lines) break;
            var lines$0 = lines[2], line = lines[1], _b7_ = caml_call2(Base_Import[91], sum, caml_ml_string_length(line)), sum$0 = caml_call2(Base_Import[91], _b7_, newline_len);
            lines = lines$0;
            sum = sum$0;
        }
        var buf = caml_call1(Base_Bytes0[7], sum), lines$1 = lines$3, written = 0;
        for(;;){
            if (!lines$1) {
                if (written === sum) return caml_string_of_bytes(buf);
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _B_
                ], 1);
            }
            var lines$2 = lines$1[2], line$0 = lines$1[1];
            caml_blit_string(line$0, 0, buf, written, caml_ml_string_length(line$0));
            var pos = caml_call2(Base_Import[91], written, caml_ml_string_length(line$0)), pos$0 = crlf ? (caml_bytes_unsafe_set(buf, pos, 13), caml_call2(Base_Import[91], pos, 1)) : pos;
            caml_bytes_unsafe_set(buf, pos$0, 10);
            var pos$1 = caml_call2(Base_Import[91], pos$0, 1);
            lines$1 = lines$2;
            written = pos$1;
        }
    }
    function filter(t, f) {
        var n = caml_ml_string_length(t), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= n) break;
            if (!caml_call1(f, caml_string_get(t, i[1]))) break;
            i[1]++;
        }
        if (i[1] === n) return t;
        var _b5_ = caml_call2(Base_Import[93], n, 1), out = caml_call1(Base_Bytes0[7], _b5_);
        caml_call5(Base_Bytes0[4], t, 0, out, 0, i[1]);
        var out_pos = [
            0,
            i[1]
        ];
        i[1]++;
        for(;;){
            if (i[1] >= n) {
                var out$0 = caml_string_of_bytes(out), _b6_ = caml_call2(Base_Import[93], n, 1);
                return out_pos[1] === _b6_ ? out$0 : sub(out$0, 0, out_pos[1]);
            }
            var c = caml_string_get(t, i[1]);
            if (caml_call1(f, c)) {
                caml_bytes_set(out, out_pos[1], c);
                out_pos[1]++;
            }
            i[1]++;
        }
    }
    function filteri(t, f) {
        var n = caml_ml_string_length(t), i = [
            0,
            0
        ];
        for(;;){
            if (i[1] >= n) break;
            var _b2_ = caml_string_get(t, i[1]);
            if (!caml_call2(f, i[1], _b2_)) break;
            i[1]++;
        }
        if (i[1] === n) return t;
        var _b3_ = caml_call2(Base_Import[93], n, 1), out = caml_call1(Base_Bytes0[7], _b3_);
        caml_call5(Base_Bytes0[4], t, 0, out, 0, i[1]);
        var out_pos = [
            0,
            i[1]
        ];
        i[1]++;
        for(;;){
            if (i[1] >= n) {
                var out$0 = caml_string_of_bytes(out), _b4_ = caml_call2(Base_Import[93], n, 1);
                return out_pos[1] === _b4_ ? out$0 : sub(out$0, 0, out_pos[1]);
            }
            var c = caml_string_get(t, i[1]);
            if (caml_call2(f, i[1], c)) {
                caml_bytes_set(out, out_pos[1], c);
                out_pos[1]++;
            }
            i[1]++;
        }
    }
    function chop_prefix(s, prefix) {
        return is_prefix$0(s, prefix) ? [
            0,
            drop_prefix(s, caml_ml_string_length(prefix))
        ] : 0;
    }
    function chop_prefix_if_exists(s, prefix) {
        return is_prefix$0(s, prefix) ? drop_prefix(s, caml_ml_string_length(prefix)) : s;
    }
    function chop_prefix_exn(s, prefix) {
        var match = chop_prefix(s, prefix);
        if (!match) return caml_call4(invalid_argf, _C_, s, prefix, 0);
        var str = match[1];
        return str;
    }
    function chop_suffix(s, suffix) {
        return is_suffix$0(s, suffix) ? [
            0,
            drop_suffix(s, caml_ml_string_length(suffix))
        ] : 0;
    }
    function chop_suffix_if_exists(s, suffix) {
        return is_suffix$0(s, suffix) ? drop_suffix(s, caml_ml_string_length(suffix)) : s;
    }
    function chop_suffix_exn(s, suffix) {
        var match = chop_suffix(s, suffix);
        if (!match) return caml_call4(invalid_argf, _D_, s, suffix, 0);
        var str = match[1];
        return str;
    }
    function shorter(a, b) {
        return caml_ml_string_length(a) <= caml_ml_string_length(b) ? a : b;
    }
    function shortest(list) {
        if (!list) return cst$5;
        var rest = list[2], first = list[1];
        return caml_call3(Base_List[20], rest, first, shorter);
    }
    function pos_from_left(param, i) {
        return i;
    }
    function pos_from_right(t, i) {
        var _b1_ = caml_call2(Base_Import[93], caml_ml_string_length(t), i);
        return caml_call2(Base_Import[93], _b1_, 1);
    }
    function common_generic2_length_loop(a, b, get_pos, max_len, len_so_far) {
        var len_so_far$0 = len_so_far;
        for(;;){
            if (max_len <= len_so_far$0) return max_len;
            var _bZ_ = caml_string_unsafe_get(b, caml_call2(get_pos, b, len_so_far$0)), _b0_ = caml_string_unsafe_get(a, caml_call2(get_pos, a, len_so_far$0));
            if (!caml_call2(Base_Char[16], _b0_, _bZ_)) return len_so_far$0;
            var len_so_far$1 = caml_call2(Base_Import[91], len_so_far$0, 1);
            len_so_far$0 = len_so_far$1;
        }
    }
    function common_generic2_length(a, b, get_pos) {
        var max_len = caml_call2(Base_Import[101], caml_ml_string_length(a), caml_ml_string_length(b));
        return common_generic2_length_loop(a, b, get_pos, max_len, 0);
    }
    function common_generic_length_loop(first, list, get_pos, max_len) {
        var first$0 = first, list$0 = list, max_len$0 = max_len;
        for(;;){
            if (!list$0) return max_len$0;
            var rest = list$0[2], second = list$0[1], max_len$1 = common_generic2_length_loop(first$0, second, get_pos, max_len$0, 0);
            first$0 = second;
            list$0 = rest;
            max_len$0 = max_len$1;
        }
    }
    function common_generic_length(list, get_pos) {
        if (!list) return 0;
        var rest = list[2], first = list[1], max_len = caml_ml_string_length(shortest(list));
        return common_generic_length_loop(first, rest, get_pos, max_len);
    }
    function common_generic2(a, b, get_pos, take) {
        var len = common_generic2_length(a, b, get_pos);
        return caml_call2(take, shorter(a, b), len);
    }
    function common_generic(list, get_pos, take) {
        if (!list) return cst$7;
        var rest = list[2], first = list[1], s = shortest(list), max_len = caml_ml_string_length(s);
        if (0 === max_len) return cst$6;
        var len = common_generic_length_loop(first, rest, get_pos, max_len);
        return caml_call2(take, s, len);
    }
    function common_prefix(list) {
        return common_generic(list, pos_from_left, prefix);
    }
    function common_suffix(list) {
        return common_generic(list, pos_from_right, suffix);
    }
    function common_prefix2(a, b) {
        return common_generic2(a, b, pos_from_left, prefix);
    }
    function common_suffix2(a, b) {
        return common_generic2(a, b, pos_from_right, suffix);
    }
    function common_prefix_length(list) {
        return common_generic_length(list, pos_from_left);
    }
    function common_suffix_length(list) {
        return common_generic_length(list, pos_from_right);
    }
    function common_prefix2_length(a, b) {
        return common_generic2_length(a, b, pos_from_left);
    }
    function common_suffix2_length(a, b) {
        return common_generic2_length(a, b, pos_from_right);
    }
    function pp(ppf, string) {
        return caml_call3(Stdlib_Format[143], ppf, _E_, string);
    }
    function of_char(c) {
        return caml_call2(make, 1, c);
    }
    function of_char_list(l) {
        var _bY_ = caml_call1(Base_List[45], l), t = caml_call1(Base_Bytes0[7], _bY_);
        caml_call2(Base_List[34], l, function(i, c) {
            return caml_bytes_set(t, i, c);
        });
        return caml_string_of_bytes(t);
    }
    function of_array(a) {
        return init(a.length - 1, function(_bX_) {
            return caml_check_bound(a, _bX_)[1 + _bX_];
        });
    }
    function to_sequence(t) {
        var len = caml_ml_string_length(t);
        return caml_call2(Base_Sequence[44], 0, function(pos) {
            return len <= pos ? 0 : [
                1,
                caml_string_unsafe_get(t, pos),
                caml_call2(Base_Import[91], pos, 1)
            ];
        });
    }
    function of_sequence(s) {
        return of_char_list(caml_call1(Base_Sequence[20], s));
    }
    function pad_right(opt, s, len) {
        var char$0 = opt ? opt[1] : 32, src_len = caml_ml_string_length(s);
        if (len <= src_len) return s;
        var res = caml_call1(Base_Bytes0[7], len);
        caml_call5(Base_Bytes0[4], s, 0, res, 0, src_len);
        var _bW_ = caml_call2(Base_Import[93], len, src_len);
        caml_call4(Base_Bytes0[15], res, src_len, _bW_, char$0);
        return caml_string_of_bytes(res);
    }
    function pad_left(opt, s, len) {
        var char$0 = opt ? opt[1] : 32, src_len = caml_ml_string_length(s);
        if (len <= src_len) return s;
        var res = caml_call1(Base_Bytes0[7], len), _bU_ = caml_call2(Base_Import[93], len, src_len);
        caml_call5(Base_Bytes0[4], s, 0, res, _bU_, src_len);
        var _bV_ = caml_call2(Base_Import[93], len, src_len);
        caml_call4(Base_Bytes0[15], res, 0, _bV_, char$0);
        return caml_string_of_bytes(res);
    }
    function local_copy_prefix(src, prefix_len, buffer_len) {
        var dst = caml_call1(Base_Bytes0[14], buffer_len);
        caml_blit_string(src, 0, dst, 0, prefix_len);
        return dst;
    }
    function local_copy_to_string(buf, pos) {
        var str = caml_string_of_bytes(buf);
        return unsafe_sub(str, 0, pos);
    }
    function filter_mapi(src, f) {
        var src_len = caml_ml_string_length(src);
        a: {
            var pos = 0;
            for(;;){
                if (pos === src_len) return src;
                var c1 = caml_string_unsafe_get(src, pos), src_pos$0 = caml_call1(Base_Int0[8], pos), option = caml_call2(f, pos, c1);
                if (!option) break a;
                var c2 = option[1];
                if (!caml_call2(Base_Char[16], c1, c2)) break;
                pos = src_pos$0;
            }
        }
        var copy = local_copy_prefix(src, pos, src_len);
        if (option) {
            var c$0 = option[1];
            caml_bytes_unsafe_set(copy, pos, c$0);
            var dst_pos$0 = src_pos$0;
        } else var dst_pos$0 = pos;
        var dst_pos = [
            0,
            dst_pos$0
        ], _bS_ = caml_call2(Base_Import[93], src_len, 1);
        if (_bS_ >= src_pos$0) {
            var src_pos = src_pos$0;
            for(;;){
                var match = caml_call2(f, src_pos, caml_string_unsafe_get(src, src_pos));
                if (match) {
                    var c = match[1];
                    caml_bytes_unsafe_set(copy, dst_pos[1], c);
                    dst_pos[1]++;
                }
                var _bT_ = src_pos + 1 | 0;
                if (_bS_ === src_pos) break;
                src_pos = _bT_;
            }
        }
        return local_copy_to_string(copy, dst_pos[1]);
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(param, c) {
            return caml_call1(f, c);
        });
    }
    function partition_map_difference(src, f, len, src_pos$0, fst_pos$0, snd_pos$0, either) {
        var fsts = local_copy_prefix(src, fst_pos$0, len), snds = local_copy_prefix(src, snd_pos$0, len);
        if (0 === either[0]) {
            var c$1 = either[1];
            caml_bytes_unsafe_set(fsts, fst_pos$0, c$1);
            var snd_pos$1 = snd_pos$0, fst_pos$1 = caml_call2(Base_Import[91], fst_pos$0, 1);
        } else {
            var c$2 = either[1];
            caml_bytes_unsafe_set(snds, snd_pos$0, c$2);
            var snd_pos$2 = caml_call2(Base_Import[91], snd_pos$0, 1), snd_pos$1 = snd_pos$2, fst_pos$1 = fst_pos$0;
        }
        var src_pos$1 = caml_call2(Base_Import[91], src_pos$0, 1), fst_pos = [
            0,
            fst_pos$1
        ], snd_pos = [
            0,
            snd_pos$1
        ], _bP_ = caml_call2(Base_Import[93], len, 1);
        if (_bP_ >= src_pos$1) {
            var src_pos = src_pos$1;
            for(;;){
                var match = caml_call1(f, caml_string_unsafe_get(src, src_pos));
                if (0 === match[0]) {
                    var c = match[1];
                    caml_bytes_unsafe_set(fsts, fst_pos[1], c);
                    fst_pos[1]++;
                } else {
                    var c$0 = match[1];
                    caml_bytes_unsafe_set(snds, snd_pos[1], c$0);
                    snd_pos[1]++;
                }
                var _bR_ = src_pos + 1 | 0;
                if (_bP_ === src_pos) break;
                src_pos = _bR_;
            }
        }
        var _bQ_ = local_copy_to_string(snds, snd_pos[1]);
        return [
            0,
            local_copy_to_string(fsts, fst_pos[1]),
            _bQ_
        ];
    }
    function partition_map(src, f) {
        var len = caml_ml_string_length(src);
        if (0 === len) return _F_;
        var c1$1 = caml_string_unsafe_get(src, 0), either$1 = caml_call1(f, c1$1);
        if (0 === either$1[0]) {
            var c2$1 = either$1[1];
            if (caml_call2(Base_Char[16], c1$1, c2$1)) {
                var pos = 1;
                for(;;){
                    if (pos === len) return [
                        0,
                        src,
                        cst$8
                    ];
                    var c1 = caml_string_unsafe_get(src, pos), either = caml_call1(f, c1);
                    if (0 === either[0]) {
                        var c2 = either[1];
                        if (caml_call2(Base_Char[16], c1, c2)) {
                            var pos$0 = caml_call2(Base_Import[91], pos, 1);
                            pos = pos$0;
                            continue;
                        }
                    }
                    return partition_map_difference(src, f, len, pos, pos, 0, either);
                }
            }
        } else {
            var c2$2 = either$1[1];
            if (caml_call2(Base_Char[16], c1$1, c2$2)) {
                var pos$1 = 1;
                for(;;){
                    if (pos$1 === len) return [
                        0,
                        cst$9,
                        src
                    ];
                    var c1$0 = caml_string_unsafe_get(src, pos$1), either$0 = caml_call1(f, c1$0);
                    if (1 === either$0[0]) {
                        var c2$0 = either$0[1];
                        if (caml_call2(Base_Char[16], c1$0, c2$0)) {
                            var pos$2 = caml_call2(Base_Import[91], pos$1, 1);
                            pos$1 = pos$2;
                            continue;
                        }
                    }
                    return partition_map_difference(src, f, len, pos$1, 0, pos$1, either$0);
                }
            }
        }
        return partition_map_difference(src, f, len, 0, 0, 0, either$1);
    }
    function partition_tf(t, f) {
        return partition_map(t, function(c) {
            return caml_call1(f, c) ? [
                0,
                c
            ] : [
                1,
                c
            ];
        });
    }
    function edit_distance(s1, s2) {
        if (caml_ml_string_length(s1) <= caml_ml_string_length(s2)) var s2$0 = s2, s1$0 = s1;
        else var s2$0 = s1, s1$0 = s2;
        var _bl_ = caml_call2(Base_Import[91], 1, caml_ml_string_length(s1$0)), _bm_ = caml_call2(Base_Import[88], 2, _bl_), table = caml_call2(Base_Array0[5], _bm_, 0);
        function at(i, j) {
            var _bN_ = caml_call2(Base_Import[122], j, 2), _bO_ = caml_call2(Base_Import[88], i, 2);
            return caml_call2(Base_Import[91], _bO_, _bN_);
        }
        var _bo_ = caml_ml_string_length(s1$0), _bn_ = 1;
        if (_bo_ >= 1) {
            var i$0 = _bn_;
            for(;;){
                var _bL_ = at(i$0, 0);
                caml_check_bound(table, _bL_)[1 + _bL_] = i$0;
                var _bM_ = i$0 + 1 | 0;
                if (_bo_ === i$0) break;
                i$0 = _bM_;
            }
        }
        var _bq_ = caml_ml_string_length(s2$0), _bp_ = 1;
        if (_bq_ >= 1) {
            var j = _bp_;
            for(;;){
                var _bs_ = at(0, j);
                caml_check_bound(table, _bs_)[1 + _bs_] = j;
                var _bu_ = caml_ml_string_length(s1$0), _bt_ = 1;
                if (_bu_ >= 1) {
                    var i = _bt_;
                    for(;;){
                        var _bw_ = caml_string_get(s2$0, caml_call2(Base_Import[93], j, 1)), _bx_ = caml_string_get(s1$0, caml_call2(Base_Import[93], i, 1));
                        if (caml_call2(Base_Char[16], _bx_, _bw_)) {
                            var _by_ = caml_call2(Base_Import[93], j, 1), _bz_ = at(caml_call2(Base_Import[93], i, 1), _by_), _bA_ = caml_check_bound(table, _bz_)[1 + _bz_], _bB_ = at(i, j);
                            caml_check_bound(table, _bB_)[1 + _bB_] = _bA_;
                        } else {
                            var _bD_ = caml_call2(Base_Import[93], j, 1), _bE_ = at(caml_call2(Base_Import[93], i, 1), _bD_), sub = caml_check_bound(table, _bE_)[1 + _bE_], _bF_ = at(caml_call2(Base_Import[93], i, 1), j), add = caml_check_bound(table, _bF_)[1 + _bF_], _bG_ = at(i, caml_call2(Base_Import[93], j, 1)), del = caml_check_bound(table, _bG_)[1 + _bG_], _bH_ = caml_call2(Base_Import[101], add, del), _bI_ = caml_call2(Base_Import[101], sub, _bH_), _bJ_ = caml_call2(Base_Import[91], 1, _bI_), _bK_ = at(i, j);
                            caml_check_bound(table, _bK_)[1 + _bK_] = _bJ_;
                        }
                        var _bC_ = i + 1 | 0;
                        if (_bu_ === i) break;
                        i = _bC_;
                    }
                }
                var _bv_ = j + 1 | 0;
                if (_bq_ === j) break;
                j = _bv_;
            }
        }
        var _br_ = at(caml_ml_string_length(s1$0), caml_ml_string_length(s2$0));
        return caml_check_bound(table, _br_)[1 + _br_];
    }
    function build_and_validate_escapeworth(escapeworthy_map, escape_char, func) {
        var escapeworthy_map$0 = caml_call3(Base_List[137][7], escapeworthy_map, Base_Char[16], escape_char) ? escapeworthy_map : [
            0,
            [
                0,
                escape_char,
                escape_char
            ],
            escapeworthy_map
        ], arr = caml_call2(Base_Array0[4], 256, -1), vals = caml_call2(Base_Array0[4], 256, 0), param = escapeworthy_map$0;
        for(;;){
            if (!param) return [
                0,
                arr
            ];
            var l = param[2], match = param[1], c_to = match[2], c_from = match[1];
            if (919809722 <= func) var v = c_from, k = caml_call1(Base_Char[32], c_to);
            else var k$0 = caml_call1(Base_Char[32], c_from), v = c_to, k = k$0;
            if (-1 !== caml_check_bound(arr, k)[1 + k]) break;
            var _bd_ = caml_call1(Base_Char[32], v);
            if (caml_check_bound(vals, _bd_)[1 + _bd_]) break;
            var _bj_ = caml_call1(Base_Char[32], v);
            caml_check_bound(arr, k)[1 + k] = _bj_;
            var _bk_ = caml_call1(Base_Char[32], v);
            caml_check_bound(vals, _bk_)[1 + _bk_] = 1;
            param = l;
        }
        var _be_ = caml_call2(Base_Import[147], Base_Import[138], Base_Import[138]), _bf_ = [
            0,
            [
                0,
                cst_escapeworthy_map,
                caml_call2(Base_Import[149], _be_, escapeworthy_map$0)
            ],
            0
        ], _bg_ = [
            0,
            [
                0,
                cst_c_to,
                caml_call1(Base_Import[138], c_to)
            ],
            _bf_
        ], _bh_ = [
            0,
            [
                0,
                cst_c_from,
                caml_call1(Base_Import[138], c_from)
            ],
            _bg_
        ], _bi_ = caml_call2(Base_Sexp[10], cst_escapeworthy_map_not_one_t, _bh_);
        return caml_call1(Base_Or_error[39], _bi_);
    }
    function escape_gen(escapeworthy_map, escape_char) {
        var x = build_and_validate_escapeworth(escapeworthy_map, escape_char, 258914209);
        if (0 !== x[0]) return x;
        var escapeworthy = x[1];
        return [
            0,
            function(src) {
                var to_escape_len = [
                    0,
                    0
                ], to_escape = foldi(src, 0, function(i, acc, c) {
                    var _bc_ = caml_call1(Base_Char[32], c), n = caml_check_bound(escapeworthy, _bc_)[1 + _bc_];
                    return -1 === n ? acc : (to_escape_len[1]++, [
                        0,
                        [
                            0,
                            i,
                            caml_call1(Base_Char[35], n)
                        ],
                        acc
                    ]);
                });
                if (!to_escape) return src;
                var last_idx = caml_ml_string_length(src), last_dst_pos = caml_call2(Base_Import[91], last_idx, to_escape_len[1]), dst = caml_call1(Base_Bytes0[7], last_dst_pos), last_idx$0 = last_idx, last_dst_pos$0 = last_dst_pos, param = to_escape;
                for(;;){
                    if (!param) {
                        caml_call5(Base_Bytes0[4], src, 0, dst, 0, last_idx$0);
                        return caml_string_of_bytes(dst);
                    }
                    var to_escape$0 = param[2], match = param[1], escaped_char = match[2], last_idx$1 = match[1], _ba_ = caml_call2(Base_Import[93], last_idx$0, last_idx$1), len = caml_call2(Base_Import[93], _ba_, 1), dst_pos = caml_call2(Base_Import[93], last_dst_pos$0, len), _bb_ = caml_call2(Base_Import[91], last_idx$1, 1);
                    caml_call5(Base_Bytes0[4], src, _bb_, dst, dst_pos, len);
                    var last_dst_pos$1 = caml_call2(Base_Import[93], dst_pos, 2);
                    caml_bytes_set(dst, last_dst_pos$1, escape_char);
                    caml_bytes_set(dst, caml_call2(Base_Import[91], last_dst_pos$1, 1), escaped_char);
                    last_idx$0 = last_idx$1;
                    last_dst_pos$0 = last_dst_pos$1;
                    param = to_escape$0;
                }
            }
        ];
    }
    function escape_gen_exn(escapeworthy_map, escape_char) {
        var _a$_ = escape_gen(escapeworthy_map, escape_char);
        return caml_call1(stage, caml_call1(Base_Or_error[34], _a$_));
    }
    function escape(escapeworthy, escape_char) {
        var _a__ = caml_call2(Base_List[126], escapeworthy, Base_Char[17]), escapeworthy_map = caml_call2(Base_List[53], _a__, function(c) {
            return [
                0,
                c,
                c
            ];
        });
        return escape_gen_exn(escapeworthy_map, escape_char);
    }
    function unescape_gen(escapeworthy_map, escape_char) {
        var x = build_and_validate_escapeworth(escapeworthy_map, escape_char, 919809722);
        if (0 !== x[0]) return x;
        var escapeworthy = x[1];
        return [
            0,
            function(src) {
                var i = 0, status = -512962225, to_unescape = 0;
                for(;;){
                    if (caml_ml_string_length(src) <= i) break;
                    if (-512962225 <= status) var _a2_ = caml_string_get(src, i), status$0 = caml_call2(Base_Char[16], _a2_, escape_char) ? -767030498 : -512962225;
                    else var status$0 = -244189789;
                    var acc = -512962225 <= status$0 ? to_unescape : [
                        0,
                        i,
                        to_unescape
                    ], i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    status = status$0;
                    to_unescape = acc;
                }
                if (!to_unescape) return src;
                var to_unescape$0 = to_unescape[2], idx = to_unescape[1], _a3_ = caml_call1(Base_List[45], to_unescape), _a4_ = caml_call2(Base_Import[93], caml_ml_string_length(src), _a3_), dst = caml_call1(Base_Bytes0[7], _a4_);
                function loop(last_idx, last_dst_pos, param) {
                    var last_idx$0 = last_idx, last_dst_pos$0 = last_dst_pos, param$0 = param;
                    for(;;){
                        if (!param$0) return caml_call5(Base_Bytes0[4], src, 0, dst, 0, last_idx$0);
                        var to_unescape = param$0[2], last_idx$1 = param$0[1], _a5_ = caml_call2(Base_Import[93], last_idx$0, last_idx$1), len = caml_call2(Base_Import[93], _a5_, 2), dst_pos = caml_call2(Base_Import[93], last_dst_pos$0, len), _a6_ = caml_call2(Base_Import[91], last_idx$1, 2);
                        caml_call5(Base_Bytes0[4], src, _a6_, dst, dst_pos, len);
                        var last_dst_pos$1 = caml_call2(Base_Import[93], dst_pos, 1), _a7_ = caml_string_get(src, caml_call2(Base_Import[91], last_idx$1, 1)), _a8_ = caml_call1(Base_Char[32], _a7_), n = caml_check_bound(escapeworthy, _a8_)[1 + _a8_], _a9_ = -1 === n ? caml_string_get(src, caml_call2(Base_Import[91], last_idx$1, 1)) : caml_call1(Base_Char[35], n);
                        caml_bytes_set(dst, last_dst_pos$1, _a9_);
                        last_idx$0 = last_idx$1;
                        last_dst_pos$0 = last_dst_pos$1;
                        param$0 = to_unescape;
                    }
                }
                if (idx < caml_call2(Base_Import[93], caml_ml_string_length(src), 1)) loop(caml_ml_string_length(src), caml_ml_bytes_length(dst), to_unescape);
                else loop(caml_call2(Base_Import[93], caml_ml_string_length(src), 1), caml_ml_bytes_length(dst), to_unescape$0);
                return caml_string_of_bytes(dst);
            }
        ];
    }
    function unescape_gen_exn(escapeworthy_map, escape_char) {
        var _a1_ = unescape_gen(escapeworthy_map, escape_char);
        return caml_call1(stage, caml_call1(Base_Or_error[34], _a1_));
    }
    function unescape(escape_char) {
        return unescape_gen_exn(0, escape_char);
    }
    function preceding_escape_chars(str, escape_char, pos) {
        var p$1 = caml_call2(Base_Import[93], pos, 1), p = p$1, cnt = 0;
        for(;;){
            if (0 <= p) {
                var _a0_ = caml_string_get(str, p);
                if (!caml_call2(Base_Char[15], _a0_, escape_char)) {
                    var cnt$0 = caml_call2(Base_Import[91], cnt, 1), p$0 = caml_call2(Base_Import[93], p, 1);
                    p = p$0;
                    cnt = cnt$0;
                    continue;
                }
            }
            return cnt;
        }
    }
    function update_escape_status(str, escape_char, i, param) {
        if (-512962225 > param) return -244189789;
        var _aZ_ = caml_string_get(str, i);
        return caml_call2(Base_Char[16], _aZ_, escape_char) ? -767030498 : -512962225;
    }
    function escape_status(str, escape_char, pos) {
        var _aX_ = preceding_escape_chars(str, escape_char, pos), odd = 1 === caml_call2(Base_Import[122], _aX_, 2) ? 1 : 0, _aY_ = caml_string_get(str, pos), match = caml_call2(Base_Char[16], _aY_, escape_char);
        return odd ? -244189789 : match ? -767030498 : -512962225;
    }
    function check_bound(str, pos, function_name) {
        var _aV_ = caml_ml_string_length(str) <= pos ? 1 : 0, _aW_ = _aV_ || (pos < 0 ? 1 : 0);
        return _aW_ ? caml_call3(invalid_argf, _G_, function_name, 0) : _aW_;
    }
    function is_char_escaping(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_escaping);
        return -512962225 <= escape_status(str, escape_char, pos) ? 0 : 1;
    }
    function is_char_escaped(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_escaped);
        return -244189789 <= escape_status(str, escape_char, pos) ? 1 : 0;
    }
    function is_char_literal(str, escape_char, pos) {
        check_bound(str, pos, cst_is_char_literal);
        return -512962225 === escape_status(str, escape_char, pos) ? 1 : 0;
    }
    function index_from$0(str, escape_char, pos, char$0) {
        check_bound(str, pos, cst_index_from);
        var status$1 = escape_status(str, escape_char, pos), i = pos, status = status$1;
        for(;;){
            if (pos <= i) {
                var _aT_ = -512962225 === status ? 1 : 0;
                if (_aT_) {
                    var _aU_ = caml_string_get(str, i);
                    if (caml_call2(Base_Char[16], _aU_, char$0)) return [
                        0,
                        i
                    ];
                }
            }
            var i$0 = caml_call2(Base_Import[91], i, 1);
            if (caml_ml_string_length(str) <= i$0) return 0;
            var status$0 = update_escape_status(str, escape_char, i$0, status);
            i = i$0;
            status = status$0;
        }
    }
    function index_from_exn$0(str, escape_char, pos, char$0) {
        var match = index_from$0(str, escape_char, pos, char$0);
        if (match) {
            var pos$0 = match[1];
            return pos$0;
        }
        var _aP_ = [
            0,
            [
                0,
                cst_char,
                caml_call1(Base_Import[138], char$0)
            ],
            0
        ], _aQ_ = [
            0,
            [
                0,
                cst_pos,
                caml_call1(Base_Import[139], pos)
            ],
            _aP_
        ], _aR_ = [
            0,
            [
                0,
                cst_escape_char,
                caml_call1(Base_Import[138], escape_char)
            ],
            _aQ_
        ], _aS_ = [
            0,
            [
                0,
                cst_str,
                caml_call1(sexp_of_t, str)
            ],
            _aR_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_index_from_exn_not_found, _aS_));
    }
    function index$1(str, escape_char, char$0) {
        return index_from$0(str, escape_char, 0, char$0);
    }
    function index_exn$1(str, escape_char, char$0) {
        return index_from_exn$0(str, escape_char, 0, char$0);
    }
    function rindex_from$0(str, escape_char, pos, char$0) {
        check_bound(str, pos, cst_rindex_from);
        if (caml_call2(Base_Char[16], char$0, escape_char)) return 0;
        var pos$0 = pos;
        for(;;){
            if (0 > pos$0) return 0;
            var escape_chars = preceding_escape_chars(str, escape_char, pos$0);
            if (0 === caml_call2(Base_Import[122], escape_chars, 2)) {
                var _aN_ = caml_string_get(str, pos$0);
                if (caml_call2(Base_Char[16], _aN_, char$0)) return [
                    0,
                    pos$0
                ];
            }
            var _aO_ = caml_call2(Base_Import[93], pos$0, escape_chars), pos$1 = caml_call2(Base_Import[93], _aO_, 1);
            pos$0 = pos$1;
        }
    }
    function rindex_from_exn$0(str, escape_char, pos, char$0) {
        var match = rindex_from$0(str, escape_char, pos, char$0);
        if (match) {
            var pos$0 = match[1];
            return pos$0;
        }
        var _aJ_ = [
            0,
            [
                0,
                cst_char$0,
                caml_call1(Base_Import[138], char$0)
            ],
            0
        ], _aK_ = [
            0,
            [
                0,
                cst_pos$0,
                caml_call1(Base_Import[139], pos)
            ],
            _aJ_
        ], _aL_ = [
            0,
            [
                0,
                cst_escape_char$0,
                caml_call1(Base_Import[138], escape_char)
            ],
            _aK_
        ], _aM_ = [
            0,
            [
                0,
                cst_str$0,
                caml_call1(sexp_of_t, str)
            ],
            _aL_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_rindex_from_exn_not_found, _aM_));
    }
    function rindex$0(str, escape_char, char$0) {
        return is_empty(str) ? 0 : rindex_from$0(str, escape_char, caml_call2(Base_Import[93], caml_ml_string_length(str), 1), char$0);
    }
    function rindex_exn$0(str, escape_char, char$0) {
        return rindex_from_exn$0(str, escape_char, caml_call2(Base_Import[93], caml_ml_string_length(str), 1), char$0);
    }
    function split_gen$0(str, escape_char, on) {
        if (552554919 <= on[1]) var l = on[2], is_delim = function(c) {
            return char_list_mem(l, c);
        };
        else var c = on[2], is_delim = function(c$0) {
            return caml_call2(Base_Char[16], c$0, c);
        };
        var len = caml_ml_string_length(str), acc = 0, status = -512962225, last_pos = 0, pos = 0;
        for(;;){
            if (pos === len) {
                var _aH_ = [
                    0,
                    sub(str, last_pos, caml_call2(Base_Import[93], len, last_pos)),
                    acc
                ];
                return caml_call1(Base_List[63], _aH_);
            }
            var status$0 = update_escape_status(str, escape_char, pos, status), _aI_ = -512962225 === status$0 ? 1 : 0;
            if (_aI_ && is_delim(caml_string_get(str, pos))) {
                var sub_str = sub(str, last_pos, caml_call2(Base_Import[93], pos, last_pos)), pos$0 = caml_call2(Base_Import[91], pos, 1), last_pos$0 = caml_call2(Base_Import[91], pos, 1), acc$0 = [
                    0,
                    sub_str,
                    acc
                ];
                acc = acc$0;
                status = status$0;
                last_pos = last_pos$0;
                pos = pos$0;
                continue;
            }
            var pos$1 = caml_call2(Base_Import[91], pos, 1);
            status = status$0;
            pos = pos$1;
        }
    }
    function split$0(str, on) {
        var _aF_ = [
            0,
            -1044422954,
            on
        ];
        return function(_aG_) {
            return split_gen$0(str, _aG_, _aF_);
        };
    }
    function split_on_chars$0(str, chars) {
        var _aD_ = [
            0,
            552554919,
            chars
        ];
        return function(_aE_) {
            return split_gen$0(str, _aE_, _aD_);
        };
    }
    function split_at(str, pos) {
        var _aA_ = caml_call2(Base_Import[93], caml_ml_string_length(str), pos), _aB_ = caml_call2(Base_Import[93], _aA_, 1), _aC_ = sub(str, caml_call2(Base_Import[91], pos, 1), _aB_);
        return [
            0,
            sub(str, 0, pos),
            _aC_
        ];
    }
    function lsplit2$0(str, on, escape_char) {
        var _az_ = index$1(str, escape_char, on);
        return caml_call2(Base_Option[24], _az_, function(x) {
            return split_at(str, x);
        });
    }
    function rsplit2$0(str, on, escape_char) {
        var _ay_ = rindex$0(str, escape_char, on);
        return caml_call2(Base_Option[24], _ay_, function(x) {
            return split_at(str, x);
        });
    }
    function lsplit2_exn$0(str, on, escape_char) {
        return split_at(str, index_exn$1(str, escape_char, on));
    }
    function rsplit2_exn$0(str, on, escape_char) {
        return split_at(str, rindex_exn$0(str, escape_char, on));
    }
    function last_non_drop_literal(drop, escape_char, t) {
        return rfindi(0, t, function(i, c) {
            var _av_ = 1 - caml_call1(drop, c);
            if (_av_) var _aw_ = _av_;
            else {
                var _ax_ = is_char_escaping(t, escape_char, i);
                if (!_ax_) return is_char_escaped(t, escape_char, i);
                var _aw_ = _ax_;
            }
            return _aw_;
        });
    }
    function first_non_drop_literal(drop, escape_char, t) {
        return lfindi(0, t, function(i, c) {
            var _as_ = 1 - caml_call1(drop, c);
            if (_as_) var _at_ = _as_;
            else {
                var _au_ = is_char_escaping(t, escape_char, i);
                if (!_au_) return is_char_escaped(t, escape_char, i);
                var _at_ = _au_;
            }
            return _at_;
        });
    }
    function rstrip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], match = last_non_drop_literal(drop, escape_char, t);
        if (!match) return cst$10;
        var i = match[1];
        return i === caml_call2(Base_Import[93], caml_ml_string_length(t), 1) ? t : prefix(t, caml_call2(Base_Import[91], i, 1));
    }
    function lstrip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], match = first_non_drop_literal(drop, escape_char, t);
        if (!match) return cst$11;
        var n = match[1];
        return 0 === n ? t : drop_prefix(t, n);
    }
    function strip_literal(opt, t, escape_char) {
        var drop = opt ? opt[1] : Base_Char[45], length = caml_ml_string_length(t);
        a: if (0 !== length) {
            if (!caml_call1(drop, caml_string_get(t, 0)) && !caml_call1(drop, caml_string_get(t, caml_call2(Base_Import[93], length, 1)))) break a;
            var match = first_non_drop_literal(drop, escape_char, t);
            if (!match) return cst$12;
            var first = match[1], match$0 = last_non_drop_literal(drop, escape_char, t);
            if (!match$0) throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _H_
            ], 1);
            var last = match$0[1], _ar_ = caml_call2(Base_Import[93], last, first);
            return sub(t, first, caml_call2(Base_Import[91], _ar_, 1));
        }
        return t;
    }
    function between$0(t, low, high) {
        var _aq_ = caml_call2(Base_Import[109][2], low, t);
        return _aq_ ? caml_call2(Base_Import[109][2], t, high) : _aq_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[109][1], t, min) ? min : caml_call2(Base_Import[109][2], t, max) ? t : max;
    }
    function clamp_exn$0(t, min, max) {
        if (caml_call2(Base_Import[109][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _I_
        ], 1);
    }
    function clamp$0(t, min, max) {
        if (!caml_call2(Base_Import[109][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _an_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _ao_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _an_
        ], _ap_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _ao_);
        return caml_call1(Base_Or_error[39], _ap_);
    }
    function create$0(opt, pattern) {
        var case_sensitive = opt ? opt[1] : 1;
        return create(pattern, case_sensitive);
    }
    function Make_utf(Format) {
        var codec_name = Format[1], is_valid = Format[3], raise_get_message = [
            246,
            function(_am_) {
                return caml_call3(Base_Printf[2], _J_, Format[2], Format[1]);
            }
        ];
        function raise_get(t, pos) {
            var _aj_ = [
                0,
                [
                    0,
                    cst$13,
                    [
                        0,
                        t
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_pos$1,
                        caml_call1(Base_Import[139], pos)
                    ],
                    0
                ]
            ], _ak_ = runtime.caml_obj_tag(raise_get_message);
            a: if (250 === _ak_) var _al_ = raise_get_message[1];
            else {
                if (246 !== _ak_ && 244 !== _ak_) {
                    var _al_ = raise_get_message;
                    break a;
                }
                var _al_ = caml_call1(CamlinternalLazy[2], raise_get_message);
            }
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], _al_, _aj_));
        }
        function get(t, byte_pos) {
            var decode = caml_call2(Format[5], t, byte_pos);
            return caml_call1(Base_Uchar0[18], decode) ? caml_call1(Base_Uchar0[19], decode) : raise_get(t, byte_pos);
        }
        function to_string(_ai_) {
            return _ai_;
        }
        function of_string_unchecked(_ah_) {
            return _ah_;
        }
        var raise_of_string_message = caml_call2(concat, 0, [
            0,
            Format[2],
            [
                0,
                cst_of_string_invalid,
                [
                    0,
                    codec_name,
                    0
                ]
            ]
        ]);
        function raise_of_string(string) {
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], raise_of_string_message, [
                0,
                [
                    0,
                    cst$14,
                    [
                        0,
                        string
                    ]
                ],
                0
            ]));
        }
        function of_string(string) {
            return caml_call1(is_valid, string) ? string : raise_of_string(string);
        }
        var include = caml_call1(Base_Sexpable[5], [
            0,
            of_string,
            to_string
        ]), t_sexp_grammar = include[1], t_of_sexp = include[2], sexp_of_t = include[3], compare = Base_Import[109][9];
        function hash(_ag_) {
            return runtime.Base_hash_string(_ag_);
        }
        var module_name = Format[2], include$0 = caml_call1(Base_Identifiable[1], [
            0,
            compare,
            hash_fold_t,
            hash,
            t_of_sexp,
            sexp_of_t,
            of_string,
            to_string,
            module_name
        ]), hash_fold_t$0 = include$0[1], hash$0 = include$0[2], t_of_sexp$0 = include$0[3], sexp_of_t$0 = include$0[4], of_string$0 = include$0[5], to_string$0 = include$0[6], symbol = include$0[7], symbol$0 = include$0[8], symbol$1 = include$0[9], symbol$2 = include$0[10], symbol$3 = include$0[11], symbol$4 = include$0[12], equal = include$0[13], compare$0 = include$0[14], min = include$0[15], max = include$0[16], ascending = include$0[17], descending = include$0[18], between = include$0[19], clamp_exn = include$0[20], clamp = include$0[21], comparator = include$0[22], pp = include$0[23], hashable = include$0[24];
        function to_sequence(t) {
            var len = caml_ml_string_length(t);
            return caml_call2(Base_Sequence[45], 0, function(byte_pos) {
                if (len <= byte_pos) return 0;
                var decode = caml_call2(Format[5], t, byte_pos), _ae_ = caml_call1(Base_Uchar0[20], decode), _af_ = caml_call2(Base_Import[91], byte_pos, _ae_);
                return [
                    0,
                    [
                        0,
                        caml_call1(Base_Uchar0[19], decode),
                        _af_
                    ]
                ];
            });
        }
        function fold(t, acc, f) {
            var len = caml_ml_string_length(t), byte_pos = 0, acc$0 = acc;
            for(;;){
                if (byte_pos === len) return acc$0;
                var decode = caml_call2(Format[5], t, byte_pos), acc$1 = caml_call2(f, acc$0, caml_call1(Base_Uchar0[19], decode)), _ad_ = caml_call1(Base_Uchar0[20], decode), byte_pos$0 = caml_call2(Base_Import[91], byte_pos, _ad_);
                byte_pos = byte_pos$0;
                acc$0 = acc$1;
            }
        }
        function sanitize(t) {
            var len = fold(t, 0, function(pos, uchar) {
                var _ac_ = caml_call1(Format[4], uchar);
                return caml_call2(Base_Import[91], pos, _ac_);
            }), bytes = caml_call1(Base_Bytes0[7], len), pos = fold(t, 0, function(pos, uchar) {
                var _ab_ = caml_call3(Format[6], bytes, pos, uchar);
                return caml_call2(Base_Import[91], pos, _ab_);
            });
            if (pos === len) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _K_
            ], 1);
        }
        function of_list(uchars) {
            var len = caml_call3(Base_List[20], uchars, 0, function(n, u) {
                var _aa_ = caml_call1(Format[4], u);
                return caml_call2(Base_Import[91], n, _aa_);
            }), bytes = caml_call1(Base_Bytes0[7], len), pos = caml_call3(Base_List[20], uchars, 0, function(pos, uchar) {
                var _$_ = caml_call3(Format[6], bytes, pos, uchar);
                return caml_call2(Base_Import[91], pos, _$_);
            });
            if (pos === len) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _L_
            ], 1);
        }
        function of_array(uchars) {
            var len = [
                0,
                0
            ], _S_ = caml_call2(Base_Import[93], uchars.length - 1, 1), _R_ = 0;
            if (_S_ >= 0) {
                var i$0 = _R_;
                for(;;){
                    var _Y_ = caml_check_bound(uchars, i$0)[1 + i$0], _Z_ = caml_call1(Format[4], _Y_);
                    len[1] = caml_call2(Base_Import[91], len[1], _Z_);
                    var ___ = i$0 + 1 | 0;
                    if (_S_ === i$0) break;
                    i$0 = ___;
                }
            }
            var bytes = caml_call1(Base_Bytes0[7], len[1]), pos = [
                0,
                0
            ], _U_ = caml_call2(Base_Import[93], uchars.length - 1, 1), _T_1 = 0;
            if (_U_ >= 0) {
                var i = _T_1;
                for(;;){
                    var _V_ = caml_check_bound(uchars, i)[1 + i], _W_ = caml_call3(Format[6], bytes, pos[1], _V_);
                    pos[1] = caml_call2(Base_Import[91], pos[1], _W_);
                    var _X_ = i + 1 | 0;
                    if (_U_ === i) break;
                    i = _X_;
                }
            }
            if (pos[1] === len[1]) return caml_string_of_bytes(bytes);
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _M_
            ], 1);
        }
        function concat$0(list) {
            return caml_call2(concat, _N_, list);
        }
        function split(t, on) {
            var len = caml_ml_string_length(t), start$1 = 0, until = 0;
            for(;;){
                if (until === len) return [
                    0,
                    sub(t, start$1, caml_call2(Base_Import[93], until, start$1)),
                    0
                ];
                var uchar = get(t, until), _P_ = caml_call1(Format[4], uchar), until$0 = caml_call2(Base_Import[91], until, _P_);
                if (caml_call2(Base_Uchar0[11], uchar, on)) break;
                until = until$0;
            }
            var block = [
                0,
                sub(t, start$1, caml_call2(Base_Import[93], until, start$1)),
                24029
            ], dst = block, offset = 1, start = until$0, until$1 = until$0;
            for(;;){
                if (until$1 === len) {
                    dst[1 + offset] = [
                        0,
                        sub(t, start, caml_call2(Base_Import[93], until$1, start)),
                        0
                    ];
                    return block;
                }
                var uchar$0 = get(t, until$1), _Q_ = caml_call1(Format[4], uchar$0), start$0 = caml_call2(Base_Import[91], until$1, _Q_);
                if (caml_call2(Base_Uchar0[11], uchar$0, on)) {
                    var dst$0 = [
                        0,
                        sub(t, start, caml_call2(Base_Import[93], until$1, start)),
                        24029
                    ];
                    dst[1 + offset] = dst$0;
                    dst = dst$0;
                    offset = 1;
                    start = start$0;
                    until$1 = start$0;
                } else until$1 = start$0;
            }
        }
        var C = caml_call1(Base_Indexed_container[12], [
            0,
            [
                0,
                Base_Uchar0[11]
            ],
            of_list,
            of_array,
            concat$0,
            fold,
            -304398144,
            -304398144,
            -304398144,
            -304398144,
            348729712,
            -637740141
        ]), append = C[3], concat_map = C[8], concat_mapi = C[39], count = C[20], counti = C[32], exists = C[18], existsi = C[30], filter = C[6], filter_map = C[7], filter_mapi = C[38], filteri = C[37], find = C[22], find_map = C[23], find_mapi = C[34], findi = C[33], fold_result = C[16], fold_until = C[17], foldi = C[28], for_all = C[19], for_alli = C[31], init = C[35], is_empty = C[13], iter = C[14], iteri = C[29], length = C[12], map = C[5], mapi = C[36], max_elt = C[27], mem = C[11], min_elt = C[26], partition_map = C[10], partition_tf = C[9], sum = C[21], to_array = C[25], to_list = C[24];
        return [
            0,
            codec_name,
            is_valid,
            ,
            ,
            get,
            of_string_unchecked,
            ,
            ,
            t_sexp_grammar,
            hash_fold_t$0,
            hash$0,
            t_of_sexp$0,
            sexp_of_t$0,
            of_string$0,
            to_string$0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal,
            compare$0,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator,
            pp,
            hashable,
            to_sequence,
            fold,
            sanitize,
            of_list,
            of_array,
            concat$0,
            split,
            ,
            append,
            concat_map,
            concat_mapi,
            count,
            counti,
            exists,
            existsi,
            filter,
            filter_map,
            filter_mapi,
            filteri,
            find,
            find_map,
            find_mapi,
            findi,
            fold_result,
            fold_until,
            foldi,
            for_all,
            for_alli,
            init,
            is_empty,
            iter,
            iteri,
            length,
            map,
            mapi,
            max_elt,
            mem,
            min_elt,
            partition_map,
            partition_tf,
            sum,
            to_array,
            to_list,
            length
        ];
    }
    var byte_length = Base_Uchar0[16], set = Base_Bytes0[8], Utf8 = Make_utf([
        0,
        codec_name,
        module_name,
        is_valid_utf_8,
        byte_length,
        get_utf_8_uchar,
        set
    ]), byte_length$0 = Base_Uchar0[17], set$0 = Base_Bytes0[9], Utf16le = Make_utf([
        0,
        codec_name$0,
        module_name$0,
        is_valid_utf_16le,
        byte_length$0,
        get_utf_16le_uchar,
        set$0
    ]), byte_length$1 = Base_Uchar0[17], set$1 = Base_Bytes0[10], Utf16be = Make_utf([
        0,
        codec_name$1,
        module_name$1,
        is_valid_utf_16be,
        byte_length$1,
        get_utf_16be_uchar,
        set$1
    ]);
    function Make_utf32(Format) {
        function byte_length(param) {
            return 4;
        }
        var codec_name = Format[1], module_name = Format[2], set = Format[4], get_decode_result = Format[3];
        function is_valid(t) {
            var len = caml_ml_string_length(t);
            if (0 !== caml_call2(Base_Import[122], len, 4)) return 0;
            var byte_pos = 0;
            for(;;){
                if (byte_pos >= len) return 1;
                var result = caml_call2(Format[3], t, byte_pos), _O_ = caml_call1(Base_Uchar0[18], result);
                if (!_O_) return _O_;
                var byte_pos$0 = caml_call2(Base_Import[91], byte_pos, 4);
                byte_pos = byte_pos$0;
            }
        }
        return Make_utf([
            0,
            codec_name,
            module_name,
            is_valid,
            byte_length,
            get_decode_result,
            set
        ]);
    }
    var set$2 = Base_Bytes0[12], Utf32le = Make_utf32([
        0,
        codec_name$2,
        module_name$2,
        get_utf_32le_uchar,
        set$2
    ]), set$3 = Base_Bytes0[13], Utf32be = Make_utf32([
        0,
        codec_name$3,
        module_name$3,
        get_utf_32be_uchar,
        set$3
    ]), include$1 = Base_Import[109], symbol$5 = include$1[1], symbol$6 = include$1[2], symbol$7 = include$1[3], symbol$8 = include$1[4], symbol$9 = include$1[5], symbol$10 = include$1[6], ascending$0 = include$1[7], descending$0 = include$1[8], compare$2 = include$1[9], compare_local$0 = include$1[10], equal$1 = include$1[11], equal_local$0 = include$1[12], max$0 = include$1[13], min$0 = include$1[14], Base_String = [
        0,
        globalize,
        t_sexp_grammar,
        sub,
        unsafe_sub,
        subo,
        of_char_list,
        of_array,
        symbol_concat,
        map,
        filter,
        filter_map,
        partition_tf,
        partition_map,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        init,
        mapi,
        filteri,
        filter_mapi,
        hash_fold_t,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        symbol$10,
        symbol$6,
        symbol$8,
        symbol$9,
        symbol$5,
        symbol$7,
        compare$2,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between$0,
        clamp_exn$0,
        clamp$0,
        comparator,
        pp,
        hashable,
        compare_local$0,
        invariant,
        max_length,
        mem,
        make,
        symbol_concat,
        concat,
        escaped,
        contains,
        uppercase,
        lowercase,
        capitalize,
        uncapitalize,
        [
            0,
            hash_fold_t$0,
            hash$0,
            t_of_sexp$0,
            sexp_of_t$2,
            t_sexp_grammar$0,
            symbol,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            equal$0,
            compare$1,
            min,
            max,
            ascending,
            descending,
            between,
            clamp_exn,
            clamp,
            comparator$0,
            compare_local,
            is_suffix,
            is_prefix,
            is_substring$0,
            is_substring_at,
            substr_index$0,
            substr_index_exn$0,
            substr_index_all$0,
            substr_replace_first$0,
            substr_replace_all$0
        ],
        index,
        index_exn,
        index_from,
        index_from_exn,
        rindex,
        rindex_exn,
        rindex_from,
        rindex_from_exn,
        to_sequence,
        of_sequence,
        [
            0,
            sexp_of_t$0,
            create$0,
            pattern,
            case_sensitive,
            matches,
            index$0,
            index_exn$0,
            index_all,
            replace_first,
            replace_all,
            split_on,
            [
                0,
                equal,
                equal_local,
                sexp_of_t$1,
                representation
            ]
        ],
        substr_index,
        substr_index_exn,
        substr_index_all,
        substr_replace_first,
        substr_replace_all,
        is_substring,
        is_substring_at$0,
        to_list_rev,
        rev,
        is_suffix$0,
        is_prefix$0,
        lsplit2_exn,
        rsplit2_exn,
        lsplit2,
        rsplit2,
        split,
        split_on_chars,
        split_lines,
        lfindi,
        rfindi,
        lstrip,
        rstrip,
        strip,
        concat_map,
        concat_mapi,
        tr,
        tr_multi,
        chop_suffix_exn,
        chop_prefix_exn,
        chop_suffix,
        chop_prefix,
        chop_suffix_if_exists,
        chop_prefix_if_exists,
        suffix,
        prefix,
        drop_suffix,
        drop_prefix,
        common_suffix,
        common_prefix,
        common_suffix_length,
        common_prefix_length,
        common_suffix2,
        common_prefix2,
        common_suffix2_length,
        common_prefix2_length,
        concat_array,
        concat_lines,
        equal$1,
        equal_local$0,
        of_char,
        of_char_list,
        pad_left,
        pad_right,
        edit_distance,
        [
            0,
            escape_gen_exn,
            escape_gen,
            escape,
            unescape_gen_exn,
            unescape_gen,
            unescape,
            is_char_escaping,
            is_char_escaped,
            is_char_literal,
            index$1,
            index_exn$1,
            rindex$0,
            rindex_exn$0,
            index_from$0,
            index_from_exn$0,
            rindex_from$0,
            rindex_from_exn$0,
            split$0,
            split_on_chars$0,
            lsplit2$0,
            lsplit2_exn$0,
            rsplit2$0,
            rsplit2_exn$0,
            lstrip_literal,
            rstrip_literal,
            strip_literal
        ],
        [
            0,
            Utf8[9],
            Utf8[10],
            Utf8[11],
            Utf8[12],
            Utf8[13],
            Utf8[14],
            Utf8[15],
            Utf8[16],
            Utf8[17],
            Utf8[18],
            Utf8[19],
            Utf8[20],
            Utf8[21],
            Utf8[22],
            Utf8[23],
            Utf8[24],
            Utf8[25],
            Utf8[26],
            Utf8[27],
            Utf8[28],
            Utf8[29],
            Utf8[30],
            Utf8[31],
            Utf8[32],
            Utf8[33],
            Utf8[37],
            Utf8[38],
            Utf8[42],
            Utf8[39],
            Utf8[67],
            Utf8[49],
            Utf8[50],
            Utf8[43],
            Utf8[73],
            Utf8[72],
            Utf8[70],
            Utf8[63],
            Utf8[64],
            Utf8[35],
            Utf8[57],
            Utf8[58],
            Utf8[47],
            Utf8[60],
            Utf8[45],
            Utf8[74],
            Utf8[53],
            Utf8[54],
            Utf8[76],
            Utf8[75],
            Utf8[71],
            Utf8[69],
            Utf8[59],
            Utf8[65],
            Utf8[48],
            Utf8[61],
            Utf8[46],
            Utf8[56],
            Utf8[55],
            Utf8[62],
            Utf8[68],
            Utf8[52],
            Utf8[51],
            Utf8[44],
            Utf8[34],
            Utf8[2],
            Utf8[36],
            Utf8[5],
            Utf8[6],
            Utf8[40],
            Utf8[1],
            Utf8[77],
            Utf8[66]
        ],
        [
            0,
            Utf16le[9],
            Utf16le[10],
            Utf16le[11],
            Utf16le[12],
            Utf16le[13],
            Utf16le[14],
            Utf16le[15],
            Utf16le[16],
            Utf16le[17],
            Utf16le[18],
            Utf16le[19],
            Utf16le[20],
            Utf16le[21],
            Utf16le[22],
            Utf16le[23],
            Utf16le[24],
            Utf16le[25],
            Utf16le[26],
            Utf16le[27],
            Utf16le[28],
            Utf16le[29],
            Utf16le[30],
            Utf16le[31],
            Utf16le[32],
            Utf16le[33],
            Utf16le[37],
            Utf16le[38],
            Utf16le[42],
            Utf16le[39],
            Utf16le[67],
            Utf16le[49],
            Utf16le[50],
            Utf16le[43],
            Utf16le[73],
            Utf16le[72],
            Utf16le[70],
            Utf16le[63],
            Utf16le[64],
            Utf16le[35],
            Utf16le[57],
            Utf16le[58],
            Utf16le[47],
            Utf16le[60],
            Utf16le[45],
            Utf16le[74],
            Utf16le[53],
            Utf16le[54],
            Utf16le[76],
            Utf16le[75],
            Utf16le[71],
            Utf16le[69],
            Utf16le[59],
            Utf16le[65],
            Utf16le[48],
            Utf16le[61],
            Utf16le[46],
            Utf16le[56],
            Utf16le[55],
            Utf16le[62],
            Utf16le[68],
            Utf16le[52],
            Utf16le[51],
            Utf16le[44],
            Utf16le[34],
            Utf16le[2],
            Utf16le[36],
            Utf16le[5],
            Utf16le[6],
            Utf16le[40],
            Utf16le[1],
            Utf16le[77],
            Utf16le[66]
        ],
        [
            0,
            Utf16be[9],
            Utf16be[10],
            Utf16be[11],
            Utf16be[12],
            Utf16be[13],
            Utf16be[14],
            Utf16be[15],
            Utf16be[16],
            Utf16be[17],
            Utf16be[18],
            Utf16be[19],
            Utf16be[20],
            Utf16be[21],
            Utf16be[22],
            Utf16be[23],
            Utf16be[24],
            Utf16be[25],
            Utf16be[26],
            Utf16be[27],
            Utf16be[28],
            Utf16be[29],
            Utf16be[30],
            Utf16be[31],
            Utf16be[32],
            Utf16be[33],
            Utf16be[37],
            Utf16be[38],
            Utf16be[42],
            Utf16be[39],
            Utf16be[67],
            Utf16be[49],
            Utf16be[50],
            Utf16be[43],
            Utf16be[73],
            Utf16be[72],
            Utf16be[70],
            Utf16be[63],
            Utf16be[64],
            Utf16be[35],
            Utf16be[57],
            Utf16be[58],
            Utf16be[47],
            Utf16be[60],
            Utf16be[45],
            Utf16be[74],
            Utf16be[53],
            Utf16be[54],
            Utf16be[76],
            Utf16be[75],
            Utf16be[71],
            Utf16be[69],
            Utf16be[59],
            Utf16be[65],
            Utf16be[48],
            Utf16be[61],
            Utf16be[46],
            Utf16be[56],
            Utf16be[55],
            Utf16be[62],
            Utf16be[68],
            Utf16be[52],
            Utf16be[51],
            Utf16be[44],
            Utf16be[34],
            Utf16be[2],
            Utf16be[36],
            Utf16be[5],
            Utf16be[6],
            Utf16be[40],
            Utf16be[1],
            Utf16be[77],
            Utf16be[66]
        ],
        [
            0,
            Utf32le[9],
            Utf32le[10],
            Utf32le[11],
            Utf32le[12],
            Utf32le[13],
            Utf32le[14],
            Utf32le[15],
            Utf32le[16],
            Utf32le[17],
            Utf32le[18],
            Utf32le[19],
            Utf32le[20],
            Utf32le[21],
            Utf32le[22],
            Utf32le[23],
            Utf32le[24],
            Utf32le[25],
            Utf32le[26],
            Utf32le[27],
            Utf32le[28],
            Utf32le[29],
            Utf32le[30],
            Utf32le[31],
            Utf32le[32],
            Utf32le[33],
            Utf32le[37],
            Utf32le[38],
            Utf32le[42],
            Utf32le[39],
            Utf32le[67],
            Utf32le[49],
            Utf32le[50],
            Utf32le[43],
            Utf32le[73],
            Utf32le[72],
            Utf32le[70],
            Utf32le[63],
            Utf32le[64],
            Utf32le[35],
            Utf32le[57],
            Utf32le[58],
            Utf32le[47],
            Utf32le[60],
            Utf32le[45],
            Utf32le[74],
            Utf32le[53],
            Utf32le[54],
            Utf32le[76],
            Utf32le[75],
            Utf32le[71],
            Utf32le[69],
            Utf32le[59],
            Utf32le[65],
            Utf32le[48],
            Utf32le[61],
            Utf32le[46],
            Utf32le[56],
            Utf32le[55],
            Utf32le[62],
            Utf32le[68],
            Utf32le[52],
            Utf32le[51],
            Utf32le[44],
            Utf32le[34],
            Utf32le[2],
            Utf32le[36],
            Utf32le[5],
            Utf32le[6],
            Utf32le[40],
            Utf32le[1],
            Utf32le[77],
            Utf32le[66]
        ],
        [
            0,
            Utf32be[9],
            Utf32be[10],
            Utf32be[11],
            Utf32be[12],
            Utf32be[13],
            Utf32be[14],
            Utf32be[15],
            Utf32be[16],
            Utf32be[17],
            Utf32be[18],
            Utf32be[19],
            Utf32be[20],
            Utf32be[21],
            Utf32be[22],
            Utf32be[23],
            Utf32be[24],
            Utf32be[25],
            Utf32be[26],
            Utf32be[27],
            Utf32be[28],
            Utf32be[29],
            Utf32be[30],
            Utf32be[31],
            Utf32be[32],
            Utf32be[33],
            Utf32be[37],
            Utf32be[38],
            Utf32be[42],
            Utf32be[39],
            Utf32be[67],
            Utf32be[49],
            Utf32be[50],
            Utf32be[43],
            Utf32be[73],
            Utf32be[72],
            Utf32be[70],
            Utf32be[63],
            Utf32be[64],
            Utf32be[35],
            Utf32be[57],
            Utf32be[58],
            Utf32be[47],
            Utf32be[60],
            Utf32be[45],
            Utf32be[74],
            Utf32be[53],
            Utf32be[54],
            Utf32be[76],
            Utf32be[75],
            Utf32be[71],
            Utf32be[69],
            Utf32be[59],
            Utf32be[65],
            Utf32be[48],
            Utf32be[61],
            Utf32be[46],
            Utf32be[56],
            Utf32be[55],
            Utf32be[62],
            Utf32be[68],
            Utf32be[52],
            Utf32be[51],
            Utf32be[44],
            Utf32be[34],
            Utf32be[2],
            Utf32be[36],
            Utf32be[5],
            Utf32be[6],
            Utf32be[40],
            Utf32be[1],
            Utf32be[77],
            Utf32be[66]
        ]
    ];
    runtime.caml_register_global(114, Base_String, "Base__String");
    return;
})(globalThis);
//# 22765 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_bytes_get = runtime.caml_bytes_get, caml_bytes_unsafe_get = runtime.caml_bytes_unsafe_get, caml_bytes_unsafe_set = runtime.caml_bytes_unsafe_set, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_bytes_length = runtime.caml_ml_bytes_length, caml_ml_string_length = runtime.caml_ml_string_length;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), module_name = "Base.Bytes", Base_Char = global_data.Base__Char, Base_Import = global_data.Base__Import, Base_Ordered_collection_common = global_data.Base__Ordered_collection_common, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Bytes_tr = global_data.Base__Bytes_tr, Base_Array0 = global_data.Base__Array0, Base_List = global_data.Base__List, Base_Printf = global_data.Base__Printf, Stdlib_Format = global_data.Stdlib__Format, Base_Staged = global_data.Base__Staged, Base_Bytes0 = global_data.Base__Bytes0, Base_Blit = global_data.Base__Blit, Base_Comparator = global_data.Base__Comparator, Base_Pretty_printer = global_data.Base__Pretty_printer, stage = Base_Staged[1], globalize = Base_Import[288], t_of_sexp = Base_Import[161], sexp_of_t = Base_Import[137], t_sexp_grammar = Base_Import[183], max_length = Base_Bytes0[2], compare = Base_Bytes0[5], copy = Base_Bytes0[6], create = Base_Bytes0[7], set_uchar_utf_8 = Base_Bytes0[8], set_uchar_utf_16le = Base_Bytes0[9], set_uchar_utf_16be = Base_Bytes0[10], set_uchar_utf_32le = Base_Bytes0[12], set_uchar_utf_32be = Base_Bytes0[13], create_local = Base_Bytes0[14], fill = Base_Bytes0[15], make = Base_Bytes0[16], map = Base_Bytes0[17], mapi = Base_Bytes0[18], to_string = Base_Bytes0[20], of_string = Base_Bytes0[21], _a_ = [
        0,
        [
            3,
            0,
            0
        ],
        "%S"
    ];
    function pp(fmt, t) {
        var _w_ = caml_call1(to_string, t);
        return caml_call3(Stdlib_Format[143], fmt, _a_, _w_);
    }
    function create$0(len) {
        return caml_call1(create, len);
    }
    var To_bytes = caml_call1(Base_Blit[1], [
        0,
        caml_ml_bytes_length,
        create$0,
        runtime.caml_blit_bytes
    ]), blit = To_bytes[1], blito = To_bytes[2], unsafe_blit = To_bytes[3], sub = To_bytes[4], subo = To_bytes[5], comparator = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ])[1], include = caml_call1(Base_Pretty_printer[3], [
        0,
        pp,
        module_name
    ]), pp$0 = include[1], To_string = caml_call1(caml_call1(Base_Blit[3], [
        0
    ]), To_bytes);
    function create$1(len) {
        return caml_call1(create, len);
    }
    var length = caml_ml_bytes_length, unsafe_blit$0 = runtime.caml_blit_string, length$0 = caml_ml_string_length, From_string = caml_call1(caml_call1(Base_Blit[2], [
        0,
        length$0
    ]), [
        0,
        length,
        create$1,
        unsafe_blit$0
    ]), _b_ = [
        0,
        [
            11,
            "Bytes.init ",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Bytes.init %d"
    ], cst_tr_multi_replacement_is_th = "tr_multi: replacement is the empty string", _c_ = [
        0,
        "src/bytes.ml",
        130,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function init(n, f) {
        if (n < 0) caml_call3(Base_Printf[7], _b_, n, 0);
        var t = caml_call1(create, n), _u_ = caml_call2(Base_Import[93], n, 1), _t_ = 0;
        if (_u_ >= 0) {
            var i = _t_;
            for(;;){
                caml_bytes_unsafe_set(t, i, caml_call1(f, i));
                var _v_ = i + 1 | 0;
                if (_u_ === i) break;
                i = _v_;
            }
        }
        return t;
    }
    function of_char_list(l) {
        var t = caml_call1(create, caml_call1(Base_List[45], l));
        caml_call2(Base_List[34], l, function(i, c) {
            return runtime.caml_bytes_set(t, i, c);
        });
        return t;
    }
    function to_list(t) {
        var i$1 = caml_call2(Base_Import[93], caml_ml_bytes_length(t), 1), i = i$1, acc = 0;
        for(;;){
            if (0 > i) return acc;
            var acc$0 = [
                0,
                caml_bytes_unsafe_get(t, i),
                acc
            ], i$0 = caml_call2(Base_Import[93], i, 1);
            i = i$0;
            acc = acc$0;
        }
    }
    function to_array(t) {
        return caml_call2(Base_Array0[12], caml_ml_bytes_length(t), function(i) {
            return caml_bytes_unsafe_get(t, i);
        });
    }
    function map$0(t, f) {
        return caml_call2(map, t, f);
    }
    function mapi$0(t, f) {
        return caml_call2(mapi, t, f);
    }
    function fold(t, init, f) {
        var len = caml_ml_bytes_length(t), pos = 0, acc = init;
        for(;;){
            if (pos === len) return acc;
            var acc$0 = caml_call2(f, acc, caml_bytes_unsafe_get(t, pos)), pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
            acc = acc$0;
        }
    }
    function foldi(t, init, f) {
        var len = caml_ml_bytes_length(t), pos = 0, acc = init;
        for(;;){
            if (pos === len) return acc;
            var acc$0 = caml_call3(f, pos, acc, caml_bytes_unsafe_get(t, pos)), pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
            acc = acc$0;
        }
    }
    function tr(target, replacement, s) {
        var _r_ = caml_call2(Base_Import[93], caml_ml_bytes_length(s), 1), _q_ = 0;
        if (_r_ >= 0) {
            var i = _q_;
            for(;;){
                if (caml_call2(Base_Char[16], caml_bytes_unsafe_get(s, i), target)) caml_bytes_unsafe_set(s, i, replacement);
                var _s_ = i + 1 | 0;
                if (_r_ === i) break;
                i = _s_;
            }
        }
        return 0;
    }
    function tr_multi(target, replacement) {
        if (0 === caml_ml_string_length(target)) return caml_call1(stage, function(_p_) {
            return 0;
        });
        if (0 === caml_ml_string_length(replacement)) return caml_call1(Base_Import[126], cst_tr_multi_replacement_is_th);
        var match = caml_call2(Base_Bytes_tr[1], target, replacement);
        if (!match) return caml_call1(stage, function(_o_) {
            return 0;
        });
        var tr_map = match[1];
        return caml_call1(stage, function(s) {
            var _m_ = caml_call2(Base_Import[93], caml_ml_bytes_length(s), 1), _l_ = 0;
            if (_m_ >= 0) {
                var i = _l_;
                for(;;){
                    caml_bytes_unsafe_set(s, i, runtime.caml_string_unsafe_get(tr_map, caml_call1(Base_Char[32], caml_bytes_unsafe_get(s, i))));
                    var _n_ = i + 1 | 0;
                    if (_m_ === i) break;
                    i = _n_;
                }
            }
            return 0;
        });
    }
    function between(t, low, high) {
        var _k_ = caml_call2(Base_Import[110][2], low, t);
        return _k_ ? caml_call2(Base_Import[110][2], t, high) : _k_;
    }
    function clamp_unchecked(t, min, max) {
        return caml_call2(Base_Import[110][1], t, min) ? min : caml_call2(Base_Import[110][2], t, max) ? t : max;
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[110][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[110][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _h_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _i_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _h_
        ], _j_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _i_);
        return caml_call1(Base_Or_error[39], _j_);
    }
    function contains(pos, len, t, char$0) {
        var match = caml_call4(Base_Ordered_collection_common[1], pos, len, 0, caml_ml_bytes_length(t)), len$0 = match[2], pos$0 = match[1], last = caml_call2(Base_Import[91], pos$0, len$0), i = pos$0;
        for(;;){
            var _d_ = i < last ? 1 : 0;
            if (_d_) {
                var _e_ = caml_bytes_get(t, i), _f_ = caml_call2(Base_Char[16], _e_, char$0);
                if (!_f_) {
                    var i$0 = caml_call2(Base_Import[91], i, 1);
                    i = i$0;
                    continue;
                }
                var _g_ = _f_;
            } else var _g_ = _d_;
            return _g_;
        }
    }
    var Utf8 = [
        0,
        set_uchar_utf_8
    ], Utf16le = [
        0,
        set_uchar_utf_16le
    ], Utf16be = [
        0,
        set_uchar_utf_16be
    ], Utf32le = [
        0,
        set_uchar_utf_32le
    ], Utf32be = [
        0,
        set_uchar_utf_32be
    ], include$0 = Base_Import[110], symbol = include$0[1], symbol$0 = include$0[2], symbol$1 = include$0[3], symbol$2 = include$0[4], symbol$3 = include$0[5], symbol$4 = include$0[6], ascending = include$0[7], descending = include$0[8], compare$0 = include$0[9], compare_local = include$0[10], equal = include$0[11], equal_local = include$0[12], max = include$0[13], min = include$0[14], Base_Bytes = [
        0,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        blit,
        blito,
        unsafe_blit,
        sub,
        subo,
        symbol$4,
        symbol$0,
        symbol$2,
        symbol$3,
        symbol,
        symbol$1,
        equal,
        compare$0,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local,
        of_string,
        to_string,
        pp$0,
        invariant,
        To_string,
        From_string,
        create,
        create_local,
        make,
        map$0,
        mapi$0,
        copy,
        init,
        of_char_list,
        caml_bytes_get,
        fill,
        tr,
        tr_multi,
        to_list,
        to_array,
        fold,
        foldi,
        contains,
        max_length,
        Utf8,
        Utf16le,
        Utf16be,
        Utf32le,
        Utf32be
    ];
    runtime.caml_register_global(24, Base_Bytes, "Base__Bytes");
    return;
})(globalThis);
//# 23130 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), ocaml_lex_tables = [
        0,
        "\0\0\0\0\x01\0\x01\0\x02\0\x1b\0R\0i\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\x01\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
        "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x02\0\0\0\0\0\x01\0\x03\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\x06\0\x04\0\0\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x06\0\x04\0\x05\0\0\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x07\0\0\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",
        "\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\0\0\x02\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\xff\xff\xff\xff\x01\0\x03\0\xff\xff\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\x03\0\x05\0\xff\xff\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x07\0\xff\xff\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff",
        cst,
        cst,
        cst,
        cst,
        cst,
        cst
    ], Stdlib_Lexing = global_data.Stdlib__Lexing;
    function parse_hex(lexbuf) {
        var ocaml_lex_state = 0;
        for(;;){
            var ocaml_lex_state$0 = caml_call3(Stdlib_Lexing[20], ocaml_lex_tables, ocaml_lex_state, lexbuf);
            if (0 === ocaml_lex_state$0) {
                var body = caml_call3(Stdlib_Lexing[16], lexbuf, lexbuf[5] + 3 | 0, lexbuf[6]);
                return [
                    0,
                    body
                ];
            }
            if (1 === ocaml_lex_state$0) {
                var body$0 = caml_call3(Stdlib_Lexing[16], lexbuf, lexbuf[5] + 2 | 0, lexbuf[6]);
                return [
                    1,
                    body$0
                ];
            }
            caml_call1(lexbuf[1], lexbuf);
            ocaml_lex_state = ocaml_lex_state$0;
        }
    }
    var Base_Hex_lexer = [
        0,
        parse_hex
    ];
    runtime.caml_register_global(2, Base_Hex_lexer, "Base__Hex_lexer");
    return;
})(globalThis);
//# 23191 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_0b$1 = "0b", caml_bytes_set = runtime.caml_bytes_set, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Base_Hex_lexer = global_data.Base__Hex_lexer, Stdlib_Lexing = global_data.Stdlib__Lexing, Base_Option = global_data.Base__Option, Base_Printf = global_data.Base__Printf, Base_Sexpable = global_data.Base__Sexpable, Base_Bytes = global_data.Base__Bytes, Base_Sexp = global_data.Base__Sexp;
    function insert_delimiter_every(input, delimiter, chars_per_delimiter) {
        var input_length = runtime.caml_ml_string_length(input);
        if (input_length <= chars_per_delimiter) return input;
        var match = caml_string_get(input, 0);
        a: {
            if (43 !== match && 45 !== match) {
                var has_sign = 0;
                break a;
            }
            var has_sign = 1;
        }
        var num_digits = has_sign ? caml_call2(Base_Import[93], input_length, 1) : input_length, _v_ = caml_call2(Base_Import[93], num_digits, 1), num_delimiters = caml_call2(Base_Import[95], _v_, chars_per_delimiter), output_length = caml_call2(Base_Import[91], input_length, num_delimiters), output = caml_call1(Base_Bytes[34], output_length), input_pos = [
            0,
            caml_call2(Base_Import[93], input_length, 1)
        ], output_pos = [
            0,
            caml_call2(Base_Import[93], output_length, 1)
        ], num_chars_until_delimiter = [
            0,
            chars_per_delimiter
        ], first_digit_pos = has_sign ? 1 : 0;
        for(;;){
            if (first_digit_pos > input_pos[1]) {
                if (has_sign) caml_bytes_set(output, 0, caml_string_get(input, 0));
                return runtime.caml_string_of_bytes(output);
            }
            if (0 === num_chars_until_delimiter[1]) {
                caml_bytes_set(output, output_pos[1], delimiter);
                output_pos[1]--;
                num_chars_until_delimiter[1] = chars_per_delimiter;
            }
            var _w_ = caml_string_get(input, input_pos[1]);
            caml_bytes_set(output, output_pos[1], _w_);
            input_pos[1]--;
            output_pos[1]--;
            num_chars_until_delimiter[1]--;
        }
    }
    function insert_delimiter(input, delimiter) {
        return insert_delimiter_every(input, delimiter, 3);
    }
    function insert_underscores(input) {
        return insert_delimiter(input, 95);
    }
    var sexp_of_int_style = Base_Sexp[20], cst_0x = "-0x", cst_0x$0 = "0x", _a_ = [
        0,
        [
            2,
            0,
            [
                11,
                ".of_string: invalid input ",
                [
                    3,
                    0,
                    0
                ]
            ]
        ],
        "%s.of_string: invalid input %S"
    ], cst_0 = "0", cst_0b = cst_0b$1, cst_0b$0 = cst_0b$1, Base_Int_string_conversions = [
        0,
        function(I) {
            var chars_per_delimiter = 3;
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95;
                return insert_delimiter_every(caml_call1(I[1], t), delimiter, chars_per_delimiter);
            }
            function sexp_of_t(t) {
                var s = caml_call1(I[1], t), s$0 = 1009018843 <= sexp_of_int_style[1] ? s : insert_delimiter_every(s, 95, chars_per_delimiter);
                return [
                    0,
                    s$0
                ];
            }
            return [
                0,
                to_string_hum,
                sexp_of_t
            ];
        },
        function(I) {
            var compare_local = I[2];
            function compare(a, b) {
                return caml_call2(compare_local, a, b);
            }
            var hash_fold_t = I[3], func = I[4];
            function hash(x) {
                return caml_call1(func, x);
            }
            var chars_per_delimiter = 4;
            function to_string(delimiter, t) {
                if (delimiter) var delimiter$0 = delimiter[1], make_suffix = function(t) {
                    return insert_delimiter_every(caml_call1(I[5], t), delimiter$0, chars_per_delimiter);
                };
                else var make_suffix = I[5];
                if (caml_call2(I[8], t, I[7])) {
                    var _t_ = caml_call1(make_suffix, caml_call1(I[9], t));
                    return caml_call2(Base_Import[112], cst_0x, _t_);
                }
                var _u_ = caml_call1(make_suffix, t);
                return caml_call2(Base_Import[112], cst_0x$0, _u_);
            }
            function to_string$0(t) {
                return to_string(0, t);
            }
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95;
                return to_string([
                    0,
                    delimiter
                ], t);
            }
            function invalid(str) {
                return caml_call4(Base_Printf[6], _a_, I[10], str, 0);
            }
            function of_string_with_delimiter(str) {
                var _s_ = caml_call2(Base_String[10], str, function(c) {
                    return caml_call2(Base_Char[15], c, 95);
                });
                return caml_call1(I[6], _s_);
            }
            function of_string(str) {
                var lex = caml_call2(Stdlib_Lexing[3], 0, str), result = caml_call1(Base_Option[47], function(param) {
                    return caml_call1(Base_Hex_lexer[1], lex);
                });
                if (lex[6] !== lex[3]) return invalid(str);
                if (!result) return invalid(str);
                var match = result[1];
                if (0 === match[0]) {
                    var body = match[1], _r_ = of_string_with_delimiter(body);
                    return caml_call1(I[9], _r_);
                }
                var body$0 = match[1];
                return of_string_with_delimiter(body$0);
            }
            var include = caml_call1(Base_Sexpable[5], [
                0,
                of_string,
                to_string$0
            ]), t_sexp_grammar = include[1], t_of_sexp = include[2], sexp_of_t = include[3];
            return [
                0,
                [
                    0,
                    t_of_sexp,
                    sexp_of_t,
                    t_sexp_grammar,
                    compare,
                    compare_local,
                    hash_fold_t,
                    hash,
                    of_string,
                    to_string$0,
                    to_string_hum
                ]
            ];
        },
        function(_b_) {
            var func = _b_[6], hash_fold_t = _b_[5], compare_local = _b_[2], _c_ = _b_[12], _d_ = _b_[13], _e_ = _b_[11], _f_ = _b_[10], _g_ = _b_[9], _h_ = _b_[8], _i_ = _b_[7], _j_ = _b_[4];
            function compare(a, b) {
                return caml_call2(compare_local, a, b);
            }
            function hash(x) {
                return caml_call1(func, x);
            }
            function to_string_suffix(t) {
                if (caml_call2(_j_, t, _d_)) var bits = 0;
                else var _m_ = caml_call1(_i_, t), bits = caml_call2(Base_Import[93], _e_, _m_);
                return 0 === bits ? cst_0 : caml_call2(Base_String[36], bits, function(char_index) {
                    var _n_ = caml_call2(Base_Import[93], bits, char_index), bit_index = caml_call2(Base_Import[93], _n_, 1), bit = caml_call2(_g_, caml_call2(_h_, t, bit_index), _c_), _o_ = caml_call1(_f_, bit), _p_ = caml_call1(Base_Char[32], 48), _q_ = caml_call2(Base_Import[91], _p_, _o_);
                    return caml_call1(Base_Char[35], _q_);
                });
            }
            function to_string(t) {
                var _l_ = to_string_suffix(t);
                return caml_call2(Base_Import[112], cst_0b, _l_);
            }
            function to_string_hum(opt, t) {
                var delimiter = opt ? opt[1] : 95, _k_ = insert_delimiter_every(to_string_suffix(t), delimiter, 4);
                return caml_call2(Base_Import[112], cst_0b$0, _k_);
            }
            function sexp_of_t(t) {
                return [
                    0,
                    to_string_hum(0, t)
                ];
            }
            return [
                0,
                [
                    0,
                    sexp_of_t,
                    compare,
                    compare_local,
                    hash_fold_t,
                    hash,
                    to_string,
                    to_string_hum
                ]
            ];
        },
        sexp_of_int_style,
        insert_delimiter_every,
        insert_delimiter,
        insert_underscores
    ];
    runtime.caml_register_global(16, Base_Int_string_conversions, "Base__Int_string_conversions");
    return;
})(globalThis);
//# 23445 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, global_data = runtime.caml_get_global_data(), m1 = runtime.caml_int64_create_lo_mi_hi(5592405, 5592405, 21845), m2 = runtime.caml_int64_create_lo_mi_hi(3355443, 3355443, 13107), m4 = runtime.caml_int64_create_lo_mi_hi(986895, 986895, 3855), h01 = runtime.caml_int64_create_lo_mi_hi(65793, 65793, 257), mask = runtime.caml_int64_create_lo_mi_hi(16777215, 255, 0), Stdlib_Nativeint = global_data.Stdlib__Nativeint, Assert_failure = global_data.Assert_failure;
    function int64_popcount(x$1) {
        var x$0 = runtime.caml_int64_sub(x$1, caml_int64_and(caml_int64_shift_right_unsigne(x$1, 1), m1)), x = caml_int64_add(caml_int64_and(x$0, m2), caml_int64_and(caml_int64_shift_right_unsigne(x$0, 2), m2)), x$2 = caml_int64_and(caml_int64_add(x, caml_int64_shift_right_unsigne(x, 4)), m4);
        return runtime.caml_int64_to_int32(caml_int64_shift_right_unsigne(runtime.caml_int64_mul(x$2, h01), 56));
    }
    function int32_popcount(x) {
        return int64_popcount(caml_int64_and(caml_int64_of_int32(x), mask));
    }
    var _a_ = Stdlib_Nativeint[9], _b_ = [
        0,
        "src/popcount.ml",
        45,
        9
    ];
    if (32 === _a_) var nativeint_popcount = function(x) {
        return int32_popcount(x);
    };
    else {
        if (64 !== _a_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
        var nativeint_popcount = function(x) {
            return int64_popcount(caml_int64_of_int32(x));
        };
    }
    var Base_Popcount = [
        0,
        function(_c_) {
            return runtime.Base_int_math_int_popcount(_c_);
        },
        int32_popcount,
        int64_popcount,
        nativeint_popcount
    ];
    runtime.caml_register_global(8, Base_Popcount, "Base__Popcount");
    return;
})(globalThis);
//# 23506 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Sign0 = global_data.Base__Sign0, Base_Identifiable = global_data.Base__Identifiable, t_sexp_grammar = Base_Sign0[3], compare_local = Base_Sign0[4], all = Base_Sign0[7], Replace_polymorphic_compare = Base_Sign0[8], to_int = Base_Sign0[11], of_int = Base_Sign0[14], _a_ = caml_call1(Base_Identifiable[1], [
        0,
        Base_Sign0[5],
        Base_Sign0[6],
        Base_Sign0[12],
        Base_Sign0[1],
        Base_Sign0[2],
        Base_Sign0[9],
        Base_Sign0[10],
        Base_Sign0[13]
    ]), hash_fold_t = _a_[1], hash = _a_[2], t_of_sexp = _a_[3], sexp_of_t = _a_[4], of_string = _a_[5], to_string = _a_[6], between = _a_[19], clamp_exn = _a_[20], clamp = _a_[21], comparator = _a_[22], pp = _a_[23], hashable = _a_[24], cst_negative = "negative", cst_zero = "zero", cst_positive = "positive";
    function to_string_hum(param) {
        switch(param){
            case 0:
                return cst_negative;
            case 1:
                return cst_zero;
            default:
                return cst_positive;
        }
    }
    function to_float(param) {
        switch(param){
            case 0:
                return -1;
            case 1:
                return 0.;
            default:
                return 1.;
        }
    }
    function flip(param) {
        switch(param){
            case 0:
                return 2;
            case 1:
                return 1;
            default:
                return 0;
        }
    }
    function symbol(t$0, t) {
        var _b_ = caml_call1(to_int, t), _c_ = caml_call1(to_int, t$0);
        return caml_call1(of_int, caml_call2(Base_Import[88], _c_, _b_));
    }
    var symbol$0 = Replace_polymorphic_compare[1], symbol$1 = Replace_polymorphic_compare[2], symbol$2 = Replace_polymorphic_compare[3], symbol$3 = Replace_polymorphic_compare[4], symbol$4 = Replace_polymorphic_compare[5], symbol$5 = Replace_polymorphic_compare[6], ascending = Replace_polymorphic_compare[7], descending = Replace_polymorphic_compare[8], compare = Replace_polymorphic_compare[9], equal = Replace_polymorphic_compare[10], equal_local = Replace_polymorphic_compare[11], max = Replace_polymorphic_compare[12], min = Replace_polymorphic_compare[13], Base_Sign = [
        0,
        all,
        t_sexp_grammar,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        symbol$5,
        symbol$1,
        symbol$3,
        symbol$4,
        symbol$0,
        symbol$2,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        compare_local,
        equal_local,
        to_string_hum,
        of_int,
        to_int,
        to_float,
        flip,
        symbol
    ];
    runtime.caml_register_global(9, Base_Sign, "Base__Sign");
    return;
})(globalThis);
//# 23636 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_x = "%x", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_div = runtime.caml_div, caml_int_compare = runtime.caml_int_compare, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int.Hex", module_name$0 = "Base.Int", Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Float0 = global_data.Base__Float0, Base_Int0 = global_data.Base__Int0, Base_Int_conversions = global_data.Base__Int_conversions, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Int_math = global_data.Base__Int_math, Base_Error = global_data.Base__Error, Base_Sign = global_data.Base__Sign, Base_Popcount = global_data.Base__Popcount, to_string = Base_Int0[1], of_string = Base_Int0[2], of_string_opt = Base_Int0[3], globalize = Base_Import[284], hash_fold_t = Base_Import[206], func = Base_Import[220];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[163], sexp_of_t = Base_Import[139], t_sexp_grammar = Base_Import[185], hashable = [
        0,
        hash,
        caml_int_compare,
        sexp_of_t
    ], compare = caml_int_compare, _a_ = [
        0,
        [
            11,
            "Int.of_string: ",
            [
                3,
                0,
                0
            ]
        ],
        "Int.of_string: %S"
    ];
    function of_string$0(s) {
        try {
            var _ar_ = caml_call1(of_string, s);
            return _ar_;
        } catch (_as_) {
            return caml_call3(Base_Printf[6], _a_, s, 0);
        }
    }
    var num_bits = Base_Int_conversions[30], float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), _b_ = [
        0,
        [
            11,
            "Int.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_aq_) {
        return _aq_;
    }
    function of_float_unchecked(_ap_) {
        return _ap_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _ao_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _b_, _ao_, 0);
    }
    var zero = 0, one = 1, comparator = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ])[1], _c_ = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), is_positive = _c_[1], is_non_negative = _c_[2], is_negative = _c_[3], is_non_positive = _c_[4], include = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include[1], sexp_of_t$0 = include[2], compare_local = Base_Import[256];
    function compare$0(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[206], func$0 = Base_Import[220];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var neg = Base_Import[113], _d_ = [
        0,
        [
            4,
            6,
            0,
            0,
            0
        ],
        cst_x
    ], _e_ = [
        0,
        [
            4,
            6,
            0,
            0,
            0
        ],
        cst_x
    ];
    function symbol(_an_, _am_) {
        return _an_ < _am_ ? 1 : 0;
    }
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$1(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_al_) {
            return _al_;
        });
    }
    var include$0 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$0,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$1,
        zero,
        symbol,
        neg,
        module_name
    ]), Hex = include$0[1], include$1 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ]), pp = include$1[1], _f_ = [
        0,
        "src/int.ml",
        111,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _aj_ = low <= t ? 1 : 0, _ak_ = _aj_ ? t <= high ? 1 : 0 : _aj_;
        return _ak_;
    }
    function clamp_unchecked(t, min, max) {
        var _ai_ = caml_call2(Base_Import[97][4], t, max);
        return caml_call1(caml_call1(Base_Import[97][3], min), _ai_);
    }
    function clamp_exn(t, min, max) {
        if (min <= max) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _f_
        ], 1);
    }
    function clamp(t, min, max) {
        if (max >= min) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _af_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _ag_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _af_
        ], _ah_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _ag_);
        return caml_call1(Base_Or_error[39], _ah_);
    }
    function pred(i) {
        return caml_call2(Base_Import[93], i, 1);
    }
    function succ(i) {
        return caml_call2(Base_Import[91], i, 1);
    }
    function to_int(i) {
        return i;
    }
    function of_int_exn(i) {
        return i;
    }
    var max_value = Base_Import[85][19], min_value = Base_Import[85][20], of_int32 = Base_Int_conversions[6], of_int32_exn = Base_Int_conversions[7], to_int32 = Base_Int_conversions[1], to_int32_exn = Base_Int_conversions[2], of_int64 = Base_Int_conversions[12], of_int64_exn = Base_Int_conversions[13], to_int64 = Base_Int_conversions[4], of_nativeint = Base_Int_conversions[23], of_nativeint_exn = Base_Int_conversions[24], to_nativeint = Base_Int_conversions[5];
    function abs(x) {
        return caml_call1(Base_Import[123], x);
    }
    function rem(a, b) {
        return caml_call2(Base_Import[122], a, b);
    }
    function incr(_ae_) {
        _ae_[1]++;
        return 0;
    }
    function decr(_ad_) {
        _ad_[1]--;
        return 0;
    }
    function shift_right(a, b) {
        return caml_call2(Base_Import[115], a, b);
    }
    function shift_right_logical(a, b) {
        return caml_call2(Base_Import[120], a, b);
    }
    function shift_left(a, b) {
        return caml_call2(Base_Import[119], a, b);
    }
    function bit_not(a) {
        return caml_call1(Base_Import[117], a);
    }
    function bit_or(a, b) {
        return caml_call2(Base_Import[118], a, b);
    }
    function bit_and(a, b) {
        return caml_call2(Base_Import[116], a, b);
    }
    function bit_xor(a, b) {
        return caml_call2(Base_Import[121], a, b);
    }
    var pow = Base_Int_math[2][1];
    function symbol$0(b, e) {
        return caml_call2(pow, b, e);
    }
    var raise_s = Base_Error[32], _g_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Int_floor_log2_got_invalid = "[Int.floor_log2] got invalid input", cst_Int_ceil_log2_got_invalid_ = "[Int.ceil_log2] got invalid input";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _g_, 0);
    }
    function ceil_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var x$0 = caml_call2(Base_Import[93], x, 1), _Z_ = caml_call2(Base_Import[120], x$0, 1), x$1 = caml_call2(Base_Import[118], x$0, _Z_), ___ = caml_call2(Base_Import[120], x$1, 2), x$2 = caml_call2(Base_Import[118], x$1, ___), _$_ = caml_call2(Base_Import[120], x$2, 4), x$3 = caml_call2(Base_Import[118], x$2, _$_), _aa_ = caml_call2(Base_Import[120], x$3, 8), x$4 = caml_call2(Base_Import[118], x$3, _aa_), _ab_ = caml_call2(Base_Import[120], x$4, 16), x$5 = caml_call2(Base_Import[118], x$4, _ab_), _ac_ = caml_call2(Base_Import[120], x$5, 32), x$6 = caml_call2(Base_Import[118], x$5, _ac_);
        return caml_call2(Base_Import[91], x$6, 1);
    }
    function floor_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var _S_ = caml_call2(Base_Import[120], x, 1), x$0 = caml_call2(Base_Import[118], x, _S_), _T_1 = caml_call2(Base_Import[120], x$0, 2), x$1 = caml_call2(Base_Import[118], x$0, _T_1), _U_ = caml_call2(Base_Import[120], x$1, 4), x$2 = caml_call2(Base_Import[118], x$1, _U_), _V_ = caml_call2(Base_Import[120], x$2, 8), x$3 = caml_call2(Base_Import[118], x$2, _V_), _W_ = caml_call2(Base_Import[120], x$3, 16), x$4 = caml_call2(Base_Import[118], x$3, _W_), _X_ = caml_call2(Base_Import[120], x$4, 32), x$5 = caml_call2(Base_Import[118], x$4, _X_), _Y_ = caml_call2(Base_Import[120], x$5, 1);
        return caml_call2(Base_Import[93], x$5, _Y_);
    }
    function is_pow2(x) {
        if (x <= 0) non_positive_argument(0);
        var _R_ = caml_call2(Base_Import[93], x, 1);
        return 0 === caml_call2(Base_Import[116], x, _R_) ? 1 : 0;
    }
    function floor_log2(i) {
        if (i <= 0) {
            var _O_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[139], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_floor_log2_got_invalid, _O_));
        }
        var _P_ = runtime.Base_int_math_int_clz(i), _Q_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _Q_, _P_);
    }
    function ceil_log2(i) {
        if (i <= 0) {
            var _M_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[139], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_ceil_log2_got_invalid_, _M_));
        }
        if (1 === i) return 0;
        var _N_ = runtime.Base_int_math_int_clz(caml_call2(Base_Import[93], i, 1));
        return caml_call2(Base_Import[93], num_bits, _N_);
    }
    var sign = Base_Sign[30], popcount = Base_Popcount[1], compare_local$0 = Base_Import[256];
    function compare$1(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[270];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[206], func$1 = Base_Import[220];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    var land = Base_Import[116], lsr = Base_Import[120];
    function clz(_L_) {
        return runtime.Base_int_math_int_clz(_L_);
    }
    var Binary = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$1,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int,
        num_bits,
        one,
        zero
    ])[1], F = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string$0,
        to_string,
        function(_K_, _J_) {
            return _K_ + _J_ | 0;
        },
        function(_I_, _H_) {
            return _I_ - _H_ | 0;
        },
        runtime.caml_mul,
        caml_div,
        function(_G_) {
            return -_G_ | 0;
        },
        function(_F_, _E_) {
            return _E_ <= _F_ ? 1 : 0;
        },
        function(_D_, _C_) {
            return _D_ <= _C_ ? 1 : 0;
        },
        function(_B_, _A_) {
            return _B_ === _A_ ? 1 : 0;
        },
        function(_z_, _y_) {
            return _y_ < _z_ ? 1 : 0;
        },
        function(_x_, _w_) {
            return _x_ < _w_ ? 1 : 0;
        },
        function(_v_, _u_) {
            return _v_ !== _u_ ? 1 : 0;
        },
        abs,
        function(_t_) {
            return -_t_ | 0;
        },
        zero,
        of_int_exn,
        rem
    ]), round = F[4], round_towards_zero = F[5], round_down = F[6], round_up = F[7], round_nearest = F[8], _h_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: modulus should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %% %s in core_int.ml: modulus should be positive"
    ], _i_ = [
        0,
        [
            2,
            0,
            [
                11,
                " /",
                [
                    12,
                    37,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " in core_int.ml: divisor should be positive",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s /%% %s in core_int.ml: divisor should be positive"
    ];
    function symbol$1(x, y) {
        if (y <= 0) {
            var _r_ = caml_call1(to_string, y), _s_ = caml_call1(to_string, x);
            caml_call4(Base_Printf[7], _h_, _s_, _r_, 0);
        }
        var rval = rem(x, y);
        return rval < 0 ? rval + y | 0 : rval;
    }
    function symbol$2(x, y) {
        if (y <= 0) {
            var _p_ = caml_call1(to_string, y), _q_ = caml_call1(to_string, x);
            caml_call4(Base_Printf[7], _i_, _q_, _p_, 0);
        }
        return x < 0 ? caml_div(x + 1 | 0, y) - 1 | 0 : caml_div(x, y);
    }
    function symbol$3(x, y) {
        return caml_call2(Base_Import[96], x, y);
    }
    var lnot = Base_Import[117], include$2 = Base_Import[97], ascending = include$2[1], descending = include$2[2], max = include$2[3], min = include$2[4], Base_Int = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string$0,
        to_string,
        function(_o_, _n_) {
            return _o_ === _n_ ? 1 : 0;
        },
        caml_int_compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        caml_int_compare,
        function(_m_, _l_) {
            return _m_ === _l_ ? 1 : 0;
        },
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        one,
        -1,
        rem,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_k_) {
            return runtime.Base_int_math_int_clz(_k_);
        },
        function(_j_) {
            return runtime.Base_int_math_int_ctz(_j_);
        },
        [
            0,
            symbol$0,
            lnot,
            abs,
            zero,
            symbol$1,
            symbol$2,
            symbol$3
        ],
        symbol$0,
        lnot,
        abs,
        zero,
        symbol$1,
        symbol$2,
        symbol$3,
        1073741823,
        of_int_exn,
        to_int,
        of_int32,
        to_int32,
        of_int64,
        of_nativeint,
        to_nativeint,
        [
            0,
            [
                0,
                F[1],
                F[2],
                F[3]
            ]
        ]
    ];
    runtime.caml_register_global(34, Base_Int, "Base__Int");
    return;
})(globalThis);
//# 24108 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Base_Sys0 = global_data.Base__Sys0, backend_type = Base_Sys0[1], interactive = Base_Sys0[2], os_type = Base_Sys0[3], unix = Base_Sys0[4], win32 = Base_Sys0[5], cygwin = Base_Sys0[6], word_size_in_bits = Base_Sys0[7], int_size_in_bits = Base_Sys0[8], big_endian = Base_Sys0[9], max_string_length = Base_Sys0[10], max_array_length = Base_Sys0[11], runtime_variant = Base_Sys0[12], runtime_parameters = Base_Sys0[13], argv = Base_Sys0[14], get_argv = Base_Sys0[15], ocaml_version = Base_Sys0[16], enable_runtime_warnings = Base_Sys0[17], runtime_warnings_enabled = Base_Sys0[18], getenv_exn = Base_Sys0[20], getenv = Base_Sys0[21], Base_Sys = [
        0,
        get_argv,
        argv,
        interactive,
        os_type,
        unix,
        win32,
        cygwin,
        backend_type,
        word_size_in_bits,
        int_size_in_bits,
        big_endian,
        max_string_length,
        max_array_length,
        runtime_variant,
        runtime_parameters,
        ocaml_version,
        enable_runtime_warnings,
        runtime_warnings_enabled,
        getenv,
        getenv_exn
    ];
    runtime.caml_register_global(1, Base_Sys, "Base__Sys");
    return;
})(globalThis);
//# 24266 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_obj_tag = runtime.caml_obj_tag;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Stdlib_Obj = global_data.Stdlib__Obj, Base_Array0 = global_data.Base__Array0, Base_Int0 = global_data.Base__Int0, Base_String0 = global_data.Base__String0, Assert_failure = global_data.Assert_failure, Base_Blit = global_data.Base__Blit, _a_ = [
        0,
        "src/obj_array.ml",
        12,
        2
    ], _b_ = [
        0,
        ">",
        0
    ], cst_Obj_array_t_of_length = "<Obj_array.t of length ", _c_ = [
        0,
        ""
    ];
    function invariant(t) {
        var _t_ = Stdlib_Obj[17];
        if (caml_obj_tag(t) !== _t_) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function length(_s_) {
        return _s_.length - 1;
    }
    function sexp_of_t(t) {
        var _r_ = [
            0,
            cst_Obj_array_t_of_length,
            [
                0,
                caml_call1(Base_Int0[1], t.length - 1),
                _b_
            ]
        ];
        return [
            0,
            caml_call2(Base_String0[20], _c_, _r_)
        ];
    }
    var zero_obj = 0;
    function create_zero(len) {
        return caml_call2(Base_Array0[4], len, zero_obj);
    }
    var empty = [
        0
    ];
    function get(t, i) {
        return caml_check_bound(t, i)[1 + i];
    }
    function unsafe_get(t, i) {
        return t[1 + i];
    }
    function unsafe_set_with_caml_modify(t, i, obj) {
        t[1 + i] = obj;
        return 0;
    }
    function set_with_caml_modify(t, i, obj) {
        caml_check_bound(t, i)[1 + i] = obj;
        return 0;
    }
    function unsafe_set_int_assuming_curren(t, i, int$0) {
        t[1 + i] = int$0;
        return 0;
    }
    function set(t, i, obj) {
        var old_obj = get(t, i);
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        var _q_ = 1 - (old_obj === obj ? 1 : 0);
        return _q_ ? unsafe_set_with_caml_modify(t, i, obj) : _q_;
    }
    function unsafe_set(t, i, obj) {
        var old_obj = t[1 + i];
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        var _p_ = 1 - (old_obj === obj ? 1 : 0);
        return _p_ ? unsafe_set_with_caml_modify(t, i, obj) : _p_;
    }
    function unsafe_set_omit_phys_equal_che(t, i, obj) {
        var old_obj = t[1 + i];
        if (typeof old_obj === "number" && typeof obj === "number") return unsafe_set_int_assuming_curren(t, i, obj);
        return unsafe_set_with_caml_modify(t, i, obj);
    }
    function swap(t, i, j) {
        var a = get(t, i), b = get(t, j);
        unsafe_set(t, i, b);
        return unsafe_set(t, j, a);
    }
    function create(len, x) {
        if (typeof x !== "number") {
            var _l_ = Stdlib_Obj[16];
            if (caml_obj_tag(x) === _l_) {
                var t = create_zero(len), _n_ = caml_call2(Base_Import[93], len, 1), _m_ = 0;
                if (_n_ >= 0) {
                    var i = _m_;
                    for(;;){
                        unsafe_set_with_caml_modify(t, i, x);
                        var _o_ = i + 1 | 0;
                        if (_n_ === i) break;
                        i = _o_;
                    }
                }
                return t;
            }
        }
        return caml_call2(Base_Array0[4], len, x);
    }
    function singleton(obj) {
        return create(1, obj);
    }
    function unsafe_set_assuming_currently_(t, i, obj) {
        return typeof obj === "number" ? unsafe_set_int_assuming_curren(t, i, obj) : unsafe_set_with_caml_modify(t, i, obj);
    }
    function unsafe_set_int(t, i, int$0) {
        var old_obj = t[1 + i];
        return typeof old_obj === "number" ? unsafe_set_int_assuming_curren(t, i, int$0) : unsafe_set_with_caml_modify(t, i, int$0);
    }
    function unsafe_clear_if_pointer(t, i) {
        var old_obj = t[1 + i], _k_ = 1 - (typeof old_obj === "number" ? 1 : 0);
        return _k_ ? unsafe_set_with_caml_modify(t, i, 0) : _k_;
    }
    function unsafe_blit(src, src_pos, dst, dst_pos, len) {
        if (dst_pos < src_pos) {
            var _e_ = caml_call2(Base_Import[93], len, 1), _d_ = 0;
            if (_e_ >= 0) {
                var i = _d_;
                for(;;){
                    var i$0 = caml_call2(Base_Import[91], src_pos, i), _i_ = src[1 + i$0];
                    unsafe_set(dst, caml_call2(Base_Import[91], dst_pos, i), _i_);
                    var _f_ = i + 1 | 0;
                    if (_e_ === i) break;
                    i = _f_;
                }
            }
            return 0;
        }
        var _g_ = caml_call2(Base_Import[93], len, 1);
        if (_g_ >= 0) {
            var i$1 = _g_;
            for(;;){
                var i$2 = caml_call2(Base_Import[91], src_pos, i$1), _j_ = src[1 + i$2];
                unsafe_set(dst, caml_call2(Base_Import[91], dst_pos, i$1), _j_);
                var _h_ = i$1 - 1 | 0;
                if (0 === i$1) break;
                i$1 = _h_;
            }
        }
        return 0;
    }
    var include = caml_call1(Base_Blit[1], [
        0,
        length,
        create_zero,
        unsafe_blit
    ]), blit = include[1], blito = include[2], unsafe_blit$0 = include[3], subo = include[5];
    function copy(src) {
        var dst = create_zero(src.length - 1);
        caml_call6(blito, src, 0, 0, dst, 0, 0);
        return dst;
    }
    var sub = Base_Array0[15], Base_Obj_array = [
        0,
        sexp_of_t,
        blit,
        blito,
        unsafe_blit$0,
        subo,
        invariant,
        create,
        create_zero,
        copy,
        singleton,
        empty,
        length,
        get,
        unsafe_get,
        set,
        unsafe_set,
        swap,
        set_with_caml_modify,
        unsafe_set_assuming_currently_,
        unsafe_set_int_assuming_curren,
        unsafe_set_int,
        unsafe_set_omit_phys_equal_che,
        unsafe_set_with_caml_modify,
        unsafe_clear_if_pointer,
        sub
    ];
    runtime.caml_register_global(12, Base_Obj_array, "Base__Obj_array");
    return;
})(globalThis);
//# 24468 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_uniform_array_ml = "src/uniform_array.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Container = global_data.Base__Container, Assert_failure = global_data.Assert_failure, Base_Array = global_data.Base__Array, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Int = global_data.Base__Int, Stdlib_Obj = global_data.Stdlib__Obj, Base_Obj_array = global_data.Base__Obj_array, Base_Sexpable = global_data.Base__Sexpable, Base_Blit = global_data.Base__Blit, Base_Binary_searchable = global_data.Base__Binary_searchable, empty = Base_Obj_array[11];
    function unsafe_create_uninitialized(len) {
        return caml_call1(Base_Obj_array[8], len);
    }
    function create_obj_array(len) {
        return caml_call1(Base_Obj_array[8], len);
    }
    function create(len, x) {
        return caml_call2(Base_Obj_array[7], len, x);
    }
    function singleton(x) {
        return caml_call1(Base_Obj_array[10], x);
    }
    function swap(t, i, j) {
        return caml_call3(Base_Obj_array[17], t, i, j);
    }
    function get(arr, i) {
        return caml_call2(Base_Obj_array[13], arr, i);
    }
    function set(arr, i, x) {
        return caml_call3(Base_Obj_array[15], arr, i, x);
    }
    function unsafe_get_local(arr, i) {
        return caml_call2(Base_Obj_array[14], arr, i);
    }
    function unsafe_get(arr, i) {
        return unsafe_get_local(arr, i);
    }
    function unsafe_set(arr, i, x) {
        return caml_call3(Base_Obj_array[16], arr, i, x);
    }
    function unsafe_set_int(arr, i, x) {
        return caml_call3(Base_Obj_array[21], arr, i, x);
    }
    function unsafe_set_int_assuming_curren(arr, i, x) {
        return caml_call3(Base_Obj_array[20], arr, i, x);
    }
    function unsafe_set_assuming_currently_(arr, i, x) {
        return caml_call3(Base_Obj_array[19], arr, i, x);
    }
    function unsafe_to_array_inplace_promis(arr) {
        return arr;
    }
    var length = Base_Obj_array[12], unsafe_blit = Base_Obj_array[4], copy = Base_Obj_array[9];
    function unsafe_set_omit_phys_equal_che(t, i, x) {
        return caml_call3(Base_Obj_array[22], t, i, x);
    }
    function unsafe_set_with_caml_modify(t, i, x) {
        return caml_call3(Base_Obj_array[23], t, i, x);
    }
    function set_with_caml_modify(t, i, x) {
        return caml_call3(Base_Obj_array[18], t, i, x);
    }
    var unsafe_clear_if_pointer = Base_Obj_array[24], sub = Base_Obj_array[25], _a_ = [
        0,
        cst_src_uniform_array_ml,
        80,
        2
    ], cst_Uniform_array_init = "Uniform_array.init", cst_Array_fold2_exn = "Array.fold2_exn", cst_Array_map2_exn = "Array.map2_exn", dummy = 0;
    function invariant(t) {
        var _ah_ = Stdlib_Obj[17];
        if (runtime.caml_obj_tag(t) !== _ah_) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function init(l, f) {
        if (0 > l) return caml_call1(Base_Import[126], cst_Uniform_array_init);
        var res = unsafe_create_uninitialized(l), _af_ = caml_call2(Base_Import[93], l, 1), _ae_ = 0;
        if (_af_ >= 0) {
            var i = _ae_;
            for(;;){
                unsafe_set(res, i, caml_call1(f, i));
                var _ag_ = i + 1 | 0;
                if (_af_ === i) break;
                i = _ag_;
            }
        }
        return res;
    }
    function of_array(arr) {
        return init(arr.length - 1, function(_ad_) {
            return arr[1 + _ad_];
        });
    }
    function map(arr, f) {
        return init(caml_call1(length, arr), function(i) {
            return caml_call1(f, unsafe_get_local(arr, i));
        });
    }
    function mapi(arr, f) {
        return init(caml_call1(length, arr), function(i) {
            return caml_call2(f, i, unsafe_get_local(arr, i));
        });
    }
    function iter(arr, f) {
        var _aa_ = caml_call1(length, arr), _ab_ = caml_call2(Base_Import[93], _aa_, 1), _$_ = 0;
        if (_ab_ >= 0) {
            var i = _$_;
            for(;;){
                caml_call1(f, unsafe_get_local(arr, i));
                var _ac_ = i + 1 | 0;
                if (_ab_ === i) break;
                i = _ac_;
            }
        }
        return 0;
    }
    function iteri(arr, f) {
        var _Y_ = caml_call1(length, arr), _Z_ = caml_call2(Base_Import[93], _Y_, 1), _X_ = 0;
        if (_Z_ >= 0) {
            var i = _X_;
            for(;;){
                caml_call2(f, i, unsafe_get_local(arr, i));
                var ___ = i + 1 | 0;
                if (_Z_ === i) break;
                i = ___;
            }
        }
        return 0;
    }
    function foldi(arr, init, f) {
        var acc = [
            0,
            init
        ], _T_1 = caml_call1(length, arr), _U_ = caml_call2(Base_Import[93], _T_1, 1), _S_ = 0;
        if (_U_ >= 0) {
            var i = _S_;
            for(;;){
                var _W_ = unsafe_get_local(arr, i);
                acc[1] = caml_call3(f, i, acc[1], _W_);
                var _V_ = i + 1 | 0;
                if (_U_ === i) break;
                i = _V_;
            }
        }
        return acc[1];
    }
    function fold(arr, init, f) {
        var r = [
            0,
            init
        ], _O_ = caml_call1(length, arr), _P_ = caml_call2(Base_Import[93], _O_, 1), _N_ = 0;
        if (_P_ >= 0) {
            var i = _N_;
            for(;;){
                var _R_ = unsafe_get_local(arr, i);
                r[1] = caml_call2(f, r[1], _R_);
                var _Q_ = i + 1 | 0;
                if (_P_ === i) break;
                i = _Q_;
            }
        }
        return r[1];
    }
    function to_list(t) {
        var _L_ = caml_call1(length, t);
        return caml_call2(Base_List[40], _L_, function(_M_) {
            return get(t, _M_);
        });
    }
    function of_list(l) {
        var len = caml_call1(Base_List[45], l), res = unsafe_create_uninitialized(len);
        caml_call2(Base_List[34], l, function(i, x) {
            return set(res, i, x);
        });
        return res;
    }
    function of_list_rev(l) {
        var len = caml_call1(Base_List[45], l), res = unsafe_create_uninitialized(len);
        caml_call2(Base_List[34], l, function(i, x) {
            var _K_ = caml_call2(Base_Import[93], len, i);
            return set(res, caml_call2(Base_Import[93], _K_, 1), x);
        });
        return res;
    }
    function to_array(arr) {
        var _J_ = caml_call1(length, arr);
        return caml_call2(Base_Array[41], _J_, function(i) {
            return unsafe_get_local(arr, i);
        });
    }
    function exists(arr, f) {
        var _I_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _I_, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                var i$0 = i[1];
                if (caml_call1(f, unsafe_get_local(arr, i$0))) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function existsi(arr, f) {
        var _G_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _G_, 1)
        ], result = [
            0,
            0
        ];
        for(;;){
            if (0 <= i[1] && !result[1]) {
                var i$0 = i[1], _H_ = unsafe_get_local(arr, i$0);
                if (caml_call2(f, i[1], _H_)) {
                    result[1] = 1;
                    continue;
                }
                i[1]--;
                continue;
            }
            return result[1];
        }
    }
    function for_all(arr, f) {
        var _F_ = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], _F_, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                var i$0 = i[1];
                if (caml_call1(f, unsafe_get_local(arr, i$0))) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function for_alli(arr, f) {
        var length$0 = caml_call1(length, arr), i = [
            0,
            caml_call2(Base_Import[93], length$0, 1)
        ], result = [
            0,
            1
        ];
        for(;;){
            if (0 <= i[1] && result[1]) {
                var i$0 = i[1], _E_ = unsafe_get_local(arr, i$0);
                if (caml_call2(f, i[1], _E_)) {
                    i[1]--;
                    continue;
                }
                result[1] = 0;
                continue;
            }
            return result[1];
        }
    }
    function filter_mapi(arr, f) {
        var r = [
            0,
            empty
        ], k = [
            0,
            0
        ], _A_ = caml_call1(length, arr), _B_ = caml_call2(Base_Import[93], _A_, 1), _z_ = 0;
        if (_B_ >= 0) {
            var i = _z_;
            for(;;){
                var match = caml_call2(f, i, unsafe_get_local(arr, i));
                if (match) {
                    var a = match[1];
                    if (0 === k[1]) r[1] = create(caml_call1(length, arr), a);
                    unsafe_set(r[1], k[1], a);
                    k[1]++;
                }
                var _D_ = i + 1 | 0;
                if (_B_ === i) break;
                i = _D_;
            }
        }
        var _C_ = caml_call1(length, arr);
        return k[1] === _C_ ? r[1] : 0 < k[1] ? caml_call3(sub, r[1], 0, k[1]) : empty;
    }
    function filteri(t, f) {
        return filter_mapi(t, function(i, x) {
            return caml_call2(f, i, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(i, a) {
            return caml_call1(f, a);
        });
    }
    function filter(t, f) {
        return filter_map(t, function(x) {
            return caml_call1(f, x) ? [
                0,
                x
            ] : 0;
        });
    }
    function fold2_exn(arr$0, arr, init, f) {
        var len = caml_call1(length, arr$0);
        if (caml_call1(length, arr) !== len) caml_call1(Base_Import[126], cst_Array_fold2_exn);
        var acc = [
            0,
            init
        ], _v_ = caml_call2(Base_Import[93], len, 1), _u_ = 0;
        if (_v_ >= 0) {
            var i = _u_;
            for(;;){
                var _y_ = unsafe_get_local(arr, i), _x_ = unsafe_get_local(arr$0, i);
                acc[1] = caml_call3(f, acc[1], _x_, _y_);
                var _w_ = i + 1 | 0;
                if (_v_ === i) break;
                i = _w_;
            }
        }
        return acc[1];
    }
    function map2_exn(arr$0, arr, f) {
        var len = caml_call1(length, arr$0);
        if (caml_call1(length, arr) !== len) caml_call1(Base_Import[126], cst_Array_map2_exn);
        return init(len, function(i) {
            var _t_ = unsafe_get_local(arr, i);
            return caml_call2(f, unsafe_get_local(arr$0, i), _t_);
        });
    }
    function concat(ts) {
        var total_len = caml_call3(Base_List[26], [
            0,
            Base_Int[79],
            function(_s_, _r_) {
                return _s_ + _r_ | 0;
            }
        ], ts, function(t) {
            return caml_call1(length, t);
        }), res = unsafe_create_uninitialized(total_len);
        caml_call3(Base_List[20], ts, 0, function(so_far, t) {
            var len = caml_call1(length, t), _o_ = caml_call2(Base_Import[93], len, 1), _n_ = 0;
            if (_o_ >= 0) {
                var i = _n_;
                for(;;){
                    var _p_ = get(t, i);
                    set(res, caml_call2(Base_Import[91], so_far, i), _p_);
                    var _q_ = i + 1 | 0;
                    if (_o_ === i) break;
                    i = _q_;
                }
            }
            return caml_call2(Base_Import[91], so_far, len);
        });
        return res;
    }
    function concat_mapi(t, f) {
        var _m_ = to_list(t);
        return concat(caml_call2(Base_List[41], _m_, f));
    }
    function concat_map(t, f) {
        var _l_ = to_list(t);
        return concat(caml_call2(Base_List[53], _l_, f));
    }
    function partition_map(arr, f) {
        var right = [
            0,
            empty
        ], left = [
            0,
            empty
        ], right_idx = [
            0,
            0
        ], left_idx = [
            0,
            0
        ];
        function append(data, idx, value) {
            if (0 === idx[1]) data[1] = create(caml_call1(length, arr), value);
            unsafe_set(data[1], idx[1], value);
            idx[1]++;
        }
        var _g_ = caml_call1(length, arr), _h_ = caml_call2(Base_Import[93], _g_, 1), _f_ = 0;
        if (_h_ >= 0) {
            var i = _f_;
            for(;;){
                var match = caml_call1(f, unsafe_get_local(arr, i));
                if (0 === match[0]) {
                    var a = match[1];
                    append(left, left_idx, a);
                } else {
                    var a$0 = match[1];
                    append(right, right_idx, a$0);
                }
                var _j_ = i + 1 | 0;
                if (_h_ === i) break;
                i = _j_;
            }
        }
        function trim(data, idx) {
            var _k_ = caml_call1(length, arr);
            return idx[1] === _k_ ? data[1] : 0 < idx[1] ? caml_call3(sub, data[1], 0, idx[1]) : empty;
        }
        var _i_ = trim(right, right_idx);
        return [
            0,
            trim(left, left_idx),
            _i_
        ];
    }
    function find_map(arr, f) {
        var length$0 = caml_call1(length, arr);
        if (0 === length$0) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length$0) {
                var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                value_found[1] = caml_call1(f, value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    function find_mapi(arr, f) {
        var length$0 = caml_call1(length, arr);
        if (0 === length$0) return 0;
        var i = [
            0,
            0
        ], value_found = [
            0,
            0
        ];
        for(;;){
            if (caml_call1(Base_Option[52], value_found[1]) && i[1] < length$0) {
                var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                value_found[1] = caml_call2(f, i[1], value);
                i[1]++;
                continue;
            }
            return value_found[1];
        }
    }
    function find(arr, f) {
        var length$0 = caml_call1(length, arr);
        function _d_(param) {
            var x = param[2];
            return x;
        }
        if (0 === length$0) var _e_ = 0;
        else {
            var i = [
                0,
                0
            ], found = [
                0,
                0
            ], value_found = [
                0,
                unsafe_get_local(arr, 0)
            ];
            for(;;){
                if (!found[1] && i[1] < length$0) {
                    var i$0 = i[1], value = unsafe_get_local(arr, i$0);
                    if (caml_call1(f, value)) {
                        value_found[1] = value;
                        found[1] = 1;
                    } else i[1]++;
                    continue;
                }
                if (found[1]) {
                    var _e_ = [
                        0,
                        [
                            0,
                            i[1],
                            value_found[1]
                        ]
                    ];
                    break;
                }
                var _e_ = 0;
                break;
            }
        }
        return caml_call2(Base_Option[24], _e_, _d_);
    }
    function findi(arr, f) {
        var len = caml_call1(length, arr), i = 0;
        for(;;){
            if (len <= i) return 0;
            var x = unsafe_get_local(arr, i);
            if (caml_call2(f, i, x)) return [
                0,
                [
                    0,
                    i,
                    x
                ]
            ];
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function t_sexp_grammar(grammar) {
        var _c_ = caml_call1(Base_Array[6], grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _c_);
    }
    var include = caml_call1(caml_call1(Base_Sexpable[2], [
        0,
        Base_Array[4],
        Base_Array[5]
    ]), [
        0,
        to_array,
        of_array
    ]), t_of_sexp = include[1], sexp_of_t = include[2], _b_ = [
        0,
        cst_src_uniform_array_ml,
        347,
        6
    ];
    function create_like(len, t) {
        if (0 === len) return empty;
        if (0 < caml_call1(length, t)) return create(len, get(t, 0));
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    var include$0 = caml_call1(Base_Blit[4], [
        0,
        create_like,
        length,
        unsafe_blit
    ]), blit = include$0[1], blito = include$0[2], unsafe_blit$0 = include$0[3], sub$0 = include$0[4], subo = include$0[5];
    function min_elt(t, compare) {
        return caml_call3(Base_Container[3], fold, t, compare);
    }
    function max_elt(t, compare) {
        return caml_call3(Base_Container[4], fold, t, compare);
    }
    function compare_local(compare_elt, a, b) {
        if (a === b) return 0;
        var len_a = caml_call1(length, a), len_b = caml_call1(length, b), ret = runtime.caml_int_compare(len_a, len_b);
        if (0 !== ret) return ret;
        var i = 0;
        for(;;){
            if (i === len_a) return 0;
            var l = unsafe_get_local(a, i), r = unsafe_get_local(b, i), res = caml_call2(compare_elt, l, r);
            if (0 !== res) return res;
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    function compare(compare_elt, a, b) {
        return compare_local(compare_elt, a, b);
    }
    var Sort = caml_call1(Base_Array[109][2], [
        0,
        unsafe_get,
        unsafe_set,
        length
    ]), sort = Sort[1], include$1 = caml_call1(Base_Binary_searchable[2], [
        0,
        unsafe_get,
        length
    ]), binary_search = include$1[1], binary_search_segmented = include$1[2], Base_Uniform_array = [
        0,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        compare,
        compare_local,
        invariant,
        empty,
        create,
        singleton,
        init,
        length,
        get,
        unsafe_get,
        unsafe_get_local,
        set,
        unsafe_set,
        swap,
        unsafe_set_omit_phys_equal_che,
        unsafe_set_with_caml_modify,
        set_with_caml_modify,
        map,
        mapi,
        iter,
        iteri,
        fold,
        foldi,
        unsafe_to_array_inplace_promis,
        of_array,
        to_array,
        of_list,
        of_list_rev,
        to_list,
        blit,
        blito,
        unsafe_blit$0,
        sub$0,
        subo,
        copy,
        exists,
        existsi,
        for_all,
        for_alli,
        concat,
        concat_map,
        concat_mapi,
        partition_map,
        filter,
        filteri,
        filter_map,
        filter_mapi,
        find,
        findi,
        find_map,
        find_mapi,
        map2_exn,
        fold2_exn,
        min_elt,
        max_elt,
        sort,
        binary_search,
        binary_search_segmented,
        unsafe_create_uninitialized,
        create_obj_array,
        unsafe_set_assuming_currently_,
        unsafe_set_int_assuming_curren,
        unsafe_set_int,
        unsafe_clear_if_pointer
    ];
    runtime.caml_register_global(18, Base_Uniform_array, "Base__Uniform_array");
    return;
})(globalThis);
//# 25788 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Array = global_data.Base__Array, Base_Import = global_data.Base__Import, Base_Uniform_array = global_data.Base__Uniform_array, Base_Option = global_data.Base__Option, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Stdlib_Obj = global_data.Stdlib__Obj, Base_Sexpable = global_data.Base__Sexpable, Base_Indexed_container = global_data.Base__Indexed_container, Base_Blit = global_data.Base__Blit, none_substitute = runtime.caml_obj_block(Stdlib_Obj[14], 1), none = 24791911, cst_Option_array_get_some_exn_ = "Option_array.get_some_exn: the element is [None]";
    function is_none(x) {
        return x === 24791911 ? 1 : 0;
    }
    function is_some(x) {
        return 1 - (x === 24791911 ? 1 : 0);
    }
    function some(x) {
        return x === 24791911 ? none_substitute : x;
    }
    function value_unsafe(x) {
        return x === none_substitute ? none : x;
    }
    function value_exn(x) {
        return is_some(x) ? value_unsafe(x) : caml_call1(Base_Import[124], cst_Option_array_get_some_exn_);
    }
    function of_sexpable(param) {
        if (!param) return none;
        var x = param[1];
        return some(x);
    }
    function to_sexpable(x) {
        return is_some(x) ? [
            0,
            value_unsafe(x)
        ] : 0;
    }
    var include = caml_call1(caml_call1(Base_Sexpable[2], [
        0,
        Base_Option[9],
        Base_Option[10]
    ]), [
        0,
        to_sexpable,
        of_sexpable
    ]), t_of_sexp = include[1], sexp_of_t = include[2];
    function t_of_sexp$0(of_a_001, x_003) {
        var _w_ = caml_call1(t_of_sexp, of_a_001);
        return caml_call2(Base_Uniform_array[1], _w_, x_003);
    }
    function sexp_of_t$0(of_a_004, x_005) {
        var _v_ = caml_call1(sexp_of_t, of_a_004);
        return caml_call2(Base_Uniform_array[2], _v_, x_005);
    }
    function t_sexp_grammar(a_sexp_grammar) {
        var _t_ = caml_call1(Base_Option[5], a_sexp_grammar), _u_ = caml_call1(Sexplib0_Sexp_grammar[1], _t_);
        return caml_call1(Base_Uniform_array[3], _u_);
    }
    var empty = Base_Uniform_array[7];
    function create(len) {
        return caml_call2(Base_Uniform_array[8], len, none);
    }
    function init(n, f) {
        return caml_call2(Base_Uniform_array[10], n, function(i) {
            return of_sexpable(caml_call1(f, i));
        });
    }
    function init_some(n, f) {
        return caml_call2(Base_Uniform_array[10], n, function(i) {
            return some(caml_call1(f, i));
        });
    }
    var _a_ = Base_Uniform_array[11];
    function get(t, i) {
        return to_sexpable(caml_call2(Base_Uniform_array[12], t, i));
    }
    function get_local(t, i) {
        var x = caml_call2(Base_Uniform_array[12], t, i);
        return is_some(x) ? [
            0,
            value_unsafe(x)
        ] : 0;
    }
    function get_some_exn(t, i) {
        return value_exn(caml_call2(Base_Uniform_array[12], t, i));
    }
    function is_none$0(t, i) {
        var x = caml_call2(Base_Uniform_array[12], t, i);
        return x === 24791911 ? 1 : 0;
    }
    function is_some$0(t, i) {
        return is_some(caml_call2(Base_Uniform_array[12], t, i));
    }
    function set(t, i, x) {
        var _s_ = of_sexpable(x);
        return caml_call3(Base_Uniform_array[15], t, i, _s_);
    }
    function set_some(t, i, x) {
        var _r_ = some(x);
        return caml_call3(Base_Uniform_array[15], t, i, _r_);
    }
    function set_none(t, i) {
        return caml_call3(Base_Uniform_array[15], t, i, none);
    }
    function swap(t, i, j) {
        return caml_call3(Base_Uniform_array[17], t, i, j);
    }
    function unsafe_get(t, i) {
        return to_sexpable(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_get_some_exn(t, i) {
        return value_exn(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_get_some_assuming_some(t, i) {
        return value_unsafe(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_is_some(t, i) {
        return is_some(caml_call2(Base_Uniform_array[13], t, i));
    }
    function unsafe_set(t, i, x) {
        var _q_ = of_sexpable(x);
        return caml_call3(Base_Uniform_array[16], t, i, _q_);
    }
    function unsafe_set_some(t, i, x) {
        var _p_ = some(x);
        return caml_call3(Base_Uniform_array[16], t, i, _p_);
    }
    function unsafe_set_none(t, i) {
        return caml_call3(Base_Uniform_array[16], t, i, none);
    }
    function clear(t) {
        var _m_ = caml_call1(_a_, t), _n_ = caml_call2(Base_Import[93], _m_, 1), _l_ = 0;
        if (_n_ >= 0) {
            var i = _l_;
            for(;;){
                unsafe_set_none(t, i);
                var _o_ = i + 1 | 0;
                if (_n_ === i) break;
                i = _o_;
            }
        }
        return 0;
    }
    function _b_(input, f) {
        var _i_ = caml_call1(_a_, input), _j_ = caml_call2(Base_Import[93], _i_, 1), _h_ = 0;
        if (_j_ >= 0) {
            var i = _h_;
            for(;;){
                caml_call2(f, i, unsafe_get(input, i));
                var _k_ = i + 1 | 0;
                if (_j_ === i) break;
                i = _k_;
            }
        }
        return 0;
    }
    function _c_(input, init, f) {
        var acc = [
            0,
            init
        ];
        _b_(input, function(i, elem) {
            acc[1] = caml_call3(f, i, acc[1], elem);
            return 0;
        });
        return acc[1];
    }
    function fold(input, init, f) {
        return _c_(input, init, function(param, acc, x) {
            return caml_call2(f, acc, x);
        });
    }
    var foldi = [
        0,
        -198771759,
        _c_
    ], iter = [
        0,
        -198771759,
        function(input, f) {
            return _b_(input, function(param, x) {
                return caml_call1(f, x);
            });
        }
    ], iteri = [
        0,
        -198771759,
        _b_
    ], length = [
        0,
        -198771759,
        _a_
    ], include$0 = caml_call1(Base_Indexed_container[10], [
        0,
        fold,
        iter,
        length,
        iteri,
        foldi
    ]), is_empty = include$0[2], mem = include$0[3], iter$0 = include$0[4], fold$0 = include$0[5], fold_result = include$0[6], fold_until = include$0[7], exists = include$0[8], for_all = include$0[9], count = include$0[10], sum = include$0[11], find = include$0[12], find_map = include$0[13], to_list = include$0[14], min_elt = include$0[16], max_elt = include$0[17], foldi$0 = include$0[18], iteri$0 = include$0[19], existsi = include$0[20], for_alli = include$0[21], counti = include$0[22], findi = include$0[23], find_mapi = include$0[24], length$0 = Base_Uniform_array[11];
    function map(input, f) {
        var output = create(caml_call1(length$0, input));
        caml_call2(iteri$0, input, function(i, elem) {
            return unsafe_set(output, i, caml_call1(f, elem));
        });
        return output;
    }
    function map_some(input, f) {
        var len = caml_call1(length$0, input), output = create(len), _f_ = caml_call2(Base_Import[93], len, 1), _e_ = 0;
        if (_f_ >= 0) {
            var i = _e_;
            for(;;){
                var opt = caml_call2(Base_Uniform_array[13], input, i);
                if (is_some(opt)) {
                    var x = value_unsafe(opt);
                    unsafe_set_some(output, i, caml_call1(f, x));
                }
                var _g_ = i + 1 | 0;
                if (_f_ === i) break;
                i = _g_;
            }
        }
        return output;
    }
    function of_array(array) {
        return init(array.length - 1, function(i) {
            return array[1 + i];
        });
    }
    function of_array_some(array) {
        return init_some(array.length - 1, function(i) {
            return array[1 + i];
        });
    }
    function to_array(t) {
        var _d_ = caml_call1(length$0, t);
        return caml_call2(Base_Array[41], _d_, function(i) {
            return unsafe_get(t, i);
        });
    }
    function create_like(len, param) {
        return create(len);
    }
    var unsafe_blit = Base_Uniform_array[35], include$1 = caml_call1(Base_Blit[5], [
        0,
        create_like,
        length$0,
        unsafe_blit
    ]), blit = include$1[1], blito = include$1[2], unsafe_blit$0 = include$1[3], sub = include$1[4], subo = include$1[5], copy = Base_Uniform_array[38], Base_Option_array = [
        0,
        t_of_sexp$0,
        sexp_of_t$0,
        t_sexp_grammar,
        empty,
        create,
        is_empty,
        mem,
        iter$0,
        fold$0,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        min_elt,
        max_elt,
        foldi$0,
        iteri$0,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        length$0,
        init_some,
        init,
        of_array,
        of_array_some,
        to_array,
        get,
        get_local,
        get_some_exn,
        is_none$0,
        is_some$0,
        unsafe_get,
        unsafe_get_some_exn,
        unsafe_get_some_assuming_some,
        unsafe_is_some,
        set,
        set_some,
        set_none,
        swap,
        clear,
        map,
        map_some,
        unsafe_set,
        unsafe_set_some,
        unsafe_set_none,
        blit,
        blito,
        unsafe_blit$0,
        sub,
        subo,
        copy,
        [
            0,
            [
                0,
                t_of_sexp,
                sexp_of_t,
                none,
                some,
                is_none,
                is_some,
                value_exn,
                value_unsafe,
                to_sexpable,
                of_sexpable
            ]
        ]
    ];
    runtime.caml_register_global(10, Base_Option_array, "Base__Option_array");
    return;
})(globalThis);
//# 26518 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Import = global_data.Base__Import, Base_Int = global_data.Base__Int, Base_Source_code_position0 = global_data.Base__Source_code_position0, Base_Comparable = global_data.Base__Comparable;
    function hash_override(param) {
        var pos_cnum = param[4], pos_bol = param[3], pos_lnum = param[2], pos_fname = param[1], _b_ = caml_call1(Base_Int[8], pos_cnum), _c_ = caml_call1(Base_Int[8], pos_bol), _d_ = caml_call1(Base_Int[8], pos_lnum), _e_ = runtime.Base_hash_string(pos_fname), _f_ = caml_call2(Base_Import[121], _e_, _d_), _g_ = caml_call2(Base_Import[121], _f_, _c_);
        return caml_call2(Base_Import[121], _g_, _b_);
    }
    var compare_local = Base_Source_code_position0[2], hash_fold_t = Base_Source_code_position0[4], comparator = Base_Source_code_position0[6], to_string = Base_Source_code_position0[8], sexp_of_t = Base_Source_code_position0[9], include = caml_call1(Base_Comparable[12], [
        0,
        sexp_of_t,
        comparator
    ]), symbol = include[1], symbol$0 = include[2], symbol$1 = include[3], symbol$2 = include[4], symbol$3 = include[5], symbol$4 = include[6], equal = include[7], compare = include[8], min = include[9], max = include[10], ascending = include[11], descending = include[12], between = include[13], clamp_exn = include[14], clamp = include[15], comparator$0 = include[16];
    function equal_local(a, b) {
        var _a_ = caml_call2(compare_local, a, b);
        return caml_call2(Base_Import[242], _a_, 0);
    }
    function of_pos(param) {
        var pos_cnum = param[3], pos_lnum = param[2], pos_fname = param[1];
        return [
            0,
            pos_fname,
            pos_lnum,
            0,
            pos_cnum
        ];
    }
    var Base_Source_code_position = [
        0,
        hash_fold_t,
        hash_override,
        sexp_of_t,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator$0,
        equal_local,
        compare_local,
        to_string,
        of_pos
    ];
    runtime.caml_register_global(4, Base_Source_code_position, "Base__Source_code_position");
    return;
})(globalThis);
//# 26897 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Sexp = global_data.Base__Sexp, Base_Comparable = global_data.Base__Comparable, _a_ = caml_call1(Base_Comparable[11], [
        0,
        Base_Sexp[7],
        Base_Sexp[5]
    ]), symbol = _a_[1], symbol$0 = _a_[2], symbol$1 = _a_[3], symbol$2 = _a_[4], symbol$3 = _a_[5], symbol$4 = _a_[6], min = _a_[9], max = _a_[10], ascending = _a_[11], descending = _a_[12], between = _a_[13], clamp_exn = _a_[14], clamp = _a_[15], comparator = _a_[16], globalize = Base_Sexp[1], hash_fold_t = Base_Sexp[2], hash = Base_Sexp[3], t_of_sexp = Base_Sexp[4], sexp_of_t = Base_Sexp[5], equal = Base_Sexp[6], compare = Base_Sexp[7], Not_found_s = Base_Sexp[8], Of_sexp_error = Base_Sexp[9], message = Base_Sexp[10], default_indent = Base_Sexp[11], pp_hum = Base_Sexp[12], pp_hum_indent = Base_Sexp[13], pp_mach = Base_Sexp[14], pp = Base_Sexp[15], to_string_hum = Base_Sexp[16], to_string_mach = Base_Sexp[17], to_string = Base_Sexp[18], of_float_style = Base_Sexp[19], of_int_style = Base_Sexp[20], equal_local = Base_Sexp[22], compare_local = Base_Sexp[23], t_sexp_grammar = Base_Sexp[24], invariant = Base_Sexp[25], of_string = Base_Sexp[26], Base_Sexp_with_comparable = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        t_sexp_grammar,
        invariant,
        of_string,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local
    ];
    runtime.caml_register_global(2, Base_Sexp_with_comparable, "Base__Sexp_with_comparable");
    return;
})(globalThis);
//# 30077 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Exn = global_data.Base__Exn, Base_List = global_data.Base__List, Base_Import = global_data.Base__Import, compare_local = Base_Import[266], compare = Base_Import[238], equal_local = Base_Import[280], equal = Base_Import[252], globalize = Base_Import[296], t_of_sexp = Base_Import[168], sexp_of_t = Base_Import[144];
    function t_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Import[191], a_sexp_grammar);
    }
    function swap(t1, t2) {
        var tmp = t1[1];
        t1[1] = t2[1];
        t2[1] = tmp;
        return 0;
    }
    function replace(t, f) {
        t[1] = caml_call1(f, t[1]);
        return 0;
    }
    function set_temporarily(t, a, f) {
        var restore_to = t[1];
        t[1] = a;
        return caml_call2(Base_Exn[13], f, function(param) {
            t[1] = restore_to;
            return 0;
        });
    }
    function set(param) {
        var a = param[2], r = param[1];
        r[1] = a;
        return 0;
    }
    function sets(ts) {
        return caml_call2(Base_List[19], ts, set);
    }
    function snapshot(param) {
        var r = param[1];
        return [
            0,
            r,
            r[1]
        ];
    }
    function sets_temporarily(and_values, f) {
        var restore_to = caml_call2(Base_List[53], and_values, snapshot);
        sets(and_values);
        return caml_call2(Base_Exn[13], f, function(param) {
            return sets(restore_to);
        });
    }
    var Base_Ref = [
        0,
        compare,
        compare_local,
        equal,
        equal_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        swap,
        replace,
        set_temporarily,
        [
            0,
            set,
            sets,
            snapshot
        ],
        sets_temporarily
    ];
    runtime.caml_register_global(3, Base_Ref, "Base__Ref");
    return;
})(globalThis);
//# 30160 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_length$2 = "length", cst_src_queue_ml = "src/queue.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "", Base_List = global_data.Base__List, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Base_Import = global_data.Base__Import, Base_Option_array = global_data.Base__Option_array, Base_Array = global_data.Base__Array, Base_Int = global_data.Base__Int, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Assert_failure = global_data.Assert_failure, Stdlib_Queue = global_data.Stdlib__Queue, Base_Indexed_container = global_data.Base__Indexed_container, _a_ = [
        0,
        "elts"
    ], _b_ = [
        0,
        cst_length$2
    ], _c_ = [
        0,
        "mask"
    ], _d_ = [
        0,
        "front"
    ], _e_ = [
        0,
        "num_mutations"
    ], cst_length = cst_length$2, cst_index = "index", cst_Queue_index_out_of_bounds = "Queue index out of bounds", _f_ = [
        0,
        "_"
    ], cst_mutation_of_queue_during_i = "mutation of queue during iteration", _g_ = [
        0,
        cst_src_queue_ml,
        184,
        9
    ], _h_ = [
        0,
        cst_src_queue_ml,
        178,
        2
    ], _i_ = [
        0,
        cst_src_queue_ml,
        177,
        2
    ], _j_ = [
        0,
        cst_src_queue_ml,
        176,
        2
    ], _k_ = [
        0,
        cst_src_queue_ml,
        175,
        2
    ], _l_ = [
        0,
        cst_src_queue_ml,
        174,
        2
    ], _m_ = [
        0,
        cst_src_queue_ml,
        172,
        2
    ], _n_ = [
        0,
        cst_src_queue_ml,
        171,
        2
    ], cst_capacity = "capacity", cst_cannot_have_queue_with_neg = "cannot have queue with negative capacity", _o_ = [
        0,
        cst_src_queue_ml,
        212,
        2
    ], cst_length$0 = cst_length$2, cst_Queue_blit_transfer_negati = "Queue.blit_transfer: negative length", dummy = 0;
    function globalize(param, t) {
        var _a3_ = caml_call1(Base_Option_array[58], t[5]);
        return [
            0,
            t[1],
            t[2],
            t[3],
            t[4],
            _a3_
        ];
    }
    function inc_num_mutations(t) {
        t[1] = caml_call2(Base_Import[91], t[1], 1);
    }
    function capacity(t) {
        return caml_call2(Base_Import[91], t[3], 1);
    }
    function elts_index(t, i) {
        var _a1_ = t[3], _a2_ = caml_call2(Base_Import[91], t[2], i);
        return caml_call2(Base_Import[116], _a2_, _a1_);
    }
    function unsafe_get(t, i) {
        var _a0_ = elts_index(t, i);
        return caml_call2(Base_Option_array[40], t[5], _a0_);
    }
    function unsafe_set(t, i, a) {
        var _aZ_ = elts_index(t, i);
        return caml_call3(Base_Option_array[51], t[5], _aZ_, a);
    }
    function check_index_exn(t, i) {
        var _aU_ = i < 0 ? 1 : 0, _aV_ = _aU_ || (t[4] <= i ? 1 : 0);
        if (!_aV_) return _aV_;
        var _aW_ = [
            0,
            [
                0,
                cst_length,
                caml_call1(Base_Int[10], t[4])
            ],
            0
        ], _aX_ = [
            0,
            [
                0,
                cst_index,
                caml_call1(Base_Int[10], i)
            ],
            _aW_
        ], _aY_ = caml_call2(Base_Sexp[10], cst_Queue_index_out_of_bounds, _aX_);
        return caml_call1(Base_Error[32], _aY_);
    }
    function get(t, i) {
        check_index_exn(t, i);
        return unsafe_get(t, i);
    }
    function set(t, i, a) {
        check_index_exn(t, i);
        inc_num_mutations(t);
        return unsafe_set(t, i, a);
    }
    function is_empty(t) {
        return 0 === t[4] ? 1 : 0;
    }
    function length(param) {
        var length = param[4];
        return length;
    }
    function ensure_no_mutation(t, num_mutations) {
        var _aT_ = t[1] !== num_mutations ? 1 : 0;
        if (!_aT_) return _aT_;
        var param = globalize(0, t);
        function of_a_001(param) {
            return _f_;
        }
        var num_mutations_003 = param[1], front_005 = param[2], mask_007 = param[3], length_009 = param[4], elts_011 = param[5], arg_012 = caml_call2(Base_Option_array[2], of_a_001, elts_011), bnds_002 = [
            0,
            [
                1,
                [
                    0,
                    _a_,
                    [
                        0,
                        arg_012,
                        0
                    ]
                ]
            ],
            0
        ], arg_010 = caml_call1(Base_Import[139], length_009), bnds_002$0 = [
            0,
            [
                1,
                [
                    0,
                    _b_,
                    [
                        0,
                        arg_010,
                        0
                    ]
                ]
            ],
            bnds_002
        ], arg_008 = caml_call1(Base_Import[139], mask_007), bnds_002$1 = [
            0,
            [
                1,
                [
                    0,
                    _c_,
                    [
                        0,
                        arg_008,
                        0
                    ]
                ]
            ],
            bnds_002$0
        ], arg_006 = caml_call1(Base_Import[139], front_005), bnds_002$2 = [
            0,
            [
                1,
                [
                    0,
                    _d_,
                    [
                        0,
                        arg_006,
                        0
                    ]
                ]
            ],
            bnds_002$1
        ], arg_004 = caml_call1(Base_Import[139], num_mutations_003), bnds_002$3 = [
            0,
            [
                1,
                [
                    0,
                    _e_,
                    [
                        0,
                        arg_004,
                        0
                    ]
                ]
            ],
            bnds_002$2
        ], _aS_ = caml_call2(Base_Sexp[10], cst_mutation_of_queue_during_i, [
            0,
            [
                0,
                cst,
                [
                    1,
                    bnds_002$3
                ]
            ],
            0
        ]);
        return caml_call1(Base_Error[32], _aS_);
    }
    function compare_local(compare_elt, t1, t2) {
        if (t1 === t2) return 0;
        var mut2 = t2[1], mut1 = t1[1], len2 = t2[4], len1 = t1[4], pos = 0;
        for(;;){
            var match = pos === len2 ? 1 : 0;
            if (pos === len1) return match ? 0 : -1;
            if (match) return 1;
            var _aR_ = unsafe_get(t2, pos), x = caml_call2(compare_elt, unsafe_get(t1, pos), _aR_);
            ensure_no_mutation(t1, mut1);
            ensure_no_mutation(t2, mut2);
            if (0 !== x) return x;
            var pos$0 = caml_call2(Base_Import[91], pos, 1);
            pos = pos$0;
        }
    }
    function compare(compare_elt, t1, t2) {
        return compare_local(compare_elt, t1, t2);
    }
    function equal_local(equal_elt, t1, t2) {
        var _aO_ = t1 === t2 ? 1 : 0;
        if (_aO_) var _aP_ = _aO_;
        else {
            var len1 = t1[4], len2 = t2[4], _aQ_ = len1 === len2 ? 1 : 0;
            if (_aQ_) {
                var mut2 = t2[1], mut1 = t1[1], pos = 0;
                for(;;){
                    var _aL_ = pos === len1 ? 1 : 0;
                    if (_aL_) var _aM_ = _aL_;
                    else {
                        var _aN_ = unsafe_get(t2, pos), b = caml_call2(equal_elt, unsafe_get(t1, pos), _aN_);
                        ensure_no_mutation(t1, mut1);
                        ensure_no_mutation(t2, mut2);
                        if (b) {
                            var pos$0 = caml_call2(Base_Import[91], pos, 1);
                            pos = pos$0;
                            continue;
                        }
                        var _aM_ = b;
                    }
                    return _aM_;
                }
            }
            var _aP_ = _aQ_;
        }
        return _aP_;
    }
    function equal(equal_elt, t1, t2) {
        return equal_local(equal_elt, t1, t2);
    }
    function invariant(invariant_a, t) {
        var num_mutations = t[1], front = t[2], length = t[4], elts = t[5];
        if (0 > front) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _n_
        ], 1);
        if (front >= capacity(t)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _m_
        ], 1);
        var capacity$0 = capacity(t);
        if (capacity$0 !== caml_call1(Base_Option_array[28], elts)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _l_
        ], 1);
        if (1 > capacity$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _k_
        ], 1);
        if (!caml_call1(Base_Int[72], capacity$0)) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
        if (0 > length) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _i_
        ], 1);
        if (length > capacity$0) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _h_
        ], 1);
        var _aJ_ = caml_call2(Base_Import[93], capacity$0, 1), _aI_ = 0;
        if (_aJ_ >= 0) {
            var i = _aI_;
            for(;;){
                if (i < t[4]) {
                    caml_call1(invariant_a, unsafe_get(t, i));
                    ensure_no_mutation(t, num_mutations);
                } else {
                    var _aH_ = elts_index(t, i);
                    if (caml_call2(Base_Option_array[42], t[5], _aH_)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _g_
                    ], 1);
                }
                var _aK_ = i + 1 | 0;
                if (_aJ_ === i) break;
                i = _aK_;
            }
        }
        return 0;
    }
    function create(capacity, param) {
        if (capacity) {
            var capacity$0 = capacity[1];
            if (0 <= capacity$0) var _aD_ = 0 === capacity$0 ? 1 : caml_call1(Base_Int[68], capacity$0);
            else var _aF_ = [
                0,
                [
                    0,
                    cst_capacity,
                    caml_call1(Base_Int[10], capacity$0)
                ],
                0
            ], _aG_ = caml_call2(Base_Sexp[10], cst_cannot_have_queue_with_neg, _aF_), _aD_ = caml_call1(Base_Error[32], _aG_);
            var capacity$1 = _aD_;
        } else var capacity$1 = 2;
        var _aE_ = caml_call1(Base_Option_array[5], capacity$1);
        return [
            0,
            0,
            0,
            caml_call2(Base_Import[93], capacity$1, 1),
            0,
            _aE_
        ];
    }
    function blit_to_array(src, dst) {
        var _az_ = caml_call1(Base_Option_array[28], dst);
        if (src[4] > _az_) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _o_
        ], 1);
        var _aA_ = src[2], _aB_ = capacity(src), _aC_ = caml_call2(Base_Import[93], _aB_, _aA_), front_len = caml_call2(Base_Int[15], src[4], _aC_), rest_len = caml_call2(Base_Import[93], src[4], front_len);
        caml_call5(Base_Option_array[53], src[5], src[2], dst, 0, front_len);
        return caml_call5(Base_Option_array[53], src[5], 0, dst, front_len, rest_len);
    }
    function set_capacity_internal(t, new_capacity) {
        var dst = caml_call1(Base_Option_array[5], new_capacity);
        blit_to_array(t, dst);
        t[2] = 0;
        t[3] = caml_call2(Base_Import[93], new_capacity, 1);
        t[5] = dst;
        return 0;
    }
    function set_capacity(t, desired_capacity) {
        inc_num_mutations(t);
        var _aw_ = caml_call2(Base_Import[100], desired_capacity, t[4]), _ax_ = caml_call2(Base_Import[100], 1, _aw_), new_capacity = caml_call1(Base_Int[68], _ax_), _ay_ = new_capacity !== capacity(t) ? 1 : 0;
        return _ay_ ? set_capacity_internal(t, new_capacity) : _ay_;
    }
    function enqueue(t, a) {
        inc_num_mutations(t);
        var _av_ = capacity(t);
        if (t[4] === _av_) set_capacity_internal(t, caml_call2(Base_Import[88], 2, t[4]));
        unsafe_set(t, t[4], a);
        t[4] = caml_call2(Base_Import[91], t[4], 1);
        return 0;
    }
    function enqueue_front(t, a) {
        inc_num_mutations(t);
        var _as_ = capacity(t);
        if (t[4] === _as_) set_capacity_internal(t, caml_call2(Base_Import[88], 2, t[4]));
        var _at_ = t[3], _au_ = caml_call2(Base_Import[93], t[2], 1), front = caml_call2(Base_Import[116], _au_, _at_);
        t[2] = front;
        t[4] = caml_call2(Base_Import[91], t[4], 1);
        return unsafe_set(t, 0, a);
    }
    function dequeue_nonempty(t) {
        inc_num_mutations(t);
        var elts = t[5], front = t[2], res = caml_call2(Base_Option_array[36], elts, front);
        caml_call2(Base_Option_array[45], elts, front);
        t[2] = elts_index(t, 1);
        t[4] = caml_call2(Base_Import[93], t[4], 1);
        return res;
    }
    function back_index(t) {
        return elts_index(t, caml_call2(Base_Import[93], t[4], 1));
    }
    function dequeue_back_nonempty(t) {
        inc_num_mutations(t);
        var elts = t[5], back = back_index(t), res = caml_call2(Base_Option_array[36], elts, back);
        caml_call2(Base_Option_array[45], elts, back);
        t[4] = caml_call2(Base_Import[93], t[4], 1);
        return res;
    }
    function dequeue_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return dequeue_nonempty(t);
    }
    function dequeue(t) {
        return is_empty(t) ? 0 : [
            0,
            dequeue_nonempty(t)
        ];
    }
    function dequeue_and_ignore_exn(t) {
        dequeue_exn(t);
        return 0;
    }
    function dequeue_back_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return dequeue_back_nonempty(t);
    }
    function dequeue_back(t) {
        return is_empty(t) ? 0 : [
            0,
            dequeue_back_nonempty(t)
        ];
    }
    function front_nonempty(t) {
        return caml_call2(Base_Option_array[40], t[5], t[2]);
    }
    function back_nonempty(t) {
        var _ar_ = back_index(t);
        return caml_call2(Base_Option_array[40], t[5], _ar_);
    }
    function last_nonempty(t) {
        return unsafe_get(t, caml_call2(Base_Import[93], t[4], 1));
    }
    function peek(t) {
        return is_empty(t) ? 0 : [
            0,
            front_nonempty(t)
        ];
    }
    function peek_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return front_nonempty(t);
    }
    function peek_back(t) {
        return is_empty(t) ? 0 : [
            0,
            back_nonempty(t)
        ];
    }
    function peek_back_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return back_nonempty(t);
    }
    function last(t) {
        return is_empty(t) ? 0 : [
            0,
            last_nonempty(t)
        ];
    }
    function last_exn(t) {
        if (is_empty(t)) throw caml_maybe_attach_backtrace(Stdlib_Queue[1], 1);
        return last_nonempty(t);
    }
    function drain(t, f, while$0) {
        for(;;){
            if (!is_empty(t) && caml_call1(while$0, front_nonempty(t))) {
                caml_call1(f, dequeue_nonempty(t));
                continue;
            }
            return 0;
        }
    }
    function clear(t) {
        inc_num_mutations(t);
        var _am_ = 0 < t[4] ? 1 : 0;
        if (_am_) {
            var _ao_ = caml_call2(Base_Import[93], t[4], 1), _an_ = 0;
            if (_ao_ >= 0) {
                var i = _an_;
                for(;;){
                    var _al_ = elts_index(t, i);
                    caml_call2(Base_Option_array[52], t[5], _al_);
                    var _aq_ = i + 1 | 0;
                    if (_ao_ === i) break;
                    i = _aq_;
                }
            }
            t[4] = 0;
            t[2] = 0;
            var _ap_ = 0;
        } else var _ap_ = _am_;
        return _ap_;
    }
    function blit_transfer(src, dst, len, param) {
        inc_num_mutations(src);
        inc_num_mutations(dst);
        if (len) {
            var len$0 = len[1];
            if (len$0 < 0) {
                var _X_ = [
                    0,
                    [
                        0,
                        cst_length$0,
                        caml_call1(Base_Int[10], len$0)
                    ],
                    0
                ], _Y_ = caml_call2(Base_Sexp[10], cst_Queue_blit_transfer_negati, _X_);
                caml_call1(Base_Error[32], _Y_);
            }
            var len$1 = caml_call2(Base_Import[101], len$0, src[4]);
        } else var len$1 = src[4];
        var _Z_ = 0 < len$1 ? 1 : 0;
        if (_Z_) {
            var ___ = caml_call2(Base_Import[91], dst[4], len$1), _$_ = capacity(dst);
            set_capacity(dst, caml_call2(Base_Import[100], _$_, ___));
            var dst_start = caml_call2(Base_Import[91], dst[2], dst[4]), _ab_ = caml_call2(Base_Import[93], len$1, 1), _aa_ = 0;
            if (_ab_ >= 0) {
                var i = _aa_;
                for(;;){
                    var _af_ = src[3], _ag_ = caml_call2(Base_Import[91], src[2], i), src_i = caml_call2(Base_Import[116], _ag_, _af_), _ah_ = dst[3], _ai_ = caml_call2(Base_Import[91], dst_start, i), dst_i = caml_call2(Base_Import[116], _ai_, _ah_), _aj_ = caml_call2(Base_Option_array[40], src[5], src_i);
                    caml_call3(Base_Option_array[51], dst[5], dst_i, _aj_);
                    caml_call2(Base_Option_array[52], src[5], src_i);
                    var _ak_ = i + 1 | 0;
                    if (_ab_ === i) break;
                    i = _ak_;
                }
            }
            dst[4] = caml_call2(Base_Import[91], dst[4], len$1);
            var _ac_ = src[3], _ad_ = caml_call2(Base_Import[91], src[2], len$1);
            src[2] = caml_call2(Base_Import[116], _ad_, _ac_);
            src[4] = caml_call2(Base_Import[93], src[4], len$1);
            var _ae_ = 0;
        } else var _ae_ = _Z_;
        return _ae_;
    }
    function enqueue_all(t, l) {
        var _U_ = caml_call1(Base_List[45], l), _V_ = caml_call2(Base_Import[91], t[4], _U_), _W_ = capacity(t);
        set_capacity(t, caml_call2(Base_Int[16], _W_, _V_));
        return caml_call2(Base_List[19], l, function(x) {
            return enqueue(t, x);
        });
    }
    function fold(t, init, f) {
        if (0 === t[4]) return init;
        var num_mutations = t[1], r = [
            0,
            init
        ], _R_ = caml_call2(Base_Import[93], t[4], 1), _Q_ = 0;
        if (_R_ >= 0) {
            var i = _Q_;
            for(;;){
                var _S_ = unsafe_get(t, i);
                r[1] = caml_call2(f, r[1], _S_);
                ensure_no_mutation(t, num_mutations);
                var _T_1 = i + 1 | 0;
                if (_R_ === i) break;
                i = _T_1;
            }
        }
        return r[1];
    }
    function foldi(t, init, f) {
        var i = [
            0,
            0
        ];
        return fold(t, init, function(acc, a) {
            var acc$0 = caml_call3(f, i[1], acc, a);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return acc$0;
        });
    }
    function iter(t, f) {
        var num_mutations = t[1], _O_ = caml_call2(Base_Import[93], t[4], 1), _N_ = 0;
        if (_O_ >= 0) {
            var i = _N_;
            for(;;){
                caml_call1(f, unsafe_get(t, i));
                ensure_no_mutation(t, num_mutations);
                var _P_ = i + 1 | 0;
                if (_O_ === i) break;
                i = _P_;
            }
        }
        return 0;
    }
    function iteri(t, f) {
        var num_mutations = t[1], _L_ = caml_call2(Base_Import[93], t[4], 1), _K_ = 0;
        if (_L_ >= 0) {
            var i = _K_;
            for(;;){
                caml_call2(f, i, unsafe_get(t, i));
                ensure_no_mutation(t, num_mutations);
                var _M_ = i + 1 | 0;
                if (_L_ === i) break;
                i = _M_;
            }
        }
        return 0;
    }
    function to_list(t) {
        var result = [
            0,
            0
        ], _H_ = caml_call2(Base_Import[93], t[4], 1);
        if (_H_ >= 0) {
            var i = _H_;
            for(;;){
                var _I_ = result[1];
                result[1] = [
                    0,
                    unsafe_get(t, i),
                    _I_
                ];
                var _J_ = i - 1 | 0;
                if (0 === i) break;
                i = _J_;
            }
        }
        return result[1];
    }
    var iter$0 = [
        0,
        -198771759,
        iter
    ], length$0 = [
        0,
        -198771759,
        length
    ], foldi$0 = [
        0,
        -198771759,
        foldi
    ], iteri$0 = [
        0,
        -198771759,
        iteri
    ], C = caml_call1(Base_Indexed_container[8], [
        0,
        fold,
        iter$0,
        length$0,
        iteri$0,
        foldi$0
    ]), count = C[10], exists = C[8], find = C[12], find_map = C[13], fold_result = C[6], fold_until = C[7], for_all = C[9], max_elt = C[17], mem = C[1], min_elt = C[16], sum = C[11], counti = C[22], existsi = C[20], find_mapi = C[24], findi = C[23], for_alli = C[21], cst_length$1 = cst_length$2, cst_Queue_init_negative_length = "Queue.init: negative length", _p_ = [
        0,
        cst_src_queue_ml,
        507,
        2
    ], _q_ = [
        0,
        1
    ];
    function concat_map(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var _G_ = caml_call1(f, a);
            return caml_call2(Base_List[19], _G_, function(b) {
                return enqueue(t_result, b);
            });
        });
        return t_result;
    }
    function concat_mapi(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var _F_ = caml_call2(f, i, a);
            return caml_call2(Base_List[19], _F_, function(b) {
                return enqueue(t_result, b);
            });
        });
        return t_result;
    }
    function filter_map(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var match = caml_call1(f, a);
            if (!match) return 0;
            var b = match[1];
            return enqueue(t_result, b);
        });
        return t_result;
    }
    function filter_mapi(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var match = caml_call2(f, i, a);
            if (!match) return 0;
            var b = match[1];
            return enqueue(t_result, b);
        });
        return t_result;
    }
    function filter(t, f) {
        var t_result = create(0, 0);
        iter(t, function(a) {
            var _E_ = caml_call1(f, a);
            return _E_ ? enqueue(t_result, a) : _E_;
        });
        return t_result;
    }
    function filteri(t, f) {
        var t_result = create(0, 0);
        iteri(t, function(i, a) {
            var _D_ = caml_call2(f, i, a);
            return _D_ ? enqueue(t_result, a) : _D_;
        });
        return t_result;
    }
    function filter_inplace(t, f) {
        var t2 = filter(t, f);
        clear(t);
        return blit_transfer(t2, t, 0, 0);
    }
    function filteri_inplace(t, f) {
        var t2 = filteri(t, f);
        clear(t);
        return blit_transfer(t2, t, 0, 0);
    }
    function copy(src) {
        var dst = create([
            0,
            src[4]
        ], 0);
        blit_to_array(src, dst[5]);
        dst[4] = src[4];
        return dst;
    }
    function of_list(l) {
        var t = create([
            0,
            caml_call1(Base_List[45], l)
        ], 0);
        caml_call2(Base_List[19], l, function(x) {
            return enqueue(t, x);
        });
        return t;
    }
    function init(len, f) {
        if (len < 0) {
            var _x_ = [
                0,
                [
                    0,
                    cst_length$1,
                    caml_call1(Base_Int[10], len)
                ],
                0
            ], _y_ = caml_call2(Base_Sexp[10], cst_Queue_init_negative_length, _x_);
            caml_call1(Base_Error[32], _y_);
        }
        var t = create([
            0,
            len
        ], 0);
        if (len > caml_call1(Base_Option_array[28], t[5])) throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _p_
        ], 1);
        var _A_ = caml_call2(Base_Import[93], len, 1), _z_ = 0;
        if (_A_ >= 0) {
            var i = _z_;
            for(;;){
                var _B_ = caml_call1(f, i);
                caml_call3(Base_Option_array[51], t[5], i, _B_);
                var _C_ = i + 1 | 0;
                if (_A_ === i) break;
                i = _C_;
            }
        }
        t[4] = len;
        return t;
    }
    function of_array(a) {
        return init(a.length - 1, function(_w_) {
            return a[1 + _w_];
        });
    }
    function to_array(t) {
        return caml_call2(Base_Array[41], t[4], function(i) {
            return unsafe_get(t, i);
        });
    }
    function map(ta, f) {
        var num_mutations = ta[1], tb = create([
            0,
            ta[4]
        ], 0);
        tb[4] = ta[4];
        var _u_ = caml_call2(Base_Import[93], ta[4], 1), _t_ = 0;
        if (_u_ >= 0) {
            var i = _t_;
            for(;;){
                var b = caml_call1(f, unsafe_get(ta, i));
                ensure_no_mutation(ta, num_mutations);
                caml_call3(Base_Option_array[51], tb[5], i, b);
                var _v_ = i + 1 | 0;
                if (_u_ === i) break;
                i = _v_;
            }
        }
        return tb;
    }
    function mapi(t, f) {
        var i = [
            0,
            0
        ];
        return map(t, function(a) {
            var result = caml_call2(f, i[1], a);
            i[1] = caml_call2(Base_Import[91], i[1], 1);
            return result;
        });
    }
    function singleton(x) {
        var t = create(_q_, 0);
        enqueue(t, x);
        return t;
    }
    function sexp_of_t(sexp_of_a, t) {
        var _s_ = to_list(t);
        return caml_call1(caml_call1(Base_List[6], sexp_of_a), _s_);
    }
    function t_of_sexp(a_of_sexp, sexp) {
        return of_list(caml_call2(Base_List[5], a_of_sexp, sexp));
    }
    function t_sexp_grammar(grammar) {
        var _r_ = caml_call1(Base_List[7], grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _r_);
    }
    function start(q) {
        return q[1];
    }
    function assert_no_mutation_since_start(t, q) {
        return ensure_no_mutation(q, t);
    }
    var Iteration = [
        0,
        start,
        assert_no_mutation_since_start
    ], Base_Queue = [
        0,
        compare,
        compare_local,
        globalize,
        t_of_sexp,
        sexp_of_t,
        t_sexp_grammar,
        mem,
        length,
        is_empty,
        iter,
        fold,
        fold_result,
        fold_until,
        exists,
        for_all,
        count,
        sum,
        find,
        find_map,
        to_list,
        to_array,
        min_elt,
        max_elt,
        foldi,
        iteri,
        existsi,
        for_alli,
        counti,
        findi,
        find_mapi,
        singleton,
        of_list,
        of_array,
        init,
        enqueue,
        enqueue_all,
        dequeue,
        dequeue_exn,
        dequeue_and_ignore_exn,
        drain,
        peek,
        peek_exn,
        clear,
        copy,
        map,
        mapi,
        concat_map,
        concat_mapi,
        filter_map,
        filter_mapi,
        filter,
        filteri,
        filter_inplace,
        filteri_inplace,
        equal,
        equal_local,
        invariant,
        create,
        last,
        last_exn,
        enqueue_front,
        dequeue_back,
        dequeue_back_exn,
        peek_back,
        peek_back_exn,
        blit_transfer,
        get,
        set,
        capacity,
        set_capacity,
        Iteration
    ];
    runtime.caml_register_global(39, Base_Queue, "Base__Queue");
    return;
})(globalThis);
//# 31084 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_nx = "%nx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_lessequal = runtime.caml_lessequal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Nativeint.Hex", module_name$0 = "Base.Nativeint", Base_Int_math = global_data.Base__Int_math, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Stdlib_Nativeint = global_data.Stdlib__Nativeint, Base_Printf = global_data.Base__Printf, Base_Float0 = global_data.Base__Float0, Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, Base_Word_size = global_data.Base__Word_size, Base_Error = global_data.Base__Error, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, include = Base_Import[104], compare = include[9], globalize = Base_Import[287], hash_fold_t = Base_Import[202], func = Base_Import[216];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[167], sexp_of_t = Base_Import[143], t_sexp_grammar = Base_Import[189], hashable = [
        0,
        hash,
        compare,
        sexp_of_t
    ], compare$0 = Base_Import[104][9], to_string = Stdlib_Nativeint[15], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib_Nativeint[14], comparator = caml_call1(Base_Comparator[7], [
        0,
        compare$0,
        sexp_of_t
    ])[1], zero = Stdlib_Nativeint[1], _a_ = caml_call1(Base_Comparable[14], [
        0,
        compare$0,
        sexp_of_t,
        zero
    ]), is_positive = _a_[1], is_non_negative = _a_[2], is_negative = _a_[3], is_non_positive = _a_[4], sign = _a_[5], include$0 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$0[1], sexp_of_t$0 = include$0[2], compare_local = Base_Import[259];
    function compare$1(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[202], func$0 = Base_Import[216];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var zero$0 = Stdlib_Nativeint[1];
    function neg(_W_) {
        return -_W_ | 0;
    }
    var symbol = Base_Import[104][1], _b_ = [
        0,
        [
            6,
            6,
            0,
            0,
            0
        ],
        cst_nx
    ], _c_ = [
        0,
        [
            6,
            6,
            0,
            0,
            0
        ],
        cst_nx
    ];
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _b_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _c_, function(_V_) {
            return _V_;
        });
    }
    var include$1 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$1,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero$0,
        symbol,
        neg,
        module_name
    ]), Hex = include$1[1], include$2 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ]), pp = include$2[1];
    function invariant(param) {
        return 0;
    }
    var num_bits = caml_call1(Base_Word_size[2], Base_Word_size[3]), float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits);
    function shift_right_logical(_U_, _T_1) {
        return _U_ >>> _T_1 | 0;
    }
    function shift_right(_S_, _R_) {
        return _S_ >> _R_;
    }
    function shift_left(_Q_, _P_) {
        return _Q_ << _P_;
    }
    var bit_not = Stdlib_Nativeint[12];
    function bit_xor(_O_, _N_) {
        return _O_ ^ _N_;
    }
    function bit_or(_M_, _L_) {
        return _M_ | _L_;
    }
    function bit_and(_K_, _J_) {
        return _K_ & _J_;
    }
    var min_value = Stdlib_Nativeint[11], max_value = Stdlib_Nativeint[10], abs = Stdlib_Nativeint[8], pred = Stdlib_Nativeint[7], succ = Stdlib_Nativeint[6], rem = runtime.caml_mod;
    function symbol$0(_I_) {
        return -_I_ | 0;
    }
    var minus_one = Stdlib_Nativeint[3], one = Stdlib_Nativeint[2], zero$1 = Stdlib_Nativeint[1], _d_ = [
        0,
        [
            11,
            "Nativeint.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Nativeint.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_H_) {
        return _H_;
    }
    function of_float_unchecked(_G_) {
        return _G_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _F_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _d_, _F_, 0);
    }
    var raise_s = Base_Error[32], _e_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Nativeint_floor_log2_got_i = "[Nativeint.floor_log2] got invalid input", cst_Nativeint_ceil_log2_got_in = "[Nativeint.ceil_log2] got invalid input", _f_ = [
        0,
        "src/nativeint.ml",
        206,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _e_, 0);
    }
    function lsr(_E_, _D_) {
        return _E_ >>> _D_ | 0;
    }
    function land(_C_, _B_) {
        return _C_ & _B_;
    }
    function ceil_pow2(x) {
        if (caml_call2(Base_Import[104][2], x, 0)) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Nativeint[7], x), x$6 = x$0 | x$0 >>> 1 | 0, x$5 = x$6 | x$6 >>> 2 | 0, x$4 = x$5 | x$5 >>> 4 | 0, x$3 = x$4 | x$4 >>> 8 | 0, x$2 = x$3 | x$3 >>> 16 | 0, x$1 = x$2 | x$2 >>> 32 | 0;
        return caml_call1(Stdlib_Nativeint[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_call2(Base_Import[104][2], x$0, 0)) non_positive_argument(0);
        var x = x$0 | x$0 >>> 1 | 0, x$5 = x | x >>> 2 | 0, x$4 = x$5 | x$5 >>> 4 | 0, x$3 = x$4 | x$4 >>> 8 | 0, x$2 = x$3 | x$3 >>> 16 | 0, x$1 = x$2 | x$2 >>> 32 | 0;
        return x$1 - (x$1 >>> 1 | 0) | 0;
    }
    function is_pow2(x) {
        if (caml_call2(Base_Import[104][2], x, 0)) non_positive_argument(0);
        var _A_ = x & caml_call1(Stdlib_Nativeint[7], x);
        return caml_call2(Base_Import[104][4], _A_, 0);
    }
    function floor_log2(i) {
        if (caml_lessequal(i, Stdlib_Nativeint[1])) {
            var _x_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[143], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Nativeint_floor_log2_got_i, _x_));
        }
        var _y_ = runtime.Base_int_math_nativeint_clz(i), _z_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _z_, _y_);
    }
    function ceil_log2(i) {
        if (caml_lessequal(i, Stdlib_Nativeint[1])) {
            var _v_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[143], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Nativeint_ceil_log2_got_in, _v_));
        }
        if (caml_call2(Stdlib_Nativeint[18], i, Stdlib_Nativeint[2])) return 0;
        var _w_ = runtime.Base_int_math_nativeint_clz(caml_call1(Stdlib_Nativeint[7], i));
        return caml_call2(Base_Import[93], num_bits, _w_);
    }
    function between(t, low, high) {
        var _u_ = caml_call2(Base_Import[104][2], low, t);
        return _u_ ? caml_call2(Base_Import[104][2], t, high) : _u_;
    }
    function clamp_unchecked(t, min, max) {
        var _t_ = caml_call2(Base_Import[104][14], t, max);
        return caml_call1(caml_call1(Base_Import[104][13], min), _t_);
    }
    function clamp_exn(t, min, max) {
        if (caml_call2(Base_Import[104][2], min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _f_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_call2(Base_Import[104][5], min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _q_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _r_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _q_
        ], _s_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _r_);
        return caml_call1(Base_Or_error[39], _s_);
    }
    var symbol$1 = runtime.caml_div, symbol$2 = runtime.caml_mul;
    function symbol$3(_p_, _o_) {
        return _p_ - _o_ | 0;
    }
    function symbol$4(_n_, _m_) {
        return _n_ + _m_ | 0;
    }
    function incr(r) {
        r[1] = r[1] + one | 0;
        return 0;
    }
    function decr(r) {
        r[1] = r[1] - one | 0;
        return 0;
    }
    function of_nativeint(t) {
        return t;
    }
    function to_nativeint(t) {
        return t;
    }
    var popcount = Base_Popcount[4], of_int_exn = Base_Int_conversions[5], to_int = Base_Int_conversions[23], to_int_exn = Base_Int_conversions[24], to_int_trunc = Base_Int_conversions[25], of_int32 = Base_Int_conversions[10], to_int32 = Base_Int_conversions[26], to_int32_exn = Base_Int_conversions[27], of_int64 = Base_Int_conversions[18], of_int64_exn = Base_Int_conversions[19], of_int64_trunc = Base_Int_conversions[20], to_int64 = Base_Int_conversions[29];
    function pow(b, e) {
        var _k_ = caml_call1(to_int_exn, e), _l_ = caml_call1(to_int_exn, b);
        return caml_call1(of_int_exn, caml_call2(Base_Int_math[2][1], _l_, _k_));
    }
    function symbol$5(b, e) {
        return pow(b, e);
    }
    var compare_local$0 = Base_Import[259];
    function compare$2(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[273];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[202], func$1 = Base_Import[216];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_j_) {
        return runtime.Base_int_math_nativeint_clz(_j_);
    }
    var Binary = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$2,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero$1
    ])[1], _g_ = Base_Import[104], symbol$6 = _g_[3], symbol$7 = _g_[1], symbol$8 = _g_[5], symbol$9 = _g_[4], symbol$10 = _g_[2], symbol$11 = _g_[6], include$3 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol$4,
        symbol$3,
        symbol$2,
        symbol$1,
        symbol$0,
        symbol$11,
        symbol$10,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        abs,
        symbol$0,
        zero$1,
        of_int_exn,
        rem
    ]), symbol$12 = include$3[1], symbol$13 = include$3[2], symbol$14 = include$3[3], round = include$3[4], round_towards_zero = include$3[5], round_down = include$3[6], round_up = include$3[7], round_nearest = include$3[8], include$4 = Base_Import[104], symbol$15 = include$4[1], symbol$16 = include$4[2], symbol$17 = include$4[3], symbol$18 = include$4[4], symbol$19 = include$4[5], symbol$20 = include$4[6], ascending = include$4[7], descending = include$4[8], compare$3 = include$4[9], compare_local$1 = include$4[10], equal$0 = include$4[11], equal_local$0 = include$4[12], max = include$4[13], min = include$4[14], Base_Nativeint = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        symbol$20,
        symbol$16,
        symbol$18,
        symbol$19,
        symbol$15,
        symbol$17,
        equal$0,
        compare$3,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local$1,
        equal_local$0,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero$1,
        one,
        minus_one,
        symbol$4,
        symbol$3,
        symbol$2,
        symbol$5,
        symbol$0,
        symbol$0,
        symbol$13,
        symbol$12,
        symbol$1,
        rem,
        symbol$14,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_i_) {
            return runtime.Base_int_math_nativeint_clz(_i_);
        },
        function(_h_) {
            return runtime.Base_int_math_nativeint_ctz(_h_);
        },
        [
            0,
            symbol$4,
            symbol$3,
            symbol$2,
            symbol$1,
            symbol$0,
            symbol$5,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs,
            symbol$0,
            zero$1,
            symbol$12,
            symbol$13,
            symbol$14,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int_exn,
        to_int,
        of_int32,
        to_int32,
        of_nativeint,
        to_nativeint,
        of_int64,
        to_int_trunc,
        of_int64_trunc,
        runtime.caml_int32_bswap
    ];
    runtime.caml_register_global(35, Base_Nativeint, "Base__Nativeint");
    return;
})(globalThis);
//# 36300 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_Lx = "%Lx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_equal = runtime.caml_equal, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_bswap = runtime.caml_int64_bswap, caml_int64_compare = runtime.caml_int64_compare, caml_int64_neg = runtime.caml_int64_neg, caml_int64_of_float = runtime.caml_int64_of_float, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_or = runtime.caml_int64_or, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int64.Hex", module_name$0 = "Base.Int64", Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Printf = global_data.Base__Printf, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Int_math = global_data.Base__Int_math, Base_Comparable = global_data.Base__Comparable, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, Base_Error = global_data.Base__Error, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, globalize = Base_Import[286], hash_fold_t = Base_Import[203], func = Base_Import[217];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[166], sexp_of_t = Base_Import[142], t_sexp_grammar = Base_Import[188], hashable = [
        0,
        hash,
        Stdlib_Int64[15],
        sexp_of_t
    ];
    function compare(_C_, _B_) {
        return caml_int64_compare(_C_, _B_);
    }
    var to_string = Stdlib_Int64[14], of_string = runtime.caml_int64_of_string, of_string_opt = Stdlib_Int64[13], include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], num_bits = 64, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), shift_right_logical = caml_int64_shift_right_unsigne, shift_right = runtime.caml_int64_shift_right, shift_left = runtime.caml_int64_shift_left, bit_not = Stdlib_Int64[11], bit_xor = runtime.caml_int64_xor, bit_or = caml_int64_or, bit_and = caml_int64_and, min_value = Stdlib_Int64[10], max_value = Stdlib_Int64[9], abs = Stdlib_Int64[8], pred = Stdlib_Int64[7], succ = Stdlib_Int64[6], symbol = Base_Int_math[2][2], rem = runtime.caml_int64_mod, neg = caml_int64_neg, minus_one = Stdlib_Int64[3], one = Stdlib_Int64[2], zero = Stdlib_Int64[1], to_float = runtime.caml_int64_to_float, of_float_unchecked = caml_int64_of_float, _a_ = [
        0,
        [
            11,
            "Int64.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int64.of_float: argument (%f) is out of range or NaN"
    ];
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return caml_int64_of_float(f);
        var _A_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _a_, _A_, 0);
    }
    function bswap16(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 48);
    }
    function bswap32(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 32);
    }
    function bswap48(x) {
        return caml_int64_shift_right_unsigne(caml_int64_bswap(x), 16);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), is_positive = include$0[1], is_non_negative = include$0[2], is_negative = include$0[3], is_non_positive = include$0[4], sign = include$0[5], _b_ = [
        0,
        "src/int64.ml",
        115,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function invariant(param) {
        return 0;
    }
    function between(t, low, high) {
        var _y_ = caml_lessequal(low, t), _z_ = _y_ ? caml_lessequal(t, high) : _y_;
        return _z_;
    }
    function clamp_unchecked(t, min, max) {
        var _x_ = caml_call2(Base_Import[103][4], t, max);
        return caml_call1(caml_call1(Base_Import[103][3], min), _x_);
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _u_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _v_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _u_
        ], _w_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _v_);
        return caml_call1(Base_Or_error[39], _w_);
    }
    function incr(r) {
        r[1] = caml_int64_add(r[1], one);
        return 0;
    }
    function decr(r) {
        r[1] = caml_int64_sub(r[1], one);
        return 0;
    }
    function of_int64_exn(_t_) {
        return _t_;
    }
    function to_int64(t) {
        return t;
    }
    var popcount = Base_Popcount[3], of_int_exn = caml_int64_of_int32, to_int = Base_Int_conversions[12], to_int_exn = Base_Int_conversions[13], of_int32_exn = caml_int64_of_int32, to_int32 = Base_Int_conversions[15], to_int32_exn = Base_Int_conversions[16], of_nativeint_exn = caml_int64_of_int32, to_nativeint = Base_Int_conversions[18], to_nativeint_exn = Base_Int_conversions[19], raise_s = Base_Error[32], _c_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ];
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _c_, 0);
    }
    var lsr = caml_int64_shift_right_unsigne, land = caml_int64_and, cst_Int64_floor_log2_got_inval = "[Int64.floor_log2] got invalid input", cst_Int64_ceil_log2_got_invali = "[Int64.ceil_log2] got invalid input";
    function ceil_pow2(x) {
        if (caml_lessequal(x, Stdlib_Int64[1])) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Int64[7], x), x$6 = caml_int64_or(x$0, caml_int64_shift_right_unsigne(x$0, 1)), x$5 = caml_int64_or(x$6, caml_int64_shift_right_unsigne(x$6, 2)), x$4 = caml_int64_or(x$5, caml_int64_shift_right_unsigne(x$5, 4)), x$3 = caml_int64_or(x$4, caml_int64_shift_right_unsigne(x$4, 8)), x$2 = caml_int64_or(x$3, caml_int64_shift_right_unsigne(x$3, 16)), x$1 = caml_int64_or(x$2, caml_int64_shift_right_unsigne(x$2, 32));
        return caml_call1(Stdlib_Int64[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_lessequal(x$0, Stdlib_Int64[1])) non_positive_argument(0);
        var x = caml_int64_or(x$0, caml_int64_shift_right_unsigne(x$0, 1)), x$5 = caml_int64_or(x, caml_int64_shift_right_unsigne(x, 2)), x$4 = caml_int64_or(x$5, caml_int64_shift_right_unsigne(x$5, 4)), x$3 = caml_int64_or(x$4, caml_int64_shift_right_unsigne(x$4, 8)), x$2 = caml_int64_or(x$3, caml_int64_shift_right_unsigne(x$3, 16)), x$1 = caml_int64_or(x$2, caml_int64_shift_right_unsigne(x$2, 32));
        return caml_int64_sub(x$1, caml_int64_shift_right_unsigne(x$1, 1));
    }
    function is_pow2(x) {
        if (caml_lessequal(x, Stdlib_Int64[1])) non_positive_argument(0);
        var _s_ = Stdlib_Int64[1];
        return caml_equal(caml_int64_and(x, caml_call1(Stdlib_Int64[7], x)), _s_);
    }
    function floor_log2(i) {
        if (caml_lessequal(i, Stdlib_Int64[1])) {
            var _p_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[142], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int64_floor_log2_got_inval, _p_));
        }
        var _q_ = runtime.Base_int_math_int64_clz(i), _r_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _r_, _q_);
    }
    function ceil_log2(i) {
        if (caml_lessequal(i, Stdlib_Int64[1])) {
            var _n_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[142], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int64_ceil_log2_got_invali, _n_));
        }
        if (caml_call2(Stdlib_Int64[17], i, Stdlib_Int64[2])) return 0;
        var _o_ = runtime.Base_int_math_int64_clz(caml_call1(Stdlib_Int64[7], i));
        return caml_call2(Base_Import[93], num_bits, _o_);
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$0 = include$1[2], compare_local = Base_Import[258];
    function compare$0(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var hash_fold_t$0 = Base_Import[203], func$0 = Base_Import[217];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    var symbol$0 = caml_lessthan, _d_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        cst_Lx
    ], _e_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        cst_Lx
    ];
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_m_) {
            return _m_;
        });
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$0,
        compare_local,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$0,
        neg,
        module_name
    ]), Hex = include$2[1], compare_local$0 = Base_Import[258];
    function compare$1(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var equal_local = Base_Import[272];
    function equal(a, b) {
        return caml_call2(equal_local, a, b);
    }
    var hash_fold_t$1 = Base_Import[203], func$1 = Base_Import[217];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_l_) {
        return runtime.Base_int_math_int64_clz(_l_);
    }
    var include$3 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$1,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero
    ]), Binary = include$3[1], pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ])[1], include$4 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        caml_int64_add,
        caml_int64_sub,
        runtime.caml_int64_mul,
        runtime.caml_int64_div,
        caml_int64_neg,
        runtime.caml_greaterequal,
        caml_lessequal,
        caml_equal,
        caml_greaterthan,
        caml_lessthan,
        runtime.caml_notequal,
        abs,
        caml_int64_neg,
        zero,
        of_int_exn,
        rem
    ]), symbol$1 = include$4[1], symbol$2 = include$4[2], symbol$3 = include$4[3], round = include$4[4], round_towards_zero = include$4[5], round_down = include$4[6], round_up = include$4[7], round_nearest = include$4[8], include$5 = Base_Import[103], ascending = include$5[1], descending = include$5[2], max = include$5[3], min = include$5[4], Base_Int64 = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        caml_equal,
        function(_k_, _j_) {
            return caml_int64_compare(_k_, _j_);
        },
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        function(_i_, _h_) {
            return caml_int64_compare(_i_, _h_);
        },
        caml_equal,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        one,
        minus_one,
        rem,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        succ,
        pred,
        symbol,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_g_) {
            return runtime.Base_int_math_int64_clz(_g_);
        },
        function(_f_) {
            return runtime.Base_int_math_int64_ctz(_f_);
        },
        [
            0,
            symbol,
            bit_not,
            abs,
            zero,
            symbol$1,
            symbol$2,
            symbol$3
        ],
        symbol,
        bit_not,
        abs,
        zero,
        symbol$1,
        symbol$2,
        symbol$3,
        to_int,
        to_int32,
        to_nativeint,
        bswap16,
        bswap32,
        bswap48
    ];
    runtime.caml_register_global(30, Base_Int64, "Base__Int64");
    return;
})(globalThis);
//# 36726 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_int63_emul_ml = "src/int63_emul.ml", caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int64_add = runtime.caml_int64_add, caml_int64_and = runtime.caml_int64_and, caml_int64_compare = runtime.caml_int64_compare, caml_int64_mul = runtime.caml_int64_mul, caml_int64_neg = runtime.caml_int64_neg, caml_int64_of_float = runtime.caml_int64_of_float, caml_int64_of_string = runtime.caml_int64_of_string, caml_int64_shift_right = runtime.caml_int64_shift_right, caml_int64_shift_right_unsigne = runtime.caml_int64_shift_right_unsigned, caml_int64_sub = runtime.caml_int64_sub, caml_lessequal = runtime.caml_lessequal, caml_lessthan = runtime.caml_lessthan, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_notequal = runtime.caml_notequal, caml_string_get = runtime.caml_string_get;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), _c_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), mask = runtime.caml_int64_create_lo_mi_hi(16777214, 16777215, 65535), module_name = "Base.Int63.Hex", module_name$0 = "Base.Int63", Base_Import = global_data.Base__Import, Base_Printf = global_data.Base__Printf, Base_Int_conversions = global_data.Base__Int_conversions, Base_Sexp = global_data.Base__Sexp, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Int64 = global_data.Base__Int64, Base_String = global_data.Base__String, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Popcount = global_data.Base__Popcount, Base_Comparator = global_data.Base__Comparator, Base_Int_math = global_data.Base__Int_math, Base_Comparable = global_data.Base__Comparable, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, include = Base_Import[103], max = include[3], min = include[4], compare_local = Base_Import[258];
    function compare(a, b) {
        return caml_call2(compare_local, a, b);
    }
    var globalize = Base_Import[286], hash_fold_t = Base_Import[203], sexp_of_t = Base_Import[142], t_sexp_grammar = Base_Import[188], include$0 = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include$0[1], _a_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0), _e_ = [
        0,
        cst_src_int63_emul_ml,
        117,
        20
    ];
    function wrap_exn(x) {
        caml_call1(Base_Int_conversions[21], x);
        return caml_int64_mul(x, _a_);
    }
    function unwrap(x) {
        return caml_int64_shift_right(x, 1);
    }
    function invariant(t) {
        if (caml_equal(caml_int64_and(t, mask), t)) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    var symbol = caml_int64_add, symbol$0 = caml_int64_sub, symbol$1 = caml_int64_neg;
    function abs(x) {
        return caml_call1(Stdlib_Int64[8], x);
    }
    var one = wrap_exn(runtime.caml_int64_create_lo_mi_hi(1, 0, 0));
    function succ(a) {
        return caml_int64_add(a, one);
    }
    function pred(a) {
        return caml_int64_sub(a, one);
    }
    var x = Stdlib_Int64[10], min_value = caml_int64_and(x, mask), x$0 = Stdlib_Int64[9], max_value = caml_int64_and(x$0, mask);
    function bit_not(x) {
        var x$0 = caml_call1(Stdlib_Int64[11], x);
        return caml_int64_and(x$0, mask);
    }
    var bit_and = caml_int64_and, bit_xor = runtime.caml_int64_xor, bit_or = runtime.caml_int64_or, shift_left = runtime.caml_int64_shift_left;
    function shift_right(x, i) {
        var x$0 = caml_int64_shift_right(x, i);
        return caml_int64_and(x$0, mask);
    }
    function shift_right_logical(x, i) {
        var x$0 = caml_int64_shift_right_unsigne(x, i);
        return caml_int64_and(x$0, mask);
    }
    var f = Base_Int_math[2][3], _d_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0);
    function pow(a, b) {
        return caml_int64_mul(caml_call2(f, caml_int64_shift_right(a, 1), caml_int64_shift_right(b, 1)), _d_);
    }
    function symbol$2(a, b) {
        return caml_int64_mul(a, caml_int64_shift_right(b, 1));
    }
    function symbol$3(a, b) {
        var x = runtime.caml_int64_div(a, b);
        return caml_int64_mul(x, _c_);
    }
    var rem = runtime.caml_int64_mod, _b_ = runtime.caml_int64_create_lo_mi_hi(2, 0, 0);
    function popcount(x) {
        return caml_call1(Base_Popcount[3], x);
    }
    function to_int64(t) {
        return caml_int64_shift_right(t, 1);
    }
    function of_int64(t) {
        return caml_call1(Base_Int_conversions[22], t) ? [
            0,
            caml_int64_mul(t, _b_)
        ] : 0;
    }
    function of_int64_exn(t) {
        return wrap_exn(t);
    }
    function of_int64_trunc(t) {
        return caml_int64_mul(t, _c_);
    }
    function t_of_sexp(x) {
        return wrap_exn(caml_call1(Base_Import[166], x));
    }
    function sexp_of_t$0(x) {
        return caml_call1(Base_Import[142], caml_int64_shift_right(x, 1));
    }
    function compare$0(x, y) {
        return caml_call2(compare_local, x, y);
    }
    function compare_local$0(x, y) {
        return caml_call2(compare_local, x, y);
    }
    var equal_local = caml_equal;
    function is_pow2(x) {
        return caml_call1(Base_Int64[72], caml_int64_shift_right(x, 1));
    }
    function clz(x) {
        return caml_call1(Base_Int64[73], x);
    }
    function ctz(x) {
        return caml_call1(Base_Int64[74], caml_int64_shift_right(x, 1));
    }
    function floor_pow2(x) {
        return wrap_exn(caml_call1(Base_Int64[69], caml_int64_shift_right(x, 1)));
    }
    function ceil_pow2(x) {
        return wrap_exn(caml_call1(Base_Int64[69], caml_int64_shift_right(x, 1)));
    }
    function floor_log2(x) {
        return caml_call1(Base_Int64[71], caml_int64_shift_right(x, 1));
    }
    function ceil_log2(x) {
        return caml_call1(Base_Int64[70], caml_int64_shift_right(x, 1));
    }
    function hash(x) {
        return caml_call1(Base_Import[85][105][28], x);
    }
    var hashable = [
        0,
        hash,
        compare$0,
        sexp_of_t$0
    ], _f_ = [
        0,
        [
            11,
            "Int63.of_string: invalid input ",
            [
                3,
                0,
                0
            ]
        ],
        "Int63.of_string: invalid input %S"
    ], _g_ = runtime.caml_int64_create_lo_mi_hi(0, 0, 0);
    function invalid_str(x) {
        return caml_call3(Base_Printf[6], _f_, x, 0);
    }
    function to_string(x) {
        return caml_call1(Stdlib_Int64[14], caml_int64_shift_right(x, 1));
    }
    function of_string_raw(str) {
        var len = caml_ml_string_length(str);
        a: if (0 < len) {
            var switcher = caml_string_get(str, 0) - 43 | 0;
            if (2 >= switcher >>> 0) switch(switcher){
                case 0:
                    var sign = 4003188, pos = 1;
                    break a;
                case 1:
                    break;
                default:
                    var sign = 3901488, pos = 1;
                    break a;
            }
            var sign = 4003188, pos = 0;
        } else var sign = 4003188, pos = 0;
        if (caml_call2(Base_Import[91], pos, 2) < len) var c1 = caml_string_get(str, pos), c2 = caml_string_get(str, caml_call2(Base_Import[91], pos, 1)), match = 48 === c1 ? 9 < c2 - 48 >>> 0 ? [
            0,
            ,
            0
        ] : [
            0,
            ,
            1
        ] : [
            0,
            ,
            1
        ];
        else var match = [
            0,
            ,
            1
        ];
        var signedness = match[2];
        if (signedness) {
            var t = caml_int64_of_string(str);
            return wrap_exn(t);
        }
        if (4003188 <= sign) var pos_str = str;
        else var _z_ = caml_call2(Base_Import[93], caml_ml_string_length(str), 1), pos_str = caml_call3(Base_String[3], str, 1, _z_);
        var int64 = caml_int64_of_string(pos_str);
        if (caml_lessthan(int64, _g_)) invalid_str(str);
        var int63 = caml_int64_mul(int64, _c_);
        return 4003188 <= sign ? int63 : caml_int64_neg(int63);
    }
    function of_string(str) {
        try {
            var _x_ = of_string_raw(str);
            return _x_;
        } catch (_y_) {
            return invalid_str(str);
        }
    }
    function of_string_opt(str) {
        try {
            var t = of_string_raw(str);
        } catch (_w_) {
            return 0;
        }
        return [
            0,
            t
        ];
    }
    function bswap16(t) {
        var x = caml_call1(Base_Int64[86], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    function bswap32(t) {
        var x = caml_call1(Base_Int64[87], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    function bswap48(t) {
        var x = caml_call1(Base_Int64[88], caml_int64_shift_right(t, 1));
        return caml_int64_mul(x, _c_);
    }
    var num_bits = 63, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), minus_one = wrap_exn(Stdlib_Int64[3]), one$0 = wrap_exn(Stdlib_Int64[2]), zero = wrap_exn(Stdlib_Int64[1]), _h_ = [
        0,
        [
            11,
            "Int63.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int63.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(x) {
        return runtime.caml_int64_to_float(caml_int64_shift_right(x, 1));
    }
    function of_float_unchecked(x) {
        var x$0 = caml_int64_of_float(x);
        return caml_int64_mul(x$0, _c_);
    }
    function of_float(t) {
        if (float_lower_bound <= t && t <= float_upper_bound) {
            var x = caml_int64_of_float(t);
            return caml_int64_mul(x, _c_);
        }
        var _v_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _h_, _v_, 0);
    }
    var _i_ = caml_call1(Base_Comparable[14], [
        0,
        compare$0,
        sexp_of_t$0,
        zero
    ]), is_positive = _i_[1], is_non_negative = _i_[2], is_negative = _i_[3], is_non_positive = _i_[4], sign = _i_[5], _j_ = [
        0,
        cst_src_int63_emul_ml,
        334,
        2
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function between(t, low, high) {
        var _t_ = caml_lessequal(low, t), _u_ = _t_ ? caml_lessequal(t, high) : _t_;
        return _u_;
    }
    function clamp_unchecked(t, min$0, max$0) {
        var _s_ = caml_call2(min, t, max$0);
        return caml_call1(caml_call1(max, min$0), _s_);
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _p_ = [
            0,
            [
                0,
                cst_max,
                sexp_of_t$0(max)
            ],
            0
        ], _q_ = [
            0,
            [
                0,
                cst_min,
                sexp_of_t$0(min)
            ],
            _p_
        ], _r_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _q_);
        return caml_call1(Base_Or_error[39], _r_);
    }
    function symbol$4(b, e) {
        return pow(b, e);
    }
    function incr(r) {
        var x = r[1];
        r[1] = caml_int64_add(x, one$0);
        return 0;
    }
    function decr(r) {
        var x = r[1];
        r[1] = caml_int64_sub(x, one$0);
        return 0;
    }
    function of_int(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[4], x));
    }
    function of_int_exn(x) {
        return of_int(x);
    }
    function to_int(x) {
        return caml_call1(Base_Int_conversions[12], caml_int64_shift_right(x, 1));
    }
    function to_int_exn(x) {
        return caml_call1(Base_Int_conversions[13], caml_int64_shift_right(x, 1));
    }
    function to_int_trunc(x) {
        return caml_call1(Base_Int_conversions[14], caml_int64_shift_right(x, 1));
    }
    function of_int32(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[9], x));
    }
    function of_int32_exn(x) {
        return of_int32(x);
    }
    function to_int32(x) {
        return caml_call1(Base_Int_conversions[15], caml_int64_shift_right(x, 1));
    }
    function to_int32_exn(x) {
        return caml_call1(Base_Int_conversions[16], caml_int64_shift_right(x, 1));
    }
    function to_int32_trunc(x) {
        return caml_call1(Base_Int_conversions[17], caml_int64_shift_right(x, 1));
    }
    function of_nativeint(x) {
        return of_int64(caml_call1(Base_Int_conversions[29], x));
    }
    function of_nativeint_exn(x) {
        return wrap_exn(caml_call1(Base_Int_conversions[29], x));
    }
    function of_nativeint_trunc(x) {
        var t = caml_call1(Base_Int_conversions[29], x);
        return caml_int64_mul(t, _c_);
    }
    function to_nativeint(x) {
        return caml_call1(Base_Int_conversions[18], caml_int64_shift_right(x, 1));
    }
    function to_nativeint_exn(x) {
        return caml_call1(Base_Int_conversions[19], caml_int64_shift_right(x, 1));
    }
    function to_nativeint_trunc(x) {
        return caml_call1(Base_Int_conversions[20], caml_int64_shift_right(x, 1));
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$1 = include$1[2];
    function compare$1(a, b) {
        return caml_call2(compare_local, a, b);
    }
    function hash$0(x) {
        return hash(x);
    }
    var symbol$5 = caml_lessthan, _k_ = [
        0,
        [
            7,
            6,
            0,
            0,
            0
        ],
        "%Lx"
    ], cst_0x = "0x";
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _k_, caml_int64_shift_right_unsigne(i, 1));
    }
    function of_string$0(s) {
        return of_string(caml_call2(Base_Import[112], cst_0x, s));
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare$1,
        compare_local$0,
        hash_fold_t,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$5,
        symbol$1,
        module_name
    ]), Hex = include$2[1];
    function to_string$1(x) {
        return to_string(x);
    }
    var pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string$1
    ])[1], symbol$6 = caml_notequal, symbol$7 = caml_lessthan, symbol$8 = caml_greaterthan, symbol$9 = caml_equal, symbol$10 = caml_lessequal, symbol$11 = caml_greaterequal, include$3 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol,
        symbol$0,
        symbol$2,
        symbol$3,
        symbol$1,
        symbol$11,
        symbol$10,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        abs,
        symbol$1,
        zero,
        of_int_exn,
        rem
    ]), symbol$12 = include$3[1], symbol$13 = include$3[2], symbol$14 = include$3[3], round = include$3[4], round_towards_zero = include$3[5], round_down = include$3[6], round_up = include$3[7], round_nearest = include$3[8];
    function compare$2(a, b) {
        return caml_call2(compare_local, a, b);
    }
    function equal(a, b) {
        return caml_equal(a, b);
    }
    function hash$1(x) {
        return hash(x);
    }
    var include$4 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$2,
        compare_local$0,
        equal,
        equal_local,
        hash_fold_t,
        hash$1,
        clz,
        shift_right_logical,
        bit_and,
        to_int_exn,
        num_bits,
        one$0,
        zero
    ]), Binary = include$4[1], Repr = [
        0
    ], include$5 = Base_Import[103], ascending = include$5[1], descending = include$5[2], max$0 = include$5[3], min$0 = include$5[4], Base_Int63_emul = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$1,
        of_string,
        to_string,
        caml_greaterequal,
        caml_lessequal,
        caml_equal,
        caml_greaterthan,
        caml_lessthan,
        caml_notequal,
        caml_equal,
        function(_o_, _n_) {
            return caml_int64_compare(_o_, _n_);
        },
        min$0,
        max$0,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        function(_m_, _l_) {
            return caml_int64_compare(_m_, _l_);
        },
        caml_equal,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one$0,
        minus_one,
        symbol,
        symbol$0,
        symbol$2,
        symbol$4,
        symbol$1,
        symbol$1,
        symbol$13,
        symbol$12,
        symbol$3,
        rem,
        symbol$14,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        clz,
        ctz,
        [
            0,
            symbol,
            symbol$0,
            symbol$2,
            symbol$3,
            symbol$1,
            symbol$4,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs,
            symbol$1,
            zero,
            symbol$12,
            symbol$13,
            symbol$14,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int,
        to_int,
        to_int_trunc,
        of_int32,
        to_int32,
        to_int32_trunc,
        of_int64,
        of_int64_trunc,
        of_nativeint,
        to_nativeint,
        of_nativeint_trunc,
        to_nativeint_trunc,
        bswap16,
        bswap32,
        bswap48,
        [
            0,
            wrap_exn,
            unwrap
        ],
        Repr,
        1
    ];
    runtime.caml_register_global(34, Base_Int63_emul, "Base__Int63_emul");
    return;
})(globalThis);
//# 37328 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$1 = "", cst_lx = "%lx", cst_argument_must_be_strictly_ = "argument must be strictly positive", caml_equal = runtime.caml_equal, caml_greaterequal = runtime.caml_greaterequal, caml_greaterthan = runtime.caml_greaterthan, caml_int32_bswap = runtime.caml_int32_bswap, caml_lessequal = runtime.caml_lessequal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$0 = cst$1, cst = cst$1, module_name = "Base.Int32.Hex", module_name$0 = "Base.Int32", Stdlib_Scanf = global_data.Stdlib__Scanf, Base_Printf = global_data.Base__Printf, Stdlib_Int32 = global_data.Stdlib__Int32, Base_Import = global_data.Base__Import, Base_Sexp = global_data.Base__Sexp, Base_Int_math = global_data.Base__Int_math, Base_Or_error = global_data.Base__Or_error, Assert_failure = global_data.Assert_failure, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Comparable = global_data.Base__Comparable, Base_Popcount = global_data.Base__Popcount, Base_Int_conversions = global_data.Base__Int_conversions, Base_Error = global_data.Base__Error, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Pretty_printer = global_data.Base__Pretty_printer, globalize = Base_Import[285], hash_fold_t = Base_Import[204], func = Base_Import[218];
    function hash(x) {
        return caml_call1(func, x);
    }
    var t_of_sexp = Base_Import[165], sexp_of_t = Base_Import[141], t_sexp_grammar = Base_Import[187], hashable = [
        0,
        hash,
        Stdlib_Int32[15],
        sexp_of_t
    ];
    function ascending(x, y) {
        return caml_call2(Stdlib_Int32[15], x, y);
    }
    var to_string = Stdlib_Int32[14], of_string = runtime.caml_int_of_string, of_string_opt = Stdlib_Int32[13], include = caml_call1(Base_Comparator[7], [
        0,
        ascending,
        sexp_of_t
    ]), comparator = include[1], num_bits = 32, float_lower_bound = caml_call1(Base_Float0[26], num_bits), float_upper_bound = caml_call1(Base_Float0[24], num_bits), float_of_bits = runtime.caml_int32_float_of_bits, bits_of_float = runtime.caml_int32_bits_of_float;
    function shift_right_logical(_T_1, _S_) {
        return _T_1 >>> _S_ | 0;
    }
    function shift_right(_R_, _Q_) {
        return _R_ >> _Q_;
    }
    function shift_left(_P_, _O_) {
        return _P_ << _O_;
    }
    var bit_not = Stdlib_Int32[11];
    function bit_xor(_N_, _M_) {
        return _N_ ^ _M_;
    }
    function bit_or(_L_, _K_) {
        return _L_ | _K_;
    }
    function bit_and(_J_, _I_) {
        return _J_ & _I_;
    }
    var min_value = Stdlib_Int32[10], max_value = Stdlib_Int32[9], abs = Stdlib_Int32[8], pred = Stdlib_Int32[7], succ = Stdlib_Int32[6], rem = runtime.caml_mod;
    function symbol(_H_) {
        return -_H_ | 0;
    }
    var minus_one = Stdlib_Int32[3], one = Stdlib_Int32[2], zero = Stdlib_Int32[1], compare_local = runtime.caml_compare, _a_ = [
        0,
        [
            11,
            "Int32.of_float: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Int32.of_float: argument (%f) is out of range or NaN"
    ];
    function to_float(_G_) {
        return _G_;
    }
    function of_float_unchecked(_F_) {
        return _F_ | 0;
    }
    function of_float(f) {
        if (float_lower_bound <= f && f <= float_upper_bound) return f | 0;
        var _E_ = caml_call1(Base_Float0[29], f);
        return caml_call3(Base_Printf[7], _a_, _E_, 0);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        ascending,
        sexp_of_t,
        zero
    ]), is_positive = include$0[1], is_non_negative = include$0[2], is_negative = include$0[3], is_non_positive = include$0[4], sign = include$0[5], symbol$0 = caml_greaterequal, symbol$1 = caml_lessequal, symbol$2 = caml_equal, symbol$3 = caml_greaterthan, symbol$4 = runtime.caml_lessthan, symbol$5 = runtime.caml_notequal;
    function descending(x, y) {
        return ascending(y, x);
    }
    function min(x, y) {
        return runtime.caml_csel_value(caml_lessequal(x, y), x, y);
    }
    function max(x, y) {
        return runtime.caml_csel_value(caml_greaterequal(x, y), x, y);
    }
    function equal(x, y) {
        return caml_equal(x, y);
    }
    var equal_local = caml_equal, _b_ = [
        0,
        "src/int32.ml",
        103,
        4
    ], cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]";
    function between(t, low, high) {
        var _D_ = caml_lessequal(low, t);
        return _D_ ? caml_lessequal(t, high) : _D_;
    }
    function clamp_unchecked(t, min$0, max$0) {
        return max(min$0, min(t, max$0));
    }
    function clamp_exn(t, min, max) {
        if (caml_lessequal(min, max)) return clamp_unchecked(t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _b_
        ], 1);
    }
    function clamp(t, min, max) {
        if (!caml_greaterthan(min, max)) return [
            0,
            clamp_unchecked(t, min, max)
        ];
        var _A_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _B_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _A_
        ], _C_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _B_);
        return caml_call1(Base_Or_error[39], _C_);
    }
    function invariant(param) {
        return 0;
    }
    var symbol$6 = runtime.caml_div, symbol$7 = runtime.caml_mul;
    function symbol$8(_z_, _y_) {
        return _z_ - _y_ | 0;
    }
    function symbol$9(_x_, _w_) {
        return _x_ + _w_ | 0;
    }
    function incr(r) {
        r[1] = r[1] + one | 0;
        return 0;
    }
    function decr(r) {
        r[1] = r[1] - one | 0;
        return 0;
    }
    function of_int32(t) {
        return t;
    }
    function to_int32(t) {
        return t;
    }
    var popcount = Base_Popcount[2], of_int = Base_Int_conversions[1], of_int_exn = Base_Int_conversions[2], of_int_trunc = Base_Int_conversions[3], to_int = Base_Int_conversions[6], to_int_exn = Base_Int_conversions[7], to_int_trunc = Base_Int_conversions[8], of_int64 = Base_Int_conversions[15], of_int64_exn = Base_Int_conversions[16], of_int64_trunc = Base_Int_conversions[17], to_int64 = Base_Int_conversions[9], of_nativeint = Base_Int_conversions[26], of_nativeint_exn = Base_Int_conversions[27], of_nativeint_trunc = Base_Int_conversions[28], to_nativeint = Base_Int_conversions[10];
    function pow(b, e) {
        var _u_ = caml_call1(to_int_exn, e), _v_ = caml_call1(to_int_exn, b);
        return caml_call1(of_int_exn, caml_call2(Base_Int_math[2][1], _v_, _u_));
    }
    function symbol$10(b, e) {
        return pow(b, e);
    }
    function bswap16(x) {
        return caml_int32_bswap(x) >>> 16 | 0;
    }
    var raise_s = Base_Error[32], _c_ = [
        0,
        [
            11,
            cst_argument_must_be_strictly_,
            0
        ],
        cst_argument_must_be_strictly_
    ], cst_Int32_floor_log2_got_inval = "[Int32.floor_log2] got invalid input", cst_Int32_ceil_log2_got_invali = "[Int32.ceil_log2] got invalid input";
    function non_positive_argument(param) {
        return caml_call2(Base_Printf[7], _c_, 0);
    }
    function lsr(_t_, _s_) {
        return _t_ >>> _s_ | 0;
    }
    function land(_r_, _q_) {
        return _r_ & _q_;
    }
    function ceil_pow2(x) {
        if (caml_call2(Base_Import[102][2], x, Stdlib_Int32[1])) non_positive_argument(0);
        var x$0 = caml_call1(Stdlib_Int32[7], x), x$5 = x$0 | x$0 >>> 1 | 0, x$4 = x$5 | x$5 >>> 2 | 0, x$3 = x$4 | x$4 >>> 4 | 0, x$2 = x$3 | x$3 >>> 8 | 0, x$1 = x$2 | x$2 >>> 16 | 0;
        return caml_call1(Stdlib_Int32[6], x$1);
    }
    function floor_pow2(x$0) {
        if (caml_call2(Base_Import[102][2], x$0, Stdlib_Int32[1])) non_positive_argument(0);
        var x = x$0 | x$0 >>> 1 | 0, x$4 = x | x >>> 2 | 0, x$3 = x$4 | x$4 >>> 4 | 0, x$2 = x$3 | x$3 >>> 8 | 0, x$1 = x$2 | x$2 >>> 16 | 0;
        return x$1 - (x$1 >>> 1 | 0) | 0;
    }
    function is_pow2(x) {
        if (caml_call2(Base_Import[102][2], x, Stdlib_Int32[1])) non_positive_argument(0);
        var _o_ = Stdlib_Int32[1], _p_ = x & caml_call1(Stdlib_Int32[7], x);
        return caml_call2(Base_Import[102][4], _p_, _o_);
    }
    function floor_log2(i) {
        if (caml_call2(Base_Import[102][2], i, Stdlib_Int32[1])) {
            var _l_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(Base_Import[141], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int32_floor_log2_got_inval, _l_));
        }
        var _m_ = runtime.Base_int_math_int32_clz(i), _n_ = caml_call2(Base_Import[93], num_bits, 1);
        return caml_call2(Base_Import[93], _n_, _m_);
    }
    function ceil_log2(i) {
        if (caml_call2(Base_Import[102][2], i, Stdlib_Int32[1])) {
            var _j_ = [
                0,
                [
                    0,
                    cst$0,
                    caml_call1(Base_Import[141], i)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int32_ceil_log2_got_invali, _j_));
        }
        if (caml_call2(Stdlib_Int32[17], i, Stdlib_Int32[2])) return 0;
        var _k_ = runtime.Base_int_math_int32_clz(caml_call1(Stdlib_Int32[7], i));
        return caml_call2(Base_Import[93], num_bits, _k_);
    }
    var include$1 = caml_call1(Base_Int_string_conversions[1], [
        0,
        to_string
    ]), to_string_hum = include$1[1], sexp_of_t$0 = include$1[2], compare_local$0 = Base_Import[257];
    function compare(a, b) {
        return caml_call2(compare_local$0, a, b);
    }
    var hash_fold_t$0 = Base_Import[204], func$0 = Base_Import[218], _d_ = [
        0,
        [
            5,
            6,
            0,
            0,
            0
        ],
        cst_lx
    ], _e_ = [
        0,
        [
            5,
            6,
            0,
            0,
            0
        ],
        cst_lx
    ];
    function hash$0(x) {
        return caml_call1(func$0, x);
    }
    function to_string$0(i) {
        return caml_call2(Base_Printf[2], _d_, i);
    }
    function of_string$0(s) {
        return caml_call3(Stdlib_Scanf[5], s, _e_, function(_i_) {
            return _i_;
        });
    }
    var include$2 = caml_call1(Base_Int_string_conversions[2], [
        0,
        compare,
        compare_local$0,
        hash_fold_t$0,
        hash$0,
        to_string$0,
        of_string$0,
        zero,
        symbol$4,
        symbol,
        module_name
    ]), Hex = include$2[1], compare_local$1 = Base_Import[257];
    function compare$0(a, b) {
        return caml_call2(compare_local$1, a, b);
    }
    var equal_local$0 = Base_Import[271];
    function equal$0(a, b) {
        return caml_call2(equal_local$0, a, b);
    }
    var hash_fold_t$1 = Base_Import[204], func$1 = Base_Import[218];
    function hash$1(x) {
        return caml_call1(func$1, x);
    }
    function clz(_h_) {
        return runtime.Base_int_math_int32_clz(_h_);
    }
    var include$3 = caml_call1(Base_Int_string_conversions[3], [
        0,
        compare$0,
        compare_local$1,
        equal$0,
        equal_local$0,
        hash_fold_t$1,
        hash$1,
        clz,
        lsr,
        land,
        to_int_exn,
        num_bits,
        one,
        zero
    ]), Binary = include$3[1], pp = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name$0,
        to_string
    ])[1], include$4 = caml_call1(Base_Int_math[1], [
        0,
        of_float,
        to_float,
        of_string,
        to_string,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$6,
        symbol,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        abs,
        symbol,
        zero,
        of_int_exn,
        rem
    ]), symbol$11 = include$4[1], symbol$12 = include$4[2], symbol$13 = include$4[3], round = include$4[4], round_towards_zero = include$4[5], round_down = include$4[6], round_up = include$4[7], round_nearest = include$4[8], Base_Int32 = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$0,
        of_string,
        to_string,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        equal,
        ascending,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local,
        equal_local,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one,
        minus_one,
        symbol$9,
        symbol$8,
        symbol$7,
        symbol$10,
        symbol,
        symbol,
        symbol$12,
        symbol$11,
        symbol$6,
        rem,
        symbol$13,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        shift_left,
        shift_right,
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32,
        to_int32,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint,
        of_float_unchecked,
        num_bits,
        max_value,
        min_value,
        shift_right_logical,
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        floor_log2,
        is_pow2,
        function(_g_) {
            return runtime.Base_int_math_int32_clz(_g_);
        },
        function(_f_) {
            return runtime.Base_int_math_int32_ctz(_f_);
        },
        [
            0,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            symbol,
            symbol$10,
            symbol$0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$5,
            abs,
            symbol,
            zero,
            symbol$11,
            symbol$12,
            symbol$13,
            bit_and,
            bit_or,
            bit_xor,
            bit_not,
            shift_left,
            shift_right,
            shift_right_logical
        ],
        of_int,
        to_int,
        of_int32,
        to_int32,
        of_nativeint,
        to_nativeint,
        of_int64,
        of_int_trunc,
        to_int_trunc,
        of_nativeint_trunc,
        of_int64_trunc,
        bits_of_float,
        float_of_bits,
        bswap16,
        caml_int32_bswap
    ];
    runtime.caml_register_global(30, Base_Int32, "Base__Int32");
    return;
})(globalThis);
//# 37814 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_product$1 = "product", cst_t$3 = "t", cst_u$3 = "u", caml_div = runtime.caml_div, caml_int64_of_int32 = runtime.caml_int64_of_int32, caml_int64_to_int32 = runtime.caml_int64_to_int32, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_mul = runtime.caml_mul;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst = "", Base_Word_size = global_data.Base__Word_size, Base_Int = global_data.Base__Int, Base_Sexp = global_data.Base__Sexp, Base_Random = global_data.Base__Random, Base_Import = global_data.Base__Import, Base_Bool = global_data.Base__Bool, Base_Int64 = global_data.Base__Int64, Base_Error = global_data.Base__Error, Base_Int63_emul = global_data.Base__Int63_emul, Base_Sys0 = global_data.Base__Sys0, Assert_failure = global_data.Assert_failure, raise_s = Base_Error[32], include = caml_call1(caml_call1(Base_Sys0[19], [
        0
    ]), [
        0
    ]), t_sexp_grammar = Base_Int[2], of_float = Base_Int[3], to_float = Base_Int[4], of_int_exn = Base_Int[5], to_int_exn = Base_Int[6], hash_fold_t = Base_Int[7], hash = Base_Int[8], t_of_sexp = Base_Int[9], sexp_of_t = Base_Int[10], of_string = Base_Int[11], to_string = Base_Int[12], equal = Base_Int[13], compare = Base_Int[14], min = Base_Int[15], max = Base_Int[16], ascending = Base_Int[17], descending = Base_Int[18], between = Base_Int[19], clamp_exn = Base_Int[20], clamp = Base_Int[21], comparator = Base_Int[22], pp = Base_Int[23], hashable = Base_Int[24], is_positive = Base_Int[25], is_non_negative = Base_Int[26], is_negative = Base_Int[27], is_non_positive = Base_Int[28], sign = Base_Int[29], compare_local = Base_Int[30], equal_local = Base_Int[31], invariant = Base_Int[32], Hex = Base_Int[33], Binary = Base_Int[34], of_string_opt = Base_Int[35], to_string_hum = Base_Int[36], one = Base_Int[37], minus_one = Base_Int[38], rem = Base_Int[39], round = Base_Int[40], round_towards_zero = Base_Int[41], round_down = Base_Int[42], round_up = Base_Int[43], round_nearest = Base_Int[44], succ = Base_Int[45], pred = Base_Int[46], pow = Base_Int[47], bit_and = Base_Int[48], bit_or = Base_Int[49], bit_xor = Base_Int[50], bit_not = Base_Int[51], popcount = Base_Int[52], shift_left = Base_Int[53], shift_right = Base_Int[54], decr = Base_Int[55], incr = Base_Int[56], of_int32_exn = Base_Int[57], to_int32_exn = Base_Int[58], of_int64_exn = Base_Int[59], to_int64 = Base_Int[60], of_nativeint_exn = Base_Int[61], to_nativeint_exn = Base_Int[62], of_float_unchecked = Base_Int[63], num_bits = Base_Int[64], max_value = Base_Int[65], min_value = Base_Int[66], shift_right_logical = Base_Int[67], ceil_pow2 = Base_Int[68], floor_pow2 = Base_Int[69], ceil_log2 = Base_Int[70], is_pow2 = Base_Int[72], clz = Base_Int[73], ctz = Base_Int[74], O = Base_Int[75], symbol = Base_Int[76], lnot = Base_Int[77], abs = Base_Int[78], zero = Base_Int[79], symbol$0 = Base_Int[80], symbol$1 = Base_Int[81], symbol$2 = Base_Int[82], of_int = Base_Int[84], to_int32 = Base_Int[87], of_int64 = Base_Int[88], of_nativeint = Base_Int[89], _a_ = Base_Int[90];
    function to_int(x) {
        return [
            0,
            x
        ];
    }
    function to_int_trunc(x) {
        return x;
    }
    function to_nativeint_trunc(x) {
        return caml_call1(_a_, x);
    }
    function to_nativeint(x) {
        return [
            0,
            caml_call1(_a_, x)
        ];
    }
    function bswap32(t) {
        return caml_int64_to_int32(caml_call1(Base_Int64[87], caml_int64_of_int32(t)));
    }
    function bswap48(t) {
        return caml_int64_to_int32(caml_call1(Base_Int64[88], caml_int64_of_int32(t)));
    }
    var cst_Int_floor_log2_got_invalid = "[Int.floor_log2] got invalid input", cst_neg_overflow = "neg overflow", cst_abs_overflow = "abs overflow", cst_product$0 = cst_product$1, cst_u$2 = cst_u$3, cst_t$2 = cst_t$3, cst_overflow$2 = "( / ) overflow", cst_product = cst_product$1, cst_u$1 = cst_u$3, cst_t$1 = cst_t$3, cst_overflow$1 = "( * ) overflow", cst_diff = "diff", cst_u$0 = cst_u$3, cst_t$0 = cst_t$3, cst_overflow$0 = "( - ) overflow", cst_sum = "sum", cst_u = cst_u$3, cst_t = cst_t$3, cst_overflow = "( + ) overflow", _b_ = [
        0,
        "src/int63.ml",
        110,
        9
    ], repr = 0, include$0 = include[1] ? [
        0,
        Base_Int63_emul[2],
        Base_Int63_emul[3],
        Base_Int63_emul[4],
        Base_Int63_emul[5],
        Base_Int63_emul[6],
        Base_Int63_emul[7],
        Base_Int63_emul[8],
        Base_Int63_emul[9],
        Base_Int63_emul[10],
        Base_Int63_emul[11],
        Base_Int63_emul[12],
        Base_Int63_emul[13],
        Base_Int63_emul[14],
        Base_Int63_emul[15],
        Base_Int63_emul[16],
        Base_Int63_emul[17],
        Base_Int63_emul[18],
        Base_Int63_emul[19],
        Base_Int63_emul[20],
        Base_Int63_emul[21],
        Base_Int63_emul[22],
        Base_Int63_emul[23],
        Base_Int63_emul[24],
        Base_Int63_emul[25],
        Base_Int63_emul[26],
        Base_Int63_emul[27],
        Base_Int63_emul[28],
        Base_Int63_emul[29],
        Base_Int63_emul[30],
        Base_Int63_emul[31],
        Base_Int63_emul[32],
        Base_Int63_emul[33],
        Base_Int63_emul[34],
        Base_Int63_emul[35],
        Base_Int63_emul[36],
        Base_Int63_emul[37],
        Base_Int63_emul[38],
        Base_Int63_emul[39],
        Base_Int63_emul[40],
        Base_Int63_emul[41],
        Base_Int63_emul[42],
        Base_Int63_emul[43],
        Base_Int63_emul[44],
        Base_Int63_emul[45],
        Base_Int63_emul[46],
        Base_Int63_emul[47],
        Base_Int63_emul[48],
        Base_Int63_emul[49],
        Base_Int63_emul[50],
        Base_Int63_emul[51],
        Base_Int63_emul[52],
        Base_Int63_emul[53],
        Base_Int63_emul[54],
        Base_Int63_emul[55],
        Base_Int63_emul[56],
        Base_Int63_emul[57],
        Base_Int63_emul[58],
        Base_Int63_emul[59],
        Base_Int63_emul[60],
        Base_Int63_emul[61],
        Base_Int63_emul[62],
        Base_Int63_emul[63],
        Base_Int63_emul[64],
        Base_Int63_emul[65],
        Base_Int63_emul[66],
        Base_Int63_emul[67],
        Base_Int63_emul[68],
        Base_Int63_emul[69],
        Base_Int63_emul[70],
        Base_Int63_emul[71],
        Base_Int63_emul[72],
        Base_Int63_emul[73],
        Base_Int63_emul[74],
        Base_Int63_emul[75],
        Base_Int63_emul[76],
        Base_Int63_emul[77],
        Base_Int63_emul[78],
        Base_Int63_emul[79],
        Base_Int63_emul[80],
        Base_Int63_emul[81],
        Base_Int63_emul[82],
        Base_Int63_emul[83],
        Base_Int63_emul[84],
        Base_Int63_emul[85],
        Base_Int63_emul[86],
        Base_Int63_emul[88],
        Base_Int63_emul[89],
        Base_Int63_emul[90],
        Base_Int63_emul[91],
        Base_Int63_emul[92],
        Base_Int63_emul[93],
        Base_Int63_emul[94],
        Base_Int63_emul[95],
        ,
        Base_Int63_emul[97],
        Base_Int63_emul[98],
        Base_Int63_emul[99],
        Base_Int63_emul[100],
        Base_Int63_emul[101],
        Base_Int63_emul[102],
        Base_Int63_emul[103],
        Base_Int63_emul[104],
        Base_Int63_emul[105],
        Base_Int63_emul[106],
        Base_Int63_emul[107],
        Base_Int63_emul[108],
        Base_Int63_emul[109],
        Base_Int63_emul[110],
        Base_Int63_emul[111],
        Base_Int63_emul[112],
        Base_Int63_emul[87],
        Base_Int63_emul[118],
        Base_Int63_emul[113],
        Base_Int63_emul[114],
        Base_Int63_emul[115]
    ] : [
        0,
        t_sexp_grammar,
        of_float,
        to_float,
        of_int_exn,
        to_int_exn,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        of_string,
        to_string,
        function(_aG_, _aF_) {
            return _aF_ <= _aG_ ? 1 : 0;
        },
        function(_aE_, _aD_) {
            return _aE_ <= _aD_ ? 1 : 0;
        },
        function(_aC_, _aB_) {
            return _aC_ === _aB_ ? 1 : 0;
        },
        function(_aA_, _az_) {
            return _az_ < _aA_ ? 1 : 0;
        },
        function(_ay_, _ax_) {
            return _ay_ < _ax_ ? 1 : 0;
        },
        function(_aw_, _av_) {
            return _aw_ !== _av_ ? 1 : 0;
        },
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        sign,
        compare_local,
        equal_local,
        invariant,
        Hex,
        Binary,
        of_string_opt,
        to_string_hum,
        zero,
        one,
        minus_one,
        function(_au_, _at_) {
            return _au_ + _at_ | 0;
        },
        function(_as_, _ar_) {
            return _as_ - _ar_ | 0;
        },
        caml_mul,
        symbol,
        function(_aq_) {
            return -_aq_ | 0;
        },
        function(_ap_) {
            return -_ap_ | 0;
        },
        symbol$1,
        symbol$0,
        caml_div,
        rem,
        symbol$2,
        function(_ao_, _an_) {
            return _ao_ & _an_;
        },
        function(_am_, _al_) {
            return _am_ | _al_;
        },
        function(_ak_, _aj_) {
            return _ak_ ^ _aj_;
        },
        lnot,
        function(_ai_, _ah_) {
            return _ai_ << _ah_;
        },
        function(_ag_, _af_) {
            return _ag_ >> _af_;
        },
        round,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        abs,
        succ,
        pred,
        pow,
        bit_and,
        bit_or,
        bit_xor,
        bit_not,
        popcount,
        shift_left,
        shift_right,
        decr,
        incr,
        of_int32_exn,
        to_int32_exn,
        of_int64_exn,
        to_int64,
        of_nativeint_exn,
        to_nativeint_exn,
        num_bits,
        max_value,
        min_value,
        function(_ae_, _ad_) {
            return _ae_ >>> _ad_ | 0;
        },
        shift_right_logical,
        ceil_pow2,
        floor_pow2,
        ceil_log2,
        ,
        is_pow2,
        clz,
        ctz,
        [
            0,
            function(_ac_, _ab_) {
                return _ac_ + _ab_ | 0;
            },
            function(_aa_, _$_) {
                return _aa_ - _$_ | 0;
            },
            caml_mul,
            caml_div,
            function(___) {
                return -___ | 0;
            },
            O[1],
            function(_Z_, _Y_) {
                return _Y_ <= _Z_ ? 1 : 0;
            },
            function(_X_, _W_) {
                return _X_ <= _W_ ? 1 : 0;
            },
            function(_V_, _U_) {
                return _V_ === _U_ ? 1 : 0;
            },
            function(_T_1, _S_) {
                return _S_ < _T_1 ? 1 : 0;
            },
            function(_R_, _Q_) {
                return _R_ < _Q_ ? 1 : 0;
            },
            function(_P_, _O_) {
                return _P_ !== _O_ ? 1 : 0;
            },
            O[3],
            function(_N_) {
                return -_N_ | 0;
            },
            O[4],
            O[5],
            O[6],
            O[7],
            function(_M_, _L_) {
                return _M_ & _L_;
            },
            function(_K_, _J_) {
                return _K_ | _J_;
            },
            function(_I_, _H_) {
                return _I_ ^ _H_;
            },
            O[2],
            function(_G_, _F_) {
                return _G_ << _F_;
            },
            function(_E_, _D_) {
                return _E_ >> _D_;
            },
            function(_C_, _B_) {
                return _C_ >>> _B_ | 0;
            }
        ],
        of_int,
        to_int,
        to_int_trunc,
        of_int32_exn,
        to_int32,
        function(_A_) {
            return _A_;
        },
        of_int64,
        caml_int64_to_int32,
        of_nativeint,
        to_nativeint,
        function(_z_) {
            return _z_;
        },
        to_nativeint_trunc,
        of_float_unchecked,
        repr,
        runtime.caml_bswap16,
        bswap32,
        bswap48
    ], t_sexp_grammar$0 = include$0[1], of_float$0 = include$0[2], to_float$0 = include$0[3], of_int_exn$0 = include$0[4], to_int_exn$0 = include$0[5], hash_fold_t$0 = include$0[6], hash$0 = include$0[7], t_of_sexp$0 = include$0[8], sexp_of_t$0 = include$0[9], of_string$0 = include$0[10], to_string$0 = include$0[11], symbol$3 = include$0[12], symbol$4 = include$0[13], symbol$5 = include$0[14], symbol$6 = include$0[15], symbol$7 = include$0[16], symbol$8 = include$0[17], equal$0 = include$0[18], compare$0 = include$0[19], min$0 = include$0[20], max$0 = include$0[21], ascending$0 = include$0[22], descending$0 = include$0[23], between$0 = include$0[24], clamp_exn$0 = include$0[25], clamp$0 = include$0[26], comparator$0 = include$0[27], pp$0 = include$0[28], hashable$0 = include$0[29], is_positive$0 = include$0[30], is_non_negative$0 = include$0[31], is_negative$0 = include$0[32], is_non_positive$0 = include$0[33], sign$0 = include$0[34], compare_local$0 = include$0[35], equal_local$0 = include$0[36], invariant$0 = include$0[37], Hex$0 = include$0[38], Binary$0 = include$0[39], of_string_opt$0 = include$0[40], to_string_hum$0 = include$0[41], zero$0 = include$0[42], one$0 = include$0[43], minus_one$0 = include$0[44], symbol$9 = include$0[45], symbol$10 = include$0[46], symbol$11 = include$0[47], symbol$12 = include$0[48], neg = include$0[49], symbol$13 = include$0[50], symbol$14 = include$0[51], symbol$15 = include$0[52], symbol$16 = include$0[53], rem$0 = include$0[54], symbol$17 = include$0[55], land = include$0[56], lor = include$0[57], lxor = include$0[58], lnot$0 = include$0[59], lsl = include$0[60], asr = include$0[61], round$0 = include$0[62], round_towards_zero$0 = include$0[63], round_down$0 = include$0[64], round_up$0 = include$0[65], round_nearest$0 = include$0[66], abs$0 = include$0[67], succ$0 = include$0[68], pred$0 = include$0[69], pow$0 = include$0[70], bit_and$0 = include$0[71], bit_or$0 = include$0[72], bit_xor$0 = include$0[73], bit_not$0 = include$0[74], popcount$0 = include$0[75], shift_left$0 = include$0[76], shift_right$0 = include$0[77], decr$0 = include$0[78], incr$0 = include$0[79], of_int32_exn$0 = include$0[80], to_int32_exn$0 = include$0[81], of_int64_exn$0 = include$0[82], to_int64$0 = include$0[83], of_nativeint_exn$0 = include$0[84], to_nativeint_exn$0 = include$0[85], num_bits$0 = include$0[86], max_value$0 = include$0[87], min_value$0 = include$0[88], lsr = include$0[89], shift_right_logical$0 = include$0[90], ceil_pow2$0 = include$0[91], floor_pow2$0 = include$0[92], ceil_log2$0 = include$0[93], is_pow2$0 = include$0[95], clz$0 = include$0[96], ctz$0 = include$0[97], O$0 = include$0[98], of_int$0 = include$0[99], to_int$0 = include$0[100], to_int_trunc$0 = include$0[101], of_int32 = include$0[102], to_int32$0 = include$0[103], to_int32_trunc = include$0[104], of_int64$0 = include$0[105], of_int64_trunc = include$0[106], of_nativeint$0 = include$0[107], to_nativeint$0 = include$0[108], of_nativeint_trunc = include$0[109], to_nativeint_trunc$0 = include$0[110], of_float_unchecked$0 = include$0[111], repr$0 = include$0[112], bswap16 = include$0[113], bswap32$0 = include$0[114], bswap48$0 = include$0[115];
    function symbol$18(t, u) {
        var sum = caml_call2(symbol$9, t, u), _v_ = caml_call2(bit_xor$0, t, caml_call1(bit_not$0, sum));
        if (caml_call2(symbol$7, caml_call2(bit_or$0, caml_call2(bit_xor$0, t, u), _v_), zero$0)) return sum;
        var _w_ = [
            0,
            [
                0,
                cst_sum,
                caml_call1(sexp_of_t$0, sum)
            ],
            0
        ], _x_ = [
            0,
            [
                0,
                cst_u,
                caml_call1(sexp_of_t$0, u)
            ],
            _w_
        ], _y_ = [
            0,
            [
                0,
                cst_t,
                caml_call1(sexp_of_t$0, t)
            ],
            _x_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow, _y_));
    }
    function symbol$19(t, u) {
        var diff = caml_call2(symbol$10, t, u), pos_diff = caml_call2(symbol$6, t, u);
        if (caml_call2(symbol$8, t, u)) {
            var _r_ = caml_call1(is_positive$0, diff);
            if (caml_call2(Base_Bool[15], pos_diff, _r_)) {
                var _s_ = [
                    0,
                    [
                        0,
                        cst_diff,
                        caml_call1(sexp_of_t$0, diff)
                    ],
                    0
                ], _t_ = [
                    0,
                    [
                        0,
                        cst_u$0,
                        caml_call1(sexp_of_t$0, u)
                    ],
                    _s_
                ], _u_ = [
                    0,
                    [
                        0,
                        cst_t$0,
                        caml_call1(sexp_of_t$0, t)
                    ],
                    _t_
                ];
                return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$0, _u_));
            }
        }
        return diff;
    }
    var negative_one = caml_call1(of_int$0, -1);
    function div_would_overflow(t, u) {
        var _q_ = caml_call2(symbol$5, t, min_value$0);
        return _q_ ? caml_call2(symbol$5, u, negative_one) : _q_;
    }
    function symbol$20(t, u) {
        var product = caml_call2(symbol$11, t, u);
        a: if (caml_call2(symbol$8, u, zero$0)) {
            if (!div_would_overflow(product, u) && !caml_call2(symbol$8, caml_call2(symbol$16, product, u), t)) break a;
            var _n_ = [
                0,
                [
                    0,
                    cst_product,
                    caml_call1(sexp_of_t$0, product)
                ],
                0
            ], _o_ = [
                0,
                [
                    0,
                    cst_u$1,
                    caml_call1(sexp_of_t$0, u)
                ],
                _n_
            ], _p_ = [
                0,
                [
                    0,
                    cst_t$1,
                    caml_call1(sexp_of_t$0, t)
                ],
                _o_
            ];
            return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$1, _p_));
        }
        return product;
    }
    function symbol$21(t, u) {
        if (!div_would_overflow(t, u)) return caml_call2(symbol$16, t, u);
        var _k_ = [
            0,
            [
                0,
                cst_product$0,
                caml_call1(sexp_of_t$0, caml_call2(symbol$16, t, u))
            ],
            0
        ], _l_ = [
            0,
            [
                0,
                cst_u$2,
                caml_call1(sexp_of_t$0, u)
            ],
            _k_
        ], _m_ = [
            0,
            [
                0,
                cst_t$2,
                caml_call1(sexp_of_t$0, t)
            ],
            _l_
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_overflow$2, _m_));
    }
    function abs$1(t) {
        return caml_call2(symbol$5, t, min_value$0) ? caml_call1(Base_Import[124], cst_abs_overflow) : caml_call1(abs$0, t);
    }
    function neg$0(t) {
        return caml_call2(symbol$5, t, min_value$0) ? caml_call1(Base_Import[124], cst_neg_overflow) : caml_call1(neg, t);
    }
    if (63 !== num_bits$0) throw caml_maybe_attach_backtrace([
        0,
        Assert_failure,
        _b_
    ], 1);
    function random_of_int(opt, bound) {
        var state = opt ? opt[1] : Base_Random[19][1], _j_ = caml_call1(to_int_exn$0, bound);
        return caml_call1(of_int$0, caml_call2(Base_Random[19][7], state, _j_));
    }
    function random_of_int64(opt, bound) {
        var state = opt ? opt[1] : Base_Random[19][1], _i_ = caml_call1(to_int64$0, bound);
        return caml_call1(of_int64_exn$0, caml_call2(Base_Random[19][10], state, _i_));
    }
    var random_of_int$0 = Base_Word_size[3] ? random_of_int : random_of_int64;
    function random_incl_of_int(opt, lo, hi) {
        var state = opt ? opt[1] : Base_Random[19][1], _g_ = caml_call1(to_int_exn$0, hi), _h_ = caml_call1(to_int_exn$0, lo);
        return caml_call1(of_int$0, caml_call3(Base_Random[19][12], state, _h_, _g_));
    }
    function random_incl_of_int64(opt, lo, hi) {
        var state = opt ? opt[1] : Base_Random[19][1], _e_ = caml_call1(to_int64$0, hi), _f_ = caml_call1(to_int64$0, lo);
        return caml_call1(of_int64_exn$0, caml_call3(Base_Random[19][15], state, _f_, _e_));
    }
    var random_incl = Base_Word_size[3] ? random_incl_of_int : random_incl_of_int64;
    function floor_log2(t) {
        if (Base_Word_size[3]) {
            var _c_ = caml_call1(to_int_exn$0, t);
            return caml_call1(Base_Int[71], _c_);
        }
        if (caml_call2(symbol$4, t, zero$0)) {
            var _d_ = [
                0,
                [
                    0,
                    cst,
                    caml_call1(sexp_of_t$0, t)
                ],
                0
            ];
            caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Int_floor_log2_got_invalid, _d_));
        }
        var floor_log2 = [
            0,
            num_bits$0 - 2 | 0
        ];
        for(;;){
            if (!caml_call2(equal$0, zero$0, caml_call2(bit_and$0, t, caml_call2(shift_left$0, one$0, floor_log2[1])))) return floor_log2[1];
            floor_log2[1] = floor_log2[1] - 1 | 0;
        }
    }
    var Base_Int63 = [
        0,
        t_sexp_grammar$0,
        of_float$0,
        to_float$0,
        of_int_exn$0,
        to_int_exn$0,
        hash_fold_t$0,
        hash$0,
        t_of_sexp$0,
        sexp_of_t$0,
        of_string$0,
        to_string$0,
        symbol$3,
        symbol$4,
        symbol$5,
        symbol$6,
        symbol$7,
        symbol$8,
        equal$0,
        compare$0,
        min$0,
        max$0,
        ascending$0,
        descending$0,
        between$0,
        clamp_exn$0,
        clamp$0,
        comparator$0,
        pp$0,
        hashable$0,
        is_positive$0,
        is_non_negative$0,
        is_negative$0,
        is_non_positive$0,
        sign$0,
        compare_local$0,
        equal_local$0,
        invariant$0,
        Hex$0,
        Binary$0,
        of_string_opt$0,
        to_string_hum$0,
        zero$0,
        one$0,
        minus_one$0,
        symbol$9,
        symbol$10,
        symbol$11,
        symbol$12,
        neg,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        rem$0,
        symbol$17,
        land,
        lor,
        lxor,
        lnot$0,
        lsl,
        asr,
        round$0,
        round_towards_zero$0,
        round_down$0,
        round_up$0,
        round_nearest$0,
        abs$0,
        succ$0,
        pred$0,
        pow$0,
        bit_and$0,
        bit_or$0,
        bit_xor$0,
        bit_not$0,
        popcount$0,
        shift_left$0,
        shift_right$0,
        decr$0,
        incr$0,
        of_int32_exn$0,
        to_int32_exn$0,
        of_int64_exn$0,
        to_int64$0,
        of_nativeint_exn$0,
        to_nativeint_exn$0,
        of_float_unchecked$0,
        num_bits$0,
        max_value$0,
        min_value$0,
        lsr,
        shift_right_logical$0,
        ceil_pow2$0,
        floor_pow2$0,
        ceil_log2$0,
        is_pow2$0,
        clz$0,
        ctz$0,
        O$0,
        [
            0,
            symbol$18,
            symbol$19,
            symbol$20,
            symbol$21,
            abs$1,
            neg$0
        ],
        of_int$0,
        to_int$0,
        of_int32,
        to_int32$0,
        of_int64$0,
        of_nativeint$0,
        to_nativeint$0,
        to_int_trunc$0,
        to_int32_trunc,
        of_int64_trunc,
        of_nativeint_trunc,
        to_nativeint_trunc$0,
        bswap16,
        bswap32$0,
        bswap48$0,
        random_of_int$0,
        random_incl,
        floor_log2,
        [
            0,
            Base_Int63_emul[117],
            repr$0
        ]
    ];
    runtime.caml_register_global(32, Base_Int63, "Base__Int63");
    return;
})(globalThis);
//# 38642 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Key = [
        0
    ], Base_Hashtbl_intf = [
        0,
        Key
    ];
    runtime.caml_register_global(0, Base_Hashtbl_intf, "Base__Hashtbl_intf");
    return;
})(globalThis);
//# 38655 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_avltree_ml = "src/avltree.ml", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Sexp = global_data.Base__Sexp, Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_Error = global_data.Base__Error, raise_s = Base_Error[32];
    function max(x, y) {
        return y < x ? x : y;
    }
    var _a_ = [
        0,
        cst_src_avltree_ml,
        50,
        6
    ], _b_ = [
        0,
        cst_src_avltree_ml,
        56,
        6
    ], _c_ = [
        0,
        cst_src_avltree_ml,
        67,
        6
    ], _d_ = [
        0,
        cst_src_avltree_ml,
        66,
        6
    ], _e_ = [
        0,
        cst_src_avltree_ml,
        87,
        22
    ], _f_ = [
        0,
        cst_src_avltree_ml,
        110,
        26
    ], _g_ = [
        0,
        cst_src_avltree_ml,
        129,
        30
    ], _h_ = [
        0,
        cst_src_avltree_ml,
        145,
        26
    ], _i_ = [
        0,
        cst_src_avltree_ml,
        163,
        30
    ], dummy = 0;
    function is_empty(param) {
        return typeof param === "number" ? 1 : 0;
    }
    function height(param) {
        if (typeof param === "number") return 0;
        if (0 !== param[0]) return 1;
        var height = param[4];
        return height;
    }
    function invariant(t, compare) {
        function inv(param) {
            if (typeof param !== "number" && 0 === param[0]) {
                var left = param[1], key = param[2], h = param[4], right = param[5], hr = height(right), hl = height(left);
                inv(left);
                inv(right);
                if (typeof left !== "number") {
                    var left_key = 0 === left[0] ? left[2] : left[1];
                    if (0 <= caml_call2(compare, left_key, key)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _a_
                    ], 1);
                }
                if (typeof right !== "number") {
                    var right_key = 0 === right[0] ? right[2] : right[1];
                    if (0 >= caml_call2(compare, right_key, key)) throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _b_
                    ], 1);
                }
                var _z_ = max(hl, hr);
                if (h !== caml_call2(Base_Import[91], _z_, 1)) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _d_
                ], 1);
                var _A_ = caml_call2(Base_Import[93], hl, hr);
                if (2 < caml_call1(Base_Import[123], _A_)) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _c_
                ], 1);
                return 0;
            }
            return 0;
        }
        return inv(t);
    }
    function update_height(x) {
        if (typeof x !== "number" && 0 === x[0]) {
            var left = x[1], old_height = x[4], right = x[5], _x_ = height(right), _y_ = max(height(left), _x_), new_height = caml_call2(Base_Import[91], _y_, 1);
            if (new_height !== old_height) x[4] = new_height;
            return;
        }
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _e_
        ], 1);
    }
    function balance(root_node) {
        if (typeof root_node !== "number" && 0 === root_node[0]) {
            var left_node = root_node[1], right_node = root_node[5], hl = height(left_node), hr = height(right_node);
            if (caml_call2(Base_Import[91], hr, 2) < hl) {
                if (typeof left_node !== "number" && 0 === left_node[0]) {
                    var left_node_left = left_node[1], left_node_right = left_node[5], _v_ = height(left_node_right);
                    if (_v_ <= height(left_node_left)) {
                        root_node[1] = left_node_right;
                        left_node[5] = root_node;
                        update_height(root_node);
                        update_height(left_node);
                        return left_node;
                    }
                    if (typeof left_node_right !== "number" && 0 === left_node_right[0]) {
                        var lr_left = left_node_right[1], lr_right = left_node_right[5];
                        left_node[5] = lr_left;
                        root_node[1] = lr_right;
                        left_node_right[5] = root_node;
                        left_node_right[1] = left_node;
                        update_height(left_node);
                        update_height(root_node);
                        update_height(left_node_right);
                        return left_node_right;
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _g_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _f_
                ], 1);
            }
            if (caml_call2(Base_Import[91], hl, 2) >= hr) {
                update_height(root_node);
                return root_node;
            }
            if (typeof right_node !== "number" && 0 === right_node[0]) {
                var right_node_left = right_node[1], right_node_right = right_node[5], _w_ = height(right_node_left);
                if (_w_ <= height(right_node_right)) {
                    root_node[5] = right_node_left;
                    right_node[1] = root_node;
                    update_height(root_node);
                    update_height(right_node);
                    return right_node;
                }
                if (typeof right_node_left !== "number" && 0 === right_node_left[0]) {
                    var rl_left = right_node_left[1], rl_right = right_node_left[5];
                    right_node[1] = rl_right;
                    root_node[5] = rl_left;
                    right_node_left[1] = root_node;
                    right_node_left[5] = right_node;
                    update_height(right_node);
                    update_height(root_node);
                    update_height(right_node_left);
                    return right_node_left;
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _i_
                ], 1);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _h_
            ], 1);
        }
        return root_node;
    }
    function add(t, replace, compare, added, k, v) {
        if (typeof t === "number") {
            added[1] = 1;
            return [
                1,
                k,
                v
            ];
        }
        if (0 !== t[0]) {
            var k$1 = t[1], c$0 = caml_call2(compare, k$1, k);
            if (0 !== c$0) {
                added[1] = 1;
                return 0 <= c$0 ? [
                    0,
                    0,
                    k,
                    v,
                    2,
                    t
                ] : [
                    0,
                    t,
                    k,
                    v,
                    2,
                    0
                ];
            }
            added[1] = 0;
            if (replace) t[2] = v;
            return t;
        }
        var left = t[1], k$0 = t[2], right = t[5], c = caml_call2(compare, k, k$0);
        if (0 === c) {
            added[1] = 0;
            if (replace) t[3] = v;
            return t;
        }
        if (0 <= c) {
            var right$0 = add(right, replace, compare, added, k, v);
            if (1 - (right$0 === right ? 1 : 0)) t[5] = right$0;
        } else {
            var left$0 = add(left, replace, compare, added, k, v);
            if (1 - (left$0 === left ? 1 : 0)) t[1] = left$0;
        }
        return added[1] ? balance(t) : t;
    }
    function first(t) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 === t$0[0]) {
                var l = t$0[1];
                if (typeof l !== "number") {
                    t$0 = l;
                    continue;
                }
                var v = t$0[3], k = t$0[2];
            } else var k$0 = t$0[1], v$0 = t$0[2], v = v$0, k = k$0;
            return [
                0,
                [
                    0,
                    k,
                    v
                ]
            ];
        }
    }
    function last(t) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 === t$0[0]) {
                var _t_ = t$0[2], _u_ = t$0[3];
                if (typeof t$0[5] !== "number") {
                    var r = t$0[5];
                    t$0 = r;
                    continue;
                }
                var v = _u_, k = _t_;
            } else var k$0 = t$0[1], v$0 = t$0[2], v = v$0, k = k$0;
            return [
                0,
                [
                    0,
                    k,
                    v
                ]
            ];
        }
    }
    function findi_and_call_impl(t, compare, k, arg1, arg2, call_if_found, call_if_not_found, if_found, if_not_found) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return caml_call4(call_if_not_found, if_not_found, k, arg1, arg2);
            if (0 !== t$0[0]) {
                var k$1 = t$0[1], v$0 = t$0[2];
                return 0 === caml_call2(compare, k, k$1) ? caml_call5(call_if_found, if_found, k$1, v$0, arg1, arg2) : caml_call4(call_if_not_found, if_not_found, k, arg1, arg2);
            }
            var left = t$0[1], k$0 = t$0[2], v = t$0[3], right = t$0[5], c = caml_call2(compare, k, k$0);
            if (0 === c) return caml_call5(call_if_found, if_found, k$0, v, arg1, arg2);
            var right$0 = 0 <= c ? right : left;
            t$0 = right$0;
        }
    }
    function call_if_found(if_found, _s_, data, _r_, param) {
        return caml_call1(if_found, data);
    }
    function call_if_not_found(if_not_found, key, _q_, param) {
        return caml_call1(if_not_found, key);
    }
    function find_and_call(t, compare, k, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, 0, 0, call_if_found, call_if_not_found, if_found, if_not_found);
    }
    function call_if_found$0(if_found, key, data, _p_, param) {
        return caml_call2(if_found, key, data);
    }
    function call_if_not_found$0(if_not_found, key, _o_, param) {
        return caml_call1(if_not_found, key);
    }
    function findi_and_call(t, compare, k, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, 0, 0, call_if_found$0, call_if_not_found$0, if_found, if_not_found);
    }
    function call_if_found$1(if_found, _n_, data, arg, param) {
        return caml_call2(if_found, data, arg);
    }
    function call_if_not_found$1(if_not_found, key, arg, param) {
        return caml_call2(if_not_found, key, arg);
    }
    function find_and_call1(t, compare, k, a, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, 0, call_if_found$1, call_if_not_found$1, if_found, if_not_found);
    }
    function call_if_found$2(if_found, key, data, arg, param) {
        return caml_call3(if_found, key, data, arg);
    }
    function call_if_not_found$2(if_not_found, key, arg, param) {
        return caml_call2(if_not_found, key, arg);
    }
    function findi_and_call1(t, compare, k, a, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, 0, call_if_found$2, call_if_not_found$2, if_found, if_not_found);
    }
    function call_if_found$3(if_found, param, data, arg1, arg2) {
        return caml_call3(if_found, data, arg1, arg2);
    }
    function call_if_not_found$3(if_not_found, key, arg1, arg2) {
        return caml_call3(if_not_found, key, arg1, arg2);
    }
    function find_and_call2(t, compare, k, a, b, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, b, call_if_found$3, call_if_not_found$3, if_found, if_not_found);
    }
    function call_if_found$4(if_found, key, data, arg1, arg2) {
        return caml_call4(if_found, key, data, arg1, arg2);
    }
    function call_if_not_found$4(if_not_found, key, arg1, arg2) {
        return caml_call3(if_not_found, key, arg1, arg2);
    }
    function findi_and_call2(t, compare, k, a, b, if_found, if_not_found) {
        return findi_and_call_impl(t, compare, k, a, b, call_if_found$4, call_if_not_found$4, if_found, if_not_found);
    }
    function if_found(v) {
        return [
            0,
            v
        ];
    }
    function if_not_found(param) {
        return 0;
    }
    function find(t, compare, k) {
        return find_and_call(t, compare, k, if_found, if_not_found);
    }
    function if_found$0(param) {
        return 1;
    }
    function if_not_found$0(param) {
        return 0;
    }
    function mem(t, compare, k) {
        return find_and_call(t, compare, k, if_found$0, if_not_found$0);
    }
    var letrec_function_context = [], _j_ = [
        0,
        cst_src_avltree_ml,
        389,
        15
    ], _k_ = [
        0,
        cst_src_avltree_ml,
        406,
        20
    ];
    function remove(t, removed, compare, k) {
        if (typeof t === "number") {
            removed[1] = 0;
            return 0;
        }
        if (0 !== t[0]) {
            var k$1 = t[1];
            return 0 === caml_call2(compare, k, k$1) ? (removed[1] = 1, 0) : (removed[1] = 0, t);
        }
        var left = t[1], k$0 = t[2], right = t[5], c = caml_call2(compare, k, k$0);
        if (0 === c) {
            removed[1] = 1;
            return caml_call2(letrec_function_context[1], left, right);
        }
        if (0 <= c) {
            var right$0 = remove(right, removed, compare, k);
            if (1 - (right$0 === right ? 1 : 0)) t[5] = right$0;
        } else {
            var left$0 = remove(left, removed, compare, k);
            if (1 - (left$0 === left ? 1 : 0)) t[1] = left$0;
        }
        return removed[1] ? balance(t) : t;
    }
    function remove_min_elt(tree) {
        if (typeof tree === "number") throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _j_
        ], 1);
        if (0 !== tree[0]) return 0;
        var left = tree[1];
        if (typeof left === "number") {
            var right = tree[5];
            return right;
        }
        if (1 === left[0]) {
            var k = tree[2], v = tree[3];
            if (typeof tree[5] === "number") return [
                1,
                k,
                v
            ];
        }
        tree[1] = remove_min_elt(left);
        return balance(tree);
    }
    function merge(t1, tree$0) {
        if (typeof t1 === "number") return tree$0;
        if (typeof tree$0 === "number") return t1;
        var tree = tree$0;
        for(;;){
            if (typeof tree === "number") var tree$1 = 0;
            else if (0 === tree[0]) {
                var left = tree[1];
                if (typeof left !== "number") {
                    tree = left;
                    continue;
                }
                var tree$1 = tree;
            } else var tree$1 = tree;
            if (typeof tree$1 === "number") throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _k_
            ], 1);
            if (0 === tree$1[0]) {
                tree$1[5] = remove_min_elt(tree$0);
                tree$1[1] = t1;
                var tree$2 = tree$1;
            } else var k = tree$1[1], v = tree$1[2], t2 = remove_min_elt(tree$0), _l_ = height(t2), _m_ = max(height(t1), _l_), tree$2 = [
                0,
                t1,
                k,
                v,
                caml_call2(Base_Import[91], _m_, 1),
                t2
            ];
            return balance(tree$2);
        }
    }
    runtime.caml_update_dummy(letrec_function_context, [
        0,
        merge
    ]);
    var cst_Avltree_choose_exn_of_empt = "[Avltree.choose_exn] of empty hashtbl";
    function fold(t, init, f) {
        var t$0 = t, init$0 = init;
        for(;;){
            if (typeof t$0 === "number") return init$0;
            if (0 !== t$0[0]) {
                var key$4 = t$0[1], data$4 = t$0[2];
                return caml_call3(f, key$4, data$4, init$0);
            }
            var left = t$0[1];
            if (typeof left === "number") {
                var key = t$0[2], data = t$0[3], match = t$0[5];
                if (typeof match !== "number" && 0 !== match[0]) {
                    var rkey = match[1], rdata = match[2];
                    return caml_call3(f, rkey, rdata, caml_call3(f, key, data, init$0));
                }
            } else {
                if (0 === left[0]) {
                    var key$1 = t$0[2], data$1 = t$0[3], match$0 = t$0[5];
                    if (typeof match$0 !== "number" && 0 !== match$0[0]) {
                        var rkey$0 = match$0[1], rdata$0 = match$0[2];
                        return caml_call3(f, rkey$0, rdata$0, caml_call3(f, key$1, data$1, fold(left, init$0, f)));
                    }
                } else {
                    var lkey$0 = left[1], ldata$0 = left[2], key$3 = t$0[2], data$3 = t$0[3], match$1 = t$0[5];
                    if (typeof match$1 === "number") return caml_call3(f, key$3, data$3, caml_call3(f, lkey$0, ldata$0, init$0));
                    if (0 !== match$1[0]) {
                        var rkey$1 = match$1[1], rdata$1 = match$1[2];
                        return caml_call3(f, rkey$1, rdata$1, caml_call3(f, key$3, data$3, caml_call3(f, lkey$0, ldata$0, init$0)));
                    }
                }
                if (typeof left !== "number" && 1 === left[0]) {
                    var lkey = left[1], ldata = left[2], key$2 = t$0[2], data$2 = t$0[3], right$0 = t$0[5], init$2 = caml_call3(f, key$2, data$2, caml_call3(f, lkey, ldata, init$0));
                    t$0 = right$0;
                    init$0 = init$2;
                    continue;
                }
            }
            var key$0 = t$0[2], data$0 = t$0[3], right = t$0[5], init$1 = caml_call3(f, key$0, data$0, fold(left, init$0, f));
            t$0 = right;
            init$0 = init$1;
        }
    }
    function iter(t, f) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 !== t$0[0]) {
                var key$0 = t$0[1], data$0 = t$0[2];
                return caml_call2(f, key$0, data$0);
            }
            var left = t$0[1], key = t$0[2], data = t$0[3], right = t$0[5];
            iter(left, f);
            caml_call2(f, key, data);
            t$0 = right;
        }
    }
    function mapi_inplace(t, f) {
        var t$0 = t;
        for(;;){
            if (typeof t$0 === "number") return 0;
            if (0 !== t$0[0]) {
                var key$0 = t$0[1], value$0 = t$0[2];
                t$0[2] = caml_call2(f, key$0, value$0);
                return 0;
            }
            var left = t$0[1], key = t$0[2], value = t$0[3], right = t$0[5];
            mapi_inplace(left, f);
            t$0[3] = caml_call2(f, key, value);
            t$0 = right;
        }
    }
    function choose_exn(param) {
        if (typeof param === "number") return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Avltree_choose_exn_of_empt, 0));
        if (0 === param[0]) var value = param[3], key = param[2];
        else var key$0 = param[1], value$0 = param[2], value = value$0, key = key$0;
        return [
            0,
            key,
            value
        ];
    }
    var Base_Avltree = [
        0,
        0,
        is_empty,
        invariant,
        add,
        first,
        last,
        find,
        find_and_call,
        find_and_call1,
        find_and_call2,
        findi_and_call,
        findi_and_call1,
        findi_and_call2,
        mem,
        remove,
        fold,
        iter,
        mapi_inplace,
        choose_exn
    ];
    runtime.caml_register_global(16, Base_Avltree, "Base__Avltree");
    return;
})(globalThis);
//# 39240 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_src_hashtbl_ml = "src/hashtbl.ml", caml_check_bound = runtime.caml_check_bound, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Avltree = global_data.Base__Avltree, Base_Import = global_data.Base__Import, Base_Hashable = global_data.Base__Hashable, Base_Array = global_data.Base__Array, Base_List = global_data.Base__List, Base_Or_error = global_data.Base__Or_error, Base_Sexp = global_data.Base__Sexp, Sexplib0_Sexp_grammar = global_data.Sexplib0__Sexp_grammar, Assert_failure = global_data.Assert_failure, Base_Error = global_data.Base__Error, Base_Option = global_data.Base__Option, Base_Random = global_data.Base__Random, Base_Int = global_data.Base__Int, Base_With_return = global_data.Base__With_return, with_return = Base_With_return[1], hash_param = Base_Hashable[5], hash = Base_Hashable[6], raise_s = Base_Error[32], cst_Hashtbl_mutation_not_allow = "Hashtbl: mutation not allowed during iteration";
    function sexp_of_key(t) {
        return t[4][3];
    }
    function compare_key(t) {
        return t[4][2];
    }
    function ensure_mutation_allowed(t) {
        var _aA_ = 1 - t[5];
        return _aA_ ? caml_call1(Base_Import[124], cst_Hashtbl_mutation_not_allow) : _aA_;
    }
    function without_mutating(t, f) {
        if (!t[5]) return caml_call1(f, 0);
        t[5] = 0;
        try {
            var x = caml_call1(f, 0);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = 1;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = 1;
        return x;
    }
    var max_table_length = caml_call1(Base_Int[69], Base_Array[47]), cst_Hashtbl_add_exn_got_key_al = "Hashtbl.add_exn got key already present", cst_Hashtbl_choose_exn_of_empt = "[Hashtbl.choose_exn] of empty hashtbl", cst_Hashtbl_choose_randomly_ex = "[Hashtbl.choose_randomly_exn] of empty hashtbl", _a_ = [
        0,
        cst_src_hashtbl_ml,
        333,
        2
    ], _b_ = [
        0,
        "Hashtbl.find_exn: not found"
    ], cst_Hashtbl_of_alist_exn_dupli = "Hashtbl.of_alist_exn: duplicate key", cst_Hashtbl_t_of_sexp_duplicat = "Hashtbl.t_of_sexp: duplicate key", _c_ = [
        0,
        cst_src_hashtbl_ml,
        582,
        4
    ], cst_keys = "keys", cst_Hashtbl_create_with_key_du = "Hashtbl.create_with_key: duplicate keys", cst_Hashtbl_merge_different_ha = "Hashtbl.merge: different 'hashable' values";
    function create(_ay_, opt, hashable, param) {
        var growth_allowed = _ay_ ? _ay_[1] : 1, size = opt ? opt[1] : 0, _az_ = caml_call2(Base_Int[16], 1, size), size$0 = caml_call2(Base_Int[15], _az_, max_table_length), size$1 = caml_call1(Base_Int[68], size$0);
        return [
            0,
            caml_call2(Base_Array[48], size$1, Base_Avltree[1]),
            0,
            growth_allowed,
            hashable,
            1
        ];
    }
    function slot(t, key) {
        var hash = caml_call1(t[4][1], key), _ax_ = caml_call2(Base_Import[93], t[1].length - 1, 1);
        return caml_call2(Base_Import[116], hash, _ax_);
    }
    function add_worker(t, replace, key, data) {
        var i = slot(t, key), root = caml_check_bound(t[1], i)[1 + i], added = [
            0,
            0
        ], _aw_ = compare_key(t), new_root = caml_call6(Base_Avltree[4], root, replace, _aw_, added, key, data);
        if (added[1]) t[2] = caml_call2(Base_Import[91], t[2], 1);
        if (1 - (new_root === root ? 1 : 0)) caml_check_bound(t[1], i)[1 + i] = new_root;
        return added[1];
    }
    function maybe_resize_table(t) {
        var len = t[1].length - 1, should_grow = len < t[2] ? 1 : 0, _an_ = should_grow ? t[3] : should_grow;
        if (_an_) {
            var _ao_ = caml_call2(Base_Import[88], len, 2), new_array_length = caml_call2(Base_Int[15], _ao_, max_table_length), _ap_ = len < new_array_length ? 1 : 0;
            if (_ap_) {
                var new_table = caml_call2(Base_Array[48], new_array_length, Base_Avltree[1]), old_table = t[1];
                t[1] = new_table;
                t[2] = 0;
                var f = function(key, data) {
                    add_worker(t, 1, key, data);
                    return 0;
                }, _ar_ = caml_call2(Base_Import[93], old_table.length - 1, 1), _aq_ = 0;
                if (_ar_ >= 0) {
                    var i = _aq_;
                    for(;;){
                        var _au_ = caml_check_bound(old_table, i)[1 + i];
                        caml_call2(Base_Avltree[17], _au_, f);
                        var _av_ = i + 1 | 0;
                        if (_ar_ === i) break;
                        i = _av_;
                    }
                }
                var _as_ = 0;
            } else var _as_ = _ap_;
            var _at_ = _as_;
        } else var _at_ = _an_;
        return _at_;
    }
    function capacity(t) {
        return t[1].length - 1;
    }
    function set(t, key, data) {
        ensure_mutation_allowed(t);
        add_worker(t, 1, key, data);
        return maybe_resize_table(t);
    }
    function add(t, key, data) {
        ensure_mutation_allowed(t);
        var added = add_worker(t, 0, key, data);
        return added ? (maybe_resize_table(t), 17724) : -1024851605;
    }
    function add_exn(t, key, data) {
        if (17724 <= add(t, key, data)) return 0;
        var sexp_of_key$0 = sexp_of_key(t), error = caml_call5(Base_Error[19], 0, 0, cst_Hashtbl_add_exn_got_key_al, key, sexp_of_key$0);
        return caml_call1(Base_Error[31], error);
    }
    function clear(t) {
        ensure_mutation_allowed(t);
        var _ak_ = caml_call2(Base_Import[93], t[1].length - 1, 1), _aj_ = 0;
        if (_ak_ >= 0) {
            var i = _aj_;
            for(;;){
                var _al_ = Base_Avltree[1];
                caml_check_bound(t[1], i)[1 + i] = _al_;
                var _am_ = i + 1 | 0;
                if (_ak_ === i) break;
                i = _am_;
            }
        }
        t[2] = 0;
        return 0;
    }
    function find_and_call(t, key, if_found, if_not_found) {
        var _ah_ = slot(t, key), tree = caml_check_bound(t[1], _ah_)[1 + _ah_];
        if (typeof tree === "number") return caml_call1(if_not_found, key);
        if (0 === tree[0]) {
            var _ai_ = compare_key(t);
            return caml_call5(Base_Avltree[8], tree, _ai_, key, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call1(if_found, v) : caml_call1(if_not_found, key);
    }
    function find_and_call1(t, key, a, if_found, if_not_found) {
        var _af_ = slot(t, key), tree = caml_check_bound(t[1], _af_)[1 + _af_];
        if (typeof tree === "number") return caml_call2(if_not_found, key, a);
        if (0 === tree[0]) {
            var _ag_ = compare_key(t);
            return caml_call6(Base_Avltree[9], tree, _ag_, key, a, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call2(if_found, v, a) : caml_call2(if_not_found, key, a);
    }
    function find_and_call2(t, key, a, b, if_found, if_not_found) {
        var _ad_ = slot(t, key), tree = caml_check_bound(t[1], _ad_)[1 + _ad_];
        if (typeof tree === "number") return caml_call3(if_not_found, key, a, b);
        if (0 === tree[0]) {
            var _ae_ = compare_key(t);
            return caml_call7(Base_Avltree[10], tree, _ae_, key, a, b, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call3(if_found, v, a, b) : caml_call3(if_not_found, key, a, b);
    }
    function findi_and_call(t, key, if_found, if_not_found) {
        var _ab_ = slot(t, key), tree = caml_check_bound(t[1], _ab_)[1 + _ab_];
        if (typeof tree === "number") return caml_call1(if_not_found, key);
        if (0 === tree[0]) {
            var _ac_ = compare_key(t);
            return caml_call5(Base_Avltree[11], tree, _ac_, key, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call2(if_found, k, v) : caml_call1(if_not_found, key);
    }
    function findi_and_call1(t, key, a, if_found, if_not_found) {
        var _$_ = slot(t, key), tree = caml_check_bound(t[1], _$_)[1 + _$_];
        if (typeof tree === "number") return caml_call2(if_not_found, key, a);
        if (0 === tree[0]) {
            var _aa_ = compare_key(t);
            return caml_call6(Base_Avltree[12], tree, _aa_, key, a, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call3(if_found, k, v, a) : caml_call2(if_not_found, key, a);
    }
    function findi_and_call2(t, key, a, b, if_found, if_not_found) {
        var _Z_ = slot(t, key), tree = caml_check_bound(t[1], _Z_)[1 + _Z_];
        if (typeof tree === "number") return caml_call3(if_not_found, key, a, b);
        if (0 === tree[0]) {
            var ___ = compare_key(t);
            return caml_call7(Base_Avltree[13], tree, ___, key, a, b, if_found, if_not_found);
        }
        var k = tree[1], v = tree[2];
        return 0 === caml_call2(compare_key(t), k, key) ? caml_call4(if_found, k, v, a, b) : caml_call3(if_not_found, key, a, b);
    }
    function if_found(v) {
        return [
            0,
            v
        ];
    }
    function if_not_found(param) {
        return 0;
    }
    function find(t, key) {
        return find_and_call(t, key, if_found, if_not_found);
    }
    function mem(t, key) {
        var _X_ = slot(t, key), tree = caml_check_bound(t[1], _X_)[1 + _X_];
        if (typeof tree === "number") return 0;
        if (0 === tree[0]) {
            var _Y_ = compare_key(t);
            return caml_call3(Base_Avltree[14], tree, _Y_, key);
        }
        var k = tree[1];
        return 0 === caml_call2(compare_key(t), k, key) ? 1 : 0;
    }
    function remove(t, key) {
        ensure_mutation_allowed(t);
        var i = slot(t, key), root = caml_check_bound(t[1], i)[1 + i], removed = [
            0,
            0
        ], _U_ = compare_key(t), new_root = caml_call4(Base_Avltree[15], root, removed, _U_, key);
        if (1 - (root === new_root ? 1 : 0)) caml_check_bound(t[1], i)[1 + i] = new_root;
        var _V_ = removed[1], _W_ = _V_ ? (t[2] = caml_call2(Base_Import[93], t[2], 1), 0) : _V_;
        return _W_;
    }
    function length(t) {
        return t[2];
    }
    function is_empty(t) {
        return 0 === t[2] ? 1 : 0;
    }
    function fold(t, init, f) {
        if (0 === t[2]) return init;
        var n = t[1].length - 1, acc = [
            0,
            init
        ], m = t[5];
        try {
            t[5] = 0;
            var _S_ = caml_call2(Base_Import[93], n, 1), _R_ = 0;
            if (_S_ >= 0) {
                var i = _R_;
                for(;;){
                    var bucket = t[1][1 + i];
                    if (typeof bucket !== "number") {
                        if (0 === bucket[0]) acc[1] = caml_call3(Base_Avltree[16], bucket, acc[1], f);
                        else {
                            var key = bucket[1], data = bucket[2];
                            acc[1] = caml_call3(f, key, data, acc[1]);
                        }
                    }
                    var _T_1 = i + 1 | 0;
                    if (_S_ === i) break;
                    i = _T_1;
                }
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = m;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = m;
        return acc[1];
    }
    function iteri(t, f) {
        if (0 === t[2]) return 0;
        var n = t[1].length - 1, m = t[5];
        try {
            t[5] = 0;
            var _P_ = caml_call2(Base_Import[93], n, 1), _O_ = 0;
            if (_P_ >= 0) {
                var i = _O_;
                for(;;){
                    var bucket = t[1][1 + i];
                    if (typeof bucket !== "number") {
                        if (0 === bucket[0]) caml_call2(Base_Avltree[17], bucket, f);
                        else {
                            var key = bucket[1], data = bucket[2];
                            caml_call2(f, key, data);
                        }
                    }
                    var _Q_ = i + 1 | 0;
                    if (_P_ === i) break;
                    i = _Q_;
                }
            }
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            t[5] = m;
            throw caml_maybe_attach_backtrace(exn, 0);
        }
        t[5] = m;
        return 0;
    }
    function iter(t, f) {
        return iteri(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function iter_keys(t, f) {
        return iteri(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function choose_nonempty(table, i) {
        var i$0 = i;
        for(;;){
            var avltree = table[1 + i$0];
            if (!caml_call1(Base_Avltree[2], avltree)) return caml_call1(Base_Avltree[19], avltree);
            var _M_ = caml_call2(Base_Import[93], table.length - 1, 1), _N_ = caml_call2(Base_Import[91], i$0, 1), i$1 = caml_call2(Base_Import[116], _N_, _M_);
            i$0 = i$1;
        }
    }
    function choose_exn(t) {
        if (0 === t[2]) caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Hashtbl_choose_exn_of_empt, 0));
        return choose_nonempty(t[1], 0);
    }
    function choose(t) {
        return is_empty(t) ? 0 : [
            0,
            choose_nonempty(t[1], 0)
        ];
    }
    function choose_randomly_nonempty(random_state, t) {
        var start_idx = caml_call2(Base_Random[19][7], random_state, t[1].length - 1);
        return choose_nonempty(t[1], start_idx);
    }
    function choose_randomly(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        return is_empty(t) ? 0 : [
            0,
            choose_randomly_nonempty(random_state, t)
        ];
    }
    function choose_randomly_exn(opt, t) {
        var random_state = opt ? opt[1] : Base_Random[19][1];
        if (0 === t[2]) caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_Hashtbl_choose_randomly_ex, 0));
        return choose_randomly_nonempty(random_state, t);
    }
    function invariant(invariant_key, invariant_data, t) {
        var _I_ = caml_call2(Base_Import[93], t[1].length - 1, 1), _H_ = 0;
        if (_I_ >= 0) {
            var i = _H_;
            for(;;){
                var _J_ = compare_key(t), _K_ = caml_check_bound(t[1], i)[1 + i];
                caml_call2(Base_Avltree[3], _K_, _J_);
                var _L_ = i + 1 | 0;
                if (_I_ === i) break;
                i = _L_;
            }
        }
        var real_len = fold(t, 0, function(key, data, i) {
            caml_call1(invariant_key, key);
            caml_call1(invariant_data, data);
            return caml_call2(Base_Import[91], i, 1);
        });
        if (real_len === t[2]) return 0;
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _a_
        ], 1);
    }
    function if_found$0(v, param) {
        return v;
    }
    function if_not_found$0(k, t) {
        var _G_ = [
            1,
            [
                0,
                _b_,
                [
                    0,
                    caml_call1(t[4][3], k),
                    0
                ]
            ]
        ];
        throw caml_maybe_attach_backtrace([
            0,
            Base_Import[297],
            _G_
        ], 1);
    }
    function find_exn(t, key) {
        return find_and_call1(t, key, t, if_found$0, if_not_found$0);
    }
    function existsi(t, f) {
        return caml_call1(with_return, function(r) {
            iteri(t, function(key, data) {
                var _F_ = caml_call2(f, key, data);
                return _F_ ? caml_call1(r, 1) : _F_;
            });
            return 0;
        });
    }
    function exists(t, f) {
        return existsi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function for_alli(t, f) {
        return 1 - existsi(t, function(key, data) {
            return 1 - caml_call2(f, key, data);
        });
    }
    function for_all(t, f) {
        return 1 - existsi(t, function(param, data) {
            return 1 - caml_call1(f, data);
        });
    }
    function counti(t, f) {
        return fold(t, 0, function(key, data, acc) {
            return caml_call2(f, key, data) ? caml_call2(Base_Import[91], acc, 1) : acc;
        });
    }
    function count(t, f) {
        return fold(t, 0, function(param, data, acc) {
            return caml_call1(f, data) ? caml_call2(Base_Import[91], acc, 1) : acc;
        });
    }
    function mapi(t, f) {
        var new_t = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            return set(new_t, key, caml_call2(f, key, data));
        });
        return new_t;
    }
    function map(t, f) {
        return mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function copy(t) {
        return map(t, function(_E_) {
            return _E_;
        });
    }
    function filter_mapi(t, f) {
        var new_t = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            var match = caml_call2(f, key, data);
            if (!match) return 0;
            var new_data = match[1];
            return set(new_t, key, new_data);
        });
        return new_t;
    }
    function filter_map(t, f) {
        return filter_mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filteri(t, f) {
        return filter_mapi(t, function(key, data) {
            return caml_call2(f, key, data) ? [
                0,
                data
            ] : 0;
        });
    }
    function filter(t, f) {
        return filteri(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filter_keys(t, f) {
        return filteri(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function partition_mapi(t, f) {
        var t0 = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0), t1 = create([
            0,
            t[3]
        ], [
            0,
            t[2]
        ], t[4], 0);
        iteri(t, function(key, data) {
            var match = caml_call2(f, key, data);
            if (0 === match[0]) {
                var new_data = match[1];
                return set(t0, key, new_data);
            }
            var new_data$0 = match[1];
            return set(t1, key, new_data$0);
        });
        return [
            0,
            t0,
            t1
        ];
    }
    function partition_map(t, f) {
        return partition_mapi(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function partitioni_tf(t, f) {
        return partition_mapi(t, function(key, data) {
            return caml_call2(f, key, data) ? [
                0,
                data
            ] : [
                1,
                data
            ];
        });
    }
    function partition_tf(t, f) {
        return partitioni_tf(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function find_or_add(t, id, default$0) {
        return find_and_call(t, id, function(data) {
            return data;
        }, function(key) {
            var default$1 = caml_call1(default$0, 0);
            set(t, key, default$1);
            return default$1;
        });
    }
    function findi_or_add(t, id, default$0) {
        return find_and_call(t, id, function(data) {
            return data;
        }, function(key) {
            var default$1 = caml_call1(default$0, key);
            set(t, key, default$1);
            return default$1;
        });
    }
    function find_and_remove(t, key) {
        var result = find_and_call(t, key, if_found, if_not_found);
        if (caml_call1(Base_Option[53], result)) remove(t, key);
        return result;
    }
    function change(t, key, f) {
        var match = caml_call1(f, find_and_call(t, key, if_found, if_not_found));
        if (!match) return remove(t, key);
        var data = match[1];
        return set(t, key, data);
    }
    function update_and_return(t, key, f) {
        var data = caml_call1(f, find_and_call(t, key, if_found, if_not_found));
        set(t, key, data);
        return data;
    }
    function update(t, id, f) {
        update_and_return(t, id, f);
        return 0;
    }
    function incr_by(remove_if_zero, t, key, by) {
        return remove_if_zero ? change(t, key, function(opt) {
            var _D_ = caml_call2(Base_Option[30], opt, 0), n = caml_call2(Base_Import[91], by, _D_);
            return 0 === n ? 0 : [
                0,
                n
            ];
        }) : update(t, key, function(param) {
            if (!param) return by;
            var i = param[1];
            return caml_call2(Base_Import[91], by, i);
        });
    }
    function incr(_C_, opt, t, key) {
        var by = _C_ ? _C_[1] : 1, remove_if_zero = opt ? opt[1] : 0;
        return incr_by(remove_if_zero, t, key, by);
    }
    function decr(_B_, opt, t, key) {
        var by = _B_ ? _B_[1] : 1, remove_if_zero = opt ? opt[1] : 0;
        return incr_by(remove_if_zero, t, key, caml_call1(Base_Import[113], by));
    }
    function add_multi(t, key, data) {
        return update(t, key, function(param) {
            if (!param) return [
                0,
                data,
                0
            ];
            var l = param[1];
            return [
                0,
                data,
                l
            ];
        });
    }
    function remove_multi(t, key) {
        var match = find_and_call(t, key, if_found, if_not_found);
        if (!match) return 0;
        var _A_ = match[1];
        if (_A_ && _A_[2]) {
            var tl = _A_[2];
            return set(t, key, tl);
        }
        return remove(t, key);
    }
    function find_multi(t, key) {
        var match = find_and_call(t, key, if_found, if_not_found);
        if (!match) return 0;
        var l = match[1];
        return l;
    }
    function create_mapped(growth_allowed, size, hashable, get_key, get_data, rows) {
        if (size) var s = size[1], size$0 = s;
        else var size$0 = caml_call1(Base_List[45], rows);
        var res = create(growth_allowed, [
            0,
            size$0
        ], hashable, 0), dupes = [
            0,
            0
        ];
        caml_call2(Base_List[19], rows, function(r) {
            var key = caml_call1(get_key, r), data = caml_call1(get_data, r);
            return mem(res, key) ? (dupes[1] = [
                0,
                key,
                dupes[1]
            ], 0) : set(res, key, data);
        });
        var keys = dupes[1];
        return keys ? [
            0,
            175765640,
            caml_call2(Base_List[126], keys, hashable[2])
        ] : [
            0,
            17724,
            res
        ];
    }
    function of_alist(growth_allowed, size, hashable, lst) {
        var match = create_mapped(growth_allowed, size, hashable, Base_Import[125], Base_Import[127], lst);
        if (175765640 <= match[1]) {
            var k = match[2];
            return [
                0,
                -1048878709,
                caml_call1(Base_List[88], k)
            ];
        }
        var t = match[2];
        return [
            0,
            17724,
            t
        ];
    }
    function of_alist_report_all_dups(growth_allowed, size, hashable, lst) {
        return create_mapped(growth_allowed, size, hashable, Base_Import[125], Base_Import[127], lst);
    }
    function of_alist_or_error(growth_allowed, size, hashable, lst) {
        var match = of_alist(growth_allowed, size, hashable, lst);
        if (17724 <= match[1]) {
            var v = match[2];
            return [
                0,
                v
            ];
        }
        var key = match[2], sexp_of_key = hashable[3];
        return caml_call5(Base_Or_error[38], 0, 0, cst_Hashtbl_of_alist_exn_dupli, key, sexp_of_key);
    }
    function of_alist_exn(growth_allowed, size, hashable, lst) {
        var match = of_alist_or_error(growth_allowed, size, hashable, lst);
        if (0 === match[0]) {
            var v = match[1];
            return v;
        }
        var e = match[1];
        return caml_call1(Base_Error[31], e);
    }
    function of_alist_multi(growth_allowed, size$0, hashable, rows) {
        var get_data = Base_Import[127], get_key = Base_Import[125];
        if (size$0) var s = size$0[1], size = s;
        else var size = caml_call1(Base_List[45], rows);
        var res = create(growth_allowed, [
            0,
            size
        ], hashable, 0);
        caml_call2(Base_List[19], rows, function(r) {
            var key = caml_call1(get_key, r), data = caml_call1(get_data, r);
            return add_multi(res, key, data);
        });
        return res;
    }
    function to_alist(t) {
        return fold(t, 0, function(key, data, list) {
            return [
                0,
                [
                    0,
                    key,
                    data
                ],
                list
            ];
        });
    }
    function sexp_of_t(sexp_of_key, sexp_of_data, t) {
        var _w_ = to_alist(t), _x_ = caml_call2(Base_List[83], _w_, function(_z_, param) {
            var k2 = param[1], k1 = _z_[1];
            return caml_call2(t[4][2], k1, k2);
        }), _y_ = caml_call2(Base_Import[147], sexp_of_key, sexp_of_data);
        return caml_call1(caml_call1(Base_Import[149], _y_), _x_);
    }
    function t_of_sexp(hashable, k_of_sexp, d_of_sexp, sexp) {
        var _p_ = caml_call2(Base_Import[171], k_of_sexp, d_of_sexp), alist = caml_call2(Base_Import[173], _p_, sexp), match = of_alist(0, [
            0,
            caml_call1(Base_List[45], alist)
        ], hashable, alist);
        if (17724 <= match[1]) {
            var v = match[2];
            return v;
        }
        var k = match[2], _q_ = caml_call2(Base_Import[171], function(_v_) {
            return _v_;
        }, function(_u_) {
            return _u_;
        }), alist_sexps = caml_call2(Base_Import[173], _q_, sexp), found_first_k = [
            0,
            0
        ];
        caml_call3(Base_List[67], alist, alist_sexps, function(_r_, param) {
            var k2_sexp = param[1], k2 = _r_[1], _s_ = 0 === caml_call2(hashable[2], k, k2) ? 1 : 0;
            if (_s_) {
                if (found_first_k[1]) return caml_call2(Base_Import[156], cst_Hashtbl_t_of_sexp_duplicat, k2_sexp);
                found_first_k[1] = 1;
                var _t_ = 0;
            } else var _t_ = _s_;
            return _t_;
        });
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _c_
        ], 1);
    }
    function t_sexp_grammar(k_grammar, v_grammar) {
        var _o_ = caml_call2(Base_List[137][3], k_grammar, v_grammar);
        return caml_call1(Sexplib0_Sexp_grammar[1], _o_);
    }
    function keys(t) {
        return fold(t, 0, function(key, param, acc) {
            return [
                0,
                key,
                acc
            ];
        });
    }
    function data(t) {
        return fold(t, 0, function(param, data, list) {
            return [
                0,
                data,
                list
            ];
        });
    }
    function group(growth_allowed, size, hashable, get_key, get_data, combine, rows) {
        var groups = create(growth_allowed, size, hashable, 0);
        caml_call2(Base_List[19], rows, function(row) {
            var key = caml_call1(get_key, row), data = caml_call1(get_data, row), match = find_and_call(groups, key, if_found, if_not_found);
            if (match) var old = match[1], data$0 = caml_call2(combine, old, data);
            else var data$0 = data;
            return set(groups, key, data$0);
        });
        return groups;
    }
    function create_with_key(growth_allowed, size, hashable, get_key, rows) {
        return create_mapped(growth_allowed, size, hashable, get_key, function(_n_) {
            return _n_;
        }, rows);
    }
    function create_with_key_or_error(growth_allowed, size, hashable, get_key, rows) {
        var match = create_with_key(growth_allowed, size, hashable, get_key, rows);
        if (175765640 <= match[1]) {
            var keys = match[2], sexp_of_key = hashable[3], _l_ = [
                0,
                [
                    0,
                    cst_keys,
                    caml_call2(Base_Import[149], sexp_of_key, keys)
                ],
                0
            ], _m_ = caml_call2(Base_Sexp[10], cst_Hashtbl_create_with_key_du, _l_);
            return caml_call1(Base_Or_error[39], _m_);
        }
        var t = match[2];
        return [
            0,
            t
        ];
    }
    function create_with_key_exn(growth_allowed, size, hashable, get_key, rows) {
        var _k_ = create_with_key_or_error(growth_allowed, size, hashable, get_key, rows);
        return caml_call1(Base_Or_error[34], _k_);
    }
    function maybe_set(t, key, f, d) {
        var match = caml_call2(f, key, d);
        if (!match) return 0;
        var v = match[1];
        return set(t, key, v);
    }
    function merge(t_left, t_right, f) {
        if (1 - caml_call2(Base_Hashable[1], t_left[4], t_right[4])) caml_call1(Base_Import[126], cst_Hashtbl_merge_different_ha);
        var new_t = create([
            0,
            t_left[3]
        ], [
            0,
            t_left[2]
        ], t_left[4], 0);
        without_mutating(t_left, function(param) {
            return without_mutating(t_right, function(param) {
                iteri(t_left, function(key, left) {
                    var match = find_and_call(t_right, key, if_found, if_not_found);
                    if (!match) return maybe_set(new_t, key, f, [
                        0,
                        847852583,
                        left
                    ]);
                    var right = match[1];
                    return maybe_set(new_t, key, f, [
                        0,
                        737457313,
                        [
                            0,
                            left,
                            right
                        ]
                    ]);
                });
                return iteri(t_right, function(key, right) {
                    return find_and_call(t_left, key, if_found, if_not_found) ? 0 : maybe_set(new_t, key, f, [
                        0,
                        -57574468,
                        right
                    ]);
                });
            });
        });
        return new_t;
    }
    function merge_into(src, dst, f) {
        return iteri(src, function(key, data) {
            var dst_data$0 = find_and_call(dst, key, if_found, if_not_found), action = without_mutating(dst, function(param) {
                return caml_call3(f, key, data, dst_data$0);
            });
            if (!action) return remove(dst, key);
            var data$0 = action[1];
            if (!dst_data$0) return set(dst, key, data$0);
            var dst_data = dst_data$0[1], _j_ = 1 - (dst_data === data$0 ? 1 : 0);
            return _j_ ? set(dst, key, data$0) : _j_;
        });
    }
    function filteri_inplace(t, f) {
        var to_remove = fold(t, 0, function(key, data, ac) {
            return caml_call2(f, key, data) ? ac : [
                0,
                key,
                ac
            ];
        });
        return caml_call2(Base_List[19], to_remove, function(key) {
            return remove(t, key);
        });
    }
    function filter_inplace(t, f) {
        return filteri_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function filter_keys_inplace(t, f) {
        return filteri_inplace(t, function(key, param) {
            return caml_call1(f, key);
        });
    }
    function filter_mapi_inplace(t, f) {
        var map_results = fold(t, 0, function(key, data, ac) {
            return [
                0,
                [
                    0,
                    key,
                    caml_call2(f, key, data)
                ],
                ac
            ];
        });
        return caml_call2(Base_List[19], map_results, function(param) {
            var result = param[2], key = param[1];
            if (!result) return remove(t, key);
            var data = result[1];
            return set(t, key, data);
        });
    }
    function filter_map_inplace(t, f) {
        return filter_mapi_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function mapi_inplace(t, f) {
        ensure_mutation_allowed(t);
        return without_mutating(t, function(param) {
            var _h_ = Base_Avltree[18];
            return caml_call2(Base_Array[20], t[1], function(_i_) {
                return caml_call2(_h_, _i_, f);
            });
        });
    }
    function map_inplace(t, f) {
        return mapi_inplace(t, function(param, data) {
            return caml_call1(f, data);
        });
    }
    function similar(equal, t$0, t) {
        var _f_ = t$0[2] === t[2] ? 1 : 0;
        return _f_ ? caml_call1(with_return, function(r) {
            without_mutating(t, function(param) {
                return iteri(t$0, function(key, data) {
                    var match = find_and_call(t, key, if_found, if_not_found);
                    if (!match) return caml_call1(r, 0);
                    var data$0 = match[1], _g_ = 1 - caml_call2(equal, data, data$0);
                    return _g_ ? caml_call1(r, 0) : _g_;
                });
            });
            return 1;
        }) : _f_;
    }
    function Creators(Key) {
        var hashable = Key[1];
        function create$0(growth_allowed, size, param) {
            return create(growth_allowed, size, hashable, 0);
        }
        function of_alist$0(growth_allowed, size, l) {
            return of_alist(growth_allowed, size, hashable, l);
        }
        function of_alist_report_all_dups$0(growth_allowed, size, l) {
            return of_alist_report_all_dups(growth_allowed, size, hashable, l);
        }
        function of_alist_or_error$0(growth_allowed, size, l) {
            return of_alist_or_error(growth_allowed, size, hashable, l);
        }
        function of_alist_exn$0(growth_allowed, size, l) {
            return of_alist_exn(growth_allowed, size, hashable, l);
        }
        function t_of_sexp$0(k_of_sexp, d_of_sexp, sexp) {
            return t_of_sexp(hashable, k_of_sexp, d_of_sexp, sexp);
        }
        function of_alist_multi$0(growth_allowed, size, l) {
            return of_alist_multi(growth_allowed, size, hashable, l);
        }
        function create_mapped$0(growth_allowed, size, get_key, get_data, l) {
            return create_mapped(growth_allowed, size, hashable, get_key, get_data, l);
        }
        function create_with_key$0(growth_allowed, size, get_key, l) {
            return create_with_key(growth_allowed, size, hashable, get_key, l);
        }
        function create_with_key_or_error$0(growth_allowed, size, get_key, l) {
            return create_with_key_or_error(growth_allowed, size, hashable, get_key, l);
        }
        function create_with_key_exn$0(growth_allowed, size, get_key, l) {
            return create_with_key_exn(growth_allowed, size, hashable, get_key, l);
        }
        function group$0(growth_allowed, size, get_key, get_data, combine, l) {
            return group(growth_allowed, size, hashable, get_key, get_data, combine, l);
        }
        return [
            0,
            t_of_sexp$0,
            create$0,
            of_alist$0,
            of_alist_report_all_dups$0,
            of_alist_or_error$0,
            of_alist_exn$0,
            of_alist_multi$0,
            create_mapped$0,
            create_with_key$0,
            create_with_key_or_error$0,
            create_with_key_exn$0,
            group$0
        ];
    }
    var hashable = Base_Hashable[2], _d_ = Creators([
        0,
        hashable
    ]), t_of_sexp$0 = _d_[1], create$0 = _d_[2], of_alist$0 = _d_[3], of_alist_report_all_dups$0 = _d_[4], of_alist_or_error$0 = _d_[5], of_alist_exn$0 = _d_[6], of_alist_multi$0 = _d_[7], create_mapped$0 = _d_[8], create_with_key$0 = _d_[9], create_with_key_or_error$0 = _d_[10], create_with_key_exn$0 = _d_[11], group$0 = _d_[12];
    function hashable$0(t) {
        return t[4];
    }
    var Private = [
        0,
        hashable$0
    ];
    function create$1(growth_allowed, size, m) {
        return create(growth_allowed, size, caml_call1(Base_Hashable[3], m), 0);
    }
    function of_alist$1(growth_allowed, size, m, l) {
        return of_alist(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_report_all_dups$1(growth_allowed, size, m, l) {
        return of_alist_report_all_dups(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_or_error$1(growth_allowed, size, m, l) {
        return of_alist_or_error(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_exn$1(growth_allowed, size, m, l) {
        return of_alist_exn(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function of_alist_multi$1(growth_allowed, size, m, l) {
        return of_alist_multi(growth_allowed, size, caml_call1(Base_Hashable[3], m), l);
    }
    function create_mapped$1(growth_allowed, size, m, get_key, get_data, l) {
        return create_mapped(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, get_data, l);
    }
    function create_with_key$1(growth_allowed, size, m, get_key, l) {
        return create_with_key(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function create_with_key_or_error$1(growth_allowed, size, m, get_key, l) {
        return create_with_key_or_error(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function create_with_key_exn$1(growth_allowed, size, m, get_key, l) {
        return create_with_key_exn(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, l);
    }
    function group$1(growth_allowed, size, m, get_key, get_data, combine, l) {
        return group(growth_allowed, size, caml_call1(Base_Hashable[3], m), get_key, get_data, combine, l);
    }
    function hashable_s(t) {
        return caml_call1(Base_Hashable[4], t[4]);
    }
    function M(K) {
        return [
            0
        ];
    }
    function sexp_of_m_t(K, sexp_of_v, t) {
        return sexp_of_t(K[1], sexp_of_v, t);
    }
    function m_t_of_sexp(K, v_of_sexp, sexp) {
        var _e_ = K[1];
        return t_of_sexp(caml_call1(Base_Hashable[3], [
            0,
            K[2],
            K[3],
            K[4]
        ]), _e_, v_of_sexp, sexp);
    }
    function m_t_sexp_grammar(K, v_grammar) {
        return t_sexp_grammar(K[1], v_grammar);
    }
    function equal_m_t(param, equal_v, t1, t2) {
        return similar(equal_v, t1, t2);
    }
    var Base_Hashtbl = [
        0,
        hash,
        hash_param,
        sexp_of_t,
        create$1,
        of_alist$1,
        of_alist_report_all_dups$1,
        of_alist_or_error$1,
        of_alist_exn$1,
        of_alist_multi$1,
        create_mapped$1,
        create_with_key$1,
        create_with_key_or_error$1,
        create_with_key_exn$1,
        group$1,
        sexp_of_key,
        clear,
        copy,
        fold,
        iter_keys,
        iter,
        iteri,
        existsi,
        exists,
        for_alli,
        for_all,
        counti,
        count,
        length,
        capacity,
        is_empty,
        mem,
        remove,
        choose,
        choose_exn,
        choose_randomly,
        choose_randomly_exn,
        set,
        add,
        add_exn,
        change,
        update,
        update_and_return,
        map,
        mapi,
        filter_map,
        filter_mapi,
        filter_keys,
        filter,
        filteri,
        partition_map,
        partition_mapi,
        partition_tf,
        partitioni_tf,
        find_or_add,
        findi_or_add,
        find,
        find_exn,
        find_and_call,
        find_and_call1,
        find_and_call2,
        findi_and_call,
        findi_and_call1,
        findi_and_call2,
        find_and_remove,
        merge,
        merge_into,
        keys,
        data,
        filter_keys_inplace,
        filter_inplace,
        filteri_inplace,
        map_inplace,
        mapi_inplace,
        filter_map_inplace,
        filter_mapi_inplace,
        similar,
        similar,
        to_alist,
        incr,
        decr,
        add_multi,
        remove_multi,
        find_multi,
        hashable_s,
        invariant,
        Creators,
        [
            0,
            t_of_sexp$0,
            sexp_of_t,
            t_sexp_grammar,
            hashable,
            invariant,
            create$0,
            of_alist$0,
            of_alist_report_all_dups$0,
            of_alist_or_error$0,
            of_alist_exn$0,
            of_alist_multi$0,
            create_mapped$0,
            create_with_key$0,
            create_with_key_or_error$0,
            create_with_key_exn$0,
            group$0,
            sexp_of_key,
            clear,
            copy,
            fold,
            iter_keys,
            iter,
            iteri,
            existsi,
            exists,
            for_alli,
            for_all,
            counti,
            count,
            length,
            capacity,
            is_empty,
            mem,
            remove,
            choose,
            choose_exn,
            choose_randomly,
            choose_randomly_exn,
            set,
            add,
            add_exn,
            change,
            update,
            update_and_return,
            map,
            mapi,
            filter_map,
            filter_mapi,
            filter_keys,
            filter,
            filteri,
            partition_map,
            partition_mapi,
            partition_tf,
            partitioni_tf,
            find_or_add,
            findi_or_add,
            find,
            find_exn,
            find_and_call,
            find_and_call1,
            find_and_call2,
            findi_and_call,
            findi_and_call1,
            findi_and_call2,
            find_and_remove,
            merge,
            merge_into,
            keys,
            data,
            filter_keys_inplace,
            filter_inplace,
            filteri_inplace,
            map_inplace,
            mapi_inplace,
            filter_map_inplace,
            filter_mapi_inplace,
            similar,
            similar,
            to_alist,
            incr,
            decr,
            add_multi,
            remove_multi,
            find_multi
        ],
        M,
        sexp_of_m_t,
        m_t_of_sexp,
        m_t_sexp_grammar,
        equal_m_t,
        Private
    ];
    runtime.caml_register_global(26, Base_Hashtbl, "Base__Hashtbl");
    return;
})(globalThis);
//# 40965 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst_out_of_range_0 = " out of range [0, ", cst_s_1e = "%s%.1e", cst_is_too_large = ") is too large", cst_is_too_small_or_NaN = ") is too small or NaN", cst$5 = ".", cst_Float_int63_round_down_exn = "Float.int63_round_down_exn: argument (", cst_Float_int63_round_nearest_ = "Float.int63_round_nearest_portable_alloc_exn: argument (", cst_Float_int63_round_up_exn_a = "Float.int63_round_up_exn: argument (", cst_Float_iround_down_exn_argu = "Float.iround_down_exn: argument (", cst_Float_iround_nearest_exn_a = "Float.iround_nearest_exn: argument (", cst_Float_iround_nearest_exn_a$0 = "Float.iround_nearest_exn: argument (%f) is too large", cst_Float_iround_up_exn_argume = "Float.iround_up_exn: argument (", cst_Infinite = "Infinite", cst_Nan = "Nan", cst_Normal = "Normal", cst_Subnormal = "Subnormal", cst_Zero = "Zero", cst_infinite = "infinite", cst_nan$1 = "nan", cst_normal = "normal", cst_src_float_ml = "src/float.ml", cst_subnormal = "subnormal", cst_zero = "zero", caml_bytes_set = runtime.caml_bytes_set, caml_float_compare = runtime.caml_float_compare, caml_format_float = runtime.caml_format_float, caml_int64_bits_of_float = runtime.caml_int64_bits_of_float, caml_int64_or = runtime.caml_int64_or, caml_int_compare = runtime.caml_int_compare, caml_log10_float = runtime.caml_log10_float, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_string_compare = runtime.caml_string_compare;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$3 = cst$4, cst$2 = cst$4, cst$1 = "-", cst$0 = cst$5, cst = cst$5, all = [
        0,
        0,
        [
            0,
            1,
            [
                0,
                2,
                [
                    0,
                    3,
                    [
                        0,
                        4,
                        0
                    ]
                ]
            ]
        ]
    ], error_source_007 = "float.ml.Class.t", t_sexp_grammar$0 = [
        3,
        [
            0,
            2,
            [
                0,
                [
                    1,
                    [
                        0,
                        cst_Infinite,
                        0
                    ]
                ],
                [
                    0,
                    [
                        1,
                        [
                            0,
                            cst_Nan,
                            0
                        ]
                    ],
                    [
                        0,
                        [
                            1,
                            [
                                0,
                                cst_Normal,
                                0
                            ]
                        ],
                        [
                            0,
                            [
                                1,
                                [
                                    0,
                                    cst_Subnormal,
                                    0
                                ]
                            ],
                            [
                                0,
                                [
                                    1,
                                    [
                                        0,
                                        cst_Zero,
                                        0
                                    ]
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ], module_name = "Base.Float", Base_Printf = global_data.Base__Printf, Base_Or_error = global_data.Base__Or_error, Base_Int = global_data.Base__Int, Base_Int63 = global_data.Base__Int63, Stdlib_Int64 = global_data.Stdlib__Int64, Base_Int64 = global_data.Base__Int64, Base_Sexp = global_data.Base__Sexp, Base_Error = global_data.Base__Error, Assert_failure = global_data.Assert_failure, Base_Import = global_data.Base__Import, Base_String = global_data.Base__String, Base_Bytes0 = global_data.Base__Bytes0, Base_Char = global_data.Base__Char, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Sexplib0_Sexp_conv_error = global_data.Sexplib0__Sexp_conv_error, Base_Float0 = global_data.Base__Float0, Base_Comparator = global_data.Base__Comparator, Base_Word_size = global_data.Base__Word_size, Base_Comparable = global_data.Base__Comparable, Base_Pretty_printer = global_data.Base__Pretty_printer, round_up = Base_Float0[1], round_down = Base_Float0[2], mod_float = Base_Float0[3], modf = Base_Float0[4], float_of_string = Base_Float0[5], float_of_string_opt = Base_Float0[6], nan = Base_Float0[7], max_value = Base_Float0[8], neg_infinity = Base_Float0[9], max_finite_value = Base_Float0[10], epsilon_float = Base_Float0[11], classify_float = Base_Float0[12], abs_float = Base_Float0[13], is_integer = Base_Float0[14], symbol = Base_Float0[15], symbol$0 = Base_Float0[16], frexp = Base_Float0[17], ldexp = Base_Float0[18], is_nan = Base_Float0[19], to_int64_preserve_order = Base_Float0[20], to_int64_preserve_order_exn = Base_Float0[21], of_int64_preserve_order = Base_Float0[22], one_ulp = Base_Float0[23], upper_bound_for_int = Base_Float0[24], lower_bound_for_int = Base_Float0[26], clamp_unchecked = Base_Float0[28], box = Base_Float0[29], raise_s = Base_Error[32], hash_fold_t = Base_Import[209], func = Base_Import[223];
    function hash(x) {
        return caml_call1(func, x);
    }
    var globalize = Base_Import[283], t_of_sexp = Base_Import[164], sexp_of_t = Base_Import[140], t_sexp_grammar = Base_Import[186], hashable = [
        0,
        hash,
        caml_float_compare,
        sexp_of_t
    ], compare = caml_float_compare, include = caml_call1(Base_Comparator[7], [
        0,
        compare,
        sexp_of_t
    ]), comparator = include[1], _a_ = [
        0,
        [
            11,
            "Float.of_string ",
            [
                2,
                0,
                0
            ]
        ],
        "Float.of_string %s"
    ];
    function invariant(param) {
        return 0;
    }
    function to_float(x) {
        return x;
    }
    function of_float(x) {
        return x;
    }
    function of_string(s) {
        try {
            var _a1_ = caml_call1(float_of_string, s);
            return _a1_;
        } catch (_a2_) {
            return caml_call3(Base_Printf[7], _a_, s, 0);
        }
    }
    function to_string(x) {
        var y = caml_format_float("%.15g", x), y$0 = caml_call1(float_of_string, y) === x ? y : caml_format_float("%.17g", x), l = runtime.caml_ml_string_length(y$0), i = 0;
        for(;;){
            if (l <= i) return caml_call2(Base_Import[112], y$0, cst);
            var match = runtime.caml_string_get(y$0, i);
            a: {
                if (48 <= match) {
                    if (58 > match) break a;
                } else if (45 === match) break a;
                return y$0;
            }
            var i$0 = caml_call2(Base_Import[91], i, 1);
            i = i$0;
        }
    }
    var min_positive_subnormal_value = caml_call2(symbol, 2., -1074), min_positive_normal_value = caml_call2(symbol, 2., -1022), zero = 0., of_int = Base_Int[4], to_int = Base_Int[3];
    function of_int63(i) {
        return caml_call1(Base_Int63[3], i);
    }
    var of_int64 = runtime.caml_int64_to_float, to_int64 = runtime.caml_int64_of_float, iround_lbound = caml_call1(lower_bound_for_int, Base_Int[64]), iround_ubound = caml_call1(upper_bound_for_int, Base_Int[64]), _b_ = [
        0,
        [
            11,
            cst_Float_iround_up_exn_argume,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.iround_up_exn: argument (%f) is too large"
    ], _c_ = [
        0,
        [
            11,
            cst_Float_iround_up_exn_argume,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_up_exn: argument (%f) is too small or NaN"
    ], _d_ = [
        0,
        [
            11,
            cst_Float_iround_down_exn_argu,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.iround_down_exn: argument (%f) is too large"
    ], _e_ = [
        0,
        [
            11,
            cst_Float_iround_down_exn_argu,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_down_exn: argument (%f) is too small or NaN"
    ], _f_ = [
        0,
        [
            11,
            "Float.iround_towards_zero_exn: argument (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is out of range or NaN",
                    0
                ]
            ]
        ],
        "Float.iround_towards_zero_exn: argument (%f) is out of range or NaN"
    ];
    function iround_up(t) {
        if (!(0. < t)) return iround_lbound <= t ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var t$0 = caml_call1(round_up, t);
        return t$0 <= iround_ubound ? [
            0,
            caml_call1(Base_Int[63], t$0)
        ] : 0;
    }
    function iround_up_exn(t) {
        if (0. < t) {
            var t$0 = caml_call1(round_up, t);
            if (t$0 <= iround_ubound) return caml_call1(Base_Int[63], t$0);
            var _aZ_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _b_, _aZ_, 0);
        }
        if (iround_lbound <= t) return caml_call1(Base_Int[63], t);
        var _a0_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _c_, _a0_, 0);
    }
    function iround_down(t) {
        if (0. <= t) return t <= iround_ubound ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var t$0 = caml_call1(round_down, t);
        return iround_lbound <= t$0 ? [
            0,
            caml_call1(Base_Int[63], t$0)
        ] : 0;
    }
    function iround_down_exn(t) {
        if (0. <= t) {
            if (t <= iround_ubound) return caml_call1(Base_Int[63], t);
            var _aX_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _d_, _aX_, 0);
        }
        var t$0 = caml_call1(round_down, t);
        if (iround_lbound <= t$0) return caml_call1(Base_Int[63], t$0);
        var _aY_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _e_, _aY_, 0);
    }
    function iround_towards_zero(t) {
        if (iround_lbound <= t && t <= iround_ubound) return [
            0,
            caml_call1(Base_Int[63], t)
        ];
        return 0;
    }
    function iround_towards_zero_exn(t) {
        if (iround_lbound <= t && t <= iround_ubound) return caml_call1(Base_Int[63], t);
        var _aW_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _f_, _aW_, 0);
    }
    var _g_ = caml_call2(symbol, 2., 52.), round_nearest_lb = caml_call1(Base_Import[114], _g_), round_nearest_ub = caml_call2(symbol, 2., 52.), one_ulp_less_than_half = caml_call2(one_ulp, 759637122, 0.5);
    function add_half_for_round_nearest(t) {
        var _aV_ = t === one_ulp_less_than_half ? one_ulp_less_than_half : 0.5;
        return caml_call2(Base_Import[92], t, _aV_);
    }
    function iround_nearest_32(t) {
        if (0. <= t) {
            var t$0 = add_half_for_round_nearest(t);
            return t$0 <= iround_ubound ? [
                0,
                caml_call1(Base_Int[63], t$0)
            ] : 0;
        }
        var t$1 = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        return iround_lbound <= t$1 ? [
            0,
            caml_call1(Base_Int[63], t$1)
        ] : 0;
    }
    function iround_nearest_64(t) {
        if (0. <= t) {
            if (!(t < round_nearest_ub)) return t <= iround_ubound ? [
                0,
                caml_call1(Base_Int[63], t)
            ] : 0;
            var _aT_ = add_half_for_round_nearest(t);
            return [
                0,
                caml_call1(Base_Int[63], _aT_)
            ];
        }
        if (!(round_nearest_lb < t)) return iround_lbound <= t ? [
            0,
            caml_call1(Base_Int[63], t)
        ] : 0;
        var _aU_ = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        return [
            0,
            caml_call1(Base_Int[63], _aU_)
        ];
    }
    var _R_ = [
        0,
        [
            8,
            [
                0,
                0,
                4
            ],
            0,
            [
                0,
                8
            ],
            0
        ],
        "%.8G"
    ], _P_ = [
        0,
        [
            11,
            "exponent ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    cst_out_of_range_0,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "exponent %d out of range [0, %d]"
    ], _Q_ = [
        0,
        [
            11,
            "mantissa ",
            [
                2,
                0,
                [
                    11,
                    cst_out_of_range_0,
                    [
                        2,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "mantissa %s out of range [0, %s]"
    ], cst_Float_sign_exn_of_NAN = "Float.sign_exn of NAN", cst_max = "max", cst_min = "min", cst_clamp_requires_min_max = "clamp requires [min <= max]", _L_ = [
        0,
        cst_src_float_ml,
        865,
        2
    ], _K_ = [
        0,
        [
            11,
            "Float.round_significant: invalid argument significant_digits:",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "Float.round_significant: invalid argument significant_digits:%d"
    ], _J_ = [
        0,
        [
            8,
            [
                0,
                0,
                3
            ],
            0,
            1,
            0
        ],
        "%.*g"
    ], _I_ = [
        0,
        "p"
    ], cst_t = "t", cst_g = "g", cst_m = "m", cst_k = "k", _F_ = [
        0,
        cst_src_float_ml,
        703,
        8
    ], _E_ = [
        0,
        cst_src_float_ml,
        706,
        8
    ], _A_ = [
        0,
        cst_src_float_ml,
        713,
        8
    ], _B_ = [
        0,
        cst_src_float_ml,
        714,
        8
    ], _C_ = [
        0,
        [
            2,
            0,
            [
                4,
                0,
                0,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        0
                    ]
                ]
            ]
        ],
        "%s%d%s "
    ], _D_ = [
        0,
        [
            2,
            0,
            [
                4,
                0,
                0,
                0,
                [
                    2,
                    0,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "%s%d%s%d"
    ], _z_ = [
        0,
        cst_src_float_ml,
        690,
        8
    ], cst_0 = ".0", _G_ = [
        0,
        [
            2,
            0,
            [
                8,
                [
                    0,
                    0,
                    1
                ],
                0,
                [
                    0,
                    1
                ],
                0
            ]
        ],
        cst_s_1e
    ], _H_ = [
        0,
        [
            2,
            0,
            [
                8,
                [
                    0,
                    0,
                    1
                ],
                0,
                [
                    0,
                    1
                ],
                0
            ]
        ],
        cst_s_1e
    ], cst_inf$1 = "-inf  ", cst_inf$2 = "inf  ", cst_nan$0 = "nan  ", cst_sexp = "sexp", cst_sexp_of_float_produced_str = "[sexp_of_float] produced strange sexp", _w_ = [
        0,
        [
            11,
            "to_string_hum: invalid argument ~decimals=",
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        "to_string_hum: invalid argument ~decimals=%d"
    ], _x_ = [
        0,
        [
            8,
            [
                0,
                1,
                0
            ],
            0,
            1,
            0
        ],
        "%+.*f"
    ], _y_ = [
        0,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            1,
            0
        ],
        "%.*f"
    ], cst_inf = "inf", cst_inf$0 = "-inf", cst_nan = cst_nan$1, _r_ = [
        0,
        cst_Infinite
    ], _s_ = [
        0,
        cst_Nan
    ], _t_ = [
        0,
        cst_Normal
    ], _u_ = [
        0,
        cst_Subnormal
    ], _v_ = [
        0,
        cst_Zero
    ], _p_ = [
        0,
        [
            11,
            cst_Float_int63_round_nearest_,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too large"
    ], _q_ = [
        0,
        [
            11,
            cst_Float_int63_round_nearest_,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_nearest_portable_alloc_exn: argument (%f) is too small or NaN"
    ], _n_ = [
        0,
        [
            11,
            cst_Float_int63_round_down_exn,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_down_exn: argument (%f) is too large"
    ], _o_ = [
        0,
        [
            11,
            cst_Float_int63_round_down_exn,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_down_exn: argument (%f) is too small or NaN"
    ], _l_ = [
        0,
        [
            11,
            cst_Float_int63_round_up_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        "Float.int63_round_up_exn: argument (%f) is too large"
    ], _m_ = [
        0,
        [
            11,
            cst_Float_int63_round_up_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.int63_round_up_exn: argument (%f) is too small or NaN"
    ], _j_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        cst_Float_iround_nearest_exn_a$0
    ], _k_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_small_or_NaN,
                    0
                ]
            ]
        ],
        "Float.iround_nearest_exn: argument (%f) is too small or NaN"
    ], _h_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    cst_is_too_large,
                    0
                ]
            ]
        ],
        cst_Float_iround_nearest_exn_a$0
    ], _i_ = [
        0,
        [
            11,
            cst_Float_iround_nearest_exn_a,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    11,
                    ") is too small",
                    0
                ]
            ]
        ],
        "Float.iround_nearest_exn: argument (%f) is too small"
    ], one = 1., minus_one = -1, pi = 3.141592653589793, sqrt_pi = 1.772453850905516, sqrt_2pi = 2.5066282746310007, euler = 0.5772156649015329, iround_nearest_64$0 = Base_Word_size[3] ? iround_nearest_64 : iround_nearest_32;
    function iround_nearest_exn_32(t) {
        if (0. <= t) {
            var t$0 = add_half_for_round_nearest(t);
            if (t$0 <= iround_ubound) return caml_call1(Base_Int[63], t$0);
            var _aR_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _h_, _aR_, 0);
        }
        var t$1 = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
        if (iround_lbound <= t$1) return caml_call1(Base_Int[63], t$1);
        var _aS_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _i_, _aS_, 0);
    }
    function iround_nearest_exn_64(t) {
        if (0. <= t) {
            if (t < round_nearest_ub) {
                var _aN_ = add_half_for_round_nearest(t);
                return caml_call1(Base_Int[63], _aN_);
            }
            if (t <= iround_ubound) return caml_call1(Base_Int[63], t);
            var _aO_ = caml_call1(box, t);
            return caml_call3(Base_Printf[7], _j_, _aO_, 0);
        }
        if (round_nearest_lb < t) {
            var _aP_ = caml_call1(round_down, caml_call2(Base_Import[92], t, 0.5));
            return caml_call1(Base_Int[63], _aP_);
        }
        if (iround_lbound <= t) return caml_call1(Base_Int[63], t);
        var _aQ_ = caml_call1(box, t);
        return caml_call3(Base_Printf[7], _k_, _aQ_, 0);
    }
    var iround_nearest_exn = Base_Word_size[3] ? iround_nearest_exn_64 : iround_nearest_exn_32;
    function iround_exn(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        return 857423934 <= dir ? 1003109192 <= dir ? iround_towards_zero_exn(t) : iround_nearest_exn(t) : 759637122 <= dir ? iround_down_exn(t) : iround_up_exn(t);
    }
    function iround(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        try {
            var _aL_ = [
                0,
                iround_exn([
                    0,
                    dir
                ], t)
            ];
            return _aL_;
        } catch (_aM_) {
            return 0;
        }
    }
    function is_inf(t) {
        return caml_call2(Base_Import[96], 1., t) === 0. ? 1 : 0;
    }
    function is_finite(t) {
        return caml_call2(Base_Import[94], t, t) === 0. ? 1 : 0;
    }
    function min_inan(x, y) {
        return caml_call1(is_nan, y) ? x : caml_call1(is_nan, x) ? y : x < y ? x : y;
    }
    function max_inan(x, y) {
        return caml_call1(is_nan, y) ? x : caml_call1(is_nan, x) ? y : y < x ? x : y;
    }
    var add = Base_Import[92], sub = Base_Import[94], neg = Base_Import[114], scale = Base_Import[90];
    function square(x) {
        return caml_call2(Base_Import[90], x, x);
    }
    function fractional(t) {
        return caml_call1(Base_Import[125], t);
    }
    function integral(t) {
        return caml_call1(Base_Import[127], t);
    }
    function round_towards_zero(t) {
        return 0. <= t ? caml_call1(round_down, t) : caml_call1(round_up, t);
    }
    function round_nearest_inline(t) {
        if (round_nearest_lb < t && t < round_nearest_ub) return caml_call1(round_down, add_half_for_round_nearest(t));
        return caml_call2(Base_Import[92], t, 0.);
    }
    function round_nearest(t) {
        return round_nearest_inline(t);
    }
    function round_nearest_half_to_even(t) {
        if (!(t <= round_nearest_lb) && !(round_nearest_ub <= t)) {
            var floor = caml_call1(round_down, t), ceil_or_succ = caml_call2(Base_Import[92], floor, 1.), diff_floor = caml_call2(Base_Import[94], t, floor), diff_ceil = caml_call2(Base_Import[94], ceil_or_succ, t);
            return diff_floor < diff_ceil ? floor : diff_ceil < diff_floor ? ceil_or_succ : caml_call2(mod_float, floor, 2.) === 0. ? floor : ceil_or_succ;
        }
        return caml_call2(Base_Import[92], t, 0.);
    }
    var int63_round_lbound = caml_call1(lower_bound_for_int, Base_Int63[87]), int63_round_ubound = caml_call1(upper_bound_for_int, Base_Int63[87]);
    function int63_round_up_exn(t) {
        if (0. < t) {
            var t$0 = caml_call1(round_up, t);
            if (t$0 <= int63_round_ubound) return caml_call1(Base_Int63[86], t$0);
            var _aJ_ = caml_call1(Base_Float0[29], t);
            return caml_call3(Base_Printf[7], _l_, _aJ_, 0);
        }
        if (int63_round_lbound <= t) return caml_call1(Base_Int63[86], t);
        var _aK_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _m_, _aK_, 0);
    }
    function int63_round_down_exn(t) {
        if (0. <= t) {
            if (t <= int63_round_ubound) return caml_call1(Base_Int63[86], t);
            var _aH_ = caml_call1(Base_Float0[29], t);
            return caml_call3(Base_Printf[7], _n_, _aH_, 0);
        }
        var t$0 = caml_call1(round_down, t);
        if (int63_round_lbound <= t$0) return caml_call1(Base_Int63[86], t$0);
        var _aI_ = caml_call1(Base_Float0[29], t);
        return caml_call3(Base_Printf[7], _o_, _aI_, 0);
    }
    function int63_round_nearest_portable_a(t0) {
        var t = round_nearest_inline(t0);
        if (0. < t) {
            if (t <= int63_round_ubound) return caml_call1(Base_Int63[86], t);
            var _aF_ = caml_call1(box, t0);
            return caml_call3(Base_Printf[7], _p_, _aF_, 0);
        }
        if (int63_round_lbound <= t) return caml_call1(Base_Int63[86], t);
        var _aG_ = caml_call1(box, t0);
        return caml_call3(Base_Printf[7], _q_, _aG_, 0);
    }
    function int63_round_nearest_arch64_noa(f) {
        var _aE_ = iround_nearest_exn(f);
        return caml_call1(Base_Int63[100], _aE_);
    }
    var int63_round_nearest_exn = Base_Word_size[3] ? int63_round_nearest_arch64_noa : int63_round_nearest_portable_a;
    function round(opt, t) {
        var dir = opt ? opt[1] : 857423934;
        return 857423934 <= dir ? 1003109192 <= dir ? round_towards_zero(t) : round_nearest_inline(t) : 759637122 <= dir ? caml_call1(round_down, t) : caml_call1(round_up, t);
    }
    var compare_local = caml_int_compare;
    function compare$0(a, b) {
        return caml_int_compare(a, b);
    }
    function t_of_sexp$0(sexp_008) {
        a: {
            if (0 === sexp_008[0]) {
                var _ay_ = sexp_008[1], _az_ = caml_string_compare(_ay_, cst_infinite);
                b: {
                    c: {
                        d: {
                            e: {
                                if (0 <= _az_) {
                                    if (0 < _az_) {
                                        if (_ay_ === cst_nan$1) break e;
                                        if (_ay_ === cst_normal) break d;
                                        if (_ay_ === cst_subnormal) break c;
                                        if (_ay_ !== cst_zero) break a;
                                        break b;
                                    }
                                } else if (_ay_ !== cst_Infinite) {
                                    if (_ay_ === cst_Nan) break e;
                                    if (_ay_ === cst_Normal) break d;
                                    if (_ay_ === cst_Subnormal) break c;
                                    if (_ay_ !== cst_Zero) break a;
                                    break b;
                                }
                                return 0;
                            }
                            return 1;
                        }
                        return 2;
                    }
                    return 3;
                }
                return 4;
            }
            var _aA_ = sexp_008[1];
            if (!_aA_) return caml_call2(Sexplib0_Sexp_conv_error[11], error_source_007, sexp_008);
            var _aB_ = _aA_[1];
            if (0 !== _aB_[0]) return caml_call2(Sexplib0_Sexp_conv_error[10], error_source_007, sexp_008);
            var _aC_ = _aB_[1], _aD_ = caml_string_compare(_aC_, cst_infinite);
            b: {
                c: {
                    d: {
                        e: {
                            if (0 <= _aD_) {
                                if (0 < _aD_) {
                                    if (_aC_ === cst_nan$1) break e;
                                    if (_aC_ === cst_normal) break d;
                                    if (_aC_ === cst_subnormal) break c;
                                    if (_aC_ !== cst_zero) break a;
                                    break b;
                                }
                            } else if (_aC_ !== cst_Infinite) {
                                if (_aC_ === cst_Nan) break e;
                                if (_aC_ === cst_Normal) break d;
                                if (_aC_ === cst_Subnormal) break c;
                                if (_aC_ !== cst_Zero) break a;
                                break b;
                            }
                            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                        }
                        return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                    }
                    return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
                }
                return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
            }
            return caml_call2(Sexplib0_Sexp_conv_error[7], error_source_007, sexp_008);
        }
        return caml_call2(Sexplib0_Sexp_conv_error[12], error_source_007, sexp_008);
    }
    function sexp_of_t$0(param) {
        switch(param){
            case 0:
                return _r_;
            case 1:
                return _s_;
            case 2:
                return _t_;
            case 3:
                return _u_;
            default:
                return _v_;
        }
    }
    function to_string$0(t) {
        var _ax_ = sexp_of_t$0(t);
        return caml_call1(Base_Import[160], _ax_);
    }
    function of_string$0(s) {
        return t_of_sexp$0(caml_call1(Base_Import[136], s));
    }
    function classify(t) {
        switch(caml_call1(classify_float, t)){
            case 0:
                return 2;
            case 1:
                return 3;
            case 2:
                return 4;
            case 3:
                return 0;
            default:
                return 1;
        }
    }
    function insert_underscores(_av_, opt, string) {
        var delimiter = _av_ ? _av_[1] : 95, strip_zero = opt ? opt[1] : 0, match = caml_call2(Base_String[100], string, 46);
        if (!match) return caml_call2(Base_Int_string_conversions[6], string, delimiter);
        var match$0 = match[1], right = match$0[2], left = match$0[1], left$0 = caml_call2(Base_Int_string_conversions[6], left, delimiter), right$0 = strip_zero ? caml_call2(Base_String[108], [
            0,
            function(c) {
                return caml_call2(Base_Char[12], c, 48);
            }
        ], right) : right;
        if (right$0 === cst$4) return left$0;
        var _aw_ = caml_call2(Base_Import[112], cst$0, right$0);
        return caml_call2(Base_Import[112], left$0, _aw_);
    }
    function to_string_hum(delimiter, _au_, strip_zero, opt, f) {
        var decimals = _au_ ? _au_[1] : 3, explicit_plus = opt ? opt[1] : 0;
        if (decimals < 0) caml_call3(Base_Printf[7], _w_, decimals, 0);
        var match = classify(f);
        if (1 === match) return cst_nan;
        if (!match) return 0. < f ? cst_inf : cst_inf$0;
        var s = explicit_plus ? caml_call3(Base_Printf[2], _x_, decimals, f) : caml_call3(Base_Printf[2], _y_, decimals, f);
        return insert_underscores(delimiter, strip_zero, s);
    }
    function sexp_of_t$1(t) {
        var sexp = caml_call1(sexp_of_t, t);
        if (1009018843 <= Base_Sexp[19][1]) return sexp;
        if (0 === sexp[0]) {
            var string = sexp[1];
            return caml_call4(Base_String[70], 0, 0, string, 69) ? sexp : [
                0,
                insert_underscores(0, 0, string)
            ];
        }
        var _at_ = [
            0,
            [
                0,
                cst_sexp,
                caml_call1(Base_Sexp[5], sexp)
            ],
            0
        ];
        return caml_call1(raise_s, caml_call2(Base_Sexp[10], cst_sexp_of_float_produced_str, _at_));
    }
    function to_padded_compact_string_custo(t, opt, kilo, mega, giga, tera, peta, param) {
        var prefix = opt ? opt[1] : cst$2, match = classify(t);
        if (1 === match) return cst_nan$0;
        if (!match) return t < 0. ? cst_inf$1 : cst_inf$2;
        function go(t) {
            function conv(mag, numerator, denominator) {
                a: {
                    if (denominator === 100. && 999.95 <= numerator) break a;
                    if (100000. <= denominator) {
                        var t$0 = caml_call2(Base_Import[90], denominator, 9.9995);
                        if (round_nearest_inline(t$0) <= numerator) break a;
                    }
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _F_
                    ], 1);
                }
                var t = caml_call2(Base_Import[90], denominator, 9999.5);
                if (!(numerator < round_nearest_inline(t))) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _E_
                ], 1);
                var k = caml_call1(round_down, caml_call2(Base_Import[96], numerator, denominator)), lower = caml_call2(Base_Import[90], denominator, k), _as_ = caml_call2(Base_Import[92], k, 1.), higher = caml_call2(Base_Import[90], denominator, _as_), diff_right = caml_call2(Base_Import[94], higher, numerator), diff_left = caml_call2(Base_Import[94], numerator, lower), k$0 = iround_nearest_exn(k), k$1 = diff_right < diff_left ? caml_call2(Base_Import[91], k$0, 1) : diff_left < diff_right ? k$0 : 0 === caml_call2(Base_Import[122], k$0, 2) ? k$0 : caml_call2(Base_Import[91], k$0, 1), d = caml_call2(Base_Import[122], k$1, 10), i = caml_call2(Base_Import[95], k$1, 10);
                if (0 <= i && 1000 > i) {
                    if (0 <= d && 10 > d) return 0 === d ? caml_call4(Base_Printf[2], _C_, prefix, i, mag) : caml_call5(Base_Printf[2], _D_, prefix, i, mag, d);
                    throw caml_maybe_attach_backtrace([
                        0,
                        Assert_failure,
                        _B_
                    ], 1);
                }
                throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _A_
                ], 1);
            }
            if (!(t < 999.95)) {
                if (t < 999950.) return conv(kilo, t, 100.);
                if (t < 999950000.) return conv(mega, t, 100000.);
                if (t < 999950000000.) return conv(giga, t, 100000000.);
                if (t < 999950000000000.) return conv(tera, t, 100000000000.);
                if (!peta) return caml_call3(Base_Printf[2], _H_, prefix, t);
                var peta$0 = peta[1];
                return t < 999950000000000000. ? conv(peta$0, t, 100000000000000.) : caml_call3(Base_Printf[2], _G_, prefix, t);
            }
            if (0. <= t && t < 999.95) {
                var x = caml_call2(Base_Import[112], prefix, caml_format_float("%.1f", t));
                if (!caml_call2(Base_String[96], x, cst_0)) return x;
                var x$0 = caml_call1(Base_Bytes0[21], x), n = runtime.caml_ml_bytes_length(x$0);
                caml_bytes_set(x$0, caml_call2(Base_Import[93], n, 1), 32);
                caml_bytes_set(x$0, caml_call2(Base_Import[93], n, 2), 32);
                return runtime.caml_string_of_bytes(x$0);
            }
            throw caml_maybe_attach_backtrace([
                0,
                Assert_failure,
                _z_
            ], 1);
        }
        if (0. <= t) return go(t);
        var _ar_ = go(caml_call1(Base_Import[114], t));
        return caml_call2(Base_Import[112], cst$1, _ar_);
    }
    function to_padded_compact_string(t) {
        return to_padded_compact_string_custo(t, 0, cst_k, cst_m, cst_g, cst_t, _I_, 0);
    }
    function int_pow(x, n) {
        if (0 === n) return 1.;
        var x$0 = [
            0,
            caml_call2(Base_Import[92], x, -0)
        ], n$0 = [
            0,
            n
        ], accum = [
            0,
            1.
        ];
        if (n$0[1] < 0) {
            x$0[1] = caml_call2(Base_Import[96], 1., x$0[1]);
            n$0[1] = caml_call1(Base_Import[113], n$0[1]);
            if (n$0[1] < 0) {
                accum[1] = x$0[1];
                n$0[1]--;
            }
        }
        for(;;){
            if (1 >= n$0[1]) return caml_call2(Base_Import[90], x$0[1], accum[1]);
            if (0 !== caml_call2(Base_Import[116], n$0[1], 1)) accum[1] = caml_call2(Base_Import[90], x$0[1], accum[1]);
            x$0[1] = caml_call2(Base_Import[90], x$0[1], x$0[1]);
            n$0[1] = caml_call2(Base_Import[120], n$0[1], 1);
        }
    }
    function round_gen(x, how) {
        if (x === 0.) return 0.;
        if (!is_finite(x)) return x;
        if (555917426 <= how[1]) var sd = how[2], _an_ = caml_call1(to_int, caml_call1(round_up, caml_log10_float(caml_call1(abs_float, x)))), dd = caml_call2(Base_Import[93], sd, _an_), dd$0 = dd, sd$0 = sd;
        else var dd$1 = how[2], _aq_ = caml_call1(to_int, caml_call1(round_up, caml_log10_float(caml_call1(abs_float, x)))), sd$1 = caml_call2(Base_Import[91], dd$1, _aq_), dd$0 = dd$1, sd$0 = sd$1;
        if (0 > sd$0) return 0.;
        if (17 <= sd$0) return x;
        var abs_dd = caml_call1(Base_Int[78], dd$0);
        if (22 >= abs_dd && 16 > sd$0) {
            var order = int_pow(10., abs_dd);
            if (0 <= dd$0) {
                var _ao_ = round_nearest_half_to_even(caml_call2(Base_Import[90], x, order));
                return caml_call2(Base_Import[96], _ao_, order);
            }
            var _ap_ = round_nearest_half_to_even(caml_call2(Base_Import[96], x, order));
            return caml_call2(Base_Import[90], _ap_, order);
        }
        return of_string(caml_call3(Base_Printf[2], _J_, sd$0, x));
    }
    function round_significant(x, significant_digits) {
        return 0 < significant_digits ? round_gen(x, [
            0,
            555917426,
            significant_digits
        ]) : caml_call3(Base_Printf[7], _K_, significant_digits, 0);
    }
    function round_decimal(x, decimal_digits) {
        return round_gen(x, [
            0,
            -352548012,
            decimal_digits
        ]);
    }
    function between(t, low, high) {
        var _al_ = low <= t ? 1 : 0, _am_ = _al_ ? t <= high ? 1 : 0 : _al_;
        return _am_;
    }
    function clamp_exn(t, min, max) {
        if (min <= max) return caml_call3(clamp_unchecked, t, min, max);
        throw caml_maybe_attach_backtrace([
            0,
            Assert_failure,
            _L_
        ], 1);
    }
    function clamp(t, min, max) {
        if (min <= max) return [
            0,
            caml_call3(clamp_unchecked, t, min, max)
        ];
        var _ai_ = [
            0,
            [
                0,
                cst_max,
                caml_call1(sexp_of_t, max)
            ],
            0
        ], _aj_ = [
            0,
            [
                0,
                cst_min,
                caml_call1(sexp_of_t, min)
            ],
            _ai_
        ], _ak_ = caml_call2(Base_Sexp[10], cst_clamp_requires_min_max, _aj_);
        return caml_call1(Base_Or_error[39], _ak_);
    }
    var symbol$1 = Base_Import[92], symbol$2 = Base_Import[94], symbol$3 = Base_Import[90], symbol$4 = Base_Import[96], symbol$5 = Base_Import[114];
    function sign_exn(t) {
        if (0. < t) return 2;
        if (t < 0.) return 0;
        if (t === 0.) return 1;
        var _ag_ = [
            0,
            [
                0,
                cst$3,
                sexp_of_t$1(t)
            ],
            0
        ], _ah_ = caml_call2(Base_Sexp[10], cst_Float_sign_exn_of_NAN, _ag_);
        return caml_call1(Base_Error[32], _ah_);
    }
    function sign_or_nan(t) {
        return 0. < t ? 2 : t < 0. ? 0 : t === 0. ? 1 : 3;
    }
    function ieee_negative(t) {
        var bits = caml_int64_bits_of_float(t);
        return runtime.caml_lessthan(bits, Stdlib_Int64[1]);
    }
    var mantissa_bits = 52, _M_ = Base_Int64[37], exponent_mask64 = runtime.caml_int64_sub(caml_call2(Base_Int64[53], Base_Int64[37], 11), _M_), exponent_mask = caml_call1(Base_Int64[6], exponent_mask64), _N_ = Base_Int63[43], _O_ = caml_call2(Base_Int63[76], Base_Int63[43], mantissa_bits), mantissa_mask = caml_call2(Base_Int63[46], _O_, _N_), mantissa_mask64 = caml_call1(Base_Int63[83], mantissa_mask);
    function ieee_exponent(t) {
        var bits = caml_int64_bits_of_float(t), _af_ = caml_call2(Base_Int64[67], bits, mantissa_bits);
        return runtime.caml_int64_to_int32(caml_call2(Base_Int64[48], _af_, exponent_mask64));
    }
    function ieee_mantissa(t) {
        var bits = caml_int64_bits_of_float(t);
        return caml_call1(Base_Int63[109], runtime.caml_int64_and(bits, mantissa_mask64));
    }
    function create_ieee_exn(negative, exponent, mantissa) {
        if (caml_call2(Base_Int[48], exponent, exponent_mask) !== exponent) return caml_call4(Base_Printf[6], _P_, exponent, exponent_mask, 0);
        var _ac_ = caml_call2(Base_Int63[71], mantissa, mantissa_mask);
        if (caml_call2(Base_Int63[17], _ac_, mantissa)) {
            var _ad_ = caml_call1(Base_Int63[11], mantissa_mask), _ae_ = caml_call1(Base_Int63[11], mantissa);
            return caml_call4(Base_Printf[6], _Q_, _ae_, _ad_, 0);
        }
        var sign_bits = negative ? Stdlib_Int64[10] : Stdlib_Int64[1], expt_bits = runtime.caml_int64_shift_left(runtime.caml_int64_of_int32(exponent), 52), mant_bits = caml_call1(Base_Int63[83], mantissa), bits = caml_int64_or(sign_bits, caml_int64_or(expt_bits, mant_bits));
        return runtime.caml_int64_float_of_bits(bits);
    }
    function create_ieee(negative, exponent, mantissa) {
        return caml_call2(Base_Or_error[31], 0, function(param) {
            return create_ieee_exn(negative, exponent, mantissa);
        });
    }
    function to_string$1(x) {
        return caml_call2(Base_Printf[2], _R_, x);
    }
    function sexp_of_t$2(x) {
        return [
            0,
            to_string$1(x)
        ];
    }
    function of_string$1(x) {
        return of_string(x);
    }
    var include$0 = caml_call1(Base_Comparable[14], [
        0,
        compare,
        sexp_of_t,
        zero
    ]), sign = include$0[5];
    function is_positive(t) {
        return 0. < t ? 1 : 0;
    }
    function is_non_negative(t) {
        return 0. <= t ? 1 : 0;
    }
    function is_negative(t) {
        return t < 0. ? 1 : 0;
    }
    function is_non_positive(t) {
        return t <= 0. ? 1 : 0;
    }
    var include$1 = caml_call1(Base_Pretty_printer[2], [
        0,
        module_name,
        to_string
    ]), pp = include$1[1];
    function symbol$6(_ab_, _aa_) {
        return _ab_ !== _aa_ ? 1 : 0;
    }
    function symbol$7(_$_, ___) {
        return _$_ < ___ ? 1 : 0;
    }
    function symbol$8(_Z_, _Y_) {
        return _Y_ < _Z_ ? 1 : 0;
    }
    function symbol$9(_X_, _W_) {
        return _X_ === _W_ ? 1 : 0;
    }
    function symbol$10(_V_, _U_) {
        return _V_ <= _U_ ? 1 : 0;
    }
    function symbol$11(_T_1, _S_) {
        return _S_ <= _T_1 ? 1 : 0;
    }
    function of_float$0(x) {
        return x;
    }
    var specialized_hash = Base_Import[223], Private = [
        0,
        box,
        clamp_unchecked,
        lower_bound_for_int,
        upper_bound_for_int,
        specialized_hash,
        one_ulp_less_than_half,
        int63_round_nearest_portable_a,
        int63_round_nearest_arch64_noa,
        iround_nearest_exn_64
    ], include$2 = Base_Import[108], ascending = include$2[1], descending = include$2[2], compare_local$0 = include$2[3], equal_local = include$2[4];
    function min(x, y) {
        if (!(x < y) && !caml_call1(is_nan, x)) return y;
        return x;
    }
    function max(x, y) {
        if (!(y < x) && !caml_call1(is_nan, x)) return y;
        return x;
    }
    var Base_Float = [
        0,
        globalize,
        t_sexp_grammar,
        of_float,
        to_float,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t$1,
        of_string,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        pp,
        hashable,
        float_of_string_opt,
        is_positive,
        is_non_negative,
        is_negative,
        is_non_positive,
        equal_local,
        compare_local$0,
        invariant,
        min,
        max,
        nan,
        max_value,
        neg_infinity,
        max_value,
        neg_infinity,
        zero,
        one,
        minus_one,
        pi,
        sqrt_pi,
        sqrt_2pi,
        euler,
        epsilon_float,
        max_finite_value,
        min_positive_subnormal_value,
        min_positive_normal_value,
        to_int64_preserve_order,
        to_int64_preserve_order_exn,
        of_int64_preserve_order,
        one_ulp,
        of_int,
        to_int,
        of_int63,
        of_int64,
        to_int64,
        round,
        iround,
        iround_exn,
        round_towards_zero,
        round_down,
        round_up,
        round_nearest,
        round_nearest_half_to_even,
        iround_towards_zero,
        iround_down,
        iround_up,
        iround_nearest_64$0,
        iround_towards_zero_exn,
        iround_down_exn,
        iround_up_exn,
        iround_nearest_exn,
        int63_round_down_exn,
        int63_round_up_exn,
        int63_round_nearest_exn,
        iround_lbound,
        iround_ubound,
        int63_round_lbound,
        int63_round_ubound,
        round_significant,
        round_decimal,
        is_nan,
        is_inf,
        is_finite,
        is_integer,
        min_inan,
        max_inan,
        symbol$1,
        symbol$2,
        symbol$4,
        symbol$0,
        symbol$3,
        symbol,
        symbol$5,
        [
            0,
            fractional,
            integral
        ],
        modf,
        mod_float,
        add,
        sub,
        neg,
        scale,
        abs_float,
        [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$0,
            symbol,
            symbol$5,
            symbol$11,
            symbol$10,
            symbol$9,
            symbol$8,
            symbol$7,
            symbol$6,
            abs_float,
            neg,
            zero,
            of_int,
            of_float$0
        ],
        [
            0,
            symbol$1,
            symbol$2,
            symbol$3,
            symbol$4,
            symbol$0,
            symbol,
            symbol$5
        ],
        to_string,
        to_string_hum,
        to_padded_compact_string,
        to_padded_compact_string_custo,
        int_pow,
        square,
        ldexp,
        frexp,
        [
            0,
            compare$0,
            compare_local,
            all,
            t_of_sexp$0,
            sexp_of_t$0,
            t_sexp_grammar$0,
            of_string$0,
            to_string$0
        ],
        classify,
        sign,
        sign_exn,
        sign_or_nan,
        create_ieee,
        create_ieee_exn,
        ieee_negative,
        ieee_exponent,
        ieee_mantissa,
        [
            0,
            t_of_sexp,
            sexp_of_t$2,
            t_sexp_grammar,
            of_string$1,
            to_string$1
        ],
        Private
    ];
    runtime.caml_register_global(191, Base_Float, "Base__Float");
    return;
})(globalThis);
//# 42162 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Base_Buffer_intf = [
        0
    ];
    runtime.caml_register_global(0, Base_Buffer_intf, "Base__Buffer_intf");
    return;
})(globalThis);
//# 42172 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Bytes = global_data.Base__Bytes, Base_Import = global_data.Base__Import, Stdlib_Buffer = global_data.Stdlib__Buffer, Base_Blit = global_data.Base__Blit, create = Stdlib_Buffer[1], contents = Stdlib_Buffer[2], to_bytes = Stdlib_Buffer[3], nth = Stdlib_Buffer[6], length = Stdlib_Buffer[7], clear = Stdlib_Buffer[8], reset = Stdlib_Buffer[9], add_char = Stdlib_Buffer[12], add_string = Stdlib_Buffer[16], add_bytes = Stdlib_Buffer[17], add_buffer = Stdlib_Buffer[21], _a_ = Stdlib_Buffer[18], _b_ = Stdlib_Buffer[19];
    function add_substring(t, s, pos, len) {
        return caml_call4(_a_, t, s, pos, len);
    }
    function add_subbytes(t, s, pos, len) {
        return caml_call4(_b_, t, s, pos, len);
    }
    function sexp_of_t(t) {
        var _c_ = caml_call1(contents, t);
        return caml_call1(Base_Import[136], _c_);
    }
    var caml_buffer_length = Stdlib_Buffer[7], caml_buffer_blit = Stdlib_Buffer[5];
    function create$0(len) {
        return caml_call1(Base_Bytes[34], len);
    }
    var length$0 = runtime.caml_ml_bytes_length;
    function unsafe_blit(src, src_pos, dst, dst_pos, len) {
        return caml_call5(caml_buffer_blit, src, src_pos, dst, dst_pos, len);
    }
    var To_bytes = caml_call1(caml_call1(Base_Blit[2], [
        0,
        caml_buffer_length
    ]), [
        0,
        length$0,
        create$0,
        unsafe_blit
    ]), blit = To_bytes[1], blito = To_bytes[2], unsafe_blit$0 = To_bytes[3], sub = To_bytes[4], subo = To_bytes[5], To_string = caml_call1(caml_call1(Base_Blit[3], [
        0
    ]), To_bytes), Base_Buffer = [
        0,
        sexp_of_t,
        create,
        contents,
        to_bytes,
        blit,
        blito,
        unsafe_blit$0,
        sub,
        subo,
        To_string,
        nth,
        length,
        clear,
        reset,
        add_char,
        add_string,
        add_substring,
        add_bytes,
        add_subbytes,
        add_buffer
    ];
    runtime.caml_register_global(4, Base_Buffer, "Base__Buffer");
    return;
})(globalThis);
//# 42268 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), elided_message = "<backtrace elided in test>", Base_Exn = global_data.Base__Exn, Base_Sys0 = global_data.Base__Sys0, Base_String = global_data.Base__String, Base_List = global_data.Base__List, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Int = global_data.Base__Int, elide = [
        0,
        0
    ];
    function get(opt, param) {
        var at_most_num_frames = opt ? opt[1] : Base_Int[65];
        return runtime.caml_get_current_callstack(at_most_num_frames);
    }
    function to_string(t) {
        return elide[1] ? elided_message : caml_call1(Stdlib_Printexc[14], t);
    }
    function to_string_list(t) {
        var _f_ = to_string(t);
        return caml_call1(Base_String[104], _f_);
    }
    function sexp_of_t(t) {
        var _e_ = to_string_list(t);
        return [
            1,
            caml_call2(Base_List[53], _e_, function(x) {
                return [
                    0,
                    x
                ];
            })
        ];
    }
    var set_recording = Stdlib_Printexc[7], am_recording = Stdlib_Printexc[8], cst_OCAMLRUNPARAM = "OCAMLRUNPARAM", cst_b = "b";
    function most_recent(param) {
        return caml_call1(Stdlib_Printexc[12], 0);
    }
    function most_recent_for_exn(exn) {
        return caml_call1(Base_Exn[18], exn) ? [
            0,
            most_recent(0)
        ] : 0;
    }
    function with_recording(b, f) {
        var saved = caml_call1(am_recording, 0);
        caml_call1(set_recording, b);
        return caml_call2(Base_Exn[13], f, function(param) {
            return caml_call1(set_recording, saved);
        });
    }
    function initialize_module(param) {
        var match = caml_call1(Base_Sys0[21], cst_OCAMLRUNPARAM);
        if (match) var x = match[1], _a_ = Base_String[97], _b_ = caml_call2(Base_String[102], x, 44), ocamlrunparam_mentions_backtra = caml_call2(Base_List[23], _b_, function(_d_) {
            return caml_call2(_a_, _d_, cst_b);
        });
        else var ocamlrunparam_mentions_backtra = 0;
        var _c_ = 1 - ocamlrunparam_mentions_backtra;
        return _c_ ? caml_call1(set_recording, 1) : _c_;
    }
    var Base_Backtrace = [
        0,
        sexp_of_t,
        get,
        to_string,
        to_string_list,
        elide,
        [
            0,
            am_recording,
            set_recording,
            with_recording,
            most_recent,
            most_recent_for_exn
        ],
        initialize_module
    ];
    runtime.caml_register_global(9, Base_Backtrace, "Base__Backtrace");
    return;
})(globalThis);
//# 42363 "../.js/default/base/base.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Ref = global_data.Base__Ref, Base_Option = global_data.Base__Option, Base_List = global_data.Base__List, Base_Array = global_data.Base__Array, Shadow_stdlib = global_data.Shadow_stdlib, Base_Sexp_with_comparable = global_data.Base__Sexp_with_comparable, Base_Int_conversions = global_data.Base__Int_conversions, Base_Int_string_conversions = global_data.Base__Int_string_conversions, Base_Import = global_data.Base__Import, Base_Bool = global_data.Base__Bool, Base_Char = global_data.Base__Char, Base_Exn = global_data.Base__Exn, Base_Float = global_data.Base__Float, Base_Int = global_data.Base__Int, Base_Int32 = global_data.Base__Int32, Base_Int64 = global_data.Base__Int64, Base_Nativeint = global_data.Base__Nativeint, Base_String = global_data.Base__String, Base_Bytes = global_data.Base__Bytes, Base_Unit = global_data.Base__Unit, Base_Error = global_data.Base__Error, Base_Container_intf = global_data.Base__Container_intf, Base_Backtrace = global_data.Base__Backtrace, Exit = Shadow_stdlib[3], Not_found = Shadow_stdlib[4], max_int = Shadow_stdlib[8], min_int = Shadow_stdlib[9], infinity = Shadow_stdlib[11], neg_infinity = Shadow_stdlib[12], nan = Shadow_stdlib[13], max_float = Shadow_stdlib[14], min_float = Shadow_stdlib[15], epsilon_float = Shadow_stdlib[16], char_of_int = Shadow_stdlib[18], string_of_bool = Shadow_stdlib[19], bool_of_string_opt = Shadow_stdlib[20], bool_of_string = Shadow_stdlib[21], string_of_int = Shadow_stdlib[22], int_of_string_opt = Shadow_stdlib[23], string_of_float = Shadow_stdlib[24], float_of_string_opt = Shadow_stdlib[25], stdin = Shadow_stdlib[27], stdout = Shadow_stdlib[28], stderr = Shadow_stdlib[29], print_char = Shadow_stdlib[30], print_string = Shadow_stdlib[31], print_bytes = Shadow_stdlib[32], print_int = Shadow_stdlib[33], print_float = Shadow_stdlib[34], print_endline = Shadow_stdlib[35], print_newline = Shadow_stdlib[36], prerr_char = Shadow_stdlib[37], prerr_string = Shadow_stdlib[38], prerr_bytes = Shadow_stdlib[39], prerr_int = Shadow_stdlib[40], prerr_float = Shadow_stdlib[41], prerr_endline = Shadow_stdlib[42], prerr_newline = Shadow_stdlib[43], read_line = Shadow_stdlib[44], read_int_opt = Shadow_stdlib[45], read_int = Shadow_stdlib[46], read_float_opt = Shadow_stdlib[47], read_float = Shadow_stdlib[48], open_out = Shadow_stdlib[49], open_out_bin = Shadow_stdlib[50], open_out_gen = Shadow_stdlib[51], flush = Shadow_stdlib[52], flush_all = Shadow_stdlib[53], output_char = Shadow_stdlib[54], output_string = Shadow_stdlib[55], output_bytes = Shadow_stdlib[56], output = Shadow_stdlib[57], output_substring = Shadow_stdlib[58], output_byte = Shadow_stdlib[59], output_binary_int = Shadow_stdlib[60], output_value = Shadow_stdlib[61], seek_out = Shadow_stdlib[62], pos_out = Shadow_stdlib[63], out_channel_length = Shadow_stdlib[64], close_out = Shadow_stdlib[65], close_out_noerr = Shadow_stdlib[66], set_binary_mode_out = Shadow_stdlib[67], open_in = Shadow_stdlib[68], open_in_bin = Shadow_stdlib[69], open_in_gen = Shadow_stdlib[70], input_char = Shadow_stdlib[71], input_line = Shadow_stdlib[72], input = Shadow_stdlib[73], really_input = Shadow_stdlib[74], really_input_string = Shadow_stdlib[75], input_byte = Shadow_stdlib[76], input_binary_int = Shadow_stdlib[77], input_value = Shadow_stdlib[78], seek_in = Shadow_stdlib[79], pos_in = Shadow_stdlib[80], in_channel_length = Shadow_stdlib[81], close_in = Shadow_stdlib[82], close_in_noerr = Shadow_stdlib[83], set_binary_mode_in = Shadow_stdlib[84], string_of_format = Shadow_stdlib[85], symbol = Shadow_stdlib[86], exit = Shadow_stdlib[87], at_exit = Shadow_stdlib[88], valid_float_lexem = Shadow_stdlib[89], unsafe_really_input = Shadow_stdlib[90], do_at_exit = Shadow_stdlib[91], do_domain_local_at_exit = Shadow_stdlib[92], globalize = Base_Sexp_with_comparable[1], hash_fold_t = Base_Sexp_with_comparable[2], hash = Base_Sexp_with_comparable[3], t_of_sexp = Base_Sexp_with_comparable[4], sexp_of_t = Base_Sexp_with_comparable[5], Not_found_s = Base_Sexp_with_comparable[6], Of_sexp_error = Base_Sexp_with_comparable[7], message = Base_Sexp_with_comparable[8], default_indent = Base_Sexp_with_comparable[9], pp_hum = Base_Sexp_with_comparable[10], pp_hum_indent = Base_Sexp_with_comparable[11], pp_mach = Base_Sexp_with_comparable[12], pp = Base_Sexp_with_comparable[13], to_string_hum = Base_Sexp_with_comparable[14], to_string_mach = Base_Sexp_with_comparable[15], to_string = Base_Sexp_with_comparable[16], of_float_style = Base_Sexp_with_comparable[17], of_int_style = Base_Sexp_with_comparable[18], t_sexp_grammar = Base_Sexp_with_comparable[19], invariant = Base_Sexp_with_comparable[20], of_string = Base_Sexp_with_comparable[21], symbol$0 = Base_Sexp_with_comparable[22], symbol$1 = Base_Sexp_with_comparable[23], symbol$2 = Base_Sexp_with_comparable[24], symbol$3 = Base_Sexp_with_comparable[25], symbol$4 = Base_Sexp_with_comparable[26], symbol$5 = Base_Sexp_with_comparable[27], equal = Base_Sexp_with_comparable[28], compare = Base_Sexp_with_comparable[29], min = Base_Sexp_with_comparable[30], max = Base_Sexp_with_comparable[31], ascending = Base_Sexp_with_comparable[32], descending = Base_Sexp_with_comparable[33], between = Base_Sexp_with_comparable[34], clamp_exn = Base_Sexp_with_comparable[35], clamp = Base_Sexp_with_comparable[36], comparator = Base_Sexp_with_comparable[37], compare_local = Base_Sexp_with_comparable[38], equal_local = Base_Sexp_with_comparable[39], Sexp = [
        0,
        globalize,
        hash_fold_t,
        hash,
        t_of_sexp,
        sexp_of_t,
        Not_found_s,
        Of_sexp_error,
        message,
        default_indent,
        pp_hum,
        pp_hum_indent,
        pp_mach,
        pp,
        to_string_hum,
        to_string_mach,
        to_string,
        of_float_style,
        of_int_style,
        t_sexp_grammar,
        invariant,
        of_string,
        symbol$0,
        symbol$1,
        symbol$2,
        symbol$3,
        symbol$4,
        symbol$5,
        equal,
        compare,
        min,
        max,
        ascending,
        descending,
        between,
        clamp_exn,
        clamp,
        comparator,
        compare_local,
        equal_local
    ], int_to_int32 = Base_Int_conversions[1], int_to_int32_exn = Base_Int_conversions[2], int_to_int32_trunc = Base_Int_conversions[3], int_to_int64 = Base_Int_conversions[4], int_to_nativeint = Base_Int_conversions[5], int32_to_int = Base_Int_conversions[6], int32_to_int_exn = Base_Int_conversions[7], int32_to_int_trunc = Base_Int_conversions[8], int32_to_int64 = Base_Int_conversions[9], int32_to_nativeint = Base_Int_conversions[10], int32_is_representable_as_int = Base_Int_conversions[11], int64_to_int = Base_Int_conversions[12], int64_to_int_exn = Base_Int_conversions[13], int64_to_int_trunc = Base_Int_conversions[14], int64_to_int32 = Base_Int_conversions[15], int64_to_int32_exn = Base_Int_conversions[16], int64_to_int32_trunc = Base_Int_conversions[17], int64_to_nativeint = Base_Int_conversions[18], int64_to_nativeint_exn = Base_Int_conversions[19], int64_to_nativeint_trunc = Base_Int_conversions[20], int64_fit_on_int63_exn = Base_Int_conversions[21], int64_is_representable_as_int6 = Base_Int_conversions[22], nativeint_to_int = Base_Int_conversions[23], nativeint_to_int_exn = Base_Int_conversions[24], nativeint_to_int_trunc = Base_Int_conversions[25], nativeint_to_int32 = Base_Int_conversions[26], nativeint_to_int32_exn = Base_Int_conversions[27], nativeint_to_int32_trunc = Base_Int_conversions[28], nativeint_to_int64 = Base_Int_conversions[29], num_bits_int = Base_Int_conversions[30], num_bits_int32 = Base_Int_conversions[31], num_bits_int64 = Base_Int_conversions[32], num_bits_nativeint = Base_Int_conversions[33], Make = Base_Int_string_conversions[1], Make_hex = Base_Int_string_conversions[2], Make_binary = Base_Int_string_conversions[3], sexp_of_int_style = Base_Int_string_conversions[4], insert_delimiter_every = Base_Int_string_conversions[5], insert_delimiter = Base_Int_string_conversions[6], insert_underscores = Base_Int_string_conversions[7], Int_conversions = [
        0,
        int_to_int32,
        int_to_int32_exn,
        int_to_int32_trunc,
        int_to_int64,
        int_to_nativeint,
        int32_to_int,
        int32_to_int_exn,
        int32_to_int_trunc,
        int32_to_int64,
        int32_to_nativeint,
        int32_is_representable_as_int,
        int64_to_int,
        int64_to_int_exn,
        int64_to_int_trunc,
        int64_to_int32,
        int64_to_int32_exn,
        int64_to_int32_trunc,
        int64_to_nativeint,
        int64_to_nativeint_exn,
        int64_to_nativeint_trunc,
        int64_fit_on_int63_exn,
        int64_is_representable_as_int6,
        nativeint_to_int,
        nativeint_to_int_exn,
        nativeint_to_int_trunc,
        nativeint_to_int32,
        nativeint_to_int32_exn,
        nativeint_to_int32_trunc,
        nativeint_to_int64,
        num_bits_int,
        num_bits_int32,
        num_bits_int64,
        num_bits_nativeint,
        Make,
        Make_hex,
        Make_binary,
        sexp_of_int_style,
        insert_delimiter_every,
        insert_delimiter,
        insert_underscores
    ], am_testing = Base_Import[129], Exported_for_specific_uses = [
        0,
        am_testing
    ], compare_array_local = Base_Array[2], compare_array = Base_Array[1], equal_array_local = Base_Array[106], equal_array = Base_Array[105], globalize_array = Base_Array[3], array_of_sexp = Base_Array[4], sexp_of_array = Base_Array[5];
    function array_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Array[6], a_sexp_grammar);
    }
    var compare_bool_local = Base_Bool[28];
    function compare_bool(a, b) {
        return caml_call2(compare_bool_local, a, b);
    }
    var equal_bool_local = Base_Bool[29];
    function equal_bool(a, b) {
        return caml_call2(equal_bool_local, a, b);
    }
    var globalize_bool = Base_Bool[2], hash_fold_bool = Base_Bool[4], func = Base_Bool[5];
    function hash_bool(x) {
        return caml_call1(func, x);
    }
    var bool_of_sexp = Base_Bool[6], sexp_of_bool = Base_Bool[7], bool_sexp_grammar = Base_Bool[3], compare_char_local = Base_Char[29];
    function compare_char(a, b) {
        return caml_call2(compare_char_local, a, b);
    }
    var equal_char_local = Base_Char[28];
    function equal_char(a, b) {
        return caml_call2(equal_char_local, a, b);
    }
    var globalize_char = Base_Char[2], hash_fold_char = Base_Char[4], func$0 = Base_Char[5];
    function hash_char(x) {
        return caml_call1(func$0, x);
    }
    var char_of_sexp = Base_Char[6], sexp_of_char = Base_Char[7], char_sexp_grammar = Base_Char[3], sexp_of_exn = Base_Exn[1], compare_float_local = Base_Float[24];
    function compare_float(a, b) {
        return caml_call2(compare_float_local, a, b);
    }
    var equal_float_local = Base_Float[23];
    function equal_float(a, b) {
        return caml_call2(equal_float_local, a, b);
    }
    var globalize_float = Base_Float[1], hash_fold_float = Base_Float[5], func$1 = Base_Float[6];
    function hash_float(x) {
        return caml_call1(func$1, x);
    }
    var float_of_sexp = Base_Float[7], sexp_of_float = Base_Float[8], float_sexp_grammar = Base_Float[2], compare_int_local = Base_Int[30];
    function compare_int(a, b) {
        return caml_call2(compare_int_local, a, b);
    }
    var equal_int_local = Base_Int[31];
    function equal_int(a, b) {
        return caml_call2(equal_int_local, a, b);
    }
    var globalize_int = Base_Int[1], hash_fold_int = Base_Int[7], func$2 = Base_Int[8];
    function hash_int(x) {
        return caml_call1(func$2, x);
    }
    var int_of_sexp = Base_Int[9], sexp_of_int = Base_Int[10], int_sexp_grammar = Base_Int[2], compare_int32_local = Base_Int32[36];
    function compare_int32(a, b) {
        return caml_call2(compare_int32_local, a, b);
    }
    var equal_int32_local = Base_Int32[37];
    function equal_int32(a, b) {
        return caml_call2(equal_int32_local, a, b);
    }
    var globalize_int32 = Base_Int32[1], hash_fold_int32 = Base_Int32[7], func$3 = Base_Int32[8];
    function hash_int32(x) {
        return caml_call1(func$3, x);
    }
    var int32_of_sexp = Base_Int32[9], sexp_of_int32 = Base_Int32[10], int32_sexp_grammar = Base_Int32[2], compare_int64_local = Base_Int64[30];
    function compare_int64(a, b) {
        return caml_call2(compare_int64_local, a, b);
    }
    var equal_int64_local = Base_Int64[31];
    function equal_int64(a, b) {
        return caml_call2(equal_int64_local, a, b);
    }
    var globalize_int64 = Base_Int64[1], hash_fold_int64 = Base_Int64[7], func$4 = Base_Int64[8];
    function hash_int64(x) {
        return caml_call1(func$4, x);
    }
    var int64_of_sexp = Base_Int64[9], sexp_of_int64 = Base_Int64[10], int64_sexp_grammar = Base_Int64[2], compare_list_local = Base_List[2], compare_list = Base_List[1], equal_list_local = Base_List[155], equal_list = Base_List[154], globalize_list = Base_List[3], hash_fold_list = Base_List[4], list_of_sexp = Base_List[5], sexp_of_list = Base_List[6];
    function list_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_List[7], a_sexp_grammar);
    }
    var compare_nativeint_local = Base_Nativeint[36];
    function compare_nativeint(a, b) {
        return caml_call2(compare_nativeint_local, a, b);
    }
    var equal_nativeint_local = Base_Nativeint[37];
    function equal_nativeint(a, b) {
        return caml_call2(equal_nativeint_local, a, b);
    }
    var globalize_nativeint = Base_Nativeint[1], hash_fold_nativeint = Base_Nativeint[7], func$5 = Base_Nativeint[8];
    function hash_nativeint(x) {
        return caml_call1(func$5, x);
    }
    var nativeint_of_sexp = Base_Nativeint[9], sexp_of_nativeint = Base_Nativeint[10], nativeint_sexp_grammar = Base_Nativeint[2], compare_option_local = Base_Option[2], compare_option = Base_Option[1], equal_option_local = Base_Option[7], equal_option = Base_Option[6], globalize_option = Base_Option[3], hash_fold_option = Base_Option[4], option_of_sexp = Base_Option[9], sexp_of_option = Base_Option[10];
    function option_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Option[5], a_sexp_grammar);
    }
    var compare_ref_local = Base_Ref[2], compare_ref = Base_Ref[1], equal_ref_local = Base_Ref[4], equal_ref = Base_Ref[3], globalize_ref = Base_Ref[5], ref_of_sexp = Base_Ref[6], sexp_of_ref = Base_Ref[7];
    function ref_sexp_grammar(a_sexp_grammar) {
        return caml_call1(Base_Ref[8], a_sexp_grammar);
    }
    var compare_string_local = Base_String[62];
    function compare_string(a, b) {
        return caml_call2(compare_string_local, a, b);
    }
    var equal_string_local = Base_String[135];
    function equal_string(a, b) {
        return caml_call2(equal_string_local, a, b);
    }
    var globalize_string = Base_String[1], hash_fold_string = Base_String[40];
    function hash_string(x) {
        return runtime.Base_hash_string(x);
    }
    var string_of_sexp = Base_String[41], sexp_of_string = Base_String[42], string_sexp_grammar = Base_String[2], compare_bytes_local = Base_Bytes[26];
    function compare_bytes(a, b) {
        return caml_call2(compare_bytes_local, a, b);
    }
    var equal_bytes_local = Base_Bytes[27];
    function equal_bytes(a, b) {
        return caml_call2(equal_bytes_local, a, b);
    }
    var globalize_bytes = Base_Bytes[1], bytes_of_sexp = Base_Bytes[2], sexp_of_bytes = Base_Bytes[3], bytes_sexp_grammar = Base_Bytes[4], compare_unit_local = Base_Unit[29];
    function compare_unit(a, b) {
        return caml_call2(compare_unit_local, a, b);
    }
    var equal_unit_local = Base_Unit[28];
    function equal_unit(a, b) {
        return caml_call2(equal_unit_local, a, b);
    }
    var globalize_unit = Base_Unit[2], hash_fold_unit = Base_Unit[4], func$6 = Base_Unit[5];
    function hash_unit(x) {
        return caml_call1(func$6, x);
    }
    var unit_of_sexp = Base_Unit[6], sexp_of_unit = Base_Unit[7], unit_sexp_grammar = Base_Unit[3], symbol$6 = Base_List[156][1], _a_ = Base_Int[75], symbol$7 = _a_[1], lnot = _a_[2], abs = _a_[3], zero = _a_[4], symbol$8 = _a_[5], symbol$9 = _a_[6], symbol$10 = _a_[7], _b_ = Base_Import[97], ascending$0 = _b_[1], descending$0 = _b_[2], max$0 = _b_[3], min$0 = _b_[4], include = Base_Float[100], symbol$11 = include[1], symbol$12 = include[2], symbol$13 = include[3], symbol$14 = include[4], symbol$15 = include[5], symbol$16 = include[6], symbol$17 = include[7], symbol_concat = Base_String[67], fst = Base_Import[125], snd = Base_Import[127], failwith = Base_Import[124], invalid_arg = Base_Import[126], raise_s = Base_Error[32], Export = [
        0,
        compare_array_local,
        compare_array,
        equal_array_local,
        equal_array,
        globalize_array,
        array_of_sexp,
        sexp_of_array,
        array_sexp_grammar,
        compare_bool_local,
        compare_bool,
        equal_bool_local,
        equal_bool,
        globalize_bool,
        hash_fold_bool,
        hash_bool,
        bool_of_sexp,
        sexp_of_bool,
        bool_sexp_grammar,
        compare_char_local,
        compare_char,
        equal_char_local,
        equal_char,
        globalize_char,
        hash_fold_char,
        hash_char,
        char_of_sexp,
        sexp_of_char,
        char_sexp_grammar,
        sexp_of_exn,
        compare_float_local,
        compare_float,
        equal_float_local,
        equal_float,
        globalize_float,
        hash_fold_float,
        hash_float,
        float_of_sexp,
        sexp_of_float,
        float_sexp_grammar,
        compare_int_local,
        compare_int,
        equal_int_local,
        equal_int,
        globalize_int,
        hash_fold_int,
        hash_int,
        int_of_sexp,
        sexp_of_int,
        int_sexp_grammar,
        compare_int32_local,
        compare_int32,
        equal_int32_local,
        equal_int32,
        globalize_int32,
        hash_fold_int32,
        hash_int32,
        int32_of_sexp,
        sexp_of_int32,
        int32_sexp_grammar,
        compare_int64_local,
        compare_int64,
        equal_int64_local,
        equal_int64,
        globalize_int64,
        hash_fold_int64,
        hash_int64,
        int64_of_sexp,
        sexp_of_int64,
        int64_sexp_grammar,
        compare_list_local,
        compare_list,
        equal_list_local,
        equal_list,
        globalize_list,
        hash_fold_list,
        list_of_sexp,
        sexp_of_list,
        list_sexp_grammar,
        compare_nativeint_local,
        compare_nativeint,
        equal_nativeint_local,
        equal_nativeint,
        globalize_nativeint,
        hash_fold_nativeint,
        hash_nativeint,
        nativeint_of_sexp,
        sexp_of_nativeint,
        nativeint_sexp_grammar,
        compare_option_local,
        compare_option,
        equal_option_local,
        equal_option,
        globalize_option,
        hash_fold_option,
        option_of_sexp,
        sexp_of_option,
        option_sexp_grammar,
        compare_ref_local,
        compare_ref,
        equal_ref_local,
        equal_ref,
        globalize_ref,
        ref_of_sexp,
        sexp_of_ref,
        ref_sexp_grammar,
        compare_string_local,
        compare_string,
        equal_string_local,
        equal_string,
        globalize_string,
        hash_fold_string,
        hash_string,
        string_of_sexp,
        sexp_of_string,
        string_sexp_grammar,
        compare_bytes_local,
        compare_bytes,
        equal_bytes_local,
        equal_bytes,
        globalize_bytes,
        bytes_of_sexp,
        sexp_of_bytes,
        bytes_sexp_grammar,
        compare_unit_local,
        compare_unit,
        equal_unit_local,
        equal_unit,
        globalize_unit,
        hash_fold_unit,
        hash_unit,
        unit_of_sexp,
        sexp_of_unit,
        unit_sexp_grammar,
        symbol$6,
        symbol$7,
        lnot,
        abs,
        zero,
        symbol$8,
        symbol$9,
        symbol$10,
        ascending$0,
        descending$0,
        max$0,
        min$0,
        symbol$11,
        symbol$12,
        symbol$13,
        symbol$14,
        symbol$15,
        symbol$16,
        symbol$17,
        symbol_concat,
        fst,
        snd,
        failwith,
        invalid_arg,
        raise_s
    ], compare_array_local$0 = Export[1], compare_array$0 = Export[2], equal_array_local$0 = Export[3], equal_array$0 = Export[4], globalize_array$0 = Export[5], array_of_sexp$0 = Export[6], sexp_of_array$0 = Export[7], array_sexp_grammar$0 = Export[8], compare_bool_local$0 = Export[9], compare_bool$0 = Export[10], equal_bool_local$0 = Export[11], equal_bool$0 = Export[12], globalize_bool$0 = Export[13], hash_fold_bool$0 = Export[14], hash_bool$0 = Export[15], bool_of_sexp$0 = Export[16], sexp_of_bool$0 = Export[17], bool_sexp_grammar$0 = Export[18], compare_char_local$0 = Export[19], compare_char$0 = Export[20], equal_char_local$0 = Export[21], equal_char$0 = Export[22], globalize_char$0 = Export[23], hash_fold_char$0 = Export[24], hash_char$0 = Export[25], char_of_sexp$0 = Export[26], sexp_of_char$0 = Export[27], char_sexp_grammar$0 = Export[28], sexp_of_exn$0 = Export[29], compare_float_local$0 = Export[30], compare_float$0 = Export[31], equal_float_local$0 = Export[32], equal_float$0 = Export[33], globalize_float$0 = Export[34], hash_fold_float$0 = Export[35], hash_float$0 = Export[36], float_of_sexp$0 = Export[37], sexp_of_float$0 = Export[38], float_sexp_grammar$0 = Export[39], compare_int_local$0 = Export[40], compare_int$0 = Export[41], equal_int_local$0 = Export[42], equal_int$0 = Export[43], globalize_int$0 = Export[44], hash_fold_int$0 = Export[45], hash_int$0 = Export[46], int_of_sexp$0 = Export[47], sexp_of_int$0 = Export[48], int_sexp_grammar$0 = Export[49], compare_int32_local$0 = Export[50], compare_int32$0 = Export[51], equal_int32_local$0 = Export[52], equal_int32$0 = Export[53], globalize_int32$0 = Export[54], hash_fold_int32$0 = Export[55], hash_int32$0 = Export[56], int32_of_sexp$0 = Export[57], sexp_of_int32$0 = Export[58], int32_sexp_grammar$0 = Export[59], compare_int64_local$0 = Export[60], compare_int64$0 = Export[61], equal_int64_local$0 = Export[62], equal_int64$0 = Export[63], globalize_int64$0 = Export[64], hash_fold_int64$0 = Export[65], hash_int64$0 = Export[66], int64_of_sexp$0 = Export[67], sexp_of_int64$0 = Export[68], int64_sexp_grammar$0 = Export[69], compare_list_local$0 = Export[70], compare_list$0 = Export[71], equal_list_local$0 = Export[72], equal_list$0 = Export[73], globalize_list$0 = Export[74], hash_fold_list$0 = Export[75], list_of_sexp$0 = Export[76], sexp_of_list$0 = Export[77], list_sexp_grammar$0 = Export[78], compare_nativeint_local$0 = Export[79], compare_nativeint$0 = Export[80], equal_nativeint_local$0 = Export[81], equal_nativeint$0 = Export[82], globalize_nativeint$0 = Export[83], hash_fold_nativeint$0 = Export[84], hash_nativeint$0 = Export[85], nativeint_of_sexp$0 = Export[86], sexp_of_nativeint$0 = Export[87], nativeint_sexp_grammar$0 = Export[88], compare_option_local$0 = Export[89], compare_option$0 = Export[90], equal_option_local$0 = Export[91], equal_option$0 = Export[92], globalize_option$0 = Export[93], hash_fold_option$0 = Export[94], option_of_sexp$0 = Export[95], sexp_of_option$0 = Export[96], option_sexp_grammar$0 = Export[97], compare_ref_local$0 = Export[98], compare_ref$0 = Export[99], equal_ref_local$0 = Export[100], equal_ref$0 = Export[101], globalize_ref$0 = Export[102], ref_of_sexp$0 = Export[103], sexp_of_ref$0 = Export[104], ref_sexp_grammar$0 = Export[105], compare_string_local$0 = Export[106], compare_string$0 = Export[107], equal_string_local$0 = Export[108], equal_string$0 = Export[109], globalize_string$0 = Export[110], hash_fold_string$0 = Export[111], hash_string$0 = Export[112], string_of_sexp$0 = Export[113], sexp_of_string$0 = Export[114], string_sexp_grammar$0 = Export[115], compare_bytes_local$0 = Export[116], compare_bytes$0 = Export[117], equal_bytes_local$0 = Export[118], equal_bytes$0 = Export[119], globalize_bytes$0 = Export[120], bytes_of_sexp$0 = Export[121], sexp_of_bytes$0 = Export[122], bytes_sexp_grammar$0 = Export[123], compare_unit_local$0 = Export[124], compare_unit$0 = Export[125], equal_unit_local$0 = Export[126], equal_unit$0 = Export[127], globalize_unit$0 = Export[128], hash_fold_unit$0 = Export[129], hash_unit$0 = Export[130], unit_of_sexp$0 = Export[131], sexp_of_unit$0 = Export[132], unit_sexp_grammar$0 = Export[133], symbol$18 = Export[134], symbol$19 = Export[135], lnot$0 = Export[136], abs$0 = Export[137], zero$0 = Export[138], symbol$20 = Export[139], symbol$21 = Export[140], symbol$22 = Export[141], ascending$1 = Export[142], descending$1 = Export[143], max$1 = Export[144], min$1 = Export[145], symbol$23 = Export[146], symbol$24 = Export[147], symbol$25 = Export[148], symbol$26 = Export[149], symbol$27 = Export[150], symbol$28 = Export[151], symbol$29 = Export[152], symbol_concat$0 = Export[153], fst$0 = Export[154], snd$0 = Export[155], failwith$0 = Export[156], invalid_arg$0 = Export[157], raise_s$0 = Export[158], include$0 = Base_Container_intf[1], Continue_or_stop = include$0[1], Not_found_s$0 = Base_Import[297];
    caml_call1(Base_Backtrace[7], 0);
    var Caml = [
        0
    ], Base = [
        0,
        Exit,
        Not_found,
        max_int,
        min_int,
        infinity,
        neg_infinity,
        nan,
        max_float,
        min_float,
        epsilon_float,
        char_of_int,
        string_of_bool,
        bool_of_string_opt,
        bool_of_string,
        string_of_int,
        int_of_string_opt,
        string_of_float,
        float_of_string_opt,
        stdin,
        stdout,
        stderr,
        print_char,
        print_string,
        print_bytes,
        print_int,
        print_float,
        print_endline,
        print_newline,
        prerr_char,
        prerr_string,
        prerr_bytes,
        prerr_int,
        prerr_float,
        prerr_endline,
        prerr_newline,
        read_line,
        read_int_opt,
        read_int,
        read_float_opt,
        read_float,
        open_out,
        open_out_bin,
        open_out_gen,
        flush,
        flush_all,
        output_char,
        output_string,
        output_bytes,
        output,
        output_substring,
        output_byte,
        output_binary_int,
        output_value,
        seek_out,
        pos_out,
        out_channel_length,
        close_out,
        close_out_noerr,
        set_binary_mode_out,
        open_in,
        open_in_bin,
        open_in_gen,
        input_char,
        input_line,
        input,
        really_input,
        really_input_string,
        input_byte,
        input_binary_int,
        input_value,
        seek_in,
        pos_in,
        in_channel_length,
        close_in,
        close_in_noerr,
        set_binary_mode_in,
        string_of_format,
        symbol,
        exit,
        at_exit,
        valid_float_lexem,
        unsafe_really_input,
        do_at_exit,
        do_domain_local_at_exit,
        Sexp,
        Int_conversions,
        Exported_for_specific_uses,
        Export,
        compare_array_local$0,
        compare_array$0,
        equal_array_local$0,
        equal_array$0,
        globalize_array$0,
        array_of_sexp$0,
        sexp_of_array$0,
        array_sexp_grammar$0,
        compare_bool_local$0,
        compare_bool$0,
        equal_bool_local$0,
        equal_bool$0,
        globalize_bool$0,
        hash_fold_bool$0,
        hash_bool$0,
        bool_of_sexp$0,
        sexp_of_bool$0,
        bool_sexp_grammar$0,
        compare_char_local$0,
        compare_char$0,
        equal_char_local$0,
        equal_char$0,
        globalize_char$0,
        hash_fold_char$0,
        hash_char$0,
        char_of_sexp$0,
        sexp_of_char$0,
        char_sexp_grammar$0,
        sexp_of_exn$0,
        compare_float_local$0,
        compare_float$0,
        equal_float_local$0,
        equal_float$0,
        globalize_float$0,
        hash_fold_float$0,
        hash_float$0,
        float_of_sexp$0,
        sexp_of_float$0,
        float_sexp_grammar$0,
        compare_int_local$0,
        compare_int$0,
        equal_int_local$0,
        equal_int$0,
        globalize_int$0,
        hash_fold_int$0,
        hash_int$0,
        int_of_sexp$0,
        sexp_of_int$0,
        int_sexp_grammar$0,
        compare_int32_local$0,
        compare_int32$0,
        equal_int32_local$0,
        equal_int32$0,
        globalize_int32$0,
        hash_fold_int32$0,
        hash_int32$0,
        int32_of_sexp$0,
        sexp_of_int32$0,
        int32_sexp_grammar$0,
        compare_int64_local$0,
        compare_int64$0,
        equal_int64_local$0,
        equal_int64$0,
        globalize_int64$0,
        hash_fold_int64$0,
        hash_int64$0,
        int64_of_sexp$0,
        sexp_of_int64$0,
        int64_sexp_grammar$0,
        compare_list_local$0,
        compare_list$0,
        equal_list_local$0,
        equal_list$0,
        globalize_list$0,
        hash_fold_list$0,
        list_of_sexp$0,
        sexp_of_list$0,
        list_sexp_grammar$0,
        compare_nativeint_local$0,
        compare_nativeint$0,
        equal_nativeint_local$0,
        equal_nativeint$0,
        globalize_nativeint$0,
        hash_fold_nativeint$0,
        hash_nativeint$0,
        nativeint_of_sexp$0,
        sexp_of_nativeint$0,
        nativeint_sexp_grammar$0,
        compare_option_local$0,
        compare_option$0,
        equal_option_local$0,
        equal_option$0,
        globalize_option$0,
        hash_fold_option$0,
        option_of_sexp$0,
        sexp_of_option$0,
        option_sexp_grammar$0,
        compare_ref_local$0,
        compare_ref$0,
        equal_ref_local$0,
        equal_ref$0,
        globalize_ref$0,
        ref_of_sexp$0,
        sexp_of_ref$0,
        ref_sexp_grammar$0,
        compare_string_local$0,
        compare_string$0,
        equal_string_local$0,
        equal_string$0,
        globalize_string$0,
        hash_fold_string$0,
        hash_string$0,
        string_of_sexp$0,
        sexp_of_string$0,
        string_sexp_grammar$0,
        compare_bytes_local$0,
        compare_bytes$0,
        equal_bytes_local$0,
        equal_bytes$0,
        globalize_bytes$0,
        bytes_of_sexp$0,
        sexp_of_bytes$0,
        bytes_sexp_grammar$0,
        compare_unit_local$0,
        compare_unit$0,
        equal_unit_local$0,
        equal_unit$0,
        globalize_unit$0,
        hash_fold_unit$0,
        hash_unit$0,
        unit_of_sexp$0,
        sexp_of_unit$0,
        unit_sexp_grammar$0,
        symbol$18,
        symbol$19,
        lnot$0,
        abs$0,
        zero$0,
        symbol$20,
        symbol$21,
        symbol$22,
        ascending$1,
        descending$1,
        max$1,
        min$1,
        symbol$23,
        symbol$24,
        symbol$25,
        symbol$26,
        symbol$27,
        symbol$28,
        symbol$29,
        symbol_concat$0,
        fst$0,
        snd$0,
        failwith$0,
        invalid_arg$0,
        raise_s$0,
        Continue_or_stop,
        Not_found_s$0,
        Caml
    ];
    runtime.caml_register_global(23, Base, "Base");
    return;
})(globalThis);
//# 5 "../.js/default/time_now/time_now.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_Int63 = global_data.Base__Int63, Base = global_data.Base, cst_clock_gettime_CLOCK_REALTI = "clock_gettime(CLOCK_REALTIME) failed";
    function nanoseconds_since_unix_epoch(param) {
        var t = runtime.time_now_nanoseconds_since_unix_epoch_or_zero(0);
        return caml_call2(Base_Int63[17], t, Base_Int63[42]) ? t : caml_call1(Base[244], cst_clock_gettime_CLOCK_REALTI);
    }
    var Time_now = [
        0,
        nanoseconds_since_unix_epoch,
        function(_a_) {
            return runtime.time_now_nanosecond_counter_for_timing(_a_);
        }
    ];
    runtime.caml_register_global(3, Time_now, "Time_now");
    return;
})(globalThis);
//# 5 "../.js/default/ppx_inline_test.runtime-lib/ppx_inline_test_lib.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$13 = "", cst$14 = "\n", cst$15 = " ", cst_line = " , line ", cst_File = " File ", cst_threw = " threw", cst_s$0 = "%s", cst_s = "%s%!", cst$12 = ".\n", cst_Ppx_inline_test_lib$0 = "Ppx_inline_test_lib", cst_TES = "TES", cst_TESTING_FRAMEWORK = "TESTING_FRAMEWORK", cst_T_MODULE_at$0 = "T_MODULE at ", cst_T_MODULES = "T_MODULES", cst_inline_test_runner$0 = "inline-test-runner", cst_inline_tests_log$0 = "inline_tests.log", cst_ppx_inline_test_error_the_ = "ppx_inline_test error: the following -only-test flags matched nothing:", caml_equal = runtime.caml_equal, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_obj_tag = runtime.caml_obj_tag, caml_sys_argv = runtime.caml_sys_argv, caml_sys_getenv = runtime.caml_sys_getenv, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), cst$11 = cst$13, cst$9 = cst$14, cst$10 = cst$15, cst$7 = cst$14, cst$8 = cst$15, cst$5 = cst$14, cst$6 = "  ", cst$3 = cst$14, cst$4 = cst$13, cst$2 = ".", cst$0 = cst$13, cst$1 = ": ", initial = [
        0,
        0,
        [
            0,
            "disabled",
            0
        ]
    ], cst = cst$13, am_running_env_var = cst_TESTING_FRAMEWORK, Stdlib_List = global_data.Stdlib__List, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Base_Exn = global_data.Base__Exn, Stdlib_Filename = global_data.Stdlib__Filename, Sexplib0_Sexp_conv = global_data.Sexplib0__Sexp_conv, Stdlib_String = global_data.Stdlib__String, CamlinternalLazy = global_data.CamlinternalLazy, Stdlib_Result = global_data.Stdlib__Result, Base = global_data.Base, Base_String = global_data.Base__String, Base_List = global_data.Base__List, Stdlib_Random = global_data.Stdlib__Random, Base_Random = global_data.Base__Random, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Int63 = global_data.Base__Int63, Time_now = global_data.Time_now, Stdlib_Arg = global_data.Stdlib__Arg, Stdlib_Array = global_data.Stdlib__Array, Stdlib_Scanf = global_data.Stdlib__Scanf, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, cst_success = "success", cst_failure = "failure", cst_error = "error";
    function to_string(param) {
        switch(param){
            case 0:
                return cst_success;
            case 1:
                return cst_failure;
            default:
                return cst_error;
        }
    }
    function combine(t1, t2) {
        a: {
            switch(t1){
                case 0:
                    if (!t2) return 0;
                    break;
                case 1:
                    break;
                default:
                    break a;
            }
            if (2 !== t2) return 1;
        }
        return 2;
    }
    function combine_all(ts) {
        return caml_call3(Stdlib_List[26], combine, 0, ts);
    }
    var already_initialized = [
        0,
        0
    ], test_modules_ran = [
        0,
        0
    ], test_modules_failed = [
        0,
        0
    ], tests_ran = [
        0,
        0
    ], tests_failed = [
        0,
        0
    ], dynamic_lib = [
        0,
        0
    ], action = [
        0,
        -950194894
    ], cst_source_tree_root$0 = "source_tree_root", cst_diff_path_prefix$0 = "diff_path_prefix", cst_diff_command = "diff_command", cst_in_place$0 = "in_place", cst_use_color = "use_color", _O_ = [
        0,
        [
            11,
            "ppx_inline_test error: attempted to access the [",
            [
                2,
                0,
                [
                    11,
                    "] config before [init] was called",
                    0
                ]
            ]
        ],
        "ppx_inline_test error: attempted to access the [%s] config before [init] was called"
    ], _N_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                0
            ]
        ],
        "%s\n"
    ], _M_ = [
        0,
        1,
        [
            0,
            7,
            0
        ]
    ], _F_ = [
        0,
        [
            12,
            32,
            [
                2,
                0,
                [
                    12,
                    58,
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        " %s:%d"
    ], _G_ = [
        0,
        [
            12,
            32,
            [
                2,
                0,
                0
            ]
        ],
        " %s"
    ], _B_ = [
        0,
        [
            11,
            "inline_tests_runner.exe is not supposed to be run by hand, you \nshould run the inline_tests_runner script instead.\n",
            [
                10,
                0
            ]
        ],
        "inline_tests_runner.exe is not supposed to be run by hand, you \nshould run the inline_tests_runner script instead.\n%!"
    ], _C_ = [
        0,
        [
            11,
            "You are doing something unexpected with the tests. No tests have \nbeen run. You should use the inline_tests_runner script to run \ntests.\n",
            [
                10,
                0
            ]
        ],
        "You are doing something unexpected with the tests. No tests have \nbeen run. You should use the inline_tests_runner script to run \ntests.\n%!"
    ], _D_ = [
        0,
        [
            4,
            0,
            0,
            0,
            [
                11,
                " tests ran, ",
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        11,
                        " test_modules ran\n",
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%d tests ran, %d test_modules ran\n%!"
    ], _E_ = [
        0,
        [
            11,
            cst_ppx_inline_test_error_the_,
            0
        ],
        cst_ppx_inline_test_error_the_
    ], _H_ = [
        0,
        [
            11,
            cst$12,
            [
                10,
                0
            ]
        ],
        ".\n%!"
    ], _I_ = [
        0,
        [
            11,
            "ppx_inline_test error: no tests have been run.\n",
            [
                10,
                0
            ]
        ],
        "ppx_inline_test error: no tests have been run.\n%!"
    ], _K_ = [
        0,
        [
            11,
            cst_T_MODULES,
            0
        ],
        cst_T_MODULES
    ], _L_ = [
        0,
        [
            11,
            ", ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " TES",
                    0
                ]
            ]
        ],
        ", %d TES"
    ], _J_ = [
        0,
        [
            11,
            "FAILED ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " / ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " tests",
                            [
                                2,
                                0,
                                [
                                    12,
                                    10,
                                    [
                                        10,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "FAILED %d / %d tests%s\n%!"
    ], _z_ = [
        0,
        [
            11,
            cst_T_MODULE_at$0,
            [
                2,
                0,
                [
                    11,
                    cst_threw,
                    [
                        2,
                        0,
                        [
                            2,
                            0,
                            [
                                11,
                                cst$12,
                                [
                                    2,
                                    0,
                                    [
                                        2,
                                        0,
                                        [
                                            12,
                                            10,
                                            [
                                                10,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "T_MODULE at %s threw%s%s.\n%s%s\n%!"
    ], _A_ = [
        0,
        [
            11,
            cst_TES,
            0
        ],
        cst_TES
    ], cst_ppx_inline_test_cannot_use = "ppx_inline_test: cannot use -list-partition or -partition without specifying a partition at preprocessing time", _t_ = [
        0,
        [
            2,
            0,
            [
                12,
                10,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s\n%s"
    ], _u_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _v_ = [
        0,
        1
    ], _w_ = [
        0,
        [
            11,
            " (",
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                [
                    0,
                    3
                ],
                [
                    11,
                    " sec)\n",
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        " (%.3f sec)\n%!"
    ], _x_ = [
        0,
        [
            2,
            0,
            [
                11,
                " is false.\n",
                [
                    2,
                    0,
                    [
                        12,
                        10,
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s is false.\n%s\n%!"
    ], _y_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_threw,
                [
                    2,
                    0,
                    [
                        2,
                        0,
                        [
                            11,
                            cst$12,
                            [
                                2,
                                0,
                                [
                                    2,
                                    0,
                                    [
                                        12,
                                        10,
                                        [
                                            10,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s threw%s%s.\n%s%s\n%!"
    ], _s_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _r_ = [
        0,
        [
            2,
            0,
            [
                10,
                0
            ]
        ],
        cst_s
    ], _q_ = [
        0,
        [
            12,
            10,
            [
                2,
                0,
                [
                    12,
                    10,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        "\n%s\n%!"
    ], cst_T_MODULE_at = cst_T_MODULE_at$0, cst_in_TES = "  in TES", cst_time_without_resetting_ran = "time_without_resetting_random_seeds", cst_Ppx_inline_test_lib = cst_Ppx_inline_test_lib$0, _l_ = [
        0,
        0
    ], _j_ = [
        0,
        0
    ], cst_inline_tests_log = cst_inline_tests_log$0, _i_ = [
        0,
        [
            11,
            "Argument ",
            [
                2,
                0,
                [
                    11,
                    " doesn't fit the format filename[:line_number]\n",
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        "Argument %s doesn't fit the format filename[:line_number]\n%!"
    ], _h_ = [
        0,
        [
            2,
            0,
            [
                11,
                ": unexpected anonymous argument ",
                [
                    2,
                    0,
                    [
                        12,
                        10,
                        [
                            10,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "%s: unexpected anonymous argument %s\n%!"
    ], cst_The_inline_test_runner_can = "The inline test runner can only be initialized once, and has already been initialized.", cst_inline_test_runner = cst_inline_test_runner$0, _g_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " [args]",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s %s [args]"
    ], cst_Prefix_to_prepend_to_filep = " Prefix to prepend to filepaths in test output", cst_diff_path_prefix = "-diff-path-prefix", cst_Path_to_the_root_of_the_so = " Path to the root of the source tree", cst_source_tree_root = "-source-tree-root", cst_Diff_command_for_tests_tha = " Diff command for tests that require diffing (use - to disable diffing)", cst_diff_cmd = "-diff-cmd", cst_Update_expect_tests_in_pla = " Update expect tests in place", cst_in_place = "-in-place", cst_Summarize_tests_without_us = " Summarize tests without using color", cst_no_color = "-no-color", cst_location_Run_only_the_test = 'location Run only the tests specified by all the -only-test options.\n                      Locations can be one of these forms:\n                      - file.ml\n                      - file.ml:line_number\n                      - File "file.ml"\n                      - File "file.ml", line 23\n                      - File "file.ml", line 23, characters 2-3', cst_only_test = "-only-test", cst_substring_Only_run_tests_w = "substring Only run tests whose names contain the given substring", cst_matching = "-matching", cst_tag_Only_run_tests_tagged_ = "tag Only run tests tagged with [tag] (overrides previous -drop-tag)", cst_require_tag = "-require-tag", cst_tag_Only_run_tests_not_tag = "tag Only run tests not tagged with [tag] (overrides previous -require-tag)", cst_drop_tag = "-drop-tag", cst_Log_the_tests_run_in_inlin = " Log the tests run in inline_tests.log", cst_log = "-log", cst_Show_the_number_of_tests_r = " Show the number of tests ran", cst_show_counts = "-show-counts", cst_End_with_an_error_if_no_te = " End with an error if no tests were run", cst_strict = "-strict", cst_Run_tests_only_up_to_the_f = " Run tests only up to the first error (doesn't work for expect tests)", cst_stop_on_error = "-stop-on-error", cst_Show_the_tests_as_they_run = " Show the tests as they run", cst_verbose = "-verbose", cst_Only_run_the_tests_in_the_ = " Only run the tests in the given partition", cst_partition = "-partition", cst_Lists_all_the_partitions_t = " Lists all the partitions that contain at least one test or test_module into FILE", cst_list_partitions_into_file = "-list-partitions-into-file", cst_Lists_all_the_partitions_t$0 = " Lists all the partitions that contain at least one test or test_module", cst_list_partitions = "-list-partitions", cst_Do_not_run_tests_but_show_ = " Do not run tests but show what would have been run", cst_list_test_names = "-list-test-names", _f_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    11,
                    cst_line,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " , characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    11,
                                    " - ",
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                10,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        " File %S , line %d , characters %d - %d %!"
    ], _e_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    11,
                    cst_line,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                10,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        " File %S , line %d %!"
    ], _d_ = [
        0,
        [
            11,
            cst_File,
            [
                3,
                0,
                [
                    12,
                    32,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        " File %S %!"
    ], _c_ = [
        0,
        [
            11,
            "File ",
            [
                3,
                0,
                [
                    11,
                    ", line ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            2,
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "File %S, line %d, characters %d-%d%s"
    ], _k_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s$0
    ], _R_ = [
        0,
        [
            2,
            0,
            0
        ],
        cst_s$0
    ], _p_ = [
        0,
        187165616,
        545942154
    ], _P_ = [
        0,
        187165616,
        -863538453
    ];
    try {
        caml_sys_getenv("FORCE_DROP_INLINE_TEST");
        var _T_1 = 1, force_drop = _T_1;
    } catch (_bx_) {
        var _a_ = caml_wrap_exception(_bx_);
        if (_a_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_a_, 0);
        var force_drop = 0;
    }
    function get(param) {
        return force_drop ? -950194894 : action[1];
    }
    var _b_ = caml_call2(Stdlib_Hashtbl[1], 0, 23), current = [
        0,
        cst
    ];
    function found_test(param) {
        var _bv_ = current[1] !== cst$13 ? 1 : 0, _bw_ = _bv_ ? 1 - caml_call2(Stdlib_Hashtbl[9], _b_, current[1]) : _bv_;
        return _bw_ ? caml_call3(Stdlib_Hashtbl[5], _b_, current[1], 0) : _bw_;
    }
    function is_current(param) {
        if (!param) return 1;
        var p = param[1];
        return p === current[1] ? 1 : 0;
    }
    var current$0 = [
        0,
        0
    ];
    function current_tags(param) {
        var t = current$0[1], _bu_ = caml_call2(Stdlib_List[20], function(m) {
            return m[2];
        }, t);
        return caml_call1(Stdlib_List[14], _bu_);
    }
    var verbose = [
        0,
        0
    ], strict = [
        0,
        0
    ], show_counts = [
        0,
        0
    ], list_test_names = [
        0,
        0
    ], delayed_errors = [
        0,
        0
    ], stop_on_error = [
        0,
        0
    ], log = [
        0,
        0
    ], time_sec = [
        0,
        0.
    ], use_color = [
        0,
        1
    ], in_place = [
        0,
        0
    ], diff_command = [
        0,
        0
    ], source_tree_root = [
        0,
        0
    ], diff_path_prefix = [
        0,
        0
    ];
    function displayed_descr(descr, filename, line, start_pos, end_pos) {
        var _bs_ = caml_obj_tag(descr);
        a: if (250 === _bs_) var descr$0 = descr[1];
        else {
            if (246 !== _bs_ && 244 !== _bs_) {
                var descr$0 = descr;
                break a;
            }
            var descr$0 = caml_call1(CamlinternalLazy[2], descr);
        }
        var _bt_ = descr$0 === cst$13 ? cst$0 : caml_call2(Stdlib[28], cst$1, descr$0);
        return caml_call6(Stdlib_Printf[4], _c_, filename, line, start_pos, end_pos, _bt_);
    }
    function parse_argv(current, args) {
        if (args) {
            var _a__ = args[2];
            if (_a__) {
                var name = args[1];
                if (_a__[1] === cst_inline_test_runner$0) {
                    var match = _a__[2];
                    if (match) {
                        var rest = match[2], lib = match[1];
                        if (already_initialized[1]) throw caml_maybe_attach_backtrace([
                            0,
                            Stdlib_Arg[8],
                            cst_The_inline_test_runner_can
                        ], 1);
                        already_initialized[1] = 1;
                        var tests = [
                            0,
                            0
                        ], list_partitions = [
                            0,
                            0
                        ], partition = [
                            0,
                            0
                        ], tag_predicate = [
                            0,
                            initial
                        ], name_filter = [
                            0,
                            0
                        ], _a$_ = caml_call4(Stdlib_Printf[4], _g_, name, cst_inline_test_runner, lib), _ba_ = caml_call2(Stdlib_Arg[11], 0, [
                            0,
                            [
                                0,
                                cst_list_test_names,
                                [
                                    0,
                                    function(param) {
                                        list_test_names[1] = 1;
                                        verbose[1] = 1;
                                        return 0;
                                    }
                                ],
                                cst_Do_not_run_tests_but_show_
                            ],
                            [
                                0,
                                [
                                    0,
                                    cst_list_partitions,
                                    [
                                        0,
                                        function(param) {
                                            list_partitions[1] = _j_;
                                            return 0;
                                        }
                                    ],
                                    cst_Lists_all_the_partitions_t$0
                                ],
                                [
                                    0,
                                    [
                                        0,
                                        cst_list_partitions_into_file,
                                        [
                                            4,
                                            function(file) {
                                                list_partitions[1] = [
                                                    0,
                                                    [
                                                        0,
                                                        file
                                                    ]
                                                ];
                                                return 0;
                                            }
                                        ],
                                        cst_Lists_all_the_partitions_t
                                    ],
                                    [
                                        0,
                                        [
                                            0,
                                            cst_partition,
                                            [
                                                4,
                                                function(i) {
                                                    partition[1] = [
                                                        0,
                                                        i
                                                    ];
                                                    return 0;
                                                }
                                            ],
                                            cst_Only_run_the_tests_in_the_
                                        ],
                                        [
                                            0,
                                            [
                                                0,
                                                cst_verbose,
                                                [
                                                    2,
                                                    verbose
                                                ],
                                                cst_Show_the_tests_as_they_run
                                            ],
                                            [
                                                0,
                                                [
                                                    0,
                                                    cst_stop_on_error,
                                                    [
                                                        2,
                                                        stop_on_error
                                                    ],
                                                    cst_Run_tests_only_up_to_the_f
                                                ],
                                                [
                                                    0,
                                                    [
                                                        0,
                                                        cst_strict,
                                                        [
                                                            2,
                                                            strict
                                                        ],
                                                        cst_End_with_an_error_if_no_te
                                                    ],
                                                    [
                                                        0,
                                                        [
                                                            0,
                                                            cst_show_counts,
                                                            [
                                                                2,
                                                                show_counts
                                                            ],
                                                            cst_Show_the_number_of_tests_r
                                                        ],
                                                        [
                                                            0,
                                                            [
                                                                0,
                                                                cst_log,
                                                                [
                                                                    0,
                                                                    function(param) {
                                                                        try {
                                                                            runtime.caml_sys_remove(cst_inline_tests_log$0);
                                                                        } catch (_br_) {}
                                                                        log[1] = [
                                                                            0,
                                                                            caml_call1(Stdlib[60], cst_inline_tests_log)
                                                                        ];
                                                                        return 0;
                                                                    }
                                                                ],
                                                                cst_Log_the_tests_run_in_inlin
                                                            ],
                                                            [
                                                                0,
                                                                [
                                                                    0,
                                                                    cst_drop_tag,
                                                                    [
                                                                        4,
                                                                        function(tag) {
                                                                            var t = tag_predicate[1], _bp_ = [
                                                                                0,
                                                                                tag,
                                                                                t[2]
                                                                            ];
                                                                            tag_predicate[1] = [
                                                                                0,
                                                                                caml_call2(Stdlib_List[44], function(_bq_) {
                                                                                    return tag !== _bq_ ? 1 : 0;
                                                                                }, t[1]),
                                                                                _bp_
                                                                            ];
                                                                            return 0;
                                                                        }
                                                                    ],
                                                                    cst_tag_Only_run_tests_not_tag
                                                                ],
                                                                [
                                                                    0,
                                                                    [
                                                                        0,
                                                                        cst_require_tag,
                                                                        [
                                                                            4,
                                                                            function(tag) {
                                                                                var t = tag_predicate[1], _bn_ = caml_call2(Stdlib_List[44], function(_bo_) {
                                                                                    return tag !== _bo_ ? 1 : 0;
                                                                                }, t[2]);
                                                                                tag_predicate[1] = [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        tag,
                                                                                        t[1]
                                                                                    ],
                                                                                    _bn_
                                                                                ];
                                                                                return 0;
                                                                            }
                                                                        ],
                                                                        cst_tag_Only_run_tests_tagged_
                                                                    ],
                                                                    [
                                                                        0,
                                                                        [
                                                                            0,
                                                                            cst_matching,
                                                                            [
                                                                                4,
                                                                                function(s) {
                                                                                    name_filter[1] = [
                                                                                        0,
                                                                                        s,
                                                                                        name_filter[1]
                                                                                    ];
                                                                                    return 0;
                                                                                }
                                                                            ],
                                                                            cst_substring_Only_run_tests_w
                                                                        ],
                                                                        [
                                                                            0,
                                                                            [
                                                                                0,
                                                                                cst_only_test,
                                                                                [
                                                                                    4,
                                                                                    function(str) {
                                                                                        try {
                                                                                            var _bg_ = [
                                                                                                0,
                                                                                                caml_call3(Stdlib_Scanf[5], str, _f_, function(file, line, start_pos, end_pos) {
                                                                                                    return [
                                                                                                        0,
                                                                                                        file,
                                                                                                        [
                                                                                                            0,
                                                                                                            line
                                                                                                        ]
                                                                                                    ];
                                                                                                })
                                                                                            ], match = _bg_;
                                                                                        } catch (_bk_) {
                                                                                            try {
                                                                                                var _bf_ = [
                                                                                                    0,
                                                                                                    caml_call3(Stdlib_Scanf[5], str, _e_, function(file, line) {
                                                                                                        return [
                                                                                                            0,
                                                                                                            file,
                                                                                                            [
                                                                                                                0,
                                                                                                                line
                                                                                                            ]
                                                                                                        ];
                                                                                                    })
                                                                                                ], match = _bf_;
                                                                                            } catch (_bl_) {
                                                                                                try {
                                                                                                    var _be_ = [
                                                                                                        0,
                                                                                                        caml_call3(Stdlib_Scanf[5], str, _d_, function(file) {
                                                                                                            return [
                                                                                                                0,
                                                                                                                file,
                                                                                                                0
                                                                                                            ];
                                                                                                        })
                                                                                                    ], match = _be_;
                                                                                                } catch (_bm_) {
                                                                                                    var match = 0;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        if (match) var match$0 = match[1], index = match$0[2], file = match$0[1], index$0 = index, filename = file;
                                                                                        else if (caml_call2(Stdlib_String[15], str, 58)) {
                                                                                            var i = caml_call2(Stdlib_String[36], str, 58), filename$0 = caml_call3(Stdlib_String[16], str, 0, i), index_string = caml_call3(Stdlib_String[16], str, i + 1 | 0, (caml_ml_string_length(str) - i | 0) - 1 | 0);
                                                                                            try {
                                                                                                var index$1 = runtime.caml_int_of_string(index_string);
                                                                                            } catch (_bj_) {
                                                                                                var _bh_ = caml_wrap_exception(_bj_);
                                                                                                if (_bh_[1] !== Stdlib[7]) throw caml_maybe_attach_backtrace(_bh_, 0);
                                                                                                var _bi_ = caml_call2(Stdlib_Printf[4], _i_, str);
                                                                                                throw caml_maybe_attach_backtrace([
                                                                                                    0,
                                                                                                    Stdlib_Arg[8],
                                                                                                    _bi_
                                                                                                ], 1);
                                                                                            }
                                                                                            var index$0 = [
                                                                                                0,
                                                                                                index$1
                                                                                            ], filename = filename$0;
                                                                                        } else var index$0 = 0, filename = str;
                                                                                        tests[1] = [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                filename,
                                                                                                index$0,
                                                                                                [
                                                                                                    0,
                                                                                                    0
                                                                                                ]
                                                                                            ],
                                                                                            tests[1]
                                                                                        ];
                                                                                        return 0;
                                                                                    }
                                                                                ],
                                                                                cst_location_Run_only_the_test
                                                                            ],
                                                                            [
                                                                                0,
                                                                                [
                                                                                    0,
                                                                                    cst_no_color,
                                                                                    [
                                                                                        3,
                                                                                        use_color
                                                                                    ],
                                                                                    cst_Summarize_tests_without_us
                                                                                ],
                                                                                [
                                                                                    0,
                                                                                    [
                                                                                        0,
                                                                                        cst_in_place,
                                                                                        [
                                                                                            2,
                                                                                            in_place
                                                                                        ],
                                                                                        cst_Update_expect_tests_in_pla
                                                                                    ],
                                                                                    [
                                                                                        0,
                                                                                        [
                                                                                            0,
                                                                                            cst_diff_cmd,
                                                                                            [
                                                                                                4,
                                                                                                function(s) {
                                                                                                    diff_command[1] = [
                                                                                                        0,
                                                                                                        s
                                                                                                    ];
                                                                                                    return 0;
                                                                                                }
                                                                                            ],
                                                                                            cst_Diff_command_for_tests_tha
                                                                                        ],
                                                                                        [
                                                                                            0,
                                                                                            [
                                                                                                0,
                                                                                                cst_source_tree_root,
                                                                                                [
                                                                                                    4,
                                                                                                    function(s) {
                                                                                                        source_tree_root[1] = [
                                                                                                            0,
                                                                                                            s
                                                                                                        ];
                                                                                                        return 0;
                                                                                                    }
                                                                                                ],
                                                                                                cst_Path_to_the_root_of_the_so
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                [
                                                                                                    0,
                                                                                                    cst_diff_path_prefix,
                                                                                                    [
                                                                                                        4,
                                                                                                        function(s) {
                                                                                                            diff_path_prefix[1] = [
                                                                                                                0,
                                                                                                                s
                                                                                                            ];
                                                                                                            return 0;
                                                                                                        }
                                                                                                    ],
                                                                                                    cst_Prefix_to_prepend_to_filep
                                                                                                ],
                                                                                                0
                                                                                            ]
                                                                                        ]
                                                                                    ]
                                                                                ]
                                                                            ]
                                                                        ]
                                                                    ]
                                                                ]
                                                            ]
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]), _bb_ = caml_call1(Stdlib_Array[11], [
                            0,
                            name,
                            rest
                        ]);
                        caml_call5(Stdlib_Arg[3], current, _bb_, _ba_, function(anon) {
                            var _bd_ = caml_call3(Stdlib_Printf[4], _h_, name, anon);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Stdlib_Arg[8],
                                _bd_
                            ], 1);
                        }, _a$_);
                        var match$0 = list_partitions[1];
                        if (match$0) var where_to_list = match$0[1], _bc_ = [
                            0,
                            -260537174,
                            where_to_list
                        ];
                        else var _bc_ = [
                            0,
                            1025081494,
                            partition[1]
                        ];
                        var v = [
                            0,
                            -753295984,
                            [
                                0,
                                [
                                    0,
                                    lib,
                                    tests[1],
                                    name_filter[1],
                                    tag_predicate[1]
                                ],
                                _bc_
                            ]
                        ];
                        action[1] = v;
                        return;
                    }
                }
            }
        }
    }
    if (Base[87][1]) try {
        var _S_ = caml_sys_argv(0);
        parse_argv(0, caml_call1(Stdlib_Array[10], _S_));
    } catch (exn$0) {
        var exn = caml_wrap_exception(exn$0);
        if (exn[1] === Stdlib_Arg[8]) {
            var msg = exn[2];
            caml_call2(Stdlib_Printf[3], _k_, msg);
            caml_call1(Stdlib[99], 1);
        } else {
            if (exn[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$0 = exn[2];
            caml_call2(Stdlib_Printf[2], _R_, msg$0);
            caml_call1(Stdlib[99], 0);
        }
    }
    function init(args) {
        var current = [
            0,
            0
        ];
        try {
            parse_argv([
                0,
                current
            ], args);
            return _l_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] === Stdlib_Arg[8]) {
                var msg = exn[2];
                return [
                    1,
                    msg
                ];
            }
            if (exn[1] !== Stdlib_Arg[7]) throw caml_maybe_attach_backtrace(exn, 0);
            var msg$0 = exn[2];
            return [
                0,
                [
                    0,
                    msg$0
                ]
            ];
        }
    }
    var am_test_runner = typeof get(0) === "number" ? 0 : 1;
    a: {
        try {
            caml_sys_getenv("PPX_INLINE_TEST_LIB_AM_RUNNING_INLINE_TEST");
        } catch (_a8_) {
            var _m_ = caml_wrap_exception(_a8_);
            if (_m_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_m_, 0);
            b: {
                try {
                    var val = caml_sys_getenv(cst_TESTING_FRAMEWORK);
                } catch (_a9_) {
                    var _n_ = caml_wrap_exception(_a9_);
                    if (_n_ !== Stdlib[8]) throw caml_maybe_attach_backtrace(_n_, 0);
                    var _o_ = 0;
                    break b;
                }
                var _Q_ = val !== "inline-test" ? 0 : 1, _o_ = _Q_;
            }
            var am_running = _o_;
            break a;
        }
        var am_running = 1;
    }
    var testing = am_test_runner ? _p_ : am_running ? _P_ : 822171972;
    function timestamp_ns(param) {
        return caml_call1(Time_now[2], 0);
    }
    var where_to_cut_backtrace = [
        246,
        function(param) {
            var _a6_ = caml_call2(Stdlib[28], cst$2, cst_time_without_resetting_ran), _a7_ = caml_call2(Stdlib[28], cst_Ppx_inline_test_lib, _a6_);
            return caml_call2(Base_String[86][2], 0, _a7_);
        }
    ];
    function time_without_resetting_random_(f) {
        var before_ns = timestamp_ns(0);
        try {
            var _a5_ = [
                0,
                caml_call1(f, 0)
            ], res = _a5_;
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0), res = [
                1,
                [
                    0,
                    exn,
                    caml_call1(Stdlib_Printexc[6], 0)
                ]
            ];
        }
        var _a3_ = timestamp_ns(0), _a4_ = caml_call2(Base_Int63[46], _a3_, before_ns);
        time_sec[1] = caml_call1(Base_Int63[3], _a4_) / 1000000000.;
        return res;
    }
    var saved_caml_random_state = [
        246,
        function(_a2_) {
            return caml_call1(Stdlib_Random[19][1], [
                0,
                100,
                200,
                300
            ]);
        }
    ], saved_base_random_state = [
        246,
        function(_a1_) {
            return caml_call1(Base_Random[19][2], [
                0,
                111,
                222,
                333
            ]);
        }
    ];
    function string_of_module_descr(param) {
        var t = current$0[1], _aW_ = caml_call2(Stdlib_List[20], function(m) {
            return m[1];
        }, t), _aX_ = caml_call2(Stdlib_List[20], function(s) {
            var _aY_ = caml_call1(Stdlib_String[29], s), _aZ_ = caml_call2(Stdlib[28], _aY_, cst$3), _a0_ = caml_call2(Stdlib[28], cst_T_MODULE_at, _aZ_);
            return caml_call2(Stdlib[28], cst_in_TES, _a0_);
        }, _aW_);
        return caml_call2(Stdlib_String[7], cst$4, _aX_);
    }
    function print_delayed_errors(param) {
        var delayed_errors$0 = caml_call1(Stdlib_List[10], delayed_errors[1]);
        if (!delayed_errors$0) return;
        var _aV_ = caml_call2(Stdlib_String[1], 70, 61);
        caml_call2(Stdlib_Printf[3], _q_, _aV_);
        return caml_call2(Stdlib_List[18], function(message) {
            return caml_call2(Stdlib_Printf[3], _r_, message);
        }, delayed_errors$0);
    }
    function eprintf_or_delay(fmt) {
        return caml_call2(Stdlib_Printf[10], function(s) {
            if (verbose[1]) delayed_errors[1] = [
                0,
                s,
                delayed_errors[1]
            ];
            else caml_call2(Stdlib_Printf[3], _s_, s);
            var _aU_ = stop_on_error[1];
            return _aU_ ? (print_delayed_errors(0), caml_call1(Stdlib[99], 2)) : _aU_;
        }, fmt);
    }
    function add_hooks(C, f, param) {
        caml_call1(C[1], 0);
        return caml_call1(f, 0);
    }
    function hum_backtrace(backtrace) {
        var _aO_ = caml_call1(Base_String[104], backtrace), _aP_ = caml_call2(Base_List[141], _aO_, function(str) {
            var _aS_ = caml_obj_tag(where_to_cut_backtrace);
            a: if (250 === _aS_) var _aT_ = where_to_cut_backtrace[1];
            else {
                if (246 !== _aS_ && 244 !== _aS_) {
                    var _aT_ = where_to_cut_backtrace;
                    break a;
                }
                var _aT_ = caml_call1(CamlinternalLazy[2], where_to_cut_backtrace);
            }
            return 1 - caml_call2(Base_String[86][5], _aT_, str);
        }), _aQ_ = caml_call2(Base_List[53], _aP_, function(str) {
            var _aR_ = caml_call2(Base[241], str, cst$5);
            return caml_call2(Base[241], cst$6, _aR_);
        });
        return caml_call2(Base_String[68], 0, _aQ_);
    }
    function test_inner(config, descr, tags, def_filename, def_line_number, start_pos, end_pos, f, bool_of_f) {
        var match = get(0);
        if (typeof match === "number") return 0;
        var _au_ = match[2], what_to_do = _au_[2], match$0 = _au_[1], which_tags = match$0[4], name_filter = match$0[3], only_test_location = match$0[2], libname = match$0[1];
        function f$0(_aN_) {
            return add_hooks(config, f, _aN_);
        }
        var descr$0 = [
            246,
            function(_aM_) {
                return displayed_descr(descr, def_filename, def_line_number, start_pos, end_pos);
            }
        ], _av_ = current_tags(0), complete_tags = caml_call2(Stdlib[37], tags, _av_), _aw_ = caml_equal([
            0,
            libname
        ], dynamic_lib[1]);
        if (_aw_) {
            var _ax_ = only_test_location ? caml_call2(Stdlib_List[34], function(param) {
                var used = param[3], line_number_opt = param[2], filename = param[1], position_start = caml_ml_string_length(def_filename) - caml_ml_string_length(filename) | 0, _aH_ = 0 <= position_start ? 1 : 0;
                if (_aH_) {
                    var end_of_def_filename = caml_call3(Stdlib_String[16], def_filename, position_start, caml_ml_string_length(filename)), _aI_ = end_of_def_filename === filename ? 1 : 0;
                    if (_aI_) {
                        var _aJ_ = 0 === position_start ? 1 : 0, _aK_ = _aJ_ || (47 === runtime.caml_string_get(def_filename, position_start - 1 | 0) ? 1 : 0);
                        if (_aK_) {
                            if (line_number_opt) var line_number = line_number_opt[1], _aL_ = caml_equal(def_line_number, line_number);
                            else var _aL_ = 1;
                        } else var _aL_ = _aK_;
                    } else var _aL_ = _aI_;
                    var found = _aL_;
                } else var found = _aH_;
                if (found) used[1] = 1;
                return found;
            }, only_test_location) : 1;
            if (_ax_) {
                var _ap_ = caml_call2(Stdlib_List[34], function(req) {
                    return 1 - caml_call2(Stdlib_List[37], req, complete_tags);
                }, which_tags[1]), _ay_ = _ap_ || caml_call2(Stdlib_List[34], function(dropped) {
                    return caml_call2(Stdlib_List[37], dropped, complete_tags);
                }, which_tags[2]), _az_ = 1 - _ay_;
                if (_az_) {
                    var _aA_ = caml_obj_tag(descr$0);
                    a: if (250 === _aA_) var descr$1 = descr$0[1];
                    else {
                        if (246 !== _aA_ && 244 !== _aA_) {
                            var descr$1 = descr$0;
                            break a;
                        }
                        var descr$1 = caml_call1(CamlinternalLazy[2], descr$0);
                    }
                    var _aB_ = name_filter ? caml_call2(Stdlib_List[34], function(substring) {
                        return caml_call2(Base_String[92], descr$1, substring);
                    }, name_filter) : 1, should_run = _aB_;
                } else var should_run = _az_;
            } else var should_run = _ax_;
        } else var should_run = _aw_;
        if (!should_run) return should_run;
        if (1025081494 > what_to_do[1]) return found_test(0);
        var partition = what_to_do[2], _aC_ = is_current(partition);
        if (!_aC_) return _aC_;
        var _aD_ = caml_obj_tag(descr$0);
        a: if (250 === _aD_) var descr$2 = descr$0[1];
        else {
            if (246 !== _aD_ && 244 !== _aD_) {
                var descr$2 = descr$0;
                break a;
            }
            var descr$2 = caml_call1(CamlinternalLazy[2], descr$0);
        }
        tests_ran[1]++;
        var match$1 = log[1];
        if (match$1) {
            var ch = match$1[1], _aE_ = string_of_module_descr(0);
            caml_call4(Stdlib_Printf[1], ch, _t_, descr$2, _aE_);
        }
        if (verbose[1]) caml_call2(Stdlib_Printf[2], _u_, descr$2);
        if (list_test_names[1]) var result$0 = _v_;
        else {
            var caml_random_state = caml_call1(Stdlib_Random[20], 0), base_random_state = caml_call1(Base_Random[19][4], Base_Random[19][1]), _aq_ = caml_obj_tag(saved_caml_random_state);
            a: if (250 === _aq_) var _ar_ = saved_caml_random_state[1];
            else {
                if (246 !== _aq_ && 244 !== _aq_) {
                    var _ar_ = saved_caml_random_state;
                    break a;
                }
                var _ar_ = caml_call1(CamlinternalLazy[2], saved_caml_random_state);
            }
            caml_call1(Stdlib_Random[21], _ar_);
            var _as_ = caml_obj_tag(saved_base_random_state);
            a: if (250 === _as_) var _at_ = saved_base_random_state[1];
            else {
                if (246 !== _as_ && 244 !== _as_) {
                    var _at_ = saved_base_random_state;
                    break a;
                }
                var _at_ = caml_call1(CamlinternalLazy[2], saved_base_random_state);
            }
            caml_call1(Base_Random[20], _at_);
            var result = time_without_resetting_random_(f$0);
            caml_call1(Stdlib_Random[21], caml_random_state);
            caml_call1(Base_Random[20], base_random_state);
            var result$0 = caml_call2(Stdlib_Result[8], bool_of_f, result);
        }
        if (verbose[1]) caml_call2(Stdlib_Printf[2], _w_, time_sec[1]);
        if (0 !== result$0[0]) {
            var match$2 = result$0[1], backtrace = match$2[2], exn = match$2[1];
            tests_failed[1]++;
            var backtrace$0 = hum_backtrace(backtrace), exn_str = caml_call1(Sexplib0_Sexp_conv[70], exn), sep = caml_call2(Stdlib_String[15], exn_str, 10) ? cst$7 : cst$8, _aG_ = string_of_module_descr(0);
            return caml_call5(eprintf_or_delay(_y_), descr$2, sep, exn_str, backtrace$0, _aG_);
        }
        if (result$0[1]) return 0;
        tests_failed[1]++;
        var _aF_ = string_of_module_descr(0);
        return caml_call2(eprintf_or_delay(_x_), descr$2, _aF_);
    }
    function set_lib_and_partition(static_lib, partition) {
        if (dynamic_lib[1]) return 0;
        dynamic_lib[1] = [
            0,
            static_lib
        ];
        var match = get(0);
        if (typeof match === "number") return 0;
        var match$0 = match[2], what_to_do = match$0[2], which_tests = match$0[1], _ao_ = which_tests[1] === static_lib ? 1 : 0;
        if (!_ao_) return _ao_;
        a: {
            if (1025081494 <= what_to_do[1] && !what_to_do[2]) {
                var requires_partition = 0;
                break a;
            }
            var requires_partition = 1;
        }
        if (partition === cst$13 && requires_partition) return caml_call1(Stdlib[2], cst_ppx_inline_test_cannot_use);
        current[1] = partition;
        return 0;
    }
    function unset_lib(static_lib) {
        var match = dynamic_lib[1];
        if (!match) return 0;
        var lib = match[1], _am_ = lib === static_lib ? 1 : 0, _an_ = _am_ ? (dynamic_lib[1] = 0, 0) : _am_;
        return _an_;
    }
    function test(config, descr, tags, filename, line_number, start_pos, end_pos, f) {
        return test_inner(config, descr, tags, filename, line_number, start_pos, end_pos, f, function(b) {
            return b;
        });
    }
    function test_unit(config, descr, tags, filename, line_number, start_pos, end_pos, f) {
        return test_inner(config, descr, tags, filename, line_number, start_pos, end_pos, f, function(param) {
            return 1;
        });
    }
    function test_module(config, descr, tags, def_filename, def_line_number, start_pos, end_pos, f) {
        var match = get(0);
        if (typeof match === "number") return 0;
        var _af_ = match[2], what_to_do = _af_[2], match$0 = _af_[1], which_tags = match$0[4], libname = match$0[1];
        function f$0(_al_) {
            return add_hooks(config, f, _al_);
        }
        var _ag_ = current_tags(0), partial_tags = caml_call2(Stdlib[37], tags, _ag_), _ah_ = caml_equal([
            0,
            libname
        ], dynamic_lib[1]), should_run = _ah_ ? 1 - caml_call2(Stdlib_List[34], function(dropped) {
            return caml_call2(Stdlib_List[37], dropped, partial_tags);
        }, which_tags[2]) : _ah_;
        if (!should_run) return should_run;
        if (1025081494 > what_to_do[1]) return found_test(0);
        var partition = what_to_do[2], _ai_ = is_current(partition);
        if (!_ai_) return _ai_;
        test_modules_ran[1]++;
        var descr$0 = displayed_descr(descr, def_filename, def_line_number, start_pos, end_pos), prev = current$0[1];
        current$0[1] = [
            0,
            [
                0,
                descr$0,
                tags
            ],
            prev
        ];
        try {
            var x = time_without_resetting_random_(f$0);
            current$0[1] = prev;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            current$0[1] = prev;
            throw caml_maybe_attach_backtrace(e, 0);
        }
        if (0 === x[0]) return 0;
        var match$1 = x[1], backtrace = match$1[2], exn = match$1[1];
        test_modules_failed[1]++;
        var backtrace$0 = hum_backtrace(backtrace), exn_str = caml_call1(Sexplib0_Sexp_conv[70], exn), sep = caml_call2(Stdlib_String[15], exn_str, 10) ? cst$9 : cst$10, _aj_ = string_of_module_descr(0), _ak_ = caml_call1(Stdlib_String[29], descr$0);
        return caml_call5(eprintf_or_delay(caml_call2(Stdlib[98], _A_, _z_)), _ak_, sep, exn_str, backtrace$0, _aj_);
    }
    function summarize(param) {
        var match = get(0);
        if (typeof match !== "number") {
            var _Z_ = match[2], match$0 = _Z_[2], which_tests = _Z_[1];
            if (1025081494 > match$0[1]) {
                var where_to_list = match$0[2], f = function(fout) {
                    var _ac_ = caml_call3(Stdlib_Hashtbl[14], function(k, param, acc) {
                        return [
                            0,
                            k,
                            acc
                        ];
                    }, _b_, 0), _ad_ = caml_call2(Stdlib_List[63], Stdlib_String[10], _ac_), _ae_ = caml_call2(Stdlib_Printf[1], fout, _N_);
                    return caml_call2(Stdlib_List[18], _ae_, _ad_);
                };
                if (where_to_list) {
                    var file = where_to_list[1], _aa_ = caml_call3(Stdlib[62], _M_, 0, file), _ab_ = Stdlib[76];
                    caml_call2(caml_call1(Base_Exn[12], f), _aa_, _ab_);
                } else f(Stdlib[39]);
                return 0;
            }
            var match$1 = log[1];
            if (match$1) {
                var ch = match$1[1];
                caml_call1(Stdlib[76], ch);
            }
            print_delayed_errors(0);
            var count = tests_failed[1], count_test_modules = test_modules_failed[1];
            if (0 === count && 0 === count_test_modules) {
                if (show_counts[1]) caml_call3(Stdlib_Printf[3], _D_, tests_ran[1], test_modules_ran[1]);
                var unused_tests = caml_call2(Stdlib_List[44], function(param) {
                    var used = param[3];
                    return 1 - used[1];
                }, which_tests[2]), errors = unused_tests ? [
                    0,
                    unused_tests
                ] : 0;
                if (errors) {
                    var tests = errors[1];
                    caml_call1(Stdlib_Printf[3], _E_);
                    caml_call2(Stdlib_List[18], function(param) {
                        var line_number_opt = param[2], filename = param[1];
                        if (!line_number_opt) return caml_call2(Stdlib_Printf[3], _G_, filename);
                        var line_number = line_number_opt[1];
                        return caml_call3(Stdlib_Printf[3], _F_, filename, line_number);
                    }, tests);
                    caml_call1(Stdlib_Printf[3], _H_);
                    return 2;
                }
                if (0 === tests_ran[1] && strict[1]) {
                    caml_call1(Stdlib_Printf[3], _I_);
                    return 2;
                }
                return 0;
            }
            if (0 === count_test_modules) var ___ = cst$11;
            else var _$_ = caml_call2(Stdlib[98], _L_, _K_), ___ = caml_call2(Stdlib_Printf[4], _$_, count_test_modules);
            caml_call4(Stdlib_Printf[3], _J_, count, tests_ran[1], ___);
            return 1;
        }
        a: {
            if (runtime.caml_notequal(caml_sys_argv(0), [
                0
            ])) {
                var _Y_ = runtime.caml_check_bound(caml_sys_argv(0), 0)[1];
                if (caml_call1(Stdlib_Filename[13], _Y_) === "inline_tests_runner.exe") {
                    caml_call1(Stdlib_Printf[3], _B_);
                    break a;
                }
            }
            caml_call1(Stdlib_Printf[3], _C_);
        }
        return 2;
    }
    function assert_test_configs_initialize(config) {
        var _W_ = 1 - already_initialized[1];
        if (!_W_) return _W_;
        var _X_ = caml_call2(Stdlib_Printf[4], _O_, config);
        return caml_call1(Stdlib[2], _X_);
    }
    function use_color$0(param) {
        assert_test_configs_initialize(cst_use_color);
        return use_color[1];
    }
    function in_place$0(param) {
        assert_test_configs_initialize(cst_in_place$0);
        return in_place[1];
    }
    function diff_command$0(param) {
        assert_test_configs_initialize(cst_diff_command);
        return diff_command[1];
    }
    function diff_path_prefix$0(param) {
        assert_test_configs_initialize(cst_diff_path_prefix$0);
        return diff_path_prefix[1];
    }
    function source_tree_root$0(param) {
        assert_test_configs_initialize(cst_source_tree_root$0);
        return source_tree_root[1];
    }
    var evaluators = [
        0,
        [
            0,
            summarize,
            0
        ]
    ];
    function add_evaluator(f) {
        evaluators[1] = [
            0,
            f,
            evaluators[1]
        ];
        return 0;
    }
    function exit(param) {
        var _U_ = caml_call1(Stdlib_List[10], evaluators[1]);
        switch(combine_all(caml_call2(Stdlib_List[20], function(f) {
            return caml_call1(f, 0);
        }, _U_))){
            case 0:
                var _V_ = 0;
                break;
            case 1:
                var _V_ = 2;
                break;
            default:
                var _V_ = 1;
        }
        return caml_call1(Stdlib[99], _V_);
    }
    var Ppx_inline_test_lib = [
        0,
        am_running,
        am_running_env_var,
        testing,
        init,
        [
            0,
            combine,
            combine_all,
            to_string
        ],
        set_lib_and_partition,
        unset_lib,
        test,
        test_unit,
        test_module,
        use_color$0,
        in_place$0,
        diff_command$0,
        diff_path_prefix$0,
        source_tree_root$0,
        add_evaluator,
        exit
    ];
    runtime.caml_register_global(137, Ppx_inline_test_lib, cst_Ppx_inline_test_lib$0);
    return;
})(globalThis);
//# 15 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), flags = [
        0,
        0,
        0
    ], Base_List = global_data.Base__List, Stdlib = global_data.Stdlib, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Stdlib_Buffer = global_data.Stdlib__Buffer, Base_Buffer = global_data.Base__Buffer, Base_Exn = global_data.Base__Exn;
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var seek = Stdlib[96][4], pos = Stdlib[96][5], length = Stdlib[96][6], stdin = Stdlib[38];
    function create(opt, file) {
        var binary = opt ? opt[1] : 1, flags$0 = binary ? [
            0,
            6,
            flags
        ] : flags;
        return caml_call3(Stdlib[81], flags$0, 0, file);
    }
    var close = Stdlib[93];
    function with_file(binary, file, f) {
        var _i_ = create(binary, file);
        return caml_call3(Base_Exn[12], f, _i_, close);
    }
    function may_eof(f) {
        try {
            var _g_ = [
                0,
                caml_call1(f, 0)
            ];
            return _g_;
        } catch (_h_) {
            var _f_ = caml_wrap_exception(_h_);
            if (_f_ === Stdlib[12]) return 0;
            throw caml_maybe_attach_backtrace(_f_, 0);
        }
    }
    function input(t, buf, pos, len) {
        return caml_call4(Stdlib[84], t, buf, pos, len);
    }
    function really_input(t, buf, pos, len) {
        return may_eof(function(param) {
            return caml_call4(Stdlib[85], t, buf, pos, len);
        });
    }
    function really_input_exn(t, buf, pos, len) {
        return caml_call4(Stdlib[85], t, buf, pos, len);
    }
    function input_byte(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[87], t);
        });
    }
    function input_char(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[82], t);
        });
    }
    function input_binary_int(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[88], t);
        });
    }
    function unsafe_input_value(t) {
        return may_eof(function(param) {
            return caml_call1(Stdlib[89], t);
        });
    }
    function input_buffer(t, buf, len) {
        return may_eof(function(param) {
            return caml_call3(Stdlib_Buffer[22], buf, t, len);
        });
    }
    var set_binary_mode = Stdlib[95];
    function input_all(t) {
        var chunk_size = 65536, buffer = caml_call1(Base_Buffer[2], chunk_size);
        try {
            for(;;)caml_call3(Stdlib_Buffer[22], buffer, t, chunk_size);
        } catch (_e_) {
            var _d_ = caml_wrap_exception(_e_);
            if (_d_ === Stdlib[12]) return caml_call1(Base_Buffer[3], buffer);
            throw caml_maybe_attach_backtrace(_d_, 0);
        }
    }
    function trim(fix_win_eol, line) {
        if (!fix_win_eol) return line;
        var len = runtime.caml_ml_string_length(line);
        if (0 < len) {
            var _c_ = runtime.caml_string_get(line, len - 1 | 0);
            if (caml_call2(Base_Char[16], _c_, 13)) return caml_call3(Base_String[3], line, 0, len - 1 | 0);
        }
        return line;
    }
    function input_line(opt, t) {
        var fix_win_eol = opt ? opt[1] : 1, match = may_eof(function(param) {
            return caml_call1(Stdlib[83], t);
        });
        if (!match) return 0;
        var line = match[1];
        return [
            0,
            trim(fix_win_eol, line)
        ];
    }
    function input_line_exn(opt, t) {
        var fix_win_eol = opt ? opt[1] : 1, line = caml_call1(Stdlib[83], t);
        return trim(fix_win_eol, line);
    }
    function fold_lines(fix_win_eol, t, init, f) {
        var ac = init;
        for(;;){
            var match = input_line(fix_win_eol, t);
            if (!match) return ac;
            var line = match[1], ac$0 = caml_call2(f, ac, line);
            ac = ac$0;
        }
    }
    function input_lines(fix_win_eol, t) {
        var _b_ = fold_lines(fix_win_eol, t, 0, function(lines, line) {
            return [
                0,
                line,
                lines
            ];
        });
        return caml_call1(Base_List[63], _b_);
    }
    function iter_lines(fix_win_eol, t, f) {
        return fold_lines(fix_win_eol, t, 0, function(param, line) {
            return caml_call1(f, line);
        });
    }
    function read_lines(fix_win_eol, fname) {
        return with_file(0, fname, function(_a_) {
            return input_lines(fix_win_eol, _a_);
        });
    }
    function read_all(fname) {
        return with_file(0, fname, input_all);
    }
    var Stdio_In_channel = [
        0,
        equal,
        stdin,
        create,
        with_file,
        close,
        input,
        really_input,
        really_input_exn,
        input_char,
        input_byte,
        input_binary_int,
        unsafe_input_value,
        input_buffer,
        input_all,
        input_line,
        input_line_exn,
        fold_lines,
        input_lines,
        iter_lines,
        seek,
        pos,
        length,
        set_binary_mode,
        read_lines,
        read_all
    ];
    runtime.caml_register_global(8, Stdio_In_channel, "Stdio__In_channel");
    return;
})(globalThis);
//# 198 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = "\n", flags = [
        0,
        1,
        [
            0,
            3,
            0
        ]
    ], Base_Exn = global_data.Base__Exn, Base = global_data.Base, Base_List = global_data.Base__List, Stdlib = global_data.Stdlib, Stdlib_Buffer = global_data.Stdlib__Buffer, Stdlib_Printf = global_data.Stdlib__Printf;
    function equal(t1, t2) {
        return t1 === t2 ? 1 : 0;
    }
    var seek = Stdlib[96][1], pos = Stdlib[96][2], length = Stdlib[96][3], stdout = Stdlib[39], stderr = Stdlib[40], _a_ = [
        0,
        "<stderr>"
    ], _b_ = [
        0,
        "<stdout>"
    ], _c_ = [
        0,
        "<Out_channel.t>"
    ];
    function sexp_of_t(t) {
        return t === stderr ? _a_ : t === stdout ? _b_ : _c_;
    }
    function create(_g_, _f_, _e_, opt, file) {
        var binary = _g_ ? _g_[1] : 1, append = _f_ ? _f_[1] : 0, fail_if_exists = _e_ ? _e_[1] : 0, perm = opt ? opt[1] : 438, _h_ = binary ? 6 : 7, flags$0 = [
            0,
            _h_,
            flags
        ], _i_ = append ? 2 : 4, flags$1 = [
            0,
            _i_,
            flags$0
        ], flags$2 = fail_if_exists ? [
            0,
            5,
            flags$1
        ] : flags$1;
        return caml_call3(Stdlib[62], flags$2, perm, file);
    }
    var set_binary_mode = Stdlib[78], flush = Stdlib[63], close = Stdlib[76], close_no_err = Stdlib[77];
    function output(t, buf, pos, len) {
        return caml_call4(Stdlib[68], t, buf, pos, len);
    }
    function output_substring(t, buf, pos, len) {
        return caml_call4(Stdlib[69], t, buf, pos, len);
    }
    var output_string = Stdlib[66], output_bytes = Stdlib[67], output_char = Stdlib[65], output_byte = Stdlib[70], output_binary_int = Stdlib[71], output_buffer = Stdlib_Buffer[10], output_value = Stdlib[72];
    function newline(t) {
        return caml_call2(output_string, t, cst);
    }
    function output_line(t, line) {
        caml_call2(output_string, t, line);
        return caml_call2(output_string, t, cst);
    }
    function output_lines(t, lines) {
        return caml_call2(Base_List[19], lines, function(line) {
            return output_line(t, line);
        });
    }
    var printf = Stdlib_Printf[2], eprintf = Stdlib_Printf[3], fprintf = Stdlib_Printf[1], kfprintf = Stdlib_Printf[8], print_string = Stdlib[42], print_endline = Stdlib[46], prerr_endline = Stdlib[53];
    function fprint_s(mach, t, sexp) {
        var string = mach ? caml_call1(Base[85][15], sexp) : caml_call2(Base[85][14], 0, sexp);
        caml_call2(output_string, t, string);
        caml_call2(output_char, t, 10);
        return caml_call1(flush, t);
    }
    function print_s(mach, sexp) {
        return fprint_s(mach, stdout, sexp);
    }
    function eprint_s(mach, sexp) {
        return fprint_s(mach, stderr, sexp);
    }
    function with_file(binary, append, fail_if_exists, perm, file, f) {
        var _d_ = create(binary, append, fail_if_exists, perm, file);
        return caml_call3(Base_Exn[12], f, _d_, close);
    }
    function write_lines(file, lines) {
        return with_file(0, 0, 0, 0, file, function(t) {
            return output_lines(t, lines);
        });
    }
    function write_all(file, data) {
        return with_file(0, 0, 0, 0, file, function(t) {
            return caml_call2(output_string, t, data);
        });
    }
    var Stdio_Out_channel = [
        0,
        sexp_of_t,
        equal,
        stdout,
        stderr,
        create,
        with_file,
        close,
        close_no_err,
        set_binary_mode,
        flush,
        output,
        output_string,
        output_substring,
        output_bytes,
        output_char,
        output_byte,
        output_binary_int,
        output_buffer,
        output_value,
        newline,
        output_lines,
        output_line,
        fprintf,
        printf,
        fprint_s,
        print_s,
        eprint_s,
        eprintf,
        kfprintf,
        print_string,
        print_endline,
        prerr_endline,
        seek,
        pos,
        length,
        write_lines,
        write_all
    ];
    runtime.caml_register_global(11, Stdio_Out_channel, "Stdio__Out_channel");
    return;
})(globalThis);
//# 372 "../.js/default/stdio/stdio.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, global_data = runtime.caml_get_global_data(), Stdio_In_channel = global_data.Stdio__In_channel, Stdio_Out_channel = global_data.Stdio__Out_channel, stdin = Stdio_In_channel[2], stdout = Stdio_Out_channel[3], stderr = Stdio_Out_channel[4], eprintf = Stdio_Out_channel[28], printf = Stdio_Out_channel[24], print_s = Stdio_Out_channel[26], eprint_s = Stdio_Out_channel[27], print_string = Stdio_Out_channel[30], print_endline = Stdio_Out_channel[31], prerr_endline = Stdio_Out_channel[32], Stdio = [
        0,
        stdin,
        stdout,
        stderr,
        printf,
        print_s,
        eprint_s,
        eprintf,
        print_string,
        print_endline,
        prerr_endline
    ];
    runtime.caml_register_global(2, Stdio, "Stdio");
    return;
})(globalThis);
//# 5 "../.js/default/ppxlib.print_diff/ppxlib_print_diff.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_line_1_characters_0_0 = '", line 1, characters 0-0:\n', cst_File = 'File "', cst_File_s_line_1_characters_0 = 'File "%s", line 1, characters 0-0:\n%!', cst_diff_u$1 = "diff -u";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst = " ", Stdlib_Filename = global_data.Stdlib__Filename, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_ListLabels = global_data.Stdlib__ListLabels, Stdlib_StringLabels = global_data.Stdlib__StringLabels, _a_ = [
        0,
        "-location-style omake",
        0
    ], _b_ = [
        0,
        "-keep-whitespace",
        0
    ], cst_patdiff = "patdiff", _c_ = [
        0,
        "-ascii",
        0
    ], _d_ = [
        0,
        [
            2,
            0,
            [
                12,
                32,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " 1>&2",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s %s %s 1>&2"
    ], _e_ = [
        0,
        [
            11,
            cst_File,
            [
                2,
                0,
                [
                    11,
                    cst_line_1_characters_0_0,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        cst_File_s_line_1_characters_0
    ], cst_diff_u = cst_diff_u$1, _f_ = [
        0,
        [
            11,
            "Error:\n> ",
            [
                3,
                0,
                [
                    11,
                    " exited with code ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            "\n> Perhaps patdiff is not installed? Hint, try: opam install patdiff\n> Falling back to diff -u\n\n",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Error:\n> %S exited with code %d\n> Perhaps patdiff is not installed? Hint, try: opam install patdiff\n> Falling back to diff -u\n\n"
    ], _g_ = [
        0,
        [
            11,
            cst_File,
            [
                2,
                0,
                [
                    11,
                    cst_line_1_characters_0_0,
                    [
                        10,
                        0
                    ]
                ]
            ]
        ],
        cst_File_s_line_1_characters_0
    ], cst_diff_u$0 = cst_diff_u$1;
    function print(diff_command, _j_, opt, file1, file2, param) {
        var extra_patdiff_args = _j_ ? _j_[1] : 0, use_color = opt ? opt[1] : 0;
        function exec(cmd) {
            var _k_ = caml_call1(Stdlib_Filename[21], file2), _l_ = caml_call1(Stdlib_Filename[21], file1), cmd$0 = caml_call4(Stdlib_Printf[4], _d_, cmd, _l_, _k_), n = runtime.caml_sys_system_command(cmd$0);
            return 0 === n ? 925282182 : 1 === n ? -890978471 : [
                0,
                106380200,
                [
                    0,
                    n,
                    cmd$0
                ]
            ];
        }
        if (diff_command) {
            var s = diff_command[1];
            exec(s);
            return 0;
        }
        var _h_ = [
            0,
            extra_patdiff_args,
            0
        ], _i_ = use_color ? 0 : _c_, args = caml_call1(Stdlib_ListLabels[14], [
            0,
            _b_,
            [
                0,
                _a_,
                [
                    0,
                    _i_,
                    _h_
                ]
            ]
        ]), match = exec(caml_call2(Stdlib_StringLabels[7], cst, [
            0,
            cst_patdiff,
            args
        ]));
        if (typeof match === "number") return 925282182 <= match ? (caml_call2(Stdlib_Printf[3], _e_, file1), exec(cst_diff_u), 0) : 0;
        var match$0 = match[2], cmd = match$0[2], err_code = match$0[1];
        caml_call3(Stdlib_Printf[3], _f_, cmd, err_code);
        caml_call2(Stdlib_Printf[3], _g_, file1);
        exec(cst_diff_u$0);
        return 0;
    }
    var Ppxlib_print_diff = [
        0,
        print
    ];
    runtime.caml_register_global(15, Ppxlib_print_diff, "Ppxlib_print_diff");
    return;
})(globalThis);
//# 29 "../.js/default/ppx_expect.make_corrected_file/make_corrected_file.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$3 = "", cst$4 = "/";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$2 = cst$3, cst$0 = cst$4, cst$1 = cst$3, cst = cst$4, Stdio_In_channel = global_data.Stdio__In_channel, Base_String = global_data.Base__String, Base = global_data.Base, Base_Option = global_data.Base__Option, Stdio_Out_channel = global_data.Stdio__Out_channel, Base_Sys = global_data.Base__Sys, Base_Char = global_data.Base__Char, Base_List = global_data.Base__List, Ppxlib_print_diff = global_data.Ppxlib_print_diff, Base_Error = global_data.Base__Error, _a_ = [
        0,
        0
    ], cst_corrected = ".corrected", cst_TESTING_FRAMEWORK = "TESTING_FRAMEWORK", cst_alt_old = "-alt-old", cst_alt_new = "-alt-new", cst_Changes_found = "Changes found.", _b_ = [
        0,
        "-default",
        0
    ];
    function chop_if_exists(ancestor, path) {
        var _j_ = caml_call2(Base[241], ancestor, cst);
        return caml_call2(Base_String[119], path, _j_);
    }
    function f(_c_, corrected_path, opt, diff_command, diff_path_prefix, next_contents, path, param) {
        var use_dot_patdiff = _c_ ? _c_[1] : 0, use_color = opt ? opt[1] : 0, prev_contents = runtime.caml_sys_file_exists(path) ? caml_call3(Stdio_In_channel[4], 0, path, Stdio_In_channel[14]) : cst$2;
        if (caml_call2(Base_String[47], prev_contents, next_contents)) return _a_;
        var default_corrected_path = caml_call2(Base[241], path, cst_corrected), corrected_path$0 = caml_call2(Base_Option[30], corrected_path, default_corrected_path);
        caml_call2(Stdio_Out_channel[37], corrected_path$0, next_contents);
        if (use_dot_patdiff) var _d_ = caml_call1(Base_Sys[19], cst_TESTING_FRAMEWORK), _e_ = caml_call1(Base_Option[52], _d_);
        else var _e_ = use_dot_patdiff;
        var default_configs = _e_ ? 0 : _b_, cwd = runtime.caml_sys_getcwd(0);
        if (diff_path_prefix) var prefix = diff_path_prefix[1], _f_ = [
            0,
            caml_call1(Base_Char[16], 47)
        ], _g_ = caml_call2(Base_String[108], _f_, prefix), prefix$0 = caml_call2(Base[241], _g_, cst$0);
        else var prefix$0 = cst$1;
        var _h_ = chop_if_exists(cwd, path), alt_old = [
            0,
            cst_alt_old,
            [
                0,
                caml_call2(Base[241], prefix$0, _h_),
                0
            ]
        ], _i_ = chop_if_exists(cwd, default_corrected_path), alt_new = [
            0,
            cst_alt_new,
            [
                0,
                caml_call2(Base[241], prefix$0, _i_),
                0
            ]
        ], extra_patdiff_args = caml_call1(Base_List[11], [
            0,
            default_configs,
            [
                0,
                alt_old,
                [
                    0,
                    alt_new,
                    0
                ]
            ]
        ]);
        caml_call6(Ppxlib_print_diff[1], diff_command, [
            0,
            extra_patdiff_args
        ], [
            0,
            use_color
        ], path, corrected_path$0, 0);
        return [
            1,
            caml_call1(Base_Error[14], cst_Changes_found)
        ];
    }
    var Make_corrected_file = [
        0,
        f
    ];
    runtime.caml_register_global(21, Make_corrected_file, "Make_corrected_file");
    return;
})(globalThis);
//# 4 "../.js/default/ppx_expect.config/expect_test_config.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function return$0(x) {
        return x;
    }
    var IO = [
        0,
        return$0
    ];
    function sanitize(s) {
        return s;
    }
    function run(f) {
        return caml_call1(f, 0);
    }
    var Expect_test_config = [
        0,
        IO,
        run,
        sanitize,
        15023
    ];
    runtime.caml_register_global(0, Expect_test_config, "Expect_test_config");
    return;
})(globalThis);
//# 19 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), default$0 = [
        0,
        2,
        0,
        "%",
        "@@"
    ], default$1 = [
        0,
        cst
    ], Base = global_data.Base, Base_Comparable = global_data.Base__Comparable, Base_Int = global_data.Base__Int;
    function equal(a, b) {
        var _d_ = a[1] === b[1] ? 1 : 0;
        if (_d_) var _e_ = a[2] === b[2] ? 1 : 0, _f_ = _e_ ? a[3] === b[3] ? 1 : 0 : _e_;
        else var _f_ = _d_;
        return _f_;
    }
    var _a_ = [
        0,
        caml_call2(Base_Comparable[2], Base[129], function(t) {
            return t[3];
        }),
        0
    ], _b_ = [
        0,
        caml_call2(Base_Comparable[2], Base[129], function(t) {
            return t[2];
        }),
        _a_
    ], compare_character_range = caml_call1(Base_Comparable[1], _b_), Compact_loc = [
        0,
        equal,
        compare_character_range
    ], Flexibility = [
        0
    ], Expect_node_formatting = [
        0,
        default$0,
        Flexibility
    ], Virtual_loc = [
        0
    ], of_int_exn = Base_Int[5], to_int_exn = Base_Int[6], hash = Base_Int[8], sexp_of_t = Base_Int[10], compare = Base_Int[14], counter = [
        0,
        0
    ];
    function mint(param) {
        var id = counter[1];
        counter[1] = id + 1 | 0;
        return id;
    }
    var Hand = [
        0
    ], Kind = [
        0
    ], Shape = [
        0
    ], _c_ = [
        0,
        cst
    ];
    function handed(t, hand) {
        return hand ? t ? t : _c_ : t;
    }
    var Ppx_expect_runtime_Types = [
        0,
        Expect_node_formatting,
        Compact_loc,
        Virtual_loc,
        [
            0,
            of_int_exn,
            to_int_exn,
            compare,
            sexp_of_t,
            hash,
            mint
        ],
        [
            0,
            Hand,
            Kind,
            Shape,
            [
                0,
                default$1,
                handed
            ]
        ]
    ];
    runtime.caml_register_global(6, Ppx_expect_runtime_Types, "Ppx_expect_runtime__Types");
    return;
})(globalThis);
//# 91 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base = global_data.Base, Stdlib = global_data.Stdlib, Base_String = global_data.Base__String, Stdio_Out_channel = global_data.Stdio__Out_channel, Stdlib_Filename = global_data.Stdlib__Filename, Make_corrected_file = global_data.Make_corrected_file, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Comparable = global_data.Base__Comparable, Base_List = global_data.Base__List, Patch_with_file_contents = [
        0
    ], cst_corrected = ".corrected", cst_corrected_tmp = ".corrected.tmp", dummy = 0;
    function f(use_color, in_place, diff_command, diff_path_prefix, filename, with$0, corrections$0) {
        var dot_corrected = caml_call2(Base[241], filename, cst_corrected), in_channel = caml_call1(Stdlib[80], filename), _c_ = caml_call1(Stdlib[92], in_channel), original_file_contents = caml_call2(Stdlib[86], in_channel, _c_);
        caml_call1(Stdlib[93], in_channel);
        function remove(file) {
            if (runtime.caml_sys_file_exists(file)) runtime.caml_sys_remove(file);
        }
        var corrections$1 = caml_call2(with$0, original_file_contents, corrections$0), _a_ = caml_call2(Base_Comparable[2], Ppx_expect_runtime_Types[2][2], Base[242]), corrections = caml_call2(Base_List[83], corrections$1, _a_), match = caml_call3(Base_List[96], corrections, 0, function(l_pos, param) {
            var correction = param[2], match = param[1], end_pos = match[3], start_pos = match[2], code_chunk = caml_call3(Base_String[3], original_file_contents, l_pos, start_pos - l_pos | 0);
            return [
                0,
                end_pos,
                [
                    0,
                    code_chunk,
                    [
                        0,
                        correction,
                        0
                    ]
                ]
            ];
        }), strs = match[2], l_pos = match[1], _b_ = caml_call1(Base_List[11], strs), result = caml_call2(Base_String[68], 0, _b_), rest = caml_call3(Base_String[5], [
            0,
            l_pos
        ], 0, original_file_contents), next_contents = caml_call2(Base[241], result, rest);
        if (in_place) {
            if (1 - caml_call2(Base_String[134], original_file_contents, next_contents)) caml_call2(Stdio_Out_channel[37], filename, next_contents);
            remove(dot_corrected);
            return 0;
        }
        if (diff_command && diff_command[1] === "-") {
            caml_call2(Stdio_Out_channel[37], dot_corrected, next_contents);
            return 0;
        }
        var _d_ = caml_call1(Stdlib_Filename[13], filename), _e_ = [
            0,
            caml_call1(Stdlib_Filename[14], filename)
        ], tmp_corrected = caml_call3(Stdlib_Filename[16], _e_, _d_, cst_corrected_tmp);
        return 0 === caml_call8(Make_corrected_file[1], 0, [
            0,
            tmp_corrected
        ], [
            0,
            use_color
        ], diff_command, diff_path_prefix, next_contents, filename, 0)[0] ? (remove(dot_corrected), remove(tmp_corrected), 0) : (runtime.caml_sys_rename(tmp_corrected, dot_corrected), 1);
    }
    var Ppx_expect_runtime_Write_corre = [
        0,
        Patch_with_file_contents,
        f
    ];
    runtime.caml_register_global(12, Ppx_expect_runtime_Write_corre, "Ppx_expect_runtime__Write_corrected_file");
    return;
})(globalThis);
//# 221 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Printf = global_data.Base__Printf, Base_String = global_data.Base__String, Base = global_data.Base, Base_List = global_data.Base__List, Type = [
        0
    ], compare = Base[195], Formatted = [
        0
    ];
    function create(format) {
        return format;
    }
    function apply(format, str) {
        return caml_call1(format, str);
    }
    var Formatter = [
        0,
        create,
        apply
    ];
    function compare$0(a, b) {
        if (!a) return b ? -1 : 0;
        if (!b) return 1;
        var b$0 = b[1], a$0 = a[1];
        return caml_call2(compare, a$0, b$0);
    }
    var Test_result = [
        0,
        compare$0
    ], _a_ = [
        0,
        "\n"
    ], _b_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    12,
                    124,
                    [
                        2,
                        0,
                        [
                            12,
                            124,
                            [
                                2,
                                0,
                                [
                                    12,
                                    125,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s|%s|%s}"
    ], _c_ = [
        0,
        [
            12,
            34,
            [
                2,
                0,
                [
                    12,
                    34,
                    0
                ]
            ]
        ],
        '"%s"'
    ];
    function default$0(contents) {
        return [
            0,
            contents,
            Ppx_expect_runtime_Types[5][4][1]
        ];
    }
    function to_source_code_string(param) {
        var tag = param[2], test_output = param[1];
        if (tag) {
            var tag$0 = tag[1];
            return caml_call4(Base_Printf[2], _b_, tag$0, test_output, tag$0);
        }
        var _k_ = caml_call2(Base_String[102], test_output, 10), _l_ = caml_call2(Base_List[53], _k_, Base_String[69]), _m_ = caml_call1(caml_call1(Base_String[68], _a_), _l_);
        return caml_call2(Base_Printf[2], _c_, _m_);
    }
    var Payload = [
        0,
        default$0,
        to_source_code_string
    ], _d_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    12,
                    124,
                    0
                ]
            ]
        ],
        "{%s|"
    ], cst_xxx = "xxx", _e_ = [
        0,
        [
            12,
            124,
            [
                2,
                0,
                [
                    12,
                    125,
                    0
                ]
            ]
        ],
        "|%s}"
    ], _f_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                12,
                                124,
                                [
                                    2,
                                    0,
                                    [
                                        12,
                                        124,
                                        [
                                            2,
                                            0,
                                            [
                                                12,
                                                125,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s%s %s|%s|%s}"
    ], _g_ = [
        0,
        [
            12,
            123,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        124,
                        [
                            2,
                            0,
                            [
                                11,
                                "|}",
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "{%s%s|%s|}"
    ], _h_ = [
        0,
        [
            12,
            91,
            [
                2,
                0,
                [
                    2,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                12,
                                93,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "[%s%s %s]"
    ];
    function reconcile(expected_output, test_output) {
        return caml_call2(Base_String[134], expected_output, test_output) ? 0 : [
            0,
            test_output
        ];
    }
    function fail(error_output) {
        return [
            0,
            error_output
        ];
    }
    function fix_delimiter_conflicts(contents, delimiter) {
        if (!delimiter) return 0;
        var tag$1 = delimiter[1], tag = tag$1;
        for(;;){
            let tag$1 = tag;
            var tag_conflicts_with = function(fstr) {
                var _j_ = caml_call2(Base_Printf[2], fstr, tag$1);
                return caml_call2(Base_String[92], contents, _j_);
            };
            if (!tag_conflicts_with(_d_) && !tag_conflicts_with(_e_)) return [
                0,
                tag
            ];
            var tag$0 = caml_call2(Base[241], tag, cst_xxx);
            tag = tag$0;
        }
    }
    function to_formatted_payload(param, contents) {
        return [
            0,
            contents,
            fix_delimiter_conflicts(contents, param)
        ];
    }
    function to_source_code_string$0(expect_node_formatting, shape, tag, contents) {
        var delimiter = fix_delimiter_conflicts(contents, caml_call2(Ppx_expect_runtime_Types[5][4][2], tag, shape[2])), payload = [
            0,
            contents,
            delimiter
        ];
        if (shape[2]) {
            var prefix = expect_node_formatting[3], tag$0 = delimiter[1];
            return tag$0 !== "" ? caml_call6(Base_Printf[2], _f_, prefix, shape[1], tag$0, contents, tag$0) : caml_call4(Base_Printf[2], _g_, prefix, shape[1], contents);
        }
        var prefix$0 = shape[3] ? expect_node_formatting[3] : expect_node_formatting[4], _i_ = caml_call1(Payload[2], payload);
        return caml_call4(Base_Printf[2], _h_, prefix$0, shape[1], _i_);
    }
    var Ppx_expect_runtime_Output = [
        0,
        Type,
        Formatted,
        [
            0
        ],
        Formatter,
        Test_result,
        Payload,
        reconcile,
        fail,
        to_formatted_payload,
        to_source_code_string$0
    ];
    runtime.caml_register_global(15, Ppx_expect_runtime_Output, "Ppx_expect_runtime__Output");
    return;
})(globalThis);
//# 377 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Insert_loc = [
        0
    ], Behavior_type = [
        0
    ], Expect_reachability = [
        0
    ], On_unreachable = [
        0
    ], Behavior = [
        0
    ], Definitions = [
        0,
        Insert_loc,
        Behavior_type,
        Expect_reachability,
        On_unreachable,
        Behavior
    ], Ppx_expect_runtime_Expectation = [
        0,
        Definitions
    ];
    runtime.caml_register_global(0, Ppx_expect_runtime_Expectation, "Ppx_expect_runtime__Expectation_intf");
    return;
})(globalThis);
//# 405 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$7 = "", cst$6 = " ", cst_expect$0 = "expect", cst_expect_uncaught_exn = "expect.uncaught_exn", cst_test_output$2 = "test output", cst_uncaught_exception$1 = "uncaught exception";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$5 = cst$6, cst$4 = cst$7, cst$0 = cst$7, cst$1 = cst$6, cst$2 = cst$6, cst$3 = cst$7, cst = cst$7, last_line = cst$6, first_line = cst$6, Ppx_expect_runtime_Output = global_data.Ppx_expect_runtime__Output, Base_Staged = global_data.Base__Staged, Base = global_data.Base, Base_String = global_data.Base__String, Base_Int = global_data.Base__Int, Base_Char = global_data.Base__Char, Base_List = global_data.Base__List, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types;
    function loc(param) {
        if (0 === param[0]) {
            var whole_node = param[1];
            return whole_node;
        }
        var loc = param[1][1];
        return loc;
    }
    var Insert_loc = [
        0,
        loc
    ], _a_ = [
        0,
        "\n"
    ], _b_ = [
        0,
        cst$6,
        0
    ], cst_test_output = cst_test_output$2, cst_expect = cst_expect$0, cst_test_output$0 = cst_test_output$2, cst_expect_exact = "expect_exact", cst_test_output$1 = cst_test_output$2, _c_ = [
        0,
        cst_expect$0,
        0,
        1
    ], _d_ = [
        1,
        0
    ], cst_uncaught_exception = cst_uncaught_exception$1, _e_ = [
        0,
        cst_expect_uncaught_exn,
        0,
        0
    ], cst_trailing_output = "trailing output", _f_ = [
        0,
        cst_expect$0,
        0,
        1
    ], cst_uncaught_exception$0 = cst_uncaught_exception$1, _g_ = [
        0,
        cst_expect_uncaught_exn,
        0,
        0
    ], _h_ = [
        1,
        1
    ];
    function with_behavior(param, behavior) {
        var inconsistent_outputs_message = param[5], on_incorrect_output = param[4], payload_type = param[3], position = param[1];
        return [
            0,
            position,
            behavior,
            payload_type,
            on_incorrect_output,
            inconsistent_outputs_message
        ];
    }
    function formatter(expect_node_formatting, param) {
        var on_incorrect_output = param[4], payload_type = param[3], behavior = param[2], position = param[1], _q_ = payload_type ? function(str) {
            var _r_ = caml_call1(Base_String[104], str), _s_ = caml_call1(Base_String[108], [
                0,
                Base_Char[45]
            ]), _t_ = caml_call2(Base_List[53], _r_, _s_), _u_ = caml_call2(Base_List[142], _t_, Base_String[14]), _v_ = caml_call1(Base_List[63], _u_), _w_ = caml_call2(Base_List[142], _v_, Base_String[14]), stripped = caml_call1(Base_List[63], _w_), indent_and_contents = caml_call2(Base_List[53], stripped, function(line) {
                var _G_ = caml_call2(Base_String[109], 0, line), _D_ = caml_call1(Base_String[25], line), _E_ = caml_call1(Base_Char[12], 32), _F_ = caml_call2(Base_List[141], _D_, _E_);
                return [
                    0,
                    caml_call1(Base_List[45], _F_),
                    _G_
                ];
            }), _x_ = caml_call2(Base_List[13], indent_and_contents, function(param) {
                var indent = param[1];
                return param[2] !== cst$7 ? [
                    0,
                    indent
                ] : 0;
            }), match = caml_call2(Base_List[31], _x_, Base_Int[14]);
            if (match) var min_indent = match[1], lines = caml_call2(Base_List[53], indent_and_contents, function(param) {
                var line = param[2], indent = param[1];
                return [
                    0,
                    caml_call2(Base_Int[16], 0, indent - min_indent | 0),
                    line
                ];
            });
            else var lines = 0;
            if (0 === behavior[0]) var tag = behavior[1][2], tag$0 = tag;
            else var tag$0 = Ppx_expect_runtime_Types[5][4][1];
            var _y_ = expect_node_formatting[2];
            if (!lines) return tag$0 ? cst$2 : cst$3;
            if (!lines[2] && !_y_) {
                var line = lines[1][2];
                return tag$0 ? caml_call2(Base_String[68], 0, [
                    0,
                    cst$1,
                    [
                        0,
                        line,
                        _b_
                    ]
                ]) : line;
            }
            if (0 === position[0]) var match$0 = position[1], start_pos = match$0[2], start_bol = match$0[1], _z_ = start_pos - start_bol | 0;
            else var match$1 = position[1][2], start_pos$0 = match$1[2], start_bol$0 = match$1[1], _B_ = on_incorrect_output[3] ? expect_node_formatting[1] : 0, _z_ = (start_pos$0 - start_bol$0 | 0) + _B_ | 0;
            var location_indent = expect_node_formatting[1] + _z_ | 0;
            function spaces(n) {
                return caml_call2(Base_String[66], n, 32);
            }
            if (tag$0) var last_line$0 = spaces(location_indent), indentation = location_indent, first_line$0 = cst;
            else var last_line$0 = last_line, indentation = 1, first_line$0 = first_line;
            var lines$0 = caml_call2(Base_List[53], lines, function(param) {
                var indent = param[1];
                if (param[2] === cst$7) return cst$0;
                var line = param[2], _C_ = spaces(indentation + indent | 0);
                return caml_call2(Base[241], _C_, line);
            }), _A_ = caml_call1(Base_List[11], [
                0,
                [
                    0,
                    first_line$0,
                    0
                ],
                [
                    0,
                    lines$0,
                    [
                        0,
                        [
                            0,
                            last_line$0,
                            0
                        ],
                        0
                    ]
                ]
            ]);
            return caml_call1(caml_call1(Base_String[68], _a_), _A_);
        } : function(_H_) {
            return _H_;
        };
        return caml_call1(Ppx_expect_runtime_Output[4][1], _q_);
    }
    function extension_syntax(extension_name, payload_loc, node_loc) {
        if (payload_loc) {
            var payload_loc$0 = payload_loc[1], _o_ = payload_loc$0[2] <= node_loc[2] ? 1 : 0, _p_ = _o_ ? node_loc[3] <= payload_loc$0[3] ? 1 : 0 : _o_;
            if (_p_) return [
                0,
                extension_name,
                1,
                1
            ];
        }
        return [
            0,
            extension_name,
            0,
            1
        ];
    }
    function possibly_relax_strictness(formatting_flexibility, t) {
        if (!formatting_flexibility) return t;
        var expect_node_formatting = formatting_flexibility[1], fmt = formatter(expect_node_formatting, t), _m_ = t[2], reachability = _m_[3], on_unreachable = _m_[2], match = _m_[1], tag = match[2], contents = match[1], _n_ = caml_call2(Ppx_expect_runtime_Output[4][2], fmt, contents), match$0 = caml_call2(Ppx_expect_runtime_Output[7], contents, _n_);
        if (!match$0) return t;
        var contents$0 = match$0[1], payload = caml_call2(Ppx_expect_runtime_Output[9], tag, contents$0);
        return with_behavior(t, [
            0,
            payload,
            on_unreachable,
            reachability
        ]);
    }
    function expected_string_and_payload_lo(param) {
        if (!param) return [
            0,
            caml_call1(Ppx_expect_runtime_Output[6][1], cst$4),
            0
        ];
        var match = param[1], b = match[2], a = match[1];
        return [
            0,
            a,
            [
                0,
                b
            ]
        ];
    }
    function expect(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                2,
                0
            ],
            1,
            extension_syntax(cst_expect, payload_loc, node_loc),
            cst_test_output
        ]);
    }
    function expect_exact(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                2,
                0
            ],
            0,
            extension_syntax(cst_expect_exact, payload_loc, node_loc),
            cst_test_output$0
        ]);
    }
    function expect_unreachable(node_loc) {
        return [
            0,
            [
                0,
                node_loc,
                0
            ],
            _d_,
            1,
            _c_,
            cst_test_output$1
        ];
    }
    function expect_uncaught_exn(formatting_flexibility, node_loc, located_payload) {
        var match = expected_string_and_payload_lo(located_payload), payload_loc = match[2], payload = match[1];
        return possibly_relax_strictness(formatting_flexibility, [
            0,
            [
                0,
                node_loc,
                payload_loc
            ],
            [
                0,
                payload,
                1,
                1
            ],
            1,
            _e_,
            cst_uncaught_exception
        ]);
    }
    function expect_trailing(insert_loc) {
        return [
            0,
            [
                1,
                insert_loc
            ],
            [
                0,
                caml_call1(Ppx_expect_runtime_Output[6][1], cst$5),
                0,
                0
            ],
            1,
            _f_,
            cst_trailing_output
        ];
    }
    function expect_no_uncaught_exn(insert_loc) {
        return [
            0,
            [
                1,
                insert_loc
            ],
            _h_,
            1,
            _g_,
            cst_uncaught_exception$0
        ];
    }
    function format_payload(mk_node) {
        return caml_call1(Base_Staged[1], function(expect_node_formatting, payload_loc, node_loc, tag, contents) {
            var node = caml_call3(mk_node, 0, node_loc, [
                0,
                [
                    0,
                    [
                        0,
                        contents,
                        tag
                    ],
                    payload_loc
                ]
            ]), _k_ = formatter(expect_node_formatting, node), formatted_contents = caml_call2(Ppx_expect_runtime_Output[4][2], _k_, contents), match = caml_call2(Ppx_expect_runtime_Output[7], contents, formatted_contents);
            if (!match) return 0;
            var contents$0 = match[1], node_shape = node[4];
            if (node_shape[2]) var source_code_string = caml_call4(Ppx_expect_runtime_Output[10], expect_node_formatting, node_shape, tag, contents$0);
            else var _l_ = caml_call2(Ppx_expect_runtime_Output[9], tag, contents$0), source_code_string = caml_call1(Ppx_expect_runtime_Output[6][2], _l_);
            return [
                0,
                source_code_string
            ];
        });
    }
    var _i_ = format_payload(expect), format_expect_payload = caml_call1(Base_Staged[2], _i_), _j_ = format_payload(expect_uncaught_exn), format_uncaught_exn_payload = caml_call1(Base_Staged[2], _j_), Ppx_expect_runtime_Expectation = [
        0,
        Insert_loc,
        with_behavior,
        formatter,
        expect,
        expect_exact,
        expect_unreachable,
        expect_uncaught_exn,
        expect_trailing,
        expect_no_uncaught_exn,
        [
            0,
            format_expect_payload,
            format_uncaught_exn_payload
        ]
    ];
    runtime.caml_register_global(35, Ppx_expect_runtime_Expectation, "Ppx_expect_runtime__Expectation");
    return;
})(globalThis);
//# 759 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    var global_data = runtime.caml_get_global_data(), tag = [
        0,
        cst$4
    ], cst$3 = cst$4, cst$2 = ";", cst = cst$4, cst$0 = "\n", cst$1 = cst$4, Ppx_expect_runtime_Output = global_data.Ppx_expect_runtime__Output, Base_Char = global_data.Base__Char, Base_String = global_data.Base__String, Ppx_expect_runtime_Expectation = global_data.Ppx_expect_runtime__Expectation, Base_Hashtbl = global_data.Base__Hashtbl, Base = global_data.Base, Base_Comparable = global_data.Base__Comparable, Base_List = global_data.Base__List, Base_Option = global_data.Base__Option, Base_Queue = global_data.Base__Queue, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_Printf = global_data.Base__Printf, Base_Error = global_data.Base__Error;
    function record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, t) {
        var results = t[2], expectation = t[1], _J_ = caml_call2(Ppx_expect_runtime_Expectation[3], expect_node_formatting, expectation), test_output = caml_call2(Ppx_expect_runtime_Output[4][2], _J_, test_output_raw), _K_ = expectation[2];
        if (0 === _K_[0]) var match = _K_[1], tag$0 = match[2], contents = match[1], tag$1 = tag$0, result = caml_call2(Ppx_expect_runtime_Output[7], contents, test_output);
        else var result$0 = caml_call1(Ppx_expect_runtime_Output[8], test_output), tag$1 = tag, result = result$0;
        if (result) failure_ref[1] = 1;
        caml_call2(Base_Queue[35], results, [
            0,
            [
                0,
                result,
                test_output_raw
            ]
        ]);
        t[3] = 1;
        return [
            0,
            result,
            tag$1
        ];
    }
    function of_expectation(expectation) {
        return [
            0,
            [
                0,
                expectation,
                caml_call2(Base_Queue[58], 0, 0),
                0
            ]
        ];
    }
    function record_end_of_run(t) {
        var match = t[1], results = match[2], reached_this_run = match[3], _I_ = 1 - reached_this_run;
        return _I_ ? caml_call2(Base_Queue[35], results, 0) : _I_;
    }
    function record_result(expect_node_formatting, failure_ref, test_output_raw, param) {
        var inner = param[1];
        record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, inner);
        return 0;
    }
    var global_results_table = caml_call3(Base_Hashtbl[4], 0, 0, [
        0,
        Base_String[51],
        Base_String[42],
        function(_H_) {
            return runtime.Base_hash_string(_H_);
        }
    ]), _d_ = [
        0,
        [
            11,
            "Internal expect test bug: could not find test\nFile: ",
            [
                2,
                0,
                [
                    11,
                    "\nID:   ",
                    [
                        4,
                        0,
                        0,
                        0,
                        0
                    ]
                ]
            ]
        ],
        "Internal expect test bug: could not find test\nFile: %s\nID:   %d"
    ];
    function find_test(absolute_filename, test_id) {
        var _C_ = caml_call2(Base_Hashtbl[56], global_results_table, absolute_filename), _D_ = caml_call2(Base_Option[22], _C_, function(param) {
            var expectations = param[1];
            return caml_call2(Base_Hashtbl[56], expectations, test_id);
        }), _E_ = caml_call1(Ppx_expect_runtime_Types[4][2], test_id), _F_ = caml_call3(Base_Printf[2], _d_, absolute_filename, _E_), _G_ = [
            0,
            caml_call1(Base_Error[14], _F_)
        ];
        return caml_call2(caml_call2(Base_Option[31], 0, _G_), 0, _D_);
    }
    function initialize_and_register_tests(absolute_filename, tests, postprocess) {
        var tests_as_in_table = caml_call2(Base_Queue[58], 0, 0);
        caml_call3(Base_Hashtbl[41], global_results_table, absolute_filename, function(file) {
            var _z_ = Ppx_expect_runtime_Types[4], _A_ = [
                0,
                caml_call3(Base_Hashtbl[4], 0, 0, [
                    0,
                    _z_[3],
                    _z_[4],
                    _z_[5]
                ]),
                postprocess
            ], file$0 = caml_call2(Base_Option[30], file, _A_), _B_ = Ppx_expect_runtime_Types[4], tests$0 = caml_call4(Base_Hashtbl[8], 0, 0, [
                0,
                _B_[3],
                _B_[4],
                _B_[5]
            ], tests);
            caml_call3(Base_Hashtbl[66], tests$0, file$0[1], function(test_id, new_test, existing_test) {
                var test = caml_call2(Base_Option[30], existing_test, new_test);
                test[1][3] = 0;
                caml_call2(Base_Queue[35], tests_as_in_table, [
                    0,
                    test_id,
                    test
                ]);
                return [
                    0,
                    test
                ];
            });
            return file$0;
        });
        return caml_call1(Base_Queue[20], tests_as_in_table);
    }
    function process_each_file(f) {
        var _w_ = caml_call1(Base_Hashtbl[78], global_results_table), _x_ = caml_call2(Base_Comparable[2], Base_String[51], Base[242]), _y_ = caml_call2(Base_List[83], _w_, _x_);
        return caml_call2(Base_List[53], _y_, function(param) {
            var match = param[2], postprocess = match[2], expectations = match[1], filename = param[1], test_nodes = caml_call1(Base_Hashtbl[68], expectations);
            return caml_call3(f, filename, test_nodes, postprocess);
        });
    }
    function expect(formatting_flexibility, node_loc, located_payload) {
        return of_expectation(caml_call3(Ppx_expect_runtime_Expectation[4], formatting_flexibility, node_loc, located_payload));
    }
    function expect_exact(formatting_flexibility, node_loc, located_payload) {
        return of_expectation(caml_call3(Ppx_expect_runtime_Expectation[5], formatting_flexibility, node_loc, located_payload));
    }
    function expect_unreachable(node_loc) {
        return of_expectation(caml_call1(Ppx_expect_runtime_Expectation[6], node_loc));
    }
    var Create = [
        0,
        expect,
        expect_exact,
        expect_unreachable
    ], _a_ = [
        0,
        [
            12,
            91,
            [
                2,
                0,
                [
                    11,
                    "expect.unreachable]",
                    0
                ]
            ]
        ],
        "[%sexpect.unreachable]"
    ], _b_ = [
        0,
        0
    ], _c_ = [
        0,
        [
            11,
            "<expect test ran without ",
            [
                2,
                0,
                [
                    12,
                    62,
                    0
                ]
            ]
        ],
        "<expect test ran without %s>"
    ];
    function loc(param) {
        var position = param[1][1][1];
        return caml_call1(Ppx_expect_runtime_Expectation[1][1], position);
    }
    function expectation_of_t(param) {
        var expectation = param[1][1], _v_ = expectation[2];
        if (0 !== _v_[0]) return 0;
        var contents = _v_[1][1];
        return [
            0,
            contents
        ];
    }
    function record_and_return_number_of_li(expect_node_formatting, failure_ref, test_output_raw, param) {
        var _s_ = record_and_return_result(expect_node_formatting, failure_ref, test_output_raw, param[1]), match = _s_[1];
        if (!match) return 0;
        var tag = _s_[2], contents = match[1], _t_ = caml_call2(Ppx_expect_runtime_Output[9], tag, contents), correction = caml_call1(Ppx_expect_runtime_Output[6][2], _t_), _u_ = caml_call1(Base_Char[16], 10);
        return [
            0,
            caml_call2(Base_String[21], correction, _u_) + 1 | 0
        ];
    }
    function to_diffs(cr_for_multiple_outputs, expect_node_formatting, original_file_contents, t) {
        var match$4 = t[1], results = match$4[2], expectation = match$4[1], results_list = caml_call1(Base_Queue[20], results), match$5 = caml_call2(Base_List[16], results_list, function(param) {
            if (!param) return _b_;
            var output = param[1];
            return [
                1,
                output
            ];
        }), outputs_list = match$5[2], unreached_list = match$5[1], _o_ = caml_call2(Base_Comparable[2], Ppx_expect_runtime_Output[5][1], function(param) {
            var result = param[1];
            return result;
        }), distinct_outputs = caml_call2(Base_List[126], outputs_list, _o_), was_reached = caml_call1(Base_List[18], unreached_list), match$6 = expectation[2];
        if (0 === match$6[0]) var reachability = match$6[3], reachability_behavior = reachability;
        else var reachability_of_corrected = match$6[1], reachability_behavior = reachability_of_corrected;
        function correction_for_single_result(param) {
            if (!param) return 0;
            var received = param[1];
            return [
                0,
                [
                    0,
                    expectation,
                    received
                ]
            ];
        }
        a: if (distinct_outputs) {
            b: if (!distinct_outputs[2]) {
                var result = distinct_outputs[1][1];
                if (!was_reached && reachability_behavior) break b;
                var match$7 = correction_for_single_result(result);
                break a;
            }
            var outputs = caml_call2(Base_List[53], results_list, function(param) {
                if (!param) return caml_call2(Base_Printf[2], _c_, expectation[5]);
                var raw = param[1][2];
                return raw;
            }), _p_ = caml_call2(cr_for_multiple_outputs, expectation[5], outputs), _q_ = caml_call2(Ppx_expect_runtime_Expectation[3], expect_node_formatting, expectation), _r_ = caml_call1(caml_call1(Ppx_expect_runtime_Output[4][2], _q_), _p_), match$7 = correction_for_single_result(caml_call1(Ppx_expect_runtime_Output[8], _r_));
        } else var behavior$0 = expectation[2], match$7 = 0 === behavior$0[0] ? [
            0,
            [
                1,
                caml_call2(Ppx_expect_runtime_Expectation[2], expectation, behavior$0)
            ]
        ] : 0;
        if (!match$7) return 0;
        var correction$2 = match$7[1];
        function safe_byte_get(string, i) {
            if (0 <= i && i < runtime.caml_ml_string_length(string)) return [
                0,
                runtime.caml_string_get(string, i)
            ];
            return 0;
        }
        if (0 === correction$2[0]) {
            var _e_ = correction$2[1], on_incorrect_output = _e_[4], test_output = correction$2[2], behavior = _e_[2], position = _e_[1];
            if (0 === position[0]) var whitespace = cst;
            else var match = position[1][2], start_pos = match[2], start_bol = match[1], let_offset = start_pos - start_bol | 0, _i_ = on_incorrect_output[3] ? expect_node_formatting[1] : 0, indent = let_offset + _i_ | 0, _j_ = caml_call2(Base_String[66], indent, 32), whitespace$0 = caml_call2(Base[241], cst$0, _j_), whitespace = whitespace$0;
            if (0 === behavior[0]) var tag = behavior[1][2], tag$0 = tag;
            else var tag$0 = Ppx_expect_runtime_Types[5][4][1];
            a: {
                if (0 === position[0]) {
                    var _g_ = position[2], _f_ = position[1];
                    if (_g_ && !on_incorrect_output[2] && on_incorrect_output[3]) {
                        var payload_loc = _g_[1], _h_ = caml_call2(Ppx_expect_runtime_Output[9], tag$0, test_output), correction$1 = caml_call1(Ppx_expect_runtime_Output[6][2], _h_), correction$0 = correction$1, loc$0 = payload_loc;
                        break a;
                    }
                    var loc = _f_;
                } else var loc = position[1][1];
                var correction = caml_call4(Ppx_expect_runtime_Output[10], expect_node_formatting, on_incorrect_output, tag$0, test_output), correction$0 = correction, loc$0 = loc;
            }
            var match$0 = [
                0,
                [
                    0,
                    loc$0,
                    caml_call2(Base[241], whitespace, correction$0)
                ]
            ];
        } else {
            var _k_ = correction$2[1], on_incorrect_output$0 = _k_[4], on_unreachable = _k_[2][2], position$0 = _k_[1], loc$1 = caml_call1(Ppx_expect_runtime_Expectation[1][1], position$0);
            switch(on_unreachable){
                case 0:
                    var match$0 = 0;
                    break;
                case 1:
                    var match$0 = [
                        0,
                        [
                            0,
                            loc$1,
                            cst$1
                        ]
                    ];
                    break;
                default:
                    var prefix = on_incorrect_output$0[3] ? expect_node_formatting[3] : expect_node_formatting[4], match$0 = [
                        0,
                        [
                            0,
                            loc$1,
                            caml_call2(Base_Printf[2], _a_, prefix)
                        ]
                    ];
            }
        }
        if (!match$0) return 0;
        var match$1 = match$0[1], diff = match$1[2], loc$2 = match$1[1], end_pos = loc$2[3], start_pos$0 = loc$2[2], start_bol$0 = loc$2[1], main_correction = [
            0,
            [
                0,
                loc$2,
                diff
            ],
            0
        ];
        a: {
            if (1 === correction$2[0] && !correction$2[1][4][3]) {
                var match$2 = safe_byte_get(original_file_contents, start_pos$0 - 1 | 0), match$3 = safe_byte_get(original_file_contents, end_pos);
                b: {
                    c: if (match$2 && 10 === match$2[1]) {
                        if (match$3 && 10 !== match$3[1]) break c;
                        var _n_ = [
                            0,
                            [
                                0,
                                [
                                    0,
                                    start_bol$0,
                                    start_pos$0 - 1 | 0,
                                    start_pos$0
                                ],
                                cst$3
                            ]
                        ];
                        break b;
                    }
                    var _n_ = 0;
                }
                var remove_empty_line_from_deleted = _n_;
                break a;
            }
            var remove_empty_line_from_deleted = 0;
        }
        a: {
            if (0 === correction$2[0]) {
                var _l_ = correction$2[1], _m_ = _l_[1];
                if (0 !== _m_[0] && _l_[4][3]) {
                    var body_loc = _m_[1][2], add_semicolon_before_trailing_ = [
                        0,
                        [
                            0,
                            [
                                0,
                                body_loc[1],
                                body_loc[3],
                                body_loc[3]
                            ],
                            cst$2
                        ]
                    ];
                    break a;
                }
            }
            var add_semicolon_before_trailing_ = 0;
        }
        var additional_corrections = caml_call2(Base_List[14], [
            0,
            remove_empty_line_from_deleted,
            [
                0,
                add_semicolon_before_trailing_,
                0
            ]
        ], Base_Option[42]);
        return caml_call2(Base[222], additional_corrections, main_correction);
    }
    var Ppx_expect_runtime_Test_node = [
        0,
        Create,
        of_expectation,
        record_end_of_run,
        record_result,
        [
            0,
            initialize_and_register_tests,
            find_test,
            process_each_file
        ],
        [
            0,
            expectation_of_t,
            record_and_return_number_of_li,
            loc,
            to_diffs
        ]
    ];
    runtime.caml_register_global(23, Ppx_expect_runtime_Test_node, "Ppx_expect_runtime__Test_node");
    return;
})(globalThis);
//# 1231 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Base_String = global_data.Base__String, Base = global_data.Base, Base_Printf = global_data.Base__Printf, Stdlib_Filename = global_data.Stdlib__Filename, CamlinternalLazy = global_data.CamlinternalLazy, Base_Or_error = global_data.Base__Or_error, current = [
        0,
        0
    ], cst_new_file = "new_file", cst_old_file = "old_file", cst_Expect_test_collector_set_ = "Expect_test_collector.set: there is already an active file", cst_Expect_test_collector_unse = "Expect_test_collector.unset: there is no active file", cst_Expect_test_collector_get_ = "Expect_test_collector.get: there is no active file";
    function set(filename_rel_to_project_root) {
        var match = current[1];
        if (match) {
            var current$0 = match[1], _h_ = [
                0,
                [
                    0,
                    cst_new_file,
                    caml_call1(Base[202], filename_rel_to_project_root)
                ],
                0
            ], _i_ = [
                0,
                [
                    0,
                    cst_old_file,
                    caml_call1(Base[202], current$0)
                ],
                _h_
            ], _j_ = caml_call2(Base[85][8], cst_Expect_test_collector_set_, _i_);
            return caml_call1(Base[246], _j_);
        }
        current[1] = [
            0,
            filename_rel_to_project_root
        ];
        return 0;
    }
    function unset(param) {
        if (current[1]) {
            current[1] = 0;
            return 0;
        }
        var _g_ = caml_call2(Base[85][8], cst_Expect_test_collector_unse, 0);
        return caml_call1(Base[246], _g_);
    }
    function get(param) {
        var match = current[1];
        if (match) {
            var fn = match[1];
            return fn;
        }
        var _f_ = caml_call2(Base[85][8], cst_Expect_test_collector_get_, 0);
        return caml_call1(Base[246], _f_);
    }
    var dir_or_error = caml_call2(Base_Or_error[31], [
        0,
        1
    ], function(_e_) {
        return runtime.caml_sys_getcwd(_e_);
    }), initial_dir = [
        246,
        function(_d_) {
            return caml_call1(Base_Or_error[34], dir_or_error);
        }
    ], _a_ = [
        0,
        [
            11,
            "Trying to run an expect test from the wrong file.\n- test declared at ",
            [
                2,
                0,
                [
                    12,
                    58,
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            "\n- trying to run it from ",
                            [
                                2,
                                0,
                                [
                                    12,
                                    10,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Trying to run an expect test from the wrong file.\n- test declared at %s:%d\n- trying to run it from %s\n"
    ];
    function absolute_path(file) {
        if (!caml_call1(Stdlib_Filename[5], file)) return file;
        var _b_ = runtime.caml_obj_tag(initial_dir);
        a: if (250 === _b_) var _c_ = initial_dir[1];
        else {
            if (246 !== _b_ && 244 !== _b_) {
                var _c_ = initial_dir;
                break a;
            }
            var _c_ = caml_call1(CamlinternalLazy[2], initial_dir);
        }
        return caml_call2(Stdlib_Filename[4], _c_, file);
    }
    function verify_that_file_is_current_ex(line_number, filename_rel_to_project_root) {
        var registering_tests_for = get(0);
        return caml_call2(Base_String[134], filename_rel_to_project_root, registering_tests_for) ? 0 : caml_call5(Base_Printf[4], Base[244], _a_, filename_rel_to_project_root, line_number, registering_tests_for);
    }
    var Ppx_expect_runtime_Current_fil = [
        0,
        set,
        unset,
        get,
        initial_dir,
        absolute_path,
        verify_that_file_is_current_ex
    ];
    runtime.caml_register_global(13, Ppx_expect_runtime_Current_fil, "Ppx_expect_runtime__Current_file");
    return;
})(globalThis);
//# 1364 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst$5 = "\n", cst$6 = "(* ", caml_ml_string_length = runtime.caml_ml_string_length, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    function caml_call8(f, a0, a1, a2, a3, a4, a5, a6, a7) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 8 ? f(a0, a1, a2, a3, a4, a5, a6, a7) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7
        ]);
    }
    var dummy = 0, global_data = runtime.caml_get_global_data(), partial = [
        12,
        10,
        [
            10,
            0
        ]
    ], cst$3 = cst$4, cst$1 = "---------------", cst$2 = cst$4, cst = "\n\n", cst$0 = cst$4, Expect_test_config = global_data.Expect_test_config, Base_Source_code_position = global_data.Base__Source_code_position, Base_Printf = global_data.Base__Printf, Base = global_data.Base, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Base_Option = global_data.Base__Option, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Base_List = global_data.Base__List, Ppx_expect_runtime_Current_fil = global_data.Ppx_expect_runtime__Current_file, Ppx_expect_runtime_Expectation = global_data.Ppx_expect_runtime__Expectation, Base_String = global_data.Base__String, Stdlib_Filename = global_data.Stdlib__Filename, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_Printexc = global_data.Stdlib__Printexc, Base_Exn = global_data.Base__Exn, Stdlib_Obj = global_data.Stdlib__Obj, Stdlib_Format = global_data.Stdlib__Format, cst_CR = "CR ", _b_ = [
        0,
        [
            11,
            cst$6,
            [
                2,
                0,
                [
                    11,
                    "expect_test_collector: This test expectation appears to contain a backtrace.\n   This is strongly discouraged as backtraces are fragile.\n   Please change this test to not include a backtrace. *)",
                    0
                ]
            ]
        ],
        "(* %sexpect_test_collector: This test expectation appears to contain a backtrace.\n   This is strongly discouraged as backtraces are fragile.\n   Please change this test to not include a backtrace. *)"
    ], _c_ = [
        0,
        [
            11,
            "Test ran multiple times with different ",
            [
                2,
                0,
                [
                    12,
                    115,
                    0
                ]
            ]
        ],
        "Test ran multiple times with different %ss"
    ], _d_ = [
        0,
        [
            11,
            cst$6,
            [
                2,
                0,
                [
                    11,
                    "expect_test: ",
                    [
                        2,
                        0,
                        [
                            11,
                            " *)",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "(* %sexpect_test: %s *)"
    ], _e_ = [
        0,
        [
            11,
            "=== Output ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    " / ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            " ===",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "=== Output %d / %d ==="
    ], _f_ = [
        0,
        [
            2,
            0,
            [
                2,
                0,
                [
                    2,
                    0,
                    0
                ]
            ]
        ],
        "%s%s%s"
    ], _g_ = [
        0,
        cst$5
    ], _h_ = [
        0,
        "Raised at ",
        [
            0,
            "Called from ",
            [
                0,
                "Raised by primitive operation ",
                0
            ]
        ]
    ], _i_ = [
        0,
        [
            11,
            '("',
            [
                2,
                0,
                [
                    11,
                    '(Cannot print more details, Exn.to_string failed)")',
                    0
                ]
            ]
        ],
        '("%s(Cannot print more details, Exn.to_string failed)")'
    ], _j_ = [
        0,
        cst$5
    ];
    function clean_up_block(param) {
        var test_output_writer = param[5], test_output_reader = param[4], output_file = param[2];
        caml_call1(Stdlib[93], test_output_reader);
        runtime.ppx_expect_runtime_after_test(Stdlib[39], Stdlib[40]);
        caml_call1(Stdlib[76], test_output_writer);
        runtime.caml_sys_remove(output_file);
    }
    function flush(param) {
        caml_call2(Stdlib_Format[43], Stdlib_Format[116], 0);
        caml_call2(Stdlib_Format[43], Stdlib_Format[118], 0);
        caml_call1(Stdlib[63], Stdlib[39]);
        caml_call1(Stdlib[63], Stdlib[40]);
        runtime.ppx_expect_runtime_flush_stubs_streams(0);
    }
    function read_test_output_unsanitized(param) {
        var old_offset = param[6], test_output_reader = param[4];
        flush(0);
        var new_offset = runtime.ppx_expect_runtime_out_channel_position(Stdlib[39]), len = new_offset - old_offset[1] | 0;
        old_offset[1] = new_offset;
        return caml_call2(Stdlib[86], test_output_reader, len);
    }
    function Configured(C) {
        var cr_prefix = 15023 <= C[4] ? cst_CR : cst$0, cr_for_backtrace = caml_call2(Base_Printf[2], _b_, cr_prefix);
        function cr_for_multiple_outputs(output_name, outputs) {
            var cr_body = caml_call2(Base_Printf[2], _c_, output_name), cr = caml_call3(Base_Printf[2], _d_, cr_prefix, cr_body), num_outputs = caml_call1(Base_List[45], outputs), outputs_with_headers = caml_call2(Base_List[44], outputs, function(index, output) {
                var header = caml_call3(Base_Printf[2], _e_, index + 1 | 0, num_outputs), pad_length = caml_ml_string_length(cr) - caml_ml_string_length(header) | 0, _N_ = [
                    0,
                    output,
                    0
                ];
                if (0 < pad_length) var lpad = caml_call2(Base_String[66], pad_length / 2 | 0, 61), rpad = caml_call2(Base_String[66], pad_length - (pad_length / 2 | 0) | 0, 61), _O_ = caml_call4(Base_Printf[2], _f_, lpad, header, rpad);
                else var _O_ = header;
                return [
                    0,
                    _O_,
                    _N_
                ];
            });
            return caml_call2(Base_String[68], _g_, [
                0,
                cr,
                outputs_with_headers
            ]);
        }
        var sanitize = C[3];
        function check_for_backtraces(s) {
            if (!caml_call2(Base_List[23], _h_, function(substring) {
                return caml_call2(Base_String[92], s, substring);
            })) return s;
            var _M_ = caml_call2(Base[241], cst, s);
            return caml_call2(Base[241], cr_for_backtrace, _M_);
        }
        function dump_backtrace(possible_exn) {
            try {
                caml_call1(C[2], possible_exn);
            } catch (exn$0) {
                var exn = caml_wrap_exception(exn$0), bt = caml_call1(Stdlib_Printexc[12], 0);
                try {
                    var _K_ = caml_call1(Base_Exn[10], exn), exn_string = _K_;
                } catch (_L_) {
                    var _I_ = caml_call1(Stdlib_Obj[22][1], exn), name = caml_call1(Stdlib_Obj[22][2], _I_), exn_string = caml_call2(Base_Printf[2], _i_, name);
                }
                var bt$0 = caml_call1(Stdlib_Printexc[14], bt), _J_ = bt$0 !== cst$4 ? caml_call2(Base_String[68], _j_, [
                    0,
                    cr_for_backtrace,
                    [
                        0,
                        exn_string,
                        [
                            0,
                            bt$0,
                            0
                        ]
                    ]
                ]) : exn_string;
                return [
                    0,
                    _J_
                ];
            }
            return 0;
        }
        return [
            0,
            ,
            ,
            cr_for_multiple_outputs,
            sanitize,
            check_for_backtraces,
            dump_backtrace
        ];
    }
    var test_is_running = [
        0,
        0
    ], _n_ = [
        0,
        [
            11,
            "File ",
            [
                3,
                0,
                [
                    11,
                    ", line ",
                    [
                        4,
                        0,
                        0,
                        0,
                        [
                            11,
                            ", characters ",
                            [
                                4,
                                0,
                                0,
                                0,
                                [
                                    12,
                                    45,
                                    [
                                        4,
                                        0,
                                        0,
                                        0,
                                        [
                                            11,
                                            ":\nError: program exited while expect test was running!\nOutput captured so far:\n",
                                            [
                                                2,
                                                0,
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "File %S, line %d, characters %d-%d:\nError: program exited while expect test was running!\nOutput captured so far:\n%s\n%!"
    ], _o_ = [
        0,
        [
            11,
            "Ppx_expect_runtime.read_current_test_output_exn called while there are no tests running at ",
            [
                2,
                0,
                0
            ]
        ],
        "Ppx_expect_runtime.read_current_test_output_exn called while there are no tests running at %s"
    ];
    function am_running_expect_test(param) {
        return caml_call1(Base_Option[53], test_is_running[1]);
    }
    function current_test(param) {
        return caml_call2(Base_Option[24], test_is_running[1], function(param) {
            var test_block = param[4];
            return test_block;
        });
    }
    function current_test_exn(param) {
        var _H_ = current_test(0);
        return caml_call4(Base_Option[31], 0, 0, 0, _H_);
    }
    function iter(f) {
        return caml_call2(Base_Option[37], test_is_running[1], f);
    }
    function at_exit(param) {
        return iter(function(param) {
            var test_block = param[4], match = param[3], end_pos = match[3], start_pos = match[2], start_bol = match[1], basename = param[2], line_number = param[1];
            flush(0);
            var output_file = test_block[2], fin = caml_call1(Stdlib[80], output_file), _G_ = caml_call1(Stdlib[92], fin), all_out = caml_call2(Stdlib[86], fin, _G_);
            clean_up_block(test_block);
            return caml_call6(Stdlib_Printf[3], _n_, basename, line_number, start_pos - start_bol | 0, end_pos - start_bol | 0, all_out);
        });
    }
    function read_current_test_output_exn(here) {
        var match = current_test(0);
        if (match) {
            var test_block = match[1], _D_ = read_test_output_unsanitized(test_block);
            return caml_call1(Expect_test_config[3], _D_);
        }
        var _E_ = caml_call1(Base_Source_code_position[22], here), _F_ = caml_call2(Base_Printf[2], _o_, _E_);
        return caml_call1(Base[244], _F_);
    }
    var default_cr_for_multiple_output = Configured(Expect_test_config)[3], For_external = [
        0,
        read_current_test_output_exn,
        am_running_expect_test,
        default_cr_for_multiple_output
    ], cst_output = "output", cst_expect_test = "expect-test", _a_ = [
        0,
        1,
        [
            0,
            3,
            [
                0,
                6,
                0
            ]
        ]
    ], _k_ = [
        0,
        "line"
    ], _l_ = [
        0,
        "file"
    ], cst_inner_test = "inner_test", cst_outer_test = "outer_test", cst_Expect_test_runtime_reache = "Expect_test_runtime: reached one [let%expect_test] from another. Nesting expect\ntests is prohibited.", cst_Trailing_output = "Trailing output", _m_ = [
        0,
        cst$5
    ], Ppx_expect_runtime_Test_block = [
        0,
        function(C) {
            var Configured$0 = Configured(C);
            function read_test_output_no_backtrace_(param) {
                var _C_ = read_test_output_unsanitized(current_test_exn(0));
                return caml_call1(Configured$0[4], _C_);
            }
            function read_test_output_sanitized_and(param) {
                var _B_ = read_test_output_no_backtrace_(0);
                return Configured$0[5].call(null, _B_);
            }
            function run_test_inner(test_id, test_output_raw, t) {
                var src_filename = t[1], _A_ = caml_call2(Ppx_expect_runtime_Test_node[5][2], src_filename, test_id), fail = t[3];
                return caml_call4(Ppx_expect_runtime_Test_node[4], Ppx_expect_runtime_Types[1][1], fail, test_output_raw, _A_);
            }
            function run_test(test_id) {
                var _z_ = current_test_exn(0);
                return run_test_inner(test_id, read_test_output_sanitized_and(0), _z_);
            }
            function run_suite(filename_rel_to_project_root, line_number, location, trailing_loc, body_loc, formatting_flexibility, expected_exn, test_to_run, exn_test_id, description, tags, inline_test_config, expectations, f) {
                var end_pos = location[3], start_pos = location[2], start_bol = location[1], basename = caml_call1(Stdlib_Filename[13], filename_rel_to_project_root);
                iter(function(param) {
                    var outer_basename = param[2], outer_line_number = param[1];
                    function sexp_here(basename, line_number) {
                        var _y_ = [
                            0,
                            [
                                1,
                                [
                                    0,
                                    _k_,
                                    [
                                        0,
                                        caml_call1(Base[136], line_number),
                                        0
                                    ]
                                ]
                            ],
                            0
                        ];
                        return [
                            1,
                            [
                                0,
                                [
                                    1,
                                    [
                                        0,
                                        _l_,
                                        [
                                            0,
                                            caml_call1(Base[202], basename),
                                            0
                                        ]
                                    ]
                                ],
                                _y_
                            ]
                        ];
                    }
                    var _v_ = [
                        0,
                        [
                            0,
                            cst_inner_test,
                            sexp_here(basename, line_number)
                        ],
                        0
                    ], _w_ = [
                        0,
                        [
                            0,
                            cst_outer_test,
                            sexp_here(outer_basename, outer_line_number)
                        ],
                        _v_
                    ], _x_ = caml_call2(Base[85][8], cst_Expect_test_runtime_reache, _w_);
                    return caml_call1(Base[246], _x_);
                });
                return caml_call8(Ppx_inline_test_lib[8], inline_test_config, [
                    246,
                    function(_u_) {
                        return caml_call2(Base_Option[30], description, cst$3);
                    }
                ], tags, basename, line_number, start_pos - start_bol | 0, end_pos - start_bol | 0, function(param) {
                    caml_call2(Ppx_expect_runtime_Current_fil[6], line_number, filename_rel_to_project_root);
                    var absolute_filename = caml_call1(Ppx_expect_runtime_Current_fil[5], basename), _q_ = caml_call1(Ppx_expect_runtime_Expectation[8], [
                        0,
                        [
                            0,
                            trailing_loc[1],
                            trailing_loc[2],
                            trailing_loc[2]
                        ],
                        body_loc
                    ]), trailing_test = caml_call1(Ppx_expect_runtime_Test_node[2], _q_);
                    if (expected_exn) var _r_ = caml_call3(Ppx_expect_runtime_Expectation[7], formatting_flexibility, trailing_loc, expected_exn), exn_test = caml_call1(Ppx_expect_runtime_Test_node[2], _r_);
                    else var _s_ = caml_call1(Ppx_expect_runtime_Expectation[9], [
                        0,
                        trailing_loc,
                        body_loc
                    ]), exn_test = caml_call1(Ppx_expect_runtime_Test_node[2], _s_);
                    var expectations$0 = [
                        0,
                        [
                            0,
                            exn_test_id,
                            exn_test
                        ],
                        [
                            0,
                            [
                                0,
                                test_to_run,
                                trailing_test
                            ],
                            expectations
                        ]
                    ], expectations$1 = caml_call3(Ppx_expect_runtime_Test_node[5][1], absolute_filename, expectations$0, function(original_file_contents, ts) {
                        var _t_ = caml_call3(Ppx_expect_runtime_Test_node[6][4], Configured$0[3], Ppx_expect_runtime_Types[1][1], original_file_contents);
                        return caml_call2(Base_List[14], ts, _t_);
                    });
                    flush(0);
                    var _p_ = caml_call3(Stdlib_Filename[16], 0, cst_expect_test, cst_output), output_file = caml_call1(Ppx_expect_runtime_Current_fil[5], _p_), test_output_writer = caml_call3(Stdlib[62], _a_, 420, output_file), test_output_reader = caml_call1(Stdlib[80], output_file);
                    runtime.ppx_expect_runtime_before_test(test_output_writer, Stdlib[39], Stdlib[40]);
                    var test_block = [
                        0,
                        absolute_filename,
                        output_file,
                        [
                            0,
                            0
                        ],
                        test_output_reader,
                        test_output_writer,
                        [
                            0,
                            0
                        ]
                    ], t = [
                        0,
                        line_number,
                        basename,
                        location,
                        test_block
                    ];
                    test_is_running[1] = [
                        0,
                        t
                    ];
                    var test_exn = Configured$0[6].call(null, function(param) {
                        read_test_output_unsanitized(test_block);
                        return caml_call1(f, 0);
                    }), trailing_raw = read_test_output_sanitized_and(0), trailing_output = caml_call2(Base_String[109], 0, trailing_raw) !== cst$4 ? [
                        0,
                        trailing_raw
                    ] : 0;
                    if (test_exn) {
                        var test_exn$0 = test_exn[1];
                        if (trailing_output) var trailing_output$0 = trailing_output[1], test_output = caml_call2(Base_String[68], _m_, [
                            0,
                            test_exn$0,
                            [
                                0,
                                cst_Trailing_output,
                                [
                                    0,
                                    cst$1,
                                    [
                                        0,
                                        trailing_output$0,
                                        0
                                    ]
                                ]
                            ]
                        ]);
                        else var test_output = test_exn$0;
                        var test_to_run$0 = exn_test_id, test_output$0 = test_output;
                    } else var test_output$1 = caml_call2(Base_Option[30], trailing_output, cst$2), test_to_run$0 = test_to_run, test_output$0 = test_output$1;
                    run_test_inner(test_to_run$0, test_output$0, test_block);
                    caml_call2(Base_List[19], expectations$1, function(param) {
                        var test_node = param[2];
                        return caml_call1(Ppx_expect_runtime_Test_node[3], test_node);
                    });
                    clean_up_block(test_block);
                    test_is_running[1] = 0;
                    return 1;
                });
            }
            return [
                0,
                read_test_output_no_backtrace_,
                run_test,
                run_suite
            ];
        },
        For_external,
        at_exit
    ];
    runtime.caml_register_global(48, Ppx_expect_runtime_Test_block, "Ppx_expect_runtime__Test_block");
    return;
})(globalThis);
//# 1921 "../.js/default/ppx_expect.runtime/ppx_expect_runtime.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Ppx_expect_runtime_Write_corre = global_data.Ppx_expect_runtime__Write_corrected_file, Ppx_expect_runtime_Current_fil = global_data.Ppx_expect_runtime__Current_file, CamlinternalLazy = global_data.CamlinternalLazy, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Ppx_expect_runtime_Test_block = global_data.Ppx_expect_runtime__Test_block, Stdlib = global_data.Stdlib;
    caml_call1(Ppx_inline_test_lib[16], function(param) {
        var _a_ = Ppx_expect_runtime_Current_fil[4], _b_ = runtime.caml_obj_tag(_a_);
        a: if (250 === _b_) var _c_ = _a_[1];
        else {
            if (246 !== _b_ && 244 !== _b_) {
                var _c_ = _a_;
                break a;
            }
            var _c_ = caml_call1(CamlinternalLazy[2], _a_);
        }
        runtime.caml_sys_chdir(_c_);
        var _d_ = caml_call1(Ppx_expect_runtime_Test_node[5][3], function(filename, test_nodes, postprocess) {
            var _e_ = caml_call1(Ppx_inline_test_lib[14], 0), _f_ = caml_call1(Ppx_inline_test_lib[13], 0), _g_ = caml_call1(Ppx_inline_test_lib[12], 0), _h_ = caml_call1(Ppx_inline_test_lib[11], 0);
            return caml_call7(Ppx_expect_runtime_Write_corre[2], _h_, _g_, _f_, _e_, filename, postprocess, test_nodes);
        });
        return caml_call1(Ppx_inline_test_lib[5][2], _d_);
    });
    caml_call1(Stdlib[100], Ppx_expect_runtime_Test_block[3]);
    var Current_file = [
        0,
        Ppx_expect_runtime_Current_fil[1],
        Ppx_expect_runtime_Current_fil[2]
    ], Test_node = [
        0
    ], Ppx_expect_runtime = [
        0,
        Current_file,
        Test_node
    ];
    runtime.caml_register_global(7, Ppx_expect_runtime, "Ppx_expect_runtime");
    return;
})(globalThis);
//# 795 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_tensor_playground = "tensor_playground";
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Option = global_data.Stdlib__Option, Stdlib_List = global_data.Stdlib__List, Stdlib_Seq = global_data.Stdlib__Seq, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_String = global_data.Stdlib__String, Stdlib_Map = global_data.Stdlib__Map, Stdlib_Set = global_data.Stdlib__Set;
    caml_call1(Ppx_expect_runtime[1][1], "lib/Counter.ml");
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground, "Counter.ml");
    var String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), _a_ = [
        0,
        1
    ];
    function add_to_count(map, x) {
        return caml_call3(String_map[4], x, function(param) {
            if (!param) return _a_;
            var n = param[1];
            return [
                0,
                n + 1 | 0
            ];
        }, map);
    }
    var make = caml_call2(Stdlib_List[26], add_to_count, String_map[1]);
    function key_set(m) {
        var _h_ = caml_call1(String_map[39], m), _i_ = caml_call1(caml_call1(Stdlib_Seq[29], function(_j_) {
            return _j_[1];
        }), _h_);
        return caml_call1(String_set[43], _i_);
    }
    function to_list(m) {
        return caml_call1(String_map[10], m);
    }
    function diff(a, b) {
        var _c_ = key_set(b), _d_ = key_set(a), _e_ = caml_call2(String_set[5], _d_, _c_), keys = caml_call1(String_set[37], _e_);
        return caml_call3(Stdlib_List[26], function(acc, key) {
            var _f_ = caml_call2(String_map[18], key, a), a_val = caml_call2(Stdlib_Option[3], _f_, 0), _g_ = caml_call2(String_map[18], key, b), b_val = caml_call2(Stdlib_Option[3], _g_, 0);
            return a_val === b_val ? acc : caml_call3(String_map[2], key, a_val - b_val | 0, acc);
        }, String_map[1], keys);
    }
    function get(m, k) {
        var _b_ = caml_call2(String_map[18], k, m);
        return caml_call2(Stdlib_Option[3], _b_, 0);
    }
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Counter = [
        0,
        String_map,
        String_set,
        make,
        diff,
        get,
        key_set,
        to_list
    ];
    runtime.caml_register_global(13, Tensor_playground_Counter, "Tensor_playground__Counter");
    return;
})(globalThis);
//# 891 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$2 = "", cst_Loop_over_all_summation_in = "\n      # Loop over all summation indices\n      total = 0\n      for s in range(d_s):\n          for t in range(d_t):\n              total += A[s] * B[s, t] * C[t]\n      return total\n      ", cst$6 = " * ", cst$7 = " -> ", cst_a_b_c = " [a; b; c] ", cst_a_b = " [a; b] ", cst_in_range = " in range(", cst_sfor_a_in_range_a = "%sfor %a in range(%a):@.", cst$4 = "):", cst$5 = "+=", cst_hov_4 = "<hov 4>", cst$3 = "@ ", cst_a$0 = "[@[%a@]]@.", cst_a = "a", cst_b = "b", cst_c = "c", cst_for = "for ", cst_i = "i", cst_j = "j", cst_k = "k", cst_l = "l", cst_lib_Einops_ml$5 = "lib/Einops.ml", cst_result = "result[", cst_s = "s", cst_t = "t", cst_tensor_playground$0 = "tensor_playground", cst_total = "total", caml_equal = runtime.caml_equal;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    function caml_call14(f, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 14 ? f(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6,
            a7,
            a8,
            a9,
            a10,
            a11,
            a12,
            a13
        ]);
    }
    var global_data = runtime.caml_get_global_data(), partial = [
        0,
        0,
        cst$2
    ], partial$0 = [
        17,
        0,
        [
            12,
            93,
            [
                17,
                0,
                [
                    17,
                    4,
                    0
                ]
            ]
        ]
    ], cst$1 = cst$2, cst$0 = ":", partial$1 = [
        0,
        cst$3,
        1,
        0
    ], partial$2 = [
        17,
        4,
        0
    ], cst = cst$2, Fmt = global_data.Fmt, Ppx_expect_runtime_Types = global_data.Ppx_expect_runtime__Types, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Char = global_data.Stdlib__Char, Tensor_playground_Counter = global_data.Tensor_playground__Counter, Stdlib = global_data.Stdlib, Stdlib_Format = global_data.Stdlib__Format, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib, Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, Expect_test_config = global_data.Expect_test_config, Ppx_expect_runtime_Test_block = global_data.Ppx_expect_runtime__Test_block, Ppx_expect_runtime_Test_node = global_data.Ppx_expect_runtime__Test_node, Inline_test_config = global_data.Inline_test_config;
    caml_call1(Ppx_expect_runtime[1][1], cst_lib_Einops_ml$5);
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground$0, "Einops.ml");
    var String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), Colored = [
        248,
        "Tensor_playground.Einops.Colored",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        [
            2,
            0,
            0
        ],
        "%s"
    ];
    function pp_var(get_color, ppf, var$0) {
        var color = caml_call1(get_color, var$0);
        caml_call2(Stdlib_Format[86], ppf, [
            0,
            Colored,
            color
        ]);
        caml_call3(Fmt[3], ppf, _a_, var$0);
        return caml_call2(Stdlib_Format[88], ppf, 0);
    }
    var PP_var_impl = [
        0,
        pp_var
    ], pp_var$0 = PP_var_impl[1], _b_ = caml_call2(Fmt[64], [
        0,
        Fmt[23]
    ], Fmt[57]), pp_friendly = caml_call2(Fmt[32], 0, _b_);
    function pp_original(ppf, group) {
        var _dk_ = caml_call2(Stdlib_String[7], cst, group);
        return caml_call2(Fmt[57], ppf, _dk_);
    }
    var Group = [
        0,
        pp_friendly,
        pp_original
    ], _c_ = caml_call2(Fmt[64], [
        0,
        Fmt[25]
    ], Group[1]), pp_friendly$0 = caml_call2(Fmt[32], 0, _c_), _d_ = caml_call2(Fmt[64], [
        0,
        Fmt[25]
    ], Group[2]), pp_original$0 = caml_call2(Fmt[32], 0, _d_), Bindings = [
        0,
        pp_friendly$0,
        pp_original$0
    ];
    function indices(param) {
        var rhs = param[2], lhs = param[1], _dj_ = caml_call1(Stdlib_List[15], lhs), lhs$0 = caml_call1(String_set[38], _dj_), rhs$0 = caml_call1(String_set[38], rhs);
        return [
            0,
            rhs$0,
            caml_call2(String_set[8], lhs$0, rhs$0)
        ];
    }
    function free_indices(t) {
        return indices(t)[1];
    }
    function summation_indices(t) {
        return indices(t)[2];
    }
    var _e_ = Group[1], _f_ = Bindings[1], _g_ = [
        0,
        caml_call1(Fmt[18], [
            0,
            [
                11,
                cst$7,
                0
            ],
            cst$7
        ])
    ], _h_ = caml_call3(Fmt[61], _g_, _f_, _e_), pp_friendly$1 = caml_call2(Fmt[32], 0, _h_), _i_ = Group[2], _j_ = Bindings[2], _k_ = [
        0,
        caml_call1(Fmt[18], [
            0,
            [
                11,
                cst$7,
                0
            ],
            cst$7
        ])
    ], _l_ = caml_call3(Fmt[61], _k_, _j_, _i_), pp_original$1 = caml_call2(Fmt[32], 0, _l_), cst_Ran_out_of_letters = "Ran out of letters", _m_ = [
        0,
        [
            11,
            "Result indices must not be repeated ([",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "])",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Result indices must not be repeated ([@[%a@]])"
    ], _n_ = [
        0,
        [
            11,
            "Result indices must be a subset of the input indices ([",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "] are not)",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Result indices must be a subset of the input indices ([@[%a@]] are not)"
    ];
    function to_original(param) {
        var rhs = param[2], lhs = param[1], match = indices([
            0,
            lhs,
            rhs
        ]), summation = match[2], free = match[1], _dg_ = caml_call2(String_set[5], free, summation), all_indices = caml_call1(String_set[37], _dg_), used = [
            0,
            0
        ];
        function pick_char(s) {
            var first = runtime.caml_string_get(s, 0);
            if (!caml_call2(Stdlib_List[37], first, used[1])) {
                used[1] = [
                    0,
                    first,
                    used[1]
                ];
                return caml_call2(Stdlib_String[1], 1, first);
            }
            var c$1 = caml_call1(Stdlib_Char[1], 97), c = c$1;
            for(;;){
                if (122 < c) return caml_call1(Stdlib[2], cst_Ran_out_of_letters);
                if (!caml_call2(Stdlib_List[37], c, used[1])) {
                    used[1] = [
                        0,
                        c,
                        used[1]
                    ];
                    return caml_call2(Stdlib_String[1], 1, c);
                }
                var c$0 = caml_call1(Stdlib_Char[1], c + 1 | 0);
                c = c$0;
            }
        }
        var assigned_chars = caml_call2(Stdlib_List[20], pick_char, all_indices), assoc_list = caml_call2(Stdlib_List[62], all_indices, assigned_chars);
        function find_char(x) {
            return caml_call2(Stdlib_List[53], x, assoc_list);
        }
        var _dh_ = caml_call2(Stdlib_List[20], find_char, rhs), _di_ = caml_call1(Stdlib_List[20], find_char);
        return [
            0,
            caml_call2(Stdlib_List[20], _di_, lhs),
            _dh_
        ];
    }
    function validate(param) {
        var rhs = param[2], lhs = param[1], _c__ = caml_call1(Stdlib_List[15], lhs), lhs_set = caml_call1(String_set[38], _c__), rhs_set = caml_call1(String_set[38], rhs), rhs_extras = caml_call2(String_set[8], rhs_set, lhs_set);
        if (!caml_call1(String_set[30], rhs_extras)) {
            var _dd_ = caml_call1(String_set[37], rhs_extras), _de_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], Fmt[57]);
            return [
                0,
                caml_call3(Fmt[6], _n_, _de_, _dd_)
            ];
        }
        var _c$_ = caml_call1(Tensor_playground_Counter[3], rhs), _da_ = caml_call1(Tensor_playground_Counter[7], _c$_), _db_ = caml_call1(caml_call1(Stdlib_List[44], function(param) {
            var n = param[2];
            return 1 < n ? 1 : 0;
        }), _da_), repeated_in_rhs = caml_call1(caml_call1(Stdlib_List[20], function(_df_) {
            return _df_[1];
        }), _db_);
        if (0 === repeated_in_rhs) return 0;
        var _dc_ = caml_call2(Fmt[64], [
            0,
            Fmt[25]
        ], Fmt[57]);
        return [
            0,
            caml_call3(Fmt[6], _m_, _dc_, repeated_in_rhs)
        ];
    }
    var Rewrite = [
        0,
        indices,
        free_indices,
        summation_indices,
        pp_friendly$1,
        pp_original$1,
        to_original,
        validate
    ];
    function indexof(x, lst) {
        var i = 0, param = lst;
        for(;;){
            if (!param) return 0;
            var ys = param[2], y = param[1];
            if (caml_equal(x, y)) return [
                0,
                i
            ];
            var i$0 = i + 1 | 0;
            i = i$0;
            param = ys;
        }
    }
    var Indexof_impl = [
        0,
        indexof
    ], indexof$0 = Indexof_impl[1], _o_ = [
        0,
        [
            11,
            "d_",
            [
                15,
                0
            ]
        ],
        "d_%a"
    ], _p_ = [
        0,
        [
            11,
            "result = np.zeros((",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            11,
                            "))",
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "result = np.zeros((@[%a@]))@."
    ], _q_ = [
        0,
        [
            11,
            "# Loop over all free indices",
            [
                17,
                4,
                0
            ]
        ],
        "# Loop over all free indices@."
    ], _r_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_for,
                [
                    15,
                    [
                        11,
                        cst_in_range,
                        [
                            15,
                            [
                                11,
                                cst$4,
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_sfor_a_in_range_a
    ], _s_ = [
        0,
        [
            2,
            0,
            [
                12,
                91,
                [
                    15,
                    [
                        12,
                        93,
                        0
                    ]
                ]
            ]
        ],
        "%s[%a]"
    ], _t_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_result,
                    [
                        18,
                        [
                            1,
                            [
                                0,
                                0,
                                cst$2
                            ]
                        ],
                        [
                            15,
                            [
                                17,
                                0,
                                [
                                    12,
                                    93,
                                    [
                                        17,
                                        [
                                            0,
                                            cst$3,
                                            1,
                                            0
                                        ],
                                        [
                                            11,
                                            cst$5,
                                            [
                                                17,
                                                partial$1,
                                                0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>result[@[%a@]]@ +=@ "
    ], _u_ = [
        0,
        [
            11,
            cst$6,
            0
        ],
        cst$6
    ], _v_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$2
                ]
            ],
            [
                11,
                "np.sum(",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                12,
                                41,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        0,
                                        [
                                            17,
                                            4,
                                            0
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[np.sum(@[%a@])@]@]@."
    ], _w_ = [
        0,
        [
            11,
            "return result",
            [
                17,
                4,
                0
            ]
        ],
        "return result@."
    ], _x_ = [
        0,
        [
            11,
            "return total",
            [
                17,
                4,
                0
            ]
        ],
        "return total@."
    ], _y_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_total,
                    [
                        17,
                        [
                            0,
                            cst$3,
                            1,
                            0
                        ],
                        [
                            12,
                            61,
                            [
                                17,
                                [
                                    0,
                                    cst$3,
                                    1,
                                    0
                                ],
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>total@ =@ "
    ], _z_ = [
        0,
        [
            2,
            0,
            [
                11,
                "# Loop over all summation indices",
                [
                    17,
                    4,
                    0
                ]
            ]
        ],
        "%s# Loop over all summation indices@."
    ], _A_ = [
        0,
        [
            2,
            0,
            [
                11,
                "total = 0",
                [
                    17,
                    4,
                    0
                ]
            ]
        ],
        "%stotal = 0@."
    ], _B_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_for,
                [
                    15,
                    [
                        11,
                        cst_in_range,
                        [
                            15,
                            [
                                11,
                                cst$4,
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_sfor_a_in_range_a
    ], _C_ = [
        0,
        [
            11,
            cst$6,
            0
        ],
        cst$6
    ], _D_ = [
        0,
        [
            2,
            0,
            [
                18,
                [
                    1,
                    [
                        0,
                        [
                            11,
                            cst_hov_4,
                            0
                        ],
                        cst_hov_4
                    ]
                ],
                [
                    11,
                    cst_total,
                    [
                        17,
                        [
                            0,
                            cst$3,
                            1,
                            0
                        ],
                        [
                            11,
                            cst$5,
                            [
                                17,
                                [
                                    0,
                                    cst$3,
                                    1,
                                    0
                                ],
                                [
                                    18,
                                    [
                                        1,
                                        [
                                            0,
                                            0,
                                            cst$2
                                        ]
                                    ],
                                    [
                                        15,
                                        [
                                            17,
                                            0,
                                            [
                                                17,
                                                0,
                                                partial$2
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%s@[<hov 4>total@ +=@ @[%a@]@]@."
    ], _E_ = [
        0,
        [
            2,
            0,
            [
                11,
                cst_result,
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                11,
                                "] = total",
                                [
                                    17,
                                    4,
                                    0
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "%sresult[@[%a@]] = total@."
    ];
    function can_use_frob(param) {
        var lhs_tensors = param[3], summation_indices = param[2];
        function has_repeated_indices(tensor) {
            var _c8_ = caml_call1(String_set[38], tensor), _c9_ = caml_call1(String_set[9], _c8_);
            return caml_call1(Stdlib_List[1], tensor) !== _c9_ ? 1 : 0;
        }
        function summation_indices_for(tensor) {
            return caml_call2(Stdlib_List[44], function(index) {
                return caml_call2(String_set[31], index, summation_indices);
            }, tensor);
        }
        var sliced_axes = caml_call2(Stdlib_List[20], summation_indices_for, lhs_tensors), longest_sliced_axes = caml_call3(Stdlib_List[26], function(longest, axes) {
            var _c7_ = caml_call1(Stdlib_List[1], longest);
            return _c7_ < caml_call1(Stdlib_List[1], axes) ? axes : longest;
        }, 0, sliced_axes), _c5_ = 1 - caml_call2(Stdlib_List[34], has_repeated_indices, lhs_tensors);
        return _c5_ ? caml_call2(Stdlib_List[33], function(axes) {
            var ys$1 = caml_call1(Stdlib_List[10], longest_sliced_axes), xs$1 = caml_call1(Stdlib_List[10], axes), xs = xs$1, ys = ys$1;
            for(;;){
                if (!xs) return 1;
                if (!ys) return 0;
                var ys$0 = ys[2], y = ys[1], xs$0 = xs[2], x = xs[1], _c6_ = caml_equal(x, y);
                if (!_c6_) return _c6_;
                xs = xs$0;
                ys = ys$0;
            }
        }, sliced_axes) : _c5_;
    }
    function mk_indent(indent) {
        return caml_call2(Stdlib_String[1], indent * 4 | 0, 32);
    }
    function pp(opt, get_color, ppf, param) {
        var use_frob = opt ? opt[1] : 0, rhs_tensor = param[4], lhs_tensors = param[3], summation_indices_set = param[2], free_indices = param[1], free_indices$0 = caml_call1(String_set[10], free_indices), summation_indices = caml_call1(String_set[10], summation_indices_set), pp_var = caml_call1(pp_var$0, get_color);
        function pp_d_var(ppf, var$0) {
            return caml_call4(Fmt[3], ppf, _o_, pp_var, var$0);
        }
        if (rhs_tensor) {
            var _cM_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp_d_var);
            caml_call4(Fmt[3], ppf, _p_, _cM_, rhs_tensor);
        }
        if (free_indices$0) caml_call2(Fmt[3], ppf, _q_);
        var outer_indent = caml_call3(Stdlib_List[26], function(indent, index) {
            var _c4_ = mk_indent(indent);
            caml_call7(Fmt[3], ppf, _r_, _c4_, pp_var, index, pp_d_var, index);
            return indent + 1 | 0;
        }, 0, free_indices$0);
        function pp_access(ppf, param) {
            var indices = param[2], tensor = param[1], _c3_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp_var);
            return caml_call5(Fmt[3], ppf, _s_, tensor, _c3_, indices);
        }
        if (use_frob) {
            if (rhs_tensor) {
                var _cN_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], pp_var), _cO_ = mk_indent(outer_indent);
                caml_call5(Fmt[3], ppf, _t_, _cO_, _cN_, free_indices$0);
            } else {
                var _cR_ = mk_indent(outer_indent);
                caml_call3(Fmt[3], ppf, _y_, _cR_);
            }
            var accesses = caml_call2(Stdlib_List[21], function(i, tensor) {
                var _cZ_ = caml_call2(Stdlib_List[20], function(label) {
                    return caml_call2(String_set[31], label, summation_indices_set) ? cst$0 : label;
                }, tensor), _c0_ = caml_call1(Stdlib_Char[1], i + 65 | 0);
                return [
                    0,
                    caml_call2(Stdlib_String[1], 1, _c0_),
                    _cZ_
                ];
            }, lhs_tensors), _cP_ = [
                0,
                caml_call1(Fmt[18], _u_)
            ], _cQ_ = caml_call2(Fmt[64], _cP_, pp_access);
            caml_call4(Fmt[3], ppf, _v_, _cQ_, accesses);
        } else {
            if (summation_indices) {
                var _cS_ = mk_indent(outer_indent);
                caml_call3(Fmt[3], ppf, _z_, _cS_);
            }
            var _cT_ = mk_indent(outer_indent);
            caml_call3(Fmt[3], ppf, _A_, _cT_);
            var inner_indent = caml_call3(Stdlib_List[26], function(indent, index) {
                var _c2_ = mk_indent(indent);
                caml_call7(Fmt[3], ppf, _B_, _c2_, pp_var, index, pp_d_var, index);
                return indent + 1 | 0;
            }, outer_indent, summation_indices), accesses$0 = caml_call2(Stdlib_List[21], function(i, tensor) {
                var _c1_ = caml_call1(Stdlib_Char[1], i + 65 | 0);
                return [
                    0,
                    caml_call2(Stdlib_String[1], 1, _c1_),
                    tensor
                ];
            }, lhs_tensors), _cU_ = [
                0,
                caml_call1(Fmt[18], _C_)
            ], _cV_ = caml_call2(Fmt[64], _cU_, pp_access), _cW_ = mk_indent(inner_indent);
            caml_call5(Fmt[3], ppf, _D_, _cW_, _cV_, accesses$0);
            if (rhs_tensor) {
                var _cX_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], pp_var), _cY_ = mk_indent(outer_indent);
                caml_call5(Fmt[3], ppf, _E_, _cY_, _cX_, free_indices$0);
            }
        }
        return rhs_tensor ? caml_call2(Fmt[3], ppf, _w_) : caml_call2(Fmt[3], ppf, _x_);
    }
    var Pyloops = [
        0,
        can_use_frob,
        pp
    ];
    function show_loops(rewrite) {
        var rhs_tensor = rewrite[2], lhs_tensors = rewrite[1], _cL_ = caml_call1(Rewrite[3], rewrite);
        return [
            0,
            caml_call1(Rewrite[2], rewrite),
            _cL_,
            lhs_tensors,
            rhs_tensor
        ];
    }
    var _F_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$2
                ]
            ],
            [
                11,
                "diagonalized: [",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst$2
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                11,
                                "],",
                                [
                                    17,
                                    [
                                        0,
                                        cst$3,
                                        1,
                                        0
                                    ],
                                    [
                                        11,
                                        "broadcast: [",
                                        [
                                            18,
                                            [
                                                1,
                                                partial
                                            ],
                                            [
                                                15,
                                                partial$0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[diagonalized: [@[%a@]],@ broadcast: [@[%a@]]@]@."
    ], _G_ = [
        0,
        cst_a,
        0
    ], _H_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _I_ = [
        0,
        cst_b,
        0
    ], _J_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _Y_ = [
        0,
        [
            12,
            91,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_a$0
    ], _Z_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], ___ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_a,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _$_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _aa_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    "d",
                    [
                        0,
                        cst_b,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _ab_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            0
        ]
    ], _ac_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                [
                    0,
                    cst_c,
                    0
                ]
            ]
        ],
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_a,
                        0
                    ]
                ]
            ],
            0
        ]
    ], _ad_ = [
        0,
        cst_a,
        0
    ], _ae_ = [
        0,
        [
            0,
            cst_a,
            [
                0,
                cst_b,
                0
            ]
        ],
        0
    ], _aB_ = [
        0,
        [
            12,
            91,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst$2
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_a$0
    ], _aC_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _aD_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_a,
                0
            ]
        ]
    ], _aE_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                [
                    0,
                    cst_a,
                    0
                ]
            ]
        ]
    ], cst_x = "x", _aX_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ], _aY_ = [
        0,
        cst_a,
        0
    ], _aZ_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            0
        ]
    ], _a0_ = [
        0,
        cst_a,
        [
            0,
            cst_b,
            [
                0,
                cst_c,
                0
            ]
        ]
    ], _bl_ = [
        0,
        [
            9,
            0,
            [
                17,
                4,
                0
            ]
        ],
        "%b@."
    ], _bm_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_k,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_k,
                    [
                        0,
                        cst_j,
                        0
                    ]
                ],
                0
            ]
        ],
        [
            0,
            cst_i,
            [
                0,
                cst_j,
                0
            ]
        ]
    ], _bn_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            0
        ],
        0
    ], _bo_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_k,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_j,
                    [
                        0,
                        cst_k,
                        [
                            0,
                            cst_l,
                            0
                        ]
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_i,
                        [
                            0,
                            cst_l,
                            0
                        ]
                    ],
                    0
                ]
            ]
        ],
        [
            0,
            cst_i,
            [
                0,
                cst_j,
                0
            ]
        ]
    ], _bp_ = [
        0,
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_c,
                        0
                    ]
                ],
                0
            ]
        ],
        0
    ], _bq_ = [
        0,
        [
            0,
            [
                0,
                cst_s,
                0
            ],
            [
                0,
                [
                    0,
                    cst_s,
                    [
                        0,
                        cst_t,
                        0
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_t,
                        0
                    ],
                    0
                ]
            ]
        ],
        0
    ], _br_ = [
        0,
        [
            0,
            [
                0,
                cst_a,
                [
                    0,
                    cst_b,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_b,
                    0
                ],
                [
                    0,
                    [
                        0,
                        cst_i,
                        0
                    ],
                    0
                ]
            ]
        ],
        [
            0,
            cst_i,
            0
        ]
    ], _bC_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_k,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_k,
                    [
                        0,
                        cst_j,
                        0
                    ]
                ],
                0
            ]
        ],
        [
            0,
            cst_i,
            [
                0,
                cst_j,
                0
            ]
        ]
    ], _bD_ = [
        0,
        [
            0,
            [
                0,
                cst_s,
                0
            ],
            [
                0,
                [
                    0,
                    cst_s,
                    [
                        0,
                        cst_t,
                        0
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_t,
                        0
                    ],
                    0
                ]
            ]
        ],
        0
    ], _bE_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            0
        ],
        [
            0,
            cst_i,
            0
        ]
    ], _bF_ = [
        0,
        [
            0,
            [
                0,
                cst_i,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            0
        ],
        0
    ], _bG_ = [
        0,
        [
            0,
            [
                0,
                cst_s,
                0
            ],
            [
                0,
                [
                    0,
                    cst_s,
                    [
                        0,
                        cst_t,
                        0
                    ]
                ],
                [
                    0,
                    [
                        0,
                        cst_t,
                        0
                    ],
                    0
                ]
            ]
        ],
        0
    ], _bH_ = [
        0,
        [
            0,
            [
                0,
                cst_b,
                [
                    0,
                    cst_i,
                    0
                ]
            ],
            [
                0,
                [
                    0,
                    cst_b,
                    [
                        0,
                        cst_j,
                        0
                    ]
                ],
                0
            ]
        ],
        [
            0,
            cst_b,
            [
                0,
                cst_i,
                [
                    0,
                    cst_j,
                    0
                ]
            ]
        ]
    ], _bI_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_i, d_j))\n      # Loop over all free indices\n      for i in range(d_i):\n          for j in range(d_j):\n              # Loop over all summation indices\n              total = 0\n              for k in range(d_k):\n                  total += A[i, k] * B[k, j]\n              result[i, j] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                9336,
                9342,
                9689
            ]
        ]
    ], _bJ_ = [
        0,
        9323,
        9327,
        9690
    ], _bM_ = [
        0,
        [
            0,
            [
                0,
                cst_Loop_over_all_summation_in,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                9755,
                9761,
                9950
            ]
        ]
    ], _bN_ = [
        0,
        9742,
        9746,
        9951
    ], _bQ_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_i))\n      # Loop over all free indices\n      for i in range(d_i):\n          total = 0\n          total += A[i, i]\n          result[i] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10003,
                10009,
                10208
            ]
        ]
    ], _bR_ = [
        0,
        9990,
        9994,
        10209
    ], _bU_ = [
        0,
        [
            0,
            [
                0,
                "\n      # Loop over all summation indices\n      total = 0\n      for i in range(d_i):\n          total += A[i, i]\n      return total\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10256,
                10262,
                10402
            ]
        ]
    ], _bV_ = [
        0,
        10243,
        10247,
        10403
    ], _bY_ = [
        0,
        [
            0,
            [
                0,
                cst_Loop_over_all_summation_in,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10468,
                10474,
                10663
            ]
        ]
    ], _bZ_ = [
        0,
        10455,
        10459,
        10664
    ], _b2_ = [
        0,
        [
            0,
            [
                0,
                "\n      result = np.zeros((d_b, d_i, d_j))\n      # Loop over all free indices\n      for b in range(d_b):\n          for i in range(d_i):\n              for j in range(d_j):\n                  total = 0\n                  total += A[b, i] * B[b, j]\n                  result[b, i, j] = total\n      return result\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                10740,
                10746,
                11061
            ]
        ]
    ], _b3_ = [
        0,
        10727,
        10731,
        11062
    ], _b6_ = [
        0,
        "show_loops"
    ], _b9_ = [
        0,
        9128,
        9130,
        11062
    ], _b__ = [
        0,
        11053,
        11062,
        11062
    ], _b$_ = [
        0,
        9128,
        9130,
        11062
    ], cst_lib_Einops_ml$4 = cst_lib_Einops_ml$5, _bs_ = [
        0,
        [
            0,
            [
                0,
                "\n      true\n      false\n      false\n      false\n      false\n      true\n      ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                11948,
                11954,
                12035
            ]
        ]
    ], _bt_ = [
        0,
        11935,
        11939,
        12036
    ], _bw_ = [
        0,
        "can_use_frob"
    ], _bz_ = [
        0,
        11064,
        11066,
        12036
    ], _bA_ = [
        0,
        12027,
        12036,
        12036
    ], _bB_ = [
        0,
        11064,
        11066,
        12036
    ], cst_lib_Einops_ml$3 = cst_lib_Einops_ml$5, _a1_ = [
        0,
        [
            0,
            [
                0,
                " [] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12342,
                12353,
                12361
            ]
        ]
    ], _a2_ = [
        0,
        12342,
        12344,
        12362
    ], _a5_ = [
        0,
        [
            0,
            [
                0,
                " [a] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12378,
                12389,
                12398
            ]
        ]
    ], _a6_ = [
        0,
        12378,
        12380,
        12399
    ], _a9_ = [
        0,
        [
            0,
            [
                0,
                " [a, x, b] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12420,
                12431,
                12446
            ]
        ]
    ], _a__ = [
        0,
        12420,
        12422,
        12447
    ], _bb_ = [
        0,
        [
            0,
            [
                0,
                " [a, x, b, x, c] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                12473,
                12484,
                12505
            ]
        ]
    ], _bc_ = [
        0,
        12473,
        12475,
        12506
    ], _bf_ = [
        0,
        "intersperse"
    ], _bi_ = [
        0,
        12168,
        12168,
        12506
    ], _bj_ = [
        0,
        12473,
        12506,
        12506
    ], _bk_ = [
        0,
        12168,
        12168,
        12506
    ], cst_lib_Einops_ml$2 = cst_lib_Einops_ml$5, _aF_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                13084,
                13097,
                13112
            ]
        ]
    ], _aG_ = [
        0,
        13084,
        13088,
        13113
    ], _aJ_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                13141,
                13154,
                13166
            ]
        ]
    ], _aK_ = [
        0,
        13141,
        13145,
        13167
    ], _aN_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                13200,
                13213,
                13228
            ]
        ]
    ], _aO_ = [
        0,
        13200,
        13204,
        13229
    ], _aR_ = [
        0,
        "extract_diagonals"
    ], _aU_ = [
        0,
        12911,
        12913,
        13229
    ], _aV_ = [
        0,
        13200,
        13229,
        13229
    ], _aW_ = [
        0,
        12911,
        12913,
        13229
    ], cst_lib_Einops_ml$1 = cst_lib_Einops_ml$5, _af_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                13828,
                13841,
                13856
            ]
        ]
    ], _ag_ = [
        0,
        13828,
        13832,
        13857
    ], _aj_ = [
        0,
        [
            0,
            [
                0,
                " [a; b; c; d] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                13926,
                13939,
                13957
            ]
        ]
    ], _ak_ = [
        0,
        13926,
        13930,
        13958
    ], _an_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b_c,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                14022,
                14035,
                14050
            ]
        ]
    ], _ao_ = [
        0,
        14022,
        14026,
        14051
    ], _ar_ = [
        0,
        [
            0,
            [
                0,
                cst_a_b,
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                14086,
                14099,
                14111
            ]
        ]
    ], _as_ = [
        0,
        14086,
        14090,
        14112
    ], _av_ = [
        0,
        "make_common_shape"
    ], _ay_ = [
        0,
        13598,
        13600,
        14112
    ], _az_ = [
        0,
        14086,
        14112,
        14112
    ], _aA_ = [
        0,
        13598,
        13600,
        14112
    ], cst_lib_Einops_ml$0 = cst_lib_Einops_ml$5, _K_ = [
        0,
        [
            0,
            [
                0,
                " diagonalized: [[a; b]], broadcast: [a; b] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                14638,
                14651,
                14698
            ]
        ]
    ], _L_ = [
        0,
        14638,
        14642,
        14699
    ], _O_ = [
        0,
        [
            0,
            [
                0,
                " diagonalized: [[a; b]], broadcast: [b; a] ",
                [
                    0,
                    cst$2
                ]
            ],
            [
                0,
                14734,
                14747,
                14794
            ]
        ]
    ], _P_ = [
        0,
        14734,
        14738,
        14795
    ], _S_ = [
        0,
        "make"
    ], _V_ = [
        0,
        14286,
        14288,
        14795
    ], _W_ = [
        0,
        14734,
        14795,
        14795
    ], _X_ = [
        0,
        14286,
        14288,
        14795
    ], cst_lib_Einops_ml = cst_lib_Einops_ml$5, cst_tensor_playground = cst_tensor_playground$0;
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$4 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _bK_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bJ_, _bI_), _bL_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 0),
                _bK_
            ],
            0
        ], _bO_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bN_, _bM_), _bP_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 1),
                _bO_
            ],
            _bL_
        ], _bS_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bR_, _bQ_), _bT_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 2),
                _bS_
            ],
            _bP_
        ], _bW_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bV_, _bU_), _bX_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 3),
                _bW_
            ],
            _bT_
        ], _b0_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bZ_, _bY_), _b1_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 4),
                _b0_
            ],
            _bX_
        ], _b4_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _b3_, _b2_), _b5_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 5),
                _b4_
            ],
            _b1_
        ], _b7_ = caml_call1(Ppx_expect_runtime_Types[4][1], 7), _b8_ = caml_call1(Ppx_expect_runtime_Types[4][1], 6);
        caml_call14(Ppx_expect_test_block$4[3], cst_lib_Einops_ml$4, 304, _b$_, _b__, _b9_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _b8_, _b7_, _b6_, 0, Inline_test_config, _b5_, function(param) {
            function go(rewrite) {
                var _cK_ = show_loops(rewrite);
                return caml_call1(caml_call3(Pyloops[2], 0, function(param) {
                    return cst$1;
                }, Fmt[1]), _cK_);
            }
            go(_bC_);
            var _cE_ = caml_call1(Ppx_expect_runtime_Types[4][1], 0);
            caml_call1(Ppx_expect_test_block$4[2], _cE_);
            go(_bD_);
            var _cF_ = caml_call1(Ppx_expect_runtime_Types[4][1], 1);
            caml_call1(Ppx_expect_test_block$4[2], _cF_);
            go(_bE_);
            var _cG_ = caml_call1(Ppx_expect_runtime_Types[4][1], 2);
            caml_call1(Ppx_expect_test_block$4[2], _cG_);
            go(_bF_);
            var _cH_ = caml_call1(Ppx_expect_runtime_Types[4][1], 3);
            caml_call1(Ppx_expect_test_block$4[2], _cH_);
            go(_bG_);
            var _cI_ = caml_call1(Ppx_expect_runtime_Types[4][1], 4);
            caml_call1(Ppx_expect_test_block$4[2], _cI_);
            go(_bH_);
            var _cJ_ = caml_call1(Ppx_expect_runtime_Types[4][1], 5);
            return caml_call1(Ppx_expect_test_block$4[2], _cJ_);
        });
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$3 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _bu_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bt_, _bs_), _bv_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 8),
                _bu_
            ],
            0
        ], _bx_ = caml_call1(Ppx_expect_runtime_Types[4][1], 10), _by_ = caml_call1(Ppx_expect_runtime_Types[4][1], 9);
        caml_call14(Ppx_expect_test_block$3[3], cst_lib_Einops_ml$3, 382, _bB_, _bA_, _bz_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _by_, _bx_, _bw_, 0, Inline_test_config, _bv_, function(param) {
            function go(rewrite) {
                var _cC_ = show_loops(rewrite), _cD_ = caml_call1(Pyloops[1], _cC_);
                return caml_call1(caml_call1(Fmt[4], _bl_), _cD_);
            }
            go(_bm_);
            go(_bn_);
            go(_bo_);
            go(_bp_);
            go(_bq_);
            go(_br_);
            var _cB_ = caml_call1(Ppx_expect_runtime_Types[4][1], 8);
            return caml_call1(Ppx_expect_test_block$3[2], _cB_);
        });
    }
    var Explain = [
        0,
        show_loops
    ];
    function intersperse(mk_sep, param) {
        if (!param) return 0;
        var x = param[1];
        if (!param[2]) return [
            0,
            x,
            0
        ];
        var xs = param[2], _cA_ = intersperse(mk_sep, xs);
        return [
            0,
            x,
            [
                0,
                caml_call1(mk_sep, 0),
                _cA_
            ]
        ];
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$2 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _a3_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a2_, _a1_), _a4_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 11),
                _a3_
            ],
            0
        ], _a7_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a6_, _a5_), _a8_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 12),
                _a7_
            ],
            _a4_
        ], _a$_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _a__, _a9_), _ba_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 13),
                _a$_
            ],
            _a8_
        ], _bd_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _bc_, _bb_), _be_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 14),
                _bd_
            ],
            _ba_
        ], _bg_ = caml_call1(Ppx_expect_runtime_Types[4][1], 16), _bh_ = caml_call1(Ppx_expect_runtime_Types[4][1], 15);
        caml_call14(Ppx_expect_test_block$2[3], cst_lib_Einops_ml$2, 416, _bk_, _bj_, _bi_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _bh_, _bg_, _bf_, 0, Inline_test_config, _be_, function(param) {
            function go(strs) {
                var _cx_ = intersperse(function(param) {
                    return cst_x;
                }, strs), _cy_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], Fmt[57]), _cz_ = caml_call1(Fmt[38], _cy_);
                return caml_call3(Fmt[4], _aX_, _cz_, _cx_);
            }
            go(0);
            var _ct_ = caml_call1(Ppx_expect_runtime_Types[4][1], 11);
            caml_call1(Ppx_expect_test_block$2[2], _ct_);
            go(_aY_);
            var _cu_ = caml_call1(Ppx_expect_runtime_Types[4][1], 12);
            caml_call1(Ppx_expect_test_block$2[2], _cu_);
            go(_aZ_);
            var _cv_ = caml_call1(Ppx_expect_runtime_Types[4][1], 13);
            caml_call1(Ppx_expect_test_block$2[2], _cv_);
            go(_a0_);
            var _cw_ = caml_call1(Ppx_expect_runtime_Types[4][1], 14);
            return caml_call1(Ppx_expect_test_block$2[2], _cw_);
        });
    }
    function extract_diagonals(tensor) {
        var seen = 0, param = tensor;
        for(;;){
            if (!param) return caml_call1(Stdlib_List[10], seen);
            var xs = param[2], x = param[1];
            if (caml_call2(Stdlib_List[37], x, seen)) param = xs;
            else {
                var seen$0 = [
                    0,
                    x,
                    seen
                ];
                seen = seen$0;
                param = xs;
            }
        }
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$1 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _aH_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aG_, _aF_), _aI_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 17),
                _aH_
            ],
            0
        ], _aL_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aK_, _aJ_), _aM_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 18),
                _aL_
            ],
            _aI_
        ], _aP_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _aO_, _aN_), _aQ_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 19),
                _aP_
            ],
            _aM_
        ], _aS_ = caml_call1(Ppx_expect_runtime_Types[4][1], 21), _aT_ = caml_call1(Ppx_expect_runtime_Types[4][1], 20);
        caml_call14(Ppx_expect_test_block$1[3], cst_lib_Einops_ml$1, 446, _aW_, _aV_, _aU_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _aT_, _aS_, _aR_, 0, Inline_test_config, _aQ_, function(param) {
            function go(tensor) {
                var _cr_ = extract_diagonals(tensor), _cs_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]);
                return caml_call1(caml_call2(Fmt[4], _aB_, _cs_), _cr_);
            }
            go(_aC_);
            var _co_ = caml_call1(Ppx_expect_runtime_Types[4][1], 17);
            caml_call1(Ppx_expect_test_block$1[2], _co_);
            go(_aD_);
            var _cp_ = caml_call1(Ppx_expect_runtime_Types[4][1], 18);
            caml_call1(Ppx_expect_test_block$1[2], _cp_);
            go(_aE_);
            var _cq_ = caml_call1(Ppx_expect_runtime_Types[4][1], 19);
            return caml_call1(Ppx_expect_test_block$1[2], _cq_);
        });
    }
    function make_common_shape(tensors, rhs) {
        var _cm_ = caml_call1(Stdlib_List[15], tensors), index_set = caml_call1(String_set[38], _cm_);
        function compare(x, y) {
            var match = caml_call2(indexof$0, x, rhs), match$0 = caml_call2(indexof$0, y, rhs);
            if (!match) return match$0 ? 1 : caml_call2(Stdlib_String[10], x, y);
            var a = match[1];
            if (!match$0) return -1;
            var b = match$0[1];
            return runtime.caml_int_compare(a, b);
        }
        var _cn_ = caml_call1(String_set[10], index_set);
        return caml_call2(Stdlib_List[63], compare, _cn_);
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block$0 = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _ah_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ag_, _af_), _ai_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 22),
                _ah_
            ],
            0
        ], _al_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ak_, _aj_), _am_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 23),
                _al_
            ],
            _ai_
        ], _ap_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _ao_, _an_), _aq_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 24),
                _ap_
            ],
            _am_
        ], _at_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _as_, _ar_), _au_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 25),
                _at_
            ],
            _aq_
        ], _aw_ = caml_call1(Ppx_expect_runtime_Types[4][1], 27), _ax_ = caml_call1(Ppx_expect_runtime_Types[4][1], 26);
        caml_call14(Ppx_expect_test_block$0[3], cst_lib_Einops_ml$0, 468, _aA_, _az_, _ay_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _ax_, _aw_, _av_, 0, Inline_test_config, _au_, function(param) {
            function go(tensors, rhs) {
                var _ck_ = make_common_shape(tensors, rhs), _cl_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]);
                return caml_call1(caml_call2(Fmt[4], _Y_, _cl_), _ck_);
            }
            go(___, _Z_);
            var _cg_ = caml_call1(Ppx_expect_runtime_Types[4][1], 22);
            caml_call1(Ppx_expect_test_block$0[2], _cg_);
            go(_aa_, _$_);
            var _ch_ = caml_call1(Ppx_expect_runtime_Types[4][1], 23);
            caml_call1(Ppx_expect_test_block$0[2], _ch_);
            go(_ac_, _ab_);
            var _ci_ = caml_call1(Ppx_expect_runtime_Types[4][1], 24);
            caml_call1(Ppx_expect_test_block$0[2], _ci_);
            go(_ae_, _ad_);
            var _cj_ = caml_call1(Ppx_expect_runtime_Types[4][1], 25);
            return caml_call1(Ppx_expect_test_block$0[2], _cj_);
        });
    }
    function make(param) {
        var rhs = param[2], lhs = param[1], diagonalized = caml_call2(Stdlib_List[20], extract_diagonals, lhs), broadcast = make_common_shape(diagonalized, rhs);
        return [
            0,
            diagonalized,
            broadcast
        ];
    }
    if (typeof Ppx_inline_test_lib[3] !== "number") {
        var Ppx_expect_test_block = caml_call1(Ppx_expect_runtime_Test_block[1], Expect_test_config), _M_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _L_, _K_), _N_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 28),
                _M_
            ],
            0
        ], _Q_ = caml_call3(Ppx_expect_runtime_Test_node[1][1], [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], _P_, _O_), _R_ = [
            0,
            [
                0,
                caml_call1(Ppx_expect_runtime_Types[4][1], 29),
                _Q_
            ],
            _N_
        ], _T_1 = caml_call1(Ppx_expect_runtime_Types[4][1], 31), _U_ = caml_call1(Ppx_expect_runtime_Types[4][1], 30);
        caml_call14(Ppx_expect_test_block[3], cst_lib_Einops_ml, 487, _X_, _W_, _V_, [
            0,
            Ppx_expect_runtime_Types[1][1]
        ], 0, _U_, _T_1, _S_, 0, Inline_test_config, _R_, function(param) {
            function go(lhs, rhs) {
                var match = make([
                    0,
                    lhs,
                    rhs
                ]), broadcast = match[2], diagonalized = match[1], _cc_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]), _cd_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], Fmt[57]), _ce_ = caml_call1(Fmt[38], _cd_), _cf_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], _ce_);
                return caml_call5(Fmt[4], _F_, _cf_, diagonalized, _cc_, broadcast);
            }
            go(_H_, _G_);
            var _ca_ = caml_call1(Ppx_expect_runtime_Types[4][1], 28);
            caml_call1(Ppx_expect_test_block[2], _ca_);
            go(_J_, _I_);
            var _cb_ = caml_call1(Ppx_expect_runtime_Types[4][1], 29);
            return caml_call1(Ppx_expect_test_block[2], _cb_);
        });
    }
    var Steps = [
        0,
        make
    ];
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Einops = [
        0,
        String_set,
        String_map,
        Colored,
        PP_var_impl,
        pp_var$0,
        Group,
        Bindings,
        Rewrite,
        Indexof_impl,
        indexof$0,
        Pyloops,
        Explain,
        intersperse,
        Steps
    ];
    runtime.caml_register_global(153, Tensor_playground_Einops, "Tensor_playground__Einops");
    return;
})(globalThis);
//# 2115 "../lib/.tensor_playground.objs/jsoo/default/tensor_playground.cma.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_Arrow = "Arrow", cst_Comma = "Comma", cst_Eof = "Eof", cst_Expected_a_group_got = "Expected a group, got [", cst_Expected_a_group_got_a = "Expected a group, got [@[%a@]]", cst_tensor_playground = "tensor_playground", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_ml_string_length = runtime.caml_ml_string_length, caml_string_get = runtime.caml_string_get, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Tensor_playground_Einops = global_data.Tensor_playground__Einops, Fmt = global_data.Fmt, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Seq = global_data.Stdlib__Seq, Stdlib = global_data.Stdlib, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Ppx_expect_runtime = global_data.Ppx_expect_runtime, Ppx_inline_test_lib = global_data.Ppx_inline_test_lib;
    caml_call1(Ppx_expect_runtime[1][1], "lib/Einsum_parser.ml");
    caml_call2(Ppx_inline_test_lib[6], cst_tensor_playground, "Einsum_parser.ml");
    var Error1 = [
        248,
        "Tensor_playground.Einsum_parser.Error",
        runtime.caml_fresh_oo_id(0)
    ], _a_ = [
        0,
        [
            11,
            cst_Arrow,
            0
        ],
        cst_Arrow
    ], _b_ = [
        0,
        [
            11,
            cst_Comma,
            0
        ],
        cst_Comma
    ], _c_ = [
        0,
        [
            11,
            cst_Eof,
            0
        ],
        cst_Eof
    ], _d_ = [
        0,
        [
            11,
            "Str ",
            [
                2,
                0,
                0
            ]
        ],
        "Str %s"
    ], _e_ = [
        0,
        [
            11,
            "At offset ",
            [
                4,
                0,
                0,
                0,
                [
                    11,
                    ": unexpected character '",
                    [
                        0,
                        [
                            11,
                            "'.\n",
                            0
                        ]
                    ]
                ]
            ]
        ],
        "At offset %d: unexpected character '%c'.\n"
    ], _f_ = [
        0,
        [
            11,
            "Expected an arrow, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected an arrow, got [@[%a@]]"
    ], _g_ = [
        0,
        [
            11,
            cst_Expected_a_group_got,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_Expected_a_group_got_a
    ], _h_ = [
        0,
        [
            11,
            cst_Expected_a_group_got,
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        cst_Expected_a_group_got_a
    ], _i_ = [
        0,
        [
            11,
            "Expected a comma or arrow, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected a comma or arrow, got [@[%a@]]"
    ], cst_Expected_more_tokens = "Expected more tokens", _j_ = [
        0,
        [
            11,
            "Expected a group or EOF, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected a group or EOF, got [@[%a@]]"
    ], _k_ = [
        0,
        [
            11,
            "Expected an arrow or EOF, got [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "Expected an arrow or EOF, got [@[%a@]]"
    ];
    function pp(ppf, param) {
        if (typeof param === "number") switch(param){
            case 0:
                return caml_call2(Stdlib_Format[143], ppf, _a_);
            case 1:
                return caml_call2(Stdlib_Format[143], ppf, _b_);
            default:
                return caml_call2(Stdlib_Format[143], ppf, _c_);
        }
        var s = param[1];
        return caml_call3(Stdlib_Format[143], ppf, _d_, s);
    }
    function lex_unsafe(input) {
        var i = 0, acc = 0;
        for(;;){
            if (caml_ml_string_length(input) <= i) return caml_call1(Stdlib_List[10], [
                0,
                2,
                acc
            ]);
            var c = caml_string_get(input, i);
            a: {
                if (33 > c) {
                    if (9 !== c && 32 > c) break a;
                    var i$3 = i + 1 | 0;
                    i = i$3;
                    continue;
                }
                if (44 === c) {
                    var acc$0 = [
                        0,
                        1,
                        acc
                    ], i$0 = i + 1 | 0;
                    i = i$0;
                    acc = acc$0;
                    continue;
                }
                if (45 === c && (i + 1 | 0) < caml_ml_string_length(input) && 62 === caml_string_get(input, i + 1 | 0)) {
                    var acc$1 = [
                        0,
                        0,
                        acc
                    ], i$1 = i + 2 | 0;
                    i = i$1;
                    acc = acc$1;
                    continue;
                }
            }
            a: {
                if (97 <= c && 122 >= c) break a;
                if (65 <= c && 90 >= c) break a;
                if (48 <= c && 57 >= c) break a;
                if (95 !== c) {
                    var _E_ = caml_string_get(input, i);
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        caml_call3(Stdlib_Printf[4], _e_, i, _E_)
                    ], 1);
                }
            }
            a: b: {
                c: {
                    var end = i;
                    for(;;){
                        if (caml_ml_string_length(input) <= end) break b;
                        var match = caml_string_get(input, end);
                        if (91 <= match) {
                            if (97 <= match) {
                                if (123 <= match) break c;
                            } else if (95 !== match) break c;
                        } else if (58 <= match) {
                            if (65 > match) break;
                        } else if (48 > match) break c;
                        var i$2 = end + 1 | 0;
                        end = i$2;
                    }
                }
                break a;
            }
            var acc$2 = [
                0,
                [
                    0,
                    caml_call3(Stdlib_String[16], input, i, end - i | 0)
                ],
                acc
            ];
            i = end;
            acc = acc$2;
        }
    }
    function group_unsafe(toks) {
        if (toks) {
            var match = toks[1];
            if (typeof match !== "number") {
                var t = toks[2], s = match[1], match$0 = group_unsafe(t), t$0 = match$0[2], strs = match$0[1];
                return [
                    0,
                    [
                        0,
                        s,
                        strs
                    ],
                    t$0
                ];
            }
        }
        return [
            0,
            0,
            toks
        ];
    }
    function parse(str) {
        a: try {
            var tokens = lex_unsafe(str);
            b: {
                c: {
                    var current_group = 0, acc = 0, param = tokens;
                    for(;;){
                        if (!param) break;
                        var tok = param[1];
                        if (typeof tok === "number") {
                            if (1 !== tok) break c;
                            var ts = param[2], acc$0 = caml_call2(Stdlib[37], acc, [
                                0,
                                current_group,
                                0
                            ]);
                            current_group = 0;
                            acc = acc$0;
                            param = ts;
                        } else {
                            var ts$1 = param[2], s = tok[1], current_group$0 = caml_call2(Stdlib[37], current_group, [
                                0,
                                s,
                                0
                            ]);
                            current_group = current_group$0;
                            param = ts$1;
                        }
                    }
                    var match = [
                        0,
                        caml_call2(Stdlib[37], acc, [
                            0,
                            current_group,
                            0
                        ]),
                        0
                    ];
                    break b;
                }
                var ts$0 = param[2], match = [
                    0,
                    caml_call2(Stdlib[37], acc, [
                        0,
                        current_group,
                        0
                    ]),
                    [
                        0,
                        tok,
                        ts$0
                    ]
                ];
            }
            var rest = match[2], lhs = match[1];
            if (rest) {
                var _z_ = rest[1];
                if (typeof _z_ === "number" && !_z_) {
                    var t = rest[2], match$0 = group_unsafe(t), g = match$0[1], _B_ = match$0[2];
                    b: if (_B_) {
                        var _C_ = _B_[1];
                        if (typeof _C_ === "number" && 2 <= _C_ && !_B_[2]) break b;
                        var toks = match$0[2], _D_ = caml_call2(Fmt[64], [
                            0,
                            Fmt[25]
                        ], pp);
                        throw caml_maybe_attach_backtrace([
                            0,
                            Error1,
                            caml_call3(Fmt[6], _g_, _D_, toks)
                        ], 1);
                    }
                    var candidate = [
                        0,
                        lhs,
                        g
                    ], match$1 = caml_call1(Tensor_playground_Einops[8][7], candidate);
                    if (!match$1) break a;
                    var e = match$1[1];
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        e
                    ], 1);
                }
            }
            var _A_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp);
            throw caml_maybe_attach_backtrace([
                0,
                Error1,
                caml_call3(Fmt[6], _f_, _A_, rest)
            ], 1);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Error1) throw caml_maybe_attach_backtrace(exn, 0);
            var e$0 = exn[2];
            return [
                1,
                e$0
            ];
        }
        return [
            0,
            candidate
        ];
    }
    function chars_to_strings(str) {
        var _w_ = caml_call1(Stdlib_String[40], str), _x_ = caml_call1(Stdlib_String[1], 1), _y_ = caml_call1(caml_call1(Stdlib_Seq[29], _x_), _w_);
        return caml_call1(Stdlib_List[69], _y_);
    }
    function parse$0(str) {
        a: try {
            var tokens = lex_unsafe(str);
            b: {
                c: {
                    var acc = 0, toks = tokens;
                    for(;;){
                        if (!toks) break;
                        var match = toks[1];
                        if (typeof match === "number") {
                            var _o_ = caml_call2(Fmt[64], 0, pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _h_, _o_, toks)
                            ], 1);
                        }
                        var ts = toks[2], s = match[1], group = chars_to_strings(s);
                        if (!ts) throw caml_maybe_attach_backtrace([
                            0,
                            Error1,
                            cst_Expected_more_tokens
                        ], 1);
                        var tok = ts[1];
                        if (typeof tok !== "number") {
                            var _p_ = caml_call2(Fmt[64], 0, pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _i_, _p_, ts)
                            ], 1);
                        }
                        if (1 !== tok) break c;
                        var toks$0 = ts[2], acc$0 = [
                            0,
                            group,
                            acc
                        ];
                        acc = acc$0;
                        toks = toks$0;
                    }
                    var match$0 = [
                        0,
                        caml_call1(Stdlib_List[10], acc),
                        0
                    ];
                    break b;
                }
                var ts$0 = ts[2], match$0 = [
                    0,
                    caml_call1(Stdlib_List[10], [
                        0,
                        group,
                        acc
                    ]),
                    [
                        0,
                        tok,
                        ts$0
                    ]
                ];
            }
            var rest = match$0[2], lhs = match$0[1];
            b: if (rest) {
                var _q_ = rest[1];
                if (typeof _q_ === "number") {
                    switch(_q_){
                        case 0:
                            var ts$1 = rest[2];
                            if (ts$1) {
                                var _r_ = ts$1[1];
                                if (typeof _r_ === "number") {
                                    if (2 <= _r_ && !ts$1[2]) {
                                        var candidate = [
                                            0,
                                            lhs,
                                            0
                                        ];
                                        break;
                                    }
                                } else {
                                    var _t_ = ts$1[2];
                                    if (_t_) {
                                        var _u_ = _t_[1];
                                        if (typeof _u_ === "number" && 2 <= _u_ && !_t_[2]) {
                                            var s$0 = _r_[1], candidate = [
                                                0,
                                                lhs,
                                                chars_to_strings(s$0)
                                            ];
                                            break;
                                        }
                                    }
                                }
                            }
                            var _s_ = caml_call2(Fmt[64], [
                                0,
                                Fmt[25]
                            ], pp);
                            throw caml_maybe_attach_backtrace([
                                0,
                                Error1,
                                caml_call3(Fmt[6], _j_, _s_, ts$1)
                            ], 1);
                        case 1:
                            break b;
                        default:
                            if (rest[2]) break b;
                            var candidate = [
                                0,
                                lhs,
                                0
                            ];
                    }
                    var match$1 = caml_call1(Tensor_playground_Einops[8][7], candidate);
                    if (!match$1) break a;
                    var e = match$1[1];
                    throw caml_maybe_attach_backtrace([
                        0,
                        Error1,
                        e
                    ], 1);
                }
            }
            var _v_ = caml_call2(Fmt[64], [
                0,
                Fmt[25]
            ], pp);
            throw caml_maybe_attach_backtrace([
                0,
                Error1,
                caml_call3(Fmt[6], _k_, _v_, rest)
            ], 1);
        } catch (exn$0) {
            var exn = caml_wrap_exception(exn$0);
            if (exn[1] !== Error1) throw caml_maybe_attach_backtrace(exn, 0);
            var e$0 = exn[2];
            return [
                1,
                e$0
            ];
        }
        return [
            0,
            candidate
        ];
    }
    function parse$1(str) {
        var _n_ = parse$0(str);
        return [
            0,
            parse(str),
            _n_
        ];
    }
    function prefers_original_notation(str) {
        try {
            var tokens$3 = lex_unsafe(str);
        } catch (_m_) {
            var _l_ = caml_wrap_exception(_m_);
            if (_l_[1] === Error1) return 0;
            throw caml_maybe_attach_backtrace(_l_, 0);
        }
        var saw_multichar = 0, group_has_token = 0, param = tokens$3;
        a: for(;;){
            if (param) {
                var match = param[1];
                if (typeof match !== "number") {
                    var tokens$1 = param[2], s = match[1];
                    if (group_has_token) return 0;
                    var group_has_token$0 = 1, saw_multichar$1 = saw_multichar || (1 < caml_ml_string_length(s) ? 1 : 0);
                    saw_multichar = saw_multichar$1;
                    group_has_token = group_has_token$0;
                    param = tokens$1;
                    continue;
                }
                switch(match){
                    case 0:
                        break a;
                    case 1:
                        var tokens$0 = param[2];
                        if (!group_has_token) return group_has_token;
                        group_has_token = 0;
                        param = tokens$0;
                        continue;
                    default:
                        if (!param[2]) {
                            var saw_multichar$0 = group_has_token ? saw_multichar : group_has_token;
                            return saw_multichar$0;
                        }
                }
            }
            return 0;
        }
        var tokens = param[2];
        if (!group_has_token) return group_has_token;
        var saw_multichar$2 = saw_multichar, group_has_token$1 = 0, param$0 = tokens;
        for(;;){
            if (param$0) {
                var match$0 = param$0[1];
                if (typeof match$0 !== "number") {
                    var tokens$2 = param$0[2], s$0 = match$0[1];
                    if (group_has_token$1) return 0;
                    var group_has_token$2 = 1, saw_multichar$3 = saw_multichar$2 || (1 < caml_ml_string_length(s$0) ? 1 : 0);
                    saw_multichar$2 = saw_multichar$3;
                    group_has_token$1 = group_has_token$2;
                    param$0 = tokens$2;
                    continue;
                }
                if (2 <= match$0 && !param$0[2]) return saw_multichar$2;
            }
            return 0;
        }
    }
    caml_call1(Ppx_inline_test_lib[7], cst_tensor_playground);
    caml_call1(Ppx_expect_runtime[1][2], 0);
    var Tensor_playground_Einsum_parse = [
        0,
        [
            0,
            parse
        ],
        [
            0,
            parse$0
        ],
        parse$1,
        prefers_original_notation
    ];
    runtime.caml_register_global(27, Tensor_playground_Einsum_parse, "Tensor_playground__Einsum_parser");
    return;
})(globalThis);
//# 4 ".tensor_playground_web.eobjs/jsoo/dune__exe.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, Dune_exe = [
        0
    ];
    runtime.caml_register_global(0, Dune_exe, "Dune__exe");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Colors.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_List = global_data.Stdlib__List, edge_attributes = [
        0,
        [
            0,
            "fill-indigo-800 dark:fill-rose-200",
            "text-indigo-800 dark:text-rose-200",
            "bg-indigo-800 dark:bg-rose-200",
            5.
        ],
        [
            0,
            "fill-pink-800 dark:fill-yellow-100",
            "text-pink-800 dark:text-yellow-100",
            "bg-pink-800 dark:bg-yellow-100",
            3.
        ],
        [
            0,
            "fill-fuchsia-800 dark:fill-emerald-200",
            "text-fuchsia-800 dark:text-emerald-200",
            "bg-fuchsia-800 dark:bg-emerald-200",
            7.
        ],
        [
            0,
            "fill-purple-900 dark:fill-cyan-200",
            "text-purple-900 dark:text-cyan-200",
            "bg-purple-900 dark:bg-cyan-200",
            9.
        ],
        [
            0,
            "fill-orange-800 dark:fill-stone-100",
            "text-orange-800 dark:text-stone-100",
            "bg-orange-800 dark:bg-stone-100",
            11.
        ],
        [
            0,
            "fill-red-700 dark:fill-pink-100",
            "text-red-700 dark:text-pink-100",
            "bg-red-700 dark:bg-pink-100",
            2.
        ],
        [
            0,
            "fill-teal-800 dark:fill-orange-200",
            "text-teal-800 dark:text-orange-200",
            "bg-teal-800 dark:bg-orange-200",
            2.
        ],
        [
            0,
            "fill-blue-900 dark:fill-blue-100",
            "text-blue-900 dark:text-blue-100",
            "bg-blue-900 dark:bg-blue-100",
            2.
        ],
        [
            0,
            "fill-cyan-800 dark:fill-slate-300",
            "text-cyan-800 dark:text-slate-300",
            "bg-cyan-800 dark:bg-slate-300",
            2.
        ],
        [
            0,
            "fill-emerald-800 dark:fill-lime-100",
            "text-emerald-800 dark:text-lime-100",
            "bg-emerald-800 dark:bg-lime-100",
            2.
        ]
    ].slice(), _a_ = [
        0,
        "fill-[#000] dark:fill-[#fff]",
        "text-[#000] dark:text-[#fff]",
        "bg-[#000] dark:bg-[#fff]",
        4.
    ];
    function get_edge_attributes(i) {
        return i < edge_attributes.length - 1 ? runtime.caml_check_bound(edge_attributes, i)[1 + i] : _a_;
    }
    function assign_edge_attributes(tensors) {
        var edge_attributes = caml_call2(Stdlib_Hashtbl[1], 0, 10), i = [
            0,
            0
        ];
        caml_call2(Stdlib_List[18], function(tensor) {
            return caml_call2(Stdlib_List[18], function(edge) {
                var _b_ = 1 - caml_call2(Stdlib_Hashtbl[9], edge_attributes, edge);
                if (!_b_) return _b_;
                var attrs = get_edge_attributes(i[1]);
                i[1] = i[1] + 1 | 0;
                return caml_call3(Stdlib_Hashtbl[5], edge_attributes, edge, attrs);
            }, tensor);
        }, tensors);
        return edge_attributes;
    }
    var Dune_exe_Colors = [
        0,
        edge_attributes,
        get_edge_attributes,
        assign_edge_attributes
    ];
    runtime.caml_register_global(4, Dune_exe_Colors, "Dune__exe__Colors");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Frontend_util.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst_0_0_20_20$0 = "0 0 20 20", cst_aria_hidden$1 = "aria-hidden", cst_aria_labelledby$1 = "aria-labelledby", cst_block_truncate$1 = "block truncate", cst_button$1 = "button", cst_clip_rule$0 = "clip-rule", cst_currentColor$1 = "currentColor", cst_evenodd$1 = "evenodd", cst_fill_rule$0 = "fill-rule", cst_listbox$1 = "listbox", cst_listbox_label$1 = "listbox-label", cst_role$1 = "role", cst_true$2 = "true", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_string_of_jsstring = runtime.caml_string_of_jsstring;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$1 = ", ", cst = "[", cst$0 = "]", Stdlib = global_data.Stdlib, Stdlib_List = global_data.Stdlib__List, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Brr = global_data.Brr, Note = global_data.Note, Note_brr = global_data.Note_brr, Stdlib_String = global_data.Stdlib__String, Brr_svg = global_data.Brr_svg, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Int = global_data.Stdlib__Int, Fmt = global_data.Fmt, Stdlib_Set = global_data.Stdlib__Set, Stdlib_Map = global_data.Stdlib__Map, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), String_map = caml_call1(Stdlib_Map[1], [
        0,
        Stdlib_String[10]
    ]), nav = Brr[9][125], h4 = Brr[9][101], h3 = Brr[9][100], h2 = Brr[9][99], h1 = Brr[9][98], li = Brr[9][118], ul = Brr[9][165], ol = Brr[9][128], p = Brr[9][132], tr = Brr[9][162], td = Brr[9][155], tbody = Brr[9][154], table = Brr[9][153], txt = Brr[9][3], span = Brr[9][147], div = Brr[9][88];
    function as_target(_aO_) {
        return _aO_;
    }
    var prop = Brr[9][28], input = Brr[9][112], set_children = Brr[9][18], code = Brr[9][79];
    function embed_svg(_aN_) {
        return _aN_;
    }
    function svg_at(name, value) {
        return caml_call3(Brr_svg[2][1], 0, caml_jsstring_of_string(name), caml_jsstring_of_string(value));
    }
    function at(name, value) {
        return caml_call2(Brr[8][1], caml_jsstring_of_string(name), caml_jsstring_of_string(value));
    }
    function txt_td(str) {
        return caml_call3(td, 0, 0, [
            0,
            caml_call2(txt, 0, str),
            0
        ]);
    }
    function class$0(str) {
        return caml_call1(Brr[8][19], caml_jsstring_of_string(str));
    }
    function classes(str) {
        var _aM_ = caml_call1(caml_call1(Stdlib_String[17], 32), str);
        return caml_call1(caml_call1(Stdlib_List[20], class$0), _aM_);
    }
    function svg_class(str) {
        return caml_call1(Brr_svg[2][23], caml_jsstring_of_string(str));
    }
    function svg_classes(str) {
        var _aL_ = caml_call1(caml_call1(Stdlib_String[17], 32), str);
        return caml_call1(caml_call1(Stdlib_List[20], svg_class), _aL_);
    }
    function type(str) {
        return caml_call1(Brr[8][48], caml_jsstring_of_string(str));
    }
    function d(str) {
        return caml_call1(Brr_svg[2][38], caml_jsstring_of_string(str));
    }
    function viewbox(str) {
        return caml_call1(Brr_svg[2][221], caml_jsstring_of_string(str));
    }
    function fill(str) {
        return caml_call1(Brr_svg[2][54], caml_jsstring_of_string(str));
    }
    function fmt_txt(fmt) {
        return caml_call2(Fmt[8], function(s) {
            return caml_call2(Brr[9][3], 0, s);
        }, fmt);
    }
    function bracketed_input(bracketed_s, elem) {
        var lbracket = caml_call3(Brr[9][147], 0, 0, 0), rbracket = caml_call3(Brr[9][147], 0, 0, 0);
        function f(str, param) {
            return param ? [
                0,
                caml_call2(Brr[9][3], 0, str),
                0
            ] : 0;
        }
        var _aH_ = caml_call3(Note[4][14], 0, function(_aK_) {
            return f(cst, _aK_);
        }, bracketed_s);
        caml_call2(Note_brr[4][2], lbracket, _aH_);
        var _aI_ = caml_call3(Note[4][14], 0, function(_aJ_) {
            return f(cst$0, _aJ_);
        }, bracketed_s);
        caml_call2(Note_brr[4][2], rbracket, _aI_);
        return caml_call3(Brr[9][147], 0, 0, [
            0,
            lbracket,
            [
                0,
                elem,
                [
                    0,
                    rbracket,
                    0
                ]
            ]
        ]);
    }
    function render_vec(direction, items) {
        if (direction) return caml_call3(tbody, 0, 0, caml_call1(caml_call1(Stdlib_List[20], function(i) {
            return caml_call3(tr, 0, 0, [
                0,
                txt_td(caml_call1(Stdlib_Int[12], i)),
                0
            ]);
        }), items));
        var _aG_ = caml_call1(caml_call1(Stdlib_List[20], Stdlib_Int[12]), items);
        return caml_call3(tbody, 0, 0, [
            0,
            caml_call3(tr, 0, 0, caml_call1(caml_call1(Stdlib_List[20], txt_td), _aG_)),
            0
        ]);
    }
    function render_mat(items) {
        var _aE_ = caml_call1(caml_call1(Stdlib_List[20], function(items) {
            var _aF_ = caml_call1(caml_call1(Stdlib_List[20], Stdlib_Int[12]), items);
            return caml_call1(caml_call1(Stdlib_List[20], txt_td), _aF_);
        }), items);
        return caml_call3(tbody, 0, 0, caml_call1(caml_call1(Stdlib_List[20], function(eta) {
            return caml_call3(tr, 0, 0, eta);
        }), _aE_));
    }
    function input$0(opt, start_value, external_update_input) {
        var at = opt ? opt[1] : 0, at$0 = [
            0,
            caml_call1(Brr[8][49], caml_jsstring_of_string(start_value)),
            at
        ], input_elem = caml_call3(input, 0, [
            0,
            at$0
        ], 0), match = caml_call2(Note[4][3], 0, start_value), set_input = match[2], input_signal = match[1];
        caml_call6(Note_brr[3][9], 0, 0, 0, input_elem, Brr[7][44], function(evt) {
            return caml_call2(set_input, 0, caml_string_of_jsstring(caml_call2(prop, Brr[9][27][10], input_elem)));
        });
        var _aD_ = caml_call2(Note[3][9], caml_jsstring_of_string, external_update_input);
        caml_call3(Note_brr[4][5], Brr[9][27][10], _aD_, input_elem);
        return [
            0,
            caml_call3(Note[3][2], 0, external_update_input, function(eta) {
                return caml_call2(set_input, 0, eta);
            }),
            input_elem,
            input_signal
        ];
    }
    var input_classes = classes("rounded-lg border-0 px-3 py-1.5 font-mono text-sm leading-6 text-slate-900 bg-white dark:bg-slate-950/60 dark:text-slate-100 shadow-sm ring-1 ring-inset ring-slate-300 dark:ring-slate-600 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:ring-2 focus:ring-inset focus:ring-indigo-500 dark:focus:ring-indigo-400"), cst_text_red_600_dark_text_red = "text-red-600 dark:text-red-400", _a_ = [
        0,
        0
    ];
    function parsed_input(parse, start_value) {
        var _aB_ = [
            0,
            caml_call1(Brr[8][49], caml_jsstring_of_string(start_value)),
            0
        ], input_elem = caml_call3(input, 0, [
            0,
            caml_call2(Stdlib[37], _aB_, input_classes)
        ], 0), parse_error_elem = caml_call3(div, 0, [
            0,
            classes(cst_text_red_600_dark_text_red)
        ], 0), match = caml_call2(Note[4][3], 0, start_value), set_input = match[2], input_signal = match[1], match$0 = caml_call2(Note[4][3], 0, 0), set_parse_error = match$0[2], parse_error_signal = match$0[1], match$1 = caml_call2(Note[4][3], 0, 0), set_parsed = match$1[2], parsed_signal = match$1[1];
        caml_call6(Note_brr[3][9], 0, 0, 0, input_elem, Brr[7][44], function(evt) {
            return caml_call2(set_input, 0, caml_string_of_jsstring(caml_call2(prop, Brr[9][27][10], input_elem)));
        });
        var output_logger = caml_call3(Note[4][2], 0, input_signal, function(str) {
            var match = caml_call1(parse, str);
            if (0 === match[0]) {
                var t = match[1];
                caml_call2(set_parsed, 0, [
                    0,
                    t
                ]);
                return caml_call2(set_parse_error, 0, 0);
            }
            var match$0 = match[1], msg2 = match$0[2], msg1 = match$0[1];
            caml_call2(set_parsed, 0, 0);
            var _aC_ = [
                0,
                caml_call2(txt, 0, msg2),
                0
            ];
            return caml_call2(set_parse_error, 0, [
                0,
                caml_call2(txt, 0, msg1),
                _aC_
            ]);
        });
        caml_call1(Note[2][7], output_logger);
        caml_call2(Note_brr[4][2], parse_error_elem, parse_error_signal);
        return [
            0,
            parsed_signal,
            input_elem,
            parse_error_elem
        ];
    }
    function bracketed_parsed_input(parse, start_value) {
        var match = caml_call2(Note[4][3], 0, 1), set_bracket = match[2], bracket_signal = match[1], match$0 = parsed_input(parse, start_value), err_elem = match$0[3], input_elem = match$0[2], out_signal = match$0[1], _aA_ = caml_call1(Stdlib_Option[7], function(param) {
            var bracketed = param[2], t = param[1];
            caml_call2(set_bracket, 0, bracketed);
            return t;
        }), out_signal$0 = caml_call3(Note[4][14], 0, _aA_, out_signal), bracketed_input_elem = bracketed_input(bracket_signal, input_elem);
        return [
            0,
            out_signal$0,
            bracketed_input_elem,
            err_elem
        ];
    }
    function result_list(results) {
        function loop(results) {
            if (!results) return _a_;
            var match = results[1];
            if (0 !== match[0]) {
                var e$0 = match[1];
                return [
                    1,
                    e$0
                ];
            }
            var results$0 = results[2], x = match[1], match$0 = loop(results$0);
            if (0 === match$0[0]) {
                var xs = match$0[1];
                return [
                    0,
                    [
                        0,
                        x,
                        xs
                    ]
                ];
            }
            var e = match$0[1];
            return [
                1,
                e
            ];
        }
        return loop(results);
    }
    var _b_ = [
        0,
        svg_at(cst_clip_rule$0, cst_evenodd$1),
        0
    ], _c_ = [
        0,
        svg_at(cst_fill_rule$0, cst_evenodd$1),
        _b_
    ], _d_ = [
        0,
        d("M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"),
        0
    ], _e_ = [
        0,
        caml_call2(Stdlib[37], _d_, _c_)
    ], _f_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _e_, 0),
        0
    ], _g_ = [
        0,
        fill(cst_currentColor$1),
        0
    ], _h_ = [
        0,
        viewbox(cst_0_0_20_20$0),
        _g_
    ], _i_ = [
        0,
        svg_at(cst_aria_hidden$1, cst_true$2),
        0
    ], _j_ = caml_call2(Stdlib[37], _i_, _h_), _k_ = svg_classes("h-5 w-5 text-gray-400"), _l_ = [
        0,
        caml_call2(Stdlib[37], _k_, _j_)
    ], chevrons_svg = caml_call3(Brr_svg[3][74], 0, _l_, _f_), cst_evenodd = cst_evenodd$1, cst_clip_rule = cst_clip_rule$0, cst_evenodd$0 = cst_evenodd$1, cst_fill_rule = cst_fill_rule$0, cst_M16_704_4_153a_75_75_0_01_ = "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z", cst_currentColor = cst_currentColor$1, cst_0_0_20_20 = cst_0_0_20_20$0, cst_true = cst_true$2, cst_aria_hidden = cst_aria_hidden$1, cst_h_5_w_5 = "h-5 w-5", cst_M_12_2_C_6_4889971_2_2_6_4 = "M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z", cst_currentColor$0 = cst_currentColor$1, cst_0_0_24_24 = "0 0 24 24", cst_true$0 = cst_true$2, cst_aria_hidden$0 = cst_aria_hidden$1, cst_h_4_w_4 = "h-4 w-4", cst_inline_flex = "inline-flex", cst_align_middle_text_slate_40 = "align-middle text-slate-400 hover:text-indigo-500 dark:text-slate-500 dark:hover:text-indigo-300 transition-colors", cst_button = cst_button$1, cst_inline_align_middle_relati = "inline align-middle relative not-prose", cst_w_screen_max_w_md_flex_aut = "w-screen max-w-md flex-auto overflow-hidden rounded-xl bg-white dark:bg-slate-800 text-sm/6 text-slate-700 dark:text-slate-200 shadow-xl ring-1 ring-slate-900/10 dark:ring-white/10 p-4", cst_absolute_z_10_flex_w_scree = "absolute z-10 flex w-screen max-w-max px-4", cst_block_truncate = cst_block_truncate$1, cst_pointer_events_none_absolu = "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2", cst_relative_w_full_cursor_def = "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 inline-flex", cst_listbox_label = cst_listbox_label$1, cst_aria_labelledby = cst_aria_labelledby$1, cst_true$1 = cst_true$2, cst_aria_expanded = "aria-expanded", cst_listbox = cst_listbox$1, cst_aria_haspopup = "aria-haspopup", cst_button$0 = cst_button$1, cst_text_indigo_600_absolute_i = "text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4", cst_option = "option", cst_role = cst_role$1, cst_text_gray_900_relative_cur = "text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9", cst_block_truncate$0 = cst_block_truncate$1, cst_listbox_label$0 = cst_listbox_label$1, cst_aria_labelledby$0 = cst_aria_labelledby$1, cst_listbox$0 = cst_listbox$1, cst_role$0 = cst_role$1, cst_absolute_z_10_mt_1_max_h_6 = "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", cst_not_prose = "not-prose";
    function info(child) {
        var match = caml_call2(Note[4][3], 0, 0), set_dropdown_open = match[2], dropdown_open_signal = match[1], _ap_ = caml_call1(Brr[10][5], Brr[16][2]), click_outside_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
            return 0;
        }, _ap_), click_child_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            return caml_call1(Brr[7][10], evt);
        }, child), _ah_ = [
            0,
            [
                0,
                d(cst_M_12_2_C_6_4889971_2_2_6_4),
                0
            ]
        ], _ai_ = [
            0,
            caml_call3(Brr_svg[3][64], 0, _ah_, 0),
            0
        ], _aj_ = [
            0,
            fill(cst_currentColor$0),
            0
        ], _ak_ = [
            0,
            viewbox(cst_0_0_24_24),
            _aj_
        ], _al_ = [
            0,
            svg_at(cst_aria_hidden$0, cst_true$0),
            0
        ], _am_ = caml_call2(Stdlib[37], _al_, _ak_), _an_ = svg_classes(cst_h_4_w_4), _ao_ = [
            0,
            caml_call2(Stdlib[37], _an_, _am_)
        ], _aq_ = [
            0,
            caml_call3(Brr_svg[3][74], 0, _ao_, _ai_),
            0
        ], _ar_ = [
            0,
            caml_call3(span, 0, [
                0,
                classes(cst_inline_flex)
            ], _aq_),
            0
        ], _as_ = classes(cst_align_middle_text_slate_40), _at_ = [
            0,
            [
                0,
                type(cst_button),
                _as_
            ]
        ], button = caml_call3(Brr[9][75], 0, _at_, _ar_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _au_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 1 - caml_call1(Note[4][6], dropdown_open_signal));
        });
        caml_call1(Note[2][8], _au_);
        var _av_ = caml_call3(Note[3][2], 0, click_outside_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 0);
        });
        caml_call1(Note[2][8], _av_);
        var _aw_ = caml_call3(Note[3][2], 0, click_child_event, function(param) {
            return 0;
        });
        caml_call1(Note[2][8], _aw_);
        var _ax_ = [
            0,
            classes(cst_inline_align_middle_relati)
        ], result_elem = caml_call3(Brr[9][88], 0, _ax_, 0), _ay_ = caml_call1(caml_call2(Note[4][14], 0, function(open) {
            if (!open) return [
                0,
                button,
                0
            ];
            var _az_ = [
                0,
                caml_call3(div, 0, [
                    0,
                    classes(cst_w_screen_max_w_md_flex_aut)
                ], [
                    0,
                    child,
                    0
                ]),
                0
            ];
            return [
                0,
                button,
                [
                    0,
                    caml_call3(div, 0, [
                        0,
                        classes(cst_absolute_z_10_flex_w_scree)
                    ], _az_),
                    0
                ]
            ];
        }), dropdown_open_signal);
        caml_call2(Note_brr[4][2], result_elem, _ay_);
        return result_elem;
    }
    function select(clicked_op_e, items) {
        var match = caml_call2(Note[4][3], 0, 0), set_selected = match[2], selected_signal = match[1], logr = caml_call3(Note[3][2], 0, clicked_op_e, function(clicked_op) {
            var stripped_list = caml_call2(Stdlib_List[20], function(s) {
                var match = caml_call2(Stdlib_String[17], 58, s);
                if (match) {
                    var _ag_ = match[2];
                    if (_ag_ && !_ag_[2]) {
                        var einsum = _ag_[1];
                        return caml_call1(Stdlib_String[24], einsum);
                    }
                }
                return s;
            }, items), match = caml_call2(Stdlib_List[41], function(s) {
                return s === clicked_op ? 1 : 0;
            }, stripped_list);
            if (match) var i = match[1], i$0 = i;
            else var i$0 = 0;
            return caml_call2(set_selected, 0, i$0);
        });
        caml_call1(Note[2][8], logr);
        var selected_item = caml_call1(caml_call2(Note[4][14], 0, function(i) {
            return caml_call2(Stdlib_List[8], items, i);
        }), selected_signal), match$0 = caml_call2(Note[4][3], 0, 0), set_dropdown_open = match$0[2], dropdown_open_signal = match$0[1], selected_span = caml_call3(span, 0, [
            0,
            classes(cst_block_truncate)
        ], 0), _I_ = caml_call1(caml_call2(Note[4][14], 0, function(i) {
            return [
                0,
                caml_call2(txt, 0, i),
                0
            ];
        }), selected_item);
        caml_call2(Note_brr[4][2], selected_span, _I_);
        var _J_ = [
            0,
            classes(cst_pointer_events_none_absolu)
        ], _K_ = [
            0,
            caml_call3(Brr[9][147], 0, _J_, [
                0,
                chevrons_svg,
                0
            ]),
            [
                0,
                selected_span,
                0
            ]
        ], _L_ = classes(cst_relative_w_full_cursor_def), _M_ = [
            0,
            at(cst_aria_labelledby, cst_listbox_label),
            0
        ], _N_ = [
            0,
            at(cst_aria_expanded, cst_true$1),
            _M_
        ], _O_ = [
            0,
            at(cst_aria_haspopup, cst_listbox),
            _N_
        ], _P_ = [
            0,
            type(cst_button$0),
            _O_
        ], _Q_ = [
            0,
            caml_call2(Stdlib[37], _P_, _L_)
        ], button = caml_call3(Brr[9][75], 0, _Q_, _K_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _x_ = [
            0,
            svg_at(cst_clip_rule, cst_evenodd),
            0
        ], _y_ = [
            0,
            svg_at(cst_fill_rule, cst_evenodd$0),
            _x_
        ], _z_ = [
            0,
            d(cst_M16_704_4_153a_75_75_0_01_),
            0
        ], _A_ = [
            0,
            caml_call2(Stdlib[37], _z_, _y_)
        ], _B_ = [
            0,
            caml_call3(Brr_svg[3][64], 0, _A_, 0),
            0
        ], _C_ = [
            0,
            fill(cst_currentColor),
            0
        ], _D_ = [
            0,
            viewbox(cst_0_0_20_20),
            _C_
        ], _E_ = [
            0,
            svg_at(cst_aria_hidden, cst_true),
            0
        ], _F_ = caml_call2(Stdlib[37], _E_, _D_), _G_ = svg_classes(cst_h_5_w_5), _H_ = [
            0,
            caml_call2(Stdlib[37], _G_, _F_)
        ], _R_ = [
            0,
            caml_call3(Brr_svg[3][74], 0, _H_, _B_),
            0
        ], checkmark = caml_call3(span, 0, [
            0,
            classes(cst_text_indigo_600_absolute_i)
        ], _R_);
        function item(i, name) {
            var _ac_ = [
                0,
                at(cst_role, cst_option),
                0
            ], _ad_ = classes(cst_text_gray_900_relative_cur), elem = caml_call3(li, 0, [
                0,
                caml_call2(Stdlib[37], _ad_, _ac_)
            ], 0), _ae_ = [
                0,
                caml_call2(txt, 0, name),
                0
            ], text_child = caml_call3(span, 0, [
                0,
                classes(cst_block_truncate$0)
            ], _ae_), is_selected_s = caml_call1(caml_call2(Note[4][14], 0, function(i$0) {
                return i === i$0 ? 1 : 0;
            }), selected_signal), evt = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
                return i;
            }, elem);
            caml_call3(Note_brr[4][8], "font-normal", is_selected_s, elem);
            caml_call3(Note_brr[4][8], "font-semibold", is_selected_s, elem);
            var _af_ = caml_call1(caml_call2(Note[4][14], 0, function(is_selected) {
                return is_selected ? [
                    0,
                    text_child,
                    [
                        0,
                        checkmark,
                        0
                    ]
                ] : [
                    0,
                    text_child,
                    0
                ];
            }), is_selected_s);
            caml_call2(Note_brr[4][2], elem, _af_);
            return [
                0,
                evt,
                elem
            ];
        }
        var _S_ = caml_call2(Stdlib_List[21], item, items), match$1 = caml_call1(Stdlib_List[61], _S_), list_elems = match$1[2], list_evts = match$1[1], _T_1 = caml_call1(Brr[10][5], Brr[16][2]), click_outside_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
            return 0;
        }, _T_1), _U_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 1 - caml_call1(Note[4][6], dropdown_open_signal));
        });
        caml_call1(Note[2][8], _U_);
        var _V_ = caml_call3(Note[3][2], 0, click_outside_event, function(param) {
            return caml_call2(set_dropdown_open, 0, 0);
        });
        caml_call1(Note[2][8], _V_);
        var _W_ = caml_call1(Note[3][13], list_evts), _X_ = caml_call3(Note[3][2], 0, _W_, function(eta) {
            return caml_call2(set_selected, 0, eta);
        });
        caml_call1(Note[2][8], _X_);
        var _Y_ = [
            0,
            at(cst_aria_labelledby$0, cst_listbox_label$0),
            0
        ], _Z_ = [
            0,
            at(cst_role$0, cst_listbox$0),
            _Y_
        ], ___ = [
            0,
            caml_call1(Brr[8][46], -1),
            _Z_
        ], _$_ = classes(cst_absolute_z_10_mt_1_max_h_6), list = caml_call3(ul, 0, [
            0,
            caml_call2(Stdlib[37], _$_, ___)
        ], list_elems), _aa_ = [
            0,
            classes(cst_not_prose)
        ], result_elem = caml_call3(Brr[9][88], 0, _aa_, 0), _ab_ = caml_call1(caml_call2(Note[4][14], 0, function(open) {
            return open ? [
                0,
                button,
                [
                    0,
                    list,
                    0
                ]
            ] : [
                0,
                button,
                0
            ];
        }), dropdown_open_signal);
        caml_call2(Note_brr[4][2], result_elem, _ab_);
        return [
            0,
            result_elem,
            selected_item
        ];
    }
    var Select_and_info = [
        0,
        select,
        info
    ], cst_underline = "underline", cst_unsnoc_empty_list = "unsnoc empty list", cst_and = ", and ", cst_and$0 = " and ", cst_in_this_case_there_are_non = "in this case there are none";
    function select$0(clicked_op_e, items) {
        return caml_call2(Select_and_info[1], clicked_op_e, items);
    }
    function info$0(child) {
        return caml_call1(Select_and_info[2], child);
    }
    function a(link, text) {
        var _u_ = [
            0,
            caml_call2(txt, 0, text),
            0
        ], _v_ = [
            0,
            class$0(cst_underline),
            0
        ], _w_ = [
            0,
            [
                0,
                caml_call1(Brr[8][31], caml_jsstring_of_string(link)),
                _v_
            ]
        ];
        return caml_call3(Brr[9][61], 0, _w_, _u_);
    }
    function unsnoc(param) {
        if (!param) return caml_call1(Stdlib[2], cst_unsnoc_empty_list);
        var x = param[1];
        if (!param[2]) return [
            0,
            0,
            x
        ];
        var xs = param[2], match = unsnoc(xs), last = match[2], init = match[1];
        return [
            0,
            [
                0,
                x,
                init
            ],
            last
        ];
    }
    function list_variables(get_classes, vars) {
        function mk_code(x) {
            var _t_ = [
                0,
                caml_call2(txt, 0, x),
                0
            ];
            return caml_call3(code, 0, [
                0,
                classes(caml_call1(get_classes, x))
            ], _t_);
        }
        if (!vars) return [
            0,
            caml_call2(txt, 0, cst_in_this_case_there_are_non),
            0
        ];
        var _m_ = vars[2], x = vars[1];
        if (!_m_) return [
            0,
            mk_code(x),
            0
        ];
        if (_m_[2]) {
            var match = unsnoc(vars), last = match[2], init = match[1], _n_ = [
                0,
                mk_code(last),
                0
            ], _o_ = [
                0,
                caml_call2(txt, 0, cst_and),
                _n_
            ], _p_ = caml_call2(Stdlib_List[20], mk_code, init), _q_ = caml_call2(Tensor_playground_Einops[13], function(param) {
                return caml_call2(txt, 0, cst$1);
            }, _p_);
            return caml_call2(Stdlib[37], _q_, _o_);
        }
        var y = _m_[1], _r_ = [
            0,
            mk_code(y),
            0
        ], _s_ = [
            0,
            caml_call2(txt, 0, cst_and$0),
            _r_
        ];
        return [
            0,
            mk_code(x),
            _s_
        ];
    }
    var Dune_exe_Frontend_util = [
        0,
        String_set,
        String_map,
        code,
        set_children,
        input,
        prop,
        as_target,
        div,
        span,
        txt,
        table,
        tbody,
        td,
        tr,
        p,
        ol,
        ul,
        li,
        h1,
        h2,
        h3,
        h4,
        nav,
        embed_svg,
        svg_at,
        at,
        txt_td,
        class$0,
        classes,
        svg_class,
        svg_classes,
        type,
        d,
        viewbox,
        fill,
        fmt_txt,
        bracketed_input,
        render_vec,
        render_mat,
        input$0,
        input_classes,
        parsed_input,
        bracketed_parsed_input,
        result_list,
        Select_and_info,
        select$0,
        info$0,
        a,
        unsnoc,
        list_variables
    ];
    runtime.caml_register_global(79, Dune_exe_Frontend_util, "Dune__exe__Frontend_util");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Isometric.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst = "", cst_L = " L", cst$0 = ", [", cst_M_f_f_f_L_f_f_f = "M%f %f %f L%f %f %f", cst_className$1 = "className", cst_fill_slate_500$0 = "fill-slate-500", cst_flex_flex_row$4 = "flex flex-row", cst_height$1 = "height", cst_left$2 = "left", cst_planeView$1 = "planeView", cst_right$2 = "right", cst_top$2 = "top", cst_width$1 = "width", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call5(f, a0, a1, a2, a3, a4) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 5 ? f(a0, a1, a2, a3, a4) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4
        ]);
    }
    function caml_call7(f, a0, a1, a2, a3, a4, a5, a6) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 7 ? f(a0, a1, a2, a3, a4, a5, a6) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5,
            a6
        ]);
    }
    var global_data = runtime.caml_get_global_data(), background_color = [
        0,
        "rgba(0, 0, 0, 0)"
    ], partial = [
        17,
        0,
        [
            17,
            4,
            0
        ]
    ], partial$0 = [
        12,
        32,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            0
        ]
    ], partial$1 = [
        0,
        0,
        0
    ], partial$2 = [
        12,
        32,
        [
            8,
            [
                0,
                0,
                0
            ],
            0,
            0,
            0
        ]
    ], partial$3 = [
        0,
        0,
        0
    ], side_name = cst_top$2, fill_class_name = cst_fill_slate_500$0, zero = [
        254,
        0.,
        0.,
        0.
    ], Fmt = global_data.Fmt, Stdlib_List = global_data.Stdlib__List, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Stdlib_String = global_data.Stdlib__String, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Stdlib_Queue = global_data.Stdlib__Queue, Brr = global_data.Brr, Assert_failure = global_data.Assert_failure, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, Stdlib = global_data.Stdlib, Stdlib_Array = global_data.Stdlib__Array, Jv = global_data.Jv, Stdlib_Option = global_data.Stdlib__Option, Stdlib_Set = global_data.Stdlib__Set, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), default_height = 160, default_width = 200;
    function isometric(param) {
        return Jv[12].isometric;
    }
    var classes = Dune_exe_Frontend_util[29];
    function array_max(arr) {
        return caml_call3(Stdlib_Array[18], Stdlib[17], Stdlib[26], arr);
    }
    function get_class_name(edge_attributes, label) {
        var fill_classes = caml_call2(Stdlib_Hashtbl[6], edge_attributes, label)[1];
        return fill_classes;
    }
    var EdgeAnimation = [
        0
    ], top = "TOP", front = "FRONT", side = "SIDE", _a_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_right$2, function(t) {
            return t[5];
        }, Fmt[53]),
        0
    ], _b_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_left$2, function(t) {
            return t[4];
        }, Fmt[53]),
        _a_
    ], _c_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_top$2, function(t) {
            return t[3];
        }, Fmt[53]),
        _b_
    ], _d_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_height$1, function(t) {
            return t[2];
        }, Fmt[53]),
        _c_
    ], _e_ = [
        0,
        caml_call5(Fmt[42], 0, 0, cst_width$1, function(t) {
            return t[1];
        }, Fmt[53]),
        _d_
    ], _f_ = caml_call2(Fmt[43], [
        0,
        Fmt[26]
    ], _e_), pp = caml_call1(Fmt[39], _f_), cst_top = cst_top$2, cst_left = cst_left$2, cst_right = cst_right$2, cst_planeView = cst_planeView$1, cst_className = cst_className$1, cst_width = cst_width$1, cst_height = cst_height$1, _g_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "animate_dimensions: [",
                [
                    18,
                    [
                        1,
                        [
                            0,
                            0,
                            cst
                        ]
                    ],
                    [
                        15,
                        [
                            17,
                            0,
                            [
                                12,
                                93,
                                [
                                    17,
                                    0,
                                    [
                                        17,
                                        4,
                                        0
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[animate_dimensions: [@[%a@]]@]@."
    ], _h_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "Rectangle.create [",
                [
                    15,
                    [
                        12,
                        93,
                        [
                            17,
                            0,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[Rectangle.create [%a]@]@."
    ], _i_ = [
        0,
        [
            12,
            77,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    12,
                    32,
                    [
                        8,
                        [
                            0,
                            0,
                            0
                        ],
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                8,
                                [
                                    0,
                                    0,
                                    0
                                ],
                                0,
                                0,
                                [
                                    11,
                                    cst_L,
                                    [
                                        8,
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                8,
                                                partial$1,
                                                0,
                                                0,
                                                partial$0
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_M_f_f_f_L_f_f_f
    ], _j_ = [
        0,
        [
            12,
            77,
            [
                8,
                [
                    0,
                    0,
                    0
                ],
                0,
                0,
                [
                    12,
                    32,
                    [
                        8,
                        [
                            0,
                            0,
                            0
                        ],
                        0,
                        0,
                        [
                            12,
                            32,
                            [
                                8,
                                [
                                    0,
                                    0,
                                    0
                                ],
                                0,
                                0,
                                [
                                    11,
                                    cst_L,
                                    [
                                        8,
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        0,
                                        0,
                                        [
                                            12,
                                            32,
                                            [
                                                8,
                                                partial$3,
                                                0,
                                                0,
                                                partial$2
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        cst_M_f_f_f_L_f_f_f
    ], cst_path = "path", cst_red = "red", cst_fontSize = "fontSize", cst_fontWeight = "fontWeight", cst_className$0 = cst_className$1, cst_strokeWidth = "strokeWidth", cst_top$0 = cst_top$2, cst_left$0 = cst_left$2, cst_right$0 = cst_right$2, cst_planeView$0 = cst_planeView$1, cst_text = "text", cst_fill_slate_500 = cst_fill_slate_500$0, cst_top$1 = cst_top$2, cst_left$1 = cst_left$2, cst_right$1 = cst_right$2, cst_container = "container", cst_backgroundColor = "backgroundColor", cst_scale = "scale", cst_height$0 = cst_height$1, cst_width$0 = cst_width$1, _k_ = [
        0,
        0.
    ], _l_ = [
        0,
        0.
    ], _m_ = [
        0,
        0.
    ], _n_ = [
        0,
        [
            11,
            "Invalid tensor: [",
            [
                18,
                [
                    1,
                    [
                        0,
                        0,
                        cst
                    ]
                ],
                [
                    15,
                    [
                        17,
                        0,
                        [
                            12,
                            93,
                            [
                                17,
                                4,
                                0
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "Invalid tensor: [@[%a@]]@."
    ], _o_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "Tensor.create rectangle (",
                [
                    2,
                    0,
                    [
                        11,
                        cst$0,
                        [
                            15,
                            [
                                11,
                                "]) (",
                                [
                                    2,
                                    0,
                                    [
                                        11,
                                        cst$0,
                                        [
                                            15,
                                            [
                                                11,
                                                "])",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[Tensor.create rectangle (%s, [%a]) (%s, [%a])@]@."
    ], _p_ = [
        0,
        -1.4
    ], cst_scalar = "(scalar)", cst_mt_4_mb_1_text_xs_font_sem = "mt-4 mb-1 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400", cst_Start = "Start", cst_flex_flex_row = cst_flex_flex_row$4, cst_Diagonalize = "Diagonalize", cst_flex_flex_row$0 = cst_flex_flex_row$4, _q_ = [
        0,
        0,
        0
    ], cst_Reorder_and_Broadcast = "Reorder and Broadcast", cst_flex_flex_row$1 = cst_flex_flex_row$4, cst_Pointwise_Multiply = "Pointwise Multiply", cst_Contract = "Contract ", cst_flex_flex_col = "flex flex-col", cst_Reorder = "Reorder", cst_Broadcast = "Broadcast", _r_ = [
        0,
        "frontend/Isometric.ml",
        665,
        28
    ], cst_flex_flex_row$2 = cst_flex_flex_row$4, cst_flex_flex_row$3 = cst_flex_flex_row$4, _s_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst
                ]
            ],
            [
                11,
                "render: ",
                [
                    15,
                    [
                        17,
                        0,
                        [
                            17,
                            4,
                            0
                        ]
                    ]
                ]
            ]
        ],
        "@[render: %a@]@."
    ], dummy = 0;
    function to_jv(param) {
        var right = param[5], left = param[4], top = param[3], height = param[2], width = param[1];
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            right: right
        };
    }
    function opts(top, left, right, plane_view, class_name, width, height, param) {
        var o = {};
        caml_call3(Jv[21][4], o, cst_top, top);
        caml_call3(Jv[21][4], o, cst_left, left);
        caml_call3(Jv[21][4], o, cst_right, right);
        caml_call3(Jv[23][4], o, cst_planeView, plane_view);
        var _aJ_ = caml_call2(Stdlib_Option[7], Jv[24], class_name);
        caml_call3(Jv[16], o, cst_className, _aJ_);
        caml_call3(Jv[21][3], o, cst_width, width);
        caml_call3(Jv[21][3], o, cst_height, height);
        return o;
    }
    function create(opts, values, param) {
        var _aH_ = caml_call2(Fmt[65], [
            0,
            Fmt[26]
        ], pp);
        caml_call3(Fmt[4], _h_, _aH_, values);
        var face$0 = new (isometric(0)).IsometricRectangle(opts), values$0 = caml_call2(Stdlib_Array[14], function(x) {
            return x[3];
        }, values), _aG_ = caml_call2(Jv[28], function(_aI_) {
            return _aI_;
        }, values$0), anim_opts = {
            property: caml_call1(Jv[24], side_name),
            duration: 2.,
            values: _aG_
        }, face = face$0.addAnimation(anim_opts);
        if (1 === values.length - 1) return face;
        var _aE_ = caml_call1(Stdlib_Array[10], values), _aF_ = caml_call2(Fmt[64], [
            0,
            Fmt[26]
        ], pp);
        caml_call3(Fmt[4], _g_, _aF_, _aE_);
        return face.animateDimensions(caml_call2(Jv[28], to_jv, values), 2.);
    }
    function create$0(opt, path_start, path_end) {
        var stroke_color = opt ? opt[1] : cst_red, opts = {
            strokeColor: caml_call1(Jv[24], stroke_color)
        }, piece = new (isometric(0)).IsometricPath(opts), start = caml_call7(Fmt[6], _i_, path_start[1], path_start[2], path_start[3], path_start[1], path_start[2], path_start[3]), finish = caml_call7(Fmt[6], _j_, path_start[1], path_start[2], path_start[3], path_end[1], path_end[2], path_end[3]), _aD_ = caml_call2(Jv[28], Jv[24], [
            0,
            start,
            finish
        ]), anim_opts = {
            property: caml_call1(Jv[24], cst_path),
            duration: 2.,
            values: _aD_
        };
        piece.addAnimation(anim_opts);
        return piece;
    }
    function opts$0(_aC_, _aB_, opt, top, left, right, plane_view, text) {
        var font_size = _aC_ ? _aC_[1] : 18., class_name = _aB_ ? _aB_[1] : cst_fill_slate_500, stroke_width = opt ? opt[1] : 0., o = {};
        caml_call3(Jv[21][3], o, cst_fontSize, font_size);
        caml_call3(Jv[23][3], o, cst_fontWeight, "500");
        caml_call3(Jv[23][3], o, cst_className$0, caml_jsstring_of_string(class_name));
        caml_call3(Jv[21][3], o, cst_strokeWidth, stroke_width);
        caml_call3(Jv[21][4], o, cst_top$0, top);
        caml_call3(Jv[21][4], o, cst_left$0, left);
        caml_call3(Jv[21][4], o, cst_right$0, right);
        caml_call3(Jv[23][4], o, cst_planeView$0, plane_view);
        caml_call3(Jv[23][3], o, cst_text, caml_jsstring_of_string(text));
        return o;
    }
    function create$1(opt, param) {
        var opts = opt ? opt[1] : Jv[5];
        return new (isometric(0)).IsometricText(opts);
    }
    function create$2(_aA_, _az_, opt, children) {
        var top = _aA_ ? _aA_[1] : 0., left = _az_ ? _az_[1] : 0., right = opt ? opt[1] : 0., opts = {};
        caml_call3(Jv[21][3], opts, cst_top$1, top);
        caml_call3(Jv[21][3], opts, cst_left$1, left);
        caml_call3(Jv[21][3], opts, cst_right$1, right);
        var group = new (isometric(0)).IsometricGroup(opts);
        runtime.caml_js_meth_call(group, "addChildren", caml_call1(Stdlib_Array[11], children));
        return group;
    }
    function add_child(o, child) {
        o.addChild(child);
    }
    function create$3(draw_diag, edge_attributes) {
        return function(invalid) {
            if (!invalid) return create$1([
                0,
                opts$0(0, 0, 0, 0, 0, 0, 0, cst_scalar)
            ], 0);
            var _ab_ = invalid[2], _ac_ = invalid[1], height$0 = _ac_[2], dim1 = _ac_[1];
            if (!_ab_) {
                var _aw_ = [
                    0,
                    array_max(height$0) * 0.5
                ], _ax_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim1)
                        ], 0, 0, _aw_, _p_, 0, dim1)
                    ], 0),
                    0
                ], _ay_ = caml_call2(Stdlib_Array[14], function(height) {
                    return [
                        254,
                        0.,
                        height,
                        0.,
                        0.,
                        0.
                    ];
                }, height$0), children$0 = [
                    0,
                    create(opts(0, 0, 0, [
                        0,
                        top
                    ], [
                        0,
                        fill_class_name
                    ], 0., array_max(height$0), 0), _ay_, 0),
                    _ax_
                ];
                return create$2(0, 0, 0, children$0);
            }
            var _ad_ = _ab_[2], _ae_ = _ab_[1], width$0 = _ae_[2], dim2 = _ae_[1];
            if (!_ad_) {
                var _al_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]), _am_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]);
                caml_call7(Fmt[4], _o_, dim1, _am_, height$0, dim2, _al_, width$0);
                var _an_ = [
                    0,
                    array_max(width$0) * 0.5
                ], _ao_ = [
                    0,
                    array_max(height$0) * -0.5
                ], _ap_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim2)
                        ], 0, 0, _ao_, _an_, 0, dim2)
                    ], 0),
                    0
                ], _aq_ = [
                    0,
                    array_max(width$0) * -0.5
                ], _ar_ = [
                    0,
                    array_max(height$0) * 0.5
                ], _as_ = [
                    0,
                    create$1([
                        0,
                        opts$0(0, [
                            0,
                            get_class_name(edge_attributes, dim1)
                        ], 0, 0, _ar_, _aq_, 0, dim1)
                    ], 0),
                    _ap_
                ], _at_ = caml_call3(Stdlib_Array[22], function(height, width) {
                    return [
                        254,
                        width,
                        height,
                        0.,
                        0.,
                        0.
                    ];
                }, height$0, width$0), _au_ = array_max(height$0), children = [
                    0,
                    create(opts(0, 0, 0, [
                        0,
                        top
                    ], [
                        0,
                        fill_class_name
                    ], array_max(width$0), _au_, 0), _at_, 0),
                    _as_
                ];
                a: {
                    if (draw_diag && dim1 === dim2) {
                        var _av_ = array_max(width$0), paths$0 = [
                            0,
                            create$0(0, zero, [
                                254,
                                array_max(height$0),
                                _av_,
                                0.
                            ]),
                            0
                        ];
                        break a;
                    }
                    var paths$0 = 0;
                }
                return create$2(0, 0, 0, caml_call2(Stdlib[37], children, paths$0));
            }
            if (_ad_[2]) {
                var _af_ = caml_call2(Fmt[65], [
                    0,
                    Fmt[26]
                ], Fmt[53]), _ag_ = caml_call1(Fmt[38], _af_), _ah_ = caml_call3(Fmt[61], [
                    0,
                    Fmt[25]
                ], Fmt[57], _ag_), _ai_ = caml_call1(Fmt[37], _ah_), _aj_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[26]
                ], _ai_), _ak_ = caml_call3(Fmt[6], _n_, _aj_, invalid);
                return caml_call1(Stdlib[2], _ak_);
            }
            var depth$0 = _ad_[1], depth = depth$0[2], depth_label = depth$0[1], width = _ae_[2], width_label = _ae_[1], height = _ac_[2], height_label = _ac_[1], max_height = array_max(height), max_width = array_max(width), max_depth = array_max(depth), _V_ = caml_call3(Stdlib_Array[22], function(height, d_as_w) {
                return [
                    254,
                    d_as_w,
                    height,
                    0.,
                    0.,
                    0.
                ];
            }, height, depth), _W_ = [
                0,
                create(opts(0, [
                    0,
                    max_width
                ], 0, [
                    0,
                    side
                ], [
                    0,
                    fill_class_name
                ], max_depth, max_height, 0), _V_, 0),
                0
            ], _X_ = caml_call3(Stdlib_Array[22], function(height, width) {
                return [
                    254,
                    width,
                    height,
                    0.,
                    0.,
                    0.
                ];
            }, height, width), _Y_ = [
                0,
                create(opts(0, 0, [
                    0,
                    max_depth
                ], [
                    0,
                    front
                ], [
                    0,
                    fill_class_name
                ], max_width, max_height, 0), _X_, 0),
                _W_
            ], _Z_ = caml_call3(Stdlib_Array[22], function(w_as_h, d_as_w) {
                return [
                    254,
                    d_as_w,
                    w_as_h,
                    0.,
                    0.,
                    0.
                ];
            }, width, depth), faces = [
                0,
                create(opts([
                    0,
                    max_height
                ], 0, 0, [
                    0,
                    top
                ], [
                    0,
                    fill_class_name
                ], max_depth, max_width, 0), _Z_, 0),
                _Y_
            ], ___ = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, width_label)
                    ], 0, [
                        0,
                        max_height * 0.5
                    ], [
                        0,
                        max_width * 1.2
                    ], _k_, 0, width_label)
                ], 0),
                0
            ], _$_ = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, depth_label)
                    ], 0, [
                        0,
                        max_height * 1.25
                    ], _l_, [
                        0,
                        max_depth * 0.5
                    ], 0, depth_label)
                ], 0),
                ___
            ], labels = [
                0,
                create$1([
                    0,
                    opts$0(0, [
                        0,
                        get_class_name(edge_attributes, height_label)
                    ], 0, [
                        0,
                        max_height * 1.25
                    ], [
                        0,
                        max_width * 0.65
                    ], _m_, 0, height_label)
                ], 0),
                _$_
            ];
            a: if (draw_diag) {
                if (height_label === width_label && width_label === depth_label) {
                    var paths = [
                        0,
                        create$0(0, [
                            254,
                            0.,
                            max_width,
                            max_height
                        ], [
                            254,
                            max_depth,
                            0.,
                            0.
                        ]),
                        0
                    ];
                    break a;
                }
                var paths = height_label === width_label ? [
                    0,
                    create$0(0, [
                        254,
                        0.,
                        max_width,
                        max_height
                    ], [
                        254,
                        max_depth,
                        0.,
                        max_height
                    ]),
                    0
                ] : height_label === depth_label ? [
                    0,
                    create$0(0, [
                        254,
                        max_depth,
                        max_width,
                        0.
                    ], [
                        254,
                        max_depth,
                        0.,
                        max_height
                    ]),
                    0
                ] : width_label === depth_label ? [
                    0,
                    create$0(0, [
                        254,
                        0.,
                        max_width,
                        0.
                    ], [
                        254,
                        max_depth,
                        max_width,
                        max_height
                    ]),
                    0
                ] : 0;
            } else var paths = 0;
            var _aa_ = caml_call2(Stdlib[37], labels, paths);
            return create$2(0, 0, 0, caml_call2(Stdlib[37], faces, _aa_));
        };
    }
    function render_unsafe(_x_, _w_, opt, edge_attributes, lhs, rhs) {
        var scale = _x_ ? _x_[1] : 10., height = _w_ ? _w_[1] : default_height, width = opt ? opt[1] : default_width;
        function get_length(label) {
            return caml_call2(Stdlib_Hashtbl[6], edge_attributes, label)[4];
        }
        function get_classes(edge_name) {
            return get_class_name(edge_attributes, edge_name);
        }
        var rows = caml_call1(Stdlib_Queue[2], 0), txt = Brr[9][3], span = Brr[9][147], div = Brr[9][88];
        function step_label(children) {
            return caml_call3(div, 0, [
                0,
                caml_call1(classes, cst_mt_4_mb_1_text_xs_font_sem)
            ], children);
        }
        var match = caml_call1(Tensor_playground_Einops[14][1], [
            0,
            lhs,
            rhs
        ]), broadcast = match[2], diagonalized = match[1];
        function mk_canvas(param) {
            var container = caml_call3(div, 0, 0, 0), width$0 = [
                0,
                width
            ], height$0 = [
                0,
                height
            ], scale$0 = [
                0,
                scale
            ], container$0 = [
                0,
                container
            ], opts = {}, _S_ = caml_call2(Stdlib_Option[7], function(_U_) {
                return _U_;
            }, container$0);
            caml_call3(Jv[16], opts, cst_container, _S_);
            var _T_1 = caml_call2(Stdlib_Option[7], Jv[24], background_color);
            caml_call3(Jv[16], opts, cst_backgroundColor, _T_1);
            caml_call3(Jv[21][4], opts, cst_scale, scale$0);
            caml_call3(Jv[20][4], opts, cst_height$0, height$0);
            caml_call3(Jv[20][4], opts, cst_width$0, width$0);
            var canvas = new (isometric(0)).IsometricCanvas(opts);
            return [
                0,
                canvas,
                container
            ];
        }
        var _y_ = step_label([
            0,
            caml_call2(txt, 0, cst_Start),
            0
        ]);
        caml_call2(Stdlib_Queue[3], _y_, rows);
        var row = caml_call2(Stdlib_List[20], function(tensor) {
            var match = mk_canvas(0), container = match[2], canvas = match[1], _Q_ = caml_call2(Stdlib_List[20], function(label) {
                var _R_ = get_length(label);
                return [
                    0,
                    label,
                    [
                        254,
                        get_length(label),
                        _R_
                    ]
                ];
            }, tensor), tensor$0 = create$3(0, edge_attributes)(_Q_);
            add_child(canvas, tensor$0);
            return container;
        }, lhs), _z_ = caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_row)
        ], row);
        caml_call2(Stdlib_Queue[3], _z_, rows);
        var diagonals_exist = caml_call3(Stdlib_List[36], function(tensor, diagonalized) {
            return 1 - caml_call3(Stdlib_List[16], Stdlib_String[9], tensor, diagonalized);
        }, lhs, diagonalized);
        if (diagonals_exist) {
            var _A_ = step_label([
                0,
                caml_call2(txt, 0, cst_Diagonalize),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _A_, rows);
            var row$0 = caml_call2(Stdlib_List[20], function(tensor) {
                var match = mk_canvas(0), container = match[2], canvas = match[1], _O_ = caml_call2(Stdlib_List[20], function(label) {
                    var _P_ = get_length(label);
                    return [
                        0,
                        label,
                        [
                            254,
                            get_length(label),
                            _P_
                        ]
                    ];
                }, tensor), tensor$0 = create$3(1, edge_attributes)(_O_);
                add_child(canvas, tensor$0);
                return container;
            }, lhs), elem = caml_call3(div, 0, [
                0,
                caml_call1(classes, cst_flex_flex_row$0)
            ], row$0);
        } else var elem = caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_row$3)
        ], 0);
        caml_call2(Stdlib_Queue[3], elem, rows);
        var match$0 = caml_call3(Stdlib_List[27], function(tensor, param) {
            var acc = param[2], reorder_necessary = param[1], reordered_tensor = caml_call2(Stdlib_List[63], function(a, b) {
                var match = caml_call2(Tensor_playground_Einops[10], b, rhs), _N_ = caml_call2(Tensor_playground_Einops[10], a, rhs);
                if (!_N_) return match ? 1 : 0;
                var i = _N_[1];
                if (!match) return -1;
                var j = match[1];
                return runtime.caml_int_compare(i, j);
            }, tensor);
            return runtime.caml_equal(reordered_tensor, tensor) ? [
                0,
                reorder_necessary,
                [
                    0,
                    reordered_tensor,
                    acc
                ]
            ] : [
                0,
                1,
                [
                    0,
                    reordered_tensor,
                    acc
                ]
            ];
        }, diagonalized, _q_), reordered = match$0[2], reorder_necessary = match$0[1], _B_ = caml_call2(Stdlib_List[16], Stdlib_String[9], broadcast), tensors_match_shape = caml_call2(Stdlib_List[33], _B_, reordered), broadcast_necessary = 1 - tensors_match_shape;
        a: {
            if (!reorder_necessary && !broadcast_necessary) {
                var elem$0 = caml_call3(div, 0, [
                    0,
                    caml_call1(classes, cst_flex_flex_row$2)
                ], 0);
                break a;
            }
            if (reorder_necessary) var msg = broadcast_necessary ? cst_Reorder_and_Broadcast : cst_Reorder;
            else {
                if (!broadcast_necessary) throw caml_maybe_attach_backtrace([
                    0,
                    Assert_failure,
                    _r_
                ], 1);
                var msg = cst_Broadcast;
            }
            var _C_ = step_label([
                0,
                caml_call2(txt, 0, msg),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _C_, rows);
            var row$1 = caml_call2(Stdlib_List[20], function(diag_tensor) {
                var match = mk_canvas(0), container = match[2], canvas = match[1], animate_edges = caml_call2(Stdlib_List[44], function(x) {
                    return 1 - caml_call2(Stdlib_List[37], x, diag_tensor);
                }, broadcast), axis_spec = caml_call2(Stdlib_List[20], function(label) {
                    var base_length = get_length(label), lengths = caml_call2(Stdlib_List[37], label, animate_edges) ? [
                        254,
                        0.,
                        base_length
                    ] : [
                        254,
                        base_length,
                        base_length
                    ];
                    return [
                        0,
                        label,
                        lengths
                    ];
                }, broadcast), tensor = create$3(0, edge_attributes)(axis_spec);
                add_child(canvas, tensor);
                return container;
            }, reordered), elem$0 = caml_call3(div, 0, [
                0,
                caml_call1(classes, cst_flex_flex_row$1)
            ], row$1);
        }
        caml_call2(Stdlib_Queue[3], elem$0, rows);
        a: {
            if (reordered && !reordered[2]) {
                var elem$1 = caml_call3(div, 0, 0, 0);
                break a;
            }
            var _D_ = step_label([
                0,
                caml_call2(txt, 0, cst_Pointwise_Multiply),
                0
            ]);
            caml_call2(Stdlib_Queue[3], _D_, rows);
            var match$1 = mk_canvas(0), container = match$1[2], canvas = match$1[1], _E_ = caml_call2(Stdlib_List[20], function(label) {
                var _M_ = get_length(label);
                return [
                    0,
                    label,
                    [
                        254,
                        get_length(label),
                        _M_
                    ]
                ];
            }, broadcast), tensor = create$3(0, edge_attributes)(_E_);
            add_child(canvas, tensor);
            var elem$1 = caml_call3(div, 0, 0, [
                0,
                container,
                0
            ]);
        }
        caml_call2(Stdlib_Queue[3], elem$1, rows);
        var need_contraction = 1 - caml_call3(Stdlib_List[16], Stdlib_String[9], broadcast, rhs);
        if (need_contraction) {
            var _F_ = caml_call1(String_set[38], rhs), _G_ = caml_call1(String_set[38], broadcast), _H_ = caml_call2(String_set[8], _G_, _F_), axes_to_contract = caml_call1(String_set[37], _H_), _I_ = [
                0,
                caml_call3(span, 0, 0, caml_call2(Dune_exe_Frontend_util[50], get_classes, axes_to_contract)),
                0
            ], _J_ = step_label([
                0,
                caml_call2(txt, 0, cst_Contract),
                _I_
            ]);
            caml_call2(Stdlib_Queue[3], _J_, rows);
            var match$2 = mk_canvas(0), container$0 = match$2[2], canvas$0 = match$2[1], axis_spec = caml_call2(Stdlib_List[20], function(label) {
                var base_length = get_length(label), lengths = caml_call2(Stdlib_List[37], label, axes_to_contract) ? [
                    254,
                    base_length,
                    0.
                ] : [
                    254,
                    base_length,
                    base_length
                ];
                return [
                    0,
                    label,
                    lengths
                ];
            }, broadcast), tensor$0 = create$3(0, edge_attributes)(axis_spec);
            add_child(canvas$0, tensor$0);
            var elem$2 = caml_call3(div, 0, 0, [
                0,
                container$0,
                0
            ]);
        } else var elem$2 = caml_call3(div, 0, 0, 0);
        caml_call2(Stdlib_Queue[3], elem$2, rows);
        var _K_ = caml_call1(Stdlib_Queue[19], rows), _L_ = caml_call1(Stdlib_List[69], _K_);
        return caml_call3(div, 0, [
            0,
            caml_call1(classes, cst_flex_flex_col)
        ], _L_);
    }
    function render(_u_, _t_, opt, edge_attributes, lhs, rhs) {
        var scale = _u_ ? _u_[1] : 10., height = _t_ ? _t_[1] : default_height, width = opt ? opt[1] : default_width;
        try {
            var _v_ = [
                0,
                render_unsafe([
                    0,
                    scale
                ], [
                    0,
                    height
                ], [
                    0,
                    width
                ], edge_attributes, lhs, rhs)
            ];
            return _v_;
        } catch (e$0) {
            var e = caml_wrap_exception(e$0);
            caml_call4(Fmt[3], Fmt[2], _s_, Fmt[59], e);
            return 0;
        }
    }
    var Scene = [
        0,
        render
    ], Dune_exe_Isometric = [
        0,
        EdgeAnimation,
        Scene
    ];
    runtime.caml_register_global(153, Dune_exe_Isometric, "Dune__exe__Isometric");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_diagram.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$4 = "", cst_group = "group-", cst_group_s = "group-%s", cst_tensor$0 = "tensor-", cst_tensor_d = "tensor-%d", caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$3 = cst$4, label = cst$4, cst$2 = cst$4, partial = [
        17,
        0,
        [
            17,
            4,
            0
        ]
    ], cst$0 = cst$4, cst$1 = cst$4, cst = cst$4, Stdlib_List = global_data.Stdlib__List, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Fmt = global_data.Fmt, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_String = global_data.Stdlib__String, Stdlib_Option = global_data.Stdlib__Option, Stdlib = global_data.Stdlib, Stdlib_Char = global_data.Stdlib__Char, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Stdlib_Array = global_data.Stdlib__Array, Brr = global_data.Brr, Jv = global_data.Jv, Stdlib_Set = global_data.Stdlib__Set, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, String_set = caml_call1(Stdlib_Set[1], [
        0,
        Stdlib_String[10]
    ]), classes = Dune_exe_Frontend_util[29], cst_tensor = "tensor", cst_edge = "edge", _a_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _b_ = [
        0,
        [
            11,
            cst_group,
            [
                2,
                0,
                0
            ]
        ],
        cst_group_s
    ], _c_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _d_ = [
        0,
        [
            18,
            [
                1,
                [
                    0,
                    0,
                    cst$4
                ]
            ],
            [
                11,
                "find_partner ",
                [
                    4,
                    0,
                    0,
                    0,
                    [
                        12,
                        32,
                        [
                            2,
                            0,
                            [
                                11,
                                " lhs=([",
                                [
                                    18,
                                    [
                                        1,
                                        [
                                            0,
                                            0,
                                            cst$4
                                        ]
                                    ],
                                    [
                                        15,
                                        [
                                            17,
                                            0,
                                            [
                                                11,
                                                "]) -> Not_found",
                                                partial
                                            ]
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ],
        "@[find_partner %d %s lhs=([@[%a@]]) -> Not_found@]@."
    ], _e_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _f_ = [
        0,
        [
            15,
            0
        ],
        "%a"
    ], _g_ = [
        0,
        [
            11,
            cst_tensor$0,
            [
                4,
                0,
                0,
                0,
                0
            ]
        ],
        cst_tensor_d
    ], _h_ = [
        0,
        [
            11,
            cst_group,
            [
                2,
                0,
                0
            ]
        ],
        cst_group_s
    ], cst_mx_auto = "mx-auto";
    function to_jv(param) {
        var class_name = param[4], node_type = param[3], label = param[2], id = param[1], _J_ = node_type ? cst_tensor : cst_edge, _K_ = caml_call1(Jv[24], _J_), _L_ = caml_call1(Jv[24], class_name), _M_ = caml_call1(Jv[24], label);
        return {
            id: caml_call1(Jv[24], id),
            label: _M_,
            class_name: _L_,
            type: _K_
        };
    }
    function to_jv$0(param) {
        var target = param[4], source = param[3], label = param[2], class_name = param[1], _G_ = caml_call1(Jv[24], target), _H_ = caml_call1(Jv[24], source), _I_ = caml_call1(Jv[24], label);
        return {
            class_name: caml_call1(Jv[24], class_name),
            label: _I_,
            source: _H_,
            target: _G_
        };
    }
    function nested_list_count(target, param) {
        if (!param) return 0;
        var lsts = param[2], lst = param[1], _E_ = nested_list_count(target, lsts), _F_ = caml_call2(Stdlib_List[37], target, lst) ? 1 : 0;
        return _F_ + _E_ | 0;
    }
    function draw_einsum(edge_attributes, lhs, rhs) {
        function get_color(name) {
            return caml_call2(Stdlib_Hashtbl[6], edge_attributes, name);
        }
        var match = caml_call1(Tensor_playground_Einops[8][1], [
            0,
            lhs,
            rhs
        ]), summation = match[2], free = match[1], _i_ = caml_call1(String_set[37], summation), match$0 = caml_call3(Stdlib_List[26], function(param, edge) {
            var groups = param[3], pairs = param[2], selves = param[1], count = nested_list_count(edge, lhs);
            return 1 === count ? [
                0,
                caml_call2(String_set[2], edge, selves),
                pairs,
                groups
            ] : 2 === count ? [
                0,
                selves,
                caml_call2(String_set[2], edge, pairs),
                groups
            ] : [
                0,
                selves,
                pairs,
                caml_call2(String_set[2], edge, groups)
            ];
        }, [
            0,
            String_set[1],
            String_set[1],
            String_set[1]
        ], _i_), contracted_in_group = match$0[3], contracted_in_pair = match$0[2], self_contracted = match$0[1], _j_ = caml_call1(caml_call1(Stdlib_List[21], function(i, x) {
            var id = caml_call2(Fmt[6], _a_, i), _D_ = caml_call1(Stdlib_Char[1], i + 65 | 0), label = caml_call2(Stdlib_String[1], 1, _D_);
            return [
                0,
                id,
                label,
                1,
                cst
            ];
        }), lhs), tensor_nodes = caml_call1(Stdlib_Array[11], _j_), _k_ = caml_call1(caml_call1(Stdlib_List[20], function(x) {
            var fill_classes = get_color(x)[1];
            return [
                0,
                x,
                x,
                0,
                fill_classes
            ];
        }), rhs), uncontracted_nodes = caml_call1(Stdlib_Array[11], _k_), _l_ = caml_call1(String_set[37], contracted_in_group), _m_ = caml_call1(caml_call1(Stdlib_List[20], function(x) {
            var id = caml_call2(Fmt[6], _b_, x);
            return [
                0,
                id,
                cst$1,
                0,
                cst$0
            ];
        }), _l_), contraction_group_nodes = caml_call1(Stdlib_Array[11], _m_), nodes = caml_call1(Stdlib_Array[5], [
            0,
            tensor_nodes,
            [
                0,
                uncontracted_nodes,
                [
                    0,
                    contraction_group_nodes,
                    0
                ]
            ]
        ]), edges = caml_call1(Stdlib_Queue[2], 0), pair_edges_seen = caml_call2(Stdlib_Hashtbl[1], 0, 10);
        caml_call2(Stdlib_List[19], function(source_n, edge_names) {
            var _r_ = caml_call2(Stdlib_List[44], function(x) {
                return caml_call2(String_set[31], x, self_contracted);
            }, edge_names), _s_ = caml_call1(String_set[38], _r_), self_contracted$0 = caml_call1(String_set[37], _s_);
            if (self_contracted$0) {
                a: {
                    if (self_contracted$0 && !self_contracted$0[2]) {
                        var x = self_contracted$0[1], fill_classes = get_color(x)[1], class_name = fill_classes;
                        break a;
                    }
                    var class_name = cst$2;
                }
                var node_id = caml_call2(Fmt[6], _e_, source_n), _t_ = caml_call2(Fmt[64], [
                    0,
                    Fmt[25]
                ], Fmt[57]), edge = [
                    0,
                    class_name,
                    caml_call3(Fmt[6], _f_, _t_, self_contracted$0),
                    node_id,
                    node_id
                ];
                caml_call2(Stdlib_Queue[3], edge, edges);
            }
            var _u_ = caml_call2(Stdlib_List[66], Stdlib_String[10], edge_names);
            return caml_call2(Stdlib_List[18], function(edge_name) {
                var contracted_in_pair$0 = caml_call2(String_set[31], edge_name, contracted_in_pair);
                a: {
                    if (contracted_in_pair$0 && caml_call2(Stdlib_Hashtbl[9], pair_edges_seen, edge_name)) break a;
                    if (!caml_call2(String_set[31], edge_name, self_contracted)) {
                        if (caml_call2(String_set[31], edge_name, free)) var label$0 = cst$3, target = edge_name;
                        else if (contracted_in_pair$0) {
                            var _v_ = caml_call2(Stdlib_List[21], function(i, x) {
                                return [
                                    0,
                                    i,
                                    x
                                ];
                            }, lhs), found_ix = caml_call3(Stdlib_List[26], function(acc, param) {
                                var edge_names = param[2], j = param[1];
                                if (source_n !== j && !caml_call1(Stdlib_Option[11], acc)) return caml_call2(Stdlib_List[37], edge_name, edge_names) ? [
                                    0,
                                    caml_call2(Fmt[6], _c_, j)
                                ] : acc;
                                return acc;
                            }, 0, _v_);
                            if (!found_ix) {
                                var _w_ = caml_call2(Stdlib_List[21], function(i, x) {
                                    return [
                                        0,
                                        i,
                                        x
                                    ];
                                }, lhs), _x_ = caml_call2(Fmt[64], [
                                    0,
                                    Fmt[23]
                                ], Fmt[57]), _y_ = caml_call1(Fmt[38], _x_), _z_ = caml_call3(Fmt[61], [
                                    0,
                                    Fmt[25]
                                ], Fmt[45], _y_), _A_ = caml_call1(Fmt[37], _z_), _B_ = caml_call2(Fmt[64], [
                                    0,
                                    Fmt[26]
                                ], _A_);
                                caml_call6(Fmt[3], Fmt[2], _d_, source_n, edge_name, _B_, _w_);
                                throw caml_maybe_attach_backtrace(Stdlib[8], 1);
                            }
                            var j = found_ix[1], label$0 = edge_name, target = j;
                        } else var target$0 = caml_call2(Fmt[6], _h_, edge_name), label$0 = label, target = target$0;
                        if (contracted_in_pair$0) caml_call3(Stdlib_Hashtbl[5], pair_edges_seen, edge_name, 0);
                        var _C_ = caml_call2(Fmt[6], _g_, source_n), fill_classes = get_color(edge_name)[1], edge = [
                            0,
                            fill_classes,
                            label$0,
                            _C_,
                            target
                        ];
                        return caml_call2(Stdlib_Queue[3], edge, edges);
                    }
                }
                return 0;
            }, _u_);
        }, lhs);
        var _n_ = caml_call1(Stdlib_Queue[19], edges), edges$0 = caml_call1(Stdlib_Array[41], _n_), _o_ = [
            0,
            caml_call1(classes, cst_mx_auto)
        ], el = caml_call3(Brr[9][88], 0, _o_, 0), _p_ = caml_call2(Jv[28], to_jv$0, edges$0), _q_ = caml_call2(Jv[28], to_jv, nodes);
        Jv[12].renderTensorDiagram(el, _q_, _p_);
        return el;
    }
    var Dune_exe_Tensor_diagram = [
        0,
        draw_einsum
    ];
    runtime.caml_register_global(40, Dune_exe_Tensor_diagram, "Dune__exe__Tensor_diagram");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Einsum_explanation.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime, cst$11 = "", cst_and$2 = " and ", cst_for_more$1 = " for more.", cst_a$0 = "%a@?", cst$12 = ")", cst$13 = ").", cst_RangeFormatter_unknown_sta = "RangeFormatter unknown stag\n", cst_blank = "_blank", cst_a_b$2 = "a b", cst_a_b_b_c_a_c$2 = "a b, b c -> a c", cst_evenodd = "evenodd", cst_https_rockt_ai_2018_04_30_$1 = "https://rockt.ai/2018/04/30/einsum", cst_i$5 = "i", cst_i_j_i$1 = "i j -> i", cst_i_j_j$2 = "i j -> j", cst_i_j_i_j_i_j$1 = "i j, i j -> i j", cst_j$3 = "j", cst_numpy_einsum$2 = "numpy.einsum", cst_round = "round", cst_size_5_inline_fill_slate_9 = "size-5 inline fill-slate-900 dark:fill-white", cst_target = "target", caml_jsstring_of_string = runtime.caml_jsstring_of_string, caml_maybe_attach_backtrace = runtime.caml_maybe_attach_backtrace, caml_wrap_exception = runtime.caml_wrap_exception;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    function caml_call3(f, a0, a1, a2) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 3 ? f(a0, a1, a2) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2
        ]);
    }
    function caml_call4(f, a0, a1, a2, a3) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 4 ? f(a0, a1, a2, a3) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3
        ]);
    }
    function caml_call6(f, a0, a1, a2, a3, a4, a5) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 6 ? f(a0, a1, a2, a3, a4, a5) : runtime.caml_call_gen(f, [
            a0,
            a1,
            a2,
            a3,
            a4,
            a5
        ]);
    }
    var global_data = runtime.caml_get_global_data(), cst$4 = cst$11, cst$3 = cst$12, cst$5 = cst$12, cst$6 = cst$12, cst$7 = " ", cst$8 = cst$13, cst$9 = ".", cst$10 = cst$13, cst$1 = cst$11, cst$2 = cst$11, cst = cst$11, cst$0 = cst$11, Dune_exe_Frontend_util = global_data.Dune__exe__Frontend_util, Brr = global_data.Brr, Stdlib_Hashtbl = global_data.Stdlib__Hashtbl, Dune_exe_Colors = global_data.Dune__exe__Colors, Tensor_playground_Einops = global_data.Tensor_playground__Einops, Fmt = global_data.Fmt, Dune_exe_Tensor_diagram = global_data.Dune__exe__Tensor_diagram, Dune_exe_Isometric = global_data.Dune__exe__Isometric, Stdlib = global_data.Stdlib, Tensor_playground_Einsum_parse = global_data.Tensor_playground__Einsum_parser, Note = global_data.Note, Note_brr = global_data.Note_brr, Stdlib_Queue = global_data.Stdlib__Queue, Stdlib_Stack = global_data.Stdlib__Stack, Stdio = global_data.Stdio, Stdlib_List = global_data.Stdlib__List, Stdlib_String = global_data.Stdlib__String, Stdlib_Printf = global_data.Stdlib__Printf, Stdlib_Format = global_data.Stdlib__Format, Brr_svg = global_data.Brr_svg;
    function code(text) {
        var _fw_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, text),
            0
        ];
        return caml_call3(Dune_exe_Frontend_util[3], 0, 0, _fw_);
    }
    var text_button_classes = caml_call1(Dune_exe_Frontend_util[29], "not-prose font-mono text-[0.875em] text-indigo-700 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-400/10 px-1.5 py-0.5 rounded-md ring-1 ring-inset ring-indigo-200 dark:ring-indigo-400/30 hover:bg-indigo-100 dark:hover:bg-indigo-400/20 hover:ring-indigo-300 dark:hover:ring-indigo-400/50 transition-colors"), section_heading_classes = caml_call1(Dune_exe_Frontend_util[29], "text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-100 mt-8 mb-3"), _a_ = [
        0,
        [
            11,
            "add_spaces negative value (!): ",
            [
                4,
                0,
                0,
                0,
                [
                    12,
                    10,
                    0
                ]
            ]
        ],
        "add_spaces negative value (!): %d\n"
    ], _b_ = [
        0,
        [
            11,
            cst_RangeFormatter_unknown_sta,
            0
        ],
        cst_RangeFormatter_unknown_sta
    ];
    function trim_before_colon(s) {
        try {
            var colon_index = caml_call2(Stdlib_String[36], s, 58), _fu_ = caml_call3(Stdlib_String[16], s, colon_index + 1 | 0, (runtime.caml_ml_string_length(s) - colon_index | 0) - 1 | 0);
            return _fu_;
        } catch (_fv_) {
            var _ft_ = caml_wrap_exception(_fv_);
            if (_ft_ === Stdlib[8]) return s;
            throw caml_maybe_attach_backtrace(_ft_, 0);
        }
    }
    function make_formatter(param) {
        var match = caml_call1(Note[3][3], 0), trigger_add_elem = match[2], add_elem_e = match[1], do_add_elem = caml_call1(caml_call1(Note[3][9], function(elem, elems) {
            return caml_call2(Stdlib[37], elems, [
                0,
                elem,
                0
            ]);
        }), add_elem_e), top_level_elems = caml_call3(Note[4][19], 0, 0, do_add_elem), stack = caml_call1(Stdlib_Stack[2], 0);
        function add_at_current_level(elem) {
            try {
                var val = caml_call1(Stdlib_Stack[7], stack);
            } catch (_fs_) {
                var _fr_ = caml_wrap_exception(_fs_);
                if (_fr_ === Stdlib_Stack[1]) return caml_call2(trigger_add_elem, 0, elem);
                throw caml_maybe_attach_backtrace(_fr_, 0);
            }
            var q = val[2];
            return caml_call2(Stdlib_Queue[3], elem, q);
        }
        function add_text(str) {
            var _fq_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, str),
                0
            ];
            return add_at_current_level(caml_call3(Dune_exe_Frontend_util[9], 0, 0, _fq_));
        }
        function add_spaces(n) {
            return 0 < n ? add_text(caml_call2(Stdlib_String[1], n, 32)) : 0 <= n ? 0 : caml_call2(Stdlib_Printf[2], _a_, n);
        }
        var out_fns = [
            0,
            function(str, start, char_count) {
                return add_text(str);
            },
            function(x) {
                return x;
            },
            function(param) {
                return add_at_current_level(caml_call3(Brr[9][74], 0, 0, 0));
            },
            add_spaces,
            add_spaces
        ], stag_fns = [
            0,
            function(param) {
                if (param[1] === Tensor_playground_Einops[3]) {
                    var color = param[2], _fp_ = [
                        0,
                        color,
                        caml_call1(Stdlib_Queue[2], 0)
                    ];
                    caml_call2(Stdlib_Stack[3], _fp_, stack);
                    return cst$1;
                }
                caml_call1(Stdio[4], _b_);
                return cst$2;
            },
            function(param) {
                try {
                    var val = caml_call1(Stdlib_Stack[4], stack);
                } catch (_fo_) {
                    var _fk_ = caml_wrap_exception(_fo_);
                    if (_fk_ === Stdlib_Stack[1]) return cst;
                    throw caml_maybe_attach_backtrace(_fk_, 0);
                }
                var q = val[2], class_name = val[1], _fl_ = caml_call1(Stdlib_Queue[19], q), _fm_ = caml_call1(Stdlib_List[69], _fl_), _fn_ = [
                    0,
                    caml_call1(Dune_exe_Frontend_util[29], class_name)
                ];
                add_at_current_level(caml_call1(caml_call2(Dune_exe_Frontend_util[9], 0, _fn_), _fm_));
                return cst$0;
            },
            function(param) {
                return 0;
            },
            function(param) {
                return 0;
            }
        ], fmt = caml_call1(Stdlib_Format[128], out_fns);
        caml_call2(Stdlib_Format[90], fmt, 1);
        caml_call2(Stdlib_Format[110], fmt, stag_fns);
        var cons = Brr[9][79], result = caml_call3(cons, 0, 0, 0);
        caml_call2(Note_brr[4][2], result, top_level_elems);
        return [
            0,
            result,
            fmt
        ];
    }
    var Make_formatter = [
        0,
        make_formatter
    ], cst_for_more = cst_for_more$1, cst_tensors_net = "tensors.net", cst_https_www_tensors_net_intr = "https://www.tensors.net/intro", cst_or = " or ", cst_tensornetwork_org = "tensornetwork.org", cst_https_tensornetwork_org_di = "https://tensornetwork.org/diagrams/", cst_See = "See ", cst_Each_node_in_a_tensor_diag = "Each node in a tensor diagram represents a tensor (e.g. a matrix or vector). Each line emanating from a tensor represents one of that tensor's dimensions. When two tensors are connected by a single line that represents a contraction (summation over the connected indices). Look through the examples to see how common operations correspond to tensor diagrams.", cst_Interpreting_a_Tensor_Diag = "Interpreting a Tensor Diagram", cst_text_base_font_semibold_mb = "text-base font-semibold mb-1";
    function mk_tensor_diagram_info(param) {
        var _e__ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_for_more),
            0
        ], _e$_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[48], cst_https_www_tensors_net_intr, cst_tensors_net),
            _e__
        ], _fa_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_or),
            _e$_
        ], _fb_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[48], cst_https_tensornetwork_org_di, cst_tensornetwork_org),
            _fa_
        ], _fc_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_See),
            _fb_
        ], _fd_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _fc_),
            0
        ], _fe_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Each_node_in_a_tensor_diag),
            0
        ], _ff_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _fe_),
            _fd_
        ], _fg_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Interpreting_a_Tensor_Diag),
            0
        ], _fh_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_text_base_font_semibold_mb)
        ], _fi_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, _fh_, _fg_),
            _ff_
        ], _fj_ = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _fi_);
        return caml_call1(Dune_exe_Frontend_util[47], _fj_);
    }
    var _c_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[33], "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"),
        0
    ], _d_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "stroke-linejoin", cst_round),
        _c_
    ], _e_ = [
        0,
        [
            0,
            caml_call2(Dune_exe_Frontend_util[25], "stroke-linecap", cst_round),
            _d_
        ]
    ], _f_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _e_, 0),
        0
    ], _g_ = caml_call1(Dune_exe_Frontend_util[31], "size-5 inline"), _h_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "fill", "none"),
        0
    ], _i_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "stroke", "currentColor"),
        _h_
    ], _j_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "stroke-width", "1.5"),
        _i_
    ], _k_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[34], "0 0 24 24"),
        _j_
    ], _l_ = [
        0,
        caml_call2(Stdlib[37], _k_, _g_)
    ], website = caml_call3(Brr_svg[3][74], 0, _l_, _f_), _m_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[33], "m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"),
            0
        ]
    ], _n_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _m_, 0),
        0
    ], _o_ = caml_call1(Dune_exe_Frontend_util[31], cst_size_5_inline_fill_slate_9), _p_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[34], "0 0 300 271"),
            _o_
        ]
    ], x = caml_call3(Brr_svg[3][74], 0, _p_, _n_), _q_ = [
        0,
        caml_call1(Dune_exe_Frontend_util[33], "M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"),
        0
    ], _r_ = [
        0,
        caml_call2(Dune_exe_Frontend_util[25], "clip-rule", cst_evenodd),
        _q_
    ], _s_ = [
        0,
        [
            0,
            caml_call2(Dune_exe_Frontend_util[25], "fill-rule", cst_evenodd),
            _r_
        ]
    ], _t_ = [
        0,
        caml_call3(Brr_svg[3][64], 0, _s_, 0),
        0
    ], _u_ = caml_call1(Dune_exe_Frontend_util[31], cst_size_5_inline_fill_slate_9), _v_ = [
        0,
        [
            0,
            caml_call1(Dune_exe_Frontend_util[34], "0 0 98 96"),
            _u_
        ]
    ], github = caml_call3(Brr_svg[3][74], 0, _v_, _t_), Icons = [
        0,
        website,
        x,
        github
    ], cst_Close = "Close", cst_md_hidden_text_sm_font_sem = "md:hidden text-sm font-semibold text-indigo-600 dark:text-indigo-300 hover:text-indigo-500", cst_a_b_b_c_a_c = cst_a_b_b_c_a_c$2, cst_w_full_max_w_sm = "w-full max-w-sm", cst_torch_einsum = "torch.einsum", cst_notation_which_is_the_same = " notation (which is the same as ", cst_numpy_einsum = cst_numpy_einsum$2, cst_or_as = " or as ", cst_Einops_notation = "Einops notation", cst_https_einops_rocks_why_use = "https://einops.rocks/#why-use-einops-notation", cst_This_input_is_valid_as_eit = "This input is valid as either ", cst_We_accept_either = "We accept either ", cst_numpy_einsum$0 = cst_numpy_einsum$2, cst_Switch_to = "Switch to ", _w_ = [
        0,
        1
    ], cst_We_ve_interpreted_it_as_Ei = "We've interpreted it as Einops notation.", cst_Switch_to_Einops = "Switch to Einops", _x_ = [
        0,
        0
    ], cst_notation = " notation.", cst_numpy_einsum$1 = cst_numpy_einsum$2, cst_We_ve_interpreted_it_as = "We've interpreted it as ", cst_overflow_x_auto_rounded_lg = "overflow-x-auto rounded-lg bg-white dark:bg-slate-950/60 px-4 py-3 text-sm leading-6 text-slate-800 dark:text-slate-200 shadow-sm ring-1 ring-slate-200 dark:ring-slate-700", cst_my_4 = "my-4", _y_ = [
        0,
        0
    ], _z_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        cst_a$0
    ], _A_ = [
        0,
        1
    ], _B_ = [
        0,
        [
            15,
            [
                17,
                2,
                0
            ]
        ],
        cst_a$0
    ], cst_instead_of_iterating_over_ = ") instead of iterating over each summation index individually.", cst_np_sum_inputs = "np.sum(inputs)", cst_In_this_next_version_of_th = "In this next version of the code, we use the Frobenius product (", cst_High_level_tensor_diagram = "High-level: tensor diagram", cst_Medium_level_isometric_dia = "Medium-level: isometric diagrams", cst_array_and_then_iterate_ove = " array and then iterate over every position in every axis, building up the result.", cst_result = "result", cst_to_sum_over_each_product_t = ") to sum over each product term. First, here's equivalent, simplified (but slow, because it's not vectorized) Python code. We initialize an empty ", cst_while_in_inner_loops_we_it = "), while in inner loops we iterate over all summation indices (", cst_In_outer_loops_we_iterate_ = "In outer loops, we iterate over all free indices to generate each output element (", cst_Low_level_Python_code = "Low-level: Python code", cst_Isometric_diagrams_are_onl = "Isometric diagrams are only available if all tensors (and all intermediate tensors, which may be bigger than all inputs and the output!) are of dimension 3 or less.", cst_my_4_rounded_lg_bg_red_50_ = "my-4 rounded-lg bg-red-50 dark:bg-red-950/40 px-4 py-3 text-sm text-red-700 dark:text-red-300 ring-1 ring-inset ring-red-200 dark:ring-red-900", cst_Broadcasting_is_a_techniqu = "Broadcasting is a technique used in numpy and other libraries to allow operations on arrays of different shapes. For example, if you have a 3x3 matrix and a 3x1 vector, numpy will automatically expand the vector to a 3x3 matrix by repeating the vector along the second axis. ", cst_https_github_com_joelburge = "https://github.com/joelburget/einsum-in-depth", cst_https_x_com_joel_burget = "https://x.com/joel_burget", cst_https_joelburget_com = "https://joelburget.com", cst_Built_by_Joel_Burget = "Built by Joel Burget ", cst_flex_flex_row_gap_4_mt_4 = "flex flex-row gap-4 mt-4", cst_Einsum_is_All_you_Need_Ein = "Einsum is All you Need - Einstein Summation in Deep Learning", cst_https_rockt_ai_2018_04_30_ = cst_https_rockt_ai_2018_04_30_$1, cst_Stack_Overflow_How_is_nump = "Stack Overflow: How is numpy.einsum implemented?", cst_https_stackoverflow_com_qu = "https://stackoverflow.com/questions/72952005/how-is-numpy-einsum-implemented", cst_ajcr_s_A_basic_introductio = "ajcr's A basic introduction to NumPy's einsum", cst_https_ajcr_net_Basic_guide = "https://ajcr.net/Basic-guide-to-einsum/", cst_Olexa_Bilaniuk_s_Einstein_ = "Olexa Bilaniuk's Einstein Summation in Numpy", cst_https_obilaniu6266h16_word = "https://obilaniu6266h16.wordpress.com/2016/02/04/einstein-summation-in-numpy/", cst_Other_Resources = "Other Resources", cst_source_code = "source code", cst_https_github_com_Transform = "https://github.com/TransformerLensOrg/TransformerLens/blob/3267a43ebcd7e42121fc1c568568165b073f4a9f/transformer_lens/utilities/attention.py", cst_see = " (see ", cst_batch_pos_head_index_d_mod = "batch pos head_index d_model, head_index d_model d_head -> batch pos head_index d_head", cst_batch_head_index_q_pos_d_m = "batch head_index q_pos d_model, batch head_index k_pos d_model -> batch head_index q_pos k_pos", cst_Attention = "Attention:", cst_Batch_matrix_multiplicatio = " (Batch matrix multiplication)", cst_batch_i_j_batch_j_k_batch_ = "batch i j, batch j k -> batch i k", cst_Machine_Learning = "Machine Learning", cst_Tim_Rockt_schel_s_post = "Tim Rockt\xc3\xa4schel's post", cst_https_rockt_ai_2018_04_30_$0 = cst_https_rockt_ai_2018_04_30_$1, cst_bilinear_transformation_se = " (bilinear transformation, see ", cst_i_k_j_k_l_i_l_i_j = "i k, j k l, i l -> i j", cst_outer_product = " (outer product)", cst_i_j_i_j = "i, j -> i j", cst_Hadamard_product = " (Hadamard product)", cst_i_j_i_j_i_j = cst_i_j_i_j_i_j$1, cst_inner_product = " (inner product)", cst_i_i = "i, i ->", cst_row_sum = " (row sum)", cst_i_j_i = cst_i_j_i$1, cst_column_sum = " (column sum)", cst_i_j_j = cst_i_j_j$2, cst_trace = " (trace)", cst_i_i$0 = "i i ->", cst_matrix_vector_product = " (matrix-vector product)", cst_a_b_b_a = "a b, b -> a", cst_matrix_multiplication = " (matrix multiplication)", cst_a_b_b_c_a_c$0 = cst_a_b_b_c_a_c$2, cst_Linear_Algebra = "Linear Algebra", cst_Now_that_we_ve_defined_wha = "Now that we've defined what einsums are doing and given basic examples, here are some examples you might come across in practice.", cst_Examples = "Examples", cst_for_more$0 = cst_for_more$1, cst_opt_einsum_docs = "opt_einsum docs", cst_https_dgasmith_github_io_o = "https://dgasmith.github.io/opt_einsum/paths/introduction/", cst_See_the = ". See the ", cst_quickly = "quickly", cst_https_en_wikipedia_org_wik = "https://en.wikipedia.org/wiki/Matrix_chain_multiplication", cst_grows = "grows", cst_https_en_wikipedia_org_wik$0 = "https://en.wikipedia.org/wiki/Catalan_number", cst_The_general_problem_of_fin = "The general problem of finding the optimal path is NP-hard (the number of possible ways of reducing n tensors ", cst_shows_an_example_where_the = " shows an example where the same reduction takes 3000x longer without optimization.", cst_opt_einsum = "opt_einsum", cst_https_github_com_dgasmith_ = "https://github.com/dgasmith/opt_einsum", cst_A_group_of_tensors_is_redu = "A group of tensors is reduced one pair at a time. The result will be the same no matter which order tensors were reduced in, but different orders can have vastly different performance characteristics. ", cst_Bonus_How_Contractions_Are = "Bonus: How Contractions Are Actually Computed", cst_I_suspect_that_in_practice = 'I suspect that in practice, people often approach tensor contractions with an "if it compiles, it works" attitude. You dump all of the tensors you need in, and tell einsum the shape you want out, and it tends to do the right thing.', cst_Above_I_classified_dimensi = "Above I classified dimensions in three ways: input, output, or different pieces of data. Using the co / contravariant lens, we can see that it's equally valid to think of just two categories, where inputs are contravariant, and both outputs and different pieces of data are covariant.", cst_In_physics_there_s_no_ambi = "In physics there's no ambiguity because physicists use special notation to distinguish outputs and inputs (or what they call co / contravariant). In physics, a contraction happens by pairing a covariant and a contravariant index. This ensures that you're connecting an output (or data) (covariant) to an input (contravariant).", cst_and_multiplied_on_the_righ = " and multiplied on the right.", cst_a_b = "a -> b", cst_to_be_interpreted_as_a_fun = " to be interpreted as a function ", cst_a_b$0 = cst_a_b$2, cst_and_you_multiply_it_on_the = ", and you multiply it on the left, but it sometimes happens that it's more convenient for ", cst_b_a = "b -> a", cst_is_an_output_or_vice_versa = " is an output or vice-versa. The convention in math is for that shape of matrix to be interpreted as a function ", cst_b = "b", cst_is_an_input_and = " is an input and ", cst_a = "a", cst_that_s_not_enough_informat = ", that's not enough information to say whether ", cst_a_b$1 = cst_a_b$2, cst_Unfortunately_when_you_see = "Unfortunately, when you see a matrix with type ", cst_a_b_b_c_a_c$1 = cst_a_b_b_c_a_c$2, cst_and_matrix_multiplication_ = ") and matrix multiplication (composing two functions: ", cst_a_b_a_b = "a b, a -> b", cst_When_you_see_two_tensors_c = "When you see two tensors contracted along some dimension, the typical interpretation is data flow, and the prototypical examples are the matrix-vector product (applying some transformation to data: ", cst_we_can_make_a_pretty_good_ = " we can make a pretty good guess. In fact, those three dimensions correspond to the three roles I just mentioned (batch is a typical name for different pieces of data processed in parallel).", cst_batch_d_in_d_out = "batch d_in d_out", cst_and_say_what_each_dimensio = " and say what each dimension represents. But given a tensor labeled ", cst_a_b_c = "a b c", cst_Because_tensors_are_just_n = "Because tensors are just n-dimensional grids of numbers, we can't look at a tensor labeled ", cst_Different_pieces_of_data_b = "Different pieces of data being operated on in parallel", cst_Output_from_a_computation = "Output from a computation", cst_Input_to_a_computation = "Input to a computation", cst_Finally_on_the_highest_lev = "Finally, on the highest level, I think of dimensions as fulfilling three different roles:", cst_Concisely_diagonalize_make = "Concisely: diagonalize, make the same shape (broadcast / reorder), align, and contract.", cst_Contract_all_summation_ind = "Contract all summation indices (those which don't appear in the output) by summing across them.", cst_Pointwise_multiply_each_te = "Pointwise multiply each tensor, giving a single tensor with maximal dimension (it has one axis for each unique input dimension).", cst_and_reorder_as_necessary_t = " and reorder as necessary to make each input tensor the same shape.", cst_Broadcast = "Broadcast", cst_For_each_input_tensor_with = "For each input tensor with repeated indices, extract the values on the diagonal, producing a new tensor of smaller dimension. Now each input tensor has uniquely named dimensions.", cst_to_confirm_that_it_is_cons = " to confirm that it is consistent with the other two.", cst_script = "script", cst_https_github_com_joelburge$0 = "https://github.com/joelburget/einsum-in-depth/blob/main/verify_consistency.py", cst_I_hadn_t_previously_seen_t = "I hadn't previously seen this interpretation, so I wrote a ", cst_Second_on_the_middle_level = "Second, on the middle level (see isometric diagrams):", cst_For_each_cell_in_the_outpu = "For each cell in the output, loop over each summation index. This gives a unique location in each input tensor. You multiply the values in each tensor and add this product to the current cell.", cst_The_free_indices_define_th = "The free indices define the shape of the output (this gives rise to a loop over each free index in the code).", cst_Classify_each_index_as_fre = "Classify each index as free (if it occurs in the output) or summation (if not).", cst_First_at_the_lowest_level_ = "First, at the lowest level, which is useful for defining the operational semantics of einsum but inefficient to compute (see Python code) and not very insightful:", cst_There_are_at_least_three_w = "There are at least three ways of thinking about what an einsum is doing, at increasing levels of abstraction.", cst_Three_Ways_to_Think_About_ = "Three Ways to Think About Contractions", cst_Hadamard_product$0 = "Hadamard product", cst_https_en_wikipedia_org_wik$1 = "https://en.wikipedia.org/wiki/Hadamard_product_(matrices)", cst_is_the_element_wise_produc = " is the element-wise product of two matrices. In general, we can always combine two tensors of the same shape in this way. This is called the ", cst_i_j_i_j_i_j$0 = cst_i_j_i_j_i_j$1, cst_is_the_element_wise_produc$0 = " is the element-wise product of two vectors. Likewise, ", cst_i_i_i = "i, i -> i", cst_There_s_one_more_basic_ope = "There's one more basic operation. So far, we've been operating on a single tensor, but an einsum can act on any number of tensors. ", cst_5_element_wise_product = "5. element-wise product", cst_is_invalid = ") is invalid.", cst_i_i_i$0 = "i -> i i", cst_Repeating_a_dimension_in_a = "Repeating a dimension in an output (", cst_i_i_i_i = "i i i -> i", cst_It_s_also_possible_to_repe = "). It's also possible to repeat an index three or more times (", cst_arr_i_i_for_i_in_d_i = "[arr[i, i] for i in d_i]", cst_You_can_think_of_this_as_u = "). You can think of this as using the same variable to iterate over both dimensions (", cst_i_i_i$1 = "i i -> i", cst_If_a_dimension_is_repeated = "If a dimension is repeated in an input tensor, we take a diagonal (", cst_4_diagonal = "4. diagonal", cst_On_a_higher_level_you_can_ = "On a higher level, you can think of the distinction being about which dimensions are preserved vs contracted.", cst_On_a_low_level_free_indice = "On a low level, free indices are associated with outer loops, one loop for each dimension of the output. While summation indices are associated with inner loops, which are run for each value in the output.", cst_is_an_example_of_a_summed_ = " is an example of a summed index. Free indices appear in the output specification, while summation indices don't.", cst_i = cst_i$5, cst_is_an_example_of_a_free_in = " is an example of a free index, while ", cst_j = cst_j$3, cst_indices_act_differently = " indices act differently. ", cst_j$0 = cst_j$3, cst_and = cst_and$2, cst_i$0 = cst_i$5, cst_you_may_notice_that_the = ", you may notice that the ", cst_i_j_j$0 = cst_i_j_j$2, cst_In_an_example_like = "In an example like ", cst_Terminology_free_and_summa = "Terminology: free and summation indices", cst_do = " do?", cst_i_j_i$0 = cst_i_j_i$1, cst_and$0 = cst_and$2, cst_i_j_j$1 = cst_i_j_j$2, cst_sums_a_matrix_Can_you_expl = " sums a matrix. Can you explain what ", cst_i_j = "i j ->", cst_sums_a_vector = " sums a vector. ", cst_i$1 = "i ->", cst_So_far_we_ve_just_rearrang = "So far we've just rearranged tensors. You can also sum across a dimension by omitting it from the result. So ", cst_3_sum = "3. sum", cst_But_einsums_can_t_do_this = ". But einsums can't do this.", cst_3_2_1 = "<3 2 1>", cst_to = " to ", cst_1_2_3 = "<1 2 3>", cst_As_an_aside_you_may_wonder = "As an aside, you may wonder whether there's a way to reverse the direction of a dimension. For example, reverse ", cst_So_this_operation_is_the_t = ". So this operation is the transpose.", cst_j$1 = cst_j$3, cst_changes_from_the_row_dimen = " changes from the row dimension to the column dimension, and likewise with ", cst_i$2 = cst_i$5, cst_dimensions = " dimensions. ", cst_j$2 = cst_j$3, cst_and$1 = cst_and$2, cst_i$3 = cst_i$5, cst_swaps_the_positions_of_the = " swaps the positions of the ", cst_i_j_j_i = "i j -> j i", cst_The_ordering_of_labels_mat = "The ordering of labels matters. ", cst_2_transpose = "2. transpose", cst_is_the_identity_operation_ = " is the identity operation on 3-dimensional tensors.", cst_i_j_k_i_j_k = "i j k -> i j k", cst_is_the_identity_operation_$0 = " is the identity operation on matrices, and ", cst_i_j_i_j$0 = "i j -> i j", cst_and_returns_the_same_vecto = ") and returns the same vector. Likewise ", cst_i$4 = cst_i$5, cst_takes_a_vector_the_fact_th = " takes a vector (the fact that a vector is one-dimensional corresponds to the single index, ", cst_i_i$1 = "i -> i", cst_An_einsum_expression_names = "An einsum expression names the axes involved in an operation. ", cst_1_identity = "1. identity", cst_We_ll_start_with_five_simp = "We'll start with five simple examples which illustrate all of the principles you need to understand einsums.", cst_Basic_Operations = "Basic Operations", cst_Though_Einsums_are_easy_to = "Though Einsums are easy to read and to understand on the level of the shapes of the input and output tensors, I initially found it hard to understand what an einsum expression was actually doing. That's why I built this page, where we start from the basics and build up to understanding what complex expressions actually mean.", cst_is_a_compact_and_intuitive = " is a compact and intuitive way to write many linear algebra operations: matrix multiplication, dot / Frobenius product, transpose, trace, as well as many more complex operations which don't have a name.", cst_Einsum_Einstein_summation_ = "Einsum (Einstein summation) notation", cst_https_en_wikipedia_org_wik$2 = "https://en.wikipedia.org/wiki/Einstein_notation", cst_Einsum_in_Depth = "Einsum in Depth", cst_flex_1_md_w_1_2_w_full_ove = "flex-1 md:w-1/2 w-full overflow-y-auto border-r border-slate-200 dark:border-slate-700 px-5 py-8 sm:px-8 prose prose-slate dark:prose-invert prose-p:my-3 prose-headings:tracking-tight prose-code:before:content-none prose-code:after:content-none", cst_Explanation = "Explanation", cst_text_xl_font_semibold_trac = "text-xl font-semibold tracking-tight text-slate-900 dark:text-slate-100", cst_flex_items_center_justify_ = "flex items-center justify-between border-b border-slate-200 dark:border-slate-700 pb-3 mb-5", cst_flex_1_md_w_1_2_w_full_ove$0 = "flex-1 md:w-1/2 w-full overflow-y-auto px-5 py-8 sm:px-8 bg-slate-50 dark:bg-slate-800 md:static md:translate-y-0 md:relative fixed bottom-0 left-0 right-0 top-0 transform transition-transform duration-300 ease-in-out md:border-none border-t border-slate-200 dark:border-slate-700 z-50", cst_flex_items_center_gap_2_mb = "flex items-center gap-2 mb-2", cst_Click_any_highlighted_expr = "Click any highlighted expression, or enter your own contraction:", cst_text_sm_text_slate_600_dar = "text-sm text-slate-600 dark:text-slate-400 mb-2", cst_relative_flex_flex_col_md_ = "relative flex flex-col md:flex-row h-screen";
    function tutorial(container) {
        var match = caml_call2(Note[4][3], 0, 1), set_overlay_hidden = match[2], overlay_hidden_s = match[1], match$0 = caml_call2(Note[4][3], 0, 0), set_syntax_preference = match$0[2], syntax_preference_s = match$0[1], _C_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Close),
            0
        ], _D_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_md_hidden_text_sm_font_sem)
        ], close_button = caml_call3(Brr[9][75], 0, _D_, _C_), match$1 = caml_call1(Note[3][3], 0), send_clicked_op_in_text = match$1[2], clicked_op_in_text_e = match$1[1];
        function example(friendly_spec) {
            function f(param) {
                if (param && param[1]) {
                    var match = caml_call1(Tensor_playground_Einsum_parse[2][1], friendly_spec);
                    if (0 !== match[0]) return friendly_spec;
                    var parsed = match[1], _e9_ = caml_call1(Tensor_playground_Einops[8][6], parsed);
                    return caml_call1(caml_call1(Fmt[96], Tensor_playground_Einops[8][5]), _e9_);
                }
                return friendly_spec;
            }
            var contents_s = caml_call1(caml_call2(Note[4][14], 0, function(preference) {
                return [
                    0,
                    code(f(preference)),
                    0
                ];
            }), syntax_preference_s), button = caml_call3(Brr[9][75], 0, [
                0,
                text_button_classes
            ], 0);
            caml_call2(Note_brr[4][2], button, contents_s);
            var evt = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(param) {
                return 0;
            }, button), _e8_ = caml_call3(Note[3][2], 0, evt, function(param) {
                caml_call2(send_clicked_op_in_text, 0, f(caml_call1(Note[4][6], syntax_preference_s)));
                return caml_call2(set_overlay_hidden, 0, 0);
            });
            caml_call1(Note[2][8], _e8_);
            return button;
        }
        var _E_ = caml_call1(Dune_exe_Frontend_util[29], cst_w_full_max_w_sm), _F_ = [
            0,
            caml_call2(Stdlib[37], Dune_exe_Frontend_util[41], _E_)
        ], match$2 = caml_call3(Dune_exe_Frontend_util[40], _F_, cst_a_b_b_c_a_c, clicked_op_in_text_e), current_input = match$2[3], c_input = match$2[2], logger = match$2[1];
        caml_call1(Note[2][8], logger);
        var parsed_input_signal = caml_call3(Note[4][14], 0, function(str) {
            var str$0 = trim_before_colon(str), _e7_ = caml_call1(Tensor_playground_Einsum_parse[4], str$0);
            return [
                0,
                caml_call1(Tensor_playground_Einsum_parse[3], str$0),
                _e7_
            ];
        }, current_input);
        function interpretation_info(valid_as_both) {
            var _eV_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst$3),
                0
            ], _eW_ = [
                0,
                code(cst_torch_einsum),
                0
            ], _eX_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], "https://pytorch.org/docs/stable/generated/torch.einsum.html"),
                    0
                ]
            ], _eY_ = [
                0,
                caml_call3(Brr[9][61], 0, _eX_, _eW_),
                _eV_
            ], _eZ_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_notation_which_is_the_same),
                _eY_
            ], _e0_ = [
                0,
                code(cst_numpy_einsum),
                0
            ], _e1_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], "https://numpy.org/doc/stable/reference/generated/numpy.einsum.html"),
                    0
                ]
            ], _e2_ = [
                0,
                caml_call3(Brr[9][61], 0, _e1_, _e0_),
                _eZ_
            ], _e3_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_or_as),
                _e2_
            ], _e4_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[48], cst_https_einops_rocks_why_use, cst_Einops_notation),
                _e3_
            ], _e5_ = valid_as_both ? cst_This_input_is_valid_as_eit : cst_We_accept_either, _e6_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, _e5_),
                _e4_
            ];
            return caml_call3(Dune_exe_Frontend_util[15], 0, 0, _e6_);
        }
        var _G_ = [
            0,
            code(cst_numpy_einsum$0),
            0
        ], _H_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Switch_to),
            _G_
        ], button = caml_call3(Brr[9][75], 0, [
            0,
            text_button_classes
        ], _H_), click_button_event = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button), _I_ = caml_call3(Note[3][2], 0, click_button_event, function(param) {
            return caml_call2(set_syntax_preference, 0, _w_);
        });
        caml_call1(Note[2][8], _I_);
        var _J_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ve_interpreted_it_as_Ei),
            0
        ], _K_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _J_),
            [
                0,
                button,
                0
            ]
        ], _L_ = [
            0,
            interpretation_info(1),
            _K_
        ], interpreted_as_friendly_messag = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _L_), _M_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Switch_to_Einops),
            0
        ], button$0 = caml_call3(Brr[9][75], 0, [
            0,
            text_button_classes
        ], _M_), click_button_event$0 = caml_call6(Note_brr[3][3], 0, 0, 0, Brr[7][45], function(evt) {
            caml_call1(Brr[7][10], evt);
            return 0;
        }, button$0), _N_ = caml_call3(Note[3][2], 0, click_button_event$0, function(param) {
            return caml_call2(set_syntax_preference, 0, _x_);
        });
        caml_call1(Note[2][8], _N_);
        var _O_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_notation),
            0
        ], _P_ = [
            0,
            code(cst_numpy_einsum$1),
            _O_
        ], _Q_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ve_interpreted_it_as),
            _P_
        ], _R_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _Q_),
            [
                0,
                button$0,
                0
            ]
        ], _S_ = [
            0,
            interpretation_info(1),
            _R_
        ], interpreted_as_original_messag = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _S_);
        function code_block(contents) {
            var _eS_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_overflow_x_auto_rounded_lg)
            ], _eT_ = [
                0,
                caml_call3(Brr[9][134], 0, _eS_, [
                    0,
                    contents,
                    0
                ]),
                0
            ], _eU_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_my_4)
            ];
            return caml_call3(Dune_exe_Frontend_util[8], 0, _eU_, _eT_);
        }
        function render_explanation(rewrite, syntax_preference) {
            var edge_attributes = caml_call1(Dune_exe_Colors[3], rewrite[1]);
            function text_color(edge_name) {
                var match = caml_call2(Stdlib_Hashtbl[7], edge_attributes, edge_name);
                if (!match) return cst$4;
                var text_classes = match[1][2];
                return text_classes;
            }
            var pyloops = caml_call1(Tensor_playground_Einops[12][1], rewrite), match = caml_call1(Make_formatter[1], 0), code_ppf = match[2], python_code = match[1], _ep_ = caml_call2(Tensor_playground_Einops[11][2], _y_, text_color);
            caml_call4(Fmt[3], code_ppf, _z_, _ep_, pyloops);
            if (caml_call1(Tensor_playground_Einops[11][1], pyloops)) {
                var match$0 = caml_call1(Make_formatter[1], 0), frob_code_ppf = match$0[2], frob_python_code = match$0[1], _eq_ = caml_call2(Tensor_playground_Einops[11][2], _A_, text_color);
                caml_call4(Fmt[3], frob_code_ppf, _B_, _eq_, pyloops);
                var _er_ = [
                    0,
                    code_block(frob_python_code),
                    0
                ], _es_ = [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, cst_instead_of_iterating_over_),
                    0
                ], _et_ = [
                    0,
                    code(cst_np_sum_inputs),
                    _es_
                ], _eu_ = [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_this_next_version_of_th),
                    _et_
                ], frob_explanation = [
                    0,
                    caml_call3(Dune_exe_Frontend_util[15], 0, 0, _eu_),
                    _er_
                ];
            } else var frob_explanation = 0;
            var free_indices = caml_call1(Dune_exe_Frontend_util[1][37], pyloops[1]), summation_indices = caml_call1(Dune_exe_Frontend_util[1][37], pyloops[2]), rhs = rewrite[2], lhs = rewrite[1], _ev_ = [
                0,
                caml_call3(Dune_exe_Tensor_diagram[1], edge_attributes, lhs, rhs),
                0
            ], _ew_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, 0, _ev_),
                0
            ], _ex_ = [
                0,
                mk_tensor_diagram_info(0),
                0
            ], _ey_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_High_level_tensor_diagram),
                _ex_
            ], _ez_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, [
                    0,
                    section_heading_classes
                ], _ey_),
                _ew_
            ], match$1 = caml_call6(Dune_exe_Isometric[2][1], 0, 0, 0, edge_attributes, lhs, rhs);
            if (match$1) var render = match$1[1], _eA_ = [
                0,
                render,
                0
            ];
            else var _eA_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Isometric_diagrams_are_onl),
                0
            ];
            var _eB_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, 0, _eA_),
                _ez_
            ], _eC_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Medium_level_isometric_dia),
                0
            ], _eD_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, [
                    0,
                    section_heading_classes
                ], _eC_),
                _eB_
            ], _eE_ = caml_call2(Stdlib[37], frob_explanation, _eD_), _eF_ = [
                0,
                code_block(python_code),
                0
            ], _eG_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_array_and_then_iterate_ove),
                0
            ], _eH_ = [
                0,
                code(cst_result),
                _eG_
            ], _eI_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_sum_over_each_product_t),
                _eH_
            ], _eJ_ = caml_call2(Dune_exe_Frontend_util[50], text_color, summation_indices), _eK_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[9], 0, 0, _eJ_),
                _eI_
            ], _eL_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_while_in_inner_loops_we_it),
                _eK_
            ], _eM_ = caml_call2(Dune_exe_Frontend_util[50], text_color, free_indices), _eN_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[9], 0, 0, _eM_),
                _eL_
            ], _eO_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_outer_loops_we_iterate_),
                _eN_
            ], _eP_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[15], 0, 0, _eO_),
                _eF_
            ], _eQ_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Low_level_Python_code),
                0
            ], _eR_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[20], 0, [
                    0,
                    section_heading_classes
                ], _eQ_),
                _eP_
            ];
            return caml_call2(Stdlib[37], _eR_, _eE_);
        }
        var explanation_message_s = caml_call4(Note[4][26], 0, function(param, syntax_preference) {
            var prefers_original_notation = param[2], rewrites = param[1], _em_ = rewrites[1];
            if (0 === _em_[0]) {
                var match = rewrites[2], friendly_rewrite = _em_[1];
                if (0 === match[0]) {
                    var original_rewrite = match[1];
                    if (syntax_preference) {
                        if (syntax_preference[1]) var opt_syntax_preference_message = [
                            0,
                            interpreted_as_original_messag
                        ], opt_syntax_preference_message$0 = opt_syntax_preference_message, explanation = render_explanation(original_rewrite, syntax_preference);
                        else var opt_syntax_preference_message$1 = [
                            0,
                            interpreted_as_friendly_messag
                        ], opt_syntax_preference_message$0 = opt_syntax_preference_message$1, explanation = render_explanation(friendly_rewrite, syntax_preference);
                    } else if (prefers_original_notation) var opt_syntax_preference_message$2 = [
                        0,
                        interpreted_as_original_messag
                    ], opt_syntax_preference_message$0 = opt_syntax_preference_message$2, explanation = render_explanation(original_rewrite, syntax_preference);
                    else var opt_syntax_preference_message$3 = [
                        0,
                        interpreted_as_friendly_messag
                    ], opt_syntax_preference_message$0 = opt_syntax_preference_message$3, explanation = render_explanation(friendly_rewrite, syntax_preference);
                } else var opt_syntax_preference_message$0 = 0, explanation = render_explanation(friendly_rewrite, syntax_preference);
            } else {
                var msg$0 = _em_[1], match$0 = rewrites[2];
                if (0 === match$0[0]) var rewrite = match$0[1], opt_syntax_preference_message$0 = 0, explanation = render_explanation(rewrite, syntax_preference);
                else var _en_ = [
                    0,
                    caml_call2(Dune_exe_Frontend_util[10], 0, msg$0),
                    0
                ], _eo_ = [
                    0,
                    caml_call1(Dune_exe_Frontend_util[29], cst_my_4_rounded_lg_bg_red_50_)
                ], explanation$0 = [
                    0,
                    caml_call3(Dune_exe_Frontend_util[8], 0, _eo_, _en_),
                    0
                ], opt_syntax_preference_message$0 = 0, explanation = explanation$0;
            }
            if (opt_syntax_preference_message$0) var msg = opt_syntax_preference_message$0[1], syntax_preference_message = msg;
            else var syntax_preference_message = interpretation_info(0);
            return [
                0,
                explanation,
                syntax_preference_message
            ];
        }, parsed_input_signal, syntax_preference_s);
        function a(href, text) {
            var _ei_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, text),
                0
            ], _ej_ = [
                0,
                caml_call1(Brr[8][19], "underline"),
                0
            ], _ek_ = [
                0,
                caml_call2(Brr[8][1], cst_target, cst_blank),
                _ej_
            ], _el_ = [
                0,
                [
                    0,
                    caml_call2(Brr[8][1], "href", caml_jsstring_of_string(href)),
                    _ek_
                ]
            ];
            return caml_call3(Brr[9][61], 0, _el_, _ei_);
        }
        var _T_1 = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Broadcasting_is_a_techniqu),
            0
        ], broadcast_info = caml_call3(Dune_exe_Frontend_util[8], 0, 0, _T_1);
        function icon_link(link_location, icon) {
            var _ef_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[24], icon),
                0
            ], _eg_ = [
                0,
                caml_call2(Brr[8][1], cst_target, cst_blank),
                0
            ], _eh_ = [
                0,
                [
                    0,
                    caml_call1(Brr[8][31], caml_jsstring_of_string(link_location)),
                    _eg_
                ]
            ];
            return caml_call3(Brr[9][61], 0, _eh_, _ef_);
        }
        var _U_ = [
            0,
            icon_link(cst_https_github_com_joelburge, Icons[3]),
            0
        ], _V_ = [
            0,
            icon_link(cst_https_x_com_joel_burget, Icons[2]),
            _U_
        ], _W_ = [
            0,
            icon_link(cst_https_joelburget_com, Icons[1]),
            _V_
        ], _X_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Built_by_Joel_Burget),
            _W_
        ], _Y_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_flex_row_gap_4_mt_4)
        ], _Z_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, _Y_, _X_),
            0
        ], ___ = [
            0,
            a(cst_https_rockt_ai_2018_04_30_, cst_Einsum_is_All_you_Need_Ein),
            0
        ], _$_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, ___),
            0
        ], _aa_ = [
            0,
            a(cst_https_stackoverflow_com_qu, cst_Stack_Overflow_How_is_nump),
            0
        ], _ab_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aa_),
            _$_
        ], _ac_ = [
            0,
            a(cst_https_ajcr_net_Basic_guide, cst_ajcr_s_A_basic_introductio),
            0
        ], _ad_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ac_),
            _ab_
        ], _ae_ = [
            0,
            a(cst_https_obilaniu6266h16_word, cst_Olexa_Bilaniuk_s_Einstein_),
            0
        ], _af_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ae_),
            _ad_
        ], _ag_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _af_),
            _Z_
        ], _ah_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Other_Resources),
            0
        ], _ai_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _ah_),
            _ag_
        ], _aj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$5),
            0
        ], _ak_ = [
            0,
            a(cst_https_github_com_Transform, cst_source_code),
            _aj_
        ], _al_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_see),
            _ak_
        ], _am_ = [
            0,
            example(cst_batch_pos_head_index_d_mod),
            _al_
        ], _an_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _am_),
            0
        ], _ao_ = [
            0,
            example(cst_batch_head_index_q_pos_d_m),
            0
        ], _ap_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ao_),
            _an_
        ], _aq_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _ap_),
            0
        ], _ar_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Attention),
            _aq_
        ], _as_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ar_),
            0
        ], _at_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Batch_matrix_multiplicatio),
            0
        ], _au_ = [
            0,
            example(cst_batch_i_j_batch_j_k_batch_),
            _at_
        ], _av_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _au_),
            _as_
        ], _aw_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _av_),
            _ai_
        ], _ax_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Machine_Learning),
            0
        ], _ay_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _ax_),
            _aw_
        ], _az_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$6),
            0
        ], _aA_ = [
            0,
            a(cst_https_rockt_ai_2018_04_30_$0, cst_Tim_Rockt_schel_s_post),
            _az_
        ], _aB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_bilinear_transformation_se),
            _aA_
        ], _aC_ = [
            0,
            example(cst_i_k_j_k_l_i_l_i_j),
            _aB_
        ], _aD_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aC_),
            0
        ], _aE_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_outer_product),
            0
        ], _aF_ = [
            0,
            example(cst_i_j_i_j),
            _aE_
        ], _aG_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aF_),
            _aD_
        ], _aH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Hadamard_product),
            0
        ], _aI_ = [
            0,
            example(cst_i_j_i_j_i_j),
            _aH_
        ], _aJ_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aI_),
            _aG_
        ], _aK_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_inner_product),
            0
        ], _aL_ = [
            0,
            example(cst_i_i),
            _aK_
        ], _aM_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aL_),
            _aJ_
        ], _aN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_row_sum),
            0
        ], _aO_ = [
            0,
            example(cst_i_j_i),
            _aN_
        ], _aP_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aO_),
            _aM_
        ], _aQ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_column_sum),
            0
        ], _aR_ = [
            0,
            example(cst_i_j_j),
            _aQ_
        ], _aS_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aR_),
            _aP_
        ], _aT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_trace),
            0
        ], _aU_ = [
            0,
            example(cst_i_i$0),
            _aT_
        ], _aV_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aU_),
            _aS_
        ], _aW_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_matrix_vector_product),
            0
        ], _aX_ = [
            0,
            example(cst_a_b_b_a),
            _aW_
        ], _aY_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _aX_),
            _aV_
        ], _aZ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_matrix_multiplication),
            0
        ], _a0_ = [
            0,
            example(cst_a_b_b_c_a_c$0),
            _aZ_
        ], _a1_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _a0_),
            _aY_
        ], _a2_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _a1_),
            _ay_
        ], _a3_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Linear_Algebra),
            0
        ], _a4_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _a3_),
            _a2_
        ], _a5_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Now_that_we_ve_defined_wha),
            0
        ], _a6_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _a5_),
            _a4_
        ], _a7_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Examples),
            0
        ], _a8_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _a7_),
            _a6_
        ], _a9_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_for_more$0),
            0
        ], _a__ = [
            0,
            a(cst_https_dgasmith_github_io_o, cst_opt_einsum_docs),
            _a9_
        ], _a$_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_See_the),
            _a__
        ], _ba_ = [
            0,
            a(cst_https_en_wikipedia_org_wik, cst_quickly),
            _a$_
        ], _bb_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$7),
            _ba_
        ], _bc_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$0, cst_grows),
            _bb_
        ], _bd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_general_problem_of_fin),
            _bc_
        ], _be_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bd_),
            _a8_
        ], _bf_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_shows_an_example_where_the),
            0
        ], _bg_ = [
            0,
            a(cst_https_github_com_dgasmith_, cst_opt_einsum),
            _bf_
        ], _bh_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_A_group_of_tensors_is_redu),
            _bg_
        ], _bi_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bh_),
            _be_
        ], _bj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Bonus_How_Contractions_Are),
            0
        ], _bk_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _bj_),
            _bi_
        ], _bl_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_I_suspect_that_in_practice),
            0
        ], _bm_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bl_),
            _bk_
        ], _bn_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Above_I_classified_dimensi),
            0
        ], _bo_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bn_),
            _bm_
        ], _bp_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_physics_there_s_no_ambi),
            0
        ], _bq_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bp_),
            _bo_
        ], _br_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_multiplied_on_the_righ),
            0
        ], _bs_ = [
            0,
            code(cst_a_b),
            _br_
        ], _bt_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_be_interpreted_as_a_fun),
            _bs_
        ], _bu_ = [
            0,
            code(cst_a_b$0),
            _bt_
        ], _bv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_you_multiply_it_on_the),
            _bu_
        ], _bw_ = [
            0,
            code(cst_b_a),
            _bv_
        ], _bx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_output_or_vice_versa),
            _bw_
        ], _by_ = [
            0,
            code(cst_b),
            _bx_
        ], _bz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_input_and),
            _by_
        ], _bA_ = [
            0,
            code(cst_a),
            _bz_
        ], _bB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_that_s_not_enough_informat),
            _bA_
        ], _bC_ = [
            0,
            code(cst_a_b$1),
            _bB_
        ], _bD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Unfortunately_when_you_see),
            _bC_
        ], _bE_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bD_),
            _bq_
        ], _bF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$8),
            0
        ], _bG_ = [
            0,
            example(cst_a_b_b_c_a_c$1),
            _bF_
        ], _bH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_matrix_multiplication_),
            _bG_
        ], _bI_ = [
            0,
            example(cst_a_b_a_b),
            _bH_
        ], _bJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_When_you_see_two_tensors_c),
            _bI_
        ], _bK_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bJ_),
            _bE_
        ], _bL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_we_can_make_a_pretty_good_),
            0
        ], _bM_ = [
            0,
            code(cst_batch_d_in_d_out),
            _bL_
        ], _bN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_say_what_each_dimensio),
            _bM_
        ], _bO_ = [
            0,
            code(cst_a_b_c),
            _bN_
        ], _bP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Because_tensors_are_just_n),
            _bO_
        ], _bQ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bP_),
            _bK_
        ], _bR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Different_pieces_of_data_b),
            0
        ], _bS_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bR_),
            0
        ], _bT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Output_from_a_computation),
            0
        ], _bU_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bT_),
            _bS_
        ], _bV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Input_to_a_computation),
            0
        ], _bW_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _bV_),
            _bU_
        ], _bX_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _bW_),
            _bQ_
        ], _bY_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Finally_on_the_highest_lev),
            0
        ], _bZ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _bY_),
            _bX_
        ], _b0_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Concisely_diagonalize_make),
            0
        ], _b1_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _b0_),
            _bZ_
        ], _b2_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Contract_all_summation_ind),
            0
        ], _b3_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b2_),
            0
        ], _b4_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Pointwise_multiply_each_te),
            0
        ], _b5_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b4_),
            _b3_
        ], _b6_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_reorder_as_necessary_t),
            0
        ], _b7_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[47], broadcast_info),
            _b6_
        ], _b8_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Broadcast),
            _b7_
        ], _b9_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b8_),
            _b5_
        ], _b__ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_For_each_input_tensor_with),
            0
        ], _b$_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _b__),
            _b9_
        ], _ca_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _b$_),
            _b1_
        ], _cb_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to_confirm_that_it_is_cons),
            0
        ], _cc_ = [
            0,
            a(cst_https_github_com_joelburge$0, cst_script),
            _cb_
        ], _cd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_I_hadn_t_previously_seen_t),
            _cc_
        ], _ce_ = caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cd_), _cf_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[47], _ce_),
            0
        ], _cg_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Second_on_the_middle_level),
            _cf_
        ], _ch_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cg_),
            _ca_
        ], _ci_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_For_each_cell_in_the_outpu),
            0
        ], _cj_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ci_),
            0
        ], _ck_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_free_indices_define_th),
            0
        ], _cl_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _ck_),
            _cj_
        ], _cm_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Classify_each_index_as_fre),
            0
        ], _cn_ = [
            0,
            caml_call3(Brr[9][118], 0, 0, _cm_),
            _cl_
        ], _co_ = [
            0,
            caml_call3(Brr[9][165], 0, 0, _cn_),
            _ch_
        ], _cp_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_First_at_the_lowest_level_),
            0
        ], _cq_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cp_),
            _co_
        ], _cr_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_There_are_at_least_three_w),
            0
        ], _cs_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cr_),
            _cq_
        ], _ct_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Three_Ways_to_Think_About_),
            0
        ], _cu_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _ct_),
            _cs_
        ], _cv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$9),
            0
        ], _cw_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$1, cst_Hadamard_product$0),
            _cv_
        ], _cx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_element_wise_produc),
            _cw_
        ], _cy_ = [
            0,
            example(cst_i_j_i_j_i_j$0),
            _cx_
        ], _cz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_element_wise_produc$0),
            _cy_
        ], _cA_ = [
            0,
            example(cst_i_i_i),
            _cz_
        ], _cB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_There_s_one_more_basic_ope),
            _cA_
        ], _cC_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cB_),
            _cu_
        ], _cD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_5_element_wise_product),
            0
        ], _cE_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _cD_),
            _cC_
        ], _cF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_invalid),
            0
        ], _cG_ = [
            0,
            example(cst_i_i_i$0),
            _cF_
        ], _cH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Repeating_a_dimension_in_a),
            _cG_
        ], _cI_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cH_),
            _cE_
        ], _cJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst$10),
            0
        ], _cK_ = [
            0,
            example(cst_i_i_i_i),
            _cJ_
        ], _cL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_It_s_also_possible_to_repe),
            _cK_
        ], _cM_ = [
            0,
            code(cst_arr_i_i_for_i_in_d_i),
            _cL_
        ], _cN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_You_can_think_of_this_as_u),
            _cM_
        ], _cO_ = [
            0,
            example(cst_i_i_i$1),
            _cN_
        ], _cP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_If_a_dimension_is_repeated),
            _cO_
        ], _cQ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cP_),
            _cI_
        ], _cR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_4_diagonal),
            0
        ], _cS_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _cR_),
            _cQ_
        ], _cT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_On_a_higher_level_you_can_),
            0
        ], _cU_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cT_),
            _cS_
        ], _cV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_On_a_low_level_free_indice),
            0
        ], _cW_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _cV_),
            _cU_
        ], _cX_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_example_of_a_summed_),
            0
        ], _cY_ = [
            0,
            code(cst_i),
            _cX_
        ], _cZ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_an_example_of_a_free_in),
            _cY_
        ], _c0_ = [
            0,
            code(cst_j),
            _cZ_
        ], _c1_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_indices_act_differently),
            _c0_
        ], _c2_ = [
            0,
            code(cst_j$0),
            _c1_
        ], _c3_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and),
            _c2_
        ], _c4_ = [
            0,
            code(cst_i$0),
            _c3_
        ], _c5_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_you_may_notice_that_the),
            _c4_
        ], _c6_ = [
            0,
            example(cst_i_j_j$0),
            _c5_
        ], _c7_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_In_an_example_like),
            _c6_
        ], _c8_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _c7_),
            _cW_
        ], _c9_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Terminology_free_and_summa),
            0
        ], _c__ = [
            0,
            caml_call3(Dune_exe_Frontend_util[22], 0, 0, _c9_),
            _c8_
        ], _c$_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_do),
            0
        ], _da_ = [
            0,
            example(cst_i_j_i$0),
            _c$_
        ], _db_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and$0),
            _da_
        ], _dc_ = [
            0,
            example(cst_i_j_j$1),
            _db_
        ], _dd_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_sums_a_matrix_Can_you_expl),
            _dc_
        ], _de_ = [
            0,
            example(cst_i_j),
            _dd_
        ], _df_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_sums_a_vector),
            _de_
        ], _dg_ = [
            0,
            example(cst_i$1),
            _df_
        ], _dh_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_So_far_we_ve_just_rearrang),
            _dg_
        ], _di_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dh_),
            _c__
        ], _dj_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_3_sum),
            0
        ], _dk_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dj_),
            _di_
        ], _dl_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_But_einsums_can_t_do_this),
            0
        ], _dm_ = [
            0,
            code(cst_3_2_1),
            _dl_
        ], _dn_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_to),
            _dm_
        ], _do_ = [
            0,
            code(cst_1_2_3),
            _dn_
        ], _dp_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_As_an_aside_you_may_wonder),
            _do_
        ], _dq_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dp_),
            _dk_
        ], _dr_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_So_this_operation_is_the_t),
            0
        ], _ds_ = [
            0,
            code(cst_j$1),
            _dr_
        ], _dt_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_changes_from_the_row_dimen),
            _ds_
        ], _du_ = [
            0,
            code(cst_i$2),
            _dt_
        ], _dv_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_dimensions),
            _du_
        ], _dw_ = [
            0,
            code(cst_j$2),
            _dv_
        ], _dx_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and$1),
            _dw_
        ], _dy_ = [
            0,
            code(cst_i$3),
            _dx_
        ], _dz_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_swaps_the_positions_of_the),
            _dy_
        ], _dA_ = [
            0,
            example(cst_i_j_j_i),
            _dz_
        ], _dB_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_The_ordering_of_labels_mat),
            _dA_
        ], _dC_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dB_),
            _dq_
        ], _dD_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_2_transpose),
            0
        ], _dE_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dD_),
            _dC_
        ], _dF_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_identity_operation_),
            0
        ], _dG_ = [
            0,
            example(cst_i_j_k_i_j_k),
            _dF_
        ], _dH_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_the_identity_operation_$0),
            _dG_
        ], _dI_ = [
            0,
            example(cst_i_j_i_j$0),
            _dH_
        ], _dJ_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_and_returns_the_same_vecto),
            _dI_
        ], _dK_ = [
            0,
            code(cst_i$4),
            _dJ_
        ], _dL_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_takes_a_vector_the_fact_th),
            _dK_
        ], _dM_ = [
            0,
            example(cst_i_i$1),
            _dL_
        ], _dN_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_An_einsum_expression_names),
            _dM_
        ], _dO_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dN_),
            _dE_
        ], _dP_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_1_identity),
            0
        ], _dQ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[21], 0, 0, _dP_),
            _dO_
        ], _dR_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_We_ll_start_with_five_simp),
            0
        ], _dS_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dR_),
            _dQ_
        ], _dT_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Basic_Operations),
            0
        ], _dU_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[20], 0, 0, _dT_),
            _dS_
        ], _dV_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Though_Einsums_are_easy_to),
            0
        ], _dW_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dV_),
            _dU_
        ], _dX_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_is_a_compact_and_intuitive),
            0
        ], _dY_ = [
            0,
            a(cst_https_en_wikipedia_org_wik$2, cst_Einsum_Einstein_summation_),
            _dX_
        ], _dZ_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[15], 0, 0, _dY_),
            _dW_
        ], _d0_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Einsum_in_Depth),
            0
        ], _d1_ = [
            0,
            caml_call3(Dune_exe_Frontend_util[19], 0, 0, _d0_),
            _dZ_
        ], content = caml_call3(Brr[9][88], 0, 0, _d1_), _d2_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_1_md_w_1_2_w_full_ove)
        ], left_pane = caml_call3(Brr[9][88], 0, _d2_, [
            0,
            content,
            0
        ]), syntax_message_container = caml_call3(Dune_exe_Frontend_util[8], 0, 0, 0), result_container = caml_call3(Dune_exe_Frontend_util[8], 0, 0, 0), _d3_ = [
            0,
            caml_call2(Dune_exe_Frontend_util[10], 0, cst_Explanation),
            0
        ], _d4_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_text_xl_font_semibold_trac)
        ], _d5_ = [
            0,
            caml_call3(Brr[9][99], 0, _d4_, _d3_),
            [
                0,
                close_button,
                0
            ]
        ], _d6_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_items_center_justify_)
        ], _d7_ = [
            0,
            caml_call3(Brr[9][88], 0, _d6_, _d5_),
            [
                0,
                syntax_message_container,
                [
                    0,
                    result_container,
                    0
                ]
            ]
        ], _d8_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_flex_1_md_w_1_2_w_full_ove$0)
        ], right_pane = caml_call3(Brr[9][88], 0, _d8_, _d7_), explanation_signal = caml_call2(Note[4][30][1], 0, explanation_message_s), syntax_preference_message_s = caml_call2(Note[4][30][2], 0, explanation_message_s);
        caml_call2(Note_brr[4][2], result_container, explanation_signal);
        var _d9_ = caml_call3(Note[4][14], 0, function(msg) {
            var _ea_ = [
                0,
                c_input,
                [
                    0,
                    caml_call1(Dune_exe_Frontend_util[47], msg),
                    0
                ]
            ], _eb_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_flex_items_center_gap_2_mb)
            ], _ec_ = [
                0,
                caml_call3(Dune_exe_Frontend_util[8], 0, _eb_, _ea_),
                0
            ], _ed_ = [
                0,
                caml_call2(Dune_exe_Frontend_util[10], 0, cst_Click_any_highlighted_expr),
                0
            ], _ee_ = [
                0,
                caml_call1(Dune_exe_Frontend_util[29], cst_text_sm_text_slate_600_dar)
            ];
            return [
                0,
                caml_call3(Dune_exe_Frontend_util[15], 0, _ee_, _ed_),
                _ec_
            ];
        }, syntax_preference_message_s);
        caml_call2(Note_brr[4][2], syntax_message_container, _d9_);
        var _d__ = caml_call3(Note[3][2], 0, clicked_op_in_text_e, function(param) {
            return right_pane.scrollTop = 0;
        });
        caml_call1(Note[2][8], _d__);
        caml_call3(Note_brr[4][8], "translate-y-full", overlay_hidden_s, right_pane);
        caml_call4(Brr[7][20], 0, Brr[7][45], function(param) {
            return caml_call2(set_overlay_hidden, 0, 1);
        }, close_button);
        var _d$_ = [
            0,
            caml_call1(Dune_exe_Frontend_util[29], cst_relative_flex_flex_col_md_)
        ], wrapper = caml_call3(Brr[9][88], 0, _d$_, [
            0,
            left_pane,
            [
                0,
                right_pane,
                0
            ]
        ]);
        return caml_call2(Dune_exe_Frontend_util[4], container, [
            0,
            wrapper,
            0
        ]);
    }
    var Dune_exe_Einsum_explanation = [
        0,
        code,
        text_button_classes,
        section_heading_classes,
        trim_before_colon,
        Make_formatter,
        mk_tensor_diagram_info,
        Icons,
        tutorial
    ];
    runtime.caml_register_global(311, Dune_exe_Einsum_explanation, "Dune__exe__Einsum_explanation");
    return;
})(globalThis);
//# 5 ".tensor_playground_web.eobjs/jsoo/dune__exe__Tensor_playground_web.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    function caml_call2(f, a0, a1) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 2 ? f(a0, a1) : runtime.caml_call_gen(f, [
            a0,
            a1
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Brr = global_data.Brr, Stdlib_Option = global_data.Stdlib__Option, Dune_exe_Einsum_explanation = global_data.Dune__exe__Einsum_explanation, Jv = global_data.Jv;
    function main(param) {
        var _a_ = caml_call2(Brr[10][2], Brr[16][2], "render"), container = caml_call1(Stdlib_Option[4], _a_);
        return caml_call1(Dune_exe_Einsum_explanation[8], container);
    }
    Jv[12].tensor_playground_main = runtime.caml_js_wrap_callback_strict(1, main);
    var Dune_exe_Tensor_playground_web = [
        0,
        main
    ];
    runtime.caml_register_global(6, Dune_exe_Tensor_playground_web, "Dune__exe__Tensor_playground_web");
    return;
})(globalThis);
//# 5 "../.js/default/stdlib/std_exit.cmo.js"
(function(globalThis1) {
    "use strict";
    var runtime = globalThis1.jsoo_runtime;
    function caml_call1(f, a0) {
        return (f.l >= 0 ? f.l : f.l = f.length) === 1 ? f(a0) : runtime.caml_call_gen(f, [
            a0
        ]);
    }
    var global_data = runtime.caml_get_global_data(), Stdlib = global_data.Stdlib;
    caml_call1(Stdlib[103], 0);
    var Std_exit = [
        0
    ];
    runtime.caml_register_global(1, Std_exit, "Std_exit");
    return;
})(globalThis); //# sourceMappingURL=data:application/json;base64,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

});
parcelRegister("48K42", function(module, exports) {
"use strict";

});

parcelRegister("77U2W", function(module, exports) {
module.exports = JSON.parse("{\"O_RDONLY\":0,\"O_WRONLY\":1,\"O_RDWR\":2,\"S_IFMT\":61440,\"S_IFREG\":32768,\"S_IFDIR\":16384,\"S_IFCHR\":8192,\"S_IFBLK\":24576,\"S_IFIFO\":4096,\"S_IFLNK\":40960,\"S_IFSOCK\":49152,\"O_CREAT\":512,\"O_EXCL\":2048,\"O_NOCTTY\":131072,\"O_TRUNC\":1024,\"O_APPEND\":8,\"O_DIRECTORY\":1048576,\"O_NOFOLLOW\":256,\"O_SYNC\":128,\"O_SYMLINK\":2097152,\"O_NONBLOCK\":4,\"S_IRWXU\":448,\"S_IRUSR\":256,\"S_IWUSR\":128,\"S_IXUSR\":64,\"S_IRWXG\":56,\"S_IRGRP\":32,\"S_IWGRP\":16,\"S_IXGRP\":8,\"S_IRWXO\":7,\"S_IROTH\":4,\"S_IWOTH\":2,\"S_IXOTH\":1,\"E2BIG\":7,\"EACCES\":13,\"EADDRINUSE\":48,\"EADDRNOTAVAIL\":49,\"EAFNOSUPPORT\":47,\"EAGAIN\":35,\"EALREADY\":37,\"EBADF\":9,\"EBADMSG\":94,\"EBUSY\":16,\"ECANCELED\":89,\"ECHILD\":10,\"ECONNABORTED\":53,\"ECONNREFUSED\":61,\"ECONNRESET\":54,\"EDEADLK\":11,\"EDESTADDRREQ\":39,\"EDOM\":33,\"EDQUOT\":69,\"EEXIST\":17,\"EFAULT\":14,\"EFBIG\":27,\"EHOSTUNREACH\":65,\"EIDRM\":90,\"EILSEQ\":92,\"EINPROGRESS\":36,\"EINTR\":4,\"EINVAL\":22,\"EIO\":5,\"EISCONN\":56,\"EISDIR\":21,\"ELOOP\":62,\"EMFILE\":24,\"EMLINK\":31,\"EMSGSIZE\":40,\"EMULTIHOP\":95,\"ENAMETOOLONG\":63,\"ENETDOWN\":50,\"ENETRESET\":52,\"ENETUNREACH\":51,\"ENFILE\":23,\"ENOBUFS\":55,\"ENODATA\":96,\"ENODEV\":19,\"ENOENT\":2,\"ENOEXEC\":8,\"ENOLCK\":77,\"ENOLINK\":97,\"ENOMEM\":12,\"ENOMSG\":91,\"ENOPROTOOPT\":42,\"ENOSPC\":28,\"ENOSR\":98,\"ENOSTR\":99,\"ENOSYS\":78,\"ENOTCONN\":57,\"ENOTDIR\":20,\"ENOTEMPTY\":66,\"ENOTSOCK\":38,\"ENOTSUP\":45,\"ENOTTY\":25,\"ENXIO\":6,\"EOPNOTSUPP\":102,\"EOVERFLOW\":84,\"EPERM\":1,\"EPIPE\":32,\"EPROTO\":100,\"EPROTONOSUPPORT\":43,\"EPROTOTYPE\":41,\"ERANGE\":34,\"EROFS\":30,\"ESPIPE\":29,\"ESRCH\":3,\"ESTALE\":70,\"ETIME\":101,\"ETIMEDOUT\":60,\"ETXTBSY\":26,\"EWOULDBLOCK\":35,\"EXDEV\":18,\"SIGHUP\":1,\"SIGINT\":2,\"SIGQUIT\":3,\"SIGILL\":4,\"SIGTRAP\":5,\"SIGABRT\":6,\"SIGIOT\":6,\"SIGBUS\":10,\"SIGFPE\":8,\"SIGKILL\":9,\"SIGUSR1\":30,\"SIGSEGV\":11,\"SIGUSR2\":31,\"SIGPIPE\":13,\"SIGALRM\":14,\"SIGTERM\":15,\"SIGCHLD\":20,\"SIGCONT\":19,\"SIGSTOP\":17,\"SIGTSTP\":18,\"SIGTTIN\":21,\"SIGTTOU\":22,\"SIGURG\":16,\"SIGXCPU\":24,\"SIGXFSZ\":25,\"SIGVTALRM\":26,\"SIGPROF\":27,\"SIGWINCH\":28,\"SIGIO\":23,\"SIGSYS\":12,\"SSL_OP_ALL\":2147486719,\"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION\":262144,\"SSL_OP_CIPHER_SERVER_PREFERENCE\":4194304,\"SSL_OP_CISCO_ANYCONNECT\":32768,\"SSL_OP_COOKIE_EXCHANGE\":8192,\"SSL_OP_CRYPTOPRO_TLSEXT_BUG\":2147483648,\"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS\":2048,\"SSL_OP_EPHEMERAL_RSA\":0,\"SSL_OP_LEGACY_SERVER_CONNECT\":4,\"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER\":32,\"SSL_OP_MICROSOFT_SESS_ID_BUG\":1,\"SSL_OP_MSIE_SSLV2_RSA_PADDING\":0,\"SSL_OP_NETSCAPE_CA_DN_BUG\":536870912,\"SSL_OP_NETSCAPE_CHALLENGE_BUG\":2,\"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG\":1073741824,\"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG\":8,\"SSL_OP_NO_COMPRESSION\":131072,\"SSL_OP_NO_QUERY_MTU\":4096,\"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION\":65536,\"SSL_OP_NO_SSLv2\":16777216,\"SSL_OP_NO_SSLv3\":33554432,\"SSL_OP_NO_TICKET\":16384,\"SSL_OP_NO_TLSv1\":67108864,\"SSL_OP_NO_TLSv1_1\":268435456,\"SSL_OP_NO_TLSv1_2\":134217728,\"SSL_OP_PKCS1_CHECK_1\":0,\"SSL_OP_PKCS1_CHECK_2\":0,\"SSL_OP_SINGLE_DH_USE\":1048576,\"SSL_OP_SINGLE_ECDH_USE\":524288,\"SSL_OP_SSLEAY_080_CLIENT_DH_BUG\":128,\"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG\":0,\"SSL_OP_TLS_BLOCK_PADDING_BUG\":512,\"SSL_OP_TLS_D5_BUG\":256,\"SSL_OP_TLS_ROLLBACK_BUG\":8388608,\"ENGINE_METHOD_DSA\":2,\"ENGINE_METHOD_DH\":4,\"ENGINE_METHOD_RAND\":8,\"ENGINE_METHOD_ECDH\":16,\"ENGINE_METHOD_ECDSA\":32,\"ENGINE_METHOD_CIPHERS\":64,\"ENGINE_METHOD_DIGESTS\":128,\"ENGINE_METHOD_STORE\":256,\"ENGINE_METHOD_PKEY_METHS\":512,\"ENGINE_METHOD_PKEY_ASN1_METHS\":1024,\"ENGINE_METHOD_ALL\":65535,\"ENGINE_METHOD_NONE\":0,\"DH_CHECK_P_NOT_SAFE_PRIME\":2,\"DH_CHECK_P_NOT_PRIME\":1,\"DH_UNABLE_TO_CHECK_GENERATOR\":4,\"DH_NOT_SUITABLE_GENERATOR\":8,\"NPN_ENABLED\":1,\"RSA_PKCS1_PADDING\":1,\"RSA_SSLV23_PADDING\":2,\"RSA_NO_PADDING\":3,\"RSA_PKCS1_OAEP_PADDING\":4,\"RSA_X931_PADDING\":5,\"RSA_PKCS1_PSS_PADDING\":6,\"POINT_CONVERSION_COMPRESSED\":2,\"POINT_CONVERSION_UNCOMPRESSED\":4,\"POINT_CONVERSION_HYBRID\":6,\"F_OK\":0,\"R_OK\":4,\"W_OK\":2,\"X_OK\":1,\"UV_UDP_REUSEADDR\":4}");

});

parcelRegister("85dKZ", function(module, exports) {

$parcel$export(module.exports, "isatty", () => $5e297631d1214357$export$9b473d35051e2626, (v) => $5e297631d1214357$export$9b473d35051e2626 = v);
$parcel$export(module.exports, "ReadStream", () => $5e297631d1214357$export$de64a30e4ee40519, (v) => $5e297631d1214357$export$de64a30e4ee40519 = v);
$parcel$export(module.exports, "WriteStream", () => $5e297631d1214357$export$b6b358f069d459a3, (v) => $5e297631d1214357$export$b6b358f069d459a3 = v);
var $5e297631d1214357$export$9b473d35051e2626;
var $5e297631d1214357$export$de64a30e4ee40519;
var $5e297631d1214357$export$b6b358f069d459a3;
$5e297631d1214357$export$9b473d35051e2626 = function() {
    return false;
};
function $5e297631d1214357$var$ReadStream() {
    throw new Error('tty.ReadStream is not implemented');
}
$5e297631d1214357$export$de64a30e4ee40519 = $5e297631d1214357$var$ReadStream;
function $5e297631d1214357$var$WriteStream() {
    throw new Error('tty.WriteStream is not implemented');
}
$5e297631d1214357$export$b6b358f069d459a3 = $5e297631d1214357$var$WriteStream;

});


parcelRegister("9eF39", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $jKHze = parcelRequire("jKHze");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jKHze.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Rgb, rgb, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Hsl, hsl, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jKHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6141bbfd30ac9e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $e6141bbfd30ac9e4$export$8b58be045bf06082);
function $e6141bbfd30ac9e4$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $e6141bbfd30ac9e4$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $d867740680d9f0ee$exports = {};

$parcel$export($d867740680d9f0ee$exports, "LineCap", () => $d867740680d9f0ee$export$71ff7619005e0377);
$parcel$export($d867740680d9f0ee$exports, "LineJoin", () => $d867740680d9f0ee$export$93dad4aa23335ca1);
$parcel$export($d867740680d9f0ee$exports, "PlaneView", () => $d867740680d9f0ee$export$34151b55b8cbc6dd);
$parcel$export($d867740680d9f0ee$exports, "Axis", () => $d867740680d9f0ee$export$d06866a9fb0606da);
$parcel$export($d867740680d9f0ee$exports, "IsometricCanvas", () => $d867740680d9f0ee$export$e3e1252f38307002);
$parcel$export($d867740680d9f0ee$exports, "IsometricGroup", () => $d867740680d9f0ee$export$d223442bf82eaf54);
$parcel$export($d867740680d9f0ee$exports, "IsometricRectangle", () => $d867740680d9f0ee$export$f54a3aa3bdb4a9c8);
$parcel$export($d867740680d9f0ee$exports, "IsometricCircle", () => $d867740680d9f0ee$export$77cf72652ee46fc7);
$parcel$export($d867740680d9f0ee$exports, "IsometricPentagram", () => $d867740680d9f0ee$export$893c7f23d4115570);
$parcel$export($d867740680d9f0ee$exports, "IsometricStarPolygon", () => $d867740680d9f0ee$export$d3c4444c1d97c361);
$parcel$export($d867740680d9f0ee$exports, "IsometricPath", () => $d867740680d9f0ee$export$271c527cab8eab68);
$parcel$export($d867740680d9f0ee$exports, "IsometricText", () => $d867740680d9f0ee$export$b5ee75f3884097c5);
/// <reference types="./index.d.ts" />
var $d867740680d9f0ee$var$t, $d867740680d9f0ee$var$e, $d867740680d9f0ee$var$n = "http://www.w3.org/2000/svg";
!function(t) {
    t.svg = "svg", t.group = "g", t.path = "path", t.rect = "rect", t.text = "text", t.tspan = "tspan", t.pattern = "pattern", t.image = "image", t.animate = "animate", t.animateTransform = "animateTransform";
}($d867740680d9f0ee$var$t || ($d867740680d9f0ee$var$t = {})), function(t) {
    t.viewBox = "viewBox";
}($d867740680d9f0ee$var$e || ($d867740680d9f0ee$var$e = {}));
Math.sqrt(3).toFixed(6);
var $d867740680d9f0ee$var$i, $d867740680d9f0ee$export$71ff7619005e0377, $d867740680d9f0ee$export$93dad4aa23335ca1, $d867740680d9f0ee$var$a, $d867740680d9f0ee$export$34151b55b8cbc6dd, $d867740680d9f0ee$export$d06866a9fb0606da, $d867740680d9f0ee$var$u, $d867740680d9f0ee$var$h, $d867740680d9f0ee$var$p, $d867740680d9f0ee$var$l = +(Math.sqrt(3) / 2).toFixed(6), $d867740680d9f0ee$var$d = "(-?\\d+(?:\\.\\d+)?|-?\\.\\d+)", $d867740680d9f0ee$var$f = "\\s*", $d867740680d9f0ee$var$m = "\\s+", $d867740680d9f0ee$var$y = "".concat($d867740680d9f0ee$var$d).concat($d867740680d9f0ee$var$m).concat($d867740680d9f0ee$var$d).concat($d867740680d9f0ee$var$m).concat($d867740680d9f0ee$var$d), $d867740680d9f0ee$var$g = "".concat($d867740680d9f0ee$var$y).concat($d867740680d9f0ee$var$m).concat($d867740680d9f0ee$var$y), $d867740680d9f0ee$var$v = new RegExp("(?:(M|L)".concat($d867740680d9f0ee$var$f).concat($d867740680d9f0ee$var$y).concat($d867740680d9f0ee$var$f, "|(C)").concat($d867740680d9f0ee$var$f).concat($d867740680d9f0ee$var$g, ")").concat($d867740680d9f0ee$var$f), "g"), $d867740680d9f0ee$var$b = Math.sqrt(1.5), $d867740680d9f0ee$var$_ = Math.PI / 3, $d867740680d9f0ee$var$x = Math.PI / 4, $d867740680d9f0ee$var$E = Math.atan(Math.SQRT2);
!function(t) {
    t.white = "white", t.black = "black";
}($d867740680d9f0ee$var$i || ($d867740680d9f0ee$var$i = {})), function(t) {
    t.butt = "butt", t.square = "square", t.round = "round";
}($d867740680d9f0ee$export$71ff7619005e0377 || ($d867740680d9f0ee$export$71ff7619005e0377 = {})), function(t) {
    t.miter = "miter", t.round = "round", t.bevel = "bevel";
}($d867740680d9f0ee$export$93dad4aa23335ca1 || ($d867740680d9f0ee$export$93dad4aa23335ca1 = {})), function(t) {
    t.move = "move", t.line = "line", t.curve = "curve";
}($d867740680d9f0ee$var$a || ($d867740680d9f0ee$var$a = {})), function(t) {
    t.FRONT = "FRONT", t.SIDE = "SIDE", t.TOP = "TOP";
}($d867740680d9f0ee$export$34151b55b8cbc6dd || ($d867740680d9f0ee$export$34151b55b8cbc6dd = {})), function(t) {
    t.RIGHT = "RIGHT", t.LEFT = "LEFT", t.TOP = "TOP";
}($d867740680d9f0ee$export$d06866a9fb0606da || ($d867740680d9f0ee$export$d06866a9fb0606da = {})), function(t) {
    t.UNDEFINED = "undefined", t.NUMBER = "number";
}($d867740680d9f0ee$var$u || ($d867740680d9f0ee$var$u = {})), function(t) {
    t.MOUSE_MOVE = "mousemove", t.MOUSE_DOWN = "mousedown", t.MOUSE_UP = "mouseup", t.TOUCH_START = "touchstart", t.TOUCH_MOVE = "touchmove", t.TOUCH_END = "touchend";
}($d867740680d9f0ee$var$h || ($d867740680d9f0ee$var$h = {})), function(t) {
    t.CENTER = "center", t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom";
}($d867740680d9f0ee$var$p || ($d867740680d9f0ee$var$p = {}));
var $d867740680d9f0ee$var$O = function(t, e) {
    return $d867740680d9f0ee$var$O = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }, $d867740680d9f0ee$var$O(t, e);
};
function $d867740680d9f0ee$var$P(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    $d867740680d9f0ee$var$O(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var $d867740680d9f0ee$var$C = function() {
    return $d867740680d9f0ee$var$C = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var r in e = arguments[n])Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
    }, $d867740680d9f0ee$var$C.apply(this, arguments);
};
function $d867740680d9f0ee$var$w(t, e) {
    var n = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(i = Object.getOwnPropertySymbols(t); r < i.length; r++)e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
    }
    return n;
}
function $d867740680d9f0ee$var$A(t, e, n) {
    if (n || 2 === arguments.length) for(var i, r = 0, o = e.length; r < o; r++)!i && r in e || (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
    return t.concat(i || Array.prototype.slice.call(e));
}
"function" == typeof SuppressedError && SuppressedError;
var $d867740680d9f0ee$var$T = function(t, e) {
    var n = Math.pow(10, e);
    return Math.round(t * n) / n;
}, $d867740680d9f0ee$var$S = function(t) {
    return {
        sin: $d867740680d9f0ee$var$T(Math.sin(t), 6),
        cos: $d867740680d9f0ee$var$T(Math.cos(t), 6)
    };
}, $d867740680d9f0ee$var$j = function(t, e) {
    return {
        x: t.x - e.x,
        y: t.y - e.y
    };
}, $d867740680d9f0ee$var$M = function(t, e) {
    var n = $d867740680d9f0ee$var$j(t, e);
    return Math.sqrt(Math.pow(n.x, 2) + Math.pow(n.y, 2));
}, $d867740680d9f0ee$var$k = function(t, e, n) {
    return {
        x: t.x + Math.cos(e) * n,
        y: t.y + Math.sin(e) * n
    };
}, $d867740680d9f0ee$var$N = function(t, e) {
    var n = $d867740680d9f0ee$var$j(e, t);
    return Math.atan2(n.y, n.x);
}, $d867740680d9f0ee$var$I = .3, $d867740680d9f0ee$var$D = function(t, e, n, i) {
    var r = n.r * Math.cos($d867740680d9f0ee$var$I) - n.l * Math.sin($d867740680d9f0ee$var$I), o = n.r * Math.sin($d867740680d9f0ee$var$I) + n.l * Math.cos($d867740680d9f0ee$var$I);
    return {
        x: $d867740680d9f0ee$var$T(t + (r - o) * i * $d867740680d9f0ee$var$l, 6),
        y: $d867740680d9f0ee$var$T(e + ((r + o) / 2 - n.t) * i, 6)
    };
}, $d867740680d9f0ee$var$R = function(t, e, n) {
    var i = $d867740680d9f0ee$var$j(e, t), r = {
        x: t.x + i.x / 2,
        y: t.y + i.y / 2
    }, o = function(t, e, n) {
        var i = $d867740680d9f0ee$var$j(t, e), r = i.x * Math.cos(n) - i.y * Math.sin(n), o = i.x * Math.sin(n) + i.y * Math.cos(n);
        return {
            x: e.x + r,
            y: e.y + o
        };
    }(e, r, Math.PI / 2), a = {
        x: o.x + (n.x - o.x) / 2,
        y: o.y + (n.y - o.y) / 2
    }, s = $d867740680d9f0ee$var$M(a, r), c = $d867740680d9f0ee$var$k(a, $d867740680d9f0ee$var$N(a, o), s), u = $d867740680d9f0ee$var$k(a, $d867740680d9f0ee$var$N(a, n), s);
    return [
        $d867740680d9f0ee$var$T($d867740680d9f0ee$var$M(n, c), 6),
        $d867740680d9f0ee$var$T($d867740680d9f0ee$var$M(n, u), 6),
        $d867740680d9f0ee$var$T(180 * $d867740680d9f0ee$var$N(r, u) / Math.PI, 6)
    ];
}, $d867740680d9f0ee$var$F = function() {
    return Array.from(Array(3)).map(function() {
        return Math.random().toString(16).slice(2);
    }).join("-");
}, $d867740680d9f0ee$var$B = function(t, e) {
    return t.map(function(n, i) {
        return e[0].map(function(r, o) {
            return n.reduce(function(n, r, a) {
                return n + t[i][a] * e[a][o];
            }, 0);
        });
    });
}, $d867740680d9f0ee$var$L = function() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    for(var n = t[0], i = 1; i < t.length; i++)n = $d867740680d9f0ee$var$B(n, t[i]);
    return n;
}, $d867740680d9f0ee$var$U = function(t) {
    var e = $d867740680d9f0ee$var$S(t);
    return [
        [
            1,
            0,
            0
        ],
        [
            0,
            e.cos,
            -e.sin
        ],
        [
            0,
            e.sin,
            e.cos
        ]
    ];
}, $d867740680d9f0ee$var$V = function(t) {
    var e = $d867740680d9f0ee$var$S(t);
    return [
        [
            e.cos,
            0,
            e.sin
        ],
        [
            0,
            1,
            0
        ],
        [
            -e.sin,
            0,
            e.cos
        ]
    ];
}, $d867740680d9f0ee$var$G = function(t) {
    var e = $d867740680d9f0ee$var$S(t);
    return [
        [
            e.cos,
            -e.sin,
            0
        ],
        [
            e.sin,
            e.cos,
            0
        ],
        [
            0,
            0,
            1
        ]
    ];
}, $d867740680d9f0ee$var$z = $d867740680d9f0ee$var$L($d867740680d9f0ee$var$U($d867740680d9f0ee$var$E), $d867740680d9f0ee$var$G(-$d867740680d9f0ee$var$x)), $d867740680d9f0ee$var$X = $d867740680d9f0ee$var$L($d867740680d9f0ee$var$G(-$d867740680d9f0ee$var$_), $d867740680d9f0ee$var$U($d867740680d9f0ee$var$E), $d867740680d9f0ee$var$G($d867740680d9f0ee$var$x)), $d867740680d9f0ee$var$H = $d867740680d9f0ee$var$L($d867740680d9f0ee$var$G($d867740680d9f0ee$var$_), $d867740680d9f0ee$var$U($d867740680d9f0ee$var$E), $d867740680d9f0ee$var$G(-$d867740680d9f0ee$var$x)), $d867740680d9f0ee$var$Y = function(t, e) {
    var n = e.value * Math.PI / 180;
    switch(t){
        case $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP:
            switch(e.axis){
                case $d867740680d9f0ee$export$d06866a9fb0606da.TOP:
                    return $d867740680d9f0ee$var$G(n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.LEFT:
                    return $d867740680d9f0ee$var$U(-n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.RIGHT:
                    return $d867740680d9f0ee$var$V(n);
                default:
                    return null;
            }
        case $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT:
            switch(e.axis){
                case $d867740680d9f0ee$export$d06866a9fb0606da.TOP:
                    return $d867740680d9f0ee$var$V(n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.LEFT:
                    return $d867740680d9f0ee$var$U(n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.RIGHT:
                    return $d867740680d9f0ee$var$G(n);
                default:
                    return null;
            }
        case $d867740680d9f0ee$export$34151b55b8cbc6dd.SIDE:
            switch(e.axis){
                case $d867740680d9f0ee$export$d06866a9fb0606da.TOP:
                    return $d867740680d9f0ee$var$V(n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.LEFT:
                    return $d867740680d9f0ee$var$G(n);
                case $d867740680d9f0ee$export$d06866a9fb0606da.RIGHT:
                    return $d867740680d9f0ee$var$U(-n);
                default:
                    return null;
            }
        default:
            return null;
    }
}, $d867740680d9f0ee$var$W = function(t, e) {
    Object.keys(e).forEach(function(n) {
        t.setAttributeNS(null, n, e[n]);
    });
}, $d867740680d9f0ee$var$q = function(t) {
    return 0 === t.length || t[0].command === $d867740680d9f0ee$var$a.move ? $d867740680d9f0ee$var$A([], t, !0) : $d867740680d9f0ee$var$A([
        {
            command: $d867740680d9f0ee$var$a.move,
            point: {
                r: 0,
                l: 0,
                t: 0
            }
        }
    ], t, !0);
}, $d867740680d9f0ee$var$Q = function(t, e, n, i, r) {
    var o = $d867740680d9f0ee$var$q(t).map(function(r, o) {
        var s, c, u, h = $d867740680d9f0ee$var$D(e, n, r.point, i);
        switch(r.command){
            case $d867740680d9f0ee$var$a.move:
                return "M".concat(h.x, " ").concat(h.y);
            case $d867740680d9f0ee$var$a.line:
                return "L".concat(h.x, " ").concat(h.y);
            case $d867740680d9f0ee$var$a.curve:
                var p = $d867740680d9f0ee$var$D(e, n, t[o - 1].point, i), l = $d867740680d9f0ee$var$D(e, n, r.control, i), d = $d867740680d9f0ee$var$R(p, h, l), f = (s = p, u = h, ((c = l).y - s.y) * (u.x - c.x) - (c.x - s.x) * (u.y - c.y) >= 0 ? 0 : 1);
                return "A ".concat(d[0], " ").concat(d[1], " ").concat(d[2], " 0 ").concat(f, " ").concat(h.x, " ").concat(h.y);
        }
    });
    if (o.length) {
        var s = r ? "z" : "";
        return "".concat(o.join(" ").trim()).concat(s);
    }
    return "";
}, $d867740680d9f0ee$var$J = function(t) {
    for(var e, n = []; null !== (e = $d867740680d9f0ee$var$v.exec(t));)switch(e[5] || e[1]){
        case "M":
            n.push({
                command: $d867740680d9f0ee$var$a.move,
                point: {
                    r: +e[2],
                    l: +e[3],
                    t: +e[4]
                }
            });
            break;
        case "L":
            n.push({
                command: $d867740680d9f0ee$var$a.line,
                point: {
                    r: +e[2],
                    l: +e[3],
                    t: +e[4]
                }
            });
            break;
        case "C":
            n.push({
                command: $d867740680d9f0ee$var$a.curve,
                control: {
                    r: +e[6],
                    l: +e[7],
                    t: +e[8]
                },
                point: {
                    r: +e[9],
                    l: +e[10],
                    t: +e[11]
                }
            });
    }
    return n;
}, $d867740680d9f0ee$var$K = function(t, e, n, i) {
    t.forEach(function(t) {
        t.point.r += e, t.point.l += n, t.point.t += i, t.control && (t.control.r += e, t.control.l += n, t.control.t += i);
    });
}, $d867740680d9f0ee$var$Z = function(t) {
    return [
        "fillColor",
        "fillOpacity",
        "strokeColor",
        "strokeOpacity",
        "strokeWidth",
        "className"
    ].includes(t);
};
function $d867740680d9f0ee$var$$(t, e, n, i, r) {
    var o = {
        fn: i,
        fnBind: i.bind(this)
    };
    e.push(o), t.addEventListener(n, o.fnBind, r);
}
var $d867740680d9f0ee$var$tt, $d867740680d9f0ee$var$et = function(t, e, n, i) {
    var r = function(t, e) {
        var n = [], i = e ? $d867740680d9f0ee$var$Y(t, e) : null;
        switch(i && n.push(i), t){
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP:
                return $d867740680d9f0ee$var$L.apply(void 0, $d867740680d9f0ee$var$A([
                    $d867740680d9f0ee$var$z
                ], n, !1));
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT:
                return $d867740680d9f0ee$var$L.apply(void 0, $d867740680d9f0ee$var$A([
                    $d867740680d9f0ee$var$X
                ], n, !1));
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.SIDE:
                return $d867740680d9f0ee$var$L.apply(void 0, $d867740680d9f0ee$var$A([
                    $d867740680d9f0ee$var$H
                ], n, !1));
        }
        return null;
    }(e, i), o = "translate(".concat(t.x, " ").concat(t.y, ")");
    if (r) {
        var a = $d867740680d9f0ee$var$T(r[0][0], 6), c = $d867740680d9f0ee$var$T(r[1][0], 6), u = $d867740680d9f0ee$var$T(r[0][1], 6), h = $d867740680d9f0ee$var$T(r[1][1], 6);
        o += " matrix(".concat(a, ",").concat(c, ",").concat(u, ",").concat(h, ",0,0)"), o += " scale(".concat($d867740680d9f0ee$var$T($d867740680d9f0ee$var$b * (n || 1), 6), ")");
    } else n && (o += " scale(".concat($d867740680d9f0ee$var$T(n, 6), ")"));
    return o;
}, $d867740680d9f0ee$var$nt = function(t) {
    return !!t.parentNode && ("SVGSVGElement" === t.parentNode.constructor.name || $d867740680d9f0ee$var$nt(t.parentNode));
}, $d867740680d9f0ee$var$it = function() {
    function t(t, e, n) {
        this.sizes = {
            centerX: t / 2,
            centerY: e / 2,
            height: e,
            width: t,
            scale: n
        };
    }
    return Object.defineProperty(t.prototype, "width", {
        get: function() {
            return this.sizes.width;
        },
        set: function(t) {
            this.sizes.width = t, this.sizes.centerX = t / 2;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
        get: function() {
            return this.sizes.height;
        },
        set: function(t) {
            this.sizes.height = t, this.sizes.centerY = t / 2;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "scale", {
        get: function() {
            return this.sizes.scale;
        },
        set: function(t) {
            this.sizes.scale = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "centerX", {
        get: function() {
            return this.sizes.centerX;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "centerY", {
        get: function() {
            return this.sizes.centerY;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}(), $d867740680d9f0ee$var$rt = function(t) {
    function e(e, i) {
        var r = t.call(this) || this;
        return r._id = e, r.listeners = [], r.element = document.createElementNS($d867740680d9f0ee$var$n, i), $d867740680d9f0ee$var$W(r.element, {
            id: r._id
        }), r;
    }
    return $d867740680d9f0ee$var$P(e, t), e.prototype.setId = function(t) {
        this._id = t, $d867740680d9f0ee$var$W(this.element, {
            id: this._id
        });
    }, e.prototype.getElement = function() {
        return this.element;
    }, e.prototype.addEventListener = function(t, e, n) {
        return void 0 === n && (n = !1), $d867740680d9f0ee$var$$.call(this, this.element, this.listeners, t, e, n), this;
    }, e.prototype.removeEventListener = function(t, e, n) {
        return void 0 === n && (n = !1), function(t, e, n, i, r) {
            var o;
            e.find(function(t, n) {
                if (t.fn === i) return o = e.splice(n, 1)[0], !0;
            }), o && t.removeEventListener(n, o.fnBind, r);
        }(this.element, this.listeners, t, e, n), this;
    }, e;
}(function() {
    function t() {}
    return Object.defineProperty(t.prototype, "data", {
        get: function() {
            return this.dataStore;
        },
        set: function(t) {
            this.dataStore = t;
        },
        enumerable: !1,
        configurable: !0
    }), t;
}()), $d867740680d9f0ee$var$ot = {
    fillColor: $d867740680d9f0ee$var$i.white,
    fillOpacity: 1,
    strokeColor: $d867740680d9f0ee$var$i.black,
    strokeDashArray: [],
    strokeLinecap: $d867740680d9f0ee$export$71ff7619005e0377.butt,
    strokeLinejoin: $d867740680d9f0ee$export$93dad4aa23335ca1.round,
    strokeOpacity: 1,
    strokeWidth: 1
}, $d867740680d9f0ee$var$at = function(e) {
    function i(t, n) {
        var i = e.call(this, t.id || $d867740680d9f0ee$var$F(), n) || this;
        i.props = $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, $d867740680d9f0ee$var$ot), t), i.animations = [], i.props.texture && i.createTexture(i.props.texture);
        var r = {
            fill: i.props.texture ? "url(#".concat(i.patternId, ") ").concat(i.fillColor) : i.fillColor,
            "fill-opacity": "".concat(i.fillOpacity),
            stroke: i.strokeColor,
            "stroke-dasharray": i.strokeDashArray.join(" "),
            "stroke-linecap": i.strokeLinecap,
            "stroke-linejoin": i.strokeLinejoin,
            "stroke-opacity": "".concat(i.strokeOpacity),
            "stroke-width": "".concat(i.strokeWidth)
        };
        return i.props.className && (r.class = i.props.className), $d867740680d9f0ee$var$W(i.element, r), i;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.createTexture = function(e) {
        this.patternId = "".concat(this.id, "__texture"), this.pattern = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.pattern), $d867740680d9f0ee$var$W(this.pattern, {
            id: this.patternId,
            preserveAspectRatio: "none",
            patternUnits: "userSpaceOnUse"
        });
        var i = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.image);
        $d867740680d9f0ee$var$W(i, {
            href: e.url,
            x: "0",
            y: "0",
            preserveAspectRatio: "none"
        }), e.pixelated && $d867740680d9f0ee$var$W(i, {
            style: "image-rendering: pixelated"
        }), this.pattern.appendChild(i);
    }, i.prototype._updateTexture = function() {
        var t = this.pattern.firstChild;
        this.props.texture.url && t.getAttribute("href") !== this.props.texture.url && $d867740680d9f0ee$var$W(t, {
            href: this.props.texture.url
        }), this.props.texture.pixelated ? $d867740680d9f0ee$var$W(t, {
            style: "image-rendering: pixelated"
        }) : t.removeAttribute("style"), this.update();
    }, i.prototype.addAnimationBasicProperties = function(t, e) {
        $d867740680d9f0ee$var$W(e.element, {
            repeatCount: "".concat(e.repeat || "indefinite"),
            attributeName: t,
            dur: "".concat(e.duration || 1, "s")
        });
    }, i.prototype.updateAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if ($d867740680d9f0ee$var$Z(i.property)) {
                var r = function(t) {
                    return ({
                        fillColor: "fill",
                        fillOpacity: "fill-opacity",
                        strokeColor: "stroke",
                        strokeOpacity: "stroke-opacity",
                        strokeWidth: "stroke-width",
                        className: "class"
                    })[t];
                }(i.property);
                i.element || (i.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties(r, i), i.values ? $d867740680d9f0ee$var$W(i.element, {
                    values: Array.isArray(i.values) ? i.values.map(function(t) {
                        return "".concat(t);
                    }).join(";") : "".concat(i.values)
                }) : $d867740680d9f0ee$var$W(i.element, {
                    from: "".concat(i.from),
                    to: "".concat(i.to)
                });
            }
        }), this.updateSubClassAnimations(), this.updateAnimations2();
    }, i.prototype.updatePatternTransform = function(t, e) {
        var n, i, r;
        if (this.props.texture) {
            var o = this.props.texture.height ? "".concat(this.props.texture.height * this.data.scale) : "100%", a = this.props.texture.width ? "".concat(this.props.texture.width * this.data.scale) : "100%", s = $d867740680d9f0ee$var$D(0, 0, {
                r: (null === (n = this.props.texture.shift) || void 0 === n ? void 0 : n.right) || 0,
                l: (null === (i = this.props.texture.shift) || void 0 === i ? void 0 : i.left) || 0,
                t: (null === (r = this.props.texture.shift) || void 0 === r ? void 0 : r.top) || 0
            }, this.data.scale), c = $d867740680d9f0ee$var$et({
                x: $d867740680d9f0ee$var$T(t.x + s.x, 6),
                y: $d867740680d9f0ee$var$T(t.y + s.y, 6)
            }, this.props.texture.planeView || e, this.props.texture.scale, this.props.texture.rotation);
            $d867740680d9f0ee$var$W(this.pattern, {
                patternTransform: c,
                height: o,
                width: a
            }), $d867740680d9f0ee$var$W(this.pattern.firstChild, {
                height: o,
                width: a
            });
        }
    }, Object.defineProperty(i.prototype, "id", {
        get: function() {
            return this._id;
        },
        set: function(t) {
            this.setId(t), this.pattern && (this.patternId = "".concat(this.id, "__texture"), $d867740680d9f0ee$var$W(this.pattern, {
                id: this.patternId
            }));
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fillColor", {
        get: function() {
            return this.props.fillColor;
        },
        set: function(t) {
            this.props.fillColor = t, $d867740680d9f0ee$var$W(this.element, {
                fill: this.props.texture ? "url(#".concat(this.patternId, ") ").concat(this.fillColor) : this.fillColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fillOpacity", {
        get: function() {
            return this.props.fillOpacity;
        },
        set: function(t) {
            this.props.fillOpacity = t, $d867740680d9f0ee$var$W(this.element, {
                "fill-opacity": "".concat(this.fillOpacity)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "texture", {
        get: function() {
            return this.props.texture;
        },
        set: function(t) {
            var e = !!this.props.texture;
            this.props.texture = t, e ? this._updateTexture() : (this.createTexture(this.props.texture), this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeColor", {
        get: function() {
            return this.props.strokeColor;
        },
        set: function(t) {
            this.props.strokeColor = t, $d867740680d9f0ee$var$W(this.element, {
                stroke: this.strokeColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeDashArray", {
        get: function() {
            return this.props.strokeDashArray;
        },
        set: function(t) {
            this.props.strokeDashArray = t, $d867740680d9f0ee$var$W(this.element, {
                "stroke-dasharray": this.strokeDashArray.join(" ")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeLinecap", {
        get: function() {
            return this.props.strokeLinecap;
        },
        set: function(t) {
            this.props.strokeLinecap = $d867740680d9f0ee$export$71ff7619005e0377[t], $d867740680d9f0ee$var$W(this.element, {
                "stroke-linecap": this.strokeLinecap
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeLinejoin", {
        get: function() {
            return this.props.strokeLinejoin;
        },
        set: function(t) {
            this.props.strokeLinejoin = $d867740680d9f0ee$export$93dad4aa23335ca1[t], $d867740680d9f0ee$var$W(this.element, {
                "stroke-linejoin": this.strokeLinejoin
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeOpacity", {
        get: function() {
            return this.props.strokeOpacity;
        },
        set: function(t) {
            this.props.strokeOpacity = t, $d867740680d9f0ee$var$W(this.element, {
                "stroke-opacity": "".concat(this.strokeOpacity)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "strokeWidth", {
        get: function() {
            return this.props.strokeWidth;
        },
        set: function(t) {
            this.props.strokeWidth = t, $d867740680d9f0ee$var$W(this.element, {
                "stroke-width": "".concat(this.strokeWidth)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "className", {
        get: function() {
            return this.props.className;
        },
        set: function(t) {
            this.props.className = t, $d867740680d9f0ee$var$W(this.element, {
                class: this.props.className
            });
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.getPattern = function() {
        return this.pattern;
    }, i.prototype.updateTexture = function(t) {
        var e = !!this.props.texture;
        if (e || t.url) {
            var n = t.shift, i = t.rotation, r = $d867740680d9f0ee$var$w(t, [
                "shift",
                "rotation"
            ]);
            this.props.texture = $d867740680d9f0ee$var$C(e ? $d867740680d9f0ee$var$C({}, this.props.texture) : {}, r), n && (this.props.texture.shift = $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, this.props.texture.shift || {}), n)), i && (this.props.texture.rotation = i), e ? this._updateTexture() : (this.createTexture(this.props.texture), this.update());
        }
        return this;
    }, i.prototype.addAnimation = function(t) {
        return this.animations.push($d867740680d9f0ee$var$C({}, t)), this.update(), this;
    }, i.prototype.removeAnimationByIndex = function(t) {
        if (t >= 0 && t < this.animations.length) {
            var e = this.animations.splice(t, 1)[0];
            e.element && e.element.parentNode && e.element.parentNode.removeChild(e.element);
        }
        return this;
    }, i.prototype.removeAnimations = function() {
        return this.animations.splice(0).forEach(function(t) {
            t.element && t.element.parentNode && t.element.parentNode.removeChild(t.element);
        }), this;
    }, i;
}($d867740680d9f0ee$var$rt), $d867740680d9f0ee$var$st = function(t) {
    function e(e, n) {
        var i = t.call(this, e, n) || this;
        return i._children = [], i;
    }
    return $d867740680d9f0ee$var$P(e, t), e.prototype.getChildIndex = function(t) {
        return this._children.indexOf(t);
    }, e.prototype.throwChildError = function() {
        throw new Error("You cannot provide a child that is not a children of the container");
    }, e.prototype.removeSVGChild = function(t) {
        var e = t.getElement();
        if (t instanceof $d867740680d9f0ee$var$at) {
            var n = t.getPattern();
            n && n.parentNode && this.element.removeChild(n);
        }
        e.parentNode && this.element.removeChild(e);
    }, e.prototype.insertPattern = function(t) {
        t && this.element.insertBefore(t, this.element.firstChild);
    }, Object.defineProperty(e.prototype, "id", {
        get: function() {
            return this._id;
        },
        set: function(t) {
            this.setId(t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "children", {
        get: function() {
            return this._children;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.update = function() {
        var t = this;
        return $d867740680d9f0ee$var$nt(this.element) && this._children.forEach(function(e) {
            e.data = t.data, e.update();
        }), this;
    }, e.prototype.clear = function() {
        var t = this;
        return this._children.splice(0).forEach(function(e) {
            t.removeSVGChild(e);
        }), this;
    }, e.prototype.addChild = function(t) {
        return t.data = this.data, this._children.push(t), t instanceof $d867740680d9f0ee$var$at && this.insertPattern(t.getPattern()), this.element.appendChild(t.getElement()), t.update(), this;
    }, e.prototype.addChildren = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        return e.forEach(function(e) {
            return t.addChild(e);
        }), this;
    }, e.prototype.getChildByIndex = function(t) {
        return this._children[t] || null;
    }, e.prototype.getChildById = function(t) {
        return this._children.find(function(e) {
            return e.id === t;
        }) || null;
    }, e.prototype.removeChild = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return this._children.splice(e, 1), this.removeSVGChild(t), this;
        this.throwChildError();
    }, e.prototype.removeChildren = function() {
        for(var t = this, e = [], n = 0; n < arguments.length; n++)e[n] = arguments[n];
        return e.forEach(function(e) {
            -1 === t.getChildIndex(e) && t.throwChildError(), t.removeChild(e);
        }), this;
    }, e.prototype.removeChildByIndex = function(t) {
        if (t >= 0 && t < this._children.length) {
            var e = this._children.splice(t, 1)[0];
            this.removeSVGChild(e);
        }
        return this;
    }, e.prototype.removeChildById = function(t) {
        var e = this.getChildById(t);
        if (e) return this.removeChild(e);
    }, e.prototype.setChildIndex = function(t, e) {
        var n = this.getChildIndex(t);
        if (n > -1) {
            e = Math.min(Math.max(0, e), this._children.length - 1);
            var i = t.getElement(), r = this._children[e].getElement();
            return this._children[e] !== t && (this._children.splice(n, 1), this._children.splice(e, 0, t), n > e ? this.element.insertBefore(i, r) : r.nextSibling ? this.element.insertBefore(i, r.nextSibling) : this.element.appendChild(i)), this;
        }
        this.throwChildError();
    }, e.prototype.bringChildToFront = function(t) {
        if (this.getChildIndex(t) > -1) return this.setChildIndex(t, this._children.length - 1), this;
        this.throwChildError();
    }, e.prototype.bringChildForward = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return e < this._children.length - 1 && this.setChildIndex(t, e + 1), this;
        this.throwChildError();
    }, e.prototype.sendChildToBack = function(t) {
        if (this.getChildIndex(t) > -1) return this.setChildIndex(t, 0), this;
        this.throwChildError();
    }, e.prototype.sendChildBackward = function(t) {
        var e = this.getChildIndex(t);
        if (e > -1) return e > 0 && this.setChildIndex(t, e - 1), this;
        this.throwChildError();
    }, e;
}($d867740680d9f0ee$var$rt), $d867740680d9f0ee$var$ct = {
    container: "body",
    backgroundColor: $d867740680d9f0ee$var$i.white,
    scale: 1,
    height: 480,
    width: 640
}, $d867740680d9f0ee$export$e3e1252f38307002 = function(i) {
    function r(r) {
        var o;
        void 0 === r && (r = {});
        var a = i.call(this, r.id || $d867740680d9f0ee$var$F(), $d867740680d9f0ee$var$t.svg) || this;
        return a.props = $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, $d867740680d9f0ee$var$ct), r), a.isAnimated = !0, a.data = new $d867740680d9f0ee$var$it(a.props.width, a.props.height, a.props.scale), $d867740680d9f0ee$var$W(a.element, ((o = {})[$d867740680d9f0ee$var$e.viewBox] = "0 0 ".concat(a.data.width, " ").concat(a.data.height), o.width = "".concat(a.data.width, "px"), o.height = "".concat(a.data.height, "px"), o)), a.background = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.rect), $d867740680d9f0ee$var$W(a.background, {
            fill: a.backgroundColor,
            x: "0",
            y: "0",
            width: "".concat(a.data.width, "px"),
            height: "".concat(a.data.height, "px")
        }), a.element.appendChild(a.background), ("string" == typeof a.props.container ? document.querySelector(a.props.container) : a.props.container).appendChild(a.element), a;
    }
    return $d867740680d9f0ee$var$P(r, i), Object.defineProperty(r.prototype, "backgroundColor", {
        get: function() {
            return this.props.backgroundColor;
        },
        set: function(t) {
            this.props.backgroundColor = t, $d867740680d9f0ee$var$W(this.background, {
                fill: this.backgroundColor
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "scale", {
        get: function() {
            return this.data.scale;
        },
        set: function(t) {
            this.data.scale = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "height", {
        get: function() {
            return this.data.height;
        },
        set: function(t) {
            var n;
            this.data.height = t, $d867740680d9f0ee$var$W(this.element, ((n = {})[$d867740680d9f0ee$var$e.viewBox] = "0 0 ".concat(this.data.width, " ").concat(this.data.height), n.height = "".concat(this.data.height, "px"), n)), $d867740680d9f0ee$var$W(this.background, {
                height: "".concat(this.data.height, "px")
            }), this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "width", {
        get: function() {
            return this.data.width;
        },
        set: function(t) {
            var n;
            this.data.width = t, $d867740680d9f0ee$var$W(this.element, ((n = {})[$d867740680d9f0ee$var$e.viewBox] = "0 0 ".concat(this.data.width, " ").concat(this.data.height), n.width = "".concat(this.data.width, "px"), n)), $d867740680d9f0ee$var$W(this.background, {
                width: "".concat(this.data.width, "px")
            }), this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(r.prototype, "animated", {
        get: function() {
            return this.isAnimated;
        },
        enumerable: !1,
        configurable: !0
    }), r.prototype.getSVGCode = function() {
        return this.element.outerHTML;
    }, r.prototype.pauseAnimations = function() {
        var t = this.element;
        return "function" == typeof t.pauseAnimations && t.pauseAnimations(), this.isAnimated = !1, this;
    }, r.prototype.resumeAnimations = function() {
        var t = this.element;
        return "function" == typeof t.unpauseAnimations && t.unpauseAnimations(), this.isAnimated = !0, this;
    }, r;
}($d867740680d9f0ee$var$st), $d867740680d9f0ee$var$ht = function(t, e) {
    Object.getOwnPropertyNames(e.prototype).forEach(function(n) {
        Object.defineProperty(t.prototype, n, Object.getOwnPropertyDescriptor(e.prototype, n));
    });
}, $d867740680d9f0ee$var$pt = [
    Number.MIN_SAFE_INTEGER,
    Number.MAX_SAFE_INTEGER
];
!function(t) {
    t.DRAG_START = "dragstart", t.DRAG = "drag", t.DRAG_END = "dragend";
}($d867740680d9f0ee$var$tt || ($d867740680d9f0ee$var$tt = {}));
var $d867740680d9f0ee$var$lt = typeof window !== $d867740680d9f0ee$var$u.UNDEFINED, $d867740680d9f0ee$var$dt = $d867740680d9f0ee$var$lt ? window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame : null, $d867740680d9f0ee$var$ft = {
    right: 0,
    left: 0,
    top: 0,
    x: 0,
    y: 0
}, $d867740680d9f0ee$var$mt = function(t) {
    return t instanceof Event ? function(t) {
        return "clientX" in t;
    }(t) ? {
        clientX: t.clientX,
        clientY: t.clientY
    } : {
        clientX: t.touches[0].clientX,
        clientY: t.touches[0].clientY
    } : t;
}, $d867740680d9f0ee$var$yt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $d867740680d9f0ee$var$P(e, t), e.prototype.setup = function() {
        this.startDrag = this.startDrag.bind(this), this.stopDrag = this.stopDrag.bind(this), this.moveElement = this.moveElement.bind(this), this.dropElement = this.dropElement.bind(this), this.animate = this.animate.bind(this), typeof this._bounds === $d867740680d9f0ee$var$u.UNDEFINED && (this._bounds = !1), typeof this._dragStore === $d867740680d9f0ee$var$u.UNDEFINED && (this._dragStore = $d867740680d9f0ee$var$ft), typeof this._coords === $d867740680d9f0ee$var$u.UNDEFINED && (this._coords = {});
    }, e.prototype.betweenBounds = function(t, e) {
        var n = $d867740680d9f0ee$var$A([], e, !0).sort();
        return $d867740680d9f0ee$var$T(Math.min(Math.max(t, n[0]), n[1]), 6);
    }, e.prototype.getBoundOrMaximum = function(t) {
        var e;
        return this.bounds && null !== (e = this.bounds[t]) && void 0 !== e ? e : $d867740680d9f0ee$var$A([], $d867740680d9f0ee$var$pt, !0);
    }, e.prototype.getRight = function(t) {
        var e = this.getBoundOrMaximum("right");
        return this.betweenBounds(this._dragStore.right + t / this.data.scale, e);
    }, e.prototype.getLeft = function(t) {
        var e = this.getBoundOrMaximum("left");
        return this.betweenBounds(this._dragStore.left + t / this.data.scale, e);
    }, e.prototype.getTop = function(t) {
        var e = this.getBoundOrMaximum("top");
        return this.betweenBounds(this._dragStore.top + t / this.data.scale, e);
    }, e.prototype.getFixedCoordinates = function(t) {
        var e = this;
        return Object.entries(t).reduce(function(t, n) {
            var i = $d867740680d9f0ee$var$C({}, t);
            switch(n[0]){
                case "right":
                    i.right = e.getRight(n[1]);
                    break;
                case "left":
                    i.left = e.getLeft(n[1]);
                    break;
                default:
                    i.top = e.getTop(n[1]);
            }
            return i;
        }, {});
    }, e.prototype.dispatchEvent = function(t) {
        var e, n, i, r = new CustomEvent(t, {
            cancelable: t === $d867740680d9f0ee$var$tt.DRAG,
            detail: {
                right: null !== (e = this._coords.right) && void 0 !== e ? e : this.right,
                left: null !== (n = this._coords.left) && void 0 !== n ? n : this.left,
                top: null !== (i = this._coords.top) && void 0 !== i ? i : this.top
            }
        });
        return this.element.dispatchEvent(r), r;
    }, e.prototype.animate = function() {
        this._update && (this._prevented || (typeof this._coords.right === $d867740680d9f0ee$var$u.NUMBER && (this.right = this._coords.right), typeof this._coords.left === $d867740680d9f0ee$var$u.NUMBER && (this.left = this._coords.left), typeof this._coords.top === $d867740680d9f0ee$var$u.NUMBER && (this.top = this._coords.top)), $d867740680d9f0ee$var$dt(this.animate));
    }, e.prototype.startDrag = function(t) {
        t.preventDefault();
        var e = $d867740680d9f0ee$var$mt(t), n = e.clientX, i = e.clientY;
        this._dragStore.x = n, this._dragStore.y = i, this._dragStore.right = this.right, this._dragStore.left = this.left, this._dragStore.top = this.top, this._update = !0, this.moveElement({
            clientX: n,
            clientY: i
        }), this.element.addEventListener($d867740680d9f0ee$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.addEventListener($d867740680d9f0ee$var$h.TOUCH_END, this.dropElement, !0), document.addEventListener($d867740680d9f0ee$var$h.MOUSE_MOVE, this.moveElement, !0), document.addEventListener($d867740680d9f0ee$var$h.MOUSE_UP, this.dropElement, !0), $d867740680d9f0ee$var$dt(this.animate);
    }, e.prototype.moveElement = function(t) {
        var e, n, i, r = $d867740680d9f0ee$var$mt(t), o = r.clientX, a = r.clientY, c = o - this._dragStore.x, u = a - this._dragStore.y;
        this._drag === $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP ? this._coords = this.getFixedCoordinates({
            right: n = (2 * u + (e = c / $d867740680d9f0ee$var$l)) / 2,
            left: n - e
        }) : this._drag === $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT ? this._coords = this.getFixedCoordinates(function(t, e) {
            var n = -t / $d867740680d9f0ee$var$l;
            return {
                left: n,
                top: n / 2 - e
            };
        }(c, u)) : this._coords = this.getFixedCoordinates(function(t, e) {
            var n = t / $d867740680d9f0ee$var$l;
            return {
                right: n,
                top: n / 2 - e
            };
        }(c, u)), t instanceof Event && (t.preventDefault(), this._dragging || this.dispatchEvent($d867740680d9f0ee$var$tt.DRAG_START), this._dragging = !0, i = this.dispatchEvent($d867740680d9f0ee$var$tt.DRAG)), this._prevented = !(!i || !i.defaultPrevented);
    }, e.prototype.dropElement = function() {
        this._update = !1, this._dragging = !1, this.element.removeEventListener($d867740680d9f0ee$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.removeEventListener($d867740680d9f0ee$var$h.TOUCH_END, this.dropElement, !0), document.removeEventListener($d867740680d9f0ee$var$h.MOUSE_MOVE, this.moveElement, !0), document.removeEventListener($d867740680d9f0ee$var$h.MOUSE_UP, this.dropElement, !0), this.dispatchEvent($d867740680d9f0ee$var$tt.DRAG_END);
    }, e.prototype.beginDrag = function() {
        this.element.addEventListener($d867740680d9f0ee$var$h.TOUCH_START, this.startDrag, !0), this.element.addEventListener($d867740680d9f0ee$var$h.MOUSE_DOWN, this.startDrag, !0);
    }, e.prototype.stopDrag = function() {
        this.element.removeEventListener($d867740680d9f0ee$var$h.TOUCH_START, this.startDrag, !0), this.element.removeEventListener($d867740680d9f0ee$var$h.TOUCH_MOVE, this.moveElement, !0), this.element.removeEventListener($d867740680d9f0ee$var$h.TOUCH_END, this.dropElement, !0), this.element.removeEventListener($d867740680d9f0ee$var$h.MOUSE_DOWN, this.startDrag, !0), document.removeEventListener($d867740680d9f0ee$var$h.MOUSE_MOVE, this.moveElement, !0), document.removeEventListener($d867740680d9f0ee$var$h.MOUSE_UP, this.dropElement, !0);
    }, Object.defineProperty(e.prototype, "right", {
        get: function() {
            return this.props.right;
        },
        set: function(t) {
            this.props.right !== t && (this.props.right = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "left", {
        get: function() {
            return this.props.left;
        },
        set: function(t) {
            this.props.left !== t && (this.props.left = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "top", {
        get: function() {
            return this.props.top;
        },
        set: function(t) {
            this.props.top !== t && (this.props.top = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "drag", {
        get: function() {
            return this._drag || !1;
        },
        set: function(t) {
            typeof this._drag === $d867740680d9f0ee$var$u.UNDEFINED && this.setup(), this._drag = t, $d867740680d9f0ee$var$lt && (this.stopDrag(), this.beginDrag());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "bounds", {
        get: function() {
            return this._bounds || !1;
        },
        set: function(t) {
            this._bounds = t;
            var e = this.getBoundOrMaximum("right"), n = this.getBoundOrMaximum("left"), i = this.getBoundOrMaximum("top");
            this.right = this.betweenBounds(this.right, e), this.left = this.betweenBounds(this.left, n), this.top = this.betweenBounds(this.top, i);
        },
        enumerable: !1,
        configurable: !0
    }), e;
}($d867740680d9f0ee$var$rt), $d867740680d9f0ee$var$gt = {
    right: 0,
    left: 0,
    top: 0
}, $d867740680d9f0ee$export$d223442bf82eaf54 = function(e) {
    function n(n) {
        void 0 === n && (n = {});
        var i = e.call(this, n.id || $d867740680d9f0ee$var$F(), $d867740680d9f0ee$var$t.group) || this;
        return i.props = $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, $d867740680d9f0ee$var$gt), n), i;
    }
    return $d867740680d9f0ee$var$P(n, e), n.prototype.update = function() {
        if ($d867740680d9f0ee$var$nt(this.element)) {
            var t = $d867740680d9f0ee$var$D(0, 0, {
                r: this.props.right,
                l: this.props.left,
                t: this.props.top
            }, this.data.scale);
            $d867740680d9f0ee$var$W(this.element, {
                transform: "translate(".concat(t.x, ", ").concat(t.y, ")")
            });
        }
        return e.prototype.update.call(this);
    }, n;
}($d867740680d9f0ee$var$st);
$d867740680d9f0ee$var$ht($d867740680d9f0ee$export$d223442bf82eaf54, $d867740680d9f0ee$var$yt);
var $d867740680d9f0ee$var$bt = function(t) {
    function e(e, n) {
        return t.call(this, e, n) || this;
    }
    return $d867740680d9f0ee$var$P(e, t), e.prototype.updateGraphic = function(t, e) {
        if (void 0 === e && (e = !0), $d867740680d9f0ee$var$nt(this.element)) {
            var n = this.getCommands(), i = function(t, e, n, i) {
                var r = {
                    x: Number.MAX_SAFE_INTEGER,
                    y: Number.MAX_SAFE_INTEGER
                };
                return $d867740680d9f0ee$var$q(t).forEach(function(t) {
                    var o = $d867740680d9f0ee$var$D(e, n, t.point, i);
                    (o.x < r.x || o.x === r.x && o.y < r.y) && (r.x = o.x, r.y = o.y);
                }), r;
            }(n, this.data.centerX, this.data.centerY, this.data.scale);
            $d867740680d9f0ee$var$W(this.element, {
                d: $d867740680d9f0ee$var$Q(n, this.data.centerX, this.data.centerY, this.data.scale, e)
            }), this.updatePatternTransform(i, t), this.updateAnimations();
        }
    }, e;
}($d867740680d9f0ee$var$at), $d867740680d9f0ee$var$_t = {
    right: 0,
    left: 0,
    top: 0
}, $d867740680d9f0ee$var$xt = function(e) {
    function n(n) {
        return e.call(this, $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, $d867740680d9f0ee$var$_t), n), $d867740680d9f0ee$var$t.path) || this;
    }
    return $d867740680d9f0ee$var$P(n, e), n.prototype.update = function() {
        return this.updateGraphic(this.planeView), this;
    }, n.prototype.clear = function() {
        return $d867740680d9f0ee$var$W(this.element, {
            d: ""
        }), this;
    }, Object.defineProperty(n.prototype, "planeView", {
        get: function() {
            return this.props.planeView;
        },
        set: function(t) {
            this.props.planeView = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), n;
}($d867740680d9f0ee$var$bt);
$d867740680d9f0ee$var$ht($d867740680d9f0ee$var$xt, $d867740680d9f0ee$var$yt);
var $d867740680d9f0ee$export$f54a3aa3bdb4a9c8 = function(e) {
    function i(t) {
        var n = this, i = t.height, r = t.width, o = $d867740680d9f0ee$var$w(t, [
            "height",
            "width"
        ]);
        return (n = e.call(this, o) || this)._width = r, n._height = i, n;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o, c = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, u = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, h = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, p = null !== (r = null == t ? void 0 : t.width) && void 0 !== r ? r : this.width, l = null !== (o = null == t ? void 0 : t.height) && void 0 !== o ? o : this.height, d = [
            {
                command: $d867740680d9f0ee$var$a.move,
                point: {
                    r: 0,
                    l: 0,
                    t: 0
                }
            }
        ];
        switch(this.planeView){
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT:
                d.push({
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: 0,
                        l: p,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: 0,
                        l: p,
                        t: l
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: 0,
                        l: 0,
                        t: l
                    }
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.SIDE:
                d.push({
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: l
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: 0,
                        l: 0,
                        t: l
                    }
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP:
                d.push({
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: p,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: p,
                        l: l,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.line,
                    point: {
                        r: 0,
                        l: l,
                        t: 0
                    }
                });
        }
        return $d867740680d9f0ee$var$K(d, c, u, h), d;
    }, i.prototype.getRectanglePath = function(t) {
        var e = this.getCommands(t);
        return $d867740680d9f0ee$var$Q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$d867740680d9f0ee$var$Z(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    width: e.width,
                    height: e.height
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $d867740680d9f0ee$var$C({}, r);
                                return n[o] = +t, e.getRectanglePath(n);
                            }).join(";")
                        };
                        else {
                            var s = $d867740680d9f0ee$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getRectanglePath(s)
                            };
                        }
                    } else {
                        var c = $d867740680d9f0ee$var$C({}, r), u = $d867740680d9f0ee$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getRectanglePath(c),
                            to: e.getRectanglePath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $d867740680d9f0ee$var$W(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "width", {
        get: function() {
            return this._width;
        },
        set: function(t) {
            this._width = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "height", {
        get: function() {
            return this._height;
        },
        set: function(t) {
            this._height = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.animateDimensions = function(t, e) {
        return void 0 === e && (e = 1), this._animInfo = {
            dims: t,
            duration: e
        }, this;
    }, i.prototype.updateAnimations2 = function() {
        var e = this;
        if (this._animInfo) {
            var i = this._animInfo, r = i.dims, o = i.duration, a = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate);
            this.element.appendChild(a);
            var s = {
                repeatCount: "indefinite",
                attributeName: "d",
                dur: "".concat(o, "s"),
                values: r.map(function(t) {
                    return e.getRectanglePath(t);
                }).join(";")
            };
            $d867740680d9f0ee$var$W(a, s);
        }
    }, i;
}($d867740680d9f0ee$var$xt), $d867740680d9f0ee$export$77cf72652ee46fc7 = function(e) {
    function i(t) {
        var n = this, i = t.radius, r = $d867740680d9f0ee$var$w(t, [
            "radius"
        ]);
        return (n = e.call(this, r) || this)._radius = i, n;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, c = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, u = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, h = null !== (r = null == t ? void 0 : t.radius) && void 0 !== r ? r : this.radius, p = [];
        switch(this.planeView){
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT:
                p.push({
                    command: $d867740680d9f0ee$var$a.move,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: 0,
                        l: -h,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: -h
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: h
                    }
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.SIDE:
                p.push({
                    command: $d867740680d9f0ee$var$a.move,
                    point: {
                        r: -h,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: h,
                        l: 0,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: -h
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: -h,
                        l: 0,
                        t: 0
                    },
                    control: {
                        r: 0,
                        l: 0,
                        t: h
                    }
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP:
                p.push({
                    command: $d867740680d9f0ee$var$a.move,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: 0,
                        l: -h,
                        t: 0
                    },
                    control: {
                        r: h,
                        l: 0,
                        t: 0
                    }
                }, {
                    command: $d867740680d9f0ee$var$a.curve,
                    point: {
                        r: 0,
                        l: h,
                        t: 0
                    },
                    control: {
                        r: -h,
                        l: 0,
                        t: 0
                    }
                });
        }
        return $d867740680d9f0ee$var$K(p, o, c, u), p;
    }, i.prototype.getCirclePath = function(t) {
        var e = this.getCommands(t);
        return $d867740680d9f0ee$var$Q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$d867740680d9f0ee$var$Z(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    radius: e.radius
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $d867740680d9f0ee$var$C({}, r);
                                return n[o] = +t, e.getCirclePath(n);
                            }).join(";")
                        };
                        else {
                            var s = $d867740680d9f0ee$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getCirclePath(s)
                            };
                        }
                    } else {
                        var c = $d867740680d9f0ee$var$C({}, r), u = $d867740680d9f0ee$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getCirclePath(c),
                            to: e.getCirclePath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $d867740680d9f0ee$var$W(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "radius", {
        get: function() {
            return this._radius;
        },
        set: function(t) {
            this._radius = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.updateAnimations2 = function() {}, i;
}($d867740680d9f0ee$var$xt), $d867740680d9f0ee$var$Pt = function(e) {
    function i(t) {
        var n = this, i = t.radius, r = t.points, o = t.density, a = t.rotation, s = void 0 === a ? 0 : a, c = $d867740680d9f0ee$var$w(t, [
            "radius",
            "points",
            "density",
            "rotation"
        ]);
        return (n = e.call(this, c) || this)._radius = i, n._points = r, n._density = o, n._rotation = s, n._sector = 2 * Math.PI / n._points, n._halfSector = n._sector / 2, n;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.getCommands = function(t) {
        var e, n, i, r, o, c, u, h = null !== (e = null == t ? void 0 : t.right) && void 0 !== e ? e : this.right, p = null !== (n = null == t ? void 0 : t.left) && void 0 !== n ? n : this.left, l = null !== (i = null == t ? void 0 : t.top) && void 0 !== i ? i : this.top, d = null !== (r = null == t ? void 0 : t.radius) && void 0 !== r ? r : this.radius, f = null !== (o = null == t ? void 0 : t.points) && void 0 !== o ? o : this._points, m = null !== (c = null == t ? void 0 : t.density) && void 0 !== c ? c : this._density, y = null !== (u = null == t ? void 0 : t.rotation) && void 0 !== u ? u : this.rotation, g = this.get2DCoordinates(d, f, m, y), v = [];
        switch(this.planeView){
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.FRONT:
                g.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $d867740680d9f0ee$var$a.move : $d867740680d9f0ee$var$a.line,
                        point: {
                            r: 0,
                            l: t.x,
                            t: t.y
                        }
                    });
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.SIDE:
                g.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $d867740680d9f0ee$var$a.move : $d867740680d9f0ee$var$a.line,
                        point: {
                            r: t.x,
                            l: 0,
                            t: t.y
                        }
                    });
                });
                break;
            case $d867740680d9f0ee$export$34151b55b8cbc6dd.TOP:
                g.forEach(function(t, e) {
                    v.push({
                        command: 0 === e ? $d867740680d9f0ee$var$a.move : $d867740680d9f0ee$var$a.line,
                        point: {
                            r: -t.x,
                            l: -t.y,
                            t: 0
                        }
                    });
                });
        }
        return $d867740680d9f0ee$var$K(v, h, p, l), v;
    }, i.prototype._getRadianAngle = function(t) {
        return t * Math.PI / 180;
    }, i.prototype._getInnerRadius = function(t, e, n) {
        return t * Math.cos(Math.PI * n / e) / Math.cos(Math.PI * (n - 1) / e);
    }, i.prototype.get2DCoordinates = function(t, e, n, i) {
        var r = this, o = this._getInnerRadius(t, e, n);
        return $d867740680d9f0ee$var$A([], Array(this._points), !0).reduce(function(e, n, a) {
            var s = a * r._sector + 2 * Math.PI - r._getRadianAngle(i), c = s + r._halfSector, u = Math.sin(s) * t, h = Math.cos(s) * t, p = Math.sin(c) * o, l = Math.cos(c) * o;
            return $d867740680d9f0ee$var$A($d867740680d9f0ee$var$A([], e, !0), [
                {
                    x: u,
                    y: h
                },
                {
                    x: p,
                    y: l
                }
            ], !1);
        }, []);
    }, i.prototype.getPentagramPath = function(t) {
        var e = this.getCommands(t);
        return $d867740680d9f0ee$var$Q(e, this.data.centerX, this.data.centerY, this.data.scale, !0);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if (!$d867740680d9f0ee$var$Z(i.property)) {
                var r = {
                    right: e.right,
                    left: e.left,
                    top: e.top,
                    radius: e.radius,
                    points: e._points,
                    density: e._density,
                    rotation: e.rotation
                };
                if (Object.prototype.hasOwnProperty.call(r, i.property)) {
                    var o = i.property, a = void 0;
                    if (i.values) {
                        if (Array.isArray(i.values)) a = {
                            values: i.values.map(function(t) {
                                var n = $d867740680d9f0ee$var$C({}, r);
                                return n[o] = +t, e.getPentagramPath(n);
                            }).join(";")
                        };
                        else {
                            var s = $d867740680d9f0ee$var$C({}, r);
                            s[o] = +i.values, a = {
                                values: e.getPentagramPath(s)
                            };
                        }
                    } else {
                        var c = $d867740680d9f0ee$var$C({}, r), u = $d867740680d9f0ee$var$C({}, r);
                        c[o] = +i.from, u[o] = +i.to, a = {
                            from: e.getPentagramPath(c),
                            to: e.getPentagramPath(u)
                        };
                    }
                    i.element || (i.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $d867740680d9f0ee$var$W(i.element, a);
                }
            }
        });
    }, Object.defineProperty(i.prototype, "radius", {
        get: function() {
            return this._radius;
        },
        set: function(t) {
            this._radius = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "rotation", {
        get: function() {
            return this._rotation;
        },
        set: function(t) {
            this._rotation = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i;
}($d867740680d9f0ee$var$xt), $d867740680d9f0ee$export$893c7f23d4115570 = function(t) {
    function e(e) {
        return t.call(this, $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, e), {
            points: 5,
            density: 2
        })) || this;
    }
    return $d867740680d9f0ee$var$P(e, t), e.prototype.updateAnimations2 = function() {}, e;
}($d867740680d9f0ee$var$Pt), $d867740680d9f0ee$export$d3c4444c1d97c361 = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $d867740680d9f0ee$var$P(e, t), Object.defineProperty(e.prototype, "points", {
        get: function() {
            return this._points;
        },
        set: function(t) {
            this._points = t, this._sector = 2 * Math.PI / this._points, this._halfSector = this._sector / 2, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "density", {
        get: function() {
            return this._density;
        },
        set: function(t) {
            this._density = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.updateAnimations2 = function() {}, e;
}($d867740680d9f0ee$var$Pt), $d867740680d9f0ee$export$271c527cab8eab68 = function(e) {
    function i(n) {
        void 0 === n && (n = {});
        var i = e.call(this, n, $d867740680d9f0ee$var$t.path) || this;
        return i.getPathFromCommands = function(t) {
            return $d867740680d9f0ee$var$Q($d867740680d9f0ee$var$J(t), i.data.centerX, i.data.centerY, i.data.scale, i._autoclose);
        }, i.commands = [], i._autoclose = !("autoclose" in n) || n.autoclose, i;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.updateSubClassAnimations = function() {
        var e = this;
        this.animations.forEach(function(i) {
            if ("path" === i.property) {
                var r = void 0;
                r = i.values ? {
                    values: Array.isArray(i.values) ? i.values.map(function(t) {
                        return e.getPathFromCommands("".concat(t));
                    }).join(";") : e.getPathFromCommands("".concat(i.values))
                } : {
                    from: e.getPathFromCommands("".concat(i.from)),
                    to: e.getPathFromCommands("".concat(i.to))
                }, i.element || (i.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animate)), i.element.parentNode || e.element.appendChild(i.element), e.addAnimationBasicProperties("d", i), $d867740680d9f0ee$var$W(i.element, r);
            }
        });
    }, i.prototype.getCommands = function() {
        return this.commands;
    }, Object.defineProperty(i.prototype, "autoclose", {
        get: function() {
            return this._autoclose;
        },
        set: function(t) {
            this._autoclose = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.update = function() {
        return this.updateGraphic(void 0, this.autoclose), this;
    }, i.prototype.clear = function() {
        return this.commands.splice(0), $d867740680d9f0ee$var$W(this.element, {
            d: ""
        }), this;
    }, i.prototype.moveTo = function(t, e, n) {
        return this.commands.push({
            command: $d867740680d9f0ee$var$a.move,
            point: {
                r: t,
                l: e,
                t: n
            }
        }), this.update(), this;
    }, i.prototype.lineTo = function(t, e, n) {
        return this.commands.push({
            command: $d867740680d9f0ee$var$a.line,
            point: {
                r: t,
                l: e,
                t: n
            }
        }), this.update(), this;
    }, i.prototype.curveTo = function(t, e, n, i, r, o) {
        return this.commands.push({
            command: $d867740680d9f0ee$var$a.curve,
            control: {
                r: t,
                l: e,
                t: n
            },
            point: {
                r: i,
                l: r,
                t: o
            }
        }), this.update(), this;
    }, i.prototype.mt = function(t, e, n) {
        return this.moveTo(t, e, n);
    }, i.prototype.lt = function(t, e, n) {
        return this.lineTo(t, e, n);
    }, i.prototype.ct = function(t, e, n, i, r, o) {
        return this.curveTo(t, e, n, i, r, o);
    }, i.prototype.draw = function(t) {
        return this.commands = $d867740680d9f0ee$var$J(t), this.update(), this;
    }, i.prototype.addAnimation = function(t) {
        return e.prototype.addAnimation.call(this, t);
    }, i.prototype.updateAnimations2 = function() {}, i;
}($d867740680d9f0ee$var$bt), $d867740680d9f0ee$export$b5ee75f3884097c5 = function(e) {
    function i(i) {
        var r, o = this, a = i.planeView, s = i.text, c = void 0 === s ? "" : s, u = i.fontFamily, h = void 0 === u ? "Arial" : u, l = i.fontSize, d = void 0 === l ? 12 : l, f = i.fontStyle, m = void 0 === f ? "normal" : f, y = i.fontWeight, g = void 0 === y ? "normal" : y, v = i.origin, b = void 0 === v ? [
            "center",
            "center"
        ] : v, _ = i.right, x = void 0 === _ ? 0 : _, E = i.left, O = void 0 === E ? 0 : E, P = i.top, C = void 0 === P ? 0 : P, A = i.rotation, T = void 0 === A ? 0 : A, S = i.selectable, j = void 0 === S || S, M = $d867740680d9f0ee$var$w(i, [
            "planeView",
            "text",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "origin",
            "right",
            "left",
            "top",
            "rotation",
            "selectable"
        ]);
        return (o = e.call(this, M, $d867740680d9f0ee$var$t.group) || this)._originHash = ((r = {})[$d867740680d9f0ee$var$p.CENTER] = "middle", r[$d867740680d9f0ee$var$p.LEFT] = "start", r[$d867740680d9f0ee$var$p.RIGHT] = "end", r[$d867740680d9f0ee$var$p.TOP] = "hanging", r[$d867740680d9f0ee$var$p.BOTTOM] = "baseline", r), o.commonAnimationAttributes = {
            attributeName: "transform",
            attributeType: "XML",
            additive: "sum",
            fill: "freeze"
        }, o.getMatrixTransform = function(t) {
            var e = $d867740680d9f0ee$var$et(o.getPositionTransform(t), o.planeView, 1);
            return "".concat(e, " rotate(").concat(o.rotation, ")");
        }, o._textElement = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.text), o._tspan = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.tspan), o._textElement.appendChild(o._tspan), o.element.appendChild(o._textElement), o.planeView = a, o.fontFamily = h, o.fontSize = d, o.fontStyle = m, o.fontWeight = g, o.selectable = j, o.origin = b, o.right = x, o.left = O, o.top = C, o.rotation = T, o.text = c, o;
    }
    return $d867740680d9f0ee$var$P(i, e), i.prototype.getPositionTransform = function(t, e) {
        return void 0 === e && (e = !0), $d867740680d9f0ee$var$D(e ? this.data.centerX : 0, e ? this.data.centerY : 0, {
            r: t.right,
            l: t.left,
            t: t.top
        }, this.data.scale);
    }, i.prototype.updateSubClassAnimations = function() {
        var e = this, i = {
            right: 0,
            left: 0,
            top: 0,
            rotation: 0
        };
        this.animations.forEach(function(r) {
            if (!$d867740680d9f0ee$var$Z(r.property) && Object.prototype.hasOwnProperty.call(i, r.property)) {
                var o = r.property, a = "rotation" === o, s = $d867740680d9f0ee$var$C($d867740680d9f0ee$var$C({}, e.commonAnimationAttributes), {
                    type: a ? "rotate" : "translate",
                    begin: "indefinite"
                }), c = void 0;
                if (r.values) {
                    if (Array.isArray(r.values)) c = $d867740680d9f0ee$var$C({
                        values: r.values.map(function(t) {
                            if (a) return "".concat(t);
                            var n = $d867740680d9f0ee$var$C({}, i);
                            n[o] = +t - e[o];
                            var r = e.getPositionTransform(n, !1);
                            return "".concat(r.x, ",").concat(r.y);
                        }).join(";")
                    }, s);
                    else if (a) c = $d867740680d9f0ee$var$C({
                        values: "".concat(r.values)
                    }, s);
                    else {
                        var u = $d867740680d9f0ee$var$C({}, i);
                        u[o] = +r.values - e[o];
                        var h = e.getPositionTransform(u, !1);
                        c = $d867740680d9f0ee$var$C({
                            values: "".concat(h.x, ",").concat(h.y)
                        }, s);
                    }
                } else if (a) c = $d867740680d9f0ee$var$C({
                    from: "".concat(r.from),
                    to: "".concat(r.to)
                }, s);
                else {
                    var p = $d867740680d9f0ee$var$C({}, i), l = $d867740680d9f0ee$var$C({}, i);
                    p[o] = +r.from - e[o], l[o] = +r.to - e[o];
                    var d = e.getPositionTransform(p, !1), f = e.getPositionTransform(l, !1);
                    c = $d867740680d9f0ee$var$C({
                        from: "".concat(d.x, ",").concat(d.y),
                        to: "".concat(f.x, ",").concat(f.y)
                    }, s);
                }
                r.element || (r.element = document.createElementNS($d867740680d9f0ee$var$n, $d867740680d9f0ee$var$t.animateTransform)), e.addAnimationBasicProperties("transform", r), $d867740680d9f0ee$var$W(r.element, c), r.element.parentNode || (a ? e._textElement.appendChild(r.element) : e.element.appendChild(r.element)), window.requestAnimationFrame(function() {
                    r.element.beginElement();
                });
            }
        });
    }, i.prototype.update = function() {
        if ($d867740680d9f0ee$var$nt(this.element)) {
            var t = this.getMatrixTransform({
                right: this.right,
                left: this.left,
                top: this.top
            });
            $d867740680d9f0ee$var$W(this._textElement, {
                transform: t
            }), this._tspan.textContent = this._text, this.updatePatternTransform({
                x: 0,
                y: 0
            }, this.planeView), this.updateAnimations();
        }
        return this;
    }, i.prototype.clear = function() {
        return this.text = "", this.update(), this;
    }, Object.defineProperty(i.prototype, "text", {
        get: function() {
            return this._text;
        },
        set: function(t) {
            this._text = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "planeView", {
        get: function() {
            return this._planeView;
        },
        set: function(t) {
            this._planeView = t, this.update();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontFamily", {
        get: function() {
            return this._fontFamily;
        },
        set: function(t) {
            this._fontFamily = t, $d867740680d9f0ee$var$W(this._tspan, {
                "font-family": this._fontFamily
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontSize", {
        get: function() {
            return this._fontSize;
        },
        set: function(t) {
            this._fontSize = t, $d867740680d9f0ee$var$W(this._tspan, {
                "font-size": "".concat(this._fontSize, "px")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontStyle", {
        get: function() {
            return this._fontStyle;
        },
        set: function(t) {
            this._fontStyle = t, $d867740680d9f0ee$var$W(this._tspan, {
                "font-style": "".concat(this._fontStyle)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "fontWeight", {
        get: function() {
            return this._fontWeight;
        },
        set: function(t) {
            this._fontWeight = t, $d867740680d9f0ee$var$W(this._tspan, {
                "font-weight": "".concat(this._fontWeight)
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "selectable", {
        get: function() {
            return this._selectable;
        },
        set: function(t) {
            this._selectable = t, this._selectable ? this._textElement.removeAttribute("style") : $d867740680d9f0ee$var$W(this._textElement, {
                style: [
                    "-webkit-user-select",
                    "-moz-user-select",
                    "-ms-user-select",
                    "user-select",
                    "pointer-events"
                ].map(function(t) {
                    return "".concat(t, ": none");
                }).join(";")
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "origin", {
        get: function() {
            return this._origin;
        },
        set: function(t) {
            this._origin = t;
            var e = this._origin, n = e[0], i = e[1];
            $d867740680d9f0ee$var$W(this._tspan, {
                "text-anchor": this._originHash[n],
                "alignment-baseline": this._originHash[i]
            });
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "right", {
        get: function() {
            return this._right;
        },
        set: function(t) {
            this._right !== t && (this._right = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "left", {
        get: function() {
            return this._left;
        },
        set: function(t) {
            this._left !== t && (this._left = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "top", {
        get: function() {
            return this._top;
        },
        set: function(t) {
            this._top !== t && (this._top = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(i.prototype, "rotation", {
        get: function() {
            return this._rotation;
        },
        set: function(t) {
            this._rotation !== t && (this._rotation = t, this.update());
        },
        enumerable: !1,
        configurable: !0
    }), i.prototype.updateAnimations2 = function() {}, i;
}($d867740680d9f0ee$var$at);


parcelRequire("5oaC6");


var $f22df01f36f3bbc5$var$noop = {
    value: ()=>{}
};
function $f22df01f36f3bbc5$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $f22df01f36f3bbc5$var$Dispatch(_);
}
function $f22df01f36f3bbc5$var$Dispatch(_) {
    this._ = _;
}
function $f22df01f36f3bbc5$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$f22df01f36f3bbc5$var$Dispatch.prototype = $f22df01f36f3bbc5$var$dispatch.prototype = {
    constructor: $f22df01f36f3bbc5$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $f22df01f36f3bbc5$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $f22df01f36f3bbc5$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $f22df01f36f3bbc5$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $f22df01f36f3bbc5$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $f22df01f36f3bbc5$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $f22df01f36f3bbc5$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $f22df01f36f3bbc5$export$2e2bcd8739ae039 = $f22df01f36f3bbc5$var$dispatch;



function $a696f7efe74d657f$var$none() {}
function $a696f7efe74d657f$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a696f7efe74d657f$var$none : function() {
        return this.querySelector(selector);
    };
}


function $fe3e8a5771c356f3$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $6100a2c8d9353abb$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $a251e86126c3c196$var$empty() {
    return [];
}
function $a251e86126c3c196$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a251e86126c3c196$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $c3afa9f57c3c6584$var$arrayAll(select) {
    return function() {
        return (0, $6100a2c8d9353abb$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $c3afa9f57c3c6584$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $c3afa9f57c3c6584$var$arrayAll(select);
    else select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, parents);
}


function $9217c1f6bb2d2b85$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $9217c1f6bb2d2b85$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $b34141b01ced0a61$var$find = Array.prototype.find;
function $b34141b01ced0a61$var$childFind(match) {
    return function() {
        return $b34141b01ced0a61$var$find.call(this.children, match);
    };
}
function $b34141b01ced0a61$var$childFirst() {
    return this.firstElementChild;
}
function $b34141b01ced0a61$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $b34141b01ced0a61$var$childFirst : $b34141b01ced0a61$var$childFind(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}



var $437727374f9902ec$var$filter = Array.prototype.filter;
function $437727374f9902ec$var$children() {
    return Array.from(this.children);
}
function $437727374f9902ec$var$childrenFilter(match) {
    return function() {
        return $437727374f9902ec$var$filter.call(this.children, match);
    };
}
function $437727374f9902ec$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $437727374f9902ec$var$children : $437727374f9902ec$var$childrenFilter(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}




function $417eb06912872de0$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



function $16e10e18a783a307$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $b2f4aac14f806d3c$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._enter || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}
function $b2f4aac14f806d3c$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$b2f4aac14f806d3c$export$67b01759a14cf6a4.prototype = {
    constructor: $b2f4aac14f806d3c$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $75c268d1af54dd4d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $052a9a1821040aa9$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $052a9a1821040aa9$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $052a9a1821040aa9$var$datum(node) {
    return node.__data__;
}
function $052a9a1821040aa9$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $052a9a1821040aa9$var$datum);
    var bind = key ? $052a9a1821040aa9$var$bindKey : $052a9a1821040aa9$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $75c268d1af54dd4d$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $052a9a1821040aa9$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $052a9a1821040aa9$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $0e815177caeed21b$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._exit || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}


function $63f586900c2b4b42$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $7a412a9de8021db3$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(merges, this._parents);
}


function $e17552b51cfac160$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $6d597722efeda79a$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $6d597722efeda79a$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $6d597722efeda79a$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $ae070bcd7d1235fe$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c6e4ab7976218275$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $055d135910c13cd5$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $f897b6f378fcb9fc$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $889880c4b5f21a22$export$2e2bcd8739ae039() {
    return !this.node();
}


function $b879b1474342de48$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $a95bc3014beac1d3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $a95bc3014beac1d3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $a95bc3014beac1d3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $58b58edfe5dae49c$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $a95bc3014beac1d3$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $a95bc3014beac1d3$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $d206eec3d2c8e9d1$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d206eec3d2c8e9d1$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d206eec3d2c8e9d1$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $d206eec3d2c8e9d1$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $d206eec3d2c8e9d1$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $d206eec3d2c8e9d1$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $d206eec3d2c8e9d1$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $d206eec3d2c8e9d1$var$attrRemoveNS : $d206eec3d2c8e9d1$var$attrRemove : typeof value === "function" ? fullname.local ? $d206eec3d2c8e9d1$var$attrFunctionNS : $d206eec3d2c8e9d1$var$attrFunction : fullname.local ? $d206eec3d2c8e9d1$var$attrConstantNS : $d206eec3d2c8e9d1$var$attrConstant)(fullname, value));
}


function $a802501d7f7ae391$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $df9d8f43b4be6d4b$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $df9d8f43b4be6d4b$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $df9d8f43b4be6d4b$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $df9d8f43b4be6d4b$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $df9d8f43b4be6d4b$var$styleRemove : typeof value === "function" ? $df9d8f43b4be6d4b$var$styleFunction : $df9d8f43b4be6d4b$var$styleConstant)(name, value, priority == null ? "" : priority)) : $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(this.node(), name);
}
function $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $f99b3adab0522f33$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $f99b3adab0522f33$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $f99b3adab0522f33$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $f99b3adab0522f33$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $f99b3adab0522f33$var$propertyRemove : typeof value === "function" ? $f99b3adab0522f33$var$propertyFunction : $f99b3adab0522f33$var$propertyConstant)(name, value)) : this.node()[name];
}


function $d06e661034a45406$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d06e661034a45406$var$classList(node) {
    return node.classList || new $d06e661034a45406$var$ClassList(node);
}
function $d06e661034a45406$var$ClassList(node) {
    this._node = node;
    this._names = $d06e661034a45406$var$classArray(node.getAttribute("class") || "");
}
$d06e661034a45406$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d06e661034a45406$var$classedAdd(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d06e661034a45406$var$classedRemove(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d06e661034a45406$var$classedTrue(names) {
    return function() {
        $d06e661034a45406$var$classedAdd(this, names);
    };
}
function $d06e661034a45406$var$classedFalse(names) {
    return function() {
        $d06e661034a45406$var$classedRemove(this, names);
    };
}
function $d06e661034a45406$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d06e661034a45406$var$classedAdd : $d06e661034a45406$var$classedRemove)(this, names);
    };
}
function $d06e661034a45406$export$2e2bcd8739ae039(name, value) {
    var names = $d06e661034a45406$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d06e661034a45406$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d06e661034a45406$var$classedFunction : value ? $d06e661034a45406$var$classedTrue : $d06e661034a45406$var$classedFalse)(names, value));
}


function $039cad3e6b62ef93$var$textRemove() {
    this.textContent = "";
}
function $039cad3e6b62ef93$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $039cad3e6b62ef93$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $039cad3e6b62ef93$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $039cad3e6b62ef93$var$textRemove : (typeof value === "function" ? $039cad3e6b62ef93$var$textFunction : $039cad3e6b62ef93$var$textConstant)(value)) : this.node().textContent;
}


function $c8e884507bcbc0d6$var$htmlRemove() {
    this.innerHTML = "";
}
function $c8e884507bcbc0d6$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c8e884507bcbc0d6$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c8e884507bcbc0d6$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c8e884507bcbc0d6$var$htmlRemove : (typeof value === "function" ? $c8e884507bcbc0d6$var$htmlFunction : $c8e884507bcbc0d6$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $d32582798f21257c$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $d32582798f21257c$export$2e2bcd8739ae039() {
    return this.each($d32582798f21257c$var$raise);
}


function $81fa89a3cf707281$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $81fa89a3cf707281$export$2e2bcd8739ae039() {
    return this.each($81fa89a3cf707281$var$lower);
}




function $9eff7b5d7c009c96$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $9eff7b5d7c009c96$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $9eff7b5d7c009c96$export$2e2bcd8739ae039(name) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $9eff7b5d7c009c96$var$creatorFixed : $9eff7b5d7c009c96$var$creatorInherit)(fullname);
}


function $e7e5728b38923688$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $92828970e51f2858$var$constantNull() {
    return null;
}
function $92828970e51f2858$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name), select = before == null ? $92828970e51f2858$var$constantNull : typeof before === "function" ? before : (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $3fba60665c09da9b$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $3fba60665c09da9b$export$2e2bcd8739ae039() {
    return this.each($3fba60665c09da9b$var$remove);
}


function $f8ba4680beaf3292$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $f8ba4680beaf3292$var$selection_cloneDeep : $f8ba4680beaf3292$var$selection_cloneShallow);
}


function $d5e7be624eaf3e5d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $f620cfb2b91d85e5$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $f620cfb2b91d85e5$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $f620cfb2b91d85e5$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $f620cfb2b91d85e5$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $f620cfb2b91d85e5$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $f620cfb2b91d85e5$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $f620cfb2b91d85e5$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $f620cfb2b91d85e5$var$onAdd : $f620cfb2b91d85e5$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $049280ac271fdabe$var$dispatchEvent(node, type, params) {
    var window = (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $049280ac271fdabe$var$dispatchConstant(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params);
    };
}
function $049280ac271fdabe$var$dispatchFunction(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $049280ac271fdabe$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $049280ac271fdabe$var$dispatchFunction : $049280ac271fdabe$var$dispatchConstant)(type, params));
}


function* $c0c33d07b05cd299$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $3fa3bddc94b4f8a8$export$e8e78c978b129247 = [
    null
];
function $3fa3bddc94b4f8a8$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $3fa3bddc94b4f8a8$var$selection() {
    return new $3fa3bddc94b4f8a8$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $3fa3bddc94b4f8a8$export$e8e78c978b129247);
}
function $3fa3bddc94b4f8a8$var$selection_selection() {
    return this;
}
$3fa3bddc94b4f8a8$export$52baac22726c72bf.prototype = $3fa3bddc94b4f8a8$var$selection.prototype = {
    constructor: $3fa3bddc94b4f8a8$export$52baac22726c72bf,
    select: (0, $fe3e8a5771c356f3$export$2e2bcd8739ae039),
    selectAll: (0, $c3afa9f57c3c6584$export$2e2bcd8739ae039),
    selectChild: (0, $b34141b01ced0a61$export$2e2bcd8739ae039),
    selectChildren: (0, $437727374f9902ec$export$2e2bcd8739ae039),
    filter: (0, $417eb06912872de0$export$2e2bcd8739ae039),
    data: (0, $052a9a1821040aa9$export$2e2bcd8739ae039),
    enter: (0, $b2f4aac14f806d3c$export$2e2bcd8739ae039),
    exit: (0, $0e815177caeed21b$export$2e2bcd8739ae039),
    join: (0, $63f586900c2b4b42$export$2e2bcd8739ae039),
    merge: (0, $7a412a9de8021db3$export$2e2bcd8739ae039),
    selection: $3fa3bddc94b4f8a8$var$selection_selection,
    order: (0, $e17552b51cfac160$export$2e2bcd8739ae039),
    sort: (0, $6d597722efeda79a$export$2e2bcd8739ae039),
    call: (0, $ae070bcd7d1235fe$export$2e2bcd8739ae039),
    nodes: (0, $c6e4ab7976218275$export$2e2bcd8739ae039),
    node: (0, $055d135910c13cd5$export$2e2bcd8739ae039),
    size: (0, $f897b6f378fcb9fc$export$2e2bcd8739ae039),
    empty: (0, $889880c4b5f21a22$export$2e2bcd8739ae039),
    each: (0, $b879b1474342de48$export$2e2bcd8739ae039),
    attr: (0, $d206eec3d2c8e9d1$export$2e2bcd8739ae039),
    style: (0, $df9d8f43b4be6d4b$export$2e2bcd8739ae039),
    property: (0, $f99b3adab0522f33$export$2e2bcd8739ae039),
    classed: (0, $d06e661034a45406$export$2e2bcd8739ae039),
    text: (0, $039cad3e6b62ef93$export$2e2bcd8739ae039),
    html: (0, $c8e884507bcbc0d6$export$2e2bcd8739ae039),
    raise: (0, $d32582798f21257c$export$2e2bcd8739ae039),
    lower: (0, $81fa89a3cf707281$export$2e2bcd8739ae039),
    append: (0, $e7e5728b38923688$export$2e2bcd8739ae039),
    insert: (0, $92828970e51f2858$export$2e2bcd8739ae039),
    remove: (0, $3fba60665c09da9b$export$2e2bcd8739ae039),
    clone: (0, $f8ba4680beaf3292$export$2e2bcd8739ae039),
    datum: (0, $d5e7be624eaf3e5d$export$2e2bcd8739ae039),
    on: (0, $f620cfb2b91d85e5$export$2e2bcd8739ae039),
    dispatch: (0, $049280ac271fdabe$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $c0c33d07b05cd299$export$2e2bcd8739ae039)
};
var $3fa3bddc94b4f8a8$export$2e2bcd8739ae039 = $3fa3bddc94b4f8a8$var$selection;


function $4506c173c1ba6b79$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $3fa3bddc94b4f8a8$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $19c289642832a009$export$524615cd03e458cc = {
    passive: false
};
const $19c289642832a009$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $19c289642832a009$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $19c289642832a009$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $ae3cd07c3e922ae3$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $ae3cd07c3e922ae3$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $9eF39 = parcelRequire("9eF39");

var $9eF39 = parcelRequire("9eF39");
function $881d0702247da37d$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $881d0702247da37d$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $881d0702247da37d$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $d875b83ab5863578$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $881d0702247da37d$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $32a1f36c13df06e0$export$2e2bcd8739ae039 = (x)=>()=>x;


function $8dfce0561889250e$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $8dfce0561889250e$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $8dfce0561889250e$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $8dfce0561889250e$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $8dfce0561889250e$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $8dfce0561889250e$var$exponential(a, b, y) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $8dfce0561889250e$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $c99ed0dd240dae7d$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $8dfce0561889250e$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $9eF39.rgb)(start)).r, (end = (0, $9eF39.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c99ed0dd240dae7d$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $9eF39.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c99ed0dd240dae7d$export$2c0e28f2e2852d3f = $c99ed0dd240dae7d$var$rgbSpline((0, $881d0702247da37d$export$2e2bcd8739ae039));
var $c99ed0dd240dae7d$export$53d5214f625ccd4c = $c99ed0dd240dae7d$var$rgbSpline((0, $d875b83ab5863578$export$2e2bcd8739ae039));



function $910b5323d0705334$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $910b5323d0705334$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $66ad23a6bb88ccc7$export$2e2bcd8739ae039(a, b) {
    return ((0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : $66ad23a6bb88ccc7$export$15d09067c6a5ee49)(a, b);
}
function $66ad23a6bb88ccc7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $3133c9670a94856a$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $4a087d8646486986$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $83516c74d826a95f$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $256699786eb44963$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $256699786eb44963$var$reB = new RegExp($256699786eb44963$var$reA.source, "g");
function $256699786eb44963$var$zero(b) {
    return function() {
        return b;
    };
}
function $256699786eb44963$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $256699786eb44963$export$2e2bcd8739ae039(a, b) {
    var bi = $256699786eb44963$var$reA.lastIndex = $256699786eb44963$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $256699786eb44963$var$reA.exec(a)) && (bm = $256699786eb44963$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $256699786eb44963$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $256699786eb44963$var$one(q[0].x) : $256699786eb44963$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $0a6b21d627aa3b76$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : b instanceof Date ? (0, $3133c9670a94856a$export$2e2bcd8739ae039) : (0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $66ad23a6bb88ccc7$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $83516c74d826a95f$export$2e2bcd8739ae039) : (0, $4a087d8646486986$export$2e2bcd8739ae039))(a, b);
}


function $39821514e2bb6c34$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $7edc954089de14ac$export$2e2bcd8739ae039(event, node) {
    event = (0, $39821514e2bb6c34$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $0830f34b180fabe6$var$frame = 0, $0830f34b180fabe6$var$timeout = 0, $0830f34b180fabe6$var$interval = 0, $0830f34b180fabe6$var$pokeDelay = 1000, $0830f34b180fabe6$var$taskHead, $0830f34b180fabe6$var$taskTail, $0830f34b180fabe6$var$clockLast = 0, $0830f34b180fabe6$var$clockNow = 0, $0830f34b180fabe6$var$clockSkew = 0, $0830f34b180fabe6$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0830f34b180fabe6$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0830f34b180fabe6$export$461939dd4422153() {
    return $0830f34b180fabe6$var$clockNow || ($0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$clearNow), $0830f34b180fabe6$var$clockNow = $0830f34b180fabe6$var$clock.now() + $0830f34b180fabe6$var$clockSkew);
}
function $0830f34b180fabe6$var$clearNow() {
    $0830f34b180fabe6$var$clockNow = 0;
}
function $0830f34b180fabe6$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$0830f34b180fabe6$export$c57e9b2d8b9e4de.prototype = $0830f34b180fabe6$export$9dc4ecf953986f04.prototype = {
    constructor: $0830f34b180fabe6$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0830f34b180fabe6$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0830f34b180fabe6$var$taskTail !== this) {
            if ($0830f34b180fabe6$var$taskTail) $0830f34b180fabe6$var$taskTail._next = this;
            else $0830f34b180fabe6$var$taskHead = this;
            $0830f34b180fabe6$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0830f34b180fabe6$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0830f34b180fabe6$var$sleep();
        }
    }
};
function $0830f34b180fabe6$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $0830f34b180fabe6$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $0830f34b180fabe6$export$d60154c1d7f3990e() {
    $0830f34b180fabe6$export$461939dd4422153(); // Get the current time, if not already set.
    ++$0830f34b180fabe6$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0830f34b180fabe6$var$taskHead, e;
    while(t){
        if ((e = $0830f34b180fabe6$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$0830f34b180fabe6$var$frame;
}
function $0830f34b180fabe6$var$wake() {
    $0830f34b180fabe6$var$clockNow = ($0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now()) + $0830f34b180fabe6$var$clockSkew;
    $0830f34b180fabe6$var$frame = $0830f34b180fabe6$var$timeout = 0;
    try {
        $0830f34b180fabe6$export$d60154c1d7f3990e();
    } finally{
        $0830f34b180fabe6$var$frame = 0;
        $0830f34b180fabe6$var$nap();
        $0830f34b180fabe6$var$clockNow = 0;
    }
}
function $0830f34b180fabe6$var$poke() {
    var now = $0830f34b180fabe6$var$clock.now(), delay = now - $0830f34b180fabe6$var$clockLast;
    if (delay > $0830f34b180fabe6$var$pokeDelay) $0830f34b180fabe6$var$clockSkew -= delay, $0830f34b180fabe6$var$clockLast = now;
}
function $0830f34b180fabe6$var$nap() {
    var t0, t1 = $0830f34b180fabe6$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0830f34b180fabe6$var$taskHead = t2;
    }
    $0830f34b180fabe6$var$taskTail = t0;
    $0830f34b180fabe6$var$sleep(time);
}
function $0830f34b180fabe6$var$sleep(time) {
    if ($0830f34b180fabe6$var$frame) return; // Soonest alarm already set, or will be.
    if ($0830f34b180fabe6$var$timeout) $0830f34b180fabe6$var$timeout = clearTimeout($0830f34b180fabe6$var$timeout);
    var delay = time - $0830f34b180fabe6$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0830f34b180fabe6$var$timeout = setTimeout($0830f34b180fabe6$var$wake, time - $0830f34b180fabe6$var$clock.now() - $0830f34b180fabe6$var$clockSkew);
        if ($0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$interval = clearInterval($0830f34b180fabe6$var$interval);
    } else {
        if (!$0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now(), $0830f34b180fabe6$var$interval = setInterval($0830f34b180fabe6$var$poke, $0830f34b180fabe6$var$pokeDelay);
        $0830f34b180fabe6$var$frame = 1, $0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$wake);
    }
}


function $761d5cee6e823ef5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $0830f34b180fabe6$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $b5673d202c1a718d$var$emptyOn = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $b5673d202c1a718d$var$emptyTween = [];
var $b5673d202c1a718d$export$ff39ebd4bb12b718 = 0;
var $b5673d202c1a718d$export$584530fe98d14a84 = 1;
var $b5673d202c1a718d$export$a5d151aee16efd42 = 2;
var $b5673d202c1a718d$export$fb935ab5849a0db9 = 3;
var $b5673d202c1a718d$export$1573e22b087389af = 4;
var $b5673d202c1a718d$export$a2e792214ded83b2 = 5;
var $b5673d202c1a718d$export$9d38167254403955 = 6;
function $b5673d202c1a718d$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $b5673d202c1a718d$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $b5673d202c1a718d$var$emptyOn,
        tween: $b5673d202c1a718d$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $b5673d202c1a718d$export$ff39ebd4bb12b718
    });
}
function $b5673d202c1a718d$export$2cd8252107eb640b(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $b5673d202c1a718d$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $b5673d202c1a718d$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $b5673d202c1a718d$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $0830f34b180fabe6$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $b5673d202c1a718d$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $b5673d202c1a718d$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $b5673d202c1a718d$export$fb935ab5849a0db9) return (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $b5673d202c1a718d$export$1573e22b087389af) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(function() {
            if (self.state === $b5673d202c1a718d$export$fb935ab5849a0db9) {
                self.state = $b5673d202c1a718d$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $b5673d202c1a718d$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $b5673d202c1a718d$export$a5d151aee16efd42) return; // interrupted
        self.state = $b5673d202c1a718d$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $b5673d202c1a718d$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $b5673d202c1a718d$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $b5673d202c1a718d$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $a9f60c0c7972321a$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $b5673d202c1a718d$export$a5d151aee16efd42) && schedule.state < (0, $b5673d202c1a718d$export$a2e792214ded83b2);
        schedule.state = (0, $b5673d202c1a718d$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $1edbe92636db4b14$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this, name);
    });
}




var $5e622cc4ee5dcd58$var$degrees = 180 / Math.PI;
var $5e622cc4ee5dcd58$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $5e622cc4ee5dcd58$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $5e622cc4ee5dcd58$var$degrees,
        skewX: Math.atan(skewX) * $5e622cc4ee5dcd58$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $2336aa7b25388556$var$svgNode;
function $2336aa7b25388556$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $5e622cc4ee5dcd58$export$f0954fd7d5368655) : (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $2336aa7b25388556$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    if (!$2336aa7b25388556$var$svgNode) $2336aa7b25388556$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $2336aa7b25388556$var$svgNode.setAttribute("transform", value);
    if (!(value = $2336aa7b25388556$var$svgNode.transform.baseVal.consolidate())) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $58d4bff51a6cd97b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $58d4bff51a6cd97b$export$56bec7123bb3589a = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $58d4bff51a6cd97b$export$da8cba906d64c082 = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $2b846766134b1951$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $2b846766134b1951$var$tweenRemove : $2b846766134b1951$var$tweenFunction)(id, name, value));
}
function $2b846766134b1951$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $9eF39 = parcelRequire("9eF39");

function $1d03f40d2ee03a56$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039))(a, b);
}


function $fa11014bc225ccbd$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $fa11014bc225ccbd$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $fa11014bc225ccbd$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $58d4bff51a6cd97b$export$da8cba906d64c082) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $fa11014bc225ccbd$var$attrFunctionNS : $fa11014bc225ccbd$var$attrFunction)(fullname, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $fa11014bc225ccbd$var$attrRemoveNS : $fa11014bc225ccbd$var$attrRemove)(fullname) : (fullname.local ? $fa11014bc225ccbd$var$attrConstantNS : $fa11014bc225ccbd$var$attrConstant)(fullname, i, value));
}



function $89c852aaf0ffbd98$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $89c852aaf0ffbd98$var$attrTweenNS : $89c852aaf0ffbd98$var$attrTween)(fullname, value));
}



function $998317f5aa574ea5$var$delayFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $998317f5aa574ea5$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $998317f5aa574ea5$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $998317f5aa574ea5$var$delayFunction : $998317f5aa574ea5$var$delayConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $fb064aa40c04a3a9$var$durationFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fb064aa40c04a3a9$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $fb064aa40c04a3a9$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fb064aa40c04a3a9$var$durationFunction : $fb064aa40c04a3a9$var$durationConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $3b84501e3f09c967$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $3b84501e3f09c967$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($3b84501e3f09c967$var$easeConstant(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $5d52f5c2bc33bebb$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $5d52f5c2bc33bebb$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($5d52f5c2bc33bebb$var$easeVarying(this._id, value));
}




function $be9cef0700338389$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $612e64afad319e12$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $43adaf0311e82f05$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $43adaf0311e82f05$var$onFunction(id, name, listener) {
    var on0, on1, sit = $43adaf0311e82f05$var$start(name) ? (0, $b5673d202c1a718d$export$2cd8252107eb640b) : (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $43adaf0311e82f05$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($43adaf0311e82f05$var$onFunction(id, name, listener));
}


function $d081c5c9ee67d011$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $d081c5c9ee67d011$export$2e2bcd8739ae039() {
    return this.on("end.remove", $d081c5c9ee67d011$var$removeFunction(this._id));
}





function $33c939ab69fb50d4$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $5accf6381f758c01$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $7a60ab3f6361005a$var$Selection = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.constructor;
function $7a60ab3f6361005a$export$2e2bcd8739ae039() {
    return new $7a60ab3f6361005a$var$Selection(this._groups, this._parents);
}







function $406987af83016736$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $406987af83016736$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $406987af83016736$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $406987af83016736$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $406987af83016736$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $406987af83016736$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $406987af83016736$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $58d4bff51a6cd97b$export$56bec7123bb3589a) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $406987af83016736$var$styleNull(name, i)).on("end.style." + name, $406987af83016736$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $406987af83016736$var$styleFunction(name, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "style." + name, value))).each($406987af83016736$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $406987af83016736$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $084d18b0ed660f1f$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $084d18b0ed660f1f$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $084d18b0ed660f1f$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $084d18b0ed660f1f$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $084d18b0ed660f1f$var$styleTween(name, value, priority == null ? "" : priority));
}



function $77d3177f82afb684$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $77d3177f82afb684$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $77d3177f82afb684$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $77d3177f82afb684$var$textFunction((0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "text", value)) : $77d3177f82afb684$var$textConstant(value == null ? "" : value + ""));
}


function $2281728614db71a0$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $2281728614db71a0$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $2281728614db71a0$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $2281728614db71a0$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $2281728614db71a0$var$textTween(value));
}




function $5075f917ce7577c6$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id0);
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $3a3e51e88d3fd2e7$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $f4875d2c4bb511a9$var$id = 0;
function $f4875d2c4bb511a9$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $f4875d2c4bb511a9$export$2e2bcd8739ae039(name) {
    return (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039)().transition(name);
}
function $f4875d2c4bb511a9$export$9ffd10a3fbdc175b() {
    return ++$f4875d2c4bb511a9$var$id;
}
var $f4875d2c4bb511a9$var$selection_prototype = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype;
$f4875d2c4bb511a9$export$be58926105124dd4.prototype = $f4875d2c4bb511a9$export$2e2bcd8739ae039.prototype = {
    constructor: $f4875d2c4bb511a9$export$be58926105124dd4,
    select: (0, $33c939ab69fb50d4$export$2e2bcd8739ae039),
    selectAll: (0, $5accf6381f758c01$export$2e2bcd8739ae039),
    selectChild: $f4875d2c4bb511a9$var$selection_prototype.selectChild,
    selectChildren: $f4875d2c4bb511a9$var$selection_prototype.selectChildren,
    filter: (0, $be9cef0700338389$export$2e2bcd8739ae039),
    merge: (0, $612e64afad319e12$export$2e2bcd8739ae039),
    selection: (0, $7a60ab3f6361005a$export$2e2bcd8739ae039),
    transition: (0, $5075f917ce7577c6$export$2e2bcd8739ae039),
    call: $f4875d2c4bb511a9$var$selection_prototype.call,
    nodes: $f4875d2c4bb511a9$var$selection_prototype.nodes,
    node: $f4875d2c4bb511a9$var$selection_prototype.node,
    size: $f4875d2c4bb511a9$var$selection_prototype.size,
    empty: $f4875d2c4bb511a9$var$selection_prototype.empty,
    each: $f4875d2c4bb511a9$var$selection_prototype.each,
    on: (0, $43adaf0311e82f05$export$2e2bcd8739ae039),
    attr: (0, $fa11014bc225ccbd$export$2e2bcd8739ae039),
    attrTween: (0, $89c852aaf0ffbd98$export$2e2bcd8739ae039),
    style: (0, $406987af83016736$export$2e2bcd8739ae039),
    styleTween: (0, $084d18b0ed660f1f$export$2e2bcd8739ae039),
    text: (0, $77d3177f82afb684$export$2e2bcd8739ae039),
    textTween: (0, $2281728614db71a0$export$2e2bcd8739ae039),
    remove: (0, $d081c5c9ee67d011$export$2e2bcd8739ae039),
    tween: (0, $2b846766134b1951$export$2e2bcd8739ae039),
    delay: (0, $998317f5aa574ea5$export$2e2bcd8739ae039),
    duration: (0, $fb064aa40c04a3a9$export$2e2bcd8739ae039),
    ease: (0, $3b84501e3f09c967$export$2e2bcd8739ae039),
    easeVarying: (0, $5d52f5c2bc33bebb$export$2e2bcd8739ae039),
    end: (0, $3a3e51e88d3fd2e7$export$2e2bcd8739ae039),
    [Symbol.iterator]: $f4875d2c4bb511a9$var$selection_prototype[Symbol.iterator]
};



function $9b730ba464200928$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $9b730ba464200928$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $9b730ba464200928$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $091a2eb19c9bc49f$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $9b730ba464200928$export$89238d3bc79d3ada)
};
function $091a2eb19c9bc49f$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $091a2eb19c9bc49f$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $f4875d2c4bb511a9$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)(), (timing = $091a2eb19c9bc49f$var$defaultTiming).time = (0, $0830f34b180fabe6$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $091a2eb19c9bc49f$var$inherit(node, id));
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.interrupt = (0, $1edbe92636db4b14$export$2e2bcd8739ae039);
(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.transition = (0, $091a2eb19c9bc49f$export$2e2bcd8739ae039);







var $778de0494e50ca37$export$2e2bcd8739ae039 = (x)=>()=>x;


function $6364eea05eaaf9a1$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $f663d3f9720c3b93$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f663d3f9720c3b93$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $08836f1eb7bc5d70$var$MODE_DRAG = {
    name: "drag"
}, $08836f1eb7bc5d70$var$MODE_SPACE = {
    name: "space"
}, $08836f1eb7bc5d70$var$MODE_HANDLE = {
    name: "handle"
}, $08836f1eb7bc5d70$var$MODE_CENTER = {
    name: "center"
};
const { abs: $08836f1eb7bc5d70$var$abs, max: $08836f1eb7bc5d70$var$max, min: $08836f1eb7bc5d70$var$min } = Math;
function $08836f1eb7bc5d70$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $08836f1eb7bc5d70$var$number2(e) {
    return [
        $08836f1eb7bc5d70$var$number1(e[0]),
        $08836f1eb7bc5d70$var$number1(e[1])
    ];
}
var $08836f1eb7bc5d70$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $08836f1eb7bc5d70$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $08836f1eb7bc5d70$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(xy) {
        return xy == null ? null : $08836f1eb7bc5d70$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $08836f1eb7bc5d70$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $08836f1eb7bc5d70$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $08836f1eb7bc5d70$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $08836f1eb7bc5d70$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $08836f1eb7bc5d70$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $08836f1eb7bc5d70$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $08836f1eb7bc5d70$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $08836f1eb7bc5d70$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $08836f1eb7bc5d70$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $08836f1eb7bc5d70$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $08836f1eb7bc5d70$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $08836f1eb7bc5d70$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $08836f1eb7bc5d70$export$979ace6c88860aa8() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$X);
}
function $08836f1eb7bc5d70$export$468748b530991c54() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$Y);
}
function $08836f1eb7bc5d70$export$2e2bcd8739ae039() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$XY);
}
function $08836f1eb7bc5d70$var$brush(dim) {
    var extent = $08836f1eb7bc5d70$var$defaultExtent, filter = $08836f1eb7bc5d70$var$defaultFilter, touchable = $08836f1eb7bc5d70$var$defaultTouchable, keys = true, listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $08836f1eb7bc5d70$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $08836f1eb7bc5d70$var$local(this).extent;
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $08836f1eb7bc5d70$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $08836f1eb7bc5d70$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $08836f1eb7bc5d70$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this), selection = $08836f1eb7bc5d70$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $6364eea05eaaf9a1$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $08836f1eb7bc5d70$var$MODE_DRAG : keys && event.altKey ? $08836f1eb7bc5d70$var$MODE_CENTER : $08836f1eb7bc5d70$var$MODE_HANDLE, signX = dim === $08836f1eb7bc5d70$var$Y ? null : $08836f1eb7bc5d70$var$signsX[type], signY = dim === $08836f1eb7bc5d70$var$X ? null : $08836f1eb7bc5d70$var$signsY[type], state = $08836f1eb7bc5d70$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $08836f1eb7bc5d70$var$Y ? W : $08836f1eb7bc5d70$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $08836f1eb7bc5d70$var$X ? N : $08836f1eb7bc5d70$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $08836f1eb7bc5d70$var$Y ? E : $08836f1eb7bc5d70$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $08836f1eb7bc5d70$var$X ? S : $08836f1eb7bc5d70$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($08836f1eb7bc5d70$var$abs(point.cur[0] - point[0]) > $08836f1eb7bc5d70$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $08836f1eb7bc5d70$var$MODE_SPACE:
                case $08836f1eb7bc5d70$var$MODE_DRAG:
                    if (signX) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $08836f1eb7bc5d70$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[0][0])), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[0][1])), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $08836f1eb7bc5d70$var$max(W - e0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $08836f1eb7bc5d70$var$max(N - s0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $08836f1eb7bc5d70$var$MODE_CENTER:
                    if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, w0 - dx * signX)), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, n0 - dy * signY)), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $08836f1eb7bc5d70$var$flipX) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $08836f1eb7bc5d70$var$flipY) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $f663d3f9720c3b93$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($08836f1eb7bc5d70$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE || mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $08836f1eb7bc5d70$var$MODE_SPACE;
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $08836f1eb7bc5d70$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)($08836f1eb7bc5d70$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}
































var $ab1b56f08da5f0f8$var$epsilon2 = 1e-12;
function $ab1b56f08da5f0f8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $ab1b56f08da5f0f8$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $ab1b56f08da5f0f8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $ab1b56f08da5f0f8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $ab1b56f08da5f0f8$var$tanh(rho * s + r0) - $ab1b56f08da5f0f8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $ab1b56f08da5f0f8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $855f7c13dc5c8800$export$2e2bcd8739ae039 = (x)=>()=>x;


function $f8b8ac12d46296b4$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $2aeeefb9d4aa62cb$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype = {
    constructor: $2aeeefb9d4aa62cb$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $2aeeefb9d4aa62cb$export$f0954fd7d5368655 = new $2aeeefb9d4aa62cb$export$563a914cafbdc389(1, 0, 0);
$2aeeefb9d4aa62cb$export$2e2bcd8739ae039.prototype = $2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype;
function $2aeeefb9d4aa62cb$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $2aeeefb9d4aa62cb$export$f0954fd7d5368655;
    return node.__zoom;
}


function $4c382e9682a58de3$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $4c382e9682a58de3$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $2e3210259ae866af$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $2e3210259ae866af$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $2e3210259ae866af$var$defaultTransform() {
    return this.__zoom || (0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655);
}
function $2e3210259ae866af$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $2e3210259ae866af$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $2e3210259ae866af$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $2e3210259ae866af$export$2e2bcd8739ae039() {
    var filter = $2e3210259ae866af$var$defaultFilter, extent = $2e3210259ae866af$var$defaultExtent, constrain = $2e3210259ae866af$var$defaultConstrain, wheelDelta = $2e3210259ae866af$var$defaultWheelDelta, touchable = $2e3210259ae866af$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $ab1b56f08da5f0f8$export$2e2bcd8739ae039), listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $f8b8ac12d46296b4$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, g.moved);
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}







const $dad545c909cfec2d$var$width = 500;
const $dad545c909cfec2d$var$height = 320;
const $dad545c909cfec2d$var$tensorNodeDistance = 75;
const $dad545c909cfec2d$var$edgeNodeDistance = 140;
function $dad545c909cfec2d$var$renderTensorDiagram(container, nodes, edges) {
    const svg = $4506c173c1ba6b79$export$2e2bcd8739ae039(container).append("svg").attr("width", $dad545c909cfec2d$var$width).attr("height", $dad545c909cfec2d$var$height).attr("viewBox", [
        -$dad545c909cfec2d$var$width / 2,
        -$dad545c909cfec2d$var$height / 2,
        $dad545c909cfec2d$var$width,
        $dad545c909cfec2d$var$height
    ]).attr("class", "max-w-full h-auto");
    // Separate tensor and edge nodes
    const tensorNodes = nodes.filter((n)=>n.type === "tensor");
    const edgeNodes = nodes.filter((n)=>n.type === "edge");
    // Position tensor nodes in geometric patterns
    const tensorCount = tensorNodes.length;
    if (tensorCount > 0) tensorNodes.forEach((node, i)=>{
        if (tensorCount === 1) {
            node.x = 0;
            node.y = 0;
        } else {
            const angle = i * 2 * Math.PI / tensorCount;
            node.x = $dad545c909cfec2d$var$tensorNodeDistance * Math.cos(angle);
            node.y = $dad545c909cfec2d$var$tensorNodeDistance * Math.sin(angle);
        }
    });
    // Helper function to find optimal position for edge nodes
    function getEdgeNodePosition(node) {
        const connectedEdges = edges.filter((e)=>e.source === node.id || e.target === node.id);
        const connectedTensors = connectedEdges.flatMap((e)=>{
            const sourceNode = nodes.find((n)=>n.id === e.source);
            const targetNode = nodes.find((n)=>n.id === e.target);
            return [
                sourceNode,
                targetNode
            ].filter((n)=>n.type === "tensor");
        });
        // Calculate average position of connected tensors
        const avgX = connectedTensors.reduce((sum, n)=>sum + (n.x || 0), 0) / connectedTensors.length;
        const avgY = connectedTensors.reduce((sum, n)=>sum + (n.y || 0), 0) / connectedTensors.length;
        // Place node further out in the same direction from center
        const angle = Math.atan2(avgY, avgX);
        return {
            x: $dad545c909cfec2d$var$edgeNodeDistance * Math.cos(angle),
            y: $dad545c909cfec2d$var$edgeNodeDistance * Math.sin(angle)
        };
    }
    // Position edge nodes
    edgeNodes.forEach((node)=>{
        const pos = getEdgeNodePosition(node);
        node.x = pos.x;
        node.y = pos.y;
    });
    function calculateLinkPath(source, target) {
        if (source === target) {
            const x = source.x;
            const y = source.y;
            return `M${x - 5},${y - 5} A30,30 0 1,1 ${x + 5},${y + 5}`;
        }
        return `M${source.x},${source.y} L${target.x},${target.y}`;
    }
    // Draw the edges
    const link = svg.append("g").attr("class", "links").selectAll("path").data(edges).enter();
    link.append("path").attr("d", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return calculateLinkPath(source, target);
    }).attr("fill", "none").attr("stroke", "#aaa").attr("stroke-width", 2);
    link.append("text").text((d)=>d.label).attr("class", (d)=>d.class_name).attr("x", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return source === target ? source.x + 30 : (source.x + target.x) / 2;
    }).attr("y", (d)=>{
        const source = nodes.find((n)=>n.id === d.source);
        const target = nodes.find((n)=>n.id === d.target);
        return source === target ? source.y - 30 : (source.y + target.y) / 2;
    });
    // Draw the nodes
    const node = svg.append("g").attr("class", "nodes").selectAll("g").data(nodes).enter().append("g").attr("transform", (d)=>`translate(${d.x}, ${d.y})`);
    node.append("circle").attr("r", 10).attr("class", "fill-indigo-600 dark:fill-indigo-300").attr("visibility", (d)=>d.type === "edge" ? "hidden" : "visible");
    // Tensor nodes show their name (A, B, ...) centered inside the circle;
    // edge nodes show the index name in that index's color.
    node.append("text").text((d)=>d.label).attr("class", (d)=>d.type === "tensor" ? "fill-white dark:fill-slate-900 font-mono" : d.class_name).attr("text-anchor", (d)=>d.type === "tensor" ? "middle" : null).attr("dy", (d)=>d.type === "tensor" ? "0.35em" : null).attr("font-size", (d)=>d.type === "tensor" ? 11 : null);
}
window.renderTensorDiagram = $dad545c909cfec2d$var$renderTensorDiagram;
window.isometric = $d867740680d9f0ee$exports;
window.addEventListener("load", ()=>window.tensor_playground_main());


//# sourceMappingURL=index.0cc3998a.js.map
